
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("go5Mj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "MaybeInlineCreateActiveIndexContainer", () => $0a687e71f9459356$export$88c9e8ba5ac9f501);
$parcel$export(module.exports, "MaybeHoverPopoverProvider", () => $0a687e71f9459356$export$a75161c82cc84af1);
$parcel$export(module.exports, "default", () => $0a687e71f9459356$export$2e2bcd8739ae039);
$parcel$export(module.exports, "NativeIssueTableEntryPoint", () => $0a687e71f9459356$export$1c6b4acc188098eb);

var $iQAl3 = parcelRequire("iQAl3");

var $fRQe9 = parcelRequire("fRQe9");

var $cqnIk = parcelRequire("cqnIk");

var $lRTKS = parcelRequire("lRTKS");

var $6psGt = parcelRequire("6psGt");

var $8vOQs = parcelRequire("8vOQs");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $j4oe4 = parcelRequire("j4oe4");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");

var $2gvG4 = parcelRequire("2gvG4");

var $9cbmy = parcelRequire("9cbmy");

var $epTsa = parcelRequire("epTsa");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $PETi0 = parcelRequire("PETi0");

var $88wTt = parcelRequire("88wTt");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $ftN6c = parcelRequire("ftN6c");

var $jE8Tu = parcelRequire("jE8Tu");

var $3cJQz = parcelRequire("3cJQz");

var $dLXgn = parcelRequire("dLXgn");

var $j8Km1 = parcelRequire("j8Km1");

var $bYhG9 = parcelRequire("bYhG9");

var $8jOO7 = parcelRequire("8jOO7");

var $f4DUY = parcelRequire("f4DUY");

var $lqvgs = parcelRequire("lqvgs");

var $kmIYY = parcelRequire("kmIYY");

var $dmolI = parcelRequire("dmolI");

var $l7qKV = parcelRequire("l7qKV");

var $P01So = parcelRequire("P01So");

var $kbYhH = parcelRequire("kbYhH");

var $4hsdx = parcelRequire("4hsdx");

var $hCXvl = parcelRequire("hCXvl");

var $6LwYU = parcelRequire("6LwYU");

var $6KVf0 = parcelRequire("6KVf0");

var $3F6xT = parcelRequire("3F6xT");

var $eqbO4 = parcelRequire("eqbO4");

var $jZFgr = parcelRequire("jZFgr");

var $kfIml = parcelRequire("kfIml");

var $7XD6x = parcelRequire("7XD6x");

var $6sUnz = parcelRequire("6sUnz");

var $91XFx = parcelRequire("91XFx");

var $sJrIm = parcelRequire("sJrIm");

var $28bHJ = parcelRequire("28bHJ");

var $7yfRR = parcelRequire("7yfRR");

var $kmbgR = parcelRequire("kmbgR");

var $12O1M = parcelRequire("12O1M");

var $clZvH = parcelRequire("clZvH");

var $6IEtQ = parcelRequire("6IEtQ");

var $9VBAD = parcelRequire("9VBAD");

var $bUOjV = parcelRequire("bUOjV");

var $cyJHb = parcelRequire("cyJHb");

var $1GzaA = parcelRequire("1GzaA");

var $b6dH0 = parcelRequire("b6dH0");

var $cGekj = parcelRequire("cGekj");

var $iFPDm = parcelRequire("iFPDm");
const $0a687e71f9459356$var$MaybeCustomComponentsProvider = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jira_native_issue_table_extra_custom_components'), (0, $6sUnz.CustomComponentsProvider), ({ children: children })=>children);
const $0a687e71f9459356$var$MaybeHierarchyContainer = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes'), (0, $jE8Tu.HierarchyContainer), ({ children: children })=>children);
const $0a687e71f9459356$export$88c9e8ba5ac9f501 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jira_inline_field_config_gate'), (0, $6KVf0.InlineCreateActiveIndexContainer), ({ children: children })=>children);
const $0a687e71f9459356$export$a75161c82cc84af1 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator'), (0, $bYhG9.HoverPopoverStateProvider), ({ children: children })=>children);
const $0a687e71f9459356$var$NativeIssueTable = ({ view: view, issues: issues, groups: groups, columns: columns, project: project, rankField: rankField, columnWidthOverrides: columnWidthOverrides, columnConfigOverrides: columnConfigOverrides, components: components, loading: loading = false, selectedRow: selectedRow = null, eventHandlers: eventHandlers, isInlineEditingEnabled: isInlineEditingEnabled = true, isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled = false, onSelectedRowChange: onSelectedRowChange, sortField: sortField, sortDirection: sortDirection = (0, $8jOO7.SORT_ASC), onReady: onReady, onSortChange: onSortChange, onColumnsChange: onColumnsChange, onColumnResize: onColumnResize, onColumnFreeze: onColumnFreeze, onRestoreDefaultColumns: onRestoreDefaultColumns, issueSearchBaseUrl: issueSearchBaseUrl = '/issues', useColumnLoader: useColumnLoader, isColumnPickerLoading: isColumnPickerLoading, projectContext: projectContext, density: density = (0, $8jOO7.DENSITY_COMPACT), isIssueHierarchyEnabled: isIssueHierarchyEnabled = false, isHideDoneItemsEnabled: isHideDoneItemsEnabled = false, areShortcutsEnabled: areShortcutsEnabled = true, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled = false, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled = false, isIssueCreateEnabled: isIssueCreateEnabled = false, enableMultiSelect: enableMultiSelect = false, tableBorderRadius: tableBorderRadius, onIssueFlatListUpdated: onIssueFlatListUpdated, jql: jql, isStatusTrackingEnabled: isStatusTrackingEnabled = false, isMergedColumnEnabled: isMergedColumnEnabled = false, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled = false, isChildIssuesTable: isChildIssuesTable = false, isIssueRankingEnabled: isIssueRankingEnabled = false, isTimelineEnabled: isTimelineEnabled = false, onPageChange: // Discrete pagination props
onPageChange, onLoadNext: // Infinite scroll pagination props
onLoadNext, onLoadPrevious: onLoadPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold, isGroupingSupported: // Experiment value props
isGroupingSupported = false, isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled = true, isCompactColumnEnabled: isCompactColumnEnabled = false, isReparentingEnabled: isReparentingEnabled = false, isColumnBordersEnabled: isColumnBordersEnabled = true, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled = false, isGridNavigationEnabled: isGridNavigationEnabled = false, onRowReorder: // Row reordering props
onRowReorder, isEntireRowDraggable: // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
isEntireRowDraggable = false, ifcConfig: ifcConfig, onRefetch: onRefetch, isStickyColumnsEnabled: isStickyColumnsEnabled = false, isConditionalFormattingEnabled: isConditionalFormattingEnabled = false, stickyColumnIds: stickyColumnIds, isRenderedInOverlay: isRenderedInOverlay = false })=>{
    const tableRef = (0, $eJOHy.useRef)(null);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (isGridNavigationEnabled) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cGekj.useKeyboardNavigation)(tableRef);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const viewData = (0, $j4oe4.useFragment)((0, $8vOQs.default), view ?? null);
    const issuesData = (0, $j4oe4.useFragment)((0, $6psGt.default), issues ?? null);
    const groupData = (0, $j4oe4.useFragment)((0, $lRTKS.default), groups ?? null); /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ 
    const columnsData = (0, $j4oe4.useFragment)((0, $cqnIk.default), columns); /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ 
    const projectData = (0, $j4oe4.useFragment)((0, $fRQe9.default), project ?? null);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $iQAl3.default), rankField ?? null);
    const isInitialDataLoaded = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!loading && !isInitialDataLoaded.current) isInitialDataLoaded.current = true;
    }, [
        loading
    ]);
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>{
        const issueTableNumberOfColumns = columnsData.totalCount;
        const issueTableFieldTypesWithCount = columnsData.edges.map((edge)=>edge?.node.type).filter((0, $P01So.isNonNullish)).sort().reduce((acc, type)=>{
            acc[type] = (acc[type] || 0) + 1;
            return acc;
        }, {});
        const issueTableFieldTypes = Object.keys(issueTableFieldTypesWithCount);
        return {
            issueTableNumberOfColumns: issueTableNumberOfColumns,
            issueTableFieldTypes: issueTableFieldTypes,
            issueTableFieldTypesWithCount: issueTableFieldTypesWithCount
        };
    }, [
        columnsData.edges,
        columnsData.totalCount
    ]);
    const canViewColumnConfiguration = useColumnLoader !== undefined;
    const canEditColumnConfiguration = onColumnsChange !== undefined;
    const isColumnResizingEnabled = onColumnResize != null; // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
    const isRowReorderingEnabled = onRowReorder != null;
    const isInfiniteScrollEnabled = onLoadNext != null && onLoadPrevious != null;
    const userHasEditIssuePermission = projectData?.editIssues?.canPerform === true;
    const userHasCreateIssuePermission = projectData?.createIssues?.canPerform === true;
    if (isInfiniteScrollEnabled && density === (0, $8jOO7.DENSITY_FULL)) throw new Error(`Infinite scroll is not allowed when density=${density}`);
    const onColumnPickerChange = (0, $eJOHy.useCallback)((pickerArgs)=>{
        if (Array.isArray(pickerArgs)) onColumnsChange && onColumnsChange(pickerArgs, (0, $8jOO7.MODIFY_COLUMNS));
        else if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) {
            const { columnIds: columnIds, isHorizontalAutoScrollNeeded: isHorizontalAutoScrollNeeded, isHorizontalAutoScrollLeftNeeded: isHorizontalAutoScrollLeftNeeded, onSuccessCallback: onSuccessCallback, onErrorCallback: onErrorCallback, retries: retries, analyticsAttributes: attributes, skipRefetch: skipRefetch = false } = pickerArgs;
            if (isHorizontalAutoScrollLeftNeeded && isMergedColumnEnabled && (0, $7jTnu.fg)('jira_list_merged_column_gate')) tableRef?.current?.parentElement?.scrollTo({
                left: 0,
                behavior: 'smooth'
            });
            else if (isHorizontalAutoScrollNeeded) tableRef?.current?.parentElement?.scrollTo({
                left: tableRef?.current.scrollWidth,
                behavior: 'smooth'
            });
            onColumnsChange && onColumnsChange(columnIds, (0, $8jOO7.MODIFY_COLUMNS), undefined, onSuccessCallback, onErrorCallback, retries, attributes, skipRefetch);
        }
    }, [
        isMergedColumnEnabled,
        onColumnsChange
    ]);
    const isMergedColumnVisible = (0, $eJOHy.useMemo)(()=>{
        if (isMergedColumnEnabled && (0, $7jTnu.fg)('jira_list_merged_column_gate')) return columnsData.edges.some((edge)=>edge?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY || edge?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE || edge?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY);
        return false;
    }, [
        isMergedColumnEnabled,
        columnsData
    ]);
    const mappedColumnConfig = (0, $eJOHy.useMemo)(()=>{
        const columnConfig = (0, $dmolI.getColumnConfig)(formatMessage);
        const columnsWithConfig = [];
        const types = columnsData.edges.filter((0, $P01So.isNonNullish)).map((edge)=>edge.node.type);
        if (isIssueHierarchyEnabled && !(isMergedColumnEnabled && (0, $7jTnu.fg)('jira_list_merged_column_gate')) && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) columnsWithConfig.push({
            id: (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON),
            type: (0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON,
            title: '',
            fieldTypeDisplayName: '',
            jqlTerm: '',
            aliases: [],
            customHeader: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
                name: "expand-column-header"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f4DUY.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cJQz.HierarchyOnboarding), null)),
            ...columnConfig[(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON](),
            ...columnConfigOverrides?.[(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON](types)
        });
        columnsData.edges.map((edge)=>edge?.node).filter((0, $P01So.isNonNullish)).forEach((node)=>{
            const { fieldSetId: fieldSetId, type: type, displayName: displayName, jqlTerm: jqlTerm, aliases: aliases, isSortable: isSortable, fieldSetPreferences: fieldSetPreferences, isPlaceHolderField: isPlaceHolderField, fieldsMetadata: fieldsMetadata } = node;
            let configureableFieldId;
            if (fieldsMetadata && (0, $7jTnu.fg)('jira_inline_field_config_gate')) {
                const configureableField = fieldsMetadata?.edges?.find((edge)=>edge?.node?.canBeConfigured);
                if (configureableField != null) configureableFieldId = configureableField?.node?.fieldId;
            }
            const mutableAliases = aliases ? Array.from(aliases) : [];
            let currentSorting = (0, $8jOO7.SORT_NONE);
            if ((0, $7jTnu.fg)('jsc_list_reranking_ast_refactor')) {
                const unsanitizedSortField = sortField && (0, $iFPDm.desanitizeField)(sortField);
                for (const term of [
                    jqlTerm,
                    ...mutableAliases
                ])if (unsanitizedSortField === term) {
                    currentSorting = sortDirection;
                    break;
                }
            } else if (jqlTerm === sortField) currentSorting = sortDirection;
            const baseConfig = {
                id: fieldSetId,
                type: type,
                title: displayName ?? '',
                jqlTerm: jqlTerm,
                aliases: mutableAliases,
                fieldTypeDisplayName: '',
                isSortable: isSortable ?? undefined,
                currentSorting: currentSorting,
                onSortOrderChanged: onSortChange,
                customWidth: columnWidthOverrides?.[fieldSetId] ?? fieldSetPreferences?.width ?? undefined,
                ...type === (0, $8jOO7.COLUMN_TYPE_PARENT_LINK) && {
                    warningText: formatMessage((0, $clZvH.default).deprecatedParentLinkMessage, {
                        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                                color: "color.text.inverse",
                                as: "strong"
                            }, chunks)
                    })
                },
                configureableFieldId: configureableFieldId
            };
            if ((0, $P01So.isKnownColumnType)(type)) {
                const getColumnTypeConfig = columnConfig[type];
                const knownColumnTypeConfig = getColumnTypeConfig();
                const getColumnConfigOverride = columnConfigOverrides?.[type];
                const columnConfigOverride = getColumnConfigOverride?.(types);
                columnsWithConfig.push({
                    ...baseConfig,
                    ...knownColumnTypeConfig,
                    ...columnConfigOverride,
                    isSortable: knownColumnTypeConfig.isSortable ?? true,
                    isPlaceHolderField: !!isPlaceHolderField
                });
            } else columnsWithConfig.push({
                ...baseConfig,
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                isPlaceHolderField: !!isPlaceHolderField
            });
        });
        if (canViewColumnConfiguration || isIssueOperationMeatballMenuEnabled) columnsWithConfig.push({
            id: (0, $8jOO7.COLUMN_ID_MEATBALL_MENU),
            type: (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS,
            title: '',
            fieldTypeDisplayName: '',
            jqlTerm: '',
            customHeader: canViewColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
                alignInline: "end"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88wTt.default), {
                view: viewData,
                columns: columnsData,
                components: (0, $7jTnu.fg)('jira_inline_field_config_gate') ? {
                    ...components?.columnPicker,
                    Footer: isInlineFieldConfigEnabled ? (0, $7XD6x.IFCFooter) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
                } : components?.columnPicker,
                onChange: canEditColumnConfiguration ? onColumnPickerChange : undefined,
                onRestoreDefaultColumns: onRestoreDefaultColumns,
                useColumnLoader: useColumnLoader,
                isLoading: isColumnPickerLoading || loading,
                isMergedColumnEnabled: isMergedColumnEnabled && (0, $7jTnu.fg)('jira_list_merged_column_gate'),
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                projectContext: (0, $7jTnu.fg)('jira_inline_field_config_gate') ? projectContext : undefined
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, formatMessage((0, $clZvH.default).columnHeaderIssueActions)),
            ...columnConfig[(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS](),
            ...columnConfigOverrides?.[(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS](types)
        });
        return columnsWithConfig;
    }, [
        formatMessage,
        columnsData,
        isIssueHierarchyEnabled,
        isMergedColumnEnabled,
        canViewColumnConfiguration,
        isIssueOperationMeatballMenuEnabled,
        columnConfigOverrides,
        sortField,
        onSortChange,
        columnWidthOverrides,
        sortDirection,
        components?.columnPicker,
        isInlineFieldConfigEnabled,
        canEditColumnConfiguration,
        onColumnPickerChange,
        onRestoreDefaultColumns,
        useColumnLoader,
        isColumnPickerLoading,
        loading,
        projectContext,
        viewData
    ]);
    const checkboxColumnConfig = (0, $eJOHy.useMemo)(()=>{
        const checkboxConfig = (0, $dmolI.getColumnConfig)(formatMessage)[(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX]();
        return {
            id: (0, $8jOO7.COLUMN_ID_CHECKBOX),
            type: (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX,
            title: '',
            fieldTypeDisplayName: '',
            jqlTerm: '',
            customHeader: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lqvgs.HeaderCheckboxCell), {
                groupByFieldId: groupData?.groupByField ?? null,
                selectableIssueIds: issuesData?.edges?.map((edge)=>edge?.node?.issueId ?? '') ?? []
            }),
            ...checkboxConfig
        };
    }, [
        formatMessage,
        issuesData?.edges,
        groupData?.groupByField
    ]);
    const mappedColumns = (0, $eJOHy.useMemo)(()=>{
        // Step 1: get columnConfigs based on bulk ops gate (when enabled)
        let computedMappedColumns = mappedColumnConfig;
        if (enableMultiSelect) computedMappedColumns = [
            checkboxColumnConfig,
            ...mappedColumnConfig
        ];
         // Step 2: get columnConfigs with merged column when enabled.
        if (isMergedColumnEnabled && (0, $7jTnu.fg)('jira_list_merged_column_gate')) computedMappedColumns = (0, $91XFx.getMergedColumnConfig)(computedMappedColumns, isIssueHierarchyEnabled, formatMessage);
         // Step 3: get columnConfigs with sticky attributes when frozen columns enabled.
        if (isStickyColumnsEnabled && (0, $7jTnu.fg)('issue_table_frozen_columns')) computedMappedColumns = (0, $l7qKV.getColumnsWithStickyOffsets)(computedMappedColumns, stickyColumnIds);
        return computedMappedColumns;
    }, [
        checkboxColumnConfig,
        enableMultiSelect,
        formatMessage,
        isMergedColumnEnabled,
        isIssueHierarchyEnabled,
        isStickyColumnsEnabled,
        mappedColumnConfig,
        stickyColumnIds
    ]);
    let isStickyColumnsVisible = false;
    if ((0, $7jTnu.fg)('issue_table_frozen_columns')) {
        const lastStickyColumn = mappedColumns.find((col)=>col.isLastStickyColumn); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isStickyColumnsVisible = (0, $eJOHy.useMemo)(()=>{
            if (!isStickyColumnsEnabled) return false;
            if (!lastStickyColumn) return false; // Check if lastStickyColumn's id is not COLUMN_ID_CHECKBOX or COLUMN_ID_EXPAND_BUTTON
            return ![
                (0, $8jOO7.COLUMN_ID_CHECKBOX),
                (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON)
            ].includes(lastStickyColumn.id);
        }, [
            lastStickyColumn,
            isStickyColumnsEnabled
        ]);
    }
    const handleOnColumnsChange = (0, $eJOHy.useCallback)((newColumns)=>{
        if (onColumnsChange) {
            let columnsWithIssueData = newColumns.filter(({ id: id })=>id ? !(0, $8jOO7.ACTION_COLUMNS).includes(id) : id !== (0, $8jOO7.COLUMN_ID_MEATBALL_MENU)); // make sure merged fields (key, type, summary) are passed to the onColumnsChange
            if (isMergedColumnVisible && (0, $7jTnu.fg)('jira_list_merged_column_gate')) {
                const mergedColumns = newColumns.find((col)=>col?.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns;
                if (mergedColumns?.length) columnsWithIssueData = [
                    ...mergedColumns,
                    ...columnsWithIssueData
                ];
            }
            const columnIds = columnsWithIssueData.map(({ id: id })=>id);
            const edges = columnsWithIssueData.map(({ id: id, type: type, title: title, jqlTerm: jqlTerm, aliases: aliases, isSortable: isSortable, fieldTypeDisplayName: fieldTypeDisplayName, customWidth: customWidth })=>({
                    node: {
                        fieldSetId: id,
                        type: type ?? null,
                        displayName: title,
                        jqlTerm: jqlTerm ?? null,
                        aliases: aliases ?? [],
                        isSortable: isSortable ?? null,
                        fieldType: fieldTypeDisplayName ? {
                            displayName: fieldTypeDisplayName
                        } : null,
                        fieldSetPreferences: customWidth ? {
                            width: customWidth
                        } : null,
                        fieldsMetadata: null
                    }
                }));
            const optimisticFieldSets = {
                totalCount: columnsData.totalCount,
                edges: edges
            };
            onColumnsChange(columnIds, (0, $8jOO7.REORDER_COLUMNS), optimisticFieldSets);
        }
    }, [
        columnsData.totalCount,
        isMergedColumnVisible,
        onColumnsChange
    ]); // TODO: HRZ-1643 Handle shortcuts with grouping
    const issueKeys = (0, $eJOHy.useMemo)(()=>(0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? undefined : issuesData?.edges?.map((edge)=>edge?.node?.key ?? ''), [
        issuesData?.edges
    ]);
    const tableInjectedProps = (0, $eJOHy.useMemo)(()=>({
            ...eventHandlers,
            issueSearchBaseUrl: issueSearchBaseUrl
        }), [
        eventHandlers,
        issueSearchBaseUrl
    ]);
    const columnPickerProps = (0, $eJOHy.useMemo)(()=>isInBetweenColumnPickerEnabled && canViewColumnConfiguration ? {
            columns: columnsData,
            components: components?.columnPicker,
            onChange: canEditColumnConfiguration ? onColumnPickerChange : undefined,
            onRestoreDefaultColumns: onRestoreDefaultColumns,
            useColumnLoader: useColumnLoader,
            isLoading: isColumnPickerLoading || loading
        } : undefined, [
        canEditColumnConfiguration,
        canViewColumnConfiguration,
        columnsData,
        components?.columnPicker,
        isColumnPickerLoading,
        isInBetweenColumnPickerEnabled,
        loading,
        onColumnPickerChange,
        onRestoreDefaultColumns,
        useColumnLoader
    ]);
    if ((0, $7jTnu.fg)('issue_table_size_ufo_metrics')) (0, $2gvG4.addUFOCustomData)({
        numberOfColumns: mappedColumns.length
    });
    (0, $eJOHy.useEffect)(()=>{
        onReady && (0, $7jTnu.fg)('endeavour_nin_filter_results_gadget') && onReady();
    }, [
        onReady
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isChildIssuesTable && (0, $7jTnu.fg)('ken-2879_is_child_issue_table')) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'columnsCount updated', 'childIssuesTable', {
            numberOfColumns: mappedColumns.length
        });
    }, [
        createAnalyticsEvent,
        isChildIssuesTable,
        mappedColumns.length
    ]);
    const conditionalOnColumnsChange = canEditColumnConfiguration ? handleOnColumnsChange : undefined; // Show the skeleton if we are loading on initial render as we may only have partial row data
    if (loading && !isInitialDataLoaded.current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kmIYY.IssueTableSkeleton), null);
    const footer = issuesData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $28bHJ.default), {
        Footer: components?.Footer,
        rankField: rankFieldData ?? null,
        IssueCount: components?.IssueCount,
        issues: issuesData,
        onPageChange: onPageChange
    }) : null;
    const connectionsSubscriber = components?.ConnectionsSubscriber && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1GzaA.ConnectionsSubscriberContainer), {
        ConnectionsSubscriber: components.ConnectionsSubscriber
    });
    const hierarchyRemountKey = `${isIssueHierarchyEnabled}-${isGroupingSupported ? groupData?.jql || issuesData?.jql : ''}-${groupData?.groupByField}`;
    const ScrollContainer = (0, $7jTnu.fg)('jira_native_issue_table_extra_custom_components') ? components?.ScrollContainer ?? (0, $9VBAD.ScrollContainer) : (0, $9VBAD.ScrollContainer);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "nativeIssueTable",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4hsdx.FeaturesContainer), {
        density: density,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled,
        isInlineEditingEnabled: isInlineEditingEnabled,
        isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
        isIssueCreateEnabled: isIssueCreateEnabled && userHasCreateIssuePermission,
        projectContext: projectContext,
        isIssueHierarchyEnabled: isIssueHierarchyEnabled,
        isIssueRankingEnabled: isIssueRankingEnabled,
        isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
        isRowReorderingEnabled: (0, $7jTnu.fg)('jsc-2065-unify-onrowreorder') ? false : isRowReorderingEnabled,
        isEntireRowDraggable: (0, $7jTnu.fg)('jsc-2065-unify-onrowreorder') ? isEntireRowDraggable : isRowReorderingEnabled && isEntireRowDraggable,
        isReparentingEnabled: isReparentingEnabled && isIssueHierarchyEnabled && (!groupData || !groupData?.groupByField) && userHasEditIssuePermission,
        sortDirection: sortDirection,
        sortField: sortField,
        jql: jql ?? '',
        isColumnBordersEnabled: isColumnBordersEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        isHideDoneItemsEnabled: isHideDoneItemsEnabled,
        isMergedColumnEnabled: isMergedColumnEnabled,
        isMergedColumnVisible: isMergedColumnVisible,
        isStickyColumnsEnabled: isStickyColumnsEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible,
        isConditionalFormattingEnabled: (0, $7jTnu.fg)('jira_list_conditional_formatting') ? isConditionalFormattingEnabled : undefined,
        isTimelineEnabled: isTimelineEnabled,
        isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
        isRenderedInOverlay: isRenderedInOverlay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a687e71f9459356$var$MaybeCustomComponentsProvider, {
        components: components
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3F6xT.TableIntersectionObserverContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7yfRR.IssueFetchQueryVariables), {
        columns: columnsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a687e71f9459356$export$88c9e8ba5ac9f501, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6LwYU.SiblingCreateActiveIndexContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a687e71f9459356$var$MaybeHierarchyContainer // Key used to reset the container store when the hierarchy settings change
    , {
        // Without it there may be flickering when Concurrent Mode is enabled
        key: hierarchyRemountKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a687e71f9459356$export$a75161c82cc84af1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfIml.DraggableRowsContainer), {
        issueConnectionId: issuesData?.__id || '',
        instanceId: issuesData?.__id,
        ...(0, $7jTnu.fg)('jsc-2065-unify-onrowreorder') ? {} : {
            onRowReorder: onRowReorder
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a687e71f9459356$var$MainContainer, {
        tableBorderRadius: isChildIssuesTableVisualUpliftEnabled && (0, $7jTnu.fg)('fg_visual_uplift_for_child_issues_table') ? "var(--ds-space-0, 0px)" : tableBorderRadius,
        tableBorderWidth: isChildIssuesTableVisualUpliftEnabled && (0, $7jTnu.fg)('fg_visual_uplift_for_child_issues_table') ? '0px' : (0, $8jOO7.BORDER_WIDTH),
        "data-vc": `issue-table-main-container${false ? '-ssr' : ''}`,
        ...false && {
            'data-ssr-placeholder': 'issue-table-main-container-placeholder'
        },
        ...!false && {
            'data-ssr-placeholder-replace': 'issue-table-main-container-placeholder'
        },
        isTimelineEnabled: isTimelineEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kbYhH.ElementSizeProvider), {
        elementRef: tableRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLXgn.ConnectionsListContainer // Key used to reset the container store when the hierarchy settings change
    ), {
        // Without it there may be flickering when Concurrent Mode is enabled
        key: hierarchyRemountKey
    }, connectionsSubscriber, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sJrIm.SortChangeContextProvider), {
        value: {
            onSortChange: onSortChange
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ScrollContainer, {
        footer: footer,
        onLoadNext: onLoadNext,
        onLoadPrevious: onLoadPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        activationThreshold: activationThreshold,
        loading: loading,
        isGrouping: isGroupingSupported && !!groupData,
        ...(0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate') && {
            columnCount: mappedColumns.length
        },
        ...((0, $7jTnu.fg)('ken-2879_is_child_issue_table') || (0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate')) && {
            isChildIssuesTable: isChildIssuesTable
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eqbO4.LazyEditabilityLoaderContainer), {
        scope: (0, $8jOO7.LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jZFgr.LazyMediaViewContextLoaderContainer), {
        scope: (0, $8jOO7.LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hCXvl.SelectedRowContainer), {
        selectedRowIndex: selectedRow,
        amountOfRows: issuesData?.edges?.length ?? 0,
        onRowChange: onSelectedRowChange,
        onPageChange: onPageChange,
        issues: issuesData ?? null
    }, areShortcutsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $12O1M.default), {
        issueKeys: issueKeys,
        onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $PETi0.ColumnPickerContainer), isInBetweenColumnPickerEnabled && {
        scope: (0, $8jOO7.COLUMN_PICKER_CONFIGURATION_CONTAINER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cyJHb.CopyPasteContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kmbgR.default), {
        view: viewData ?? null,
        columnPickerProps: columnPickerProps,
        issueResults: issuesData ?? null,
        groupResults: groupData ?? null,
        project: projectData ?? null,
        rankField: rankFieldData ?? null,
        columns: mappedColumns,
        canViewColumnConfiguration: canViewColumnConfiguration,
        canEditColumnConfiguration: canEditColumnConfiguration,
        loading: loading,
        tableInjectedProps: tableInjectedProps,
        onColumnsChange: conditionalOnColumnsChange,
        onResizeColumn: onColumnResize,
        onFreezeColumn: onColumnFreeze,
        NoColumns: components?.NoColumns,
        NoIssues: components?.NoIssues,
        tableRef: tableRef,
        isGroupingSupported: isGroupingSupported,
        isCompactColumnEnabled: isCompactColumnEnabled,
        tableBorderRadius: isChildIssuesTableVisualUpliftEnabled && (0, $7jTnu.fg)('fg_visual_uplift_for_child_issues_table') ? "var(--ds-space-0, 0px)" : tableBorderRadius,
        onIssueFlatListUpdated: onIssueFlatListUpdated,
        ifcConfig: ifcConfig,
        columnsQueryRef: columnsData
    })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b6dH0.RootConnectionRegister), {
        issues: issuesData
    }), projectData && (0, $epTsa.expVal)('jira_list_realtime_updates_with_queue', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6IEtQ.RealtimeUpdater), {
        project: projectData,
        issues: issuesData,
        groups: groupData,
        isHierarchyEnabled: isIssueHierarchyEnabled,
        isStatusTrackingEnabled: isStatusTrackingEnabled,
        onRefetch: onRefetch
    }))))))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTable"
    }));
};
const $0a687e71f9459356$var$NativeIssueTableWithSelectedIssuesProvider = (0, $bUOjV.IssueTableSelectedIssuesProvider)($0a687e71f9459356$var$NativeIssueTable);
var $0a687e71f9459356$export$2e2bcd8739ae039 = $0a687e71f9459356$var$NativeIssueTableWithSelectedIssuesProvider;
const $0a687e71f9459356$export$1c6b4acc188098eb = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a687e71f9459356$var$NativeIssueTableWithSelectedIssuesProvider, props); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a687e71f9459356$var$MainContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { tableBorderWidth: tableBorderWidth, tableBorderRadius: tableBorderRadius, isTimelineEnabled: isTimelineEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rg2d25": (0, $awdRS.default)(__cmplp.tableBorderWidth)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2lx21bp4 _1n261q9c _1reo15vq _18m915vq _1h6dmuej _1dqonqa1 _189e1ht6 _1e0c1txw",
            __cmplp.tableBorderRadius ?? "_2rkopd34",
            __cmplp.isTimelineEnabled ? "_kqswh2mm" : "_kqswpfqs",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iQAl3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a18bc31bbf2e850$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<62956a8980a18ac8c5b7acc9c3f12fc9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4a18bc31bbf2e850$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_nativeIssueTable_NativeIssueTable_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issueTable_nativeIssueTable_rankField"
        },
        {
            "kind": "FragmentSpread",
            "name": "footerRenderer_nativeIssueTable_rankField"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$4a18bc31bbf2e850$var$node.hash = "eff3157b029509df380c37697d2aad1f";
var $4a18bc31bbf2e850$export$2e2bcd8739ae039 = $4a18bc31bbf2e850$var$node;

});

parcelRegister("fRQe9", function(module, exports) {

$parcel$export(module.exports, "default", () => $11c42eae98bcd716$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2b510015dabf44b44f827f4eef4327e9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $11c42eae98bcd716$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "ui_nativeIssueTable_NativeIssueTable_project",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "editIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v0 /*: any*/ ,
                        "storageKey": "action(type:\"EDIT_ISSUES\")"
                    }
                ]
            },
            {
                "alias": "createIssues",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_ISSUES"
                    }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": v0 /*: any*/ ,
                "storageKey": "action(type:\"CREATE_ISSUES\")"
            },
            {
                "kind": "FragmentSpread",
                "name": "realtimeUpdater_nativeIssueTable_project"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isConditionalFormattingEnabled",
                        "variableName": "isConditionalFormattingEnabled"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "issueTable_nativeIssueTable_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$11c42eae98bcd716$var$node.hash = "b214bfd43a10254dc42d0aab7508319f";
var $11c42eae98bcd716$export$2e2bcd8739ae039 = $11c42eae98bcd716$var$node;

});

parcelRegister("cqnIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e4b0c2dc70652d7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e877f0cf47c1c9f9e70d34dd49d23c14>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8e4b0c2dc70652d7$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "ui_nativeIssueTable_NativeIssueTable_columns",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issueFetchQueryVariables_nativeIssueTable"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalCount"
            },
            "action": "THROW",
            "path": "totalCount"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueSearchFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "fieldSetId"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.fieldSetId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "type"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.type"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.displayName"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "jqlTerm"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.jqlTerm"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "aliases"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                },
                                {
                                    "concreteType": "JiraFieldSetPreferences",
                                    "kind": "LinkedField",
                                    "name": "fieldSetPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsMetadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canBeConfigured"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPlaceHolderField"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "edges.node"
                    }
                ]
            },
            "action": "THROW",
            "path": "edges"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueTableColumnPicker_ColumnConfig_columns"
        },
        {
            "kind": "FragmentSpread",
            "name": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef"
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$8e4b0c2dc70652d7$var$node.hash = "b73c672bc8c7ff4406bd1ed6f0e87186";
var $8e4b0c2dc70652d7$export$2e2bcd8739ae039 = $8e4b0c2dc70652d7$var$node;

});

parcelRegister("lRTKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $03ce73a90ddb06ed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e77fce82c2c604d3fb64e8fede3510bf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03ce73a90ddb06ed$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": true,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "ui_nativeIssueTable_NativeIssueTable_groups",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "groupByField"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueTable_nativeIssueTable_groupResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "realtimeUpdater_nativeIssueTable_groups"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$03ce73a90ddb06ed$var$node.hash = "66fe67bc40cc13aac950d4436cf073ef";
var $03ce73a90ddb06ed$export$2e2bcd8739ae039 = $03ce73a90ddb06ed$var$node;

});

parcelRegister("6psGt", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c4199b9895ca16$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e450b7781b7286489b6113b1e86affd8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $63c4199b9895ca16$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "pageSize",
            "variableName": "pageSize"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageSize"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "ui_nativeIssueTable_NativeIssueTable_issues",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "issueId"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "jql"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isConditionalFormattingEnabled",
                        "variableName": "isConditionalFormattingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isDensityFull",
                        "variableName": "isDensityFull"
                    },
                    {
                        "kind": "Variable",
                        "name": "isInlineEditingEnabled",
                        "variableName": "isInlineEditingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isReparentingEnabled",
                        "variableName": "isReparentingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isTimelineEnabled",
                        "variableName": "isTimelineEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKey",
                        "variableName": "projectKey"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKeys",
                        "variableName": "projectKeys"
                    },
                    {
                        "kind": "Variable",
                        "name": "shouldQueryHasChildren",
                        "variableName": "shouldQueryHasChildren"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "issueTable_nativeIssueTable_issueResults"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "footerRenderer_nativeIssueTable_issues"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "selectedRowState_nativeIssueTable_SelectedRowContainer"
            },
            {
                "kind": "FragmentSpread",
                "name": "realtimeUpdater_nativeIssueTable_issues"
            },
            {
                "kind": "FragmentSpread",
                "name": "rootConnectionRegister_nativeIssueTable_issues"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$63c4199b9895ca16$var$node.hash = "6f9a26d970175911c6de6f8b5d309e32";
var $63c4199b9895ca16$export$2e2bcd8739ae039 = $63c4199b9895ca16$var$node;

});

parcelRegister("8vOQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8a2322802c81959$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<655d81ece952fe65e258e9028cd8a1e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c8a2322802c81959$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_nativeIssueTable_NativeIssueTable_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueTableColumnPicker_ColumnConfig_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueTable_nativeIssueTable_view"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$c8a2322802c81959$var$node.hash = "467890bbe52fd2a978a7ca9974a354c1";
var $c8a2322802c81959$export$2e2bcd8739ae039 = $c8a2322802c81959$var$node;

});

parcelRegister("PETi0", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerContainer", () => $3bc985482a1599b5$export$e1286e1cb3fa0dec);
$parcel$export(module.exports, "useColumnPickerOpenState", () => $3bc985482a1599b5$export$81588ffe8d9d4add);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $3bc985482a1599b5$export$e1286e1cb3fa0dec = (0, $6E16M.createContainer)();
const $3bc985482a1599b5$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'ColumnPickerOpenState',
    containedBy: $3bc985482a1599b5$export$e1286e1cb3fa0dec
});
const $3bc985482a1599b5$export$81588ffe8d9d4add = (0, $iJq0l.createHook)($3bc985482a1599b5$var$Store);

});

parcelRegister("88wTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e03d97ba1f3fd3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");

var $7jTnu = parcelRequire("7jTnu");

var $1KdDN = parcelRequire("1KdDN");

var $dyvFQ = parcelRequire("dyvFQ");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $cWT2N = parcelRequire("cWT2N");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $54e03d97ba1f3fd3$var$ColumnConfig = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("eOLDG")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/issue-table/column-picker/src/ui/main.tsx"
});
const $54e03d97ba1f3fd3$var$ErrorFallback = ({ onRetry: onRetry, customIcon: customIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cWT2N.default), {
                ...props,
                ref: triggerRef,
                customIcon: customIcon
            }),
        placement: "bottom-end",
        spacing: "compact",
        shouldRenderToParent: (0, $7jTnu.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyvFQ.ErrorState), {
        onRetry: onRetry,
        pageAction: "columnPicker"
    }));
const $54e03d97ba1f3fd3$var$AsyncColumnConfig = (props)=>{
    const [resetCaughtError, setResetCaughtError] = (0, $eJOHy.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueTableColumnPicker",
        id: "unhandled",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54e03d97ba1f3fd3$var$ErrorFallback, {
                onRetry: ()=>setResetCaughtError(error),
                customIcon: props.components?.Icon
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-column-config",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cWT2N.PickerButtonFallback), {
            customIcon: props.components?.Icon,
            isInBetweenColumnPickerEnabled: props.isInBetweenColumnPickerEnabled
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54e03d97ba1f3fd3$var$ColumnConfig, props)));
};
var $54e03d97ba1f3fd3$export$2e2bcd8739ae039 = $54e03d97ba1f3fd3$var$AsyncColumnConfig;

});
parcelRegister("dyvFQ", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $147eb7ee5e3e0a78$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $goZPP = parcelRequire("goZPP");

var $1NG86 = parcelRequire("1NG86");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $ivs94 = parcelRequire("ivs94");

var $1m9Wj = parcelRequire("1m9Wj");
const $147eb7ee5e3e0a78$var$BOX_HEIGHT = (0, $dPMMf.gridSize) * 18;
const $147eb7ee5e3e0a78$var$ERROR_ICON_BOX_WRAPPER_HEIGHT = (0, $dPMMf.gridSize) * 9;
const $147eb7ee5e3e0a78$var$ICON_SIZE = (0, $dPMMf.gridSize) * 9;
const $147eb7ee5e3e0a78$export$c1ed4f415b9e7023 = (props)=>{
    const { pageAction: pageAction, onRetry: onRetry, description: description, role: role } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = ()=>{
        onRetry?.();
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), `${pageAction}Retry clicked`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147eb7ee5e3e0a78$var$StyledBox, {
        height: $147eb7ee5e3e0a78$var$BOX_HEIGHT,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147eb7ee5e3e0a78$var$StyledBox, {
        height: $147eb7ee5e3e0a78$var$ERROR_ICON_BOX_WRAPPER_HEIGHT,
        iconSize: $147eb7ee5e3e0a78$var$ICON_SIZE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1m9Wj.StyledText), null, description !== undefined ? description : formatMessage((0, $ivs94.default).errorMessage)), (onRetry || !(0, $7jTnu.fg)('nin_filter_details_popup_entrypoint_migration')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClick,
        appearance: "link",
        testId: "issue-navigator-actions-common.ui.error.button"
    }, formatMessage((0, $ivs94.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $147eb7ee5e3e0a78$var$StyledBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ivs94", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fc2779f4954708a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7fc2779f4954708a$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-actions-common.error.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-actions-common.error.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $7fc2779f4954708a$export$2e2bcd8739ae039 = $7fc2779f4954708a$var$messages;

});

parcelRegister("1m9Wj", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $fe5d3814363465dc$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $806LH = parcelRequire("806LH");
const $fe5d3814363465dc$export$d675f139b342d51a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $fe5d3814363465dc$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $fe5d3814363465dc$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe5d3814363465dc$var$StyledTextComponent, props));

});


parcelRegister("cWT2N", function(module, exports) {

$parcel$export(module.exports, "PickerButtonFallback", () => $19f27efe9b61f432$export$d2ed0044a1cffec6);
$parcel$export(module.exports, "default", () => $19f27efe9b61f432$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $dcLzM = parcelRequire("dcLzM");

var $2a3IQ = parcelRequire("2a3IQ");

var $7skWy = parcelRequire("7skWy");

var $k71qx = parcelRequire("k71qx");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $fbuFM = parcelRequire("fbuFM");
const $19f27efe9b61f432$var$PickerButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isLoading: isLoading = false, isSelected: isSelected = false, customIcon: customIcon, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, onPickerMouseEnter: onPickerMouseEnter, onPickerMouseLeave: onPickerMouseLeave }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const iconColor = isSelected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon, #44546F)";
    const tooltipContent = formatMessage(isInBetweenColumnPickerEnabled && (0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, $fbuFM.default).addColumnTooltipText : (0, $fbuFM.default).tooltipText);
    const tooltipOptions = {
        position: 'bottom',
        content: tooltipContent,
        delay: 0
    };
    const isDisabled = !isSelected && isLoading;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'ninColumnPickerButton', {
            isInline: !!isInBetweenColumnPickerEnabled
        });
        onClick?.(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isInBetweenColumnPickerEnabled,
        onClick
    ]);
    if (isInBetweenColumnPickerEnabled && (0, $7jTnu.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $19f27efe9b61f432$var$pressableStyles,
        testId: "issue-table-column-picker.ui.column-picker.picker-button.pressable-add-column",
        isDisabled: isDisabled,
        onClick: handleOnClick,
        onMouseEnter: onPickerMouseEnter,
        onMouseLeave: onPickerMouseLeave,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
        label: tooltipContent
    })));
    const icon = customIcon ?? ((0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, (/*@__PURE__*/$parcel$interopDefault($2a3IQ))) : (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))));
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: icon,
        testId: "issue-table-column-picker.ui.column-picker.picker-button.picker-button",
        label: tooltipContent,
        appearance: "subtle",
        isDisabled: isDisabled,
        onClick: (0, $7jTnu.fg)('jira_inline_field_config_gate') ? handleOnClick : onClick,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected,
        isSelected: isSelected,
        tooltip: tooltipOptions,
        isTooltipDisabled: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "bottom",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        testId: "issue-table-column-picker.ui.column-picker.picker-button.picker-button",
        "aria-label": tooltipContent,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7skWy))), {
            label: "",
            spacing: "spacious",
            LEGACY_size: "medium",
            color: iconColor
        }),
        isDisabled: isDisabled,
        onClick: (0, $7jTnu.fg)('jira_inline_field_config_gate') ? handleOnClick : onClick,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected,
        isSelected: isSelected
    }));
});
const $19f27efe9b61f432$export$d2ed0044a1cffec6 = ({ customIcon: customIcon, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = formatMessage(isInBetweenColumnPickerEnabled && (0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, $fbuFM.default).addColumnTooltipText : (0, $fbuFM.default).tooltipText);
    if (isInBetweenColumnPickerEnabled && (0, $7jTnu.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $19f27efe9b61f432$var$pressableStyles,
        isDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
        label: tooltipContent
    })));
    const icon = customIcon ?? ((0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, (/*@__PURE__*/$parcel$interopDefault($2a3IQ))) : (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))));
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: icon,
        label: tooltipContent,
        appearance: "subtle",
        isDisabled: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        "aria-label": formatMessage((0, $fbuFM.default).tooltipText),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7skWy))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium"
        }),
        isDisabled: true
    });
};
const $19f27efe9b61f432$var$pressableStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '24px',
    width: '24px',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    position: 'relative',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    boxShadow: 'elevation.shadow.overlay',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
var $19f27efe9b61f432$export$2e2bcd8739ae039 = $19f27efe9b61f432$var$PickerButton;

});
parcelRegister("2a3IQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78298474d22014d47c8de5bc58c5ffc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $192f672196aef77f$var$_react = $192f672196aef77f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $192f672196aef77f$var$_baseNew = $192f672196aef77f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $192f672196aef77f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnsDistribute".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for distributing the width of table columns evenly.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $192f672196aef77f$var$TableColumnsDistributeIcon = (props)=>/*#__PURE__*/ $192f672196aef77f$var$_react.default.createElement($192f672196aef77f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.375C2 1.615 2.616 1 3.375 1h9.25C13.385 1 14 1.616 14 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 15 2 14.384 2 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm3.5 0v11h2v-11z" clip-rule="evenodd"/>`
    }, props));
$192f672196aef77f$var$TableColumnsDistributeIcon.displayName = 'TableColumnsDistributeIcon';
var $192f672196aef77f$var$_default = module.exports.default = $192f672196aef77f$var$TableColumnsDistributeIcon;

});

parcelRegister("7skWy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59e43c1f00fcc95f49aa5b3733f7f372>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56db64df0b3e22ba$var$_react = $56db64df0b3e22ba$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $56db64df0b3e22ba$var$_customize = $56db64df0b3e22ba$var$_interopRequireDefault((parcelRequire("iiRWr")));

var $56db64df0b3e22ba$var$_preferences = $56db64df0b3e22ba$var$_interopRequireDefault((parcelRequire("c8Sc8")));
function $56db64df0b3e22ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CustomizeIcon.
 * This component is CustomizeIcon, with `UNSAFE_fallbackIcon` set to "PreferencesIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56db64df0b3e22ba$var$CustomizeIcon = (props)=>/*#__PURE__*/ $56db64df0b3e22ba$var$_react.default.createElement($56db64df0b3e22ba$var$_customize.default, Object.assign({
        LEGACY_fallbackIcon: $56db64df0b3e22ba$var$_preferences.default
    }, props));
$56db64df0b3e22ba$var$CustomizeIcon.Name = 'CustomizeIconMigration';
var $56db64df0b3e22ba$var$_default = module.exports.default = $56db64df0b3e22ba$var$CustomizeIcon;

});
parcelRegister("iiRWr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8bb9804f9ea7eaa10f227008c94bcff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d533c021bfcfd692$var$_react = $d533c021bfcfd692$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d533c021bfcfd692$var$_baseNew = $d533c021bfcfd692$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d533c021bfcfd692$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d533c021bfcfd692$var$CustomizeIcon = (props)=>/*#__PURE__*/ $d533c021bfcfd692$var$_react.default.createElement($d533c021bfcfd692$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$d533c021bfcfd692$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $d533c021bfcfd692$var$_default = module.exports.default = $d533c021bfcfd692$var$CustomizeIcon;

});

parcelRegister("c8Sc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d70455a797b43c6$var$_react = $8d70455a797b43c6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $8d70455a797b43c6$var$_customize = $8d70455a797b43c6$var$_interopRequireDefault((parcelRequire("iiRWr")));
function $8d70455a797b43c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d70455a797b43c6$var$PreferencesIcon = (props)=>/*#__PURE__*/ $8d70455a797b43c6$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $8d70455a797b43c6$var$_customize.default
    }));
$8d70455a797b43c6$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $8d70455a797b43c6$var$_default = module.exports.default = $8d70455a797b43c6$var$PreferencesIcon;

});


parcelRegister("fbuFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $066cf44b88090e47$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $066cf44b88090e47$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltipText: {
        "id": "issue-table-column-picker.column-picker.picker-button.tooltip-text",
        "defaultMessage": "Configure columns"
    },
    addColumnTooltipText: {
        "id": "issue-table-column-picker.column-picker.picker-button.add-column-tooltip-text",
        "defaultMessage": "Add column"
    },
    columnPickerButtonText: {
        "id": "issue-table-column-picker.column-picker.picker-button.column-picker-button-text",
        "defaultMessage": "Column picker menu"
    },
    chevronDownIconText: {
        "id": "issue-table-column-picker.column-picker.picker-button.chevron-down-icon-text",
        "defaultMessage": "Chevron down icon"
    },
    boardIconText: {
        "id": "issue-table-column-picker.column-picker.picker-button.board-icon-text",
        "defaultMessage": "board icon"
    }
});

});


parcelRegister("eOLDG", function(module, exports) {

let $ac9ab05502b098cd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ac9ab05502b098cd$var$load("ffQaD"),
    $ac9ab05502b098cd$var$load("kvRbA"),
    $ac9ab05502b098cd$var$load("b9RuP")
]).then(()=>parcelRequire('7AiD0'));

});


// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("jE8Tu", function(module, exports) {

$parcel$export(module.exports, "filterNonIssueItems", () => $8416c949b39a62cd$export$3bf3427e3d5241d1);
$parcel$export(module.exports, "getItemKey", () => $8416c949b39a62cd$export$424834ba1b0663bc);
$parcel$export(module.exports, "getChildIssueCreateItemKey", () => $8416c949b39a62cd$export$5dbc02cdc002848d);
$parcel$export(module.exports, "getShowMoreItemKey", () => $8416c949b39a62cd$export$b262bb2cd2ab9f00);
$parcel$export(module.exports, "HierarchyContainer", () => $8416c949b39a62cd$export$4666215eda1bff58);
$parcel$export(module.exports, "useHierarchyStore", () => $8416c949b39a62cd$export$2fc259d06066fab6);
$parcel$export(module.exports, "useHierarchyActions", () => $8416c949b39a62cd$export$4fd9d94900cdff43);
$parcel$export(module.exports, "useIsItemExpanded", () => $8416c949b39a62cd$export$d11bf3cdf2aca60f);
$parcel$export(module.exports, "useIsSelected", () => $8416c949b39a62cd$export$fb40a80c530e5f2b);
$parcel$export(module.exports, "useIsFocused", () => $8416c949b39a62cd$export$a774b9356e1b793);
$parcel$export(module.exports, "useIsItemLoading", () => $8416c949b39a62cd$export$d169440ae865c511);
$parcel$export(module.exports, "useSelectedRow", () => $8416c949b39a62cd$export$11a86b67953bcc50);
$parcel$export(module.exports, "useVisibleDepth", () => $8416c949b39a62cd$export$ebb5be32d1c1b3ea);
$parcel$export(module.exports, "useFlatList", () => $8416c949b39a62cd$export$e8de618a961e45f5);
$parcel$export(module.exports, "useIssueIds", () => $8416c949b39a62cd$export$85c95ca9de9161bf);
$parcel$export(module.exports, "useFlatListIssueKeys", () => $8416c949b39a62cd$export$9f91dbe98f60bbaa);
$parcel$export(module.exports, "useHasExpandedItems", () => $8416c949b39a62cd$export$d77963246cf4131);
$parcel$export(module.exports, "useSelectedIssueKey", () => $8416c949b39a62cd$export$7cedcbfb2da7e49d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $jBNts = parcelRequire("jBNts");
const $8416c949b39a62cd$var$initialState = {
    selectedItem: null,
    focusedItem: null,
    expandedItems: {},
    rootConnectionId: null,
    connectionMap: {},
    connectionItems: {},
    loadingItems: {},
    /**
	 * Indicates the maximum expanded hierarhcy level:
	 * - Starts with 0 on initial load (flat list)
	 * - Expanding each level increments the value
	 */ visibleDepth: 0,
    flatList: [],
    issueKeys: [],
    listMetadata: [],
    amountOfRows: 0
};
const $8416c949b39a62cd$var$CHILD_ISSUE_CREATE_PREFIX = 'CHILD_ISSUE_CREATE';
const $8416c949b39a62cd$var$SHOW_MORE_PREFIX = 'SHOW_MORE';
const $8416c949b39a62cd$var$LOADING_ROW_PREFIX = 'LOADING_ROW';
const $8416c949b39a62cd$var$isSpecialItem = (id)=>id?.startsWith($8416c949b39a62cd$var$CHILD_ISSUE_CREATE_PREFIX) || id?.startsWith($8416c949b39a62cd$var$SHOW_MORE_PREFIX) || id?.startsWith($8416c949b39a62cd$var$LOADING_ROW_PREFIX);
const $8416c949b39a62cd$export$3bf3427e3d5241d1 = (list)=>list.filter(Boolean).filter((item)=>!$8416c949b39a62cd$var$isSpecialItem(item));
const $8416c949b39a62cd$export$424834ba1b0663bc = (itemsConnectionId, itemId, groupId)=>`${itemsConnectionId}::${itemId}${groupId ? `::${groupId}` : ''}`;
const $8416c949b39a62cd$export$5dbc02cdc002848d = (parentItemId)=>`${$8416c949b39a62cd$var$CHILD_ISSUE_CREATE_PREFIX}_${parentItemId}`;
const $8416c949b39a62cd$export$b262bb2cd2ab9f00 = (parentItemId)=>`${$8416c949b39a62cd$var$SHOW_MORE_PREFIX}_${parentItemId}`;
const $8416c949b39a62cd$export$4db25121b2596d32 = (parentItemId)=>`${$8416c949b39a62cd$var$LOADING_ROW_PREFIX}_${parentItemId}`;
const $8416c949b39a62cd$export$4aad0fc50e1251e4 = (key)=>{
    if (typeof key !== 'string') return {
        connectionId: null,
        itemId: null
    };
    const [connectionId, itemId] = key.split('::');
    return {
        connectionId: connectionId,
        itemId: itemId
    };
};
const $8416c949b39a62cd$var$actions = {
    populateConnection: ({ parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentConnectionId: parentConnectionId, list: list, hasNext: hasNext, isChildIssueCreateRowVisible: isChildIssueCreateRowVisible, groupId: groupId })=>{
        return ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (parentItemId === 'root') setState({
                rootConnectionId: itemsConnectionId
            });
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, parentItemId, groupId);
            const state = getState();
            let nextList = list?.slice() ?? null;
            // adding [Show more] button to flat list so that virtualiser recognizes it
            if (hasNext && nextList) {
                const showMoreRowKey = $8416c949b39a62cd$export$b262bb2cd2ab9f00(parentItemId);
                nextList = nextList.concat({
                    key: showMoreRowKey,
                    itemId: showMoreRowKey,
                    groupId: groupId
                });
            }
            if (isChildIssueCreateRowVisible && nextList) {
                const childIssueCreateRowKey = $8416c949b39a62cd$export$5dbc02cdc002848d(parentItemId);
                nextList.unshift({
                    key: childIssueCreateRowKey,
                    itemId: childIssueCreateRowKey,
                    groupId: groupId
                });
            }
            const parentKey = $8416c949b39a62cd$export$424834ba1b0663bc(parentConnectionId, parentItemId, // root doesn't have a groupId
            parentItemId === 'root' ? undefined : groupId);
            setState({
                connectionMap: {
                    ...state.connectionMap,
                    [parentKey]: key
                },
                connectionItems: {
                    ...state.connectionItems,
                    [key]: nextList
                }
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
            dispatch($8416c949b39a62cd$var$actions.clearSelectionIfItemIsNotInList());
        };
    },
    setItemIsLoading: ({ itemId: itemId, groupId: groupId, isLoading: isLoading })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { loadingItems: loadingItems, listMetadata: listMetadata, connectionItems: connectionItems } = getState();
            const loadingItemKey = $8416c949b39a62cd$export$4db25121b2596d32(itemId);
            const metadataItem = listMetadata.find((metadata)=>metadata.itemId === itemId);
            const key = metadataItem ? $8416c949b39a62cd$export$424834ba1b0663bc(metadataItem.connectionId, metadataItem.parentId, metadataItem.groupId) : null;
            if (!key || !connectionItems) return;
            let nextList = (connectionItems?.[key] ?? []).slice();
            if (isLoading) {
                const itemIndex = nextList.findIndex((item)=>item.itemId === itemId);
                if (itemIndex > -1) // insert loading row right after the expanded item
                nextList.splice(itemIndex + 1, 0, {
                    key: loadingItemKey,
                    itemId: loadingItemKey,
                    groupId: groupId
                });
            } else nextList = nextList.filter((item)=>item.itemId !== loadingItemKey);
            setState({
                loadingItems: {
                    ...loadingItems,
                    [itemId]: isLoading
                },
                connectionItems: {
                    ...connectionItems,
                    [key]: nextList
                }
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
            dispatch($8416c949b39a62cd$var$actions.clearSelectionIfItemIsNotInList());
        },
    toggleIsItemExpanded: (itemDetails, issueDepth)=>({ getState: getState, dispatch: dispatch })=>{
            if (!itemDetails) return;
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            const state = getState();
            const isExpanded = !state.expandedItems[key];
            dispatch($8416c949b39a62cd$var$actions.setIsItemExpanded(itemDetails, isExpanded, issueDepth));
        },
    setIsItemExpanded: (itemDetails, isItemExpanded, issueDepth = 0)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (!itemDetails) return;
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            const state = getState();
            /*
				Update visibleDepth with the new depth if is expanded an item
				traverseTreeAndUpdateState function would update the visibleDepth when collapse
			*/ const optimisticVisibleDepth = issueDepth + 1;
            const currentVisibleDepth = state.visibleDepth;
            const newVisibleDepth = isItemExpanded && optimisticVisibleDepth > currentVisibleDepth ? optimisticVisibleDepth : state.visibleDepth;
            setState({
                expandedItems: {
                    ...state.expandedItems,
                    [key]: isItemExpanded
                },
                ...isItemExpanded === false ? {
                    connectionItems: {
                        ...state.connectionItems,
                        [key]: null
                    }
                } : {},
                visibleDepth: newVisibleDepth
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
            dispatch($8416c949b39a62cd$var$actions.clearSelectionIfItemIsNotInList());
        },
    traverseTreeAndUpdateState: ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const result = $8416c949b39a62cd$export$dc56145edcd15e3e(getState());
            setState({
                flatList: result.flatlist,
                issueKeys: result.issueKeys,
                listMetadata: result.listMetadata,
                visibleDepth: result.hierarchyLevels[result.hierarchyLevels.length - 1]
            });
            dispatch($8416c949b39a62cd$var$actions.setAmountOfRows(result.flatlist.length));
        },
    setSelectedRow: (itemDetails)=>({ setState: setState })=>{
            if (!itemDetails) {
                setState({
                    selectedItem: null,
                    focusedItem: null
                });
                return;
            }
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            setState({
                selectedItem: key,
                focusedItem: key
            });
        },
    selectNextRow: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { listMetadata: listMetadata, selectedItem: selectedItem } = state;
            if (!selectedItem) return;
            const currentIndex = listMetadata.findIndex((item)=>item.key === selectedItem);
            const nextIndex = currentIndex + 1;
            if (nextIndex < listMetadata.length) dispatch($8416c949b39a62cd$var$actions.setSelectedRow({
                itemsConnectionId: listMetadata[nextIndex].connectionId,
                itemId: listMetadata[nextIndex].itemId,
                groupId: listMetadata[nextIndex].groupId
            }));
        },
    selectPrevRow: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { listMetadata: listMetadata, selectedItem: selectedItem } = state;
            if (!selectedItem) return;
            const currentIndex = listMetadata.findIndex((item)=>item.key === selectedItem);
            const previousIndex = currentIndex - 1;
            if (previousIndex >= 0) dispatch($8416c949b39a62cd$var$actions.setSelectedRow({
                itemsConnectionId: listMetadata[previousIndex].connectionId,
                itemId: listMetadata[previousIndex].itemId,
                groupId: listMetadata[previousIndex].groupId
            }));
        },
    clearSelectionIfItemIsNotInList: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { selectedItem: selectedItem } = state;
            if (!selectedItem || state.listMetadata.find((item)=>item.key === selectedItem)) return;
            dispatch($8416c949b39a62cd$var$actions.setSelectedRow(null));
        },
    setAmountOfRows: (newAmountOfRows)=>({ getState: getState, setState: setState })=>{
            const { amountOfRows: amountOfRows } = getState();
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows
            });
        },
    resetFocus: ()=>({ getState: getState, setState: setState })=>{
            const { focusedItem: focusedItem } = getState();
            focusedItem !== null && setState({
                focusedItem: null
            });
        },
    resetHierarchyKeepingFirstGroupExpanded: ({ firstGroupId: firstGroupId, itemsConnectionId: itemsConnectionId })=>({ setState: setState, dispatch: dispatch })=>{
            if (firstGroupId && itemsConnectionId) {
                const firstGroupKey = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, firstGroupId, firstGroupId);
                // First group is always expanded by default
                setState({
                    expandedItems: {
                        [firstGroupKey]: true
                    }
                });
            } else setState({
                expandedItems: {}
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
        }
};
const $8416c949b39a62cd$export$4666215eda1bff58 = (0, $6E16M.createContainer)();
const $8416c949b39a62cd$var$Store = (0, $GtRbT.createStore)({
    initialState: $8416c949b39a62cd$var$initialState,
    actions: $8416c949b39a62cd$var$actions,
    name: 'hierarchy',
    containedBy: $8416c949b39a62cd$export$4666215eda1bff58
});
const $8416c949b39a62cd$export$2fc259d06066fab6 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store);
const $8416c949b39a62cd$export$4fd9d94900cdff43 = (0, $iJq0l.createActionsHook)($8416c949b39a62cd$var$Store);
const $8416c949b39a62cd$export$d11bf3cdf2aca60f = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: (state, itemDetails)=>{
        if (!itemDetails) return false;
        const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
        const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
        return state.expandedItems[key] ?? false;
    }
});
const $8416c949b39a62cd$export$fb40a80c530e5f2b = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: (state, itemDetails)=>{
        if (!itemDetails) return false;
        const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
        return state.selectedItem === $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    }
});
const $8416c949b39a62cd$export$a774b9356e1b793 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: (state, itemDetails)=>{
        if (!itemDetails) return false;
        const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
        return state.focusedItem === $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    }
});
const $8416c949b39a62cd$var$getSelectedIndexSelector = (state)=>{
    const index = state.listMetadata.findIndex((item)=>item.key === state.selectedItem);
    if (index === -1) return null;
    return index;
};
const $8416c949b39a62cd$export$d169440ae865c511 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: (state, itemId)=>Boolean(itemId && state.loadingItems[itemId])
});
const $8416c949b39a62cd$export$11a86b67953bcc50 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getSelectedIndexSelector
});
const $8416c949b39a62cd$export$dc56145edcd15e3e = (state)=>{
    const traverse = ({ itemsConnectionId: itemsConnectionId, parentId: parentId, flatlist: flatlist, issueKeys: issueKeys, listMetadata: listMetadata, hierarchyLevels: hierarchyLevels, depth: depth, groupId: groupId })=>{
        const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, parentId, groupId);
        const connectionItem = state.connectionItems[key];
        if (!connectionItem) return {
            flatlist: flatlist,
            issueKeys: issueKeys,
            listMetadata: listMetadata,
            hierarchyLevels: hierarchyLevels
        };
        // itemGroupId is different from groupId at the root level
        connectionItem.forEach(({ itemId: id, key: issueKey, groupId: itemGroupId })=>{
            // groupId is needed in flatlist to make the issueId unique across multiple groups
            flatlist.push((0, $jBNts.getFlatListKey)({
                itemId: id,
                groupId: itemGroupId
            }));
            issueKeys.push(issueKey);
            const childConnectionKey = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, id, itemGroupId);
            listMetadata.push({
                itemId: id,
                parentId: parentId,
                key: childConnectionKey,
                connectionId: itemsConnectionId,
                groupId: itemGroupId
            });
            const isExpanded = state.expandedItems[childConnectionKey];
            if (isExpanded) {
                const currentDepth = depth + 1;
                if (!hierarchyLevels.includes(currentDepth)) hierarchyLevels.push(currentDepth);
                const childrenConnection = state.connectionMap[childConnectionKey];
                const { connectionId: childrenConnectionId } = $8416c949b39a62cd$export$4aad0fc50e1251e4(childrenConnection);
                if (childrenConnectionId) traverse({
                    itemsConnectionId: childrenConnectionId,
                    parentId: id,
                    flatlist: flatlist,
                    issueKeys: issueKeys,
                    listMetadata: listMetadata,
                    hierarchyLevels: hierarchyLevels,
                    depth: currentDepth,
                    groupId: itemGroupId
                });
            }
        });
        return {
            flatlist: flatlist,
            issueKeys: issueKeys,
            listMetadata: listMetadata,
            hierarchyLevels: hierarchyLevels
        };
    };
    const depth = 0;
    const flatlist = [];
    const issueKeys = [];
    const listMetadata = [];
    const hierarchyLevels = [
        depth
    ];
    if (!state.rootConnectionId) return {
        flatlist: flatlist,
        issueKeys: issueKeys,
        listMetadata: listMetadata,
        hierarchyLevels: hierarchyLevels
    };
    return traverse({
        itemsConnectionId: state.rootConnectionId,
        parentId: 'root',
        flatlist: flatlist,
        issueKeys: issueKeys,
        listMetadata: listMetadata,
        hierarchyLevels: hierarchyLevels,
        depth: depth
    });
};
const $8416c949b39a62cd$export$ebb5be32d1c1b3ea = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: (state)=>state.visibleDepth
});
const $8416c949b39a62cd$export$e8de618a961e45f5 = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: (state)=>state.flatList
});
const $8416c949b39a62cd$var$getIssueIdsSelector = (0, $4MchI.createSelector)((state)=>state.listMetadata, (listMetadata)=>listMetadata// filtering group headers out
    .filter(({ itemId: itemId, groupId: groupId })=>itemId !== groupId && !$8416c949b39a62cd$var$isSpecialItem(itemId)).map(({ itemId: itemId })=>itemId));
const $8416c949b39a62cd$export$85c95ca9de9161bf = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getIssueIdsSelector
});
const $8416c949b39a62cd$var$getIssueKeysSelector = (state)=>state.issueKeys;
const $8416c949b39a62cd$var$getFlatListIssueKeysSelector = (0, $4MchI.createSelector)($8416c949b39a62cd$var$getIssueKeysSelector, (issueKeys)=>$8416c949b39a62cd$export$3bf3427e3d5241d1(issueKeys));
const $8416c949b39a62cd$export$9f91dbe98f60bbaa = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getFlatListIssueKeysSelector
});
const $8416c949b39a62cd$export$a5d72277eb099991 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getIssueKeysSelector
});
const $8416c949b39a62cd$var$getSelectedIssueKeySelector = (0, $4MchI.createSelector)($8416c949b39a62cd$var$getSelectedIndexSelector, $8416c949b39a62cd$var$getIssueKeysSelector, (selectedIndex, issueKeys)=>{
    if (selectedIndex === null) return null;
    return issueKeys[selectedIndex];
});
const $8416c949b39a62cd$export$d77963246cf4131 = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: (state)=>Object.values(state.expandedItems).some((isExpanded)=>isExpanded)
});
const $8416c949b39a62cd$export$7cedcbfb2da7e49d = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getSelectedIssueKeySelector
});

});
parcelRegister("jBNts", function(module, exports) {

$parcel$export(module.exports, "getFlatListKey", () => $53a9450db45372ed$export$c15cfc620819beb5);
const $53a9450db45372ed$export$c15cfc620819beb5 = ({ itemId: itemId, groupId: groupId })=>`${itemId}${groupId ? `::${groupId}` : ''}`;

});


parcelRegister("3cJQz", function(module, exports) {

$parcel$export(module.exports, "HierarchyOnboardingProvider", () => $e4b1171d87a4cba5$export$61ea399940cf79d6);
$parcel$export(module.exports, "useHierarchyOnboardingContext", () => $e4b1171d87a4cba5$export$34916c588fba606d);
$parcel$export(module.exports, "HierarchyOnboarding", () => $e4b1171d87a4cba5$export$19eb9bdb0cf578f5);
$parcel$export(module.exports, "HierarchyToggleOnboarding", () => $e4b1171d87a4cba5$export$e350c43a524c2f15);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $d2s5v = parcelRequire("d2s5v");

var $3CprG = parcelRequire("3CprG");

var $9zZj0 = parcelRequire("9zZj0");

var $lRq8t = parcelRequire("lRq8t");

var $9HHOs = parcelRequire("9HHOs");

var $kEUB1 = parcelRequire("kEUB1");

var $g1NZW = parcelRequire("g1NZW");

var $epTsa = parcelRequire("epTsa");

var $domHz = parcelRequire("domHz");
const $e4b1171d87a4cba5$export$2d29273a16589c02 = 'jira-nin-hierarchy-onboarding-stg';
const $e4b1171d87a4cba5$export$e7deeb52c7c3e7a9 = 'jira-list-nin-hierarchy-onboarding';
const $e4b1171d87a4cba5$var$ENV_STAGING = 'staging';
const $e4b1171d87a4cba5$var$STARGATE_URL = '/gateway/api';
const $e4b1171d87a4cba5$var$HierarchyOnboardingContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $e4b1171d87a4cba5$export$61ea399940cf79d6 = ({ children: children })=>{
    const [showToggleOnboarding, setShowToggleOnboarding] = (0, $eJOHy.useState)(false);
    const value = (0, $eJOHy.useMemo)(()=>({
            showToggleOnboarding: showToggleOnboarding,
            setShowToggleOnboarding: setShowToggleOnboarding
        }), [
        showToggleOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4b1171d87a4cba5$var$HierarchyOnboardingContext.Provider, {
        value: value
    }, children);
};
const $e4b1171d87a4cba5$export$34916c588fba606d = ()=>{
    const hierarchyContext = (0, $eJOHy.useContext)($e4b1171d87a4cba5$var$HierarchyOnboardingContext);
    if (!hierarchyContext) throw new Error('useHierarchyOnboardingContext must be used within a HierarchyOnboardingProvider');
    return hierarchyContext;
};
const $e4b1171d87a4cba5$export$19eb9bdb0cf578f5 = ()=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $g1NZW.useEnvironment)() === $e4b1171d87a4cba5$var$ENV_STAGING ? $e4b1171d87a4cba5$export$2d29273a16589c02 : $e4b1171d87a4cba5$export$e7deeb52c7c3e7a9;
    const { setShowToggleOnboarding: setShowToggleOnboarding } = $e4b1171d87a4cba5$export$34916c588fba606d();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $kEUB1.useCloudId)();
    /**
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the HIERARCHY_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, $e4b1171d87a4cba5$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(false);
    const [isEnrolled, stopEnrolment] = (0, $7UDun.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $eJOHy.useEffect)(()=>{
        if (isEnrolled) {
            stopEnrolment(false);
            setIsSpotlightActive(true);
        }
    }, [
        isEnrolled,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isEnrolled && isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.expand-column-header",
        messageType: "engagement",
        actionsBeforeElement: "1/2",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    setShowToggleOnboarding(true);
                },
                text: formatMessage((0, $domHz.default).next)
            },
            {
                appearance: 'subtle',
                onClick: ()=>setIsSpotlightActive(false),
                text: formatMessage((0, $domHz.default).dismiss)
            }
        ],
        dialogWidth: 320,
        heading: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $domHz.default).onboardingHeadingIssueTermRefresh : (0, $domHz.default).onboardingHeading),
        target: "expand-column-header",
        key: "expand-column-header",
        targetRadius: 3
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $domHz.default).onboardingDescriptionIssueTermRefresh : (0, $domHz.default).onboardingDescription))));
};
const $e4b1171d87a4cba5$export$e350c43a524c2f15 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showToggleOnboarding: showToggleOnboarding, setShowToggleOnboarding: setShowToggleOnboarding } = $e4b1171d87a4cba5$export$34916c588fba606d();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(true);
    if (!isSpotlightActive || !showToggleOnboarding) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.hierarchy-feature-toggle",
        messageType: "engagement",
        actionsBeforeElement: "2/2",
        actions: [
            {
                onClick: ()=>{
                    setShowToggleOnboarding(false);
                    setIsSpotlightActive(false);
                },
                text: formatMessage((0, $domHz.default).ok)
            }
        ],
        dialogWidth: 320,
        target: "hierarchy-feature-toggle",
        key: "hierarchy-feature-toggle",
        targetRadius: 3
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $domHz.default).toggleOnboardingIssueTermRefresh : (0, $domHz.default).toggleOnboarding)));
};

});
parcelRegister("domHz", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb46e101bc25a0ef$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $eb46e101bc25a0ef$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    onboardingHeading: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading",
        "defaultMessage": "View issue hierarchy"
    },
    onboardingHeadingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading-issue-term-refresh",
        "defaultMessage": "View hierarchy"
    },
    onboardingDescription: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child issues."
    },
    onboardingDescriptionIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description-issue-term-refresh",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child work items."
    },
    next: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.next",
        "defaultMessage": "Next"
    },
    toggleOnboarding: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding",
        "defaultMessage": "Use the toggle to show or hide the issue hierarchy."
    },
    toggleOnboardingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding-issue-term-refresh",
        "defaultMessage": "Use the toggle to show or hide the hierarchy."
    },
    ok: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.done",
        "defaultMessage": "Ok"
    },
    dismiss: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("dLXgn", function(module, exports) {

$parcel$export(module.exports, "ConnectionsListContainer", () => $281e5150464a3bb6$export$ba73231554574611);
$parcel$export(module.exports, "useConnectionsList", () => $281e5150464a3bb6$export$8d76c2ce1bf0921e);
$parcel$export(module.exports, "useConnectionsListActions", () => $281e5150464a3bb6$export$d656d29a379d1749);
$parcel$export(module.exports, "useRegisterConnection", () => $281e5150464a3bb6$export$f9bef9773768341d);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $7zZ4w = parcelRequire("7zZ4w");
const $281e5150464a3bb6$var$INITIAL_CONNECTIONS_LIST_STATE = {
    connections: {}
};
const $281e5150464a3bb6$export$ba73231554574611 = (0, $6E16M.createContainer)();
const $281e5150464a3bb6$var$getKeyForConnection = (connection)=>{
    let key = connection.connectionId;
    if (connection.type === 'PARENT_CHILDREN') key = connection.parentId;
    if (connection.type === 'GROUP_CHILDREN') key = connection.groupId;
    // add some formatting to ensure it is not used for another purpose
    return `KEY_${key}`;
};
const $281e5150464a3bb6$var$actions = {
    addConnection: (connection)=>({ setState: setState, getState: getState })=>{
            const { connections: connections } = getState();
            const key = $281e5150464a3bb6$var$getKeyForConnection(connection);
            setState({
                connections: {
                    ...connections,
                    [key]: connection
                }
            });
        },
    removeConnection: (connection)=>({ setState: setState, getState: getState })=>{
            const { connections: connections } = getState();
            const key = $281e5150464a3bb6$var$getKeyForConnection(connection);
            const { [key]: _, ...newConnections } = connections;
            setState({
                connections: newConnections
            });
        }
};
const $281e5150464a3bb6$var$Store = (0, $GtRbT.createStore)({
    initialState: $281e5150464a3bb6$var$INITIAL_CONNECTIONS_LIST_STATE,
    name: 'ConnectionsListStore',
    containedBy: $281e5150464a3bb6$export$ba73231554574611,
    actions: $281e5150464a3bb6$var$actions,
    handlers: {
        onDestroy: ()=>({ getState: getState })=>{
                const { connections: connections } = getState();
                const environment = (0, $7zZ4w.default)();
                Object.values(connections).forEach((connection)=>{
                    environment.commitUpdate((store)=>{
                        const connectionToInvalidate = store.get(connection.connectionId);
                        if (connectionToInvalidate) connectionToInvalidate.invalidateRecord();
                    });
                });
            }
    }
});
const $281e5150464a3bb6$export$8d76c2ce1bf0921e = (0, $iJq0l.createStateHook)($281e5150464a3bb6$var$Store);
const $281e5150464a3bb6$export$d656d29a379d1749 = (0, $iJq0l.createActionsHook)($281e5150464a3bb6$var$Store);
const $281e5150464a3bb6$export$f9bef9773768341d = (connection)=>{
    const { addConnection: addConnection } = $281e5150464a3bb6$export$d656d29a379d1749();
    (0, $eJOHy.useEffect)(()=>{
        if (connection) addConnection(connection);
    }, [
        addConnection,
        connection
    ]);
};

});

parcelRegister("bYhG9", function(module, exports) {

$parcel$export(module.exports, "useHoverPopoverState", () => $d736550e3de5add3$export$ecaed54879b49151);
$parcel$export(module.exports, "useHoverPopoverSetter", () => $d736550e3de5add3$export$3ced34cbab3dc9bf);
$parcel$export(module.exports, "HoverPopoverStateProvider", () => $d736550e3de5add3$export$3240cf68ec0b7d81);

var $eJOHy = parcelRequire("eJOHy");

var $3OT15 = parcelRequire("3OT15");
const $d736550e3de5add3$var$HoverPopoverStateContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $d736550e3de5add3$var$HoverPopoverSetterContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $d736550e3de5add3$var$defaultState = {
    content: null,
    contentElement: null,
    cellRef: null,
    isOpen: false
};
const $d736550e3de5add3$var$HoverPopoverProviderLocal = ({ children: children })=>{
    const [hoverPopoverState, setHoverPopoverState] = (0, $eJOHy.useState)($d736550e3de5add3$var$defaultState);
    const unsubscribeRef = (0, $eJOHy.useRef)(null);
    const { getHoverPopoverContentById: getHoverPopoverContentById, subscribeHoverPopoverContentDeleteById: subscribeHoverPopoverContentDeleteById } = (0, $3OT15.useHoverPopoverContent)();
    const setPopoverClosed = (0, $eJOHy.useCallback)(()=>{
        setHoverPopoverState($d736550e3de5add3$var$defaultState);
    }, [
        setHoverPopoverState
    ]);
    /**
	 * When a popoover is opened, we subscribe to whether the content ref is deleted (i.e user switches from read to edit mode).
	 * If the content ref is deleted, we close the popover.
	 */ const setPopoverOpen = (0, $eJOHy.useCallback)(({ fieldId: fieldId, cell: cell, clearHoverFocusState: clearHoverFocusState })=>{
        const content = getHoverPopoverContentById(fieldId);
        if (!content) return;
        setHoverPopoverState({
            ...content,
            isOpen: true,
            cellRef: cell
        });
        unsubscribeRef.current = subscribeHoverPopoverContentDeleteById(fieldId, clearHoverFocusState);
    }, [
        setHoverPopoverState,
        getHoverPopoverContentById,
        subscribeHoverPopoverContentDeleteById
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            unsubscribeRef.current?.();
        };
    }, []);
    const stateValue = (0, $eJOHy.useMemo)(()=>({
            hoverPopoverState: hoverPopoverState
        }), [
        hoverPopoverState
    ]);
    const setterValue = (0, $eJOHy.useMemo)(()=>({
            setPopoverClosed: setPopoverClosed,
            setPopoverOpen: setPopoverOpen
        }), [
        setPopoverClosed,
        setPopoverOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d736550e3de5add3$var$HoverPopoverStateContext.Provider, {
        value: stateValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d736550e3de5add3$var$HoverPopoverSetterContext.Provider, {
        value: setterValue
    }, children));
};
const $d736550e3de5add3$export$ecaed54879b49151 = ()=>{
    const context = (0, $eJOHy.useContext)($d736550e3de5add3$var$HoverPopoverStateContext);
    if (context === undefined) throw new Error('useHoverPopover must be used within a HoverPopoverProvider');
    return context;
};
const $d736550e3de5add3$export$3ced34cbab3dc9bf = ()=>{
    const context = (0, $eJOHy.useContext)($d736550e3de5add3$var$HoverPopoverSetterContext);
    if (context === undefined) throw new Error('useHoverPopover must be used within a HoverPopoverProvider');
    return context;
};
const $d736550e3de5add3$export$3240cf68ec0b7d81 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3OT15.HoverPopoverContentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d736550e3de5add3$var$HoverPopoverProviderLocal, null, children));
};

});
parcelRegister("3OT15", function(module, exports) {

$parcel$export(module.exports, "HoverPopoverContentProvider", () => $0eef00447d3c2884$export$ae46fde6067ae6a0);
$parcel$export(module.exports, "useHoverPopoverContent", () => $0eef00447d3c2884$export$b82953ec381ff123);
$parcel$export(module.exports, "useHoverPopoverContentRef", () => $0eef00447d3c2884$export$674a542a71639eb6);

var $eJOHy = parcelRequire("eJOHy");

var $hX7Ca = parcelRequire("hX7Ca");
const $0eef00447d3c2884$var$HoverPopoverContentContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $0eef00447d3c2884$export$ae46fde6067ae6a0 = ({ children: children })=>{
    /**
	 * cellRefFieldIdMap is a map of cell refs to field IDs. This is used by the
	 * event delegator to lookup which field is hovered by table cell ref.
	 */ const cellRefFieldIdMap = (0, $hX7Ca.useLazyRef)(()=>new Map());
    /**
	 * fieldIdPopoverContentMap is a map of ARI field IDs to hover popover content.
	 * This is used by the hover popover state provider to lookup what the content for a hover popover
	 * is by a given field ID. In conjunction with the cellRefFieldIdMap above, this allows us to
	 * lookup the content for a hover popover by a given table cell ref.
	 */ const fieldIdPopoverContentMap = (0, $hX7Ca.useLazyRef)(()=>new Map());
    /**
	 * deleteListeners is a map of ARI field IDs to a set of delete listeners. See comments below on deleteHoverPopoverContentById.
	 */ const deleteListeners = (0, $hX7Ca.useLazyRef)(()=>new Map());
    const setCellIdByRef = (0, $eJOHy.useCallback)((cell, fieldId)=>{
        cellRefFieldIdMap.current.set(cell, fieldId);
    }, [
        cellRefFieldIdMap
    ]);
    const getCellIdByRef = (0, $eJOHy.useCallback)((cell)=>{
        return cellRefFieldIdMap.current.get(cell);
    }, [
        cellRefFieldIdMap
    ]);
    const deleteCellIdByRef = (0, $eJOHy.useCallback)((cell)=>{
        cellRefFieldIdMap.current.delete(cell);
    }, [
        cellRefFieldIdMap
    ]);
    const setHoverPopoverContentById = (0, $eJOHy.useCallback)((fieldId, content)=>{
        fieldIdPopoverContentMap.current.set(fieldId, content);
    }, [
        fieldIdPopoverContentMap
    ]);
    const getHoverPopoverContentById = (0, $eJOHy.useCallback)((fieldId)=>{
        return fieldIdPopoverContentMap.current.get(fieldId);
    }, [
        fieldIdPopoverContentMap
    ]);
    /**
	 * When a user hovers on a cell a popover opens. Then if they open inline edit we need the popover to close.
	 *
	 * The popover is attached using the hoverPopoverContentRef. When the popup is mounted, subscribeHoverPopoverContentDeleteById
	 * is called which allows us to subscribe to calls to deleteHoverPopoverContentById. When the component unmounts, the hover popover content ref will call this
	 * delete method (i.e user switches from read to edit mode), which calls any listeners (e.g closePopup).
	 */ const deleteHoverPopoverContentById = (0, $eJOHy.useCallback)((fieldId)=>{
        const isDeleted = fieldIdPopoverContentMap.current.delete(fieldId);
        if (isDeleted && deleteListeners.current.has(fieldId)) {
            for (const listener of deleteListeners.current.get(fieldId) ?? [])listener(fieldId);
            deleteListeners.current.delete(fieldId);
        }
    }, [
        fieldIdPopoverContentMap,
        deleteListeners
    ]);
    const subscribeHoverPopoverContentDeleteById = (0, $eJOHy.useCallback)((fieldId, listener)=>{
        if (!deleteListeners.current.has(fieldId)) deleteListeners.current.set(fieldId, new Set());
        deleteListeners.current.get(fieldId)?.add(listener);
        return ()=>{
            const listeners = deleteListeners.current.get(fieldId);
            if (listeners) {
                listeners.delete(listener);
                if (listeners.size === 0) deleteListeners.current.delete(fieldId);
            }
        };
    }, [
        deleteListeners
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            setCellIdByRef: setCellIdByRef,
            deleteCellIdByRef: deleteCellIdByRef,
            getCellIdByRef: getCellIdByRef,
            setHoverPopoverContentById: setHoverPopoverContentById,
            deleteHoverPopoverContentById: deleteHoverPopoverContentById,
            getHoverPopoverContentById: getHoverPopoverContentById,
            subscribeHoverPopoverContentDeleteById: subscribeHoverPopoverContentDeleteById
        }), [
        setCellIdByRef,
        deleteCellIdByRef,
        getCellIdByRef,
        setHoverPopoverContentById,
        deleteHoverPopoverContentById,
        getHoverPopoverContentById,
        subscribeHoverPopoverContentDeleteById
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0eef00447d3c2884$var$HoverPopoverContentContext.Provider, {
        value: contextValue
    }, children);
};
const $0eef00447d3c2884$export$b82953ec381ff123 = ()=>{
    const context = (0, $eJOHy.useContext)($0eef00447d3c2884$var$HoverPopoverContentContext);
    if (context === undefined) throw new Error('useHoverPopoverContent must be used within a HoverPopoverContentProvider');
    return context;
};
const $0eef00447d3c2884$export$674a542a71639eb6 = (fieldId)=>{
    const lastNode = (0, $eJOHy.useRef)(null);
    const { setHoverPopoverContentById: setHoverPopoverContentById, deleteHoverPopoverContentById: deleteHoverPopoverContentById } = $0eef00447d3c2884$export$b82953ec381ff123();
    const hoverPopoverContentRefFactory = (0, $eJOHy.useCallback)((content)=>(node)=>{
            if (node && fieldId) {
                setHoverPopoverContentById(fieldId, {
                    ...content,
                    contentElement: node
                });
                lastNode.current = node;
            } else if (lastNode.current && fieldId) {
                deleteHoverPopoverContentById(fieldId);
                lastNode.current = null;
            }
        }, [
        fieldId,
        setHoverPopoverContentById,
        deleteHoverPopoverContentById
    ]);
    return hoverPopoverContentRefFactory;
};

});
parcelRegister("hX7Ca", function(module, exports) {

$parcel$export(module.exports, "getClosestTextElement", () => $d5817523e8234df4$export$a4c1c84a8efc2153);
$parcel$export(module.exports, "checkIsClamped", () => $d5817523e8234df4$export$63c32f0123c21b4d);
$parcel$export(module.exports, "useLazyRef", () => $d5817523e8234df4$export$fd27aa36f007ec3d);

var $eJOHy = parcelRequire("eJOHy");
const $d5817523e8234df4$export$a4c1c84a8efc2153 = (el)=>{
    if (!el || !el.children || el.children.length === 0) return el;
    const elements = [
        el
    ];
    for (const e of elements){
        if (e.clientWidth !== e.scrollWidth) return e;
        for (const child of e.children)elements.push(child);
    }
    return el;
};
const $d5817523e8234df4$export$63c32f0123c21b4d = (el)=>{
    if (!el) return false;
    if (!(el instanceof Element)) return false;
    const currentStyle = getComputedStyle(el);
    const lineClamp = parseInt(currentStyle.getPropertyValue('-webkit-line-clamp'), 10);
    if (lineClamp > 0 && currentStyle.getPropertyValue('overflow') === 'hidden') return el.scrollHeight > el.clientHeight;
    return false;
};
const $d5817523e8234df4$var$uniqueReferencedValue = {};
function $d5817523e8234df4$export$fd27aa36f007ec3d(initializer) {
    const ref = (0, $eJOHy.useRef)($d5817523e8234df4$var$uniqueReferencedValue);
    if (ref.current === $d5817523e8234df4$var$uniqueReferencedValue) ref.current = initializer();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ref;
}

});



parcelRegister("f4DUY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f06e7986112c40eb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cQxBL = parcelRequire("cQxBL");

var $1OQKp = parcelRequire("1OQKp");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $9cbmy = parcelRequire("9cbmy");

var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $jE8Tu = parcelRequire("jE8Tu");

var $1NtzV = parcelRequire("1NtzV");
const $f06e7986112c40eb$var$ExpandHeaderCell = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const hasExpandedItems = (0, $jE8Tu.useHasExpandedItems)();
    const getScreenReaderMessage = ()=>{
        if (hasExpandedItems) return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderCollapseButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderCollapseButton;
        return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderExpandButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderExpandButton;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        xcss: $f06e7986112c40eb$var$hierarchyHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $f06e7986112c40eb$var$headerIconStyles
    }, hasExpandedItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
        label: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderCollapseButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderCollapseButton),
        color: "currentColor",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        label: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderExpandButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderExpandButton),
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, formatMessage(getScreenReaderMessage()))));
};
/* TODO: remove after cleaning jira_spreadsheet_component_m1 - style added for the onboarding spotlight  */ const $f06e7986112c40eb$var$hierarchyHeaderStyles = (0, $1DXK0.xcss)({
    height: 'size.300'
});
const $f06e7986112c40eb$var$headerIconStyles = (0, $1DXK0.xcss)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});
var $f06e7986112c40eb$export$2e2bcd8739ae039 = $f06e7986112c40eb$var$ExpandHeaderCell;

});
parcelRegister("1NtzV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c95e471dc06941e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5c95e471dc06941e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    columnHeaderExpandButton: {
        "id": "native-issue-table.column-header-expand-button",
        "defaultMessage": "Show all issues - expanded"
    },
    columnHeaderCollapseButton: {
        "id": "native-issue-table.column-header-collapse-button",
        "defaultMessage": "Show all issues - collapsed"
    },
    columnHeaderExpandButtonIssueTermRefresh: {
        "id": "native-issue-table.column-header-expand-button-issue-term-refresh",
        "defaultMessage": "Show all work items - expanded"
    },
    columnHeaderCollapseButtonIssueTermRefresh: {
        "id": "native-issue-table.column-header-collapse-button-issue-term-refresh",
        "defaultMessage": "Show all work items - collapsed"
    }
});

});


parcelRegister("lqvgs", function(module, exports) {

$parcel$export(module.exports, "CheckboxCell", () => $9bcf807234d52bfa$export$e0722abfbf26acc0);
$parcel$export(module.exports, "HeaderCheckboxCell", () => $9bcf807234d52bfa$export$b9d19e1dc166efac);

var $eJOHy = parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $6djmC = parcelRequire("6djmC");

var $2QO3b = parcelRequire("2QO3b");

var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $bJscI = parcelRequire("bJscI");

var $16sa1 = parcelRequire("16sa1");

var $da0uW = parcelRequire("da0uW");

var $bjHjL = parcelRequire("bjHjL");
const $9bcf807234d52bfa$var$MaybeCheckboxUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "checkbox-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $9bcf807234d52bfa$var$MaybeHeaderCheckboxUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "header-checkbox-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $9bcf807234d52bfa$export$e0722abfbf26acc0 = ({ issueId: issueId, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        "aria-label": formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bjHjL.messages).checkboxAriaLabelIssueTermRefresh : (0, $bjHjL.messages).checkboxAriaLabel),
        onClick: ()=>(0, $2QO3b.abortAll)('new_interaction'),
        ...checkboxProps
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $da0uW.CheckboxCell), {
        issueId: issueId,
        ...checkboxProps
    }));
};
const $9bcf807234d52bfa$export$b9d19e1dc166efac = ({ selectableIssueIds: selectableIssueIds, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeHeaderCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "header-checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        "aria-label": formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bjHjL.messages).checkboxAriaLabelIssueTermRefresh : (0, $bjHjL.messages).checkboxAriaLabel),
        onClick: ()=>(0, $2QO3b.abortAll)('new_interaction'),
        ...checkboxProps
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeHeaderCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $da0uW.HeaderCheckboxCell), {
        selectableIssueIds: selectableIssueIds,
        ...checkboxProps
    }));
};

});
parcelRegister("86tBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $43629aa548cc82fb$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $gyJTO = parcelRequire("gyJTO");

var $cM2mi = parcelRequire("cM2mi");
var $jJLKy = parcelRequire("jJLKy");
var $9ywMw = parcelRequire("9ywMw");
var $lsp6q = parcelRequire("lsp6q");
const $43629aa548cc82fb$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $43629aa548cc82fb$var$Checkbox = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $eJOHy.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $gyJTO.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eJOHy.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jJLKy.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hcewu.default)([
                    $43629aa548cc82fb$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cM2mi.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ywMw.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lsp6q.default), {})
                ]
            })
        ]
    });
}));
$43629aa548cc82fb$var$Checkbox.displayName = 'Checkbox';
var $43629aa548cc82fb$export$2e2bcd8739ae039 = $43629aa548cc82fb$var$Checkbox;

});
parcelRegister("cM2mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b89a586a6c2ef726$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
function $b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $b89a586a6c2ef726$var$CheckboxIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eJOHy.useMemo)(()=>$b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $b89a586a6c2ef726$export$2e2bcd8739ae039 = $b89a586a6c2ef726$var$CheckboxIcon;

});

parcelRegister("jJLKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4573aabb850f2ff0$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4573aabb850f2ff0$var$baseStyles = null;
const $4573aabb850f2ff0$var$textLabelLayoutStyles = null;
const $4573aabb850f2ff0$var$disabledStyles = null;
const $4573aabb850f2ff0$var$labelStyles = null;
function $4573aabb850f2ff0$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("9ywMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $94306373cce3a9fe$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $94306373cce3a9fe$var$labelTextStyles = null;
function $94306373cce3a9fe$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("lsp6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bafcc116ddbb4544$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bafcc116ddbb4544$var$requiredIndicatorStyles = null;
function $bafcc116ddbb4544$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hcewu.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("da0uW", function(module, exports) {

$parcel$export(module.exports, "CheckboxCell", () => $c779eb0d2caf5c35$export$e0722abfbf26acc0);
$parcel$export(module.exports, "HeaderCheckboxCell", () => $c779eb0d2caf5c35$export$b9d19e1dc166efac);

var $eJOHy = parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $6djmC = parcelRequire("6djmC");

var $2QO3b = parcelRequire("2QO3b");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $jE8Tu = parcelRequire("jE8Tu");

var $3TtKq = parcelRequire("3TtKq");

var $hCXvl = parcelRequire("hCXvl");

var $bjHjL = parcelRequire("bjHjL");
const $c779eb0d2caf5c35$var$EMPTY_ARRAY = [];
const $c779eb0d2caf5c35$export$e0722abfbf26acc0 = ({ issueId: issueId, rowIndex: rowIndex, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isIssueSelected = (0, $3TtKq.useIsIssueSelected)(issueId);
    // TODO Remove useSelectedRowActions when cleaning up jsc_m2_hierarchy_fe_changes
    const { checkRow: checkRowWithoutHierarchy } = (0, $hCXvl.useSelectedRowActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    let flatListIssueIds = $c779eb0d2caf5c35$var$EMPTY_ARRAY;
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    flatListIssueIds = (0, $jE8Tu.useIssueIds)();
    const { selectedOnlyIssueId: selectedOnlyIssueId, checkIssueRow: checkIssueRow } = (0, $3TtKq.useIssueTableSelectedIssuesActions)();
    const isShiftPressed = (0, $eJOHy.useRef)(false);
    const onCheckboxChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        const toggleCheckboxChecked = e.target.checked;
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'newIssueNavigatorTableRow', {
            isCheckboxChecked: toggleCheckboxChecked,
            selectionType: isShiftPressed.current ? 'shift' : 'default'
        });
        if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) checkIssueRow(issueId, toggleCheckboxChecked, isShiftPressed.current, flatListIssueIds);
        else checkRowWithoutHierarchy(rowIndex, toggleCheckboxChecked, isShiftPressed.current);
    }, [
        checkIssueRow,
        issueId,
        flatListIssueIds,
        checkRowWithoutHierarchy,
        rowIndex
    ]);
    const handleSelectedOnlyIssueId = (0, $eJOHy.useCallback)((ev)=>{
        ev.preventDefault();
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'checkbox',
            action: 'changed'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'newIssueNavigatorTableRow', {
            isCheckboxChecked: true,
            selectionType: 'ctrl'
        });
        selectedOnlyIssueId(issueId);
    }, [
        createAnalyticsEvent,
        selectedOnlyIssueId,
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        ...checkboxProps,
        "aria-label": formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bjHjL.messages).checkboxAriaLabelIssueTermRefresh : (0, $bjHjL.messages).checkboxAriaLabel),
        isChecked: isIssueSelected,
        onChange: onCheckboxChange,
        onClick: (ev)=>{
            isShiftPressed.current = ev.shiftKey;
            (0, $2QO3b.abortAll)('new_interaction');
        },
        onKeyDown: (ev)=>{
            if (!isIssueSelected && ev.ctrlKey && ev.code === 'Space') handleSelectedOnlyIssueId(ev);
        },
        onContextMenu: (ev)=>{
            if (!isIssueSelected && ev.ctrlKey) handleSelectedOnlyIssueId(ev);
        }
    }));
};
const $c779eb0d2caf5c35$export$b9d19e1dc166efac = ({ selectableIssueIds: selectableIssueIds, groupByFieldId: groupByFieldId, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedIssueIds = (0, $3TtKq.useIssueTableSelectedIssues)();
    const { insertSelectedIssueIds: insertSelectedIssueIds, reset: reset } = (0, $3TtKq.useIssueTableSelectedIssuesActions)();
    const prevGroupByFieldId = (0, $eJOHy.useRef)(groupByFieldId);
    if (prevGroupByFieldId.current !== groupByFieldId) {
        prevGroupByFieldId.current = groupByFieldId;
        reset();
    }
    let issueIds;
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    issueIds = (0, $jE8Tu.useIssueIds)();
    else issueIds = selectableIssueIds;
    const isChecked = (0, $3TtKq.useAreAllIssuesSelected)(issueIds);
    const isIndeterminate = !isChecked && selectedIssueIds.length > 0;
    const onCheckboxChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        const toggleCheckboxChecked = e.target.checked;
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'bulkSelectTableRows', {
            isCheckboxChecked: toggleCheckboxChecked
        });
        if (isIndeterminate || !isChecked) insertSelectedIssueIds(issueIds);
        else if (isChecked) reset();
    }, [
        insertSelectedIssueIds,
        isChecked,
        isIndeterminate,
        reset,
        issueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "header-checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        ...checkboxProps,
        "aria-label": formatMessage((0, $bjHjL.messages).headerCheckboxAriaLabel),
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        onChange: onCheckboxChange,
        onClick: ()=>{
            (0, $2QO3b.abortAll)('new_interaction');
        }
    }));
};

});
parcelRegister("3TtKq", function(module, exports) {

$parcel$export(module.exports, "IssueTableSelectedIssuesContainer", () => $8531abba95832313$export$b11112517798dbed);
$parcel$export(module.exports, "useIssueTableSelectedIssuesActions", () => $8531abba95832313$export$b4602482fdfd31ed);
$parcel$export(module.exports, "useIssueTableSelectedIssues", () => $8531abba95832313$export$ad5f97924b14314b);
$parcel$export(module.exports, "useIsIssueSelected", () => $8531abba95832313$export$cfefd69fc8a5ac52);
$parcel$export(module.exports, "useAreAllIssuesSelected", () => $8531abba95832313$export$949e47631f4a60a5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $1hqwo = parcelRequire("1hqwo");
const $8531abba95832313$export$b11112517798dbed = (0, $6E16M.createContainer)();
const $8531abba95832313$var$Store = (0, $GtRbT.createStore)({
    initialState: $1hqwo.initialState,
    actions: $1hqwo.actions,
    name: 'jira-native-issue-table-selected-issues-state',
    containedBy: $8531abba95832313$export$b11112517798dbed
});
const $8531abba95832313$export$b4602482fdfd31ed = (0, $iJq0l.createActionsHook)($8531abba95832313$var$Store);
const $8531abba95832313$var$getSelectedIssueIdsSelector = (state)=>{
    return Array.from(state.selectedIssueIds);
};
const $8531abba95832313$export$ad5f97924b14314b = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getSelectedIssueIdsSelector
});
const $8531abba95832313$var$getIsIssueIdSelectedSelector = (state, issueId)=>{
    return state.selectedIssueIds.has(issueId);
};
const $8531abba95832313$export$cfefd69fc8a5ac52 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsIssueIdSelectedSelector
});
const $8531abba95832313$var$getAreAllIssuesSelectedSelector = (state, issueIds)=>{
    const selectedIssueIds = $8531abba95832313$var$getSelectedIssueIdsSelector(state);
    return issueIds.length > 0 && issueIds.every((issueId)=>selectedIssueIds.includes(issueId));
};
const $8531abba95832313$export$949e47631f4a60a5 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getAreAllIssuesSelectedSelector
});

});
parcelRegister("1hqwo", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d2b10d6e7ee3216e$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $d2b10d6e7ee3216e$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d2b10d6e7ee3216e$export$d4c72bab9d6cc13a = {
    selectedIssueIds: new Set([]),
    lastSelectedRowIndex: null
};
const $d2b10d6e7ee3216e$export$e324594224ef24da = {
    insertSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            onIssueSelected?.(selectedIssueIds);
            setState({
                selectedIssueIds: new Set([
                    ...currentState.selectedIssueIds,
                    ...selectedIssueIds
                ])
            });
        },
    removeSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            selectedIssueIds.forEach((selectedIssueId)=>{
                updatedSelectedIssueIds.delete(selectedIssueId);
            });
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    insertSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.add(selectedIssueId);
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    removeSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.delete(selectedIssueId);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    selectedOnlyIssueId: (selectedIssueId)=>({ setState: setState }, { onIssueSelected: onIssueSelected })=>{
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: new Set([
                    selectedIssueId
                ])
            });
        },
    updateLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState })=>{
            setState({
                lastSelectedRowIndex: lastSelectedRowIndex
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState($d2b10d6e7ee3216e$export$d4c72bab9d6cc13a);
        },
    checkIssueRow: (issueId, isChecked, isShiftPressed, flatList)=>({ dispatch: dispatch, getState: getState })=>{
            const selectedIssueIds = [
                issueId
            ];
            const currentState = getState();
            const currentCheckedIndex = flatList.findIndex((id)=>id === issueId);
            if (isShiftPressed && currentState.lastSelectedRowIndex !== null) {
                const start = Math.min(currentState.lastSelectedRowIndex, currentCheckedIndex);
                const end = Math.max(currentState.lastSelectedRowIndex, currentCheckedIndex);
                selectedIssueIds.push(...flatList.slice(start, end + 1).filter((id)=>id !== issueId));
            }
            dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.updateLastSelectedRowIndex(currentCheckedIndex));
            if (isChecked) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.insertSelectedIssueIds(selectedIssueIds));
            else dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.removeSelectedIssueIds(selectedIssueIds));
        }
};

});


parcelRegister("hCXvl", function(module, exports) {

$parcel$export(module.exports, "SelectedRowContainer", () => $6927ba9053d93947$export$613ab77d2c52b90d);
$parcel$export(module.exports, "useSelectedRow", () => $6927ba9053d93947$export$11a86b67953bcc50);
$parcel$export(module.exports, "useIsSelected", () => $6927ba9053d93947$export$fb40a80c530e5f2b);
$parcel$export(module.exports, "useIsFocused", () => $6927ba9053d93947$export$a774b9356e1b793);
$parcel$export(module.exports, "useSelectedRowActions", () => $6927ba9053d93947$export$7b16b18429291a5c);

var $dQYVb = parcelRequire("dQYVb");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $3TtKq = parcelRequire("3TtKq");

var $jILqm = parcelRequire("jILqm");
const $6927ba9053d93947$var$initialState = {
    selectedRowIndex: null,
    amountOfRows: 0,
    focusedRowIndex: null
};
const $6927ba9053d93947$var$Store = (0, $GtRbT.createStore)({
    initialState: $6927ba9053d93947$var$initialState,
    actions: $jILqm.default,
    name: 'selectedRowState'
});
const $6927ba9053d93947$export$42a852a2b6b56249 = (0, $6E16M.createContainer)($6927ba9053d93947$var$Store, {
    onInit: ()=>({ setState: setState }, { selectedRowIndex: selectedRowIndex = null, amountOfRows: amountOfRows = 0 })=>{
            setState({
                selectedRowIndex: selectedRowIndex,
                amountOfRows: amountOfRows
            });
        },
    onUpdate: ()=>({ setState: setState, getState: getState }, { selectedRowIndex: newRowIndex, amountOfRows: newAmountOfRows })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            selectedRowIndex !== newRowIndex && setState({
                selectedRowIndex: newRowIndex ?? null
            });
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows ?? 0
            });
        }
});
const $6927ba9053d93947$export$613ab77d2c52b90d = ({ issues: issues, onPageChange: onPageChange, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $dQYVb.default), issues);
    const { insertSelectedIssueIds: insertSelectedIssueIds, removeSelectedIssueIds: removeSelectedIssueIds } = (0, $3TtKq.useIssueTableSelectedIssuesActions)();
    const lastSelectedRow = (0, $eJOHy.useRef)(null);
    const cursors = data?.pageCursors?.around;
    const currentPageIndex = (0, $eJOHy.useMemo)(()=>cursors?.findIndex((cursor)=>cursor?.isCurrent) ?? -1, [
        cursors
    ]);
    const onNextPage = (0, $eJOHy.useCallback)(()=>{
        if (onPageChange && currentPageIndex > -1) {
            const nextPage = cursors?.[currentPageIndex + 1];
            if (nextPage && nextPage.cursor != null) onPageChange(nextPage.cursor, false);
        }
    }, [
        currentPageIndex,
        cursors,
        onPageChange
    ]);
    const onPreviousPage = (0, $eJOHy.useCallback)(()=>{
        if (onPageChange && currentPageIndex > 0) {
            const previousPage = cursors?.[currentPageIndex - 1];
            if (previousPage && previousPage.cursor != null) onPageChange(previousPage.cursor, true);
        }
    }, [
        currentPageIndex,
        cursors,
        onPageChange
    ]);
    const onCheckRow = (0, $eJOHy.useCallback)((rowIndex, isChecked, isShiftSelected)=>{
        const initialIssueId = data?.edges?.[rowIndex]?.node?.issueId;
        if (!initialIssueId) return;
        const selectedIssueIds = [
            initialIssueId
        ];
        if (isShiftSelected && lastSelectedRow.current !== null) {
            const start = Math.min(lastSelectedRow.current, rowIndex);
            const end = Math.max(lastSelectedRow.current, rowIndex);
            for(let i = start; i <= end; i++){
                const currentIssueId = data?.edges?.[i]?.node?.issueId;
                if (i !== rowIndex && currentIssueId) selectedIssueIds.push(currentIssueId);
            }
        }
        lastSelectedRow.current = rowIndex;
        if (isChecked) insertSelectedIssueIds(selectedIssueIds);
        else removeSelectedIssueIds(selectedIssueIds);
    }, [
        data?.edges,
        insertSelectedIssueIds,
        removeSelectedIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6927ba9053d93947$export$42a852a2b6b56249, {
        ...props,
        onNextPage: onNextPage,
        onPreviousPage: onPreviousPage,
        onCheckRow: onCheckRow
    });
};
const $6927ba9053d93947$export$11a86b67953bcc50 = (0, $iJq0l.createHook)($6927ba9053d93947$var$Store, {
    selector: (state)=>state.selectedRowIndex
});
const $6927ba9053d93947$export$fb40a80c530e5f2b = (0, $iJq0l.createHook)($6927ba9053d93947$var$Store, {
    selector: (state, { selectedRowIndex: selectedRowIndex })=>state.selectedRowIndex === selectedRowIndex
});
const $6927ba9053d93947$export$a774b9356e1b793 = (0, $iJq0l.createHook)($6927ba9053d93947$var$Store, {
    selector: (state, { selectedRowIndex: selectedRowIndex })=>state.focusedRowIndex === selectedRowIndex
});
const $6927ba9053d93947$export$7b16b18429291a5c = (0, $iJq0l.createActionsHook)($6927ba9053d93947$var$Store);
const $6927ba9053d93947$export$f8ee25964657042a = (0, $iJq0l.createHook)($6927ba9053d93947$var$Store, {
    selector: (state)=>state.amountOfRows
});

});
parcelRegister("dQYVb", function(module, exports) {

$parcel$export(module.exports, "default", () => $da75d2a3af1a5458$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<062fdfba47135a99742296f1356235f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $da75d2a3af1a5458$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageSize"
        }
    ],
    "kind": "Fragment",
    "name": "selectedRowState_nativeIssueTable_SelectedRowContainer",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "maxCursors",
                    "value": 7
                },
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                }
            ],
            "concreteType": "JiraPageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "around",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCurrent"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$da75d2a3af1a5458$var$node.hash = "558a18d92170dc40c5bb420aa3fa3826";
var $da75d2a3af1a5458$export$2e2bcd8739ae039 = $da75d2a3af1a5458$var$node;

});

parcelRegister("jILqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $496a7015da5426ec$export$2e2bcd8739ae039);
const $496a7015da5426ec$var$actions = {
    setSelectedRow: (rowIndex)=>({ getState: getState, setState: setState }, { onRowChange: onRowChange })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            if (selectedRowIndex !== rowIndex && amountOfRows > 0) {
                setState({
                    selectedRowIndex: rowIndex,
                    focusedRowIndex: rowIndex
                });
                onRowChange && onRowChange(rowIndex);
            }
        },
    resetFocus: ()=>({ getState: getState, setState: setState })=>{
            const { focusedRowIndex: focusedRowIndex } = getState();
            focusedRowIndex !== null && setState({
                focusedRowIndex: null
            });
        },
    setAmountOfRows: (newAmountOfRows)=>({ setState: setState, getState: getState })=>{
            const { amountOfRows: amountOfRows } = getState();
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows
            });
        },
    selectNextRow: ()=>({ getState: getState, dispatch: dispatch }, { onNextPage: onNextPage })=>{
            const { amountOfRows: amountOfRows, selectedRowIndex: selectedRowIndex } = getState();
            if (amountOfRows === 0) return;
            // edge case: we have only blank issues in the list, we want to make it key accessible
            if (selectedRowIndex === null) dispatch($496a7015da5426ec$var$actions.setSelectedRow(0));
            else if (selectedRowIndex < amountOfRows - 1) dispatch($496a7015da5426ec$var$actions.setSelectedRow(selectedRowIndex + 1));
            else if (selectedRowIndex === amountOfRows - 1 && onNextPage) onNextPage();
        },
    selectPrevRow: ()=>({ getState: getState, dispatch: dispatch }, { onPreviousPage: onPreviousPage })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            if (amountOfRows === 0) return;
            // edge case: we have only one blank issues in the list, we want to make it key accessible
            if (selectedRowIndex === null) dispatch($496a7015da5426ec$var$actions.setSelectedRow(0));
            else if (selectedRowIndex > 0) dispatch($496a7015da5426ec$var$actions.setSelectedRow(selectedRowIndex - 1));
            else if (selectedRowIndex === 0 && onPreviousPage) onPreviousPage();
        },
    checkRow: (rowIndex, isChecked, isShiftPressed)=>(_, { onCheckRow: onCheckRow })=>{
            onCheckRow && onCheckRow(rowIndex, isChecked, isShiftPressed);
        }
};
var $496a7015da5426ec$export$2e2bcd8739ae039 = $496a7015da5426ec$var$actions;

});


parcelRegister("bjHjL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b1f512fd4e489e96$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b1f512fd4e489e96$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    checkboxAriaLabel: {
        "id": "native-issue-table.common.issue-cells.checkbox.checkbox-aria-label",
        "defaultMessage": "Issue checkbox"
    },
    checkboxAriaLabelIssueTermRefresh: {
        "id": "native-issue-table.common.issue-cells.checkbox.checkbox-aria-label-issue-term-refresh",
        "defaultMessage": "Work item checkbox"
    },
    headerCheckboxAriaLabel: {
        "id": "native-issue-table.common.issue-cells.checkbox.header-checkbox-aria-label",
        "defaultMessage": "Select all checkbox"
    }
});

});



parcelRegister("kmIYY", function(module, exports) {

$parcel$export(module.exports, "IssueTableSkeleton", () => $d01bd5b1473e1c91$export$32020b6a5557f03e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $coBPg = parcelRequire("coBPg");
const $d01bd5b1473e1c91$export$32020b6a5557f03e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d01bd5b1473e1c91$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coBPg.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d01bd5b1473e1c91$var$SkeletonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("coBPg", function(module, exports) {

$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $f004264ba9491c9c$export$309a6db85e3f2aaa);
/* NativeIssueTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $9co9i = parcelRequire("9co9i");
const $f004264ba9491c9c$var$customCssStyles = null;
const $f004264ba9491c9c$var$containerStyles = {
    height: '448px'
};
const $f004264ba9491c9c$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9co9i))),
        containerStyles: $f004264ba9491c9c$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("9co9i", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});



parcelRegister("dmolI", function(module, exports) {

$parcel$export(module.exports, "getColumnConfig", () => $7eb0a7a19768d5ff$export$38a3f9395eadb298);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $3cMgR = parcelRequire("3cMgR");

var $7jTnu = parcelRequire("7jTnu");

var $6XJko = parcelRequire("6XJko");

var $j8Km1 = parcelRequire("j8Km1");

var $8jOO7 = parcelRequire("8jOO7");

var $kpvjE = parcelRequire("kpvjE");
const $7eb0a7a19768d5ff$export$47c53e05a89322a1 = (0, $LFmXM.default)((formatMessage)=>({
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ASSIGNEE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX]: ()=>({
                defaultWidth: 40,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATED]: ()=>({
                defaultWidth: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? 201 : 126,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).UPDATED]: ()=>({
                defaultWidth: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? 201 : 130,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TIMELINE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE]: ()=>({
                defaultWidth: 140,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION_DATE]: ()=>({
                defaultWidth: 106,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PRIORITY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY]: ()=>({
                defaultWidth: (0, $7jTnu.fg)('jira_list_merged_column_gate') ? 140 : 96,
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON]: ()=>({
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: ()=>({
                title: '',
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: ()=>({
                // Overrides title from the server's displayName from "Issue Type" to "Type" as per designs
                title: formatMessage((0, $kpvjE.default).columnHeaderIssueType),
                defaultWidth: 101,
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION]: ()=>({
                defaultWidth: 106
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REPORTER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATOR]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SPRINT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PARENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        // Labels renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
        // <Tag/> has a maxWidth of 180px with 4px of padding either side
        // And we need to accound for 5px & 8px for left and right padding on our cell respectively
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).LABELS]: ()=>({
                defaultWidth: 201
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).COMPONENTS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).FIX_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS_CATEGORY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PROJECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EPIC_LINK]: ()=>({
                // EpicLink renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
                // <Tag/> has a maxWidth of 180px with 4px of padding either side
                // And we need to account for 5px & 8px for left and right padding on our cell respectively
                defaultWidth: 201,
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld),
                warningText: formatMessage((0, $kpvjE.default).deprecatedEpicLinkMessage, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                            color: "color.text.inverse",
                            as: "strong"
                        }, chunks)
                })
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DESCRIPTION]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ENVIRONMENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT_AREA]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).READ_ONLY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).AFFECTS_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REQUEST_TYPE]: ()=>({
                defaultWidth: 251,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).NUMBER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).USER_PICKER]: ()=>(0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? {
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            } : {
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            },
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CUSTOM_LABELS]: ()=>({
                defaultWidth: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? 201 : (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_TIME]: ()=>({
                defaultWidth: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? 201 : (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).URL]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jsc_inline_editing_field_refactor') && {
                    ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                    descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_USER_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEAM]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ORIGINAL_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).GOALS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CASCADING_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CONFLUENCE_PAGES]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PEOPLE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN]: ()=>({
                defaultWidth: (0, $j8Km1.MERGED_COLUMN_DEFAULT_WIDTH),
                isSortable: false
            })
    }));
const $7eb0a7a19768d5ff$export$f7ea0b98861f6494 = (0, $LFmXM.default)((formatMessage)=>{
    const aToZOrder = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_A_TO_Z) : formatMessage((0, $kpvjE.default).aToZOrder);
    const zToAOrder = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_Z_TO_A) : formatMessage((0, $kpvjE.default).zToAOrder);
    const oldestToNewestOrder = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_OLDEST_TO_NEWEST) : formatMessage((0, $kpvjE.default).oldestToNewestOrder);
    const newestToOldestOrder = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_NEWEST_TO_OLDEST) : formatMessage((0, $kpvjE.default).newestToOldestOrder);
    return {
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ASSIGNEE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX]: ()=>({
                defaultWidth: 40,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATED]: ()=>({
                defaultWidth: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? 201 : 126,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).UPDATED]: ()=>({
                defaultWidth: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? 201 : 130,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TIMELINE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE]: ()=>({
                defaultWidth: 140,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION_DATE]: ()=>({
                defaultWidth: 106,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PRIORITY]: ()=>({
                defaultWidth: 140,
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY]: ()=>({
                defaultWidth: (0, $7jTnu.fg)('jira_list_merged_column_gate') ? 140 : 96,
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') ? {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                } : {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON]: ()=>({
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: ()=>({
                title: '',
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: ()=>({
                // Overrides title from the server's displayName from "Issue Type" to "Type" as per designs
                title: formatMessage((0, $kpvjE.default).columnHeaderIssueType),
                defaultWidth: 101,
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION]: ()=>({
                defaultWidth: 106,
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REPORTER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATOR]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SPRINT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PARENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        // Labels renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
        // <Tag/> has a maxWidth of 180px with 4px of padding either side
        // And we need to accound for 5px & 8px for left and right padding on our cell respectively
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).LABELS]: ()=>({
                defaultWidth: 201,
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).COMPONENTS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).FIX_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS_CATEGORY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PROJECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EPIC_LINK]: ()=>({
                // EpicLink renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
                // <Tag/> has a maxWidth of 180px with 4px of padding either side
                // And we need to account for 5px & 8px for left and right padding on our cell respectively
                defaultWidth: 201,
                ascText: aToZOrder,
                descText: zToAOrder,
                warningText: formatMessage((0, $kpvjE.default).deprecatedEpicLinkMessage, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                            color: "color.text.inverse",
                            as: "strong"
                        }, chunks)
                })
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DESCRIPTION]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ENVIRONMENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT_AREA]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).READ_ONLY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).AFFECTS_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REQUEST_TYPE]: ()=>({
                defaultWidth: 251,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).NUMBER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).USER_PICKER]: ()=>(0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? {
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            } : {
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            },
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CUSTOM_LABELS]: ()=>({
                defaultWidth: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? 201 : (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_TIME]: ()=>({
                defaultWidth: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? 201 : (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: oldestToNewestOrder,
                    descText: newestToOldestOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).URL]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jsc_inline_editing_field_refactor') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_USER_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEAM]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ORIGINAL_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).GOALS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CASCADING_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CONFLUENCE_PAGES]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PEOPLE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    ascText: oldestToNewestOrder,
                    descText: newestToOldestOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN]: ()=>({
                defaultWidth: (0, $j8Km1.MERGED_COLUMN_DEFAULT_WIDTH),
                isSortable: false
            })
    };
});
const $7eb0a7a19768d5ff$export$38a3f9395eadb298 = (formatMessage)=>{
    return (0, $6XJko.isVisualRefreshEnabled)() ? $7eb0a7a19768d5ff$export$f7ea0b98861f6494(formatMessage) : $7eb0a7a19768d5ff$export$47c53e05a89322a1(formatMessage);
};

});
parcelRegister("kpvjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6783773279e9ee3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e6783773279e9ee3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    columnHeaderIssueType: {
        "id": "native-issue-table.common.utils.get-column-config.column-header-issue-type",
        "defaultMessage": "Type"
    },
    aToZOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.a-to-z-order-old",
        "defaultMessage": "A \u279E Z"
    },
    zToAOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.z-to-a-order-old",
        "defaultMessage": "Z \u279E A"
    },
    oldestToNewestOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.oldest-to-newest-order-old",
        "defaultMessage": "oldest \u279E newest"
    },
    newestToOldestOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.newest-to-oldest-order-old",
        "defaultMessage": "newest \u279E oldest"
    },
    deprecatedEpicLinkMessage: {
        "id": "native-issue-table.common.utils.get-column-config.deprecated-epic-link-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>."
    },
    aToZOrder: {
        "id": "native-issue-table.common.utils.get-column-config.a-to-z-order",
        "defaultMessage": "A \u2192 Z"
    },
    zToAOrder: {
        "id": "native-issue-table.common.utils.get-column-config.z-to-a-order",
        "defaultMessage": "Z \u2192 A"
    },
    oldestToNewestOrder: {
        "id": "native-issue-table.common.utils.get-column-config.oldest-to-newest-order",
        "defaultMessage": "oldest \u2192 newest"
    },
    newestToOldestOrder: {
        "id": "native-issue-table.common.utils.get-column-config.newest-to-oldest-order",
        "defaultMessage": "newest \u2192 oldest"
    }
});

});


parcelRegister("l7qKV", function(module, exports) {

$parcel$export(module.exports, "getColumnsWithStickyOffsets", () => $5ccab77fed5b6341$export$6e976bf0e5378347);

var $j8Km1 = parcelRequire("j8Km1");

var $8jOO7 = parcelRequire("8jOO7");
const $5ccab77fed5b6341$export$6e976bf0e5378347 = (columnConfig, stickyColumnIds)=>{
    const stickyColumnsById = {};
    const orderedStickyColumns = [];
    const nonStickyColumns = [];
    columnConfig.forEach((column)=>{
        const { id: id } = column;
        if (id === (0, $8jOO7.COLUMN_ID_CHECKBOX) || id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON) || id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) orderedStickyColumns.push(column);
        else if (stickyColumnIds?.includes(id)) stickyColumnsById[id] = column;
        else nonStickyColumns.push(column);
    });
    stickyColumnIds?.forEach((columnId)=>{
        if (stickyColumnsById[columnId]) orderedStickyColumns.push(stickyColumnsById[columnId]);
    });
    let cumulativeStickyOffset = 0;
    const processedStickyColumns = orderedStickyColumns.map((column, i)=>{
        const { id: id, customWidth: customWidth, defaultWidth: defaultWidth } = column;
        const stickyOffsets = cumulativeStickyOffset;
        if (id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON)) cumulativeStickyOffset += defaultWidth + (0, $8jOO7.EXPAND_CELL_PADDING);
        else cumulativeStickyOffset += customWidth ?? defaultWidth;
        const isLastStickyColumn = id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) ? column.mergedColumns && column.mergedColumns.length > 0 && i === orderedStickyColumns.length - 1 : i === orderedStickyColumns.length - 1;
        return {
            ...column,
            isColumnSticky: true,
            stickyOffsets: stickyOffsets,
            isLastStickyColumn: isLastStickyColumn
        };
    });
    return [
        ...processedStickyColumns,
        ...nonStickyColumns
    ];
};

});

parcelRegister("P01So", function(module, exports) {

$parcel$export(module.exports, "isNonNullish", () => $a4f78649e91890cd$export$70573498ee17fe1d);
$parcel$export(module.exports, "isKnownColumnType", () => $a4f78649e91890cd$export$e8280bcdc1c3f84);
$parcel$export(module.exports, "exclusiveGroupsOrIssuesFragment", () => $a4f78649e91890cd$export$7ac78cf15a1a4ba3);
$parcel$export(module.exports, "getProjectKeyFromIssueKey", () => $a4f78649e91890cd$export$defe38779a6b81d2);
$parcel$export(module.exports, "escapeBackslashes", () => $a4f78649e91890cd$export$fbd15c27bb7e257c);

var $j8Km1 = parcelRequire("j8Km1");

function $a4f78649e91890cd$export$70573498ee17fe1d(value) {
    return value != null;
}
function $a4f78649e91890cd$export$e8280bcdc1c3f84(value) {
    return value !== undefined && Object.values((0, $j8Km1.KNOWN_COLUMN_TYPES)).includes(value);
}
function $a4f78649e91890cd$export$7ac78cf15a1a4ba3({ groups: groups, issues: issues }) {
    if (issues) return {
        groups: null,
        issues: issues
    };
    if (groups) return {
        groups: groups,
        issues: null
    };
    return null;
}
function $a4f78649e91890cd$export$defe38779a6b81d2(issueKey) {
    return issueKey.split('-')[0];
}
const $a4f78649e91890cd$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');

});

parcelRegister("kbYhH", function(module, exports) {

$parcel$export(module.exports, "useElementSizeSelector", () => $815a2426d7099138$export$6af5bd31f067d7e5);
$parcel$export(module.exports, "ElementSizeProvider", () => $815a2426d7099138$export$73bf76c50625186);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $815a2426d7099138$export$e4c0458e30711294 = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0
};
const $815a2426d7099138$export$638cf470f916deb7 = (0, $6E16M.createContainer)({
    getIsConcurrentSafe: ()=>true
});
const $815a2426d7099138$export$3378d8ea7d02abd0 = {
    height: 0,
    width: 0
};
const $815a2426d7099138$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $815a2426d7099138$var$Store = (0, $GtRbT.createStore)({
    containedBy: $815a2426d7099138$export$638cf470f916deb7,
    initialState: $815a2426d7099138$export$3378d8ea7d02abd0,
    name: 'ElementSize',
    actions: $815a2426d7099138$var$actions,
    handlers: {
        onInit: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            },
        onContainerUpdate: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            }
    }
});
const $815a2426d7099138$export$6af5bd31f067d7e5 = (0, $iJq0l.createStateHook)($815a2426d7099138$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $815a2426d7099138$export$2b86bedf890eab8 = (elementRef)=>{
    const [size, setSize] = (0, $eJOHy.useState)($815a2426d7099138$export$e4c0458e30711294);
    (0, $eJOHy.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                setSize({
                    height: element.clientHeight,
                    width: element.clientWidth,
                    scrollHeight: element.scrollHeight,
                    scrollWidth: element.scrollWidth
                });
            });
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        elementRef
    ]);
    return size;
};
const $815a2426d7099138$export$73bf76c50625186 = ({ elementRef: elementRef, children: children })=>{
    const { width: width, height: height } = $815a2426d7099138$export$2b86bedf890eab8(elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($815a2426d7099138$export$638cf470f916deb7, {
        width: width,
        height: height
    }, children);
};

});

parcelRegister("4hsdx", function(module, exports) {

$parcel$export(module.exports, "FeaturesContainer", () => $8decaf9559798f71$export$449fd4f36db88f87);

var $eJOHy = parcelRequire("eJOHy");

var $4xbv3 = parcelRequire("4xbv3");

var $7jTnu = parcelRequire("7jTnu");

var $34oCh = parcelRequire("34oCh");

var $iFFNS = parcelRequire("iFFNS");
const $8decaf9559798f71$var$ContextualFeatureAnalytics = ({ children: children })=>{
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    const isColumnResizingEnabled = (0, $34oCh.useIsColumnResizingEnabled)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isIssueCreateEnabled = (0, $34oCh.useIsIssueCreateEnabled)();
    const isInfiniteScrollEnabled = (0, $34oCh.useIsInfiniteScrollEnabled)();
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    const isChildIssueCreateEnabled = (0, $34oCh.useIsChildIssueCreateEnabled)();
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    const isIssueOperationMeatballMenuEnabled = (0, $34oCh.useIsIssueOperationMeatballMenuEnabled)();
    const isColumnBordersEnabled = (0, $34oCh.useIsColumnBordersEnabled)();
    const isRowReorderingEnabled = (0, $34oCh.useIsRowReorderingEnabled)();
    const isEntireRowDraggable = (0, $34oCh.useIsEntireRowDraggable)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $34oCh.useIsInBetweenColumnPickerEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    const isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    const isChildIssuesTableVisualUpliftEnabled = (0, $34oCh.useIsChildIssuesTableVisualUpliftEnabled)();
    const isRenderedInOverlay = (0, $34oCh.useIsRenderedInOverlay)();
    const isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
    const isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    let isConditionalFormattingEnabled = false;
    if ((0, $7jTnu.fg)('jira_list_conditional_formatting')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            issueTableFeatures: {
                isDensityFull: isDensityFull,
                isVirtualizationEnabled: isVirtualizationEnabled,
                isColumnResizingEnabled: isColumnResizingEnabled,
                isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
                isIssueCreateEnabled: isIssueCreateEnabled,
                isInfiniteScrollEnabled: isInfiniteScrollEnabled,
                isSiblingIssueCreateEnabled: isSiblingIssueCreateEnabled,
                isChildIssueCreateEnabled: isChildIssueCreateEnabled,
                isIssueRankDescending: isIssueRankDescending,
                isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
                isColumnBordersEnabled: isColumnBordersEnabled,
                isRowReorderingEnabled: isRowReorderingEnabled,
                isEntireRowDraggable: isEntireRowDraggable,
                isGridNavigationEnabled: isGridNavigationEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
                isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                isMergedColumnEnabled: isMergedColumnEnabled,
                isMergedColumnVisible: isMergedColumnVisible,
                isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
                isStickyColumnsEnabled: isStickyColumnsEnabled,
                isStickyColumnsVisible: isStickyColumnsVisible,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isTimelineEnabled: isTimelineEnabled,
                isRenderedInOverlay: isRenderedInOverlay
            }
        }
    }, children);
};
const $8decaf9559798f71$export$449fd4f36db88f87 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iFFNS.FeaturesContainerInternal), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8decaf9559798f71$var$ContextualFeatureAnalytics, null, children));
};

});
parcelRegister("34oCh", function(module, exports) {

$parcel$export(module.exports, "useIsDensityFull", () => $0a9c6aee69856176$export$f031d973e8f9ebd1);
$parcel$export(module.exports, "useIsVirtualizationEnabled", () => $0a9c6aee69856176$export$e8cb30aec148fb72);
$parcel$export(module.exports, "useIsColumnResizingEnabled", () => $0a9c6aee69856176$export$928fba01e945632a);
$parcel$export(module.exports, "useIsFixedTableLayoutEnabled", () => $0a9c6aee69856176$export$bce4f421d3fcab1b);
$parcel$export(module.exports, "useIsInlineEditingEnabled", () => $0a9c6aee69856176$export$3e66c03eddc15634);
$parcel$export(module.exports, "useIsInlineEditingExtendedFieldSupportEnabled", () => $0a9c6aee69856176$export$2763573a98b052ad);
$parcel$export(module.exports, "useIsIssueCreateEnabled", () => $0a9c6aee69856176$export$543273904a8063c6);
$parcel$export(module.exports, "useIsInfiniteScrollEnabled", () => $0a9c6aee69856176$export$de7fbee8ed52ae4);
$parcel$export(module.exports, "useIsSiblingIssueCreateEnabled", () => $0a9c6aee69856176$export$f1842b07a822e21a);
$parcel$export(module.exports, "useIsChildIssueCreateEnabled", () => $0a9c6aee69856176$export$1c15679efffd4e2b);
$parcel$export(module.exports, "useIsIssueRankDescending", () => $0a9c6aee69856176$export$82982f49a24a3a9b);
$parcel$export(module.exports, "useIsIssueHierarchyEnabled", () => $0a9c6aee69856176$export$4f04f80fe2006454);
$parcel$export(module.exports, "useIsIssueOperationMeatballMenuEnabled", () => $0a9c6aee69856176$export$a99d862d213ae04);
$parcel$export(module.exports, "useIsRowReorderingEnabled", () => $0a9c6aee69856176$export$3c2a1b4963d788c8);
$parcel$export(module.exports, "useIsEntireRowDraggable", () => $0a9c6aee69856176$export$40143afd2a4a7546);
$parcel$export(module.exports, "useIsReparentingEnabled", () => $0a9c6aee69856176$export$64a4c7b004e35cb6);
$parcel$export(module.exports, "useIsDragAndDropEnabled", () => $0a9c6aee69856176$export$b4fbf34545c95b8e);
$parcel$export(module.exports, "useProjectContext", () => $0a9c6aee69856176$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useSortField", () => $0a9c6aee69856176$export$f8f71fe8cdc658b6);
$parcel$export(module.exports, "useSortDirection", () => $0a9c6aee69856176$export$c88af24ce42b9b94);
$parcel$export(module.exports, "useJql", () => $0a9c6aee69856176$export$f813789488fdc0c7);
$parcel$export(module.exports, "useIsColumnBordersEnabled", () => $0a9c6aee69856176$export$8136b1ebbacf80ef);
$parcel$export(module.exports, "useIsInlineFieldConfigEnabled", () => $0a9c6aee69856176$export$edb9f869c9fd4d6e);
$parcel$export(module.exports, "useIsInBetweenColumnPickerEnabled", () => $0a9c6aee69856176$export$9e70cd1d138c2276);
$parcel$export(module.exports, "useIsSingleLineRowHeightEnabled", () => $0a9c6aee69856176$export$626f961c251cf22e);
$parcel$export(module.exports, "useIsHideDoneItemsEnabled", () => $0a9c6aee69856176$export$41bad204cf3bf31b);
$parcel$export(module.exports, "useIsMergedColumnEnabled", () => $0a9c6aee69856176$export$f6d8bbcfea5cc718);
$parcel$export(module.exports, "useIsMergedColumnVisible", () => $0a9c6aee69856176$export$28416a110952f775);
$parcel$export(module.exports, "useIsChildIssuesTableVisualUpliftEnabled", () => $0a9c6aee69856176$export$5e14421c97bdcf37);
$parcel$export(module.exports, "useIsIssueRankingEnabled", () => $0a9c6aee69856176$export$7fa8121781f45255);
$parcel$export(module.exports, "useIsStickyColumnsEnabled", () => $0a9c6aee69856176$export$6050cee0da5e731b);
$parcel$export(module.exports, "useIsStickyColumnsVisible", () => $0a9c6aee69856176$export$9cc19f3a611a61c0);
$parcel$export(module.exports, "useIsConditionalFormattingEnabled", () => $0a9c6aee69856176$export$c799a83481d5936b);
$parcel$export(module.exports, "useIsTimelineEnabled", () => $0a9c6aee69856176$export$1a04536b4e3a55ba);
$parcel$export(module.exports, "useIsGridNavigationEnabled", () => $0a9c6aee69856176$export$2903dd9e444e3b01);
$parcel$export(module.exports, "useIsRenderedInOverlay", () => $0a9c6aee69856176$export$da525d31a51aa908);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $8jOO7 = parcelRequire("8jOO7");

var $iFFNS = parcelRequire("iFFNS");
const $0a9c6aee69856176$export$f031d973e8f9ebd1 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.density === (0, $8jOO7.DENSITY_FULL)
});
const $0a9c6aee69856176$export$e8cb30aec148fb72 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.density === (0, $8jOO7.DENSITY_COMPACT) && state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$928fba01e945632a = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isColumnResizingEnabled
});
const $0a9c6aee69856176$export$bce4f421d3fcab1b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isFixedTableLayoutEnabled
});
const $0a9c6aee69856176$export$3e66c03eddc15634 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInlineEditingEnabled
});
const $0a9c6aee69856176$export$2763573a98b052ad = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInlineEditingExtendedFieldSupportEnabled
});
const $0a9c6aee69856176$export$543273904a8063c6 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$de7fbee8ed52ae4 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$f1842b07a822e21a = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isIssueRankingEnabled
});
const $0a9c6aee69856176$export$1c15679efffd4e2b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isIssueHierarchyEnabled
});
const $0a9c6aee69856176$export$82982f49a24a3a9b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueRankDescending
});
const $0a9c6aee69856176$export$4f04f80fe2006454 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueHierarchyEnabled && state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$a99d862d213ae04 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueOperationMeatballMenuEnabled
});
const $0a9c6aee69856176$export$3c2a1b4963d788c8 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isRowReorderingEnabled
});
const $0a9c6aee69856176$export$40143afd2a4a7546 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isEntireRowDraggable
});
const $0a9c6aee69856176$export$64a4c7b004e35cb6 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isReparentingEnabled
});
const $0a9c6aee69856176$export$b4fbf34545c95b8e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isRowReorderingEnabled || state.isReparentingEnabled || state.isIssueRankingEnabled
});
const $0a9c6aee69856176$export$8f31c2503e1efa93 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.projectContext
});
const $0a9c6aee69856176$export$f8f71fe8cdc658b6 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.sortField
});
const $0a9c6aee69856176$export$c88af24ce42b9b94 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.sortDirection
});
const $0a9c6aee69856176$export$f813789488fdc0c7 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.jql
});
const $0a9c6aee69856176$export$8136b1ebbacf80ef = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isColumnBordersEnabled
});
const $0a9c6aee69856176$export$edb9f869c9fd4d6e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInlineFieldConfigEnabled
});
const $0a9c6aee69856176$export$9e70cd1d138c2276 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInBetweenColumnPickerEnabled
});
const $0a9c6aee69856176$export$626f961c251cf22e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isSingleLineRowHeightEnabled
});
const $0a9c6aee69856176$export$41bad204cf3bf31b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isHideDoneItemsEnabled
});
const $0a9c6aee69856176$export$f6d8bbcfea5cc718 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isMergedColumnEnabled
});
const $0a9c6aee69856176$export$28416a110952f775 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isMergedColumnVisible
});
const $0a9c6aee69856176$export$5e14421c97bdcf37 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isChildIssuesTableVisualUpliftEnabled
});
const $0a9c6aee69856176$export$7fa8121781f45255 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueRankingEnabled
});
const $0a9c6aee69856176$export$6050cee0da5e731b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isStickyColumnsEnabled
});
const $0a9c6aee69856176$export$9cc19f3a611a61c0 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isStickyColumnsVisible
});
const $0a9c6aee69856176$export$c799a83481d5936b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isConditionalFormattingEnabled
});
const $0a9c6aee69856176$export$1a04536b4e3a55ba = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isTimelineEnabled
});
const $0a9c6aee69856176$export$2903dd9e444e3b01 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isGridNavigationEnabled
});
const $0a9c6aee69856176$export$da525d31a51aa908 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isRenderedInOverlay
});

});
parcelRegister("iFFNS", function(module, exports) {

$parcel$export(module.exports, "FeaturesContainerInternal", () => $fec205bcdab5c4a8$export$8a9f5b92d3cec1ec);
$parcel$export(module.exports, "FeaturesStore", () => $fec205bcdab5c4a8$export$b78abb146634afd0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8jOO7 = parcelRequire("8jOO7");
const $fec205bcdab5c4a8$var$initialState = {
    density: (0, $8jOO7.DENSITY_COMPACT),
    isColumnResizingEnabled: true,
    isFixedTableLayoutEnabled: true,
    isInlineEditingEnabled: true,
    isInlineEditingExtendedFieldSupportEnabled: false,
    isIssueCreateEnabled: false,
    projectContext: null,
    isInfiniteScrollEnabled: false,
    isIssueRankingEnabled: false,
    isIssueRankDescending: false,
    isIssueHierarchyEnabled: false,
    isIssueOperationMeatballMenuEnabled: true,
    isRowReorderingEnabled: false,
    isEntireRowDraggable: false,
    isReparentingEnabled: false,
    isColumnBordersEnabled: true,
    isGridNavigationEnabled: false,
    isInlineFieldConfigEnabled: false,
    isInBetweenColumnPickerEnabled: false,
    isSingleLineRowHeightEnabled: false,
    isHideDoneItemsEnabled: false,
    isMergedColumnEnabled: false,
    isMergedColumnVisible: false,
    isChildIssuesTableVisualUpliftEnabled: false,
    isStickyColumnsEnabled: false,
    isStickyColumnsVisible: false,
    isConditionalFormattingEnabled: false,
    isTimelineEnabled: false,
    isRenderedInOverlay: false
};
const $fec205bcdab5c4a8$export$8a9f5b92d3cec1ec = (0, $6E16M.createContainer)();
const $fec205bcdab5c4a8$var$updateStore = ({ setState: setState }, { density: density, isColumnResizingEnabled: isColumnResizingEnabled, isInlineEditingEnabled: isInlineEditingEnabled, isIssueCreateEnabled: isIssueCreateEnabled, isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled, projectContext: projectContext, isInfiniteScrollEnabled: isInfiniteScrollEnabled, sortDirection: sortDirection, sortField: sortField, isIssueHierarchyEnabled: isIssueHierarchyEnabled, isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled, isRowReorderingEnabled: isRowReorderingEnabled, isEntireRowDraggable: isEntireRowDraggable, isReparentingEnabled: isReparentingEnabled, jql: jql, isColumnBordersEnabled: isColumnBordersEnabled, isGridNavigationEnabled: isGridNavigationEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isMergedColumnEnabled: isMergedColumnEnabled, isMergedColumnVisible: isMergedColumnVisible, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, isIssueRankingEnabled: isIssueRankingEnabled, isStickyColumnsEnabled: isStickyColumnsEnabled, isStickyColumnsVisible: isStickyColumnsVisible, isConditionalFormattingEnabled: isConditionalFormattingEnabled = false, isTimelineEnabled: isTimelineEnabled, isRenderedInOverlay: isRenderedInOverlay })=>{
    setState({
        density: density,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isFixedTableLayoutEnabled: isColumnResizingEnabled,
        isInlineEditingEnabled: isInlineEditingEnabled,
        isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
        isIssueCreateEnabled: isIssueCreateEnabled && Boolean(projectContext),
        projectContext: projectContext ?? null,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled,
        isIssueHierarchyEnabled: isIssueHierarchyEnabled && Boolean(projectContext),
        isIssueRankingEnabled: isIssueRankingEnabled,
        isIssueRankDescending: sortDirection === (0, $8jOO7.SORT_DESC),
        isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
        isRowReorderingEnabled: isRowReorderingEnabled,
        isEntireRowDraggable: isEntireRowDraggable,
        isReparentingEnabled: isReparentingEnabled,
        sortDirection: sortDirection,
        sortField: sortField,
        jql: jql,
        isColumnBordersEnabled: isColumnBordersEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        isHideDoneItemsEnabled: isHideDoneItemsEnabled,
        isMergedColumnEnabled: isMergedColumnEnabled,
        isMergedColumnVisible: isMergedColumnVisible,
        isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
        isStickyColumnsEnabled: isStickyColumnsEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible,
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isTimelineEnabled: isTimelineEnabled,
        isRenderedInOverlay: isRenderedInOverlay
    });
};
const $fec205bcdab5c4a8$export$b78abb146634afd0 = (0, $GtRbT.createStore)({
    initialState: $fec205bcdab5c4a8$var$initialState,
    actions: {},
    containedBy: $fec205bcdab5c4a8$export$8a9f5b92d3cec1ec,
    handlers: {
        onInit: ()=>$fec205bcdab5c4a8$var$updateStore,
        onContainerUpdate: ()=>$fec205bcdab5c4a8$var$updateStore
    }
});

});



parcelRegister("6LwYU", function(module, exports) {

$parcel$export(module.exports, "SiblingCreateActiveIndexContainer", () => $cce11cf956429fbb$export$3bb3687dbfff2504);
$parcel$export(module.exports, "useIsSiblingIssueCreateActive", () => $cce11cf956429fbb$export$1e0d27763664702c);
$parcel$export(module.exports, "useSiblingCreateActiveIndexActions", () => $cce11cf956429fbb$export$c2ceb7cc1900ce28);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $cce11cf956429fbb$var$CLEAR_DELAY = 300;
const $cce11cf956429fbb$var$initialState = {
    issue: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    },
    field: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    }
};
const $cce11cf956429fbb$var$actions = {
    setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: index
                }
            });
            dispatch($cce11cf956429fbb$var$actions.lockIndex(key));
        },
    clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: undefined
                }
            });
            dispatch($cce11cf956429fbb$var$actions.unlockIndex(key));
        },
    clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const timeoutId = setTimeout(()=>{
                if (!getState()[key].isIndexLocked) {
                    dispatch($cce11cf956429fbb$var$actions.clearIndex(key));
                    setState({
                        [key]: {
                            ...getState()[key],
                            timeoutId: undefined
                        }
                    });
                }
            }, $cce11cf956429fbb$var$CLEAR_DELAY);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false,
                    timeoutId: timeoutId
                }
            });
        },
    lockIndex: (key)=>({ setState: setState, getState: getState })=>{
            const { timeoutId: timeoutId } = getState()[key];
            if (timeoutId) clearTimeout(timeoutId);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: true,
                    timeoutId: undefined
                }
            });
        },
    unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false
                }
            });
        }
};
const $cce11cf956429fbb$export$3bb3687dbfff2504 = (0, $6E16M.createContainer)();
const $cce11cf956429fbb$var$Store = (0, $GtRbT.createStore)({
    initialState: $cce11cf956429fbb$var$initialState,
    actions: $cce11cf956429fbb$var$actions,
    containedBy: $cce11cf956429fbb$export$3bb3687dbfff2504
});
const $cce11cf956429fbb$var$isIndexEqual = (a, b)=>a !== undefined && a[0] === b[0] && a[1] === b[1];
const $cce11cf956429fbb$export$1e0d27763664702c = (0, $iJq0l.createHook)($cce11cf956429fbb$var$Store, {
    selector: (state, index)=>$cce11cf956429fbb$var$isIndexEqual(state.issue.index, index)
});
const $cce11cf956429fbb$export$c2ceb7cc1900ce28 = (0, $iJq0l.createActionsHook)($cce11cf956429fbb$var$Store);
const $cce11cf956429fbb$export$7de76a106681e3b2 = (0, $iJq0l.createHook)($cce11cf956429fbb$var$Store);

});

parcelRegister("6KVf0", function(module, exports) {

$parcel$export(module.exports, "InlineCreateActiveIndexContainer", () => $27ce9003fc1e8500$export$293e9de3e94ac3e3);
$parcel$export(module.exports, "useInlineCreateActiveIndexActions", () => $27ce9003fc1e8500$export$109b1f65f6277f1f);
$parcel$export(module.exports, "useInlineFieldCreateActiveIndex", () => $27ce9003fc1e8500$export$b47f84449b2c30b5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $27ce9003fc1e8500$var$CLEAR_DELAY = 300;
const $27ce9003fc1e8500$export$3378d8ea7d02abd0 = {
    issue: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    },
    field: {
        index: undefined,
        isHovered: false,
        isIndexLocked: false,
        timeoutId: undefined
    }
};
const $27ce9003fc1e8500$var$actions = {
    setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: index
                }
            });
            dispatch($27ce9003fc1e8500$var$actions.lockIndex(key));
        },
    clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: undefined
                }
            });
            dispatch($27ce9003fc1e8500$var$actions.unlockIndex(key));
        },
    clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const timeoutId = setTimeout(()=>{
                if (!getState()[key].isIndexLocked) {
                    dispatch($27ce9003fc1e8500$var$actions.clearIndex(key));
                    setState({
                        [key]: {
                            ...getState()[key],
                            timeoutId: undefined
                        }
                    });
                }
            }, $27ce9003fc1e8500$var$CLEAR_DELAY);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false,
                    timeoutId: timeoutId
                }
            });
        },
    setIsHovered: (key)=>({ getState: getState, setState: setState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isHovered: true
                }
            });
        },
    clearIsHovered: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isHovered: false
                }
            });
        },
    lockIndex: (key)=>({ setState: setState, getState: getState })=>{
            const { timeoutId: timeoutId } = getState()[key];
            if (timeoutId) clearTimeout(timeoutId);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: true,
                    timeoutId: undefined
                }
            });
        },
    unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false
                }
            });
        }
};
const $27ce9003fc1e8500$export$293e9de3e94ac3e3 = (0, $6E16M.createContainer)();
const $27ce9003fc1e8500$var$Store = (0, $GtRbT.createStore)({
    initialState: $27ce9003fc1e8500$export$3378d8ea7d02abd0,
    actions: $27ce9003fc1e8500$var$actions,
    containedBy: $27ce9003fc1e8500$export$293e9de3e94ac3e3
});
const $27ce9003fc1e8500$export$121b3ed4dfcef179 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store);
const $27ce9003fc1e8500$export$109b1f65f6277f1f = (0, $iJq0l.createActionsHook)($27ce9003fc1e8500$var$Store);
const $27ce9003fc1e8500$var$getInlineIssueCreate = (state)=>state.issue;
const $27ce9003fc1e8500$var$getInlineFieldCreate = (state)=>state.field;
const $27ce9003fc1e8500$var$isIssueIndexEqual = (a, b)=>a !== undefined && a[0] === b[0] && a[1] === b[1];
const $27ce9003fc1e8500$export$4e43a4c525201572 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store, {
    selector: (state, index)=>$27ce9003fc1e8500$var$isIssueIndexEqual(state.issue.index, index)
});
const $27ce9003fc1e8500$export$72e323294e39f1e1 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store, {
    selector: $27ce9003fc1e8500$var$getInlineIssueCreate
});
const $27ce9003fc1e8500$export$b47f84449b2c30b5 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store, {
    selector: $27ce9003fc1e8500$var$getInlineFieldCreate
});

});

parcelRegister("3F6xT", function(module, exports) {

$parcel$export(module.exports, "TableIntersectionObserverContainer", () => $38738d16686b0ed7$export$d70db3a85b45c17e);
$parcel$export(module.exports, "useIntersectionObserver", () => $38738d16686b0ed7$export$a7395f9832c00176);
$parcel$export(module.exports, "useObserveItem", () => $38738d16686b0ed7$export$323a1519def7418e);
$parcel$export(module.exports, "useCalculateIssueInsertionPoint", () => $38738d16686b0ed7$export$736db8d31780fc97);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8jOO7 = parcelRequire("8jOO7");

var $dEwO3 = parcelRequire("dEwO3");
const $38738d16686b0ed7$export$d4c72bab9d6cc13a = {
    intersectionObserver: null,
    itemsObserved: new Map(),
    insertionPoint: null,
    isObserving: false
};
const $38738d16686b0ed7$export$d70db3a85b45c17e = (0, $6E16M.createContainer)();
const $38738d16686b0ed7$var$actions = {
    /**
	 * Starts the intersection observer to observer any stored item.
	 */ observeItems: ()=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            if (isObserving) return;
            if (intersectionObserver != null) itemsObserved.forEach((_, element)=>{
                intersectionObserver.observe(element);
            });
            setState({
                isObserving: true
            });
        },
    /**
	 * Stops the intersection observer.
	 */ unobserveItems: ()=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, isObserving: isObserving } = getState();
            if (!isObserving) return;
            if (intersectionObserver != null) intersectionObserver.disconnect();
            setState({
                isObserving: false
            });
        },
    /**
	 * Disconnect any previous intersection observer stored, if the stored is set to automatically observe,
	 * we start observing any stored item, finally we updated the stored with the new observer.
	 * @param {Object} config
	 * @param {IntersectionObserver} config.intersectionObserver - New IntersectionObserver to be added it
	 */ setIntersectionObserver: ({ intersectionObserver: newIntersectionObserver })=>({ setState: setState, getState: getState })=>{
            const { intersectionObserver: intersectionObserver, isObserving: isObserving, itemsObserved: itemsObserved } = getState();
            if (intersectionObserver != null) intersectionObserver.disconnect();
            if (isObserving) itemsObserved.forEach((_, element)=>{
                newIntersectionObserver.observe(element);
            });
            setState({
                intersectionObserver: newIntersectionObserver
            });
        },
    /**
	 * Add a HTML element ot the list of observed elements. It start's observing automatically
	 * if the stored is observing.
	 * @param {Object} config
	 * @param {HTMLElement} element - HTML Element to be observed
	 * @param {string} issueId - Id of the issue that is associated to the HTML Element that is been observed
	 */ observeItem: ({ element: element, issueId: issueId })=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            setState({
                itemsObserved: new Map([
                    ...itemsObserved.entries(),
                    [
                        element,
                        issueId
                    ]
                ])
            });
            if (intersectionObserver == null || !isObserving) return;
            intersectionObserver.observe(element);
        },
    /**
	 * Removes an element from been observed, I stop's observing the element automatically
	 * if the stored is observing
	 * @param {Object} config
	 * @param {HTMLElement} element - Element to be unobserved
	 */ unobserveItem: ({ element: element })=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            if (itemsObserved.has(element)) {
                const newItemsObserved = new Map(itemsObserved.entries());
                newItemsObserved.delete(element);
                setState({
                    itemsObserved: newItemsObserved
                });
            }
            if (intersectionObserver == null || !isObserving) return;
            intersectionObserver.unobserve(element);
        },
    /**
	 * It stored the insertion point in the stored
	 * @param {InsertionPoint} insertionPoint - Insertion point to be stored
	 */ setInsertionPoint: (insertionPoint)=>({ setState: setState })=>{
            setState({
                insertionPoint: insertionPoint
            });
        }
};
const $38738d16686b0ed7$export$bc23ad63575022d9 = (0, $GtRbT.createStore)({
    initialState: $38738d16686b0ed7$export$d4c72bab9d6cc13a,
    actions: $38738d16686b0ed7$var$actions,
    containedBy: $38738d16686b0ed7$export$d70db3a85b45c17e
});
const $38738d16686b0ed7$export$bfaae927f3082143 = (0, $iJq0l.createHook)($38738d16686b0ed7$export$bc23ad63575022d9);
const $38738d16686b0ed7$export$bc925ad7e18c9ef8 = (0, $iJq0l.createActionsHook)($38738d16686b0ed7$export$bc23ad63575022d9);
const $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER = (0, $8jOO7.ROW_HEIGHT) + 1;
const $38738d16686b0ed7$export$a7395f9832c00176 = ()=>{
    const { setIntersectionObserver: setObserver, setInsertionPoint: setInsertionPoint } = $38738d16686b0ed7$export$bc925ad7e18c9ef8();
    return (0, $eJOHy.useCallback)((element)=>{
        if (element != null) {
            const observer = new IntersectionObserver((entries)=>{
                const isOverflow = element.scrollHeight > element.clientHeight;
                const mostRecentEntryCloseToFooter = entries.map((entry)=>{
                    if (entry.rootBounds == null) return;
                    const { top: top } = entry.boundingClientRect;
                    const { bottom: interceptLine } = entry.rootBounds;
                    /**
								 * When scrolling upward (mac), the top line of the item rect is
								 * passing from below to above the intercept line. We identify this
								 * because the entry rectangle will look like:
								 *
								 *  --------  -> Top of root
								 * |        |
								 * |        |
								 * =========  -> Top of item
								 * ---------  -> Bottom of root (aka intercept line)
								 * =========  -> Bottom of item (aka top + height )
								 */ const isBelow = top <= interceptLine && top + $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER >= interceptLine;
                    /**
								 * When scrolling downward (mac), the top line of the item rect is
								 * passing from above to below the intercept line. We identify this
								 * because the entry rectangle will look like:
								 *
								 *  --------  -> Top of root
								 * |        |
								 * |        |
								 * ---------  -> Bottom of root (aka intercept line)
								 * =========  -> Top of item
								 * |        |
								 * =========  -> Bottom of item (aka top + height )
								 * If top minus height is below that the intercept line, means that is
								 * rectangle fits
								 */ const isAbove = top >= interceptLine && top - $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER <= interceptLine;
                    // We prioritize below vs above when is possible.
                    if (isBelow) return {
                        position: 'below',
                        entry: entry
                    };
                    if (isAbove) return {
                        position: 'above',
                        entry: entry
                    };
                    // Otherwise; Is pass the intercept line ignored
                    return undefined;
                }).filter((a)=>a !== undefined)// put most recent entries on top, is possible that multiple
                // entries pass the intercept line
                .sort((a, b)=>{
                    if (b.entry.time !== a.entry.time) return b.entry.time - a.entry.time;
                    // Returns the closest to the bottom when the time is the same
                    if (b.entry.boundingClientRect.y > a.entry.boundingClientRect.y) return 1;
                    if (b.entry.boundingClientRect.y < a.entry.boundingClientRect.y) return -1;
                    return 0;
                })// get the most recent one
                .shift();
                if (mostRecentEntryCloseToFooter) setInsertionPoint({
                    element: mostRecentEntryCloseToFooter.entry.target,
                    // Always insert below when is not overflowing
                    position: isOverflow ? mostRecentEntryCloseToFooter.position : 'below'
                });
            }, {
                root: element,
                // We are placing the interceptor just below the header
                // and a row above the footer, as we want to insert the icon
                // at least a row above the footer to be visible
                rootMargin: `-40px 0px -${2 * $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER}px 0px`
            });
            setObserver({
                intersectionObserver: observer
            });
        }
    }, [
        setInsertionPoint,
        setObserver
    ]);
};
const $38738d16686b0ed7$export$323a1519def7418e = (issueId)=>{
    const { observeItem: observeItem, unobserveItem: unobserveItem } = $38738d16686b0ed7$export$bc925ad7e18c9ef8();
    const itemRef = (0, $eJOHy.useRef)();
    const wasObserved = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>()=>{
            itemRef.current != null && unobserveItem({
                element: itemRef.current
            });
        }, [
        unobserveItem
    ]);
    return (0, $eJOHy.useCallback)((element)=>{
        if (element != null) {
            itemRef.current = element;
            if (issueId != null) {
                observeItem({
                    element: element,
                    issueId: issueId
                });
                wasObserved.current = true;
            }
        }
    }, [
        issueId,
        observeItem
    ]);
};
const $38738d16686b0ed7$export$935a9e0cb21f3923 = (0, $iJq0l.createStateHook)($38738d16686b0ed7$export$bc23ad63575022d9, {
    selector: (0, $dEwO3.getInsertionPointSelector)
});
const $38738d16686b0ed7$export$736db8d31780fc97 = ()=>{
    const { observeItems: observeItems, unobserveItems: unobserveItems } = $38738d16686b0ed7$export$bc925ad7e18c9ef8();
    (0, $eJOHy.useEffect)(()=>{
        observeItems();
        return ()=>{
            unobserveItems();
        };
    }, [
        observeItems,
        unobserveItems
    ]);
    return $38738d16686b0ed7$export$935a9e0cb21f3923();
};

});
parcelRegister("dEwO3", function(module, exports) {

$parcel$export(module.exports, "getInsertionPointSelector", () => $c3d64bf506bc2d61$export$74f2307c2f2b1be0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4MchI = parcelRequire("4MchI");
const $c3d64bf506bc2d61$var$getIssueIdSelector = (0, $4MchI.createSelector)((state)=>state.itemsObserved, (_, element)=>element, (items, element)=>{
    const issueId = items.get(element);
    if (issueId === undefined) return null;
    return issueId;
});
const $c3d64bf506bc2d61$export$74f2307c2f2b1be0 = (state)=>{
    const { insertionPoint: insertionPoint } = state;
    if (insertionPoint == null) return null;
    const { element: element, position: position } = insertionPoint;
    const issueId = $c3d64bf506bc2d61$var$getIssueIdSelector(state, element);
    if (issueId == null) return null;
    return {
        issueId: issueId,
        position: position
    };
};

});


parcelRegister("eqbO4", function(module, exports) {

$parcel$export(module.exports, "LazyEditabilityLoaderContainer", () => $8a9b205a24007018$export$9e924386fdd64f6e);
$parcel$export(module.exports, "useLazyLoadEditability", () => $8a9b205a24007018$export$9b127efb5c6c57e8);

var $eJOHy = parcelRequire("eJOHy");

var $79KwK = parcelRequire("79KwK");

var $j4oe4 = parcelRequire("j4oe4");

var $3pSHx = parcelRequire("3pSHx");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $lMr7M = parcelRequire("lMr7M");

var $2NUpV = parcelRequire("2NUpV");

const $8a9b205a24007018$var$initialState = {
    loader: null,
    scheduler: null
};
const $8a9b205a24007018$var$Container = (0, $6E16M.createContainer)();
const $8a9b205a24007018$var$Store = (0, $GtRbT.createStore)({
    containedBy: $8a9b205a24007018$var$Container,
    initialState: $8a9b205a24007018$var$initialState,
    actions: $2NUpV.actions,
    handlers: {
        onInit: ()=>({ setState: setState }, { environment: environment })=>{
                const scheduler = (0, $lMr7M.createDataLoaderScheduler)(100);
                const loader = new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))((0, $2NUpV.batchIsEditableInIssueViewFactory)(environment), {
                    maxBatchSize: (0, $df5a5f20911361eb$export$fba142522eb62862),
                    batchScheduleFn: scheduler.schedule
                });
                setState({
                    loader: loader,
                    scheduler: scheduler
                });
            }
    }
});
const $8a9b205a24007018$export$9e924386fdd64f6e = ({ children: children, scope: scope })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8a9b205a24007018$var$Container, {
        scope: scope,
        environment: environment
    }, children);
};
const $8a9b205a24007018$export$ceb1f4a193b695d1 = (0, $iJq0l.createActionsHook)($8a9b205a24007018$var$Store);
const $8a9b205a24007018$export$9b127efb5c6c57e8 = (id, isEditable)=>{
    const { load: load } = $8a9b205a24007018$export$ceb1f4a193b695d1();
    (0, $eJOHy.useEffect)(()=>{
        const executeLoad = async ()=>{
            // If there is no editability information for the issue field then queue a request to lazily fetch this data
            // We need to explicitly check the ID is an ARI to ignore fields for optimistically created issues, which
            // are initialised as a UUID.
            if (id != null && isEditable === undefined && (0, $3pSHx.JiraIssuefieldvalueAri).check(id)) load(id);
        };
        executeLoad();
    }, [
        isEditable,
        load,
        id
    ]);
};

});
parcelRegister("3pSHx", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $27ce236fe1a3184f$export$828c4931ae562af7);

var $caazz = parcelRequire("caazz");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issuefieldvalue/manifest.ts
var $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $caazz.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $caazz.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $27ce236fe1a3184f$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("caazz", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $8dae9ec06e7b65f0$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $8dae9ec06e7b65f0$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $8dae9ec06e7b65f0$export$39e9358142fbbc64 = "jira", $8dae9ec06e7b65f0$export$f9e57427271adc95 = "issuefieldvalue";

});


parcelRegister("lMr7M", function(module, exports) {

$parcel$export(module.exports, "createDataLoaderScheduler", () => $4339ad4fc34caffc$export$f3542fc7467ff455);

var $3s8bj = parcelRequire("3s8bj");
function $4339ad4fc34caffc$export$f3542fc7467ff455(delay) {
    let cb = [];
    return {
        schedule (callback) {
            cb.push(callback);
        },
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            cb.forEach((callback)=>callback());
            cb = [];
        }, delay)
    };
}

});

parcelRegister("2NUpV", function(module, exports) {

$parcel$export(module.exports, "batchIsEditableInIssueViewFactory", () => $935bc2d7061582b7$export$781008fa22e0792);
$parcel$export(module.exports, "actions", () => $935bc2d7061582b7$export$e324594224ef24da);

var $jKaIi = parcelRequire("jKaIi");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $8jOO7 = parcelRequire("8jOO7");

const $935bc2d7061582b7$export$781008fa22e0792 = (environment)=>async (fieldIds)=>{
        const isEditableMap = new Map();
        const promise = (0, $j4oe4.fetchQuery)(environment, (0, $jKaIi.default), {
            ids: fieldIds,
            first: (0, $df5a5f20911361eb$export$fba142522eb62862)
        }).toPromise();
        try {
            const data = await promise;
            (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
                data?.jira?.issueFieldsByIds?.edges?.map((edge)=>edge?.node).filter(Boolean).forEach(({ __id: __id, id: id, isEditableInIssueView: isEditableInIssueView })=>{
                    isEditableMap.set(id, isEditableInIssueView ?? null);
                    // Set whether issue fields are editable as a new client-only field on the matching node in the Relay
                    // store
                    store.get(__id)?.setValue(isEditableInIssueView ?? null, 'lazyIsEditableInIssueView');
                });
            });
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'lazyEditabilityLoader',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        // Ensure input argument order is preserved when returning batch results as required by the dataloader
        return fieldIds.map((id)=>isEditableMap.get(id) ?? null);
    };
const $935bc2d7061582b7$export$e324594224ef24da = {
    load: (fieldId)=>({ getState: getState })=>{
            const { loader: loader, scheduler: scheduler } = getState();
            const loading = loader ? loader.load(fieldId) : Promise.resolve(null);
            scheduler?.dispatch();
            return loading;
        }
};

});
parcelRegister("jKaIi", function(module, exports) {

$parcel$export(module.exports, "default", () => $098181c0d4d0436f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8228d06ebe8452bee095ff8f5594dc9>>
 * @relayHash e0b6440748f83639ae3e7c7c2d3fe93e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24fe88e198b2feee72f5134490dbe0d574f365abdcf6a8e568c8988963268c89
const $098181c0d4d0436f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ids"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "ids"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isEditableInIssueView"
    }, v5 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "actions_LazyLoadEditabilityQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "issueFieldsByIds",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "actions_LazyLoadEditabilityQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "issueFieldsByIds",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "24fe88e198b2feee72f5134490dbe0d574f365abdcf6a8e568c8988963268c89",
            "metadata": {},
            "name": "actions_LazyLoadEditabilityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$098181c0d4d0436f$var$node.hash = "271711cb2a483cec7c4f662a4b4db511";
var $098181c0d4d0436f$export$2e2bcd8739ae039 = $098181c0d4d0436f$var$node;

});

const $df5a5f20911361eb$export$fba142522eb62862 = 499;



parcelRegister("jZFgr", function(module, exports) {

$parcel$export(module.exports, "LazyMediaViewContextLoaderContainer", () => $4b1ddbdb2bf7672f$export$c268c26f941d1a5);
$parcel$export(module.exports, "useLazyMediaViewContext", () => $4b1ddbdb2bf7672f$export$5475aeba7ee80aa1);

var $eJOHy = parcelRequire("eJOHy");

var $79KwK = parcelRequire("79KwK");

var $j4oe4 = parcelRequire("j4oe4");

var $d7xa7 = parcelRequire("d7xa7");

var $kEUB1 = parcelRequire("kEUB1");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $lMr7M = parcelRequire("lMr7M");

var $aHvCt = parcelRequire("aHvCt");

var $93QIg = parcelRequire("93QIg");
const $4b1ddbdb2bf7672f$var$initialState = {
    loader: null,
    scheduler: null
};
const $4b1ddbdb2bf7672f$var$Container = (0, $6E16M.createContainer)();
const $4b1ddbdb2bf7672f$var$Store = (0, $GtRbT.createStore)({
    containedBy: $4b1ddbdb2bf7672f$var$Container,
    initialState: $4b1ddbdb2bf7672f$var$initialState,
    actions: $aHvCt.actions,
    handlers: {
        onInit: ()=>({ setState: setState }, { environment: environment, cloudId: cloudId })=>{
                const scheduler = (0, $lMr7M.createDataLoaderScheduler)(100);
                const loader = new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))((0, $aHvCt.batchMediaViewResponseFactory)(environment, cloudId), {
                    maxBatchSize: (0, $93QIg.MAX_BATCH_SIZE),
                    batchScheduleFn: scheduler.schedule
                });
                setState({
                    loader: loader,
                    scheduler: scheduler
                });
            }
    }
});
const $4b1ddbdb2bf7672f$export$c268c26f941d1a5 = ({ children: children, scope: scope })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b1ddbdb2bf7672f$var$Container, {
        scope: scope,
        environment: environment,
        cloudId: cloudId
    }, children);
};
const $4b1ddbdb2bf7672f$export$2ccec1e3fc6f5f = (0, $iJq0l.createActionsHook)($4b1ddbdb2bf7672f$var$Store);
const $4b1ddbdb2bf7672f$export$5475aeba7ee80aa1 = (issueKey)=>{
    const { load: load } = $4b1ddbdb2bf7672f$export$2ccec1e3fc6f5f();
    const [viewContext, setViewContext] = (0, $eJOHy.useState)();
    (0, $eJOHy.useEffect)(()=>{
        const executeLoad = async ()=>{
            // We only want to fetch when viewContext's value hasn't been initialised yet
            if (viewContext === undefined) {
                const viewResponse = await load(issueKey);
                if (viewResponse) setViewContext((0, $d7xa7.viewContextTransformer)(viewResponse));
                else setViewContext(null);
            }
        };
        executeLoad();
    }, [
        viewContext,
        load,
        issueKey
    ]);
    return viewContext ?? null;
};

});
parcelRegister("d7xa7", function(module, exports) {

$parcel$export(module.exports, "getTokenDeltaProps", () => $16b06cb22c076d80$export$4d271852dd07ca26);
$parcel$export(module.exports, "isTokenValid", () => $16b06cb22c076d80$export$d1a8c8b605234fe8);
$parcel$export(module.exports, "viewContextTransformer", () => $16b06cb22c076d80$export$5fb65caa7eb9e932);
// This has TS defs, so when we move to TS let's enable them again
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'jwt-decode'. '/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/jwt-decode/lib/index.js' implicitly has an 'any' type.

var $lNv8v = parcelRequire("lNv8v");
const $16b06cb22c076d80$var$TOKEN_NETWORK_BUFFER = 10000;
const $16b06cb22c076d80$export$e9df841c4c486a60 = (startTimestamp)=>startTimestamp ? startTimestamp - Date.now() + 0 : undefined;
const $16b06cb22c076d80$export$4d271852dd07ca26 = (token)=>{
    let decodedToken;
    try {
        decodedToken = (0, (/*@__PURE__*/$parcel$interopDefault($lNv8v)))(token);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // why would this be the case
        return {
            tokenDecodeError: typeof error.message === 'string' ? error.message : undefined,
            localTimeDelta: undefined,
            tokenExpiryTime: undefined
        };
    }
    // In my testing, sometimes issued at was missing
    const startTimestamp = decodedToken.iat || decodedToken.nbf;
    return {
        tokenDecodeError: undefined,
        localTimeDelta: $16b06cb22c076d80$export$e9df841c4c486a60(startTimestamp * 1000),
        tokenExpiryTime: decodedToken.exp * 1000
    };
};
function $16b06cb22c076d80$export$d1a8c8b605234fe8({ token: token, tokenExpiryTime: tokenExpiryTime, localTimeDelta: localTimeDelta }) {
    if (typeof token !== 'string' || token.length === 0) return false;
    if (typeof tokenExpiryTime !== 'number' || typeof localTimeDelta !== 'number') return false;
    const actualExpiryTime = tokenExpiryTime + localTimeDelta - $16b06cb22c076d80$var$TOKEN_NETWORK_BUFFER;
    const timeUntilExpiry = actualExpiryTime - Date.now();
    const isValid = timeUntilExpiry >= 0;
    return isValid;
}
const $16b06cb22c076d80$export$5fb65caa7eb9e932 = (viewResponse)=>{
    const token = viewResponse.tokensWithFiles[0]?.token || null;
    const tokenProps = typeof token === 'string' ? $16b06cb22c076d80$export$4d271852dd07ca26(token) : {};
    return {
        clientId: viewResponse.clientId,
        serviceHost: viewResponse.endpointUrl,
        token: token,
        areTokenPermissionsUpToDate: true,
        tokenLifespanInMs: viewResponse.tokenLifespanInSeconds * 1000,
        collection: viewResponse.collection !== undefined && viewResponse.collection !== '' ? viewResponse.collection : null,
        tokenIssueTimestamp: Date.now() - $16b06cb22c076d80$var$TOKEN_NETWORK_BUFFER,
        tokenDecodeError: tokenProps.tokenDecodeError,
        localTimeDelta: tokenProps.localTimeDelta,
        tokenExpiryTime: tokenProps.tokenExpiryTime
    };
};

});
parcelRegister("lNv8v", function(module, exports) {
'use strict';

var $6bURt = parcelRequire("6bURt");
function $fde6539338bf9ae7$var$InvalidTokenError(message) {
    this.message = message;
}
$fde6539338bf9ae7$var$InvalidTokenError.prototype = new Error();
$fde6539338bf9ae7$var$InvalidTokenError.prototype.name = 'InvalidTokenError';
module.exports = function(token, options) {
    if (typeof token !== 'string') throw new $fde6539338bf9ae7$var$InvalidTokenError('Invalid token specified');
    options = options || {};
    var pos = options.header === true ? 0 : 1;
    try {
        return JSON.parse($6bURt(token.split('.')[pos]));
    } catch (e) {
        throw new $fde6539338bf9ae7$var$InvalidTokenError('Invalid token specified: ' + e.message);
    }
};
module.exports.InvalidTokenError = $fde6539338bf9ae7$var$InvalidTokenError;

});
parcelRegister("6bURt", function(module, exports) {

var $1UChD = parcelRequire("1UChD");
function $481fe0ae33ee61a4$var$b64DecodeUnicode(str) {
    return decodeURIComponent($1UChD(str).replace(/(.)/g, function(m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = '0' + code;
        return '%' + code;
    }));
}
module.exports = function(str) {
    var output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return $481fe0ae33ee61a4$var$b64DecodeUnicode(output);
    } catch (err) {
        return $1UChD(output);
    }
};

});
parcelRegister("1UChD", function(module, exports) {
/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */ var $1648b7b5b93c4620$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function $1648b7b5b93c4620$var$InvalidCharacterError(message) {
    this.message = message;
}
$1648b7b5b93c4620$var$InvalidCharacterError.prototype = new Error();
$1648b7b5b93c4620$var$InvalidCharacterError.prototype.name = 'InvalidCharacterError';
function $1648b7b5b93c4620$var$polyfill(input) {
    var str = String(input).replace(/=+$/, '');
    if (str.length % 4 == 1) throw new $1648b7b5b93c4620$var$InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
    for(// initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = ''; // get next character
    buffer = str.charAt(idx++); // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    bc++ % 4) && (output += String.fromCharCode(255 & bs >> (-2 * bc & 6))))// try to find character in table (0-63, not found => -1)
    buffer = $1648b7b5b93c4620$var$chars.indexOf(buffer);
    return output;
}
module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || $1648b7b5b93c4620$var$polyfill;

});




parcelRegister("aHvCt", function(module, exports) {

$parcel$export(module.exports, "batchMediaViewResponseFactory", () => $f1d81eb8a0075a3d$export$eedff7e9aaf52da1);
$parcel$export(module.exports, "actions", () => $f1d81eb8a0075a3d$export$e324594224ef24da);

var $5eDz8 = parcelRequire("5eDz8");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $8jOO7 = parcelRequire("8jOO7");

var $93QIg = parcelRequire("93QIg");
const $f1d81eb8a0075a3d$export$eedff7e9aaf52da1 = (environment, cloudId)=>async (issueKeys)=>{
        const issueKeysMap = new Map();
        const uniqueIssueKeys = [
            ...new Set(issueKeys)
        ];
        const promise = (0, $j4oe4.fetchQuery)(environment, (0, $5eDz8.default), {
            issueKeys: uniqueIssueKeys,
            cloudId: cloudId,
            maxTokenLength: (0, $93QIg.MAX_TOKEN_LENGTH)
        }).toPromise();
        try {
            const result = await promise;
            const issues = result?.jira?.issuesByKey;
            issues?.forEach((issue)=>{
                if (issue?.mediaReadToken) {
                    const { clientId: clientId, endpointUrl: endpointUrl, tokenLifespanInSeconds: tokenLifespanInSeconds, tokensWithFiles: tokensWithFiles } = issue?.mediaReadToken;
                    const tokensWithFilesFlattened = tokensWithFiles?.edges?.map((edge)=>edge?.node?.token ? {
                            token: edge.node.token
                        } : null).filter(Boolean);
                    if (clientId && endpointUrl && tokenLifespanInSeconds && tokensWithFilesFlattened) {
                        const viewResponse = {
                            clientId: clientId,
                            endpointUrl: endpointUrl,
                            tokenLifespanInSeconds: tokenLifespanInSeconds,
                            tokensWithFiles: tokensWithFilesFlattened
                        };
                        issueKeysMap.set(issue.key, viewResponse);
                    }
                }
            });
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'lazyMediaViewResponseFactory',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        // Ensure input argument order is preserved when returning batch results as required by the dataloader
        return issueKeys.map((issueKey)=>issueKeysMap.get(issueKey) ?? null);
    };
const $f1d81eb8a0075a3d$export$e324594224ef24da = {
    load: (issueKey)=>({ getState: getState })=>{
            const { loader: loader, scheduler: scheduler } = getState();
            const loading = loader ? loader.load(issueKey) : Promise.resolve(null);
            scheduler?.dispatch();
            return loading;
        }
};

});
parcelRegister("5eDz8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ede01961e427f39c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<038490e885f5ed59aebe309ed3d06370>>
 * @relayHash 88dc3fe18d2828d729fb2bf7929e7076
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 878b3b6282e98d324c50ccd49dbaf8a07c889063b5efed0881fe239f64e5160d
const $ede01961e427f39c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKeys"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "maxTokenLength"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "keys",
            "variableName": "issueKeys"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issuesByKey",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issuesByKey",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "878b3b6282e98d324c50ccd49dbaf8a07c889063b5efed0881fe239f64e5160d",
            "metadata": {},
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ede01961e427f39c$var$node.hash = "a1b3499bc5d237db13d819b5abf7ce41";
var $ede01961e427f39c$export$2e2bcd8739ae039 = $ede01961e427f39c$var$node;

});

parcelRegister("93QIg", function(module, exports) {

$parcel$export(module.exports, "MAX_BATCH_SIZE", () => $161cf6e30dc5abb0$export$b79d95ee17a87a);
$parcel$export(module.exports, "MAX_TOKEN_LENGTH", () => $161cf6e30dc5abb0$export$525f5433a110000f);

var $cGVqS = parcelRequire("cGVqS");
const $161cf6e30dc5abb0$export$b79d95ee17a87a = 100;
const $161cf6e30dc5abb0$export$525f5433a110000f = (0, $cGVqS.getMaxTokenLength)();

});
parcelRegister("cGVqS", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $fda68ad41e642ef5$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $fda68ad41e642ef5$var$nonIE11MaxTokenLength = 2 ** 16;
const $fda68ad41e642ef5$export$e40f2acaf1a50b00 = ()=>$fda68ad41e642ef5$var$nonIE11MaxTokenLength;

});




parcelRegister("kfIml", function(module, exports) {

$parcel$export(module.exports, "DraggableRowsContainer", () => $5287baf143ef1bf7$export$d659f1efda86963d);
$parcel$export(module.exports, "Store", () => $5287baf143ef1bf7$export$390f32400eaf98c9);
$parcel$export(module.exports, "useDraggableRowsConnectionId", () => $5287baf143ef1bf7$export$ab74a8a2556419cd);

var $cSmYj = parcelRequire("cSmYj");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");
const $5287baf143ef1bf7$export$d4c72bab9d6cc13a = {
    currentDropTarget: null,
    instanceId: 'pdnd-issue-table-rows',
    issueConnectionId: '',
    items: new Map(),
    // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
    /** @deprecated Use `useIssuesRanker` directly */ onRowReorder: undefined
};
const $5287baf143ef1bf7$var$actions = {
    setDropTarget: (dropTarget)=>({ setState: setState, getState: getState })=>{
            const currentDropTarget = getState().currentDropTarget;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(currentDropTarget, dropTarget)) setState({
                currentDropTarget: dropTarget
            });
        },
    /** @deprecated Use `useIssuesRanker` directly */ reorderRows: (sourceIndex, destinationIndex)=>({ getState: getState })=>{
            if ((0, $7jTnu.fg)('jsc-2065-unify-onrowreorder')) return;
            const { items: items, onRowReorder: onRowReorder } = getState();
            onRowReorder?.({
                source: {
                    issueIds: [
                        items.get(sourceIndex) ?? ''
                    ],
                    rowIndex: sourceIndex
                },
                destination: {
                    relativeToIssueId: items.get(destinationIndex) ?? '',
                    rowIndex: destinationIndex
                },
                edge: sourceIndex > destinationIndex ? 'top' : 'bottom'
            });
        },
    registerItem: (edgeIndex, issueId)=>({ getState: getState, setState: setState })=>{
            const { items: items } = getState();
            setState({
                items: items.set(edgeIndex, issueId)
            });
        },
    unregisterItem: (edgeIndex)=>({ getState: getState, setState: setState })=>{
            const { items: items } = getState();
            if (items.delete(edgeIndex)) setState({
                items: items
            });
        }
};
const $5287baf143ef1bf7$export$d659f1efda86963d = (0, $6E16M.createContainer)({
    getIsConcurrentSafe: ()=>true
});
const $5287baf143ef1bf7$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    initialState: $5287baf143ef1bf7$export$d4c72bab9d6cc13a,
    actions: $5287baf143ef1bf7$var$actions,
    containedBy: $5287baf143ef1bf7$export$d659f1efda86963d,
    handlers: {
        onInit: ()=>({ setState: setState }, { instanceId: instanceId, onRowReorder: onRowReorder, issueConnectionId: issueConnectionId })=>{
                if ((0, $7jTnu.fg)('jsc-2065-unify-onrowreorder')) setState({
                    instanceId: instanceId ?? $5287baf143ef1bf7$export$d4c72bab9d6cc13a.instanceId,
                    issueConnectionId: issueConnectionId
                });
                else setState({
                    instanceId: instanceId ?? $5287baf143ef1bf7$export$d4c72bab9d6cc13a.instanceId,
                    onRowReorder: onRowReorder,
                    issueConnectionId: issueConnectionId
                });
            },
        onContainerUpdate: (props, prevProps)=>({ setState: setState }, { instanceId: instanceId, onRowReorder: onRowReorder, issueConnectionId: issueConnectionId })=>{
                if (props.instanceId !== prevProps.instanceId || props.onRowReorder !== prevProps.onRowReorder || // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
                props.issueConnectionId !== prevProps.issueConnectionId) setState({
                    instanceId: instanceId,
                    onRowReorder: onRowReorder,
                    issueConnectionId: issueConnectionId
                });
            }
    }
});
const $5287baf143ef1bf7$export$ab74a8a2556419cd = (0, $iJq0l.createHook)($5287baf143ef1bf7$export$390f32400eaf98c9, {
    selector: ({ issueConnectionId: issueConnectionId })=>issueConnectionId
});

});

parcelRegister("7XD6x", function(module, exports) {

$parcel$export(module.exports, "IFCFooter", () => $8b646a3a3d5430a0$export$7b0e717a6d1208a9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hx3Sa = parcelRequire("hx3Sa");

var $8nu6j = parcelRequire("8nu6j");

var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");

var $5CSKW = parcelRequire("5CSKW");

var $jQjGM = parcelRequire("jQjGM");

var $i4Iw4 = parcelRequire("i4Iw4");

var $lL4G9 = parcelRequire("lL4G9");

var $lRq8t = parcelRequire("lRq8t");

var $gZTP9 = parcelRequire("gZTP9");

var $2aY2d = parcelRequire("2aY2d");

var $fpyg5 = parcelRequire("fpyg5");

var $6rftq = parcelRequire("6rftq");

var $epTsa = parcelRequire("epTsa");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6KVf0 = parcelRequire("6KVf0");


var $pZqvR = parcelRequire("pZqvR");

var $cEWre = parcelRequire("cEWre");

var $kompv = parcelRequire("kompv");

var $7lNJU = parcelRequire("7lNJU");
const $8b646a3a3d5430a0$var$styles = {
    ifcFooter: "_1h6dmuej _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1e0c1txw _2lx2vrvc _15a5nqa1 _uwhke4h9 _1bah1h6o"
};
const $8b646a3a3d5430a0$export$7b0e717a6d1208a9 = ({ onPickerClose: onPickerClose, columnsDataId: columnsDataId, columnInsertIndex: columnInsertIndex })=>{
    const contactAdminGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $kompv.default).contactAdminGalaxia : (0, $kompv.default).contactAdmin;
    const { ifcConfig: ifcConfig, addFieldToColumns: addFieldToColumns } = (0, $pZqvR.useIFCConfigContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isSiteAdmin = (0, $gZTP9.useIsAdmin)();
    const isProjectAdmin = (0, $6rftq.useIsProjectAdmin)();
    const isTMP = (0, $2aY2d.useIsSimplifiedProject)();
    const isAdmin = isSiteAdmin || isProjectAdmin;
    const isCMPAdmin = isAdmin && !isTMP;
    const isTMPAdmin = isAdmin && isTMP;
    const { clearIndex: clearIndex } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const environment = (0, $hx3Sa.useRelayEnvironment)();
    const editField = (0, $cEWre.useIFCEditField)();
    const onStartFieldCreate = (0, $eJOHy.useCallback)(({ name: name, type: type })=>{
        const field = {
            fieldSetId: (0, $7lNJU.TEMP_CREATE_FIELDSET_ID),
            name: name,
            type: type
        };
        (0, $fpyg5.createOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: columnsDataId,
            fields: [
                field
            ],
            createIndex: columnInsertIndex
        });
    }, [
        columnInsertIndex,
        columnsDataId,
        environment
    ]);
    const onFieldCreated = (0, $eJOHy.useCallback)((fieldId, fieldSetId)=>{
        if (fieldSetId) {
            (0, $7lNJU.updateTempOptimisticFieldSetId)({
                environment: environment,
                fieldConfigId: columnsDataId,
                fieldSetId: fieldSetId
            });
            addFieldToColumns?.(fieldSetId, columnInsertIndex, ()=>{
                (0, $fpyg5.deleteOptimisticFieldConfig)({
                    environment: environment,
                    fieldConfigId: columnsDataId,
                    fields: [
                        {
                            fieldSetId: fieldSetId,
                            name: ''
                        }
                    ]
                });
            });
            editField(fieldId, fieldSetId);
        }
    }, [
        environment,
        columnsDataId,
        addFieldToColumns,
        columnInsertIndex,
        editField
    ]);
    const onFieldCreateError = (0, $eJOHy.useCallback)(()=>{
        (0, $fpyg5.deleteOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: columnsDataId,
            fields: [
                {
                    fieldSetId: (0, $7lNJU.TEMP_CREATE_FIELDSET_ID),
                    name: ''
                }
            ]
        });
    }, [
        columnsDataId,
        environment
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const clickHandler = (0, $eJOHy.useCallback)((event)=>{
        onPickerClose?.(event);
        clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
        ifcConfig?.onCreate({
            onFieldCreated: onFieldCreated,
            onStartFieldCreate: onStartFieldCreate,
            onFieldCreateError: onFieldCreateError
        });
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createFieldIFCFooterButton');
    }, [
        onPickerClose,
        clearIndex,
        ifcConfig,
        onFieldCreated,
        onStartFieldCreate,
        onFieldCreateError,
        createAnalyticsEvent
    ]);
    if (!isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8b646a3a3d5430a0$var$styles.ifcFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage(contactAdminGalaxia, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
                href: "/secure/ContactAdministrators!default.jspa",
                target: "_blank",
                onClick: ()=>{
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'link'
                    }), 'endUserIFCFooterLink');
                }
            }, chunks)
    }))));
    if (isTMPAdmin && ifcConfig?.IFCTriggerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8b646a3a3d5430a0$var$styles.ifcFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ifcConfig.IFCTriggerRef, null, ({ triggerRef: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            ref: triggerRef,
            onClick: clickHandler,
            shouldFitContainer: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQjGM))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $kompv.default).createAnotherButton))))));
    if (isCMPAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8b646a3a3d5430a0$var$styles.ifcFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $kompv.default).makeChangesInConfig, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
                href: (0, $epTsa.expVal)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', false) ? '/jira/settings/issues/fields' : '/secure/admin/ViewCustomFields.jspa',
                target: "_blank",
                onClick: ()=>{
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'link'
                    }), 'cmpAdminIFCFooterLink');
                }
            }, chunks)
    }))));
};

});
parcelRegister("hx3Sa", function(module, exports) {
/**
 * Relay v0.0.0-main-5980a913
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("lBb6O"));

});
parcelRegister("lBb6O", function(module, exports) {
'use strict';

var $4E40D = parcelRequire("4E40D");

var $bdIJW = parcelRequire("bdIJW");

var $bQPKN = parcelRequire("bQPKN");
var $fb95aba886d4097a$var$loadQuery = $bQPKN.loadQuery;

var $83OIO = parcelRequire("83OIO");

var $1NoLa = parcelRequire("1NoLa");

var $iahTm = parcelRequire("iahTm");

var $kM8tH = parcelRequire("kM8tH");

var $cOk0k = parcelRequire("cOk0k");

var $dmpY4 = parcelRequire("dmpY4");

var $73jbJ = parcelRequire("73jbJ");

var $xo8pN = parcelRequire("xo8pN");

var $RjuBo = parcelRequire("RjuBo");

var $eyGnt = parcelRequire("eyGnt");

var $i764d = parcelRequire("i764d");

var $dEDMm = parcelRequire("dEDMm");

var $4Iwb3 = parcelRequire("4Iwb3");

var $37Ewn = parcelRequire("37Ewn");
module.exports = {
    ConnectionHandler: $37Ewn.ConnectionHandler,
    applyOptimisticMutation: $37Ewn.applyOptimisticMutation,
    commitLocalUpdate: $37Ewn.commitLocalUpdate,
    commitMutation: $37Ewn.commitMutation,
    graphql: $37Ewn.graphql,
    readInlineData: $37Ewn.readInlineData,
    requestSubscription: $37Ewn.requestSubscription,
    EntryPointContainer: $4E40D,
    RelayEnvironmentProvider: $1NoLa,
    ProfilerContext: $83OIO,
    fetchQuery: $37Ewn.fetchQuery,
    loadQuery: $fb95aba886d4097a$var$loadQuery,
    loadEntryPoint: $bdIJW,
    useFragment: $kM8tH,
    useLazyLoadQuery: $cOk0k,
    useEntryPointLoader: $iahTm,
    useQueryLoader: $RjuBo,
    useMutation: $dmpY4,
    usePaginationFragment: $73jbJ,
    usePreloadedQuery: $xo8pN,
    useRefetchableFragment: $eyGnt,
    useRelayEnvironment: $i764d,
    useSubscribeToInvalidationState: $dEDMm,
    useSubscription: $4Iwb3
};

});


parcelRegister("jQjGM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::739edc58ca910533dbcf168239dfad1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7222574ac205219$var$_react = $e7222574ac205219$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e7222574ac205219$var$_add = $e7222574ac205219$var$_interopRequireDefault((parcelRequire("dcLzM")));

var $e7222574ac205219$var$_add2 = $e7222574ac205219$var$_interopRequireDefault((parcelRequire("lnnie")));
function $e7222574ac205219$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7222574ac205219$var$AddIcon = (props)=>/*#__PURE__*/ $e7222574ac205219$var$_react.default.createElement($e7222574ac205219$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $e7222574ac205219$var$_add2.default
    }, props));
$e7222574ac205219$var$AddIcon.Name = 'AddIconMigration';
var $e7222574ac205219$var$_default = module.exports.default = $e7222574ac205219$var$AddIcon;

});
parcelRegister("lnnie", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8fdd0750f7e22cb$var$_react = $f8fdd0750f7e22cb$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $f8fdd0750f7e22cb$var$_add = $f8fdd0750f7e22cb$var$_interopRequireDefault((parcelRequire("dcLzM")));
function $f8fdd0750f7e22cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8fdd0750f7e22cb$var$AddIcon = (props)=>/*#__PURE__*/ $f8fdd0750f7e22cb$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $f8fdd0750f7e22cb$var$_add.default
    }));
$f8fdd0750f7e22cb$var$AddIcon.displayName = 'AddIcon';
var $f8fdd0750f7e22cb$var$_default = module.exports.default = $f8fdd0750f7e22cb$var$AddIcon;

});


parcelRegister("fpyg5", function(module, exports) {

$parcel$export(module.exports, "isOnlyUnselectableField", () => $608fafa198ebf130$export$bf5bbd6344a5f1aa);
$parcel$export(module.exports, "getFieldDisabledMessage", () => $608fafa198ebf130$export$b547e1f9b04ac0ef);
$parcel$export(module.exports, "findNewInsertFields", () => $608fafa198ebf130$export$60fa8135877879de);
$parcel$export(module.exports, "findRemovedFields", () => $608fafa198ebf130$export$bcbd9324b737d43e);
$parcel$export(module.exports, "getUpdatedOptions", () => $608fafa198ebf130$export$f35b98a37123c93f);
$parcel$export(module.exports, "sortMergedColumnOptions", () => $608fafa198ebf130$export$9c9602c008ed572e);
$parcel$export(module.exports, "createOptimisticFieldConfig", () => $608fafa198ebf130$export$156c6a7908536c2c);
$parcel$export(module.exports, "deleteOptimisticFieldConfig", () => $608fafa198ebf130$export$c2b4d8461d595052);
$parcel$export(module.exports, "getRollbackFields", () => $608fafa198ebf130$export$f07a9aef49bee569);
$parcel$export(module.exports, "rollbackOptimisticFieldConfig", () => $608fafa198ebf130$export$4b8e679985e2412d);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $3cMgR = parcelRequire("3cMgR");

var $j8Km1 = parcelRequire("j8Km1");

var $lWeUb = parcelRequire("lWeUb");
const $608fafa198ebf130$export$bf5bbd6344a5f1aa = (fieldType, canEditColumnConfiguration)=>{
    // Epic Link can only be unselected
    if (fieldType === 'com.pyxis.greenhopper.jira:gh-epic-link') return canEditColumnConfiguration;
    // Parent Link can only be unselected
    if (fieldType === 'com.atlassian.jpo:jpo-custom-field-parent') return canEditColumnConfiguration;
    return false;
};
const $608fafa198ebf130$export$b547e1f9b04ac0ef = (fieldType, formatMessage)=>{
    // Epic Link deprecation message
    if (fieldType === 'com.pyxis.greenhopper.jira:gh-epic-link') return formatMessage((0, $lWeUb.default).deprecatedEpicMessage, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, chunks)
    });
    // Parent Link deprecation message
    if (fieldType === 'com.atlassian.jpo:jpo-custom-field-parent') return formatMessage((0, $lWeUb.default).deprecatedParentLinkMessage, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, chunks)
    });
    return undefined;
};
const $608fafa198ebf130$export$60fa8135877879de = (options, selectedColumns)=>{
    return options.filter((option)=>!selectedColumns.some((prevOption)=>{
            if ('value' in prevOption && 'value' in option) return prevOption.value === option.value;
            return false;
        }));
};
const $608fafa198ebf130$export$bcbd9324b737d43e = (options, selectedColumns)=>{
    const removedFields = [];
    const existingValues = new Set(options.map((opt)=>'value' in opt ? opt.value : ''));
    selectedColumns.forEach((option)=>{
        if ('value' in option && !existingValues.has(option.value)) removedFields.push({
            name: option.label,
            fieldSetId: option.value
        });
    });
    return removedFields;
};
const $608fafa198ebf130$export$f35b98a37123c93f = (options, insertFields, insertIndex)=>{
    if (insertIndex !== undefined) {
        const updatedOptions = [
            ...options
        ];
        updatedOptions.splice(insertIndex, 0, ...insertFields);
        return updatedOptions;
    }
    return [
        ...options,
        ...insertFields
    ];
};
const $608fafa198ebf130$export$9c9602c008ed572e = (options)=>{
    let issuekey;
    let issuetype;
    let summary;
    const otherOptions = [];
    options.forEach((option)=>{
        if ('value' in option) {
            if (option.value === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE) issuetype = option;
            else if (option.value === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) issuekey = option;
            else if (option.value === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) summary = option;
            else otherOptions.push(option);
        } else otherOptions.push(option);
    });
    return [
        issuetype,
        issuekey,
        summary,
        ...otherOptions
    ].filter(Boolean);
};
const $608fafa198ebf130$export$156c6a7908536c2c = ({ environment: environment, fieldConfigId: fieldConfigId, fields: newFields, createIndex: createIndex })=>{
    if (fieldConfigId) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const createdFields = [];
            newFields.forEach((field)=>{
                const exists = fields?.find((edge)=>edge.getLinkedRecord('node')?.getValue('fieldSetId') === field.fieldSetId);
                if (!exists) createdFields.push($608fafa198ebf130$var$createFieldInStore(field, store));
            });
            if (fields) {
                if (createIndex !== undefined && createIndex >= 0 && createIndex <= fields.length) {
                    const updatedFields = [
                        ...fields
                    ];
                    updatedFields.splice(createIndex, 0, ...createdFields);
                    store.get(fieldConfigId)?.setLinkedRecords(updatedFields, 'edges');
                } else store.get(fieldConfigId)?.setLinkedRecords([
                    ...fields,
                    ...createdFields
                ], 'edges');
                store.get(fieldConfigId)?.setValue(fields.length + createdFields.length, 'totalCount');
            }
        }
    });
    const rollback = ()=>{
        if (fieldConfigId) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const fieldSetsConnection = store.get(fieldConfigId);
            if (fieldConfigId) {
                fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
                    const node = edge.getLinkedRecord('node');
                    const exists = newFields?.find((field)=>node?.getValue('fieldSetId') === field.fieldSetId);
                    if (exists) {
                        const nodeId = node?.getDataID();
                        nodeId && (0, $37Ewn.ConnectionHandler).deleteNode(fieldSetsConnection, nodeId);
                    }
                });
                const newTotalCount = fieldSetsConnection?.getLinkedRecords('edges')?.length;
                store.get(fieldConfigId)?.setValue(newTotalCount, 'totalCount');
            }
        });
    };
    return rollback;
};
const $608fafa198ebf130$export$c2b4d8461d595052 = ({ environment: environment, fieldConfigId: fieldConfigId, fields: deletedFields })=>{
    if (fieldConfigId) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        const fieldSetsConnection = store.get(fieldConfigId);
        const deletedFieldsSetIds = new Set(deletedFields.map((field)=>field.fieldSetId));
        fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            const fieldSetId = node?.getValue('fieldSetId')?.toString();
            if (fieldSetId && deletedFieldsSetIds.has(fieldSetId)) {
                const nodeId = node?.getDataID();
                nodeId && (0, $37Ewn.ConnectionHandler).deleteNode(fieldSetsConnection, nodeId);
            }
        });
        const newTotalCount = fieldSetsConnection?.getLinkedRecords('edges')?.length;
        store.get(fieldConfigId)?.setValue(newTotalCount, 'totalCount');
    });
};
const $608fafa198ebf130$export$f07a9aef49bee569 = ({ environment: environment, fieldConfigId: fieldConfigId })=>{
    const backupFields = [];
    (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fieldSetsConnection = store.get(fieldConfigId);
            fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
                const node = edge.getLinkedRecord('node');
                const fieldSetPreferences = node?.getLinkedRecord('fieldSetPreferences');
                const width = fieldSetPreferences?.getValue('width')?.toString();
                const field = {
                    fieldSetId: node?.getValue('fieldSetId')?.toString() || '',
                    jqlTerm: node?.getValue('jqlTerm')?.toString() || '',
                    type: node?.getValue('type')?.toString() || '',
                    name: node?.getValue('displayName')?.toString() || '',
                    customWidth: width ? Number(width) : undefined
                };
                backupFields.push(field);
            });
        }
    });
    return backupFields;
};
const $608fafa198ebf130$export$4b8e679985e2412d = ({ environment: environment, fieldConfigId: fieldConfigId, fields: backupFields })=>{
    if (fieldConfigId && backupFields.length > 0) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        const fieldSetsConnection = store.get(fieldConfigId);
        // Create new edges for each backup node and completely replace the current edges
        const restoredEdges = backupFields.map((field)=>$608fafa198ebf130$var$createFieldInStore(field, store));
        if (fieldSetsConnection) {
            fieldSetsConnection.setLinkedRecords(restoredEdges, 'edges');
            fieldSetsConnection.setValue(restoredEdges.length, 'totalCount');
        }
    });
};
const $608fafa198ebf130$var$createFieldInStore = (newField, store)=>{
    const fieldJqlTerm = 'jql-placeholder-only';
    const edge = store.create((0, $aXKmr.v4)(), 'JiraIssueSearchFieldSetEdge');
    const aField = store.create((0, $aXKmr.v4)(), 'JiraIssueSearchFieldSet');
    aField.setValue(newField.fieldSetId, 'fieldSetId');
    aField.setValue(newField.jqlTerm ?? fieldJqlTerm, 'jqlTerm');
    aField.setValue(newField.type, 'type');
    aField.setValue(newField.name, 'displayName');
    if (!newField.jqlTerm) aField.setValue(true, 'isPlaceHolderField');
    if (newField.customWidth) {
        const preferences = store.create((0, $aXKmr.v4)(), 'FieldSetPreferences');
        preferences.setValue(newField.customWidth, 'width');
        aField.setLinkedRecord(preferences, 'fieldSetPreferences');
    }
    edge.setLinkedRecord(aField, 'node');
    return edge;
};

});
parcelRegister("lWeUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35255bd661bd8f4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d35255bd661bd8f4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issuetype: {
        "id": "issue-table-column-picker.issuetype",
        "defaultMessage": "Issue Type"
    },
    issuekey: {
        "id": "issue-table-column-picker.issuekey",
        "defaultMessage": "Key"
    },
    summary: {
        "id": "issue-table-column-picker.summary",
        "defaultMessage": "Summary"
    },
    assignee: {
        "id": "issue-table-column-picker.assignee",
        "defaultMessage": "Assignee"
    },
    reporter: {
        "id": "issue-table-column-picker.reporter",
        "defaultMessage": "Reporter"
    },
    priority: {
        "id": "issue-table-column-picker.priority",
        "defaultMessage": "Priority"
    },
    status: {
        "id": "issue-table-column-picker.status",
        "defaultMessage": "Status"
    },
    resolution: {
        "id": "issue-table-column-picker.resolution",
        "defaultMessage": "Resolution"
    },
    created: {
        "id": "issue-table-column-picker.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "issue-table-column-picker.updated",
        "defaultMessage": "Updated"
    },
    duedate: {
        "id": "issue-table-column-picker.duedate",
        "defaultMessage": "Due date"
    },
    deprecatedParentLinkMessage: {
        "id": "issue-table-column-picker.deprecated-parent-link-message",
        "defaultMessage": "<strong>Parent Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    deprecatedEpicMessage: {
        "id": "issue-table-column-picker.deprecated-epic-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    issuetypeIssueTerminologyRefreshM4: {
        "id": "issue-table-column-picker.issuetype-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    }
});

});


parcelRegister("6rftq", function(module, exports) {

$parcel$export(module.exports, "useIsProjectAdmin", () => $4b16618c7781b873$export$9facd8d31b938a25);

var $2aY2d = parcelRequire("2aY2d");
const $4b16618c7781b873$export$9facd8d31b938a25 = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    return !!data?.isProjectAdmin;
};

});

const $7423e9894c2b8b23$export$76a449e52fa0e1e8 = 'issue';
const $7423e9894c2b8b23$export$d6f887e0c1be1b74 = 'field';

parcelRegister("pZqvR", function(module, exports) {

$parcel$export(module.exports, "useIFCConfigContext", () => $48ca4011692a630d$export$e3a7198c51d237d7);
$parcel$export(module.exports, "IFCConfigContextProviderComponent", () => $48ca4011692a630d$export$8df178a0d1abc310);

var $9RmXR = parcelRequire("9RmXR");

var $3hBQH = parcelRequire("3hBQH");

var $eJOHy = parcelRequire("eJOHy");

var $hx3Sa = parcelRequire("hx3Sa");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $j8Km1 = parcelRequire("j8Km1");

var $fpyg5 = parcelRequire("fpyg5");

var $dLXgn = parcelRequire("dLXgn");

var $d8Dow = parcelRequire("d8Dow");

var $8jOO7 = parcelRequire("8jOO7");

var $7lNJU = parcelRequire("7lNJU");

var $b9qDs = parcelRequire("b9qDs");
const $48ca4011692a630d$export$be578a14685d978b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    ifcConfig: undefined
});
const $48ca4011692a630d$export$16276ffbd566ecbc = ({ children: children, ifcConfig: ifcConfig, columns: columns, onColumnsChange: onColumnsChange, queryRef: queryRef, columnsQueryRef: columnsQueryRef })=>{
    const columnRef = (0, $eJOHy.useRef)(columns);
    const currentIssuesRef = (0, $eJOHy.useRef)(null);
    const processedIssuesRef = (0, $eJOHy.useRef)({
        issuesRef: null,
        fieldId: null
    });
    const selectedOptions = (0, $eJOHy.useRef)(undefined);
    if (columnRef.current !== columns) columnRef.current = columns;
    const environment = (0, $hx3Sa.useRelayEnvironment)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const currentConnections = (0, $eJOHy.useRef)();
    const currentGroupsIssuesRef = (0, $eJOHy.useRef)([]);
    if (currentConnections.current !== connections) {
        currentGroupsIssuesRef.current = Object.values(connections).filter((connection)=>connection.type === 'GROUP_CHILDREN' || connection.type === 'PARENT_CHILDREN').map((connection)=>connection.type === 'GROUP_CHILDREN' || connection.type === 'PARENT_CHILDREN' ? connection.fieldSetsData : undefined);
        currentConnections.current = connections;
    }
    const issuesQueryRef = (0, $hx3Sa.useFragment)((0, $3hBQH.default), queryRef);
    const fieldConfig = (0, $hx3Sa.useFragment)((0, $9RmXR.default), columnsQueryRef);
    if (currentIssuesRef.current !== issuesQueryRef) currentIssuesRef.current = issuesQueryRef ?? null;
    const optimisticDeleteField = (0, $eJOHy.useCallback)((fieldSetId)=>{
        (0, $fpyg5.deleteOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: fieldConfig?.__id,
            fields: [
                {
                    fieldSetId: fieldSetId,
                    name: ''
                }
            ]
        });
    }, [
        environment,
        fieldConfig?.__id
    ]);
    const getColumnIds = (0, $eJOHy.useCallback)(()=>{
        const columnIds = columnRef.current?.map(({ id: id })=>id)?.filter((id)=>!id.startsWith((0, $8jOO7.COLUMN_ID_INTERNAL_COLUMN)) && id !== (0, $7lNJU.TEMP_CREATE_FIELDSET_ID));
        const mergedColumnsIds = (0, $7jTnu.fg)('jira_list_merged_column_gate') ? (columnRef.current.find((col)=>col?.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns ?? []).map((col)=>col.id) : [];
        return [
            ...mergedColumnsIds,
            ...columnIds
        ];
    }, []);
    const replaceFieldSetInColumns = (0, $eJOHy.useCallback)((fieldSetId, newfieldSetId, fieldId)=>{
        const columnIds = getColumnIds();
        let skipRefetch = true;
        // find out if a column of the same fieldsetid exists
        // if yes, the column will get merged when we refetch so we also don't skip refetch
        const duplicateFieldSetIndex = columnIds.findIndex((id)=>id === newfieldSetId);
        if (duplicateFieldSetIndex > -1) {
            optimisticDeleteField(newfieldSetId);
            skipRefetch = false;
            columnIds.splice(duplicateFieldSetIndex, 1);
        }
        (0, $7lNJU.optimisticUpdateColumnConfigFieldSetIdById)({
            environment: environment,
            fieldConfigId: fieldConfig?.__id,
            field: {
                fieldId: fieldId,
                fieldSetId: newfieldSetId
            }
        });
        (0, $b9qDs.optimisticUpdateIssuesFieldSetId)(environment, currentIssuesRef.current, fieldId, newfieldSetId);
        // for groups
        currentGroupsIssuesRef.current.forEach((groupIssuesRef)=>{
            if (groupIssuesRef != null) (0, $b9qDs.optimisticUpdateIssuesFieldSetId)(environment, groupIssuesRef, fieldId, newfieldSetId);
        });
        const insertIndex = columnIds.findIndex((id)=>id === fieldSetId);
        if (insertIndex > -1) {
            columnIds[insertIndex] = newfieldSetId;
            onColumnsChange?.({
                columnIds: columnIds,
                retries: 3,
                onErrorCallback: ()=>{
                    optimisticDeleteField(newfieldSetId);
                },
                isHorizontalAutoScrollNeeded: false,
                skipRefetch: skipRefetch,
                analyticsAttributes: {
                    fromIFCFieldUpdated: true,
                    changeType: (0, $d8Dow.ADD_COLUMNS)
                }
            });
        }
    }, [
        environment,
        fieldConfig?.__id,
        getColumnIds,
        onColumnsChange,
        optimisticDeleteField
    ]);
    const addFieldToColumns = (0, $eJOHy.useCallback)((fieldSetId, index, onErrorCallback)=>{
        const columnIds = getColumnIds();
        const insertIndex = index == null ? columnIds.length : index;
        columnIds.splice(insertIndex, 0, fieldSetId);
        onColumnsChange?.({
            columnIds: columnIds,
            retries: 3,
            onErrorCallback: onErrorCallback,
            isHorizontalAutoScrollNeeded: index === undefined,
            analyticsAttributes: {
                fromIFCFieldCreated: true,
                changeType: (0, $d8Dow.ADD_COLUMNS)
            }
        });
    }, [
        getColumnIds,
        onColumnsChange
    ]);
    const updateSelectedOptions = (0, $eJOHy.useCallback)((fieldId, type, options)=>{
        if (type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT && type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT) return;
        if (processedIssuesRef.current.issuesRef !== currentIssuesRef.current || processedIssuesRef.current.fieldId !== fieldId) {
            selectedOptions.current = (0, $b9qDs.getSelectedOptions)(currentIssuesRef.current, fieldId, type);
            processedIssuesRef.current.issuesRef = currentIssuesRef.current;
            processedIssuesRef.current.fieldId = fieldId;
        }
        // for groups
        currentGroupsIssuesRef.current.forEach((groupIssuesRef)=>{
            if (groupIssuesRef != null) selectedOptions.current = {
                ...selectedOptions.current,
                ...(0, $b9qDs.getSelectedOptions)(groupIssuesRef, fieldId, type)
            };
        });
        if (selectedOptions.current) return (0, $b9qDs.optimisticUpdatesSelectedOptions)(environment, type, selectedOptions.current, options);
    }, [
        environment
    ]);
    const optimisticUpdateField = (0, $eJOHy.useCallback)((fieldId, field)=>{
        if (fieldConfig?.__id) {
            const prevName = (0, $7lNJU.updateOptimisticFieldName)({
                environment: environment,
                fieldConfigId: fieldConfig?.__id,
                field: {
                    fieldId: fieldId,
                    name: field.name
                }
            });
            let prevOptions;
            if (field.options) prevOptions = updateSelectedOptions?.(fieldId, field.type, field.options);
            if (prevName) return {
                id: fieldId,
                field: {
                    name: prevName,
                    type: field.type,
                    options: prevOptions
                }
            };
        }
    }, [
        environment,
        fieldConfig?.__id,
        updateSelectedOptions
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            ifcConfig: ifcConfig,
            addFieldToColumns: addFieldToColumns,
            updateSelectedOptions: updateSelectedOptions,
            replaceFieldSetInColumns: replaceFieldSetInColumns,
            optimisticUpdateField: optimisticUpdateField,
            optimisticDeleteField: optimisticDeleteField
        }), [
        ifcConfig,
        addFieldToColumns,
        updateSelectedOptions,
        replaceFieldSetInColumns,
        optimisticUpdateField,
        optimisticDeleteField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($48ca4011692a630d$export$be578a14685d978b.Provider, {
        value: value
    }, children);
};
const $48ca4011692a630d$export$e3a7198c51d237d7 = ()=>{
    return (0, $eJOHy.useContext)($48ca4011692a630d$export$be578a14685d978b);
};
const $48ca4011692a630d$export$8df178a0d1abc310 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jira_inline_field_config_gate'), $48ca4011692a630d$export$16276ffbd566ecbc, ({ children: children })=>children);

});
parcelRegister("9RmXR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f7e946677098a43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab771d6d7f14313f1bf27206756b3ede>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5f7e946677098a43$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$5f7e946677098a43$var$node.hash = "da9cc8f15ae8ed9e7e4b651383cc3495";
var $5f7e946677098a43$export$2e2bcd8739ae039 = $5f7e946677098a43$var$node;

});

parcelRegister("3hBQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2933c390546b2df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<51e830bcf0e997137ea6d87890e6a21b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e2933c390546b2df$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "type"
    }, v1 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "context_nativeIssueTable_IFCConfigContextProvider_queryRef",
        "selections": [
            {
                "kind": "InlineDataFragmentSpread",
                "name": "optimisticUpdatesSelectedOptionsQuery",
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 500
                                    }
                                ],
                                "concreteType": "JiraIssueFieldSetConnection",
                                "kind": "LinkedField",
                                "name": "fieldSets",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldSetEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldSet",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fields",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "__typename"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "fieldId"
                                                                            },
                                                                            v0 /*: any*/ ,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraOptionConnection",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "selectedOptions",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraOptionEdge",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "edges",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraOption",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "node",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "id"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "value"
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    v1 /*: any*/ 
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraCheckboxesField"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraOption",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "fieldOption",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "optionId"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraSingleSelectField"
                                                                            },
                                                                            v1 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldSets(first:500)"
                            }
                        ]
                    }
                ],
                "argumentDefinitions": []
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$e2933c390546b2df$var$node.hash = "f0f5032440126e7680db215f36484487";
var $e2933c390546b2df$export$2e2bcd8739ae039 = $e2933c390546b2df$var$node;

});

parcelRegister("d8Dow", function(module, exports) {

$parcel$export(module.exports, "MAX_COLUMNS", () => $0ea88860b9e82601$export$7ec4af037f372df4);
$parcel$export(module.exports, "createDebouncedColumnLoader", () => $0ea88860b9e82601$export$a6cff24b97727de1);
$parcel$export(module.exports, "REMOVE_COLUMNS", () => $0ea88860b9e82601$export$191e3e934175a609);
$parcel$export(module.exports, "ADD_COLUMNS", () => $0ea88860b9e82601$export$ccf17692f1fc979a);

var $3Zpjn = parcelRequire("3Zpjn");

const $0ea88860b9e82601$export$7ec4af037f372df4 = 500;
const $0ea88860b9e82601$export$a6cff24b97727de1 = (0, $3Zpjn.createGenericDebouncableDataLoader);
const $0ea88860b9e82601$export$191e3e934175a609 = 'REMOVE_COLUMNS';
const $0ea88860b9e82601$export$ccf17692f1fc979a = 'ADD_COLUMNS';

});
parcelRegister("3Zpjn", function(module, exports) {

$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $515f3085be272897$export$ea63a11564958c9e);

var $3s8bj = parcelRequire("3s8bj");
const $515f3085be272897$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $515f3085be272897$export$2e2bcd8739ae039 = $515f3085be272897$export$ea63a11564958c9e;

});


parcelRegister("7lNJU", function(module, exports) {

$parcel$export(module.exports, "TEMP_CREATE_FIELDSET_ID", () => $108bec5f55b27c19$export$6ec0f6605f2c959e);
$parcel$export(module.exports, "updateTempOptimisticFieldSetId", () => $108bec5f55b27c19$export$983fb13ccb9ab7e0);
$parcel$export(module.exports, "updateOptimisticFieldName", () => $108bec5f55b27c19$export$1ba75d43b01f9290);
$parcel$export(module.exports, "optimisticUpdateColumnConfigFieldSetIdById", () => $108bec5f55b27c19$export$28a743eeaeb242db);

var $hx3Sa = parcelRequire("hx3Sa");
const $108bec5f55b27c19$export$6ec0f6605f2c959e = 'temp_new_fieldset_id';
const $108bec5f55b27c19$export$983fb13ccb9ab7e0 = ({ environment: environment, fieldConfigId: fieldConfigId, fieldSetId: fieldSetId })=>{
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>edge.getLinkedRecord('node')?.getValue('fieldSetId') === $108bec5f55b27c19$export$6ec0f6605f2c959e);
            if (currentField) currentField.getLinkedRecord('node')?.setValue(fieldSetId, 'fieldSetId');
        }
    });
};
const $108bec5f55b27c19$export$1ba75d43b01f9290 = ({ environment: environment, fieldConfigId: fieldConfigId, field: { fieldId: fieldId, name: name } })=>{
    let previousName;
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>{
                const metadata = edge.getLinkedRecord('node')?.getLinkedRecord('fieldsMetadata');
                const fsFields = metadata?.getLinkedRecords('edges');
                const fsField = fsFields?.find((fedge)=>fedge?.getLinkedRecord('node')?.getValue('fieldId') === fieldId);
                return !!fsField;
            });
            if (currentField) {
                previousName = currentField.getLinkedRecord('node')?.getValue('displayName');
                currentField.getLinkedRecord('node')?.setValue(name, 'displayName');
            }
        }
    });
    return previousName;
};
const $108bec5f55b27c19$export$28a743eeaeb242db = ({ environment: environment, fieldConfigId: fieldConfigId, field: { fieldId: fieldId, fieldSetId: fieldSetId } })=>{
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>{
                const metadata = edge.getLinkedRecord('node')?.getLinkedRecord('fieldsMetadata');
                const fsFields = metadata?.getLinkedRecords('edges');
                const fsField = fsFields?.find((fedge)=>fedge?.getLinkedRecord('node')?.getValue('fieldId') === fieldId);
                return !!fsField;
            });
            if (currentField) currentField.getLinkedRecord('node')?.setValue(fieldSetId, 'fieldSetId');
        }
    });
};

});

parcelRegister("b9qDs", function(module, exports) {

$parcel$export(module.exports, "getSelectedOptions", () => $cf3d6c186dbc2f35$export$dd5cf00ceb58ef45);
$parcel$export(module.exports, "optimisticUpdatesSelectedOptions", () => $cf3d6c186dbc2f35$export$b96cfa9b16d1cfb3);
$parcel$export(module.exports, "optimisticUpdateIssuesFieldSetId", () => $cf3d6c186dbc2f35$export$6b82cef47b481f3a);

var $WSSft = parcelRequire("WSSft");

var $j4oe4 = parcelRequire("j4oe4");

var $hx3Sa = parcelRequire("hx3Sa");

var $wufAv = parcelRequire("wufAv");

var $j8Km1 = parcelRequire("j8Km1");
const $cf3d6c186dbc2f35$var$readIssuesData = (queryRef)=>{
    return (0, $j4oe4.readInlineData)((0, $WSSft.default), queryRef);
};
const $cf3d6c186dbc2f35$export$dd5cf00ceb58ef45 = (queryRef, fieldId, type)=>{
    if (!queryRef) return;
    const selectedOptions = $cf3d6c186dbc2f35$var$readIssuesData(queryRef);
    const selectedOptionMap = {};
    switch(type){
        case (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT:
            selectedOptions?.edges?.forEach((issue)=>{
                const fieldsets = issue?.fieldSets?.edges?.filter((fieldSet)=>fieldSet?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT);
                fieldsets?.forEach((fieldSet)=>{
                    const field = fieldSet?.node?.fields?.edges?.find((f)=>f?.node?.fieldId === fieldId);
                    field?.node?.selectedOptions?.edges?.forEach((option)=>{
                        if (option?.__id != null && option?.node?.id != null) {
                            const optionId = option?.__id ?? '';
                            selectedOptionMap[optionId] = option?.node?.id;
                        }
                    });
                });
            });
            break;
        case (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT:
            selectedOptions?.edges?.forEach((issue)=>{
                const fieldsets = issue?.fieldSets?.edges?.filter((fieldSet)=>fieldSet?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT);
                fieldsets?.forEach((fieldSet)=>{
                    const field = fieldSet?.node?.fields?.edges?.find((f)=>{
                        return f?.node?.fieldId === fieldId;
                    });
                    if (field?.node?.__id != null && field?.node?.fieldOption?.optionId) selectedOptionMap[field?.node?.__id ?? ''] = field?.node?.fieldOption?.optionId;
                });
            });
            break;
        default:
            break;
    }
    return selectedOptionMap;
};
const $cf3d6c186dbc2f35$export$b96cfa9b16d1cfb3 = (environment, type, selectedOptionMap, options)=>{
    if (type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT && type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT) return;
    const previousOptions = {};
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        const ids = Object.keys(selectedOptionMap);
        if (ids.length > 0) {
            const optionMap = {};
            options.forEach((opt)=>{
                optionMap[opt.id] = opt.value;
            });
            switch(type){
                case (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT:
                    ids.forEach((id)=>{
                        const option = store.get(id)?.getLinkedRecord('node');
                        const optionId = (0, $wufAv.JiraIssueFieldOptionAri).parse(selectedOptionMap[id]).optionId;
                        // set return value
                        if (!previousOptions[optionId]) previousOptions[optionId] = option?.getValue('value')?.toString() ?? '';
                        if (optionMap[optionId]) option?.setValue(optionMap[optionId], 'value');
                    });
                    break;
                case (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT:
                    ids.forEach((id)=>{
                        const option = store.get(id)?.getLinkedRecord('fieldOption');
                        const optionId = selectedOptionMap[id];
                        // set return value
                        if (!previousOptions[optionId]) previousOptions[optionId] = option?.getValue('value')?.toString() ?? '';
                        if (optionMap[optionId]) option?.setValue(optionMap[optionId], 'value');
                    });
                    break;
                default:
                    break;
            }
        }
    });
    return Object.keys(previousOptions).map((id)=>({
            id: id,
            value: previousOptions[id]
        }));
};
const $cf3d6c186dbc2f35$export$6b82cef47b481f3a = (environment, queryRef, fieldId, fieldSetId)=>{
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        const issues = $cf3d6c186dbc2f35$var$readIssuesData(queryRef);
        issues?.edges?.forEach((issue)=>{
            const fieldsets = issue?.fieldSets?.edges;
            fieldsets?.forEach((fieldSet)=>{
                const field = fieldSet?.node?.fields?.edges?.find((f)=>f?.node?.fieldId === fieldId);
                if (field) {
                    const id = fieldSet?.node?.__id ?? '';
                    const fieldSetToUpdate = store.get(id);
                    fieldSetToUpdate?.setValue(fieldSetId, 'fieldSetId');
                }
            });
        });
    });
};

});
parcelRegister("WSSft", function(module, exports) {

$parcel$export(module.exports, "default", () => $d40a3cc2b0922d38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<89d6b255850c3254e4c9e029fdce0750>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d40a3cc2b0922d38$var$node = {
    "kind": "InlineDataFragment",
    "name": "optimisticUpdatesSelectedOptionsQuery"
};
$d40a3cc2b0922d38$var$node.hash = "7bbbbfe99393a18f403346aba1304e20";
var $d40a3cc2b0922d38$export$2e2bcd8739ae039 = $d40a3cc2b0922d38$var$node;

});

parcelRegister("wufAv", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $061a7460522c266a$export$e3bc1ec22f941fbe);

var $4gJvn = parcelRequire("4gJvn");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issue-field-option/manifest.ts
var $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $4gJvn.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $4gJvn.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $061a7460522c266a$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("4gJvn", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $31bbf461f55c01f8$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $31bbf461f55c01f8$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $31bbf461f55c01f8$export$eb4f4cf0880fe5a8 = "jira", $31bbf461f55c01f8$export$4bec333360908e78 = "issue-field-option";

});




parcelRegister("cEWre", function(module, exports) {

$parcel$export(module.exports, "useIFCEditField", () => $0bd928140d605343$export$9e12f6c6c7e366bd);

var $eJOHy = parcelRequire("eJOHy");

var $fwzaq = parcelRequire("fwzaq");

var $pZqvR = parcelRequire("pZqvR");
const $0bd928140d605343$export$9e12f6c6c7e366bd = ()=>{
    const { ifcConfig: ifcConfig, optimisticUpdateField: optimisticUpdateField, replaceFieldSetInColumns: replaceFieldSetInColumns, optimisticDeleteField: optimisticDeleteField } = (0, $pZqvR.useIFCConfigContext)();
    const currentFieldSetId = (0, $eJOHy.useRef)();
    const currentField = (0, $eJOHy.useRef)(null);
    const isUpdateInProgress = (0, $eJOHy.useRef)();
    const onStartFieldUpdate = (0, $eJOHy.useCallback)((id, field)=>{
        isUpdateInProgress.current = true;
        const previousValue = optimisticUpdateField?.(id, field);
        // init the old value here
        if (currentField.current == null && previousValue) currentField.current = previousValue;
    }, [
        optimisticUpdateField
    ]);
    const [onDebouncedFieldUpdated] = (0, $fwzaq.default)((fieldId, field)=>{
        if (field?.collapsedName && currentFieldSetId.current && !isUpdateInProgress.current) {
            // skip saving fieldset config when there is no change in name
            if (field?.collapsedName !== currentFieldSetId.current) replaceFieldSetInColumns?.(currentFieldSetId.current, field.collapsedName, fieldId);
            currentFieldSetId.current = field?.collapsedName;
            // reset old value to null so it gets initialised on start update again
            currentField.current = null;
        }
    }, 1000);
    const onFieldUpdated = (0, $eJOHy.useCallback)((fieldId, field)=>{
        isUpdateInProgress.current = false;
        onDebouncedFieldUpdated(fieldId, field);
    }, [
        onDebouncedFieldUpdated
    ]);
    const onFieldUpdateError = (0, $eJOHy.useCallback)(()=>{
        if (currentField.current) {
            const { id: id, field: field } = currentField.current;
            optimisticUpdateField?.(id, field);
        }
    }, [
        optimisticUpdateField
    ]);
    const onFieldDeleted = (0, $eJOHy.useCallback)(()=>{
        if (currentFieldSetId.current) optimisticDeleteField?.(currentFieldSetId.current);
    }, [
        optimisticDeleteField
    ]);
    const onUpdate = (fieldId, fieldSetId)=>{
        currentFieldSetId.current = fieldSetId;
        ifcConfig?.onUpdate({
            fieldId: fieldId,
            onStartFieldUpdate: (field)=>onStartFieldUpdate(fieldId, field),
            onFieldUpdated: onFieldUpdated,
            onFieldDeleted: onFieldDeleted,
            onFieldUpdateError: onFieldUpdateError
        });
    };
    return onUpdate;
};

});
parcelRegister("fwzaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab2d121bc64be0a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
function $ab2d121bc64be0a3$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eJOHy.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eJOHy.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eJOHy.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});


parcelRegister("kompv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d0bca35a7562312$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3d0bca35a7562312$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createAnotherButton: {
        "id": "native-issue-table.inline-field-config-footer.create-another-button",
        "defaultMessage": "Create another"
    },
    contactAdmin: {
        "id": "native-issue-table.inline-field-config-footer.contact-admin-text",
        "defaultMessage": "<link>Contact your project admin</link> to make changes"
    },
    makeChangesInConfig: {
        "id": "native-issue-table.inline-field-config-footer.make-config-changes-text",
        "defaultMessage": "Make changes in <link>configurations</link>"
    },
    contactAdminGalaxia: {
        "id": "native-issue-table.inline-field-config-footer.contact-admin-text-galaxia",
        "defaultMessage": "<link>Contact your space admin</link> to make changes"
    }
});

});


parcelRegister("6sUnz", function(module, exports) {

$parcel$export(module.exports, "CustomComponentsProvider", () => $74efdbb095f380c6$export$e4fb02e50022594f);
$parcel$export(module.exports, "useCustomComponents", () => $74efdbb095f380c6$export$b0e9d19f717d0a5c);

var $eJOHy = parcelRequire("eJOHy");
const $74efdbb095f380c6$var$CustomComponentsContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $74efdbb095f380c6$export$e4fb02e50022594f = ({ children: children, components: components })=>{
    // Memoize individual components to avoid re-rendering if a new object with
    // the same values is passed in via NativeIssueTable’s components prop
    const timeline = (0, $eJOHy.useMemo)(()=>({
            Cell: components?.timeline?.Cell,
            ColumnHeader: components?.timeline?.ColumnHeader,
            ContextualItemMenu: components?.timeline?.ContextualItemMenu,
            InitializeVirtualizer: components?.timeline?.InitializeVirtualizer
        }), [
        components?.timeline?.Cell,
        components?.timeline?.ColumnHeader,
        components?.timeline?.ContextualItemMenu,
        components?.timeline?.InitializeVirtualizer
    ]);
    const columnPicker = (0, $eJOHy.useMemo)(()=>({
            Container: components?.columnPicker?.Container,
            EmptyState: components?.columnPicker?.EmptyState,
            Footer: components?.columnPicker?.Footer,
            Icon: components?.columnPicker?.Icon,
            PopupComponent: components?.columnPicker?.PopupComponent
        }), [
        components?.columnPicker?.Container,
        components?.columnPicker?.EmptyState,
        components?.columnPicker?.Footer,
        components?.columnPicker?.Icon,
        components?.columnPicker?.PopupComponent
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            ConnectionsSubscriber: components?.ConnectionsSubscriber,
            Footer: components?.Footer,
            IssueCount: components?.IssueCount,
            NoColumns: components?.NoColumns,
            NoIssues: components?.NoIssues,
            RowsAdditionalContent: components?.RowsAdditionalContent,
            ScrollContainer: components?.ScrollContainer,
            columnPicker: columnPicker,
            timeline: timeline
        }), [
        columnPicker,
        components?.ConnectionsSubscriber,
        components?.Footer,
        components?.IssueCount,
        components?.NoColumns,
        components?.NoIssues,
        components?.RowsAdditionalContent,
        components?.ScrollContainer,
        timeline
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74efdbb095f380c6$var$CustomComponentsContext.Provider, {
        value: value
    }, children);
};
const $74efdbb095f380c6$export$b0e9d19f717d0a5c = ()=>{
    const context = (0, $eJOHy.useContext)($74efdbb095f380c6$var$CustomComponentsContext);
    if (!context) throw new Error('useCustomComponents must be used within a CustomComponentsProvider');
    return context;
};

});

parcelRegister("91XFx", function(module, exports) {

$parcel$export(module.exports, "getMergedColumnConfig", () => $cad9621c000691ac$export$9fce51f35317a690);

var $eJOHy = parcelRequire("eJOHy");

var $j8Km1 = parcelRequire("j8Km1");

var $dmolI = parcelRequire("dmolI");

var $9vDhp = parcelRequire("9vDhp");
const $cad9621c000691ac$var$getColumnTitle = (mergedColumns, baseField, formatMessage)=>{
    if (mergedColumns.length === 0) return '';
    if (mergedColumns.length === 1 && baseField) return baseField.title;
    return formatMessage((0, $9vDhp.default).columnHeaderMergedColumn);
};
const $cad9621c000691ac$export$9fce51f35317a690 = (columns, isIssueHierarchyEnabled, formatMessage)=>{
    const filteredColumns = [];
    let mergedColumns = [];
    let issueKeyColumn = null;
    let issueTypeColumn = null;
    let summaryColumn = null;
    let isCheckboxColumnEnabled = false;
    // Filter out the issue key, issue type, and summary columns
    columns.forEach((column)=>{
        if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) issueKeyColumn = column;
        else if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE) issueTypeColumn = column;
        else if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) summaryColumn = column;
        else filteredColumns.push(column);
        if (column.id === (0, $j8Km1.COLUMN_ID_CHECKBOX)) isCheckboxColumnEnabled = true;
    });
    // Always preserve this order: issue type, key, summary
    mergedColumns = [
        issueTypeColumn,
        issueKeyColumn,
        summaryColumn
    ].filter(Boolean);
    // If there is no issue key, issue type, or summary column, we show only expand & child issue create icons
    const baseField = summaryColumn ?? issueKeyColumn ?? issueTypeColumn ?? null;
    // return original columns if hierarchy is OFF and merged fields are OFF
    if (!mergedColumns.length && !isIssueHierarchyEnabled) return columns;
    const columnConfig = baseField ?? (0, $dmolI.getColumnConfig)(formatMessage)[(0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN]();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const resizeColumnId = baseField ? baseField.id : undefined;
    const mergedColumn = {
        jqlTerm: '',
        aliases: [],
        fieldTypeDisplayName: '',
        ...columnConfig,
        id: (0, $j8Km1.COLUMN_ID_MERGED_COLUMN),
        type: (0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN,
        title: $cad9621c000691ac$var$getColumnTitle(mergedColumns, baseField, formatMessage),
        // only show quick sort icon if there is a single merged field enabled
        isSortable: mergedColumns.length < 2,
        mergedColumns: mergedColumns,
        resizeColumnId: resizeColumnId,
        customHeader: baseField ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    };
    // insert the merged column after the checkbox column if it exists
    const mergedColumnIndex = isCheckboxColumnEnabled ? 1 : 0;
    return [
        ...filteredColumns.slice(0, mergedColumnIndex),
        mergedColumn,
        ...filteredColumns.slice(mergedColumnIndex)
    ];
};

});
parcelRegister("9vDhp", function(module, exports) {

$parcel$export(module.exports, "default", () => $991d287fa52317bd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $991d287fa52317bd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    columnHeaderMergedColumn: {
        "id": "native-issue-table.common.utils.get-merged-column-config.column-header-merged-column",
        "defaultMessage": "Work"
    }
});

});


parcelRegister("sJrIm", function(module, exports) {

$parcel$export(module.exports, "SortChangeContextProvider", () => $9d128466cbfef453$export$61767aa5bd260064);
$parcel$export(module.exports, "useSortContext", () => $9d128466cbfef453$export$a3b9cb2711d4166);

var $eJOHy = parcelRequire("eJOHy");
const $9d128466cbfef453$var$SortChangeContext = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $9d128466cbfef453$export$61767aa5bd260064 = $9d128466cbfef453$var$SortChangeContext.Provider;
const $9d128466cbfef453$export$a3b9cb2711d4166 = ()=>{
    const context = (0, $eJOHy.useContext)($9d128466cbfef453$var$SortChangeContext);
    return context !== undefined ? context : {};
};

});

parcelRegister("28bHJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9581c7828277191b$export$2e2bcd8739ae039);

var $eyZIA = parcelRequire("eyZIA");

var $a1Lxb = parcelRequire("a1Lxb");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6XJko = parcelRequire("6XJko");

var $4ohGb = parcelRequire("4ohGb");

var $34oCh = parcelRequire("34oCh");

var $kzhHK = parcelRequire("kzhHK");

var $2AgH2 = parcelRequire("2AgH2");

var $jLqsN = parcelRequire("jLqsN");
/**
 * Render the table footer, composing together the default IssueCount and Pagination UI elements.
 */ const $9581c7828277191b$var$FooterRenderer = ({ Footer: Footer, IssueCount: IssueCount, issues: issues, rankField: rankField, onPageChange: onPageChange })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $a1Lxb.default), issues);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $eyZIA.default), rankField ?? null);
    const isIssueCreateEnabled = (0, $34oCh.useIsIssueCreateEnabled)();
    const isInfiniteScrollEnabled = (0, $34oCh.useIsInfiniteScrollEnabled)();
    // Use new Visual Refresh footer order if visual refresh or any m1 features are enabled to
    // simplfiy the number of cases we need to handle with the new features.
    // cleanup all isNewFooterOrderEnabled props with visual-refresh FG
    const isNewFooterOrderEnabled = (0, $6XJko.isVisualRefreshEnabled)() || isIssueCreateEnabled || isInfiniteScrollEnabled;
    let start;
    let center;
    let end;
    // Show pagination controls only when discrete pagination is enabled
    if (onPageChange && !isInfiniteScrollEnabled) {
        const paginationControls = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLqsN.PaginationControls), {
            issues: issueData,
            onPageChange: (after)=>onPageChange(after, false),
            isNewFooterOrderEnabled: isNewFooterOrderEnabled
        });
        if (isNewFooterOrderEnabled) center = paginationControls;
        else end = paginationControls;
    }
    // Show issue count when either pagination or infinite scroll are enabled
    if (onPageChange || isInfiniteScrollEnabled) {
        const issueCount = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kzhHK.default), {
            issues: issueData,
            IssueCount: IssueCount,
            isNewFooterOrderEnabled: isNewFooterOrderEnabled,
            isInfiniteScrollEnabled: isInfiniteScrollEnabled
        });
        if (isNewFooterOrderEnabled) end = issueCount;
        else center = issueCount;
    }
    const hasIssues = (issueData.totalIssueSearchResultCount ?? 0) > 0;
    const hasIssueConnectionControls = hasIssues && (!!onPageChange || isInfiniteScrollEnabled);
    const hasControlsToDisplay = hasIssueConnectionControls || isIssueCreateEnabled;
    // Hide the footer if we have no issues UNLESS the consumer has provided a custom footer component, in which case
    // the consumer becomes responsible for when the footer should be shown/hidden.
    if (!hasControlsToDisplay && !Footer) return null;
    const FooterToRender = Footer ?? (0, $4ohGb.Footer);
    if (isIssueCreateEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2AgH2.IssueCreateFooter), {
        Footer: FooterToRender,
        rankField: rankFieldData ?? null,
        start: start,
        center: center,
        end: end,
        issues: issueData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FooterToRender, {
        start: start,
        center: center,
        end: end
    });
};
var $9581c7828277191b$export$2e2bcd8739ae039 = $9581c7828277191b$var$FooterRenderer;

});
parcelRegister("eyZIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $67a2484cd7d95dcf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7929ed8faf1eaa7247c7d0c6b2ce94d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $67a2484cd7d95dcf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "footerRenderer_nativeIssueTable_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issueCreateFooter_nativeIssueTable_rankField"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$67a2484cd7d95dcf$var$node.hash = "51e407fb70a032eedb7750b35ea0492c";
var $67a2484cd7d95dcf$export$2e2bcd8739ae039 = $67a2484cd7d95dcf$var$node;

});

parcelRegister("a1Lxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba6e93d9276fcad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<55714f2c2460e374783c0b1feae590b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7ba6e93d9276fcad$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageSize"
        }
    ],
    "kind": "Fragment",
    "name": "footerRenderer_nativeIssueTable_issues",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_nativeIssueTable_IssueCountRenderer"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueCreateFooter_nativeIssueTable_issues"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                }
            ],
            "kind": "FragmentSpread",
            "name": "paginationControls_nativeIssueTable"
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        }
    ],
    "type": "JiraIssueConnection"
};
$7ba6e93d9276fcad$var$node.hash = "b33af498ce59c9940c71b520b1fb07ca";
var $7ba6e93d9276fcad$export$2e2bcd8739ae039 = $7ba6e93d9276fcad$var$node;

});

parcelRegister("4ohGb", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $74e7263cd9d59bbd$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7jTnu = parcelRequire("7jTnu");

var $kbYhH = parcelRequire("kbYhH");

var $7n9BS = parcelRequire("7n9BS");
const $74e7263cd9d59bbd$export$a06f1c675e846f6f = ({ start: start = $74e7263cd9d59bbd$var$SpacerElement, center: center = $74e7263cd9d59bbd$var$SpacerElement, end: end = $74e7263cd9d59bbd$var$SpacerElement })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterBase, null, start, center, end);
};
function $74e7263cd9d59bbd$var$FooterBase({ children: children }) {
    const tableHeight = (0, $kbYhH.useElementSizeSelector)((size)=>size.height);
    const hasShadow = (0, $7n9BS.useScrollStateSelector)((scrollState)=>{
        const { height: containerHeight, scrollTop: scrollTop } = scrollState;
        // Scroll measurements are fractional, while height measurements are integer, so we need to round before comparing
        return containerHeight < tableHeight && Math.round(scrollTop) < tableHeight - containerHeight;
    });
    return (0, $7jTnu.fg)('reduce_size_of_scroll_container_shadow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterWrapper, null, hasShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterShadow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterContainer, {
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: false
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterContainer, {
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: hasShadow
    }, children);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $74e7263cd9d59bbd$var$FooterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$FooterShadow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _4t3i1y44 _lcxvglyw _16qs9g9j",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$FooterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb _1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.hasShadow && "_16qsahas",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$export$d7a54cba636a8cd6, null);

});
parcelRegister("7n9BS", function(module, exports) {

$parcel$export(module.exports, "useScrollStateSelector", () => $fb5e49bfa6da600b$export$a2d79f83724ed591);
$parcel$export(module.exports, "useScrollElement", () => $fb5e49bfa6da600b$export$fae04c81b2201f65);
$parcel$export(module.exports, "ScrollStateProvider", () => $fb5e49bfa6da600b$export$9f9741e7dc6bdb9b);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $fb5e49bfa6da600b$export$50b6b7783d156e1b = 200;
const $fb5e49bfa6da600b$export$f9abcb6f103965a2 = (0, $6E16M.createContainer)();
const $fb5e49bfa6da600b$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $fb5e49bfa6da600b$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $fb5e49bfa6da600b$var$Store = (0, $GtRbT.createStore)({
    containedBy: $fb5e49bfa6da600b$export$f9abcb6f103965a2,
    initialState: $fb5e49bfa6da600b$var$INITIAL_SCROLL_STATE,
    name: 'ScrollStateManager',
    actions: $fb5e49bfa6da600b$var$actions
});
const $fb5e49bfa6da600b$var$useScrollStateActions = (0, $iJq0l.createActionsHook)($fb5e49bfa6da600b$var$Store);
const $fb5e49bfa6da600b$export$a2d79f83724ed591 = (0, $iJq0l.createStateHook)($fb5e49bfa6da600b$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $fb5e49bfa6da600b$export$fae04c81b2201f65 = (0, $iJq0l.createStateHook)($fb5e49bfa6da600b$var$Store, {
    selector: (state)=>state.scrollElement
});
const $fb5e49bfa6da600b$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $fb5e49bfa6da600b$var$useElementScrollState = (scrollRef)=>{
    const { update: update } = $fb5e49bfa6da600b$var$useScrollStateActions();
    (0, $eJOHy.useEffect)(()=>{
        const targetEl = scrollRef.current;
        // The element should always exists as the useEffect triggers after the reference is assigned.
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            update({
                scrollWidth: targetEl.scrollWidth,
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollWidth: targetEl.scrollWidth,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $fb5e49bfa6da600b$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            update({
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                height: targetEl.clientHeight,
                width: targetEl.clientWidth,
                scrollHeight: targetEl.scrollHeight,
                scrollWidth: targetEl.scrollWidth,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $fb5e49bfa6da600b$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $fb5e49bfa6da600b$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        update({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef,
        update
    ]);
};
const $fb5e49bfa6da600b$var$ScrollStateProviderInner = ({ scrollRef: scrollRef, children: children })=>{
    $fb5e49bfa6da600b$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $fb5e49bfa6da600b$export$9f9741e7dc6bdb9b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb5e49bfa6da600b$export$f9abcb6f103965a2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb5e49bfa6da600b$var$ScrollStateProviderInner, props));
};

});


parcelRegister("kzhHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c631d51c68fc26e$export$2e2bcd8739ae039);

var $6rtFN = parcelRequire("6rtFN");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2bNYj = parcelRequire("2bNYj");
const $4c631d51c68fc26e$var$IssueCountRenderer = ({ issues: issues, IssueCount: IssueCount = (0, $2bNYj.IssueCount), isNewFooterOrderEnabled: isNewFooterOrderEnabled, isInfiniteScrollEnabled: isInfiniteScrollEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $6rtFN.default), issues);
    const startIssueRange = data.issueNavigatorPageInfo?.firstIssuePosition ?? 0;
    const endIssueRange = data.issueNavigatorPageInfo?.lastIssuePosition ?? 0;
    const loadedIssuesCount = data.edges?.length ?? 0;
    const total = data.totalIssueSearchResultCount ?? 0;
    const countExceedsMaxResults = !!data.isCappingIssueSearchResult;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueCount, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        loadedIssuesCount: loadedIssuesCount,
        total: total,
        countExceedsMaxResults: countExceedsMaxResults,
        isNewFooterOrderEnabled: isNewFooterOrderEnabled,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled
    });
};
var $4c631d51c68fc26e$export$2e2bcd8739ae039 = $4c631d51c68fc26e$var$IssueCountRenderer;

});
parcelRegister("6rtFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6bf44cdf4a9e0f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<58136de7036b95adc6365cb31a2bfcea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a6bf44cdf4a9e0f0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_nativeIssueTable_IssueCountRenderer",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "concreteType": "JiraIssueNavigatorPageInfo",
            "kind": "LinkedField",
            "name": "issueNavigatorPageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "firstIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssuePosition"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$a6bf44cdf4a9e0f0$var$node.hash = "26c8c81744afeed511fc1eca25e62e4d";
var $a6bf44cdf4a9e0f0$export$2e2bcd8739ae039 = $a6bf44cdf4a9e0f0$var$node;

});

parcelRegister("2bNYj", function(module, exports) {

$parcel$export(module.exports, "IssueCount", () => $efade5dddaf06e66$export$542fba90cc9c1bd1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $iIICj = parcelRequire("iIICj");
const $efade5dddaf06e66$export$542fba90cc9c1bd1 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, loadedIssuesCount: loadedIssuesCount, total: total, countExceedsMaxResults: countExceedsMaxResults, isNewFooterOrderEnabled: isNewFooterOrderEnabled, isInfiniteScrollEnabled: isInfiniteScrollEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const totalNumberIssues = countExceedsMaxResults ? `${total}+` : total;
    const isTotalUnknown = total <= 0;
    if (isInfiniteScrollEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efade5dddaf06e66$var$IssueCountContainer, {
        "data-testid": "native-issue-table.ui.footer-renderer.issue-count-renderer.issue-count.issue-count",
        isFlexEnd: true
    }, isTotalUnknown ? String(loadedIssuesCount) : formatMessage((0, $iIICj.default).loadedIssuesTotalKnown, {
        loadedIssuesCount: loadedIssuesCount,
        totalNumberIssues: totalNumberIssues
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efade5dddaf06e66$var$IssueCountContainer, {
        "data-testid": "native-issue-table.ui.footer-renderer.issue-count-renderer.issue-count.issue-count",
        isFlexEnd: isNewFooterOrderEnabled
    }, isTotalUnknown ? formatMessage((0, $iIICj.default).issueRangeUnknown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange
    }) : formatMessage((0, $iIICj.default).issueRangeKnown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        totalNumberIssues: totalNumberIssues
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efade5dddaf06e66$var$IssueCountContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexEnd: isFlexEnd, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _k48p1pd9",
            __cmplp.isFlexEnd ? "_1bahesu3" : "_1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iIICj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfb9f623cbed4390$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bfb9f623cbed4390$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadedIssuesTotalKnown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.loaded-issues-total-known",
        "defaultMessage": "{loadedIssuesCount} of {totalNumberIssues}"
    },
    issueRangeKnown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});

});



parcelRegister("2AgH2", function(module, exports) {

$parcel$export(module.exports, "IssueCreateFooter", () => $7a7430e316d021c2$export$e3ef2bbdafbe53d8);

var $br8iE = parcelRequire("br8iE");

var $dtM9e = parcelRequire("dtM9e");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $68iTT = parcelRequire("68iTT");

var $6xIZT = parcelRequire("6xIZT");

var $1cMAs = parcelRequire("1cMAs");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $4ohGb = parcelRequire("4ohGb");

var $34oCh = parcelRequire("34oCh");

var $3F6xT = parcelRequire("3F6xT");

var $iC2St = parcelRequire("iC2St");
const $7a7430e316d021c2$var$FormWithInsertionPoint = ({ connectionId: connectionId, rankFieldId: rankFieldId, rankFieldTerms: rankFieldTerms, ...props })=>{
    const insertionPoint = (0, $3F6xT.useCalculateIssueInsertionPoint)();
    let jql;
    if ((0, $epTsa.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    jql = (0, $34oCh.useJql)();
    const handleIssueCreate = (0, $iC2St.useIssueCreateMutation)({
        issueConnectionId: connectionId,
        jql: jql,
        ...(0, $7jTnu.fg)('jsc_list_reranking_gate') && {
            rankFieldTerms: rankFieldTerms
        }
    });
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const formContextualFields = (0, $eJOHy.useMemo)(()=>{
        if (!isIssueRankingEnabled || !(0, $7jTnu.fg)('jsc_list_reranking_gate')) return undefined;
        if (isIssueRankDescending) return insertionPoint?.position === 'below' ? {
            rankBeforeIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        } : {
            rankAfterIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        };
        return insertionPoint?.position === 'below' ? {
            rankAfterIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        } : {
            rankBeforeIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        };
    }, [
        insertionPoint?.issueId,
        insertionPoint?.position,
        isIssueRankDescending,
        isIssueRankingEnabled,
        rankFieldId
    ]);
    const handleIssueCreateWithInsertionPoint = (0, $eJOHy.useCallback)((issueToCreate, contextualFields)=>{
        if (insertionPoint == null) return handleIssueCreate(issueToCreate, contextualFields);
        return handleIssueCreate(issueToCreate, contextualFields, {
            insertAfter: insertionPoint.position === 'below',
            insertNodeId: insertionPoint.issueId
        });
    }, [
        handleIssueCreate,
        insertionPoint
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7a7430e316d021c2$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        ...props,
        onCreateIssue: handleIssueCreateWithInsertionPoint,
        rankFieldId: rankFieldId,
        contextualFields: formContextualFields
    }));
};
const $7a7430e316d021c2$export$e3ef2bbdafbe53d8 = ({ Footer: Footer = (0, $4ohGb.Footer), issues: issues, rankField: rankField, ...footerProps })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $dtM9e.default), issues);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $br8iE.default), rankField ?? null);
    const projectContext = (0, $34oCh.useProjectContext)();
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $68iTT.useInlineCreateHandlers)({
        projectKey: projectContext,
        minHierarchyLevel: 0
    });
    const rankFieldTerms = (0, $eJOHy.useMemo)(()=>({
            jqlTerm: rankFieldData?.jqlTerm ?? null,
            aliases: rankFieldData?.aliases ? Array.from(rankFieldData.aliases) : null
        }), [
        rankFieldData
    ]);
    if (isFormVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7a7430e316d021c2$var$FormWithInsertionPoint, {
        connectionId: issueData?.__id,
        rankFieldId: rankFieldData?.fieldId ?? null,
        rankFieldTerms: rankFieldTerms,
        ...formProps,
        appearance: "footer",
        depth: 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Footer, {
        ...footerProps,
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $7a7430e316d021c2$var$triggerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cMAs.default), triggerProps))
    });
};
const $7a7430e316d021c2$var$BORDER_WIDTH = '1px';
const $7a7430e316d021c2$var$formContainerStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface',
    boxShadow: 'elevation.shadow.overflow',
    borderTopWidth: $7a7430e316d021c2$var$BORDER_WIDTH,
    borderTopStyle: 'solid',
    borderTopColor: 'color.border'
});
const $7a7430e316d021c2$var$triggerContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    minHeight: '32px'
});

});
parcelRegister("br8iE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1688bfc8bebe69$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74fba5047c16456a196b2566b6b91538>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c1688bfc8bebe69$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "issueCreateFooter_nativeIssueTable_rankField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "jqlTerm"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "aliases"
                }
            ]
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$6c1688bfc8bebe69$var$node.hash = "ab411698c10f2e181c128d1a6656afb1";
var $6c1688bfc8bebe69$export$2e2bcd8739ae039 = $6c1688bfc8bebe69$var$node;

});

parcelRegister("dtM9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af899077fdf843$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ee98c0ce34f33e3c4f3543efa8bedf8b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $76af899077fdf843$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueCreateFooter_nativeIssueTable_issues",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$76af899077fdf843$var$node.hash = "80e50d59b31e5c90016c84b106f12ad2";
var $76af899077fdf843$export$2e2bcd8739ae039 = $76af899077fdf843$var$node;

});

parcelRegister("68iTT", function(module, exports) {

$parcel$export(module.exports, "useInlineCreateHandlers", () => $f2e349346c4eb6b1$export$bec6eb88acc84895);

var $eJOHy = parcelRequire("eJOHy");

var $ciFJV = parcelRequire("ciFJV");

var $jd93d = parcelRequire("jd93d");

var $7jTnu = parcelRequire("7jTnu");

var $6xIZT = parcelRequire("6xIZT");

var $1Ob2L = parcelRequire("1Ob2L");

var $1cMAs = parcelRequire("1cMAs");
const $f2e349346c4eb6b1$export$bec6eb88acc84895 = ({ projectKey: projectKey, defaultAssigneeId: defaultAssigneeId, minHierarchyLevel: minHierarchyLevel, maxHierarchyLevel: maxHierarchyLevel })=>{
    const [isFormVisible, setIsFormVisible] = (0, $eJOHy.useState)(false);
    const formIssueDraftRef = (0, $eJOHy.useRef)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $1Ob2L.useInlineIssueCreateEntryPoint)(projectKey, minHierarchyLevel, maxHierarchyLevel);
    const ref = (0, $eJOHy.useRef)(null);
    const buttonRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    const merged = (0, $jd93d.default)(ref, buttonRef);
    const handleTriggerClick = (0, $eJOHy.useCallback)(()=>{
        setIsFormVisible(true);
    }, []);
    const handleFormCancel = (0, $eJOHy.useCallback)(()=>{
        setIsFormVisible(false);
        ref.current?.focus();
    }, []);
    const onDraftUpdate = (0, $eJOHy.useCallback)((issueDraft)=>{
        formIssueDraftRef.current = issueDraft;
    }, []);
    if ((0, $7jTnu.fg)('jira_render_pic_in_nin')) {
        const { entryPointActions: additionalFieldsEntryPointActions, entryPointReferenceSubject: additionalFieldsEntryPointSubject } = (0, $1Ob2L.useInlineIssueCreateAdditionalFieldsEntryPoint)({
            projectKey: projectKey,
            defaultAssigneeId: defaultAssigneeId
        });
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const additionalFieldsRef = (0, $ciFJV.useEntryPointButtonTrigger)(additionalFieldsEntryPointActions);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const mergedRefWithAdditionalFields = (0, $jd93d.default)(ref, buttonRef, additionalFieldsRef);
        return {
            isFormVisible: isFormVisible,
            entryPointActions: entryPointActions,
            additionalFieldsEntryPointActions: additionalFieldsEntryPointActions,
            formProps: {
                initialIssueDraft: formIssueDraftRef.current,
                onDraftUpdate: onDraftUpdate,
                onCancel: handleFormCancel,
                entryPointSubject: entryPointReferenceSubject,
                additionalFieldsEntryPointSubject: additionalFieldsEntryPointSubject
            },
            triggerProps: {
                onClick: handleTriggerClick,
                ref: mergedRefWithAdditionalFields
            }
        };
    }
    return {
        isFormVisible: isFormVisible,
        entryPointActions: entryPointActions,
        formProps: {
            initialIssueDraft: formIssueDraftRef.current,
            onDraftUpdate: onDraftUpdate,
            onCancel: handleFormCancel,
            entryPointSubject: entryPointReferenceSubject
        },
        triggerProps: {
            onClick: handleTriggerClick,
            ref: merged
        }
    };
};
const $f2e349346c4eb6b1$var$InlineCreate = ({ projectKey: projectKey, minHierarchyLevel: minHierarchyLevel, ...formProps })=>{
    const { isFormVisible: isFormVisible, formProps: formPropsAdditional, triggerProps: triggerProps } = $f2e349346c4eb6b1$export$bec6eb88acc84895({
        projectKey: projectKey,
        minHierarchyLevel: minHierarchyLevel
    });
    return isFormVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        ...formProps,
        ...formPropsAdditional
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cMAs.default), triggerProps);
};
var $f2e349346c4eb6b1$export$2e2bcd8739ae039 = $f2e349346c4eb6b1$var$InlineCreate;

});
parcelRegister("6xIZT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6479a1a8f48bc6cf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $cBavF = parcelRequire("cBavF");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $j8Km1 = parcelRequire("j8Km1");

var $epTsa = parcelRequire("epTsa");


var $gBHpC = parcelRequire("gBHpC");

var $fh8ae = parcelRequire("fh8ae");

var $eNuUB = parcelRequire("eNuUB");

var $ab4Fp = parcelRequire("ab4Fp");

const $6479a1a8f48bc6cf$var$ICON_WIDTH = 24;
const $6479a1a8f48bc6cf$var$PADDING = 8;
const $6479a1a8f48bc6cf$var$HIERARCHY_LEVEL_PADDING = 12;
const $6479a1a8f48bc6cf$export$35cad9398ceaeef0 = ()=>{
    const isReadyRef = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        setTimeout(()=>{
            isReadyRef.current = true;
        }, 100);
    }, []);
    return isReadyRef;
};
const $6479a1a8f48bc6cf$var$isComposing = (event)=>event.nativeEvent.isComposing;
const $6479a1a8f48bc6cf$export$848553d86b9bee59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fh8ae.IssueTypeDropdown), {
        project: null,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onProjectChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        selectedType: null
    });
const $6479a1a8f48bc6cf$var$calledFromSource = 'issueTable';
const $6479a1a8f48bc6cf$var$InlineCreateForm = ({ initialIssueDraft: initialIssueDraft, onDraftUpdate: onDraftUpdate, onCreateIssue: onCreateIssue, onCancel: onCancel, entryPointSubject: entryPointSubject, appearance: appearance = 'row', depth: depth = 0, columns: columns, isGrouping: isGrouping, additionalFieldsEntryPointSubject: additionalFieldsEntryPointSubject, location: location })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [textContent, setTextContent] = (0, $eJOHy.useState)(initialIssueDraft?.summary ?? '');
    const [selectedType, setSelectedType] = (0, $eJOHy.useState)(initialIssueDraft?.issueType ?? null);
    const [selectedProject, setSelectedProject] = (0, $eJOHy.useState)(initialIssueDraft?.project ?? null); // assignee would be undefined initially, when user selects unassigned user from picker then it will be null
    // Default assignee is fetched from the entrypoint
    const [assignee, setAssignee] = (0, $eJOHy.useState)(undefined);
    const [dueDate, setDueDate] = (0, $eJOHy.useState)(null);
    const [isUpdatingAdditionalFields, setIsUpdatingAdditionalFields] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        onDraftUpdate?.({
            summary: textContent,
            project: selectedProject ?? undefined,
            issueType: selectedType ?? undefined,
            ...assignee && (0, $7jTnu.fg)('jira_render_pic_in_nin') ? {
                assignee: {
                    accountId: assignee.accountId ?? '',
                    name: assignee.displayName,
                    picture: assignee.avatarUrls['48x48'] ?? ''
                }
            } : {},
            ...dueDate != null && (0, $7jTnu.fg)('jira_render_pic_in_nin') ? {
                dueDate: dueDate
            } : {}
        });
    }, [
        onDraftUpdate,
        selectedProject,
        selectedType,
        textContent,
        assignee,
        dueDate
    ]);
    const formRef = (0, $eJOHy.useRef)(null);
    const isEmptyRef = (0, $eJOHy.useRef)(true);
    const textAreaRef = (0, $eJOHy.useRef)(null);
    isEmptyRef.current = textContent.trim().length === 0;
    const contextualFields = (0, $gBHpC.useIssueCreateContextualFields)(); // prevent blurring from occurring when the form is first rendered
    const isReadyRef = $6479a1a8f48bc6cf$export$35cad9398ceaeef0();
    const handleCreateIssue = (0, $eJOHy.useCallback)(()=>{
        if (!isEmptyRef.current && selectedType && selectedProject) {
            onCreateIssue({
                summary: textContent,
                project: selectedProject,
                issueType: selectedType,
                ...assignee && (0, $7jTnu.fg)('jira_render_pic_in_nin') ? {
                    assignee: {
                        accountId: assignee.accountId ?? '',
                        name: assignee.displayName ?? '',
                        picture: assignee.avatarUrls['48x48'] ?? ''
                    }
                } : {},
                ...dueDate != null && (0, $7jTnu.fg)('jira_render_pic_in_nin') ? {
                    dueDate: dueDate
                } : {}
            }, contextualFields);
            setTextContent('');
            setAssignee(undefined);
            setDueDate(null);
        }
    }, [
        contextualFields,
        onCreateIssue,
        selectedProject,
        selectedType,
        textContent,
        assignee,
        dueDate
    ]);
    const handleCreateIssueRef = (0, $eJOHy.useRef)(handleCreateIssue);
    handleCreateIssueRef.current = handleCreateIssue;
    const handleBlur = (0, $eJOHy.useCallback)((event)=>{
        if (!isReadyRef.current) return;
         // make sure to make a local copy of the isEmptyRef value before it gets reset by the create handler
        const formEmpty = isEmptyRef.current; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inForm = formRef.current?.contains(event.target) ?? false;
        if (!inForm) {
            onCancel?.();
            if ((0, $7jTnu.fg)('jsc_list_reranking_fixes')) event.stopPropagation();
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                formEmpty: formEmpty,
                escapeKeyPressed: false
            });
        }
    }, [
        isReadyRef,
        onCancel,
        createAnalyticsEvent
    ]);
    const handleChange = (0, $eJOHy.useCallback)((e)=>{
        const content = e.target.value.replace(/[\n\r]+/g, ' ');
        setTextContent(content);
    }, []);
    const handleKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (e.key === 'Enter' && !$6479a1a8f48bc6cf$var$isComposing(e)) {
            e.preventDefault();
            handleCreateIssue();
        }
    }, [
        handleCreateIssue
    ]);
    const handleFormKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (!isUpdatingAdditionalFields || !(0, $7jTnu.fg)('jira_render_pic_in_nin')) e.stopPropagation();
    }, [
        isUpdatingAdditionalFields
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        handleCreateIssue();
    }, [
        handleCreateIssue
    ]);
    const handleCreateButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit');
    }, [
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // on mount, we want to move the cursor to the end of the input
        // TODO; Add test for this feature once we support pre-population of the summary
        textAreaRef.current?.setSelectionRange(textAreaRef.current.value.length, textAreaRef.current.value.length);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'form focused', 'inlineCreate', {
            location: location
        });
    }, [
        createAnalyticsEvent,
        location
    ]);
    const handleEscape = (0, $eJOHy.useCallback)((e)=>{
        const isAdditionalFieldsPickersActive = isUpdatingAdditionalFields && (0, $7jTnu.fg)('jira_render_pic_in_nin');
        if (!isAdditionalFieldsPickersActive) {
            e.stopPropagation();
            if (e.key === 'Escape') {
                onCancel?.();
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                    formEmpty: isEmptyRef.current,
                    escapeKeyPressed: true
                });
            }
        }
        if (e.key === 'Enter') {
            if ((0, $7jTnu.fg)('jira_render_pic_in_nin')) {
                if (e.target === textAreaRef.current) {
                    e.preventDefault();
                    handleCreateIssue();
                }
            } else {
                e.preventDefault();
                handleCreateIssue();
            }
        }
    }, [
        createAnalyticsEvent,
        handleCreateIssue,
        onCancel,
        isUpdatingAdditionalFields,
        textAreaRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!false) {
            document.addEventListener('click', handleBlur, true);
            document.addEventListener('keydown', handleEscape, true);
            if ((0, $7jTnu.fg)('jsc_list_reranking_fixes')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            document.addEventListener('dragstart', handleBlur, true);
            return ()=>{
                document.removeEventListener('click', handleBlur, true);
                document.removeEventListener('keydown', handleEscape, true);
                if ((0, $7jTnu.fg)('jsc_list_reranking_fixes')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('dragstart', handleBlur, true);
            };
        }
    }, [
        handleBlur,
        handleEscape
    ]);
    const padding = (0, $7jTnu.fg)('jira_list_merged_column_gate') ? $6479a1a8f48bc6cf$var$HIERARCHY_LEVEL_PADDING : $6479a1a8f48bc6cf$var$PADDING;
    let paddingLeft = depth > 1 ? (depth - 1) * $6479a1a8f48bc6cf$var$ICON_WIDTH + padding : padding;
    const mergedColumn = (0, $7jTnu.fg)('jira_list_merged_column_gate') ? columns?.find(({ id: id })=>id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) : undefined;
    if (mergedColumn && !isGrouping) {
        const checkboxColumnWidth = columns?.find(({ id: id })=>id === (0, $j8Km1.COLUMN_ID_CHECKBOX))?.defaultWidth ?? 0;
        const hasMergedFields = Number(mergedColumn.mergedColumns?.length) > 0;
        paddingLeft += (hasMergedFields ? $6479a1a8f48bc6cf$var$ICON_WIDTH : 0) + checkboxColumnWidth - $6479a1a8f48bc6cf$var$PADDING * depth;
    }
    const shouldShowAdditionalFields = (0, $eJOHy.useCallback)(()=>(0, $epTsa.expVal)('jira_powerful_inline_create_for_nin', 'isEnabled', false), []);
    return(// TODO: Check if we can catch the escape in a different level that removes below lint rule
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$var$FullContent, {
        ref: formRef,
        onKeyDown: handleFormKeyDown,
        onSubmit: handleSubmit,
        appearance: appearance,
        paddingLeft: paddingLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointSubject,
        id: "async-issue-create-issue-type-dropdown",
        packageName: (0, $23b4218cfd94fe9f$export$b8b9d90f9e5bd72b),
        teamName: (0, $23b4218cfd94fe9f$export$d57b6b390e78d90f),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$export$848553d86b9bee59, null),
        runtimeProps: {
            onChange: setSelectedType,
            onProjectChange: setSelectedProject,
            selectedType: selectedType
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6479a1a8f48bc6cf$var$TextAreaStyles,
        as: "textarea",
        autoFocus: true,
        "aria-label": formatMessage((0, $eNuUB.default).placeholderText),
        placeholder: formatMessage((0, $eNuUB.default).placeholderText),
        value: textContent,
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        ref: textAreaRef
    }), additionalFieldsEntryPointSubject != null && selectedProject?.key && (0, $7jTnu.fg)('jira_render_pic_in_nin') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: additionalFieldsEntryPointSubject,
        id: "async-inline-create-additional-fields",
        packageName: "async-inline-create-additional-fields",
        teamName: "jira-werewolves",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            projectKey: selectedProject?.key,
            fullWidth: false,
            isCompactDueDatePicker: true,
            shouldRenderToParent: true,
            shouldShowNameLabel: false,
            strategy: 'fixed',
            onAssigneeUpdate: setAssignee,
            defaultAssignee: assignee,
            defaultDueDate: dueDate,
            onDateSelected: setDueDate,
            shouldShowAdditionalFields: shouldShowAdditionalFields,
            source: $6479a1a8f48bc6cf$var$calledFromSource,
            onUpdatingAssigneePicker: setIsUpdatingAdditionalFields,
            onUpdatingDueDatePicker: setIsUpdatingAdditionalFields,
            issueTypeId: selectedType?.issueTypeId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center",
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$var$StyledCreateButton, {
        appearance: "primary",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ab4Fp.default), null),
        isDisabled: isEmptyRef.current,
        spacing: "compact",
        type: "submit",
        onClick: handleCreateButtonClick
    }, formatMessage((0, $eNuUB.default).createButton)))));
};
const $6479a1a8f48bc6cf$var$InlineCreateFormWithContainer = ({ contextualFields: contextualFields, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "issue-table-inline-issue-create"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gBHpC.IssueCreateContextualFieldsData), {
        payload: contextualFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$var$InlineCreateForm, props)));
var $6479a1a8f48bc6cf$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eJOHy.memo)($6479a1a8f48bc6cf$var$InlineCreateFormWithContainer);
const $6479a1a8f48bc6cf$var$FullContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { paddingLeft: paddingLeft, appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_to5f02": (0, $awdRS.default)(`${__cmplp.paddingLeft}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _v56416gf _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _bfhkvuon _16qs1yp9 _vchhusvi _1tke1ylp _2lx2vrvc _4cvr1h6o _4t3i1ylp _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvedk6",
            __cmplp.appearance === 'footer' ? "_mrkbpd34 _1o0zpd34" : "_2rkoiti9",
            __cmplp.className
        ])
    });
});
const $6479a1a8f48bc6cf$var$TextAreaStyles = (0, $1DXK0.xcss)({
    flex: '1',
    border: 'none',
    outline: 'none',
    margin: '0',
    padding: 'space.050',
    height: '20px',
    resize: 'none',
    backgroundColor: 'elevation.surface',
    color: 'color.text',
    font: 'font.body',
    scrollbarWidth: 'none',
    whiteSpace: 'pre',
    boxSizing: 'content-box',
    fontFamily: 'inherit'
}); // TODO: Maybe we can rewrite to pressable....
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6479a1a8f48bc6cf$var$StyledCreateButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
const $23b4218cfd94fe9f$export$b8b9d90f9e5bd72b = 'jiraIssueTableInlineIssueCreate';
const $23b4218cfd94fe9f$export$d57b6b390e78d90f = 'empanada';
const $23b4218cfd94fe9f$export$e77c67bc8157f49 = 'jsc_onboarding_inline_create';
const $23b4218cfd94fe9f$export$c7e6a6b283196232 = '/gateway/api';

parcelRegister("gBHpC", function(module, exports) {

$parcel$export(module.exports, "IssueCreateContextualFieldsData", () => $ebc2e159f3e0305c$export$a4ac6f56634f61f4);
$parcel$export(module.exports, "useIssueCreateContextualFields", () => $ebc2e159f3e0305c$export$6bb8d4e3be0700f9);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $ebc2e159f3e0305c$var$initialState = {};
const $ebc2e159f3e0305c$var$Store = (0, $GtRbT.createStore)({
    initialState: $ebc2e159f3e0305c$var$initialState,
    actions: {}
});
const $ebc2e159f3e0305c$var$updateStore = ()=>({ setState: setState }, { payload: payload })=>setState(payload);
const $ebc2e159f3e0305c$var$Container = (0, $6E16M.createContainer)($ebc2e159f3e0305c$var$Store, {
    onInit: $ebc2e159f3e0305c$var$updateStore,
    onUpdate: $ebc2e159f3e0305c$var$updateStore
});
const $ebc2e159f3e0305c$export$a4ac6f56634f61f4 = ({ children: children, payload: payload })=>{
    const ancestorPayload = $ebc2e159f3e0305c$export$6bb8d4e3be0700f9();
    const nextPayload = (0, $eJOHy.useMemo)(()=>({
            ...ancestorPayload,
            ...payload
        }), [
        ancestorPayload,
        payload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ebc2e159f3e0305c$var$Container, {
        payload: nextPayload
    }, children);
};
const $ebc2e159f3e0305c$export$6bb8d4e3be0700f9 = (0, $iJq0l.createStateHook)($ebc2e159f3e0305c$var$Store);

});

parcelRegister("fh8ae", function(module, exports) {

$parcel$export(module.exports, "IssueTypeDropdown", () => $46aa89e2d718a4b7$export$16aea7aa4bac227f);
$parcel$export(module.exports, "IssueTypeDropdownEntryPoint", () => $46aa89e2d718a4b7$export$7b1e666ab7e366e1);

var $2Akpc = parcelRequire("2Akpc");

var $jLSkj = parcelRequire("jLSkj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $c24ZZ = parcelRequire("c24ZZ");

var $dIK9p = parcelRequire("dIK9p");

var $7jTnu = parcelRequire("7jTnu");

var $aB2Z6 = parcelRequire("aB2Z6");

var $l4kLF = parcelRequire("l4kLF");
const $46aa89e2d718a4b7$var$createIssueTypeOption = (id, name, avatar)=>({
        label: name,
        value: id,
        avatar: {
            small: avatar
        }
    });
const $46aa89e2d718a4b7$var$createIssueType = (id, issueTypeId, name, avatar, hierarchyLevel)=>({
        id: id,
        issueTypeId: issueTypeId,
        name: name,
        avatar: {
            small: avatar
        },
        ...typeof hierarchyLevel === 'number' ? {
            hierarchy: {
                level: hierarchyLevel
            }
        } : {}
    });
const $46aa89e2d718a4b7$var$placeholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
    size: "medium"
});
const $46aa89e2d718a4b7$export$16aea7aa4bac227f = ({ onChange: onChange, onProjectChange: onProjectChange, project: project, selectedType: selectedType })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isPristine = (0, $eJOHy.useRef)(true);
    // TODO; JSC-36  We need to integrate hierarchy level filter once JSC-59 is implemented
    const { data: data, refetch: refetch } = (0, $j4oe4.usePaginationFragment)((0, $jLSkj.default), project);
    const [defaultIssueTypeId, { setDefaultIssueType: setDefaultIssueType }] = (0, $aB2Z6.useDefaultIssueType)(data?.key ?? null);
    const selectedTypeOption = (0, $eJOHy.useMemo)(()=>{
        if (selectedType == null) return null;
        return $46aa89e2d718a4b7$var$createIssueTypeOption(selectedType.id, selectedType.name, selectedType.avatar?.small);
    }, [
        selectedType
    ]);
    const handleGetRefetchVariables = (0, $eJOHy.useCallback)(()=>({
            id: data?.id || ''
        }), [
        data?.id
    ]);
    const handleIssueTypeChange = (0, $eJOHy.useCallback)((typeOption)=>{
        let newIssueType = null;
        if (typeOption != null) {
            const issueType = (data?.issueTypes?.edges || []).find((edge)=>edge?.node?.id === typeOption.value);
            if (issueType?.node != null && issueType.node.issueTypeId != null) newIssueType = $46aa89e2d718a4b7$var$createIssueType(issueType.node.id, issueType.node.issueTypeId, issueType.node.name, issueType.node.avatar?.small, issueType.node.hierarchy?.level);
        }
        isPristine.current = false;
        onChange(newIssueType);
        if (newIssueType?.issueTypeId) setDefaultIssueType(data?.key ?? null, newIssueType?.issueTypeId);
    }, [
        data?.issueTypes?.edges,
        data?.key,
        onChange,
        setDefaultIssueType
    ]);
    // Initialize with the first default issue
    (0, $eJOHy.useEffect)(()=>{
        if (isPristine.current) {
            const defaultIssueTypeEdge = (data?.issueTypes?.edges || []).find((edge)=>edge?.node?.issueTypeId === defaultIssueTypeId);
            if (defaultIssueTypeEdge?.node != null && defaultIssueTypeEdge.node.issueTypeId != null) // Return default issue type if exists
            return onChange($46aa89e2d718a4b7$var$createIssueType(defaultIssueTypeEdge.node.id, defaultIssueTypeEdge.node.issueTypeId, defaultIssueTypeEdge.node.name, defaultIssueTypeEdge.node.avatar?.small, defaultIssueTypeEdge.node.hierarchy?.level));
            const firstIssue = data?.issueTypes?.edges?.[0];
            if (firstIssue?.node != null && firstIssue.node.issueTypeId != null) // Return first issue type in the connection
            return onChange($46aa89e2d718a4b7$var$createIssueType(firstIssue.node.id, firstIssue.node.issueTypeId, firstIssue.node.name, firstIssue.node.avatar?.small, firstIssue.node.hierarchy?.level));
        }
    }, [
        data?.issueTypes?.edges,
        defaultIssueTypeId,
        onChange
    ]);
    const prevProjectKey = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (data?.id != null && prevProjectKey.current !== data?.id && data.projectId != null) {
            onProjectChange({
                id: data.id,
                projectId: data.projectId,
                key: data.key,
                name: data.name,
                avatar: data.avatar ? {
                    large: data.avatar.large
                } : null
            });
            prevProjectKey.current = data?.id;
        }
    }, [
        data?.avatar,
        data?.id,
        data?.key,
        data?.name,
        data?.projectId,
        onProjectChange
    ]);
    // TODO: JSC-71 We need to updated below component styles to adapt more to JWM current design
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c24ZZ.IssueTypeEditViewWithIssueTypeConnection), {
        issueTypesFragmentRef: data?.issueTypes ?? null,
        menuPosition: "fixed",
        menuPlacement: "top",
        onChange: handleIssueTypeChange,
        onRefetch: refetch,
        onGetRefetchVariables: handleGetRefetchVariables,
        refetchQuery: (0, $dIK9p.default),
        value: selectedTypeOption,
        spacing: "compact",
        stopPropagationOfMenuEscape: true,
        label: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $l4kLF.default).labelIssueTerminologyRefreshM4 : (0, $l4kLF.default).label),
        iconsOnly: true,
        appearance: "subtle",
        isSearchable: !(0, $7jTnu.fg)('fix_icc_type_select_being_searchable'),
        placeholder: (0, $7jTnu.fg)('jifjam_deliveroo_icc_changes') ? $46aa89e2d718a4b7$var$placeholder : undefined
    });
};
const $46aa89e2d718a4b7$export$7b1e666ab7e366e1 = ({ queries: { projectData: projectData }, props: props })=>{
    const data = (0, $j4oe4.usePreloadedQuery)((0, $2Akpc.default), projectData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($46aa89e2d718a4b7$export$16aea7aa4bac227f, {
        ...props,
        project: data.jira.jiraProjectByKey ?? null
    });
};
var $46aa89e2d718a4b7$export$2e2bcd8739ae039 = $46aa89e2d718a4b7$export$16aea7aa4bac227f;

});
parcelRegister("2Akpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $aff33008072933a3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ab7f0858672cb82645a3396e11f8fe0>>
 * @relayHash 0d9abbece612cf0b39d1b506df6ac887
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 88cc5b35279fc932bb73f89b79d29c75908b5950ef5010942a12dc207bfe4268
const $aff33008072933a3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasProjectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v5 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        v5 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTypeDropdownIssueType_projectDataQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "hasProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectByKey",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "issueTypeDropdown_issueTableInlineIssueCreate"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueTypeDropdownIssueType_projectDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "hasProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "large"
                                                }
                                            ]
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "JiraIssueTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "issueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeId"
                                                                },
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "hierarchy",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "level"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "filters": [
                                                "filter"
                                            ],
                                            "handle": "connection",
                                            "key": "inlineIssueCreate_IssueTable_issueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "issueTypes"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "88cc5b35279fc932bb73f89b79d29c75908b5950ef5010942a12dc207bfe4268",
            "metadata": {},
            "name": "issueTypeDropdownIssueType_projectDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$aff33008072933a3$var$node.hash = "30a657670a87487d2fd2c30abf17ebc7";
var $aff33008072933a3$export$2e2bcd8739ae039 = $aff33008072933a3$var$node;

});

parcelRegister("jLSkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $337da71ad19d7bf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e511847ce4b6e983a0b805f6c7186ccc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $dIK9p = parcelRequire("dIK9p");
const $337da71ad19d7bf5$var$node = function() {
    var v0 = [
        "issueTypes"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filter"
            },
            {
                "defaultValue": 10,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $dIK9p.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "issueTypeDropdown_issueTableInlineIssueCreate",
        "selections": [
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "projectId"
            },
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v2 /*: any*/ ,
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "large"
                    }
                ]
            },
            {
                "alias": "issueTypes",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "filter",
                        "variableName": "filter"
                    }
                ],
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "__inlineIssueCreate_IssueTable_issueTypes_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueTypeId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "small"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchy",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "level"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$337da71ad19d7bf5$var$node.hash = "404aea827078dfb362c35ecb15dd8d3b";
var $337da71ad19d7bf5$export$2e2bcd8739ae039 = $337da71ad19d7bf5$var$node;

});
parcelRegister("dIK9p", function(module, exports) {

$parcel$export(module.exports, "default", () => $e170485f93d3fbc4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3ffc8c4257de96b52bfeb3d2dc90fc9b>>
 * @relayHash 7eefb6eeec213554db3d9a71ab4a3bb5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4208f182e24c74b313733c6747a0ff72e0249a271aadc573f28bb0de60cf2b96
const $e170485f93d3fbc4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cursor"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        },
        {
            "defaultValue": 10,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                },
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "issueTypeDropdown_issueTableInlineIssueCreate"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueTypeId"
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "level"
                                                                }
                                                            ]
                                                        },
                                                        v4 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "inlineIssueCreate_IssueTable_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4208f182e24c74b313733c6747a0ff72e0249a271aadc573f28bb0de60cf2b96",
            "metadata": {},
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e170485f93d3fbc4$var$node.hash = "404aea827078dfb362c35ecb15dd8d3b";
var $e170485f93d3fbc4$export$2e2bcd8739ae039 = $e170485f93d3fbc4$var$node;

});


parcelRegister("c24ZZ", function(module, exports) {

$parcel$export(module.exports, "IssueTypeEditViewWithIssueTypeConnection", () => $657e3371d6260ec4$export$139e4bfeb055992c);
$parcel$export(module.exports, "IssueTypeEditView", () => $657e3371d6260ec4$export$83fe9ca9fdf41761);

var $3ATPW = parcelRequire("3ATPW");

var $7BW6r = parcelRequire("7BW6r");

var $5xS2c = parcelRequire("5xS2c");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $c4OV1 = parcelRequire("c4OV1");

var $7jTnu = parcelRequire("7jTnu");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");

var $jbtzi = parcelRequire("jbtzi");

var $f1FvV = parcelRequire("f1FvV");

var $aUMMA = parcelRequire("aUMMA");

var $lkYtk = parcelRequire("lkYtk");

var $fwzaq = parcelRequire("fwzaq");

var $QH4SF = parcelRequire("QH4SF");

var $4F1Zj = parcelRequire("4F1Zj");
const $657e3371d6260ec4$var$iconOnlySelectStyles = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $dPMMf.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $dPMMf.layers).modal,
            minWidth: '120px',
            maxWidth: '440px',
            width: 'auto',
            overflowY: 'auto'
        }),
    control: (base)=>({
            ...base,
            '&:hover': {
                borderColor: 'transparent'
            }
        })
};
const $657e3371d6260ec4$export$6a277fd8285f68cf = ({ queryFragmentRef: queryFragmentRef, fieldId: fieldId, filterOptionsById: filterOptionsById = null, ...props })=>{
    const { data: issueTypesSearchData, refetch: refetchSuggestions } = (0, $j4oe4.usePaginationFragment)((0, $5xS2c.default), queryFragmentRef);
    const onGetRefetchVariables = (0, $eJOHy.useCallback)((searchBy)=>({
            id: fieldId,
            searchBy: searchBy,
            filterById: filterOptionsById
        }), [
        fieldId,
        filterOptionsById
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$export$139e4bfeb055992c, {
        ...props,
        issueTypesFragmentRef: issueTypesSearchData.node?.issueTypes ?? null,
        onGetRefetchVariables: onGetRefetchVariables,
        refetchQuery: (0, $QH4SF.default),
        onRefetch: refetchSuggestions
    });
};
const $657e3371d6260ec4$export$139e4bfeb055992c = ({ autoFocus: autoFocus = false, issueTypesFragmentRef: issueTypesFragmentRef, onChange: onChange, onGetRefetchVariables: onGetRefetchVariables, value: value, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, isInvalid: isInvalid, isDisabled: isDisabled = false, inputId: inputId, menuPosition: menuPosition, menuPlacement: menuPlacement, refetchQuery: refetchQuery, onRefetch: onRefetch, openMenuOnFocus: openMenuOnFocus, spacing: spacing, stopPropagationOfMenuEscape: stopPropagationOfMenuEscape, iconsOnly: iconsOnly = false, appearance: appearance = 'default', isSearchable: isSearchable = true, placeholder: placeholder })=>{
    const [menuIsOpen, setMenuIsOpen] = (0, $eJOHy.useState)(autoFocus);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getNoOptionsMessage = (0, $eJOHy.useCallback)(()=>noOptionsMessage ?? formatMessage((0, $4F1Zj.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eJOHy.useCallback)(()=>loadingMessage ?? formatMessage((0, $4F1Zj.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const defaultPlaceholder = formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $4F1Zj.default).placeholderIssueTerminologyRefreshM4 : (0, $4F1Zj.default).placeholder); // #region Relay
    // suggestions fragment with pagination and refetch
    const data = (0, $j4oe4.useFragment)((0, $7BW6r.default), issueTypesFragmentRef); // #endregion
    // #region Common state (might be handy for other components)
    const [searchByString, setSearchByString] = (0, $eJOHy.useState)(''); // #endregion
    // #region Debounced suspensless refetch helpers
    const [searchSuspenselessRefetch, isLoading, lastFetchError] = (0, $lkYtk.useSuspenselessRefetch)(refetchQuery, onRefetch);
    const [searchDebouncedSuspenselessRefetch] = (0, $fwzaq.default)(searchSuspenselessRefetch, (0, $jbtzi.SEARCH_DEBOUNCE_TIMEOUT));
    (0, $eJOHy.useEffect)(()=>{
        if (autoFocus) searchSuspenselessRefetch(onGetRefetchVariables(searchByString));
    }, [
        searchSuspenselessRefetch,
        autoFocus,
        searchByString,
        onGetRefetchVariables
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (stopPropagationOfMenuEscape && menuIsOpen && e.key === 'Escape') e.stopPropagation();
    }, [
        menuIsOpen,
        stopPropagationOfMenuEscape
    ]); // #region Common callbacks for the selector
    const openMenu = ()=>setMenuIsOpen(true);
    const closeMenu = ()=>setMenuIsOpen(false);
    const onSelectFocus = (0, $eJOHy.useCallback)(()=>{
        searchSuspenselessRefetch(onGetRefetchVariables(searchByString));
    }, [
        searchSuspenselessRefetch,
        searchByString,
        onGetRefetchVariables
    ]);
    const onSearchByStringChangeFunction = (0, $eJOHy.useCallback)((newSearchByString)=>{
        setSearchByString(newSearchByString);
        searchDebouncedSuspenselessRefetch(onGetRefetchVariables(newSearchByString || ''));
    }, [
        onGetRefetchVariables,
        searchDebouncedSuspenselessRefetch
    ]); // #endregion
    // #region Transform options data from relay to AK Select
    const defaultFailedOption = (0, $eJOHy.useMemo)(()=>({
            label: formatMessage((0, $4F1Zj.default).failedFetch),
            value: '',
            avatar: {
                small: ''
            },
            isDisabled: true
        }), [
        formatMessage
    ]);
    const renderIconOnlyOption = (option, formatOptionLabelMeta)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            xcss: $657e3371d6260ec4$var$inlineIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
            src: option.avatar?.small || '',
            alt: option.label,
            width: 2 * (0, $dPMMf.gridSize),
            height: 2 * (0, $dPMMf.gridSize)
        })), formatOptionLabelMeta.context !== 'value' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, option.label));
    const renderIconWithTextOption = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$var$ImgSpan, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
            src: option.avatar?.small || '',
            alt: option.label,
            width: 2 * (0, $dPMMf.gridSize),
            height: 2 * (0, $dPMMf.gridSize)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, option.label));
    const selectFieldOptions = (0, $eJOHy.useMemo)(()=>{
        // checks for query errors
        if (lastFetchError != null) return [
            defaultFailedOption
        ];
        return data?.edges?.map((edge)=>edge?.node).filter(Boolean).map(({ label: optionLabel, value: optionValue, avatar: avatar })=>({
                label: optionLabel ?? '',
                value: optionValue,
                avatar: avatar
            })) ?? [];
    }, [
        lastFetchError,
        data,
        defaultFailedOption
    ]); // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        "aria-label": formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $4F1Zj.default).labelIssueTerminologyRefreshM4 : (0, $4F1Zj.default).label),
        formatOptionLabel: iconsOnly ? renderIconOnlyOption : renderIconWithTextOption,
        styles: iconsOnly ? $657e3371d6260ec4$var$iconOnlySelectStyles : (0, $aUMMA.defaultSelectStyles),
        value: value,
        options: selectFieldOptions,
        menuIsOpen: menuIsOpen,
        placeholder: placeholder && (0, $7jTnu.fg)('jifjam_deliveroo_icc_changes') ? placeholder : defaultPlaceholder,
        noOptionsMessage: getNoOptionsMessage,
        loadingMessage: getLoadingMessage,
        filterOption: (0, $f1FvV.filterOptionByLabelAndFilterValues),
        onInputChange: onSearchByStringChangeFunction,
        onChange: onChange,
        openMenuOnFocus: openMenuOnFocus,
        onFocus: onSelectFocus,
        onKeyDown: onKeyDown,
        autoFocus: autoFocus,
        isInvalid: isInvalid,
        isDisabled: isDisabled,
        isLoading: isLoading && menuIsOpen,
        inputId: inputId,
        menuPosition: menuPosition,
        menuPlacement: menuPlacement,
        onMenuOpen: openMenu,
        onMenuClose: closeMenu,
        spacing: spacing,
        appearance: appearance,
        isSearchable: isSearchable
    });
};
const $657e3371d6260ec4$export$83fe9ca9fdf41761 = (props)=>{
    const suggestionsData = (0, $j4oe4.useLazyLoadQuery)((0, $3ATPW.default), {
        id: props.fieldId,
        filterById: props.filterOptionsById
    }, {
        fetchPolicy: 'store-only'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$export$6a277fd8285f68cf, {
        ...props,
        queryFragmentRef: suggestionsData
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $657e3371d6260ec4$var$OptionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $657e3371d6260ec4$var$ImgSpan = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $657e3371d6260ec4$var$inlineIconStyle = (0, $1DXK0.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("3ATPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35b5261ea602541$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfa9b261ee662a6f57fc80f1429c11c9>>
 * @relayHash 29e5738373d98b44824fad02a3d3cd14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e50d5efb3e493597a605e3f7eb0d92c3151c4aaeb3ec7b9f8a450d447af2ab54
const $c35b5261ea602541$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "Literal",
        "name": "searchBy",
        "value": ""
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        v4 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueType_issueTypeSearchQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueType_issueTypeSearchQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "e50d5efb3e493597a605e3f7eb0d92c3151c4aaeb3ec7b9f8a450d447af2ab54",
            "metadata": {},
            "name": "issueType_issueTypeSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c35b5261ea602541$var$node.hash = "a9ae551cfa917838f44cb5ad82166383";
var $c35b5261ea602541$export$2e2bcd8739ae039 = $c35b5261ea602541$var$node;

});

parcelRegister("7BW6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $6409f3ef4c1bc03b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e0227129a9b0594353e8c68d9a88930>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6409f3ef4c1bc03b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef",
    "selections": [
        {
            "concreteType": "JiraIssueTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueTypeConnection"
};
$6409f3ef4c1bc03b$var$node.hash = "a3043f504a0b36b603fb3665ac2ae823";
var $6409f3ef4c1bc03b$export$2e2bcd8739ae039 = $6409f3ef4c1bc03b$var$node;

});

parcelRegister("5xS2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $2088ea6e2d1ccbc5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92d1e3360b2d69683e70b781460fce34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $QH4SF = parcelRequire("QH4SF");
const $2088ea6e2d1ccbc5$var$node = function() {
    var v0 = [
        "node",
        "issueTypes"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterById"
            },
            {
                "defaultValue": 1000,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "searchBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $QH4SF.default)
            }
        },
        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "id"
                    }
                ],
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": "issueTypes",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterById",
                                        "variableName": "filterById"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchBy",
                                        "variableName": "searchBy"
                                    }
                                ],
                                "concreteType": "JiraIssueTypeConnection",
                                "kind": "LinkedField",
                                "name": "__issueType_issueFieldIssueTypeEditviewFull_issueTypes_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef"
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraIssueTypeField"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$2088ea6e2d1ccbc5$var$node.hash = "54c04d4f507b644a10ef1cc8b3c0fc09";
var $2088ea6e2d1ccbc5$export$2e2bcd8739ae039 = $2088ea6e2d1ccbc5$var$node;

});
parcelRegister("QH4SF", function(module, exports) {

$parcel$export(module.exports, "default", () => $979de82bb5a16211$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2fb7462fc58470e5f932ba5f158f8a16>>
 * @relayHash 53b193ba86b71b4b505947ef99d7bce3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ddf0f50c9d8d9f30aa48671b2fc60b8934c2cf6d1edc9897ed54f296df319cd4
const $979de82bb5a16211$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        },
        {
            "defaultValue": 1000,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "searchBy"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v5 = {
        "kind": "Variable",
        "name": "searchBy",
        "variableName": "searchBy"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueType_SearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueType_SearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "ddf0f50c9d8d9f30aa48671b2fc60b8934c2cf6d1edc9897ed54f296df319cd4",
            "metadata": {},
            "name": "issueType_SearchRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$979de82bb5a16211$var$node.hash = "54c04d4f507b644a10ef1cc8b3c0fc09";
var $979de82bb5a16211$export$2e2bcd8739ae039 = $979de82bb5a16211$var$node;

});


parcelRegister("jbtzi", function(module, exports) {

$parcel$export(module.exports, "FRAGMENT_FIELD_OPTIONS_FIRST", () => $d156ca0cd64e2913$export$971747fe11f2a6f4);
$parcel$export(module.exports, "FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST", () => $d156ca0cd64e2913$export$1a6463c5895cff9e);
$parcel$export(module.exports, "SELECTABLE_FIELD_PAGE_OPTIONS", () => $d156ca0cd64e2913$export$d1beabd8dceb4469);
$parcel$export(module.exports, "MULTI_VERSIONS_FIELD_OPTIONS_FETCH_FIRST", () => $d156ca0cd64e2913$export$176e9e0c749f88b2);
$parcel$export(module.exports, "SEARCH_DEBOUNCE_TIMEOUT", () => $d156ca0cd64e2913$export$228cc37ca8dce73);
$parcel$export(module.exports, "versionStatus", () => $d156ca0cd64e2913$export$7fc41a408a0533d3);
/**
 * This will be used to set the default value for the number of options
 * to be fetched in the first request for the field options.
 */ const $d156ca0cd64e2913$export$971747fe11f2a6f4 = 100;
const $d156ca0cd64e2913$export$1a6463c5895cff9e = 55;
const $d156ca0cd64e2913$export$d1beabd8dceb4469 = 50;
const $d156ca0cd64e2913$export$176e9e0c749f88b2 = 1000;
const $d156ca0cd64e2913$export$228cc37ca8dce73 = 300;
const $d156ca0cd64e2913$export$b983f2cb1f658a55 = 'RELEASED';
const $d156ca0cd64e2913$export$cb459d726a8530a5 = 'UNRELEASED';
const $d156ca0cd64e2913$export$c936349447a77fe0 = 'ARCHIVED';
const $d156ca0cd64e2913$export$7fc41a408a0533d3 = {
    RELEASED: $d156ca0cd64e2913$export$b983f2cb1f658a55,
    UNRELEASED: $d156ca0cd64e2913$export$cb459d726a8530a5,
    ARCHIVED: $d156ca0cd64e2913$export$c936349447a77fe0
};

});

parcelRegister("f1FvV", function(module, exports) {

$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $0b19d4706e6a94cf$export$58bb91b619b113f6);

var $LFmXM = parcelRequire("LFmXM");

var $1beam = parcelRequire("1beam");
const $0b19d4706e6a94cf$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $0b19d4706e6a94cf$var$stringifyLabelAndDataFilterValues = (option)=>{
    const { label: label, data: data } = option || {};
    const { filterValues: filterValues } = data || {};
    const labelString = typeof label === 'string' ? label : '';
    const filterValuesString = (filterValues || []).join(' ');
    return `${labelString} ${filterValuesString}`;
};
/**
 * By default react-select matches by both option.label and option.value: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js#L14.
 * This leads to undesired UX, when filter result includes options without displayed text matching the query (which is very confusing for the user): BENTO-5735, BENTO-5655.
 * That's why we need this function.
 */ const $0b19d4706e6a94cf$var$filterOptionByLabelAndFilterValuesInternal = (0, $LFmXM.default)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $1beam.createFilter)({
        // Take an option object and convert it to a string that needs to partially match the user's query
        stringify: $0b19d4706e6a94cf$var$stringifyLabelAndDataFilterValues
    }));
const $0b19d4706e6a94cf$export$58bb91b619b113f6 = (option, inputValue)=>$0b19d4706e6a94cf$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);

});

parcelRegister("lkYtk", function(module, exports) {

$parcel$export(module.exports, "useSuspenselessRefetchStateless", () => $a7aab68bfd95469d$export$ae1adabf094b2244);
$parcel$export(module.exports, "useSuspenselessRefetch", () => $a7aab68bfd95469d$export$c7ce5f64dc007896);
// eslint-disable-next-line jira/restricted/react-18

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4im1M = parcelRequire("4im1M");

var $kn2Rh = parcelRequire("kn2Rh");
const $a7aab68bfd95469d$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $eJOHy.useRef)([]);
    return (0, $eJOHy.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $a7aab68bfd95469d$var$useTransitionNoop = ()=>[
        null,
        null
    ];
const $a7aab68bfd95469d$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const isMounted = (0, $4im1M.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $a7aab68bfd95469d$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    const useTransitionFG = // eslint-disable-next-line react-hooks/react-compiler
    (0, $kn2Rh.getIsConcurrentEnabled)() ? (0, $eJOHy.useTransition) : $a7aab68bfd95469d$var$useTransitionNoop;
    // eslint-disable-next-line react-hooks/react-compiler
    const [_, startTransition] = useTransitionFG();
    return (0, $eJOHy.useCallback)((variables)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $j4oe4.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    if (startTransition && (0, $kn2Rh.getIsConcurrentEnabled)()) // we need concurrent mode for useTransition to work
                    startTransition(()=>{
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                        });
                    });
                    else {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                        });
                    }
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError,
        startTransition
    ]);
};
const $a7aab68bfd95469d$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $eJOHy.useState)(null);
    const refetchFunction = $a7aab68bfd95469d$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});
parcelRegister("4im1M", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $bb7ff1168b248128$export$80c2a3957bcb42ea);

var $eJOHy = parcelRequire("eJOHy");
const $bb7ff1168b248128$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});


parcelRegister("4F1Zj", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc03aeeb2a58dadd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $dc03aeeb2a58dadd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    empty: {
        "id": "issue-field-issue-type-editview-full.issue-type.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-issue-type-editview-full.issue-type.failed-fetch",
        "defaultMessage": "Search failed."
    },
    loading: {
        "id": "issue-field-issue-type-editview-full.issue-type.loading",
        "defaultMessage": "Searching..."
    },
    placeholder: {
        "id": "issue-field-issue-type-editview-full.issue-type.placeholder",
        "defaultMessage": "Select Issue Type"
    },
    label: {
        "id": "issue-field-issue-type-editview-full.issue-type.label",
        "defaultMessage": "Issue Type"
    },
    placeholderIssueTerminologyRefreshM4: {
        "id": "issue-field-issue-type-editview-full.issue-type.placeholder-issue-terminology-refresh-m4",
        "defaultMessage": "Select work type"
    },
    labelIssueTerminologyRefreshM4: {
        "id": "issue-field-issue-type-editview-full.issue-type.label-issue-terminology-refresh-m4",
        "defaultMessage": "Work Type"
    }
});

});


parcelRegister("aB2Z6", function(module, exports) {

$parcel$export(module.exports, "useDefaultIssueType", () => $eafa7e0acaad2c22$export$9c7f64b201a937e7);

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");

var $1W85r = parcelRequire("1W85r");
const $eafa7e0acaad2c22$var$defaultProjectConfigProjectConfig = {
    defaultIssueType: null
};
const $eafa7e0acaad2c22$var$selectProjectConfig = (0, $4MchI.createSelector)((_, projectKey)=>projectKey, ({ projectConfigs: projectConfigs })=>projectConfigs, (projectKey, projectConfigs)=>{
    if (projectKey == null) return $eafa7e0acaad2c22$var$defaultProjectConfigProjectConfig;
    const config = projectConfigs[projectKey];
    if (config == null) return $eafa7e0acaad2c22$var$defaultProjectConfigProjectConfig;
    return config;
});
const $eafa7e0acaad2c22$var$selectIssueType = (0, $4MchI.createSelector)($eafa7e0acaad2c22$var$selectProjectConfig, (config)=>config.defaultIssueType);
const $eafa7e0acaad2c22$export$9c7f64b201a937e7 = (0, $iJq0l.createHook)((0, $1W85r.IICConfigStore), {
    selector: $eafa7e0acaad2c22$var$selectIssueType
});

});
parcelRegister("1W85r", function(module, exports) {

$parcel$export(module.exports, "IICConfigStore", () => $0b13d55531392d29$export$9bd138189628b8f1);
$parcel$export(module.exports, "useIICConfigActions", () => $0b13d55531392d29$export$d86349fef3b2869d);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $0b13d55531392d29$var$initialState = {
    projectConfigs: {}
};
const $0b13d55531392d29$var$actions = {
    setDefaultIssueType: (projectKey, issueType)=>({ setState: setState, getState: getState })=>{
            if (projectKey == null) return;
            const currentState = getState();
            let projectConfig = currentState.projectConfigs[projectKey];
            if (projectConfig == null) projectConfig = {
                defaultIssueType: null
            };
            projectConfig.defaultIssueType = issueType;
            setState({
                ...currentState,
                projectConfigs: {
                    ...currentState.projectConfigs,
                    [projectKey]: projectConfig
                }
            });
        }
};
const $0b13d55531392d29$export$9bd138189628b8f1 = (0, $GtRbT.createStore)({
    initialState: $0b13d55531392d29$var$initialState,
    actions: $0b13d55531392d29$var$actions
});
const $0b13d55531392d29$export$8b216441e8d7a953 = (0, $iJq0l.createHook)($0b13d55531392d29$export$9bd138189628b8f1);
const $0b13d55531392d29$export$d86349fef3b2869d = (0, $iJq0l.createActionsHook)($0b13d55531392d29$export$9bd138189628b8f1);

});


parcelRegister("l4kLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb1df118e16999d7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cb1df118e16999d7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        "id": "issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label",
        "defaultMessage": "Issue type"
    },
    labelIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    }
});

});


parcelRegister("eNuUB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c7dd3f69b21f2c1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3c7dd3f69b21f2c1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createButton: {
        "id": "issue-table-inline-issue-create.inline-create-from.create-button",
        "defaultMessage": "Create"
    },
    placeholderText: {
        "id": "issue-table-inline-issue-create.inline-create-from.placeholder-text",
        "defaultMessage": "What needs to be done?"
    }
});

});

parcelRegister("ab4Fp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f79f07048da8f6ae$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $f79f07048da8f6ae$var$ReturnGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H21C22.6569 16 24 14.6569 24 13V3C24 1.34315 22.6569 0 21 0H3Z",
        fill: "var(--ds-background-inverse-subtle, #00000029)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15.5 5.75V6.75C15.5 8.26878 14.2688 9.5 12.75 9.5H8.75C8.33579 9.5 8 9.16421 8 8.75C8 8.33579 8.33579 8 8.75 8H12.75C13.4404 8 14 7.44036 14 6.75V5.75C14 5.33579 14.3358 5 14.75 5C15.1642 5 15.5 5.33579 15.5 5.75Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M9.28033 9.28033L11.0303 7.53033C11.3232 7.23744 11.3232 6.76256 11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967L8.21967 8.21967C7.92678 8.51256 7.92678 8.98744 8.21967 9.28033C8.51256 9.57322 8.98744 9.57322 9.28033 9.28033Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M9.28033 8.21967L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L8.21967 9.28033C7.92678 8.98744 7.92678 8.51256 8.21967 8.21967C8.51256 7.92678 8.98744 7.92678 9.28033 8.21967Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
const $f79f07048da8f6ae$var$ReturnIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $f79f07048da8f6ae$var$ReturnGlyph,
        label: ""
    });
var $f79f07048da8f6ae$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($f79f07048da8f6ae$var$ReturnIcon);

});


parcelRegister("1Ob2L", function(module, exports) {

$parcel$export(module.exports, "useInlineIssueCreateEntryPoint", () => $a59bff9a3ee71001$export$885248fb7870aaf0);
$parcel$export(module.exports, "useInlineIssueCreateAdditionalFieldsEntryPoint", () => $a59bff9a3ee71001$export$345c7d6ef1e7c79c);

var $bbdV2 = parcelRequire("bbdV2");

var $kEUB1 = parcelRequire("kEUB1");

var $bYsdT = parcelRequire("bYsdT");

var $63ryK = parcelRequire("63ryK");
const $a59bff9a3ee71001$export$885248fb7870aaf0 = (projectKey, minHierarchyLevel, maxHierarchyLevel)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    return (0, $bbdV2.useEntryPoint)((0, $63ryK.default), {
        cloudId: cloudId,
        projectKey: projectKey,
        minHierarchyLevel: minHierarchyLevel ?? undefined,
        maxHierarchyLevel: maxHierarchyLevel ?? undefined
    });
};
const $a59bff9a3ee71001$export$345c7d6ef1e7c79c = ({ projectKey: projectKey, defaultAssigneeId: defaultAssigneeId })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    return (0, $bbdV2.useEntryPoint)((0, $bYsdT.InlineCreateAdditionalFieldsEntrypoint), {
        cloudId: cloudId,
        projectKey: projectKey,
        defaultAssigneeId: defaultAssigneeId
    });
};

});
parcelRegister("bYsdT", function(module, exports) {

$parcel$export(module.exports, "InlineCreateAdditionalFieldsEntrypoint", () => $4dcf8b0cdfa91d90$export$19884e0312fcb420);

var $gY3Fs = parcelRequire("gY3Fs");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $4dcf8b0cdfa91d90$export$19884e0312fcb420 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("2eLsz")), {
        moduleId: "be327326",
        moduleName: "InlineCreateAdditionalFieldsEntrypoint",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey, defaultAssigneeId: defaultAssigneeId })=>({
            queries: {
                rootData: {
                    parameters: $gY3Fs.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey ?? '',
                        hasProjectKey: !!projectKey,
                        defaultAssigneeId: defaultAssigneeId ?? '',
                        hasDefaultAssignee: !!defaultAssigneeId
                    }
                }
            }
        })
});

});
parcelRegister("gY3Fs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1a4247321fd47be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<083791ee8fe8ac629678816f5ad84129>>
 * @relayHash 18a79873a0d8adb8b564459d1e3933ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e912661cb90a2ca17e80283a3722471456baf4b4679e680954281ed13e4261ef
const $a1a4247321fd47be$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e912661cb90a2ca17e80283a3722471456baf4b4679e680954281ed13e4261ef",
        "metadata": {},
        "name": "InlineCreateAdditionalFieldsEntrypointQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a1a4247321fd47be$export$2e2bcd8739ae039 = $a1a4247321fd47be$var$node;

});

parcelRegister("2eLsz", function(module, exports) {

let $1a11b418bd01f88d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1a11b418bd01f88d$var$load("ffQaD"),
    $1a11b418bd01f88d$var$load("kvRbA"),
    $1a11b418bd01f88d$var$load("jfnqE")
]).then(()=>parcelRequire('bwXPC'));

});


parcelRegister("63ryK", function(module, exports) {

$parcel$export(module.exports, "default", () => $00eae25319f329e7$export$2e2bcd8739ae039);

var $2Akpc = parcelRequire("2Akpc");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $00eae25319f329e7$var$IssueTypeDropdownEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("fh8ae"))).then((module)=>module.IssueTypeDropdownEntryPoint), {
        moduleId: "2e71ceb4",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey, minHierarchyLevel: minHierarchyLevel, maxHierarchyLevel: maxHierarchyLevel })=>({
            queries: {
                projectData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $2Akpc.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey ?? '',
                        hasProjectKey: !!projectKey,
                        ...minHierarchyLevel != null ? {
                            filter: {
                                minHierarchyLevel: minHierarchyLevel,
                                maxHierarchyLevel: maxHierarchyLevel
                            }
                        } : {}
                    }
                }
            }
        })
});
var $00eae25319f329e7$export$2e2bcd8739ae039 = $00eae25319f329e7$var$IssueTypeDropdownEntryPoint;

});


parcelRegister("1cMAs", function(module, exports) {

$parcel$export(module.exports, "default", () => $979fa4e593532476$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $dcLzM = parcelRequire("dcLzM");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $9zZj0 = parcelRequire("9zZj0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $g9Vr6 = parcelRequire("g9Vr6");

var $kEUB1 = parcelRequire("kEUB1");


var $iTHfM = parcelRequire("iTHfM");

var $dCQmT = parcelRequire("dCQmT");
const $979fa4e593532476$var$InlineCreateTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const [isStoplightVisible, setIsSpotlightVisible] = (0, $eJOHy.useState)(false);
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, (0, $23b4218cfd94fe9f$export$c7e6a6b283196232), false, orgId), [
        cloudId,
        orgId
    ]);
    const startTour = (0, $eJOHy.useCallback)(async ()=>{
        const started = await coordinationClient?.start((0, $23b4218cfd94fe9f$export$e77c67bc8157f49));
        if (started) setIsSpotlightVisible(true);
    }, [
        coordinationClient
    ]);
    const endTour = (0, $eJOHy.useCallback)(()=>{
        setIsSpotlightVisible(false);
        coordinationClient?.stop?.((0, $23b4218cfd94fe9f$export$e77c67bc8157f49));
    }, [
        coordinationClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        startTour();
    }, [
        startTour
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClickCallback = (0, $eJOHy.useCallback)(()=>{
        onClick?.();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineIssueCreateButton');
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'inlineIssueCreateButton');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "inline-create-trigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onClickCallback,
        ref: ref,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM)))
    }, formatMessage((0, $iTHfM.default).createLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dCQmT.default), {
        showOnboarding: isStoplightVisible,
        onDismiss: endTour
    }));
});
var $979fa4e593532476$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($979fa4e593532476$var$InlineCreateTrigger);

});
parcelRegister("iTHfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $66695a78f0b2ab0e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $66695a78f0b2ab0e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createLabel: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.create-label",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("dCQmT", function(module, exports) {

$parcel$export(module.exports, "default", () => $349f8bf77bb8cae2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $d2s5v = parcelRequire("d2s5v");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $9HHOs = parcelRequire("9HHOs");

var $e625v = parcelRequire("e625v");
const $349f8bf77bb8cae2$var$InlineCreateOnboardingSpotlight = ({ showOnboarding: showOnboarding, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, showOnboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        actions: [
            {
                onClick: onDismiss,
                text: formatMessage((0, $e625v.default).onboardingDismiss)
            }
        ],
        heading: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $e625v.default).onboardingHeaderIssueTerminologyRefreshM4 : (0, $e625v.default).onboardingHeader),
        target: "inline-create-trigger",
        key: "inline-create-trigger",
        messageType: "engagement",
        dialogPlacement: "top right",
        messageId: ((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $e625v.default).onboardingDescriptionIssueTerminologyRefreshM4 : (0, $e625v.default).onboardingDescription).id,
        dialogWidth: 275
    }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $e625v.default).onboardingDescriptionIssueTerminologyRefreshM4 : (0, $e625v.default).onboardingDescription)));
};
var $349f8bf77bb8cae2$export$2e2bcd8739ae039 = $349f8bf77bb8cae2$var$InlineCreateOnboardingSpotlight;

});
parcelRegister("e625v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5acc70d9685ac55c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5acc70d9685ac55c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    onboardingDescription: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-description",
        "defaultMessage": "Quickly create issues on this page by selecting + Create below"
    },
    onboardingHeader: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-header",
        "defaultMessage": "Create issues in context"
    },
    onboardingDismiss: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-dismiss",
        "defaultMessage": "OK"
    },
    onboardingDescriptionIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-description-issue-terminology-refresh-m4",
        "defaultMessage": "Quickly create work items on this page by selecting + Create below"
    },
    onboardingHeaderIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-header-issue-terminology-refresh-m4",
        "defaultMessage": "Create work items in context"
    }
});

});




parcelRegister("iC2St", function(module, exports) {

$parcel$export(module.exports, "useIssueCreateMutation", () => $c04e6c3749743271$export$2a4bb6ab1e983642);
$parcel$export(module.exports, "CreateIssueController", () => $c04e6c3749743271$export$dac3b0377215001c);

var $kRNbx = parcelRequire("kRNbx");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $h1PFK = parcelRequire("h1PFK");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $6bbL3 = parcelRequire("6bbL3");

var $3ElzA = parcelRequire("3ElzA");

var $sJrIm = parcelRequire("sJrIm");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $d0yFI = parcelRequire("d0yFI");

var $5NEjg = parcelRequire("5NEjg");

var $brgMm = parcelRequire("brgMm");

var $dhVsI = parcelRequire("dhVsI");

var $4uses = parcelRequire("4uses");

var $5hgjg = parcelRequire("5hgjg");
const $c04e6c3749743271$var$ACTION_SUBJECT_ID = 'issueTableIssueCreate';
const $c04e6c3749743271$var$PACKAGE_LOCATION = 'jira-native-issue-table-inline-issue-create';
const $c04e6c3749743271$var$issueConnectionMutationUpdater = (store, response, issueConnectionId, insertionArgs, parentItemConnectionId, projectKey, groupId)=>{
    const issue = response?.jira?.createIssue?.issue;
    const issueId = issue?.__id; // it's always defined, but relay types it as nullable, relay sets this field whether it's there or not.
    if (!issue || !issueId) return;
    (0, $d0yFI.issueConnectionUpdater)(store, {
        ...insertionArgs,
        issue: issue,
        issueConnectionId: issueConnectionId,
        parentItemConnectionId: parentItemConnectionId,
        issueRecordId: issueId,
        fieldSetsConnectionId: issue.fieldSetsById?.__id ?? '',
        projectKey: projectKey,
        groupId: groupId
    });
};
const $c04e6c3749743271$export$2a4bb6ab1e983642 = ({ issueConnectionId: issueConnectionId, parentItemConnectionId: parentItemConnectionId, groupContextFieldInput: groupContextFieldInput, jql: jql, location: location, rankFieldTerms: rankFieldTerms })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const handleErrorIIC = (0, $h1PFK.useIssueCreateOnError)();
    const shouldSkipIssuesConnectionUpdateAndShowFlag = (0, $6bbL3.useShouldSkipIssuesConnectionUpdate)();
    const { onSortChange: onSortChange } = (0, $sJrIm.useSortContext)();
    const { fieldSetIds: fieldSetIds } = (0, $5NEjg.useIssueFetchQueryVariables)();
    const onIssueFetchAndAppend = (0, $brgMm.useIssueFetchAndAppend)({
        issueConnectionId: issueConnectionId,
        groupContextFieldInput: groupContextFieldInput,
        jql: jql
    });
    const { generateOptimisticId: generateOptimisticId, getRealId: getRealId } = (0, $5hgjg.useOptimisticId)();
    let queuedCommit;
    if ((0, $7jTnu.fg)('jsc_list_reranking_gate')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const generateDeferredVariables = (0, $eJOHy.useCallback)((oldVariables)=>{
            const rank = oldVariables.issueCreateInput.rank;
            if (rank) return {
                ...oldVariables,
                issueCreateInput: {
                    ...oldVariables.issueCreateInput,
                    rank: {
                        ...rank,
                        afterIssueId: rank.afterIssueId ? getRealId(rank.afterIssueId) ?? rank.afterIssueId : rank.afterIssueId,
                        beforeIssueId: rank.beforeIssueId ? getRealId(rank.beforeIssueId) ?? rank.beforeIssueId : rank.beforeIssueId
                    }
                }
            };
            return oldVariables;
        }, [
            getRealId
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        queuedCommit = (0, $3ElzA.useQueuedMutationCommit)({
            generateDeferredVariables: generateDeferredVariables
        });
    }
    const [commit] = (0, $j4oe4.useMutation)((0, $kRNbx.default), queuedCommit);
    let projectKey;
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    let isIssueHierarchyEnabled = false;
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        projectKey = (0, $34oCh.useProjectContext)();
    }
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $8jOO7.INLINE_ISSUE_CREATE_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $8jOO7.INLINE_ISSUE_CREATE_EXPERIENCE),
        attributes: {
            isGroupIssueCreate: !!groupContextFieldInput
        }
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $8jOO7.INLINE_ISSUE_CREATE_EXPERIENCE)
    });
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7jTnu.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    return (0, $eJOHy.useCallback)((issueToCreate, contextualFields, insertionArgs)=>{
        const issueCreateInput = (0, $dhVsI.toIssueCreateInput)(issueToCreate, contextualFields, groupContextFieldInput, isIssueRankingEnabled);
        if (!issueCreateInput || issueConnectionId == null) return;
        const insertionArgsWithIdGetter = insertionArgs == null ? insertionArgs : {
            ...insertionArgs,
            getRealId: getRealId
        };
        const handleError = async (error)=>{
            const response = await handleErrorIIC({
                issueToCreate: issueToCreate,
                contextualFields: contextualFields,
                groupContextFieldInput: groupContextFieldInput,
                error: error,
                onFail: (e)=>onExperienceFail($c04e6c3749743271$var$PACKAGE_LOCATION, e)
            });
            if (response) {
                onIssueFetchAndAppend(response, insertionArgsWithIdGetter);
                onExperienceSuccess();
            }
        };
        const { id: optimisticId, saveRealId: saveRealId } = generateOptimisticId();
        onExperienceStart();
        commit({
            variables: {
                issueCreateInput: issueCreateInput,
                fieldSetIds: fieldSetIds,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isDensityFull: isDensityFull,
                isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                isIdFieldEnabled: !(0, $7jTnu.fg)('nin-optimistic-flashing-fix'),
                isGroupByAnyFieldsTechnicalEnabled: (0, $7jTnu.fg)('group_by_any_fields_technical'),
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isTimelineEnabled: isTimelineEnabled,
                ...(0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? {
                    projectKey: projectKey
                } : {},
                ...groupContextFieldInput ? {
                    shouldQueryFieldsByIdOrAlias: true,
                    fieldIdsOrAliases: [
                        groupContextFieldInput.fieldId
                    ]
                } : {
                    shouldQueryFieldsByIdOrAlias: false,
                    fieldIdsOrAliases: []
                },
                ...jql ? {
                    shouldQueryMatchesIssueSearch: true,
                    issueSearchInput: {
                        jql: jql
                    }
                } : {
                    shouldQueryMatchesIssueSearch: false,
                    issueSearchInput: {
                        jql: ''
                    }
                }
            },
            optimisticResponse: (0, $4uses.toOptimisticResponse)(issueToCreate, optimisticId, isIssueHierarchyEnabled, groupContextFieldInput),
            optimisticUpdater: (store, response)=>$c04e6c3749743271$var$issueConnectionMutationUpdater(store, response, issueConnectionId, insertionArgsWithIdGetter, parentItemConnectionId, projectKey),
            updater: (store, response)=>{
                if (response != null && response?.jira?.createIssue?.issue?.id != null) saveRealId(response?.jira?.createIssue?.issue?.id);
                if (shouldSkipIssuesConnectionUpdateAndShowFlag(groupContextFieldInput, response?.jira?.createIssue?.issue, isIssueRankingEnabled, onSortChange, rankFieldTerms)) return;
                return $c04e6c3749743271$var$issueConnectionMutationUpdater(store, response, issueConnectionId, insertionArgsWithIdGetter, parentItemConnectionId, projectKey, groupContextFieldInput?.groupId);
            },
            onCompleted: (response)=>{
                const { errors: errors, issue: issue } = response?.jira?.createIssue ?? {};
                if (!issue) {
                    // Handle any GraphQL errors that occurred during issue create
                    errors && handleError(errors);
                    return;
                }
                // Event contributes towards Jira Monthly Core User, see https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition#%3Ajira%3A-Jira.
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', $c04e6c3749743271$var$ACTION_SUBJECT_ID, {
                    ...location && (0, $7jTnu.fg)('jsc_list_reranking_gate') && {
                        location: location
                    },
                    ...(0, $7jTnu.fg)('jira_render_pic_in_nin') && {
                        fields: {
                            hasAssignee: Boolean(issueToCreate.assignee),
                            hasDueDate: Boolean(issueToCreate.dueDate)
                        }
                    }
                });
                onExperienceSuccess();
                (0, $d0yFI.removeHighlightAfterDelay)(environment, issue);
            },
            onError: (error)=>{
                // Handle any network errors that occurred during issue create
                handleError(error);
            }
        });
    }, [
        groupContextFieldInput,
        isIssueRankingEnabled,
        issueConnectionId,
        getRealId,
        generateOptimisticId,
        onExperienceStart,
        commit,
        fieldSetIds,
        isInlineEditingEnabled,
        isDensityFull,
        isIssueHierarchyEnabled,
        isConditionalFormattingEnabled,
        projectKey,
        jql,
        handleErrorIIC,
        onExperienceFail,
        onIssueFetchAndAppend,
        onExperienceSuccess,
        parentItemConnectionId,
        shouldSkipIssuesConnectionUpdateAndShowFlag,
        onSortChange,
        rankFieldTerms,
        createAnalyticsEvent,
        location,
        environment,
        isTimelineEnabled
    ]);
};
const $c04e6c3749743271$export$dac3b0377215001c = ({ childConnectionId: childConnectionId, parentItemConnectionId: parentItemConnectionId, groupContextFieldInput: groupContextFieldInput, setOnCreateIssue: setOnCreateIssue, jql: jql, location: location, rankFieldTerms: rankFieldTerms })=>{
    const onCreateIssue = $c04e6c3749743271$export$2a4bb6ab1e983642({
        issueConnectionId: childConnectionId,
        parentItemConnectionId: parentItemConnectionId,
        groupContextFieldInput: groupContextFieldInput,
        jql: jql,
        ...(0, $7jTnu.fg)('jsc_list_reranking_gate') && {
            location: location,
            rankFieldTerms: rankFieldTerms
        }
    });
    setOnCreateIssue(onCreateIssue);
    return null;
};

});
parcelRegister("kRNbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9b5d76c0e2746e5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<07b97d0df8fe7988440b0b6a67e472b8>>
 * @relayHash cfcab819f15ac6d01ca10f55020d6c99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67879bbe553603505117cb0e969516921eea4b07e61152b8d8cb1416c4acedac

var $kZq2R = parcelRequire("kZq2R");

var $5CxJ3 = parcelRequire("5CxJ3");

var $eHMRp = parcelRequire("eHMRp");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $bU8Sj = parcelRequire("bU8Sj");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");
const $f9b5d76c0e2746e5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldIdsOrAliases"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isGroupByAnyFieldsTechnicalEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIdFieldEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIssueHierarchyEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueCreateInput"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldsByIdOrAlias"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryMatchesIssueSearch"
    }, v14 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "issueCreateInput"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v16 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v17 = {
        "condition": "isIdFieldEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v16 /*: any*/ 
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = {
        "kind": "ScalarField",
        "name": "key"
    }, v20 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v21 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v22 = {
        "args": [
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "canHaveChildIssues"
    }, v23 = [
        {
            "kind": "Variable",
            "name": "idsOrAliases",
            "variableName": "fieldIdsOrAliases"
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "name"
    }, v28 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v28 /*: any*/ 
                ]
            }
        ],
        "type": "JiraPriorityField"
    }, v30 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v31 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v32 = [
        v31 /*: any*/ 
    ], v33 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v34 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v35 = {
        "kind": "ScalarField",
        "name": "number"
    }, v36 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v37 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v27 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraLabelsField"
    }, v38 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v32 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ], v39 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v40 = [
        v39 /*: any*/ 
    ], v41 = [
        {
            "concreteType": "JiraVersionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": v40 /*: any*/ 
                }
            ]
        }
    ], v42 = {
        "condition": "shouldQueryMatchesIssueSearch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "kind": "ScalarField",
                "name": "matchesIssueSearch"
            }
        ]
    }, v43 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v44 = [
        v18 /*: any*/ 
    ], v45 = {
        "kind": "ScalarField",
        "name": "type"
    }, v46 = {
        "kind": "ScalarField",
        "name": "value"
    }, v47 = [
        v46 /*: any*/ ,
        v18 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v48 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v49 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v50 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v51 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v52 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v53 = {
        "kind": "ScalarField",
        "name": "text"
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            v53 /*: any*/ ,
            v27 /*: any*/ ,
            v48 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v55 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v56 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v18 /*: any*/ 
        ]
    }, v57 = [
        v55 /*: any*/ 
    ], v58 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v59 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v60 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v61 = [
        v27 /*: any*/ ,
        v18 /*: any*/ 
    ], v62 = {
        "kind": "ScalarField",
        "name": "date"
    }, v63 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v64 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v65 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v64 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v66 = [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                },
                v27 /*: any*/ ,
                v18 /*: any*/ 
            ]
        }
    ], v67 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v53 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v68 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v56 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v69 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v70 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v69 /*: any*/ ,
                    v27 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            },
            v18 /*: any*/ 
        ]
    }, v71 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v72 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v73 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v65 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v74 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v75 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v76 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v77 = [
        v24 /*: any*/ ,
        v25 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v62 /*: any*/ 
            ],
            "type": "JiraDatePickerField"
        },
        v18 /*: any*/ 
    ], v78 = [
        v24 /*: any*/ ,
        v30 /*: any*/ ,
        v18 /*: any*/ 
    ], v79 = [
        v39 /*: any*/ ,
        v18 /*: any*/ 
    ], v80 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": v79 /*: any*/ 
            }
        ],
        "type": "JiraSingleVersionPickerField"
    }, v81 = [
        v24 /*: any*/ ,
        v18 /*: any*/ 
    ], v82 = [
        v31 /*: any*/ ,
        v18 /*: any*/ 
    ], v83 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v82 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueCreateMutation_useIssueCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraIssueCreatePayload",
                            "kind": "LinkedField",
                            "name": "createIssue",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "highlightIssueRow_update_isHighlightedIssueRow"
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "condition": "isIssueHierarchyEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v22 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryFieldsByIdOrAlias",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v23 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        v29 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v30 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": v32 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v33 /*: any*/ ,
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedSprintsConnection(first:1)"
                                                                }
                                                            ],
                                                            "type": "JiraSprintField"
                                                        },
                                                        v36 /*: any*/ ,
                                                        {
                                                            "condition": "isGroupByAnyFieldsTechnicalEnabled",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "selectedOption",
                                                                            "plural": false,
                                                                            "selections": v32 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "JiraRadioSelectField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v38 /*: any*/ ,
                                                                    "type": "JiraMultipleSelectField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v38 /*: any*/ ,
                                                                    "type": "JiraCheckboxesField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "selectedVersionsConnection",
                                                                            "plural": false,
                                                                            "selections": v41 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "JiraMultipleVersionPickerField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "version",
                                                                            "plural": false,
                                                                            "selections": v40 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "JiraSingleVersionPickerField"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v42 /*: any*/ ,
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSetsById",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isConditionalFormattingEnabled",
                                                            "variableName": "isConditionalFormattingEnabled"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isDensityFull",
                                                            "variableName": "isDensityFull"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isInlineEditingEnabled",
                                                            "variableName": "isInlineEditingEnabled"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isTimelineEnabled",
                                                            "variableName": "isTimelineEnabled"
                                                        }
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v9 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v12 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v11 /*: any*/ ,
                v10 /*: any*/ ,
                v13 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueCreateMutation_useIssueCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraIssueCreatePayload",
                            "kind": "LinkedField",
                            "name": "createIssue",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v24 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v44 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSetsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldSetId"
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v24 /*: any*/ ,
                                                                                        v25 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v18 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v47 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v47 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v49 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v50 /*: any*/ ,
                                                                                                                                v51 /*: any*/ ,
                                                                                                                                v18 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v52 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                v54 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v55 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v46 /*: any*/ ,
                                                                                                                v56 /*: any*/ ,
                                                                                                                v18 /*: any*/ ,
                                                                                                                v31 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v48 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v57 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v46 /*: any*/ ,
                                                                                                                                v31 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v46 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v24 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v58 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v59 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v48 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraEstimate",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "originalEstimate",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "timeInSeconds"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingSettings",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingSettings",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingHoursPerDay"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingDaysPerWeek"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultFormat"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultUnit"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v45 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v60 /*: any*/ ,
                                                                                                                v18 /*: any*/ ,
                                                                                                                v50 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v49 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v50 /*: any*/ ,
                                                                                                                                v51 /*: any*/ ,
                                                                                                                                v39 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": v44 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "args": v49 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v16 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        v48 /*: any*/ ,
                                                                                                        v16 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v49 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "href"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v55 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "componentsOld",
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v61 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v53 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v62 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v63 /*: any*/ ,
                                                                                                v48 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v52 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        v54 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v65 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v49 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v56 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v55 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v27 /*: any*/ ,
                                                                                                v48 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": v66 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": v66 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        v67 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v68 /*: any*/ ,
                                                                                                                v70 /*: any*/ ,
                                                                                                                v67 /*: any*/ ,
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v68 /*: any*/ ,
                                                                                                                v70 /*: any*/ ,
                                                                                                                v67 /*: any*/ ,
                                                                                                                v18 /*: any*/ ,
                                                                                                                v20 /*: any*/ ,
                                                                                                                v71 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v25 /*: any*/ ,
                                                                                                                                                v53 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v25 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v72 /*: any*/ ,
                                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                                        v69 /*: any*/ ,
                                                                                                                                                        v21 /*: any*/ ,
                                                                                                                                                        v18 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v25 /*: any*/ ,
                                                                                                                                                v73 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v27 /*: any*/ ,
                                                                                                        v48 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ ,
                                                                                                v48 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v61 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v34 /*: any*/ ,
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ ,
                                                                                                v48 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v30 /*: any*/ ,
                                                                                                        v58 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v18 /*: any*/ ,
                                                                                                        v59 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ ,
                                                                                                v63 /*: any*/ ,
                                                                                                v48 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v27 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v49 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v61 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "json"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        v69 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v33 /*: any*/ ,
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v55 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v71 /*: any*/ ,
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v65 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v18 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                v18 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v74 /*: any*/ ,
                                                                                                                        v18 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v75 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v48 /*: any*/ ,
                                                                                                        v75 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v48 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v27 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v48 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "direction"
                                                                                                                },
                                                                                                                v74 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v44 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "isInlineEditingEnabled",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isEditableInIssueView"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                v20 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v61 /*: any*/ 
                                                                                                                        },
                                                                                                                        v18 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v73 /*: any*/ ,
                                                                                                                        v18 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "assigneeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v24 /*: any*/ ,
                                                                                                                                v58 /*: any*/ ,
                                                                                                                                v18 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v18 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v76 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "startDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v77 /*: any*/ ,
                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v76 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "endDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v77 /*: any*/ ,
                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v57 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v17 /*: any*/ ,
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v49 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                },
                                                                                                                                v18 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v78 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                v29 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                v80 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v72 /*: any*/ ,
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v49 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": v41 /*: any*/ ,
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v81 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v81 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v60 /*: any*/ ,
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "condition": "isIssueHierarchyEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v18 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v22 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryFieldsByIdOrAlias",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v23 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraPriorityField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v78 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": v82 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v33 /*: any*/ ,
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedSprintsConnection(first:1)"
                                                                }
                                                            ],
                                                            "type": "JiraSprintField"
                                                        },
                                                        v36 /*: any*/ ,
                                                        {
                                                            "condition": "isGroupByAnyFieldsTechnicalEnabled",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "selectedOption",
                                                                            "plural": false,
                                                                            "selections": v82 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "JiraRadioSelectField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v83 /*: any*/ ,
                                                                    "type": "JiraMultipleSelectField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v83 /*: any*/ ,
                                                                    "type": "JiraCheckboxesField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "selectedVersionsConnection",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersionEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraVersion",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": v79 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraMultipleVersionPickerField"
                                                                },
                                                                v80 /*: any*/ 
                                                            ]
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v42 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "67879bbe553603505117cb0e969516921eea4b07e61152b8d8cb1416c4acedac",
            "metadata": {},
            "name": "issueCreateMutation_useIssueCreateMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $eHMRp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider": (0, $5CxJ3.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default)
            }
        }
    };
}();
$f9b5d76c0e2746e5$var$node.hash = "7f65e9b34d35d3b7b0689ec7eef59c5d";
var $f9b5d76c0e2746e5$export$2e2bcd8739ae039 = $f9b5d76c0e2746e5$var$node;

});

parcelRegister("h1PFK", function(module, exports) {

$parcel$export(module.exports, "useIssueCreateOnError", () => $0e9105b7566f222f$export$5a42366aaf5bc501);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");


var $5ppNC = parcelRequire("5ppNC");

var $dwCPn = parcelRequire("dwCPn");
const $0e9105b7566f222f$var$isMutationValidationError = (errors)=>errors.some((error)=>error.extensions?.statusCode === 400);
const $0e9105b7566f222f$var$toError = (errors)=>{
    const statusCodes = new Set();
    errors.forEach((err)=>{
        const sc = err.extensions?.statusCode;
        if (sc) statusCodes.add(String(sc));
    });
    return new Error(`Fail to fallback to GIC extension status codes: ${statusCodes.size > 0 ? Array.from(statusCodes.values()).join(',') : 'No status'}`);
};
const $0e9105b7566f222f$export$5a42366aaf5bc501 = ()=>{
    const onFallbackToGIC = (0, $5ppNC.useFallbackToGIC)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    return (0, $eJOHy.useCallback)(({ issueToCreate: issueToCreate, contextualFields: contextualFields, groupContextFieldInput: groupContextFieldInput, error: error, onFail: onFail })=>{
        let shouldFallbackToGIC;
        if (error instanceof Error) shouldFallbackToGIC = error instanceof (0, $1uIew.ValidationError);
        else shouldFallbackToGIC = $0e9105b7566f222f$var$isMutationValidationError(error);
        if (shouldFallbackToGIC) {
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'globalIssueCreate fallback', 'inlineIssueCreate');
            return onFallbackToGIC({
                issueToCreate: issueToCreate,
                contextualFields: contextualFields,
                groupContextFieldInput: groupContextFieldInput
            });
        }
        // Fire error analytics event and display flag if we were unable to fallback to GIC
        (0, $gYnSx.default)({
            event: createAnalyticsEvent({}),
            meta: {
                id: 'inlineIssueCreate',
                packageName: (0, $23b4218cfd94fe9f$export$b8b9d90f9e5bd72b),
                teamName: (0, $23b4218cfd94fe9f$export$d57b6b390e78d90f)
            },
            error: error instanceof Error ? error : undefined,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            type: 'error',
            title: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $dwCPn.default).errorFlagTitleIssueTerminologyRefreshM4 : (0, $dwCPn.default).errorFlagTitleNonFinal),
            description: formatMessage((0, $dwCPn.default).errorFlagDescriptionNonFinal),
            messageId: 'issue-table-inline-issue-create.controllers.use-issue-create-on-error.show-flag.error',
            messageType: 'transactional'
        });
        onFail?.(error instanceof Error ? error : $0e9105b7566f222f$var$toError(error));
        return Promise.resolve(null);
    }, [
        createAnalyticsEvent,
        formatMessage,
        onFallbackToGIC,
        showFlag
    ]);
};

});
parcelRegister("5ppNC", function(module, exports) {

$parcel$export(module.exports, "useFallbackToGIC", () => $8dac54862ef56e31$export$1682627434940303);

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $3T7mg = parcelRequire("3T7mg");

var $2ApNu = parcelRequire("2ApNu");

var $7jTnu = parcelRequire("7jTnu");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $8ntPR = parcelRequire("8ntPR");

var $814y1 = parcelRequire("814y1");
const $8dac54862ef56e31$var$issueIdFromAri = (ari)=>(0, $2ApNu.JiraIssueAri).parse(ari).issueId;
const $8dac54862ef56e31$var$toGICAdditionalFields = ({ rankFieldId: rankFieldId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId }, groupContextFieldInput)=>{
    const additionalFields = {};
    if (rankFieldId && (rankBeforeIssueId || rankAfterIssueId)) {
        if ((0, $7jTnu.fg)('jsc_list_reranking_gate')) additionalFields[rankFieldId] = {
            ...rankBeforeIssueId ? {
                rankBeforeIssue: $8dac54862ef56e31$var$issueIdFromAri(rankBeforeIssueId)
            } : {},
            ...rankAfterIssueId ? {
                rankAfterIssue: $8dac54862ef56e31$var$issueIdFromAri(rankAfterIssueId)
            } : {}
        };
        else additionalFields[rankFieldId] = {
            ...rankBeforeIssueId ? {
                rankBeforeIssue: rankBeforeIssueId
            } : {},
            ...rankAfterIssueId ? {
                rankAfterIssue: rankAfterIssueId
            } : {}
        };
    }
    if (groupContextFieldInput) return {
        ...additionalFields,
        ...(0, $8ntPR.convertFieldToGICAdditionalFieldsPayload)(groupContextFieldInput)
    };
    return additionalFields;
};
const $8dac54862ef56e31$export$1682627434940303 = ()=>{
    const openIssueCreateModal = (0, $jipjz.useOpenIssueCreateModal)();
    const { subscribe: subscribe } = (0, $4PKlm.useGICLifeCycleEvents)();
    return (0, $eJOHy.useCallback)(({ issueToCreate: issueToCreate, contextualFields: contextualFields, groupContextFieldInput: groupContextFieldInput })=>{
        const { project: { projectId: projectId }, issueType: { issueTypeId: issueTypeId }, summary: summary, assignee: assignee, dueDate: dueDate } = issueToCreate;
        const payload = {
            project: {
                projectId: projectId
            },
            issueType: {
                issueTypeId: issueTypeId
            },
            ...contextualFields.parentIssueAri && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? {
                parentId: {
                    parentId: $8dac54862ef56e31$var$issueIdFromAri(contextualFields.parentIssueAri)
                }
            } : {},
            ...groupContextFieldInput?.fieldType === (0, $814y1.STATUS_TYPE) ? (0, $8ntPR.convertFieldToStatusGICInput)(groupContextFieldInput) : {},
            defaultValues: {
                singleLineTextFields: [
                    {
                        fieldId: 'summary',
                        text: summary
                    }
                ],
                ...assignee && (0, $7jTnu.fg)('jira_render_pic_in_nin') && {
                    singleSelectUserPickerFields: [
                        {
                            fieldId: 'assignee',
                            user: {
                                accountId: assignee.accountId
                            }
                        }
                    ]
                },
                ...dueDate && (0, $7jTnu.fg)('jira_render_pic_in_nin') && {
                    datePickerFields: [
                        {
                            fieldId: 'duedate',
                            date: {
                                formattedDate: (0, $57raR.default)((0, $3T7mg.default)(dueDate), 'yyyy-MM-dd')
                            }
                        }
                    ]
                },
                ...contextualFields.parentIssueAri && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? {
                    parentField: {
                        issueId: $8dac54862ef56e31$var$issueIdFromAri(contextualFields.parentIssueAri)
                    }
                } : {},
                ...groupContextFieldInput ? (0, $8ntPR.convertFieldToIssueCreateInput)(groupContextFieldInput) : {}
            }
        };
        return new Promise((resolve)=>{
            const unsubscribe = subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                // the user cancelled editing
                onClose(null);
            });
            // resolve the promise once the GIC has been closed or cancelled
            const onClose = (data)=>{
                const result = data?.[0]?.issueKey ?? null;
                resolve(result);
                unsubscribe();
            };
            const isSubTaskCreationOpen = !!(issueToCreate.issueType?.hierarchy?.level === -1 && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes'));
            openIssueCreateModal({
                payload: payload,
                context: {
                    projectId: projectId,
                    submitApiData: {
                        additionalFields: $8dac54862ef56e31$var$toGICAdditionalFields(contextualFields, groupContextFieldInput)
                    }
                },
                onClose: onClose,
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                triggerPointKey: (0, $84DOT.JIRA_ISSUE_TABLE_TRIGGER),
                disableProjectDropdown: true,
                disableIssueTypeDropdown: false,
                disableCreationSuccessFlag: true,
                minimizableModalView: 'mini'
            });
        });
    }, [
        openIssueCreateModal,
        subscribe
    ]);
};

});
parcelRegister("2ApNu", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $1e22f45952f0c501$export$1da6808e89ee03e);

var $dhskT = parcelRequire("dhskT");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issue/manifest.ts
var $1e22f45952f0c501$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $dhskT.JiraIssueAriResourceOwner),
    resourceType: (0, $dhskT.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $1e22f45952f0c501$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $1e22f45952f0c501$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $1e22f45952f0c501$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("dhskT", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $9ab2d7d34ec0a003$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $9ab2d7d34ec0a003$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $9ab2d7d34ec0a003$export$665a39f1b4e29e0a = "jira", $9ab2d7d34ec0a003$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("xMjNG", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $6988db3fd722d63c$export$876003a5b887f37e);
const $6988db3fd722d63c$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("4PKlm", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $8e36a2abc6a32ec2$export$e3ff72f196296fcc);

var $8Urkc = parcelRequire("8Urkc");
const $8e36a2abc6a32ec2$var$GICLifeCycleEventsService = new (0, $8Urkc.PubSubHub)();
const $8e36a2abc6a32ec2$export$e3ff72f196296fcc = ()=>({
        ...$8e36a2abc6a32ec2$var$GICLifeCycleEventsService
    });

});
parcelRegister("8Urkc", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $ef124bfbd3a417bb$export$e3607828f8f2c01e);
class $ef124bfbd3a417bb$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("8ntPR", function(module, exports) {

$parcel$export(module.exports, "isOptionFieldType", () => $1e3493a9d203145a$export$cdebdb13954c63c8);
$parcel$export(module.exports, "isVersionFieldType", () => $1e3493a9d203145a$export$3868397c63c76330);
$parcel$export(module.exports, "isUserFieldType", () => $1e3493a9d203145a$export$fe80a5e9db59a835);
$parcel$export(module.exports, "isCreateIssueSupportedForFieldType", () => $1e3493a9d203145a$export$6a7d6e7c75a0955e);
$parcel$export(module.exports, "convertFieldToStatusGICInput", () => $1e3493a9d203145a$export$ff734d0b6c783fa9);
$parcel$export(module.exports, "convertFieldToGICAdditionalFieldsPayload", () => $1e3493a9d203145a$export$2bcbed170a89c245);
$parcel$export(module.exports, "convertFieldToIssueCreateInput", () => $1e3493a9d203145a$export$1492200cb52faf7c);
$parcel$export(module.exports, "toOptimisticField", () => $1e3493a9d203145a$export$4905b0508c306b7b);

var $7jTnu = parcelRequire("7jTnu");

var $814y1 = parcelRequire("814y1");

var $gwBQn = parcelRequire("gwBQn");
const $1e3493a9d203145a$var$OPTION_FIELD_TYPES = new Set([
    (0, $814y1.CATEGORY_TYPE),
    (0, $814y1.SELECT_CF_TYPE),
    (0, $814y1.MULTI_SELECT_CF_TYPE),
    (0, $814y1.MULTI_CHECKBOXES_CF_TYPE),
    (0, $814y1.RADIO_BUTTONS_CF_TYPE)
]);
const $1e3493a9d203145a$var$VERSION_FIELD_TYPES = new Set([
    (0, $814y1.VERSION_CF_TYPE),
    (0, $814y1.MULTI_VERSION_CF_TYPE),
    (0, $814y1.AFFECTS_VERSIONS_TYPE),
    (0, $814y1.FIX_VERSIONS_TYPE)
]);
const $1e3493a9d203145a$var$USER_FIELD_TYPES = new Set([
    (0, $814y1.ASSIGNEE_TYPE),
    (0, $814y1.REPORTER_TYPE),
    (0, $814y1.USER_CF_TYPE)
]);
const $1e3493a9d203145a$export$f9c7798bde1b3073 = new Set([
    (0, $814y1.PRIORITY_TYPE),
    (0, $814y1.STATUS_TYPE),
    (0, $814y1.LABELS_TYPE),
    (0, $814y1.SPRINT_TYPE),
    (0, $814y1.ISSUE_TYPE),
    (0, $814y1.GROUP_CF_TYPE),
    (0, $814y1.MULTI_GROUP_CF_TYPE),
    ...$1e3493a9d203145a$var$OPTION_FIELD_TYPES,
    ...$1e3493a9d203145a$var$VERSION_FIELD_TYPES,
    ...$1e3493a9d203145a$var$USER_FIELD_TYPES
]);
const $1e3493a9d203145a$export$2ebdffdb7d794ccf = new Set([
    (0, $814y1.NUMBER_CF_TYPE),
    (0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE)
]);
const $1e3493a9d203145a$export$8dd5b143c91a8104 = new Set([
    ...$1e3493a9d203145a$export$f9c7798bde1b3073,
    ...$1e3493a9d203145a$export$2ebdffdb7d794ccf
]);
const $1e3493a9d203145a$export$cdebdb13954c63c8 = (fieldType)=>$1e3493a9d203145a$var$OPTION_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$3868397c63c76330 = (fieldType)=>$1e3493a9d203145a$var$VERSION_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$fe80a5e9db59a835 = (fieldType)=>$1e3493a9d203145a$var$USER_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$6a7d6e7c75a0955e = (fieldType)=>Boolean(fieldType && $1e3493a9d203145a$export$8dd5b143c91a8104.has(fieldType));
const $1e3493a9d203145a$export$ff734d0b6c783fa9 = ({ fieldValue: fieldValue })=>{
    if (fieldValue === null) return null;
    return {
        status: {
            statusId: fieldValue
        }
    };
};
const $1e3493a9d203145a$export$2bcbed170a89c245 = (groupContextFieldInput)=>{
    const { fieldType: fieldType, fieldValue: fieldValue, fieldId: fieldId } = groupContextFieldInput;
    if (fieldValue === null) return null;
    // Note: excluding status type and issue type as they're always shown in GIC
    switch(fieldType){
        case 0, $814y1.PRIORITY_TYPE:
        case 0, $814y1.ASSIGNEE_TYPE:
        case 0, $814y1.REPORTER_TYPE:
        case 0, $814y1.USER_CF_TYPE:
            return {
                [fieldId]: {
                    id: fieldValue
                }
            };
        case 0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $814y1.NUMBER_CF_TYPE:
            if (typeof fieldValue === 'number' && (0, $7jTnu.fg)('group_by_any_fields_technical')) return {
                [fieldId]: fieldValue
            };
            return {
                [fieldId]: {
                    id: fieldId,
                    value: fieldValue
                }
            };
        case 0, $814y1.SPRINT_TYPE:
            return {
                [fieldId]: {
                    id: fieldId,
                    value: fieldValue
                }
            };
        case 0, $814y1.LABELS_TYPE:
            return {
                [fieldId]: [
                    fieldValue
                ]
            };
        case 0, $814y1.VERSION_CF_TYPE:
        case 0, $814y1.AFFECTS_VERSIONS_TYPE:
        case 0, $814y1.FIX_VERSIONS_TYPE:
        case 0, $814y1.SELECT_CF_TYPE:
        case 0, $814y1.RADIO_BUTTONS_CF_TYPE:
        case 0, $814y1.CATEGORY_TYPE:
            return {
                [fieldId]: {
                    id: fieldValue,
                    value: fieldValue
                }
            };
        case 0, $814y1.MULTI_SELECT_CF_TYPE:
        case 0, $814y1.MULTI_CHECKBOXES_CF_TYPE:
        case 0, $814y1.MULTI_VERSION_CF_TYPE:
            return {
                [fieldId]: [
                    {
                        id: fieldValue
                    }
                ]
            };
        default:
            // note: this code path should never be reached following the cleanup of the group_by_any_fields_technical flag
            // as the typing on GroupContextField will only support supported field types
            return null;
    }
};
const $1e3493a9d203145a$export$1492200cb52faf7c = ({ fieldType: fieldType, fieldValue: fieldValue, fieldId: fieldId })=>{
    if (fieldValue === null) return null;
    // Note: excluding issue type as it's supported directly via inline issue create
    switch(fieldType){
        case 0, $814y1.PRIORITY_TYPE:
            return {
                priority: {
                    priorityId: fieldValue
                }
            };
        case 0, $814y1.ASSIGNEE_TYPE:
        case 0, $814y1.USER_CF_TYPE:
        case 0, $814y1.REPORTER_TYPE:
            return {
                singleSelectUserPickerFields: [
                    {
                        fieldId: fieldId,
                        user: {
                            accountId: fieldValue
                        }
                    }
                ]
            };
        case 0, $814y1.STATUS_TYPE:
            return {
                status: {
                    statusId: fieldValue
                }
            };
        case 0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $814y1.NUMBER_CF_TYPE:
            if ((0, $7jTnu.fg)('group_by_any_fields_technical')) {
                // this check will be removed as part of the fg cleanup logic, as once cleaned up TS will know that fieldValue is a number at this point
                if (typeof fieldValue === 'number') return {
                    numberFields: [
                        {
                            fieldId: fieldId,
                            value: fieldValue
                        }
                    ]
                };
            }
            // TODO: JSC-2109
            // there is currently a type issue where the `mergeWith` usage in
            // src/packages/platform/ui/issue-table/issue-table/src/services/issue-create-mutation/utils/to-issue-create-input.tsx
            // is hiding an implicit casting this from a string to a number. We will update the GroupContextField type to have number fields defined as a number.
            // Note even though this type doesn't match the API type, it still accepts a string, and is the current behaviour.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                numberFields: [
                    {
                        fieldId: fieldId,
                        value: fieldValue
                    }
                ]
            };
        case 0, $814y1.CATEGORY_TYPE:
        case 0, $814y1.SELECT_CF_TYPE:
        case 0, $814y1.RADIO_BUTTONS_CF_TYPE:
            return {
                singleSelectFields: [
                    {
                        fieldId: fieldId,
                        option: {
                            id: fieldValue,
                            optionId: fieldValue
                        }
                    }
                ]
            };
        case 0, $814y1.MULTI_SELECT_CF_TYPE:
        case 0, $814y1.MULTI_CHECKBOXES_CF_TYPE:
            return {
                multipleSelectFields: [
                    {
                        fieldId: fieldId,
                        options: [
                            {
                                id: fieldValue,
                                optionId: fieldValue
                            }
                        ]
                    }
                ]
            };
        case 0, $814y1.VERSION_CF_TYPE:
        case 0, $814y1.AFFECTS_VERSIONS_TYPE:
        case 0, $814y1.FIX_VERSIONS_TYPE:
        case 0, $814y1.MULTI_VERSION_CF_TYPE:
            return {
                multipleVersionPickerFields: [
                    {
                        fieldId: fieldId,
                        versions: [
                            {
                                versionId: fieldValue
                            }
                        ]
                    }
                ]
            };
        case 0, $814y1.SPRINT_TYPE:
            return {
                sprintsField: {
                    fieldId: fieldId,
                    sprints: [
                        {
                            sprintId: fieldValue
                        }
                    ]
                }
            };
        case 0, $814y1.LABELS_TYPE:
            return {
                labelsFields: [
                    {
                        fieldId: fieldId,
                        labels: [
                            {
                                name: fieldValue
                            }
                        ]
                    }
                ]
            };
        case 0, $814y1.GROUP_CF_TYPE:
            return {
                singleGroupPickerFields: [
                    {
                        fieldId: fieldId,
                        group: {
                            groupName: fieldValue
                        }
                    }
                ]
            };
        case 0, $814y1.MULTI_GROUP_CF_TYPE:
            return {
                multipleGroupPickerFields: [
                    {
                        fieldId: fieldId,
                        groups: [
                            {
                                groupName: fieldValue
                            }
                        ]
                    }
                ]
            };
        default:
            // note: this code path should never be reached following the cleanup of the group_by_any_fields_technical flag
            // as the typing on GroupContextField will only support supported field types
            return null;
    }
};
const $1e3493a9d203145a$export$4905b0508c306b7b = (issueId, { fieldId: fieldId, fieldType: fieldType, optimisticResponse: optimisticResponse })=>{
    // Note: excluding issue type as it's supported separately
    switch(optimisticResponse?.type){
        case 0, $814y1.PRIORITY_TYPE:
            return (0, $gwBQn.toOptimisticPriority)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $814y1.ASSIGNEE_TYPE:
        case 0, $814y1.USER_CF_TYPE:
        case 0, $814y1.REPORTER_TYPE:
            return (0, $gwBQn.toOptimisticUser)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $814y1.STATUS_TYPE:
            return (0, $gwBQn.toOptimisticStatus)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $814y1.CATEGORY_TYPE:
        case 0, $814y1.SELECT_CF_TYPE:
            return (0, $gwBQn.toOptimisticSingleSelect)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $814y1.RADIO_BUTTONS_CF_TYPE:
            return (0, $gwBQn.toOptimisticRadioSelect)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $814y1.MULTI_SELECT_CF_TYPE:
            return (0, $gwBQn.toOptimisticMultiSelect)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $814y1.MULTI_CHECKBOXES_CF_TYPE:
            return (0, $gwBQn.toOptimisticCheckbox)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $814y1.SPRINT_TYPE:
            return (0, $gwBQn.toOptimisticSprint)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $814y1.NUMBER_CF_TYPE:
            return (0, $gwBQn.toOptimisticNumber)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $814y1.LABELS_TYPE:
            return (0, $gwBQn.toOptimisticLabels)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $814y1.MULTI_GROUP_CF_TYPE:
            return (0, $gwBQn.toOptimisticMultiGroup)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        // Note: Excluding VERSION_CF_TYPE as it's a fallback field.
        case 0, $814y1.MULTI_VERSION_CF_TYPE:
        case 0, $814y1.AFFECTS_VERSIONS_TYPE:
        case 0, $814y1.FIX_VERSIONS_TYPE:
            return (0, $gwBQn.toOptimisticMultiVersion)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        default:
            return null;
    }
};

});
parcelRegister("gwBQn", function(module, exports) {

$parcel$export(module.exports, "toOptimisticPriority", () => $bed603991fa02297$export$b0e8bb5f2ea51c4f);
$parcel$export(module.exports, "toOptimisticUser", () => $bed603991fa02297$export$afc99b621d72ef26);
$parcel$export(module.exports, "toOptimisticStatus", () => $bed603991fa02297$export$3e4b4b49e4ee4e20);
$parcel$export(module.exports, "toOptimisticSingleSelect", () => $bed603991fa02297$export$71ead0fa097cead6);
$parcel$export(module.exports, "toOptimisticRadioSelect", () => $bed603991fa02297$export$f32e937f8185cba6);
$parcel$export(module.exports, "toOptimisticMultiSelect", () => $bed603991fa02297$export$a0aeb0a088349a7f);
$parcel$export(module.exports, "toOptimisticCheckbox", () => $bed603991fa02297$export$bdb06cc2dd7fdd79);
$parcel$export(module.exports, "toOptimisticSprint", () => $bed603991fa02297$export$d9be65aae3a85c75);
$parcel$export(module.exports, "toOptimisticNumber", () => $bed603991fa02297$export$4b7137aed66177e0);
$parcel$export(module.exports, "toOptimisticLabels", () => $bed603991fa02297$export$deffb20716f51298);
$parcel$export(module.exports, "toOptimisticMultiGroup", () => $bed603991fa02297$export$da80edba1526dc1d);
$parcel$export(module.exports, "toOptimisticMultiVersion", () => $bed603991fa02297$export$32cb633741e0efe2);

var $7jTnu = parcelRequire("7jTnu");
const $bed603991fa02297$export$b0e8bb5f2ea51c4f = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { priority: priority, fieldSetId: fieldSetId } })=>({
        node: {
            fieldSetId: fieldSetId && (0, $7jTnu.fg)('group_by_any_fields_technical') ? fieldSetId : fieldType,
            type: fieldId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraPriorityField',
                            __isJiraIssueField: 'JiraPriorityField',
                            fieldId: fieldId,
                            id: `${issueId}/${fieldId}`,
                            type: fieldType,
                            name: 'Priority',
                            priority: priority
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$afc99b621d72ef26 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { user: user, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId && (0, $7jTnu.fg)('group_by_any_fields_technical') ? fieldSetId : fieldId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleSelectUserPickerField',
                            __isJiraIssueField: 'JiraSingleSelectUserPickerField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: (0, $7jTnu.fg)('group_by_any_fields_technical') ? 'User' : 'Assignee',
                            user: user ? {
                                __typename: 'AtlassianAccountUser',
                                accountStatus: 'active',
                                id: user.id,
                                accountId: user.accountId,
                                picture: user.picture,
                                name: user.name
                            } : null
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$3e4b4b49e4ee4e20 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { status: status, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId && (0, $7jTnu.fg)('group_by_any_fields_technical') ? fieldSetId : fieldId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraStatusField',
                            __isJiraIssueField: 'JiraStatusField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            status: status
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$71ead0fa097cead6 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId && (0, $7jTnu.fg)('group_by_any_fields_technical') ? fieldSetId : 'Category[Category]',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleSelectField',
                            __isJiraIssueField: 'JiraSingleSelectField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: (0, $7jTnu.fg)('group_by_any_fields_technical') ? 'SingleSelectCustomField' : 'Category',
                            fieldOptions: {
                                totalCount: 1
                            },
                            fieldOption: option ? {
                                id: option.id,
                                optionId: option.optionId,
                                value: option.value,
                                color: option.color
                            } : null
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$f32e937f8185cba6 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraRadioSelectField',
                            __isJiraIssueField: 'JiraRadioSelectField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'RadioSelectField',
                            selectedOption: option ? {
                                id: option.id,
                                // NOTE: For radio select fields, the value is the id of the option
                                value: option.id,
                                label: option.value
                            } : null
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$a0aeb0a088349a7f = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraMultipleSelectField',
                            __isJiraIssueField: 'JiraMultipleSelectField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'MultiSelectCustomField',
                            selectedOptions: {
                                edges: option ? [
                                    {
                                        node: {
                                            id: option.id,
                                            optionId: option.optionId,
                                            value: option.value
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$bdb06cc2dd7fdd79 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraCheckboxesField',
                            __isJiraIssueField: 'JiraCheckboxesField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'MultiSelectCustomField',
                            selectedOptions: {
                                edges: option ? [
                                    {
                                        node: {
                                            id: option.id,
                                            value: option.value
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$d9be65aae3a85c75 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { sprint: sprint, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId && (0, $7jTnu.fg)('group_by_any_fields_technical') ? fieldSetId : fieldId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSprintField',
                            __isJiraIssueField: 'JiraSprintField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Sprint',
                            selectedSprintsConnection: {
                                edges: sprint ? [
                                    {
                                        node: {
                                            id: sprint.id,
                                            sprintId: sprint.sprintId,
                                            name: sprint.name,
                                            state: sprint.state,
                                            endDate: sprint.endDate
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$4b7137aed66177e0 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { value: value, fieldSetId: fieldSetId, isStoryPointField: isStoryPointField } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraNumberField',
                            __isJiraIssueField: 'JiraNumberField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Story point estimate',
                            number: value,
                            isStoryPointField: isStoryPointField
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$deffb20716f51298 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { value: value, fieldSetId: fieldSetId } })=>{
    return {
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraLabelsField',
                            __isJiraIssueField: 'JiraLabelsField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Labels',
                            selectedLabelsConnection: {
                                totalCount: value ? 1 : 0,
                                edges: value ? [
                                    {
                                        node: {
                                            name: value,
                                            color: null
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    };
};
const $bed603991fa02297$export$da80edba1526dc1d = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { value: value, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraMultipleGroupPickerField',
                            __isJiraIssueField: 'JiraMultipleGroupPickerField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Groups',
                            selectedGroupsConnection: {
                                edges: value ? [
                                    {
                                        node: value
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$32cb633741e0efe2 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { version: version, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraMultipleVersionPickerField',
                            __isJiraIssueField: 'JiraMultipleVersionPickerField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Versions',
                            selectedVersionsConnection: {
                                edges: version ? [
                                    {
                                        node: {
                                            id: version.id,
                                            value: version.id,
                                            name: version.name,
                                            label: version.name,
                                            versionId: version.versionId
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });

});



parcelRegister("dwCPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $10f04f10d016508d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $10f04f10d016508d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorFlagTitleNonFinal: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-title-non-final",
        "defaultMessage": "We weren't able to create an issue"
    },
    errorFlagDescriptionNonFinal: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-description-non-final",
        "defaultMessage": "Refresh the page and try again."
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "We weren't able to create a work item"
    }
});

});


parcelRegister("6bbL3", function(module, exports) {

$parcel$export(module.exports, "useShouldSkipIssuesConnectionUpdate", () => $586a076f65fa653e$export$39d39d16a578afb3);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $bILK0 = parcelRequire("bILK0");

var $dnU6V = parcelRequire("dnU6V");

var $814y1 = parcelRequire("814y1");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $k9oyv = parcelRequire("k9oyv");
const $586a076f65fa653e$export$ce7751641b93537d = (0, $dnU6V.createLocalStorageProvider)('jira-native-issue-table-inline-issue-create');
const $586a076f65fa653e$export$39d39d16a578afb3 = ()=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireApplyRankingAnalytics = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'applyRankingFromSuccessFlag');
    }, [
        createAnalyticsEvent
    ]);
    const fireViewWorkItemUIAnalytics = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewWorkItemFromSuccessFlag');
    }, [
        createAnalyticsEvent
    ]);
    return (0, $eJOHy.useCallback)((groupContextField, createdIssue, isIssueRankingEnabled = false, onSortChange, rankFieldTerms)=>{
        if (!createdIssue) return false;
        // Determines whether to show the default success flag or the reranking prompt success flag
        const showDefaultSuccessFlag = (issueKey)=>{
            const issueCreatedCount = $586a076f65fa653e$export$ce7751641b93537d.get('issueCreatedCount') ?? 0;
            if (issueCreatedCount < 3) {
                $586a076f65fa653e$export$ce7751641b93537d.set('issueCreatedCount', issueCreatedCount + 1);
                showFlag((0, $k9oyv.getIssueCreateRerankingPromptSuccessFlag)({
                    issueKey: issueKey,
                    onSortChange: onSortChange,
                    rankFieldTerms: rankFieldTerms,
                    fireApplyRankingAnalytics: fireApplyRankingAnalytics,
                    fireViewWorkItemUIAnalytics: fireViewWorkItemUIAnalytics
                }));
            } else showFlag((0, $k9oyv.getIssueCreateSuccessFlag)({
                issueKey: issueKey
            }));
        };
        const issueKey = createdIssue.key;
        const event = createAnalyticsEvent({});
        if ((0, $epTsa.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) {
            const matchesIssueSearch = createdIssue.matchesIssueSearch !== false;
            const hasGroupValueChanged = (0, $7jTnu.fg)('group_by_any_fields_technical') ? !!groupContextField && !(0, $k9oyv.fieldValueContainsGroupContextValue)(createdIssue, groupContextField, groupContextField.fieldId) : !!groupContextField && (0, $k9oyv.getCreatedIssueFieldValue)(createdIssue, groupContextField.fieldId) !== groupContextField.fieldValue;
            if (!matchesIssueSearch) issueKey && showFlag((0, $k9oyv.getIssueCreateHiddenFlag)({
                issueKey: issueKey
            }));
            else if (hasGroupValueChanged && groupContextField?.fieldType === (0, $814y1.STATUS_TYPE)) issueKey && showFlag((0, $k9oyv.getIssueCreateSuccessFlag)({
                issueKey: issueKey,
                statusName: (0, $k9oyv.getStatusName)(createdIssue)
            }));
            else if (!isIssueRankingEnabled && (0, $7jTnu.fg)('jsc_list_reranking_gate')) issueKey && showDefaultSuccessFlag(issueKey);
            else issueKey && showFlag((0, $k9oyv.getIssueCreateSuccessFlag)({
                issueKey: issueKey
            }));
            (0, $gCeeo.fireUIAnalytics)(event, 'issueCreatedInListFlag shown', {
                matchesIssueSearch: matchesIssueSearch,
                groupIssueCreateFieldType: groupContextField?.fieldType || null,
                hasGroupValueChanged: hasGroupValueChanged
            });
            return hasGroupValueChanged || !matchesIssueSearch;
        }
        if (issueKey && (0, $7jTnu.fg)('jsc_list_reranking_gate')) {
            isIssueRankingEnabled ? showFlag((0, $k9oyv.getIssueCreateSuccessFlag)({
                issueKey: issueKey
            })) : showDefaultSuccessFlag(issueKey);
            (0, $gCeeo.fireUIAnalytics)(event, 'issueCreatedInListFlagNoGrouping shown', {});
        }
        return false;
    }, [
        createAnalyticsEvent,
        showFlag,
        fireApplyRankingAnalytics,
        fireViewWorkItemUIAnalytics
    ]);
};

});
parcelRegister("k9oyv", function(module, exports) {

$parcel$export(module.exports, "getCreatedIssueFieldValue", () => $690b1b9780012057$export$6e13001df02cb10d);
$parcel$export(module.exports, "fieldValueContainsGroupContextValue", () => $690b1b9780012057$export$a22b68ac49a3d37c);
$parcel$export(module.exports, "getStatusName", () => $690b1b9780012057$export$25a87d7a26b3901c);
$parcel$export(module.exports, "getIssueCreateSuccessFlag", () => $690b1b9780012057$export$d4c1d656d8898934);
$parcel$export(module.exports, "getIssueCreateRerankingPromptSuccessFlag", () => $690b1b9780012057$export$3b825da3d0425a10);
$parcel$export(module.exports, "getIssueCreateHiddenFlag", () => $690b1b9780012057$export$58532011dc58b882);

var $eJOHy = parcelRequire("eJOHy");

var $4sprp = parcelRequire("4sprp");

var $3cMgR = parcelRequire("3cMgR");

var $814y1 = parcelRequire("814y1");

var $7jTnu = parcelRequire("7jTnu");

var $lFP7n = parcelRequire("lFP7n");
const $690b1b9780012057$export$6e13001df02cb10d = (createdIssue, fieldId)=>{
    const issueField = createdIssue.fieldsByIdOrAlias?.find((field)=>field?.fieldId === fieldId);
    switch(issueField?.__typename){
        case 'JiraStatusField':
            return issueField.status?.statusId ?? null;
        case 'JiraPriorityField':
            return issueField.priority?.priorityId ?? null;
        case 'JiraSingleSelectUserPickerField':
            return issueField.user?.accountId ?? null;
        case 'JiraSingleSelectField':
            return issueField.fieldOption?.optionId ?? null;
        case 'JiraSprintField':
            return issueField.selectedSprintsConnection?.edges?.[0]?.node?.sprintId ?? null;
        case 'JiraNumberField':
            return issueField.number?.toString() ?? null;
        default:
            return null;
    }
};
const $690b1b9780012057$export$a22b68ac49a3d37c = (createdIssue, groupContextField, fieldId)=>{
    const issueField = createdIssue.fieldsByIdOrAlias?.find((field)=>field?.fieldId === fieldId);
    let fieldValue;
    switch(issueField?.__typename){
        case 'JiraStatusField':
            fieldValue = issueField.status?.statusId ?? null;
            break;
        case 'JiraPriorityField':
            fieldValue = issueField.priority?.priorityId ?? null;
            break;
        case 'JiraSingleSelectUserPickerField':
            fieldValue = issueField.user?.accountId ?? null;
            break;
        case 'JiraSingleSelectField':
            fieldValue = issueField.fieldOption?.optionId ?? null;
            break;
        case 'JiraRadioSelectField':
            fieldValue = issueField.selectedOption?.optionId ?? null;
            break;
        case 'JiraCheckboxesField':
        case 'JiraMultipleSelectField':
            fieldValue = issueField.selectedOptions?.edges?.map((edge)=>edge?.node?.optionId).filter((optionId)=>!!optionId) ?? null;
            break;
        case 'JiraSprintField':
            fieldValue = issueField.selectedSprintsConnection?.edges?.map((edge)=>edge?.node?.sprintId).filter((sprintId)=>!!sprintId) ?? null;
            break;
        case 'JiraNumberField':
            fieldValue = issueField.number ?? null;
            break;
        case 'JiraLabelsField':
            fieldValue = issueField.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name).filter((name)=>!!name) ?? null;
            break;
        case 'JiraMultipleVersionPickerField':
            fieldValue = issueField.selectedVersionsConnection?.edges?.map((edge)=>edge?.node?.versionId).filter((versionId)=>!!versionId) ?? null;
            break;
        case 'JiraSingleVersionPickerField':
            fieldValue = issueField.version?.versionId ?? null;
            break;
        default:
            fieldValue = null;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(fieldValue)) return fieldValue === groupContextField.fieldValue;
    if (fieldValue.length === 0) return groupContextField.fieldValue === null;
    return typeof groupContextField.fieldValue === 'string' && fieldValue?.includes(groupContextField.fieldValue);
};
const $690b1b9780012057$export$25a87d7a26b3901c = (createdIssue)=>{
    const issueField = createdIssue.fieldsByIdOrAlias?.find((field)=>field?.fieldId === (0, $814y1.STATUS_TYPE));
    return issueField?.status?.name;
};
const $690b1b9780012057$var$Bold = (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "strong"
    }, chunk);
const $690b1b9780012057$export$d4c1d656d8898934 = ({ issueKey: issueKey, statusName: statusName })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-success',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-success',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $lFP7n.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: statusName ? [
            (0, $lFP7n.default).workItemChangedStatusDescription,
            {
                issueKey: issueKey,
                statusName: statusName,
                Bold: $690b1b9780012057$var$Bold
            }
        ] : undefined,
        actions: [
            {
                content: [
                    (0, $lFP7n.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`
            }
        ]
    });
const $690b1b9780012057$export$3b825da3d0425a10 = ({ issueKey: issueKey, onSortChange: onSortChange, rankFieldTerms: rankFieldTerms, fireApplyRankingAnalytics: fireApplyRankingAnalytics, fireViewWorkItemUIAnalytics: fireViewWorkItemUIAnalytics })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-reranking-prompt-success',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-reranking-prompt-success',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $lFP7n.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: [
            (0, $lFP7n.default).rerankingPromptDescription,
            {
                issueKey: issueKey,
                Bold: $690b1b9780012057$var$Bold
            }
        ],
        actions: [
            {
                content: (0, $lFP7n.default).applyRanking,
                onClick: ()=>{
                    fireApplyRankingAnalytics();
                    rankFieldTerms?.jqlTerm && onSortChange?.(rankFieldTerms.jqlTerm, 'ASC', rankFieldTerms.aliases && (0, $7jTnu.fg)('jsc_list_reranking_ast_refactor') ? rankFieldTerms.aliases : undefined);
                }
            },
            {
                content: [
                    (0, $lFP7n.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`,
                onClick: ()=>{
                    fireViewWorkItemUIAnalytics();
                }
            }
        ]
    });
const $690b1b9780012057$export$58532011dc58b882 = ({ issueKey: issueKey })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-hidden',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-hidden',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $lFP7n.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: [
            (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $lFP7n.default).workItemHiddenDescription : (0, $lFP7n.default).issueHiddenDescription,
            {
                issueKey: issueKey,
                Bold: $690b1b9780012057$var$Bold
            }
        ],
        actions: [
            {
                content: [
                    (0, $lFP7n.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`
            }
        ]
    });

});
parcelRegister("lFP7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $20d9124b1f2da319$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $20d9124b1f2da319$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    workItemCreatedSuccessfullyTitle: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-created-successfully-title",
        "defaultMessage": "Created {issueKey}"
    },
    workItemChangedStatusDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-changed-status-description",
        "defaultMessage": "Created <Bold>{issueKey}</Bold> with <Bold>{statusName}</Bold> status"
    },
    workItemHiddenDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-hidden-description",
        "defaultMessage": "<Bold>{issueKey}</Bold> is hidden because a filter is applied. Clear the filter to see all work items."
    },
    rerankingPromptDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.reranking-prompt-description",
        "defaultMessage": "Select <Bold>apply ranking</Bold> to create and reorder work in specific positions."
    },
    applyRanking: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.apply-ranking",
        "defaultMessage": "Apply ranking"
    },
    viewWorkItem: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.view-work-item",
        "defaultMessage": "View {issueKey}"
    },
    issueHiddenDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.issue-hidden-description",
        "defaultMessage": "<Bold>{issueKey}</Bold> is hidden because a filter is applied. Clear the filter to see all issues."
    }
});

});



parcelRegister("3ElzA", function(module, exports) {

$parcel$export(module.exports, "useQueuedMutationCommit", () => $13f1b54ac5fcbf64$export$4eb3ddef28ed9675);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");
const $13f1b54ac5fcbf64$export$4eb3ddef28ed9675 = ({ generateDeferredVariables: generateDeferredVariables })=>{
    const running = (0, $eJOHy.useRef)(false);
    const queue = (0, $eJOHy.useRef)([]);
    /**
   * Dispose of any queued commits (in backwards order) and requeue each commit (which will execute the first commit
   * immediately). We need to explicitly dispose and requeue commits so optimistic updates are performed in the
   * correct order when the first queued commit is executed.
   */ const dequeue = (0, $eJOHy.useCallback)(()=>{
        running.current = false;
        const requeue = [];
        while(queue.current.length){
            const entry = queue.current.pop();
            if (entry) {
                entry.dispose();
                requeue.unshift(entry.requeue);
            }
        }
        requeue.forEach((fn)=>fn());
    }, []);
    const queuedCommit = (0, $eJOHy.useCallback)((environment, config)=>{
        const disposables = [];
        const requeue = ()=>{
            disposables.push(queuedCommit(environment, config));
        };
        const dispose = ()=>{
            while(disposables.length)disposables.pop()?.dispose();
        };
        const commit = ()=>{
            running.current = true;
            const disposable = (0, $j4oe4.commitMutation)(environment, {
                ...config,
                variables: generateDeferredVariables ? generateDeferredVariables(config.variables) : config.variables,
                onCompleted: (response, errors)=>{
                    // Run any queued commits after the mutation has completed
                    dequeue();
                    config.onCompleted?.(response, errors);
                },
                onError: (error)=>{
                    // Run any queued commits after the mutation has failed
                    dequeue();
                    config.onError?.(error);
                }
            });
            disposables.push(disposable);
        };
        if (!running.current) commit();
        else {
            const optimisticDisposable = (0, $j4oe4.applyOptimisticMutation)(environment, config);
            disposables.push(optimisticDisposable);
            queue.current.push({
                requeue: requeue,
                dispose: dispose
            });
        }
        // Return a new disposable that cleans up the optimistic AND committed operations
        return {
            dispose: dispose
        };
    }, [
        dequeue,
        generateDeferredVariables
    ]);
    return queuedCommit;
};

});

parcelRegister("d0yFI", function(module, exports) {

$parcel$export(module.exports, "issueConnectionUpdater", () => $7fde21bc9a1cb8cc$export$340227f0fce3ad1b);
$parcel$export(module.exports, "removeHighlightAfterDelay", () => $7fde21bc9a1cb8cc$export$c6f131ddea3d52b7);

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $iU3tR = parcelRequire("iU3tR");

var $8jOO7 = parcelRequire("8jOO7");

var $57Nys = parcelRequire("57Nys");

var $cf7fh = parcelRequire("cf7fh");
const $7fde21bc9a1cb8cc$export$340227f0fce3ad1b = (store, { issue: issue, issueConnectionId: issueConnectionId, parentItemConnectionId: parentItemConnectionId, issueRecordId: issueRecordId, fieldSetsConnectionId: fieldSetsConnectionId, insertAfter: insertAfter = true, insertNodeId: insertNodeId, getRealId: getRealId = (id)=>id, projectKey: projectKey, groupId: groupId })=>{
    (0, $iU3tR.highlightIssueRow)(store, issue, true);
    const issueRecord = store.get(issueRecordId);
    const connectionRecord = store.get(issueConnectionId);
    const fieldSetsRecord = store.get(fieldSetsConnectionId);
    if (!issueRecord || !connectionRecord || !fieldSetsRecord) return;
    if (parentItemConnectionId) {
        const updateArgs = projectKey ? {
            filterByProjectKeys: [
                projectKey
            ]
        } : undefined;
        store.get(parentItemConnectionId)?.setValue(true, 'hasChildren', updateArgs);
    }
    const edge = (0, $j4oe4.ConnectionHandler).createEdge(store, connectionRecord, issueRecord, 'JiraIssueEdge');
    // don't insert the same edge in case optimisticUpdater gets called multiple times
    if ((0, $cf7fh.hasEdge)(connectionRecord, edge) && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) return;
    const updateArgs = projectKey ? {
        projectKey: projectKey
    } : undefined;
    const canHaveChildIssues = issueRecord.getValue('canHaveChildIssues', updateArgs);
    if (canHaveChildIssues) edge.setValue(true, 'canHaveChildIssues', updateArgs);
    let realNodeId = insertNodeId;
    if (insertNodeId != null) realNodeId = getRealId(insertNodeId) ?? insertNodeId;
    if (insertAfter) (0, $cf7fh.insertEdgeAfter)(connectionRecord, edge, realNodeId);
    else (0, $cf7fh.insertEdgeBefore)(connectionRecord, edge, realNodeId);
    const fieldSets = edge.getOrCreateLinkedRecord('fieldSets', 'JiraIssueFieldSetEdge', {
        first: 500
    });
    fieldSets.copyFieldsFrom(fieldSetsRecord);
    const totalIssues = connectionRecord.getValue('totalIssueSearchResultCount');
    if (totalIssues != null && typeof totalIssues === 'number') connectionRecord.setValue(totalIssues + 1, 'totalIssueSearchResultCount');
    if (groupId) (0, $57Nys.updateGroupIssueCount)({
        store: store,
        groupId: groupId,
        netChangeInIssueCount: 1
    });
};
const $7fde21bc9a1cb8cc$export$c6f131ddea3d52b7 = (environment, issue)=>{
    setTimeout(()=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            (0, $iU3tR.highlightIssueRow)(store, issue, false);
        });
    }, (0, $8jOO7.HIGHLIGHT_LINGER_DURATION_MS));
};

});
parcelRegister("iU3tR", function(module, exports) {

$parcel$export(module.exports, "highlightIssueRow", () => $e7cd9c906a857a78$export$53e8a18b32fbb0d6);

var $9T6as = parcelRequire("9T6as");
const $e7cd9c906a857a78$export$53e8a18b32fbb0d6 = (store, issueRef, isHighlighted)=>{
    const { updatableData: updatableData } = store.readUpdatableFragment((0, $9T6as.default), issueRef);
    updatableData.isHighlightedIssueRow = isHighlighted;
};

});
parcelRegister("9T6as", function(module, exports) {

$parcel$export(module.exports, "default", () => $c63cf2ef0c18aa26$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cbfd986a9695ce8be5f34b186061834a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c63cf2ef0c18aa26$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "highlightIssueRow_update_isHighlightedIssueRow",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHighlightedIssueRow"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$c63cf2ef0c18aa26$var$node.hash = "5d94f587c290893134bcec9a782eee62";
var $c63cf2ef0c18aa26$export$2e2bcd8739ae039 = $c63cf2ef0c18aa26$var$node;

});


parcelRegister("57Nys", function(module, exports) {

$parcel$export(module.exports, "getIssueIndexInConnection", () => $88b8327741a45694$export$fc68d8bf4e03e424);
$parcel$export(module.exports, "updateGroupIssueCount", () => $88b8327741a45694$export$9d5e7224bfc56344);
$parcel$export(module.exports, "updateParentHasChildren", () => $88b8327741a45694$export$49a0ddeeed46a5b);
$parcel$export(module.exports, "useUpdateConnectionDetails", () => $88b8327741a45694$export$8ce878b875ed1164);
$parcel$export(module.exports, "insertNewGroupInGroupsConnection", () => $88b8327741a45694$export$4369efd6760b11d0);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $kqd31 = parcelRequire("kqd31");

var $7jTnu = parcelRequire("7jTnu");

var $dLXgn = parcelRequire("dLXgn");
const $88b8327741a45694$var$JIRA_SPREADSHEET_GROUP_TYPENAME = 'JiraSpreadsheetGroup';
const $88b8327741a45694$export$fc68d8bf4e03e424 = ({ issues: issues, issuesWithContext: issuesWithContext, context: context })=>{
    let foundMovedIssue = false;
    // There is a possible race condition where the bulk query for positions fires without all the issue subscriptions arriving (when an issue is created right as the timeout for the client finishes)
    // In those cases, we should use relative positioning instead of the absolute position where possible to prevent issues from being inserted at the wrong position
    const relativeIssueIndex = issues.findIndex((issue)=>{
        const issueId = issue.getLinkedRecord('node')?.getValue('issueId');
        if (issueId === context.sourceIssueId) foundMovedIssue = true;
        if (!issueId || typeof issueId === 'string' && issuesWithContext.has(issueId)) return false;
        return issueId === context.afterIssueId || issueId === context.beforeIssueId;
    });
    let relativePosition;
    if (relativeIssueIndex !== -1) {
        const relativeIssue = issues[relativeIssueIndex];
        const relativeIssueId = relativeIssue?.getLinkedRecord('node')?.getValue('issueId');
        if (relativeIssueId === context.afterIssueId) relativePosition = relativeIssueIndex;
        else if (relativeIssueId === context.beforeIssueId) relativePosition = relativeIssueIndex + 1;
        if (foundMovedIssue && relativePosition != null) // if we moved the issue down the list, we need to adjust the position otherwise its original position in the list impacts the index of all issues after
        relativePosition -= 1;
    }
    return relativePosition ?? context.position;
};
const $88b8327741a45694$var$removeGroupFromConnection = ({ store: store, groupId: groupId, connectionId: connectionId, groupConnectionId: groupConnectionId })=>{
    if (!groupConnectionId) return;
    if (connectionId) {
        // invalidate connection for next incoming updates.
        const connectionRecord = store.get(connectionId);
        connectionRecord?.invalidateRecord();
    }
    const relayId = (0, $kqd31.default)({
        id: groupId
    }, $88b8327741a45694$var$JIRA_SPREADSHEET_GROUP_TYPENAME);
    const groupConnectionRecord = store.get(groupConnectionId);
    if (!groupConnectionRecord || !relayId) return;
    (0, $37Ewn.ConnectionHandler).deleteNode(groupConnectionRecord, relayId);
    // Remove the firstGroup reference if it's the same as the group being removed
    if (groupConnectionRecord.getLinkedRecord('firstGroup')?.getDataID() === relayId) groupConnectionRecord.setValue(null, 'firstGroup');
};
const $88b8327741a45694$export$9d5e7224bfc56344 = ({ store: store, groupId: groupId, netChangeInIssueCount: netChangeInIssueCount, groupConnectionId: groupConnectionId, connectionId: connectionId })=>{
    const relayId = (0, $kqd31.default)({
        id: groupId
    }, $88b8327741a45694$var$JIRA_SPREADSHEET_GROUP_TYPENAME);
    if (!relayId) return;
    const groupRecord = store.get(relayId);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueCount = groupRecord?.getValue('issueCount') || 0;
    const newIssueCount = issueCount + netChangeInIssueCount;
    if (newIssueCount <= 0) $88b8327741a45694$var$removeGroupFromConnection({
        store: store,
        groupId: groupId,
        connectionId: connectionId,
        groupConnectionId: groupConnectionId
    });
    else groupRecord?.setValue(newIssueCount, 'issueCount');
};
const $88b8327741a45694$export$49a0ddeeed46a5b = ({ store: store, parentIssueEdgeRecordId: parentIssueEdgeRecordId, connectionId: connectionId, hasChildren: hasChildren, projectKey: projectKey })=>{
    // returns whether an update was performed
    const parentIssueRecord = store.get(parentIssueEdgeRecordId);
    const updateArgs = projectKey ? {
        filterByProjectKeys: [
            projectKey
        ]
    } : undefined;
    if (parentIssueRecord && parentIssueRecord.getValue('hasChildren', updateArgs) !== hasChildren) {
        parentIssueRecord?.setValue(hasChildren, 'hasChildren', updateArgs);
        if (hasChildren === false && connectionId && (0, $7jTnu.fg)('jsc_list_reparenting')) {
            const connectionRecord = store.get(connectionId);
            connectionRecord?.invalidateRecord();
        }
        return true;
    }
    return false;
};
const $88b8327741a45694$export$8ce878b875ed1164 = ()=>{
    const { removeConnection: removeConnectionFromList } = (0, $dLXgn.useConnectionsListActions)();
    return (0, $eJOHy.useCallback)(({ store: store, connection: connection, netChangeInIssueCount: netChangeInIssueCount, remainingIssueCount: remainingIssueCount, groupConnectionId: groupConnectionId, projectKey: projectKey })=>{
        if (remainingIssueCount === undefined) return;
        switch(connection.type){
            case 'GROUP_CHILDREN':
                $88b8327741a45694$export$9d5e7224bfc56344({
                    store: store,
                    groupId: connection.groupId,
                    netChangeInIssueCount: netChangeInIssueCount,
                    groupConnectionId: groupConnectionId,
                    connectionId: connection.connectionId
                });
                break;
            case 'PARENT_CHILDREN':
                $88b8327741a45694$export$49a0ddeeed46a5b({
                    store: store,
                    parentIssueEdgeRecordId: connection.parentRelayId,
                    connectionId: connection.connectionId,
                    hasChildren: remainingIssueCount > 0,
                    projectKey: projectKey
                });
                break;
            case 'ROOT_ISSUES':
                {
                    const connectionRecord = store.get(connection.connectionId);
                    if (!connectionRecord) break;
                    const totalIssues = connectionRecord.getValue('totalIssueSearchResultCount');
                    if (totalIssues != null && typeof totalIssues === 'number') connectionRecord.setValue(totalIssues + netChangeInIssueCount, 'totalIssueSearchResultCount');
                    break;
                }
            default:
        }
        if (remainingIssueCount === 0) removeConnectionFromList(connection);
    }, [
        removeConnectionFromList
    ]);
};
function $88b8327741a45694$var$insertEdgeAtPosition(existingEdges, newEdge, index) {
    return [
        ...existingEdges.slice(0, index),
        newEdge,
        ...existingEdges.slice(index)
    ];
}
const $88b8327741a45694$export$4369efd6760b11d0 = ({ store: store, groupsConnection: groupsConnection, newGroup: newGroup, groupEdges: groupEdges, afterGroupId: afterGroupId })=>{
    const newGroupEdge = (0, $37Ewn.ConnectionHandler).createEdge(store, groupsConnection, newGroup, 'JiraSpreadsheetGroupEdge');
    if (afterGroupId === null) return $88b8327741a45694$var$insertEdgeAtPosition(groupEdges, newGroupEdge, 0);
    const afterGroupIndex = groupEdges.findIndex((edge)=>edge.getLinkedRecord('node')?.getValue('id') === afterGroupId);
    if (afterGroupIndex !== -1) return $88b8327741a45694$var$insertEdgeAtPosition(groupEdges, newGroupEdge, afterGroupIndex + 1);
    return groupEdges;
};

});

parcelRegister("cf7fh", function(module, exports) {

$parcel$export(module.exports, "insertEdgeBefore", () => $0d35c4acd0065c5a$export$af841f09852c57d0);
$parcel$export(module.exports, "insertEdgeAfter", () => $0d35c4acd0065c5a$export$10e6263a191d72a0);
$parcel$export(module.exports, "hasEdge", () => $0d35c4acd0065c5a$export$da04cd0b23213625);

var $37Ewn = parcelRequire("37Ewn");
const $0d35c4acd0065c5a$var$findEdgeIndex = (edges, id)=>{
    if (id == null) return -1;
    const { NODE: NODE } = (0, $37Ewn.ConnectionInterface).get();
    return edges.findIndex((edge)=>edge.getLinkedRecord(NODE)?.getValue('id') === id);
};
const $0d35c4acd0065c5a$export$af841f09852c57d0 = (record, newEdge, id)=>{
    const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const index = $0d35c4acd0065c5a$var$findEdgeIndex(edges, id);
    let nextEdges;
    if (index === -1) nextEdges = [
        newEdge
    ].concat(edges);
    else nextEdges = edges.slice(0, index).concat(newEdge).concat(edges.slice(index));
    record.setLinkedRecords(nextEdges, EDGES);
};
const $0d35c4acd0065c5a$export$10e6263a191d72a0 = (record, newEdge, id)=>{
    const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const index = $0d35c4acd0065c5a$var$findEdgeIndex(edges, id);
    let nextEdges;
    if (index === -1) nextEdges = edges.concat(newEdge);
    else nextEdges = edges.slice(0, index + 1).concat(newEdge).concat(edges.slice(index + 1));
    record.setLinkedRecords(nextEdges, EDGES);
};
const $0d35c4acd0065c5a$export$da04cd0b23213625 = (record, edge)=>{
    const { NODE: NODE, EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const edgeIndex = edges.findIndex((e)=>e.getLinkedRecord(NODE)?.getValue('id') === edge.getLinkedRecord(NODE)?.getValue('id'));
    return edgeIndex > -1;
};

});


parcelRegister("5NEjg", function(module, exports) {

$parcel$export(module.exports, "IssueFetchQueryVariablesContainer", () => $9a9cd43ba0376cc5$export$72556f17a9cf678b);
$parcel$export(module.exports, "useIssueFetchQueryVariables", () => $9a9cd43ba0376cc5$export$52ce8dcf7591a458);

var $cSmYj = parcelRequire("cSmYj");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $9a9cd43ba0376cc5$export$72556f17a9cf678b = (0, $6E16M.createContainer)();
const $9a9cd43ba0376cc5$export$d4c72bab9d6cc13a = {
    fieldSetIds: []
};
const $9a9cd43ba0376cc5$var$updateStore = ()=>({ setState: setState, getState: getState }, { fieldSetIds: fieldSetIds })=>{
        const state = getState();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(fieldSetIds, state.fieldSetIds)) setState({
            fieldSetIds: fieldSetIds
        });
    };
const $9a9cd43ba0376cc5$var$Store = (0, $GtRbT.createStore)({
    containedBy: $9a9cd43ba0376cc5$export$72556f17a9cf678b,
    initialState: $9a9cd43ba0376cc5$export$d4c72bab9d6cc13a,
    actions: {},
    handlers: {
        onInit: $9a9cd43ba0376cc5$var$updateStore,
        onContainerUpdate: $9a9cd43ba0376cc5$var$updateStore
    }
});
const $9a9cd43ba0376cc5$export$52ce8dcf7591a458 = (0, $iJq0l.createStateHook)($9a9cd43ba0376cc5$var$Store);

});

parcelRegister("brgMm", function(module, exports) {

$parcel$export(module.exports, "useIssueFetchAndAppend", () => $49b35233f04752af$export$e36c00c1dfa0c592);

var $jy7L6 = parcelRequire("jy7L6");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kEUB1 = parcelRequire("kEUB1");

var $6bbL3 = parcelRequire("6bbL3");

var $7jTnu = parcelRequire("7jTnu");

var $34oCh = parcelRequire("34oCh");

var $d0yFI = parcelRequire("d0yFI");

var $5NEjg = parcelRequire("5NEjg");
const $49b35233f04752af$var$issueConnectionQueryUpdater = (environment, response, issueConnectionId, insertionArgs, groupId)=>{
    const issue = response?.jira?.issueByKey;
    if (!issue) return;
    (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        (0, $d0yFI.issueConnectionUpdater)(store, {
            ...insertionArgs,
            issue: issue,
            issueConnectionId: issueConnectionId,
            issueRecordId: issue.__id,
            fieldSetsConnectionId: issue.fieldSetsById.__id,
            groupId: groupId
        });
    });
    (0, $d0yFI.removeHighlightAfterDelay)(environment, issue);
};
const $49b35233f04752af$export$e36c00c1dfa0c592 = ({ issueConnectionId: issueConnectionId, groupContextFieldInput: groupContextFieldInput, jql: jql })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const { fieldSetIds: fieldSetIds } = (0, $5NEjg.useIssueFetchQueryVariables)();
    const shouldSkipIssuesConnectionUpdateAndShowFlag = (0, $6bbL3.useShouldSkipIssuesConnectionUpdate)();
    return (0, $eJOHy.useCallback)((issueKey, insertionArgs)=>{
        if (!issueConnectionId) return null;
        (0, $j4oe4.fetchQuery)(environment, (0, $jy7L6.default), {
            cloudId: cloudId,
            issueKey: issueKey,
            fieldSetIds: fieldSetIds,
            isInlineEditingEnabled: isInlineEditingEnabled,
            isDensityFull: isDensityFull,
            isConditionalFormattingEnabled: false,
            ...groupContextFieldInput ? {
                shouldQueryFieldsByIdOrAlias: true,
                fieldIdsOrAliases: [
                    groupContextFieldInput.fieldId
                ]
            } : {
                shouldQueryFieldsByIdOrAlias: false,
                fieldIdsOrAliases: []
            },
            ...jql ? {
                shouldQueryMatchesIssueSearch: true,
                issueSearchInput: {
                    jql: jql
                }
            } : {
                shouldQueryMatchesIssueSearch: false,
                issueSearchInput: {
                    jql: ''
                }
            },
            isGroupByAnyFieldsTechnicalEnabled: (0, $7jTnu.fg)('group_by_any_fields_technical'),
            isTimelineEnabled: isTimelineEnabled
        }).subscribe({
            next: (data)=>{
                if (shouldSkipIssuesConnectionUpdateAndShowFlag(groupContextFieldInput, data?.jira?.issueByKey)) return;
                $49b35233f04752af$var$issueConnectionQueryUpdater(environment, data, issueConnectionId, insertionArgs, groupContextFieldInput?.groupId);
            }
        });
    }, [
        cloudId,
        environment,
        fieldSetIds,
        isDensityFull,
        isInlineEditingEnabled,
        issueConnectionId,
        groupContextFieldInput,
        jql,
        shouldSkipIssuesConnectionUpdateAndShowFlag,
        isTimelineEnabled
    ]);
};

});
parcelRegister("jy7L6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b496f8d67dfd63d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dea495355940815309bfeca9d936fc59>>
 * @relayHash eab7f764ceddcd7dc2b49b3a4ad3ad83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 656a9e0ffc4c6b96bf98794ec066b924e8f5839c82840ee935af3aeac0e99ebb

var $kZq2R = parcelRequire("kZq2R");

var $5CxJ3 = parcelRequire("5CxJ3");

var $eHMRp = parcelRequire("eHMRp");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $bU8Sj = parcelRequire("bU8Sj");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");
const $2b496f8d67dfd63d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldIdsOrAliases"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isGroupByAnyFieldsTechnicalEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldsByIdOrAlias"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryMatchesIssueSearch"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v16 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v17 = [
        {
            "kind": "Variable",
            "name": "idsOrAliases",
            "variableName": "fieldIdsOrAliases"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v21 = {
        "kind": "ScalarField",
        "name": "name"
    }, v22 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "JiraPriorityField"
    }, v24 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v28 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "number"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": [
            v29 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v21 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraLabelsField"
    }, v32 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v26 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v34 = [
        v33 /*: any*/ 
    ], v35 = [
        {
            "concreteType": "JiraVersionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": v34 /*: any*/ 
                }
            ]
        }
    ], v36 = {
        "condition": "shouldQueryMatchesIssueSearch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "kind": "ScalarField",
                "name": "matchesIssueSearch"
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "type"
    }, v38 = {
        "kind": "ScalarField",
        "name": "id"
    }, v39 = {
        "kind": "ScalarField",
        "name": "value"
    }, v40 = [
        v39 /*: any*/ ,
        v38 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v41 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v42 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v43 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v44 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v45 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v46 = {
        "kind": "ScalarField",
        "name": "text"
    }, v47 = {
        "kind": "InlineFragment",
        "selections": [
            v46 /*: any*/ ,
            v21 /*: any*/ ,
            v41 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v48 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v49 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v38 /*: any*/ 
        ]
    }, v50 = [
        v48 /*: any*/ 
    ], v51 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v52 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v53 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v54 = [
        v38 /*: any*/ 
    ], v55 = [
        v21 /*: any*/ ,
        v38 /*: any*/ 
    ], v56 = {
        "kind": "ScalarField",
        "name": "date"
    }, v57 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v58 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v59 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v58 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v60 = [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                },
                v21 /*: any*/ ,
                v38 /*: any*/ 
            ]
        }
    ], v61 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v46 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v62 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v49 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v63 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v64 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v63 /*: any*/ ,
                    v21 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            },
            v38 /*: any*/ 
        ]
    }, v65 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v66 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v67 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v59 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v68 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v69 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v70 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v71 = [
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v56 /*: any*/ 
            ],
            "type": "JiraDatePickerField"
        },
        v38 /*: any*/ 
    ], v72 = [
        v18 /*: any*/ ,
        v24 /*: any*/ ,
        v38 /*: any*/ 
    ], v73 = [
        v33 /*: any*/ ,
        v38 /*: any*/ 
    ], v74 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": v73 /*: any*/ 
            }
        ],
        "type": "JiraSingleVersionPickerField"
    }, v75 = [
        v18 /*: any*/ ,
        v38 /*: any*/ 
    ], v76 = [
        v25 /*: any*/ ,
        v38 /*: any*/ 
    ], v77 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v76 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueFetchAndAppendQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "highlightIssueRow_update_isHighlightedIssueRow"
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v15 /*: any*/ ,
                                        "concreteType": "JiraIssueFieldSetConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldSetsById",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isConditionalFormattingEnabled",
                                                        "variableName": "isConditionalFormattingEnabled"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isDensityFull",
                                                        "variableName": "isDensityFull"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isInlineEditingEnabled",
                                                        "variableName": "isInlineEditingEnabled"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isTimelineEnabled",
                                                        "variableName": "isTimelineEnabled"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
                                            },
                                            v16 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.issueByKey.fieldSetsById"
                                },
                                {
                                    "condition": "shouldQueryFieldsByIdOrAlias",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "fieldsByIdOrAlias",
                                            "plural": true,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v24 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "fieldOption",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedSprintsConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                v30 /*: any*/ ,
                                                {
                                                    "condition": "isGroupByAnyFieldsTechnicalEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v31 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": v26 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v32 /*: any*/ ,
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v32 /*: any*/ ,
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": v35 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersion",
                                                                    "kind": "LinkedField",
                                                                    "name": "version",
                                                                    "plural": false,
                                                                    "selections": v34 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleVersionPickerField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v36 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v8 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v9 /*: any*/ ,
                v11 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueFetchAndAppendQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraIssueFieldSetConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldSetsById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSet",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldSetId"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v37 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                },
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "serviceId"
                                                                                                                },
                                                                                                                v21 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraAffectedServicesField"
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v40 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v40 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v42 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        v44 /*: any*/ ,
                                                                                                                        v38 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v45 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        v47 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v39 /*: any*/ ,
                                                                                                        v49 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": v50 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v39 /*: any*/ ,
                                                                                                                        v25 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v39 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v24 /*: any*/ ,
                                                                                                                        v21 /*: any*/ ,
                                                                                                                        v51 /*: any*/ ,
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "timeTrackingField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v41 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraEstimate",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "originalEstimate",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "timeInSeconds"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingSettings",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "workingHoursPerDay"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "workingDaysPerWeek"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "defaultFormat"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "defaultUnit"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v19 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v37 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v53 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        v43 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v42 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v21 /*: any*/ ,
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        v44 /*: any*/ ,
                                                                                                                        v33 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": v54 /*: any*/ 
                                                                                                },
                                                                                                {
                                                                                                    "args": v42 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v13 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v16 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                v41 /*: any*/ ,
                                                                                                v16 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v42 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "href"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "objectId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "label"
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "mediaClientConfig",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "clientId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "fileId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "url48"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "QueryError",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "errors",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "message"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraCMDBField"
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "componentsOld",
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v55 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v46 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v56 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        v57 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDatePickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDateTimePickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraEpic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "epic",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "summary"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "color"
                                                                                                },
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraEpicLinkField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "renderedFieldHtml"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFallbackField"
                                                                                },
                                                                                v47 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatusCategory",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "statusCategory",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v58 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusCategoryField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v20 /*: any*/ ,
                                                                                                v59 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraLabelConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedLabelsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraLabel",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v21 /*: any*/ ,
                                                                                                                v49 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v48 /*: any*/ 
                                                                                            ],
                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraLabelsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": v60 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": v60 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "parentIssue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                v61 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        v62 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        v61 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        v62 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        v61 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        v14 /*: any*/ ,
                                                                                                        v65 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "ids",
                                                                                                                    "value": [
                                                                                                                        "issuetype",
                                                                                                                        "project",
                                                                                                                        "summary",
                                                                                                                        "status"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsById",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v46 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueType",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v66 /*: any*/ ,
                                                                                                                                                v21 /*: any*/ ,
                                                                                                                                                v63 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "hierarchy",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "level"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                v38 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v67 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v21 /*: any*/ ,
                                                                                                v41 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraParentIssueField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraProject",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "project",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "large"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraResolution",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "resolution",
                                                                                            "plural": false,
                                                                                            "selections": v55 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraResolutionField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraSprintConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedSprintsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprint",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "state"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "endDate"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSprintField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v51 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                v52 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v57 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraVersionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedVersionsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": v55 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRichText",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "richText",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraADF",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "adfValue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "condition": "isDensityFull",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "isDensityFull",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "json"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraRichTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "requestType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v63 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v27 /*: any*/ ,
                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueLinkConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v48 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v65 /*: any*/ ,
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "statusCategory"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v18 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v59 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                },
                                                                                                                                                v38 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                        },
                                                                                                                        v38 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v68 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueLinkField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isStoryPointField"
                                                                                        },
                                                                                        v29 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                v29 /*: any*/ ,
                                                                                                v69 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                v29 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                v41 /*: any*/ ,
                                                                                                v69 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraNumberField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroupConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedGroupsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroup",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "groupId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLink",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "direction"
                                                                                                        },
                                                                                                        v68 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "type",
                                                                                                            "plural": false,
                                                                                                            "selections": v54 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "isInlineEditingEnabled",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isEditableInIssueView"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkRelationshipTypeField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "isTimelineEnabled",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v55 /*: any*/ 
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v67 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "assigneeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "user",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v51 /*: any*/ ,
                                                                                                                        v38 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "args": v70 /*: any*/ ,
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "startDateViewField",
                                                                                                            "plural": false,
                                                                                                            "selections": v71 /*: any*/ ,
                                                                                                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                        },
                                                                                                        {
                                                                                                            "args": v70 /*: any*/ ,
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "endDateViewField",
                                                                                                            "plural": false,
                                                                                                            "selections": v71 /*: any*/ ,
                                                                                                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraTimelineField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": v50 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConditionalFormattingEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v42 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "componentId"
                                                                                                                        },
                                                                                                                        v38 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v72 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "projectId"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        v74 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v66 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v42 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": v35 /*: any*/ ,
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v75 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedValues",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v75 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v53 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ 
                                    ]
                                },
                                v38 /*: any*/ ,
                                {
                                    "condition": "shouldQueryFieldsByIdOrAlias",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "fieldsByIdOrAlias",
                                            "plural": true,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": v72 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "fieldOption",
                                                            "plural": false,
                                                            "selections": v76 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28 /*: any*/ ,
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedSprintsConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                v30 /*: any*/ ,
                                                {
                                                    "condition": "isGroupByAnyFieldsTechnicalEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v31 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": v76 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v77 /*: any*/ ,
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v77 /*: any*/ ,
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersion",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v73 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        v74 /*: any*/ 
                                                    ]
                                                },
                                                v38 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v36 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "656a9e0ffc4c6b96bf98794ec066b924e8f5839c82840ee935af3aeac0e99ebb",
            "metadata": {},
            "name": "issueFetchAndAppendQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $eHMRp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider": (0, $5CxJ3.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default)
            }
        }
    };
}();
$2b496f8d67dfd63d$var$node.hash = "010ae4dc60bc9b91431b244e2bc0fad0";
var $2b496f8d67dfd63d$export$2e2bcd8739ae039 = $2b496f8d67dfd63d$var$node;

});


parcelRegister("dhVsI", function(module, exports) {

$parcel$export(module.exports, "toIssueCreateInput", () => $9a20f8fc188f0eb6$export$8430ab93380b81ae);

var $16aVR = parcelRequire("16aVR");

var $57raR = parcelRequire("57raR");

var $7jTnu = parcelRequire("7jTnu");

var $8ntPR = parcelRequire("8ntPR");
const $9a20f8fc188f0eb6$var$mapContextualFieldDataToInput = (payload)=>{
    let rank;
    if (payload.rankBeforeIssueId) rank = {
        beforeIssueId: payload.rankBeforeIssueId
    };
    else if (payload.rankAfterIssueId) rank = {
        afterIssueId: payload.rankAfterIssueId
    };
    return {
        rank: rank
    };
};
const $9a20f8fc188f0eb6$var$generateRankInput = (payload)=>{
    if (payload.rankBeforeIssueId) return {
        beforeIssueId: payload.rankBeforeIssueId
    };
    if (payload.rankAfterIssueId) return {
        afterIssueId: payload.rankAfterIssueId
    };
    return undefined;
};
const $9a20f8fc188f0eb6$export$8430ab93380b81ae = ({ project: project, issueType: issueType, summary: summary, assignee: assignee, dueDate: dueDate }, contextualFields, groupContextFieldInput, isIssueRankingEnabled)=>{
    if (!summary.trim().length) return null;
    const input = {
        projectId: project.id,
        issueTypeId: issueType.id,
        fields: {
            singleLineTextFields: [
                {
                    fieldId: 'summary',
                    text: summary
                }
            ],
            ...contextualFields.parentIssueAri !== undefined && {
                parentField: {
                    issueId: contextualFields.parentIssueAri
                }
            },
            ...groupContextFieldInput && (0, $8ntPR.convertFieldToIssueCreateInput)(groupContextFieldInput),
            ...assignee && (0, $7jTnu.fg)('jira_render_pic_in_nin') && {
                singleSelectUserPickerFields: [
                    {
                        fieldId: 'assignee',
                        user: {
                            accountId: assignee.accountId
                        }
                    }
                ]
            },
            ...dueDate && (0, $7jTnu.fg)('jira_render_pic_in_nin') && {
                datePickerFields: [
                    {
                        fieldId: 'duedate',
                        date: {
                            formattedDate: (0, $57raR.default)(dueDate, 'dd/MMM/yy')
                        }
                    }
                ]
            }
        },
        rank: isIssueRankingEnabled && (0, $7jTnu.fg)('jsc_list_reranking_gate') ? $9a20f8fc188f0eb6$var$generateRankInput(contextualFields) : undefined
    };
    if ((0, $7jTnu.fg)('jsc_list_reranking_gate')) return input;
    return (0, (/*@__PURE__*/$parcel$interopDefault($16aVR)))(input, $9a20f8fc188f0eb6$var$mapContextualFieldDataToInput(contextualFields), (objValue, srcValue)=>{
        if (Array.isArray(objValue)) return objValue.concat(srcValue);
    });
};

});

parcelRegister("4uses", function(module, exports) {

$parcel$export(module.exports, "toOptimisticResponse", () => $9e8fadc0c70ba0f6$export$79353fa5e28d43d8);

var $57raR = parcelRequire("57raR");

var $7jTnu = parcelRequire("7jTnu");

var $8ntPR = parcelRequire("8ntPR");
const $9e8fadc0c70ba0f6$export$79353fa5e28d43d8 = ({ project: project, issueType: issueType, summary: summary, assignee: assignee, dueDate: dueDate }, optimisticId, isIssueHierarchyEnabled, groupContextFieldInput)=>{
    const issueId = optimisticId;
    const summaryEdge = summary ? $9e8fadc0c70ba0f6$var$toOptimisticSummary(issueId, summary) : null;
    const projectEdge = project ? $9e8fadc0c70ba0f6$var$toOptimisticProject(issueId, project) : null;
    const issueTypeEdge = issueType ? $9e8fadc0c70ba0f6$var$toOptimisticIssueType(issueId, issueType) : null;
    const assigneeEdge = assignee && (0, $7jTnu.fg)('jira_render_pic_in_nin') ? $9e8fadc0c70ba0f6$var$toOptimisticAssignee(issueId, assignee) : null;
    const dueDateEdge = dueDate && (0, $7jTnu.fg)('jira_render_pic_in_nin') ? $9e8fadc0c70ba0f6$var$toOptimisticDueDate(issueId, dueDate) : null;
    const edges = [
        summaryEdge,
        projectEdge,
        issueTypeEdge,
        assigneeEdge,
        dueDateEdge
    ].filter((edge)=>edge !== null);
    if (groupContextFieldInput) {
        if ((0, $7jTnu.fg)('jira_render_pic_in_nin')) {
            if (groupContextFieldInput.fieldId !== 'assignee' || assigneeEdge === null) {
                const groupContextFieldEdge = (0, $8ntPR.toOptimisticField)(issueId, groupContextFieldInput);
                edges.push(groupContextFieldEdge);
            }
        } else {
            const groupContextFieldEdge = (0, $8ntPR.toOptimisticField)(issueId, groupContextFieldInput);
            edges.push(groupContextFieldEdge);
        }
    }
    return {
        jira: {
            createIssue: {
                errors: null,
                issue: {
                    __typename: 'JiraIssue',
                    id: issueId,
                    issueId: issueId,
                    key: '',
                    fieldsByIdOrAlias: [],
                    fieldSetsById: {
                        edges: edges
                    },
                    matchesIssueSearch: undefined,
                    ...isIssueHierarchyEnabled ? {
                        issueTypeField: {
                            issueType: {
                                hierarchy: {
                                    level: issueType?.hierarchy?.level
                                },
                                id: issueType?.id
                            },
                            id: ''
                        },
                        canHaveChildIssues: false
                    } : {
                        issueTypeField: undefined,
                        canHaveChildIssues: undefined
                    }
                }
            }
        }
    };
};
const $9e8fadc0c70ba0f6$var$toOptimisticSummary = (issueId, summary)=>({
        node: {
            fieldSetId: 'summary',
            type: 'summary',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleLineTextField',
                            __isJiraIssueField: 'JiraSingleLineTextField',
                            fieldId: 'summary',
                            id: `${issueId}/summary`,
                            name: 'Summary',
                            text: summary,
                            type: 'summary',
                            lazyIsEditableInIssueView: undefined
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticIssueType = (issueId, issueType)=>({
        node: {
            fieldSetId: 'issuetype',
            type: 'issuetype',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraIssueTypeField',
                            __isJiraIssueField: 'JiraIssueTypeField',
                            fieldId: 'issuetype',
                            id: `${issueId}/issuetype`,
                            type: 'issuetype',
                            issueType: {
                                id: issueType.id,
                                ...(0, $7jTnu.fg)('jira_list_conditional_formatting') && {
                                    issueTypeId: issueType.issueTypeId
                                },
                                name: issueType.name,
                                avatar: issueType.avatar
                            }
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticProject = (issueId, project)=>({
        node: {
            fieldSetId: 'project',
            type: 'project',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraProjectField',
                            __isJiraIssueField: 'JiraProjectField',
                            fieldId: 'project',
                            id: `${issueId}/project`,
                            type: 'project',
                            project: {
                                id: project.id,
                                ...(0, $7jTnu.fg)('jira_list_conditional_formatting') && {
                                    projectId: project.projectId
                                },
                                key: project.key,
                                name: project.name,
                                avatar: project.avatar
                            }
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticAssignee = (issueId, { accountId: accountId, name: name, picture: picture })=>({
        node: {
            fieldSetId: 'assignee',
            type: 'assignee',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleSelectUserPickerField',
                            __isJiraIssueField: 'JiraSingleSelectUserPickerField',
                            fieldId: 'assignee',
                            id: `${issueId}/assignee`,
                            type: 'assignee',
                            name: 'Assignee',
                            user: {
                                id: accountId,
                                accountId: accountId,
                                name: name,
                                picture: picture,
                                accountStatus: 'active',
                                __typename: 'AtlassianAccountUser'
                            }
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticDueDate = (issueId, dueDate)=>({
        node: {
            fieldSetId: 'duedate',
            type: 'duedate',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraDatePickerField',
                            __isJiraIssueField: 'JiraDatePickerField',
                            fieldId: 'duedate',
                            id: `${issueId}/duedate`,
                            type: 'duedate',
                            date: (0, $57raR.default)(dueDate, 'yyyy-MM-dd'),
                            name: 'Due Date',
                            fieldConfig: {
                                isRequired: false
                            }
                        }
                    }
                ]
            }
        }
    });

});

parcelRegister("5hgjg", function(module, exports) {

$parcel$export(module.exports, "useOptimisticId", () => $0e6eea24f2449862$export$753dc4430b354b6a);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");
const $0e6eea24f2449862$export$753dc4430b354b6a = ()=>{
    const optimisticIDtoReal = (0, $eJOHy.useRef)(new Map());
    const generateOptimisticId = (0, $eJOHy.useCallback)(()=>{
        const id = (0, $aXKmr.v4)();
        optimisticIDtoReal.current.set(id, undefined);
        return {
            id: id,
            saveRealId: (realId)=>{
                optimisticIDtoReal.current.set(id, realId);
            }
        };
    }, []);
    const getRealId = (0, $eJOHy.useCallback)((optimisticId)=>{
        return optimisticIDtoReal.current.get(optimisticId);
    }, []);
    return {
        generateOptimisticId: generateOptimisticId,
        getRealId: getRealId
    };
};

});



parcelRegister("jLqsN", function(module, exports) {

$parcel$export(module.exports, "PaginationControls", () => $75a4bc7d8078275f$export$ff17519edeb6015d);

var $hmBZO = parcelRequire("hmBZO");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $b3eVo = parcelRequire("b3eVo");

var $k71qx = parcelRequire("k71qx");

var $3LCex = parcelRequire("3LCex");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $21Au6 = parcelRequire("21Au6");
const $75a4bc7d8078275f$var$getFirstPage = (data)=>{
    if (data?.pageCursors?.first) return data?.pageCursors.first.pageNumber;
    if (data?.pageCursors?.around?.length) return data?.pageCursors.around[0]?.pageNumber;
    return undefined;
};
const $75a4bc7d8078275f$var$getLastPage = (data)=>{
    if (data?.pageCursors?.last) return data?.pageCursors.last.pageNumber;
    if (data?.pageCursors?.around?.length) return data?.pageCursors.around[data?.pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $75a4bc7d8078275f$var$getPageCursor = (data, page)=>{
    const { first: first, last: last, around: around } = data?.pageCursors ?? {};
    if (page === first?.pageNumber) return first?.cursor ?? undefined;
    if (page === last?.pageNumber) return last?.cursor ?? undefined;
    return around?.find((pageCursor)=>page === pageCursor?.pageNumber)?.cursor ?? undefined;
};
const $75a4bc7d8078275f$export$ff17519edeb6015d = ({ issues: issues, onPageChange: onPageChange, isNewFooterOrderEnabled: isNewFooterOrderEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $hmBZO.default), issues);
    const [optimisticCurrentPage, setOptimisticCurrentPage] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // Clear our optimistically set page number whenever fragment data changes.
        setOptimisticCurrentPage(null);
    }, [
        data
    ]);
    const pages = (0, $eJOHy.useMemo)(()=>{
        const firstPage = $75a4bc7d8078275f$var$getFirstPage(data) ?? 1;
        const lastPage = $75a4bc7d8078275f$var$getLastPage(data) ?? 1;
        return Array(lastPage - firstPage + 1).fill(undefined).map((_, i)=>firstPage + i);
    }, [
        data
    ]);
    const currentPage = optimisticCurrentPage ?? data?.pageCursors?.around?.find((pageCursor)=>pageCursor?.isCurrent)?.pageNumber ?? 1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onChange = (0, $eJOHy.useCallback)((_, page)=>{
        if (page === currentPage || optimisticCurrentPage !== null) return;
        const pageCursorToFetch = $75a4bc7d8078275f$var$getPageCursor(data, page);
        if (pageCursorToFetch != null) {
            setOptimisticCurrentPage(page);
            onPageChange(pageCursorToFetch);
            const attributes = {
                currentPage: currentPage,
                nextPage: page,
                randomAccess: Math.abs(page - currentPage) > 1,
                isLastPage: page === pages.length
            };
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'pageNumber'
            }), 'issueTablePagination', attributes);
        }
    }, [
        createAnalyticsEvent,
        currentPage,
        data,
        onPageChange,
        optimisticCurrentPage,
        pages.length
    ]); // Disable the pagination buttons while the selected page is optimistically rendered as we may not have page cursors
    // readily available for pages rendered on the UI.
    const OptimisticDisabledButtonRenderer = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ 'aria-label': ariaLabel, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": !ariaLabel && props.page ? formatMessage((0, $21Au6.default).pageButtonPrefix, {
                page: props.page
            }) : ariaLabel,
            disabled: props.disabled || optimisticCurrentPage !== null
        }), [
        formatMessage,
        optimisticCurrentPage
    ]);
    const OptimisticDisabledButtonRendererWithTooltip = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ 'aria-label': ariaLabel, ...props }, ref)=>props.disabled && optimisticCurrentPage == null && data?.isCappingIssueSearchResult ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $21Au6.default).disabledButtonTooltipIssueTermRefresh : (0, $21Au6.default).disabledButtonTooltip),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($75a4bc7d8078275f$var$FullHeightDisabledButton, {
            tabIndex: 0,
            isDisabled: true,
            "aria-label": formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $21Au6.default).disabledButtonTooltipIssueTermRefresh : (0, $21Au6.default).disabledButtonTooltip),
            "data-testid": "native-issue-table.ui.footer-renderer.pagination-controls.full-height-disabled-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": ariaLabel
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": ariaLabel,
            disabled: props.disabled || optimisticCurrentPage !== null
        }), [
        optimisticCurrentPage,
        data?.isCappingIssueSearchResult,
        formatMessage
    ]);
    const components = (0, $eJOHy.useMemo)(()=>{
        const OptimisticDisabledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(OptimisticDisabledButtonRenderer);
        const OptimisticDisabledButtonWithTooltip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(OptimisticDisabledButtonRendererWithTooltip);
        return {
            Page: OptimisticDisabledButton,
            Previous: OptimisticDisabledButton,
            Next: OptimisticDisabledButtonWithTooltip
        };
    }, [
        OptimisticDisabledButtonRenderer,
        OptimisticDisabledButtonRendererWithTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($75a4bc7d8078275f$var$PaginationContainer, {
        isFlexCenter: isNewFooterOrderEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3eVo.default), {
        testId: "native-issue-table.ui.footer-renderer.pagination-controls.pagination-controls",
        components: components,
        pages: pages,
        onChange: onChange,
        selectedIndex: currentPage - 1,
        max: 7,
        nextLabel: formatMessage((0, $21Au6.default).nextButton),
        previousLabel: formatMessage((0, $21Au6.default).prevButton)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75a4bc7d8078275f$var$FullHeightDisabledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $3LCex.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75a4bc7d8078275f$var$PaginationContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexCenter: isFlexCenter, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o",
            __cmplp.isFlexCenter ? "_1bah1h6o" : "_1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hmBZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b25c0e82857e8399$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3901018953637bca59dab12c8fc72e0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b25c0e82857e8399$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageSize"
            }
        ],
        "kind": "Fragment",
        "name": "paginationControls_nativeIssueTable",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCappingIssueSearchResult"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    },
                    {
                        "kind": "Variable",
                        "name": "pageSize",
                        "variableName": "pageSize"
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$b25c0e82857e8399$var$node.hash = "f6c43af42ef3986e51936f79243f5544";
var $b25c0e82857e8399$export$2e2bcd8739ae039 = $b25c0e82857e8399$var$node;

});

parcelRegister("b3eVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e9938bbbd4852c0$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $7O2l7 = parcelRequire("7O2l7");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $2xCo3 = parcelRequire("2xCo3");

var $6CP4r = parcelRequire("6CP4r");

var $3IiVn = parcelRequire("3IiVn");

var $1CN10 = parcelRequire("1CN10");

var $1hfAD = parcelRequire("1hfAD");
const $2e9938bbbd4852c0$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $2e9938bbbd4852c0$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $2e9938bbbd4852c0$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $2e9938bbbd4852c0$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $2e9938bbbd4852c0$var$InnerPagination({ components: components = (0, $1CN10.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1CN10.emptyObject), max: max = 7, onChange: onChange = (0, $3Vuhz.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $3IiVn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $7O2l7.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$2e9938bbbd4852c0$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "li",
            xcss: $2e9938bbbd4852c0$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CP4r.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $2e9938bbbd4852c0$var$styles.paginationMenu,
                    children: (0, $1hfAD.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $2e9938bbbd4852c0$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($2e9938bbbd4852c0$var$InnerPagination));
var $2e9938bbbd4852c0$export$2e2bcd8739ae039 = $2e9938bbbd4852c0$var$Pagination;

});
parcelRegister("a2JSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e34bc8237f35d48455854b605c0f874a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74fdae0df2a41f03$var$_react = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $74fdae0df2a41f03$var$_chevronLeft = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("8PCRQ")));

var $74fdae0df2a41f03$var$_chevronLeftLarge = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("k9ooi")));
function $74fdae0df2a41f03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74fdae0df2a41f03$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $74fdae0df2a41f03$var$_react.default.createElement($74fdae0df2a41f03$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $74fdae0df2a41f03$var$_chevronLeftLarge.default
    }, props));
$74fdae0df2a41f03$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $74fdae0df2a41f03$var$_default = module.exports.default = $74fdae0df2a41f03$var$ChevronLeftIcon;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("k9ooi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab7917427604e36$var$_react = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $eab7917427604e36$var$_chevronLeft = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("8PCRQ")));
function $eab7917427604e36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eab7917427604e36$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $eab7917427604e36$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $eab7917427604e36$var$_chevronLeft.default
    }));
$eab7917427604e36$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $eab7917427604e36$var$_default = module.exports.default = $eab7917427604e36$var$ChevronLeftLargeIcon;

});


parcelRegister("1kTzc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4724a1e5dc4e8ab6ea5bb133724929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f92c313e495a986$var$_react = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0f92c313e495a986$var$_chevronRight = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("cQxBL")));

var $0f92c313e495a986$var$_chevronRightLarge = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("czcci")));
function $0f92c313e495a986$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f92c313e495a986$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0f92c313e495a986$var$_react.default.createElement($0f92c313e495a986$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $0f92c313e495a986$var$_chevronRightLarge.default
    }, props));
$0f92c313e495a986$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $0f92c313e495a986$var$_default = module.exports.default = $0f92c313e495a986$var$ChevronRightIcon;

});
parcelRegister("czcci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9262370c29d80ea9$var$_react = $9262370c29d80ea9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $9262370c29d80ea9$var$_chevronRight = $9262370c29d80ea9$var$_interopRequireDefault((parcelRequire("cQxBL")));
function $9262370c29d80ea9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9262370c29d80ea9$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9262370c29d80ea9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9262370c29d80ea9$var$_chevronRight.default
    }));
$9262370c29d80ea9$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9262370c29d80ea9$var$_default = module.exports.default = $9262370c29d80ea9$var$ChevronRightLargeIcon;

});


parcelRegister("2xCo3", function(module, exports) {

$parcel$export(module.exports, "default", () => $390a465a7b875c7d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $390a465a7b875c7d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("6CP4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7a0738c73e50f62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $a7a0738c73e50f62$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("3IiVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $eee95bde3b212432$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6fs4r = parcelRequire("6fs4r");
const $eee95bde3b212432$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $eee95bde3b212432$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "li",
        testId: testId,
        xcss: $eee95bde3b212432$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("1CN10", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $1b85b3c8ab534085$export$3f860eba1218f8d3);
const $1b85b3c8ab534085$export$3f860eba1218f8d3 = {};

});

parcelRegister("1hfAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $916df7f6e7c50105$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $916df7f6e7c50105$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $916df7f6e7c50105$export$2e2bcd8739ae039 = $916df7f6e7c50105$var$collapseRange;

});


parcelRegister("3LCex", function(module, exports) {

$parcel$export(module.exports, "default", () => $0be296db7657e907$export$2e2bcd8739ae039);

var $cdbP5 = parcelRequire("cdbP5");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0be296db7657e907$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $cdbP5.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0be296db7657e907$export$2e2bcd8739ae039 = $0be296db7657e907$var$DisabledButtonWithTooltip;

});

parcelRegister("21Au6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea084c23b4d940a9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ea084c23b4d940a9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    nextButton: {
        "id": "native-issue-table.footer-renderer.pagination-controls.next-button",
        "defaultMessage": "Next page"
    },
    prevButton: {
        "id": "native-issue-table.footer-renderer.pagination-controls.prev-button",
        "defaultMessage": "Previous page"
    },
    pageButtonPrefix: {
        "id": "native-issue-table.footer-renderer.pagination-controls.page-button-prefix",
        "defaultMessage": "Page {page}"
    },
    disabledButtonTooltip: {
        "id": "native-issue-table.footer-renderer.pagination-controls.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonTooltipIssueTermRefresh: {
        "id": "native-issue-table.footer-renderer.pagination-controls.disabled-button-tooltip-issue-term-refresh",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more work."
    }
});

});



parcelRegister("7yfRR", function(module, exports) {

$parcel$export(module.exports, "IssueFetchQueryVariables", () => $50654ebf46a53d18$export$2cef1066f7674208);

var $eYj1O = parcelRequire("eYj1O");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5NEjg = parcelRequire("5NEjg");
const $50654ebf46a53d18$export$2cef1066f7674208 = ({ children: children, columns: columns })=>{
    const columnsData = (0, $j4oe4.useFragment)((0, $eYj1O.default), columns);
    const fieldSetIds = (0, $eJOHy.useMemo)(()=>columnsData.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        columnsData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5NEjg.IssueFetchQueryVariablesContainer), {
        fieldSetIds: fieldSetIds
    }, children);
};

});
parcelRegister("eYj1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd00ed105dd970c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<20ba60668b078076c74952de9fab8952>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dd00ed105dd970c5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueFetchQueryVariables_nativeIssueTable",
    "selections": [
        {
            "concreteType": "JiraIssueSearchFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fieldSetId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$dd00ed105dd970c5$var$node.hash = "03290a1a84f19d99043c011485a36598";
var $dd00ed105dd970c5$export$2e2bcd8739ae039 = $dd00ed105dd970c5$var$node;

});


parcelRegister("kmbgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1744fe6b66488abe$export$2e2bcd8739ae039);

var $ipznG = parcelRequire("ipznG");

var $92w1n = parcelRequire("92w1n");

var $78TK1 = parcelRequire("78TK1");

var $gXZv6 = parcelRequire("gXZv6");

var $fLEXm = parcelRequire("fLEXm");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $jE8Tu = parcelRequire("jE8Tu");

var $gM8ln = parcelRequire("gM8ln");

var $8jOO7 = parcelRequire("8jOO7");

var $hnyyS = parcelRequire("hnyyS");

var $34oCh = parcelRequire("34oCh");

var $Kdcei = parcelRequire("Kdcei");

var $pZqvR = parcelRequire("pZqvR");

var $hHg7L = parcelRequire("hHg7L");

var $6sUnz = parcelRequire("6sUnz");

var $hATyi = parcelRequire("hATyi");

var $jJgFJ = parcelRequire("jJgFJ");

var $eI4dM = parcelRequire("eI4dM");

var $l00LF = parcelRequire("l00LF");

var $kaSuB = parcelRequire("kaSuB");

var $4R6nP = parcelRequire("4R6nP");

var $7WpdI = parcelRequire("7WpdI");
const $1744fe6b66488abe$var$emptyArray = []; // We use rowsCount=50 by default to set the minimum table height until virtualizer reads it from DOM
const $1744fe6b66488abe$var$getInitialTableHeight = (rowsCount = 50)=>(0, $8jOO7.ROW_HEIGHT) * rowsCount + (0, $8jOO7.HEADER_HEIGHT);
const $1744fe6b66488abe$var$IssueTable = ({ view: view, columnPickerProps: columnPickerProps, columns: columns, NoIssues: NoIssues, canViewColumnConfiguration: canViewColumnConfiguration, canEditColumnConfiguration: canEditColumnConfiguration, issueResults: issueResults, groupResults: groupResults, project: project, rankField: rankField, loading: loading, NoColumns: NoColumns, onColumnsChange: onColumnsChange, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, tableInjectedProps: tableInjectedProps, tableRef: tableRef, isGroupingSupported: isGroupingSupported, isCompactColumnEnabled: isCompactColumnEnabled = false, onIssueFlatListUpdated: onIssueFlatListUpdated, tableBorderRadius: tableBorderRadius, ifcConfig: ifcConfig, columnsQueryRef: columnsQueryRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [resizingColumnIndex, setResizingColumnIndex] = (0, $eJOHy.useState)();
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7jTnu.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const customComponents = (0, $7jTnu.fg)('jira_native_issue_table_extra_custom_components') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $6sUnz.useCustomComponents)() : null;
    const InitializeVirtualizer = customComponents?.timeline?.InitializeVirtualizer ?? (0, $7WpdI.InitializeVirtualizer);
    const viewData = (0, $j4oe4.useFragment)((0, $fLEXm.default), view ?? null);
    const issueResultsData = (0, $j4oe4.useFragment)((0, $gXZv6.default), issueResults);
    const groupResultsData = (0, $j4oe4.useFragment)((0, $78TK1.default), groupResults);
    const projectData = (0, $j4oe4.useFragment)((0, $92w1n.default), project);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $ipznG.default), rankField);
    let flatList = $1744fe6b66488abe$var$emptyArray;
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        flatList = (0, $jE8Tu.useFlatList)(); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const flatListIssueKeys = (0, $jE8Tu.useFlatListIssueKeys)(); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const flatListIssueIds = (0, $jE8Tu.useIssueIds)(); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useEffect)(()=>{
            onIssueFlatListUpdated?.(flatListIssueKeys.filter(Boolean), flatListIssueIds);
        }, [
            flatList,
            flatListIssueIds,
            flatListIssueKeys,
            onIssueFlatListUpdated
        ]);
    }
    const getItemKey = (0, $eJOHy.useCallback)((index)=>{
        if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) return flatList[index] ?? index;
        return issueResultsData?.edges?.at(index)?.node?.key ?? index;
    }, [
        flatList,
        issueResultsData?.edges
    ]);
    const totalSizeRef = (0, $eJOHy.useRef)($1744fe6b66488abe$var$getInitialTableHeight(issueResultsData?.edges?.length));
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const showNoIssues = issueResultsData && !issueResultsData.edges?.length;
    const showNoGroupingIssues = isGroupingSupported && groupResultsData && !groupResultsData.edges?.length;
    let isMergedColumnVisible = false;
    if ((0, $7jTnu.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    let showNoColumns = (columns.length === 0 || columns.length === 1 && columns[0].id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU)) && !isMergedColumnVisible;
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) showNoColumns = columns.filter((col)=>!(0, $8jOO7.ACTION_COLUMNS).includes(col.id)).length === 0 && !isMergedColumnVisible;
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    const { handleMouseOver: handleMouseOver, handleMouseLeave: handleMouseLeave } = (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hHg7L.useEventDelegator)() : {
        handleMouseOver: undefined,
        handleMouseLeave: undefined
    };
    const tableHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pZqvR.IFCConfigContextProviderComponent), {
        ifcConfig: ifcConfig,
        columns: columns,
        onColumnsChange: columnPickerProps?.onChange,
        queryRef: issueResultsData ?? null,
        columnsQueryRef: columnsQueryRef ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jJgFJ.Header), {
        view: viewData,
        columnPickerProps: columnPickerProps,
        columns: columns,
        canViewColumnConfiguration: canViewColumnConfiguration,
        canEditColumnConfiguration: canEditColumnConfiguration,
        isCompactColumnEnabled: isCompactColumnEnabled,
        resizeHandleType: showNoIssues || showNoColumns ? (0, $8jOO7.COLUMN_RESIZE_HANDLE_HEADER_ONLY) : (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT),
        onColumnsChange: onColumnsChange,
        onResizeColumn: onResizeColumn,
        onFreezeColumn: onFreezeColumn,
        tableRef: tableRef,
        tableBorderRadius: tableBorderRadius,
        showNoColumns: showNoColumns,
        ...(0, $7jTnu.fg)('issue_table_frozen_columns') && {
            resizingColumnIndex: resizingColumnIndex,
            setResizingColumnIndex: setResizingColumnIndex
        }
    }));
    if (showNoIssues || showNoGroupingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1744fe6b66488abe$export$36d41a08d3c6eb45, {
        isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
        "aria-label": formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eI4dM.default).issuesTableLabelIssueTermRefresh : (0, $eI4dM.default).issuesTableLabel),
        ref: tableRef
    }, tableHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kaSuB.default), {
        NoIssues: NoIssues,
        isLoading: loading
    }));
    if (showNoColumns) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, canViewColumnConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1744fe6b66488abe$export$36d41a08d3c6eb45, {
        isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
        "aria-label": formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eI4dM.default).issuesTableLabelIssueTermRefresh : (0, $eI4dM.default).issuesTableLabel),
        ref: tableRef
    }, tableHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l00LF.default), {
        NoColumns: NoColumns,
        hasColumnConfiguration: canViewColumnConfiguration,
        isLoading: loading
    }));
    const renderTableBody = ()=>{
        if (isGroupingSupported && groupResultsData && !issueResultsData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hATyi.GroupTableBody), {
            groupResults: groupResultsData,
            rankField: rankFieldData ?? null,
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            project: projectData ?? null,
            loading: loading,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled
        });
        if (issueResultsData == null) return null;
        const tableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4R6nP.default), {
            issueResults: issueResultsData,
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            project: projectData ?? null,
            rankField: rankFieldData ?? null,
            isGroupingSupported: isGroupingSupported,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            ...(0, $7jTnu.fg)('issue_table_frozen_columns') && {
                resizingColumnIndex: resizingColumnIndex
            }
        });
        return tableBody;
    };
    const renderTable = (style)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1744fe6b66488abe$export$36d41a08d3c6eb45, {
            ...style ? {
                style: style
            } : {},
            isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
            "aria-label": formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eI4dM.default).issuesTableLabelIssueTermRefresh : (0, $eI4dM.default).issuesTableLabel),
            ref: tableRef,
            "aria-rowcount": issueResultsData?.totalIssueSearchResultCount && issueResultsData?.totalIssueSearchResultCount > 0 && (0, $7jTnu.fg)('nin-grid-keyboard-navigation') ? issueResultsData?.totalIssueSearchResultCount : undefined,
            "data-vc": `issue-table${false ? '-ssr' : ''}`,
            onMouseOver: handleMouseOver,
            onMouseLeave: handleMouseLeave,
            ...false && (0, $7jTnu.fg)('additional_nin_ssr_placeholders') && {
                'data-ssr-placeholder': 'issue-table-placeholder'
            },
            ...!false && (0, $7jTnu.fg)('additional_nin_ssr_placeholders') && {
                'data-ssr-placeholder-replace': 'issue-table-placeholder'
            }
        }, tableHeader, renderTableBody(), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1744fe6b66488abe$var$TableFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, (0, $7jTnu.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.Overlay), {
            interactionName: "issue-table-renderer-overlay"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.OverlayOld), null)))) : null, isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gM8ln.HoverPopoverWithDelegator), null) : null);
    };
    const rowsCount = flatList?.length > 0 && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? flatList?.length : issueResultsData?.edges?.length;
    if (isVirtualizationEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Kdcei.VirtualizationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InitializeVirtualizer, {
        rows: rowsCount ?? 0,
        getItemKey: getItemKey,
        totalSizeRef: totalSizeRef
    }), renderTable({
        width: '100%',
        position: 'relative'
    }));
    return renderTable();
};
var $1744fe6b66488abe$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $1744fe6b66488abe$var$IssueTable;
const $1744fe6b66488abe$export$36d41a08d3c6eb45 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedTableLayoutEnabled: isFixedTableLayoutEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3it94y _kqswh2mm _yq5h18uv _btyzidpf",
            __cmplp.isFixedTableLayoutEnabled && "_1kqm1n9t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
const $1744fe6b66488abe$var$TableFooter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "tfoot", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itglyw _p4liidpf _owipidpf _6autidpf _1pqwidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ipznG", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2442626a826f4ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<44303b94d07299f27c191f2263a9d40a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2442626a826f4ab$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueTable_nativeIssueTable_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "tableBody_nativeIssueTable_rankField"
        },
        {
            "kind": "FragmentSpread",
            "name": "groupTableBody_nativeIssueTable_rankField"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$a2442626a826f4ab$var$node.hash = "744dcf6aed2e3628cba0d01e183b9af5";
var $a2442626a826f4ab$export$2e2bcd8739ae039 = $a2442626a826f4ab$var$node;

});

parcelRegister("92w1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $104e0dd6c10cfb66$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04276df08361b22fb635eaa652118763>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $104e0dd6c10cfb66$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "issueTable_nativeIssueTable_project",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "groupTableBody_nativeIssueTable_project"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "tableBody_nativeIssueTable_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$104e0dd6c10cfb66$var$node.hash = "dec27f6377a00d0f180cbce1d4d237be";
var $104e0dd6c10cfb66$export$2e2bcd8739ae039 = $104e0dd6c10cfb66$var$node;

});

parcelRegister("78TK1", function(module, exports) {

$parcel$export(module.exports, "default", () => $696f22b1919ec26a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a0b5430b44579e1bbe3bd306bccce32e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $696f22b1919ec26a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "issueTable_nativeIssueTable_groupResults",
    "selections": [
        {
            "concreteType": "JiraSpreadsheetGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraSpreadsheetGroup",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "groupTableBody_nativeIssueTable_groupResults"
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$696f22b1919ec26a$var$node.hash = "9e81a6d05fd7bff18d5d5f8ad3ab7bb0";
var $696f22b1919ec26a$export$2e2bcd8739ae039 = $696f22b1919ec26a$var$node;

});

parcelRegister("gXZv6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4325a23fc04f5c3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea403f8a2afa8dfc084f79e389ec60d6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4325a23fc04f5c3a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "issueTable_nativeIssueTable_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "tableBody_nativeIssueTable_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "context_nativeIssueTable_IFCConfigContextProvider_queryRef"
        }
    ],
    "type": "JiraIssueConnection"
};
$4325a23fc04f5c3a$var$node.hash = "64b0fccb15eb56a8931ad71573a77210";
var $4325a23fc04f5c3a$export$2e2bcd8739ae039 = $4325a23fc04f5c3a$var$node;

});

parcelRegister("fLEXm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6623958ab742c8ed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9bed57b5d438b60d469c421b5a829a65>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6623958ab742c8ed$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueTable_nativeIssueTable_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "header_nativeIssueTable"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$6623958ab742c8ed$var$node.hash = "6274d6e3d3b28be9b9e64979f1543d09";
var $6623958ab742c8ed$export$2e2bcd8739ae039 = $6623958ab742c8ed$var$node;

});

parcelRegister("gM8ln", function(module, exports) {

$parcel$export(module.exports, "HoverPopoverWithDelegator", () => $45aab2dddaf31bc3$export$9b1830049d07a4b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $67YQP = parcelRequire("67YQP");

var $8qmYl = parcelRequire("8qmYl");

var $1KdDN = parcelRequire("1KdDN");

var $16sa1 = parcelRequire("16sa1");

var $bYhG9 = parcelRequire("bYhG9");


var $1VYeC = parcelRequire("1VYeC");
const $45aab2dddaf31bc3$export$9b1830049d07a4b = ()=>{
    const { hoverPopoverState: hoverPopoverState } = (0, $bYhG9.useHoverPopoverState)();
    const { isOpen: isOpen, content: content, contentElement: contentElement, alwaysShow: alwaysShow, cellRef: cellRef, onHoverOut: onHoverOut, shouldRenderToContent: shouldRenderToContent } = hoverPopoverState;
    const refToRenderTo = shouldRenderToContent ? contentElement : cellRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isOpen && refToRenderTo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $67YQP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "jira-list-hover-popover",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jira-list-hover-popover",
        packageName: (0, $05f3bc586d738eb3$export$b8b9d90f9e5bd72b),
        teamName: (0, $05f3bc586d738eb3$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qmYl.Popper), {
        placement: "bottom-start",
        referenceElement: refToRenderTo
    }, ({ ref: ref, style: style, update: update, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ref: ref,
            // Style is required for react-popper to apply positioning correctly (allows it to render to parent)
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
            style: style,
            className: (0, $hcewu.default)([
                shouldRenderToContent && "_19pku2gc _18u0x0bf"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VYeC.PopoverInternal), {
            content: content,
            contentElement: contentElement,
            onUpdate: update,
            isReferenceHidden: isReferenceHidden,
            alwaysShow: alwaysShow,
            onHoverOut: onHoverOut
        })))))));
};
const $45aab2dddaf31bc3$var$renderToContentStyles = null;

});
const $05f3bc586d738eb3$export$d57b6b390e78d90f = 'jira-yurree';
const $05f3bc586d738eb3$export$b8b9d90f9e5bd72b = '@atlassian/jira-hover-popover';

parcelRegister("1VYeC", function(module, exports) {

$parcel$export(module.exports, "PopoverInternal", () => $f2c475c7a9bd946f$export$681e33c5421549b0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9CHGV = parcelRequire("9CHGV");

var $hX7Ca = parcelRequire("hX7Ca");
const $f2c475c7a9bd946f$var$CELL_HOVER_DELAY = 200;
const $f2c475c7a9bd946f$export$681e33c5421549b0 = ({ content: content, contentElement: contentElement, onUpdate: onUpdate, isReferenceHidden: isReferenceHidden, alwaysShow: alwaysShow, onHoverOut: onHoverOut })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $eJOHy.useState)(false);
    const hoverTimeoutRef = (0, $eJOHy.useRef)(null);
    hoverTimeoutRef.current = setTimeout(()=>{
        if (alwaysShow) setIsPopupOpen(true);
        const elementWithTextContent = contentElement ? (0, $hX7Ca.getClosestTextElement)(contentElement) : undefined;
        const clientWidth = elementWithTextContent?.clientWidth || 0;
        const scrollWidth = elementWithTextContent?.scrollWidth || 0;
        const isClamped = (0, $hX7Ca.checkIsClamped)(elementWithTextContent);
        if (!contentElement || scrollWidth > clientWidth || isClamped) setIsPopupOpen(true);
    }, $f2c475c7a9bd946f$var$CELL_HOVER_DELAY);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
            if (onHoverOut) onHoverOut();
        };
    }, [
        onHoverOut
    ]);
    if (isPopupOpen && content && !isReferenceHidden) return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            "_j7hq1ida _tzy4idpf _5sag1yx9 _1pgl1v42 _1o51q7pw _p12f1mjv _lcxvglyw"
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $9CHGV.PopupContent), {
        update: onUpdate
    }, content));
};
const $f2c475c7a9bd946f$var$fadeIn = null;
const $f2c475c7a9bd946f$var$containerStyles = null;

});
parcelRegister("9CHGV", function(module, exports) {

$parcel$export(module.exports, "PopupContent", () => $95ad311b87a00fc3$export$2a2c7ba12d3231e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $1OHZM = parcelRequire("1OHZM");

var $2ZGUP = parcelRequire("2ZGUP");
const $95ad311b87a00fc3$var$PopupContentComponent = ({ children: children, update: update, isInteractive: isInteractive, analyticsAttributes: analyticsAttributes })=>{
    const componentRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const mountTimeRef = (0, $eJOHy.useRef)(Date.now());
    (0, $1OHZM.useResizeObserver)({
        ref: componentRef,
        onResize: update
    });
    (0, $eJOHy.useEffect)(()=>{
        const mountTime = mountTimeRef.current;
        if (!(0, $7jTnu.fg)('issue_table_single_line_row_height_fast_follows')) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'popup displayed', 'hoverPopover', {
            isInteractive: isInteractive,
            ...analyticsAttributes
        });
        return ()=>{
            if ((0, $7jTnu.fg)('issue_table_single_line_row_height_fast_follows')) {
                const duration = Date.now() - mountTime;
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'popup displayed', 'hoverPopover', {
                    isInteractive: isInteractive,
                    duration: duration,
                    ...analyticsAttributes
                });
            }
        };
    }, [
        createAnalyticsEvent,
        isInteractive,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        ref: componentRef,
        "data-testid": "hover-popover.ui.popup-content.hover-popover-content",
        "aria-hidden": !isInteractive,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: isInteractive ? 0 : undefined,
        className: (0, $hcewu.default)([
            "_2rkoglpi _1reo1wug _18m91wug _18zrutpp _1rjc12x7 _bfhk1bhr _16qs1cd0 _qv3h2smr _k48pi7a9 _1i4q1hna _c71l1mjv _1nmz1hna _y2mvugt7 _1bg4v77o"
        ])
    }, children, /*#__PURE__*/ $eJOHy.createElement((0, $2ZGUP.default), null));
};
const $95ad311b87a00fc3$export$2a2c7ba12d3231e3 = /*#__PURE__*/ (0, $eJOHy.memo)($95ad311b87a00fc3$var$PopupContentComponent);
const $95ad311b87a00fc3$var$popoverStyles = null;

});
parcelRegister("1OHZM", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $7c1c433db2df08f5$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $7c1c433db2df08f5$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $7c1c433db2df08f5$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $7c1c433db2df08f5$export$e58143dc89297272);

var $eJOHy = parcelRequire("eJOHy");

var $cOhmL = parcelRequire("cOhmL");
function $7c1c433db2df08f5$export$87a9d3e287304ae4(params) {
    const group = new (0, $cOhmL.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $eJOHy.useRef)(onResize);
        (0, $eJOHy.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $eJOHy.useCallback)(()=>onResizeRef.current(), []);
        (0, $eJOHy.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $7c1c433db2df08f5$export$683480f191c0e3ea, flushResizeObservers: $7c1c433db2df08f5$export$a181ef2a6d0a1bb6 } = $7c1c433db2df08f5$export$87a9d3e287304ae4();
function $7c1c433db2df08f5$export$e58143dc89297272({ ref: ref, useResizeObserverDI: // eslint-disable-next-line react-hooks/react-compiler
useResizeObserverDI = $7c1c433db2df08f5$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $eJOHy.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("cOhmL", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $4b26b203cb8a861d$export$607798bbe2869c0);

var $aQK2r = parcelRequire("aQK2r");

var $3s8bj = parcelRequire("3s8bj");
class $4b26b203cb8a861d$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $aQK2r.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});





parcelRegister("hnyyS", function(module, exports) {

$parcel$export(module.exports, "Overlay", () => $2263ce5e083f2a0f$export$c6fdb837b070b4ff);
$parcel$export(module.exports, "OverlayOld", () => $2263ce5e083f2a0f$export$3dff7b29487a2410);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");
const $2263ce5e083f2a0f$export$c6fdb837b070b4ff = ({ interactionName: interactionName })=>{
    return(// We are intentionally ignoring jira/ufo/valid-labels because we have a valid use case
    // for an encapsulated generic component, similar to generic AK components.
    // eslint-disable-next-line jira/ufo/valid-labels
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: interactionName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2263ce5e083f2a0f$var$StyledOverlay, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $2263ce5e083f2a0f$var$StyledOverlay = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _bfhk166n _tzy4txnc _1sb2b3bt",
            __cmplp.className
        ])
    });
});
const $2263ce5e083f2a0f$export$3dff7b29487a2410 = $2263ce5e083f2a0f$var$StyledOverlay;

});

parcelRegister("Kdcei", function(module, exports) {

$parcel$export(module.exports, "VirtualizationContainer", () => $29e00bcf5213eb76$export$6f4d8b0593660d4a);
$parcel$export(module.exports, "useVirtualizationActions", () => $29e00bcf5213eb76$export$2d20df04c90a6b4d);
$parcel$export(module.exports, "useVirtualization", () => $29e00bcf5213eb76$export$8c88e6c844ce8aa0);
$parcel$export(module.exports, "useVirtualItemsMap", () => $29e00bcf5213eb76$export$48859eaeca922cb5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $29e00bcf5213eb76$var$initialState = {
    virtualizer: null,
    virtualItemsMap: {}
};
const $29e00bcf5213eb76$var$actions = {
    setVirtualizer: (virtualizer)=>({ setState: setState })=>{
            setState({
                virtualizer: virtualizer
            });
        },
    setVirtualItemsMap: (virtualItemsMap)=>({ setState: setState })=>{
            setState({
                virtualItemsMap: virtualItemsMap
            });
        }
};
const $29e00bcf5213eb76$export$6f4d8b0593660d4a = (0, $6E16M.createContainer)();
const $29e00bcf5213eb76$var$Store = (0, $GtRbT.createStore)({
    initialState: $29e00bcf5213eb76$var$initialState,
    actions: $29e00bcf5213eb76$var$actions,
    name: 'VirtualizerStore',
    containedBy: $29e00bcf5213eb76$export$6f4d8b0593660d4a
});
const $29e00bcf5213eb76$export$2d20df04c90a6b4d = (0, $iJq0l.createActionsHook)($29e00bcf5213eb76$var$Store);
const $29e00bcf5213eb76$export$88d9b12c2ccec7b9 = (0, $iJq0l.createHook)($29e00bcf5213eb76$var$Store);
const $29e00bcf5213eb76$var$getVirtualizerSelector = (state)=>state.virtualizer;
const $29e00bcf5213eb76$export$8c88e6c844ce8aa0 = (0, $iJq0l.createStateHook)($29e00bcf5213eb76$var$Store, {
    selector: $29e00bcf5213eb76$var$getVirtualizerSelector
});
const $29e00bcf5213eb76$var$getVirtualItemsMapSelector = (state)=>state.virtualItemsMap;
const $29e00bcf5213eb76$export$48859eaeca922cb5 = (0, $iJq0l.createStateHook)($29e00bcf5213eb76$var$Store, {
    selector: $29e00bcf5213eb76$var$getVirtualItemsMapSelector
});

});

parcelRegister("hHg7L", function(module, exports) {

$parcel$export(module.exports, "useEventDelegator", () => $a9d2dac88d84964b$export$d7391873b7d90fb9);
$parcel$export(module.exports, "useEventDelegatorRef", () => $a9d2dac88d84964b$export$5213ba3182c7ed61);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $3OT15 = parcelRequire("3OT15");

var $bYhG9 = parcelRequire("bYhG9");
const $a9d2dac88d84964b$var$HOVER_DEBOUNCE_DURATION = 100;
const $a9d2dac88d84964b$export$d7391873b7d90fb9 = ()=>{
    const { setPopoverClosed: setPopoverClosed, setPopoverOpen: setPopoverOpen } = (0, $bYhG9.useHoverPopoverSetter)();
    const { getCellIdByRef: getCellIdByRef } = (0, $3OT15.useHoverPopoverContent)();
    const currentHoveredCellFieldIdRef = (0, $eJOHy.useRef)(null);
    const debouncedSetHoverFocusStateRef = (0, $eJOHy.useRef)(null);
    const clearHoverFocusState = (0, $eJOHy.useCallback)(()=>{
        debouncedSetHoverFocusStateRef.current?.cancel();
        setPopoverClosed();
        currentHoveredCellFieldIdRef.current = null;
    }, [
        setPopoverClosed
    ]);
    const setHoverFocusState = (0, $eJOHy.useCallback)((fieldId, cell)=>{
        setPopoverOpen({
            fieldId: fieldId,
            cell: cell,
            clearHoverFocusState: clearHoverFocusState
        });
    }, [
        setPopoverOpen,
        clearHoverFocusState
    ]);
    const handleMouseOver = (0, $eJOHy.useCallback)((event)=>{
        if (event.target instanceof HTMLElement) {
            const target = event.target;
            // Get closest cell that is being hovered over
            const cell = target.closest('td');
            // If no cell is found, clear the hover state and return
            if (!cell || !(cell instanceof HTMLTableCellElement)) {
                clearHoverFocusState();
                return;
            }
            const fieldId = getCellIdByRef(cell);
            // If there is a cell but no field id, clear the hover state and return
            if (!fieldId) {
                clearHoverFocusState();
                return;
            }
            // If the cell is the same as the current hovered cell, return
            if (fieldId !== currentHoveredCellFieldIdRef.current) {
                // If the cell is different from the current hovered cell, clear the previous hover state
                if (currentHoveredCellFieldIdRef.current) clearHoverFocusState();
                // Finally, set the hover state for the new cell
                currentHoveredCellFieldIdRef.current = fieldId;
                debouncedSetHoverFocusStateRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>setHoverFocusState(fieldId, cell), $a9d2dac88d84964b$var$HOVER_DEBOUNCE_DURATION);
                debouncedSetHoverFocusStateRef.current();
            }
        }
    }, [
        clearHoverFocusState,
        getCellIdByRef,
        setHoverFocusState
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        clearHoverFocusState();
        debouncedSetHoverFocusStateRef.current?.cancel();
    }, [
        clearHoverFocusState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (currentHoveredCellFieldIdRef.current) clearHoverFocusState();
            debouncedSetHoverFocusStateRef.current?.cancel();
        };
    }, [
        clearHoverFocusState
    ]);
    return {
        handleMouseLeave: handleMouseLeave,
        handleMouseOver: handleMouseOver
    };
};
const $a9d2dac88d84964b$export$5213ba3182c7ed61 = (fieldId)=>{
    const lastNode = (0, $eJOHy.useRef)(null);
    const { setCellIdByRef: setCellIdByRef, deleteCellIdByRef: deleteCellIdByRef } = (0, $3OT15.useHoverPopoverContent)();
    const tableCellRef = (0, $eJOHy.useCallback)((node)=>{
        if (node && fieldId) {
            setCellIdByRef(node, fieldId);
            lastNode.current = node;
        } else if (lastNode.current) {
            deleteCellIdByRef(lastNode.current);
            lastNode.current = null;
        }
    }, [
        fieldId,
        setCellIdByRef,
        deleteCellIdByRef
    ]);
    return tableCellRef;
};

});

parcelRegister("hATyi", function(module, exports) {

$parcel$export(module.exports, "GroupTableBody", () => $b3c14289e18dd606$export$aa181eb5196ac7ed);

var $kpERG = parcelRequire("kpERG");

var $3KHED = parcelRequire("3KHED");

var $j2Mv2 = parcelRequire("j2Mv2");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $jPROM = parcelRequire("jPROM");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jBNts = parcelRequire("jBNts");

var $6d9QY = parcelRequire("6d9QY");

var $7jTnu = parcelRequire("7jTnu");

var $jE8Tu = parcelRequire("jE8Tu");

var $cNwIG = parcelRequire("cNwIG");

var $eSclU = parcelRequire("eSclU");

var $9I6ok = parcelRequire("9I6ok");

var $3fA0C = parcelRequire("3fA0C");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");

var $km3XC = parcelRequire("km3XC");

var $8jOO7 = parcelRequire("8jOO7");

var $bKlUQ = parcelRequire("bKlUQ");

var $7n9BS = parcelRequire("7n9BS");

var $iC2St = parcelRequire("iC2St");

var $kfIml = parcelRequire("kfIml");
const $b3c14289e18dd606$export$aa181eb5196ac7ed = ({ groupResults: groupResults, project: project, columns: columns, rankField: rankField, loading: loading, isConditionalFormattingEnabled: isConditionalFormattingEnabled, ...tableBodyProps })=>{
    const groupsData = (0, $j4oe4.useFragment)((0, $j2Mv2.default), groupResults);
    const projectData = (0, $j4oe4.useFragment)((0, $3KHED.default), project);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $kpERG.default), rankField);
    const rankFieldTerms = (0, $eJOHy.useMemo)(()=>({
            jqlTerm: rankFieldData?.jqlTerm ?? null,
            aliases: rankFieldData?.aliases ? Array.from(rankFieldData.aliases) : null
        }), [
        rankFieldData
    ]);
    const groupConnectionId = groupsData.__id;
    const { populateConnection: populateConnection } = (0, $jE8Tu.useHierarchyActions)();
    const populateConnectionArgs = (0, $eJOHy.useMemo)(()=>({
            parentItemId: 'root',
            itemsConnectionId: groupConnectionId,
            parentConnectionId: groupConnectionId,
            list: groupsData?.edges?.map((edge)=>edge?.node && {
                    itemId: edge.node.id,
                    key: null,
                    groupId: edge.node.id
                }).filter(Boolean) ?? []
        }), [
        groupConnectionId,
        groupsData.edges
    ]);
    const prevPopulateConnectionArgs = (0, $6d9QY.usePrevious)(populateConnectionArgs);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(populateConnectionArgs, prevPopulateConnectionArgs)) populateConnection(populateConnectionArgs);
    /**
   * Passing those values down to ChildRowsLoader as props to avoid direct imports
   */ const jql = (0, $34oCh.useJql)();
    const sortField = (0, $34oCh.useSortField)();
    const sortDirection = (0, $34oCh.useSortDirection)();
    const isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isIssueCreateEnabled = (0, $34oCh.useIsIssueCreateEnabled)();
    let isStickyColumnsVisible = false;
    if ((0, $7jTnu.fg)('issue_table_frozen_columns')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    const renderDraggableWrapper = (0, $eJOHy.useCallback)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfIml.DraggableRowsContainer), {
            issueConnectionId: props.issueConnectionId,
            instanceId: props.instanceId
        }, props.children);
    }, []);
    const renderChildRows = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNwIG.ChildRows), {
            ...props,
            projectKey: projectData?.key,
            isGroupingSupported: true,
            childItemsExperience: (0, $8jOO7.GROUPED_ITEMS_EXPERIENCE),
            childItemsLoadMoreExperience: (0, $8jOO7.GROUPED_LOAD_MORE_EXPERIENCE),
            analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE),
            renderChildRowsLoader: (childRowsLoaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eSclU.ChildRowsLoader), {
                    ...childRowsLoaderProps,
                    jql: jql,
                    width: width,
                    sortField: sortField,
                    sortDirection: sortDirection,
                    columns: columns,
                    amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                    actionColumns: (0, $8jOO7.ACTION_COLUMNS),
                    pageSize: (0, $8jOO7.CHILD_QUERY_PAGE_SIZE),
                    isReparentingEnabled: isReparentingEnabled,
                    isTimelineEnabled: isTimelineEnabled,
                    isIssueRankDescending: isIssueRankDescending,
                    isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                    isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
                    rankFieldId: rankFieldData?.fieldId ?? null,
                    renderRows: (rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3fA0C.Rows), {
                            project: projectData,
                            ...rowProps
                        }),
                    renderTableCell: (tableCellProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), tableCellProps),
                    renderCreateIssueController: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2St.CreateIssueController), {
                            ...args,
                            groupContextFieldInput: props.groupContextField,
                            jql: jql,
                            rankFieldTerms: rankFieldTerms
                        }),
                    renderDraggableWrapper: renderDraggableWrapper,
                    isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                    isInlineFieldConfigEnabled: isInlineFieldConfigEnabled
                })
        }), [
        projectData,
        jql,
        width,
        sortField,
        sortDirection,
        columns,
        isReparentingEnabled,
        isTimelineEnabled,
        isIssueRankDescending,
        isHideDoneItemsEnabled,
        isConditionalFormattingEnabled,
        isFixedTableLayoutEnabled,
        rankFieldData?.fieldId,
        renderDraggableWrapper,
        isInlineFieldConfigEnabled,
        rankFieldTerms
    ]);
    const renderRows = (0, $eJOHy.useCallback)((rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3fA0C.Rows), {
            project: projectData,
            ...rowProps
        }), [
        projectData
    ]);
    const renderCreateIssueController = (0, $eJOHy.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2St.CreateIssueController), {
            ...args,
            jql: jql
        }), [
        jql
    ]);
    const numFirstGroupIssues = groupsData?.firstGroup?.issues?.edges?.length;
    const isFirstGroupEmpty = (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(numFirstGroupIssues) || numFirstGroupIssues === 0;
    const renderGroups = (0, $eJOHy.useCallback)((isItemVirtual)=>groupsData?.edges?.map((group, index)=>group?.node && // We need to render the first group separately because it requires initialization during the table rendering process.
            // Additionally, it bypasses the ChildRowLoader and directly uses ChildRowsPagination, as the data is already available in data.firstGroup.
            (groupsData?.firstGroup && group.node.id === groupsData.firstGroup.id && !isFirstGroupEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNv5I.RowContextProvider), {
                key: groupsData.firstGroup.id,
                groupId: groupsData.firstGroup.id,
                groupConnectionId: (0, $7jTnu.fg)('jsc_list_hide_done_items') ? groupConnectionId : undefined,
                ...tableBodyProps,
                columns: columns
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9I6ok.FirstGroupRow), {
                firstGroupRow: groupsData.firstGroup,
                rankField: rankFieldData ?? null,
                groupConnectionId: groupConnectionId,
                loading: loading,
                isVirtual: isItemVirtual?.((0, $jBNts.getFlatListKey)({
                    itemId: groupsData.firstGroup.id,
                    groupId: groupsData.firstGroup.id
                })) ?? true,
                isGroupAtTop: index === 0,
                projectKey: projectData?.key,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                isIssueRankDescending: isIssueRankDescending,
                isTimelineEnabled: isTimelineEnabled,
                columns: columns,
                width: width,
                amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                actionColumns: (0, $8jOO7.ACTION_COLUMNS),
                pageSize: (0, $8jOO7.CHILD_QUERY_PAGE_SIZE),
                childItemsExperience: (0, $8jOO7.GROUPED_ITEMS_EXPERIENCE),
                childItemsLoadMoreExperience: (0, $8jOO7.GROUPED_LOAD_MORE_EXPERIENCE),
                analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE),
                renderRows: renderRows,
                renderCreateIssueController: renderCreateIssueController,
                isIssueCreateEnabled: isIssueCreateEnabled,
                isGridNavigationEnabled: isGridNavigationEnabled,
                renderDraggableWrapper: renderDraggableWrapper,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                isStickyColumnsVisible: isStickyColumnsVisible
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNv5I.RowContextProvider), {
                key: group.node.id,
                groupId: group.node.id,
                groupConnectionId: (0, $7jTnu.fg)('jsc_list_hide_done_items') ? groupConnectionId : undefined,
                ...tableBodyProps,
                columns: columns,
                renderChildRows: renderChildRows
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9I6ok.GroupRow), {
                groupRow: group.node,
                groupConnectionId: groupConnectionId,
                isVirtual: isItemVirtual?.((0, $jBNts.getFlatListKey)({
                    itemId: group.node.id,
                    groupId: group.node.id
                })) ?? true,
                isGroupAtTop: index === 0,
                projectKey: projectData?.key,
                columns: columns,
                renderChildRows: renderChildRows,
                isIssueCreateEnabled: isIssueCreateEnabled,
                isGridNavigationEnabled: isGridNavigationEnabled,
                isStickyColumnsVisible: isStickyColumnsVisible
            })))), [
        groupsData?.edges,
        groupsData.firstGroup,
        isFirstGroupEmpty,
        groupConnectionId,
        tableBodyProps,
        columns,
        rankFieldData,
        loading,
        projectData?.key,
        isHideDoneItemsEnabled,
        isIssueRankDescending,
        isTimelineEnabled,
        width,
        renderRows,
        renderCreateIssueController,
        isIssueCreateEnabled,
        isGridNavigationEnabled,
        renderDraggableWrapper,
        isConditionalFormattingEnabled,
        isInlineFieldConfigEnabled,
        isStickyColumnsVisible,
        renderChildRows
    ]);
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "tbody",
        xcss: $b3c14289e18dd606$var$tableBodyStyles
    }, isVirtualizationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $km3XC.VirtualizedRows), {
        hasSpacers: true,
        columnsCount: columns.length
    }, renderGroups) : renderGroups());
};
const $b3c14289e18dd606$var$tableBodyStyles = (0, $1DXK0.xcss)({
    borderBottom: 'none',
    overflowX: 'hidden'
});

});
parcelRegister("kpERG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb53b05c5e0e1d92$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f2adbad784062bc779712a30bd8697c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bb53b05c5e0e1d92$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "groupTableBody_nativeIssueTable_rankField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "jqlTerm"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "aliases"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "groupRow_issueTableGrouping_FirstGroupRow_rankField"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$bb53b05c5e0e1d92$var$node.hash = "cfe0731a96231d3ed0d59b078c97ab2c";
var $bb53b05c5e0e1d92$export$2e2bcd8739ae039 = $bb53b05c5e0e1d92$var$node;

});

parcelRegister("3KHED", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8b6904db165a106$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6459e3b0728ceed51eda940a82efb789>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a8b6904db165a106$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "groupTableBody_nativeIssueTable_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "rows_jiraProject"
        }
    ],
    "type": "JiraProject"
};
$a8b6904db165a106$var$node.hash = "b6019a485ee13ec38df04bd759772c97";
var $a8b6904db165a106$export$2e2bcd8739ae039 = $a8b6904db165a106$var$node;

});

parcelRegister("j2Mv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $66385d3be97e8831$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<56133e54cf4564df16f3d03308dbef70>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $66385d3be97e8831$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isPaginating"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "firstGroup",
                        "issues"
                    ]
                }
            ]
        },
        "name": "groupTableBody_nativeIssueTable_groupResults",
        "selections": [
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "firstGroup",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "alias": "issues",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "fieldSetsInput",
                                        "variableName": "fieldSetsInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "scope",
                                        "variableName": "fieldSetsScope"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "settings",
                                        "variableName": "settings"
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "__firstGroupSection_nativeIssueTable__issues_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "isConditionalFormattingEnabled",
                                        "variableName": "isConditionalFormattingEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isDensityFull",
                                        "variableName": "isDensityFull"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isInlineEditingEnabled",
                                        "variableName": "isInlineEditingEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isTimelineEnabled",
                                        "variableName": "isTimelineEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "projectKey",
                                        "variableName": "projectKey"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "projectKeys",
                                        "variableName": "projectKeys"
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "groupRow_issueTableGrouping_groupRow"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroupConnection"
    };
}();
$66385d3be97e8831$var$node.hash = "79fed2b686baaba6209394599c86d6f0";
var $66385d3be97e8831$export$2e2bcd8739ae039 = $66385d3be97e8831$var$node;

});

parcelRegister("cNwIG", function(module, exports) {

$parcel$export(module.exports, "ChildRows", () => $c306099c2e91dd3b$export$d1ec222e220e369e);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $gYnSx = parcelRequire("gYnSx");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $jE8Tu = parcelRequire("jE8Tu");


var $eYYOy = parcelRequire("eYYOy");
const $c306099c2e91dd3b$var$PACKAGE_LOCATION = 'jira-issue-table-hierarchy-child-rows';
const $c306099c2e91dd3b$export$5881677fb314e6d9 = 'issue-table-child-rows-entrypoint-container';
const $c306099c2e91dd3b$export$d1ec222e220e369e = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const [isExpanded] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: props.parentItemId,
        itemsConnectionId: props.itemsConnectionId,
        groupId: props.groupId
    });
    if (!isExpanded) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c306099c2e91dd3b$var$ChildRowsInner, props);
});
const $c306099c2e91dd3b$var$ChildRowsInner = (props)=>{
    const { parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, type: type, parentItemConnectionId: parentItemConnectionId, depth: depth, groupId: groupId, renderChildRowsLoader: renderChildRowsLoader } = props;
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: props.childItemsExperience,
        analyticsSource: props.analyticsSource
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: props.childItemsExperience,
        attributes: {}
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const { setIsItemExpanded: setIsItemExpanded } = (0, $jE8Tu.useHierarchyActions)();
    const { showFlag: showFlag, hasFlag: hasFlag } = (0, $bILK0.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        setIsItemExpanded({
            itemId: parentItemId,
            itemsConnectionId: itemsConnectionId,
            groupId: groupId
        }, false);
        if (!hasFlag?.($c306099c2e91dd3b$export$5881677fb314e6d9)) {
            const isGrouping = groupId && depth === 0;
            showFlag({
                id: $c306099c2e91dd3b$export$5881677fb314e6d9,
                title: formatMessage(isGrouping ? (0, $eYYOy.default).errorFlagGroupingTitle : (0, $eYYOy.default).errorFlagTitle),
                description: formatMessage(isGrouping ? (0, $eYYOy.default).errorFlagGroupingDescription : (0, $eYYOy.default).errorFlagDescription),
                type: 'error',
                messageId: `issue-table-hierarchy.ui.child-rows.showFlag.${$c306099c2e91dd3b$export$5881677fb314e6d9}`,
                messageType: 'transactional'
            });
        }
        (0, $gYnSx.default)({
            meta: {
                id: 'issue-table-child-rows-container',
                packageName: (0, $313deb82db1bb5f5$export$b8b9d90f9e5bd72b),
                teamName: (0, $313deb82db1bb5f5$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($c306099c2e91dd3b$var$PACKAGE_LOCATION, error);
        return null;
    }, [
        formatMessage,
        hasFlag,
        itemsConnectionId,
        onExperienceFail,
        parentItemId,
        setIsItemExpanded,
        showFlag,
        depth,
        groupId
    ]);
    const connectionMetadata = (0, $eJOHy.useMemo)(()=>{
        if (type === 'PARENT_CHILDREN' && parentItemConnectionId) return {
            type: type,
            parentRelayId: parentItemConnectionId,
            parentId: parentItemId
        };
        if (type === 'GROUP_CHILDREN' && groupId) return {
            type: type,
            fieldValue: props.groupFieldValue,
            groupId: groupId,
            jql: props.groupJql
        };
        return undefined;
    }, [
        type,
        parentItemConnectionId,
        groupId,
        props.groupFieldValue,
        props.groupJql,
        parentItemId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: $c306099c2e91dd3b$var$PACKAGE_LOCATION,
        packageName: (0, $313deb82db1bb5f5$export$b8b9d90f9e5bd72b),
        teamName: (0, $313deb82db1bb5f5$export$d57b6b390e78d90f),
        onError: (_, error)=>handleError(error)
    }, renderChildRowsLoader({
        ...props,
        connectionMetadata: connectionMetadata
    }));
};

});
const $313deb82db1bb5f5$export$b8b9d90f9e5bd72b = 'jira-issue-table-hierarchy';
const $313deb82db1bb5f5$export$d57b6b390e78d90f = 'keystone';

parcelRegister("eYYOy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cde560affa26929e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cde560affa26929e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorFlagTitle: {
        "id": "native-issue-table.rows.child-rows.error-flag-title",
        "defaultMessage": "We couldn't expand hierarchy"
    },
    errorFlagDescription: {
        "id": "native-issue-table.rows.child-rows.error-flag-description",
        "defaultMessage": "Someone may have deleted a task or changed access to the parent. Try again or contact an admin."
    },
    errorFlagGroupingTitle: {
        "id": "native-issue-table.rows.child-rows.error-flag-grouping-title",
        "defaultMessage": "We couldn't expand the group"
    },
    errorFlagGroupingDescription: {
        "id": "native-issue-table.rows.child-rows.error-flag-grouping-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});


parcelRegister("eSclU", function(module, exports) {

$parcel$export(module.exports, "ChildRowsLoader", () => $b2e52c6a1bb90691$export$148a4cf18f2e069b);

var $5SXMS = parcelRequire("5SXMS");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $jaNQz = parcelRequire("jaNQz");

var $5SXMS = parcelRequire("5SXMS");

var $kEUB1 = parcelRequire("kEUB1");

var $9AekN = parcelRequire("9AekN");

var $hCzdk = parcelRequire("hCzdk");

var $8dmSB = parcelRequire("8dmSB");
const $b2e52c6a1bb90691$export$148a4cf18f2e069b = (props)=>{
    const [issueSearch, loadQuery, dispose] = (0, $j4oe4.useQueryLoader)((0, $5SXMS.default));
    const cloudId = (0, $kEUB1.useCloudId)();
    const { sortField: sortField, sortDirection: sortDirection, jql: jql, columns: columns, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, isGroupingSupported: isGroupingSupported, pageSize: pageSize, amountOfColumns: amountOfColumns, actionColumns: actionColumns, isHideDoneItemsEnabled: isHideDoneItemsEnabled, projectKey: projectKey, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled } = props;
    const variables = (0, $eJOHy.useMemo)(()=>props.type === 'GROUP_CHILDREN' ? (0, $9AekN.getChildQueryVariablesForJql)({
            cloudId: cloudId,
            columns: columns,
            jql: props.groupJql,
            isReparentingEnabled: false,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            projectKey: projectKey,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled
        }) : (0, $9AekN.getChildQueryVariablesForParentIssue)({
            cloudId: cloudId,
            columns: columns,
            parentIssueKey: props.issueKey,
            sortDirection: sortDirection,
            sortField: sortField,
            jql: jql,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled
        }), [
        props.type,
        props.groupJql,
        props.issueKey,
        cloudId,
        columns,
        actionColumns,
        amountOfColumns,
        pageSize,
        sortDirection,
        sortField,
        jql,
        isConditionalFormattingEnabled,
        isHideDoneItemsEnabled,
        isReparentingEnabled,
        isTimelineEnabled,
        projectKey,
        isInlineFieldConfigEnabled
    ]);
    const prevIssueSearchInput = (0, $eJOHy.useRef)(variables.issueSearchInput);
    (0, $eJOHy.useEffect)(()=>{
        // This check prevents performing another network request for child items when the issue query changes
        // (which is unused as we re-fetch the issues when this happens). This is due to a race condition where
        // this component has not yet been unmounted when the issue query changes.
        if (props.isGroupingSupported && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(variables.issueSearchInput, prevIssueSearchInput.current)) return;
        loadQuery(variables);
        if (props.isGroupingSupported) prevIssueSearchInput.current = variables.issueSearchInput;
        return ()=>{
            dispose();
        };
    }, [
        variables,
        loadQuery,
        dispose,
        props.isGroupingSupported
    ]);
    if (!issueSearch) return null;
    const { groupId: groupId, depth: depth, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, parentIssueHierarchyLevel: parentIssueHierarchyLevel, connectionMetadata: connectionMetadata, isFormVisible: isFormVisible, formProps: formProps, rankFieldId: rankFieldId, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, width: width, isIssueRankDescending: isIssueRankDescending, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jaNQz.default), {
        name: "native-issue-table-child-rows-query",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hCzdk.default), {
            itemId: parentItemId,
            groupId: groupId,
            columnsCount: columns.length,
            isFixedTableLayoutEnabled: props.isFixedTableLayoutEnabled,
            renderTableCell: props.renderTableCell
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b2e52c6a1bb90691$export$410977b2c408dd5d, {
        issueSearch: issueSearch,
        depth: depth,
        parentItemId: parentItemId,
        itemsConnectionId: itemsConnectionId,
        parentIssueAri: parentIssueAri,
        parentItemConnectionId: parentItemConnectionId,
        parentIssueRelayConnectionId: parentIssueRelayConnectionId,
        parentIssueHierarchyLevel: parentIssueHierarchyLevel,
        connectionMetadata: connectionMetadata,
        isFormVisible: isFormVisible,
        formProps: formProps,
        projectKey: projectKey,
        isGroupingSupported: isGroupingSupported,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        pageSize: pageSize,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        renderRows: renderRows,
        renderCreateIssueController: renderCreateIssueController,
        groupId: groupId,
        columns: columns,
        rankFieldId: rankFieldId,
        renderDraggableWrapper: renderDraggableWrapper
    }));
};
const $b2e52c6a1bb90691$export$410977b2c408dd5d = ({ issueSearch: issueSearch, ...rest })=>{
    const queryData = (0, $j4oe4.usePreloadedQuery)((0, $5SXMS.default), issueSearch);
    if (rest.isGroupingSupported && queryData?.jira?.issueSearch?.issueSearchError?.__typename) switch(queryData.jira.issueSearch.issueSearchError.__typename){
        case 'JiraInvalidJqlError':
            throw new Error(queryData.jira.issueSearch.issueSearchError.messages?.[0] ?? 'Invalid JQL');
        case 'JiraInvalidSyntaxError':
        case 'JiraServerError':
            throw new Error(queryData.jira.issueSearch.issueSearchError.message ?? 'Unknown Error');
        default:
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8dmSB.ChildRowsPagination), {
        ...rest,
        query: queryData
    });
};

});
parcelRegister("5SXMS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8888d8c3c40fc7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57032c4eb82acb3cf95b1fb6492db14a>>
 * @relayHash a9410cbaf373de99a1e5028b4d887b9f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 556bb0fe7f248a0f16ea3b7476a2938cc77b977c29c96c61b623a7aa273753b3

var $kZq2R = parcelRequire("kZq2R");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $5CxJ3 = parcelRequire("5CxJ3");

var $eHMRp = parcelRequire("eHMRp");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $bU8Sj = parcelRequire("bU8Sj");

var $clCUA = parcelRequire("clCUA");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");
const $9a8888d8c3c40fc7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isReparentingEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v16 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v17 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "message"
        }
    ], v20 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v18 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v19 /*: any*/ ,
                "type": "JiraServerError"
            },
            {
                "kind": "InlineFragment",
                "selections": v19 /*: any*/ ,
                "type": "JiraInvalidSyntaxError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "id"
    }, v22 = {
        "kind": "ScalarField",
        "name": "key"
    }, v23 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v24 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "name"
    }, v26 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v27 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v29 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v30 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            v27 /*: any*/ ,
            v30 /*: any*/ 
        ],
        "type": "JiraStatusField"
    }, v32 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v33 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v34 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v35 = {
        "kind": "ScalarField",
        "name": "type"
    }, v36 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v37 = {
        "kind": "ScalarField",
        "name": "value"
    }, v38 = [
        v37 /*: any*/ ,
        v21 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v39 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v40 = {
        "kind": "ClientExtension",
        "selections": [
            v39 /*: any*/ 
        ]
    }, v41 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v42 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v43 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v44 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v45 = {
        "kind": "ScalarField",
        "name": "text"
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            v45 /*: any*/ ,
            v25 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v47 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v48 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v21 /*: any*/ 
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v50 = [
        v47 /*: any*/ 
    ], v51 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            v37 /*: any*/ 
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v53 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v54 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v55 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v56 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v57 = [
        v21 /*: any*/ 
    ], v58 = {
        "kind": "ClientExtension",
        "selections": [
            v26 /*: any*/ 
        ]
    }, v59 = [
        v25 /*: any*/ ,
        v21 /*: any*/ 
    ], v60 = {
        "kind": "ScalarField",
        "name": "date"
    }, v61 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v62 = [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                v33 /*: any*/ ,
                v25 /*: any*/ ,
                v21 /*: any*/ 
            ]
        }
    ], v63 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v45 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v64 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v48 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v65 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v66 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v65 /*: any*/ ,
                    v25 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            },
            v21 /*: any*/ 
        ]
    }, v67 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v68 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v69 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v70 = {
        "kind": "ScalarField",
        "name": "number"
    }, v71 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v72 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v73 = {
        "kind": "InlineFragment",
        "selections": [
            v60 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v74 = [
        v18 /*: any*/ ,
        v27 /*: any*/ ,
        v73 /*: any*/ ,
        v21 /*: any*/ 
    ], v75 = [
        v18 /*: any*/ ,
        v21 /*: any*/ 
    ], v76 = [
        v18 /*: any*/ ,
        v73 /*: any*/ ,
        v21 /*: any*/ 
    ], v77 = {
        "args": v72 /*: any*/ ,
        "kind": "LinkedField",
        "name": "startDateViewField",
        "plural": false,
        "selections": v76 /*: any*/ ,
        "storageKey": "startDateViewField(viewId:\"list_default\")"
    }, v78 = {
        "args": v72 /*: any*/ ,
        "kind": "LinkedField",
        "name": "endDateViewField",
        "plural": false,
        "selections": v76 /*: any*/ ,
        "storageKey": "endDateViewField(viewId:\"list_default\")"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "childRowsLoaderQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        v16 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "childRowsPagination_issueTableHierarchy_query"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v17 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                v4 /*: any*/ ,
                v9 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v10 /*: any*/ ,
                v3 /*: any*/ ,
                v12 /*: any*/ ,
                v11 /*: any*/ ,
                v15 /*: any*/ ,
                v14 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v13 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "childRowsLoaderQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v17 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v24 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isReparentingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v32 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v33 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v34 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                v36 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v35 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v21 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v38 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v38 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v43 /*: any*/ ,
                                                                                                                                v21 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v44 /*: any*/ ,
                                                                                                        v25 /*: any*/ ,
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                v46 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v47 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v37 /*: any*/ ,
                                                                                                                v48 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v49 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v50 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                v49 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v51 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v52 /*: any*/ ,
                                                                                                                                v25 /*: any*/ ,
                                                                                                                                v53 /*: any*/ ,
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v54 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v21 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraEstimate",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "originalEstimate",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "timeInSeconds"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingSettings",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingSettings",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingHoursPerDay"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingDaysPerWeek"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultFormat"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultUnit"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v40 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v55 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v42 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v25 /*: any*/ ,
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v43 /*: any*/ ,
                                                                                                                                v56 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": v57 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v22 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v58 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                v39 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "href"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v47 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": v19 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "componentsOld",
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v59 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v45 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v60 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v61 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v44 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v32 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v29 /*: any*/ ,
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v41 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v48 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v47 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v25 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": v62 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": v62 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v63 /*: any*/ ,
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v64 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v64 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                v67 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        v21 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v27 /*: any*/ ,
                                                                                                                                                v45 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v27 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v68 /*: any*/ ,
                                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                                        v65 /*: any*/ ,
                                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                                        v21 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        v31 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ ,
                                                                                                        v40 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v25 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v22 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v59 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v21 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v25 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v52 /*: any*/ ,
                                                                                                        v53 /*: any*/ ,
                                                                                                        v25 /*: any*/ ,
                                                                                                        v21 /*: any*/ ,
                                                                                                        v54 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v25 /*: any*/ ,
                                                                                                v61 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v25 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v41 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v59 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v65 /*: any*/ ,
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v47 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v67 /*: any*/ ,
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v29 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v21 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                v21 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v21 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                v70 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        v70 /*: any*/ ,
                                                                                                        v71 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        v70 /*: any*/ ,
                                                                                                        v25 /*: any*/ ,
                                                                                                        v71 /*: any*/ ,
                                                                                                        v40 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v25 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v21 /*: any*/ ,
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isEditableInIssueView"
                                                                                                        },
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v21 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "direction"
                                                                                                                },
                                                                                                                v69 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v57 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v21 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v59 /*: any*/ 
                                                                                                                        },
                                                                                                                        v21 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v30 /*: any*/ ,
                                                                                                                        v21 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "assigneeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v53 /*: any*/ ,
                                                                                                                                v21 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v21 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v72 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "startDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v74 /*: any*/ ,
                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v72 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "endDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v74 /*: any*/ ,
                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v58 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v50 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                },
                                                                                                                                v21 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v52 /*: any*/ ,
                                                                                                                                v21 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "priorityId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "version",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v56 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v68 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v56 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v75 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v75 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v55 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "filterByProjectKeys",
                                                            "variableName": "projectKeys"
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "args": [
                                                        v16 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        v58 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        }
                                    ]
                                },
                                v20 /*: any*/ ,
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v34 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v36 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v77 /*: any*/ ,
                                                                                                                v78 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                },
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 10
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v77 /*: any*/ ,
                                                                                        v78 /*: any*/ ,
                                                                                        v23 /*: any*/ ,
                                                                                        v22 /*: any*/ ,
                                                                                        v21 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v69 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v58 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v34 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v51 /*: any*/ ,
                                                                                                                        v58 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v49 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v58 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v17 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput",
                                "scope"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "556bb0fe7f248a0f16ea3b7476a2938cc77b977c29c96c61b623a7aa273753b3",
            "metadata": {},
            "name": "childRowsLoaderQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $eHMRp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider": (0, $5CxJ3.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default)
            }
        }
    };
}();
$9a8888d8c3c40fc7$var$node.hash = "d221e5e8a7404b56943d245bb6127ce5";
var $9a8888d8c3c40fc7$export$2e2bcd8739ae039 = $9a8888d8c3c40fc7$var$node;

});

parcelRegister("9AekN", function(module, exports) {

$parcel$export(module.exports, "getChildQueryVariablesForJql", () => $014130e7555c3d46$export$e5b06f7246d135e);
$parcel$export(module.exports, "getChildQueryVariablesForParentIssue", () => $014130e7555c3d46$export$e350acffa980a984);

var $7jTnu = parcelRequire("7jTnu");

var $j8Km1 = parcelRequire("j8Km1");

var $awWeA = parcelRequire("awWeA");
const $014130e7555c3d46$var$getProjectKeyFromIssueKey = (issueKey)=>{
    return issueKey.split('-')[0];
};
const $014130e7555c3d46$var$getChildQueryVariablesBase = ({ cloudId: cloudId, columns: columns, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize, projectKey: projectKey, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled })=>{
    let fieldSetIds = columns.filter((column)=>!!column.id && !actionColumns.includes(column.id)).map((column)=>column.id).sort();
    const mergedColumnsIds = (0, $7jTnu.fg)('jira_list_merged_column_gate') ? (columns.find((col)=>col?.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns ?? []).map((col)=>col.id) : [];
    fieldSetIds = [
        ...mergedColumnsIds,
        ...fieldSetIds
    ];
    const operationScope = (0, $awWeA.getOperationScope)(projectKey);
    const fieldSetsScope = isInlineFieldConfigEnabled ? {
        operationScope: operationScope,
        projectKey: projectKey
    } : null;
    return {
        cloudId: cloudId,
        amountOfColumns: amountOfColumns,
        fieldSetsInput: {
            fieldSetIds: fieldSetIds
        },
        fieldSetIds: fieldSetIds,
        first: pageSize,
        namespace: '',
        shouldQueryFieldSetsById: true,
        filterId: null,
        viewId: null,
        isReparentingEnabled: isReparentingEnabled,
        isTimelineEnabled: isTimelineEnabled,
        scope: fieldSetsScope
    };
};
const $014130e7555c3d46$export$e5b06f7246d135e = ({ cloudId: cloudId, columns: columns, jql: jql, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, projectKey: projectKey, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled })=>{
    return {
        ...$014130e7555c3d46$var$getChildQueryVariablesBase({
            cloudId: cloudId,
            columns: columns,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            projectKey: projectKey,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled
        }),
        issueSearchInput: {
            jql: jql
        },
        shouldQueryHasChildren: false,
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        ...isHideDoneItemsEnabled && (0, $7jTnu.fg)('jsc_list_hide_done_items') && {
            viewConfigInput: {
                staticViewInput: {
                    isHideDoneEnabled: true
                }
            }
        }
    };
};
const $014130e7555c3d46$export$e350acffa980a984 = ({ cloudId: cloudId, columns: columns, parentIssueKey: parentIssueKey, jql: jql, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled })=>{
    const projectKey = $014130e7555c3d46$var$getProjectKeyFromIssueKey(parentIssueKey);
    return {
        ...$014130e7555c3d46$var$getChildQueryVariablesBase({
            cloudId: cloudId,
            columns: columns,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            projectKey: projectKey,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled
        }),
        issueSearchInput: {
            childIssuesInput: {
                parentIssueKey: parentIssueKey,
                filterByProjectKeys: [
                    projectKey
                ],
                ...jql ? {
                    jql: jql
                } : {},
                ...(0, $7jTnu.fg)('jsc_list_hide_done_items') && {
                    namespace: 'ISSUE_NAVIGATOR'
                }
            }
        },
        projectKeys: [
            projectKey
        ],
        projectKey: projectKey,
        viewConfigInput: {
            staticViewInput: {
                isHierarchyEnabled: true,
                isGroupingEnabled: false,
                ...(0, $7jTnu.fg)('jsc_list_hide_done_items') && {
                    isHideDoneEnabled: isHideDoneItemsEnabled
                }
            }
        },
        shouldQueryHasChildren: true,
        isConditionalFormattingEnabled: isConditionalFormattingEnabled
    };
};

});

parcelRegister("hCzdk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f47963be7d20baa6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jE8Tu = parcelRequire("jE8Tu");
const $f47963be7d20baa6$var$LoadingIssueRow = ({ itemId: itemId, groupId: groupId, columnsCount: columnsCount, isFixedTableLayoutEnabled: isFixedTableLayoutEnabled, renderTableCell: renderTableCell })=>{
    const { setItemIsLoading: setItemIsLoading } = (0, $jE8Tu.useHierarchyActions)();
    (0, $eJOHy.useEffect)(()=>{
        setItemIsLoading({
            itemId: itemId,
            groupId: groupId,
            isLoading: true
        });
        return ()=>{
            setItemIsLoading({
                itemId: itemId,
                groupId: groupId,
                isLoading: false
            });
        };
    }, [
        itemId,
        groupId,
        setItemIsLoading
    ]);
    const columns = Array.from({
        length: columnsCount
    });
    const colSpans = columns.map((_, index)=>{
        const isLastColumn = index === columns.length - 1;
        return 1 + (isLastColumn && isFixedTableLayoutEnabled ? 1 : 0);
    });
    return /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        as: "tr",
        xcss: $f47963be7d20baa6$var$wrapperStyles
    }, columns.map((_, i)=>renderTableCell({
            key: `${itemId}-${i}`,
            colSpan: colSpans[i],
            border: [
                $f47963be7d20baa6$var$cellBorderStyles,
                i === columnsCount - 1 && $f47963be7d20baa6$var$lastCellBorderStyles
            ],
            children: /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
                xcss: $f47963be7d20baa6$var$loadingCellStyles
            })
        })));
};
var $f47963be7d20baa6$export$2e2bcd8739ae039 = $f47963be7d20baa6$var$LoadingIssueRow;
const $f47963be7d20baa6$var$wrapperStyles = (0, $1DXK0.xcss)({
    height: '40px'
});
const $f47963be7d20baa6$var$cellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: 'border.width',
    borderBottomWidth: '0',
    borderLeftWidth: '0',
    borderRightWidth: 'border.width'
});
const $f47963be7d20baa6$var$lastCellBorderStyles = (0, $1DXK0.xcss)({
    borderRightWidth: '0'
});
const $f47963be7d20baa6$var$loadingCellStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    padding: 'space.150',
    width: '100%'
});

});

parcelRegister("8dmSB", function(module, exports) {

$parcel$export(module.exports, "ChildRowsPagination", () => $239ba3a7fd9f3860$export$74d2c2d9ae144c85);

var $3uZzS = parcelRequire("3uZzS");

var $bvI7I = parcelRequire("bvI7I");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $jE8Tu = parcelRequire("jE8Tu");

var $dLXgn = parcelRequire("dLXgn");

var $4gytc = parcelRequire("4gytc");

var $7Slu4 = parcelRequire("7Slu4");
const $239ba3a7fd9f3860$var$PACKAGE_LOCATION = 'jira-issue-table-hierarchy-child-rows-pagination';
const $239ba3a7fd9f3860$export$74d2c2d9ae144c85 = ({ query: query, depth: depth, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, parentIssueHierarchyLevel: parentIssueHierarchyLevel, isFormVisible: isFormVisible, formProps: formProps, connectionMetadata: connectionMetadata, projectKey: projectKey, pageSize: pageSize, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, isIssueRankDescending: isIssueRankDescending, groupId: groupId, width: width, columns: columns, rankFieldId: rankFieldId, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper })=>{
    const { data: queryData, loadNext: loadNext, isLoadingNext: isLoadingNext, hasNext: hasNext } = (0, $j4oe4.usePaginationFragment)((0, $bvI7I.default), query);
    const issueResultsData = (0, $j4oe4.useFragment)((0, $3uZzS.default), queryData?.jira?.issueSearch);
    const { type: type } = connectionMetadata || {};
    const isGroupChildren = type === 'GROUP_CHILDREN';
    const onCreateIssueRef = (0, $eJOHy.useRef)();
    const setOnCreateIssue = (0, $eJOHy.useCallback)((onCreateIssue)=>{
        onCreateIssueRef.current = onCreateIssue;
    }, []);
    // Set the issue count on the group record if needed
    (0, $4gytc.useUpdateGroupIssueCountOnExpand)({
        groupId: groupId,
        isGroupChildren: isGroupChildren,
        totalIssueSearchResultCount: issueResultsData.totalIssueSearchResultCount || 0,
        isCappingIssueSearchResult: issueResultsData.isCappingIssueSearchResult ?? false
    });
    const onExperienceLoadMoreStart = (0, $8Uqf3.useExperienceStart)({
        experience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource
    });
    const onExperienceLoadMoreFail = (0, $aqnJa.useExperienceFail)({
        experience: childItemsLoadMoreExperience,
        attributes: {}
    });
    const onExperienceLoadMoreSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: childItemsLoadMoreExperience,
        attributes: {}
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: childItemsExperience,
        attributes: {}
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    const childConnectionId = issueResultsData.__id;
    const [isSelected] = (0, $jE8Tu.useIsSelected)({
        itemsConnectionId: itemsConnectionId,
        groupId: groupId,
        itemId: parentItemId
    });
    const siblingIssueId = issueResultsData.edges?.[0]?.node?.id;
    const isChildIssueCreateRowVisible = isSelected && !!formProps && isFormVisible;
    if ((0, $epTsa.expVal)('jira_list_realtime_updates_with_queue', 'isEnabled', false)) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4gytc.useUpdateHierarchyHasChildrenOnExpand)({
        connectionMetadata: connectionMetadata,
        projectKey: projectKey,
        childCount: issueResultsData.edges?.length ?? 0
    });
    const connectionDetails = (0, $eJOHy.useMemo)(()=>{
        if (issueResultsData?.edges?.length === undefined || issueResultsData.edges.length === 0 && !isChildIssueCreateRowVisible || !connectionMetadata) return undefined;
        return {
            connectionId: childConnectionId,
            // This is the value the backend uses to fetch the issue list for realtime updates. It should be the connection length + 1
            // to ensure a potentially newly created issue is also fetched and included in the results.
            first: issueResultsData.edges.length + 1,
            ...connectionMetadata,
            ...(0, $7jTnu.fg)('jira_inline_field_config_gate') ? {
                fieldSetsData: queryData?.jira?.issueSearch
            } : {}
        };
    }, [
        childConnectionId,
        connectionMetadata,
        isChildIssueCreateRowVisible,
        issueResultsData.edges?.length,
        queryData?.jira?.issueSearch
    ]);
    (0, $dLXgn.useRegisterConnection)(connectionDetails);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onCompleteLoadNextItems = (0, $eJOHy.useCallback)((error)=>{
        if (!error) onExperienceLoadMoreSuccess();
        else onExperienceLoadMoreFail($239ba3a7fd9f3860$var$PACKAGE_LOCATION, error);
    }, [
        onExperienceLoadMoreFail,
        onExperienceLoadMoreSuccess
    ]);
    const loadNextItems = (0, $eJOHy.useCallback)(()=>{
        onExperienceLoadMoreStart();
        const actionSubjectId = isGroupChildren ? 'groupingLoadMore' : 'hierarchyLoadMore';
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        loadNext(pageSize, {
            onComplete: onCompleteLoadNextItems
        });
    }, [
        pageSize,
        onExperienceLoadMoreStart,
        isGroupChildren,
        createAnalyticsEvent,
        loadNext,
        onCompleteLoadNextItems
    ]);
    const renderChildIssueCreateRow = (0, $eJOHy.useCallback)(()=>isChildIssueCreateRowVisible && onCreateIssueRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Slu4.ChildIssueCreateRow), {
            depth: depth,
            parentIssueAri: parentIssueAri,
            siblingIssueId: siblingIssueId,
            isFormVisible: isFormVisible ?? false,
            ...formProps,
            width: width,
            isIssueRankDescending: isIssueRankDescending,
            onCreateIssue: onCreateIssueRef.current,
            columns: columns,
            rankFieldId: rankFieldId,
            isGrouping: !!groupId && (0, $7jTnu.fg)('jira_list_merged_column_gate')
        }) : null, [
        groupId,
        isChildIssueCreateRowVisible,
        depth,
        parentIssueAri,
        siblingIssueId,
        isFormVisible,
        formProps,
        width,
        isIssueRankDescending,
        columns,
        rankFieldId
    ]);
    const renderChildRowsBody = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderCreateIssueController({
            childConnectionId: issueResultsData.__id,
            parentItemConnectionId: parentItemConnectionId,
            setOnCreateIssue: setOnCreateIssue
        }), renderRows({
            issueResults: issueResultsData,
            depth: depth + 1,
            parentItemId: parentItemId,
            itemsConnectionId: itemsConnectionId,
            parentIssueAri: parentIssueAri,
            parentItemConnectionId: parentItemConnectionId,
            parentIssueHierarchyLevel: parentIssueHierarchyLevel,
            isLoadingNext: isLoadingNext,
            hasNext: hasNext,
            rankFieldId: rankFieldId,
            onLoadNextItems: loadNextItems,
            renderChildIssueCreateRow: renderChildIssueCreateRow,
            isChildIssueCreateRowVisible: isChildIssueCreateRowVisible,
            parentIssueRelayConnectionId: parentIssueRelayConnectionId,
            ...(0, $7jTnu.fg)('jsc_list_reparenting') ? {
                projectKey: projectKey
            } : {}
        }));
    }, [
        renderCreateIssueController,
        issueResultsData,
        parentItemConnectionId,
        setOnCreateIssue,
        renderRows,
        depth,
        parentItemId,
        itemsConnectionId,
        parentIssueAri,
        parentIssueHierarchyLevel,
        isLoadingNext,
        hasNext,
        rankFieldId,
        loadNextItems,
        renderChildIssueCreateRow,
        isChildIssueCreateRowVisible,
        parentIssueRelayConnectionId,
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderDraggableWrapper ? renderDraggableWrapper({
        instanceId: issueResultsData?.__id,
        issueConnectionId: childConnectionId,
        children: renderChildRowsBody()
    }) : renderChildRowsBody());
};

});
parcelRegister("3uZzS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b134a5ad2006039$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11f3c212931bb7de3fe159e41d9555db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5b134a5ad2006039$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "childRowsPagination_issueTableHierarchy_queryData",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "rows_nativeIssueTable_issueResults"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$5b134a5ad2006039$var$node.hash = "7f88c1df42f7159fce665e1396e69c53";
var $5b134a5ad2006039$export$2e2bcd8739ae039 = $5b134a5ad2006039$var$node;

});

parcelRegister("bvI7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $fec58b7cab94289c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ff05601a31c7a8ec422483e493cc776>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $bbv44 = parcelRequire("bbv44");
const $fec58b7cab94289c$var$node = function() {
    var v0 = [
        "jira",
        "issueSearch"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $bbv44.default)
            }
        },
        "name": "childRowsPagination_issueTableHierarchy_query",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "issueSearch",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "fieldSetsInput",
                                        "variableName": "fieldSetsInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "issueSearchInput",
                                        "variableName": "issueSearchInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "options",
                                        "variableName": "options"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "scope",
                                        "variableName": "scope"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "viewConfigInput",
                                        "variableName": "viewConfigInput"
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "__hierarchy_nativeIssueTable__issueSearch_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "isConditionalFormattingEnabled",
                                                "variableName": "isConditionalFormattingEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isDensityFull",
                                                "variableName": "isDensityFull"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isInlineEditingEnabled",
                                                "variableName": "isInlineEditingEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isReparentingEnabled",
                                                "variableName": "isReparentingEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isTimelineEnabled",
                                                "variableName": "isTimelineEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "projectKey",
                                                "variableName": "projectKey"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "projectKeys",
                                                "variableName": "projectKeys"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "shouldQueryHasChildren",
                                                "variableName": "shouldQueryHasChildren"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "childRowsPagination_issueTableHierarchy_queryData"
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "InlineDataFragmentSpread",
                                                "name": "optimisticUpdatesSelectedOptionsQuery",
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "first",
                                                                        "value": 500
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueFieldSetConnection",
                                                                "kind": "LinkedField",
                                                                "name": "fieldSets",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueFieldSetEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldSet",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v2 /*: any*/ ,
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldConnection",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "fields",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueFieldEdge",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "edges",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "node",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v1 /*: any*/ ,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "fieldId"
                                                                                                            },
                                                                                                            v2 /*: any*/ ,
                                                                                                            {
                                                                                                                "kind": "InlineFragment",
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "concreteType": "JiraOptionConnection",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "selectedOptions",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "concreteType": "JiraOptionEdge",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "edges",
                                                                                                                                "plural": true,
                                                                                                                                "selections": [
                                                                                                                                    {
                                                                                                                                        "concreteType": "JiraOption",
                                                                                                                                        "kind": "LinkedField",
                                                                                                                                        "name": "node",
                                                                                                                                        "plural": false,
                                                                                                                                        "selections": [
                                                                                                                                            {
                                                                                                                                                "kind": "ScalarField",
                                                                                                                                                "name": "id"
                                                                                                                                            },
                                                                                                                                            {
                                                                                                                                                "kind": "ScalarField",
                                                                                                                                                "name": "value"
                                                                                                                                            }
                                                                                                                                        ]
                                                                                                                                    },
                                                                                                                                    v3 /*: any*/ 
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ],
                                                                                                                "type": "JiraCheckboxesField"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "InlineFragment",
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "concreteType": "JiraOption",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "fieldOption",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "ScalarField",
                                                                                                                                "name": "optionId"
                                                                                                                            }
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ],
                                                                                                                "type": "JiraSingleSelectField"
                                                                                                            },
                                                                                                            v3 /*: any*/ 
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    v3 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "fieldSets(first:500)"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "argumentDefinitions": []
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasPreviousPage"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "startCursor"
                                            }
                                        ]
                                    },
                                    v3 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.issueSearch"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$fec58b7cab94289c$var$node.hash = "84cb82fcd93633a34966af83533d2554";
var $fec58b7cab94289c$export$2e2bcd8739ae039 = $fec58b7cab94289c$var$node;

});
parcelRegister("bbv44", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d7551dd29053c95$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8d49d2c40922ecce9456141ed675711b>>
 * @relayHash ea5bc1b687c3324896e2b263f2376c12
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6ed7c2202e0bf993ca1f762024a0c14576064778c62e5c9cea3a5b4aad05d8cd

var $kZq2R = parcelRequire("kZq2R");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $5CxJ3 = parcelRequire("5CxJ3");

var $eHMRp = parcelRequire("eHMRp");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $bU8Sj = parcelRequire("bU8Sj");

var $clCUA = parcelRequire("clCUA");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");
const $2d7551dd29053c95$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v7 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJscIFCEnabled"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isReparentingEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v19 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v20 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "kind": "ScalarField",
        "name": "id"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v25 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "name"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v28 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v30 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v22 /*: any*/ 
        ]
    }, v31 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v22 /*: any*/ 
        ]
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            v28 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraStatusField"
    }, v33 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v34 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v35 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v36 = {
        "kind": "ScalarField",
        "name": "type"
    }, v37 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v38 = {
        "kind": "ScalarField",
        "name": "value"
    }, v39 = [
        v38 /*: any*/ ,
        v22 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v40 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v41 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v42 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v43 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v44 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v45 = {
        "kind": "ScalarField",
        "name": "text"
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            v45 /*: any*/ ,
            v26 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v47 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v48 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v22 /*: any*/ 
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v50 = [
        v47 /*: any*/ 
    ], v51 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v53 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v54 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v55 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v56 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v57 = [
        v22 /*: any*/ 
    ], v58 = {
        "kind": "ClientExtension",
        "selections": [
            v27 /*: any*/ 
        ]
    }, v59 = [
        v26 /*: any*/ ,
        v22 /*: any*/ 
    ], v60 = {
        "kind": "ScalarField",
        "name": "date"
    }, v61 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v62 = [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                v34 /*: any*/ ,
                v26 /*: any*/ ,
                v22 /*: any*/ 
            ]
        }
    ], v63 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v45 /*: any*/ ,
            v22 /*: any*/ 
        ]
    }, v64 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v48 /*: any*/ ,
            v22 /*: any*/ 
        ]
    }, v65 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v66 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v65 /*: any*/ ,
                    v26 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            },
            v22 /*: any*/ 
        ]
    }, v67 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v68 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v69 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v70 = {
        "kind": "ScalarField",
        "name": "number"
    }, v71 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v72 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v73 = {
        "kind": "InlineFragment",
        "selections": [
            v60 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v74 = [
        v21 /*: any*/ ,
        v28 /*: any*/ ,
        v73 /*: any*/ ,
        v22 /*: any*/ 
    ], v75 = [
        v21 /*: any*/ ,
        v22 /*: any*/ 
    ], v76 = [
        v21 /*: any*/ ,
        v73 /*: any*/ ,
        v22 /*: any*/ 
    ], v77 = {
        "args": v72 /*: any*/ ,
        "kind": "LinkedField",
        "name": "startDateViewField",
        "plural": false,
        "selections": v76 /*: any*/ ,
        "storageKey": "startDateViewField(viewId:\"list_default\")"
    }, v78 = {
        "args": v72 /*: any*/ ,
        "kind": "LinkedField",
        "name": "endDateViewField",
        "plural": false,
        "selections": v76 /*: any*/ ,
        "storageKey": "endDateViewField(viewId:\"list_default\")"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isDensityFull",
                            "variableName": "isDensityFull"
                        },
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        v19 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "childRowsPagination_issueTableHierarchy_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v20 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                v22 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v27 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v22 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isDensityFull",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canBeExported"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isReparentingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v33 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v34 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v35 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        v36 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v39 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v39 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v43 /*: any*/ ,
                                                                                                                                v22 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v44 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                v46 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v47 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v48 /*: any*/ ,
                                                                                                                v22 /*: any*/ ,
                                                                                                                v49 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v50 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v49 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v51 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v52 /*: any*/ ,
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v53 /*: any*/ ,
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v54 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraEstimate",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "originalEstimate",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "timeInSeconds"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingSettings",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingSettings",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingHoursPerDay"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingDaysPerWeek"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultFormat"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultUnit"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v36 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v22 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v55 /*: any*/ ,
                                                                                                                v22 /*: any*/ ,
                                                                                                                v42 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v43 /*: any*/ ,
                                                                                                                                v56 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": v57 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v23 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v58 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        v40 /*: any*/ ,
                                                                                                        v58 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "href"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v47 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "componentsOld",
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v59 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v45 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v60 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                v61 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v44 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v23 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v22 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        v29 /*: any*/ ,
                                                                                                        v22 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v30 /*: any*/ ,
                                                                                                        v22 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v41 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v48 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v47 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v26 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": v62 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": v62 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v23 /*: any*/ ,
                                                                                                        v63 /*: any*/ ,
                                                                                                        v22 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v64 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                v22 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v64 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                v22 /*: any*/ ,
                                                                                                                v24 /*: any*/ ,
                                                                                                                v67 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v21 /*: any*/ ,
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v28 /*: any*/ ,
                                                                                                                                                v45 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v28 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v68 /*: any*/ ,
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v65 /*: any*/ ,
                                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                                        v22 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        v32 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v26 /*: any*/ ,
                                                                                                        v40 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v22 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        v23 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v22 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v59 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        v52 /*: any*/ ,
                                                                                                        v53 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v22 /*: any*/ ,
                                                                                                        v54 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ ,
                                                                                                v61 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v26 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v41 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v59 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "json"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        v65 /*: any*/ ,
                                                                                                        v22 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v47 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v67 /*: any*/ ,
                                                                                                                                v23 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v21 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v30 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v22 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                v22 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                v70 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        v70 /*: any*/ ,
                                                                                                        v71 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        v70 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        v71 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v26 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "direction"
                                                                                                                },
                                                                                                                v69 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v57 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "isInlineEditingEnabled",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isEditableInIssueView"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v24 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v59 /*: any*/ 
                                                                                                                        },
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v23 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v31 /*: any*/ ,
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "assigneeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v53 /*: any*/ ,
                                                                                                                                v22 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v72 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "startDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v74 /*: any*/ ,
                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v72 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "endDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v74 /*: any*/ ,
                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v58 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v50 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                },
                                                                                                                                v22 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v52 /*: any*/ ,
                                                                                                                                v22 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "priorityId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "version",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v56 /*: any*/ ,
                                                                                                                v22 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v68 /*: any*/ ,
                                                                                                                v22 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v56 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v75 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v75 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v55 /*: any*/ ,
                                                                                                                v22 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "filterByProjectKeys",
                                                            "variableName": "projectKeys"
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "args": [
                                                        v19 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        v58 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v35 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v37 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v77 /*: any*/ ,
                                                                                                                v78 /*: any*/ ,
                                                                                                                v22 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                },
                                                                                                v22 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 10
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v22 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v77 /*: any*/ ,
                                                                                        v78 /*: any*/ ,
                                                                                        v24 /*: any*/ ,
                                                                                        v23 /*: any*/ ,
                                                                                        v22 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v69 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v58 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v35 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v51 /*: any*/ ,
                                                                                                                        v58 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v49 /*: any*/ ,
                                                                                                                v22 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v58 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v20 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput",
                                "scope"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6ed7c2202e0bf993ca1f762024a0c14576064778c62e5c9cea3a5b4aad05d8cd",
            "metadata": {},
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isJscIFCEnabled": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $eHMRp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider": (0, $5CxJ3.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default)
            }
        }
    };
}();
$2d7551dd29053c95$var$node.hash = "84cb82fcd93633a34966af83533d2554";
var $2d7551dd29053c95$export$2e2bcd8739ae039 = $2d7551dd29053c95$var$node;

});


parcelRegister("4gytc", function(module, exports) {

$parcel$export(module.exports, "useUpdateHierarchyHasChildrenOnExpand", () => $c9ddcf47968a6013$export$7ab3d5838740f061);
$parcel$export(module.exports, "useUpdateGroupIssueCountOnExpand", () => $c9ddcf47968a6013$export$60baf22d0466329d);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kqd31 = parcelRequire("kqd31");
const $c9ddcf47968a6013$export$7ab3d5838740f061 = ({ connectionMetadata: connectionMetadata, projectKey: projectKey, childCount: childCount })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    (0, $eJOHy.useEffect)(()=>{
        if (connectionMetadata?.type === 'PARENT_CHILDREN' && childCount === 0) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const parentIssueRecord = store.get(connectionMetadata.parentRelayId);
            const updateArgs = projectKey ? {
                filterByProjectKeys: [
                    projectKey
                ]
            } : undefined;
            if (parentIssueRecord && parentIssueRecord.getValue('hasChildren', updateArgs) === true) parentIssueRecord.setValue(false, 'hasChildren', updateArgs);
        });
    }, [
        childCount,
        connectionMetadata,
        environment,
        projectKey
    ]);
};
const $c9ddcf47968a6013$export$60baf22d0466329d = ({ groupId: groupId, isGroupChildren: isGroupChildren, totalIssueSearchResultCount: totalIssueSearchResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    // we need to update the group only once when the component mounts which happens on first expand
    // Other changes to issue count will be handled by realtime connection updates
    // also, we don't need to update the "firstGroup" field in the group record as it's expanded on default and realtime event always updates it
    const hasIssueCountUpdated = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasIssueCountUpdated.current && groupId && isGroupChildren) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const relayId = (0, $kqd31.default)({
                id: groupId
            }, 'JiraSpreadsheetGroup');
            if (!relayId) return;
            const groupRecord = store.get(relayId);
            if (groupRecord?.getValue('issueCount') !== totalIssueSearchResultCount && !isCappingIssueSearchResult) groupRecord?.setValue(totalIssueSearchResultCount, 'issueCount');
        });
        hasIssueCountUpdated.current = true;
    }, [
        environment,
        groupId,
        isCappingIssueSearchResult,
        isGroupChildren,
        totalIssueSearchResultCount
    ]);
};

});

parcelRegister("7Slu4", function(module, exports) {

$parcel$export(module.exports, "ChildIssueCreateRow", () => $ab6d35972ebfb79a$export$3a3a78b432b7032f);

var $eJOHy = parcelRequire("eJOHy");

var $gOwRD = parcelRequire("gOwRD");
const $ab6d35972ebfb79a$export$3a3a78b432b7032f = ({ isFormVisible: isFormVisible, ...props })=>{
    return isFormVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gOwRD.IssueCreateCell), props));
};

});
parcelRegister("gOwRD", function(module, exports) {

$parcel$export(module.exports, "IssueCreateCell", () => $1a3532c480c6bbee$export$2337c3632571bf46);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6xIZT = parcelRequire("6xIZT");
const $1a3532c480c6bbee$export$2337c3632571bf46 = ({ parentIssueAri: parentIssueAri, siblingIssueId: siblingIssueId, depth: depth, isIssueRankDescending: isIssueRankDescending, width: width, onCreateIssue: onCreateIssue, rankFieldId: rankFieldId, ...props })=>{
    const formContextualFields = (0, $eJOHy.useMemo)(()=>isIssueRankDescending ? {
            rankAfterIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        } : {
            rankBeforeIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        }, [
        isIssueRankDescending,
        siblingIssueId,
        rankFieldId
    ]);
    const handleIssueCreate = (0, $eJOHy.useCallback)((issueToCreate, contextualFields)=>{
        onCreateIssue(issueToCreate, {
            ...contextualFields,
            parentIssueAri: parentIssueAri
        }, {
            insertAfter: false,
            insertNodeId: siblingIssueId
        });
    }, [
        onCreateIssue,
        parentIssueAri,
        siblingIssueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td",
        xcss: $1a3532c480c6bbee$var$cellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1a3532c480c6bbee$var$boxStyles,
        style: {
            width: `${width}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        contextualFields: formContextualFields,
        onCreateIssue: handleIssueCreate,
        depth: depth + 1,
        rankFieldId: rankFieldId,
        ...props
    })));
};
const $1a3532c480c6bbee$var$cellStyles = (0, $1DXK0.xcss)({
    height: '40px',
    left: 'space.0',
    position: 'sticky',
    zIndex: 'card'
});
const $1a3532c480c6bbee$var$boxStyles = (0, $1DXK0.xcss)({
    left: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});




parcelRegister("9I6ok", function(module, exports) {

$parcel$export(module.exports, "FirstGroupRow", () => $f6a7bf7663c9578c$export$ac1801bcb8e0f256);
$parcel$export(module.exports, "GroupRow", () => $f6a7bf7663c9578c$export$84aac6ac2cec7eed);

var $ce0E2 = parcelRequire("ce0E2");

var $g9Gmp = parcelRequire("g9Gmp");

var $eSOGk = parcelRequire("eSOGk");

var $eJOHy = parcelRequire("eJOHy");

var $8sbs2 = parcelRequire("8sbs2");

var $j4oe4 = parcelRequire("j4oe4");

var $68iTT = parcelRequire("68iTT");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $jE8Tu = parcelRequire("jE8Tu");

var $9AekN = parcelRequire("9AekN");

var $epTsa = parcelRequire("epTsa");

var $814y1 = parcelRequire("814y1");

var $8ntPR = parcelRequire("8ntPR");

var $lkZRv = parcelRequire("lkZRv");

var $4k0Ma = parcelRequire("4k0Ma");

var $6sgpk = parcelRequire("6sgpk");
const $f6a7bf7663c9578c$var$getGroupFieldValue = (fieldValue)=>{
    switch(fieldValue?.__typename){
        case 'JiraJqlPriorityFieldValue':
            return fieldValue?.priority?.priorityId ?? null;
        case 'JiraJqlUserFieldValue':
            return fieldValue?.user?.accountId ?? null;
        case 'JiraJqlStatusFieldValue':
            return fieldValue?.status?.id ?? null;
        case 'JiraJqlNumberFieldValue':
            return fieldValue?.number?.toString() ?? null;
        case 'JiraJqlOptionFieldValue':
            return fieldValue?.option?.optionId ?? null;
        case 'JiraJqlSprintFieldValue':
            return fieldValue?.sprint?.sprintId ?? null;
        case 'JiraJqlGoalsFieldValue':
            return fieldValue?.goal?.id ?? null;
        case 'JiraJqlLabelFieldValue':
            return fieldValue?.label?.name ?? null;
        case 'JiraJqlGroupPickerFieldValue':
            return fieldValue?.group?.name ?? null;
        default:
            return null;
    }
};
const $f6a7bf7663c9578c$var$toGroupContextFieldInput = ({ fieldId: fieldId, fieldValue: fieldValue, groupId: groupId, fieldType: fieldType, fieldSetId: fieldSetId })=>{
    const groupFieldValueBase = {
        fieldId: fieldId,
        groupId: groupId,
        optimisticResponse: fieldSetId ? $f6a7bf7663c9578c$export$6afa27f3196791b2({
            fieldType: fieldType,
            fieldId: fieldId,
            fieldSetId: fieldSetId,
            fieldValue: fieldValue
        }) : undefined
    };
    switch(fieldValue?.__typename){
        case 'JiraJqlPriorityFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $814y1.PRIORITY_TYPE),
                fieldValue: fieldValue?.priority?.priorityId ?? null
            };
        case 'JiraJqlUserFieldValue':
            return (0, $8ntPR.isUserFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.user?.accountId ?? null
            } : undefined;
        case 'JiraJqlStatusFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $814y1.STATUS_TYPE),
                fieldValue: fieldValue?.status?.id ?? null
            };
        case 'JiraJqlNumberFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $814y1.NUMBER_CF_TYPE),
                fieldValue: fieldValue?.number ?? null
            };
        case 'JiraJqlOptionFieldValue':
            return (0, $8ntPR.isOptionFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.option?.optionId ?? null
            } : undefined;
        case 'JiraJqlSprintFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $814y1.SPRINT_TYPE),
                fieldValue: fieldValue?.sprint?.sprintId ?? null
            };
        case 'JiraJqlLabelFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $814y1.LABELS_TYPE),
                fieldValue: fieldValue?.label?.name ?? null
            };
        case 'JiraJqlGroupPickerFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $814y1.MULTI_GROUP_CF_TYPE),
                fieldValue: fieldValue?.group?.name ?? null
            };
        case 'JiraJqlVersionFieldValue':
            return (0, $8ntPR.isVersionFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.version?.versionId ?? null
            } : undefined;
        default:
            return undefined;
    }
};
const $f6a7bf7663c9578c$export$6afa27f3196791b2 = ({ fieldType: fieldType, fieldId: fieldId, fieldSetId: fieldSetId, fieldValue: fieldValue })=>{
    if (!fieldSetId && (0, $7jTnu.fg)('group_by_any_fields_technical')) return undefined;
    switch(fieldType){
        case 0, $814y1.PRIORITY_TYPE:
            if (fieldValue?.__typename === 'JiraJqlPriorityFieldValue' && fieldValue?.priority) return {
                type: (0, $814y1.PRIORITY_TYPE),
                fieldSetId: fieldSetId,
                priority: {
                    id: fieldValue.priority.priorityId,
                    name: fieldValue.priority.name,
                    iconUrl: fieldValue.priority.iconUrl
                }
            };
            break;
        case 0, $814y1.ASSIGNEE_TYPE:
        case 0, $814y1.REPORTER_TYPE:
        case 0, $814y1.USER_CF_TYPE:
            return {
                type: (0, $7jTnu.fg)('group_by_any_fields_technical') ? fieldType : (0, $814y1.ASSIGNEE_TYPE),
                fieldSetId: fieldSetId,
                user: fieldValue?.__typename === 'JiraJqlUserFieldValue' && fieldValue?.user ? {
                    id: fieldValue.user.accountId,
                    accountId: fieldValue.user.accountId,
                    name: fieldValue.user.name,
                    picture: fieldValue.user.picture
                } : null
            };
        case 0, $814y1.STATUS_TYPE:
            if (fieldValue?.__typename === 'JiraJqlStatusFieldValue' && fieldValue?.status && fieldValue?.status.statusCategory) return {
                type: (0, $814y1.STATUS_TYPE),
                fieldSetId: fieldSetId,
                status: {
                    id: fieldValue.status.id,
                    name: fieldValue.status.name,
                    statusId: fieldValue.status.id,
                    statusCategory: {
                        statusCategoryId: fieldValue.status.statusCategory.statusCategoryId,
                        id: fieldValue.status.statusCategory.id
                    }
                }
            };
            break;
        case 0, $814y1.SELECT_CF_TYPE:
        case 0, $814y1.MULTI_SELECT_CF_TYPE:
        case 0, $814y1.MULTI_CHECKBOXES_CF_TYPE:
        case 0, $814y1.RADIO_BUTTONS_CF_TYPE:
        case 0, $814y1.CATEGORY_TYPE:
            return {
                type: fieldType,
                fieldSetId: fieldSetId,
                option: fieldValue?.__typename === 'JiraJqlOptionFieldValue' && fieldValue?.option ? {
                    id: fieldValue.option.optionId,
                    value: fieldValue.option.value,
                    optionId: fieldValue.option.optionId,
                    color: fieldValue.option.color ? {
                        colorKey: fieldValue.option.color.colorKey,
                        id: fieldValue.option.color.id
                    } : undefined
                } : null
            };
        case 0, $814y1.SPRINT_TYPE:
            return {
                type: (0, $814y1.SPRINT_TYPE),
                fieldSetId: fieldSetId,
                sprint: fieldValue?.__typename === 'JiraJqlSprintFieldValue' && fieldValue?.sprint ? {
                    id: fieldValue.sprint.sprintId,
                    sprintId: fieldValue.sprint.sprintId,
                    name: fieldValue.sprint.name,
                    state: fieldValue.sprint.state,
                    endDate: fieldValue.sprint.endDate
                } : null
            };
        case 0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE:
            return {
                type: (0, $814y1.NUMBER_CF_TYPE),
                value: fieldValue?.__typename === 'JiraJqlNumberFieldValue' ? fieldValue.number : null,
                fieldSetId: fieldSetId && (0, $7jTnu.fg)('group_by_any_fields_technical') ? fieldSetId : fieldId
            };
        case 0, $814y1.NUMBER_CF_TYPE:
            return {
                type: (0, $814y1.NUMBER_CF_TYPE),
                value: fieldValue?.__typename === 'JiraJqlNumberFieldValue' ? fieldValue.number : null,
                // TODO: Remove fieldSetId check when cleaning up group_by_any_fields_technical flag
                fieldSetId: fieldSetId && (0, $7jTnu.fg)('group_by_any_fields_technical') ? fieldSetId : 'Story Points[Number]',
                isStoryPointField: true
            };
        case 0, $814y1.LABELS_TYPE:
            return {
                type: (0, $814y1.LABELS_TYPE),
                value: fieldValue?.__typename === 'JiraJqlLabelFieldValue' ? fieldValue.label?.name ?? null : null,
                // TODO: Remove fieldSetId check when cleaning up group_by_any_fields_technical flag
                fieldSetId: fieldSetId && (0, $7jTnu.fg)('group_by_any_fields_technical') ? fieldSetId : fieldId
            };
        case 0, $814y1.MULTI_GROUP_CF_TYPE:
            return {
                type: (0, $814y1.MULTI_GROUP_CF_TYPE),
                value: fieldValue?.__typename === 'JiraJqlGroupFieldValue' && fieldValue?.group ? {
                    id: fieldValue.group.id,
                    groupId: fieldValue.group.groupId,
                    name: fieldValue.group.name
                } : null,
                // TODO: Remove fieldSetId check when cleaning up group_by_any_fields_technical flag
                fieldSetId: fieldSetId && (0, $7jTnu.fg)('group_by_any_fields_technical') ? fieldSetId : fieldId
            };
        case 0, $814y1.MULTI_VERSION_CF_TYPE:
        case 0, $814y1.AFFECTS_VERSIONS_TYPE:
        case 0, $814y1.FIX_VERSIONS_TYPE:
            return {
                type: fieldType,
                // TODO: Remove fieldSetId check when cleaning up group_by_any_fields_technical flag
                fieldSetId: fieldSetId && (0, $7jTnu.fg)('group_by_any_fields_technical') ? fieldSetId : fieldId,
                version: fieldValue?.__typename === 'JiraJqlVersionFieldValue' && fieldValue?.version ? {
                    id: fieldValue.version.id,
                    name: fieldValue.version.name ?? '',
                    versionId: fieldValue.version.versionId
                } : null
            };
        default:
            return undefined;
    }
};
const $f6a7bf7663c9578c$export$ac1801bcb8e0f256 = /*#__PURE__*/ (0, $eJOHy.memo)(({ firstGroupRow: firstGroupRow, rankField: rankField, groupConnectionId: groupConnectionId, isVirtual: isVirtual, loading: loading, isGroupAtTop: isGroupAtTop, projectKey: projectKey = null, columns: columns, actionColumns: actionColumns, amountOfColumns: amountOfColumns, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isTimelineEnabled: isTimelineEnabled, pageSize: pageSize, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, width: width, isIssueRankDescending: isIssueRankDescending, isIssueCreateEnabled: isIssueCreateEnabled, isGridNavigationEnabled: isGridNavigationEnabled, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isStickyColumnsVisible: isStickyColumnsVisible })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const firstGroupRowData = (0, $j4oe4.useFragment)((0, $eSOGk.default), firstGroupRow);
    const variables = (0, $eJOHy.useMemo)(()=>{
        return {
            ...(0, $9AekN.getChildQueryVariablesForJql)({
                cloudId: cloudId,
                columns: columns,
                jql: firstGroupRowData.jql,
                isReparentingEnabled: false,
                isTimelineEnabled: isTimelineEnabled,
                actionColumns: actionColumns,
                amountOfColumns: amountOfColumns,
                pageSize: pageSize,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled
            }),
            shouldQueryFieldSetsById: false,
            namespace: 'ISSUE_NAVIGATOR',
            shouldQueryHasChildren: false,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled
        };
    }, [
        cloudId,
        columns,
        firstGroupRowData.jql,
        isTimelineEnabled,
        actionColumns,
        amountOfColumns,
        pageSize,
        isConditionalFormattingEnabled,
        isHideDoneItemsEnabled,
        isInlineFieldConfigEnabled
    ]);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $g9Gmp.default), rankField);
    const baseProps = [
        'cloudId',
        'issueSearchInput',
        'fieldSetsInput',
        'scope'
    ];
    const propsWithViewConfigInput = [
        ...baseProps,
        'viewConfigInput'
    ];
    const hasInitialised = (0, $4k0Ma.useInitialiseFirstGroupIssues)({
        groupId: firstGroupRowData.id,
        groupConnectionId: groupConnectionId,
        firstGroupItemsConnectionId: firstGroupRowData.issues?.__id ?? null,
        issueSearchVariables: (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(variables, ...isHideDoneItemsEnabled ? propsWithViewConfigInput : baseProps),
        loading: loading
    });
    const [isExpanded] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: firstGroupRowData.id,
        groupId: firstGroupRowData.id,
        itemsConnectionId: groupConnectionId
    });
    let inlineCreateHandlers;
    let groupContextFieldInput;
    const groupFieldValue = $f6a7bf7663c9578c$var$getGroupFieldValue(firstGroupRowData.fieldValue);
    if ((0, $epTsa.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        inlineCreateHandlers = (0, $68iTT.useInlineCreateHandlers)({
            projectKey: projectKey,
            defaultAssigneeId: firstGroupRowData.fieldType === (0, $814y1.ASSIGNEE_TYPE) && (0, $7jTnu.fg)('jira_render_pic_in_nin') ? firstGroupRowData.fieldValue?.user?.id : undefined,
            minHierarchyLevel: 0
        });
        const { fieldId: fieldId, fieldType: fieldType } = firstGroupRowData;
        if ((0, $7jTnu.fg)('group_by_any_fields_technical')) {
            if (fieldId && fieldType) groupContextFieldInput = $f6a7bf7663c9578c$var$toGroupContextFieldInput({
                fieldType: fieldType,
                fieldId: fieldId,
                fieldValue: firstGroupRowData.fieldValue,
                groupId: firstGroupRowData.id,
                fieldSetId: firstGroupRowData.fieldSetId
            });
        } else groupContextFieldInput = fieldId && fieldType ? {
            fieldValue: groupFieldValue,
            fieldId: fieldId,
            fieldType: fieldType,
            groupId: firstGroupRowData.id,
            optimisticResponse: $f6a7bf7663c9578c$export$6afa27f3196791b2({
                fieldType: fieldType,
                fieldId: fieldId,
                fieldValue: firstGroupRowData.fieldValue
            })
        } : undefined;
    }
    const renderChildIssueControllerWithGroupContextField = (0, $eJOHy.useCallback)((args)=>{
        return renderCreateIssueController?.({
            ...args,
            groupContextFieldInput: groupContextFieldInput
        });
    }, [
        renderCreateIssueController,
        groupContextFieldInput
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6sgpk.GroupHeader), {
        projectKey: projectKey,
        groupHeader: firstGroupRowData,
        groupConnectionId: groupConnectionId,
        isGroupAtTop: isGroupAtTop,
        createChildTriggerProps: inlineCreateHandlers?.triggerProps,
        columnsCount: columns.length,
        groupId: firstGroupRowData.id,
        isIssueCreateEnabled: isIssueCreateEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible
    }), hasInitialised && isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lkZRv.FirstGroupIssues), {
        variables: variables,
        rankField: rankFieldData ?? null,
        groupId: firstGroupRowData.id,
        groupConnectionId: groupConnectionId,
        groupFieldValue: (0, $7jTnu.fg)('group_by_any_fields_technical') ? firstGroupRowData.fieldValue?.jqlTerm ?? null : groupFieldValue,
        formProps: inlineCreateHandlers?.formProps,
        isFormVisible: inlineCreateHandlers?.isFormVisible,
        pageSize: pageSize,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        renderRows: renderRows,
        renderCreateIssueController: (0, $epTsa.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false) ? renderChildIssueControllerWithGroupContextField : renderCreateIssueController,
        renderDraggableWrapper: renderDraggableWrapper
    }));
});
const $f6a7bf7663c9578c$export$84aac6ac2cec7eed = /*#__PURE__*/ (0, $eJOHy.memo)(({ groupRow: groupRow, groupConnectionId: groupConnectionId, isVirtual: isVirtual, projectKey: projectKey = null, columns: columns, isIssueCreateEnabled: isIssueCreateEnabled, isGridNavigationEnabled: isGridNavigationEnabled, isStickyColumnsVisible: isStickyColumnsVisible, renderChildRows: renderChildRows })=>{
    const groupRowData = (0, $j4oe4.useFragment)((0, $ce0E2.default), groupRow);
    let inlineCreateHandlers;
    let groupContextField;
    const groupFieldValue = $f6a7bf7663c9578c$var$getGroupFieldValue(groupRowData.fieldValue);
    if ((0, $epTsa.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        inlineCreateHandlers = (0, $68iTT.useInlineCreateHandlers)({
            projectKey: projectKey,
            defaultAssigneeId: groupRowData.fieldType === (0, $814y1.ASSIGNEE_TYPE) && (0, $7jTnu.fg)('jira_render_pic_in_nin') ? groupRowData.fieldValue?.user?.id : undefined,
            minHierarchyLevel: 0
        });
        const { fieldId: fieldId, fieldType: fieldType } = groupRowData;
        if ((0, $7jTnu.fg)('group_by_any_fields_technical')) {
            if (fieldId && fieldType) groupContextField = $f6a7bf7663c9578c$var$toGroupContextFieldInput({
                fieldType: fieldType,
                fieldId: fieldId,
                fieldValue: groupRowData.fieldValue,
                groupId: groupRowData.id,
                fieldSetId: groupRowData.fieldSetId
            });
        } else groupContextField = fieldId && fieldType ? {
            fieldValue: groupFieldValue,
            fieldId: fieldId,
            fieldType: fieldType,
            groupId: groupRowData.id,
            optimisticResponse: $f6a7bf7663c9578c$export$6afa27f3196791b2({
                fieldType: fieldType,
                fieldId: fieldId,
                fieldValue: groupRowData.fieldValue
            })
        } : undefined;
    }
    return groupRowData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6sgpk.GroupHeader), {
        projectKey: projectKey,
        groupHeader: groupRowData,
        groupConnectionId: groupConnectionId,
        createChildTriggerProps: inlineCreateHandlers?.triggerProps,
        columnsCount: columns.length,
        groupId: groupRowData.id,
        isIssueCreateEnabled: isIssueCreateEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible
    }), renderChildRows?.({
        parentItemId: groupRowData.id,
        itemsConnectionId: groupConnectionId,
        depth: 0,
        type: 'GROUP_CHILDREN',
        groupFieldValue: (0, $7jTnu.fg)('group_by_any_fields_technical') ? groupRowData.fieldValue?.jqlTerm ?? null : groupFieldValue,
        groupJql: groupRowData.jql,
        formProps: inlineCreateHandlers?.formProps,
        isFormVisible: inlineCreateHandlers?.isFormVisible,
        groupId: groupRowData.id,
        groupContextField: groupContextField
    }));
});

});
parcelRegister("ce0E2", function(module, exports) {

$parcel$export(module.exports, "default", () => $21a37ba66dc42f64$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e1b9a86384d3ff46b817153e6f0ad3f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $21a37ba66dc42f64$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "groupRow_issueTableGrouping_groupRow",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                "action": "THROW",
                "path": "jql"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "fieldType"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fieldSetId"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "fieldValue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "JiraLabel",
                                        "kind": "LinkedField",
                                        "name": "label",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ 
                                        ]
                                    }
                                ],
                                "type": "JiraJqlLabelFieldValue"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "group",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "groupId"
                                            },
                                            v1 /*: any*/ 
                                        ]
                                    }
                                ],
                                "type": "JiraJqlGroupFieldValue"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            },
                                            v1 /*: any*/ 
                                        ]
                                    }
                                ],
                                "type": "JiraJqlVersionFieldValue"
                            }
                        ]
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "priorityId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlPriorityFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlUserFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "statusCategoryId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlStatusFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ],
                        "type": "JiraJqlNumberFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlOptionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlSprintFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlGoalsFieldValue"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "groupHeader_issueTableGrouping"
            }
        ],
        "type": "JiraSpreadsheetGroup"
    };
}();
$21a37ba66dc42f64$var$node.hash = "b902d1a85d92def64b39148cc384d154";
var $21a37ba66dc42f64$export$2e2bcd8739ae039 = $21a37ba66dc42f64$var$node;

});

parcelRegister("g9Gmp", function(module, exports) {

$parcel$export(module.exports, "default", () => $06654b36fc7ed38c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4f1ec9b68738a4af37583c7593b2fb6d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $06654b36fc7ed38c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "groupRow_issueTableGrouping_FirstGroupRow_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "firstGroupIssues_issueTableGrouping"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$06654b36fc7ed38c$var$node.hash = "5602f23546a386a14074a3a5b572a140";
var $06654b36fc7ed38c$export$2e2bcd8739ae039 = $06654b36fc7ed38c$var$node;

});

parcelRegister("eSOGk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e5667cc0ce1eb27$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<88afcd1445e35e379dc553e3e0c64e95>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0e5667cc0ce1eb27$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "issues"
                    ]
                }
            ]
        },
        "name": "groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                "action": "THROW",
                "path": "jql"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "fieldType"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fieldSetId"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "fieldValue",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "JiraLabel",
                                        "kind": "LinkedField",
                                        "name": "label",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ 
                                        ]
                                    }
                                ],
                                "type": "JiraJqlLabelFieldValue"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "group",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "groupId"
                                            },
                                            v2 /*: any*/ 
                                        ]
                                    }
                                ],
                                "type": "JiraJqlGroupFieldValue"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            },
                                            v2 /*: any*/ 
                                        ]
                                    }
                                ],
                                "type": "JiraJqlVersionFieldValue"
                            }
                        ]
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "priorityId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlPriorityFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlUserFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "statusCategoryId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlStatusFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ],
                        "type": "JiraJqlNumberFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlOptionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlSprintFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlGoalsFieldValue"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "groupHeader_issueTableGrouping"
            },
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "fieldSetsInput",
                        "variableName": "fieldSetsInput"
                    },
                    {
                        "kind": "Variable",
                        "name": "scope",
                        "variableName": "fieldSetsScope"
                    },
                    {
                        "kind": "Variable",
                        "name": "settings",
                        "variableName": "settings"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__firstGroupSection_nativeIssueTable__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isConditionalFormattingEnabled",
                                "variableName": "isConditionalFormattingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isDensityFull",
                                "variableName": "isDensityFull"
                            },
                            {
                                "kind": "Variable",
                                "name": "isInlineEditingEnabled",
                                "variableName": "isInlineEditingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isReparentingEnabled",
                                "variableName": "isReparentingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isTimelineEnabled",
                                "variableName": "isTimelineEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Literal",
                                "name": "shouldQueryHasChildren",
                                "value": false
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "childRowsPagination_issueTableHierarchy_queryData"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__id"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroup"
    };
}();
$0e5667cc0ce1eb27$var$node.hash = "9ffce3cc74ce728227447e309311a950";
var $0e5667cc0ce1eb27$export$2e2bcd8739ae039 = $0e5667cc0ce1eb27$var$node;

});

parcelRegister("lkZRv", function(module, exports) {

$parcel$export(module.exports, "FirstGroupIssues", () => $15a2e56a55095e15$export$e2f0ecb1fcdc2610);

var $7SMuO = parcelRequire("7SMuO");

var $aWllK = parcelRequire("aWllK");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8dmSB = parcelRequire("8dmSB");
const $15a2e56a55095e15$export$e2f0ecb1fcdc2610 = ({ variables: variables, rankField: rankField, groupId: groupId, groupConnectionId: groupConnectionId, groupFieldValue: groupFieldValue, isFormVisible: isFormVisible, formProps: formProps, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, pageSize: pageSize, width: width, isIssueRankDescending: isIssueRankDescending, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper })=>{
    const data = (0, $j4oe4.useLazyLoadQuery)((0, $aWllK.default), variables, {
        fetchPolicy: 'store-only'
    });
    const rankFieldData = (0, $j4oe4.useFragment)((0, $7SMuO.default), rankField);
    const connectionMetadata = (0, $eJOHy.useMemo)(()=>variables.issueSearchInput.jql ? {
            type: 'GROUP_CHILDREN',
            fieldValue: groupFieldValue,
            groupId: groupId,
            jql: variables.issueSearchInput.jql
        } : undefined, [
        groupFieldValue,
        groupId,
        variables.issueSearchInput.jql
    ]);
    // Ensure relay cache is in correct state
    if (!data?.jira?.issueSearch?.edges) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8dmSB.ChildRowsPagination), {
        query: data,
        depth: 0,
        parentItemId: groupId,
        groupId: groupId,
        itemsConnectionId: groupConnectionId,
        connectionMetadata: connectionMetadata,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        pageSize: pageSize,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        rankFieldId: rankFieldData?.fieldId ?? null,
        renderRows: renderRows,
        renderCreateIssueController: renderCreateIssueController,
        renderDraggableWrapper: renderDraggableWrapper,
        isFormVisible: isFormVisible,
        formProps: formProps
    });
};

});
parcelRegister("7SMuO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3bff901b9ac14eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eebef84e322d65e9a33ff5a107e7941a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c3bff901b9ac14eb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "firstGroupIssues_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$c3bff901b9ac14eb$var$node.hash = "cc627c313216b2c02d5935c9c7dccd74";
var $c3bff901b9ac14eb$export$2e2bcd8739ae039 = $c3bff901b9ac14eb$var$node;

});

parcelRegister("aWllK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f05dee804c4eeb0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9b249f38b62bb8090660bd7f5f9b025>>
 * @relayHash 2351505d359a94af3f9c300f8f0705ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 13dd117bec29cc2f647e59c872999b8fd4a4c2084bf22bf5934b24c2b650fdef

var $kZq2R = parcelRequire("kZq2R");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $5CxJ3 = parcelRequire("5CxJ3");

var $eHMRp = parcelRequire("eHMRp");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $bU8Sj = parcelRequire("bU8Sj");

var $clCUA = parcelRequire("clCUA");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");
const $2f05dee804c4eeb0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v13 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v14 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v15 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v16 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v17 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v18 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v21 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v22 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v15 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "id"
    }, v24 = {
        "kind": "ScalarField",
        "name": "key"
    }, v25 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v26 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "name"
    }, v28 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v29 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v31 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v32 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v33 = {
        "kind": "InlineFragment",
        "selections": [
            v29 /*: any*/ ,
            v32 /*: any*/ 
        ],
        "type": "JiraStatusField"
    }, v34 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v35 = {
        "kind": "ScalarField",
        "name": "type"
    }, v36 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v37 = {
        "kind": "ScalarField",
        "name": "value"
    }, v38 = [
        v37 /*: any*/ ,
        v23 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v39 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v40 = {
        "kind": "ClientExtension",
        "selections": [
            v39 /*: any*/ 
        ]
    }, v41 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v42 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v43 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v44 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v45 = {
        "kind": "ScalarField",
        "name": "text"
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            v45 /*: any*/ ,
            v27 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v47 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v48 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v23 /*: any*/ 
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v50 = [
        v47 /*: any*/ 
    ], v51 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v37 /*: any*/ 
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v53 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v54 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v55 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v56 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v57 = [
        v23 /*: any*/ 
    ], v58 = {
        "kind": "ClientExtension",
        "selections": [
            v28 /*: any*/ 
        ]
    }, v59 = [
        v27 /*: any*/ ,
        v23 /*: any*/ 
    ], v60 = {
        "kind": "ScalarField",
        "name": "date"
    }, v61 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v62 = [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                },
                v27 /*: any*/ ,
                v23 /*: any*/ 
            ]
        }
    ], v63 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v45 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v64 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v48 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v65 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v66 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v65 /*: any*/ ,
                    v27 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            },
            v23 /*: any*/ 
        ]
    }, v67 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v68 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v69 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v70 = {
        "kind": "ScalarField",
        "name": "number"
    }, v71 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v72 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v73 = {
        "kind": "InlineFragment",
        "selections": [
            v60 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v74 = [
        v19 /*: any*/ ,
        v29 /*: any*/ ,
        v73 /*: any*/ ,
        v23 /*: any*/ 
    ], v75 = [
        v19 /*: any*/ ,
        v23 /*: any*/ 
    ], v76 = [
        v19 /*: any*/ ,
        v73 /*: any*/ ,
        v23 /*: any*/ 
    ], v77 = {
        "args": v72 /*: any*/ ,
        "kind": "LinkedField",
        "name": "startDateViewField",
        "plural": false,
        "selections": v76 /*: any*/ ,
        "storageKey": "startDateViewField(viewId:\"list_default\")"
    }, v78 = {
        "args": v72 /*: any*/ ,
        "kind": "LinkedField",
        "name": "endDateViewField",
        "plural": false,
        "selections": v76 /*: any*/ ,
        "storageKey": "endDateViewField(viewId:\"list_default\")"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "firstGroupIssues_issueTableGrouping_childIssuesQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "childRowsPagination_issueTableHierarchy_query"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "issueSearch",
                            "args": [
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "__hierarchy_nativeIssueTable__issueSearch_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                v8 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v9 /*: any*/ ,
                v3 /*: any*/ ,
                v12 /*: any*/ ,
                v11 /*: any*/ ,
                v6 /*: any*/ ,
                v10 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "firstGroupIssues_issueTableGrouping_childIssuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v22 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v26 /*: any*/ ,
                                                                v23 /*: any*/ 
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v32 /*: any*/ ,
                                                                v23 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v23 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v34 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                v36 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v19 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v35 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v23 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v38 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v38 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v43 /*: any*/ ,
                                                                                                                                v23 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v44 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                v46 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v47 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v37 /*: any*/ ,
                                                                                                                v48 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                v49 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v50 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v23 /*: any*/ ,
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                v49 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v51 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v52 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v53 /*: any*/ ,
                                                                                                                                v23 /*: any*/ ,
                                                                                                                                v54 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraEstimate",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "originalEstimate",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "timeInSeconds"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingSettings",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingSettings",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingHoursPerDay"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingDaysPerWeek"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultFormat"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultUnit"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v29 /*: any*/ ,
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v40 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v23 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v55 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                v42 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v23 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v43 /*: any*/ ,
                                                                                                                                v56 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": v57 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v23 /*: any*/ ,
                                                                                                                                v24 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v58 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v39 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v23 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "href"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v47 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "componentsOld",
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v59 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v45 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v60 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v61 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v44 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        v30 /*: any*/ ,
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v31 /*: any*/ ,
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v41 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v48 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v47 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v27 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": v62 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": v62 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v63 /*: any*/ ,
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v24 /*: any*/ ,
                                                                                                                v64 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                v23 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v24 /*: any*/ ,
                                                                                                                v64 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                v67 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v23 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v29 /*: any*/ ,
                                                                                                                                                v45 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v29 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v68 /*: any*/ ,
                                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                                        v65 /*: any*/ ,
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v23 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        v33 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v27 /*: any*/ ,
                                                                                                        v40 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        v24 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v59 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        v52 /*: any*/ ,
                                                                                                        v53 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v23 /*: any*/ ,
                                                                                                        v54 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ ,
                                                                                                v61 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v27 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v41 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v59 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        v65 /*: any*/ ,
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v47 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v67 /*: any*/ ,
                                                                                                                                v24 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v31 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v23 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                v23 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v23 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                v70 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        v70 /*: any*/ ,
                                                                                                        v71 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        v70 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v71 /*: any*/ ,
                                                                                                        v40 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v27 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isEditableInIssueView"
                                                                                                        },
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "direction"
                                                                                                                },
                                                                                                                v69 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v57 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v59 /*: any*/ 
                                                                                                                        },
                                                                                                                        v23 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v24 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v23 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "assigneeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v53 /*: any*/ ,
                                                                                                                                v23 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v23 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v72 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "startDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v74 /*: any*/ ,
                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v72 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "endDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v74 /*: any*/ ,
                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v58 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v50 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                },
                                                                                                                                v23 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v52 /*: any*/ ,
                                                                                                                                v23 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "priorityId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "version",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v56 /*: any*/ ,
                                                                                                                v23 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v68 /*: any*/ ,
                                                                                                                v23 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v56 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v75 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v75 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v55 /*: any*/ ,
                                                                                                                v23 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        v58 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                v21 /*: any*/ ,
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v34 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v36 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v77 /*: any*/ ,
                                                                                                                v78 /*: any*/ ,
                                                                                                                v23 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                },
                                                                                                v23 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 10
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v23 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v77 /*: any*/ ,
                                                                                        v78 /*: any*/ ,
                                                                                        v25 /*: any*/ ,
                                                                                        v24 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v69 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v58 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v34 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v51 /*: any*/ ,
                                                                                                                        v58 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v49 /*: any*/ ,
                                                                                                                v23 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v58 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v22 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput",
                                "scope"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "13dd117bec29cc2f647e59c872999b8fd4a4c2084bf22bf5934b24c2b650fdef",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "bidirectional",
                        "path": [
                            "jira",
                            "issueSearch"
                        ]
                    }
                ]
            },
            "name": "firstGroupIssues_issueTableGrouping_childIssuesQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $eHMRp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider": (0, $5CxJ3.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default)
            }
        }
    };
}();
$2f05dee804c4eeb0$var$node.hash = "15b5c4931fed5daa32eac57649120e1b";
var $2f05dee804c4eeb0$export$2e2bcd8739ae039 = $2f05dee804c4eeb0$var$node;

});


parcelRegister("4k0Ma", function(module, exports) {

$parcel$export(module.exports, "useInitialiseFirstGroupIssues", () => $dd008cff549f4f94$export$3e4eaea282025a37);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $jE8Tu = parcelRequire("jE8Tu");
const $dd008cff549f4f94$var$JIRA = 'jira';
const $dd008cff549f4f94$var$HIERARCHY_ISSUE_SEARCH_CONNECTION = 'hierarchy_nativeIssueTable__issueSearch';
const $dd008cff549f4f94$var$JIRA_ISSUE_CONNECTION_TYPE = 'JiraIssueConnection';
const $dd008cff549f4f94$var$CONNECTION = 'connection';
const $dd008cff549f4f94$export$3e4eaea282025a37 = ({ groupId: groupId, groupConnectionId: groupConnectionId, firstGroupItemsConnectionId: firstGroupItemsConnectionId, issueSearchVariables: issueSearchVariables, loading: loading })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const hasInitialised = (0, $eJOHy.useRef)(false);
    const prevGroupConnectionId = (0, $eJOHy.useRef)(groupConnectionId);
    const prevFieldSetsInput = (0, $eJOHy.useRef)(issueSearchVariables.fieldSetsInput);
    const prevViewConfigInput = (0, $eJOHy.useRef)(issueSearchVariables.viewConfigInput);
    const prevLoading = (0, $eJOHy.useRef)(loading);
    const { setIsItemExpanded: setIsItemExpanded } = (0, $jE8Tu.useHierarchyActions)();
    // When firstGroupItemsConnectionId is available, if the groupConnectionId changes, fieldSetsInput change or view has finished loading, trigger re-initialisation
    if (!!firstGroupItemsConnectionId && (!loading && prevLoading.current || prevGroupConnectionId.current !== groupConnectionId || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevFieldSetsInput.current, issueSearchVariables.fieldSetsInput) || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevViewConfigInput.current, issueSearchVariables.viewConfigInput))) {
        hasInitialised.current = false;
        prevGroupConnectionId.current = groupConnectionId;
        prevFieldSetsInput.current = issueSearchVariables.fieldSetsInput;
        prevViewConfigInput.current = issueSearchVariables.viewConfigInput;
        prevLoading.current = loading;
    }
    if (!hasInitialised.current) {
        setIsItemExpanded({
            itemId: groupId,
            groupId: groupId,
            itemsConnectionId: groupConnectionId
        }, true);
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const firstGroupIssuesConnection = store.get(firstGroupItemsConnectionId ?? '');
            const jiraRecord = store.getRoot().getLinkedRecord($dd008cff549f4f94$var$JIRA);
            if (!firstGroupIssuesConnection || !jiraRecord) return;
            const connectionId = (0, $37Ewn.ConnectionHandler).getConnectionID(jiraRecord.getDataID(), $dd008cff549f4f94$var$HIERARCHY_ISSUE_SEARCH_CONNECTION, issueSearchVariables);
            // If connection already exists, update it with the latest data. This ensures the field sets are correct.
            let connection = store.get(connectionId);
            if (!connection) connection = store.create(connectionId, $dd008cff549f4f94$var$JIRA_ISSUE_CONNECTION_TYPE);
            connection.copyFieldsFrom(firstGroupIssuesConnection);
            jiraRecord.setLinkedRecord(connection, (0, $37Ewn.getRelayHandleKey)($dd008cff549f4f94$var$CONNECTION, $dd008cff549f4f94$var$HIERARCHY_ISSUE_SEARCH_CONNECTION), issueSearchVariables);
            hasInitialised.current = true;
        });
    }
    return hasInitialised.current;
};

});

parcelRegister("6sgpk", function(module, exports) {

$parcel$export(module.exports, "GroupHeader", () => $e79f59b1ca9a07d0$export$58d63a2875c58fc8);

var $4wVTg = parcelRequire("4wVTg");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $j4oe4 = parcelRequire("j4oe4");

var $lT9x0 = parcelRequire("lT9x0");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $814y1 = parcelRequire("814y1");

var $7jTnu = parcelRequire("7jTnu");

var $jE8Tu = parcelRequire("jE8Tu");

var $2XtSM = parcelRequire("2XtSM");

var $epTsa = parcelRequire("epTsa");

var $3Ldj6 = parcelRequire("3Ldj6");

var $8ntPR = parcelRequire("8ntPR");

var $1W85r = parcelRequire("1W85r");

var $3zo68 = parcelRequire("3zo68");

var $98A5p = parcelRequire("98A5p");

var $1PNpH = parcelRequire("1PNpH");

var $iYld7 = parcelRequire("iYld7");

var $aV9Qf = parcelRequire("aV9Qf");

var $iIcv7 = parcelRequire("iIcv7");

var $gv23s = parcelRequire("gv23s");

var $cjsh9 = parcelRequire("cjsh9");

var $jinCH = parcelRequire("jinCH");

var $2fiDR = parcelRequire("2fiDR");

var $hKYCG = parcelRequire("hKYCG");

var $cCW4w = parcelRequire("cCW4w");

var $4HTXE = parcelRequire("4HTXE");

var $bwwaP = parcelRequire("bwwaP");
const $e79f59b1ca9a07d0$var$isCompletedSprintGroup = (data)=>data?.fieldValue?.__typename === 'JiraJqlSprintFieldValue' && data.fieldValue.sprint?.state === 'CLOSED';
const $e79f59b1ca9a07d0$var$isSubtaskGroup = (data)=>{
    if (!(0, $7jTnu.fg)('group_by_any_fields_technical')) return false;
    return data.fieldValue?.__typename === 'JiraJqlIssueTypeFieldValue' && data.fieldValue.issueTypes?.[0]?.hierarchy?.level === -1;
};
const $e79f59b1ca9a07d0$var$getGroupIssueTypeId = (data)=>{
    if (!(0, $7jTnu.fg)('group_by_any_fields_technical')) return null;
    switch(data.fieldType){
        case 0, $814y1.ISSUE_TYPE:
            return data.fieldValue?.issueTypes?.[0]?.issueTypeId;
        default:
            return null;
    }
};
const $e79f59b1ca9a07d0$var$ONBOARDING_TARGET_NAME = 'issue-navigator-create-issue-in-group';
const $e79f59b1ca9a07d0$export$58d63a2875c58fc8 = ({ groupHeader: groupHeader, groupConnectionId: groupConnectionId, createChildTriggerProps: createChildTriggerProps, isGroupAtTop: isGroupAtTop = false, columnsCount: columnsCount, groupId: groupId, isIssueCreateEnabled: isIssueCreateEnabled = true, isGridNavigationEnabled: isGridNavigationEnabled = false, isStickyColumnsVisible: isStickyColumnsVisible, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const tableRowRef = (0, $eJOHy.useRef)(null);
    const data = (0, $j4oe4.useFragment)((0, $4wVTg.default), groupHeader);
    const itemDetails = (0, $eJOHy.useMemo)(()=>data ? {
            itemsConnectionId: groupConnectionId,
            itemId: data.id,
            groupId: groupId
        } : null, [
        data,
        groupConnectionId,
        groupId
    ]); // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const list = (0, $7jTnu.fg)('nin-grid-keyboard-navigation') ? (0, $jE8Tu.useFlatList)() : [];
    const [isSelected, { setSelectedRow: setSelectedRow }] = (0, $jE8Tu.useIsSelected)(itemDetails);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Scroll the table row into view (if needed - block: nearest) when it becomes selected
        if (isSelected) tableRowRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        isSelected
    ]);
    const focusCurrentRow = (0, $eJOHy.useCallback)(()=>{
        return setSelectedRow(itemDetails);
    }, [
        setSelectedRow,
        itemDetails
    ]);
    const groupHeaderView = (0, $eJOHy.useMemo)(()=>{
        switch(data.fieldType){
            case 0, $814y1.PRIORITY_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PNpH.PriorityGroupHeader), {
                    priorityGroupHeader: data.fieldValue ?? null
                });
            case 0, $814y1.REPORTER_TYPE:
            case 0, $814y1.ASSIGNEE_TYPE:
            case 0, $814y1.USER_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4HTXE.UserGroupHeader), {
                    userGroupHeader: data.fieldValue ?? null,
                    fieldType: data.fieldType
                });
            case 0, $814y1.STATUS_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV9Qf.StatusGroupHeader), {
                    statusGroupHeader: data.fieldValue ?? null
                });
            case 0, $814y1.NUMBER_CF_TYPE:
            case 0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIcv7.StoryPointsGroupHeader), {
                    storyPointsGroupHeader: data.fieldValue ?? null
                });
            case 0, $814y1.GOALS_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gv23s.GoalGroupHeader), {
                    goalGroupHeader: data.fieldValue ?? null
                });
            case 0, $814y1.CATEGORY_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3zo68.CategoryGroupHeader), {
                    categoryGroupHeader: data.fieldValue ?? null
                });
            case 0, $814y1.SELECT_CF_TYPE:
            case 0, $814y1.MULTI_SELECT_CF_TYPE:
            case 0, $814y1.MULTI_CHECKBOXES_CF_TYPE:
            case 0, $814y1.RADIO_BUTTONS_CF_TYPE:
                return (0, $7jTnu.fg)('group_by_any_fields_technical') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hKYCG.OptionGroupHeader), {
                    optionGroupHeader: data.fieldValue ?? null,
                    fieldType: data.fieldType
                }) : null;
            case 0, $814y1.SPRINT_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iYld7.SprintGroupHeader), {
                    sprintGroupHeader: data.fieldValue ?? null
                });
            case 0, $814y1.LABELS_TYPE:
                return (0, $7jTnu.fg)('group_by_any_fields_technical') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cjsh9.LabelGroupHeader), {
                    labelGroupHeader: data.fieldValue ?? null
                }) : null;
            case 0, $814y1.ISSUE_TYPE:
                return (0, $7jTnu.fg)('group_by_any_fields_technical') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jinCH.IssueTypeGroupHeader), {
                    issueTypeGroupHeader: data.fieldValue ?? null
                }) : null;
            case 0, $814y1.GROUP_CF_TYPE:
            case 0, $814y1.MULTI_GROUP_CF_TYPE:
                return (0, $7jTnu.fg)('group_by_any_fields_technical') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2fiDR.GroupPickerGroupHeader), {
                    groupPickerGroupHeader: data.fieldValue ?? null
                }) : null;
            case 0, $814y1.VERSION_CF_TYPE:
            case 0, $814y1.MULTI_VERSION_CF_TYPE:
            case 0, $814y1.AFFECTS_VERSIONS_TYPE:
            case 0, $814y1.FIX_VERSIONS_TYPE:
                return (0, $7jTnu.fg)('group_by_any_fields_technical') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cCW4w.VersionGroupHeader), {
                    versionGroupHeader: data.fieldValue ?? null,
                    fieldType: data.fieldType
                }) : null;
            case 0, $814y1.RESOLUTION_TYPE:
                return (0, $7jTnu.fg)('group_by_any_fields_technical') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bwwaP.ResolutionGroupHeader), {
                    resolutionGroupHeader: data.fieldValue ?? null
                }) : null;
            default:
                // should never happen
                return null;
        }
    }, [
        data
    ]);
    const groupMetadata = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, groupHeaderView, !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(data?.issueCount) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            color: "color.text.subtlest"
        }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $98A5p.default).issuesIssueTermRefresh : (0, $98A5p.default).issues, {
            count: data.issueCount
        })));
    }, [
        data.issueCount,
        formatMessage,
        groupHeaderView
    ]);
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $jE8Tu.useIsItemExpanded)(itemDetails);
    const [isLoading] = (0, $jE8Tu.useIsItemLoading)(data?.id ?? null);
    const { setDefaultIssueType: setDefaultIssueType } = (0, $1W85r.useIICConfigActions)();
    const groupIssueTypeId = $e79f59b1ca9a07d0$var$getGroupIssueTypeId(data);
    const onCreateChildClick = (0, $eJOHy.useCallback)(()=>{
        if (groupIssueTypeId && projectKey) setDefaultIssueType(projectKey, groupIssueTypeId);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupCreateChildButton');
        if (!isExpanded) toggleIsItemExpanded(itemDetails, 0);
        createChildTriggerProps?.onClick();
    }, [
        createAnalyticsEvent,
        isExpanded,
        toggleIsItemExpanded,
        itemDetails,
        createChildTriggerProps,
        setDefaultIssueType,
        groupIssueTypeId,
        projectKey
    ]);
    const headerContent = (0, $eJOHy.useMemo)(()=>{
        if ((0, $epTsa.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data.issueCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.ExpandButton), {
            itemId: data.id,
            itemsConnectionId: groupConnectionId,
            depth: 0,
            isGroupButton: true,
            groupId: groupId
        }) : null, groupMetadata, isIssueCreateEnabled && (0, $8ntPR.isCreateIssueSupportedForFieldType)(data.fieldType) && !$e79f59b1ca9a07d0$var$isCompletedSprintGroup(data) && !$e79f59b1ca9a07d0$var$isSubtaskGroup(data) && (isGroupAtTop ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
            name: $e79f59b1ca9a07d0$var$ONBOARDING_TARGET_NAME
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                "_kqswh2mm _yt1xcs5v"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ldj6.default), {
            onClick: onCreateChildClick,
            ref: createChildTriggerProps?.ref,
            isCreateWorkItem: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lT9x0.EngagementSpotlight), {
            engagementId: $e79f59b1ca9a07d0$var$ONBOARDING_TARGET_NAME
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                "_kqswh2mm _yt1xcs5v"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ldj6.default), {
            onClick: onCreateChildClick,
            ref: createChildTriggerProps?.ref,
            isCreateWorkItem: true
        }))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data.issueCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.ExpandButtonWithCreateChildButton), {
            isGroupButton: true,
            itemId: data.id,
            itemsConnectionId: groupConnectionId,
            depth: 0,
            groupId: groupId
        }) : null, groupMetadata);
    }, [
        data,
        groupConnectionId,
        groupId,
        groupMetadata,
        isIssueCreateEnabled,
        isGroupAtTop,
        onCreateChildClick,
        createChildTriggerProps?.ref
    ]);
    const rowIndex = itemDetails && (0, $7jTnu.fg)('nin-grid-keyboard-navigation') ? list.indexOf(`${itemDetails.itemId}::${itemDetails.itemId}`) + 1 : -1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", {
        role: "row",
        tabIndex: -1,
        ...rowIndex > 0 && isGridNavigationEnabled && {
            'aria-rowindex': rowIndex
        },
        onFocus: focusCurrentRow,
        "data-testid": "issue-table-grouping.ui.group-row.group-header.tr",
        "aria-selected": isSelected,
        ref: tableRowRef,
        className: (0, $hcewu.default)([
            "_nt751r31 _49pcglyw _1hvw1o36 _irr3108i",
            isSelected && !isGridNavigationEnabled && "_bfhkfg4m _irr3i1yw",
            isGridNavigationEnabled && "_10j7fg4m _1p0pi1yw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td" // Additional column for configure columns menu & issue actions
        ,
        colSpan: columnsCount + 1,
        xcss: [
            $e79f59b1ca9a07d0$var$borderStyles,
            isGroupAtTop && $e79f59b1ca9a07d0$var$removeTopBorder,
            (0, $7jTnu.fg)('group_by_any_fields_technical') && $e79f59b1ca9a07d0$var$rowHeight,
            (!isExpanded || isLoading || !data.issueCount || (0, $epTsa.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) && $e79f59b1ca9a07d0$var$removeBottomBorder
        ],
        ...isGridNavigationEnabled && {
            tabIndex: -1
        }
    }, isStickyColumnsVisible && (0, $7jTnu.fg)('issue_table_frozen_columns') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "issue-table-grouping.ui.group-row.group-header.sticky-header",
        xcss: $e79f59b1ca9a07d0$var$stickyContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $e79f59b1ca9a07d0$var$inlineStyles,
            !data.issueCount && $e79f59b1ca9a07d0$var$placeholderStyles
        ],
        space: "space.100"
    }, headerContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $e79f59b1ca9a07d0$var$inlineStyles,
            !data.issueCount && $e79f59b1ca9a07d0$var$placeholderStyles
        ],
        space: "space.100"
    }, headerContent)));
};
const $e79f59b1ca9a07d0$var$inlineStyles = (0, $1DXK0.xcss)({
    paddingInline: 'space.150',
    alignItems: 'center',
    gap: 'space.100'
});
const $e79f59b1ca9a07d0$var$placeholderStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.400'
});
const $e79f59b1ca9a07d0$var$stickyContainerStyles = (0, $1DXK0.xcss)({
    position: 'sticky',
    left: 'space.0',
    width: 'fit-content'
});
const $e79f59b1ca9a07d0$var$borderStyles = (0, $1DXK0.xcss)({
    border: 0,
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: 'border.width',
    borderBottomWidth: 'border.width'
});
const $e79f59b1ca9a07d0$var$removeTopBorder = (0, $1DXK0.xcss)({
    borderTopWidth: '0'
});
const $e79f59b1ca9a07d0$var$removeBottomBorder = (0, $1DXK0.xcss)({
    borderBottomWidth: '0'
});
const $e79f59b1ca9a07d0$var$headerRowStyles = null;
const $e79f59b1ca9a07d0$var$headerRowKeyboardNavigationStyles = null;
const $e79f59b1ca9a07d0$var$activeRowStyles = null;
const $e79f59b1ca9a07d0$var$raiseOnHoverStyles = null;
const $e79f59b1ca9a07d0$var$rowHeight = (0, $1DXK0.xcss)({
    height: "var(--ds-space-500, 40px)"
});

});
parcelRegister("4wVTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbc4b36a1aaaa8f7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc56eca86e9dbe95fbcf2d4e01e7a670>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cbc4b36a1aaaa8f7$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "groupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldType"
        },
        {
            "kind": "ScalarField",
            "name": "issueCount"
        },
        {
            "kind": "LinkedField",
            "name": "fieldValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "priorityGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "userGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "statusGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "categoryGroupHeader_issueTableGrouping"
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "optionGroupHeader_issueTableGrouping"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "versionGroupHeader_issueTableGrouping"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "labelGroupHeader_issueTableGrouping"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "issueTypeGroupHeader_issueTableGrouping"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "groupPickerGroupHeader_issueTableGrouping"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "resolutionGroupHeader_issueTableGrouping"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "issueTypeId"
                                        },
                                        {
                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                            "kind": "LinkedField",
                                            "name": "hierarchy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "level"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlIssueTypeFieldValue"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "sprintGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "storyPointsGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "goalGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                }
                            ]
                        }
                    ],
                    "type": "JiraJqlSprintFieldValue"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroup"
};
$cbc4b36a1aaaa8f7$var$node.hash = "0029bcef9613631b9dba991e0fd01834";
var $cbc4b36a1aaaa8f7$export$2e2bcd8739ae039 = $cbc4b36a1aaaa8f7$var$node;

});

parcelRegister("2XtSM", function(module, exports) {

$parcel$export(module.exports, "ExpandButton", () => $e99284d207f534ad$export$5663c8f5aeb8c1c4);
$parcel$export(module.exports, "CreateChildButtonWithExpandToggle", () => $e99284d207f534ad$export$86df7a8824b06d6e);
$parcel$export(module.exports, "ExpandButtonWithCreateChildButton", () => $e99284d207f534ad$export$b921667debd4e0cb);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $1OQKp = parcelRequire("1OQKp");

var $cQxBL = parcelRequire("cQxBL");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $3Ldj6 = parcelRequire("3Ldj6");

var $jE8Tu = parcelRequire("jE8Tu");

var $d8783 = parcelRequire("d8783");

var $5XgIy = parcelRequire("5XgIy");
const $e99284d207f534ad$var$ICON_WIDTH = 24;
const $e99284d207f534ad$var$EXTRA_PADDING_ROW_WITHOUT_EXPAND = 8;
const $e99284d207f534ad$export$5663c8f5aeb8c1c4 = ({ itemId: itemId, itemsConnectionId: itemsConnectionId, depth: depth, isGroupButton: isGroupButton, groupId: groupId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: itemId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId
    });
    const onExpandClick = (0, $eJOHy.useCallback)(()=>{
        const actionSubjectId = isGroupButton ? 'groupExpandButton' : 'hierarchyExpandButton';
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        toggleIsItemExpanded({
            itemId: itemId,
            itemsConnectionId: itemsConnectionId,
            groupId: groupId
        }, depth);
    }, [
        createAnalyticsEvent,
        depth,
        itemId,
        itemsConnectionId,
        toggleIsItemExpanded,
        isGroupButton,
        groupId
    ]);
    const label = (0, $eJOHy.useMemo)(()=>{
        if (isGroupButton) return formatMessage(isExpanded ? (0, $d8783.default).collapseGroup : (0, $d8783.default).expandGroup);
        return formatMessage(isExpanded ? (0, $d8783.default).collapseIssue : (0, $d8783.default).expandIssue);
    }, [
        formatMessage,
        isExpanded,
        isGroupButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        spacing: "compact",
        appearance: "subtle",
        label: label,
        "aria-expanded": isExpanded,
        testId: "issue-table-hierarchy.ui.expand-button.expand-button",
        icon: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                ...iconProps,
                size: "small"
            }),
        onClick: onExpandClick,
        isTooltipDisabled: false
    });
};
const $e99284d207f534ad$export$86df7a8824b06d6e = ({ itemId: itemId, groupId: groupId, itemsConnectionId: itemsConnectionId, isCreateChildFormVisible: isCreateChildFormVisible, depth: depth, isGroupButton: isGroupButton, createChildTriggerProps: createChildTriggerProps, renderIcon: renderIcon })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isInlineCreateChildOpen, setIsInlineCreateChildOpen] = (0, $eJOHy.useState)(false);
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: itemId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId
    });
    (0, $eJOHy.useEffect)(()=>{
        if (!isCreateChildFormVisible) setIsInlineCreateChildOpen(false);
    }, [
        isCreateChildFormVisible
    ]);
    const onCreateChildClick = (0, $eJOHy.useCallback)(()=>{
        const actionSubjectId = isGroupButton ? 'groupCreateChildButton' : 'hierarchyCreateChildButton';
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        if (!isExpanded) toggleIsItemExpanded({
            itemId: itemId,
            itemsConnectionId: itemsConnectionId
        }, depth);
        if (!isCreateChildFormVisible) createChildTriggerProps?.onClick();
        setIsInlineCreateChildOpen(true);
    }, [
        createAnalyticsEvent,
        createChildTriggerProps,
        depth,
        isCreateChildFormVisible,
        isExpanded,
        itemId,
        itemsConnectionId,
        toggleIsItemExpanded,
        isGroupButton
    ]);
    return !isInlineCreateChildOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ldj6.default), {
        onClick: onCreateChildClick,
        ref: createChildTriggerProps?.ref,
        renderIcon: renderIcon
    });
};
const $e99284d207f534ad$export$b921667debd4e0cb = ({ itemId: itemId, itemsConnectionId: itemsConnectionId, depth: depth, hasChildren: hasChildren = true, isRowHoveredOrSelected: isRowHoveredOrSelected, showCreateChildButton: showCreateChildButton, createChildTriggerProps: createChildTriggerProps, isCreateChildFormVisible: isCreateChildFormVisible, isGroupButton: isGroupButton, groupId: groupId })=>{
    if (hasChildren) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        tabIndex: isRowHoveredOrSelected ? 0 : -1,
        xcss: [
            $e99284d207f534ad$var$cellStyle,
            !isGroupButton && $e99284d207f534ad$var$cellPaddingStyle
        ],
        "data-vc": "expand-button-with-create-child-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5XgIy.default), {
        depth: depth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e99284d207f534ad$var$cellWrapperStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${$e99284d207f534ad$var$ICON_WIDTH * depth}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e99284d207f534ad$export$5663c8f5aeb8c1c4, {
        itemId: itemId,
        itemsConnectionId: itemsConnectionId,
        depth: depth,
        isGroupButton: isGroupButton,
        groupId: groupId
    })), showCreateChildButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e99284d207f534ad$export$86df7a8824b06d6e, {
        depth: depth,
        itemId: itemId,
        groupId: groupId,
        isGroupButton: isGroupButton,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        tabIndex: 0,
        xcss: $e99284d207f534ad$var$cellSizeStyle,
        "data-vc": "expand-button-with-create-child-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5XgIy.default), {
        depth: depth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e99284d207f534ad$var$cellPaddingStyle,
        style: {
            paddingLeft: `${$e99284d207f534ad$var$ICON_WIDTH * depth + $e99284d207f534ad$var$ICON_WIDTH + $e99284d207f534ad$var$EXTRA_PADDING_ROW_WITHOUT_EXPAND}px`
        }
    }, showCreateChildButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e99284d207f534ad$export$86df7a8824b06d6e, {
        depth: depth,
        itemId: itemId,
        groupId: groupId,
        isGroupButton: isGroupButton,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible
    })));
};
const $e99284d207f534ad$var$cellWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $e99284d207f534ad$var$cellSizeStyle = (0, $1DXK0.xcss)({
    height: '100%'
});
const $e99284d207f534ad$var$cellStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
});
const $e99284d207f534ad$var$cellPaddingStyle = (0, $1DXK0.xcss)({
    padding: 'space.100'
});

});
parcelRegister("3Ldj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7c1775e33e0cf91$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dcLzM = parcelRequire("dcLzM");

var $Ay1uj = parcelRequire("Ay1uj");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $2DRCb = parcelRequire("2DRCb");
const $b7c1775e33e0cf91$var$getWorkItemMessage = ()=>(0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $2DRCb.default).createWorkItem : (0, $2DRCb.default).createIssue;
const $b7c1775e33e0cf91$var$CreateChildButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isCreateWorkItem: isCreateWorkItem, renderIcon: renderIcon }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const defaultIcon = (0, $eJOHy.useCallback)((iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
            ...iconProps,
            size: "small"
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        spacing: "compact",
        appearance: "subtle",
        label: isCreateWorkItem ? formatMessage($b7c1775e33e0cf91$var$getWorkItemMessage()) : formatMessage((0, $2DRCb.default).createChildItem),
        testId: "issue-table-hierarchy.ui.create-child-button.create",
        icon: renderIcon && (0, $7jTnu.fg)('jira_list_merged_column_inline_create_icon_style') ? renderIcon : defaultIcon,
        onClick: onClick,
        isTooltipDisabled: false,
        ref: ref
    });
});
var $b7c1775e33e0cf91$export$2e2bcd8739ae039 = $b7c1775e33e0cf91$var$CreateChildButton;

});
parcelRegister("2DRCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7a4d5368b16f278$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c7a4d5368b16f278$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createChildItem: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-child-item",
        "defaultMessage": "Create child item"
    },
    createWorkItem: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-work-item",
        "defaultMessage": "Create work item"
    },
    createIssue: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-issue",
        "defaultMessage": "Create issue"
    }
});

});


parcelRegister("d8783", function(module, exports) {

$parcel$export(module.exports, "default", () => $0995f9578d4dea24$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0995f9578d4dea24$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    expandIssue: {
        "id": "native-issue-table.expand-button.expand-issue-hierarchy",
        "defaultMessage": "Expand hierarchy"
    },
    collapseIssue: {
        "id": "native-issue-table.expand-button.collapse",
        "defaultMessage": "Collapse hierarchy"
    },
    expandGroup: {
        "id": "native-issue-table.expand-button.expand-group-issue-hierarchy",
        "defaultMessage": "Expand group"
    },
    collapseGroup: {
        "id": "native-issue-table.expand-button.collapse-group",
        "defaultMessage": "Collapse group"
    }
});

});

parcelRegister("5XgIy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cda404939b0af13$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $8cda404939b0af13$var$ICON_WIDTH = 24;
const $8cda404939b0af13$var$INDENTED_PADDING = 8;
const $8cda404939b0af13$var$IndentedIcon = ({ depth: depth })=>{
    if (depth <= 0) return null;
    const left = depth > 1 ? (depth - 1) * $8cda404939b0af13$var$ICON_WIDTH + $8cda404939b0af13$var$INDENTED_PADDING : $8cda404939b0af13$var$INDENTED_PADDING;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            left: `${left}px`
        },
        xcss: $8cda404939b0af13$var$imgContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8cda404939b0af13$var$imgStyles,
        testId: "issue-table-hierarchy.ui.expand-button.indented-icon.indented-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 0V9.5C1 10.3284 1.67157 11 2.5 11H12V12H2.5C1.11929 12 0 10.8807 0 9.5V0H1Z",
        fill: "var(--ds-border, #091E4224)"
    }))));
};
const $8cda404939b0af13$var$imgStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});
const $8cda404939b0af13$var$imgContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    height: '100%'
});
var $8cda404939b0af13$export$2e2bcd8739ae039 = $8cda404939b0af13$var$IndentedIcon;

});


parcelRegister("3zo68", function(module, exports) {

$parcel$export(module.exports, "CategoryGroupHeader", () => $42bbf2f308d092b8$export$fc0707d1ce99fe4d);

var $4Uxi2 = parcelRequire("4Uxi2");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $ivVFT = parcelRequire("ivVFT");

var $lRq8t = parcelRequire("lRq8t");

var $ldHGO = parcelRequire("ldHGO");
const $42bbf2f308d092b8$export$fc0707d1ce99fe4d = ({ categoryGroupHeader: categoryGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $4Uxi2.default), categoryGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return data != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivVFT.default), {
        categoryColor: data?.option?.color?.colorKey ?? null,
        categoryName: data?.displayName,
        isInteractive: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $ldHGO.default).noCategory));
};

});
parcelRegister("4Uxi2", function(module, exports) {

$parcel$export(module.exports, "default", () => $eccad9349bda3ab6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7e75d6021772df962ce23c83c556dffa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $eccad9349bda3ab6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "categoryGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "option",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraJqlOptionFieldValue"
};
$eccad9349bda3ab6$var$node.hash = "90b12dc5c3b223af53b5f45469a1b3f2";
var $eccad9349bda3ab6$export$2e2bcd8739ae039 = $eccad9349bda3ab6$var$node;

});

parcelRegister("ivVFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd752ee372910218$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $4KSRb = parcelRequire("4KSRb");
const $fd752ee372910218$var$CategoryTag = ({ categoryName: categoryName, categoryColor: categoryColor, isInteractive: isInteractive = true })=>{
    const { textColor: textColor, backgroundColor: tagColor } = (0, $4KSRb.getColorMetadata)(categoryColor);
    return /*#__PURE__*/ $eJOHy.createElement($fd752ee372910218$var$CategoryTagWrapper, {
        isInteractive: isInteractive,
        textColor: (0, $6XJko.isVisualRefreshEnabled)() ? "var(--ds-text, #172B4D)" : textColor,
        "aria-label": categoryName,
        "data-testid": "business-categories.ui.category-form.category-tag.category-tag-wrapper"
    }, /*#__PURE__*/ $eJOHy.createElement($fd752ee372910218$var$StyledTag, {
        color: tagColor
    }, categoryName));
};
var $fd752ee372910218$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($fd752ee372910218$var$CategoryTag);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd752ee372910218$var$CategoryTagWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, isInteractive: isInteractive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $awdRS.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564188d _1e0c116y _1bah1e5h _4cvr1h6o _p12f1osq _1ul9idpf _1tkeidpf _syazijt0",
            __cmplp.isInteractive ? "_d0altlke" : "_d0al73ad",
            __cmplp.className
        ])
    });
});
const $fd752ee372910218$var$StyledTagOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $awdRS.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoiti9 _11c82smr _1reo15vq _18m915vq _bfhk1cj8 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $fd752ee372910218$var$StyledTagNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $awdRS.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko5n0m _19it11we _11c82smr _1reo15vq _18m915vq _bfhk18uv _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $fd752ee372910218$var$StyledTag = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $fd752ee372910218$var$StyledTagNew, $fd752ee372910218$var$StyledTagOld);

});
parcelRegister("4KSRb", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $3bcf16c800b16b64$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $3bcf16c800b16b64$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $3bcf16c800b16b64$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $3bcf16c800b16b64$export$49fce7fdcf55f26d);

var $jHxAK = parcelRequire("jHxAK");
const $3bcf16c800b16b64$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $jHxAK.CATEGORY_THEMES).length);
    return (0, $jHxAK.CATEGORY_THEMES)[randomIndex].name;
};
const $3bcf16c800b16b64$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $jHxAK.CATEGORY_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $3bcf16c800b16b64$export$9eff62e8ee2aaa2c = (colorName)=>(0, $jHxAK.CATEGORY_THEMES).find((item)=>item.name === colorName)?.backgroundColor ?? '';
const $3bcf16c800b16b64$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $jHxAK.GREY_LIGHTEST_META;
    return (0, $jHxAK.CATEGORY_THEMES).find((item)=>item.name === colorName) ?? (0, $jHxAK.GREY_LIGHTEST_META);
};
const $3bcf16c800b16b64$export$4ef6b7574883e63d = ()=>(0, $jHxAK.CATEGORY_THEMES).map((item)=>item.name);

});
parcelRegister("jHxAK", function(module, exports) {

$parcel$export(module.exports, "GREY_LIGHTEST_META", () => $c24cfcc605338ece$export$cb19a604bb399a88);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $c24cfcc605338ece$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $c24cfcc605338ece$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "CATEGORY_THEMES", () => $c24cfcc605338ece$export$845e69f3af4133a6);

var $2hJG2 = parcelRequire("2hJG2");
const $c24cfcc605338ece$export$cb19a604bb399a88 = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $2hJG2.default).greyLightest
};
const $c24cfcc605338ece$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $2hJG2.default).greyLighter
};
const $c24cfcc605338ece$var$GREY_META = {
    name: 'GREY',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $2hJG2.default).grey
};
const $c24cfcc605338ece$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greyDarker
};
const $c24cfcc605338ece$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greyDarkest
};
const $c24cfcc605338ece$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $2hJG2.default).purpleLightest
};
const $c24cfcc605338ece$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $2hJG2.default).purpleLighter
};
const $c24cfcc605338ece$var$PURPLE_META = {
    name: 'PURPLE',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $2hJG2.default).purple
};
const $c24cfcc605338ece$var$PURPLE_DARKER_META = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).purpleDarker
};
const $c24cfcc605338ece$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).purpleDarkest
};
const $c24cfcc605338ece$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $2hJG2.default).blueLightest
};
const $c24cfcc605338ece$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $2hJG2.default).blueLighter
};
const $c24cfcc605338ece$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $2hJG2.default).blue
};
const $c24cfcc605338ece$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).blueDarker
};
const $c24cfcc605338ece$var$BLUE_DARKEST_META = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).blueDarkest
};
const $c24cfcc605338ece$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $2hJG2.default).tealLightest
};
const $c24cfcc605338ece$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $2hJG2.default).tealLighter
};
const $c24cfcc605338ece$var$TEAL_META = {
    name: 'TEAL',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $2hJG2.default).teal
};
const $c24cfcc605338ece$var$TEAL_DARKER_META = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).tealDarker
};
const $c24cfcc605338ece$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).tealDarkest
};
const $c24cfcc605338ece$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $2hJG2.default).greenLightest
};
const $c24cfcc605338ece$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $2hJG2.default).greenLighter
};
const $c24cfcc605338ece$var$GREEN_META = {
    name: 'GREEN',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $2hJG2.default).green
};
const $c24cfcc605338ece$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greenDarker
};
const $c24cfcc605338ece$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greenDarkest
};
const $c24cfcc605338ece$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $2hJG2.default).limeLightest
};
const $c24cfcc605338ece$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $2hJG2.default).limeLighter
};
const $c24cfcc605338ece$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $2hJG2.default).lime
};
const $c24cfcc605338ece$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).limeDarker
};
const $c24cfcc605338ece$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).limeDarkest
};
const $c24cfcc605338ece$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $2hJG2.default).yellowLightest
};
const $c24cfcc605338ece$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $2hJG2.default).yellowLighter
};
const $c24cfcc605338ece$var$YELLOW_META = {
    name: 'YELLOW',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $2hJG2.default).yellow
};
const $c24cfcc605338ece$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).yellowDarker
};
const $c24cfcc605338ece$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).yellowDarkest
};
const $c24cfcc605338ece$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $2hJG2.default).orangeLightest
};
const $c24cfcc605338ece$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $2hJG2.default).orangeLighter
};
const $c24cfcc605338ece$var$ORANGE_META = {
    name: 'ORANGE',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $2hJG2.default).orange
};
const $c24cfcc605338ece$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).orangeDarker
};
const $c24cfcc605338ece$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).orangeDarkest
};
const $c24cfcc605338ece$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $2hJG2.default).redLightest
};
const $c24cfcc605338ece$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $2hJG2.default).redLighter
};
const $c24cfcc605338ece$var$RED_META = {
    name: 'RED',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $2hJG2.default).red
};
const $c24cfcc605338ece$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).redDarker
};
const $c24cfcc605338ece$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).redDarkest
};
const $c24cfcc605338ece$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $2hJG2.default).magentaLightest
};
const $c24cfcc605338ece$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $2hJG2.default).magentaLighter
};
const $c24cfcc605338ece$var$MAGENTA_META = {
    name: 'MAGENTA',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $2hJG2.default).magenta
};
const $c24cfcc605338ece$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).magentaDarker
};
const $c24cfcc605338ece$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).magentaDarkest
};
const $c24cfcc605338ece$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $c24cfcc605338ece$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $c24cfcc605338ece$export$845e69f3af4133a6 = [
    $c24cfcc605338ece$export$cb19a604bb399a88,
    $c24cfcc605338ece$var$PURPLE_LIGHTEST_META,
    $c24cfcc605338ece$var$BLUE_LIGHTEST_META,
    $c24cfcc605338ece$var$TEAL_LIGHTEST_META,
    $c24cfcc605338ece$var$GREEN_LIGHTEST_META,
    $c24cfcc605338ece$var$LIME_LIGHTEST_META,
    $c24cfcc605338ece$var$YELLOW_LIGHTEST_META,
    $c24cfcc605338ece$var$ORANGE_LIGHTEST_META,
    $c24cfcc605338ece$var$RED_LIGHTEST_META,
    $c24cfcc605338ece$var$MAGENTA_LIGHTEST_META,
    $c24cfcc605338ece$var$GREY_LIGHTER_META,
    $c24cfcc605338ece$var$PURPLE_LIGHTER_META,
    $c24cfcc605338ece$var$BLUE_LIGHTER_META,
    $c24cfcc605338ece$var$TEAL_LIGHTER_META,
    $c24cfcc605338ece$var$GREEN_LIGHTER_META,
    $c24cfcc605338ece$var$LIME_LIGHTER_META,
    $c24cfcc605338ece$var$YELLOW_LIGHTER_META,
    $c24cfcc605338ece$var$ORANGE_LIGHTER_META,
    $c24cfcc605338ece$var$RED_LIGHTER_META,
    $c24cfcc605338ece$var$MAGENTA_LIGHTER_META,
    $c24cfcc605338ece$var$GREY_META,
    $c24cfcc605338ece$var$PURPLE_META,
    $c24cfcc605338ece$var$BLUE_META,
    $c24cfcc605338ece$var$TEAL_META,
    $c24cfcc605338ece$var$GREEN_META,
    $c24cfcc605338ece$var$LIME_META,
    $c24cfcc605338ece$var$YELLOW_META,
    $c24cfcc605338ece$var$ORANGE_META,
    $c24cfcc605338ece$var$RED_META,
    $c24cfcc605338ece$var$MAGENTA_META,
    $c24cfcc605338ece$var$GREY_DARKER_META,
    $c24cfcc605338ece$var$PURPLE_DARKER_META,
    $c24cfcc605338ece$var$BLUE_DARKER_META,
    $c24cfcc605338ece$var$TEAL_DARKER_META,
    $c24cfcc605338ece$var$GREEN_DARKER_META,
    $c24cfcc605338ece$var$LIME_DARKER_META,
    $c24cfcc605338ece$var$YELLOW_DARKER_META,
    $c24cfcc605338ece$var$ORANGE_DARKER_META,
    $c24cfcc605338ece$var$RED_DARKER_META,
    $c24cfcc605338ece$var$MAGENTA_DARKER_META,
    $c24cfcc605338ece$var$GREY_DARKEST_META,
    $c24cfcc605338ece$var$PURPLE_DARKEST_META,
    $c24cfcc605338ece$var$BLUE_DARKEST_META,
    $c24cfcc605338ece$var$TEAL_DARKEST_META,
    $c24cfcc605338ece$var$GREEN_DARKEST_META,
    $c24cfcc605338ece$var$LIME_DARKEST_META,
    $c24cfcc605338ece$var$YELLOW_DARKEST_META,
    $c24cfcc605338ece$var$ORANGE_DARKEST_META,
    $c24cfcc605338ece$var$RED_DARKEST_META,
    $c24cfcc605338ece$var$MAGENTA_DARKEST_META
];

});
parcelRegister("2hJG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4a201e1872b1174$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f4a201e1872b1174$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    greyLightest: {
        "id": "business-categories.category-form.category-color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "business-categories.category-form.category-color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "business-categories.category-form.category-color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "business-categories.category-form.category-color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "business-categories.category-form.category-color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "business-categories.category-form.category-color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "business-categories.category-form.category-color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "business-categories.category-form.category-color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "business-categories.category-form.category-color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "business-categories.category-form.category-color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "business-categories.category-form.category-color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "business-categories.category-form.category-color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "business-categories.category-form.category-color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "business-categories.category-form.category-color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "business-categories.category-form.category-color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "business-categories.category-form.category-color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "business-categories.category-form.category-color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "business-categories.category-form.category-color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "business-categories.category-form.category-color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "business-categories.category-form.category-color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "business-categories.category-form.category-color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "business-categories.category-form.category-color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "business-categories.category-form.category-color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "business-categories.category-form.category-color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "business-categories.category-form.category-color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "business-categories.category-form.category-color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "business-categories.category-form.category-color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "business-categories.category-form.category-color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "business-categories.category-form.category-color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "business-categories.category-form.category-color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "business-categories.category-form.category-color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "business-categories.category-form.category-color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "business-categories.category-form.category-color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "business-categories.category-form.category-color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "business-categories.category-form.category-color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "business-categories.category-form.category-color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "business-categories.category-form.category-color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "business-categories.category-form.category-color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "business-categories.category-form.category-color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "business-categories.category-form.category-color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "business-categories.category-form.category-color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "business-categories.category-form.category-color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "business-categories.category-form.category-color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "business-categories.category-form.category-color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "business-categories.category-form.category-color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "business-categories.category-form.category-color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "business-categories.category-form.category-color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "business-categories.category-form.category-color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "business-categories.category-form.category-color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "business-categories.category-form.category-color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});




parcelRegister("ldHGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a2b1fb7f562b512$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0a2b1fb7f562b512$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noCategory: {
        "id": "issue-table-grouping.group-row.group-header.category-group-header.no-category",
        "defaultMessage": "Uncategorized"
    }
});

});


parcelRegister("98A5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f23a688be5d03c8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7f23a688be5d03c8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issues: {
        "id": "issue-table-grouping.group-row.group-header.issues",
        "defaultMessage": "{count, plural, one {# issue} other {# issues}}"
    },
    issuesIssueTermRefresh: {
        "id": "issue-table-grouping.group-row.group-header.issues-issue-term-refresh",
        "defaultMessage": "{count, plural, one {# work item} other {# work items}}"
    }
});

});

parcelRegister("1PNpH", function(module, exports) {

$parcel$export(module.exports, "PriorityGroupHeader", () => $96241136ae9fdec3$export$3d9fbda3fab02eba);

var $cR0Hm = parcelRequire("cR0Hm");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $2gIth = parcelRequire("2gIth");
const $96241136ae9fdec3$export$3d9fbda3fab02eba = ({ priorityGroupHeader: priorityGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $cR0Hm.default), priorityGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data?.priority.iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "img",
        src: data.priority.iconUrl,
        xcss: $96241136ae9fdec3$var$iconStyles,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, data?.displayName ?? formatMessage((0, $2gIth.default).noPriority)));
};
const $96241136ae9fdec3$var$iconStyles = (0, $1DXK0.xcss)({
    width: "var(--ds-space-250, 20px)",
    height: "var(--ds-space-250, 20px)"
});

});
parcelRegister("cR0Hm", function(module, exports) {

$parcel$export(module.exports, "default", () => $87044741b0c84473$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a47183f377827441d9c91b7504c70c7f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $87044741b0c84473$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priorityGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        }
    ],
    "type": "JiraJqlPriorityFieldValue"
};
$87044741b0c84473$var$node.hash = "3dcfc9ec9cb74efd76e969db691aec34";
var $87044741b0c84473$export$2e2bcd8739ae039 = $87044741b0c84473$var$node;

});

parcelRegister("2gIth", function(module, exports) {

$parcel$export(module.exports, "default", () => $a64d8ab52717dcf9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a64d8ab52717dcf9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noPriority: {
        "id": "issue-table-grouping.group-row.group-header.priority-group-header.no-priority",
        "defaultMessage": "No priority"
    }
});

});


parcelRegister("iYld7", function(module, exports) {

$parcel$export(module.exports, "SprintGroupHeader", () => $f791af42ff216eb4$export$c4bf8cf8359b52ab);

var $si2Kd = parcelRequire("si2Kd");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $52CBb = parcelRequire("52CBb");
const $f791af42ff216eb4$export$c4bf8cf8359b52ab = ({ sprintGroupHeader: sprintGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $si2Kd.default), sprintGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let text;
    if (!data) text = formatMessage((0, $52CBb.default).backlog);
    else if (data.sprint?.state === 'CLOSED') text = formatMessage((0, $52CBb.default).completedSprint);
    else text = data.displayName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
        text: text
    });
};

});
parcelRegister("si2Kd", function(module, exports) {

$parcel$export(module.exports, "default", () => $975350d37db2f079$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6e460a26aee2693b751f2aede983be2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $975350d37db2f079$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprintGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraSprint",
            "kind": "LinkedField",
            "name": "sprint",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "state"
                }
            ]
        }
    ],
    "type": "JiraJqlSprintFieldValue"
};
$975350d37db2f079$var$node.hash = "8c878b1b3d9a4d86bbc1c264380dbce5";
var $975350d37db2f079$export$2e2bcd8739ae039 = $975350d37db2f079$var$node;

});

parcelRegister("ewOxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $935d42f1f33a5e95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1fStw = parcelRequire("1fStw");

var $40nZT = parcelRequire("40nZT");

var $6UE2q = parcelRequire("6UE2q");
const $935d42f1f33a5e95$var$SimpleTagComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6UE2q.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1fStw.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40nZT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $935d42f1f33a5e95$var$SimpleTag = /*#__PURE__*/ (0, $eJOHy.memo)($935d42f1f33a5e95$var$SimpleTagComponent);
var $935d42f1f33a5e95$export$2e2bcd8739ae039 = $935d42f1f33a5e95$var$SimpleTag;

});
parcelRegister("1fStw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb40a4175fb93ea9$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5itvH = parcelRequire("5itvH");
const $eb40a4175fb93ea9$var$borderColorCssVar = '--ds-bc';
const $eb40a4175fb93ea9$var$focusRingCssVar = '--ds-cfr';
const $eb40a4175fb93ea9$var$textLinkCssVar = '--ds-ctl';
const $eb40a4175fb93ea9$var$textDefaultCssVar = '--ds-ct';
const $eb40a4175fb93ea9$var$textHoverCssVar = '--ds-cth';
const $eb40a4175fb93ea9$var$textActiveCssVar = '--ds-ctp';
const $eb40a4175fb93ea9$var$backgroundDefaultCssVar = '--ds-cb';
const $eb40a4175fb93ea9$var$backgroundHoverCssVar = '--ds-cbh';
const $eb40a4175fb93ea9$var$backgroundActiveCssVar = '--ds-cba';
const $eb40a4175fb93ea9$var$removeButtonDefaultCssVar = '--ds-rb';
const $eb40a4175fb93ea9$var$removeButtonHoverCssVar = '--ds-rbh';
const $eb40a4175fb93ea9$var$borderRadiusCssVar = '--ds-br';
// To be removed with platform-component-visual-refresh (BLU-2992)
const $eb40a4175fb93ea9$var$baseStylesOld = null;
const $eb40a4175fb93ea9$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $eb40a4175fb93ea9$var$interactiveStylesOld = null;
const $eb40a4175fb93ea9$var$interactiveStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $eb40a4175fb93ea9$var$focusRingStylesOld = null;
const $eb40a4175fb93ea9$var$focusRingStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $eb40a4175fb93ea9$var$nonStandardLinkStyles = null;
const $eb40a4175fb93ea9$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? (0, $5itvH.textColors)['standardLink'] : (0, $5itvH.textColors)[color];
    const backgroundHoverColors = isRemovable && !isLink ? (0, $5itvH.backgroundColors)[color] : (0, $5itvH.linkHoverBackgroundColors)[color];
    const backgroundActiveColors = isRemovable && !isLink ? (0, $5itvH.backgroundColors)[color] : (0, $5itvH.linkActiveBackgroundColors)[color];
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // NOTE: The vast majority of these styles have zero purpose to be runtime computed
            // This can all be migrated to statically distributed atomic CSS with Compiled in the future
            // The main reason for not touching this is there is to avoid excessive changes in the same PR on non-visual-refresh code
            /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ [$eb40a4175fb93ea9$var$borderColorCssVar]: (0, $5itvH.borderColors)[color],
            [$eb40a4175fb93ea9$var$textDefaultCssVar]: (0, $5itvH.textColors)[color],
            [$eb40a4175fb93ea9$var$textHoverCssVar]: (0, $5itvH.textHoverColors)[color],
            [$eb40a4175fb93ea9$var$textActiveCssVar]: (0, $5itvH.textActiveColors)[color],
            [$eb40a4175fb93ea9$var$textLinkCssVar]: textLinkColors,
            [$eb40a4175fb93ea9$var$backgroundDefaultCssVar]: (0, $5itvH.backgroundColors)[color],
            [$eb40a4175fb93ea9$var$backgroundHoverCssVar]: backgroundHoverColors,
            [$eb40a4175fb93ea9$var$backgroundActiveCssVar]: backgroundActiveColors,
            [$eb40a4175fb93ea9$var$focusRingCssVar]: (0, $5itvH.focusRingColors),
            [$eb40a4175fb93ea9$var$removeButtonDefaultCssVar]: (0, $5itvH.removeButtonColors)[color],
            [$eb40a4175fb93ea9$var$removeButtonHoverCssVar]: (0, $5itvH.removeButtonHoverColors)[color],
            [$eb40a4175fb93ea9$var$borderRadiusCssVar]: appearance === 'rounded' ? '10px' : '3px',
            /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_zulp1b66 _2rko1sit _1h6d2fso _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad" : "_2rko1l5z _1mou1b66 _195g1b66 _1rjcze3t _18zrze3t _1e0c116y _1ul9idpf _4t3iv47k _kqswh2mm _bfhklsll _syaz148y _80om73ad",
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_1e38ugt7 _7glxv77o" : "_1guj1r31 _pbhaglyw _11ow1o36 _1u6lnr64",
            isLink && (0, $eGOwo.fg)('platform-component-visual-refresh') && "_irr3166n _1di61dty",
            !(0, $eGOwo.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && "_9h8h1348",
            !(0, $eGOwo.fg)('platform-component-visual-refresh') && isInteractive && "_irr31lyj _1di6oo20",
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eb40a4175fb93ea9$export$2e2bcd8739ae039 = $eb40a4175fb93ea9$var$BaseTag;

});
parcelRegister("5itvH", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $4a01ae90fd3660b9$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $4a01ae90fd3660b9$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $4a01ae90fd3660b9$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $4a01ae90fd3660b9$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $4a01ae90fd3660b9$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $4a01ae90fd3660b9$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $4a01ae90fd3660b9$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $4a01ae90fd3660b9$export$2a31dbe82788f940);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $4a01ae90fd3660b9$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $4a01ae90fd3660b9$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $4a01ae90fd3660b9$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $4a01ae90fd3660b9$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $4a01ae90fd3660b9$export$b03fbc2a369c563e);
// Text colors
const $4a01ae90fd3660b9$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, #253858)",
    standardLink: "var(--ds-link, #0052CC)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $4a01ae90fd3660b9$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $4a01ae90fd3660b9$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, #0065FF)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $4a01ae90fd3660b9$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, #0065FF)",
    blue: "var(--ds-text-accent-blue, #172B4D)",
    red: "var(--ds-text-accent-red, #172B4D)",
    yellow: "var(--ds-text-accent-yellow, #172B4D)",
    green: "var(--ds-text-accent-green, #172B4D)",
    teal: "var(--ds-text-accent-teal, #172B4D)",
    purple: "var(--ds-text-accent-purple, #172B4D)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
    redLight: "var(--ds-text-accent-red-bolder, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
    greenLight: "var(--ds-text-accent-green-bolder, #006644)",
    tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
    purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};
const $4a01ae90fd3660b9$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, #F4F5F7)",
    blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    red: "var(--ds-background-accent-red-subtle, #FF8F73)",
    yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
    green: "var(--ds-background-accent-green-subtle, #57D9A3)",
    teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
    purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, #42526E)",
    blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
    greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
    tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
    purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
const $4a01ae90fd3660b9$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
    red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
    green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
    teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
    purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
    redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
    greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
const $4a01ae90fd3660b9$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
    red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
    green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
    teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
    purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
    grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
    redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
    greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
const $4a01ae90fd3660b9$export$2a31dbe82788f940 = "var(--ds-border-focused, #4C9AFF)";
const $4a01ae90fd3660b9$export$1202b7eb21da7b58 = "var(--ds-background-danger, #FFEBE6)";
const $4a01ae90fd3660b9$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, #FFEBE6)";
const $4a01ae90fd3660b9$export$17d206ccea111bbb = "var(--ds-text-danger, #BF2600)";
const $4a01ae90fd3660b9$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, #42526E)",
    blue: "var(--ds-text-accent-blue-bolder, #42526E)",
    red: "var(--ds-text-accent-red-bolder, #42526E)",
    yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
    green: "var(--ds-text-accent-green-bolder, #42526E)",
    teal: "var(--ds-text-accent-teal-bolder, #42526E)",
    purple: "var(--ds-text-accent-purple-bolder, #42526E)",
    lime: "var(--ds-text-accent-lime-bolder, #42526E)",
    magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
    orange: "var(--ds-text-accent-orange-bolder, #42526E)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #42526E)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #42526E)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #42526E)",
    limeLight: "var(--ds-text-accent-lime, #42526E)",
    magentaLight: "var(--ds-text-accent-magenta, #42526E)",
    orangeLight: "var(--ds-text-accent-orange, #42526E)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $4a01ae90fd3660b9$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, #253858)",
    standardLink: "var(--ds-text-danger, #0052CC)",
    blue: "var(--ds-text-danger, #172B4D)",
    red: "var(--ds-text-danger, #172B4D)",
    yellow: "var(--ds-text-danger, #172B4D)",
    green: "var(--ds-text-danger, #172B4D)",
    teal: "var(--ds-text-danger, #172B4D)",
    purple: "var(--ds-text-danger, #172B4D)",
    lime: "var(--ds-text-danger, #172B4D)",
    magenta: "var(--ds-text-danger, #172B4D)",
    orange: "var(--ds-text-danger, #172B4D)",
    grey: "var(--ds-text-danger, #172B4D)",
    blueLight: "var(--ds-text-danger, #0747A6)",
    redLight: "var(--ds-text-danger, #42526E)",
    yellowLight: "var(--ds-text-danger, #42526E)",
    greenLight: "var(--ds-text-danger, #006644)",
    tealLight: "var(--ds-text-danger, #42526E)",
    purpleLight: "var(--ds-text-danger, #403294)",
    limeLight: "var(--ds-text-danger, #403294)",
    magentaLight: "var(--ds-text-danger, #403294)",
    orangeLight: "var(--ds-text-danger, #403294)",
    greyLight: "var(--ds-text-danger, #42526E)"
};

});


parcelRegister("40nZT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae242ab93c29e38$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $dae242ab93c29e38$var$beforeElementStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $dae242ab93c29e38$var$beforeElementStylesOld = null;
const $dae242ab93c29e38$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dae242ab93c29e38$export$2e2bcd8739ae039 = $dae242ab93c29e38$var$Before;

});

parcelRegister("6UE2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d73caba6a9e3a1c$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
// To be removed with platform-component-visual-refresh (BLU-2992)
const $6d73caba6a9e3a1c$var$baseStylesOld = null;
const $6d73caba6a9e3a1c$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $6d73caba6a9e3a1c$var$linkStylesOld = null;
const $6d73caba6a9e3a1c$var$linkStyles = null;
const $6d73caba6a9e3a1c$var$hasAfterStylesOld = null;
const $6d73caba6a9e3a1c$var$hasAfterStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $6d73caba6a9e3a1c$var$hasBeforeStyles = null;
const $6d73caba6a9e3a1c$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, $hcewu.default)([
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3117u _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1348",
            !(0, $eGOwo.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $eGOwo.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $eGOwo.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            !(0, $eGOwo.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $eGOwo.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $eGOwo.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d73caba6a9e3a1c$export$2e2bcd8739ae039 = $6d73caba6a9e3a1c$var$Content;

});


parcelRegister("52CBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $19f4af068b811078$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $19f4af068b811078$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    completedSprint: {
        "id": "issue-table-grouping.group-row.group-header.sprint-group-header.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    backlog: {
        "id": "issue-table-grouping.group-row.group-header.sprint-group-header.backlog",
        "defaultMessage": "Backlog"
    }
});

});


parcelRegister("aV9Qf", function(module, exports) {

$parcel$export(module.exports, "StatusGroupHeader", () => $3befe5f31c7aeac2$export$47d603da63417bb);

var $9aYqr = parcelRequire("9aYqr");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jdqdp = parcelRequire("jdqdp");

var $7keuM = parcelRequire("7keuM");
const $3befe5f31c7aeac2$var$appearanceMap = {
    [(0, $7keuM.UNDEFINED)]: 'default',
    [(0, $7keuM.TODO)]: 'default',
    [(0, $7keuM.DONE)]: 'success',
    [(0, $7keuM.IN_PROGRESS)]: 'inprogress'
};
const $3befe5f31c7aeac2$export$47d603da63417bb = ({ statusGroupHeader: statusGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $9aYqr.default), statusGroupHeader);
    const appearance = data?.statusCategory.statusCategoryId != null ? $3befe5f31c7aeac2$var$appearanceMap[(0, $7keuM.statusCategoryForId)(data?.statusCategory.statusCategoryId)] : $3befe5f31c7aeac2$var$appearanceMap[0, $7keuM.UNDEFINED];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: appearance
    }, data?.displayName);
};

});
parcelRegister("9aYqr", function(module, exports) {

$parcel$export(module.exports, "default", () => $18dea5fe626204c9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ad111684f32cabb41a8564790f4ff647>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $18dea5fe626204c9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "statusGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCategoryId"
                }
            ]
        }
    ],
    "type": "JiraJqlStatusFieldValue"
};
$18dea5fe626204c9$var$node.hash = "4f2de6020bb90556ff180cce2814c51d";
var $18dea5fe626204c9$export$2e2bcd8739ae039 = $18dea5fe626204c9$var$node;

});

parcelRegister("7keuM", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e9fafd5bde6d9f47$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e9fafd5bde6d9f47$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e9fafd5bde6d9f47$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e9fafd5bde6d9f47$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e9fafd5bde6d9f47$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e9fafd5bde6d9f47$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e9fafd5bde6d9f47$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e9fafd5bde6d9f47$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e9fafd5bde6d9f47$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e9fafd5bde6d9f47$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e9fafd5bde6d9f47$export$d928f247c903643a);
const $e9fafd5bde6d9f47$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e9fafd5bde6d9f47$export$aa456a5030160740 = 'TODO';
const $e9fafd5bde6d9f47$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e9fafd5bde6d9f47$export$71efb3495f6084f2 = 'DONE';
const $e9fafd5bde6d9f47$export$d9119300f9d9a815 = [
    $e9fafd5bde6d9f47$export$6db089fe7b26f5b6,
    $e9fafd5bde6d9f47$export$aa456a5030160740,
    $e9fafd5bde6d9f47$export$5a9ac66c2785cc13,
    $e9fafd5bde6d9f47$export$71efb3495f6084f2
];
const $e9fafd5bde6d9f47$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e9fafd5bde6d9f47$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e9fafd5bde6d9f47$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e9fafd5bde6d9f47$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e9fafd5bde6d9f47$export$71efb3495f6084f2
    }
];
const $e9fafd5bde6d9f47$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e9fafd5bde6d9f47$export$3f42f49c284d5b58 = Object.freeze({
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.NEW]: 2,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.DONE]: 3,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e9fafd5bde6d9f47$export$f3f919dc0f56d9eb = Object.values($e9fafd5bde6d9f47$export$5d42a08d46cffe7);
const $e9fafd5bde6d9f47$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e9fafd5bde6d9f47$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e9fafd5bde6d9f47$export$6db089fe7b26f5b6;
};
const $e9fafd5bde6d9f47$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e9fafd5bde6d9f47$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e9fafd5bde6d9f47$export$d928f247c903643a = (key)=>$e9fafd5bde6d9f47$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("iIcv7", function(module, exports) {

$parcel$export(module.exports, "StoryPointsGroupHeader", () => $68b2779188a1d871$export$67c95e3a82fabe13);

var $fI0zf = parcelRequire("fI0zf");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7q9BG = parcelRequire("7q9BG");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $6qVOj = parcelRequire("6qVOj");
const $68b2779188a1d871$export$67c95e3a82fabe13 = ({ storyPointsGroupHeader: storyPointsGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $fI0zf.default), storyPointsGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        appearance: "default"
    }, typeof data?.number === 'number' ? formatMessage((0, $6qVOj.default).storyPoints, {
        points: data?.number
    }) : formatMessage((0, $6qVOj.default).noStoryPoints)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
        text: typeof data?.number === 'number' ? formatMessage((0, $6qVOj.default).storyPoints, {
            points: data?.number
        }) : formatMessage((0, $6qVOj.default).noStoryPoints)
    });
};

});
parcelRegister("fI0zf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c7c46a03d76dab1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ce8ac842490f82e59f8a233d44e27fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c7c46a03d76dab1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointsGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraJqlNumberFieldValue"
};
$3c7c46a03d76dab1$var$node.hash = "99ed4a1cc4e5ea4a4b3c5cb98de1c14f";
var $3c7c46a03d76dab1$export$2e2bcd8739ae039 = $3c7c46a03d76dab1$var$node;

});

parcelRegister("6qVOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9524c98beda18117$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9524c98beda18117$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    storyPoints: {
        "id": "issue-table-grouping.group-row.group-header.story-points-group-header.story-points",
        "defaultMessage": "{points, plural, one {# point} other {# points}}"
    },
    noStoryPoints: {
        "id": "issue-table-grouping.group-row.group-header.story-points-group-header.no-story-points",
        "defaultMessage": "No points"
    }
});

});


parcelRegister("gv23s", function(module, exports) {

$parcel$export(module.exports, "GoalGroupHeader", () => $d4b20c1fe21cd40f$export$2fac2323394ec085);

var $3nO8n = parcelRequire("3nO8n");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jdqdp = parcelRequire("jdqdp");

var $lRq8t = parcelRequire("lRq8t");

var $jsdaB = parcelRequire("jsdaB");

var $jsdaB = parcelRequire("jsdaB");

var $7jTnu = parcelRequire("7jTnu");

var $dlGxm = parcelRequire("dlGxm");
const $d4b20c1fe21cd40f$var$goalStatusToLabelMap = {
    ARCHIVED: (0, $dlGxm.default).statusLabelArchived,
    PENDING: (0, $dlGxm.default).statusLabelPending,
    IN_PROGRESS: (0, $dlGxm.default).statusLabelInProgress,
    COMPLETED: (0, $dlGxm.default).statusLabelCompleted,
    DONE: (0, $dlGxm.default).statusLabelCompleted,
    ON_TRACK: (0, $dlGxm.default).statusLabelOnTrack,
    PAUSED: (0, $dlGxm.default).statusLabelPaused,
    AT_RISK: (0, $dlGxm.default).statusLabelAtRisk,
    OFF_TRACK: (0, $dlGxm.default).statusLabelOffTrack,
    CANCELLED: (0, $dlGxm.default).statusLabelCancelled
};
const $d4b20c1fe21cd40f$var$goalStatusToLozengeAppearanceMap = {
    ARCHIVED: 'default',
    PENDING: 'default',
    IN_PROGRESS: 'inprogress',
    COMPLETED: 'success',
    DONE: 'success',
    ON_TRACK: 'success',
    PAUSED: 'moved',
    AT_RISK: 'moved',
    OFF_TRACK: 'removed',
    CANCELLED: 'removed'
};
const $d4b20c1fe21cd40f$export$2fac2323394ec085 = ({ goalGroupHeader: goalGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $3nO8n.default), goalGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const displayName = data?.displayName ?? formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $dlGxm.default).noGoalsDisplayNameIssueTermRefresh : (0, $dlGxm.default).noGoalsDisplayName);
    const status = formatMessage($d4b20c1fe21cd40f$var$goalStatusToLabelMap[data?.goal?.status || 'PENDING']);
    const appearance = (0, $jsdaB.normalizeGoalAppearance)(data?.goal?.status || 'PENDING');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data?.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jsdaB.GoalIcon), {
        size: "16",
        appearance: appearance,
        goalIconKey: "GOAL"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d4b20c1fe21cd40f$var$goalTextStyles
    }, displayName), data?.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: $d4b20c1fe21cd40f$var$goalStatusToLozengeAppearanceMap[data.goal.status || 'PENDING']
    }, status, data.goal.score && ` - ${data.goal.score || ''}`));
};
const $d4b20c1fe21cd40f$var$goalTextStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("3nO8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $f075982d79da0577$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<01232dee66988142ad1378499d9b08c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f075982d79da0577$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "goalGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraGoal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "kind": "ScalarField",
                    "name": "score"
                }
            ]
        }
    ],
    "type": "JiraJqlGoalsFieldValue"
};
$f075982d79da0577$var$node.hash = "ff278af7d79d0614b5dc07558d4a411c";
var $f075982d79da0577$export$2e2bcd8739ae039 = $f075982d79da0577$var$node;

});

parcelRegister("jsdaB", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $a7b2c6cc6d0f42bb$export$134cbcd70c6693b8);
$parcel$export(module.exports, "normalizeGoalAppearance", () => $a7b2c6cc6d0f42bb$export$f1b3ca93191ce5cc);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $1WryD = parcelRequire("1WryD");

var $9qes7 = parcelRequire("9qes7");

var $9RMYL = parcelRequire("9RMYL");

var $1wxug = parcelRequire("1wxug");

var $dVVwX = parcelRequire("dVVwX");

var $h8rwk = parcelRequire("h8rwk");
const $a7b2c6cc6d0f42bb$var$appearanceToColorMap = {
    DEFAULT: 'gray',
    MENU: 'gray',
    OFF_TRACK: 'red',
    AT_RISK: 'yellow',
    ON_TRACK: 'green'
};
const $a7b2c6cc6d0f42bb$var$appearanceToNewColorMap = {
    MENU: "var(--ds-icon, #44546F)",
    DEFAULT: "var(--ds-icon-accent-gray, #758195)",
    OFF_TRACK: "var(--ds-icon-danger, #C9372C)",
    AT_RISK: "var(--ds-icon-warning, #E56910)",
    ON_TRACK: "var(--ds-icon-success, #22A06B)"
};
const $a7b2c6cc6d0f42bb$var$keyToIconMap = {
    GOAL: (0, (/*@__PURE__*/$parcel$interopDefault($9qes7))),
    OBJECTIVE: (0, (/*@__PURE__*/$parcel$interopDefault($1wxug))),
    KEY_RESULT: (0, (/*@__PURE__*/$parcel$interopDefault($9RMYL)))
};
const $a7b2c6cc6d0f42bb$var$getLabel = (intl, label, localizedLabel)=>{
    if (label) return label;
    if (localizedLabel && (0, $h8rwk.isMessageId)(localizedLabel?.messageId)) return intl.formatMessage((0, $h8rwk.messages)[localizedLabel.messageId]);
    return '';
};
const $a7b2c6cc6d0f42bb$export$134cbcd70c6693b8 = ({ appearance: appearance, size: size, localizedLabel: localizedLabel, goalIconKey: goalIconKey = 'GOAL', isVisualRefresh: isVisualRefresh = false, visualRefreshSpacing: visualRefreshSpacing = 'none', label: label, shouldScale: shouldScale = false })=>{
    const intl = (0, $lRq8t.default)();
    const iconLabel = $a7b2c6cc6d0f42bb$var$getLabel(intl, label, localizedLabel);
    const Icon = $a7b2c6cc6d0f42bb$var$keyToIconMap[goalIconKey] ?? $a7b2c6cc6d0f42bb$var$keyToIconMap.GOAL;
    if (isVisualRefresh) {
        const ResizableIcon = Icon;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ResizableIcon, {
            shouldScale: shouldScale,
            color: $a7b2c6cc6d0f42bb$var$appearanceToNewColorMap[appearance],
            label: iconLabel,
            spacing: visualRefreshSpacing
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        size: size,
        icon: Icon,
        label: iconLabel,
        appearance: $a7b2c6cc6d0f42bb$var$appearanceToColorMap[appearance]
    });
};
const $a7b2c6cc6d0f42bb$export$f1b3ca93191ce5cc = (statusValue)=>{
    const appearanceUppercase = statusValue.toLocaleUpperCase();
    return (0, $dVVwX.isGoalAppearance)(appearanceUppercase) ? appearanceUppercase : 'DEFAULT';
};

});
parcelRegister("1WryD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5a874af77e003e$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $6d5a874af77e003e$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $6d5a874af77e003e$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $6d5a874af77e003e$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $6d5a874af77e003e$var$iconTileStyles = null;
function $6d5a874af77e003e$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $eGOwo.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $6d5a874af77e003e$var$appearanceMap[appearance],
            $6d5a874af77e003e$var$sizeMap[size],
            $6d5a874af77e003e$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});

parcelRegister("9RMYL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9ba563912d9cb57c78d7ea4485b79c7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72ef0e7f955dc8ab$var$_react = $72ef0e7f955dc8ab$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72ef0e7f955dc8ab$var$_baseNew = $72ef0e7f955dc8ab$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72ef0e7f955dc8ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "KeyResult".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing key results.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72ef0e7f955dc8ab$var$KeyResultIcon = (props)=>/*#__PURE__*/ $72ef0e7f955dc8ab$var$_react.default.createElement($72ef0e7f955dc8ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.435.001a.75.75 0 0 1 .547.194l3.023 2.75-1.01 1.11-2.437-2.217A10.2 10.2 0 0 0 7.527 7.25h3.163l1.28-1.28a.75.75 0 0 1 .53-.22h2.75a.75.75 0 0 1 .671 1.085L15.339 8l.582 1.165a.75.75 0 0 1-.67 1.085H12.5a.75.75 0 0 1-.531-.22l-1.28-1.28H7.528c.149 2.02.895 3.88 2.051 5.41l2.414-2.213 1.014 1.106-3 2.75a.75.75 0 0 1-1.07-.059A11.75 11.75 0 0 1 6.023 8.75H2.756l1.361 1.184-.984 1.132-2.875-2.5a.75.75 0 0 1 0-1.132l2.875-2.5.984 1.132L2.755 7.25h3.269A11.7 11.7 0 0 1 8.914.255a.75.75 0 0 1 .52-.254m2.626 8 .75.749h1.226l-.208-.414a.75.75 0 0 1 0-.671l.208-.415H12.81z" clip-rule="evenodd"/>`
    }, props));
$72ef0e7f955dc8ab$var$KeyResultIcon.displayName = 'KeyResultIcon';
var $72ef0e7f955dc8ab$var$_default = module.exports.default = $72ef0e7f955dc8ab$var$KeyResultIcon;

});

parcelRegister("1wxug", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6209776ef69c56f26af2970fd840a919>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $11c2c178697c4d79$var$_react = $11c2c178697c4d79$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $11c2c178697c4d79$var$_baseNew = $11c2c178697c4d79$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $11c2c178697c4d79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Objective".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for objectives.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $11c2c178697c4d79$var$ObjectiveIcon = (props)=>/*#__PURE__*/ $11c2c178697c4d79$var$_react.default.createElement($11c2c178697c4d79$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.422.02a.75.75 0 0 1 .54.493l.38 1.144 1.145.381a.75.75 0 0 1 .293 1.242l-2 2a.75.75 0 0 1-.53.22h-1.69L8.03 9.03 6.97 7.97l3.53-3.53V2.75a.75.75 0 0 1 .22-.53l2-2a.75.75 0 0 1 .702-.2M12 4h.94l.922-.922-.35-.116a.75.75 0 0 1-.473-.475l-.117-.349-.922.923zM8 1.5A6.5 6.5 0 1 0 14.5 8H16a8 8 0 1 1-8-8zM8 5a3 3 0 1 0 3 3h1.5A4.5 4.5 0 1 1 8 3.5z" clip-rule="evenodd"/>`
    }, props));
$11c2c178697c4d79$var$ObjectiveIcon.displayName = 'ObjectiveIcon';
var $11c2c178697c4d79$var$_default = module.exports.default = $11c2c178697c4d79$var$ObjectiveIcon;

});

parcelRegister("dVVwX", function(module, exports) {

$parcel$export(module.exports, "isGoalAppearance", () => $5f59c3cc5e299b8b$export$86d2476abee3806b);
$parcel$export(module.exports, "isGoalIconKey", () => $5f59c3cc5e299b8b$export$51f87e2f4bd9e4bf);
const $5f59c3cc5e299b8b$export$d6870ac5e959c0f5 = [
    'DEFAULT',
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'MENU'
];
const $5f59c3cc5e299b8b$export$86d2476abee3806b = (value)=>$5f59c3cc5e299b8b$export$d6870ac5e959c0f5.includes(value);
const $5f59c3cc5e299b8b$export$d7b4c6a971e28318 = [
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'PENDING',
    'DONE',
    'CANCELLED',
    'PAUSED',
    'ARCHIVED'
];
const $5f59c3cc5e299b8b$export$a65140e49f013a96 = [
    'GOAL',
    'OBJECTIVE',
    'KEY_RESULT'
];
const $5f59c3cc5e299b8b$export$51f87e2f4bd9e4bf = (value)=>$5f59c3cc5e299b8b$export$a65140e49f013a96.includes(value);

});

parcelRegister("h8rwk", function(module, exports) {

$parcel$export(module.exports, "isMessageId", () => $874dea3760057f53$export$d28699f9b486207b);
$parcel$export(module.exports, "messages", () => $874dea3760057f53$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $874dea3760057f53$var$MESSAGE_IDS = [
    'townsquare.api.goal-state.on-track',
    'townsquare.api.goal-state.off-track',
    'townsquare.api.goal-state.at-risk',
    'townsquare.api.goal-state.pending',
    'townsquare.api.goal-state.completed',
    'townsquare.api.goal-state.cancelled',
    'townsquare.api.goal-state.paused'
];
const $874dea3760057f53$export$d28699f9b486207b = (value)=>$874dea3760057f53$var$MESSAGE_IDS.includes(value);
const $874dea3760057f53$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    'townsquare.api.goal-state.on-track': {
        id: 'Goals.icon.label.on-track',
        defaultMessage: 'On track',
        description: 'The label for the "on track" goal status'
    },
    'townsquare.api.goal-state.off-track': {
        id: 'Goals.icon.label.off-track',
        defaultMessage: 'Off track',
        description: 'The label for the "off track" goal status'
    },
    'townsquare.api.goal-state.at-risk': {
        id: 'Goals.icon.label.at-risk',
        defaultMessage: 'At risk',
        description: 'The label for the "at risk" goal status'
    },
    'townsquare.api.goal-state.pending': {
        id: 'Goals.icon.label.pending',
        defaultMessage: 'Pending',
        description: 'The label for the "pending" goal status'
    },
    'townsquare.api.goal-state.completed': {
        id: 'Goals.icon.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    'townsquare.api.goal-state.cancelled': {
        id: 'Goals.icon.label.cancelled',
        defaultMessage: 'Cancelled',
        description: 'The label for the "cancelled" goal status'
    },
    'townsquare.api.goal-state.paused': {
        id: 'Goals.icon.label.paused',
        defaultMessage: 'Paused',
        description: 'The label for the "paused" goal status'
    }
});

});


parcelRegister("dlGxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $632cb9afa5d02bed$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $632cb9afa5d02bed$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noGoalsDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.goal-group-header.no-goals-display-name",
        "defaultMessage": "Issues without goal"
    },
    noGoalsDisplayNameIssueTermRefresh: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.no-goals-display-name-issue-term-refresh",
        "defaultMessage": "Work items without goal"
    },
    statusLabelArchived: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-archived",
        "defaultMessage": "Archived"
    },
    statusLabelPending: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-pending",
        "defaultMessage": "Pending"
    },
    statusLabelInProgress: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-in-progress",
        "defaultMessage": "In progress"
    },
    statusLabelCompleted: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-completed",
        "defaultMessage": "Completed"
    },
    statusLabelOnTrack: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-on-track",
        "defaultMessage": "On track"
    },
    statusLabelPaused: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-paused",
        "defaultMessage": "Paused"
    },
    statusLabelAtRisk: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-at-risk",
        "defaultMessage": "At risk"
    },
    statusLabelOffTrack: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-off-track",
        "defaultMessage": "Off track"
    },
    statusLabelCancelled: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-cancelled",
        "defaultMessage": "Cancelled"
    }
});

});


parcelRegister("cjsh9", function(module, exports) {

$parcel$export(module.exports, "LabelGroupHeader", () => $8225eec13a992ae2$export$18b1d108a714e82e);

var $9v5wf = parcelRequire("9v5wf");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $aCFLd = parcelRequire("aCFLd");

var $051tO = parcelRequire("051tO");

var $aIng6 = parcelRequire("aIng6");

var $7hEnC = parcelRequire("7hEnC");
const $8225eec13a992ae2$var$isColorfulLabelsEnabled = ()=>(0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) || (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false);
// Logic inherited from src/packages/issue/fields/platform/labels/readview-full/src/ui/labels/index.tsx
const $8225eec13a992ae2$var$getLabelColor = (label)=>{
    if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        const colorName = label?.color?.colorKey;
        if (!colorName) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label?.name || '');
        const { tagColor: tagColor } = (0, $051tO.getColorMetadata)(colorName);
        return tagColor;
    }
    if ((0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label?.name || '');
};
const $8225eec13a992ae2$export$18b1d108a714e82e = ({ labelGroupHeader: labelGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $9v5wf.default), labelGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIng6.TagGroupHeaderContent), {
        text: data?.label?.name,
        color: data?.label ? $8225eec13a992ae2$var$getLabelColor(data.label) : undefined,
        isColored: $8225eec13a992ae2$var$isColorfulLabelsEnabled(),
        noValueText: formatMessage((0, $7hEnC.default).noLabel)
    });
};

});
parcelRegister("9v5wf", function(module, exports) {

$parcel$export(module.exports, "default", () => $910b2815889dddbc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef2d4b8da5c229711b0b19fd50961cc7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $910b2815889dddbc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "labelGroupHeader_issueTableGrouping",
    "selections": [
        {
            "concreteType": "JiraLabel",
            "kind": "LinkedField",
            "name": "label",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraJqlLabelFieldValue"
};
$910b2815889dddbc$var$node.hash = "5799ec916c3b3253f43da10a011536b1";
var $910b2815889dddbc$export$2e2bcd8739ae039 = $910b2815889dddbc$var$node;

});

parcelRegister("aCFLd", function(module, exports) {

$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $3bdc301abc6592d1$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $3bdc301abc6592d1$export$a80529ae8ec44f02);

var $5PQOA = parcelRequire("5PQOA");

var $cNNNb = parcelRequire("cNNNb");

var $1mQND = parcelRequire("1mQND");

var $eFge8 = parcelRequire("eFge8");
const $3bdc301abc6592d1$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $1mQND.getHashValueForText)(option);
        const randomIndex = (0, $eFge8.getRandomIndex)(hashValue);
        return (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $cNNNb.GREY_META).name;
};
const $3bdc301abc6592d1$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $1mQND.getHashValueForText)(option);
        const randomIndex = (0, $eFge8.getRandomIndex)(hashValue);
        return (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $cNNNb.GREY_META).tagColor;
};
const $3bdc301abc6592d1$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($3bdc301abc6592d1$export$97056d4b28203ee9);
const $3bdc301abc6592d1$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($3bdc301abc6592d1$export$a3f5334e7a13e57a);

});
parcelRegister("cNNNb", function(module, exports) {

$parcel$export(module.exports, "GREY_META", () => $711a16afce0bfcb3$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $711a16afce0bfcb3$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $711a16afce0bfcb3$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $711a16afce0bfcb3$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $711a16afce0bfcb3$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT", () => $711a16afce0bfcb3$export$20b2b274810f728a);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $711a16afce0bfcb3$export$7c14120abebd4749);

var $isE62 = parcelRequire("isE62");
const $711a16afce0bfcb3$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).greyLightest
};
const $711a16afce0bfcb3$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).greyLighter
};
const $711a16afce0bfcb3$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).grey
};
const $711a16afce0bfcb3$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greyDarker
};
const $711a16afce0bfcb3$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greyDarkest
};
const $711a16afce0bfcb3$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purpleLightest
};
const $711a16afce0bfcb3$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purpleLighter
};
const $711a16afce0bfcb3$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purple
};
const $711a16afce0bfcb3$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).purpleDarker
};
const $711a16afce0bfcb3$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).purpleDarkest
};
const $711a16afce0bfcb3$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blueLightest
};
const $711a16afce0bfcb3$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blueLighter
};
const $711a16afce0bfcb3$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blue
};
const $711a16afce0bfcb3$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).blueDarker
};
const $711a16afce0bfcb3$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).blueDarkest
};
const $711a16afce0bfcb3$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).tealLightest
};
const $711a16afce0bfcb3$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).tealLighter
};
const $711a16afce0bfcb3$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).teal
};
const $711a16afce0bfcb3$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).tealDarker
};
const $711a16afce0bfcb3$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).tealDarkest
};
const $711a16afce0bfcb3$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).greenLightest
};
const $711a16afce0bfcb3$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).greenLighter
};
const $711a16afce0bfcb3$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).green
};
const $711a16afce0bfcb3$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greenDarker
};
const $711a16afce0bfcb3$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greenDarkest
};
const $711a16afce0bfcb3$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).limeLightest
};
const $711a16afce0bfcb3$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).limeLighter
};
const $711a16afce0bfcb3$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).lime
};
const $711a16afce0bfcb3$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).limeDarker
};
const $711a16afce0bfcb3$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).limeDarkest
};
const $711a16afce0bfcb3$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellowLightest
};
const $711a16afce0bfcb3$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellowLighter
};
const $711a16afce0bfcb3$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellow
};
const $711a16afce0bfcb3$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).yellowDarker
};
const $711a16afce0bfcb3$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).yellowDarkest
};
const $711a16afce0bfcb3$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orangeLightest
};
const $711a16afce0bfcb3$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orangeLighter
};
const $711a16afce0bfcb3$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orange
};
const $711a16afce0bfcb3$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).orangeDarker
};
const $711a16afce0bfcb3$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).orangeDarkest
};
const $711a16afce0bfcb3$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).redLightest
};
const $711a16afce0bfcb3$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).redLighter
};
const $711a16afce0bfcb3$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).red
};
const $711a16afce0bfcb3$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).redDarker
};
const $711a16afce0bfcb3$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).redDarkest
};
const $711a16afce0bfcb3$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magentaLightest
};
const $711a16afce0bfcb3$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magentaLighter
};
const $711a16afce0bfcb3$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magenta
};
const $711a16afce0bfcb3$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).magentaDarker
};
const $711a16afce0bfcb3$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).magentaDarkest
};
const $711a16afce0bfcb3$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $711a16afce0bfcb3$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $711a16afce0bfcb3$export$7f42563469df7e01 = [
    $711a16afce0bfcb3$var$GREY_LIGHTEST_META,
    $711a16afce0bfcb3$var$PURPLE_LIGHTEST_META,
    $711a16afce0bfcb3$var$BLUE_LIGHTEST_META,
    $711a16afce0bfcb3$var$TEAL_LIGHTEST_META,
    $711a16afce0bfcb3$var$GREEN_LIGHTEST_META,
    $711a16afce0bfcb3$var$LIME_LIGHTEST_META,
    $711a16afce0bfcb3$var$YELLOW_LIGHTEST_META,
    $711a16afce0bfcb3$var$ORANGE_LIGHTEST_META,
    $711a16afce0bfcb3$var$RED_LIGHTEST_META,
    $711a16afce0bfcb3$var$MAGENTA_LIGHTEST_META,
    $711a16afce0bfcb3$var$GREY_LIGHTER_META,
    $711a16afce0bfcb3$var$PURPLE_LIGHTER_META,
    $711a16afce0bfcb3$var$BLUE_LIGHTER_META,
    $711a16afce0bfcb3$var$TEAL_LIGHTER_META,
    $711a16afce0bfcb3$var$GREEN_LIGHTER_META,
    $711a16afce0bfcb3$var$LIME_LIGHTER_META,
    $711a16afce0bfcb3$var$YELLOW_LIGHTER_META,
    $711a16afce0bfcb3$var$ORANGE_LIGHTER_META,
    $711a16afce0bfcb3$var$RED_LIGHTER_META,
    $711a16afce0bfcb3$var$MAGENTA_LIGHTER_META,
    $711a16afce0bfcb3$export$11b75436f568ab00,
    $711a16afce0bfcb3$var$PURPLE_META,
    $711a16afce0bfcb3$var$BLUE_META,
    $711a16afce0bfcb3$var$TEAL_META,
    $711a16afce0bfcb3$var$GREEN_META,
    $711a16afce0bfcb3$var$LIME_META,
    $711a16afce0bfcb3$var$YELLOW_META,
    $711a16afce0bfcb3$var$ORANGE_META,
    $711a16afce0bfcb3$var$RED_META,
    $711a16afce0bfcb3$var$MAGENTA_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$export$7c314e2461a7241b,
    $711a16afce0bfcb3$var$BLUE_DARKER_META,
    $711a16afce0bfcb3$export$6daaa1cc3f46f41,
    $711a16afce0bfcb3$var$GREEN_DARKER_META,
    $711a16afce0bfcb3$var$LIME_DARKER_META,
    $711a16afce0bfcb3$var$YELLOW_DARKER_META,
    $711a16afce0bfcb3$var$ORANGE_DARKER_META,
    $711a16afce0bfcb3$var$RED_DARKER_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKEST_META,
    $711a16afce0bfcb3$var$PURPLE_DARKEST_META,
    $711a16afce0bfcb3$export$69c4eac71b813fba,
    $711a16afce0bfcb3$var$TEAL_DARKEST_META,
    $711a16afce0bfcb3$var$GREEN_DARKEST_META,
    $711a16afce0bfcb3$var$LIME_DARKEST_META,
    $711a16afce0bfcb3$var$YELLOW_DARKEST_META,
    $711a16afce0bfcb3$var$ORANGE_DARKEST_META,
    $711a16afce0bfcb3$var$RED_DARKEST_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKEST_META
];
const $711a16afce0bfcb3$export$2c649adf8351b065 = [
    $711a16afce0bfcb3$var$PURPLE_META,
    $711a16afce0bfcb3$var$YELLOW_META,
    $711a16afce0bfcb3$var$GREEN_META,
    $711a16afce0bfcb3$var$TEAL_META,
    $711a16afce0bfcb3$var$RED_META,
    $711a16afce0bfcb3$var$ORANGE_META,
    $711a16afce0bfcb3$var$MAGENTA_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$export$11b75436f568ab00
];
const $711a16afce0bfcb3$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$711a16afce0bfcb3$export$2c649adf8351b065.forEach((option)=>{
    $711a16afce0bfcb3$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $711a16afce0bfcb3$export$20b2b274810f728a = [
    $711a16afce0bfcb3$export$7c314e2461a7241b,
    $711a16afce0bfcb3$var$YELLOW_DARKER_META,
    $711a16afce0bfcb3$var$GREEN_DARKER_META,
    $711a16afce0bfcb3$export$6daaa1cc3f46f41,
    $711a16afce0bfcb3$var$RED_DARKER_META,
    $711a16afce0bfcb3$var$ORANGE_DARKER_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKEST_META
];
const $711a16afce0bfcb3$export$7c14120abebd4749 = {};
$711a16afce0bfcb3$export$7f42563469df7e01.forEach((option)=>{
    $711a16afce0bfcb3$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("isE62", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddc0b3065e46f63$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2ddc0b3065e46f63$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});


parcelRegister("1mQND", function(module, exports) {

$parcel$export(module.exports, "getHashValueForText", () => $682ff2f1c6e48764$export$e352defce701b36e);

const $682ff2f1c6e48764$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $12800e69511f991d$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $12800e69511f991d$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $12800e69511f991d$export$d15e38bcd75fda7c = 256;
const $12800e69511f991d$export$e143f4b09221a374 = 1000000007;


parcelRegister("eFge8", function(module, exports) {

$parcel$export(module.exports, "getRandomIndex", () => $e4e4b7d26b0de284$export$cb0dffe2d2ae675a);

var $cNNNb = parcelRequire("cNNNb");
const $e4e4b7d26b0de284$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("051tO", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $3b3f14c0d0659bfe$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $3b3f14c0d0659bfe$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $3b3f14c0d0659bfe$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $3b3f14c0d0659bfe$export$49fce7fdcf55f26d);

var $cNNNb = parcelRequire("cNNNb");
const $3b3f14c0d0659bfe$export$e4369cabd7e84cd9 = ({ colorPaletteVariant: colorPaletteVariant = '' } = {})=>{
    // usign colorPaletteVariant to determine which color palette to use for random color selection
    const palette = colorPaletteVariant === 'newDarker' ? (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT) : (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT);
    const randomIndex = Math.floor(Math.random() * palette.length);
    return palette[randomIndex].name;
};
const $3b3f14c0d0659bfe$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $cNNNb.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $3b3f14c0d0659bfe$export$9eff62e8ee2aaa2c = (colorName)=>(0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
const $3b3f14c0d0659bfe$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $cNNNb.GREY_META;
    return (0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $cNNNb.GREY_META);
};
const $3b3f14c0d0659bfe$export$4ef6b7574883e63d = ()=>(0, $cNNNb.OPTION_COLOR_THEMES).map((item)=>item.name);

});

parcelRegister("aIng6", function(module, exports) {

$parcel$export(module.exports, "TagGroupHeaderContent", () => $ca486725032725d5$export$be4c68ded587a8de);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $1tX0c = parcelRequire("1tX0c");
const $ca486725032725d5$export$be4c68ded587a8de = ({ text: text, noValueText: noValueText, ...colorProps })=>{
    return text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tX0c.TagItem), {
        name: text,
        ...colorProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, noValueText);
};

});
parcelRegister("1tX0c", function(module, exports) {

$parcel$export(module.exports, "TagItem", () => $99a66faf131dedf1$export$32a09b7581f7fd80);
$parcel$export(module.exports, "TagItemPopupContentWrapper", () => $99a66faf131dedf1$export$c9925310d93bfb2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $2TCFC = parcelRequire("2TCFC");
var $5DgXR = parcelRequire("5DgXR");
var $lC3pF = parcelRequire("lC3pF");

var $cgxPA = parcelRequire("cgxPA");

var $ewOxf = parcelRequire("ewOxf");

var $epTsa = parcelRequire("epTsa");

var $iyBBa = parcelRequire("iyBBa");

var $ibVOD = parcelRequire("ibVOD");

var $9Mapt = parcelRequire("9Mapt");

var $jd93d = parcelRequire("jd93d");

var $gybMp = parcelRequire("gybMp");
const $99a66faf131dedf1$var$AVATAR_SIZE = 'xsmall';
const $99a66faf131dedf1$var$AVATAR_APPEARANCE = 'square';
const $99a66faf131dedf1$var$tagMarginFixStyles = null;
const $99a66faf131dedf1$var$tagMarginInlineFixStyles = null;
const $99a66faf131dedf1$var$strikethroughStyles = null;
const $99a66faf131dedf1$var$TagItemAvatar = ({ src: src, testId: testId = 'list-with-popup.ui.tag-item.avatar' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: $99a66faf131dedf1$var$AVATAR_APPEARANCE,
        size: $99a66faf131dedf1$var$AVATAR_SIZE,
        src: src,
        borderColor: "transparent",
        testId: testId
    });
const $99a66faf131dedf1$var$TagItemMediaImage = /*#__PURE__*/ (0, $eJOHy.memo)(({ mediaImage: mediaImage, fallbackSrc: fallbackSrc })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cgxPA.MediaImageWithErrorBoundary), {
        identifier: mediaImage.identifier,
        mediaClientConfig: mediaImage.mediaClientConfig,
        apiConfig: {
            ...mediaImage.apiConfig,
            width: (0, $2TCFC.AVATAR_SIZES)[$99a66faf131dedf1$var$AVATAR_SIZE],
            height: (0, $2TCFC.AVATAR_SIZES)[$99a66faf131dedf1$var$AVATAR_SIZE]
        }
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lC3pF.default), {
            appearance: $99a66faf131dedf1$var$AVATAR_APPEARANCE,
            size: $99a66faf131dedf1$var$AVATAR_SIZE
        });
        if (error || !data?.src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemAvatar, {
            src: fallbackSrc,
            testId: "list-with-popup.ui.tag-item.media-image-error"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemAvatar, {
            src: data?.src,
            testId: "list-with-popup.ui.tag-item.media-image-avatar"
        });
    }));
const $99a66faf131dedf1$var$TagItemIcon = ({ icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, icon.mediaImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemMediaImage, {
        mediaImage: icon.mediaImage,
        fallbackSrc: icon.url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemAvatar, {
        src: icon.url
    }));
const $99a66faf131dedf1$export$32a09b7581f7fd80 = ({ name: name, href: href, icon: icon, shouldDisplayStrikethrough: shouldDisplayStrikethrough, isColored: isColored, color: color, isHoverPopoverEnabled: isHoverPopoverEnabled = false, isOnlyOneItem: isOnlyOneItem })=>{
    const tagRef = (0, $eJOHy.useRef)(null);
    if (isHoverPopoverEnabled) {
        const renderTagContent = (ref, props)=>{
            return isColored ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iyBBa.ColoredTag), {
                labelName: name,
                href: href,
                actionSubjectId: "listWithPopup",
                containerXcss: $99a66faf131dedf1$var$extraColoredTagStyles,
                contentXcss: $99a66faf131dedf1$var$extraColoredTagTextStyles,
                analyticsAttributes: {
                    isHoverPopoverEnabled: isHoverPopoverEnabled
                },
                ref: ref,
                ...color && (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
                    color: color
                } : {},
                ...props
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1ule _1ul9ze3t"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
                "data-testid": "list-with-popup.ui.tag-item.tag-item",
                ...props,
                className: (0, $hcewu.default)([
                    "_1e0c1o8l _19pkr5cr _otyrr5cr _p12f1osq _l9z01osq",
                    "_2hwxr5cr _18u0r5cr",
                    shouldDisplayStrikethrough && "_59381r81 _yha21cog _1nmzvv82"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
                elemBefore: icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemIcon, {
                    icon: icon
                }) : undefined,
                text: name,
                href: href,
                linkComponent: (0, $gybMp.default),
                ref: ref
            })));
        };
        const hoverPopoverContent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                contentRef: tagRef,
                content: name
            }, ({ ref: ref })=>renderTagContent((0, $jd93d.mergeRefs)(tagRef, ref), props));
        if (isOnlyOneItem) return hoverPopoverContent();
        // If there are more then one tag, different popovers need to be rendered on the tag and the see more button.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, ({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>hoverPopoverContent({
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            })));
    }
    if (isColored) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iyBBa.ColoredTag), {
        labelName: name,
        href: href,
        actionSubjectId: "listWithPopup",
        containerXcss: $99a66faf131dedf1$var$extraColoredTagStyles,
        contentXcss: $99a66faf131dedf1$var$extraColoredTagTextStyles,
        ...color && (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
            color: color
        } : {}
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": "list-with-popup.ui.tag-item.tag-item",
        className: (0, $hcewu.default)([
            "_1e0c1o8l _19pkr5cr _otyrr5cr _p12f1osq _l9z01osq",
            "_2hwxr5cr _18u0r5cr",
            shouldDisplayStrikethrough && "_59381r81 _yha21cog _1nmzvv82"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
        elemBefore: icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemIcon, {
            icon: icon
        }) : undefined,
        text: name,
        href: href,
        linkComponent: (0, $gybMp.default)
    }));
};
const $99a66faf131dedf1$export$c9925310d93bfb2 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        shouldWrap: true
    }, children);
const $99a66faf131dedf1$var$extraColoredTagTextStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});
const $99a66faf131dedf1$var$extraColoredTagStyles = (0, $1DXK0.xcss)({
    marginInline: 'space.0',
    minWidth: '0px'
});
const $99a66faf131dedf1$var$hoverPopoverStyles = null;

});
parcelRegister("lC3pF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd8f08acdf78d9e1$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fd8f08acdf78d9e1$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $fd8f08acdf78d9e1$var$styles = {
    root: "_2rko1q5u _189e1bk5 _1dqonqa1 _1h6d3acm _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    strongOpacity: "_tzy4clii"
};
const $fd8f08acdf78d9e1$var$sizeStyles = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $fd8f08acdf78d9e1$var$borderRadiusMap = {
    xsmall: "_2rkogqwt",
    small: "_2rkogqwt",
    medium: "_2rkosqtm",
    large: "_2rkosqtm",
    xlarge: "_2rkoi2wt",
    xxlarge: "_2rkob7nn"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $fd8f08acdf78d9e1$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$fd8f08acdf78d9e1$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $hcewu.default)([
            $fd8f08acdf78d9e1$var$styles.root,
            $fd8f08acdf78d9e1$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' && $fd8f08acdf78d9e1$var$borderRadiusMap[size ?? 'medium'],
            weight === 'strong' && $fd8f08acdf78d9e1$var$styles.strongOpacity
        ])
    });
var $fd8f08acdf78d9e1$export$2e2bcd8739ae039 = $fd8f08acdf78d9e1$var$Skeleton;

});

parcelRegister("cgxPA", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $4d10e61645f59e88$export$758a2fef95a29ad0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $iDkaD = parcelRequire("iDkaD");
const $4d10e61645f59e88$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iDkaD.MediaImageWithMediaClient), {
            ...props
        })
    });

});
parcelRegister("iDkaD", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $124670e45144e8f4$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cu5Ae = parcelRequire("cu5Ae");

var $iN7PZ = parcelRequire("iN7PZ");

var $eGOwo = parcelRequire("eGOwo");
const $124670e45144e8f4$var$copyDivStyles = null;
const $124670e45144e8f4$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $iN7PZ.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview?.dataURI
                } : undefined
            }),
            (0, $eGOwo.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $hcewu.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $gt9Am.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $124670e45144e8f4$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $eJOHy.useMemo)(()=>(0, $cu5Ae.withMediaClient)($124670e45144e8f4$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(MediaImageComponent, {
        ...props
    });
};

});
parcelRegister("cu5Ae", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $5bfc4058bddc627f$export$9f7977d4a2561bee);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");
const $5bfc4058bddc627f$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        });

});
parcelRegister("93R6D", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $c470ce77068e97aa$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $c470ce77068e97aa$export$5bff351c86f56d97);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");
const $c470ce77068e97aa$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $c470ce77068e97aa$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($c470ce77068e97aa$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});
parcelRegister("aRuva", function(module, exports) {

$parcel$export(module.exports, "getMediaClient", () => $3430d7925e0b0890$export$c9ecbc1b719fd417);

var $e33YM = parcelRequire("e33YM");
const $3430d7925e0b0890$export$f92e83e86b03c398 = new Map();
const $3430d7925e0b0890$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $e33YM.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $3430d7925e0b0890$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $e33YM.MediaClient)(mediaClientConfig);
        $3430d7925e0b0890$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("e33YM", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $4ee615cd17ba35c7$export$fba8b4ca6d386aec);

var $adK77 = parcelRequire("adK77");
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");

var $jkwTu = parcelRequire("jkwTu");

var $iPHIU = parcelRequire("iPHIU");

var $gWavf = parcelRequire("gWavf");
parcelRequire("48hWz");
var $1ZNSP = parcelRequire("1ZNSP");

class $4ee615cd17ba35c7$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $1ZNSP.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $jkwTu.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $9t1Mu.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $iPHIU.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
        this.stargate = new (0, $gWavf.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("c4FM0"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("adK77", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $igDjg !== 'undefined' && $igDjg.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $igDjg.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("1jG9B", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("bLPxw")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("7mZlN")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("7mZlN")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("9t1Mu")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $bLPxw = parcelRequire("bLPxw");

var $7mZlN = parcelRequire("7mZlN");

var $9t1Mu = parcelRequire("9t1Mu");

});
parcelRegister("bLPxw", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $b0497af2bbf706c4$export$8cef61637918b288);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $b0497af2bbf706c4$export$8cef61637918b288 = {
    streams: new (0, $7xkt0.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $adK77.EventEmitter2)()
};

});

parcelRegister("7mZlN", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $8faf84af4f6865cd$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $8faf84af4f6865cd$export$17f6055767a8d96a);
function $8faf84af4f6865cd$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $8faf84af4f6865cd$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $8faf84af4f6865cd$export$17f6055767a8d96a = (auth)=>{
    if ($8faf84af4f6865cd$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("9t1Mu", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $7f634a1b182817d3$export$d3e73a50cc549c2e);
var $7f634a1b182817d3$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("jkwTu", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $6c83a790055aaff5$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $6c83a790055aaff5$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $6c83a790055aaff5$export$20f9315304dd6726);
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");
var $7mZlN = parcelRequire("7mZlN");

var $6PCIn = parcelRequire("6PCIn");

var $1xw3A = parcelRequire("1xw3A");

var $h3W10 = parcelRequire("h3W10");
var $8RCh7 = parcelRequire("8RCh7");

var $2Cdf9 = parcelRequire("2Cdf9");

var $2dJnj = parcelRequire("2dJnj");

var $hsEvX = parcelRequire("hsEvX");
const $6c83a790055aaff5$var$MEDIA_API_REGION = 'media-api-region';
const $6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $6c83a790055aaff5$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $6PCIn.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $6PCIn.MAX_RESOLUTION),
            height: (0, $6PCIn.MAX_RESOLUTION)
        } : {}
    };
};
const $6c83a790055aaff5$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $6c83a790055aaff5$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $2dJnj.isCDNEnabled)()) result += '/cdn';
    return result;
};
class $6c83a790055aaff5$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $2Cdf9.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $8RCh7.request)(artifactUrl, options, abortController).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name,
                collection: collectionName
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            const metadata = {
                method: 'DELETE',
                endpoint: '/file/{fileId}/artifact/{artifactName}'
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                traceContext: traceContext,
                params: {
                    collection: collectionName
                }
            };
            await this.request(`/file/${id}/artifact/${artifactName}`, options);
        };
        this.resolveAuth = (authContext)=>(0, $hsEvX.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $hsEvX.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $9t1Mu.ChunkHashAlgorithm).Sha256;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $6c83a790055aaff5$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('image');
        return (0, $2dJnj.mapToMediaCdnUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('binary');
        return (0, $2dJnj.mapToMediaCdnUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
			const cdnUrl = artifacts[artifactName]?.cdnUrl;
			if (cdnUrl) {
				return cdnUrl;
			}
		} */ const artifactUrl = (0, $1xw3A.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        return (0, $2Cdf9.createUrl)((0, $2dJnj.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $6c83a790055aaff5$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getDocumentContent(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $6c83a790055aaff5$var$cdnFeatureFlag('contents') : 'contents';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                pageStart: options.pageStart,
                pageEnd: options.pageEnd,
                'max-age': shouldCache ? (0, $6PCIn.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getDocumentPageImage(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $6c83a790055aaff5$var$cdnFeatureFlag('page') : 'page';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                page: options.page,
                zoom: options.zoom,
                'max-age': shouldCache ? (0, $6PCIn.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                id: id
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>(0, $2Cdf9.defaultShouldRetryError)(err) || (0, $h3W10.isRequestError)(err) && err?.metadata?.statusCode === 401
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $7mZlN.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $2Cdf9.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $2dJnj.mapToMediaCdnUrl)(url, auth.token);
        const response = await (0, $8RCh7.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $6c83a790055aaff5$var$setKeyValueInSessionStorage($6c83a790055aaff5$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $6c83a790055aaff5$var$setKeyValueInSessionStorage($6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $8RCh7.request)(url, {
            method: 'HEAD',
            traceContext: (0, $2Cdf9.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $6c83a790055aaff5$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $6c83a790055aaff5$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $6c83a790055aaff5$export$c8b741e18397852a = ()=>{
    return $6c83a790055aaff5$var$getValueFromSessionStorage($6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT);
};
const $6c83a790055aaff5$export$20f9315304dd6726 = ()=>{
    return $6c83a790055aaff5$var$getValueFromSessionStorage($6c83a790055aaff5$var$MEDIA_API_REGION);
};

});
parcelRegister("6PCIn", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $b90d9cdebe03397b$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $b90d9cdebe03397b$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $b90d9cdebe03397b$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $b90d9cdebe03397b$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $b90d9cdebe03397b$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $b90d9cdebe03397b$export$f14f521f3d306044);

var $jmTJ7 = parcelRequire("jmTJ7");
const $b90d9cdebe03397b$export$860a16125e30000b = 'recents';
const $b90d9cdebe03397b$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $b90d9cdebe03397b$export$6e70f30e392bc53f = 4096;
const $b90d9cdebe03397b$export$c1abb8bab1e615cd = 5 * (0, $jmTJ7.DATA_UNIT).MB;
const $b90d9cdebe03397b$export$3d5157f0def70e54 = 1000;
const $b90d9cdebe03397b$export$f14f521f3d306044 = 2 * (0, $jmTJ7.DATA_UNIT).TB;

});
parcelRegister("jmTJ7", function(module, exports) {

$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $29f3d51eb645d15a$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $29f3d51eb645d15a$export$76cfea4c354af843);
const $29f3d51eb645d15a$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $29f3d51eb645d15a$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $29f3d51eb645d15a$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("1xw3A", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $91442ef87cdc4338$export$1cc24defa44e7f84);

var $2dJnj = parcelRequire("2dJnj");
const $91442ef87cdc4338$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $2dJnj.isCDNEnabled)() && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("2dJnj", function(module, exports) {

$parcel$export(module.exports, "isCDNEnabled", () => $bf5b522ee1224e39$export$3e47d0e609e44278);
$parcel$export(module.exports, "mapToMediaCdnUrl", () => $bf5b522ee1224e39$export$fb88a576cf28364d);

var $eGOwo = parcelRequire("eGOwo");

var $3NmFr = parcelRequire("3NmFr");

var $7pw1V = parcelRequire("7pw1V");
const $bf5b522ee1224e39$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $bf5b522ee1224e39$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $bf5b522ee1224e39$export$3e47d0e609e44278() {
    const isIsolatedCloudWithDisabledCDN = (0, $eGOwo.fg)('platform_disable_isolated_cloud_media_cdn_delivery') && (0, $7pw1V.isIsolatedCloud)();
    return (0, $3NmFr.isCommercial)() && !isIsolatedCloudWithDisabledCDN && (0, $eGOwo.fg)('platform_media_cdn_delivery');
}
function $bf5b522ee1224e39$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!$bf5b522ee1224e39$export$3e47d0e609e44278() || tokenLength > $bf5b522ee1224e39$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $eGOwo.fg)('platform_media_cdn_delivery') && (0, $eGOwo.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $bf5b522ee1224e39$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("3NmFr", function(module, exports) {

$parcel$export(module.exports, "isCommercial", () => $130542adabbe691e$export$df69ff6733e73e50);
function $130542adabbe691e$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}

});



parcelRegister("h3W10", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $360d238df22c07b8$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $360d238df22c07b8$export$3717b1ffef4428ea);

var $4rKJa = parcelRequire("4rKJa");
class $360d238df22c07b8$export$43ee7d0e4f429743 extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $360d238df22c07b8$export$3717b1ffef4428ea(err) {
    return err instanceof $360d238df22c07b8$export$43ee7d0e4f429743;
}

});
parcelRegister("4rKJa", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $e9c543355e5204ca$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $e9c543355e5204ca$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $e9c543355e5204ca$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $e9c543355e5204ca$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $e9c543355e5204ca$export$c2b89b9a32286816);

var $eBofv = parcelRequire("eBofv");
class $e9c543355e5204ca$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $e9c543355e5204ca$export$e574d1724215079f extends $e9c543355e5204ca$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $e9c543355e5204ca$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $e9c543355e5204ca$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $e9c543355e5204ca$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new $e9c543355e5204ca$export$e574d1724215079f(error?.reason || 'unknown-reason', error.metadata, error.innerError);
};
const $e9c543355e5204ca$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error?.reason,
                metadata: error?.metadata,
                innerError: error?.innerError
            },
            // Legacy details
            ...error?.attributes
        },
        message: error?.message
    };
};

});
parcelRegister("eBofv", function(module, exports) {

$parcel$export(module.exports, "getMediaClientErrorReason", () => $508e04f54b9269ab$export$c15d72765ee2baa4);
function $508e04f54b9269ab$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $508e04f54b9269ab$export$c15d72765ee2baa4(err) {
    return $508e04f54b9269ab$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("8RCh7", function(module, exports) {

$parcel$export(module.exports, "request", () => $16d1dca60bf2e497$export$b5fe3f66a567bec0);

var $h3W10 = parcelRequire("h3W10");

var $2Cdf9 = parcelRequire("2Cdf9");
async function $16d1dca60bf2e497$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $2Cdf9.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $2Cdf9.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $2Cdf9.createProcessFetchResponse)(metadata));
    return (0, $2Cdf9.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("2Cdf9", function(module, exports) {

$parcel$export(module.exports, "extendTraceContext", () => $8e2ee04a8e27c7ba$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $8e2ee04a8e27c7ba$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $8e2ee04a8e27c7ba$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $8e2ee04a8e27c7ba$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $8e2ee04a8e27c7ba$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $8e2ee04a8e27c7ba$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $8e2ee04a8e27c7ba$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $8e2ee04a8e27c7ba$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $8e2ee04a8e27c7ba$export$6e2e477edb7d6032);
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");

var $3xaEP = parcelRequire("3xaEP");

var $9WNJB = parcelRequire("9WNJB");

var $h3W10 = parcelRequire("h3W10");
const $8e2ee04a8e27c7ba$var$getStatusCode = (error)=>(0, $h3W10.isRequestError)(error) && error.metadata?.statusCode && error.metadata.statusCode;
function $8e2ee04a8e27c7ba$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $8e2ee04a8e27c7ba$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $8e2ee04a8e27c7ba$export$bc96a6a479480590(error) {
    const statusCode = error && $8e2ee04a8e27c7ba$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $8e2ee04a8e27c7ba$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: traceContext?.spanId || (0, $3xaEP.getRandomTelemetryId)()
    } : undefined;
const $8e2ee04a8e27c7ba$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $8e2ee04a8e27c7ba$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$8e2ee04a8e27c7ba$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$8e2ee04a8e27c7ba$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $8e2ee04a8e27c7ba$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $7mZlN.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $8e2ee04a8e27c7ba$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $9WNJB.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $8e2ee04a8e27c7ba$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$8e2ee04a8e27c7ba$export$eaf4479116d2f925(auth),
        ...$8e2ee04a8e27c7ba$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $8e2ee04a8e27c7ba$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $h3W10.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $8e2ee04a8e27c7ba$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $h3W10.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $8e2ee04a8e27c7ba$export$fee2242cbb339663 = (err)=>{
    const statusCode = $8e2ee04a8e27c7ba$var$getStatusCode(err);
    return $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $8e2ee04a8e27c7ba$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $8e2ee04a8e27c7ba$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $h3W10.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $8e2ee04a8e27c7ba$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$8e2ee04a8e27c7ba$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $8e2ee04a8e27c7ba$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $8e2ee04a8e27c7ba$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($8e2ee04a8e27c7ba$export$de0b576cf7ce4a53(err)) throw new (0, $h3W10.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $h3W10.isRequestError)(lastError)) throw $8e2ee04a8e27c7ba$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $h3W10.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $8e2ee04a8e27c7ba$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $8e2ee04a8e27c7ba$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $8e2ee04a8e27c7ba$export$6397609af718d008(statusCode);
    return new (0, $h3W10.RequestError)(reason, {
        ...metadata,
        ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $8e2ee04a8e27c7ba$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $8e2ee04a8e27c7ba$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $8e2ee04a8e27c7ba$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("3xaEP", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $af4102ec3e3c11b2$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $af4102ec3e3c11b2$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $af4102ec3e3c11b2$export$456b25e3a9b4a843);
$parcel$export(module.exports, "getRandomTelemetryId", () => $af4102ec3e3c11b2$export$2e36de8639bad0ad);
const $af4102ec3e3c11b2$export$fce6876652108ab = (value)=>value === undefined;
const $af4102ec3e3c11b2$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $af4102ec3e3c11b2$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $af4102ec3e3c11b2$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $af4102ec3e3c11b2$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $af4102ec3e3c11b2$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $af4102ec3e3c11b2$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $af4102ec3e3c11b2$var$getRandomHexValues(byte);
    }
    else randomHex = $af4102ec3e3c11b2$var$getRandomHexValues(byte);
    return randomHex;
}
function $af4102ec3e3c11b2$export$2e36de8639bad0ad() {
    return $af4102ec3e3c11b2$export$456b25e3a9b4a843(8);
}

});

parcelRegister("9WNJB", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $47d6feb819b26718$export$6833b130611df767);
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");
function $47d6feb819b26718$export$6833b130611df767(auth) {
    if ((0, $7mZlN.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("hsEvX", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $6d143f49360dbe76$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $6d143f49360dbe76$export$5211e1371264aec3);

var $3Y4Hn = parcelRequire("3Y4Hn");

var $3nErQ = parcelRequire("3nErQ");
const $6d143f49360dbe76$export$560085fe411c0660 = 10000;
const $6d143f49360dbe76$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $6d143f49360dbe76$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $3nErQ.rejectTimeout)(authProviderTimeout, new (0, $3Y4Hn.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $3Y4Hn.MediaStoreError)) throw err;
        throw new (0, $3Y4Hn.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $3Y4Hn.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $6d143f49360dbe76$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $3Y4Hn.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("3Y4Hn", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $d19f60583c5ce4e8$export$b78480bd311630bc);

var $4rKJa = parcelRequire("4rKJa");
class $d19f60583c5ce4e8$export$b78480bd311630bc extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $d19f60583c5ce4e8$export$8d2a9b675b2ce37a(err) {
    return err instanceof $d19f60583c5ce4e8$export$b78480bd311630bc;
}

});

parcelRegister("3nErQ", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $bdd7813d02cb717f$export$cf2d2a1124beacb2);
const $bdd7813d02cb717f$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $bdd7813d02cb717f$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("iPHIU", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $09c82e56436a3d4e$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("1GWfm")).FileFetcherError);

var $2PBDa = parcelRequire("2PBDa");

var $3PmNk = parcelRequire("3PmNk");

var $8KLBw = parcelRequire("8KLBw");
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");

var $g1OQu = parcelRequire("g1OQu");

var $jkwTu = parcelRequire("jkwTu");

var $bbNl0 = parcelRequire("bbNl0");

var $jmTJ7 = parcelRequire("jmTJ7");

var $1GWfm = parcelRequire("1GWfm");

var $2mMyO = parcelRequire("2mMyO");

var $abkQS = parcelRequire("abkQS");

var $lRBVi = parcelRequire("lRBVi");

var $6PCIn = parcelRequire("6PCIn");

var $eaj78 = parcelRequire("eaj78");

var $hRxrn = parcelRequire("hRxrn");

var $atDjN = parcelRequire("atDjN");

var $053B3 = parcelRequire("053B3");

var $iDYg8 = parcelRequire("iDYg8");

var $jFXx8 = parcelRequire("jFXx8");
var $kFG4u = parcelRequire("kFG4u");

var $ea8A0 = parcelRequire("ea8A0");

var $jkEmk = parcelRequire("jkEmk");

var $5JVfG = parcelRequire("5JVfG");

var $8UZz3 = parcelRequire("8UZz3");

var $393Zn = parcelRequire("393Zn");

var $iX2Cl = parcelRequire("iX2Cl");
parcelRequire("48hWz");
var $1ZNSP = parcelRequire("1ZNSP");

var $bksvR = parcelRequire("bksvR");

var $2Cdf9 = parcelRequire("2Cdf9");

var $4rKJa = parcelRequire("4rKJa");
const $09c82e56436a3d4e$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $09c82e56436a3d4e$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $09c82e56436a3d4e$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $1ZNSP.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $4rKJa.isCommonMediaClientError)(error)) return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $4rKJa.CommonMediaClientError)(error);
                return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $4rKJa.CommonMediaClientError)(error?.reason || 'unknown', error?.metadata, error?.innerError);
                return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh)=>{
            const subject = (0, $jkEmk.createMediaSubject)();
            const poll = new (0, $393Zn.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $jmTJ7.isNotFoundMediaItemDetails)(response)) throw new (0, $1GWfm.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $iX2Cl.isEmptyFile)(response)) throw new (0, $1GWfm.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $bbNl0.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $iDYg8.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $atDjN.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $bbNl0.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            await this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
            // Manually remove the artifact from file state instead of re-requesting the entire payload.
            const file = this.store.getState().files[id];
            if (file && file.status === 'processed' && file.artifacts) {
                const updatedArtifacts = {
                    ...file.artifacts
                };
                delete updatedArtifacts[artifactName];
                const updatedFileState = {
                    ...file,
                    artifacts: updatedArtifacts
                };
                this.setFileState(id, updatedFileState);
            }
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4');
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch (_err) {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $hRxrn.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $bksvR.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(id)) {
            const subject = (0, $jkEmk.createMediaSubject)();
            const err = new (0, $1GWfm.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $jFXx8.fromObservable)(subject);
        }
        if (forceRefresh) (0, $abkQS.getFileStreamsCache)().remove(id);
        return (0, $jFXx8.fromObservable)((0, $abkQS.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $kFG4u.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $jkEmk.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $abkQS.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $ea8A0.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $jkEmk.createMediaSubject)();
        (0, $abkQS.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $2PBDa.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $3PmNk.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $053B3.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $2mMyO.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $jFXx8.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName, traceContext) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $g1OQu.downloadUrl)(url, {
            name: name
        });
        (0, $lRBVi.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $6PCIn.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $2Cdf9.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $jkwTu.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $7mZlN.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $abkQS.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($09c82e56436a3d4e$var$isCopySourceFileWithToken(source) && $09c82e56436a3d4e$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $5JVfG.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $bbNl0.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $jkEmk.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $bbNl0.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $bbNl0.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $8UZz3.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $053B3.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $053B3.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $bbNl0.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $bbNl0.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $bbNl0.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $abkQS.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $jkEmk.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("g1OQu", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $c1f893c1652c9963$export$8a96edb1c96563f4);
const $c1f893c1652c9963$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("bbNl0", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $071e98cd60064284$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $071e98cd60064284$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $071e98cd60064284$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $071e98cd60064284$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $071e98cd60064284$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $071e98cd60064284$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $071e98cd60064284$export$8f33148a37b0c72f);
$parcel$export(module.exports, "hasArtifacts", () => $071e98cd60064284$export$ecdf3dee1d148302);
$parcel$export(module.exports, "isImageRepresentationReady", () => $071e98cd60064284$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $071e98cd60064284$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $071e98cd60064284$export$ea3730792e8bebfb);
const $071e98cd60064284$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $071e98cd60064284$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $071e98cd60064284$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $071e98cd60064284$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $071e98cd60064284$export$92dd692b31e42e64 = (fileState)=>!$071e98cd60064284$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $071e98cd60064284$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $071e98cd60064284$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $071e98cd60064284$export$ecdf3dee1d148302 = (fileState)=>'artifacts' in fileState && fileState.artifacts !== undefined;
const $071e98cd60064284$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $071e98cd60064284$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification, mediaMetadata: mediaMetadata } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $071e98cd60064284$export$ea3730792e8bebfb = (id, item)=>{
    return $071e98cd60064284$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("1GWfm", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $a248c46a7558c626$export$e3e60f0dab8641de);

var $4rKJa = parcelRequire("4rKJa");
class $a248c46a7558c626$export$e3e60f0dab8641de extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}
function $a248c46a7558c626$export$5c3435f75ce0ce70(err) {
    return err instanceof $a248c46a7558c626$export$e3e60f0dab8641de;
}

});

parcelRegister("2mMyO", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $d0f3b9835713140d$export$a5575dbeeffdad98);

var $irjb3 = parcelRequire("irjb3");

var $2opa2 = parcelRequire("2opa2");

var $4pIMA = parcelRequire("4pIMA");

var $keN2a = parcelRequire("keN2a");

var $bpbRw = parcelRequire("bpbRw");

var $6PCIn = parcelRequire("6PCIn");

var $jZL78 = parcelRequire("jZL78");
const $d0f3b9835713140d$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $keN2a.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $d0f3b9835713140d$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $d0f3b9835713140d$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $d0f3b9835713140d$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $d0f3b9835713140d$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $d0f3b9835713140d$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $6PCIn.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $jZL78.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $jZL78.fileSizeError)) callbacks?.onUploadFinish(new (0, $bpbRw.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $irjb3.chunkinator)(content, {
        hashingFunction: (blob)=>$d0f3b9835713140d$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $d0f3b9835713140d$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $6PCIn.PROCESSING_BATCH_SIZE),
        processingFunction: $d0f3b9835713140d$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $2opa2.from)(deferredUploadId).pipe((0, $4pIMA.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $4pIMA.concatMap)(()=>(0, $2opa2.from)($d0f3b9835713140d$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $d0f3b9835713140d$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("irjb3", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $d61183fbf8357e07$export$9ab6bef3838698f8);

var $jgII5 = parcelRequire("jgII5");

var $4pIMA = parcelRequire("4pIMA");

var $aoje7 = parcelRequire("aoje7");

var $9cPse = parcelRequire("9cPse");

var $fjIB7 = parcelRequire("fjIB7");

var $iyZWI = parcelRequire("iyZWI");

var $htAnC = parcelRequire("htAnC");

var $h9RjH = parcelRequire("h9RjH");

var $aN4rI = parcelRequire("aN4rI");

var $2opa2 = parcelRequire("2opa2");
const $d61183fbf8357e07$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $9cPse.fromPromise)((0, $aN4rI.fetchBlob)(file)).pipe((0, $4pIMA.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $fjIB7.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $iyZWI.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $htAnC.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $jgII5.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $h9RjH.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $4pIMA.concatMap)((batchedChunks)=>{
            return (0, $2opa2.from)(batchedChunks);
        }), (0, $aoje7.bufferCount)(totalChunks));
    }));
const $d61183fbf8357e07$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $d61183fbf8357e07$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("fjIB7", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $0dec34349839a009$export$5b92d769f2f57509);

var $4NFCE = parcelRequire("4NFCE");

var $3PmNk = parcelRequire("3PmNk");
const $0dec34349839a009$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $4NFCE.range)(0, totalChunks).pipe((0, $3PmNk.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("iyZWI", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $946c6df5bbe7edda$export$d5f5a550a38ec367);

var $aN4rI = parcelRequire("aN4rI");
const $946c6df5bbe7edda$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $946c6df5bbe7edda$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $aN4rI.asyncMap)($946c6df5bbe7edda$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("aN4rI", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $6bb2bbe9f31d7b02$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $6bb2bbe9f31d7b02$export$707ee4c4c95d39e3);

var $7kixv = parcelRequire("7kixv");

var $eynBz = parcelRequire("eynBz");
async function $6bb2bbe9f31d7b02$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $6bb2bbe9f31d7b02$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $6bb2bbe9f31d7b02$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $7kixv.Observable)((sub)=>{
            notifiers.push($6bb2bbe9f31d7b02$var$notify(project(value), sub, onReady));
        });
};
const $6bb2bbe9f31d7b02$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $eynBz.mergeMap)($6bb2bbe9f31d7b02$var$mapper(project), concurrent);

});


parcelRegister("htAnC", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $376f95738497d04c$export$94ce0f3fcf999415);

var $aN4rI = parcelRequire("aN4rI");
const $376f95738497d04c$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $aN4rI.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("h9RjH", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $cfa6e3d7bb356500$export$2f21790600302ed);

var $aoje7 = parcelRequire("aoje7");

var $4pIMA = parcelRequire("4pIMA");
const $cfa6e3d7bb356500$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $aoje7.bufferCount)(options.batchSize)).pipe((0, $4pIMA.concatMap)(process));
};

});


parcelRegister("keN2a", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $a41e44f7241fbce8$export$14b114effbc08b6b);
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");
let $a41e44f7241fbce8$var$hasher = null;
let $a41e44f7241fbce8$var$sha256Hasher = null;
const $a41e44f7241fbce8$export$d9c9d11cd648a505 = ()=>{
    $a41e44f7241fbce8$var$hasher = null;
    $a41e44f7241fbce8$var$sha256Hasher = null;
};


const $a41e44f7241fbce8$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $9t1Mu.ChunkHashAlgorithm).Sha256) {
            if (!$a41e44f7241fbce8$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("aOfga"));
                $a41e44f7241fbce8$var$sha256Hasher = new SimpleHasher();
            }
            return $a41e44f7241fbce8$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("63Grn"));
    $a41e44f7241fbce8$var$hasher = new SimpleHasher();
    return $a41e44f7241fbce8$var$hasher;
};

});
parcelRegister("aOfga", function(module, exports) {

let $7dea6927bc881dd1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7dea6927bc881dd1$var$load("kxQbf").then(()=>parcelRequire('g8wZ9'));

});

parcelRegister("63Grn", function(module, exports) {

let $4693f1ae0207df80$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4693f1ae0207df80$var$load("76n7a"),
    $4693f1ae0207df80$var$load("l253H"),
    $4693f1ae0207df80$var$load("6rET6")
]).then(()=>parcelRequire('cPCGi'));

});


parcelRegister("bpbRw", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $85ab3781ae20a637$export$515240c3f059c807);

var $4rKJa = parcelRequire("4rKJa");
class $85ab3781ae20a637$export$515240c3f059c807 extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $85ab3781ae20a637$export$80ee180172bc336(err) {
    return err instanceof $85ab3781ae20a637$export$515240c3f059c807;
}

});

parcelRegister("jZL78", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $b71a6cbe9ec1a24a$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $b71a6cbe9ec1a24a$export$71f452e02035c1e2);

var $jmTJ7 = parcelRequire("jmTJ7");

var $6PCIn = parcelRequire("6PCIn");
const $b71a6cbe9ec1a24a$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $b71a6cbe9ec1a24a$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $6PCIn.MAX_UPLOAD_FILE_SIZE)) throw new Error($b71a6cbe9ec1a24a$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $jmTJ7.DATA_UNIT).GB) return 5 * (0, $jmTJ7.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $jmTJ7.DATA_UNIT).GB && fileSize <= 50 * (0, $jmTJ7.DATA_UNIT).GB) return 50 * (0, $jmTJ7.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $jmTJ7.DATA_UNIT).GB && fileSize <= 0.95 * (0, $jmTJ7.DATA_UNIT).TB) return 100 * (0, $jmTJ7.DATA_UNIT).MB;
    return 210 * (0, $jmTJ7.DATA_UNIT).MB;
};

});


parcelRegister("abkQS", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $20fb1b7a81082f5e$export$f2f061938c1e6810);
class $20fb1b7a81082f5e$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $20fb1b7a81082f5e$var$streamCache;

const $20fb1b7a81082f5e$export$f2f061938c1e6810 = ()=>{
    if (!$20fb1b7a81082f5e$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("bLPxw")).mediaState;
        $20fb1b7a81082f5e$var$streamCache = new $20fb1b7a81082f5e$export$4293896e79732236(mediaState.streams);
    }
    return $20fb1b7a81082f5e$var$streamCache;
};

});

parcelRegister("lRBVi", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $175af825576b091d$export$68d003d3105952ad);
parcelRequire("1jG9B");
var $bLPxw = parcelRequire("bLPxw");
const $175af825576b091d$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $bLPxw.mediaState).eventEmitter) (0, $bLPxw.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $bLPxw.mediaState).eventEmitter) (0, $bLPxw.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $bLPxw.mediaState).eventEmitter) return (0, $bLPxw.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("eaj78", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $5Ovjr = parcelRequire("5Ovjr");
var $a500d3812b6eabd3$require$Buffer = $5Ovjr.Buffer;
var $a500d3812b6eabd3$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $a500d3812b6eabd3$var$_byteToHex = [];
for(var $a500d3812b6eabd3$var$i = 0; $a500d3812b6eabd3$var$i < 256; $a500d3812b6eabd3$var$i++)$a500d3812b6eabd3$var$_byteToHex[$a500d3812b6eabd3$var$i] = ($a500d3812b6eabd3$var$i + 0x100).toString(16).substr(1);
function $a500d3812b6eabd3$var$unparse(buf, offset) {
    var i = offset || 0, bth = $a500d3812b6eabd3$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($a500d3812b6eabd3$require$Buffer.isBuffer(uuid)) parsedUuid = $a500d3812b6eabd3$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$a500d3812b6eabd3$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $a500d3812b6eabd3$var$extractVersion(parsedUuid);
    else if ($a500d3812b6eabd3$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $a500d3812b6eabd3$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("hRxrn", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $611f84914cb6f1a5$export$ae188fee39529b82);

var $79KwK = parcelRequire("79KwK");

var $3xaEP = parcelRequire("3xaEP");
const $611f84914cb6f1a5$export$b79d95ee17a87a = 100;
const $611f84914cb6f1a5$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $611f84914cb6f1a5$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $611f84914cb6f1a5$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $611f84914cb6f1a5$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $611f84914cb6f1a5$var$makeCacheKey(id, collection);
        if ($611f84914cb6f1a5$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($611f84914cb6f1a5$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $611f84914cb6f1a5$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $611f84914cb6f1a5$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $3xaEP.getRandomTelemetryId)(),
                spanId: (0, $3xaEP.getRandomTelemetryId)()
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $611f84914cb6f1a5$export$71cd2e8f8162d47b(keys, items);
    };
}
function $611f84914cb6f1a5$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))($611f84914cb6f1a5$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $611f84914cb6f1a5$export$b79d95ee17a87a
    });
}

});

parcelRegister("atDjN", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $4c3ee7170cb316c1$export$ac3214931ffd82af);

var $5JVfG = parcelRequire("5JVfG");
const $4c3ee7170cb316c1$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $5JVfG.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("5JVfG", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $2a0d3eeca821ff8d$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("fK3MF")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("fK3MF")).isVideoMimeTypeSupportedByBrowser);

var $5hd6w = parcelRequire("5hd6w");

var $fK3MF = parcelRequire("fK3MF");

var $i9yw1 = parcelRequire("i9yw1");
const $2a0d3eeca821ff8d$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $5hd6w.isArchive)(mimeType)) return 'archive';
    if ((0, $fK3MF.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $fK3MF.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $fK3MF.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $fK3MF.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("5hd6w", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $d95d3f124d05d5e2$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $d95d3f124d05d5e2$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("fK3MF", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $14d0a1fe72c887af$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $14d0a1fe72c887af$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$55ca6cdaf6093034 = (mimeType)=>$14d0a1fe72c887af$export$74325e3c843a9555(mimeType) || $14d0a1fe72c887af$export$c021f2623a75015f(mimeType) || $14d0a1fe72c887af$export$ff36075ea755a717(mimeType) || $14d0a1fe72c887af$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("i9yw1", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $b92ae6a0fa1244e6$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$548d9148a80556a3 = (mimeType)=>$b92ae6a0fa1244e6$export$e9a065a80f76311e(mimeType) || $b92ae6a0fa1244e6$export$86baad7a89d908e9(mimeType) || $b92ae6a0fa1244e6$export$8cba23825d020bbb(mimeType) || $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3(mimeType) || $b92ae6a0fa1244e6$export$94e1479e01d2af53(mimeType);

});



parcelRegister("053B3", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $492d4a64b2b2425c$export$89097c0ec1e0dee1);

var $bbNl0 = parcelRequire("bbNl0");
const $492d4a64b2b2425c$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $bbNl0.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("iDYg8", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $87b4c423efa40e5c$export$ed17558b11b88056);
const $87b4c423efa40e5c$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("jFXx8", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $a6ac257ab8a71611$export$4b2432e2d8723823);

var $jkEmk = parcelRequire("jkEmk");
function $a6ac257ab8a71611$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $a6ac257ab8a71611$export$8659d1f07d151381(item) {
    return $a6ac257ab8a71611$export$4b2432e2d8723823((0, $jkEmk.createMediaSubject)(item));
}

});
parcelRegister("jkEmk", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $5f3a872941d2eff3$export$bc76d51553fa5e35);

var $86Sof = parcelRequire("86Sof");
function $5f3a872941d2eff3$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $86Sof.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("kFG4u", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $74eb9133065f0126$export$4dbaaf6c79705e6c);

var $2PBDa = parcelRequire("2PBDa");
const $74eb9133065f0126$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $2PBDa.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("ea8A0", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $2f9cb480159d13ae$export$71797c284d89a3e1);

var $hthqT = parcelRequire("hthqT");

var $gOskN = parcelRequire("gOskN");
const $2f9cb480159d13ae$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $hthqT.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $gOskN.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("hthqT", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $d7d48590d371ba3a$export$a1c3205f28a20414);
const $d7d48590d371ba3a$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("gOskN", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $4a8128b4320ca47f$export$62aabd5ff85d0451);
const $4a8128b4320ca47f$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("8UZz3", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $d7014b773fe3cff6$export$2ccdd6f9a9eba6a);

var $fK3MF = parcelRequire("fK3MF");
var $i9yw1 = parcelRequire("i9yw1");

var $gOskN = parcelRequire("gOskN");
async function $d7014b773fe3cff6$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $i9yw1.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $gOskN.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("393Zn", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $10b695ec33f62c2d$export$4c54d536f8e37dc2);

var $8iexj = parcelRequire("8iexj");
const $10b695ec33f62c2d$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $10b695ec33f62c2d$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$10b695ec33f62c2d$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $8iexj.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $8iexj.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("8iexj", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $76319a6a54892893$export$c3748c310e92340a);

var $4rKJa = parcelRequire("4rKJa");
class $76319a6a54892893$export$c3748c310e92340a extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $76319a6a54892893$export$541e3e52eea6fece(err) {
    return err instanceof $76319a6a54892893$export$c3748c310e92340a;
}

});


parcelRegister("iX2Cl", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $0723e6aaf9777481$export$728192ce8dd94659);
const $0723e6aaf9777481$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $0723e6aaf9777481$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $0723e6aaf9777481$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("48hWz", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("1ZNSP")).mediaStore);

var $1ZNSP = parcelRequire("1ZNSP");

});
parcelRegister("1ZNSP", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $8cb4e2ad5e722a42$export$5785580dea19518d);

var $7LOiC = parcelRequire("7LOiC");

var $1pZVO = parcelRequire("1pZVO");

var $96y8R = parcelRequire("96y8R");
const $8cb4e2ad5e722a42$var$mediaStoreWithoutDevtools = (0, $96y8R.createStore)()((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
        files: {}
    }))));
const $8cb4e2ad5e722a42$var$mediaStoreWithDevtools = (0, $96y8R.createStore)()((0, $7LOiC.devtools)((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
        files: {}
    })))));
const $8cb4e2ad5e722a42$export$5785580dea19518d = $8cb4e2ad5e722a42$var$mediaStoreWithoutDevtools;
const $8cb4e2ad5e722a42$export$503459913a0dc356 = (initialStore)=>{
    return (0, $96y8R.createStore)()((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("7LOiC", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $5a83f092dca5fc3e$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $5a83f092dca5fc3e$export$5c593627aef9f076);
var $5a83f092dca5fc3e$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $5a83f092dca5fc3e$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $5a83f092dca5fc3e$export$4feba8a1bc8e9afd = $5a83f092dca5fc3e$var$reduxImpl;
const $5a83f092dca5fc3e$var$trackedConnections = /* @__PURE__ */ new Map();
const $5a83f092dca5fc3e$var$getTrackedConnectionState = (name)=>{
    const api = $5a83f092dca5fc3e$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $5a83f092dca5fc3e$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $5a83f092dca5fc3e$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $5a83f092dca5fc3e$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $5a83f092dca5fc3e$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) {
            if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $5a83f092dca5fc3e$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$5a83f092dca5fc3e$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $5a83f092dca5fc3e$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $5a83f092dca5fc3e$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $5a83f092dca5fc3e$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $5a83f092dca5fc3e$export$6922d3b3a607469e = $5a83f092dca5fc3e$var$devtoolsImpl;
const $5a83f092dca5fc3e$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $5a83f092dca5fc3e$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $5a83f092dca5fc3e$export$5c593627aef9f076 = $5a83f092dca5fc3e$var$subscribeWithSelectorImpl;
const $5a83f092dca5fc3e$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $5a83f092dca5fc3e$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $5a83f092dca5fc3e$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $5a83f092dca5fc3e$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $5a83f092dca5fc3e$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $5a83f092dca5fc3e$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $5a83f092dca5fc3e$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $5a83f092dca5fc3e$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $5a83f092dca5fc3e$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $5a83f092dca5fc3e$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $5a83f092dca5fc3e$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $5a83f092dca5fc3e$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $5a83f092dca5fc3e$var$oldImpl(config, baseOptions);
    }
    return $5a83f092dca5fc3e$var$newImpl(config, baseOptions);
};
const $5a83f092dca5fc3e$export$9a6132153fba2e0 = $5a83f092dca5fc3e$var$persistImpl;

});

parcelRegister("1pZVO", function(module, exports) {

$parcel$export(module.exports, "immer", () => $10882a850d9663b5$export$428de7ec69ac95c);

var $K2rwM = parcelRequire("K2rwM");
const $10882a850d9663b5$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $K2rwM.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $10882a850d9663b5$export$428de7ec69ac95c = $10882a850d9663b5$var$immerImpl;

});
parcelRegister("K2rwM", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $08a6311ec7f77a2c$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $08a6311ec7f77a2c$export$2e2bcd8739ae039 = fn;

});


parcelRegister("96y8R", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $6a0f287ca3f709ed$export$f51a9068ac82ea43);
var $6a0f287ca3f709ed$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $6a0f287ca3f709ed$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($6a0f287ca3f709ed$import_meta.env ? $6a0f287ca3f709ed$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $6a0f287ca3f709ed$export$f51a9068ac82ea43 = (createState)=>createState ? $6a0f287ca3f709ed$var$createStoreImpl(createState) : $6a0f287ca3f709ed$var$createStoreImpl;
var $6a0f287ca3f709ed$export$2e2bcd8739ae039 = (createState)=>{
    if (($6a0f287ca3f709ed$import_meta.env ? $6a0f287ca3f709ed$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $6a0f287ca3f709ed$export$f51a9068ac82ea43(createState);
};

});



parcelRegister("bksvR", function(module, exports) {

$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $6bed172d1e1e47c4$export$57945b6819e39246);

var $79KwK = parcelRequire("79KwK");

var $3xaEP = parcelRequire("3xaEP");
const $6bed172d1e1e47c4$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $6bed172d1e1e47c4$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $3xaEP.getRandomTelemetryId)(),
                spanId: (0, $3xaEP.getRandomTelemetryId)()
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            return items.find((item)=>item.id === id && item.collection === collectionName)?.error;
        });
    };
}
function $6bed172d1e1e47c4$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))($6bed172d1e1e47c4$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $6bed172d1e1e47c4$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});


parcelRegister("gWavf", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $60a1ef1a71feccaf$export$c66ca190f89caaac);
class $60a1ef1a71feccaf$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("c4FM0", function(module, exports) {

let $8ca6431068cfdd61$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8ca6431068cfdd61$var$load("lPk9Z").then(()=>parcelRequire('h77Xn'));

});





parcelRegister("iN7PZ", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $e54d3f9e11f733f6$export$4eaebdef02112fe4);

var $eJOHy = parcelRequire("eJOHy");

var $bbNl0 = parcelRequire("bbNl0");
var $4rKJa = parcelRequire("4rKJa");

var $kCvcX = parcelRequire("kCvcX");
var $djK7X = parcelRequire("djK7X");
var $3cc2J = parcelRequire("3cc2J");

var $fK3MF = parcelRequire("fK3MF");

var $eGOwo = parcelRequire("eGOwo");

var $7aoMz = parcelRequire("7aoMz");

var $e2t9t = parcelRequire("e2t9t");

var $33YQ1 = parcelRequire("33YQ1");

var $k9eRE = parcelRequire("k9eRE");
var $hNvWT = parcelRequire("hNvWT");
var $9Mg12 = parcelRequire("9Mg12");

var $i0gVY = parcelRequire("i0gVY");
var $8Dv9L = parcelRequire("8Dv9L");

var $3c1p9 = parcelRequire("3c1p9");
const $e54d3f9e11f733f6$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const [status, setStatus] = (0, $eJOHy.useState)('loading');
    const [error, setError] = (0, $eJOHy.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eJOHy.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eJOHy.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eJOHy.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eJOHy.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $7aoMz.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isLoading && (0, $eGOwo.fg)('platform_close_image_blindspot_2')) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $eJOHy.useMemo)(()=>dimensions ? (0, $3c1p9.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $3c1p9.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $8Dv9L.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $k9eRE.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $e2t9t.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eJOHy.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $djK7X.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $bbNl0.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eJOHy.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('metadata-fetch', (0, $4rKJa.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $3c1p9.useCurrentValueRef)(()=>{
        return (0, $k9eRE.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eJOHy.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $3c1p9.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $3c1p9.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $eJOHy.useEffect)(()=>{
        const cachedPreview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $3c1p9.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $hNvWT.isSupportedLocalPreview)(mediaType) && (0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $k9eRE.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $3c1p9.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $k9eRE.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $33YQ1.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eJOHy.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $k9eRE.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $k9eRE.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $k9eRE.isLocalPreview)(failedPreview);
        const isRemote = (0, $k9eRE.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $33YQ1.ImageLoadError)(failedPreview?.source);
            (0, $9Mg12.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eJOHy.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $k9eRE.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $k9eRE.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $i0gVY.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $kCvcX.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("kCvcX", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $556b9eb703c9e12d$export$46fd859414de9d62);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $3cc2J = parcelRequire("3cc2J");

var $bMoFA = parcelRequire("bMoFA");

var $b7hyt = parcelRequire("b7hyt");
function $556b9eb703c9e12d$var$useCurrentValueRef(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}
const $556b9eb703c9e12d$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const innerRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const registerCopyIntentRef = $556b9eb703c9e12d$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $bMoFA.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $bMoFA.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $eJOHy.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $eJOHy.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) (0, $b7hyt.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $b7hyt.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("3cc2J", function(module, exports) {

$parcel$export(module.exports, "useMediaClient", () => $d8e7b96ea4671e74$export$8b3e87ea56c3a345);

var $eJOHy = parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");

var $f7iZ0 = parcelRequire("f7iZ0");
const $d8e7b96ea4671e74$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $93R6D.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $f7iZ0.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("f7iZ0", function(module, exports) {

$parcel$export(module.exports, "MediaContext", () => $b977b15c2bc7301b$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $b977b15c2bc7301b$export$57164260bc1f1218);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");

var $lMkQs = parcelRequire("lMkQs");
const $b977b15c2bc7301b$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $b977b15c2bc7301b$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $lMkQs.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b977b15c2bc7301b$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("lMkQs", function(module, exports) {

$parcel$export(module.exports, "useMediaParsedSettings", () => $e0ef7db6f81da61d$export$d54af28440a5efc0);

var $eJOHy = parcelRequire("eJOHy");

var $4iDQM = parcelRequire("4iDQM");
const $e0ef7db6f81da61d$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $eJOHy.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $4iDQM.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("4iDQM", function(module, exports) {

$parcel$export(module.exports, "defaultMediaUserPreferences", () => $fd3af50559080092$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $fd3af50559080092$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $fd3af50559080092$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($fd3af50559080092$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $fd3af50559080092$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $fd3af50559080092$export$2d23ed2854ac1650 = $fd3af50559080092$export$7e209e67b965bc63($fd3af50559080092$var$defaultUserPreferences);

});




parcelRegister("bMoFA", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $93f079c5c30deecd$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $93f079c5c30deecd$export$aacb463551da2e8f);

var $h3W10 = parcelRequire("h3W10");
const $93f079c5c30deecd$var$getRequestErrorDetails = (err)=>{
    if ((0, $h3W10.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $93f079c5c30deecd$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $h3W10.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$93f079c5c30deecd$var$getRequestErrorDetails(error)
        }
    };
};
const $93f079c5c30deecd$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("b7hyt", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $b67882b47b14e094$export$f65ca476c09acec0);
const $b67882b47b14e094$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("djK7X", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $5a07b53d359ee7c3$export$90ff537b0999afb);

var $eJOHy = parcelRequire("eJOHy");

var $3cc2J = parcelRequire("3cc2J");

var $kNd6B = parcelRequire("kNd6B");
function $5a07b53d359ee7c3$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const fileState = (0, $kNd6B.useMediaStore)((state)=>state.files[id]);
    (0, $eJOHy.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("kNd6B", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $d5b1e147a2796345$export$8a9cc8c330400af8);

var $eOVQp = parcelRequire("eOVQp");

var $3cc2J = parcelRequire("3cc2J");
const $d5b1e147a2796345$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $eOVQp.useStore)(store, selector, equals);
function $d5b1e147a2796345$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $d5b1e147a2796345$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("eOVQp", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $aca29ade4cd157ce$export$6ccbb43953eebf8);

var $96y8R = parcelRequire("96y8R");

var $eJOHy = parcelRequire("eJOHy");

var $iHcr1 = parcelRequire("iHcr1");
var $aca29ade4cd157ce$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $aca29ade4cd157ce$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)));
const { useSyncExternalStoreWithSelector: $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($iHcr1)));
let $aca29ade4cd157ce$var$didWarnAboutEqualityFn = false;
const $aca29ade4cd157ce$var$identity = (arg)=>arg;
function $aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector = $aca29ade4cd157ce$var$identity, equalityFn) {
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$aca29ade4cd157ce$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $aca29ade4cd157ce$var$didWarnAboutEqualityFn = true;
    }
    const slice = $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $aca29ade4cd157ce$var$useDebugValue(slice);
    return slice;
}
const $aca29ade4cd157ce$var$createImpl = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $96y8R.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $aca29ade4cd157ce$export$185802fd694ee1f5 = (createState)=>createState ? $aca29ade4cd157ce$var$createImpl(createState) : $aca29ade4cd157ce$var$createImpl;
var $aca29ade4cd157ce$export$2e2bcd8739ae039 = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $aca29ade4cd157ce$export$185802fd694ee1f5(createState);
};

});



parcelRegister("e2t9t", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $3f058c26ca766723$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $3f058c26ca766723$export$768c370ed0dbaeb3);

var $4rKJa = parcelRequire("4rKJa");

var $33YQ1 = parcelRequire("33YQ1");
const $3f058c26ca766723$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $3f058c26ca766723$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $3f058c26ca766723$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $3f058c26ca766723$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $3f058c26ca766723$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $3f058c26ca766723$export$4af9d71992e89714(error),
        error: $3f058c26ca766723$export$88c61dcad53762da(error),
        errorDetail: $3f058c26ca766723$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $3f058c26ca766723$export$29aa614726672b2e(error)
    };
};
const $3f058c26ca766723$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$3f058c26ca766723$export$74aaf4784c2edb2c(new (0, $33YQ1.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("33YQ1", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $ba556c1ff2a47bc7$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ba556c1ff2a47bc7$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ba556c1ff2a47bc7$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ba556c1ff2a47bc7$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ba556c1ff2a47bc7$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ba556c1ff2a47bc7$export$7156ce7b78b49bd7);
class $ba556c1ff2a47bc7$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ba556c1ff2a47bc7$export$2c035820a31723e extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$10ab445310d30114 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$18e89b7e50818288 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $ba556c1ff2a47bc7$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ba556c1ff2a47bc7$export$d0a45ab59b4606b extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(source){
        super($ba556c1ff2a47bc7$var$getImageLoadPrimaryReason(source));
    }
}
function $ba556c1ff2a47bc7$export$553696a6e769784c(err) {
    return err instanceof $ba556c1ff2a47bc7$export$96e559194c287cf4;
}
const $ba556c1ff2a47bc7$export$b380593ba3516c6f = (err)=>err instanceof $ba556c1ff2a47bc7$export$2c035820a31723e;
const $ba556c1ff2a47bc7$export$e1d87830b3784f94 = (err)=>err instanceof $ba556c1ff2a47bc7$export$10ab445310d30114;
const $ba556c1ff2a47bc7$export$443aeb298d35d79d = (err)=>$ba556c1ff2a47bc7$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ba556c1ff2a47bc7$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ba556c1ff2a47bc7$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("k9eRE", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $acdcd6198e7dee1d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $acdcd6198e7dee1d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $acdcd6198e7dee1d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $acdcd6198e7dee1d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $acdcd6198e7dee1d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $acdcd6198e7dee1d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $acdcd6198e7dee1d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $acdcd6198e7dee1d$export$98e935d981c884d);

var $bajro = parcelRequire("bajro");

var $33YQ1 = parcelRequire("33YQ1");

var $9Mg12 = parcelRequire("9Mg12");

var $hNvWT = parcelRequire("hNvWT");
const $acdcd6198e7dee1d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $9Mg12.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $acdcd6198e7dee1d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $33YQ1.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $acdcd6198e7dee1d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $acdcd6198e7dee1d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $acdcd6198e7dee1d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $hNvWT.getRemotePreview)(mediaClient, id, params, traceContext);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $acdcd6198e7dee1d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $hNvWT.getLocalPreview)(filePreview);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("bajro", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $dd0a5c69b434a5a7$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $dd0a5c69b434a5a7$export$e51a8146182600b8);
const $dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $dd0a5c69b434a5a7$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $dd0a5c69b434a5a7$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $dd0a5c69b434a5a7$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'collection'),
        alt: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'alt'),
        height: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'height'),
        width: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'width'),
        size: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'size'),
        name: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'name'),
        mimeType: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'mimeType')
    };
};
const $dd0a5c69b434a5a7$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $dd0a5c69b434a5a7$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $dd0a5c69b434a5a7$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("9Mg12", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $d9909271b08294f2$export$b7e8ee3f7a41459);

var $4ZQua = parcelRequire("4ZQua");
const $d9909271b08294f2$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $d9909271b08294f2$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $d9909271b08294f2$export$b7e8ee3f7a41459 = new $d9909271b08294f2$export$7b50526c091bb915((0, $4ZQua.createObjectURLCache)());

});
parcelRegister("4ZQua", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $7640c7504dcb2ad6$export$ba71be67d5c32535);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $7640c7504dcb2ad6$export$36d0f9859761643d = 50;
class $7640c7504dcb2ad6$var$ExtendedLRUCache extends (0, $7xkt0.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $7640c7504dcb2ad6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $7640c7504dcb2ad6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $7640c7504dcb2ad6$export$ba71be67d5c32535 = ()=>new $7640c7504dcb2ad6$export$75d1c8c9ba1d0773($7640c7504dcb2ad6$export$36d0f9859761643d);

});


parcelRegister("hNvWT", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3247cef0fce3851d$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3247cef0fce3851d$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3247cef0fce3851d$export$bfe20bd01db02b3);

var $5JVfG = parcelRequire("5JVfG");

var $cK5G4 = parcelRequire("cK5G4");

var $33YQ1 = parcelRequire("33YQ1");

var $heXDA = parcelRequire("heXDA");
const $3247cef0fce3851d$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3247cef0fce3851d$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $cK5G4.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $heXDA.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3247cef0fce3851d$var$getImageLocalPreview(value);
            case 'video':
                return $3247cef0fce3851d$var$getVideoLocalPreview(value);
            default:
                throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
};
const $3247cef0fce3851d$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $33YQ1.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("cK5G4", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $4622caaad73ce041$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $4622caaad73ce041$export$67689507e8404821);

var $9PgO0 = parcelRequire("9PgO0");

var $f8uqC = parcelRequire("f8uqC");

var $fOXQV = parcelRequire("fOXQV");

var $kHzU5 = parcelRequire("kHzU5");
const { Orientation: $4622caaad73ce041$var$Orientation, XResolution: $4622caaad73ce041$var$XResolution } = (0, $9PgO0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $4622caaad73ce041$var$DPI_WEB_BASELINE = 72;
async function $4622caaad73ce041$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $4622caaad73ce041$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $4622caaad73ce041$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $4622caaad73ce041$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
        else return $4622caaad73ce041$export$268f92356524130b(tags, $4622caaad73ce041$var$XResolution, $4622caaad73ce041$var$DPI_WEB_BASELINE) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $4622caaad73ce041$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$4622caaad73ce041$var$Orientation]) {
        const tagValue = tags[$4622caaad73ce041$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $9PgO0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $4622caaad73ce041$export$67689507e8404821(file) {
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    return $4622caaad73ce041$var$getOrientationFromTags(tags);
}
function $4622caaad73ce041$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $4622caaad73ce041$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $fOXQV.loadImage)(src);
        const { width: width, height: height } = (0, $fOXQV.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("9PgO0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $c8d64cb551bef33f$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $c8d64cb551bef33f$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $c8d64cb551bef33f$export$f6ea0c89fd7d156);
var $c8d64cb551bef33f$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $c8d64cb551bef33f$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $c8d64cb551bef33f$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("f8uqC", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $80e2aeeb99751964$export$41982b5c7acb23c4);

var $9PgO0 = parcelRequire("9PgO0");

var $dCEVY = parcelRequire("dCEVY");

var $7BlyC = parcelRequire("7BlyC");

var $3yAnp = parcelRequire("3yAnp");
async function $80e2aeeb99751964$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $9PgO0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $7BlyC.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $3yAnp.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $9PgO0.ImageType).JPEG) return await (0, $dCEVY.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("dCEVY", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $ff103de7f6ab6f18$export$556b2ccec62d7f2a);

var $9PgO0 = parcelRequire("9PgO0");
const { XResolution: $ff103de7f6ab6f18$var$XResolution, YResolution: $ff103de7f6ab6f18$var$YResolution } = (0, $9PgO0.SupportedImageMetaTag);
let $ff103de7f6ab6f18$var$loadImage;

function $ff103de7f6ab6f18$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$ff103de7f6ab6f18$var$loadImage) {
            const module = await (parcelRequire("9JMwr"));
            $ff103de7f6ab6f18$var$loadImage = module.default || module;
        }
        $ff103de7f6ab6f18$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $ff103de7f6ab6f18$var$XResolution || key === $ff103de7f6ab6f18$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("9JMwr", function(module, exports) {

let $716df486413b4273$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $716df486413b4273$var$load("2HU4O").then(()=>parcelRequire('4Mu1O'));

});


parcelRegister("7BlyC", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $e9cd4ca7c89b16ee$export$5fb37736440fca6f);

var $fOXQV = parcelRequire("fOXQV");
let $e9cd4ca7c89b16ee$var$pngChunksExtract;

async function $e9cd4ca7c89b16ee$export$5fb37736440fca6f(file) {
    if (!$e9cd4ca7c89b16ee$var$pngChunksExtract) {
        const module = await (parcelRequire("dopkG"));
        $e9cd4ca7c89b16ee$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $fOXQV.fileToArrayBuffer)(file);
    const chunks = $e9cd4ca7c89b16ee$var$pngChunksExtract(buffer);
    return await $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks);
}
async function $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("fOXQV", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $cb7adf01e70d1e12$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $cb7adf01e70d1e12$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $cb7adf01e70d1e12$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $cb7adf01e70d1e12$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $cb7adf01e70d1e12$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $cb7adf01e70d1e12$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $cb7adf01e70d1e12$export$61a1de0822e2820);

var $6OBnQ = parcelRequire("6OBnQ");

var $2Pj0H = parcelRequire("2Pj0H");

var $jb8ZN = parcelRequire("jb8ZN");

var $4w1Xx = parcelRequire("4w1Xx");

var $heBKY = parcelRequire("heBKY");

var $jP9Cl = parcelRequire("jP9Cl");

var $gAsmN = parcelRequire("gAsmN");

var $iqmbF = parcelRequire("iqmbF");

var $hLw8T = parcelRequire("hLw8T");

var $jpYYq = parcelRequire("jpYYq");

var $4SXVP = parcelRequire("4SXVP");

var $91IX3 = parcelRequire("91IX3");

var $i9oSq = parcelRequire("i9oSq");

var $1TONM = parcelRequire("1TONM");

var $3LgN4 = parcelRequire("3LgN4");

var $jmdLl = parcelRequire("jmdLl");
function $cb7adf01e70d1e12$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $cb7adf01e70d1e12$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $cb7adf01e70d1e12$export$849633012686f7ee(file)
    };
}
async function $cb7adf01e70d1e12$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $cb7adf01e70d1e12$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $cb7adf01e70d1e12$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $cb7adf01e70d1e12$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $cb7adf01e70d1e12$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $cb7adf01e70d1e12$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $cb7adf01e70d1e12$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6OBnQ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SXVP)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jpYYq)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iqmbF)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4w1Xx)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jb8ZN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Pj0H)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($91IX3)))
    }
];
function $cb7adf01e70d1e12$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $cb7adf01e70d1e12$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $jmdLl.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3LgN4)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($heBKY)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jP9Cl)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gAsmN)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("6OBnQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $4f6469314c3d6ff1$var$_react = $4f6469314c3d6ff1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $4f6469314c3d6ff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6469314c3d6ff1$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $4f6469314c3d6ff1$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$4f6469314c3d6ff1$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $4f6469314c3d6ff1$var$_default = module.exports.default = $4f6469314c3d6ff1$var$PdfDocument24Icon;

});

parcelRegister("2Pj0H", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $20ef173efcc507e4$var$_react = $20ef173efcc507e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $20ef173efcc507e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $20ef173efcc507e4$var$Gif24Icon = (props)=>/*#__PURE__*/ $20ef173efcc507e4$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$20ef173efcc507e4$var$Gif24Icon.displayName = 'Gif24Icon';
var $20ef173efcc507e4$var$_default = module.exports.default = $20ef173efcc507e4$var$Gif24Icon;

});

parcelRegister("jb8ZN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $df6605c69004c362$var$_react = $df6605c69004c362$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $df6605c69004c362$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $df6605c69004c362$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $df6605c69004c362$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$df6605c69004c362$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $df6605c69004c362$var$_default = module.exports.default = $df6605c69004c362$var$PowerpointPresentation24Icon;

});

parcelRegister("4w1Xx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $349babaa4a8a09e8$var$_react = $349babaa4a8a09e8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $349babaa4a8a09e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $349babaa4a8a09e8$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $349babaa4a8a09e8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$349babaa4a8a09e8$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $349babaa4a8a09e8$var$_default = module.exports.default = $349babaa4a8a09e8$var$WordDocument24Icon;

});

parcelRegister("heBKY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c8c1082e5cae77c8$var$_react = $c8c1082e5cae77c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c8c1082e5cae77c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c8c1082e5cae77c8$var$Sketch24Icon = (props)=>/*#__PURE__*/ $c8c1082e5cae77c8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c8c1082e5cae77c8$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $c8c1082e5cae77c8$var$_default = module.exports.default = $c8c1082e5cae77c8$var$Sketch24Icon;

});

parcelRegister("jP9Cl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6ea3d8b8f4b0c1d$var$_react = $e6ea3d8b8f4b0c1d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $e6ea3d8b8f4b0c1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6ea3d8b8f4b0c1d$var$Figma24Icon = (props)=>/*#__PURE__*/ $e6ea3d8b8f4b0c1d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e6ea3d8b8f4b0c1d$var$Figma24Icon.displayName = 'Figma24Icon';
var $e6ea3d8b8f4b0c1d$var$_default = module.exports.default = $e6ea3d8b8f4b0c1d$var$Figma24Icon;

});

parcelRegister("gAsmN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1360329a45292df$var$_react = $c1360329a45292df$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c1360329a45292df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1360329a45292df$var$Executable24Icon = (props)=>/*#__PURE__*/ $c1360329a45292df$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1360329a45292df$var$Executable24Icon.displayName = 'Executable24Icon';
var $c1360329a45292df$var$_default = module.exports.default = $c1360329a45292df$var$Executable24Icon;

});

parcelRegister("iqmbF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d69bdda0af90a430$var$_react = $d69bdda0af90a430$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $d69bdda0af90a430$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d69bdda0af90a430$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d69bdda0af90a430$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d69bdda0af90a430$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d69bdda0af90a430$var$_default = module.exports.default = $d69bdda0af90a430$var$GoogleDoc24Icon;

});

parcelRegister("hLw8T", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ceefc245c72865b3$var$_react = $ceefc245c72865b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $ceefc245c72865b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ceefc245c72865b3$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $ceefc245c72865b3$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ceefc245c72865b3$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $ceefc245c72865b3$var$_default = module.exports.default = $ceefc245c72865b3$var$GoogleForm24Icon;

});

parcelRegister("jpYYq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e22fa632d0a47674$var$_react = $e22fa632d0a47674$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $e22fa632d0a47674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e22fa632d0a47674$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $e22fa632d0a47674$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e22fa632d0a47674$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $e22fa632d0a47674$var$_default = module.exports.default = $e22fa632d0a47674$var$GoogleSheet24Icon;

});

parcelRegister("4SXVP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $38eab1c43401fe51$var$_react = $38eab1c43401fe51$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $38eab1c43401fe51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $38eab1c43401fe51$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $38eab1c43401fe51$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$38eab1c43401fe51$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $38eab1c43401fe51$var$_default = module.exports.default = $38eab1c43401fe51$var$GoogleSlide24Icon;

});

parcelRegister("91IX3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $69271380a604c514$var$_react = $69271380a604c514$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $69271380a604c514$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69271380a604c514$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $69271380a604c514$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$69271380a604c514$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $69271380a604c514$var$_default = module.exports.default = $69271380a604c514$var$ExcelSpreadsheet24Icon;

});

parcelRegister("i9oSq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36c5d4aab250180$var$_react = $d36c5d4aab250180$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $d36c5d4aab250180$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36c5d4aab250180$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d36c5d4aab250180$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36c5d4aab250180$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d36c5d4aab250180$var$_default = module.exports.default = $d36c5d4aab250180$var$Spreadsheet24Icon;

});

parcelRegister("1TONM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $162255ae7d5921b9$var$_react = $162255ae7d5921b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $162255ae7d5921b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162255ae7d5921b9$var$Presentation24Icon = (props)=>/*#__PURE__*/ $162255ae7d5921b9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$162255ae7d5921b9$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $162255ae7d5921b9$var$_default = module.exports.default = $162255ae7d5921b9$var$Presentation24Icon;

});

parcelRegister("3LgN4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2bd2c91c79a3039e$var$_react = $2bd2c91c79a3039e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $2bd2c91c79a3039e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bd2c91c79a3039e$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2bd2c91c79a3039e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2bd2c91c79a3039e$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2bd2c91c79a3039e$var$_default = module.exports.default = $2bd2c91c79a3039e$var$SourceCode24Icon;

});

parcelRegister("jmdLl", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $d6ba8b104df87d35$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d6ba8b104df87d35$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d6ba8b104df87d35$export$ba4368c844580f9e);
function $d6ba8b104df87d35$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d6ba8b104df87d35$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d6ba8b104df87d35$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d6ba8b104df87d35$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d6ba8b104df87d35$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("dopkG", function(module, exports) {

let $9c012ac78e0c2259$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9c012ac78e0c2259$var$load("fWdHm").then(()=>parcelRequire('6TwJU'));

});


parcelRegister("3yAnp", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $a54c683875c3acaa$export$55c3bc9841b19de2);
function $a54c683875c3acaa$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("kHzU5", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $d080920ecf648ea4$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $d080920ecf648ea4$export$43142f95b8de7a91);
const $d080920ecf648ea4$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $d080920ecf648ea4$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $d080920ecf648ea4$export$43142f95b8de7a91 = (orientation)=>{
    return $d080920ecf648ea4$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("heXDA", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $e7f813388d1815ac$export$4269d30173168e5c);
const $e7f813388d1815ac$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("i0gVY", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $c6ffe105f3de4b84$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $c6ffe105f3de4b84$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $c6ffe105f3de4b84$export$de7c49925e44d75d);

var $itX9h = parcelRequire("itX9h");
const $c6ffe105f3de4b84$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $c6ffe105f3de4b84$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $c6ffe105f3de4b84$var$dashed = (param)=>param ? `-${param}` : '';
const $c6ffe105f3de4b84$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$c6ffe105f3de4b84$var$dashed(collectionName)}${$c6ffe105f3de4b84$var$dashed(occurrenceKey)}`;
const $c6ffe105f3de4b84$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $c6ffe105f3de4b84$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $itX9h.printFunctionCall)($c6ffe105f3de4b84$export$4310981e0aa4ce67, $c6ffe105f3de4b84$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $itX9h.printScript)([
        $c6ffe105f3de4b84$export$ede93d4564eaa8da.toString(),
        $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $c6ffe105f3de4b84$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $c6ffe105f3de4b84$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("itX9h", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $58d2f85efd2afaca$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $58d2f85efd2afaca$export$8b902fb69a2f17c1);
const $58d2f85efd2afaca$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $58d2f85efd2afaca$var$printParams = (args)=>args.map((arg)=>$58d2f85efd2afaca$var$printParam(arg)).join(',');
const $58d2f85efd2afaca$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$58d2f85efd2afaca$var$printParams(args)});`;
const $58d2f85efd2afaca$export$8b902fb69a2f17c1 = (statements)=>`(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		`;

});


parcelRegister("8Dv9L", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $2f30a37781c6f0c3$export$d3a890b0f7844b6f);

var $i0gVY = parcelRequire("i0gVY");
const $2f30a37781c6f0c3$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $i0gVY.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $i0gVY.getKey)(identifier)];
};

});

parcelRegister("3c1p9", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $f93a7743871712e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $f93a7743871712e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $f93a7743871712e9$export$b3e10e1f0fbb71db);

var $eJOHy = parcelRequire("eJOHy");
const $f93a7743871712e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $f93a7743871712e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $f93a7743871712e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $f93a7743871712e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $f93a7743871712e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}

});




parcelRegister("iyBBa", function(module, exports) {

$parcel$export(module.exports, "ColoredTag", () => $edbc1f1c5365a1cc$export$526384205b143b58);

var $eJOHy = parcelRequire("eJOHy");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $051tO = parcelRequire("051tO");

var $aCFLd = parcelRequire("aCFLd");
const $edbc1f1c5365a1cc$export$526384205b143b58 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ labelName: labelName, href: href, actionSubjectId: actionSubjectId, containerXcss: containerXcss, contentXcss: contentXcss, analyticsAttributes: analyticsAttributes, color: color, ...restProps }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { backgroundColor: borderColor } = (0, $051tO.getColorMetadata)((0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(labelName));
    const onHandleClick = (0, $eJOHy.useCallback)(()=>{
        if (href) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.href = href;
        if (actionSubjectId) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            attributes: analyticsAttributes
        }), actionSubjectId);
    }, [
        actionSubjectId,
        createAnalyticsEvent,
        href,
        analyticsAttributes
    ]);
    const onHandleClickForAnchor = (0, $eJOHy.useCallback)(()=>{
        if (actionSubjectId) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            attributes: analyticsAttributes
        }), actionSubjectId);
    }, [
        actionSubjectId,
        createAnalyticsEvent,
        analyticsAttributes
    ]);
    if (href) return (0, $7jTnu.fg)('replacing_pressable_by_anchor_for_colored_tag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        xcss: [
            $edbc1f1c5365a1cc$var$tagStyles,
            $edbc1f1c5365a1cc$var$hoverStyles,
            $edbc1f1c5365a1cc$var$anchorTextStyles,
            ...containerXcss ? [
                containerXcss
            ] : []
        ],
        href: href,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color || borderColor
        },
        onClick: onHandleClickForAnchor,
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $edbc1f1c5365a1cc$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ]
    }, labelName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        xcss: [
            $edbc1f1c5365a1cc$var$tagStyles,
            $edbc1f1c5365a1cc$var$hoverStyles,
            ...containerXcss ? [
                containerXcss
            ] : []
        ],
        onClick: onHandleClick,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color || borderColor
        },
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $edbc1f1c5365a1cc$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ]
    }, labelName));
    return (0, $7jTnu.fg)('colored_tag_fix_truncation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: ref,
        xcss: [
            $edbc1f1c5365a1cc$var$tagStyles,
            ...containerXcss ? [
                containerXcss
            ] : []
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color || borderColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $edbc1f1c5365a1cc$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ]
    }, labelName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: ref,
        xcss: [
            $edbc1f1c5365a1cc$var$tagStyles,
            $edbc1f1c5365a1cc$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color || borderColor
        }
    }, labelName);
});
const $edbc1f1c5365a1cc$var$tagStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    backgroundColor: 'color.background.neutral.subtle',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    paddingInline: 'space.050',
    paddingBlock: '0',
    font: 'font.body',
    marginBlock: 'space.050',
    marginInline: 'space.050',
    height: '20px',
    alignItems: 'center',
    maxWidth: '100%'
});
const $edbc1f1c5365a1cc$var$hoverStyles = (0, $1DXK0.xcss)({
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered',
        textDecoration: 'underline'
    }
});
const $edbc1f1c5365a1cc$var$tagTextStyles = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '180px'
});
const $edbc1f1c5365a1cc$var$anchorTextStyles = (0, $1DXK0.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    ':hover': {
        color: 'color.text'
    }
});

});

parcelRegister("ibVOD", function(module, exports) {

$parcel$export(module.exports, "useCellHoverCallbacks", () => $72d9a29ee2941367$export$793f17026bd5d1b4);
$parcel$export(module.exports, "CellHoverProvider", () => $72d9a29ee2941367$export$d427879c5002c548);
$parcel$export(module.exports, "useCellHoverHandlers", () => $72d9a29ee2941367$export$5ac0a932365e8caa);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $hX7Ca = parcelRequire("hX7Ca");
const $72d9a29ee2941367$export$7c2be23b3b8e5093 = 200;
const $72d9a29ee2941367$export$1e4bd5ddbd3e82e5 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $72d9a29ee2941367$var$onShowPopup = ({ contentRef: contentRef, onPopupToggle: onPopupToggle, shouldGetParentRef: shouldGetParentRef })=>{
    const elementWithTextContent = contentRef?.current ? (0, $hX7Ca.getClosestTextElement)(shouldGetParentRef ? contentRef?.current.parentElement : contentRef?.current) : undefined;
    const clientWidth = elementWithTextContent?.clientWidth || 0;
    const scrollWidth = elementWithTextContent?.scrollWidth || 0;
    const isClamped = (0, $hX7Ca.checkIsClamped)(elementWithTextContent);
    // If contentRef is not provided then the popover should always be visible on hover.
    if (!contentRef?.current || scrollWidth > clientWidth || isClamped) onPopupToggle(true);
};
const $72d9a29ee2941367$export$793f17026bd5d1b4 = ({ contentRef: contentRef, onPreload: onPreload, onPopupToggle: onPopupToggle, onLoad: onLoad, shouldGetParentRef: shouldGetParentRef, onHoverOut: onHoverOut, onChangePopupState: onChangePopupState })=>{
    const handlers = (0, $eJOHy.useContext)($72d9a29ee2941367$export$1e4bd5ddbd3e82e5);
    const onHidePopup = (0, $eJOHy.useCallback)(()=>{
        onPopupToggle(false);
    }, [
        onPopupToggle
    ]);
    if (!handlers) return;
    if (handlers.onPreload) // eslint-disable-next-line react-hooks/react-compiler
    handlers.onPreload.current = onPreload || null;
    if (handlers.onLoad) handlers.onLoad.current = onLoad || null;
    if (handlers.onChangePopupState) handlers.onChangePopupState.current = onChangePopupState || null;
    handlers.onShowPopup.current = ()=>$72d9a29ee2941367$var$onShowPopup({
            contentRef: contentRef,
            onPopupToggle: onPopupToggle,
            shouldGetParentRef: shouldGetParentRef
        });
    handlers.onHidePopup.current = ()=>{
        onHidePopup();
        onHoverOut?.();
    };
};
const $72d9a29ee2941367$export$d427879c5002c548 = ({ children: children, delay: delay = $72d9a29ee2941367$export$7c2be23b3b8e5093 })=>{
    const hoverTimeoutRef = (0, $eJOHy.useRef)(null);
    const onPreloadRef = (0, $eJOHy.useRef)(null);
    const onLoadRef = (0, $eJOHy.useRef)(null);
    const onShowPopupRef = (0, $eJOHy.useRef)(null);
    const onHidePopupRef = (0, $eJOHy.useRef)(null);
    const onChangePopupStateRef = (0, $eJOHy.useRef)(null);
    const cleanUpTimeout = (0, $eJOHy.useCallback)(()=>{
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
    }, []);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        if (hoverTimeoutRef.current && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) return;
        onPreloadRef.current?.();
        hoverTimeoutRef.current = setTimeout(()=>{
            onLoadRef.current?.();
            onShowPopupRef.current?.();
        }, delay);
    }, [
        delay
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        cleanUpTimeout();
        onHidePopupRef.current?.();
    }, [
        cleanUpTimeout
    ]);
    const handleToggle = (0, $eJOHy.useCallback)(()=>{
        onLoadRef.current?.();
        onChangePopupStateRef.current?.();
    }, []);
    const handers = (0, $eJOHy.useMemo)(()=>({
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            onPreload: onPreloadRef,
            onLoad: onLoadRef,
            onShowPopup: onShowPopupRef,
            onHidePopup: onHidePopupRef,
            handleToggle: handleToggle,
            onChangePopupState: onChangePopupStateRef
        }), [
        handleMouseEnter,
        handleMouseLeave,
        handleToggle
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return cleanUpTimeout;
    }, [
        cleanUpTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($72d9a29ee2941367$export$1e4bd5ddbd3e82e5.Provider, {
        value: handers
    }, children);
};
const $72d9a29ee2941367$export$5ac0a932365e8caa = ()=>{
    const handlers = (0, $eJOHy.useContext)($72d9a29ee2941367$export$1e4bd5ddbd3e82e5);
    if (handlers === null) throw new Error('useCellHoverHandlers must be used within a CellHoverProvider');
    return handlers;
};

});

parcelRegister("9Mapt", function(module, exports) {

$parcel$export(module.exports, "HoverPopoverWithContext", () => $356133080582a054$export$34da0ae4eaeabe16);
$parcel$export(module.exports, "CellHoverRenderer", () => $356133080582a054$export$15e55631babd0ec5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $kJsb4 = parcelRequire("kJsb4");

var $1KdDN = parcelRequire("1KdDN");

var $16sa1 = parcelRequire("16sa1");

var $7jTnu = parcelRequire("7jTnu");

var $ibVOD = parcelRequire("ibVOD");


var $9CHGV = parcelRequire("9CHGV");
const $356133080582a054$var$PopupComponentInternal = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: popupChildren, isReferenceHidden: isReferenceHidden, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, ...restProps }, ref)=>{
    const { isFixedWidth: isFixedWidth, isInteractive: isInteractive, setIsPopupOpen: setIsPopupOpen } = (0, $eJOHy.useContext)($356133080582a054$var$HoverPopoverContext);
    return !isReferenceHidden ? /*#__PURE__*/ $eJOHy.createElement("div", {
        onMouseEnter: ()=>isInteractive && setIsPopupOpen(true),
        onMouseLeave: ()=>isInteractive && setIsPopupOpen(false),
        ...restProps,
        ref: ref,
        className: (0, $hcewu.default)([
            "_1mouu2gc _j7hq1ida _tzy4idpf _5sag1yx9 _1pgl1v42 _1o51q7pw _p12f1mjv _lcxvglyw",
            (0, $7jTnu.fg)('single_line_row_height_collapsable_fields') && "_1pbycs5v",
            isInteractive && "_1moux0bf _1rjcutpp _lcxv1wug",
            isFixedWidth && "_1bsb1mjv"
        ])
    }, popupChildren) : null;
});
const $356133080582a054$var$HoverPopoverContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isFixedWidth: false,
    isInteractive: false,
    setIsPopupOpen: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $356133080582a054$var$HoverPopoverComponent = ({ content: content, children: children, contentRef: contentRef, entryPointActions: entryPointActions, isInteractive: isInteractive, shouldGetParentRef: shouldGetParentRef, isFixedWidth: isFixedWidth, onHoverOut: onHoverOut, hidePopover: hidePopover, analyticsAttributes: analyticsAttributes })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $eJOHy.useState)(false);
    const togglePopup = (0, $eJOHy.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
    }, [
        isPopupOpen
    ]);
    (0, $ibVOD.useCellHoverCallbacks)({
        contentRef: contentRef,
        onPreload: entryPointActions?.preload,
        onLoad: entryPointActions?.load,
        onPopupToggle: setIsPopupOpen,
        shouldGetParentRef: shouldGetParentRef,
        onHoverOut: onHoverOut,
        onChangePopupState: togglePopup
    });
    if (content && isPopupOpen) return (0, $7jTnu.fg)('issue_table_single_line_row_height_fast_follows') ? /*#__PURE__*/ $eJOHy.createElement((0, $16sa1.default), {
        name: "jira-list-hover-popover",
        mode: "list"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jira-list-hover-popover",
        packageName: (0, $05f3bc586d738eb3$export$b8b9d90f9e5bd72b),
        teamName: (0, $05f3bc586d738eb3$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ $eJOHy.createElement($356133080582a054$var$HoverPopoverContext.Provider, {
        value: {
            isFixedWidth: isFixedWidth,
            isInteractive: isInteractive,
            setIsPopupOpen: setIsPopupOpen
        }
    }, /*#__PURE__*/ $eJOHy.createElement((0, $kJsb4.Popup), {
        // eslint-disable-next-line jira/import/no-direct-popup
        content: ({ update: update })=>/*#__PURE__*/ $eJOHy.createElement((0, $9CHGV.PopupContent), {
                isInteractive: isInteractive,
                update: update,
                analyticsAttributes: analyticsAttributes
            }, content),
        popupComponent: $356133080582a054$var$PopupComponentInternal,
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: false,
        isOpen: !hidePopover && isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        trigger: ({ ref: ref })=>children({
                ref: ref,
                ariaExpanded: isPopupOpen
            }),
        placement: "bottom-start"
    })))) : /*#__PURE__*/ $eJOHy.createElement((0, $16sa1.default), {
        name: "jira-list-hover-popover",
        mode: "list"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jira-list-hover-popover",
        packageName: (0, $05f3bc586d738eb3$export$b8b9d90f9e5bd72b),
        teamName: (0, $05f3bc586d738eb3$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $kJsb4.Popup), {
        // eslint-disable-next-line jira/import/no-direct-popup
        content: ({ update: update })=>/*#__PURE__*/ $eJOHy.createElement((0, $9CHGV.PopupContent), {
                isInteractive: isInteractive,
                update: update,
                analyticsAttributes: analyticsAttributes
            }, content),
        popupComponent: /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: popupChildren, isReferenceHidden: isReferenceHidden, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, ...restProps }, ref)=>{
            if (isReferenceHidden && isPopupOpen) setIsPopupOpen(false);
            return /*#__PURE__*/ $eJOHy.createElement("div", {
                onMouseEnter: ()=>isInteractive && setIsPopupOpen(true),
                onMouseLeave: ()=>isInteractive && setIsPopupOpen(false),
                ...restProps,
                ref: ref,
                className: (0, $hcewu.default)([
                    "_1mouu2gc _j7hq1ida _tzy4idpf _5sag1yx9 _1pgl1v42 _1o51q7pw _p12f1mjv _lcxvglyw",
                    (0, $7jTnu.fg)('single_line_row_height_collapsable_fields') && "_1pbycs5v",
                    isInteractive && "_1moux0bf _1rjcutpp _lcxv1wug",
                    isFixedWidth && "_1bsb1mjv"
                ])
            }, popupChildren);
        }),
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: false,
        isOpen: !hidePopover && isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        trigger: ({ ref: ref })=>children({
                ref: ref,
                ariaExpanded: isPopupOpen
            }),
        placement: "bottom-start"
    })));
    return typeof children === 'function' ? children({
        ref: null
    }) : children;
};
const $356133080582a054$export$34da0ae4eaeabe16 = /*#__PURE__*/ (0, $eJOHy.memo)($356133080582a054$var$HoverPopoverComponent);
const $356133080582a054$export$15e55631babd0ec5 = ({ children: children })=>{
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, handleToggle: handleToggle } = (0, $ibVOD.useCellHoverHandlers)();
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.code === 'Space' || event.code === 'Enter' && (0, $7jTnu.fg)('issue_table_single_line_row_height_fast_follows')) {
            // Prevent default is needed to prevent the table from scrolling down on space/enter press
            if ((0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) event.preventDefault();
            handleToggle();
        }
    }, [
        handleToggle
    ]);
    return children({
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onKeyDown: handleKeyDown
    });
};
const $356133080582a054$var$fadeIn = null;
const $356133080582a054$var$interactiveStyles = null;
const $356133080582a054$var$containerStyles = null;
const $356133080582a054$var$renderToParentStyles = null;
const $356133080582a054$var$fixedWidthStyles = null;

});

parcelRegister("gybMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $03a1c6c7f1e563da$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $c9uTK = parcelRequire("c9uTK");

var $7jTnu = parcelRequire("7jTnu");

var $jiTA8 = parcelRequire("jiTA8");
const $03a1c6c7f1e563da$var$Link = ({ onClick: onClick, wordBreak: wordBreak = true, shouldDisplayStrikethrough: shouldDisplayStrikethrough = false, ...rest })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isEmbedMode = (0, $7jTnu.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jiTA8.useIsEmbedMode)() : false;
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((e)=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'listWithPopup');
        onClick && onClick(e);
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03a1c6c7f1e563da$var$StyledLink, {
        wordBreak: wordBreak,
        shouldDisplayStrikethrough: shouldDisplayStrikethrough,
        ...rest,
        onClick: onClickWithAnalytics,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    });
};
// Fix for Compiled bug where invalid props are passed on to the underlying DOM element when using inheritance.
const $03a1c6c7f1e563da$var$PropFilteredLink = ({ wordBreak: wordBreak, shouldDisplayStrikethrough: shouldDisplayStrikethrough, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), rest);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03a1c6c7f1e563da$var$StyledLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $03a1c6c7f1e563da$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.wordBreak && "_1nmz1hna",
            __cmplp.shouldDisplayStrikethrough && "_4bfu1r81 _1hms1cog _ajmmvv82",
            __cmplp.className
        ])
    });
});
var $03a1c6c7f1e563da$export$2e2bcd8739ae039 = $03a1c6c7f1e563da$var$Link;

});



parcelRegister("7hEnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d49520d2b77e8f2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4d49520d2b77e8f2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    // TODO: [JSC-2233] remove nonfinal suffix after confirming with CD
    noLabel: {
        "id": "issue-table-grouping.group-row.group-header.label-group-header.no-label-nonfinal",
        "defaultMessage": "Unlabelled"
    }
});

});


parcelRegister("jinCH", function(module, exports) {

$parcel$export(module.exports, "IssueTypeGroupHeader", () => $799e85f339372570$export$dccf116a86b73229);

var $k4tOO = parcelRequire("k4tOO");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $8wyVH = parcelRequire("8wyVH");
const $799e85f339372570$export$dccf116a86b73229 = ({ issueTypeGroupHeader: issueTypeGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $k4tOO.default), issueTypeGroupHeader);
    const issueType = data?.issueTypes[0]; // note: we are expecting only one issue type per group
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, issueType?.avatar?.small && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        height: "var(--ds-space-200, 16px)",
        width: "var(--ds-space-200, 16px)",
        src: issueType.avatar.small,
        alt: issueType.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, issueType?.name));
};

});
parcelRegister("k4tOO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe03886596b1fa6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf785b14459f5bcbedb582e2e5159df2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bfe03886596b1fa6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueTypeGroupHeader_issueTableGrouping",
    "selections": [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueTypes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraJqlIssueTypeFieldValue"
};
$bfe03886596b1fa6$var$node.hash = "838558b93c23fe6d10aa63aa37347e32";
var $bfe03886596b1fa6$export$2e2bcd8739ae039 = $bfe03886596b1fa6$var$node;

});


parcelRegister("2fiDR", function(module, exports) {

$parcel$export(module.exports, "GroupPickerGroupHeader", () => $b57f680c422339f2$export$310ade6d89d65120);

var $krQRK = parcelRequire("krQRK");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $6w3tC = parcelRequire("6w3tC");

var $1wrYf = parcelRequire("1wrYf");
const $b57f680c422339f2$export$310ade6d89d65120 = ({ groupPickerGroupHeader: groupPickerGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $krQRK.default), groupPickerGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.group?.name,
        noValueText: formatMessage((0, $1wrYf.default).noGroup)
    });
};

});
parcelRegister("krQRK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceda1d6676cbb3c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3298519dfd4746ee6ce234a9fa29f953>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ceda1d6676cbb3c7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "groupPickerGroupHeader_issueTableGrouping",
    "selections": [
        {
            "concreteType": "JiraGroup",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraJqlGroupFieldValue"
};
$ceda1d6676cbb3c7$var$node.hash = "1586f026d7391c5354a0bb5a5a52ee17";
var $ceda1d6676cbb3c7$export$2e2bcd8739ae039 = $ceda1d6676cbb3c7$var$node;

});

parcelRegister("6w3tC", function(module, exports) {

$parcel$export(module.exports, "TextGroupHeaderContent", () => $258f99b95fda91d0$export$902945573f65d5a4);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");
const $258f99b95fda91d0$export$902945573f65d5a4 = ({ text: text, noValueText: noValueText })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, text ?? noValueText);
};

});

parcelRegister("1wrYf", function(module, exports) {

$parcel$export(module.exports, "default", () => $cee3bd62c7572fb0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cee3bd62c7572fb0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    // TODO: [JSC-2233] remove nonfinal suffix after confirming with CD
    noGroup: {
        "id": "issue-table-grouping.group-row.group-header.group-picker-group-header.no-group-nonfinal",
        "defaultMessage": "No group"
    }
});

});


parcelRegister("hKYCG", function(module, exports) {

$parcel$export(module.exports, "OptionGroupHeader", () => $762f6701cb057b20$export$100e8d6eda7c9ebc);

var $94gBg = parcelRequire("94gBg");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $814y1 = parcelRequire("814y1");

var $6w3tC = parcelRequire("6w3tC");

var $aIng6 = parcelRequire("aIng6");

var $3QRBm = parcelRequire("3QRBm");
const $762f6701cb057b20$export$100e8d6eda7c9ebc = ({ optionGroupHeader: optionGroupHeader, fieldType: fieldType })=>{
    const data = (0, $j4oe4.useFragment)((0, $94gBg.default), optionGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return fieldType === (0, $814y1.RADIO_BUTTONS_CF_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.displayName || data?.option?.value,
        noValueText: formatMessage((0, $3QRBm.default).noOption)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIng6.TagGroupHeaderContent), {
        text: data?.displayName || data?.option?.value,
        noValueText: formatMessage((0, $3QRBm.default).noOption)
    });
};

});
parcelRegister("94gBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ad25b362c22bca3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bcddcd7f903696953ee0d3efdd046cea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8ad25b362c22bca3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "optionGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "option",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraJqlOptionFieldValue"
};
$8ad25b362c22bca3$var$node.hash = "45f8a556fccbdfe752d726e04df3a2ee";
var $8ad25b362c22bca3$export$2e2bcd8739ae039 = $8ad25b362c22bca3$var$node;

});

parcelRegister("3QRBm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7965b3ff7c3d2b69$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7965b3ff7c3d2b69$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noOption: {
        "id": "issue-table-grouping.group-row.group-header.option-group-header.no-option-non-final",
        "defaultMessage": "No value"
    }
});

});


parcelRegister("cCW4w", function(module, exports) {

$parcel$export(module.exports, "VersionGroupHeader", () => $c8ce998c78aeb6f7$export$e72e2cdf797c0426);

var $2PJQP = parcelRequire("2PJQP");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $814y1 = parcelRequire("814y1");

var $6w3tC = parcelRequire("6w3tC");

var $aIng6 = parcelRequire("aIng6");

var $4z91V = parcelRequire("4z91V");
const $c8ce998c78aeb6f7$export$e72e2cdf797c0426 = ({ versionGroupHeader: versionGroupHeader, fieldType: fieldType })=>{
    const data = (0, $j4oe4.useFragment)((0, $2PJQP.default), versionGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return fieldType === (0, $814y1.VERSION_CF_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.displayName || data?.version?.name,
        noValueText: formatMessage((0, $4z91V.default).noVersion)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIng6.TagGroupHeaderContent), {
        text: data?.displayName || data?.version?.name,
        noValueText: formatMessage((0, $4z91V.default).noVersion)
    });
};

});
parcelRegister("2PJQP", function(module, exports) {

$parcel$export(module.exports, "default", () => $979c1df4f44184a0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a192ce9939f08f3273c81b2ed09887b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $979c1df4f44184a0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraJqlVersionFieldValue"
};
$979c1df4f44184a0$var$node.hash = "6f40702033c0b53530dbd612b74690ed";
var $979c1df4f44184a0$export$2e2bcd8739ae039 = $979c1df4f44184a0$var$node;

});

parcelRegister("4z91V", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc58f19fb4ae2242$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fc58f19fb4ae2242$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noVersion: {
        "id": "issue-table-grouping.group-row.group-header.version-group-header.no-version-non-final",
        "defaultMessage": "Work items with no version"
    }
});

});


parcelRegister("4HTXE", function(module, exports) {

$parcel$export(module.exports, "UserGroupHeader", () => $60f5fd2e3231a29d$export$6a5bbfbd8cc048b3);

var $dx1Wj = parcelRequire("dx1Wj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $4UiGa = parcelRequire("4UiGa");

var $814y1 = parcelRequire("814y1");

var $7jTnu = parcelRequire("7jTnu");

var $8vugl = parcelRequire("8vugl");
const $60f5fd2e3231a29d$export$6a5bbfbd8cc048b3 = ({ userGroupHeader: userGroupHeader, fieldType: fieldType })=>{
    const data = (0, $j4oe4.useFragment)((0, $dx1Wj.default), userGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let displayName;
    if ((0, $7jTnu.fg)('group_by_any_fields_technical')) {
        let noValueText;
        switch(fieldType){
            case 0, $814y1.ASSIGNEE_TYPE:
                noValueText = formatMessage((0, $8vugl.default).unassignedDisplayName);
                break;
            case 0, $814y1.USER_CF_TYPE:
                noValueText = formatMessage((0, $8vugl.default).noUserDisplayName);
                break;
            case 0, $814y1.REPORTER_TYPE:
                noValueText = formatMessage((0, $8vugl.default).anonymousDisplayName);
                break;
            default:
                noValueText = null;
        }
        displayName = data?.displayName ?? noValueText;
    } else displayName = data?.displayName ?? formatMessage((0, $8vugl.default).unassignedDisplayName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4UiGa.AvatarLite), {
        avatarUrl: data.user?.picture
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "circle",
        src: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, displayName));
};

});
parcelRegister("dx1Wj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f33fddc8297b6b47$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b902e234c0d2c419537ba8bf4085b8a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f33fddc8297b6b47$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "userGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                }
            ]
        }
    ],
    "type": "JiraJqlUserFieldValue"
};
$f33fddc8297b6b47$var$node.hash = "0f23b32be06ea51411482617cee8a9c0";
var $f33fddc8297b6b47$export$2e2bcd8739ae039 = $f33fddc8297b6b47$var$node;

});

parcelRegister("4UiGa", function(module, exports) {

$parcel$export(module.exports, "AvatarLite", () => $cb3b12b2e97c8824$export$8b9560cc4e12c651);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $cb3b12b2e97c8824$var$AVATAR_SIZE = 24;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb3b12b2e97c8824$var$Avatar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { avatarUrl: avatarUrl, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fzlxay": (0, $awdRS.default)(`url(${__cmplp.avatarUrl})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1ssb _12ji1r31 _1qu2glyw _12y3idpf _1itk1v7f _ouxl1ssb _12vemgnk _1lrw1dfr _bfhk18uv _vchh18uv _4t3i1tcg _1bsb1tcg _1ul91tcg _1tke1tcg _1e0c1o8l _kqswh2mm _80om1kw7 _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.isHighlighted ? "_16qsa9gh" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $cb3b12b2e97c8824$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $cb3b12b2e97c8824$export$8b9560cc4e12c651 = /*#__PURE__*/ (0, $eJOHy.memo)(({ avatarUrl: avatarUrl, name: name = '', highlight: highlight, testId: testId })=>{
    const isHighlighted = highlight && highlight.some($cb3b12b2e97c8824$var$hasKeywords(name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cb3b12b2e97c8824$var$Avatar, {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        avatarUrl: avatarUrl,
        title: name,
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        isHighlighted: isHighlighted,
        "data-testid": testId
    });
});

});

parcelRegister("8vugl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9aa0597a71f459f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f9aa0597a71f459f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    unassignedDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.assignee-group-header.unassigned-display-name",
        "defaultMessage": "Unassigned"
    },
    noUserDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.user-group-header.no-user-display-name-nonfinal",
        "defaultMessage": "None"
    },
    anonymousDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.user-group-header.anonymous-display-name-nonfinal",
        "defaultMessage": "Anonymous"
    }
});

});


parcelRegister("bwwaP", function(module, exports) {

$parcel$export(module.exports, "ResolutionGroupHeader", () => $3b9742564e699517$export$d4278b92a1d7dd0c);

var $1NyYL = parcelRequire("1NyYL");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $6w3tC = parcelRequire("6w3tC");

var $gA8Ur = parcelRequire("gA8Ur");
const $3b9742564e699517$export$d4278b92a1d7dd0c = ({ resolutionGroupHeader: resolutionGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $1NyYL.default), resolutionGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.displayName || data?.resolution?.name || data?.resolution?.id,
        noValueText: formatMessage((0, $gA8Ur.default).noResolution)
    });
};

});
parcelRegister("1NyYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c295e8e891f2c705$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<51f9f744203c7ef37161cb984a2e4096>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c295e8e891f2c705$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "resolutionGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraResolution",
            "kind": "LinkedField",
            "name": "resolution",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraJqlResolutionFieldValue"
};
$c295e8e891f2c705$var$node.hash = "b210ce2bdf11caef915ebd09c93be95b";
var $c295e8e891f2c705$export$2e2bcd8739ae039 = $c295e8e891f2c705$var$node;

});

parcelRegister("gA8Ur", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ffefe9700680e82$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9ffefe9700680e82$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noResolution: {
        "id": "issue-table-grouping.group-row.group-header.resolution-group-header.no-resolution-non-final",
        "defaultMessage": "No value"
    }
});

});




parcelRegister("3fA0C", function(module, exports) {

$parcel$export(module.exports, "Rows", () => $deb69377f8c66ef1$export$9ba739f4e3fc4d9);

var $4YzlL = parcelRequire("4YzlL");

var $5jCqD = parcelRequire("5jCqD");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $68iTT = parcelRequire("68iTT");

var $4xbv3 = parcelRequire("4xbv3");

var $jBNts = parcelRequire("jBNts");

var $6d9QY = parcelRequire("6d9QY");

var $jE8Tu = parcelRequire("jE8Tu");

var $aqT6C = parcelRequire("aqT6C");

var $34oCh = parcelRequire("34oCh");

var $2N0PS = parcelRequire("2N0PS");

var $2UC2O = parcelRequire("2UC2O");

var $jNv5I = parcelRequire("jNv5I");

var $km3XC = parcelRequire("km3XC");

var $8lwz0 = parcelRequire("8lwz0");
const $deb69377f8c66ef1$var$HierarchyRow = /*#__PURE__*/ (0, $eJOHy.memo)(({ project: project, depth: depth, itemsConnectionId: itemsConnectionId, rankFieldId: rankFieldId, parentItemConnectionId: parentItemConnectionId, parentIssueAri: parentIssueAri, parentIssueHierarchyLevel: parentIssueHierarchyLevel, rowsData: rowsData, index: index, isVirtual: isVirtual, isIssueHierarchyEnabled: isIssueHierarchyEnabled, measureElement: measureElement, projectKey: projectKey })=>{
    const issueRow = rowsData?.edges?.[index];
    const hierarchyLevel = issueRow?.node?.issueTypeField?.issueType?.hierarchy?.level;
    const { renderChildRows: renderChildRows } = (0, $jNv5I.useRowContext)();
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $68iTT.useInlineCreateHandlers)({
        projectKey: (0, $34oCh.useProjectContext)(),
        ...hierarchyLevel != null && {
            minHierarchyLevel: hierarchyLevel - 1,
            maxHierarchyLevel: hierarchyLevel - 1
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            rowIndex: index,
            tableRowNumber: index
        }
    }, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2N0PS.default), {
        project: project,
        rankFieldId: rankFieldId,
        rowIndex: index,
        itemsConnectionId: rowsData.__id,
        issue: issueRow?.node ?? null,
        issueEdge: issueRow ?? null,
        fieldSets: issueRow?.fieldSets ?? null,
        depth: depth,
        parentIssueAri: parentIssueAri,
        parentItemConnectionId: parentItemConnectionId,
        parentIssueRelayConnectionId: itemsConnectionId,
        parentIssueHierarchyLevel: parentIssueHierarchyLevel,
        triggerProps: triggerProps,
        isFormVisible: isFormVisible,
        measureElement: measureElement,
        ...(0, $7jTnu.fg)('jsc_list_reparenting') ? {
            hierarchyLevel: hierarchyLevel,
            issueKey: issueRow?.node?.key,
            projectKey: projectKey
        } : {}
    }), issueRow?.node?.issueId && isIssueHierarchyEnabled && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') && renderChildRows?.({
        issueKey: issueRow?.node?.key,
        parentItemId: issueRow?.node?.issueId,
        itemsConnectionId: rowsData.__id,
        depth: depth,
        parentIssueAri: issueRow?.node?.id,
        parentItemConnectionId: issueRow?.__id,
        parentIssueRelayConnectionId: itemsConnectionId,
        parentIssueHierarchyLevel: hierarchyLevel,
        type: 'PARENT_CHILDREN',
        isFormVisible: isFormVisible,
        formProps: formProps,
        hasChildren: issueRow?.hasChildren ?? false
    }));
});
const $deb69377f8c66ef1$export$9ba739f4e3fc4d9 = ({ project: project, projectKey: projectKey, issueResults: issueResults, rankFieldId: rankFieldId, depth: depth = 0, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, parentIssueHierarchyLevel: parentIssueHierarchyLevel, isLoadingNext: isLoadingNext, hasNext: hasNext, isChildIssueCreateRowVisible: isChildIssueCreateRowVisible, onLoadNextItems: onLoadNextItems, renderChildIssueCreateRow: renderChildIssueCreateRow })=>{
    const rowsData = (0, $j4oe4.useFragment)((0, $5jCqD.default), issueResults);
    const projectData = (0, $j4oe4.useFragment)((0, $4YzlL.default), project ?? null);
    let isIssueHierarchyEnabled = false;
    let populateConnection = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ populateConnection: populateConnection } = (0, $jE8Tu.useHierarchyActions)());
    }
    const { columns: columns, groupId: groupId } = (0, $jNv5I.useRowContext)();
    const populateConnectionArgs = (0, $eJOHy.useMemo)(()=>({
            parentItemId: parentItemId,
            itemsConnectionId: rowsData.__id,
            parentConnectionId: itemsConnectionId,
            list: rowsData?.edges?.map((edge)=>edge?.node && {
                    key: edge.node.key,
                    itemId: edge.node.issueId,
                    groupId: groupId
                }).filter(Boolean) ?? [],
            hasNext: hasNext,
            groupId: groupId,
            isChildIssueCreateRowVisible: isChildIssueCreateRowVisible
        }), [
        parentItemId,
        itemsConnectionId,
        rowsData.__id,
        rowsData?.edges,
        hasNext,
        groupId,
        isChildIssueCreateRowVisible
    ]);
    const prevPopulateConnectArgs = (0, $6d9QY.usePrevious)(populateConnectionArgs);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(populateConnectionArgs, prevPopulateConnectArgs) && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) populateConnection(populateConnectionArgs);
    const renderRowItem = (0, $eJOHy.useCallback)((index, measureElement)=>{
        const issueRow = rowsData?.edges?.[index];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            key: issueRow?.node?.key || index,
            attributes: {
                rowIndex: index,
                tableRowNumber: index
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2N0PS.default), {
            project: projectData,
            rowIndex: index,
            rankFieldId: rankFieldId,
            itemsConnectionId: rowsData.__id,
            issue: issueRow?.node ?? null,
            issueEdge: issueRow ?? null,
            fieldSets: issueRow?.fieldSets ?? null,
            depth: depth,
            parentIssueAri: parentIssueAri,
            parentItemConnectionId: parentItemConnectionId,
            parentIssueRelayConnectionId: parentIssueRelayConnectionId,
            parentIssueHierarchyLevel: parentIssueHierarchyLevel,
            measureElement: measureElement,
            ...(0, $7jTnu.fg)('jsc_list_reparenting') ? {
                projectKey: projectKey,
                issueKey: issueRow?.node?.key
            } : {}
        }));
    }, [
        projectData,
        rowsData?.edges,
        rowsData.__id,
        rankFieldId,
        depth,
        parentIssueAri,
        parentItemConnectionId,
        parentIssueRelayConnectionId,
        parentIssueHierarchyLevel,
        projectKey
    ]);
    const renderRows = (0, $eJOHy.useCallback)((isItemVirtual, measureElement)=>{
        if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) {
            const childIssueCreateItemId = (0, $jBNts.getFlatListKey)({
                itemId: (0, $jE8Tu.getChildIssueCreateItemKey)(parentItemId),
                groupId: groupId
            });
            const isChildIssueCreateRowVirtual = isItemVirtual?.(childIssueCreateItemId) ?? true;
            const showMoreItemId = (0, $jBNts.getFlatListKey)({
                itemId: (0, $jE8Tu.getShowMoreItemKey)(parentItemId),
                groupId: groupId
            });
            const isShowMoreItemVirtual = isItemVirtual?.(showMoreItemId) ?? true;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isChildIssueCreateRowVirtual && renderChildIssueCreateRow?.(), rowsData?.edges?.map((edge, index)=>{
                const flatListIssueId = (0, $jBNts.getFlatListKey)({
                    itemId: edge?.node?.issueId ?? '',
                    groupId: groupId
                });
                const isVirtual = isItemVirtual?.(flatListIssueId) ?? true;
                return isIssueHierarchyEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($deb69377f8c66ef1$var$HierarchyRow, {
                    project: projectData,
                    key: flatListIssueId,
                    rankFieldId: rankFieldId,
                    itemsConnectionId: itemsConnectionId,
                    isVirtual: isVirtual,
                    index: index,
                    rowsData: rowsData,
                    depth: depth,
                    parentItemConnectionId: parentItemConnectionId ?? '',
                    parentIssueAri: parentIssueAri ?? '',
                    parentIssueHierarchyLevel: parentIssueHierarchyLevel,
                    isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                    measureElement: measureElement,
                    projectKey: projectKey
                }) : isVirtual && renderRowItem(index, measureElement);
            }), hasNext && isShowMoreItemVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aqT6C.LoadMoreItemsRow), {
                isLoadingNext: isLoadingNext,
                columnsCount: columns.length,
                loadNext: onLoadNextItems ?? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
            }), (0, $7jTnu.fg)('jira_native_issue_table_extra_custom_components') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UC2O.RowsAdditionalContentRenderer), {
                depth: depth,
                groupId: groupId,
                issues: rowsData,
                parentItemId: parentItemId
            }));
        }
        return rowsData?.edges?.map((_, index)=>renderRowItem(index, measureElement) ?? null);
    }, [
        projectData,
        columns.length,
        depth,
        groupId,
        hasNext,
        isIssueHierarchyEnabled,
        isLoadingNext,
        itemsConnectionId,
        onLoadNextItems,
        parentIssueAri,
        parentIssueHierarchyLevel,
        parentItemConnectionId,
        parentItemId,
        projectKey,
        rankFieldId,
        renderChildIssueCreateRow,
        renderRowItem,
        rowsData
    ]);
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    if (isVirtualizationEnabled) {
        if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) {
            const isGrouping = Boolean(groupId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $km3XC.VirtualizedRows), {
                hasSpacers: depth === 0 && !isGrouping,
                columnsCount: columns.length
            }, renderRows);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lwz0.VirtualizedRows), {
            renderRow: renderRowItem
        }, renderRows);
    }
    return renderRows();
};

});
parcelRegister("4YzlL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e02b545e2e18643$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c06a595d30a83891fcced5f125ec317e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9e02b545e2e18643$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "rows_jiraProject",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_project"
        }
    ],
    "type": "JiraProject"
};
$9e02b545e2e18643$var$node.hash = "191ecc0805ec45cf34336a9298bd8638";
var $9e02b545e2e18643$export$2e2bcd8739ae039 = $9e02b545e2e18643$var$node;

});

parcelRegister("5jCqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8abd721188630cca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d72b8e81e5850a2a85cf32e062ddd0cf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8abd721188630cca$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "isDensityFull",
        "variableName": "isDensityFull"
    }, v1 = {
        "kind": "Variable",
        "name": "isTimelineEnabled",
        "variableName": "isTimelineEnabled"
    }, v2 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "rows_nativeIssueTable_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "isReparentingEnabled",
                                "variableName": "isReparentingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Variable",
                                "name": "shouldQueryHasChildren",
                                "variableName": "shouldQueryHasChildren"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "row_nativeIssueTable_issueEdge"
                    },
                    {
                        "condition": "shouldQueryHasChildren",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterByProjectKeys",
                                        "variableName": "projectKeys"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "hasChildren"
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "issueId"
                            },
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                                "kind": "LinkedField",
                                                "name": "hierarchy",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "level"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v0 /*: any*/ 
                                ],
                                "kind": "FragmentSpread",
                                "name": "row_nativeIssueTable_issue"
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 500
                            }
                        ],
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "isConditionalFormattingEnabled",
                                        "variableName": "isConditionalFormattingEnabled"
                                    },
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "isInlineEditingEnabled",
                                        "variableName": "isInlineEditingEnabled"
                                    },
                                    v1 /*: any*/ 
                                ],
                                "kind": "FragmentSpread",
                                "name": "row_nativeIssueTable_fieldSets"
                            }
                        ],
                        "storageKey": "fieldSets(first:500)"
                    },
                    v2 /*: any*/ 
                ]
            },
            {
                "args": [
                    v1 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "rowsAdditionalContentRenderer_nativeIssueTable"
            },
            v2 /*: any*/ 
        ],
        "type": "JiraIssueConnection"
    };
}();
$8abd721188630cca$var$node.hash = "ae55dee72afc6cb6156702a8ab3cb8c6";
var $8abd721188630cca$export$2e2bcd8739ae039 = $8abd721188630cca$var$node;

});

parcelRegister("aqT6C", function(module, exports) {

$parcel$export(module.exports, "LoadMoreItemsRow", () => $1118dff792cb08d1$export$23063d416e023423);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $bKlUQ = parcelRequire("bKlUQ");

var $aIvQb = parcelRequire("aIvQb");
const $1118dff792cb08d1$var$ROW_HEIGHT = 40;
const $1118dff792cb08d1$export$23063d416e023423 = ({ loadNext: loadNext, isLoadingNext: isLoadingNext = false, columnsCount: columnsCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "tr",
        xcss: $1118dff792cb08d1$var$rowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: $1118dff792cb08d1$var$cellBorderStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: $1118dff792cb08d1$var$cellBorderStyles,
        colSpan: columnsCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        spacing: "compact",
        isDisabled: isLoadingNext,
        onClick: loadNext
    }, isLoadingNext ? formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aIvQb.default).loadingMoreItemsIssueTermRefresh : (0, $aIvQb.default).loadingMoreItems) : formatMessage((0, $aIvQb.default).showMore))));
};
const $1118dff792cb08d1$var$rowStyles = (0, $1DXK0.xcss)({
    height: `${$1118dff792cb08d1$var$ROW_HEIGHT}px`,
    backgroundColor: 'elevation.surface'
});
const $1118dff792cb08d1$var$cellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: 'border.width',
    borderBottomWidth: '0',
    borderLeftWidth: '0',
    borderRightWidth: '0'
});

});
parcelRegister("bKlUQ", function(module, exports) {

$parcel$export(module.exports, "TableCell", () => $939ec101f3206f90$export$1e4baea7053fc0e3);

var $eJOHy = parcelRequire("eJOHy");

var $buoPQ = parcelRequire("buoPQ");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $ibVOD = parcelRequire("ibVOD");

var $johMb = parcelRequire("johMb");

var $34oCh = parcelRequire("34oCh");

var $hHg7L = parcelRequire("hHg7L");
const $939ec101f3206f90$export$1e4baea7053fc0e3 = (props)=>{
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    return isSingleLineRowHeightEnabled && !(0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($939ec101f3206f90$var$TableCellInner, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($939ec101f3206f90$var$TableCellInner, props);
};
const $939ec101f3206f90$var$TableCellInner = ({ children: children, border: border, spacing: spacing, formatting: formatting, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isColumnResizing: isColumnResizing, hasRightShadow: hasRightShadow, fieldId: fieldId, ...htmlAttributes })=>{
    const spacingStyles = spacing !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(spacing) : [
        $939ec101f3206f90$var$defaultSpacingStyles
    ];
    const borderStyles = border !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(border) : [];
    const formattingStyles = formatting !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(formatting) : [];
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const eventDelegatorRef = isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hHg7L.useEventDelegatorRef)(fieldId) : null;
    let singleLineRowHeightProps = {};
    if (isSingleLineRowHeightEnabled && !(0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave } = (0, $ibVOD.useCellHoverHandlers)();
        singleLineRowHeightProps = {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        };
    }
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td",
        xcss: [
            $939ec101f3206f90$var$baseStyles,
            ...spacingStyles,
            ...borderStyles,
            ...isConditionalFormattingEnabled ? formattingStyles : [],
            isGridNavigationEnabled && $939ec101f3206f90$var$keyboardNavigationStyles,
            isGridNavigationEnabled && $939ec101f3206f90$var$keyboardNavigationPointerEventsStyles,
            isColumnSticky && (0, $7jTnu.fg)('issue_table_frozen_columns') && $939ec101f3206f90$var$stickyStyles,
            hasRightShadow && (0, $7jTnu.fg)('issue_table_frozen_columns') && $939ec101f3206f90$var$shadowStyles
        ],
        ...htmlAttributes,
        ...isSingleLineRowHeightEnabled && !(0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') && singleLineRowHeightProps,
        ...isGridNavigationEnabled && {
            tabIndex: -1
        },
        ...(0, $7jTnu.fg)('issue_table_frozen_columns') && {
            style: {
                ...htmlAttributes.style,
                left: isColumnSticky ? (0, $johMb.getColumnOffset)(stickyOffsets ?? 0, !!isColumnResizing) : undefined,
                zIndex: isColumnSticky ? 2 : undefined
            }
        },
        ...eventDelegatorRef && {
            ref: eventDelegatorRef
        }
    }, children);
};
const $939ec101f3206f90$var$baseStyles = (0, $1DXK0.xcss)({
    background: 'inherit',
    // Cross-browser CSS hack to allow inline editable fields to fill the entire space of their `td`. The
    // preferred long-term solution is to adopt a flexbox layout, but until then, please do extensive
    // cross-browser testing before you update this rule.
    height: '100%',
    position: 'relative'
});
const $939ec101f3206f90$var$keyboardNavigationStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    ':focus': {
        outline: 'unset'
    },
    ':focus::before': {
        display: 'block',
        content: '" "',
        position: 'absolute',
        height: '100%',
        width: '100%',
        inset: '0px',
        borderColor: 'color.border.focused',
        borderWidth: 'border.width.outline',
        borderStyle: 'solid',
        boxSizing: 'border-box'
    }
});
// Move into keyboardNavigationStyles when cleaning fg('nin-grid-keyboard-navigation-fast-follow-1')
const $939ec101f3206f90$var$keyboardNavigationPointerEventsStyles = (0, $1DXK0.xcss)({
    ':focus::before': {
        pointerEvents: 'none'
    }
});
const $939ec101f3206f90$var$defaultSpacingStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingLeft: 'space.100'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        paddingRight: 'space.100'
    }
});
const $939ec101f3206f90$var$stickyStyles = (0, $1DXK0.xcss)({
    position: 'sticky'
});
const $939ec101f3206f90$var$shadowStyles = (0, $1DXK0.xcss)({
    '::after': {
        height: '100%',
        width: '4px',
        content: "''",
        opacity: 0.5,
        transition: 'opacity 0.25s',
        background: 'linear-gradient(90deg, #0000001a 0%, #0000)',
        position: 'absolute',
        right: '-5px',
        top: 'space.0'
    }
});

});
parcelRegister("johMb", function(module, exports) {

$parcel$export(module.exports, "getExpandColumnWidth", () => $20ef55c956fe2fc8$export$6344c84966147aa0);
$parcel$export(module.exports, "getColumnOffset", () => $20ef55c956fe2fc8$export$3e2d9135e2882f1d);

var $8jOO7 = parcelRequire("8jOO7");
const $20ef55c956fe2fc8$export$6344c84966147aa0 = (depth)=>depth * (0, $8jOO7.DEPTH_WIDTH) + (0, $8jOO7.EXPAND_BUTTON_WIDTH) + (0, $8jOO7.CREATE_CHILD_BUTTON_WIDTH) + (0, $8jOO7.EXPAND_CELL_PADDING);
const $20ef55c956fe2fc8$export$3e2d9135e2882f1d = (stickyOffsets, isResizing)=>{
    if (isResizing) return `calc(${stickyOffsets}px + var(--local-resizing-offset, 0px))`;
    return `${stickyOffsets}px`;
};

});


parcelRegister("aIvQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7f7f80423ad6969$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a7f7f80423ad6969$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showMore: {
        "id": "native-issue-table.common.load-more-items-row.show-more",
        "defaultMessage": "Show more"
    },
    loadingMoreItems: {
        "id": "native-issue-table.common.load-more-items-row.loading-more-items",
        "defaultMessage": "Loading more issues"
    },
    loadingMoreItemsIssueTermRefresh: {
        "id": "native-issue-table.common.load-more-items-row.loading-more-items-issue-term-refresh",
        "defaultMessage": "Loading more"
    }
});

});


parcelRegister("2N0PS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3b12007bc04643a$export$2e2bcd8739ae039);

var $lMOdu = parcelRequire("lMOdu");

var $ioHwy = parcelRequire("ioHwy");

var $btFWS = parcelRequire("btFWS");

var $odtPM = parcelRequire("odtPM");

var $479fo = parcelRequire("479fo");

var $5TZ76 = parcelRequire("5TZ76");

var $5dPdd = parcelRequire("5dPdd");

var $8wgBN = parcelRequire("8wgBN");

var $8wx8F = parcelRequire("8wx8F");

var $22PsM = parcelRequire("22PsM");

var $6aJiT = parcelRequire("6aJiT");

var $bcyaZ = parcelRequire("bcyaZ");

var $hcgC7 = parcelRequire("hcgC7");

var $iT0ZD = parcelRequire("iT0ZD");

var $jWhOS = parcelRequire("jWhOS");

var $iHcjJ = parcelRequire("iHcjJ");

var $3DEfF = parcelRequire("3DEfF");

var $kejcI = parcelRequire("kejcI");

var $dCDjU = parcelRequire("dCDjU");

var $eoGrZ = parcelRequire("eoGrZ");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $1DXK0 = parcelRequire("1DXK0");

var $16sa1 = parcelRequire("16sa1");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $68iTT = parcelRequire("68iTT");

var $jd93d = parcelRequire("jd93d");

var $6d9QY = parcelRequire("6d9QY");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $jE8Tu = parcelRequire("jE8Tu");

var $jBNts = parcelRequire("jBNts");

var $bJscI = parcelRequire("bJscI");

var $l4EsH = parcelRequire("l4EsH");

var $7n9BS = parcelRequire("7n9BS");

var $34oCh = parcelRequire("34oCh");

var $bnxIc = parcelRequire("bnxIc");

var $3TtKq = parcelRequire("3TtKq");

var $4NiKr = parcelRequire("4NiKr");

var $3F6xT = parcelRequire("3F6xT");

var $jNv5I = parcelRequire("jNv5I");

var $lRgXM = parcelRequire("lRgXM");

var $29rOm = parcelRequire("29rOm");

var $7EMZm = parcelRequire("7EMZm");

var $6tbsq = parcelRequire("6tbsq");

var $fY66e = parcelRequire("fY66e");
const $c3b12007bc04643a$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-row",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $c3b12007bc04643a$var$RowWithSiblingCreate = (props)=>{
    const { itemsConnectionId: itemsConnectionId, rowIndex: rowIndex, parentIssueAri: parentIssueAri, rankFieldId: rankFieldId, parentIssueHierarchyLevel: parentIssueHierarchyLevel } = props;
    const projectRef = (0, $j4oe4.useFragment)((0, $eoGrZ.default), props.project);
    const issueRowDataOld = (0, $j4oe4.useFragment)((0, $dCDjU.default), props.issue);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $kejcI.default), props.issueEdge);
    const issueRowData = (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? issueRowEdgeData?.node : issueRowDataOld;
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $3DEfF.default), props.fieldSets);
    const { onMouseLeave: onMouseLeave, onMouseMove: onMouseMove } = (0, $4NiKr.useSiblingIssueCreateHandler)(itemsConnectionId, rowIndex);
    const projectContext = (0, $34oCh.useProjectContext)();
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $68iTT.useInlineCreateHandlers)({
        projectKey: projectContext,
        ...parentIssueHierarchyLevel != null && (0, $7jTnu.fg)('jsc_list_reranking_gate') ? {
            minHierarchyLevel: parentIssueHierarchyLevel - 1,
            maxHierarchyLevel: parentIssueHierarchyLevel - 1
        } : {
            minHierarchyLevel: 0
        }
    });
    const issueCreateRowContext = (0, $eJOHy.useMemo)(()=>({
            isFormVisible: isFormVisible,
            triggerProps: triggerProps
        }), [
        isFormVisible,
        triggerProps
    ]);
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    const issueCreateRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7EMZm.IssueCreateRow), {
        depth: 0,
        isGrouping: !!groupId && (0, $7jTnu.fg)('jira_list_merged_column_gate'),
        isFormVisible: isFormVisible,
        issuesConnectionId: itemsConnectionId,
        siblingIssueId: issueRowData?.id ?? '',
        rankFieldId: rankFieldId,
        parentIssueAri: parentIssueAri,
        ...(0, $7jTnu.fg)('jsc_list_reranking_gate') && {
            location: 'siblingCreateForm'
        },
        ...formProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NiKr.SiblingIssueCreateRowContext).Provider, {
        value: issueCreateRowContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c3b12007bc04643a$var$MaybeRowWithDragAndDrop, {
        ...props,
        project: projectRef,
        issue: issueRowDataOld ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        beforeRow: issueCreateRow
    }));
};
const $c3b12007bc04643a$var$RowWithDragAndDrop = (props)=>{
    const projectRef = (0, $j4oe4.useFragment)((0, $iHcjJ.default), props.project);
    const issueRowDataOld = (0, $j4oe4.useFragment)((0, $jWhOS.default), props.issue);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $iT0ZD.default), props.issueEdge);
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $hcgC7.default), props.fieldSets);
    const issueRowData = (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? issueRowEdgeData?.node : issueRowDataOld;
    const draggableRef = (0, $l4EsH.useDraggableRow)({
        edgeIndex: props.rowIndex,
        issueId: issueRowData?.id ?? '',
        hierarchyLevel: props.hierarchyLevel,
        parentIssueAri: props.parentIssueAri,
        parentIssueEdgeRelayId: props.parentItemConnectionId,
        parentIssueConnectionId: props.parentIssueRelayConnectionId,
        issueEdgeRelayId: issueRowEdgeData?.__id,
        depth: props.depth,
        itemsConnectionId: props.itemsConnectionId,
        projectKey: props.projectKey,
        hasChildren: Boolean(issueRowEdgeData?.hasChildren),
        issueKey: props.issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c3b12007bc04643a$var$MaybeMemoRowInner, {
        ...props,
        issue: issueRowDataOld ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: projectRef,
        ref: draggableRef
    });
};
const $c3b12007bc04643a$var$MaybeRowWithDragAndDrop = (props)=>{
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    const projectRef = (0, $j4oe4.useFragment)((0, $bcyaZ.default), props.project);
    const issueRowDataOld = (0, $j4oe4.useFragment)((0, $6aJiT.default), props.issue);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $22PsM.default), props.issueEdge);
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $8wx8F.default), props.fieldSets);
    if (isDragAndDropEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c3b12007bc04643a$var$RowWithDragAndDrop, {
        ...props,
        issue: issueRowDataOld ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: projectRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c3b12007bc04643a$var$MaybeMemoRowInner, {
        ...props,
        project: projectRef,
        issue: issueRowDataOld ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null
    });
};
const $c3b12007bc04643a$var$RowInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, forwardedRef)=>{
    const { rowIndex: rowIndex, project: project, issue: issue, issueEdge: issueEdge, fieldSets: fieldSets, itemsConnectionId: itemsConnectionId, depth: depth, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, beforeRow: beforeRow, triggerProps: triggerProps, isFormVisible: isFormVisible, parentIssueAri: parentIssueAri, parentIssueRelayConnectionId: parentIssueRelayConnectionId, measureElement: measureElement = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), hierarchyLevel: hierarchyLevel, issueKey: issueKey, projectKey: projectKey } = props;
    const tableRowRef = (0, $eJOHy.useRef)(null);
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    const projectRef = (0, $j4oe4.useFragment)((0, $8wgBN.default), project);
    const issueRowDataOld = (0, $j4oe4.useFragment)((0, $5dPdd.default), issue);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $5TZ76.default), issueEdge);
    const issueRowData = (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? issueRowEdgeData?.node : issueRowDataOld;
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $479fo.default), fieldSets);
    const itemDetails = (0, $eJOHy.useMemo)(()=>issueRowData ? {
            itemsConnectionId: itemsConnectionId,
            itemId: issueRowData.issueId,
            groupId: groupId
        } : null, [
        issueRowData,
        itemsConnectionId,
        groupId
    ]); // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const list = isGridNavigationEnabled ? (0, $jE8Tu.useFlatList)() : [];
    const [isSelected, { setSelectedRow: setSelectedRow }] = (0, $bnxIc.useIsSelected)(itemDetails, {
        selectedRowIndex: rowIndex
    });
    const prevIsSelected = (0, $6d9QY.usePreviousWithInitial)(isSelected);
    const [isFocused, { resetFocus: resetFocus }] = (0, $bnxIc.useIsFocused)(itemDetails, {
        selectedRowIndex: rowIndex
    });
    const [isRowHovered, setIsRowHovered] = (0, $eJOHy.useState)(false);
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    const isEntireRowDraggable = (0, $34oCh.useIsEntireRowDraggable)();
    const isReParentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const [currentDraggingRow, setCurrentDraggingRow] = (0, $eJOHy.useState)(null);
    const isScrolling = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.isScrolling);
    const isIssueSelected = (0, $3TtKq.useIsIssueSelected)(issueRowData?.issueId ?? '');
    (0, $eJOHy.useEffect)(()=>{
        // Explicitly reset our internal state to track which row is focused. We do this to prevent the DOM element being re-focused unintentionally when the component is re-rendered.
        if (isFocused) resetFocus();
    }, [
        isFocused,
        resetFocus
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    let isIssueHierarchyEnabled = false;
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    const onMouseOverHandler = (0, $eJOHy.useCallback)(()=>{
        if (!isScrolling && (isIssueHierarchyEnabled && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') || isConditionalFormattingEnabled || isDragAndDropEnabled || isGridNavigationEnabled && (0, $7jTnu.fg)('jira_list_merged_column_inline_create_icon_style'))) setIsRowHovered(true);
    }, [
        isScrolling,
        isIssueHierarchyEnabled,
        isConditionalFormattingEnabled,
        isDragAndDropEnabled,
        isGridNavigationEnabled
    ]);
    const onMouseLeaveHandler = (0, $eJOHy.useCallback)((e)=>{
        onMouseLeave?.(e);
        if (isIssueHierarchyEnabled && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') || isConditionalFormattingEnabled || isDragAndDropEnabled || isGridNavigationEnabled && (0, $7jTnu.fg)('jira_list_merged_column_inline_create_icon_style')) setIsRowHovered(false);
    }, [
        onMouseLeave,
        isIssueHierarchyEnabled,
        isConditionalFormattingEnabled,
        isDragAndDropEnabled,
        isGridNavigationEnabled
    ]);
    const focusCurrentRow = (0, $eJOHy.useCallback)(()=>{
        return setSelectedRow(// The method below has a different signature compared to the old implementation which leads to this type error which is not trivial to solve
        // @ts-expect-error - TS2345: Argument of type '[number | { itemsConnectionId: string; itemId: string; }]' is not assignable to parameter of type '{ itemsConnectionId: string; itemId: string; } & number'
        (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? itemDetails : rowIndex);
    }, [
        setSelectedRow,
        itemDetails,
        rowIndex
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const clickAnalytics = createAnalyticsEvent({});
        const actionSubjectId = issueRowData ? 'issueRow' : 'blankRow';
        (0, $gCeeo.fireUIAnalytics)(clickAnalytics, 'rowItem clicked', actionSubjectId);
    }, [
        createAnalyticsEvent,
        issueRowData
    ]);
    const isColumnBordersEnabled = (0, $34oCh.useIsColumnBordersEnabled)();
    const isGrouping = !!groupId && (0, $epTsa.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false);
    const cellBorder = (0, $eJOHy.useMemo)(()=>[
            isColumnBordersEnabled ? $c3b12007bc04643a$var$cellBorderStyles : $c3b12007bc04643a$var$cellBorderStylesWithNoColumn,
            rowIndex === 0 && !parentIssueAri && !isGrouping && $c3b12007bc04643a$var$firstRowCellBorderStyles
        ], [
        parentIssueAri,
        rowIndex,
        isColumnBordersEnabled,
        isGrouping
    ]); // when cleaning up jsc_m2_hierarchy_fe_changes, replace issueRowDataOld with issueRowEdgeData, and ensure it is a required property
    const rowContent = issueRowDataOld ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6tbsq.IssueRow), {
        project: projectRef,
        issue: issueRowDataOld,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        cellBorder: cellBorder,
        beforeFirstCell: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRgXM.BeforeFirstCell), {
            edgeIndex: rowIndex,
            issueId: issueRowDataOld.id,
            itemsConnectionId: itemsConnectionId,
            hierarchyLevel: hierarchyLevel,
            parentIssueAri: parentIssueAri,
            parentIssueConnectionId: parentIssueRelayConnectionId,
            issueKey: issueKey,
            projectKey: projectKey,
            ...isDragAndDropEnabled ? {
                isRowHovered: isRowHovered
            } : {},
            ...isReParentingEnabled ? {
                issueRowData: issueRowEdgeData?.node || null,
                setCurrentDraggingRow: setCurrentDraggingRow
            } : {
                issueRowData: null
            }
        }),
        itemsConnectionId: itemsConnectionId,
        depth: depth,
        isRowHoveredOrSelected: isFocused || isSelected || isRowHovered,
        rowIndex: rowIndex,
        triggerProps: triggerProps,
        isFormVisible: isFormVisible
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $29rOm.default), {
        isSelected: isSelected,
        cellBorder: cellBorder
    }); /**
                                                                                                                                                                                                                                                                                     * Only scroll table row into view when it's a _newly_ selected row.
                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                     * We keep track of the prev selected state to avoid jumping to the selected row on mount. This issue
                                                                                                                                                                                                                                                                                     * was introduced when we enabled virtualization as part of the infinite scroll work.
                                                                                                                                                                                                                                                                                     * @see https://getsupport.atlassian.com/browse/PCS-359806
                                                                                                                                                                                                                                                                                     */ 
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isSelected && isSelected !== prevIsSelected) tableRowRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        isSelected,
        prevIsSelected
    ]);
    const highlightFadeOut = (0, $eJOHy.useRef)(false);
    const onInterceptionItemRef = (0, $3F6xT.useObserveItem)(issueRowData?.id);
    let trRef = (0, $jd93d.default)(onInterceptionItemRef, tableRowRef, forwardedRef);
    const isHighlighted = issueRowData?.isHighlightedIssueRow ?? false;
    const prevIsHighlighted = (0, $6d9QY.usePrevious)(isHighlighted); // Begin fade out animation when isHighlighted changes to false
    if (prevIsHighlighted && !isHighlighted) highlightFadeOut.current = true;
    trRef = (0, $jd93d.default)(trRef, measureElement);
    let itemKey = null;
    if (itemsConnectionId && issueRowData?.id) itemKey = (0, $jE8Tu.getItemKey)(itemsConnectionId, issueRowData.id);
    const overallRowIndex = itemDetails && isGridNavigationEnabled ? list.indexOf((0, $jBNts.getFlatListKey)(itemDetails)) + 1 : -1;
    const color = (0, $7jTnu.fg)('jira_list_conditional_formatting') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fY66e.useRowColor)(fieldSetsData, projectRef) : undefined; // placeholder for what will be const color = useRowColor in the future.
    // TODO: Move inside `css` prop on `jsc-2065-unify-onrowreorder` cleanup
    const shouldHaveDraggableRowStyles = (0, $7jTnu.fg)('jsc-2065-unify-onrowreorder') ? isDragAndDropEnabled && isEntireRowDraggable : isEntireRowDraggable;
    const isRenderedInOverlay = (0, $34oCh.useIsRenderedInOverlay)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeRow, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c3b12007bc04643a$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "native-issue-table.ui.issue-row",
        "aria-selected": isIssueSelected && isGridNavigationEnabled || isSelected,
        ...overallRowIndex > 0 && isGridNavigationEnabled && {
            'aria-rowindex': overallRowIndex
        },
        role: "row",
        onAnimationEnd: ()=>{
            /*
        Animation set using @compiled may be inadvertently started when the scripting engine applies
        new styles (e.g. after a new issue row is appended). We need to set the animation duration
        to 0s once the animation has completed to prevent the animation restarting.
        See https://drafts.csswg.org/css-animations-1/#animations
         */ if (tableRowRef.current) tableRowRef.current.style.animationDuration = '0s';
        },
        onFocus: focusCurrentRow,
        onClick: onClick,
        onMouseOver: onMouseOverHandler,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeaveHandler,
        tabIndex: -1,
        ...isConditionalFormattingEnabled && color && {
            style: {
                backgroundColor: isRowHovered ? color.hoverValue : color.value
            }
        },
        'data-index': rowIndex,
        ref: trRef,
        "data-vc": `issue-row${false ? '-ssr' : ''}`,
        ...false && (0, $7jTnu.fg)('additional_nin_ssr_placeholders') && {
            'data-ssr-placeholder': 'issue-row-placeholder'
        },
        ...!false && (0, $7jTnu.fg)('additional_nin_ssr_placeholders') && {
            'data-ssr-placeholder-replace': 'issue-row-placeholder'
        },
        className: (0, $hcewu.default)([
            "_4t3i1ylp _kqswh2mm _nt751r31 _49pcglyw _1hvw1o36",
            (0, $7jTnu.fg)('jira_jif_jam_fixes_fy26h1') ? isRenderedInOverlay ? "_bfhk1bhr _7psyru3m _irr316qz" : "_bfhkvuon _7psyru3m _irr3108i" : "_bfhkvuon _7psyru3m _irr3108i",
            isGridNavigationEnabled && "_qj5iru3m _10j7fg4m _1p0pi1yw",
            highlightFadeOut.current && "",
            highlightFadeOut.current && "_j7hqwkqb _5sagymdr _1pgl6ui8",
            (isSelected && !(0, $7jTnu.fg)('nin-grid-keyboard-navigation') || isIssueSelected) && "_5sagru3m _bfhkfg4m _irr3i1yw",
            isHighlighted && "_bfhkavxe",
            shouldHaveDraggableRowStyles && "_80om1qgj _1qam5szm",
            currentDraggingRow !== null && currentDraggingRow === itemKey && (0, $7jTnu.fg)('jsc_list_reparenting') && "_tzy41ou4"
        ])
    }, rowContent)));
});
const $c3b12007bc04643a$var$MaybeMemoRowInner = /*#__PURE__*/ (0, $eJOHy.memo)($c3b12007bc04643a$var$RowInner);
const $c3b12007bc04643a$var$Row = (props)=>{
    const issueRowData = (0, $j4oe4.useFragment)((0, $odtPM.default), props.issue);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $btFWS.default), props.issueEdge);
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $ioHwy.default), props.fieldSets);
    const project = (0, $j4oe4.useFragment)((0, $lMOdu.default), props.project);
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    if (isSiblingIssueCreateEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c3b12007bc04643a$var$RowWithSiblingCreate, {
        ...props,
        issue: issueRowData ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: project
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c3b12007bc04643a$var$MaybeRowWithDragAndDrop, {
        ...props,
        issue: issueRowData ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: project
    });
};
var $c3b12007bc04643a$export$2e2bcd8739ae039 = $c3b12007bc04643a$var$Row;
const $c3b12007bc04643a$var$ROW_HEIGHT = 40;
const $c3b12007bc04643a$var$cellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: 'border.width',
    borderBottomWidth: '0',
    borderLeftWidth: '0',
    borderRightWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderRightWidth: '0'
    }
});
const $c3b12007bc04643a$var$cellBorderStylesWithNoColumn = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: 'border.width',
    borderBottomWidth: '0',
    borderLeftWidth: '0',
    borderRightWidth: '0'
});
const $c3b12007bc04643a$var$firstRowCellBorderStyles = (0, $1DXK0.xcss)({
    borderTopWidth: '0'
});
const $c3b12007bc04643a$var$fadeOut = null;
const $c3b12007bc04643a$var$rowStyles = null;
const $c3b12007bc04643a$var$rowBackground = null;
const $c3b12007bc04643a$var$rowBackgroundInOverlay = null;
const $c3b12007bc04643a$var$rowStylesKeyboardNavigation = null;
const $c3b12007bc04643a$var$draggableRowStyles = null;
const $c3b12007bc04643a$var$activeRowStyles = null;
const $c3b12007bc04643a$var$highlightRowStyles = null;
const $c3b12007bc04643a$var$draggingRowStyles = null;
const $c3b12007bc04643a$var$highlightFadeOutStyles = null;

});
parcelRegister("lMOdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f31b29e4cf478cb2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<615730ebe89b9f163bdfff097ab37358>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f31b29e4cf478cb2$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_project",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_project"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithSiblingCreate_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$f31b29e4cf478cb2$var$node.hash = "305a3dd7ddc9d2f8fd95d39ea0c44dcf";
var $f31b29e4cf478cb2$export$2e2bcd8739ae039 = $f31b29e4cf478cb2$var$node;

});

parcelRegister("ioHwy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cac4da9c8f8ba351$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb9c374a501e160332d3d2ed9808875b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cac4da9c8f8ba351$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isTimelineEnabled",
            "variableName": "isTimelineEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_fieldSets",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithSiblingCreate_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_fieldSets"
            },
            {
                "condition": "isConditionalFormattingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "useRowColor_fieldSets"
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$cac4da9c8f8ba351$var$node.hash = "b1479388a8b72b31899c906005fdd494";
var $cac4da9c8f8ba351$export$2e2bcd8739ae039 = $cac4da9c8f8ba351$var$node;

});

parcelRegister("btFWS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da42f9c07685eab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<faa24e7c142bf317ad4338364514c8e0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2da42f9c07685eab$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isReparentingEnabled",
            "variableName": "isReparentingEnabled"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        },
        {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
        },
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_issueEdge",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithSiblingCreate_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_issueEdge"
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    }
                ]
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$2da42f9c07685eab$var$node.hash = "a41e13eccfce7cb28f1676d55f4456c7";
var $2da42f9c07685eab$export$2e2bcd8739ae039 = $2da42f9c07685eab$var$node;

});

parcelRegister("odtPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fde8200bd033b67$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1e5ff2d196a89aabb93012894d34d60>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6fde8200bd033b67$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_issue",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_issue"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithSiblingCreate_issue"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issue"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_issue"
            }
        ],
        "type": "JiraIssue"
    };
}();
$6fde8200bd033b67$var$node.hash = "314b522083d141f30470d2c88982ba17";
var $6fde8200bd033b67$export$2e2bcd8739ae039 = $6fde8200bd033b67$var$node;

});

parcelRegister("479fo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3871dd6cf7c3f6a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<58dbaecb384e9a1e59cb7ba357653607>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3871dd6cf7c3f6a9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowInner_fieldSets",
    "selections": [
        {
            "condition": "isConditionalFormattingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useRowColor_fieldSets"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$3871dd6cf7c3f6a9$var$node.hash = "0ed10ff8bfccffbbaab36c1656579577";
var $3871dd6cf7c3f6a9$export$2e2bcd8739ae039 = $3871dd6cf7c3f6a9$var$node;

});

parcelRegister("5TZ76", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ffc91cf2f82336$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<12e755d22dfa437f8e056fca858767cc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $86ffc91cf2f82336$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowInner_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issueEdge"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "beforeFirstCell_nativeIssueTable"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isHighlightedIssueRow"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$86ffc91cf2f82336$var$node.hash = "8c74c6f54ca05f1801258b84cfefe0a9";
var $86ffc91cf2f82336$export$2e2bcd8739ae039 = $86ffc91cf2f82336$var$node;

});

parcelRegister("5dPdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9e734822e6a3699$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d6ae5338c019d70022ecb0ce90446bdd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9e734822e6a3699$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowInner_issue",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issue"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "issueId"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHighlightedIssueRow"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$f9e734822e6a3699$var$node.hash = "f1aa43f307d95f3f63f93f35d327aff6";
var $f9e734822e6a3699$export$2e2bcd8739ae039 = $f9e734822e6a3699$var$node;

});

parcelRegister("8wgBN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad88731d078a27af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0db943fe5be2fbfe9aa918c7b3d72114>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ad88731d078a27af$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowInner_project",
    "selections": [
        {
            "condition": "isConditionalFormattingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useRowColor_project"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_project"
        }
    ],
    "type": "JiraProject"
};
$ad88731d078a27af$var$node.hash = "3421471235a1479b4664ce102d537e15";
var $ad88731d078a27af$export$2e2bcd8739ae039 = $ad88731d078a27af$var$node;

});

parcelRegister("8wx8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $36abe0ec203dc48c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<375c61d0b9a42394f468337be862a51b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $36abe0ec203dc48c$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isTimelineEnabled",
            "variableName": "isTimelineEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_fieldSets",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_fieldSets"
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$36abe0ec203dc48c$var$node.hash = "df0569af63f87e0d32230a52759f5fb6";
var $36abe0ec203dc48c$export$2e2bcd8739ae039 = $36abe0ec203dc48c$var$node;

});

parcelRegister("22PsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1bb6fe25b35b56c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c711924504b551438eca67bcc5f99223>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b1bb6fe25b35b56c$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isReparentingEnabled",
            "variableName": "isReparentingEnabled"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        },
        {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
        },
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issueEdge",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_issueEdge"
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    }
                ]
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$b1bb6fe25b35b56c$var$node.hash = "ecb4fe0e48ee9f9990cf1ba7ac697127";
var $b1bb6fe25b35b56c$export$2e2bcd8739ae039 = $b1bb6fe25b35b56c$var$node;

});

parcelRegister("6aJiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $17634ca98d253286$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<27618ffe298320529ed931623d1f100d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $17634ca98d253286$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issue",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_issue"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_issue"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraIssue"
    };
}();
$17634ca98d253286$var$node.hash = "34c520a3bc6ec117d9f602769ebed646";
var $17634ca98d253286$export$2e2bcd8739ae039 = $17634ca98d253286$var$node;

});

parcelRegister("bcyaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8342f849ef7ff4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e856ad9107eaca5f7caa0a3ba51e7dc3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9c8342f849ef7ff4$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_project",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_project"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$9c8342f849ef7ff4$var$node.hash = "22d1625372ec1bb4cc986747310780cc";
var $9c8342f849ef7ff4$export$2e2bcd8739ae039 = $9c8342f849ef7ff4$var$node;

});

parcelRegister("hcgC7", function(module, exports) {

$parcel$export(module.exports, "default", () => $418a22157d6664b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bfadbd05b1f827457e86fd2c08750196>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $418a22157d6664b2$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithDragAndDrop_fieldSets",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_RowInner_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$418a22157d6664b2$var$node.hash = "780c4baf41d3aefe6a98e21336093bc0";
var $418a22157d6664b2$export$2e2bcd8739ae039 = $418a22157d6664b2$var$node;

});

parcelRegister("iT0ZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5fd034fa128db1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bde9fa539c9d7423e0b15d00ea0000b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7c5fd034fa128db1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithDragAndDrop_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_RowInner_issueEdge"
        },
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$7c5fd034fa128db1$var$node.hash = "e566a7d196325a9925eee40b93813a10";
var $7c5fd034fa128db1$export$2e2bcd8739ae039 = $7c5fd034fa128db1$var$node;

});

parcelRegister("jWhOS", function(module, exports) {

$parcel$export(module.exports, "default", () => $815f5a4c603f3ac8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36e0af31105676d4c13fa1151311f4bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $815f5a4c603f3ac8$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithDragAndDrop_issue",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_RowInner_issue"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ],
    "type": "JiraIssue"
};
$815f5a4c603f3ac8$var$node.hash = "7a12c603dc5ac5fd96d9c3a48373491e";
var $815f5a4c603f3ac8$export$2e2bcd8739ae039 = $815f5a4c603f3ac8$var$node;

});

parcelRegister("iHcjJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe1bd2ace92c1592$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e8bfff6ea42616f24b1f0fb704d037be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fe1bd2ace92c1592$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithDragAndDrop_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_RowInner_project"
        }
    ],
    "type": "JiraProject"
};
$fe1bd2ace92c1592$var$node.hash = "e305c96733bb25d26cbca91f49c03317";
var $fe1bd2ace92c1592$export$2e2bcd8739ae039 = $fe1bd2ace92c1592$var$node;

});

parcelRegister("3DEfF", function(module, exports) {

$parcel$export(module.exports, "default", () => $080362a9c416b766$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c8a7ff22e31bdb08089a2306d4b7145f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $080362a9c416b766$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithSiblingCreate_fieldSets",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$080362a9c416b766$var$node.hash = "5be1586fcbef8d93c24cce0190deffad";
var $080362a9c416b766$export$2e2bcd8739ae039 = $080362a9c416b766$var$node;

});

parcelRegister("kejcI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8beda67f3c694ed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94304c9893f25a1dd7f6db7ddc503270>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d8beda67f3c694ed$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithSiblingCreate_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issueEdge"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$d8beda67f3c694ed$var$node.hash = "1e979b6bc2af3190b4df9ad4da90d243";
var $d8beda67f3c694ed$export$2e2bcd8739ae039 = $d8beda67f3c694ed$var$node;

});

parcelRegister("dCDjU", function(module, exports) {

$parcel$export(module.exports, "default", () => $66998e4645687044$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a5c055de93d7aa2f0dfa7ed19834f2f0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $66998e4645687044$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithSiblingCreate_issue",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issue"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ],
    "type": "JiraIssue"
};
$66998e4645687044$var$node.hash = "35e8c278ec90de51801dc4516edd7193";
var $66998e4645687044$export$2e2bcd8739ae039 = $66998e4645687044$var$node;

});

parcelRegister("eoGrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $245f95bd9f5d29b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5cbee117db0751a5e7a7f9022d4b3d88>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $245f95bd9f5d29b2$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithSiblingCreate_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_project"
        }
    ],
    "type": "JiraProject"
};
$245f95bd9f5d29b2$var$node.hash = "f369449010c90230b9b745c7543e8337";
var $245f95bd9f5d29b2$export$2e2bcd8739ae039 = $245f95bd9f5d29b2$var$node;

});

parcelRegister("l4EsH", function(module, exports) {

$parcel$export(module.exports, "EXTRA_SPACE_PER_LEVEL", () => $97cccd1c556c1005$export$107c825dc66c95b7);
$parcel$export(module.exports, "useDraggableRows", () => $97cccd1c556c1005$export$1e4d2f7e506c2b7d);
$parcel$export(module.exports, "useDraggableRow", () => $97cccd1c556c1005$export$a878804271d34ba8);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $3nrCN = parcelRequire("3nrCN");

var $dROq6 = parcelRequire("dROq6");

var $iJoDE = parcelRequire("iJoDE");

var $1l4lS = parcelRequire("1l4lS");

var $bGx3v = parcelRequire("bGx3v");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $iJq0l = parcelRequire("iJq0l");

var $2ApNu = parcelRequire("2ApNu");
var $3pSHx = parcelRequire("3pSHx");

var $kEUB1 = parcelRequire("kEUB1");

var $814y1 = parcelRequire("814y1");

var $7jTnu = parcelRequire("7jTnu");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $443cm = parcelRequire("443cm");

var $gKOb9 = parcelRequire("gKOb9");

var $15Apk = parcelRequire("15Apk");

var $jNv5I = parcelRequire("jNv5I");

var $kfIml = parcelRequire("kfIml");

var $t5ecZ = parcelRequire("t5ecZ");
const $97cccd1c556c1005$var$INDENT_PER_LEVEL = 42;
const $97cccd1c556c1005$export$107c825dc66c95b7 = 4;
const $97cccd1c556c1005$var$ATTACH_INSTRUCTION_MODE = 'standard';
const $97cccd1c556c1005$var$SUPPORTED_TYPES = new Set([
    (0, $8jOO7.MAKE_CHILD),
    (0, $8jOO7.REORDER_ABOVE),
    (0, $8jOO7.REORDER_BELOW)
]);
const $97cccd1c556c1005$export$1e4d2f7e506c2b7d = (0, $iJq0l.createHook)((0, $kfIml.Store));
const $97cccd1c556c1005$var$isDraggableRowData = (data)=>data != null && typeof data === 'object' && 'operation' in data && data.operation === (0, $8jOO7.ROW_OPERATION_REORDER);
const $97cccd1c556c1005$export$a878804271d34ba8 = (props)=>{
    const { edgeIndex: edgeIndex, issueId: issueId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueEdgeRelayId: parentIssueEdgeRelayId, parentIssueConnectionId: parentIssueConnectionId, issueEdgeRelayId: issueEdgeRelayId, issueKey: issueKey } = props;
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    const isEntireRowDraggable = (0, $34oCh.useIsEntireRowDraggable)();
    let isRowReorderingEnabled = false;
    if (!(0, $7jTnu.fg)('jsc-2065-unify-onrowreorder')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isRowReorderingEnabled = (0, $34oCh.useIsRowReorderingEnabled)();
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const isReParentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const rankIssues = (0, $gKOb9.useIssuesRanker)();
    let sortDirection;
    let getBlockedInstructions = (0, $t5ecZ.getBlockedInstructionsOld);
    if ((0, $7jTnu.fg)('jsc_list_reranking_gate')) {
        getBlockedInstructions = (0, $t5ecZ.getBlockedInstructions);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        sortDirection = (0, $34oCh.useSortDirection)();
    }
    const [{ instanceId: instanceId, onRowReorder: onRowReorderHandler }, { registerItem: registerItem, setDropTarget: setDropTarget, unregisterItem: unregisterItem }] = $97cccd1c556c1005$export$1e4d2f7e506c2b7d();
    let reparent = null;
    if ((0, $7jTnu.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reparent: reparent } = (0, $443cm.useUpdateParent)());
    const cloudId = (0, $kEUB1.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onRowReorder = isIssueRankingEnabled ? rankIssues : onRowReorderHandler;
    // TODO: Use `rankIssues` directly on jsc-2065-unify-onrowreorder cleanup
    const onRankIssues = (0, $7jTnu.fg)('jsc-2065-unify-onrowreorder') ? rankIssues : onRowReorder;
    const cleanupFnRef = (0, $eJOHy.useRef)(null);
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    const attachDraggableElement = (0, $eJOHy.useCallback)((rowElement)=>isEntireRowDraggable ? (0, $bGx3v.draggable)({
            element: rowElement,
            getInitialData () {
                return {
                    operation: (0, $8jOO7.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    hierarchyLevel: hierarchyLevel,
                    parentIssueAri: parentIssueAri,
                    parentIssueEdgeRelayId: parentIssueEdgeRelayId,
                    parentIssueConnectionId: parentIssueConnectionId,
                    issueEdgeRelayId: issueEdgeRelayId,
                    rowIndex: edgeIndex,
                    itemsConnectionId: props.itemsConnectionId,
                    issueKey: issueKey,
                    groupId: groupId
                };
            },
            onDragStart () {
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dragged',
                    actionSubject: 'useDraggableRow',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            },
            onDrop () {
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dropped',
                    actionSubject: 'useDraggableRow',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            }
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), [
        isEntireRowDraggable,
        instanceId,
        issueId,
        hierarchyLevel,
        parentIssueAri,
        parentIssueEdgeRelayId,
        parentIssueConnectionId,
        issueEdgeRelayId,
        edgeIndex,
        props.itemsConnectionId,
        issueKey,
        groupId,
        createAnalyticsEvent
    ]);
    const attachDropTargetElement = (0, $eJOHy.useCallback)((rowElement)=>(0, $bGx3v.dropTargetForElements)({
            element: rowElement,
            canDrop ({ source: source }) {
                return source.data.operation === (0, $8jOO7.ROW_OPERATION_REORDER) && source.data.issueId !== issueId;
            },
            getData ({ input: input, element: element, source: source }) {
                const data = {
                    operation: (0, $8jOO7.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    parentIssueAri: parentIssueAri,
                    parentIssueConnectionId: parentIssueConnectionId,
                    issueEdgeRelayId: issueEdgeRelayId,
                    parentIssueEdgeRelayId: parentIssueEdgeRelayId,
                    rowIndex: edgeIndex,
                    itemsConnectionId: props.itemsConnectionId,
                    hasChildren: Boolean(props.hasChildren),
                    groupId: groupId
                };
                if ((0, $7jTnu.fg)('jsc_list_reparenting')) {
                    const blockedInstructions = $97cccd1c556c1005$var$isDraggableRowData(source.data) ? getBlockedInstructions({
                        dropTarget: {
                            ...data,
                            ...props
                        },
                        draggedItem: source.data,
                        isRowReorderingEnabled: isRowReorderingEnabled,
                        isIssueRankingEnabled: isIssueRankingEnabled
                    }) : [
                        (0, $8jOO7.MAKE_CHILD),
                        (0, $8jOO7.REORDER_BELOW),
                        (0, $8jOO7.REORDER_BELOW)
                    ];
                    return (0, $iJoDE.attachInstruction)(data, {
                        input: input,
                        element: element,
                        mode: $97cccd1c556c1005$var$ATTACH_INSTRUCTION_MODE,
                        indentPerLevel: // adjust the drop indicator position based on the depth of the item
                        !props.depth || props.depth < 2 ? $97cccd1c556c1005$var$INDENT_PER_LEVEL : $97cccd1c556c1005$var$INDENT_PER_LEVEL - props.depth * $97cccd1c556c1005$export$107c825dc66c95b7,
                        currentLevel: props.depth || 0,
                        block: blockedInstructions
                    });
                }
                return (0, $3nrCN.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDrag ({ self: self, source: source }) {
                // Don't set drop edge if source target is the same as this row instance
                if (issueId === source.data.issueId) return;
                if ((0, $7jTnu.fg)('jsc_list_reparenting')) {
                    const extractedInstruction = (0, $iJoDE.extractInstruction)(self.data);
                    extractedInstruction && setDropTarget({
                        issueId: issueId,
                        dropInstruction: extractedInstruction
                    });
                    return;
                }
                const closestEdge = (0, $3nrCN.extractClosestEdge)(self.data);
                closestEdge && setDropTarget({
                    issueId: issueId,
                    dropEdge: closestEdge
                });
            },
            onDragLeave () {
                setDropTarget(null);
            },
            onDrop ({ source: source, location: location }) {
                const [destination] = location.current.dropTargets;
                setDropTarget(null);
                if (!$97cccd1c556c1005$var$isDraggableRowData(source.data) || !$97cccd1c556c1005$var$isDraggableRowData(destination?.data)) return;
                let closestEdgeOfTarget;
                let extractedInstruction;
                if ((0, $7jTnu.fg)('jsc_list_reparenting')) {
                    extractedInstruction = (0, $iJoDE.extractInstruction)(destination.data);
                    closestEdgeOfTarget = extractedInstruction?.type === (0, $8jOO7.REORDER_ABOVE) ? 'top' : 'bottom';
                } else closestEdgeOfTarget = (0, $3nrCN.extractClosestEdge)(destination.data);
                const dragItemParent = source.data?.parentIssueAri;
                const dropTargetParent = props?.parentIssueAri;
                const isWithinSameParent = dragItemParent === dropTargetParent;
                // We are dropping at specific edge but not changing parent, meaning only reranking
                const isRerankingOnly = (extractedInstruction?.type === (0, $8jOO7.REORDER_ABOVE) || extractedInstruction?.type === (0, $8jOO7.REORDER_BELOW)) && isWithinSameParent;
                const shouldRerank = (0, $7jTnu.fg)('jsc_list_reranking_gate') ? isRerankingOnly && (isRowReorderingEnabled || isIssueRankingEnabled) : isRowReorderingEnabled;
                const shouldReparent = (0, $7jTnu.fg)('jsc_list_reranking_gate') ? !isRerankingOnly && isReParentingEnabled : isReParentingEnabled;
                if (shouldRerank) {
                    if (!closestEdgeOfTarget) return;
                    const startIndex = source.data.rowIndex;
                    const finishIndex = (0, $1l4lS.getReorderDestinationIndex)({
                        axis: 'vertical',
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        startIndex: startIndex,
                        indexOfTarget: destination.data.rowIndex
                    });
                    if (startIndex === finishIndex) return;
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'updatedRanking',
                        actionSubject: 'dragActionsButton',
                        actionSubjectId: 'jscDraggableIssue'
                    }));
                    const edge = isIssueRankingEnabled ? (0, $15Apk.getEdgeForRerank)(startIndex, finishIndex, sortDirection) : closestEdgeOfTarget;
                    onRankIssues?.({
                        source: {
                            issueIds: [
                                source.data.issueId
                            ],
                            rowIndex: startIndex
                        },
                        destination: {
                            relativeToIssueId: destination.data.issueId,
                            rowIndex: finishIndex
                        },
                        edge: edge
                    });
                }
                if (shouldReparent) {
                    if (extractedInstruction && $97cccd1c556c1005$var$SUPPORTED_TYPES.has(extractedInstruction.type)) {
                        const issueIdToReparent = (0, $2ApNu.JiraIssueAri).parse(source.data.issueId).issueId;
                        const issueFieldAriToReparent = (0, $3pSHx.JiraIssuefieldvalueAri).create({
                            siteId: cloudId,
                            issueId: issueIdToReparent,
                            fieldId: (0, $814y1.PARENT_TYPE)
                        }).toString();
                        const oldParentId = source.data.parentIssueAri && (0, $2ApNu.JiraIssueAri).parse(source.data.parentIssueAri).issueId;
                        const newParentAri = extractedInstruction.type === (0, $8jOO7.MAKE_CHILD) ? destination.data.issueId : destination.data.parentIssueAri;
                        const newParentId = newParentAri ? (0, $2ApNu.JiraIssueAri).parse(newParentAri).issueId : undefined;
                        const newParentEdgeId = extractedInstruction?.type === (0, $8jOO7.MAKE_CHILD) ? destination.data.issueEdgeRelayId : destination.data.parentIssueEdgeRelayId;
                        let dropIndex = 0;
                        if (extractedInstruction?.type === (0, $8jOO7.REORDER_ABOVE)) dropIndex = destination.data.rowIndex;
                        else if (extractedInstruction?.type === (0, $8jOO7.REORDER_BELOW)) dropIndex = destination.data.rowIndex + 1;
                        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'field updated', {
                            isJscReparenting: true
                        });
                        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueParent updated', {
                            isJscReparenting: true
                        });
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'updatedParent',
                            actionSubject: 'dragActionsButton',
                            actionSubjectId: 'jscDraggableIssue'
                        }), {
                            reparentingMethod: extractedInstruction.type,
                            isAddingParent: !oldParentId,
                            isUnparenting: !newParentAri,
                            droppedIssueHierarchyLevel: source.data.hierarchyLevel
                        });
                        reparent?.({
                            issueId: source.data.issueId,
                            issueAri: issueFieldAriToReparent,
                            oldParentId: oldParentId,
                            newParentId: newParentId,
                            newParentAri: newParentAri || null,
                            newParentEdgeId: newParentEdgeId,
                            index: dropIndex,
                            projectKey: props.projectKey,
                            issueKey: source.data.issueKey
                        });
                    }
                }
            }
        }), [
        instanceId,
        issueId,
        parentIssueAri,
        parentIssueConnectionId,
        issueEdgeRelayId,
        parentIssueEdgeRelayId,
        edgeIndex,
        props,
        groupId,
        getBlockedInstructions,
        isRowReorderingEnabled,
        isIssueRankingEnabled,
        setDropTarget,
        isReParentingEnabled,
        createAnalyticsEvent,
        sortDirection,
        onRankIssues,
        cloudId,
        reparent
    ]);
    const registerDraggableRow = (0, $eJOHy.useCallback)(()=>{
        registerItem(edgeIndex, issueId);
    }, [
        edgeIndex,
        issueId,
        registerItem
    ]);
    const unregisterDraggableRow = (0, $eJOHy.useCallback)(()=>{
        unregisterItem(edgeIndex);
    }, [
        edgeIndex,
        unregisterItem
    ]);
    const attachDraggableRow = (0, $eJOHy.useCallback)((rowElement)=>{
        // If there's an existing ref, clean up before attaching
        cleanupFnRef.current?.();
        if (!rowElement) return;
        cleanupFnRef.current = (0, $dROq6.combine)(attachDraggableElement(rowElement), attachDropTargetElement(rowElement), ()=>{
            // Reset the ref to null so that the cleanup function is not called again
            cleanupFnRef.current = null;
        });
    }, [
        attachDraggableElement,
        attachDropTargetElement
    ]);
    (0, $eJOHy.useEffect)(()=>()=>cleanupFnRef.current?.(), []);
    (0, $eJOHy.useEffect)(()=>{
        registerDraggableRow();
        return ()=>{
            unregisterDraggableRow();
        };
    }, [
        registerDraggableRow,
        unregisterDraggableRow
    ]);
    return isDragAndDropEnabled ? attachDraggableRow : null;
};

});
parcelRegister("3nrCN", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $d7df9ca07492ea22$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $d7df9ca07492ea22$export$945a571f3b658bf);
const $d7df9ca07492ea22$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $d7df9ca07492ea22$var$uniqueKey = Symbol('closestEdge');
function $d7df9ca07492ea22$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $d7df9ca07492ea22$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$d7df9ca07492ea22$var$uniqueKey]: addClosestEdge
    };
}
function $d7df9ca07492ea22$export$945a571f3b658bf(userData) {
    return userData[$d7df9ca07492ea22$var$uniqueKey] ?? null;
}

});

parcelRegister("iJoDE", function(module, exports) {

$parcel$export(module.exports, "attachInstruction", () => $438e65d4c84faf14$export$267ad49d812c2c7f);
$parcel$export(module.exports, "extractInstruction", () => $438e65d4c84faf14$export$c8ffecbe249dc8f8);

var $d2foH = parcelRequire("d2foH");
// using a symbol so we can guarantee a key with a unique value
const $438e65d4c84faf14$var$uniqueKey = Symbol('tree-item-instruction');
function $438e65d4c84faf14$var$getCenter(rect) {
    return {
        x: (rect.right + rect.left) / 2,
        y: (rect.bottom + rect.top) / 2
    };
}
function $438e65d4c84faf14$var$standardHitbox({ client: client, borderBox: borderBox }) {
    const quarterOfHeight = borderBox.height / 4;
    // In the top 1/4: reorder-above
    // On the line = in the top 1/4 to give this zone a bit more space
    if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
    // In the bottom 1/4: reorder-below
    // On the line = in the bottom 1/4 to give this zone a bit more space
    if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
    return 'make-child';
}
function $438e65d4c84faf14$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    if (mode === 'standard') {
        const type = $438e65d4c84faf14$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            type: type,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    const center = $438e65d4c84faf14$var$getCenter(borderBox);
    if (mode === 'expanded') {
        // leveraging "standard" hitbox to ensure that the 'reorder-above' hit zone is
        // exactly the same for "standard" and "expanded" items
        const type = $438e65d4c84faf14$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            // Use the "standard" hitbox for "reorder above",
            // The rest of the item is "make-child"
            type: type === 'reorder-above' ? type : 'make-child',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // `mode` is "last-in-group"
    const visibleInset = indentPerLevel * currentLevel;
    // Before the left edge of the visible item
    if (client.x < borderBox.left + visibleInset) {
        // Above the center: `reorder-above`
        if (client.y < center.y) return {
            type: 'reorder-above',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
        // On or below the center: `reparent`
        // On the center = `reparent` as we are giving a slightly bigger hitbox to this
        // action as it is the only place a user can do it
        const rawLevel = (client.x - borderBox.left) / indentPerLevel;
        // We can get sub pixel negative numbers as getBoundingClientRect gives sub-pixel accuracy,
        // where as clientX is rounded to the nearest pixel.
        // Using Math.max() ensures we can never get a negative level
        const desiredLevel = Math.max(Math.floor(rawLevel), 0);
        return {
            type: 'reparent',
            desiredLevel: desiredLevel,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // On the visible item
    return {
        type: $438e65d4c84faf14$var$standardHitbox({
            borderBox: borderBox,
            client: client
        }),
        indentPerLevel: indentPerLevel,
        currentLevel: currentLevel
    };
}
function $438e65d4c84faf14$var$areInstructionsEqual(a, b) {
    // Shortcut
    if (a.type !== b.type) return false;
    if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $438e65d4c84faf14$var$areInstructionsEqual(a.desired, b.desired);
    return (0, $d2foH.isShallowEqual)(a, b);
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $438e65d4c84faf14$var$memoizeInstruction = (0, $d2foH.stable)($438e65d4c84faf14$var$areInstructionsEqual);
function $438e65d4c84faf14$var$applyInstructionBlock({ desired: desired, block: block }) {
    if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
        const blocked = {
            type: 'instruction-blocked',
            desired: desired
        };
        return blocked;
    }
    return desired;
}
function $438e65d4c84faf14$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
    const desired = $438e65d4c84faf14$var$getInstruction(rest);
    const withBlock = $438e65d4c84faf14$var$applyInstructionBlock({
        desired: desired,
        block: block
    });
    const memoized = $438e65d4c84faf14$var$memoizeInstruction(withBlock);
    return {
        ...userData,
        [$438e65d4c84faf14$var$uniqueKey]: memoized
    };
}
function $438e65d4c84faf14$export$c8ffecbe249dc8f8(userData) {
    return userData[$438e65d4c84faf14$var$uniqueKey] ?? null;
}

});

parcelRegister("1l4lS", function(module, exports) {

$parcel$export(module.exports, "getReorderDestinationIndex", () => $f0909d4a1662ae03$export$846f792f51b92b6e);
function $f0909d4a1662ae03$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});

parcelRegister("443cm", function(module, exports) {

$parcel$export(module.exports, "useUpdateParent", () => $7516b102f870f621$export$d767b1cfe1a164d3);

var $gtOUD = parcelRequire("gtOUD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kqd31 = parcelRequire("kqd31");

var $gYnSx = parcelRequire("gYnSx");

var $bILK0 = parcelRequire("bILK0");

var $8Uqf3 = parcelRequire("8Uqf3");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $4SjAP = parcelRequire("4SjAP");

var $lRq8t = parcelRequire("lRq8t");

var $8jOO7 = parcelRequire("8jOO7");

var $8pBFu = parcelRequire("8pBFu");

var $adrlS = parcelRequire("adrlS");
const $7516b102f870f621$export$d767b1cfe1a164d3 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $8pBFu.REPARENTING_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $8pBFu.REPARENTING_EXPERIENCE)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $8pBFu.REPARENTING_EXPERIENCE)
    });
    const [commitMutation, loading] = (0, $j4oe4.useMutation)((0, $gtOUD.default));
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'issueTableReparentMutation',
                packageName: (0, $8jOO7.PACKAGE_NAME),
                teamName: (0, $8jOO7.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $8jOO7.PACKAGE_NAME), error);
        showFlag((0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
    }, [
        onExperienceFail,
        showFlag
    ]);
    const updater = (0, $adrlS.useGetReparentUpdater)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const highlightIssue = (0, $eJOHy.useCallback)(({ issueId: issueId, store: store })=>{
        // Highlight the row
        const issueRelayID = (0, $kqd31.default)({
            id: issueId
        }, (0, $adrlS.JIRA_ISSUE_TYPENAME));
        if (issueRelayID) {
            const node = store.get(issueRelayID);
            if (node) node?.setValue(true, 'isHighlightedIssueRow');
        }
    }, []);
    const reparent = (0, $eJOHy.useCallback)(({ issueId: issueId, issueAri: issueAri, oldParentId: oldParentId, newParentId: newParentId, newParentAri: newParentAri, newParentEdgeId: newParentEdgeId, index: index, projectKey: projectKey, issueKey: issueKey })=>{
        const input = {
            id: issueAri,
            operation: {
                operation: 'SET',
                id: newParentAri
            }
        };
        onExperienceStart();
        commitMutation({
            variables: {
                input: input
            },
            optimisticUpdater: (store)=>{
                updater({
                    store: store,
                    issueId: issueId,
                    oldParentId: oldParentId,
                    newParentId: newParentId,
                    newParentEdgeId: newParentEdgeId,
                    index: index,
                    projectKey: projectKey
                });
                // Highlight the row
                highlightIssue({
                    store: store,
                    issueId: issueId
                });
            },
            updater: (store, response)=>{
                if (response?.jira?.updateParentField?.success) {
                    updater({
                        store: store,
                        issueId: issueId,
                        oldParentId: oldParentId,
                        newParentId: newParentId,
                        newParentEdgeId: newParentEdgeId,
                        index: index,
                        projectKey: projectKey
                    });
                    highlightIssue({
                        store: store,
                        issueId: issueId
                    });
                    const issueRelayID = (0, $kqd31.default)({
                        id: issueId
                    }, (0, $adrlS.JIRA_ISSUE_TYPENAME));
                    if (issueRelayID) setTimeout(()=>{
                        (0, $j4oe4.commitLocalUpdate)(environment, (currentStore)=>{
                            const node = currentStore.get(issueRelayID);
                            node?.setValue(false, 'isHighlightedIssueRow');
                        });
                    }, (0, $8jOO7.HIGHLIGHT_LINGER_DURATION_MS));
                }
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.updateParentField ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    const clientSideErrorMessage = (0, $adrlS.getFlagDetails)(statusCode, intl, issueKey);
                    if (clientSideErrorMessage) {
                        showFlag(clientSideErrorMessage);
                        onExperienceSuccess();
                        return;
                    }
                    handleError(error);
                    return;
                }
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue reparented', (0, $8pBFu.ACTION_SUBJECT_ID));
                onExperienceSuccess();
            },
            onError: (error)=>{
                const err = new (0, $4SjAP.MutationError)(error);
                handleError(err);
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        environment,
        handleError,
        highlightIssue,
        onExperienceStart,
        onExperienceSuccess,
        showFlag,
        updater,
        intl
    ]);
    return {
        reparent: reparent,
        loading: loading
    };
};

});
parcelRegister("gtOUD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2e9000c51021ad8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a14b547dc80db979d18a2f6b7caad927>>
 * @relayHash 912b3665801859ed64b357f816488c18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5822dc5c39bb3263eb89e5efb2750a9fb42f5c4f74af60f422e877ecfaac2766
const $f2e9000c51021ad8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraParentIssueField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "reparentMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "reparentMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5822dc5c39bb3263eb89e5efb2750a9fb42f5c4f74af60f422e877ecfaac2766",
            "metadata": {},
            "name": "reparentMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$f2e9000c51021ad8$var$node.hash = "8010fe7d0e37915f076661fa947a0546";
var $f2e9000c51021ad8$export$2e2bcd8739ae039 = $f2e9000c51021ad8$var$node;

});

parcelRegister("8pBFu", function(module, exports) {

$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG", () => $abcfa65d938eed87$export$e80b28191e1d3602);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG", () => $abcfa65d938eed87$export$29d372313e7a3d7b);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA", () => $abcfa65d938eed87$export$e40785c138c2ad43);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM", () => $abcfa65d938eed87$export$a75bfbb3fb2f437c);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG", () => $abcfa65d938eed87$export$6a4ca5120f2baf63);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM", () => $abcfa65d938eed87$export$4cba4bafd925e182);
$parcel$export(module.exports, "REPARENTING_EXPERIENCE", () => $abcfa65d938eed87$export$4c7c3fa9c49bb0d7);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $abcfa65d938eed87$export$9957974f8b4d8f74);

var $f55DR = parcelRequire("f55DR");
const $abcfa65d938eed87$export$e80b28191e1d3602 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParentGenericErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$29d372313e7a3d7b = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent400ErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-400-flag.error.flag.update-issue-parent400error',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$e40785c138c2ad43 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTermRefreshGalaxia,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term-galaxia.error',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$a75bfbb3fb2f437c = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$6a4ca5120f2baf63 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent404ErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$4cba4bafd925e182 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent404ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$4c7c3fa9c49bb0d7 = 'updateParent';
const $abcfa65d938eed87$export$11823571c61d4d02 = 'SUCCEEDED';
const $abcfa65d938eed87$export$d71930f7f5807a72 = 'FAILED';
const $abcfa65d938eed87$export$f3390a0e172fee41 = 'useUpdateParent';
const $abcfa65d938eed87$export$9957974f8b4d8f74 = 'issueTableUpdateIssueParent';

});
parcelRegister("f55DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $60f7f21fe7d4c781$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $60f7f21fe7d4c781$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    updateIssueParentErrorTitle: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    updateIssueParentGenericErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-generic-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    updateIssueParent400ErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description",
        "defaultMessage": "You don\u2019t have permission to update this issue. Contact a project admin."
    },
    updateIssueParent404ErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-description",
        "defaultMessage": "We\u2019re having trouble updating this issue. To continue, refresh the page."
    },
    updateIssueParent400ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-term-refresh",
        "defaultMessage": "You don\u2019t have permission to update this work item. Contact a project admin."
    },
    updateIssueParent400ErrorTitleIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-title-issue-terminology-refresh-m4",
        "defaultMessage": "You don\u2019t have permission to update {issueKey}"
    },
    updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-terminology-refresh-m4",
        "defaultMessage": "Contact your project admin."
    },
    updateIssueParent404ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-description-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble updating this work item. To continue, refresh the page."
    },
    updateIssueParent404ErrorTitleIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-title-issue-terminology-refresh-m4",
        "defaultMessage": "We\u2019re having trouble updating {issueKey}"
    },
    updateIssueParent404ErrorDescriptionIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-description-issue-terminology-refresh-m4",
        "defaultMessage": "Refresh and try again."
    },
    updateIssueParent400ErrorDescriptionIssueTermRefreshGalaxia: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-term-refresh-galaxia",
        "defaultMessage": "You don\u2019t have permission to update this work item. Contact a space admin."
    },
    updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-terminology-refresh-m4-galaxia",
        "defaultMessage": "Contact your space admin."
    }
});

});


parcelRegister("adrlS", function(module, exports) {

$parcel$export(module.exports, "getFlagDetails", () => $d54f04439f880b90$export$e0141c03826f0c2c);
$parcel$export(module.exports, "JIRA_ISSUE_TYPENAME", () => $d54f04439f880b90$export$8df31253ff7294c9);
$parcel$export(module.exports, "useGetReparentUpdater", () => $d54f04439f880b90$export$b3f12c98c1f443a);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $epTsa = parcelRequire("epTsa");

var $kqd31 = parcelRequire("kqd31");

var $dLXgn = parcelRequire("dLXgn");

var $57Nys = parcelRequire("57Nys");

var $f55DR = parcelRequire("f55DR");

var $8pBFu = parcelRequire("8pBFu");
const $d54f04439f880b90$export$e0141c03826f0c2c = (statusCode, intl, issueKey)=>{
    switch(statusCode){
        case 400:
            if (issueKey && (0, $epTsa.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return $d54f04439f880b90$export$2aa1f96ba5bf0010(intl, issueKey);
            if ((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) {
                if ((0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false)) return 0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA;
                return 0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM;
            }
            return 0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_400_FLAG;
        case 404:
            if (issueKey && (0, $epTsa.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return $d54f04439f880b90$export$c7d107a3107d23fd(intl, issueKey);
            return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM) : (0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_404_FLAG);
        default:
            return null;
    }
};
const $d54f04439f880b90$export$2aa1f96ba5bf0010 = (intl, issueKey)=>{
    const updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia : (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4;
    return {
        type: 'error',
        title: intl.formatMessage((0, $f55DR.default).updateIssueParent400ErrorTitleIssueTerminologyRefreshM4, {
            issueKey: issueKey
        }),
        description: intl.formatMessage(updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia, {
            issueKey: issueKey
        }),
        messageId: 'native-issue-table.services.reparent-mutation.flag.error.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic.1.1',
        messageType: 'transactional'
    };
};
const $d54f04439f880b90$export$c7d107a3107d23fd = (intl, issueKey)=>{
    return {
        type: 'error',
        title: intl.formatMessage((0, $f55DR.default).updateIssueParent404ErrorTitleIssueTerminologyRefreshM4, {
            issueKey: issueKey
        }),
        description: intl.formatMessage((0, $f55DR.default).updateIssueParent404ErrorDescriptionIssueTerminologyRefreshM4, {
            issueKey: issueKey
        }),
        messageId: 'native-issue-table.services.reparent-mutation.flag.error.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic.1.1.1',
        messageType: 'transactional'
    };
};
const $d54f04439f880b90$export$8df31253ff7294c9 = 'JiraIssue';
const $d54f04439f880b90$export$b3f12c98c1f443a = ()=>{
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    const getConection = (0, $eJOHy.useCallback)(({ issueId: issueId })=>Object.values(connections).find((connection)=>{
            if (issueId) return connection.type === 'PARENT_CHILDREN' && connection.parentId === issueId;
            return connection.type === 'ROOT_ISSUES';
        }), [
        connections
    ]);
    const updater = (0, $eJOHy.useCallback)(({ store: store, issueId: issueId, oldParentId: oldParentId, newParentId: newParentId, newParentEdgeId: newParentEdgeId, index: index = 0, projectKey: projectKey })=>{
        const relayId = (0, $kqd31.default)({
            id: issueId
        }, $d54f04439f880b90$export$8df31253ff7294c9);
        if (!relayId) return;
        const oldConnection = getConection({
            issueId: oldParentId
        });
        const newConnection = getConection({
            issueId: newParentId
        });
        if (!oldConnection) // Since the issue has to be visible to be repartented, this case should not occur
        return;
        const oldConnectionRecord = store.get(oldConnection.connectionId);
        if (!oldConnectionRecord) return;
        if (newParentEdgeId) (0, $57Nys.updateParentHasChildren)({
            store: store,
            parentIssueEdgeRecordId: newParentEdgeId,
            connectionId: newConnection?.connectionId,
            hasChildren: true,
            projectKey: projectKey
        });
        if (newConnection) {
            const newConnectionRecord = store.get(newConnection.connectionId);
            if (!newConnectionRecord) return;
            const existingEdge = oldConnectionRecord.getLinkedRecords('edges')?.find((edge)=>edge?.getLinkedRecord('node')?.getDataID() === relayId);
            // no before or after implies an empty conneciton, verify then create the edges list
            const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
            const edges = newConnectionRecord.getLinkedRecords(EDGES);
            if (!edges || !existingEdge) return;
            const nextEdges = edges.slice(0, index).concat(existingEdge).concat(edges.slice(index));
            newConnectionRecord.setLinkedRecords(nextEdges, EDGES);
            updateConnectionDetails({
                store: store,
                connection: newConnection,
                netChangeInIssueCount: 1,
                remainingIssueCount: newConnectionRecord.getLinkedRecords('edges')?.length,
                projectKey: projectKey
            });
        }
        if (oldConnection) // remove the issue from the old connection
        {
            if (oldConnectionRecord.getLinkedRecords('edges')?.some((edge)=>edge?.getLinkedRecord('node')?.getDataID() === relayId)) {
                (0, $37Ewn.ConnectionHandler).deleteNode(oldConnectionRecord, relayId);
                updateConnectionDetails({
                    store: store,
                    connection: oldConnection,
                    netChangeInIssueCount: -1,
                    remainingIssueCount: oldConnectionRecord.getLinkedRecords('edges')?.length,
                    projectKey: projectKey
                });
            }
        }
    }, [
        getConection,
        updateConnectionDetails
    ]);
    return updater;
};

});


parcelRegister("gKOb9", function(module, exports) {

$parcel$export(module.exports, "useIssuesRanker", () => $baa286f0fb20e9cc$export$40f5e450e8552c78);

var $48qiM = parcelRequire("48qiM");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $isfFo = parcelRequire("isfFo");

var $ftN6c = parcelRequire("ftN6c");

var $8Uqf3 = parcelRequire("8Uqf3");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $bILK0 = parcelRequire("bILK0");

var $4SjAP = parcelRequire("4SjAP");

var $gCeeo = parcelRequire("gCeeo");

var $8jOO7 = parcelRequire("8jOO7");

var $kfIml = parcelRequire("kfIml");

var $dPwlR = parcelRequire("dPwlR");

var $1jyN6 = parcelRequire("1jyN6");

var $ikiN2 = parcelRequire("ikiN2");
const $baa286f0fb20e9cc$var$getRankMutationEdge = (edge)=>{
    switch(edge){
        case 'top':
            return 'TOP';
        case 'bottom':
            return 'BOTTOM';
        default:
            // Unsupported edge
            return null;
    }
};
const $baa286f0fb20e9cc$export$40f5e450e8552c78 = ()=>{
    const [issueConnectionId] = (0, $kfIml.useDraggableRowsConnectionId)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $dPwlR.RE_RANKING_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $dPwlR.RE_RANKING_EXPERIENCE)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $dPwlR.RE_RANKING_EXPERIENCE)
    });
    const [rankIssuesMutation] = (0, $j4oe4.useMutation)((0, $48qiM.default));
    const showErrorFlag = (0, $eJOHy.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh : (0, $ikiN2.default).reorderErrorTitle,
            description: (0, $ikiN2.default).reorderErrorDescription,
            isAutoDismiss: true,
            messageId: 'native-issue-table.services.rank-mutation.show-flag.error.use-issues-ranker.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    const reorderIssuesUpdater = (0, $eJOHy.useCallback)((store, startIndex, finishIndex)=>{
        const issueConnection = store.get(issueConnectionId);
        if (!issueConnection) return;
        const edges = issueConnection.getLinkedRecords('edges');
        if (!edges) return;
        const reorderedEdges = (0, $isfFo.reorder)({
            list: edges,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        issueConnection.setLinkedRecords(reorderedEdges, 'edges');
    }, [
        issueConnectionId
    ]);
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'commitRankIssuesMutationError',
                packageName: (0, $8jOO7.PACKAGE_NAME),
                teamName: (0, $8jOO7.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $8jOO7.PACKAGE_NAME), error);
        showErrorFlag();
    }, [
        onExperienceFail,
        showErrorFlag
    ]);
    const rankIssues = (0, $eJOHy.useCallback)((payload)=>{
        const { source: source, destination: destination, edge: edge } = payload;
        const rankMutationEdge = $baa286f0fb20e9cc$var$getRankMutationEdge(edge);
        onExperienceStart();
        if (rankMutationEdge == null) {
            showErrorFlag();
            (0, $gYnSx.default)({
                meta: {
                    id: 'commitRankIssuesError',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: new Error(`Edge "${edge}" is unsupported in JiraMutation.rankIssues`),
                sendToPrivacyUnsafeSplunk: true
            });
            return;
        }
        rankIssuesMutation({
            variables: {
                rankInput: {
                    issues: source.issueIds,
                    relativeToIssue: destination.relativeToIssueId,
                    edge: rankMutationEdge
                }
            },
            optimisticUpdater (store) {
                reorderIssuesUpdater(store, source.rowIndex, destination.rowIndex);
            },
            updater (store, data) {
                // Rollback update if mutation fails
                if (!data?.jira?.rankIssues?.success) return;
                reorderIssuesUpdater(store, source.rowIndex, destination.rowIndex);
            },
            onCompleted (data) {
                const { errors: errors } = data?.jira?.rankIssues ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    const clientSideErrorMessage = (0, $1jyN6.getFlagDetails)(statusCode);
                    if (clientSideErrorMessage) {
                        showFlag(clientSideErrorMessage);
                        onExperienceSuccess();
                        return;
                    }
                    handleError(error);
                    return;
                }
                if (!data.jira?.rankIssues?.success) {
                    const error = new Error(errors?.[0]?.message ?? 'Failed to reorder issues: Unknown Error occurred');
                    handleError(error);
                    return;
                }
                onExperienceSuccess();
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue updated', 'issueTableUpdateIssueRank');
            },
            onError (error) {
                handleError(error);
            }
        });
    }, [
        createAnalyticsEvent,
        handleError,
        onExperienceStart,
        onExperienceSuccess,
        rankIssuesMutation,
        reorderIssuesUpdater,
        showErrorFlag,
        showFlag
    ]);
    return rankIssues;
};

});
parcelRegister("48qiM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fc9aa5ab203269a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7b6192e241bff817293e89536fb54d7>>
 * @relayHash 5af65462c60885c21e1ab5b9e7fe7bcd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28980e6494a8955ea545f2049a61094e488898b5d096195ce03d5df5cd90873c
const $1fc9aa5ab203269a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "rankInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "rankInput",
            "variableName": "rankInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "rankMutation_rankIssuesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRankMutationPayload",
                            "kind": "LinkedField",
                            "name": "rankIssues",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "rankMutation_rankIssuesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRankMutationPayload",
                            "kind": "LinkedField",
                            "name": "rankIssues",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "28980e6494a8955ea545f2049a61094e488898b5d096195ce03d5df5cd90873c",
            "metadata": {},
            "name": "rankMutation_rankIssuesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$1fc9aa5ab203269a$var$node.hash = "4dde1357f9a06e5132a41d95c199765c";
var $1fc9aa5ab203269a$export$2e2bcd8739ae039 = $1fc9aa5ab203269a$var$node;

});

parcelRegister("dPwlR", function(module, exports) {

$parcel$export(module.exports, "REORDER_ITEM_FAIL_400_FLAG", () => $411491f5dedc5b65$export$c58c5fc634df2e30);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA", () => $411491f5dedc5b65$export$ecb799b5eeb91e4e);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM", () => $411491f5dedc5b65$export$d37d45ebdf6e6be4);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_404_FLAG", () => $411491f5dedc5b65$export$d9fdb4939efc3fa9);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_404_FLAG_WITH_ISSUE_TERM", () => $411491f5dedc5b65$export$83a2ceb0732d655a);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_409_FLAG", () => $411491f5dedc5b65$export$3b5b9901de703a5a);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_409_FLAG_WITH_ISSUE_TERM", () => $411491f5dedc5b65$export$b57a01d3fd8405a5);
$parcel$export(module.exports, "RE_RANKING_EXPERIENCE", () => $411491f5dedc5b65$export$cb50c1de8dfcf0a5);

var $ikiN2 = parcelRequire("ikiN2");
const $411491f5dedc5b65$export$9aa93234f179f11b = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-generic-flag.error.update-item-parent-fail-generic-flag.error.reparent-mutation.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$c58c5fc634df2e30 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderIssue400ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag.error.update-item-parent-fail-400-flag.error.reparent-mutation.update-item-parent-fail-400-flag.error.flag.update-issue-parent400error',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$ecb799b5eeb91e4e = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue400ErrorDescriptionIssueTermRefreshGalaxia,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag-with-issue-term-galaxia.error.reorder-item-fail-400-flag-with-issue-term-gal-axia.error.reorder-item-fail-400-flag-with-issue-term.error.update-item-parent-fail-400-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh-galaxia',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$d37d45ebdf6e6be4 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue400ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag-with-issue-term.error.update-item-parent-fail-400-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$d9fdb4939efc3fa9 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderIssue404ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-404-flag.error.update-item-parent-fail-404-flag.error.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$83a2ceb0732d655a = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue404ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-404-flag-with-issue-term.error.update-item-parent-fail-404-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$3b5b9901de703a5a = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderIssue409ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-409-flag.error.reorder-item-fail-404-flag.error.update-item-parent-fail-404-flag.error.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$b57a01d3fd8405a5 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue409ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-409-flag-with-issue-term.error.reorder-item-fail-404-flag-with-issue-term.error.update-item-parent-fail-404-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$cb50c1de8dfcf0a5 = 'reRankIssue';

});
parcelRegister("ikiN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $22f0324d073f2689$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $22f0324d073f2689$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    reorderErrorTitle: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-title",
        "defaultMessage": "We couldn't reorder those issues"
    },
    reorderErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-description",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    reorderErrorTitleIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-title-issue-term-refresh",
        "defaultMessage": "We couldn't reorder those work items"
    },
    reorderIssue400ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-400-error-description",
        "defaultMessage": "You don\u2019t have permission to reorder this issue. Contact a project admin."
    },
    reorderIssue404ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-404-error-description",
        "defaultMessage": "We\u2019re having trouble reordering this issue. To continue, refresh the page."
    },
    reorderIssue409ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-409-error-description",
        "defaultMessage": "There was a conflict reordering those issues. Please try again."
    },
    reorderIssue400ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-400-error-description-issue-term-refresh",
        "defaultMessage": "You don\u2019t have permission to reorder this work item. Contact a project admin."
    },
    reorderIssue404ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-404-error-description-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble reordering this work item. To continue, refresh the page."
    },
    reorderIssue409ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-409-error-description-issue-term-refresh",
        "defaultMessage": "There was a conflict reordering those work items. Please try again."
    },
    reorderIssue400ErrorDescriptionIssueTermRefreshGalaxia: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-400-error-description-issue-term-refresh-galaxia",
        "defaultMessage": "You don\u2019t have permission to reorder this work item. Contact a space admin."
    }
});

});


parcelRegister("1jyN6", function(module, exports) {

$parcel$export(module.exports, "getFlagDetails", () => $fb1754413aaa4816$export$e0141c03826f0c2c);

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $dPwlR = parcelRequire("dPwlR");
const $fb1754413aaa4816$export$e0141c03826f0c2c = (statusCode)=>{
    switch(statusCode){
        case 400:
            if ((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3')) {
                if ((0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false)) return 0, $dPwlR.REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA;
                return 0, $dPwlR.REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM;
            }
            return 0, $dPwlR.REORDER_ITEM_FAIL_400_FLAG;
        case 404:
            return (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $dPwlR.REORDER_ITEM_FAIL_404_FLAG_WITH_ISSUE_TERM) : (0, $dPwlR.REORDER_ITEM_FAIL_404_FLAG);
        case 409:
            return (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $dPwlR.REORDER_ITEM_FAIL_409_FLAG_WITH_ISSUE_TERM) : (0, $dPwlR.REORDER_ITEM_FAIL_409_FLAG);
        default:
            return null;
    }
};

});


parcelRegister("15Apk", function(module, exports) {

$parcel$export(module.exports, "getEdgeForRerank", () => $c1d6810499cb70fa$export$6bd827e42c9b2c6f);
const $c1d6810499cb70fa$export$6bd827e42c9b2c6f = (sourceIndex, destinationIndex, sortDirection)=>{
    // When sorting DESC, the visual direction is inverted
    // Moving up visually (lower index) means moving down in ascending order
    if (sortDirection === 'DESC') return sourceIndex > destinationIndex ? 'bottom' : 'top';
    // ASC: normal logic
    return sourceIndex > destinationIndex ? 'top' : 'bottom';
};

});

parcelRegister("jNv5I", function(module, exports) {

$parcel$export(module.exports, "useRowContext", () => $ab12d7ac2653f245$export$7a486b5630cc7522);
$parcel$export(module.exports, "RowContextProvider", () => $ab12d7ac2653f245$export$81ecc1ee96e0504e);

var $eJOHy = parcelRequire("eJOHy");
const $ab12d7ac2653f245$var$RowContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $ab12d7ac2653f245$export$7a486b5630cc7522 = ()=>{
    const context = (0, $eJOHy.useContext)($ab12d7ac2653f245$var$RowContext);
    if (!context) throw new Error('useRowContext must be used within RowContextProvider');
    return context;
};
const $ab12d7ac2653f245$export$81ecc1ee96e0504e = ({ children: children, columns: columns, tableInjectedProps: tableInjectedProps, renderChildRows: renderChildRows, groupId: groupId, groupConnectionId: groupConnectionId, resizingColumnIndex: resizingColumnIndex })=>{
    const props = (0, $eJOHy.useMemo)(()=>({
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            renderChildRows: renderChildRows,
            groupId: groupId,
            groupConnectionId: groupConnectionId,
            resizingColumnIndex: resizingColumnIndex
        }), [
        columns,
        tableInjectedProps,
        renderChildRows,
        groupId,
        groupConnectionId,
        resizingColumnIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ab12d7ac2653f245$var$RowContext.Provider, {
        value: props
    }, children);
};

});

parcelRegister("t5ecZ", function(module, exports) {

$parcel$export(module.exports, "getBlockedInstructions", () => $f79d815e41b917a5$export$44539271c2e3abc8);
$parcel$export(module.exports, "getBlockedInstructionsOld", () => $f79d815e41b917a5$export$704f71e2437b55b4);

var $lBtjB = parcelRequire("lBtjB");

var $8jOO7 = parcelRequire("8jOO7");
const $f79d815e41b917a5$export$acc17f62bededcaf = ({ dropTarget: dropTarget, draggedItem: draggedItem, isIssueRankingEnabled: isIssueRankingEnabled })=>{
    const draggedItemLevel = draggedItem?.hierarchyLevel;
    const dropTargetLevel = dropTarget?.hierarchyLevel;
    const draggedItemHasParent = !!draggedItem?.parentIssueAri;
    const dropTargetHasParent = !!dropTarget?.parentIssueAri;
    const draggedItemGrouping = draggedItem?.groupId;
    const dropTargetGrouping = dropTarget?.groupId;
    // CASE 1: Grouping information does not match
    if (draggedItemGrouping !== dropTargetGrouping) return {
        [(0, $8jOO7.COMBINE)]: 'blocked',
        [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
        [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
    };
    // CASE 2: Both items have no hierarchy information
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(dropTargetLevel) || !(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(draggedItemLevel)) {
        // Still consider if they're are in the first depth, but prevent combining
        if (dropTarget?.depth === 0 && draggedItem?.depth === 0) return {
            [(0, $8jOO7.COMBINE)]: 'not-available',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        return {
            [(0, $8jOO7.COMBINE)]: 'available',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
    }
    const draggedItemParentIsDropTarget = String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);
    const isSiblingOfDropTarget = String(dropTarget?.parentIssueAri) === String(draggedItem?.parentIssueAri);
    const droppingToSameParent = draggedItem?.parentIssueAri !== '' && draggedItem?.parentIssueAri != null && (isSiblingOfDropTarget || draggedItemParentIsDropTarget);
    // CASE 3: Both items have parent information
    if (droppingToSameParent) {
        if (isIssueRankingEnabled && isSiblingOfDropTarget) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        if (draggedItemParentIsDropTarget && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
            [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
        };
    }
    // CASE 4: Reparenting if there's a difference in hierarchy levels
    if (dropTargetLevel !== draggedItemLevel + 1) {
        // If drop target is of same level as drag item and drop target has parent,
        // do not block reorder as we are reordering to reparent
        if (dropTargetLevel === draggedItemLevel && dropTargetHasParent) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        // If we are dropping to a top level issue (unparenting or reranking), we should not block reordering
        if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) {
            if (draggedItemHasParent || isIssueRankingEnabled) return {
                [(0, $8jOO7.COMBINE)]: 'blocked',
                [(0, $8jOO7.REORDER_BEFORE)]: 'available',
                [(0, $8jOO7.REORDER_AFTER)]: 'available'
            };
        }
        if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
            [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
        };
        // Any other actions is an invalid drop onto an item
        return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
            [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
        };
    }
    // CASE 5: We cannot unparent a subtask that does not have a parent
    if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return {
        [(0, $8jOO7.COMBINE)]: 'available',
        [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
        [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
    };
    // CASE 6: Unparenting any non-subtask
    if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && draggedItemHasParent) return {
        [(0, $8jOO7.COMBINE)]: 'available',
        [(0, $8jOO7.REORDER_BEFORE)]: 'available',
        [(0, $8jOO7.REORDER_AFTER)]: 'available'
    };
    // Default case: Drop target is valid
    return {
        [(0, $8jOO7.COMBINE)]: 'available',
        [(0, $8jOO7.REORDER_BEFORE)]: 'available',
        [(0, $8jOO7.REORDER_AFTER)]: 'available'
    };
};
const $f79d815e41b917a5$export$44539271c2e3abc8 = ({ dropTarget: dropTarget, draggedItem: draggedItem, isIssueRankingEnabled: isIssueRankingEnabled })=>{
    const draggedItemLevel = draggedItem?.hierarchyLevel;
    const dropTargetLevel = dropTarget?.hierarchyLevel;
    const dragItemHasParent = !!draggedItem?.parentIssueAri;
    const dropTargetHasParent = !!dropTarget?.parentIssueAri;
    const draggedItemGrouping = draggedItem?.groupId;
    const dropTargeGrouping = dropTarget?.groupId;
    if (draggedItemGrouping !== dropTargeGrouping) return [
        (0, $8jOO7.MAKE_CHILD),
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(dropTargetLevel) || !(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(draggedItemLevel)) return [];
    const dragItemParentIsDropTarget = String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);
    const isSiblingOfDropTarget = String(dropTarget?.parentIssueAri) === String(draggedItem?.parentIssueAri);
    const droppingToSameParent = // Do not take into account when both drag item and drop target do not have parent, in which case
    // they have an equal parent value but is not reparenting to same parent
    draggedItem?.parentIssueAri !== '' && draggedItem?.parentIssueAri != null && (isSiblingOfDropTarget || dragItemParentIsDropTarget);
    if (droppingToSameParent) {
        if (isIssueRankingEnabled && isSiblingOfDropTarget) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        if (dragItemParentIsDropTarget && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
    }
    // if the difference is not of one level up, we could be reparenting by dragging
    if (dropTargetLevel !== draggedItemLevel + 1) {
        // If drop target is of same level as drag item and drop target has parent,
        // do not block reorder as we are reordering to reparent
        if (dropTargetLevel === draggedItemLevel && dropTargetHasParent) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        // If we are dropping to a top level issue (unparenting or reranking), we should not block reordering
        if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) {
            if (dragItemHasParent || isIssueRankingEnabled) return [
                (0, $8jOO7.MAKE_CHILD)
            ];
        }
        if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
        // Any other actions is an invalid drop onto an item
        return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
    }
    // we cannot unparent a subtask nor an item that already does not have a parent
    if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return [
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    // Unparenting any non-subtask issue type
    if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [];
    // we are dropping to a valid parent
    return [];
};
const $f79d815e41b917a5$export$704f71e2437b55b4 = ({ dropTarget: dropTarget, draggedItem: draggedItem, isRowReorderingEnabled: isRowReorderingEnabled })=>{
    // We don't support reordering and reparenting
    if (isRowReorderingEnabled) return [
        (0, $8jOO7.MAKE_CHILD)
    ];
    const draggedItemLevel = draggedItem?.hierarchyLevel;
    const dropTargetLevel = dropTarget?.hierarchyLevel;
    const dragItemHasParent = !!draggedItem?.parentIssueAri;
    const dropTargetHasParent = !!dropTarget?.parentIssueAri;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(dropTargetLevel) || !(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(draggedItemLevel)) return [];
    const dragItemParentIsDropTarget = String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);
    const isSiblingOfDropTarget = String(dropTarget?.parentIssueAri) === String(draggedItem?.parentIssueAri);
    const droppingToSameParent = // Do not take into account when both drag item and drop target do not have parent, in which case
    // they have an equal parent value but is not reparenting to same parent
    draggedItem?.parentIssueAri !== '' && draggedItem?.parentIssueAri != null && (isSiblingOfDropTarget || dragItemParentIsDropTarget);
    if (droppingToSameParent) return [
        (0, $8jOO7.MAKE_CHILD),
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    // if the difference is not of one level up, we could be reparenting by dragging
    if (dropTargetLevel !== draggedItemLevel + 1) {
        // If drop target is of same level as drag item and drop target has parent,
        // do not block reorder as we are reordering to reparent
        if (dropTargetLevel === draggedItemLevel && dropTargetHasParent) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        // If we are dropping to a top level issue (unparenting), we should not block reordering
        if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        // Any other actions are invalid
        return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
    }
    // we cannot unparent a subtask nor an item that already does not have a parent
    if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) || !dragItemHasParent) return [
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    // Unparenting any non-subtask issue type
    if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [];
    // we are dropping to a valid parent
    return [
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
};

});
parcelRegister("lBtjB", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $fba3cb134bd6d57d$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $fba3cb134bd6d57d$var$isNumber(value) {
    return typeof value == 'number' || $7gKgM(value) && $1O9y6(value) == $fba3cb134bd6d57d$var$numberTag;
}
module.exports = $fba3cb134bd6d57d$var$isNumber;

});



parcelRegister("bnxIc", function(module, exports) {

$parcel$export(module.exports, "useSelectedRow", () => $34cf68440e07d5d8$export$11a86b67953bcc50);
$parcel$export(module.exports, "useIsSelected", () => $34cf68440e07d5d8$export$fb40a80c530e5f2b);
$parcel$export(module.exports, "useIsFocused", () => $34cf68440e07d5d8$export$a774b9356e1b793);

var $7jTnu = parcelRequire("7jTnu");

var $jE8Tu = parcelRequire("jE8Tu");

var $hCXvl = parcelRequire("hCXvl");
const $34cf68440e07d5d8$export$11a86b67953bcc50 = ()=>{
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $jE8Tu.useSelectedRow)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $hCXvl.useSelectedRow)();
};
const $34cf68440e07d5d8$export$fb40a80c530e5f2b = (itemDetail, rowDetail)=>{
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $jE8Tu.useIsSelected)(itemDetail);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $hCXvl.useIsSelected)(rowDetail);
};
const $34cf68440e07d5d8$export$a774b9356e1b793 = (itemDetail, rowDetail)=>{
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $jE8Tu.useIsFocused)(itemDetail);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $hCXvl.useIsFocused)(rowDetail);
};

});

parcelRegister("4NiKr", function(module, exports) {

$parcel$export(module.exports, "SiblingIssueCreateRowContext", () => $519225a615dc40ac$export$93b3e64bc25dd687);
$parcel$export(module.exports, "useSiblingIssueCreateRow", () => $519225a615dc40ac$export$4d2a6b6549dc23e8);
$parcel$export(module.exports, "useSiblingIssueCreateHandler", () => $519225a615dc40ac$export$6dac168b5104cc);
$parcel$export(module.exports, "useSiblingIssueCreateOnScroll", () => $519225a615dc40ac$export$2dfe9712a7a20bc9);

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $34oCh = parcelRequire("34oCh");

var $6LwYU = parcelRequire("6LwYU");

const $519225a615dc40ac$var$MOUSE_MOVE_THROTTLE = 16;
const $519225a615dc40ac$var$SIBLING_CREATE_HOVER_AREA = 12;
const $519225a615dc40ac$export$93b3e64bc25dd687 = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $519225a615dc40ac$export$4d2a6b6549dc23e8 = ()=>{
    const context = (0, $eJOHy.useContext)($519225a615dc40ac$export$93b3e64bc25dd687);
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    return isSiblingIssueCreateEnabled ? context : {};
};
const $519225a615dc40ac$export$6dac168b5104cc = (connectionId, edgeIndex)=>{
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    const { setIndex: setIndex, clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay } = (0, $6LwYU.useSiblingCreateActiveIndexActions)();
    const calculateRowIndex = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((event)=>{
            const currentRow = event.currentTarget;
            if (!currentRow) return;
            // Calculate the y position of the mouse relative to the top of the current row.
            const currentRowRect = currentRow.getBoundingClientRect();
            // This calculation ranges from -1 to 39, instead of 0 to 40, potentially due to the row's border.
            // For this reason, we add 1 to ensure the value is correct.
            const currentRowMouseVerticalOffset = event.clientY - currentRowRect.top + 1;
            if (currentRowMouseVerticalOffset >= 0 && currentRowMouseVerticalOffset <= $519225a615dc40ac$var$SIBLING_CREATE_HOVER_AREA) // When hovering the top part of a row, the trigger should be rendered at the top of the current row.
            setIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8), [
                connectionId,
                edgeIndex
            ]);
            else if (currentRowMouseVerticalOffset > currentRowRect.height - $519225a615dc40ac$var$SIBLING_CREATE_HOVER_AREA) // When hovering the bottom part of a row, the trigger should be rendered at the top of the next row.
            setIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8), [
                connectionId,
                edgeIndex + 1
            ]);
            else // When hovering the middle part of a row, the trigger should not be rendered.
            clearIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
        }, $519225a615dc40ac$var$MOUSE_MOVE_THROTTLE), [
        connectionId,
        edgeIndex,
        clearIndex,
        setIndex
    ]);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        clearIndexAfterDelay((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
    }, [
        clearIndexAfterDelay
    ]);
    const onMouseMove = (0, $eJOHy.useCallback)((event)=>{
        calculateRowIndex(event);
    }, [
        calculateRowIndex
    ]);
    return isSiblingIssueCreateEnabled ? {
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove
    } : {};
};
const $519225a615dc40ac$export$2dfe9712a7a20bc9 = ()=>{
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    const { clearIndex: clearIndex } = (0, $6LwYU.useSiblingCreateActiveIndexActions)();
    return (0, $eJOHy.useMemo)(()=>isSiblingIssueCreateEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(()=>{
            clearIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
        }, $519225a615dc40ac$var$MOUSE_MOVE_THROTTLE) : undefined, [
        clearIndex,
        isSiblingIssueCreateEnabled
    ]);
};

});
const $a11b3ba2d46b97f5$export$76a449e52fa0e1e8 = 'issue';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $a11b3ba2d46b97f5$var$FIELD = 'field';


parcelRegister("lRgXM", function(module, exports) {

$parcel$export(module.exports, "BeforeFirstCell", () => $5e89cced523df811$export$bcb733e1e43aa5a8);

var $9MzhQ = parcelRequire("9MzhQ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $34oCh = parcelRequire("34oCh");

var $4NiKr = parcelRequire("4NiKr");

var $6LwYU = parcelRequire("6LwYU");

var $h243O = parcelRequire("h243O");

var $aTzcv = parcelRequire("aTzcv");
const $5e89cced523df811$export$bcb733e1e43aa5a8 = ({ edgeIndex: edgeIndex, issueId: issueId, itemsConnectionId: itemsConnectionId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueConnectionId: parentIssueConnectionId, issueKey: issueKey, projectKey: projectKey, isRowHovered: isRowHovered, issueRowData: issueRowData, setCurrentDraggingRow: setCurrentDraggingRow })=>{
    const { isFormVisible: isFormVisible } = (0, $4NiKr.useSiblingIssueCreateRow)();
    const firstCellData = (0, $j4oe4.useFragment)((0, $9MzhQ.default), issueRowData);
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    let isReparentingEnabled = false;
    if ((0, $7jTnu.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    let isAdjacentInlineIssueCreateActive = false;
    if ((0, $7jTnu.fg)('jsc_list_reranking_gate')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isInlineIssueCreateActive] = (0, $6LwYU.useIsSiblingIssueCreateActive)([
            itemsConnectionId,
            edgeIndex
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isInlineIssueCreateActiveRowBelow] = (0, $6LwYU.useIsSiblingIssueCreateActive)([
            itemsConnectionId,
            edgeIndex + 1
        ]);
        isAdjacentInlineIssueCreateActive = isInlineIssueCreateActive || isInlineIssueCreateActiveRowBelow;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, // Check value instead of truthiness because it can be `undefined` if sibling issue create is disabled
    isFormVisible === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aTzcv.SiblingIssueCreateButton), {
        edgeIndex: edgeIndex,
        issuesConnectionId: itemsConnectionId
    }), isDragAndDropEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h243O.DragActionsButton), {
        edgeIndex: edgeIndex,
        issueId: issueId,
        isRowHovered: isRowHovered && !isAdjacentInlineIssueCreateActive,
        parentIssueConnectionId: parentIssueConnectionId,
        ...isReparentingEnabled ? {
            hierarchyLevel: hierarchyLevel,
            parentIssueAri: parentIssueAri,
            issueKey: issueKey,
            projectKey: projectKey,
            firstCellData: firstCellData ?? null,
            itemsConnectionId: itemsConnectionId,
            setCurrentDraggingRow: setCurrentDraggingRow
        } : {
            firstCellData: null
        }
    }));
};

});
parcelRegister("9MzhQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $234f13a1a1686821$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9abde640c438bf7b632fc8e21ea6b27b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $234f13a1a1686821$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "beforeFirstCell_nativeIssueTable",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "dragActionsButton_nativeIssueTable"
        }
    ],
    "type": "JiraIssue"
};
$234f13a1a1686821$var$node.hash = "780f04e74d4c4e81616ebb05591db223";
var $234f13a1a1686821$export$2e2bcd8739ae039 = $234f13a1a1686821$var$node;

});

parcelRegister("h243O", function(module, exports) {

$parcel$export(module.exports, "DragActionsButton", () => $c06cff2a70ca64e5$export$d55b3c0033758134);

var $f0TXA = parcelRequire("f0TXA");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $j4oe4 = parcelRequire("j4oe4");

var $5k2HF = parcelRequire("5k2HF");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $dX4g9 = parcelRequire("dX4g9");

var $aHiGM = parcelRequire("aHiGM");

var $6qaBj = parcelRequire("6qaBj");

var $bGx3v = parcelRequire("bGx3v");

var $2ApNu = parcelRequire("2ApNu");

var $d1S9l = parcelRequire("d1S9l");

var $jd93d = parcelRequire("jd93d");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $jE8Tu = parcelRequire("jE8Tu");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");

var $aBHUF = parcelRequire("aBHUF");

var $6pTKw = parcelRequire("6pTKw");

var $l4EsH = parcelRequire("l4EsH");

var $gbzqX = parcelRequire("gbzqX");

var $4AddX = parcelRequire("4AddX");

var $gKOb9 = parcelRequire("gKOb9");

var $15Apk = parcelRequire("15Apk");

var $jNv5I = parcelRequire("jNv5I");

var $gCGxb = parcelRequire("gCGxb");

var $h4EQn = parcelRequire("h4EQn");

var $bCFDb = parcelRequire("bCFDb");
const $c06cff2a70ca64e5$var$styles = {
    button: "_1dqonqa1 _1h6dmuej _189ee4h9 _4t3i7vkz _1bsbdlk8 _16qs1cd0 _bfhkhp5a _syaz1fxt _80om1qgj _irr31a0f _1di6qctv _9h8h16c2 _1qam5szm"
}; // Negatively offset by 1px to account for the cell border
const $c06cff2a70ca64e5$var$offset = [
    (0, $8jOO7.ROW_HEIGHT) / 2 - 1,
    -1
];
const $c06cff2a70ca64e5$var$BUTTON_SIZE = 16;
const $c06cff2a70ca64e5$var$IDLE_DRAGGABLE_STATE = 'idle';
const $c06cff2a70ca64e5$var$PREVIEW_DRAGGABLE_STATE = 'preview';
const $c06cff2a70ca64e5$var$DRAGGING_DRAGGABLE_STATE = 'dragging';
const $c06cff2a70ca64e5$var$isDropEdgeTarget = (dropTarget)=>'dropEdge' in dropTarget;
const $c06cff2a70ca64e5$export$d55b3c0033758134 = ({ edgeIndex: edgeIndex, issueId: issueId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueConnectionId: parentIssueConnectionId, issueKey: issueKey, projectKey: projectKey, isRowHovered: isRowHovered, firstCellData: firstCellData, itemsConnectionId: itemsConnectionId, setCurrentDraggingRow: setCurrentDraggingRow })=>{
    const dragPreviewData = (0, $j4oe4.useFragment)((0, $f0TXA.default), firstCellData);
    const buttonRef = (0, $eJOHy.useRef)(null);
    const [buttonState, setButtonState] = (0, $eJOHy.useState)($c06cff2a70ca64e5$var$IDLE_DRAGGABLE_STATE);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const [{ currentDropTarget: currentDropTarget, instanceId: instanceId, items: items }, { reorderRows: reorderRows }] = (0, $l4EsH.useDraggableRows)();
    let isRowReorderingEnabled = false;
    if (!(0, $7jTnu.fg)('jsc-2065-unify-onrowreorder')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isRowReorderingEnabled = (0, $34oCh.useIsRowReorderingEnabled)();
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    let rankIssues = null;
    let sortDirection;
    if ((0, $7jTnu.fg)('jsc_list_reranking_gate')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        rankIssues = (0, $gKOb9.useIssuesRanker)(); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        sortDirection = (0, $34oCh.useSortDirection)();
    }
    const onRankIssuesNew = (0, $eJOHy.useCallback)((sourceIndex, destinationIndex)=>{
        const edge = (0, $15Apk.getEdgeForRerank)(sourceIndex, destinationIndex, sortDirection);
        return rankIssues?.({
            source: {
                issueIds: [
                    items.get(sourceIndex) ?? ''
                ],
                rowIndex: sourceIndex
            },
            destination: {
                relativeToIssueId: items.get(destinationIndex) ?? '',
                rowIndex: destinationIndex
            },
            edge: edge
        });
    }, [
        items,
        sortDirection,
        rankIssues
    ]);
    const onReorderRows = isIssueRankingEnabled ? onRankIssuesNew : reorderRows; // Note: It will use the `isIssueRankingEnabled` condition in the dropdown items instead
    // TODO: Use `onRankIssuesNew` directly on jsc-2065-unify-onrowreorder cleanup
    const onRankIssues = (0, $7jTnu.fg)('jsc-2065-unify-onrowreorder') ? onRankIssuesNew : onReorderRows;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isVisible = isDropdownOpen || isRowHovered || buttonState === $c06cff2a70ca64e5$var$DRAGGING_DRAGGABLE_STATE;
    const isDropTarget = currentDropTarget?.issueId === issueId;
    const [draggableState, setDraggableState] = (0, $eJOHy.useState)({
        type: $c06cff2a70ca64e5$var$IDLE_DRAGGABLE_STATE
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (!buttonRef.current) return;
        return (0, $bGx3v.draggable)({
            element: buttonRef.current,
            getInitialData () {
                return {
                    operation: (0, $8jOO7.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    rowIndex: edgeIndex,
                    hierarchyLevel: hierarchyLevel,
                    parentIssueAri: parentIssueAri,
                    parentIssueConnectionId: parentIssueConnectionId,
                    itemsConnectionId: itemsConnectionId,
                    issueKey: issueKey,
                    groupId: groupId
                };
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                // We need to make sure that the element not obfuscated by the sticky header
                (0, $aHiGM.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $dX4g9.pointerOutsideOfPreview)({
                        x: "var(--ds-space-250, 20px)",
                        y: "var(--ds-space-250, 20px)"
                    }),
                    render ({ container: container }) {
                        setDraggableState({
                            type: $c06cff2a70ca64e5$var$PREVIEW_DRAGGABLE_STATE,
                            container: container
                        });
                        return ()=>setDraggableState({
                                type: $c06cff2a70ca64e5$var$IDLE_DRAGGABLE_STATE
                            });
                    }
                });
            },
            onDragStart () {
                if (isReparentingEnabled && itemsConnectionId && (0, $7jTnu.fg)('jsc_list_reparenting')) {
                    const itemKey = (0, $jE8Tu.getItemKey)(itemsConnectionId, issueId);
                    setCurrentDraggingRow && setCurrentDraggingRow(itemKey);
                }
                setButtonState('dragging');
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dragged',
                    actionSubject: 'dragActionsButton',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            },
            onDrop () {
                if (isReparentingEnabled && (0, $7jTnu.fg)('jsc_list_reparenting')) setCurrentDraggingRow && setCurrentDraggingRow(null);
                buttonRef.current?.blur();
                setButtonState('idle');
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dropped',
                    actionSubject: 'dragActionsButton',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            }
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        issueId,
        hierarchyLevel,
        parentIssueAri,
        instanceId,
        itemsConnectionId,
        parentIssueConnectionId,
        setCurrentDraggingRow,
        isReparentingEnabled,
        issueKey,
        groupId
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        if (parentIssueAri) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'changeParent');
        else (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'addParent');
    }, [
        createAnalyticsEvent,
        parentIssueAri
    ]);
    const isFirstRow = edgeIndex === 0 && !parentIssueAri;
    const [isOnboardingVisible, setIsOnboardingVisible] = (0, $eJOHy.useState)(false);
    let handleSubmitReparenting;
    if ((0, $7jTnu.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    handleSubmitReparenting = (0, $gbzqX.useReparentingFromModal)({
        projectKey: projectKey
    });
    const modalEntryPointProps = (0, $eJOHy.useMemo)(()=>({
            issueId: issueId,
            parentIssueAri: parentIssueAri,
            issueKey: issueKey,
            hierarchyLevel: hierarchyLevel,
            onSubmit: handleSubmitReparenting
        }), [
        handleSubmitReparenting,
        hierarchyLevel,
        issueId,
        issueKey,
        parentIssueAri
    ]);
    const handleMoveToTop = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, 0);
        if ((0, $7jTnu.fg)('jsc_list_reranking_gate')) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveToTop'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        onRankIssues
    ]);
    const handleMoveUp = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, edgeIndex - 1);
        if ((0, $7jTnu.fg)('jsc_list_reranking_gate')) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveUp'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        onRankIssues
    ]);
    const handleMoveDown = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, edgeIndex + 1);
        if ((0, $7jTnu.fg)('jsc_list_reranking_gate')) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveDown'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        onRankIssues
    ]);
    const handleMoveToBottom = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, items.size - 1);
        if ((0, $7jTnu.fg)('jsc_list_reranking_gate')) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveToBottom'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        items.size,
        onRankIssues
    ]);
    if (!issueKey && isReparentingEnabled && (0, $7jTnu.fg)('jsc_list_reparenting')) // if the issue key is empty, it indicates that it’s an optimistic row so we should not render the drag handler
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isOpen: isDropdownOpen,
        onOpenChange: (attrs)=>{
            setIsDropdownOpen(attrs.isOpen);
        },
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pTKw.RowPopupButton), {
                alignToYAxis: true,
                buttonSize: $c06cff2a70ca64e5$var$BUTTON_SIZE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k2HF))), {
                    label: "",
                    size: "small"
                }),
                isVisible: isVisible || isOnboardingVisible,
                label: formatMessage((0, $bCFDb.default).label),
                offset: $c06cff2a70ca64e5$var$offset,
                ref: (0, $jd93d.mergeRefs)(triggerRef, buttonRef),
                xcss: (0, $6qaBj.cx)($c06cff2a70ca64e5$var$styles.button),
                onClick: triggerProps.onClick
            }),
        testId: "native-issue-table.ui.row.before-first-cell.drag-actions-button.dropdown-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        "data-testid": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reorder-menu-items"
    }, (isRowReorderingEnabled || isIssueRankingEnabled) && items.size > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isIssueRankingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === 0,
        onClick: handleMoveToTop
    }, formatMessage((0, $bCFDb.default).moveToTop)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === 0,
        onClick: handleMoveUp
    }, formatMessage((0, $bCFDb.default).moveUp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === items.size - 1,
        onClick: handleMoveDown
    }, formatMessage((0, $bCFDb.default).moveDown)), isIssueRankingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === items.size - 1,
        onClick: handleMoveToBottom
    }, formatMessage((0, $bCFDb.default).moveToBottom))), projectKey && (0, $7jTnu.fg)('jsc_list_reparenting') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1S9l.ModalEntryPointDropdownItemTrigger), {
        entryPoint: (0, $4AddX.reparentModalEntryPoint),
        entryPointProps: modalEntryPointProps,
        entryPointParams: {
            cloudId: cloudId,
            projectKey: projectKey
        },
        interactionName: "open-reparent-issue-modal",
        useInternalModal: true,
        onClick: handleClick
    }, parentIssueAri ? formatMessage((0, $bCFDb.default).changeParent) : formatMessage((0, $bCFDb.default).addParent)))), isDropTarget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBHUF.RowDropIndicator), $c06cff2a70ca64e5$var$isDropEdgeTarget(currentDropTarget) ? {
        edge: currentDropTarget.dropEdge
    } : {
        instruction: currentDropTarget.dropInstruction
    }), draggableState.type === $c06cff2a70ca64e5$var$PREVIEW_DRAGGABLE_STATE && isReparentingEnabled && dragPreviewData && /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h4EQn.DragPreview), {
        issueId: (0, $2ApNu.JiraIssueAri).parse(issueId).issueId,
        itemsConnectionId: itemsConnectionId,
        summary: dragPreviewData.summary,
        issueTypeAvatarUrl: dragPreviewData.issueTypeField?.issueType?.avatar?.small
    }), draggableState.container), isFirstRow && isReparentingEnabled && buttonRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gCGxb.ReparentingOnboarding), {
        buttonElement: buttonRef.current,
        setIsOnboardingVisible: setIsOnboardingVisible
    }));
};

});
parcelRegister("f0TXA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d721a15756ba7a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<871b4d4d6f391f7645d8365104353e34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4d721a15756ba7a1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "dragActionsButton_nativeIssueTable",
    "selections": [
        {
            "condition": "isReparentingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$4d721a15756ba7a1$var$node.hash = "2c82d93dee43bfbb87413c0ffdd9f22b";
var $4d721a15756ba7a1$export$2e2bcd8739ae039 = $4d721a15756ba7a1$var$node;

});

parcelRegister("5k2HF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37637907bc962c27c98c216148025653>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e00ead02e99da4c$var$_react = $3e00ead02e99da4c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3e00ead02e99da4c$var$_baseNew = $3e00ead02e99da4c$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $3e00ead02e99da4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e00ead02e99da4c$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $3e00ead02e99da4c$var$_react.default.createElement($3e00ead02e99da4c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$3e00ead02e99da4c$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $3e00ead02e99da4c$var$_default = module.exports.default = $3e00ead02e99da4c$var$DragHandleVerticalIcon;

});

parcelRegister("aBHUF", function(module, exports) {

$parcel$export(module.exports, "RowDropIndicator", () => $fe45d0eb6b7ca840$export$fa88485e37d4f027);

var $eJOHy = parcelRequire("eJOHy");

var $hM0gG = parcelRequire("hM0gG");

var $igtYB = parcelRequire("igtYB");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $7n9BS = parcelRequire("7n9BS");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");

var $l4EsH = parcelRequire("l4EsH");
const $fe45d0eb6b7ca840$export$feefd628b4f4feb5 = ({ instruction: instruction })=>{
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.scrollWidth - (0, $l4EsH.EXTRA_SPACE_PER_LEVEL));
    const isReParentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.common.ui.row-drop-indicator.box",
        xcss: [
            $fe45d0eb6b7ca840$var$boxStyles,
            $fe45d0eb6b7ca840$var$dropIndicatorStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: `${width}px`
        },
        "data-row-drop-indicator": true
    }, isReParentingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hM0gG.DropIndicator), {
        instruction: instruction
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igtYB.DropIndicator), {
        edge: instruction.type === (0, $8jOO7.REORDER_ABOVE) ? 'top' : 'bottom',
        ...(0, $7jTnu.fg)('jsc_list_reranking_gate') ? {
            appearance: instruction.type === (0, $8jOO7.INSTRUCTION_BLOCKED) ? 'warning' : 'default'
        } : {}
    }));
};
const $fe45d0eb6b7ca840$export$d508f4eb766c5ef8 = ({ edge: edge })=>{
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.common.ui.row-drop-indicator.box",
        xcss: [
            $fe45d0eb6b7ca840$var$boxStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: `${width}px`
        },
        "data-row-drop-indicator": true
    }, edge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igtYB.DropIndicator), {
        edge: edge
    }));
};
const $fe45d0eb6b7ca840$export$fa88485e37d4f027 = /*#__PURE__*/ (0, $eJOHy.memo)(({ edge: edge, instruction: instruction })=>{
    if (instruction && (0, $7jTnu.fg)('jsc_list_reparenting')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe45d0eb6b7ca840$export$feefd628b4f4feb5, {
        instruction: instruction
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe45d0eb6b7ca840$export$d508f4eb766c5ef8, {
        edge: edge
    });
});
const $fe45d0eb6b7ca840$var$boxStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    top: 'space.0',
    bottom: 'space.0',
    // Negatively offset by 1px to account for the cell border
    left: '-1px',
    pointerEvents: 'none'
});
const $fe45d0eb6b7ca840$var$dropIndicatorStyles = (0, $1DXK0.xcss)({
    left: 'space.050',
    width: '100%',
    zIndex: 'tooltip'
});

});
parcelRegister("hM0gG", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $eab1d74837eadd45$export$62ed72bc21f6b8a6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5HaAt = parcelRequire("5HaAt");

var $igtYB = parcelRequire("igtYB");
function $eab1d74837eadd45$var$getElement({ instruction: instruction, isBlocked: isBlocked }) {
    const indent = `${instruction.currentLevel * instruction.indentPerLevel}px`;
    const appearance = isBlocked ? 'warning' : 'default';
    if (instruction.type === 'reorder-above') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
        edge: "top",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reorder-below') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
        edge: "bottom",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'make-child') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5HaAt.DropIndicator), {
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reparent') {
        const reparentIndent = `${instruction.desiredLevel * instruction.indentPerLevel}px`;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
            edge: "bottom",
            appearance: appearance,
            indent: reparentIndent
        });
    }
    return null;
}
function $eab1d74837eadd45$export$62ed72bc21f6b8a6({ instruction: instruction }) {
    if (instruction.type === 'instruction-blocked') return $eab1d74837eadd45$var$getElement({
        instruction: instruction.desired,
        isBlocked: true
    });
    return $eab1d74837eadd45$var$getElement({
        instruction: instruction,
        isBlocked: false
    });
}

});


parcelRegister("6pTKw", function(module, exports) {

$parcel$export(module.exports, "RowPopupButton", () => $a86e6d6da2b92676$export$960d0282617d39c3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $6qaBj = parcelRequire("6qaBj");

var $6G5P1 = parcelRequire("6G5P1");
var $azjc1 = parcelRequire("azjc1");

var $8nu6j = parcelRequire("8nu6j");

var $46R8N = parcelRequire("46R8N");

var $k71qx = parcelRequire("k71qx");

var $jd93d = parcelRequire("jd93d");

var $8cv11 = parcelRequire("8cv11");
const $a86e6d6da2b92676$var$styles = {
    reference: "_1ltvze3t _154ize3t",
    visuallyHidden: "_19itglyw _1reo15vq _18m915vq _1bsbt94y _4t3it94y _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _kqswstnw _mkrz1ly6 _o5721q9c"
};
const $a86e6d6da2b92676$var$buttonStyles = {
    root: "_1e0c1txw _1bah1h6o _4cvr1h6o _1pby1nn1",
    default: "_2rkoglpi _bfhk1bhr _80omtlke _irr316qz _1di6vq0a"
};
const $a86e6d6da2b92676$var$constantModifiers = [
    {
        name: 'flip',
        enabled: false
    }
];
// Height/width of the popup button
const $a86e6d6da2b92676$var$DEFAULT_BUTTON_SIZE = 24;
// Height/width of the reference element the popup button is anchored to
const $a86e6d6da2b92676$var$REFERENCE_SIZE = 1;
const $a86e6d6da2b92676$export$960d0282617d39c3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, forwardedRef)=>{
    const { icon: icon, isVisible: isVisible, label: label, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, tooltipContent: tooltipContent, tooltipPosition: tooltipPosition, alignToYAxis: alignToYAxis = true, buttonSize: buttonSize = $a86e6d6da2b92676$var$DEFAULT_BUTTON_SIZE, offset: offset = [
        0,
        0
    ], xcss: xcss } = props;
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const updateRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Recompute popup position when the button is shown
        isVisible && updateRef.current?.();
    }, [
        isVisible
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Recompute popup position when the button is focused
        isFocused && updateRef.current?.();
    }, [
        isFocused
    ]);
    const [along, away] = offset;
    const finalOffset = (0, $eJOHy.useMemo)(()=>// Negatively offset the popup by the button + reference size to center the button on the secondary axis
        [
            along,
            away - (buttonSize + $a86e6d6da2b92676$var$REFERENCE_SIZE) / 2
        ], [
        along,
        away,
        buttonSize
    ]);
    const modifiers = (0, $eJOHy.useMemo)(()=>{
        // Adjust the overflow calculation for the primary axis so it is relative to the center of the button.
        const alongCenterOffset = -(buttonSize / 2);
        // Retain the provided offset for the secondary axis
        const padding = alignToYAxis ? {
            left: finalOffset[1],
            top: alongCenterOffset,
            bottom: alongCenterOffset
        } : {
            top: finalOffset[1],
            left: alongCenterOffset,
            right: alongCenterOffset
        };
        return [
            ...$a86e6d6da2b92676$var$constantModifiers,
            {
                name: 'preventOverflow',
                options: {
                    mainAxis: true,
                    altAxis: true,
                    padding: padding,
                    altBoundary: true,
                    rootBoundary: 'viewport',
                    tether: false
                }
            },
            {
                name: 'eventListeners',
                options: {
                    // Only recompute position on scroll/resize events while the button is focused to reduce CPU load
                    scroll: isFocused,
                    resize: isFocused
                }
            }
        ];
    }, [
        alignToYAxis,
        buttonSize,
        finalOffset,
        isFocused
    ]);
    // Ensure a stable ref function is passed through to the trigger button
    const memoizedMergeRefs = (0, $eJOHy.useMemo)(()=>(0, $LFmXM.default)((0, $jd93d.mergeRefs)), []);
    const isVisuallyHidden = !isVisible && !isFocused;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6G5P1.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $azjc1.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: (0, $6qaBj.cx)($a86e6d6da2b92676$var$styles.reference, $a86e6d6da2b92676$var$styles.visuallyHidden),
            ref: ref
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        placement: alignToYAxis ? 'right' : 'bottom',
        modifiers: modifiers,
        offset: finalOffset,
        messageId: "native-issue-table.common.ui.row-popup-button.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            position: tooltipPosition,
            content: tooltipContent,
            canAppear: ()=>tooltipContent != null
        }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46R8N.default), {
                ...triggerProps,
                "aria-label": label,
                testId: `native-issue-table.common.ui.row-popup-button.pressable${isVisuallyHidden ? '-hidden' : ''}`,
                xcss: (0, $6qaBj.cx)($a86e6d6da2b92676$var$buttonStyles.root, $a86e6d6da2b92676$var$buttonStyles.default, // See https://atlassian.design/components/css/overview#building-reusable-components
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                xcss, isVisuallyHidden && $a86e6d6da2b92676$var$styles.visuallyHidden),
                onClick: (e, analyticEvent)=>{
                    onClick?.(e, analyticEvent);
                    triggerProps.onClick(e);
                },
                onFocus: (e)=>{
                    setIsFocused(true);
                    triggerProps.onFocus(e);
                },
                onBlur: (e)=>{
                    setIsFocused(false);
                    triggerProps.onBlur(e);
                },
                onMouseMove: (e)=>{
                    // Stop propagation so the button isn't inadvertently hidden when hovering
                    e.stopPropagation();
                    triggerProps.onMouseMove?.(e);
                },
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                ref: memoizedMergeRefs(ref, triggerProps.ref, forwardedRef),
                // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
                style: style
            }, icon));
    }));
});

});
parcelRegister("8cv11", function(module, exports) {

$parcel$export(module.exports, "JiraPopper", () => $7c774b4266762c6b$export$23789575ac361b5d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $8qmYl = parcelRequire("8qmYl");

var $SyPNn = parcelRequire("SyPNn");

var $k3Xbr = parcelRequire("k3Xbr");
const $7c774b4266762c6b$export$23789575ac361b5d = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k3Xbr.ChoreographerPopper), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qmYl.Popper), rest);
};

});
parcelRegister("k3Xbr", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopper", () => $035f7c874f3f3baa$export$6077de4a190b560c);
// eslint-disable-next-line jira/restricted/react-component-props

var $8qmYl = parcelRequire("8qmYl");

var $1pkzT = parcelRequire("1pkzT");
const $035f7c874f3f3baa$export$6077de4a190b560c = (0, $1pkzT.withChoreographedRender)((0, $8qmYl.Popper));

});



parcelRegister("gbzqX", function(module, exports) {

$parcel$export(module.exports, "useReparentingFromModal", () => $69b98f49ec4fd4fd$export$7ed8dfd115f70801);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $gYnSx = parcelRequire("gYnSx");

var $2ApNu = parcelRequire("2ApNu");

var $kEUB1 = parcelRequire("kEUB1");

var $bILK0 = parcelRequire("bILK0");

var $adrlS = parcelRequire("adrlS");

var $8jOO7 = parcelRequire("8jOO7");

var $8pBFu = parcelRequire("8pBFu");
const $69b98f49ec4fd4fd$export$7ed8dfd115f70801 = ({ projectKey: projectKey })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const updateParentConnections = (0, $adrlS.useGetReparentUpdater)();
    return (0, $eJOHy.useCallback)((updatedIssues, newParentId, newIssueParent, requestPromise)=>{
        if (updatedIssues.length) {
            const upatedIssue = updatedIssues[0];
            if (upatedIssue.id) {
                const ariIssueId = (0, $2ApNu.JiraIssueAri).create({
                    issueId: upatedIssue.id,
                    siteId: cloudId
                }).toString();
                (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
                    updateParentConnections({
                        store: store,
                        issueId: ariIssueId,
                        oldParentId: upatedIssue.parentId,
                        newParentId: newParentId,
                        index: 0,
                        projectKey: projectKey
                    });
                });
                requestPromise.catch((error)=>{
                    // Rollback
                    (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
                        updateParentConnections({
                            store: store,
                            issueId: ariIssueId,
                            oldParentId: newParentId,
                            newParentId: upatedIssue.parentId,
                            index: 0,
                            projectKey: projectKey
                        });
                    });
                    (0, $gYnSx.default)({
                        meta: {
                            id: 'issueTableReparentMutationFromModal',
                            packageName: (0, $8jOO7.PACKAGE_NAME),
                            teamName: (0, $8jOO7.TEAM_NAME)
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    showFlag((0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
                });
            }
        }
    }, [
        cloudId,
        environment,
        projectKey,
        showFlag,
        updateParentConnections
    ]);
};

});

parcelRegister("4AddX", function(module, exports) {

$parcel$export(module.exports, "reparentModalEntryPoint", () => $10fd1aa1388ec33e$export$e5e5cbbac06953a1);

var $2Akpc = parcelRequire("2Akpc");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $10fd1aa1388ec33e$export$e5e5cbbac06953a1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hdxZ6")), {
        moduleId: "a7705f96",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
            queries: {
                projectData: {
                    parameters: $2Akpc.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("hdxZ6", function(module, exports) {

let $c88e0331781cee3c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $c88e0331781cee3c$var$load("kNFvF"),
    $c88e0331781cee3c$var$load("aJsyY")
]).then(()=>parcelRequire('afNBU'));

});


parcelRegister("gCGxb", function(module, exports) {

$parcel$export(module.exports, "ReparentingOnboarding", () => $77a5b7e391e34013$export$18bcadaeddef642);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $d2s5v = parcelRequire("d2s5v");

var $8IeH1 = parcelRequire("8IeH1");

var $58yRG = parcelRequire("58yRG");

var $3CprG = parcelRequire("3CprG");

var $9zZj0 = parcelRequire("9zZj0");

var $lRq8t = parcelRequire("lRq8t");

var $9HHOs = parcelRequire("9HHOs");

var $kEUB1 = parcelRequire("kEUB1");

var $g1NZW = parcelRequire("g1NZW");

var $jie4g = parcelRequire("jie4g");

var $cOh4b = parcelRequire("cOh4b");

var $2TobG = parcelRequire("2TobG");
const $77a5b7e391e34013$export$ae06398c30161061 = 'jira-list-nin-reparent-onboarding-stg';
const $77a5b7e391e34013$export$c63f3f365035b47c = 'jira-list-nin-reparent-onboarding';
const $77a5b7e391e34013$var$ENV_STAGING = 'staging';
const $77a5b7e391e34013$var$STARGATE_URL = '/gateway/api';
const $77a5b7e391e34013$export$18bcadaeddef642 = ({ buttonElement: buttonElement, setIsOnboardingVisible: setIsOnboardingVisible })=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $g1NZW.useEnvironment)() === $77a5b7e391e34013$var$ENV_STAGING ? $77a5b7e391e34013$export$ae06398c30161061 : $77a5b7e391e34013$export$c63f3f365035b47c;
    const cloudId = (0, $kEUB1.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const spotlight = colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($2TobG))) : (0, (/*@__PURE__*/$parcel$interopDefault($cOh4b)));
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(false);
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, $77a5b7e391e34013$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $7UDun.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $eJOHy.useEffect)(()=>{
        if (isEnrolled) {
            setIsOnboardingVisible(true);
            stopEnrolment(false);
            setTimeout(()=>{
                setIsSpotlightActive(true);
            }, 50);
        }
    }, [
        isEnrolled,
        setIsOnboardingVisible,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isSpotlightActive && buttonElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        onMouseOver: (event)=>{
            event.stopPropagation();
        },
        onMouseLeave: (event)=>{
            event.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        image: spotlight,
        messageId: "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.jira-spotlight.expand-column-header",
        messageType: "engagement",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    setIsOnboardingVisible(false);
                },
                text: formatMessage((0, $jie4g.default).dismiss)
            }
        ],
        dialogWidth: 270,
        heading: formatMessage((0, $jie4g.default).onboardingHeading),
        targetNode: buttonElement,
        targetRadius: 3,
        key: "reparenting-onboarding"
    }, formatMessage((0, $jie4g.default).onboardingDescription)))));
};

});
parcelRegister("jie4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $825ad67642b58329$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $825ad67642b58329$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    onboardingHeading: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.onboarding-heading",
        "defaultMessage": "Re-parent work items"
    },
    onboardingDescription: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.onboarding-description",
        "defaultMessage": "Select and move a work item to add, or change, the parent."
    },
    dismiss: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});

parcelRegister("cOh4b", function(module, exports) {
module.exports = new URL("reparent-onboarding-light.f5faa58e.gif", import.meta.url).toString();

});

parcelRegister("2TobG", function(module, exports) {
module.exports = new URL("reparent-onboarding-dark.ad59f27a.gif", import.meta.url).toString();

});


parcelRegister("h4EQn", function(module, exports) {

$parcel$export(module.exports, "DragPreview", () => $aba8ee8166d92834$export$905ab40ac2179daa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $jE8Tu = parcelRequire("jE8Tu");
const $aba8ee8166d92834$var$MAX_ISSUE_COUNT = 99;
const $aba8ee8166d92834$export$905ab40ac2179daa = ({ summary: summary, issueTypeAvatarUrl: issueTypeAvatarUrl, issueId: issueId, itemsConnectionId: itemsConnectionId })=>{
    const [{ listMetadata: listMetadata, connectionMap: connectionMap, connectionItems: connectionItems }] = (0, $jE8Tu.useHierarchyStore)();
    const [isExpanded] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: issueId,
        itemsConnectionId: itemsConnectionId || ''
    });
    const childCount = (0, $eJOHy.useMemo)(()=>{
        if (isExpanded) {
            const itemKey = listMetadata.find((element)=>element.itemId === issueId)?.key || '';
            const keyConnection = connectionMap[itemKey];
            const itemConnectionItems = keyConnection ? connectionItems[keyConnection] || [] : [];
            return itemConnectionItems.length ? (0, $jE8Tu.filterNonIssueItems)(itemConnectionItems.map((item)=>item.itemId)).length || 0 : 0;
        }
        return 0;
    }, [
        connectionItems,
        connectionMap,
        isExpanded,
        issueId,
        listMetadata
    ]);
    const showChildIssues = childCount > 0;
    const hasMoreThanOneChild = childCount > 1;
    const countIncludingParent = childCount > 0 ? childCount + 1 : 0;
    const hasLessThanMaxIssueCount = countIncludingParent < $aba8ee8166d92834$var$MAX_ISSUE_COUNT;
    const roundedIssueCount = hasLessThanMaxIssueCount ? countIncludingParent : $aba8ee8166d92834$var$MAX_ISSUE_COUNT;
    return summary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $aba8ee8166d92834$var$rootStyles
    }, showChildIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hasMoreThanOneChild ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $aba8ee8166d92834$var$listItemStyles,
            $aba8ee8166d92834$var$child2Styles
        ]
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $aba8ee8166d92834$var$listItemStyles,
            $aba8ee8166d92834$var$child1Styles
        ]
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $aba8ee8166d92834$var$listItemStyles,
            $aba8ee8166d92834$var$primaryItemStyles
        ]
    }, showChildIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: hasLessThanMaxIssueCount ? $aba8ee8166d92834$var$badgeStyles : [
            $aba8ee8166d92834$var$badgeStyles,
            $aba8ee8166d92834$var$smallContentStyles
        ],
        alignItems: "center",
        justifyContent: "center"
    }, hasLessThanMaxIssueCount ? roundedIssueCount : `${roundedIssueCount}+`) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $aba8ee8166d92834$var$innerStyles,
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center"
    }, issueTypeAvatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: issueTypeAvatarUrl,
        alt: "",
        className: (0, $hcewu.default)([
            "_4t3ipxbi _1bsbpxbi"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $aba8ee8166d92834$var$textStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        maxLines: 1
    }, summary)))))) : null;
};
const $aba8ee8166d92834$var$MAX_WIDTH = 300;
const $aba8ee8166d92834$var$rootStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    width: `${$aba8ee8166d92834$var$MAX_WIDTH}px`
});
const $aba8ee8166d92834$var$listItemStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface',
    boxShadow: 'elevation.shadow.overlay',
    position: 'absolute',
    height: 'size.400',
    width: `${$aba8ee8166d92834$var$MAX_WIDTH}px`
});
const $aba8ee8166d92834$var$primaryItemStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.200',
    backgroundColor: 'color.background.input'
});
const $aba8ee8166d92834$var$innerStyles = (0, $1DXK0.xcss)({
    height: '100%'
});
const $aba8ee8166d92834$var$textStyle = (0, $1DXK0.xcss)({
    maxWidth: '220px'
});
const $aba8ee8166d92834$var$imageStyles = null;
const $aba8ee8166d92834$var$child1Styles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    left: 'space.075',
    top: 'space.075'
});
const $aba8ee8166d92834$var$child2Styles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    left: 'space.150',
    top: 'space.150'
});
const $aba8ee8166d92834$var$badgeStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    top: 'space.negative.150',
    right: 'space.negative.150',
    borderRadius: 'border.radius.circle',
    backgroundColor: 'color.background.accent.red.bolder',
    width: 'size.200',
    height: 'size.200',
    color: 'color.text.inverse'
});
const $aba8ee8166d92834$var$smallContentStyles = (0, $1DXK0.xcss)({
    font: 'font.body.small'
});

});

parcelRegister("bCFDb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4ec151de2659cca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d4ec151de2659cca$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.label",
        "defaultMessage": "Actions"
    },
    addParent: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.add-parent",
        "defaultMessage": "Add parent"
    },
    changeParent: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.change-parent",
        "defaultMessage": "Change parent"
    },
    moveToTop: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-to-top",
        "defaultMessage": "Move to top"
    },
    moveUp: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-up",
        "defaultMessage": "Move up"
    },
    moveDown: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-down",
        "defaultMessage": "Move down"
    },
    moveToBottom: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-to-bottom",
        "defaultMessage": "Move to bottom"
    }
});

});


parcelRegister("aTzcv", function(module, exports) {

$parcel$export(module.exports, "SiblingIssueCreateButton", () => $d33708464bf5704f$export$76f0c0887f3df38d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $jQjGM = parcelRequire("jQjGM");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $aBHUF = parcelRequire("aBHUF");

var $6pTKw = parcelRequire("6pTKw");

var $6LwYU = parcelRequire("6LwYU");


var $4NiKr = parcelRequire("4NiKr");

var $e980u = parcelRequire("e980u");
const $d33708464bf5704f$var$styles = {
    button: "_1dqonqa1 _189ee4h9 _1h6dmuej _4t3i1tcg _1bsb1tcg _kqswh2mm _16qs1cd0"
};
const $d33708464bf5704f$var$offset = [
    -1,
    -1
]; /**
                                            * Display a 'Create' popup button positioned relative to the nearest containing block that will appear when hovering
                                            * between issue rows.
                                            */ 
const $d33708464bf5704f$export$76f0c0887f3df38d = ({ issuesConnectionId: issuesConnectionId, edgeIndex: edgeIndex })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isInlineIssueCreateActive, { lockIndex: lockIndex, clearIndexAfterDelay: clearIndexAfterDelay }] = (0, $6LwYU.useIsSiblingIssueCreateActive)([
        issuesConnectionId,
        edgeIndex
    ]);
    const [isMouseOverSiblingCreate, setIsMouseOverSiblingCreate] = (0, $eJOHy.useState)(false);
    const { triggerProps: triggerProps } = (0, $4NiKr.useSiblingIssueCreateRow)();
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsMouseOverSiblingCreate(true);
        lockIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
    }, [
        lockIndex
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsMouseOverSiblingCreate(false);
        clearIndexAfterDelay((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
    }, [
        clearIndexAfterDelay
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        triggerProps?.onClick();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'siblingIssueCreateButton');
    }, [
        createAnalyticsEvent,
        triggerProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pTKw.RowPopupButton), {
        alignToYAxis: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQjGM))), {
            label: "",
            LEGACY_size: "small"
        }),
        isVisible: isInlineIssueCreateActive,
        label: formatMessage((0, $e980u.default).createLabel),
        offset: $d33708464bf5704f$var$offset,
        onClick: handleOnClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: triggerProps?.ref,
        tooltipContent: formatMessage((0, $e980u.default).createLabel),
        tooltipPosition: (0, $7jTnu.fg)('jsc_list_reranking_fixes') ? 'left' : undefined,
        xcss: $d33708464bf5704f$var$styles.button
    }), isMouseOverSiblingCreate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBHUF.RowDropIndicator), {
        edge: "top"
    }));
};

});
parcelRegister("e980u", function(module, exports) {

$parcel$export(module.exports, "default", () => $17e444ad74de1b00$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $17e444ad74de1b00$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createLabel: {
        "id": "native-issue-table.ui.row.before-first-cell.sibling-issue-create-button.create-label",
        "defaultMessage": "Create"
    }
});

});



parcelRegister("29rOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cc4cd5321bb6155$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $iqtgH = parcelRequire("iqtgH");

var $bKlUQ = parcelRequire("bKlUQ");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");

var $c2eR8 = parcelRequire("c2eR8");
const $0cc4cd5321bb6155$var$BlankIssueRow = ({ isSelected: isSelected, cellBorder: cellBorder })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { columns: columns } = (0, $jNv5I.useRowContext)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    // Extra column added to account for the blank spacer column added to the table
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        colSpan: columns.length + (isFixedTableLayoutEnabled ? 1 : 0),
        border: cellBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cc4cd5321bb6155$var$Text, {
        isSelected: isSelected
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c2eR8.default).blankRowTextWithArchiveIssueIssueTermRefresh : (0, $c2eR8.default).blankRowTextWithArchiveIssue)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "blankIssue"
    }));
};
var $0cc4cd5321bb6155$export$2e2bcd8739ae039 = $0cc4cd5321bb6155$var$BlankIssueRow;
const $0cc4cd5321bb6155$var$textColorActiveState = "var(--ds-text-selected, #0C66E4)";
const $0cc4cd5321bb6155$var$textColor = "var(--ds-text, #172B4D)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0cc4cd5321bb6155$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19bv1b66 _80om73ad",
            __cmplp.isSelected ? "_syazaqb7" : "_syaz1fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c2eR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0299e96509ca7ed3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0299e96509ca7ed3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    blankRow: {
        "id": "native-issue-table.issue-row.blank-row.blank-row",
        "defaultMessage": "We can't display this issue"
    },
    blankRowText: {
        "id": "native-issue-table.row.blank-row.blank-row-text",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    blankRowTextWithArchiveIssue: {
        "id": "native-issue-table.row.blank-row.blank-row-text-with-archive-issue",
        "defaultMessage": "This issue can\u2019t be opened because it may have been archived or deleted, or you don\u2019t have access to it."
    },
    blankRowTextWithArchiveIssueIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-text-with-archive-issue-issue-term-refresh",
        "defaultMessage": "This work item can\u2019t be opened because it may have been archived or deleted, or you don\u2019t have access to it."
    },
    tooltip: {
        "id": "native-issue-table.issue-row.blank-row.tooltip",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    },
    blankRowIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-issue-term-refresh",
        "defaultMessage": "We can't display this work item"
    },
    blankRowTextIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-text-issue-term-refresh",
        "defaultMessage": "This work item cannot be opened because it may have been deleted or you do not have access to it."
    },
    tooltipIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.tooltip-issue-term-refresh",
        "defaultMessage": "Either this work item has been deleted, or you don\u2019t have access to it."
    }
});

});


parcelRegister("7EMZm", function(module, exports) {

$parcel$export(module.exports, "IssueCreateRow", () => $566ff58d0f75b900$export$a7c20b50f3f5d02c);

var $eJOHy = parcelRequire("eJOHy");

var $es8uT = parcelRequire("es8uT");
const $566ff58d0f75b900$export$a7c20b50f3f5d02c = ({ isFormVisible: isFormVisible, ...props })=>{
    return isFormVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $es8uT.IssueCreateCell), props));
};

});
parcelRegister("es8uT", function(module, exports) {

$parcel$export(module.exports, "IssueCreateCell", () => $c269d40757de226d$export$2337c3632571bf46);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6xIZT = parcelRequire("6xIZT");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $34oCh = parcelRequire("34oCh");

var $7n9BS = parcelRequire("7n9BS");

var $iC2St = parcelRequire("iC2St");
const $c269d40757de226d$export$2337c3632571bf46 = ({ issuesConnectionId: issuesConnectionId, siblingIssueId: siblingIssueId, rankFieldId: rankFieldId, parentIssueAri: parentIssueAri, location: location, ...props })=>{
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    let jql;
    if ((0, $epTsa.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    jql = (0, $34oCh.useJql)();
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    // JSC-169 Set rankFieldId into formContextualFields so correct rank is set for GIC fallback
    const formContextualFields = (0, $eJOHy.useMemo)(()=>isIssueRankDescending ? {
            rankAfterIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        } : {
            rankBeforeIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        }, [
        isIssueRankDescending,
        siblingIssueId,
        rankFieldId
    ]);
    const onCreateIssue = (0, $iC2St.useIssueCreateMutation)({
        issueConnectionId: issuesConnectionId,
        jql: jql,
        ...(0, $7jTnu.fg)('jsc_list_reranking_gate') && {
            location: location
        }
    });
    const handleIssueCreate = (0, $eJOHy.useCallback)((issueToCreate, contextualFields)=>{
        onCreateIssue(issueToCreate, {
            ...contextualFields,
            ...parentIssueAri && {
                parentIssueAri: parentIssueAri
            }
        }, {
            insertAfter: false,
            insertNodeId: siblingIssueId
        });
    }, [
        onCreateIssue,
        parentIssueAri,
        siblingIssueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td",
        xcss: $c269d40757de226d$var$cellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c269d40757de226d$var$boxStyles,
        style: {
            width: `${width}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        contextualFields: formContextualFields,
        onCreateIssue: handleIssueCreate,
        rankFieldId: rankFieldId,
        location: location,
        ...props
    })));
};
const $c269d40757de226d$var$cellStyles = (0, $1DXK0.xcss)({
    height: '40px',
    left: 'space.0',
    position: 'sticky',
    zIndex: 'card'
});
const $c269d40757de226d$var$boxStyles = (0, $1DXK0.xcss)({
    left: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});


parcelRegister("6tbsq", function(module, exports) {

$parcel$export(module.exports, "IssueRow", () => $2743eb5a6b2ee3f3$export$29013dcb6d1b879d);

var $iGar9 = parcelRequire("iGar9");

var $3oQNl = parcelRequire("3oQNl");

var $7Jlhw = parcelRequire("7Jlhw");

var $6R0Vi = parcelRequire("6R0Vi");

var $eJOHy = parcelRequire("eJOHy");

var $buoPQ = parcelRequire("buoPQ");

var $12DRg = parcelRequire("12DRg");

var $5PQOA = parcelRequire("5PQOA");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $ljej9 = parcelRequire("ljej9");

var $j8Km1 = parcelRequire("j8Km1");

var $gYnSx = parcelRequire("gYnSx");

var $ftN6c = parcelRequire("ftN6c");

var $7n9BS = parcelRequire("7n9BS");

var $8jOO7 = parcelRequire("8jOO7");

var $1VefS = parcelRequire("1VefS");

var $1iVG2 = parcelRequire("1iVG2");

var $lqvgs = parcelRequire("lqvgs");

var $7Rkba = parcelRequire("7Rkba");

var $kFDsf = parcelRequire("kFDsf");

var $lGSrF = parcelRequire("lGSrF");

var $cIMhw = parcelRequire("cIMhw");

var $a2txc = parcelRequire("a2txc");

var $jGEbG = parcelRequire("jGEbG");

var $ce2G1 = parcelRequire("ce2G1");

var $6HQQO = parcelRequire("6HQQO");

var $9GFuY = parcelRequire("9GFuY");

var $j1xvD = parcelRequire("j1xvD");

var $1OSuW = parcelRequire("1OSuW");

var $eVFZZ = parcelRequire("eVFZZ");

var $dBL3m = parcelRequire("dBL3m");

var $icPQx = parcelRequire("icPQx");

var $3rjQa = parcelRequire("3rjQa");

var $cg2Iv = parcelRequire("cg2Iv");

var $3jrj1 = parcelRequire("3jrj1");

var $kta9N = parcelRequire("kta9N");

var $bwtnm = parcelRequire("bwtnm");

var $16mrC = parcelRequire("16mrC");

var $dpp73 = parcelRequire("dpp73");

var $idXX1 = parcelRequire("idXX1");

var $8nvWc = parcelRequire("8nvWc");

var $6AOez = parcelRequire("6AOez");

var $kcYXT = parcelRequire("kcYXT");

var $fvCj0 = parcelRequire("fvCj0");

var $cS9gj = parcelRequire("cS9gj");

var $cC5v7 = parcelRequire("cC5v7");

var $3PbyM = parcelRequire("3PbyM");

var $bmB3W = parcelRequire("bmB3W");

var $cmNPo = parcelRequire("cmNPo");

var $273hQ = parcelRequire("273hQ");

var $iour7 = parcelRequire("iour7");

var $7B1xx = parcelRequire("7B1xx");

var $9PzxA = parcelRequire("9PzxA");

var $iYWyN = parcelRequire("iYWyN");

var $bKlUQ = parcelRequire("bKlUQ");

var $P01So = parcelRequire("P01So");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");

var $6O6q1 = parcelRequire("6O6q1");

var $hL4Y9 = parcelRequire("hL4Y9");

var $emEZF = parcelRequire("emEZF");

var $jT7JX = parcelRequire("jT7JX");

var $3vVaS = parcelRequire("3vVaS");

var $e5umc = parcelRequire("e5umc");

var $40qcF = parcelRequire("40qcF");

var $eQ4s7 = parcelRequire("eQ4s7");

var $e8DGh = parcelRequire("e8DGh");

var $cOqgG = parcelRequire("cOqgG");

var $bgTt1 = parcelRequire("bgTt1");

var $cvtnA = parcelRequire("cvtnA");

var $69bTC = parcelRequire("69bTC");
const $2743eb5a6b2ee3f3$export$cc10a6916fdb60c = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((typename, createAnalyticsEvent)=>{
    (0, $gYnSx.default)({
        meta: {
            id: 'tableCellUnhandledGraphQLType',
            packageName: (0, $8jOO7.PACKAGE_NAME),
            teamName: (0, $8jOO7.TEAM_NAME)
        },
        error: new Error(`Unhandled GraphQL type ${typename} when trying to render issue field.`),
        event: createAnalyticsEvent({}),
        attributes: {
            typename: typename
        }
    });
});
const $2743eb5a6b2ee3f3$export$b1e360b45a7ed518 = ({ project: project, issue: issue, issueEdge: issueEdge, fieldSets: fieldSets, cellBorder: cellBorder, beforeFirstCell: beforeFirstCell, itemsConnectionId: itemsConnectionId, depth: depth, isRowHoveredOrSelected: isRowHoveredOrSelected, rowIndex: rowIndex, triggerProps: triggerProps, isFormVisible: isFormVisible })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const projectRef = (0, $j4oe4.useFragment)((0, $6R0Vi.default), project);
    const issueDataOld = (0, $j4oe4.useFragment)((0, $7Jlhw.default), issue);
    const issueEdgeData = (0, $j4oe4.useFragment)((0, $3oQNl.default), issueEdge);
    const issueData = (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? // Clean up issueDataOld on experiment cleanup, this will be safe as we the edge data will be made required
    issueEdgeData?.node ?? issueDataOld : issueDataOld;
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $iGar9.default), fieldSets);
    const colorForId = (0, $7jTnu.fg)('jira_list_conditional_formatting') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $e8DGh.useCellsConditionalFormatting)(projectRef, fieldSetsData) : {}; // placeholder for what will soon be const color = ...
    const isCreateSubTaskAllowed = issueData && issueData.issueTypeField?.issueType?.hierarchy?.level === 0;
    const { columns: columns, tableInjectedProps: tableInjectedProps, groupConnectionId: groupConnectionId, groupId: groupId, resizingColumnIndex: resizingColumnIndex } = (0, $jNv5I.useRowContext)();
    const columnConfigByIdMap = (0, $eJOHy.useMemo)(()=>{
        const result = new Map();
        columns.forEach((columnConfig)=>{
            result.set(columnConfig.id, columnConfig);
        });
        return result;
    }, [
        columns
    ]);
    let isIssueHierarchyEnabled = false;
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    let handleStatusUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $7jTnu.fg)('jsc_list_hide_done_items')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    handleStatusUpdate = (0, $jT7JX.useHideDoneItems)({
        itemsConnectionId: itemsConnectionId,
        recordId: (0, $7jTnu.fg)('jsc_hide_done_status_update_check') ? issueData?.__id : issueData.__id,
        projectKey: (0, $P01So.getProjectKeyFromIssueKey)((0, $7jTnu.fg)('jsc_hide_done_status_update_check') ? issueData?.key : issueData.key),
        groupConnectionId: groupConnectionId
    });
    let isMergedColumnEnabled = false;
    if ((0, $7jTnu.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    const handleUpdateCacheNew = (0, $eJOHy.useCallback)((issueKey, fieldName, field)=>{
        tableInjectedProps.onUpdateCache?.(issueKey, fieldName, field);
        handleStatusUpdate(field);
    }, [
        handleStatusUpdate,
        tableInjectedProps
    ]);
    const handleUpdateCache = (0, $7jTnu.fg)('jsc_list_hide_done_items') ? handleUpdateCacheNew : tableInjectedProps.onUpdateCache;
    const isIssueOperationMeatballMenuEnabled = (0, $34oCh.useIsIssueOperationMeatballMenuEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const fieldElementByIdMap = (0, $eJOHy.useMemo)(()=>{
        // Map all issue fields into their respective cell type keyed by fieldSetId. This will be used as a lookup when
        // mapping table columns in the row.
        const result = new Map();
        if (isIssueHierarchyEnabled && issueEdgeData && !(isMergedColumnEnabled && (0, $7jTnu.fg)('jira_list_merged_column_gate')) && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bgTt1.default), {
                isRowHoveredOrSelected: Boolean(isRowHoveredOrSelected),
                itemsConnectionId: itemsConnectionId,
                depth: depth,
                issueRef: issueEdgeData,
                triggerProps: triggerProps,
                isFormVisible: isFormVisible
            });
            result.set((0, $8jOO7.COLUMN_ID_EXPAND_BUTTON), {
                cellElement: element,
                spacing: $2743eb5a6b2ee3f3$var$noSpacingStyles
            });
        }
        if (issueEdgeData && isMergedColumnEnabled && (0, $7jTnu.fg)('jira_list_merged_column_gate')) {
            const { issueTypeField: issueTypeField, issueKeyField: issueKeyField, summaryField: summaryField, fieldId: fieldId } = (0, $69bTC.getMergedFields)(fieldSetsData);
            const isHierarchyEnabled = isIssueHierarchyEnabled && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes');
            if (isHierarchyEnabled || issueTypeField || issueKeyField || summaryField) {
                const mergedColumns = columns.find(({ id: id })=>id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns?.map(({ id: id })=>id) ?? [];
                const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cvtnA.MergedCell), {
                    key: (0, $j8Km1.COLUMN_ID_MERGED_COLUMN),
                    itemsConnectionId: itemsConnectionId,
                    depth: depth,
                    issueRef: issueEdgeData,
                    isRowHoveredOrSelected: Boolean(isRowHoveredOrSelected),
                    isCreateChildFormVisible: isFormVisible,
                    createChildTriggerProps: triggerProps,
                    groupId: groupId,
                    isHierarchyEnabled: isHierarchyEnabled,
                    renderContent: ({ actionButtons: actionButtons })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, issueTypeField && mergedColumns.includes('issuetype') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                            xcss: isHierarchyEnabled ? $2743eb5a6b2ee3f3$var$typeCellStyles : $2743eb5a6b2ee3f3$var$typeCellNoHierarchyStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3jrj1.IssueTypeCell), {
                            fieldRef: issueTypeField
                        })), issueKeyField && mergedColumns.includes('issuekey') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1OSuW.IssueKeyCell), {
                            fieldRef: issueKeyField,
                            issueRef: issueData,
                            onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected,
                            isTruncated: Boolean(summaryField) === false
                        }), !summaryField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                            xcss: $2743eb5a6b2ee3f3$var$childCreateButtonStyle
                        }, actionButtons), summaryField && mergedColumns.includes('summary') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cg2Iv.IssueSummaryCell), {
                            fieldRef: summaryField,
                            issueRef: issueData,
                            onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected,
                            isRowHoveredOrSelected: Boolean(isRowHoveredOrSelected)
                        }, actionButtons))
                });
                result.set((0, $j8Km1.COLUMN_ID_MERGED_COLUMN), {
                    cellElement: element,
                    spacing: $2743eb5a6b2ee3f3$var$noSpacingStyles,
                    multipleFieldLayoutAdjustment: true,
                    columnIds: mergedColumns,
                    ...fieldId ? {
                        fieldId: fieldId
                    } : {}
                });
            }
        }
        fieldSetsData?.edges?.map((edge)=>edge?.node).filter((0, $P01So.isNonNullish)).forEach((fieldSet)=>{
            // @ts-expect-error - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | null'.
            const columnConfig = columnConfigByIdMap.get(fieldSet.fieldSetId);
            if (!fieldSet.fieldSetId || !columnConfig) return;
            const projectKey = (0, $P01So.getProjectKeyFromIssueKey)(issueData.key);
            // Handle Collapsed Fields on a single issue (rare) by simply rendering a node for each field.
            const fieldElements = [];
            // Allow td spacing to be configured for the given field type
            let spacing;
            // Stop gap fix to wrap inline editable field elements in styled containers when there are multiple
            // fields within a single cell. This is necessary as inline editable fields have min-height: 100% by
            // default.
            // TODO JSC-1783 This approach will need to be revised as part of single row height once we gather data
            //  on prevalence of this edge case.
            let multipleFieldLayoutAdjustment;
            let fieldId;
            const hasDuplicates = (fieldSet.fields?.totalCount ?? 1) > 1;
            fieldSet.fields?.edges?.forEach((fieldEdge, count)=>{
                // True if it is the first occuring cell
                const isFirstField = count === 0;
                if ((0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) fieldId = fieldEdge?.node?.id;
                switch(fieldEdge?.node?.__typename){
                    case 'JiraAffectedServicesField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VefS.AffectedServicesCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraCascadingSelectField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cIMhw.CascadingSelectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraCMDBField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kFDsf.CmdbObjectsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraCheckboxesField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Rkba.CheckboxSelectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraComponentsField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGSrF.ComponentsInlineEditCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                                jqlTerm: columnConfig.jqlTerm,
                                projectKey: projectKey
                            }));
                            multipleFieldLayoutAdjustment = true;
                        } else fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGSrF.ComponentsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm,
                            projectKey: projectKey
                        }));
                        break;
                    case 'JiraTimelineField':
                        if (isTimelineEnabled) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e5umc.TimelineCellRenderer), {
                                key: fieldEdge.node.fieldId,
                                depth: depth,
                                groupId: groupId,
                                fieldRef: fieldEdge.node
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraDatePickerField':
                        if (isInlineEditingExtendedFieldSupportEnabled) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a2txc.DateInlineEditCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a2txc.DateCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            if (fieldEdge.node.fieldId === (0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE) spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraDateTimePickerField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jGEbG.DateTimeCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a2txc.DateCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isRequired: fieldEdge.node.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).CREATED || fieldEdge.node.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).UPDATED
                        }));
                        break;
                    case 'JiraEpicLinkField':
                        // This field is deprecated; this field will show text "Replaced by Parent field" as content
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ce2G1.EpicLinkCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraFallbackField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6HQQO.FallbackCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        break;
                    case 'JiraIssueTypeField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3jrj1.IssueTypeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraLabelsField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kta9N.LabelsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        if (fieldEdge.node.fieldId === (0, $j8Km1.KNOWN_COLUMN_TYPES).LABELS || (0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraMultipleSelectField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bwtnm.MultiSelectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraMultipleSelectUserPickerField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            // This field is not treated with single line row height since the read view
                            // is using <AvatarGroup> component from @atlaskit/avatar-group. Until this component is modified,
                            // or rebuilt, right truncation will not be applied.
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16mrC.MultiUserPickerCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraMultipleGroupPickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3vVaS.MultiGroupPickerCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        break;
                    case 'JiraNumberField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idXX1.NumberCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraParentIssueField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6AOez.ParentCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            fieldType: fieldEdge.node.type
                        }));
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraPriorityField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvCj0.PriorityCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraProjectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cS9gj.ProjectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isRequired: fieldEdge.node.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).PROJECT
                        }));
                        break;
                    case 'JiraResolutionField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bmB3W.ResolutionCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraRichTextField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cmNPo.RichTextCell), {
                            issueKey: issueData.key,
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueRef: issueData,
                            isFirstField: isFirstField
                        }));
                        spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraSingleLineTextField':
                        if (fieldEdge.node.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1OSuW.IssueKeyCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueRef: issueData,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        } else if (fieldEdge.node.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cg2Iv.IssueSummaryCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueRef: issueData,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else {
                            if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                                fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kcYXT.PlainTextCell), {
                                    key: fieldEdge.node.fieldId,
                                    fieldRef: fieldEdge.node,
                                    isFirstField: isFirstField,
                                    hasDuplicates: hasDuplicates
                                }));
                                multipleFieldLayoutAdjustment = true;
                            } else fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kcYXT.PlainTextCellOld), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraSingleSelectUserPickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9PzxA.UserCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            projectKey: projectKey,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        if (fieldEdge.node.fieldId === 'assignee' || fieldEdge.node.fieldId === 'reporter' || (0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraSingleSelectField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $273hQ.SingleSelectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraSprintField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iour7.SprintCell), {
                            key: fieldEdge.node.fieldId,
                            projectKey: (0, $ljej9.toProjectKey)(projectKey),
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm
                        }));
                        spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraStatusCategoryField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $icPQx.IssueStatusCategoryCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraStatusField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3rjQa.IssueStatusCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueKey: issueData.key,
                            issueId: issueData.issueId,
                            onUpdateCache: handleUpdateCache
                        }));
                        break;
                    case 'JiraServiceManagementRequestTypeField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PbyM.RequestTypeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraTeamViewField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7B1xx.TeamCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraIssueLinkField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eVFZZ.IssueLinksCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            issueKey: issueData.key
                        }));
                        break;
                    case 'JiraCommentSummaryField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6O6q1.CommentSummaryCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueKey: issueData.key,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraUrlField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hL4Y9.UrlCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraOriginalTimeEstimateField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nvWc.OriginalEstimateCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraRadioSelectField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cC5v7.RadioSelectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraMultipleVersionPickerField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emEZF.MultiVersionPickerCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iYWyN.VersionsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm,
                            projectKey: projectKey
                        }));
                        break;
                    case 'JiraGoalsField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1xvD.GoalsCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraConfluenceRemoteIssueLinksField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dpp73.ConfluencePagesCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraFlagField':
                        if ((0, $7jTnu.fg)('jsc_inline_editing_flag_fix')) fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9GFuY.FlagCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraWatchesField':
                        if ((0, $7jTnu.fg)('render_jirawatchesfield_nin')) fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $40qcF.WatchersCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraIssueLinkRelationshipTypeField':
                        if ((0, $7jTnu.fg)('jira-linked-work-items-table-kill-switch')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eQ4s7.LinkRelationshipTypeCell), {
                                key: fieldEdge.node.fieldId,
                                issueKey: issueData.key,
                                fieldRef: fieldEdge.node,
                                onIssueUnlink: tableInjectedProps.onIssueDelete,
                                issueStoreId: issueData?.__id,
                                itemsConnectionId: itemsConnectionId
                            }));
                            spacing = $2743eb5a6b2ee3f3$var$noSpacingStyles;
                        }
                        break;
                    default:
                        if (fieldEdge?.node?.__typename && (0, $7jTnu.fg)('jsc_inline_editing_flag_fix')) $2743eb5a6b2ee3f3$export$cc10a6916fdb60c(fieldEdge?.node?.__typename, createAnalyticsEvent);
                        break;
                }
            });
            if (fieldElements.length) result.set(fieldSet.fieldSetId, {
                cellElement: fieldElements,
                spacing: spacing,
                multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment,
                ...fieldId ? {
                    fieldId: fieldId
                } : {}
            });
        });
        // Always include the Issue Operations meatball menu cell.
        // But show it empty if isIssueOperationMeatballMenuEnabled is false
        result.set((0, $8jOO7.COLUMN_ID_MEATBALL_MENU), {
            cellElement: isIssueOperationMeatballMenuEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dBL3m.IssueOperations), {
                key: (0, $8jOO7.COLUMN_ID_MEATBALL_MENU),
                workType: issueData.issueTypeField?.issueType?.name,
                issueId: Number(issueData.issueId),
                issueKey: issueData.key,
                onIssueRefetch: tableInjectedProps.onIssueRefetch,
                onIssueDelete: tableInjectedProps.onIssueDelete,
                isCreateSubTaskAllowed: isCreateSubTaskAllowed
            })
        });
        result.set((0, $8jOO7.COLUMN_ID_CHECKBOX), {
            cellElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lqvgs.CheckboxCell), {
                issueId: issueData.issueId,
                rowIndex: rowIndex
            })
        });
        return result;
    }, [
        isIssueHierarchyEnabled,
        issueEdgeData,
        isMergedColumnEnabled,
        fieldSetsData,
        isIssueOperationMeatballMenuEnabled,
        issueData,
        tableInjectedProps.onIssueRefetch,
        tableInjectedProps.onIssueDelete,
        tableInjectedProps.onIssueLinkSelected,
        tableInjectedProps.issueSearchBaseUrl,
        isCreateSubTaskAllowed,
        rowIndex,
        isRowHoveredOrSelected,
        itemsConnectionId,
        depth,
        triggerProps,
        isFormVisible,
        groupId,
        columnConfigByIdMap,
        isTimelineEnabled,
        isInlineEditingExtendedFieldSupportEnabled,
        handleUpdateCache,
        createAnalyticsEvent,
        columns
    ]);
    const cellBorderWithNoInlineBordersStyles = (0, $eJOHy.useMemo)(()=>{
        if (cellBorder === undefined) return $2743eb5a6b2ee3f3$var$noInlineBordersStyles;
        return [
            ...(0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(cellBorder),
            $2743eb5a6b2ee3f3$var$noInlineBordersStyles
        ];
    }, [
        cellBorder
    ]);
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    let scrollLeft = 0;
    let isStickyColumnsVisible = false;
    if ((0, $7jTnu.fg)('issue_table_frozen_columns')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        scrollLeft = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.scrollLeft) || 0;
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, columns.map(({ id: id, type: type, isPlaceHolderField: isPlaceHolderField, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isLastStickyColumn: isLastStickyColumn }, index)=>{
        const field = fieldElementByIdMap.get(id);
        const columnIds = field?.columnIds; /* when cells are merged, multiple column ids */ 
        const formatting = (()=>{
            if (!(0, $7jTnu.fg)('jira_list_conditional_formatting')) return undefined;
            if (!isConditionalFormattingEnabled) return undefined;
            /* merged cell is 1 column, many fields. check each columnId for the column's rules -> find first rule */ if (columnIds) {
                const rules = columnIds.map((columnId)=>colorForId[columnId]).filter(Boolean);
                if (!rules.length) return undefined;
                const appliedRuleIndex = Math.min(...rules.map(({ index: i })=>i));
                /* find rule with lowest index */ return rules.find(({ index: i })=>appliedRuleIndex === i);
            }
            return colorForId[id];
        })();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: id
        }, // TODO: EM-7165 – Update the extra filler cell logic when refactoring the column picker column
        // Empty cell to fill remainig space if configured columns are not wide enough to fill the table
        isFixedTableLayoutEnabled && id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
            border: cellBorderWithNoInlineBordersStyles,
            "aria-hidden": true,
            ...isConditionalFormattingEnabled && {
                formatting: $2743eb5a6b2ee3f3$var$formattingStyles,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                style: {
                    '--issue-row-bg': formatting?.value,
                    '--issue-row-hover-bg': formatting?.hoverValue
                }
            }
        }), isPlaceHolderField && (0, $7jTnu.fg)('jira_inline_field_config_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1iVG2.LoadingCell), {
            cellBorder: cellBorder
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cOqgG.default), {
            type: type,
            beforeElement: index === 0 ? beforeFirstCell : undefined,
            cellElement: field?.cellElement,
            spacing: field?.spacing,
            multipleFieldLayoutAdjustment: field?.multipleFieldLayoutAdjustment,
            border: cellBorder,
            ...isConditionalFormattingEnabled && {
                formatting: (0, $7jTnu.fg)('issue_table_frozen_columns') ? $2743eb5a6b2ee3f3$var$formattingStyles : $2743eb5a6b2ee3f3$var$formattingStylesOld,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                style: {
                    '--issue-row-bg': formatting?.value,
                    '--issue-row-hover-bg': formatting?.hoverValue
                }
            },
            ...isStickyColumnsVisible && (0, $7jTnu.fg)('issue_table_frozen_columns') && {
                isColumnSticky: isColumnSticky,
                stickyOffsets: stickyOffsets,
                hasRightShadow: isLastStickyColumn && scrollLeft > 0,
                isColumnResizing: isColumnSticky && (resizingColumnIndex ?? 0) < index && (0, $7jTnu.fg)('issue_table_frozen_columns')
            },
            ...field?.fieldId && {
                fieldId: field.fieldId
            }
        }));
    }));
};
const $2743eb5a6b2ee3f3$var$noSpacingStyles = (0, $1DXK0.xcss)({
    padding: 'space.0'
});
const $2743eb5a6b2ee3f3$var$noInlineBordersStyles = (0, $1DXK0.xcss)({
    borderLeftWidth: '0',
    borderRightWidth: '0'
});
const $2743eb5a6b2ee3f3$var$formattingStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error XCSS typings don't allow css variables
    backgroundColor: 'var(--issue-row-bg, inherit)',
    ':hover': {
        // @ts-expect-error XCSS typings don't allow css variables
        backgroundColor: 'var(--issue-row-hover-bg, inherit)'
    }
});
const $2743eb5a6b2ee3f3$var$formattingStylesOld = (0, $1DXK0.xcss)({
    // @ts-expect-error XCSS typings don't allow css variables
    backgroundColor: 'var(--issue-row-bg)',
    ':hover': {
        // @ts-expect-error XCSS typings don't allow css variables
        backgroundColor: 'var(--issue-row-hover-bg)'
    }
});
const $2743eb5a6b2ee3f3$var$typeCellStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.050'
});
const $2743eb5a6b2ee3f3$var$typeCellNoHierarchyStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.100'
});
const $2743eb5a6b2ee3f3$var$childCreateButtonStyle = (0, $1DXK0.xcss)({
    marginLeft: 'auto',
    marginRight: 'space.100'
});
const $2743eb5a6b2ee3f3$export$29013dcb6d1b879d = /*#__PURE__*/ (0, $eJOHy.memo)($2743eb5a6b2ee3f3$export$b1e360b45a7ed518);

});
parcelRegister("iGar9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfa3c7844136bb02$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06df9df3570aa6e750a93088e54d5e1d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bfa3c7844136bb02$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "type"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets",
        "selections": [
            {
                "condition": "isConditionalFormattingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "useCellsConditionalFormatting_fieldSet"
                    }
                ]
            },
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "fieldSetId"
                            },
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "totalCount"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "affectedServices_nativeIssueTable_AffectedServicesCell"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "cascadingSelect_nativeIssueTable_CascadingSelectCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "components_nativeIssueTable_ComponentsInlineEditCell_fieldRef"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "dateTime_nativeIssueTable_DateTimeCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "plainText_nativeIssueTable_PlainTextCell_fieldRef"
                                                            },
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "commentSummary_nativeIssueTable_CommentSummaryCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "url_nativeIssueTable_UrlCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "singleSelect_nativeIssueTable_SingleSelectCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "multiSelect_nativeIssueTable_MultiSelectCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "checkboxSelect_nativeIssueTable_CheckboxSelectCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "multiUserPicker_nativeIssueTable_MultiUserPickerCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "team_nativeIssueTable_TeamCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "originalEstimate_nativeIssueTable_OriginalEstimateCell_fieldRef"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "radioSelect_nativeIssueTable_RadioSelectCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "multiVersionPicker_nativeIssueTable_MultiVersionPickerCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "goals_nativeIssueTable_GoalsCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "confluencePages_nativeIssueTable_ConfluencePagesCell"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "cmdbObjects_nativeIssueTable_CmdbObjectsCell"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "components_nativeIssueTable_ComponentsCell_fieldRef"
                                                            },
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "plainText_nativeIssueTable_PlainTextCellOld_fieldRef"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "date_nativeIssueTable_DateCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "date_nativeIssueTable_DateInlineEditCell_fieldRef"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "epicLink_nativeIssueTable_EpicLinkCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "fallback_nativeIssueTable_FallbackCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldRef"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "issueStatus_nativeIssueTable_IssueStatusCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "issueSummary_nativeIssueTable_IssueSummaryCell_fieldRef"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "labels_nativeIssueTable_LabelsCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueType_nativeIssueTable_IssueTypeCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "parent_nativeIssueTable_ParentCell_fieldRef"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "priority_nativeIssueTable_PriorityCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "project_nativeIssueTable_ProjectCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "resolution_nativeIssueTable_ResolutionCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "sprint_nativeIssueTable_SprintCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "user_nativeIssueTable_UserCell_fieldRef"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versions_nativeIssueTable_VersionsCell"
                                                    },
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "isDensityFull",
                                                                "variableName": "isDensityFull"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "richText_nativeIssueTable_RichTextCell_fieldRef"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "requestType_nativeIssueTable_RequestTypeCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueLinks_nativeIssueTable_IssueLinksCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "number_nativeIssueTable_NumberCell_fieldRef"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "multiGroupPicker_nativeIssueTable_MultiGroupPickerCell"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "flag_nativeIssueTable_FlagCell"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "watches_nativeIssueTable_WatchersCell"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "isTimelineEnabled",
                                                                "variableName": "isTimelineEnabled"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "timeline_nativeIssueTable_TimelineCellRenderer"
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$bfa3c7844136bb02$var$node.hash = "d8025a3b0e440cd27505902511cd2d63";
var $bfa3c7844136bb02$export$2e2bcd8739ae039 = $bfa3c7844136bb02$var$node;

});

parcelRegister("3oQNl", function(module, exports) {

$parcel$export(module.exports, "default", () => $987f4fc5209fcddf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5007c4cca7f49bfeebe273af81388cf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $987f4fc5209fcddf$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v1 = {
        "kind": "Variable",
        "name": "projectKeys",
        "variableName": "projectKeys"
    }, v2 = {
        "kind": "Variable",
        "name": "shouldQueryHasChildren",
        "variableName": "shouldQueryHasChildren"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issueEdge",
        "selections": [
            {
                "args": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "firstColumnCell_nativeIssueTable"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isJscM2Enabled",
                                "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                            },
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ],
                        "kind": "FragmentSpread",
                        "name": "mergedCell_nativeIssueTable"
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                    "kind": "LinkedField",
                                                    "name": "hierarchy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "level"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "issueSummary_nativeIssueTable_IssueSummaryCell_issueRef"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isDensityFull",
                                    "variableName": "isDensityFull"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "richText_nativeIssueTable_RichTextCell_issueRef"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "node"
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$987f4fc5209fcddf$var$node.hash = "63c2525b4d6ca8062d2c8d0b97f81f25";
var $987f4fc5209fcddf$export$2e2bcd8739ae039 = $987f4fc5209fcddf$var$node;

});

parcelRegister("7Jlhw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f690996777d107e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<26d5aca3650152ee42d5fba05998f0dd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f690996777d107e$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issue",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "issueId"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "level"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "issueSummary_nativeIssueTable_IssueSummaryCell_issueRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                }
            ],
            "kind": "FragmentSpread",
            "name": "richText_nativeIssueTable_RichTextCell_issueRef"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$6f690996777d107e$var$node.hash = "42952239ebd70a5100b8c66e0fa1831d";
var $6f690996777d107e$export$2e2bcd8739ae039 = $6f690996777d107e$var$node;

});

parcelRegister("6R0Vi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a9a7ef349c6e6c9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0d76fa2d0050b491870f80282438e34d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2a9a7ef349c6e6c9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "issueRow_nativeIssueTable_IssueRowWithFragments_project",
    "selections": [
        {
            "condition": "isConditionalFormattingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useCellsConditionalFormatting_project"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$2a9a7ef349c6e6c9$var$node.hash = "128aeca0e604cff4b96616344f2fb333";
var $2a9a7ef349c6e6c9$export$2e2bcd8739ae039 = $2a9a7ef349c6e6c9$var$node;

});

parcelRegister("1VefS", function(module, exports) {

$parcel$export(module.exports, "AffectedServicesCell", () => $4f66708756f89aa6$export$e6c0da3971931bb1);

var $dG1Di = parcelRequire("dG1Di");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $P01So = parcelRequire("P01So");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $1vkmT = parcelRequire("1vkmT");
const $4f66708756f89aa6$export$e6c0da3971931bb1 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $dG1Di.default), fieldRef);
    const affectedServices = data.selectedAffectedServicesConnection?.edges;
    const filteredAffectedServices = affectedServices?.map((edge)=>edge?.node?.name != null ? {
            key: edge.node.serviceId,
            name: edge.node.name
        } : null).filter((0, $P01So.isNonNullish)) ?? [];
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    if (!affectedServices || affectedServices.length !== filteredAffectedServices.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "affectedServices",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: filteredAffectedServices,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $1vkmT.default).triggerButton),
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled
    });
});

});
parcelRegister("dG1Di", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb362ea50691488$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3588ea039c9febd14e0e88de5d01bbc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0eb362ea50691488$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "affectedServices_nativeIssueTable_AffectedServicesCell",
    "selections": [
        {
            "concreteType": "JiraAffectedServiceConnection",
            "kind": "LinkedField",
            "name": "selectedAffectedServicesConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAffectedServiceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraAffectedService",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "serviceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraAffectedServicesField"
};
$0eb362ea50691488$var$node.hash = "ce0f961052b6620f6333f7806e16524e";
var $0eb362ea50691488$export$2e2bcd8739ae039 = $0eb362ea50691488$var$node;

});

parcelRegister("2j0d2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1696def9371c7de3$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $ibVOD = parcelRequire("ibVOD");

var $f8qFy = parcelRequire("f8qFy");
const $1696def9371c7de3$var$ListWithPopup = ({ items: items, ItemComponent: ItemComponent, maxLimit: maxLimit, initialIsOpen: initialIsOpen, isHoverPopoverEnabled: isHoverPopoverEnabled, ...restProps })=>{
    const [firstItem, ...restItems] = items;
    const ShowMorePopupRenderer = (0, $eJOHy.useCallback)(()=>isHoverPopoverEnabled ? /*#__PURE__*/ $eJOHy.createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ $eJOHy.createElement((0, $f8qFy.default), {
            items: restItems,
            maxLimit: maxLimit,
            ItemComponent: ItemComponent,
            initialIsOpen: initialIsOpen,
            isHoverPopoverEnabled: isHoverPopoverEnabled,
            ...restProps
        })) : /*#__PURE__*/ $eJOHy.createElement((0, $f8qFy.default), {
            items: restItems,
            maxLimit: maxLimit,
            ItemComponent: ItemComponent,
            initialIsOpen: initialIsOpen,
            isHoverPopoverEnabled: isHoverPopoverEnabled,
            ...restProps
        }), [
        ItemComponent,
        initialIsOpen,
        isHoverPopoverEnabled,
        maxLimit,
        restItems,
        restProps
    ]);
    if (items.length === 0) return null;
    return /*#__PURE__*/ $eJOHy.createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !isHoverPopoverEnabled,
        xcss: isHoverPopoverEnabled && $1696def9371c7de3$var$hoverPopoverStyles
    }, /*#__PURE__*/ $eJOHy.createElement(ItemComponent, {
        ...firstItem,
        isHoverPopoverEnabled: isHoverPopoverEnabled,
        className: (0, $hcewu.default)([
            isHoverPopoverEnabled && "_1ul9ze3t"
        ])
    }), restItems.length >= 1 && ShowMorePopupRenderer());
};
const $1696def9371c7de3$var$hoverPopoverStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.050',
    width: '100%'
});
const $1696def9371c7de3$var$hoverPopoverItemStyles = null;
var $1696def9371c7de3$export$2e2bcd8739ae039 = $1696def9371c7de3$var$ListWithPopup;

});
parcelRegister("f8qFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4966e4da02c2cf85$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $2ZGUP = parcelRequire("2ZGUP");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $9Mapt = parcelRequire("9Mapt");
const $4966e4da02c2cf85$var$ShowMorePopup = ({ showMoreTooltip: showMoreTooltip, items: items, ItemComponent: ItemComponent, PopupContentWrapper: PopupContentWrapper = (0, $eJOHy.Fragment), maxLimit: maxLimit = 99, OverrideContentComponent: OverrideContentComponent, initialIsOpen: initialIsOpen = false, isHoverPopoverEnabled: isHoverPopoverEnabled = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(initialIsOpen);
    const list = items.slice(0, maxLimit);
    const content = (0, $eJOHy.useCallback)(()=>list.map(({ key: key, ...item })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ItemComponent, item))), [
        ItemComponent,
        list
    ]);
    if (items.length === 0) return null;
    const onClickTrigger = ()=>{
        setIsOpen(!isOpen);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'listWithPopup');
    };
    const contentWithWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: [
                $4966e4da02c2cf85$var$ContainerDialogStyles,
                $4966e4da02c2cf85$var$ContainerDialogBorderStyles
            ]
        }, OverrideContentComponent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PopupContentWrapper, null, content()) : OverrideContentComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null));
    if (isHoverPopoverEnabled) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const hoverPopoverContent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $4966e4da02c2cf85$var$HoverPopoverContainerDialogStyles
            }, OverrideContentComponent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PopupContentWrapper, null, content()) : OverrideContentComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null)), [
            OverrideContentComponent,
            PopupContentWrapper,
            content
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: hoverPopoverContent,
                isInteractive: true
            }, ({ ref: ref, ariaExpanded: ariaExpanded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    isSelected: isOpen,
                    spacing: "none",
                    testId: "list-with-popup.ui.show-more-popup.items-count",
                    "aria-expanded": ariaExpanded,
                    ref: ref,
                    ...props
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4966e4da02c2cf85$var$ItemsCount, null, "+", list.length))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom",
        content: contentWithWrapper,
        testId: "list-with-popup.ui.show-more-popup",
        messageId: "list-with-popup.ui.show-more-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                key: "triggerLinksDialog",
                content: showMoreTooltip,
                tag: $4966e4da02c2cf85$var$TooltipContainer,
                ...(0, $7jTnu.fg)('jsc_inline_editing_field_refactor') && {
                    position: 'top'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: onClickTrigger,
                spacing: "none",
                testId: "list-with-popup.ui.show-more-popup.items-count"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4966e4da02c2cf85$var$ItemsCount, null, "+", list.length)))
    });
};
const $4966e4da02c2cf85$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ...props,
        ref: ref,
        as: "span",
        xcss: $4966e4da02c2cf85$var$tooltipContainerStyles
    }));
const $4966e4da02c2cf85$var$ContainerDialogStyles = (0, $1DXK0.xcss)({
    width: '240px',
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.100'
});
const $4966e4da02c2cf85$var$HoverPopoverContainerDialogStyles = (0, $1DXK0.xcss)({
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.050'
});
const $4966e4da02c2cf85$var$ContainerDialogBorderStyles = (0, $1DXK0.xcss)({
    border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
});
const $4966e4da02c2cf85$var$tooltipContainerStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4966e4da02c2cf85$var$ItemsCount = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _k48pi7a9 _vwz4v47k",
            __cmplp.className
        ])
    });
});
var $4966e4da02c2cf85$export$2e2bcd8739ae039 = $4966e4da02c2cf85$var$ShowMorePopup;

});


parcelRegister("86BUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceecc2739c875115$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $jkYbX = parcelRequire("jkYbX");

var $k71qx = parcelRequire("k71qx");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $9Mapt = parcelRequire("9Mapt");

var $7jTnu = parcelRequire("7jTnu");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $80M6O = parcelRequire("80M6O");
const $ceecc2739c875115$var$fireAnalyticsCache = {};
const $ceecc2739c875115$var$fireAnalyticsDebouncedByCellType = (cellType, reason, event)=>{
    if (!(cellType in $ceecc2739c875115$var$fireAnalyticsCache)) $ceecc2739c875115$var$fireAnalyticsCache[cellType] = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))($ceecc2739c875115$var$fireAnalytics);
    $ceecc2739c875115$var$fireAnalyticsCache[cellType](cellType, reason, event);
};
const $ceecc2739c875115$var$fireAnalytics = (cellType, reason, event)=>{
    const options = reason instanceof Error ? {
        cause: reason
    } : undefined;
    const error = new Error(`Failed to render cell data for the ${cellType} cell type. Reason: ${reason}`, options);
    (0, $gYnSx.default)({
        meta: {
            id: 'errorCell',
            packageName: (0, $8jOO7.PACKAGE_NAME),
            teamName: (0, $8jOO7.TEAM_NAME)
        },
        error: error,
        event: event,
        attributes: {
            cellType: cellType
        },
        sendToPrivacyUnsafeSplunk: true
    });
    // Clean up debounced function after flush
    delete $ceecc2739c875115$var$fireAnalyticsCache[cellType];
};
const $ceecc2739c875115$var$ErrorCell = ({ cellType: cellType, reason: reason })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>setIsHovered(true), []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>setIsHovered(false), []);
    const iconColor = isHovered ? "var(--ds-icon, #44546F)" : "var(--ds-icon-subtle, #626F86)";
    const message = formatMessage((0, $80M6O.default).tooltip);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $7jTnu.fg)('empanada_error_cell_logging')) return;
        const timerId = setTimeout(()=>$ceecc2739c875115$var$fireAnalyticsDebouncedByCellType(cellType, reason, createAnalyticsEvent({})));
        // Cancel any pending events on unmount. This prevents sending an error event when the cell was mounted
        // due to an intermediary render. We've observed this when new columns are committed to the Relay store
        // in a separate render before issue field sets are aligned.
        return ()=>clearTimeout(timerId);
    // Only fire on mount
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('empanada_error_cell_logging')) return;
        const sendAnalytics = ()=>{
            const error = new Error(`Failed to render cell data for the ${cellType} cell type. Reason: ${reason}`);
            (0, $gYnSx.default)({
                meta: {
                    id: 'errorCell',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error,
                event: createAnalyticsEvent({}),
                attributes: {
                    cellType: cellType
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const sendAnalyticsDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(sendAnalytics);
        sendAnalyticsDebounced();
        // Cancel any debounced events on unmount. This prevents sending an error event when the cell was mounted
        // due to an intermediary render. We've observed this when new columns are committed to the Relay store
        // in a separate render before issue field sets are aligned.
        return ()=>{
            sendAnalyticsDebounced.cancel();
        };
    // Only fire on mount
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const cellContent = (ref = null)=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "native-issue-table.common.error-cell.tooltip-target",
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
            color: iconColor,
            label: message,
            spacing: "spacious"
        }));
    if (isSingleLineRowHeightEnabled && !(0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: message
    }, ({ ref: ref })=>cellContent(ref));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: message,
        position: "bottom-start"
    }, cellContent());
};
var $ceecc2739c875115$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($ceecc2739c875115$var$ErrorCell);

});
parcelRegister("80M6O", function(module, exports) {

$parcel$export(module.exports, "default", () => $83096c771fe45e4d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $83096c771fe45e4d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "native-issue-table.common.error-cell.tooltip",
        "defaultMessage": "We couldn\u2019t load this field\u2019s details. Refresh and try again."
    }
});

});


parcelRegister("1vkmT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf4715a793d93265$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bf4715a793d93265$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.affected-services.trigger-button",
        "defaultMessage": "See more affected services"
    }
});

});


parcelRegister("1iVG2", function(module, exports) {

$parcel$export(module.exports, "LoadingCell", () => $be7d804ab43d5c91$export$5191481abee8295e);

var $eJOHy = parcelRequire("eJOHy");

var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");

var $bKlUQ = parcelRequire("bKlUQ");
const $be7d804ab43d5c91$export$5191481abee8295e = ({ cellBorder: cellBorder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: cellBorder ?? $be7d804ab43d5c91$var$cellBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        testId: "native-issue-table.common.ui.issue-cells.loading-cell",
        height: "16px",
        width: "100%",
        borderRadius: "3px"
    }));
};
const $be7d804ab43d5c91$var$cellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: '0',
    borderBottomWidth: 'border.width',
    borderLeftWidth: '0',
    borderRightWidth: 'border.width'
});

});

parcelRegister("7Rkba", function(module, exports) {

$parcel$export(module.exports, "CheckboxSelectCell", () => $cc566242a414d73a$export$1fd5a9db1fedc6bb);

var $2edtZ = parcelRequire("2edtZ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4l5Js = parcelRequire("4l5Js");

var $7jTnu = parcelRequire("7jTnu");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $cc566242a414d73a$export$1fd5a9db1fedc6bb = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $2edtZ.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4l5Js.CheckboxSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: isFirstField ? $cc566242a414d73a$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isSingleLineRowHeightEnabled: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4l5Js.CheckboxSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        menuPosition: "fixed",
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isTruncated: true,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
    });
};
const $cc566242a414d73a$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cc566242a414d73a$var$customTargetStyles,
        ref: ref
    });
});
const $cc566242a414d73a$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("2edtZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f36ab77d085fbf25$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b92cc8d61690b086c94cc5bd1949b44b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f36ab77d085fbf25$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "checkboxSelect_nativeIssueTable_CheckboxSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraCheckboxesField"
};
$f36ab77d085fbf25$var$node.hash = "2c20809123ea14dfdd133e575ffd4309";
var $f36ab77d085fbf25$export$2e2bcd8739ae039 = $f36ab77d085fbf25$var$node;

});

parcelRegister("4l5Js", function(module, exports) {

$parcel$export(module.exports, "CheckboxSelectInlineEditViewWithIsEditable", () => $d58acf5f3ab7c8b2$export$1b3be05b9a6273f2);

var $ioZ2j = parcelRequire("ioZ2j");

var $fktbb = parcelRequire("fktbb");

var $gb8GX = parcelRequire("gb8GX");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $8Y7vF = parcelRequire("8Y7vF");

var $ifQgt = parcelRequire("ifQgt");

var $auNLL = parcelRequire("auNLL");
const $d58acf5f3ab7c8b2$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-checkbox-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $d58acf5f3ab7c8b2$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $d58acf5f3ab7c8b2$export$1b3be05b9a6273f2 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupTarget: editViewPopupTarget, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $gb8GX.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $fktbb.default));
    const { id: uniqueFieldId, name: name, selectedOptions: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                value: edge?.node?.id ?? '',
                label: edge?.node?.value ?? ''
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.value) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateCheckboxesField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateCheckboxesField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOptions: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.value ?? '',
                                            value: edge.label ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $d58acf5f3ab7c8b2$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'checkboxSelect'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d58acf5f3ab7c8b2$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ifQgt.CheckboxSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isHoverPopoverEnabled: isSingleLineRowHeightEnabled
        })), [
        data,
        isTruncated,
        isSingleLineRowHeightEnabled
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            fetchSuggestionsOnMount: true,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $8Y7vF.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
};
const $d58acf5f3ab7c8b2$export$110d4fbf3ef97d6 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $ioZ2j.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d58acf5f3ab7c8b2$export$1b3be05b9a6273f2, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("ioZ2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9d34824802c4510$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<865dcb3c94a5735613636474e65b5c54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d9d34824802c4510$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraCheckboxesField"
};
$d9d34824802c4510$var$node.hash = "578907f93847166d177912bba783cc44";
var $d9d34824802c4510$export$2e2bcd8739ae039 = $d9d34824802c4510$var$node;

});

parcelRegister("fktbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a09d1cb9cb0011a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a674bc11003d5a4f6042bd041448c62>>
 * @relayHash 2f2935fb2f2e43d33d4c8ed1e1b2cd67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8540386bf8ddcde1b4f569318aad611087a8b356d205fa2274ec5675ba438f8e
const $2a09d1cb9cb0011a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCheckboxesFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCheckboxesField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCheckboxesField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCheckboxesFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCheckboxesField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCheckboxesField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8540386bf8ddcde1b4f569318aad611087a8b356d205fa2274ec5675ba438f8e",
            "metadata": {},
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2a09d1cb9cb0011a$var$node.hash = "8471c6b898ae5a82094ee733778542d4";
var $2a09d1cb9cb0011a$export$2e2bcd8739ae039 = $2a09d1cb9cb0011a$var$node;

});

parcelRegister("gb8GX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3fe594bc152f312$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e85c1b6294972f8a4727536d560cd70>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e3fe594bc152f312$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "checkboxSelect_issueFieldCheckboxSelectReadviewFull_CheckboxSelectReadView"
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCheckboxesField"
    };
}();
$e3fe594bc152f312$var$node.hash = "949a32b9c93f1898a846b4634eca9e93";
var $e3fe594bc152f312$export$2e2bcd8739ae039 = $e3fe594bc152f312$var$node;

});

parcelRegister("4s7iN", function(module, exports) {

$parcel$export(module.exports, "useFieldInlineEditActions", () => $d37bf9db13197a19$export$ad535fb3592a66ff);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $fAZgY = parcelRequire("fAZgY");

var $d2AGn = parcelRequire("d2AGn");

var $8c3Yt = parcelRequire("8c3Yt");

var $9XwQG = parcelRequire("9XwQG");

var $6jOZV = parcelRequire("6jOZV");

var $itOZI = parcelRequire("itOZI");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $3mxJ5 = parcelRequire("3mxJ5");

var $78Ere = parcelRequire("78Ere");

var $kB1g4 = parcelRequire("kB1g4");

var $aIlUW = parcelRequire("aIlUW");

var $SKIZT = parcelRequire("SKIZT");
const $d37bf9db13197a19$var$defaultIsEquals = (a, b)=>a === b;
const $d37bf9db13197a19$export$ad535fb3592a66ff = ({ attributes: attributes, fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, initialValue: initialValue, isValueEqual: isValueEqual = $d37bf9db13197a19$var$defaultIsEquals, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onUpdateValue: onUpdateValue, startWithEditViewOpen: startWithEditViewOpen = false, updatedValue: updatedValue, validator: validator, setAnalyticsAttributes: setAnalyticsAttributes, analyticsFieldType: analyticsFieldType, clipboardComponentType: clipboardComponentType })=>{
    const [isEditing, setIsEditing] = (0, $8c3Yt.useOptionallyControlledEditingState)(startWithEditViewOpen, fieldId, (0, $fAZgY.useMemoWithCondition)(()=>({
            // Ensure our updatedValue is re-initialised if editing is enabled via an external store update
            onSharedChange: (sharedIsEditing)=>sharedIsEditing && onUpdateValue(initialValue, true)
        }), [
        onUpdateValue,
        initialValue
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1')));
    const [{ isRealTimeCommentUpdated: isRealTimeCommentUpdated }] = (0, $SKIZT.useRealTimeComments)();
    const [invalidMessage, { validateChange: validateChange, validateSubmit: validateSubmit, clearValidation: clearValidation }] = (0, $9XwQG.useClientValidationHandler)(validator);
    const [hasServerValidationError, { handleSubmitFailed: handleSubmitFailed, clearServerValidation: clearServerValidation }] = (0, $6jOZV.useServerValidationHandler)(fieldName, setIsEditing, onSubmitFailed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    /** Clear any validation errors and transition to read view. */ const onStopEditing = (0, $eJOHy.useCallback)(()=>{
        clearValidation();
        clearServerValidation();
        setIsEditing(false);
    }, [
        clearServerValidation,
        clearValidation,
        setIsEditing
    ]);
    /** Handler to validate and submit the updated value for a field. */ const handleSubmit = (0, $eJOHy.useCallback)((value, analyticsEvent)=>{
        // Early exit if a validation error is present
        if (validateSubmit(value) === 'error') return;
        onStopEditing();
        // Skip mutation if value is unchanged
        if (isValueEqual(initialValue, value)) return;
        onSubmit(value, {
            onSuccess: ()=>{
                // Field updated event is a core action used to track MCU as defined in https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'field updated', {
                    ...attributes,
                    fieldKey: fieldId,
                    fieldType: fieldType,
                    ...(0, $7jTnu.fg)('thor_send_realtime_attribute') ? {
                        isRealTimeCommentUpdated: !!isRealTimeCommentUpdated
                    } : {}
                });
                onSubmitSucceeded?.(value);
            },
            onFail: (error, message)=>{
                handleSubmitFailed(error, message);
                if (!(0, $7jTnu.fg)('relay-migration-issue-fields-assignee-fg')) onSubmitFailed?.(); // we don't need this since it's called in handleSubmitFailed
            }
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
    }, [
        attributes,
        createAnalyticsEvent,
        fieldId,
        fieldType,
        handleSubmitFailed,
        initialValue,
        isValueEqual,
        onStopEditing,
        onSubmit,
        onSubmitFailed,
        onSubmitSucceeded,
        validateSubmit,
        isRealTimeCommentUpdated
    ]);
    /** Exits `editView` and switches back to `readView`. This is called when the cancel action button (x) is clicked. */ const handleCancel = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        onStopEditing();
        onCancel?.();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
    }, [
        onCancel,
        onStopEditing
    ]);
    /** Handler called when readView is clicked. */ const handleEdit = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        // Re-initialise the edit view value unless there is a server error, in which case we want to preserve the
        // previous dirty value.
        if (!hasServerValidationError) onUpdateValue(initialValue, true);
        setIsEditing(true);
        onEdit?.();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        const fieldIdWithoutAri = (0, $itOZI.getFieldIdFromAri)(fieldId);
        const fieldTypeAttribute = analyticsFieldType ?? fieldType;
        if (fieldIdWithoutAri && fieldTypeAttribute) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldIdWithoutAri, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: fieldTypeAttribute
            }
        });
    }, [
        hasServerValidationError,
        setIsEditing,
        onEdit,
        fieldId,
        fieldType,
        onUpdateValue,
        initialValue,
        createAnalyticsEvent,
        analyticsFieldType
    ]);
    /** Saves and confirms the value entered into the field. It exits `editView` and returns to `readView`. */ const handleConfirm = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        handleSubmit(updatedValue, analyticsEvent);
    }, [
        handleSubmit,
        updatedValue
    ]);
    /**
	 * Handler called when the `editView` is updated by the user. This will validate the input and call
	 * `onUpdateValue` to update the value in state.
	 */ const handleChange = (0, $eJOHy.useCallback)((value)=>{
        validateChange(value);
        onUpdateValue(value, false);
        setAnalyticsAttributes?.(value);
    }, [
        onUpdateValue,
        setAnalyticsAttributes,
        validateChange
    ]);
    /**
	 * Handler called when the `editView` is updated by the user which will immediately confirm the value and return to
	 * `readView`.
	 *
	 * Note that this **will not** run any `change` validator functions. Consumers should instead define a `submit`
	 * validator function if required.
	 */ const handleChangeAndConfirm = (0, $eJOHy.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: 'inlineEdit'
        });
        onUpdateValue(value, false);
        handleSubmit(value, analyticsEvent);
        setAnalyticsAttributes?.(value);
    }, [
        createAnalyticsEvent,
        handleSubmit,
        onUpdateValue,
        setAnalyticsAttributes
    ]);
    const reportClipboardError = (0, $kB1g4.useClipboardErrorReporting)(fieldName, fieldType);
    /**
	 * Attempt to submit changes to a field in the background (i.e. while remaining in `readView`). If the updated
	 * value fails `change` or `submit` validation then we forcibly switch to `editView` to allow users to correct
	 * their changes.
	 */ const handleBackgroundSubmit = (0, $eJOHy.useCallback)((value)=>{
        if (validateChange(value) === 'error' || validateSubmit(value) === 'error') {
            onUpdateValue(value, false);
            setIsEditing(true);
        } else handleChangeAndConfirm(value);
    }, [
        handleChangeAndConfirm,
        setIsEditing,
        onUpdateValue,
        validateChange,
        validateSubmit
    ]);
    const copyToClipboard = (0, $eJOHy.useMemo)(()=>{
        return clipboardComponentType !== undefined ? (0, $3mxJ5.getOnCopyHandler)(clipboardComponentType, /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        initialValue) : undefined;
    }, [
        clipboardComponentType,
        initialValue
    ]);
    const handleCopy = (0, $eJOHy.useMemo)(()=>{
        return ()=>{
            if (copyToClipboard) {
                copyToClipboard();
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clipboardCopy',
                    actionSubject: 'inlineEdit'
                }));
                // Signal the copy event has been explicitly handled
                return true;
            }
            reportClipboardError((0, $78Ere.ClipboardValidationError).copyOperationUnsupported());
            return false;
        };
    }, [
        copyToClipboard,
        createAnalyticsEvent,
        reportClipboardError
    ]);
    const handleCut = (0, $eJOHy.useMemo)(()=>{
        return ()=>{
            if (clipboardComponentType !== undefined && copyToClipboard) {
                copyToClipboard();
                if ((0, $aIlUW.isNullableComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit(null);
                else if ((0, $aIlUW.isStringComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit('');
                else if ((0, $aIlUW.isArrayComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit([]);
                else reportClipboardError((0, $78Ere.ClipboardValidationError).cutNonEditableError(clipboardComponentType));
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clipboardCut',
                    actionSubject: 'inlineEdit'
                }));
                // Signal the copy event has been explicitly handled
                return true;
            }
            reportClipboardError((0, $78Ere.ClipboardValidationError).cutOperationUnsupported());
            return false;
        };
    }, [
        clipboardComponentType,
        copyToClipboard,
        createAnalyticsEvent,
        handleBackgroundSubmit,
        reportClipboardError
    ]);
    const handlePaste = (0, $eJOHy.useMemo)(()=>{
        if (clipboardComponentType !== undefined) {
            const onPaste = (0, $3mxJ5.getOnPasteHandler)(clipboardComponentType);
            return (e)=>{
                try {
                    const value = onPaste(e);
                    if (value !== undefined) {
                        /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
						 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        handleBackgroundSubmit(value);
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'clipboardPaste',
                            actionSubject: 'inlineEdit'
                        }));
                        // Signal the paste event has been explicitly handled
                        return true;
                    }
                } catch (error) {
                    reportClipboardError(error instanceof Error ? error : undefined);
                }
                return false;
            };
        }
        return ()=>{
            reportClipboardError((0, $78Ere.ClipboardValidationError).pasteOperationUnsupported());
            return false;
        };
    }, [
        clipboardComponentType,
        createAnalyticsEvent,
        handleBackgroundSubmit,
        reportClipboardError
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            handleCancel: handleCancel,
            handleEdit: handleEdit,
            handleConfirm: handleConfirm,
            handleChange: handleChange,
            handleChangeAndConfirm: handleChangeAndConfirm,
            hasServerValidationError: hasServerValidationError,
            handleCopy: handleCopy,
            handleCut: handleCut,
            handlePaste: handlePaste,
            invalidMessage: invalidMessage,
            isEditing: isEditing
        }), [
        handleCancel,
        handleChange,
        handleChangeAndConfirm,
        handleConfirm,
        handleEdit,
        handleCopy,
        handleCut,
        handlePaste,
        hasServerValidationError,
        invalidMessage,
        isEditing
    ]);
};

});
parcelRegister("8c3Yt", function(module, exports) {

$parcel$export(module.exports, "IssueContext", () => $d33da18a7f7219ac$export$c436e295255cfd98);
$parcel$export(module.exports, "IssueFieldEditingContextProvider", () => $d33da18a7f7219ac$export$4bdcf555c5e0921f);
$parcel$export(module.exports, "useOptionallyControlledEditingState", () => $d33da18a7f7219ac$export$db1e18c2e86e1a50);

var $eJOHy = parcelRequire("eJOHy");

var $bGobh = parcelRequire("bGobh");
const $d33da18a7f7219ac$export$c436e295255cfd98 = /*#__PURE__*/ (0, $eJOHy.createContext)('localStateMode');
const $d33da18a7f7219ac$export$4bdcf555c5e0921f = ({ children: children, scope: scope })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d33da18a7f7219ac$export$c436e295255cfd98.Provider, {
        value: "sharedStateMode"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bGobh.FieldEditingContainer), {
        scope: scope
    }, children));
const $d33da18a7f7219ac$export$db1e18c2e86e1a50 = (initialState, fieldId, { onLocalChange: onLocalChange, onChange: onChange, onSharedChange: onSharedChange } = {})=>{
    const editingContext = (0, $eJOHy.useContext)($d33da18a7f7219ac$export$c436e295255cfd98);
    const isLocalStateMode = editingContext !== 'sharedStateMode';
    const [sharedState, { setFieldEditingState: setFieldEditingState }] = (0, $bGobh.useFieldIsEditing)(fieldId);
    const [localState, setLocalState] = (0, $eJOHy.useState)(isLocalStateMode ? initialState : sharedState);
    const unifiedOnChange = (0, $eJOHy.useCallback)((newValue)=>{
        onLocalChange?.(newValue, localState);
        onChange?.(newValue, localState);
        setLocalState(newValue);
        if (!isLocalStateMode) setFieldEditingState(fieldId, newValue);
    }, [
        onLocalChange,
        localState,
        onChange,
        isLocalStateMode,
        setFieldEditingState,
        fieldId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // If sharedState updates to a value that is different from localState, it's a shared state update.
        // Otherwise, it's just the shared state following a locally triggered state update
        if (!isLocalStateMode && sharedState !== localState) {
            onSharedChange?.(sharedState, !sharedState);
            onChange?.(sharedState, !sharedState);
            setLocalState(sharedState);
        }
    // We want to ensure this useEffect is only called when the sharedState changes, not when any other dependencies change
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sharedState
    ]);
    const resultState = isLocalStateMode ? localState : sharedState;
    return [
        resultState,
        unifiedOnChange
    ];
};

});
parcelRegister("bGobh", function(module, exports) {

$parcel$export(module.exports, "useFieldIsEditing", () => $c643e2de6411b40d$export$3734a1b20e979e6e);
$parcel$export(module.exports, "useFieldIsEditingActions", () => $c643e2de6411b40d$export$a4850d650526df2e);
$parcel$export(module.exports, "FieldEditingContainer", () => $c643e2de6411b40d$export$4301025b8d3e0255);

var $huH03 = parcelRequire("huH03");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $c643e2de6411b40d$var$Store = (0, $GtRbT.createStore)({
    initialState: {},
    actions: {
        setFieldEditingState: (fieldId, isEditing)=>({ setState: setState })=>{
                setState({
                    [fieldId]: isEditing
                });
            },
        toggleFieldEditingState: (fieldId)=>({ setState: setState, getState: getState })=>{
                if (getState()[fieldId] == null) return undefined;
                const toggledValue = !getState()[fieldId];
                setState({
                    [fieldId]: toggledValue
                });
                return toggledValue;
            },
        getFieldEditingState: (fieldId)=>({ getState: getState })=>getState()[fieldId],
        resetFieldEditingStateStore: ()=>({ setState: setState, getState: getState })=>{
                setState((0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(getState(), ()=>false));
            }
    },
    name: 'FieldEditingState'
});
const $c643e2de6411b40d$export$3734a1b20e979e6e = (0, $iJq0l.createHook)($c643e2de6411b40d$var$Store, {
    selector: (state, arg)=>state[arg] != null ? state[arg] : false
});
const $c643e2de6411b40d$export$a4850d650526df2e = (0, $iJq0l.createActionsHook)($c643e2de6411b40d$var$Store);
const $c643e2de6411b40d$export$4301025b8d3e0255 = (0, $6E16M.createContainer)($c643e2de6411b40d$var$Store);

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});



parcelRegister("9XwQG", function(module, exports) {

$parcel$export(module.exports, "useClientValidationHandler", () => $2dafbdf964d3724b$export$f57c10638969fb77);

var $eJOHy = parcelRequire("eJOHy");
/** Return an `ValidationStatus` for a given validation message. */ const $2dafbdf964d3724b$var$getValidationStatus = (message)=>message ? message.type : 'success';
// Priority order for ValidationStatus. Higher value = higher priority.
const $2dafbdf964d3724b$var$invalidStatusPriority = {
    success: 0,
    warning: 1,
    error: 2
};
/**
 * Return the higher priority message of `messageA` and `messageB`. If the priority is equal then `messageA` will be
 * returned.
 */ const $2dafbdf964d3724b$var$getHigherPriorityMessage = (messageA, messageB)=>{
    const statusA = $2dafbdf964d3724b$var$getValidationStatus(messageA);
    const statusB = $2dafbdf964d3724b$var$getValidationStatus(messageB);
    return $2dafbdf964d3724b$var$invalidStatusPriority[statusA] >= $2dafbdf964d3724b$var$invalidStatusPriority[statusB] ? messageA : messageB;
};
const $2dafbdf964d3724b$export$f57c10638969fb77 = (validator)=>{
    const [invalidEvent, setInvalidEvent] = (0, $eJOHy.useState)(null);
    const { change: change, submit: submit } = validator ?? {};
    const validateChange = (0, $eJOHy.useCallback)((value)=>{
        // If no change validator is defined then the value is considered valid
        const message = change ? change(value) : null;
        setInvalidEvent(message ? {
            action: 'change',
            state: message
        } : null);
        return $2dafbdf964d3724b$var$getValidationStatus(message);
    }, [
        change
    ]);
    const validateSubmit = (0, $eJOHy.useCallback)((value)=>{
        // If no submit validator is defined then the value is considered valid
        const message = submit ? submit(value) : null;
        const changeInvalidMessage = invalidEvent?.action === 'change' ? invalidEvent.state : null;
        // Only update the change event invalid state if a higher priority message is returned
        const higherPriorityMessage = $2dafbdf964d3724b$var$getHigherPriorityMessage(message, changeInvalidMessage);
        setInvalidEvent(higherPriorityMessage ? {
            action: 'submit',
            state: higherPriorityMessage
        } : null);
        return $2dafbdf964d3724b$var$getValidationStatus(higherPriorityMessage);
    }, [
        invalidEvent,
        submit
    ]);
    const clearValidation = (0, $eJOHy.useCallback)(()=>{
        setInvalidEvent(null);
    }, []);
    const actions = (0, $eJOHy.useMemo)(()=>({
            validateChange: validateChange,
            validateSubmit: validateSubmit,
            clearValidation: clearValidation
        }), [
        clearValidation,
        validateChange,
        validateSubmit
    ]);
    return [
        invalidEvent?.state ?? null,
        actions
    ];
};

});

parcelRegister("6jOZV", function(module, exports) {

$parcel$export(module.exports, "useServerValidationHandler", () => $1ed3149aae721e64$export$1bf5fbbc94f09320);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $3Kttn = parcelRequire("3Kttn");
const $1ed3149aae721e64$export$1bf5fbbc94f09320 = (fieldName, setIsEditing, onSubmitFailed)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [hasServerValidationError, setHasServerValidationError] = (0, $eJOHy.useState)(false);
    const handleSubmitFailed = (0, $eJOHy.useCallback)((error, message)=>{
        setHasServerValidationError(true);
        const flagId = showFlag({
            type: 'error',
            title: formatMessage((0, $7jTnu.fg)('relay-migration-issue-fields-number') ? (0, $3Kttn.default).submitFailedTitle : (0, $3Kttn.default).submitFailedTitleOld, {
                fieldName: fieldName
            }),
            description: message ?? formatMessage((0, $3Kttn.default).submitFailedDescription),
            testId: (0, $7jTnu.fg)('relay-migration-issue-fields-assignee-fg') ? 'issue-field-validation-handler.controllers.server-validation-handler.submit-failed-flag' : undefined,
            messageId: 'issue-field-validation-handler.controllers.server-validation-handler.show-flag.error.submit-failed',
            messageType: 'transactional',
            onDismissed: ()=>{
                setHasServerValidationError(false);
            },
            // eslint-disable-next-line no-nested-ternary
            actions: (0, $7jTnu.fg)('relay-migration-issue-header-and-parent') ? setIsEditing ? [
                {
                    content: (0, $3Kttn.default).submitFailedTryAgain,
                    onClick: ()=>{
                        setIsEditing(true);
                        flagId && dismissFlag(flagId);
                    }
                }
            ] : undefined : [
                {
                    content: (0, $3Kttn.default).submitFailedTryAgain,
                    onClick: ()=>{
                        setIsEditing?.(true);
                        flagId && dismissFlag(flagId);
                    }
                }
            ]
        });
        (0, $gYnSx.default)({
            meta: {
                id: 'serverValidationHandler',
                packageName: 'jiraIssueFieldValidationHandler',
                teamName: 'empanada'
            },
            event: createAnalyticsEvent({}),
            error: error,
            attributes: {
                fieldName: fieldName
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true
        });
        if ((0, $7jTnu.fg)('relay-migration-issue-fields-assignee-fg')) onSubmitFailed?.(error);
        else onSubmitFailed?.();
    }, [
        dismissFlag,
        fieldName,
        formatMessage,
        onSubmitFailed,
        setIsEditing,
        showFlag,
        createAnalyticsEvent
    ]);
    const clearServerValidation = (0, $eJOHy.useCallback)(()=>setHasServerValidationError(false), []);
    return (0, $eJOHy.useMemo)(()=>[
            hasServerValidationError,
            {
                handleSubmitFailed: handleSubmitFailed,
                clearServerValidation: clearServerValidation
            }
        ], [
        hasServerValidationError,
        handleSubmitFailed,
        clearServerValidation
    ]);
};

});
parcelRegister("3Kttn", function(module, exports) {

$parcel$export(module.exports, "default", () => $663c31e87c1dd7c6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var // Keep up to date with jira/src/packages/issue/keyboard-shortcuts/src/services/assign-to-me-or-unassign/messages.tsx
$663c31e87c1dd7c6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    submitFailedTitleOld: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-title",
        "defaultMessage": "We couldn\u2019t update {fieldName}"
    },
    submitFailedTitle: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-title-new",
        "defaultMessage": "We couldn\u2019t update the {fieldName} value"
    },
    submitFailedDescription: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-description",
        "defaultMessage": "You can try again in a few minutes, or refresh the page."
    },
    submitFailedTryAgain: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-try-again",
        "defaultMessage": "Try editing the field again"
    }
});

});


parcelRegister("itOZI", function(module, exports) {

$parcel$export(module.exports, "getFieldIdFromAri", () => $ab10ef835f490454$export$4ae913a052c0d582);
$parcel$export(module.exports, "getPriorityIdFromAri", () => $ab10ef835f490454$export$d3f3dc1a70aa9a8);
$parcel$export(module.exports, "getUserIdFromAri", () => $ab10ef835f490454$export$364d97890ac491af);
const $ab10ef835f490454$var$FIELD_ID_ARI_REGEX = /ari:cloud:jira:.*?:issuefieldvalue\/.*?\/(.*)/;
const $ab10ef835f490454$var$PRIORITY_ID_ARI_REGEX = /ari:cloud:jira:.*?:priority\/activation\/.*?\/(.*)/;
const $ab10ef835f490454$var$USER_ID_ARI_REGEX = /ari:cloud:identity::user\/(.*)/;
const $ab10ef835f490454$export$4ae913a052c0d582 = (fieldIdOrAri)=>{
    const match = fieldIdOrAri?.match($ab10ef835f490454$var$FIELD_ID_ARI_REGEX);
    return match ? match[1] : fieldIdOrAri;
};
const $ab10ef835f490454$export$d3f3dc1a70aa9a8 = (priorityIdOrAri)=>{
    const match = priorityIdOrAri?.match($ab10ef835f490454$var$PRIORITY_ID_ARI_REGEX);
    return match ? match[1] : priorityIdOrAri;
};
const $ab10ef835f490454$export$364d97890ac491af = (userIdOrAri)=>{
    const match = userIdOrAri?.match($ab10ef835f490454$var$USER_ID_ARI_REGEX);
    return match ? match[1] : userIdOrAri;
};

});

parcelRegister("3mxJ5", function(module, exports) {

$parcel$export(module.exports, "getOnCopyHandler", () => $7f34b51931f27aa7$export$ce96a952c1e6691a);
$parcel$export(module.exports, "getOnPasteHandler", () => $7f34b51931f27aa7$export$66ac6a407d63bc45);

var $hGArn = parcelRequire("hGArn");

var $i6t0v = parcelRequire("i6t0v");

var $67o6i = parcelRequire("67o6i");

var $78Ere = parcelRequire("78Ere");
/** Returns a sanitised HTML string with the provided `componentType` and `value` set as HTML attributes. */ const $7f34b51931f27aa7$var$safelyAddRichValueToHtml = (componentType, value)=>{
    try {
        const html = `<div data-type="table-cell" data-component-type="${componentType}" />`;
        const DOM = new DOMParser().parseFromString(html, 'text/html');
        DOM.body?.querySelector('div')?.setAttribute('data-field-value', JSON.stringify(value));
        return DOM.body?.innerHTML || '';
    } catch (e) {
        return null;
    }
};
function $7f34b51931f27aa7$export$89af511f3acca517(componentType, value, textSerialiser) {
    const clipboardItems = {
        'text/plain': new globalThis.window.Blob([
            textSerialiser(value)
        ], {
            type: 'text/plain'
        })
    };
    const html = $7f34b51931f27aa7$var$safelyAddRichValueToHtml(componentType, value);
    if (html) clipboardItems['text/html'] = new globalThis.window.Blob([
        html
    ], {
        type: 'text/html'
    });
    const clipboardItem = new globalThis.window.ClipboardItem(clipboardItems);
    globalThis.navigator.clipboard.write([
        clipboardItem
    ]);
}
const $7f34b51931f27aa7$export$29418a91c5daf3d9 = (e)=>{
    const html = e.clipboardData?.getData('text/html');
    if (!html) return null;
    try {
        const clipboardDocument = new DOMParser().parseFromString(html, 'text/html');
        const data = clipboardDocument.body?.querySelector('div')?.dataset;
        if (!data || !data.componentType || !data.fieldValue) return null;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            componentType: data.componentType,
            value: JSON.parse(data.fieldValue)
        };
    } catch (error) {
        return null;
    }
};
const $7f34b51931f27aa7$export$ce96a952c1e6691a = (componentType, value)=>{
    const textSerialiser = (0, $hGArn.getDefaultClipboardTextSerialiser)();
    return ()=>$7f34b51931f27aa7$export$89af511f3acca517(componentType, value, textSerialiser);
};
const $7f34b51931f27aa7$export$66ac6a407d63bc45 = (componentType)=>{
    const parser = (0, $i6t0v.getDefaultClipboardParser)(componentType);
    return (e)=>{
        let caughtError;
        const metadata = $7f34b51931f27aa7$export$29418a91c5daf3d9(e);
        if (metadata) try {
            return parser(metadata);
        } catch (error) {
            // Silently ignore and fallthrough
            caughtError = error;
        }
        const plainText = e.clipboardData?.getData('text/plain');
        if (plainText) try {
            if (componentType === 'text') return (0, $67o6i.stringClipboardTextParser)(plainText);
            return (0, $67o6i.defaultClipboardTextParser)(plainText);
        } catch (error) {
            // Silently ignore and fallthrough
            caughtError = caughtError ?? error;
        }
        if (caughtError instanceof (0, $78Ere.ClipboardValidationError)) throw caughtError;
    };
};

});
parcelRegister("hGArn", function(module, exports) {

$parcel$export(module.exports, "getDefaultClipboardTextSerialiser", () => $58f0868807ff38e7$export$2bbd2e5056252b1d);
const $58f0868807ff38e7$export$2bbd2e5056252b1d = ()=>{
    return (value)=>{
        switch(typeof value){
            case 'string':
            case 'number':
            case 'boolean':
                return String(value);
            default:
                return '';
        }
    };
};

});

parcelRegister("i6t0v", function(module, exports) {

$parcel$export(module.exports, "getDefaultClipboardParser", () => $7b612785ecca3e27$export$b221956cf03526aa);

var $78Ere = parcelRequire("78Ere");
const $7b612785ecca3e27$var$isComponentType = (meta, type)=>meta.componentType === type;
const $7b612785ecca3e27$export$b221956cf03526aa = (expectedComponentType)=>{
    return (meta)=>{
        if ($7b612785ecca3e27$var$isComponentType(meta, expectedComponentType)) return meta.value;
        throw (0, $78Ere.ClipboardValidationError).pasteUnexpectedComponentType(meta.componentType, expectedComponentType);
    };
};

});
parcelRegister("78Ere", function(module, exports) {

$parcel$export(module.exports, "ClipboardValidationError", () => $927996358e9f15b0$export$41262351255fc0fe);
class $927996358e9f15b0$export$41262351255fc0fe extends Error {
    constructor(type, message){
        super(message);
        this.name = 'ClipboardValidationError';
        this.type = type;
    }
    static copyOperationUnsupported() {
        return new $927996358e9f15b0$export$41262351255fc0fe('copyOperationUnsupported', 'Copy operation not supported.');
    }
    static cutOperationUnsupported() {
        return new $927996358e9f15b0$export$41262351255fc0fe('cutOperationUnsupported', 'Cut operation not supported.');
    }
    static cutNonEditableError(actual) {
        return new $927996358e9f15b0$export$41262351255fc0fe('cutNonEditableError', `Received component type '${actual}' cannot be cut.`);
    }
    static pasteOperationUnsupported() {
        return new $927996358e9f15b0$export$41262351255fc0fe('pasteOperationUnsupported', 'Paste operation not supported.');
    }
    static pasteUnexpectedComponentType(actual, expected) {
        return new $927996358e9f15b0$export$41262351255fc0fe('pasteUnexpectedComponentType', `Received component type '${actual}' when '${expected}' was expected.`);
    }
    static pasteUnsupportedFormat(format) {
        return new $927996358e9f15b0$export$41262351255fc0fe('pasteUnsupportedFormat', `Unsupported data transfer format '${format}'.`);
    }
}

});


parcelRegister("67o6i", function(module, exports) {

$parcel$export(module.exports, "defaultClipboardTextParser", () => $99079690e1495c78$export$eaf687a0cd453100);
$parcel$export(module.exports, "stringClipboardTextParser", () => $99079690e1495c78$export$95f020f7a1102e64);

var $78Ere = parcelRequire("78Ere");
const $99079690e1495c78$export$eaf687a0cd453100 = ()=>{
    throw (0, $78Ere.ClipboardValidationError).pasteUnsupportedFormat('text/plain');
};
const $99079690e1495c78$export$95f020f7a1102e64 = (plainText)=>plainText;

});


parcelRegister("kB1g4", function(module, exports) {

$parcel$export(module.exports, "useClipboardErrorReporting", () => $f82dd9dc823d71e4$export$a3594035e6545378);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $48Ylx = parcelRequire("48Ylx");

var $78Ere = parcelRequire("78Ere");
const $f82dd9dc823d71e4$var$uniqueFlagId = (0, $hrodw.toFlagId)('JSC_COPY_PASTE_FLAG');
const $f82dd9dc823d71e4$export$f2525c1d596f8d46 = (_)=>{
    throw new Error('Unreachable code reached');
};
const $f82dd9dc823d71e4$var$useGetErrorFlag = (fieldName)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)((errorType)=>{
        switch(errorType){
            case 'copyOperationUnsupported':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).copyErrorTitle),
                    description: formatMessage((0, $48Ylx.default).copyValidationError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.copy-validation-error',
                    messageType: 'transactional'
                };
            case 'cutOperationUnsupported':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).cutErrorTitle),
                    description: formatMessage((0, $48Ylx.default).cutValidationError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.cut-validation-error',
                    messageType: 'transactional'
                };
            case 'cutNonEditableError':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).cutErrorTitle),
                    description: formatMessage((0, $48Ylx.default).cutNonEditableError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.cut-non-editable-error',
                    messageType: 'transactional'
                };
            case 'pasteOperationUnsupported':
            case 'pasteUnexpectedComponentType':
            case 'pasteUnsupportedFormat':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).pasteErrorTitle),
                    description: formatMessage((0, $48Ylx.default).pasteUnsupportedError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.paste-unsupported-error',
                    messageType: 'transactional'
                };
            default:
                return $f82dd9dc823d71e4$export$f2525c1d596f8d46(errorType);
        }
    }, [
        fieldName,
        formatMessage
    ]);
};
const $f82dd9dc823d71e4$export$a3594035e6545378 = (fieldName, fieldType)=>{
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const getErrorFlag = $f82dd9dc823d71e4$var$useGetErrorFlag(fieldName);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((error)=>{
        if (error instanceof (0, $78Ere.ClipboardValidationError)) {
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'inlineEdit clipboardValidationError', {
                clipboardValidationErrorType: error.type,
                fieldType: fieldType
            });
            dismissFlag($f82dd9dc823d71e4$var$uniqueFlagId);
            showFlag({
                ...getErrorFlag(error.type),
                id: $f82dd9dc823d71e4$var$uniqueFlagId
            });
        } else {
            const ugcSafeMessage = `Failed to perform clipboard operation for field of type ${fieldType}`;
            (0, $gYnSx.default)({
                meta: {
                    id: 'clipboardOperationError',
                    packageName: 'jiraIssueFieldCopyPaste',
                    teamName: 'empanada'
                },
                attributes: {
                    message: ugcSafeMessage,
                    fieldType: fieldType
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        dismissFlag,
        fieldType,
        getErrorFlag,
        showFlag
    ]);
};

});
parcelRegister("48Ylx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c28fb312260a79a6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c28fb312260a79a6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    copyErrorTitle: {
        "id": "issue-field-copy-paste.controller.copy-error-title",
        "defaultMessage": "Unable to copy"
    },
    copyValidationError: {
        "id": "issue-field-copy-paste.controller.copy-validation-error",
        "defaultMessage": "{name} can't be copied."
    },
    cutErrorTitle: {
        "id": "issue-field-cut-paste.controller.cut-error-title",
        "defaultMessage": "Unable to cut"
    },
    cutValidationError: {
        "id": "issue-field-cut-paste.controller.cut-validation-error",
        "defaultMessage": "{name} can't be cut."
    },
    cutNonEditableError: {
        "id": "business-list.controllers.clipboard.cut-non-editable-error",
        "defaultMessage": "{name} is copied to your clipboard instead."
    },
    pasteErrorTitle: {
        "id": "issue-field-copy-paste.controller.paste-error-title",
        "defaultMessage": "Unable to paste"
    },
    pasteUnsupportedError: {
        "id": "issue-field-copy-paste.controller.paste-unsupported-error",
        "defaultMessage": "This can't be pasted on {name}."
    }
});

});


parcelRegister("aIlUW", function(module, exports) {

$parcel$export(module.exports, "isNullableComponentType", () => $746cf1207b9950e2$export$caeca7da2724234c);
$parcel$export(module.exports, "isStringComponentType", () => $746cf1207b9950e2$export$6e42f8250885ab5b);
$parcel$export(module.exports, "isArrayComponentType", () => $746cf1207b9950e2$export$1c384554b943e9d8);
/**
 * Exhaustive assertion that will throw for all component types that do not support a `null` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `null` values then it must be added to the below switch
 * case.
 */ const $746cf1207b9950e2$var$assertIsNullableComponentType = (type)=>{
    switch(type){
        case 'number':
        case 'boolean':
        case 'text':
        case 'priority':
        case 'labels':
        case 'originalEstimate':
            throw new Error(`Type '${type}' does not support null values`);
        default:
            return type;
    }
};
const $746cf1207b9950e2$export$caeca7da2724234c = (type)=>{
    try {
        $746cf1207b9950e2$var$assertIsNullableComponentType(type);
        return true;
    } catch  {
        return false;
    }
};
/**
 * Exhaustive assertion that will throw for all component types that do not support a `string` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `string` values then it must be added to the below
 * switch case.
 */ const $746cf1207b9950e2$var$assertIsStringComponentType = (type)=>{
    switch(type){
        case 'number':
        case 'boolean':
        case 'checkboxSelect':
        case 'numberNullable':
        case 'priority':
        case 'sprint':
        case 'singleUser':
        case 'labels':
        case 'singleSelect':
        case 'multiUserPicker':
        case 'multiSelect':
        case 'multiGroupPicker':
        case 'cascadingSelect':
        case 'radioSelect':
        case 'components':
        case 'team':
        case 'multiVersionSelect':
        case 'parent':
            throw new Error(`Type '${type}' does not support string values`);
        default:
            return type;
    }
};
const $746cf1207b9950e2$export$6e42f8250885ab5b = (type)=>{
    try {
        $746cf1207b9950e2$var$assertIsStringComponentType(type);
        return true;
    } catch  {
        return false;
    }
};
/**
 * Exhaustive assertion that will throw for all component types that do not support an `array` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `array` values then it must be added to the below
 * switch case.
 */ const $746cf1207b9950e2$var$assertIsArrayComponentType = (type)=>{
    switch(type){
        case 'date':
        case 'dateTime':
        case 'text':
        case 'number':
        case 'numberNullable':
        case 'boolean':
        case 'sprint':
        case 'originalEstimate':
        case 'singleUser':
        case 'singleSelect':
        case 'url':
        case 'priority':
        case 'cascadingSelect':
        case 'radioSelect':
        case 'team':
        case 'parent':
            throw new Error(`Type '${type}' does not support array values`);
        default:
            return type;
    }
};
const $746cf1207b9950e2$export$1c384554b943e9d8 = (type)=>{
    try {
        $746cf1207b9950e2$var$assertIsArrayComponentType(type);
        return true;
    } catch  {
        return false;
    }
};

});

parcelRegister("SKIZT", function(module, exports) {

$parcel$export(module.exports, "useRealTimeComments", () => $b2344957e97b16de$export$77846b359c3804dd);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $b2344957e97b16de$var$initialState = {
    isRealTimeCommentUpdated: false
};
const $b2344957e97b16de$var$actions = {
    setRealTimeCommentUpdated: (isRealTimeCommentUpdated)=>({ setState: setState })=>{
            setState({
                isRealTimeCommentUpdated: isRealTimeCommentUpdated
            });
        }
};
const $b2344957e97b16de$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view.controllers.realtime-comments',
    initialState: $b2344957e97b16de$var$initialState,
    actions: $b2344957e97b16de$var$actions
});
const $b2344957e97b16de$export$77846b359c3804dd = (0, $iJq0l.createHook)($b2344957e97b16de$var$store);

});


parcelRegister("99gun", function(module, exports) {

$parcel$export(module.exports, "FieldInlineEditLiteWithEntryPoint", () => $a603698b24549ac2$export$d14ba912eb773f8d);

var $eJOHy = parcelRequire("eJOHy");

var $dllpM = parcelRequire("dllpM");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $tYLUh = parcelRequire("tYLUh");

var $8uEpk = parcelRequire("8uEpk");

var $6TknG = parcelRequire("6TknG");

const $a603698b24549ac2$export$d14ba912eb773f8d = ({ editViewEntryPoint: editViewEntryPoint, editViewEntryPointParams: editViewEntryPointParams, getEditViewProps: getEditViewProps, ...props })=>{
    const { hideEditButton: hideEditButton, isEditable: isEditable, isEditing: isEditing, readView: readView, readViewFitContainerHeight: readViewFitContainerHeight, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, disableReadViewAppearanceOnHoverOnly: disableReadViewAppearanceOnHoverOnly = false } = props;
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const pressTrace = (0, $dllpM.default)('issue.field.inline-edit-lite');
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)(editViewEntryPoint, editViewEntryPointParams);
    const entryPointEventMap = (0, $eJOHy.useMemo)(()=>{
        const actions = (0, $ciFJV.getDefaultEntrypointActionEventMap)(entryPointActions);
        const { click: click } = actions;
        actions.click = (e)=>{
            pressTrace();
            click(e);
        };
        return actions;
    }, [
        entryPointActions,
        pressTrace
    ]);
    const readViewTrigger = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, true, entryPointEventMap);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        // This component can be mounted in an editing state or toggled externally, so we need to ensure the entrypoint
        // is always explicitly loaded when entering edit view.
        if (isEditing) entryPointActions.load();
    }, [
        isEditing,
        entryPointActions
    ]);
    const renderEditView = (fieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "editView",
            packageName: "jiraIssueFieldInlineEditLite",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TknG.ReadViewNonEditable), {
                hideEditButton: hideEditButton,
                isLoading: true,
                readViewFitContainerHeight: readViewFitContainerHeight
            }, readView()),
            runtimeProps: getEditViewProps(fieldProps)
        });
    const renderedOutsideIssueView = readViewFitContainerHeight && props.editViewPopup && props.editViewPopupAlignBlock === 'center';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uEpk.default), {
        ...props,
        ...isExperimentEnabled && {
            value: renderedOutsideIssueView || disableReadViewAppearanceOnHoverOnly ? true : getEditViewProps()?.value || getEditViewProps()?.defaultValue
        },
        readViewContainerRef: isEditable ? readViewTrigger : undefined,
        editView: renderEditView,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled
    });
};

});
parcelRegister("tYLUh", function(module, exports) {

$parcel$export(module.exports, "useBespokeEmptyFieldTextExperiment", () => $6e661923caaee82d$export$5a7b1bb3c8ba459f);

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");

var $ln6Iy = parcelRequire("ln6Iy");
const $6e661923caaee82d$var$useIsExperimentEligible = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    /* Some URL patterns where Issue view is rendered either in a modal or full page or in a sidebar
	The common pattern is presence of issue key in the URL pathname or search params
	1. /browse/TEST-1
	2. /issues/TEST-1
	3. /jira/software/c/projects/TEST/issues/TEST-1
	4. /jira/software/c/projects/TEST/boards/1?selectedIssue=TEST-1
	5. /jira/software/c/projects/TEST/boards/1/backlog?selectedIssue=TEST-1
	6. /jira/software/c/projects/TEST/list?selectedIssue=TEST-1
	*/ const ISSUE_KEY_REGEX = /[A-Z][A-Z0-9]+-\d+/;
    let isFieldRenderedInIssueView = false;
    try {
        isFieldRenderedInIssueView = // eslint-disable-next-line no-restricted-globals
        ISSUE_KEY_REGEX.test(location.search) || ISSUE_KEY_REGEX.test(location.pathname);
    } catch (error) {
        // If regex test fails for some reason, default to false
        isFieldRenderedInIssueView = false;
    }
    return projectType === (0, $ln6Iy.SOFTWARE_PROJECT) && isFieldRenderedInIssueView && (0, $7jTnu.fg)('bespoke-empty-field-text-gate');
};
const $6e661923caaee82d$export$5a7b1bb3c8ba459f = ()=>{
    const isExperimentEligible = $6e661923caaee82d$var$useIsExperimentEligible();
    const isVisibleAlways = isExperimentEligible && (0, $epTsa.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'always', 'never');
    const isVisibleOnHover = isExperimentEligible && (0, $epTsa.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'hover', 'never');
    return {
        bespokeEmptyFieldTextExperimentVariant: isExperimentEligible ? (0, $epTsa.expVal)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'never') : null,
        isExperimentEnabled: isVisibleAlways || isVisibleOnHover,
        isVisibleAlways: isVisibleAlways,
        isVisibleOnHover: isVisibleOnHover
    };
};

});

parcelRegister("8uEpk", function(module, exports) {

$parcel$export(module.exports, "default", () => $166556c5a2840ca0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $f4cRx = parcelRequire("f4cRx");

var $lRq8t = parcelRequire("lRq8t");

var $tYLUh = parcelRequire("tYLUh");

var $dA2s3 = parcelRequire("dA2s3");

var $2TDKv = parcelRequire("2TDKv");

var $2KSbM = parcelRequire("2KSbM");

var $ew20k = parcelRequire("ew20k");

// Fallback placements to be used for the validation popover if it overflows its clipping parent
const $166556c5a2840ca0$var$fallbackPlacements = [
    'left',
    'top-start',
    'auto'
];
/**
 * Component leveraging `@atlassian/jira-inline-edit-lite` to provide consistent spacing and validation UX for issue
 * fields.
 */ const $166556c5a2840ca0$var$FieldInlineEditLite = ({ editView: editView, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupMinWidth: editViewPopupMinWidth, editViewPopupTarget: editViewPopupTarget, fieldName: fieldName, hasUnsubmittedChanges: hasUnsubmittedChanges, hideActionButtons: hideActionButtons, hideEditButton: hideEditButton, invalidMessage: invalidMessage, isEditable: isEditable, isEditing: isEditing, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onCopy: onCopy, onCut: onCut, onPaste: onPaste, readViewFitContainerHeight: readViewFitContainerHeight, readViewContainerRef: readViewContainerRef, readView: readView, readViewContainerTarget: readViewContainerTarget, confirmButtonLabel: confirmButtonLabelProp, cancelButtonLabel: cancelButtonLabelProp, editButtonLabel: editButtonLabelProp, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, value: value })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { context: context, refs: refs } = (0, $f4cRx.useInlineEdit)({
        isEditing: isEditing,
        onCancel: onCancel,
        onConfirm: onConfirm,
        onEdit: onEdit
    });
    const confirmButtonLabel = confirmButtonLabelProp ?? formatMessage((0, $2KSbM.default).confirmButtonLabel, {
        fieldName: fieldName
    });
    const cancelButtonLabel = cancelButtonLabelProp ?? formatMessage((0, $2KSbM.default).cancelButtonLabel, {
        fieldName: fieldName
    });
    const editButtonLabel = editButtonLabelProp ?? formatMessage((0, $2KSbM.default).editButtonLabel, {
        fieldName: fieldName
    });
    if (isEditing && isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2TDKv.EditView), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: editViewPopupMinWidth,
        editViewPopupTarget: editViewPopupTarget,
        hideActionButtons: hideActionButtons,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dA2s3.default), {
        message: invalidMessage,
        trigger: (triggerProps)=>editView(triggerProps),
        placement: "right",
        fallbackPlacements: $166556c5a2840ca0$var$fallbackPlacements
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ew20k.ReadView), {
        context: context,
        editButtonLabel: editButtonLabel,
        editButtonRef: refs.editButton,
        hideEditButton: hideEditButton,
        isEditInteractionEnabled: isEditable,
        isInvalid: hasUnsubmittedChanges,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readViewContainerRef: readViewContainerRef,
        onCopy: onCopy,
        onCut: onCut,
        onPaste: onPaste,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        ...isExperimentEnabled && {
            value: value
        },
        readViewContainerTarget: readViewContainerTarget
    }, readView());
};
var $166556c5a2840ca0$export$2e2bcd8739ae039 = $166556c5a2840ca0$var$FieldInlineEditLite;

});
parcelRegister("f4cRx", function(module, exports) {

$parcel$export(module.exports, "useInlineEdit", () => $82c0f5b6e77ac78a$export$4059f16ba5dcb4e1);

var $eJOHy = parcelRequire("eJOHy");

var $6d9QY = parcelRequire("6d9QY");

var $ftN6c = parcelRequire("ftN6c");
const $82c0f5b6e77ac78a$var$actionSubject = 'inlineEdit';
const $82c0f5b6e77ac78a$export$4059f16ba5dcb4e1 = ({ isEditing: isEditing, onCancel: onCancelOption, onConfirm: onConfirmOption, onEdit: onEditOption })=>{
    const editButtonRef = (0, $eJOHy.useRef)(null);
    const preventFocusOnEditButtonRef = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const prevIsEditing = (0, $6d9QY.usePrevious)(isEditing);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !isEditing) {
            if (preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else editButtonRef.current?.focus();
        }
    }, [
        prevIsEditing,
        isEditing
    ]);
    const onCancel = (0, $eJOHy.useCallback)((preventFocusReturn = true)=>{
        preventFocusOnEditButtonRef.current = preventFocusReturn;
        const analyticsEvent = createAnalyticsEvent({
            action: 'canceled',
            actionSubject: $82c0f5b6e77ac78a$var$actionSubject
        });
        onCancelOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onCancelOption
    ]);
    const onConfirm = (0, $eJOHy.useCallback)((preventFocusReturn = true)=>{
        preventFocusOnEditButtonRef.current = preventFocusReturn;
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: $82c0f5b6e77ac78a$var$actionSubject
        });
        onConfirmOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onConfirmOption
    ]);
    const onEdit = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: $82c0f5b6e77ac78a$var$actionSubject
        });
        onEditOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onEditOption
    ]);
    const context = (0, $eJOHy.useMemo)(()=>({
            onCancel: onCancel,
            onConfirm: onConfirm,
            onEdit: onEdit
        }), [
        onCancel,
        onConfirm,
        onEdit
    ]);
    const refs = (0, $eJOHy.useMemo)(()=>({
            editButton: editButtonRef
        }), []);
    return (0, $eJOHy.useMemo)(()=>({
            context: context,
            refs: refs
        }), [
        context,
        refs
    ]);
};

});

parcelRegister("dA2s3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f07c4c3cece0ae1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $iGn6g = parcelRequire("iGn6g");
/**
 * Popup component to display a validation message for inline editable fields. The message will be displayed when the
 * user focuses the trigger attached to this component (which should be an interactive form field), and hidden when the
 * trigger is blurred.
 *
 * Why do we have a custom popup instead of using an existing `@atlaskit` component? There are a couple of caveats from
 * the existing components which makes them unsuitable for our use case:
 * 1. `@atlaskit/popup` - Creates a focus lock within the popup preventing the user from tab navigating to and from the
 * popup content.
 * 2. `@atlaskit/inline-dialog` - Deprecated in favour of `@atlaskit/popup`.
 * 3. `@atlaskit/tooltip` - Does not allow visibility to be controlled via a prop and attaches to mouseover events,
 * which is undesired.
 */ const $7f07c4c3cece0ae1$var$ValidationPopup = ({ message: message, placement: placement, fallbackPlacements: fallbackPlacements, trigger: trigger })=>{
    const [isVisuallyHidden, setIsVisuallyHidden] = (0, $eJOHy.useState)(true);
    const wasFocusReceivedSinceLastBlurRef = (0, $eJOHy.useRef)(false);
    const triggerRef = (0, $eJOHy.useRef)();
    const onFocus = ()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
        setIsVisuallyHidden(false);
    };
    const onBlur = ()=>{
        wasFocusReceivedSinceLastBlurRef.current = false;
        setTimeout(()=>{
            if (!wasFocusReceivedSinceLastBlurRef.current) setIsVisuallyHidden(true);
        }, 0);
    };
    const popupContentId = (0, $eJOHy.useMemo)(()=>`${(0, $aXKmr.v4)()}-validation-popup`, []);
    const fieldProps = {
        ref: triggerRef,
        onFocus: onFocus,
        onBlur: onBlur,
        'aria-describedby': isVisuallyHidden ? undefined : popupContentId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, trigger(fieldProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iGn6g.default), {
        id: popupContentId,
        isVisuallyHidden: isVisuallyHidden,
        message: message,
        onFocus: onFocus,
        onBlur: onBlur,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        referenceElement: triggerRef?.current
    }));
};
var $7f07c4c3cece0ae1$export$2e2bcd8739ae039 = $7f07c4c3cece0ae1$var$ValidationPopup;

});
parcelRegister("iGn6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c2d5c88d4613b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $Ys7jv = parcelRequire("Ys7jv");
var $2rPSy = parcelRequire("2rPSy");

var $IW7jS = parcelRequire("IW7jS");

var $9cbmy = parcelRequire("9cbmy");

var $8cv11 = parcelRequire("8cv11");

var $efqhN = parcelRequire("efqhN");
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $b1c2d5c88d4613b7$var$getDirectionFromPlacement = (placement)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    placement.split('-')[0];
// Inverts motion direction
const $b1c2d5c88d4613b7$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $b1c2d5c88d4613b7$var$ValidationPopper = ({ id: id, isVisuallyHidden: isVisuallyHidden, message: message, onFocus: onFocus, onBlur: onBlur, placement: placement, fallbackPlacements: fallbackPlacements, referenceElement: referenceElement })=>{
    const updateRef = (0, $eJOHy.useRef)();
    const modifiers = (0, $eJOHy.useMemo)(()=>[
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ], [
        fallbackPlacements
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Since we are applying visually hidden styles instead of unmounting the popup for accessibility reasons,
        // there will be cases where the popup placement is calculated while it's visually hidden (e.g. when a
        // validation occurs on blur). While visually hidden, popup size is 1px x 1px, and this can make Popper
        // think that the popup fits in a placement where it doesn't actually fit, and end up overflowing the
        // viewport. To prevent this from happening, we ask Popper to recompute popup position when it becomes visible.
        !isVisuallyHidden && updateRef.current?.();
    }, [
        isVisuallyHidden
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ys7jv.default), {
        appear: true
    }, message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        placement: placement,
        referenceElement: referenceElement,
        strategy: "absolute",
        modifiers: modifiers,
        messageId: "issue-field-validation-popup.ui.validation-popper.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, placement: finalPlacement, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2rPSy.default), {
            entranceDirection: $b1c2d5c88d4613b7$var$invertedDirection[$b1c2d5c88d4613b7$var$getDirectionFromPlacement(finalPlacement)]
        }, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line jira/react/no-style-attribute
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...style,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    ...isVisuallyHidden && (0, $9cbmy.visuallyHiddenStyles),
                    zIndex: (0, $IW7jS.layers).layer()
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $efqhN.default), {
                ...message,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                id: id,
                onFocus: onFocus,
                onBlur: onBlur,
                "data-testid": "issue-field-validation-popup.ui.validation-popper.popup-content",
                testId: `issue-field-validation-popup.ui.validation-popper.popup-content${isVisuallyHidden ? '-hidden' : ''}`
            })));
    }));
};
var $b1c2d5c88d4613b7$export$2e2bcd8739ae039 = $b1c2d5c88d4613b7$var$ValidationPopper;

});
parcelRegister("efqhN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2564887d15946d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1NG86 = parcelRequire("1NG86");

var $jkYbX = parcelRequire("jkYbX");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $iyBj8 = parcelRequire("iyBj8");
const $fa2564887d15946d$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $fa2564887d15946d$var$useIcon = (type)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    switch(type){
        case 'error':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                spacing: "spacious",
                label: formatMessage((0, $iyBj8.default).errorLabel),
                color: "var(--ds-icon-danger, #C9372C)"
            });
        case 'warning':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
                spacing: "spacious",
                label: formatMessage((0, $iyBj8.default).warningLabel),
                color: "var(--ds-icon-warning, #E56910)"
            });
        default:
            $fa2564887d15946d$var$assertUnreachable(type);
    }
};
const $fa2564887d15946d$var$PopupContent = ({ className: className, id: id, message: message, onFocus: onFocus, onBlur: onBlur, testId: testId, title: title, type: type })=>{
    const icon = $fa2564887d15946d$var$useIcon(type);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa2564887d15946d$var$Content // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        role: "alert",
        id: id,
        hasTitle: !!title,
        onFocus: onFocus,
        onBlur: onBlur,
        "data-testid": testId
    }, icon, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockEnd: "space.075",
        xcss: $fa2564887d15946d$var$titleStyles
    }, title), message) : message);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa2564887d15946d$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasTitle: hasTitle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _1e0c1txw _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _vchhusvi _p12f1feq _bfhk1bhr _16qs1cd0 _1bsb1ns9",
            __cmplp.hasTitle ? "_zulppxbi" : "_zulp12x7 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $fa2564887d15946d$var$titleStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtle',
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px'
});
var $fa2564887d15946d$export$2e2bcd8739ae039 = $fa2564887d15946d$var$PopupContent;

});
parcelRegister("iyBj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $699d6029843e778e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $699d6029843e778e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorLabel: {
        "id": "issue-field-validation-popup.validation-popper.popup-content.error-label",
        "defaultMessage": "Error"
    },
    warningLabel: {
        "id": "issue-field-validation-popup.validation-popper.popup-content.warning-label",
        "defaultMessage": "Warning"
    }
});

});




parcelRegister("2TDKv", function(module, exports) {

$parcel$export(module.exports, "EditView", () => $589496f4abd155cb$export$280eb2fbab4e5389);

var $eJOHy = parcelRequire("eJOHy");

var $2tS6J = parcelRequire("2tS6J");

var $3Js2r = parcelRequire("3Js2r");
const $589496f4abd155cb$export$280eb2fbab4e5389 = ({ cancelButtonLabel: cancelButtonLabel, children: children, confirmButtonLabel: confirmButtonLabel, context: context, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupMinWidth: editViewPopupMinWidth, editViewPopupTarget: editViewPopupTarget, hideActionButtons: hideActionButtons, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur })=>{
    const form = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2tS6J.Form), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        hideActionButtons: hideActionButtons,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur
    }, children);
    if (editViewPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Js2r.EditViewPopup), {
        alignBlock: editViewPopupAlignBlock,
        width: editViewPopupWidth,
        minWidth: editViewPopupMinWidth,
        target: editViewPopupTarget
    }, form);
    return form;
};

});
parcelRegister("2tS6J", function(module, exports) {

$parcel$export(module.exports, "Form", () => $101e08a54c1b522e$export$a7fed597f4b8afd8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7jTnu = parcelRequire("7jTnu");

var $46mQ4 = parcelRequire("46mQ4");
const $101e08a54c1b522e$export$a7fed597f4b8afd8 = ({ cancelButtonLabel: cancelButtonLabel, children: children, confirmButtonLabel: confirmButtonLabel, context: context, hideActionButtons: hideActionButtons, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur })=>{
    const { onCancel: onCancel, onConfirm: onConfirm } = context;
    const wasFocusReceivedSinceLastBlurRef = (0, $eJOHy.useRef)(false);
    const formRef = (0, $eJOHy.useRef)(null);
    /** If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save)
   */ const onBlur = (0, $eJOHy.useCallback)(()=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            setTimeout(()=>{
                // Check the form hasn't unmounted before attempting to auto-submit
                !wasFocusReceivedSinceLastBlurRef.current && formRef.current && onConfirm(true);
            }, 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        onConfirm
    ]);
    /** Gets called when focus is transferred to the editView, or action buttons
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field
   */ const onFocus = (0, $eJOHy.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const onSubmit = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        onConfirm(false);
    }, [
        onConfirm
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) onSubmit(event);
        if (event.key === 'Esc' || event.key === 'Escape') {
            onCancel(false);
            if ((0, $7jTnu.fg)('jira_issue_view_esc_behaviour_fix')) event.stopPropagation();
        }
    }, [
        onCancel,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($101e08a54c1b522e$var$StyledForm, {
        ref: formRef,
        role: "presentation",
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onSubmit: onSubmit
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46mQ4.FormControls), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        hideActionButtons: hideActionButtons
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $101e08a54c1b522e$var$StyledForm = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("46mQ4", function(module, exports) {

$parcel$export(module.exports, "FormControls", () => $36c7b7a5b7d284f3$export$9b13823dba16e7d1);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bGUQI = parcelRequire("bGUQI");

var $83PoE = parcelRequire("83PoE");
const $36c7b7a5b7d284f3$export$9b13823dba16e7d1 = ({ cancelButtonLabel: cancelButtonLabel, confirmButtonLabel: confirmButtonLabel, context: { onCancel: onCancel }, hideActionButtons: hideActionButtons })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return !hideActionButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $83PoE.default), {
        cancelButtonLabel: cancelButtonLabel ?? formatMessage((0, $bGUQI.default).cancelButtonLabel),
        confirmButtonLabel: confirmButtonLabel ?? formatMessage((0, $bGUQI.default).confirmButtonLabel),
        onCancelClick: ()=>onCancel(false)
    }) : /** This is to allow Ctrl + Enter to submit without action buttons */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
        hidden: true,
        type: "submit",
        "aria-label": formatMessage((0, $bGUQI.default).submitButtonLabel)
    });
};

});
parcelRegister("bGUQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $785a91e9889ee2a9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $785a91e9889ee2a9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    editButtonLabel: {
        "id": "inline-edit-lite.read-view.edit-button-label",
        "defaultMessage": "Edit"
    },
    confirmButtonLabel: {
        "id": "inline-edit-lite.edit-view.confirm-button-label",
        "defaultMessage": "Confirm"
    },
    cancelButtonLabel: {
        "id": "inline-edit-lite.edit-view.cancel-button-label",
        "defaultMessage": "Cancel"
    },
    submitButtonLabel: {
        "id": "inline-edit-lite.edit-view.submit-button-label",
        "defaultMessage": "Submit"
    }
});

});

parcelRegister("83PoE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29521711d40a0dd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $entZ3 = parcelRequire("entZ3");

var $6J9k6 = parcelRequire("6J9k6");
const $b29521711d40a0dd$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b29521711d40a0dd$var$ButtonsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b29521711d40a0dd$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "aria-label": confirmButtonLabel,
        type: "submit",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($entZ3))), {
            label: confirmButtonLabel,
            LEGACY_size: "small"
        }),
        shouldFitContainer: true,
        onMouseDown: onMouseDown
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b29521711d40a0dd$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "aria-label": cancelButtonLabel,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            label: cancelButtonLabel,
            LEGACY_size: "small"
        }),
        onClick: onCancelClick,
        shouldFitContainer: true,
        onMouseDown: onMouseDown
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b29521711d40a0dd$var$ButtonsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1pfh12x7 _kqswstnw _152t1osq _rjxpidpf _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $b29521711d40a0dd$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1cd0 _1mpy1b66 _1nlx1bhr _l2uv16qz _7mfvvq0a _szlb1fxt",
            __cmplp.className
        ])
    });
});
var $b29521711d40a0dd$export$2e2bcd8739ae039 = $b29521711d40a0dd$var$Buttons;

});
parcelRegister("entZ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a77a78d359015cce$var$_react = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a77a78d359015cce$var$_checkMark = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("lwpci")));

var $a77a78d359015cce$var$_check = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("2kdvq")));
function $a77a78d359015cce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a77a78d359015cce$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a77a78d359015cce$var$_react.default.createElement($a77a78d359015cce$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $a77a78d359015cce$var$_check.default
    }, props));
$a77a78d359015cce$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $a77a78d359015cce$var$_default = module.exports.default = $a77a78d359015cce$var$CheckMarkIcon;

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5437a6fa40a6a5e2291c258b3bd34ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});

parcelRegister("2kdvq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b17ecff78f4ff04$var$_react = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1b17ecff78f4ff04$var$_checkMark = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("lwpci")));
function $1b17ecff78f4ff04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1b17ecff78f4ff04$var$CheckIcon = (props)=>/*#__PURE__*/ $1b17ecff78f4ff04$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $1b17ecff78f4ff04$var$_checkMark.default
    }));
$1b17ecff78f4ff04$var$CheckIcon.displayName = 'CheckIcon';
var $1b17ecff78f4ff04$var$_default = module.exports.default = $1b17ecff78f4ff04$var$CheckIcon;

});





parcelRegister("3Js2r", function(module, exports) {

$parcel$export(module.exports, "EditViewPopup", () => $685159e43c153664$export$3ce17fd683f703eb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $LFmXM = parcelRequire("LFmXM");

var $6G5P1 = parcelRequire("6G5P1");
var $azjc1 = parcelRequire("azjc1");

var $jd93d = parcelRequire("jd93d");

var $8cv11 = parcelRequire("8cv11");
const $685159e43c153664$var$getModifiers = (alignBlock)=>[
        {
            name: 'offset',
            enabled: alignBlock === 'center',
            options: {
                // Use negative offset of half the popper height to vertically center the content
                offset: ({ popper: popper })=>[
                        0,
                        -popper.height / 2
                    ]
            }
        },
        {
            name: 'flip',
            enabled: false
        },
        {
            name: 'computeStyles',
            options: {
                // Prevent use of 3D transforms to avoid creating a new stacking context for fixed position children
                gpuAcceleration: false
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 0,
                rootBoundary: 'viewport',
                // Allow the popup to remain within the clipping parent when overflowing the Y axis
                altAxis: true
            }
        }
    ];
/** Map the provided alignment to the appropriate popper placement. */ const $685159e43c153664$var$toPopperPlacement = (alignBlock)=>{
    switch(alignBlock){
        case 'end':
            return 'top-start';
        default:
            return 'bottom-start';
    }
};
/** Map the provided min width breakpoint to a pixel value. */ const $685159e43c153664$var$toMinWidth = (minWidth)=>{
    switch(minWidth){
        case 'large':
            return '400px';
        case 'medium':
            return '200px';
        default:
            return '140px';
    }
};
const $685159e43c153664$export$3ce17fd683f703eb = ({ alignBlock: alignBlock = 'start', width: width, minWidth: minWidth = 'medium', target: target, children: children })=>{
    const updateRef = (0, $eJOHy.useRef)();
    const resizeObserver = (0, $eJOHy.useRef)();
    // Cleanup the resize observer when the component is unmounted
    (0, $eJOHy.useEffect)(()=>()=>resizeObserver.current?.disconnect(), []);
    const resizeRef = (0, $eJOHy.useCallback)((el)=>{
        if (el) {
            // Update popup positioning whenever content is resized
            resizeObserver.current = new ResizeObserver(()=>updateRef.current?.());
            resizeObserver.current.observe(el);
        }
    }, []);
    const Target = (0, $eJOHy.useMemo)(()=>target != null ? target : $685159e43c153664$var$DefaultTarget, [
        target
    ]);
    // Ensure a stable ref function is passed through to the popup content
    const memoizedMergeRefs = (0, $eJOHy.useMemo)(()=>(0, $LFmXM.default)((0, $jd93d.mergeRefs)), []);
    const modifiers = (0, $eJOHy.useMemo)(()=>$685159e43c153664$var$getModifiers(alignBlock), [
        alignBlock
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6G5P1.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $azjc1.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Target, {
            ref: ref
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        placement: $685159e43c153664$var$toPopperPlacement(alignBlock),
        strategy: "absolute",
        modifiers: modifiers,
        messageId: "issue-field-inline-edit-lite.ui.field-inline-edit-lite.edit-view.edit-view-popup.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($685159e43c153664$var$Content, {
            ref: memoizedMergeRefs(ref, resizeRef),
            width: width,
            minWidth: minWidth,
            /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style
        }, children);
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $685159e43c153664$var$DefaultTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbidpf",
            __cmplp.className
        ])
    });
});
const $685159e43c153664$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_19fgw0l": (0, $awdRS.default)((()=>{
                return __cmplp.width ? '0px' : `max(100%, ${$685159e43c153664$var$toMinWidth(__cmplp.minWidth)})`;
            })()),
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul91oyu _p12fkbql _1pby16oo",
            __cmplp.width ? "_1bsb1efm" : "_1bsb1ris",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2KSbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b248572e32a7e865$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b248572e32a7e865$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    confirmButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    }
});

});

parcelRegister("ew20k", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $ab3c7684ddf42ea0$export$a4b5824ec1e018e1);

var $eJOHy = parcelRequire("eJOHy");

var $64Dbx = parcelRequire("64Dbx");

var $tYLUh = parcelRequire("tYLUh");

var $k4Rl5 = parcelRequire("k4Rl5");

var $7jTnu = parcelRequire("7jTnu");

var $kjtxW = parcelRequire("kjtxW");
const $ab3c7684ddf42ea0$export$a4b5824ec1e018e1 = ({ children: children, context: context, editButtonLabel: editButtonLabel, editButtonRef: editButtonRef, hideEditButton: hideEditButton, isEditInteractionEnabled: isEditInteractionEnabled, isInvalid: isInvalid, isLoading: isLoading, readViewContainerRef: readViewContainerRef, readViewFitContainerHeight: readViewFitContainerHeight, readViewContainerTarget: readViewContainerTarget, onCopy: onCopy, onCut: onCut, onPaste: onPaste, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, value: value })=>{
    const { isEditButtonFocused: isEditButtonFocused, onClick: onClick, onMouseDown: onMouseDown, onEditButtonBlur: onEditButtonBlur, onEditButtonFocus: onEditButtonFocus } = (0, $64Dbx.useInlineEditReadViewContainer)(context, isEditInteractionEnabled);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { onFocus: onFocus, onBlur: onBlur, lastCopiedTarget: isCopied } = (0, $kjtxW.useCopyPasteTarget)({
        onCopy: onCopy,
        onCut: onCut,
        // Don't allow paste interaction for non-editable fields
        onPaste: isEditInteractionEnabled ? onPaste : undefined
    });
    const handleEditButtonBlur = (0, $eJOHy.useCallback)((e)=>{
        onEditButtonBlur(e);
        onBlur(e);
    }, [
        onEditButtonBlur,
        onBlur
    ]);
    const handleEditButtonFocus = (0, $eJOHy.useCallback)((e)=>{
        onEditButtonFocus(e);
        onFocus(e);
    }, [
        onEditButtonFocus,
        onFocus
    ]);
    if (readViewContainerTarget && (0, $7jTnu.fg)('inline_edit_read_view_container_target')) {
        const Target = readViewContainerTarget;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Target, {
            context: context,
            editButtonLabel: editButtonLabel,
            editButtonRef: editButtonRef,
            hideEditButton: hideEditButton,
            isEditable: isEditInteractionEnabled,
            isLoading: isLoading,
            isInvalid: isInvalid,
            onClick: onClick,
            editViewPreloadTriggerRef: readViewContainerRef
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k4Rl5.default), {
        context: context,
        editButtonLabel: editButtonLabel,
        editButtonRef: editButtonRef,
        hideEditButton: hideEditButton,
        isEditInteractionEnabled: isEditInteractionEnabled,
        isEditButtonFocused: isEditButtonFocused,
        isCopied: isCopied,
        // Highlight the field as invalid to notify the user if there was an error attempting to submit changes.
        isInvalid: isInvalid,
        isLoading: isLoading,
        onClick: onClick,
        onMouseDown: onMouseDown,
        onEditButtonBlur: handleEditButtonBlur,
        onEditButtonFocus: handleEditButtonFocus,
        readViewFitContainerHeight: readViewFitContainerHeight,
        ref: readViewContainerRef,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        ...isExperimentEnabled && {
            value: value
        }
    }, children);
};

});
parcelRegister("64Dbx", function(module, exports) {

$parcel$export(module.exports, "useInlineEditReadViewContainer", () => $8db9de8130ba3246$export$49374f374d70ab51);

var $eJOHy = parcelRequire("eJOHy");
const $8db9de8130ba3246$var$DRAG_THRESHOLD = 5;
const $8db9de8130ba3246$var$isLinkOrButton = (element)=>element.closest('a') != null || element.closest('button') != null;
const $8db9de8130ba3246$export$49374f374d70ab51 = ({ onEdit: onEdit }, isEditInteractionEnabled = true)=>{
    const startX = (0, $eJOHy.useRef)(0);
    const startY = (0, $eJOHy.useRef)(0);
    const [isEditButtonFocused, setEditButtonFocused] = (0, $eJOHy.useState)(false);
    const mouseHasMovedAfterMouseDown = (0, $eJOHy.useCallback)((event)=>Math.abs(startX.current - event.clientX) >= $8db9de8130ba3246$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $8db9de8130ba3246$var$DRAG_THRESHOLD, []);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        const element = event.target;
        /** If a link or button is clicked in the read view, default action should be taken */ if (element instanceof HTMLElement && !$8db9de8130ba3246$var$isLinkOrButton(element) && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEdit();
        }
    }, [
        mouseHasMovedAfterMouseDown,
        onEdit
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)((event)=>{
        startX.current = event.clientX;
        startY.current = event.clientY;
    }, []);
    const onEditButtonBlur = (0, $eJOHy.useCallback)(()=>setEditButtonFocused(false), []);
    const onEditButtonFocus = (0, $eJOHy.useCallback)(()=>setEditButtonFocused(true), []);
    return {
        isEditButtonFocused: isEditButtonFocused,
        onClick: isEditInteractionEnabled ? onClick : undefined,
        onMouseDown: isEditInteractionEnabled ? onMouseDown : undefined,
        onEditButtonBlur: onEditButtonBlur,
        onEditButtonFocus: onEditButtonFocus
    };
};

});

parcelRegister("k4Rl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dcf29bcd23ed8fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $7jTnu = parcelRequire("7jTnu");

var $gFFoY = parcelRequire("gFFoY");

var $ejhcC = parcelRequire("ejhcC");

var $jCuWH = parcelRequire("jCuWH");

var $tYLUh = parcelRequire("tYLUh");
const $6dcf29bcd23ed8fd$var$borderStyles = {
    focused: "_1h6d1p6i",
    invalid: "_1h6d1bqt",
    copied: "_1h6d1p6i _1dqogq9o",
    none: "_1h6d3acm"
};
const $6dcf29bcd23ed8fd$var$getBorderStyle = ({ isFocusRingVisible: isFocusRingVisible, isInvalid: isInvalid, isCopied: isCopied })=>{
    if (isFocusRingVisible) return 'focused';
    if (isInvalid) return 'invalid';
    if (isCopied) return 'copied';
    return 'none';
};
/**
 * This component is designed to be rendered within the `readView` of a `FieldInlineEditLite` component. This can be
 * rendered in a 'read-only' layout by omitting the `context` prop which is provided by `useInlineEdit` in
 * `@atlassian/jira-inline-edit-lite`. This ensures consistent spacing for consumers when a field is conditionally
 * editable.
 */ const $6dcf29bcd23ed8fd$var$InlineEditReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, context: context, editButtonLabel: editButtonLabel, editButtonRef: editButtonRef, hideEditButton: hideEditButton = true, isCopied: isCopied = false, isEditButtonFocused: isEditButtonFocused = false, isEditInteractionEnabled: isEditInteractionEnabled = true, isLoading: isLoading = false, isInvalid: isInvalid = false, onClick: onClick, onMouseDown: onMouseDown, onEditButtonBlur: onEditButtonBlur, onEditButtonFocus: onEditButtonFocus, readViewFitContainerHeight: readViewFitContainerHeight = false, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled = false, value: value }, ref)=>{
    const isHiddenButtonFocused = hideEditButton && isEditButtonFocused;
    const isFocusRingVisible = isHiddenButtonFocused || isLoading;
    const isEditable = Boolean(context) && isEditInteractionEnabled;
    const { isVisibleOnHover: isVisibleOnHover } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const [isMouseOver, setIsMouseOver] = (0, $eJOHy.useState)(false);
    const handleOnHover = (0, $eJOHy.useCallback)(()=>setIsMouseOver(true), []);
    const handleOnLeave = (0, $eJOHy.useCallback)(()=>setIsMouseOver(false), []);
    const borderStyle = $6dcf29bcd23ed8fd$var$getBorderStyle({
        isFocusRingVisible: isFocusRingVisible,
        isInvalid: isInvalid,
        isCopied: isCopied
    });
    const childrenToRender = !isVisibleOnHover || value?.toString() || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(value) || isMouseOver ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6dcf29bcd23ed8fd$var$readViewHiddenUntilHoverStyle
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dcf29bcd23ed8fd$var$Container, {
        "data-testid": "issue-field-inline-edit-read-view-container.ui.container",
        "data-vc": "issue-field-inline-edit-read-view-container",
        readViewFitContainerHeight: readViewFitContainerHeight,
        isEditable: isEditable,
        onClick: onClick,
        onMouseDown: onMouseDown,
        role: "presentation",
        ref: ref,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        onFocus: handleOnHover,
        onBlur: handleOnLeave,
        onMouseEnter: handleOnHover,
        onMouseLeave: handleOnLeave,
        // Consumers may currently update non-visual styles dynamically based off isEditable prop.
        // Here we allow consumers to exclude the attachment of edit styles from VC calculation.
        // Learn more about why this has been introduced https://jplat.atlassian.net/browse/EM-9211
        "data-vc-nvs": (0, $7jTnu.fg)('ignore_inline_edit_cell'),
        className: (0, $hcewu.default)([
            borderStyle && $6dcf29bcd23ed8fd$var$borderStyles[borderStyle]
        ])
    }, hideEditButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ejhcC.EditButtonHidden), {
        ref: editButtonRef,
        context: context ?? (0, $gFFoY.EMPTY_INLINE_EDIT_CONTEXT),
        isDisabled: !isEditable,
        label: editButtonLabel,
        onBlur: onEditButtonBlur,
        onFocus: onEditButtonFocus
    }), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dcf29bcd23ed8fd$var$LoadingOverlay, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dcf29bcd23ed8fd$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null))) : childrenToRender, !hideEditButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jCuWH.EditButton), {
        ref: editButtonRef,
        context: context ?? (0, $gFFoY.EMPTY_INLINE_EDIT_CONTEXT),
        isDisabled: !isEditable,
        label: editButtonLabel,
        onBlur: onEditButtonBlur,
        onFocus: onEditButtonFocus,
        // In future providing CSS variables *may* be something that makes its way into the design system, but
        // for now this is an acceptable override to prevent managing additional state with JS.
        // More context here https://atlassian.slack.com/archives/C060GTVV988/p1703214250865779?thread_ts=1703212675.166419&cid=C060GTVV988
        /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766, */ style: $6dcf29bcd23ed8fd$var$editButtonStyles
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6dcf29bcd23ed8fd$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { readViewFitContainerHeight: readViewFitContainerHeight, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _zulpu2gc _189eyh40 _1dqonqa1 _ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7 _1e0c1txw _4cvr1h6o _vchhusvi _p12f1osq _kqswh2mm _16jlkb7n",
            __cmplp.readViewFitContainerHeight ? "_1tke1osq" : "_1tkezwfg",
            __cmplp.hasReadViewTruncateDisabled ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
            __cmplp.hasReadViewTruncateDisabled ? "_1bton7od" : "_1bto1l2s",
            __cmplp.isEditable && "_v56412tl _yyosidpf _irr3166n _37uft94y _1rr4t94y",
            __cmplp.className
        ])
    });
});
const $6dcf29bcd23ed8fd$var$editButtonStyles = {
    flexShrink: 0,
    marginLeft: 'auto',
    opacity: 'var(--edit-button-opacity, 0)'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6dcf29bcd23ed8fd$var$LoadingOverlay = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_lcxvglyw _tzy4n2vs",
            __cmplp.className
        ])
    });
});
const $6dcf29bcd23ed8fd$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _1ltv1ssb _154i1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $6dcf29bcd23ed8fd$var$readViewHiddenUntilHoverStyle = (0, $1DXK0.xcss)({
    visibility: 'hidden'
});
var $6dcf29bcd23ed8fd$export$2e2bcd8739ae039 = $6dcf29bcd23ed8fd$var$InlineEditReadViewContainer;

});
parcelRegister("gFFoY", function(module, exports) {

$parcel$export(module.exports, "EMPTY_INLINE_EDIT_CONTEXT", () => $01d5176cdfd5ecd4$export$817cfe3c303a8a15);

var $12DRg = parcelRequire("12DRg");
const $01d5176cdfd5ecd4$export$817cfe3c303a8a15 = {
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};

});

parcelRegister("ejhcC", function(module, exports) {

$parcel$export(module.exports, "EditButtonHidden", () => $c9cbb95271b5bc33$export$c2bd955fafbef8bc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bGUQI = parcelRequire("bGUQI");
const $c9cbb95271b5bc33$export$c2bd955fafbef8bc = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ context: { onEdit: onEdit }, isDisabled: isDisabled, label: label, onBlur: onBlur, onFocus: onFocus }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const finalEditButtonLabel = label ?? formatMessage((0, $bGUQI.default).editButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9cbb95271b5bc33$var$HiddenButton, {
        "aria-label": finalEditButtonLabel,
        disabled: isDisabled,
        "aria-hidden": isDisabled,
        onBlur: onBlur,
        onFocus: onFocus,
        onClick: onEdit,
        ref: ref,
        type: "button"
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/no-html-button -- Ignored via go/DSP-18766
const $c9cbb95271b5bc33$var$HiddenButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jCuWH", function(module, exports) {

$parcel$export(module.exports, "EditButton", () => $b4e433ce880239a1$export$a8d3280cb45e38b8);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $bIv5I = parcelRequire("bIv5I");

var $lRq8t = parcelRequire("lRq8t");

var $bGUQI = parcelRequire("bGUQI");
const $b4e433ce880239a1$export$a8d3280cb45e38b8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ context: { onEdit: onEdit }, isDisabled: isDisabled, label: label, onBlur: onBlur, onFocus: onFocus, style: style }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const finalEditButtonLabel = label ?? formatMessage((0, $bGUQI.default).editButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "data-vc": "inline-edit-lite-edit-button",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bIv5I))), {
            spacing: "spacious",
            label: finalEditButtonLabel,
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: isDisabled,
        "aria-hidden": isDisabled,
        onClick: onEdit,
        onBlur: onBlur,
        onFocus: onFocus,
        ref: ref,
        spacing: "none",
        // In future providing CSS variables *may* be something that makes its way into the design system, but
        // for now this is an acceptable override to prevent managing additional state with JS.
        // More context here https://atlassian.slack.com/archives/C060GTVV988/p1703214250865779?thread_ts=1703212675.166419&cid=C060GTVV988
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jira/react/no-style-attribute -- Ignored via go/DSP-18766
        style: style
    });
});

});
parcelRegister("bIv5I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a01e1f60e987af0a2e95a320523abf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $887bebda3990aef8$var$_react = $887bebda3990aef8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $887bebda3990aef8$var$_edit = $887bebda3990aef8$var$_interopRequireDefault((parcelRequire("gTr6H")));

var $887bebda3990aef8$var$_edit2 = $887bebda3990aef8$var$_interopRequireDefault((parcelRequire("6x7wA")));
function $887bebda3990aef8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditorEditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $887bebda3990aef8$var$EditIcon = (props)=>/*#__PURE__*/ $887bebda3990aef8$var$_react.default.createElement($887bebda3990aef8$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $887bebda3990aef8$var$_edit2.default
    }, props));
$887bebda3990aef8$var$EditIcon.Name = 'EditIconMigration';
var $887bebda3990aef8$var$_default = module.exports.default = $887bebda3990aef8$var$EditIcon;

});
parcelRegister("gTr6H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c6cf489c8bf4fc$var$_react = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c4c6cf489c8bf4fc$var$_baseNew = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c4c6cf489c8bf4fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4c6cf489c8bf4fc$var$EditIcon = (props)=>/*#__PURE__*/ $c4c6cf489c8bf4fc$var$_react.default.createElement($c4c6cf489c8bf4fc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$c4c6cf489c8bf4fc$var$EditIcon.displayName = 'EditIcon';
var $c4c6cf489c8bf4fc$var$_default = module.exports.default = $c4c6cf489c8bf4fc$var$EditIcon;

});

parcelRegister("6x7wA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c1ba95e397b10f9$var$_react = $4c1ba95e397b10f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $4c1ba95e397b10f9$var$_edit = $4c1ba95e397b10f9$var$_interopRequireDefault((parcelRequire("gTr6H")));
function $4c1ba95e397b10f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4c1ba95e397b10f9$var$EditorEditIcon = (props)=>/*#__PURE__*/ $4c1ba95e397b10f9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M15.148 6.852a.5.5 0 0 1 .708.004l2.288 2.288a.5.5 0 0 1 .004.708L11 17l-3-3zM7 15l3 3-3.51.877c-.27.068-.436-.092-.367-.367z"/></svg>`
    }, props, {
        newIcon: $4c1ba95e397b10f9$var$_edit.default
    }));
$4c1ba95e397b10f9$var$EditorEditIcon.displayName = 'EditorEditIcon';
var $4c1ba95e397b10f9$var$_default = module.exports.default = $4c1ba95e397b10f9$var$EditorEditIcon;

});




parcelRegister("kjtxW", function(module, exports) {

$parcel$export(module.exports, "CopyPasteContextProvider", () => $cafc82d5a6cd54a2$export$1afe5f1aa41cba74);
$parcel$export(module.exports, "useCopyPasteTarget", () => $cafc82d5a6cd54a2$export$6bdcb2980d85cb0f);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $cafc82d5a6cd54a2$var$CopyPasteContext = /*#__PURE__*/ (0, $eJOHy.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
const $cafc82d5a6cd54a2$export$1afe5f1aa41cba74 = ({ children: children })=>{
    const copyPasteTarget = (0, $eJOHy.useRef)(null);
    const lastCopiedTarget = (0, $eJOHy.useRef)(null);
    const updateCopyPasteTarget = (0, $eJOHy.useCallback)((handlers)=>{
        copyPasteTarget.current = handlers;
    }, []);
    /** Update the last copied target if the copy event is explicitly handled. */ const updateLastCopiedTargetWhenHandled = (0, $eJOHy.useCallback)((handled, nextTarget)=>{
        if (!handled) return;
        // Clear previously copied target
        lastCopiedTarget.current?.onLastCopiedTarget(false);
        // Set next copied target
        nextTarget?.onLastCopiedTarget(true);
        lastCopiedTarget.current = nextTarget;
    }, []);
    const onCopy = (0, $eJOHy.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onCopy(event) ?? false, copyPasteTarget.current);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    const onCut = (0, $eJOHy.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onCut(event) ?? false, copyPasteTarget.current);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    const onPaste = (0, $eJOHy.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onPaste(event) ?? false, null);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        globalThis.document.addEventListener('copy', onCopy);
        globalThis.document.addEventListener('cut', onCut);
        globalThis.document.addEventListener('paste', onPaste, true);
        return ()=>{
            globalThis.document.removeEventListener('copy', onCopy);
            globalThis.document.removeEventListener('cut', onCut);
            globalThis.document.removeEventListener('paste', onPaste, true);
        };
    }, [
        onCopy,
        onCut,
        onPaste
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cafc82d5a6cd54a2$var$CopyPasteContext.Provider, {
        value: updateCopyPasteTarget
    }, children);
};
const $cafc82d5a6cd54a2$export$6bdcb2980d85cb0f = ({ onCopy: onCopy, onCut: onCut, onPaste: onPaste })=>{
    const updateCopyPasteTarget = (0, $eJOHy.useContext)($cafc82d5a6cd54a2$var$CopyPasteContext);
    const [lastCopiedTarget, setLastCopiedTarget] = (0, $eJOHy.useState)(false);
    // Track callbacks as refs so they can be invoked using a stable function reference
    const onCopyRef = (0, $eJOHy.useRef)(onCopy);
    onCopyRef.current = onCopy;
    const onCutRef = (0, $eJOHy.useRef)(onCut);
    onCutRef.current = onCut;
    const onPasteRef = (0, $eJOHy.useRef)(onPaste);
    onPasteRef.current = onPaste;
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        // Ensure stable function reference is provided as the callback functions are only bound to the document once
        const stableCopy = (event)=>onCopyRef.current?.(event) ?? false;
        const stableCut = (event)=>onCutRef.current?.(event) ?? false;
        const stablePaste = (event)=>onPasteRef.current?.(event) ?? false;
        /* Queue as a microtask to ensure the blur callback is emitted before calling updateCopyPasteTarget when
		 * navigating between targets. */ queueMicrotask(()=>{
            updateCopyPasteTarget({
                onCopy: stableCopy,
                onCut: stableCut,
                onPaste: stablePaste,
                onLastCopiedTarget: setLastCopiedTarget
            });
        });
    }, [
        updateCopyPasteTarget
    ]);
    const onBlur = (0, $eJOHy.useCallback)(()=>{
        updateCopyPasteTarget(null);
    }, [
        updateCopyPasteTarget
    ]);
    return {
        lastCopiedTarget: lastCopiedTarget,
        onFocus: onFocus,
        onBlur: onBlur
    };
};

});



parcelRegister("6TknG", function(module, exports) {

$parcel$export(module.exports, "ReadViewNonEditable", () => $cf90f517f772227d$export$4efb4956550fac52);

var $eJOHy = parcelRequire("eJOHy");

var $k4Rl5 = parcelRequire("k4Rl5");
const $cf90f517f772227d$export$4efb4956550fac52 = ({ children: children, hideEditButton: hideEditButton, isLoading: isLoading, readViewFitContainerHeight: readViewFitContainerHeight, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k4Rl5.default), {
        hideEditButton: hideEditButton,
        isLoading: isLoading,
        readViewFitContainerHeight: readViewFitContainerHeight,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled
    }, children);

});


parcelRegister("8Y7vF", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c3753d64a477f9$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $76c3753d64a477f9$var$CheckboxSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dMQrt")), {
        moduleId: "6225fccd",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $76c3753d64a477f9$export$2e2bcd8739ae039 = $76c3753d64a477f9$var$CheckboxSelectEditViewEntryPoint;

});
parcelRegister("dMQrt", function(module, exports) {

let $a0986ff308657e4e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a0986ff308657e4e$var$load("561TQ").then(()=>parcelRequire('cg7du'));

});


parcelRegister("ifQgt", function(module, exports) {

$parcel$export(module.exports, "CheckboxSelectReadView", () => $660041d08f4602e0$export$9aaea694d3042383);

var $5MZfY = parcelRequire("5MZfY");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $fI7RQ = parcelRequire("fI7RQ");
const $660041d08f4602e0$export$9aaea694d3042383 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $5MZfY.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedOptions = data?.selectedOptions?.edges?.filter((edge)=>Boolean(edge?.node?.value)).map((edge)=>({
            name: edge?.node?.value || '',
            key: edge?.node?.id || ''
        })) || [];
    if (!selectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: isHoverPopoverEnabled && $660041d08f4602e0$var$widthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: selectedOptions,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $fI7RQ.default).showMoreTooltip),
        isHoverPopoverEnabled: isHoverPopoverEnabled
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $660041d08f4602e0$var$containerWithNegativeMarginOffset
    }, selectedOptions.map((value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
            key: value.key,
            text: value.name
        })));
};
const $660041d08f4602e0$var$containerWithNegativeMarginOffset = (0, $1DXK0.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $660041d08f4602e0$var$widthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("5MZfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e9593a3d50f3042$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e66798db69b7174dc3e67181cb94bce4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e9593a3d50f3042$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "checkboxSelect_issueFieldCheckboxSelectReadviewFull_CheckboxSelectReadView",
    "selections": [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCheckboxesField"
};
$3e9593a3d50f3042$var$node.hash = "d4b0ebe1c72d70b5bd1191947a37e196";
var $3e9593a3d50f3042$export$2e2bcd8739ae039 = $3e9593a3d50f3042$var$node;

});

parcelRegister("d9T1A", function(module, exports) {

$parcel$export(module.exports, "EmptyFieldText", () => $dd0e40972cfd3cc1$export$f6d716da5f11cd01);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $3Lkm9 = parcelRequire("3Lkm9");
const $dd0e40972cfd3cc1$export$f6d716da5f11cd01 = ({ emptyText: emptyText })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dd0e40972cfd3cc1$var$EmptyValueStyleWrapper, null, emptyText ?? formatMessage((0, $3Lkm9.default).emptyFieldText));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $dd0e40972cfd3cc1$var$EmptyValueStyleWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _syaz131l _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3Lkm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4a1e0054ae710f1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a4a1e0054ae710f1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyFieldText: {
        "id": "issue-empty-field-text.empty-field-text",
        "defaultMessage": "None"
    }
});

});


parcelRegister("fI7RQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $178b1865ab14869a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $178b1865ab14869a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-checkbox-select-readview-full.checkbox-select.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});

});


parcelRegister("auNLL", function(module, exports) {

$parcel$export(module.exports, "InlineEditFieldInjectionsContext", () => $24da2a466c96bb11$export$5b3426c89ef7f7de);
$parcel$export(module.exports, "useInlineEditFieldInjections", () => $24da2a466c96bb11$export$23de4844126025dd);

var $eJOHy = parcelRequire("eJOHy");

var $kLKe4 = parcelRequire("kLKe4");
const $24da2a466c96bb11$export$f36c9b20522c59e3 = {
    overriding: {
        overrideLabel: (0, $kLKe4.identity),
        overrideDescription: (0, $kLKe4.identity),
        overrideIsEditable: (0, $kLKe4.identity),
        overrideFieldOptionsFilter: (0, $kLKe4.identity)
    }
};
const $24da2a466c96bb11$export$5b3426c89ef7f7de = /*#__PURE__*/ (0, $eJOHy.createContext)($24da2a466c96bb11$export$f36c9b20522c59e3);
const $24da2a466c96bb11$export$23de4844126025dd = ()=>(0, $eJOHy.useContext)($24da2a466c96bb11$export$5b3426c89ef7f7de);

});
parcelRegister("kLKe4", function(module, exports) {

$parcel$export(module.exports, "identity", () => $f351f1a309dc1227$export$f0954fd7d5368655);
$parcel$export(module.exports, "FieldInjectionsContext", () => $f351f1a309dc1227$export$a6ff76841695c6c0);

var $eJOHy = parcelRequire("eJOHy");
const $f351f1a309dc1227$export$8793edee2d425525 = ()=>{};
const $f351f1a309dc1227$export$f0954fd7d5368655 = (x)=>x;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f351f1a309dc1227$var$initialValue = {
    capturing: {
        captureAllowedValues: $f351f1a309dc1227$export$8793edee2d425525,
        captureDescription: $f351f1a309dc1227$export$8793edee2d425525,
        captureFieldId: $f351f1a309dc1227$export$8793edee2d425525,
        captureFieldType: $f351f1a309dc1227$export$8793edee2d425525,
        captureIsDisabled: $f351f1a309dc1227$export$8793edee2d425525,
        captureIsRequired: $f351f1a309dc1227$export$8793edee2d425525,
        captureLabel: $f351f1a309dc1227$export$8793edee2d425525,
        captureRenderer: $f351f1a309dc1227$export$8793edee2d425525
    },
    overriding: {
        overrideLabel: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideElementAfterLabel: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideIsRequired: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideIsDisabled: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideAllowedValues: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideFieldOptionsFilter: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideOnChange: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideOnBlur: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideDescription: $f351f1a309dc1227$export$f0954fd7d5368655
    }
};
const $f351f1a309dc1227$export$a6ff76841695c6c0 = /*#__PURE__*/ (0, $eJOHy.createContext)($f351f1a309dc1227$var$initialValue);

});



parcelRegister("4vHFI", function(module, exports) {

$parcel$export(module.exports, "INLINE_EDIT_ANALYTICS_ATTRIBUTES", () => $91288825d5f914de$export$a659dfe9528cfc57);
// Attributes for inline editing track events
const $91288825d5f914de$export$a659dfe9528cfc57 = {
    // If the update was made inline (and not via the issue view)
    isInlineEditing: true
};

});


parcelRegister("kFDsf", function(module, exports) {

$parcel$export(module.exports, "CmdbObjectsCell", () => $ba7527cfbb2c9ff3$export$eebc6db46b17b7b3);

var $6TRbo = parcelRequire("6TRbo");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $bYOuG = parcelRequire("bYOuG");

var $P01So = parcelRequire("P01So");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $lIbdr = parcelRequire("lIbdr");

var $aVDPt = parcelRequire("aVDPt");
const $ba7527cfbb2c9ff3$var$CELL_TYPE = 'cmdbObjects';
const $ba7527cfbb2c9ff3$export$eebc6db46b17b7b3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $6TRbo.default), fieldRef);
    const errors = data?.selectedCmdbObjectsConnection?.errors?.map((error)=>error?.message);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (errors?.length) // At time of writing, these errors are not wired up on the issue backend. However we will maintain this
    // logging so that it is present if/when it is wired up so we can get error information immediately.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: $ba7527cfbb2c9ff3$var$CELL_TYPE,
        reason: `Errors present: ${errors.length} - ${errors.join(', ')}; Edges present: ${data?.selectedCmdbObjectsConnection?.edges?.length}`
    });
    const objects = data?.selectedCmdbObjectsConnection?.edges;
    const filteredObjectsWithMedia = objects?.map((edge)=>{
        if (!edge?.node?.label) return null;
        let mediaImage;
        const iconUrl = edge.node.avatar?.url48 ?? undefined;
        if (edge.node.avatar?.mediaClientConfig?.clientId && edge.node.avatar?.mediaClientConfig?.fileId && edge.node.avatar?.mediaClientConfig?.mediaBaseUrl && edge.node.avatar?.mediaClientConfig?.mediaJwtToken) {
            const identifier = {
                id: edge.node.avatar.mediaClientConfig.fileId,
                mediaItemType: 'file'
            };
            const clientBasedAuth = {
                clientId: edge.node.avatar.mediaClientConfig.clientId,
                token: edge.node.avatar.mediaClientConfig.mediaJwtToken,
                baseUrl: edge.node.avatar.mediaClientConfig.mediaBaseUrl
            };
            const mediaClientConfig = {
                authProvider: ()=>Promise.resolve(clientBasedAuth)
            };
            mediaImage = {
                identifier: identifier,
                mediaClientConfig: mediaClientConfig
            };
        }
        return {
            key: edge.node.objectId || 'missingId',
            name: edge.node.label,
            href: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $bYOuG.createObjectDetailUrl)(edge.node.objectId || '') : (0, $lIbdr.createObjectDetailUrl)(edge.node.objectId || ''),
            icon: {
                url: !mediaImage ? iconUrl : undefined,
                mediaImage: mediaImage
            }
        };
    }).filter((0, $P01So.isNonNullish)) ?? [];
    if (!objects || objects.length !== filteredObjectsWithMedia.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: $ba7527cfbb2c9ff3$var$CELL_TYPE,
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: filteredObjectsWithMedia,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $aVDPt.default).triggerButton),
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
});

});
parcelRegister("6TRbo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac2780e21ea8b4f9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d0ec6f9a42c69561a21d355d7d95393a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ac2780e21ea8b4f9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cmdbObjects_nativeIssueTable_CmdbObjectsCell",
    "selections": [
        {
            "concreteType": "JiraCmdbObjectConnection",
            "kind": "LinkedField",
            "name": "selectedCmdbObjectsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCmdbObjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraCmdbObject",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "objectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "label"
                                },
                                {
                                    "concreteType": "JiraCmdbAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCmdbMediaClientConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaClientConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "clientId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fileId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaBaseUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaJwtToken"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url48"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCMDBField"
};
$ac2780e21ea8b4f9$var$node.hash = "b737019714db01f1a69458d583f66ece";
var $ac2780e21ea8b4f9$export$2e2bcd8739ae039 = $ac2780e21ea8b4f9$var$node;

});

parcelRegister("lIbdr", function(module, exports) {

$parcel$export(module.exports, "createObjectDetailUrl", () => $4bcc9ec1645a5953$export$51e4229f2c7d3866);
// Hardcoded values from @atlassian/jira-servicedesk-insight-urls
const $4bcc9ec1645a5953$var$ASSETS_ROUTE_PREFIX = '/jira/servicedesk/assets';
const $4bcc9ec1645a5953$export$51e4229f2c7d3866 = (objectId)=>`${$4bcc9ec1645a5953$var$ASSETS_ROUTE_PREFIX}/object/${objectId}`;

});

parcelRegister("aVDPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8748f15801c24aca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8748f15801c24aca$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.cmdb-objects.trigger-button",
        "defaultMessage": "See more assets"
    }
});

});


parcelRegister("lGSrF", function(module, exports) {

$parcel$export(module.exports, "ComponentsCell", () => $ada8a1999d311b53$export$fafea088ac1dbc41);
$parcel$export(module.exports, "ComponentsInlineEditCell", () => $ada8a1999d311b53$export$b3c67e48ecea06e4);

var $2wOY9 = parcelRequire("2wOY9");

var $8BbKy = parcelRequire("8BbKy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $lRq8t = parcelRequire("lRq8t");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $ho4SO = parcelRequire("ho4SO");

var $P01So = parcelRequire("P01So");

var $86BUM = parcelRequire("86BUM");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $a4QIC = parcelRequire("a4QIC");
/**
 * Expected JQL Output: `project = ${projectKey} AND ${jqlTerm} = ${name}`
 */ const $ada8a1999d311b53$var$getLinkJql = (projectKey, jqlTerm, name)=>{
    const jast = (0, $f26C8.default).jast((0, $f26C8.default).query((0, $f26C8.default).compoundClause((0, $f26C8.default).compoundOperator((0, $f6415dda43b7f459$export$6d6d48d210d3ca97)), [
        (0, $f26C8.default).terminalClause((0, $f26C8.default).field('project'), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand(projectKey)),
        (0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $P01So.escapeBackslashes)(jqlTerm)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand((0, $P01So.escapeBackslashes)(name)))
    ])));
    return (0, $1jiqw.print)(jast, {
        operatorCase: 'upper'
    });
};
const $ada8a1999d311b53$export$fafea088ac1dbc41 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { componentsOld: selectedComponentsConnection } = (0, $j4oe4.useFragment)((0, $8BbKy.default), fieldRef);
    const components = selectedComponentsConnection?.edges;
    const filteredComponents = (0, $eJOHy.useMemo)(()=>components?.map((edge)=>edge?.node?.name != null ? {
                key: edge.node.name,
                name: edge.node.name,
                href: `${issueSearchBaseUrl}?jql=${encodeURIComponent($ada8a1999d311b53$var$getLinkJql(projectKey, jqlTerm, edge.node.name))}`
            } : null).filter((0, $P01So.isNonNullish)) ?? [], [
        components,
        issueSearchBaseUrl,
        projectKey,
        jqlTerm
    ]);
    if (!components || components.length !== filteredComponents.length || !projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "components",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: filteredComponents,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $a4QIC.default).triggerButton)
    });
});
const $ada8a1999d311b53$export$b3c67e48ecea06e4 = ({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, projectKey: projectKey })=>{
    const data = (0, $j4oe4.useFragment)((0, $2wOY9.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const formatComponentJql = (0, $eJOHy.useCallback)((componentName)=>$ada8a1999d311b53$var$getLinkJql(projectKey, jqlTerm, componentName), [
        jqlTerm,
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ho4SO.ComponentsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        formatComponentJql: formatComponentJql,
        fragmentRef: data,
        isTruncated: true,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};

});
parcelRegister("2wOY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f7f4f9ce8e9c100$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47106549cd6ea23d9e005ca430b256b6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7f7f4f9ce8e9c100$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "components_nativeIssueTable_ComponentsInlineEditCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraComponentsField"
};
$7f7f4f9ce8e9c100$var$node.hash = "464cf035608be826c9250669fd7b79b4";
var $7f7f4f9ce8e9c100$export$2e2bcd8739ae039 = $7f7f4f9ce8e9c100$var$node;

});

parcelRegister("8BbKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7095704d23d444$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<373e632fc369142429d535218f0816a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8e7095704d23d444$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_nativeIssueTable_ComponentsCell_fieldRef",
    "selections": [
        {
            "alias": "componentsOld",
            "concreteType": "JiraComponentConnection",
            "kind": "LinkedField",
            "name": "selectedComponentsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraComponentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraComponent",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraComponentsField"
};
$8e7095704d23d444$var$node.hash = "0c7ed7763b84f4a5f5fdf18a8ff99f37";
var $8e7095704d23d444$export$2e2bcd8739ae039 = $8e7095704d23d444$var$node;

});

const $f6415dda43b7f459$export$6d6d48d210d3ca97 = 'and';
const $f6415dda43b7f459$export$7b8f0a728d79a753 = 'or';

parcelRegister("ho4SO", function(module, exports) {

$parcel$export(module.exports, "ComponentsInlineEditViewWithIsEditable", () => $699cbb166c13207d$export$32ccb5f0cb497709);

var $bPc2T = parcelRequire("bPc2T");

var $7Usdb = parcelRequire("7Usdb");

var $3h1nJ = parcelRequire("3h1nJ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $lCtpC = parcelRequire("lCtpC");

var $5SZDT = parcelRequire("5SZDT");

var $auNLL = parcelRequire("auNLL");
const $699cbb166c13207d$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-components-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $699cbb166c13207d$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $699cbb166c13207d$export$32ccb5f0cb497709 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, baseSearchUrl: baseSearchUrl, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover, formatComponentJql: formatComponentJql })=>{
    const data = (0, $j4oe4.useFragment)((0, $3h1nJ.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $7Usdb.default));
    const { id: uniqueFieldId, name: name, selectedComponentsConnection: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                value: edge?.node?.value ?? '',
                label: edge?.node?.label ?? ''
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.value) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateComponentsField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateComponentsField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedComponentsConnection: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.value ?? '',
                                            label: edge.label ?? '',
                                            value: edge.value ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $699cbb166c13207d$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'components'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($699cbb166c13207d$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5SZDT.ComponentsReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            baseSearchUrl: baseSearchUrl,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover,
            formatComponentJql: formatComponentJql
        })), [
        data,
        baseSearchUrl,
        isTruncated,
        isTruncatedWithHoverPopover,
        formatComponentJql
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    (values, actionMeta)=>{
        const mutableOptions = values?.map((i)=>({
                label: i.label,
                value: i.value || ''
            })) || null;
        handleChange(mutableOptions);
    }, [
        handleChange
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleOnChange,
            fetchSuggestionsOnMount: true,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $lCtpC.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $699cbb166c13207d$export$bbb45a0e0da9bd53 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $bPc2T.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($699cbb166c13207d$export$32ccb5f0cb497709, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("bPc2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $869d6499628ae96f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d752273960d62c97543fd5c98cc9b483>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $869d6499628ae96f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraComponentsField"
};
$869d6499628ae96f$var$node.hash = "616223369097ff7023289b730e24e390";
var $869d6499628ae96f$export$2e2bcd8739ae039 = $869d6499628ae96f$var$node;

});

parcelRegister("7Usdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1ebcbbeceb36b85$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a287f8603250d4bcfa340f08a133c0c>>
 * @relayHash 7fdc4a8b53b49ddfa954865ceb36f19e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 37d268d7e189244c2485e7f63d82c6610aa4201a00aec643ec30383b07b411b3
const $b1ebcbbeceb36b85$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraComponentsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateComponentsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraComponentsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraComponentsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateComponentsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraComponentsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraComponentConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedComponentsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraComponentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraComponent",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "37d268d7e189244c2485e7f63d82c6610aa4201a00aec643ec30383b07b411b3",
            "metadata": {},
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b1ebcbbeceb36b85$var$node.hash = "55d6de75b11bbe1bea570947ba244198";
var $b1ebcbbeceb36b85$export$2e2bcd8739ae039 = $b1ebcbbeceb36b85$var$node;

});

parcelRegister("3h1nJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $79aff15c1c5068e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<176cf950f3063d94accb5a37ad63e7ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $79aff15c1c5068e2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsReadviewFull_ComponentsReadView"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "value",
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "alias": "label",
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedComponentsConnection"
        }
    ],
    "type": "JiraComponentsField"
};
$79aff15c1c5068e2$var$node.hash = "7d58e8d795b9134c31920723b434efe7";
var $79aff15c1c5068e2$export$2e2bcd8739ae039 = $79aff15c1c5068e2$var$node;

});

parcelRegister("lCtpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2539dfc09599984$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $d2539dfc09599984$var$ComponentsEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("e5XoX")), {
        moduleId: "09bac631",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $d2539dfc09599984$export$2e2bcd8739ae039 = $d2539dfc09599984$var$ComponentsEditViewEntryPoint;

});
parcelRegister("e5XoX", function(module, exports) {

let $a42f9c3827b30ac5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a42f9c3827b30ac5$var$load("dXOpn").then(()=>parcelRequire('kb00V'));

});


parcelRegister("5SZDT", function(module, exports) {

$parcel$export(module.exports, "ComponentsReadView", () => $e07554ca3e796e3f$export$1841519927c4fa28);

var $k0HKH = parcelRequire("k0HKH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ar6fB = parcelRequire("ar6fB");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $bnIBr = parcelRequire("bnIBr");

var $7jTnu = parcelRequire("7jTnu");

var $caakL = parcelRequire("caakL");
const $e07554ca3e796e3f$export$b1992ee206a63570 = (value, baseSearchUrl = '/issues/')=>{
    const jqlEncodedValue = encodeURIComponent(`components = ${(0, $bnIBr.toQuotedString)(value)}`);
    return `${baseSearchUrl}?jql=${jqlEncodedValue}`;
};
const $e07554ca3e796e3f$export$e2150facc9f107aa = (componentName)=>`component = ${(0, $bnIBr.toQuotedString)(componentName)}`;
const $e07554ca3e796e3f$export$12458b8497b0a890 = (componentJql, baseSearchUrl = '/issues/')=>`${baseSearchUrl}?jql=${encodeURIComponent(componentJql)}`;
const $e07554ca3e796e3f$export$1841519927c4fa28 = ({ baseSearchUrl: baseSearchUrl, fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover, formatComponentJql: formatComponentJql = $e07554ca3e796e3f$export$e2150facc9f107aa })=>{
    const data = (0, $j4oe4.useFragment)((0, $k0HKH.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedComponents = data?.selectedComponentsConnection?.edges?.filter((edge)=>Boolean(edge?.node?.label)).map((item)=>{
        let href;
        if ((0, $7jTnu.fg)('jsc_inline_editing_component_jql_fix')) href = item?.node?.label ? $e07554ca3e796e3f$export$12458b8497b0a890(formatComponentJql(item?.node?.label), baseSearchUrl) : undefined;
        else href = item?.node?.label ? $e07554ca3e796e3f$export$b1992ee206a63570(item?.node?.label, baseSearchUrl) : undefined;
        return {
            name: item?.node?.label || '',
            key: item?.node?.value || '',
            href: href
        };
    }) || [];
    if (!selectedComponents?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: isTruncatedWithHoverPopover && $e07554ca3e796e3f$var$widthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: selectedComponents,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $caakL.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e07554ca3e796e3f$var$containerWithNegativeMarginOffset
    }, selectedComponents.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
            key: item.key,
            isRemovable: false,
            text: item.name,
            href: item.href
        })));
};
const $e07554ca3e796e3f$var$containerWithNegativeMarginOffset = (0, $1DXK0.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $e07554ca3e796e3f$var$widthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("k0HKH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea0b61fb36095e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<309f4d62bd850a58613b75bc1e5b17ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cea0b61fb36095e8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsReadviewFull_ComponentsReadView",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "value",
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "alias": "label",
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedComponentsConnection"
        }
    ],
    "type": "JiraComponentsField"
};
$cea0b61fb36095e8$var$node.hash = "35b9643b76a914d7422dfb3f74901db8";
var $cea0b61fb36095e8$export$2e2bcd8739ae039 = $cea0b61fb36095e8$var$node;

});

parcelRegister("ar6fB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf2340f5bdb4d38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $315a7 = parcelRequire("315a7");

var $gyJTO = parcelRequire("gyJTO");

var $3Vuhz = parcelRequire("3Vuhz");

var $Ys7jv = parcelRequire("Ys7jv");
var $lncqW = parcelRequire("lncqW");

var $eGOwo = parcelRequire("eGOwo");

var $5itvH = parcelRequire("5itvH");

var $1fStw = parcelRequire("1fStw");

var $40nZT = parcelRequire("40nZT");

var $6UE2q = parcelRequire("6UE2q");

var $h89xH = parcelRequire("h89xH");
const $7bf2340f5bdb4d38$var$textLinkCssVar = '--ds-ctl';
const $7bf2340f5bdb4d38$var$textDefaultCssVar = '--ds-ct';
const $7bf2340f5bdb4d38$var$textActiveCssVar = '--ds-ctp';
const $7bf2340f5bdb4d38$var$backgroundHoverCssVar = '--ds-cbh';
const $7bf2340f5bdb4d38$var$backgroundActiveCssVar = '--ds-cba';
var $7bf2340f5bdb4d38$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($7bf2340f5bdb4d38$var$TagStatus || {});
const $7bf2340f5bdb4d38$var$packageName = "platform-pkg";
const $7bf2340f5bdb4d38$var$packageVersion = "0.0.0-use.local";
const $7bf2340f5bdb4d38$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $7bf2340f5bdb4d38$var$removingStyles = null;
const $7bf2340f5bdb4d38$var$RemovableTagComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $7bf2340f5bdb4d38$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $3Vuhz.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $eJOHy.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $eJOHy.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $315a7.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $7bf2340f5bdb4d38$var$packageName,
            packageVersion: $7bf2340f5bdb4d38$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $eJOHy.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $eJOHy.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $eJOHy.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $eJOHy.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $eJOHy.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $eJOHy.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h89xH.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6UE2q.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: (0, $eGOwo.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle, #00000000)" : undefined,
        // Tag background color on hover
        [$7bf2340f5bdb4d38$var$backgroundHoverCssVar]: (0, $eGOwo.fg)('platform-component-visual-refresh') ? undefined : (0, $5itvH.removalHoverBackgroundColors),
        // Tag background color on press
        [$7bf2340f5bdb4d38$var$backgroundActiveCssVar]: (0, $eGOwo.fg)('platform-component-visual-refresh') ? undefined : (0, $5itvH.removalActiveBackgroundColors),
        // The tag text on hover of remove button
        [$7bf2340f5bdb4d38$var$textDefaultCssVar]: (0, $eGOwo.fg)('platform-component-visual-refresh') ? undefined : (0, $5itvH.removalTextColors),
        // 'elemBefore' text on press of remove button
        [$7bf2340f5bdb4d38$var$textActiveCssVar]: (0, $eGOwo.fg)('platform-component-visual-refresh') ? undefined : (0, $5itvH.removalTextColors),
        // The tag link text on hover of remove button
        [$7bf2340f5bdb4d38$var$textLinkCssVar]: (0, $eGOwo.fg)('platform-component-visual-refresh') ? undefined : (0, $5itvH.removalTextColors)
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lncqW.default), {
            children: (motion)=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1fStw.default), {
                    ref: (0, $gyJTO.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40nZT.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $hcewu.default)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqht1nip"
                    ])
                });
            }
        })
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $7bf2340f5bdb4d38$var$RemovableTag = /*#__PURE__*/ (0, $eJOHy.memo)($7bf2340f5bdb4d38$var$RemovableTagComponent);
var $7bf2340f5bdb4d38$export$2e2bcd8739ae039 = $7bf2340f5bdb4d38$var$RemovableTag;

});
parcelRegister("lncqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $10f384baaa61acd2$export$2e2bcd8739ae039);

var $34ZNB = parcelRequire("34ZNB");

var $gcrIE = parcelRequire("gcrIE");

var $grWPV = parcelRequire("grWPV");

var $5mfrv = parcelRequire("5mfrv");

var $Ys7jv = parcelRequire("Ys7jv");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $10f384baaa61acd2$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $grWPV.useElementRef)();
    const exiting = (0, $Ys7jv.useExitingPersistence)();
    const requestAnimationFrame = (0, $gcrIE.useRequestAnimationFrame)();
    const setTimeout = (0, $gcrIE.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $5mfrv.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $34ZNB.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $34ZNB.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $10f384baaa61acd2$export$2e2bcd8739ae039 = $10f384baaa61acd2$var$ShrinkOut;

});
parcelRegister("grWPV", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $d3a4ee4e08936b24$export$ff879f35a69d56b7);

var $eJOHy = parcelRequire("eJOHy");
const $d3a4ee4e08936b24$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $eJOHy.useRef)(null);
    const setRef = (0, $eJOHy.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("h89xH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebeaa36c6c332ef4$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $5wxTT = parcelRequire("5wxTT");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");
const $ebeaa36c6c332ef4$var$removeButtonStyles = {
    root: "_19itglyw _2rkogqwt _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _1bsb7vkz _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1fxt _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah31i6y _irr3166n _1di61dty"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $ebeaa36c6c332ef4$var$removeButtonStylesOld = {
    root: "_19itglyw _2rko1l5z _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _ahbqze3t _12l2ze3t _1pfhze3t _6rthze3t _kqswstnw _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1bah _80omtlke _lcxv1wug _1ah3ze3t _30l31eu2"
};
const $ebeaa36c6c332ef4$var$removeButtonStylesOldIcon = {
    root: "_rjxpze3t"
};
const $ebeaa36c6c332ef4$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
const $ebeaa36c6c332ef4$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: (0, $6qaBj.cx)(// TODO: When cleaning up all these feature gates, they should just be converged into a single `styles` object.
        (0, $eGOwo.fg)('platform-component-visual-refresh') && $ebeaa36c6c332ef4$var$removeButtonStyles.root, !(0, $eGOwo.fg)('platform-component-visual-refresh') && $ebeaa36c6c332ef4$var$removeButtonStylesOld.root, $ebeaa36c6c332ef4$var$removeButtonStylesOldIcon.root, (0, $eGOwo.fg)('platform-visual-refresh-icons') && $ebeaa36c6c332ef4$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "small",
            size: "small"
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ebeaa36c6c332ef4$export$2e2bcd8739ae039 = $ebeaa36c6c332ef4$var$RemoveButton;

});
parcelRegister("5wxTT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53b9d7f39d5a7786fd5c4592782d4f82>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405a3cd7d6c6872a$var$_react = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $405a3cd7d6c6872a$var$_cross = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $405a3cd7d6c6872a$var$_close = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $405a3cd7d6c6872a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405a3cd7d6c6872a$var$CrossIcon = (props)=>/*#__PURE__*/ $405a3cd7d6c6872a$var$_react.default.createElement($405a3cd7d6c6872a$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $405a3cd7d6c6872a$var$_close.default
    }, props));
$405a3cd7d6c6872a$var$CrossIcon.Name = 'CrossIconMigration';
var $405a3cd7d6c6872a$var$_default = module.exports.default = $405a3cd7d6c6872a$var$CrossIcon;

});
parcelRegister("6OLN4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6c7bc606f2d15e$var$_react = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $4f6c7bc606f2d15e$var$_cross = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("6zhpo")));
function $4f6c7bc606f2d15e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6c7bc606f2d15e$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $4f6c7bc606f2d15e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $4f6c7bc606f2d15e$var$_cross.default
    }));
$4f6c7bc606f2d15e$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $4f6c7bc606f2d15e$var$_default = module.exports.default = $4f6c7bc606f2d15e$var$EditorCloseIcon;

});




parcelRegister("bnIBr", function(module, exports) {

$parcel$export(module.exports, "toQuotedString", () => $a183e8d5995c289a$export$dbeab020a4aa404);
$parcel$export(module.exports, "createProjectAllWorkUri", () => $a183e8d5995c289a$export$497544a08e0b5e51);
$parcel$export(module.exports, "createAllWorkUrl", () => $a183e8d5995c289a$export$ca075a1255c9a76d);

var $7jTnu = parcelRequire("7jTnu");
const $a183e8d5995c289a$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $a183e8d5995c289a$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $a183e8d5995c289a$var$ENCODE_MAP[character] || character;
};
const $a183e8d5995c289a$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $a183e8d5995c289a$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $a183e8d5995c289a$export$497544a08e0b5e51 = (jql)=>(0, $7jTnu.fg)('jira_list_nin_merge') ? `/list/?jql=${encodeURIComponent(jql)}` : `/issues/?jql=${encodeURIComponent(jql)}`;
const $a183e8d5995c289a$export$ca075a1255c9a76d = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});

parcelRegister("caakL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6b87dd9236836a3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c6b87dd9236836a3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-components-readview-full.components.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});

});



parcelRegister("a4QIC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b4f007c33a6c18$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f3b4f007c33a6c18$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.components.trigger-button",
        "defaultMessage": "See more components"
    }
});

});


parcelRegister("cIMhw", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectCell", () => $b08c4b423a640edc$export$4f505fdc26f544f5);

var $7Boiy = parcelRequire("7Boiy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $alVoT = parcelRequire("alVoT");

var $7jTnu = parcelRequire("7jTnu");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $8jOO7 = parcelRequire("8jOO7");
const $b08c4b423a640edc$export$4f505fdc26f544f5 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $7Boiy.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldRenderHoverPopover = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && shouldRenderHoverPopover && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alVoT.CascadingSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupTarget: isFirstField ? $b08c4b423a640edc$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        isTruncated: true,
        shouldRenderHoverPopover: isFirstField && shouldRenderHoverPopover
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alVoT.CascadingSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: $b08c4b423a640edc$var$CustomTarget,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        menuPosition: "fixed",
        isTruncated: true,
        shouldRenderHoverPopover: shouldRenderHoverPopover
    });
};
const $b08c4b423a640edc$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b08c4b423a640edc$var$customTargetStyles,
        ref: ref
    });
});
const $b08c4b423a640edc$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: '0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("7Boiy", function(module, exports) {

$parcel$export(module.exports, "default", () => $13035878178ee8a4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a170f6032ed9d52606dab07b6826eca7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $13035878178ee8a4$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "cascadingSelect_nativeIssueTable_CascadingSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraCascadingSelectField"
};
$13035878178ee8a4$var$node.hash = "c0952c4997585ebce9f9a5e25b71750e";
var $13035878178ee8a4$export$2e2bcd8739ae039 = $13035878178ee8a4$var$node;

});

parcelRegister("alVoT", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectInlineEditViewIsEditable", () => $a381d2d31fb89055$export$d3164c915fdde2ef);
$parcel$export(module.exports, "CascadingSelectInlineEditView", () => $a381d2d31fb89055$export$c72b86275efea41a);

var $jrGLl = parcelRequire("jrGLl");

var $brzz4 = parcelRequire("brzz4");

var $hs8vH = parcelRequire("hs8vH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $9j9do = parcelRequire("9j9do");

var $99gun = parcelRequire("99gun");

var $dG41I = parcelRequire("dG41I");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $tYLUh = parcelRequire("tYLUh");
const $a381d2d31fb89055$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-cascading-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment)); /** Check if the new selected value is equal to the old value */ 
const $a381d2d31fb89055$var$isEqualSelection = (a, b)=>a?.parentOptionValue?.value === b?.parentOptionValue?.value && a?.childOptionValue?.value === b?.childOptionValue?.value;
const $a381d2d31fb89055$var$EditViewWrapper = ({ children: children })=>{
    // This needs to be fixed by DST: go/DSP-22083
    // Dropdown z-index is 1, action bar is 200
    // Bento fixes this by wrapping dropdown into a new 300 stack context
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a381d2d31fb89055$var$wrapperStyles
    }, children);
}; /**
    * Inline edit will handle the switching behaviour between the 'readView' and 'editView' components.
    *
    * @param props [CascadingSelectInlineEditViewProps](./types.tsx)
    */ 
const $a381d2d31fb89055$export$d3164c915fdde2ef = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, readViewFitContainerHeight: readViewFitContainerHeight, hideActionButtons: hideActionButtons = false, menuPosition: menuPosition, fragmentRef: fragmentRef, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, spacing: spacing = 'default', isTruncated: isTruncated = false, isEditable: isEditable = false, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)(); // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $hs8vH.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $brzz4.default));
    const { id: uniqueFieldId, cascadingOption: cascadingOption, name: name, fieldId: fieldId, type: fieldType } = data; // #endregion
    // #region State
    const initialValue = (0, $eJOHy.useMemo)(()=>({
            parentOptionValue: cascadingOption?.parentOptionValue ? {
                id: cascadingOption?.parentOptionValue?.id ?? '',
                value: cascadingOption?.parentOptionValue?.value ?? '',
                isDisabled: cascadingOption?.parentOptionValue?.isDisabled
            } : null,
            childOptionValue: cascadingOption?.childOptionValue ? {
                id: cascadingOption?.childOptionValue?.id ?? '',
                value: cascadingOption?.childOptionValue?.value ?? '',
                isDisabled: cascadingOption?.childOptionValue?.isDisabled
            } : null
        }), [
        cascadingOption?.childOptionValue,
        cascadingOption?.parentOptionValue
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]); // #endregion
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((newOption, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newOption); // note: If these objects happen to include more than what is expected, Relay will complain.
        const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = newOption || {};
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        parentOption: parentOptionValue?.id || null,
                        childOption: childOptionValue?.id || null
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateCascadingSelectField?.success) onSuccess();
                else onFail();
            },
            onError: (error)=>onFail(error, error.message),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateCascadingSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            cascadingOption: newOption
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        isValueEqual: $a381d2d31fb89055$var$isEqualSelection,
        clipboardComponentType: 'cascadingSelect'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange, invalidMessage: invalidMessage, isEditing: isEditing } = actions; // #endregion Action
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a381d2d31fb89055$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dG41I.CascadingSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        isTruncated,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            wrapper: $a381d2d31fb89055$var$EditViewWrapper,
            fieldId: uniqueFieldId,
            autoFocus: true,
            parentOptionValue: updatedValue?.parentOptionValue,
            childOptionValue: updatedValue?.childOptionValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            spacing: spacing,
            ...isExperimentEnabled && {
                value: !updatedValue || !updatedValue.parentOptionValue?.id ? null : updatedValue
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $9j9do.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: hideActionButtons,
        hasReadViewTruncateDisabled: shouldRenderHoverPopover
    }); // #endregion Action
};
const $a381d2d31fb89055$export$c72b86275efea41a = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $jrGLl.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a381d2d31fb89055$export$d3164c915fdde2ef, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $a381d2d31fb89055$var$wrapperStyles = (0, $1DXK0.xcss)({
    zIndex: 'modal',
    position: 'relative'
});

});
parcelRegister("jrGLl", function(module, exports) {

$parcel$export(module.exports, "default", () => $851ebb56b44cef28$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<391d228206c5d2da2084fd47967509e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $851ebb56b44cef28$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraCascadingSelectField"
};
$851ebb56b44cef28$var$node.hash = "e2f7106f0e284e4683ba8bf8fd5fa780";
var $851ebb56b44cef28$export$2e2bcd8739ae039 = $851ebb56b44cef28$var$node;

});

parcelRegister("brzz4", function(module, exports) {

$parcel$export(module.exports, "default", () => $297c463699425fe3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a8f46f36cc9206ce74e761332053256d>>
 * @relayHash 1c1957f0674166c9db6b089b3b8bbf4a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 63b51752988a375e4ba7b59d39b515819298e285b93d0191029c8f91a60999c4

var $dTrc4 = parcelRequire("dTrc4");
const $297c463699425fe3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraCascadingOption",
                                            "kind": "LinkedField",
                                            "name": "cascadingOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "parentOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "childOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "63b51752988a375e4ba7b59d39b515819298e285b93d0191029c8f91a60999c4",
            "metadata": {},
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default)
            }
        }
    };
}();
$297c463699425fe3$var$node.hash = "792c8e7af6ed535746e17a76dc52564b";
var $297c463699425fe3$export$2e2bcd8739ae039 = $297c463699425fe3$var$node;

});

parcelRegister("hs8vH", function(module, exports) {

$parcel$export(module.exports, "default", () => $00ae13543d7d5391$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ae6d5401514d5954c10b2c3baa89186>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $00ae13543d7d5391$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView"
            },
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$00ae13543d7d5391$var$node.hash = "afadb43a696a96b327cd8181443d429b";
var $00ae13543d7d5391$export$2e2bcd8739ae039 = $00ae13543d7d5391$var$node;

});

parcelRegister("9j9do", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d63c91c286e9e61$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $9d63c91c286e9e61$var$CascadingEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gRDbg")), {
        moduleId: "d23a4651",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $9d63c91c286e9e61$export$2e2bcd8739ae039 = $9d63c91c286e9e61$var$CascadingEditViewEntryPoint;

});
parcelRegister("gRDbg", function(module, exports) {

let $c46ffd0ba66463dc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c46ffd0ba66463dc$var$load("dnyoG").then(()=>parcelRequire('lOgAb'));

});


parcelRegister("dG41I", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectReadView", () => $1a98731018f28a4c$export$4b0478fdeeb1c69);

var $lDsel = parcelRequire("lDsel");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $d9T1A = parcelRequire("d9T1A");

var $7jTnu = parcelRequire("7jTnu");

var $9Mapt = parcelRequire("9Mapt");

var $3OT15 = parcelRequire("3OT15");

var $jd93d = parcelRequire("jd93d");

var $9Ndu3 = parcelRequire("9Ndu3");
const $1a98731018f28a4c$var$getFieldValueAsText = (cascadingOption)=>{
    if (!cascadingOption || !cascadingOption?.parentOptionValue) return null;
    if (!cascadingOption?.childOptionValue) return cascadingOption.parentOptionValue.value;
    return `${cascadingOption.parentOptionValue.value} - ${cascadingOption.childOptionValue.value}`;
};
const $1a98731018f28a4c$export$4b0478fdeeb1c69 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated = false, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $lDsel.default), fragmentRef);
    const { cascadingOption: cascadingOption } = data;
    const fieldValueAsText = $1a98731018f28a4c$var$getFieldValueAsText(cascadingOption);
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldRenderHoverPopover && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: fieldValueAsText
    });
    if (!fieldValueAsText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) {
        if (shouldRenderHoverPopover) return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ndu3.CascadingSelectOptionTruncated), {
            value: fieldValueAsText,
            ref: hoverPopoverRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: fieldValueAsText,
            contentRef: contentRef
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ndu3.CascadingSelectOptionTruncated), {
                value: fieldValueAsText,
                ref: (0, $jd93d.mergeRefs)(ref, contentRef)
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ndu3.CascadingSelectOptionTruncated), {
            value: fieldValueAsText
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, fieldValueAsText);
};

});
parcelRegister("lDsel", function(module, exports) {

$parcel$export(module.exports, "default", () => $f289b1101cffcad0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d53d11653a982ea82543668931897a3f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f289b1101cffcad0$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    }
                ]
            },
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$f289b1101cffcad0$var$node.hash = "24c4c1a2c85b60dd22f3819bc838494a";
var $f289b1101cffcad0$export$2e2bcd8739ae039 = $f289b1101cffcad0$var$node;

});

parcelRegister("9Ndu3", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectOptionTruncated", () => $d5a65d8f464678ec$export$8691872cfdb45f29);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $d5a65d8f464678ec$export$8691872cfdb45f29 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ value: value }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $d5a65d8f464678ec$var$cascadingValueStylesTruncated,
        ref: ref
    }, value);
});
const $d5a65d8f464678ec$var$cascadingValueStylesTruncated = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    width: '100%'
});

});




parcelRegister("a2txc", function(module, exports) {

$parcel$export(module.exports, "DateCell", () => $3681949de0e7a794$export$64a69967f353bb7c);
$parcel$export(module.exports, "DateInlineEditCell", () => $3681949de0e7a794$export$976ea8051f04575);

var $aGc7L = parcelRequire("aGc7L");

var $d63uu = parcelRequire("d63uu");

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7qGN1 = parcelRequire("7qGN1");

var $5gpGG = parcelRequire("5gpGG");

var $j8Km1 = parcelRequire("j8Km1");

var $7jTnu = parcelRequire("7jTnu");

var $eqbO4 = parcelRequire("eqbO4");

var $86BUM = parcelRequire("86BUM");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $3681949de0e7a794$var$parseDate = (dateString)=>{
    if (dateString !== null && dateString !== '') {
        const date = (0, $kQ82p.default)(dateString);
        if (date.toString() !== 'Invalid Date') return date;
    }
    return null;
};
const $3681949de0e7a794$var$formattedDate = (dateString)=>{
    const date = $3681949de0e7a794$var$parseDate(dateString);
    if (!date) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7qGN1.FormattedDate), {
        value: date,
        year: "numeric",
        month: "short",
        day: "numeric"
    });
};
const $3681949de0e7a794$export$64a69967f353bb7c = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isRequired: isRequired })=>{
    const data = (0, $j4oe4.useFragment)(/* eslint-disable @atlassian/relay/graphql-naming */ (0, $d63uu.default), fieldRef);
    if (data.__typename === 'JiraDatePickerField' && data.fieldId === (0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3681949de0e7a794$export$976ea8051f04575, {
        fieldRef: data
    });
    let date = null;
    if (data.__typename === 'JiraDatePickerField') date = data.date ?? null;
    else if (data.__typename === 'JiraDateTimePickerField') date = data.dateTime ?? null;
    if (isRequired && date == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "date",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3681949de0e7a794$var$wrapperStyles
    }, $3681949de0e7a794$var$formattedDate(date));
});
const $3681949de0e7a794$export$976ea8051f04575 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $aGc7L.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gpGG.DateInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: isFirstField ? $3681949de0e7a794$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        shouldShowHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gpGG.DateInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        shouldShowHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $3681949de0e7a794$var$wrapperStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $3681949de0e7a794$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3681949de0e7a794$var$customTargetStyles,
        ref: ref
    });
});
const $3681949de0e7a794$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("aGc7L", function(module, exports) {

$parcel$export(module.exports, "default", () => $d662d6b631d4cc85$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5348679d88409840cbc084cca6cb2abb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d662d6b631d4cc85$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "date_nativeIssueTable_DateInlineEditCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraDatePickerField"
};
$d662d6b631d4cc85$var$node.hash = "d355ad73c106c22099e54f46482d082c";
var $d662d6b631d4cc85$export$2e2bcd8739ae039 = $d662d6b631d4cc85$var$node;

});

parcelRegister("d63uu", function(module, exports) {

$parcel$export(module.exports, "default", () => $39927b02de428484$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4f7957eb15e09b3ca778fbe5b6cecfb8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $39927b02de428484$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "date_nativeIssueTable_DateCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "date"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "date_nativeIssueTable_DateInlineEditCell_fieldRef"
                }
            ],
            "type": "JiraDatePickerField"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dateTime"
                }
            ],
            "type": "JiraDateTimePickerField"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$39927b02de428484$var$node.hash = "7b89423f51f8c1066484f850cdda0694";
var $39927b02de428484$export$2e2bcd8739ae039 = $39927b02de428484$var$node;

});

parcelRegister("5gpGG", function(module, exports) {

$parcel$export(module.exports, "DateInlineEditViewWithIsEditable", () => $da48bca7bd3c96b9$export$af387cb7b19f78a3);
$parcel$export(module.exports, "DateInlineEditView", () => $da48bca7bd3c96b9$export$d1623660a0dc5b59);

var $9y3IM = parcelRequire("9y3IM");

var $96KlH = parcelRequire("96KlH");

var $6V9qT = parcelRequire("6V9qT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $l11m9 = parcelRequire("l11m9");

var $bekdN = parcelRequire("bekdN");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $epTsa = parcelRequire("epTsa");

var $8oOr4 = parcelRequire("8oOr4");

var $6pncb = parcelRequire("6pncb");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");

var $ln6Iy = parcelRequire("ln6Iy");

var $ftN6c = parcelRequire("ftN6c");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $k745d = parcelRequire("k745d");
const $da48bca7bd3c96b9$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-date-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $da48bca7bd3c96b9$var$RecurWorkItemContainerEmpty = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $da48bca7bd3c96b9$export$af387cb7b19f78a3 = (props)=>{
    const { attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupTarget: editViewPopupTarget, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, isEditing: isEditingProp = false, isEditable: isEditable, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, fragmentRef: fragmentRef, readViewFitContainerHeight: readViewFitContainerHeight, includeUrgencyTreatment: includeUrgencyTreatment, context: context, shouldShowHoverPopover: shouldShowHoverPopover } = props;
    const data = (0, $j4oe4.useFragment)((0, $6V9qT.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $96KlH.default));
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, fieldConfig: fieldConfig } = data;
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const fieldName = overriding.overrideLabel(name);
    const isFieldEditable = overriding.overrideIsEditable(isEditable);
    const isFieldRequired = fieldConfig?.isRequired ?? false;
    const validator = (0, $k745d.useDateValidator)(fieldName, isFieldRequired);
    const initialValue = data.date ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        date: value,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateDateField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateDateField: {
                        success: true,
                        errors: null,
                        field: {
                            date: value,
                            id: uniqueFieldId
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>{
        onSubmitSucceeded?.(value);
    }, [
        onSubmitSucceeded
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: isEditingProp,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'date'
    });
    const isRecurWorkItemEnabled = (projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT)) && context === 'ISSUE_DETAIL' && fieldId === (0, $8oOr4.DUE_DATE) && (0, $epTsa.expVal)('jira-recur-single-work-item-on-sched-due-date-exp', 'showRecurringWorkPopup', false);
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da48bca7bd3c96b9$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bekdN.DateReadView), {
            fragmentRef: data,
            includeUrgencyTreatment: includeUrgencyTreatment,
            ...(0, $7jTnu.fg)('issue_view_due_date_colored_field_targeting_gate') ? {
                fieldId: fieldId
            } : {},
            shouldShowRecurWorkIcon: isRecurWorkItemEnabled && (0, $epTsa.expVal)('jira-recur-single-work-item-on-sched-due-date-exp', 'showRecurWorkIconInDueDate', false),
            shouldShowHoverPopover: shouldShowHoverPopover
        })), [
        data,
        fieldId,
        includeUrgencyTreatment,
        isRecurWorkItemEnabled,
        shouldShowHoverPopover
    ]);
    const RecurWorkItemContainer = isRecurWorkItemEnabled ? (0, $6pncb.RecurWorkItemContainer) : $da48bca7bd3c96b9$var$RecurWorkItemContainerEmpty;
    // copied from @atlassian/jira-inline-edit-lite/src/ui/use-inline-edit/index.tsx
    const handleCancelWithEvent = (0, $eJOHy.useCallback)(()=>handleCancel(createAnalyticsEvent({
            action: 'canceled',
            actionSubject: 'inlineEdit'
        })), [
        handleCancel,
        createAnalyticsEvent
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            value: updatedValue,
            onChange: handleChange,
            isInvalid: !!invalidMessage,
            autoFocus: true,
            label: fieldName,
            ...isRecurWorkItemEnabled && {
                issueKey: issueKey,
                isRecurWorkItemEnabled: isRecurWorkItemEnabled,
                onCancel: handleCancelWithEvent
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RecurWorkItemContainer, {
        issueKey: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $l11m9.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        invalidMessage: invalidMessage,
        hideActionButtons: true
    }));
};
const $da48bca7bd3c96b9$export$d1623660a0dc5b59 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $9y3IM.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da48bca7bd3c96b9$export$af387cb7b19f78a3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("9y3IM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5665c7d240b1b213$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c7e4c91cc0608cf472bd3e81527b427>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5665c7d240b1b213$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateInlineEditFull_DateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraDatePickerField"
};
$5665c7d240b1b213$var$node.hash = "0548aa5d7a0a6ecdbe8581123c90487f";
var $5665c7d240b1b213$export$2e2bcd8739ae039 = $5665c7d240b1b213$var$node;

});

parcelRegister("96KlH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9886dde8952c3b20$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3544f4fde4e58c3db63548472c851999>>
 * @relayHash 3f73c046ded86edefc83912b3cd5e2d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4e94696fd29cf731c3234b50dbf74d91aa220d3c9064bbb1beb198ce6b790f4
const $9886dde8952c3b20$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "date"
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "date_issueFieldDate_DateField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDatePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "date_issueFieldDate_DateField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDatePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f4e94696fd29cf731c3234b50dbf74d91aa220d3c9064bbb1beb198ce6b790f4",
            "metadata": {},
            "name": "date_issueFieldDate_DateField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9886dde8952c3b20$var$node.hash = "3265ff9f0b11e3ed4bac45dff405280d";
var $9886dde8952c3b20$export$2e2bcd8739ae039 = $9886dde8952c3b20$var$node;

});

parcelRegister("6V9qT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e881deeddfc7042$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e77458cde4889443c861d0d7069e28b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e881deeddfc7042$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateReadviewFull_DateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "date"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }
    ],
    "type": "JiraDatePickerField"
};
$3e881deeddfc7042$var$node.hash = "2d11e23373a2a9517c8a8ac5a6bfe366";
var $3e881deeddfc7042$export$2e2bcd8739ae039 = $3e881deeddfc7042$var$node;

});

parcelRegister("l11m9", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e41e4dc412b477$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $28e41e4dc412b477$var$DateEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8m0wy")), {
        moduleId: "652b5c22",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $28e41e4dc412b477$export$2e2bcd8739ae039 = $28e41e4dc412b477$var$DateEditViewEntryPoint;

});
parcelRegister("8m0wy", function(module, exports) {

let $6150c8df3c669a04$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6150c8df3c669a04$var$load("lx5kZ").then(()=>parcelRequire('7tcPf'));

});


parcelRegister("bekdN", function(module, exports) {

$parcel$export(module.exports, "DateReadView", () => $5f9b76cb43e378fb$export$c663acc1a0b7c5a9);

var $3JU4H = parcelRequire("3JU4H");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $bemI6 = parcelRequire("bemI6");

var $7jTnu = parcelRequire("7jTnu");

var $lBRZk = parcelRequire("lBRZk");

var $dVT0O = parcelRequire("dVT0O");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $3NHJr = parcelRequire("3NHJr");

var $8oOr4 = parcelRequire("8oOr4");

var $6pncb = parcelRequire("6pncb");

var $9Vf8k = parcelRequire("9Vf8k");

var $g2hxj = parcelRequire("g2hxj");

var $jd93d = parcelRequire("jd93d");

var $9Mapt = parcelRequire("9Mapt");

var $3OT15 = parcelRequire("3OT15");

var $7y0HS = parcelRequire("7y0HS");
const $5f9b76cb43e378fb$var$RecurringWorkItemIcon = ({ useUrgentColour: useUrgentColour })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $6pncb.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $9Vf8k.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bemI6))), {
        label: "",
        testId: "issue-field-date-readview-full.ui.date.recur-work-icon",
        ...useUrgentColour ? {
            color: "var(--ds-icon-danger, #C9372C)"
        } : {}
    });
};
const $5f9b76cb43e378fb$var$EmptyContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $5f9b76cb43e378fb$export$c663acc1a0b7c5a9 = ({ fragmentRef: fragmentRef, fieldId: fieldId, includeUrgencyTreatment: includeUrgencyTreatment, shouldShowRecurWorkIcon: shouldShowRecurWorkIcon = false, shouldShowHoverPopover: shouldShowHoverPopover })=>{
    const { formatDateOnly: formatDateOnly } = (0, $3NHJr.useDateTimeFormatter)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const noValueTextExperiment = formatMessage(fieldId === (0, $8oOr4.DUE_DATE) ? (0, $7y0HS.default).noValueTextExperimentDueDate : (0, $7y0HS.default).noValueTextExperiment);
    const data = (0, $j4oe4.useFragment)((0, $3JU4H.default), fragmentRef);
    const { date: date } = data || {};
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldShowHoverPopover && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (!date) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
    const daysSinceDate = (0, $g2hxj.getNoOfDaysSinceUTCDateString)(date);
    const isDatePast = daysSinceDate != null && daysSinceDate > 0;
    const isDueToday = daysSinceDate === 0;
    const renderColoredDueDate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lBRZk.ColoredDueDate), {
            dateString: date,
            pastDue: isDatePast && Boolean(includeUrgencyTreatment) && fieldId === (0, $8oOr4.DUE_DATE),
            dueToday: isDueToday && Boolean(includeUrgencyTreatment) && fieldId === (0, $8oOr4.DUE_DATE),
            warningIconTestId: "date-field.warning-icon",
            clockIconTestId: "date-field.clock-icon",
            calendarIconTestId: "date-field.calendar-icon",
            maybeShowRecurIcon: shouldShowRecurWorkIcon,
            recurIconTestId: "date-field.recur-icon"
        });
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: formatDateOnly(date)
    });
    const renderedValue = includeUrgencyTreatment && fieldId === (0, $8oOr4.DUE_DATE) && (0, $epTsa.expVal)('due_date_colured_field', 'showUrgencyIndicator', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dVT0O.DateWithUrgencyIndicator), {
        value: date
    }) : formatDateOnly(date);
    const Container = shouldShowRecurWorkIcon ? (0, $3Wh6p.default) : $5f9b76cb43e378fb$var$EmptyContainer;
    /**
   * Hover popover is only enabled on NIN, GNIN, and CHIN and hence the conditional rendering of
   * other formatted dates is ignroed
   */ if (shouldShowHoverPopover) return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Container, {
        space: "space.075",
        alignBlock: "center",
        testId: "issue-field-date-readview-full.ui.date.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: [
            $5f9b76cb43e378fb$var$dateReadViewStyles,
            $5f9b76cb43e378fb$var$singleLineStyles
        ],
        ref: hoverPopoverRef
    }, formatDateOnly(date))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        contentRef: contentRef,
        content: formatDateOnly(date)
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Container, {
            space: "space.075",
            alignBlock: "center",
            testId: "issue-field-date-readview-full.ui.date.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            xcss: [
                $5f9b76cb43e378fb$var$dateReadViewStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            maxLines: 1,
            ref: (0, $jd93d.mergeRefs)(ref, contentRef)
        }, formatDateOnly(date)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Container, {
        space: "space.075",
        alignBlock: "center",
        testId: "issue-field-date-readview-full.ui.date.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: [
            $5f9b76cb43e378fb$var$dateReadViewStyles,
            !(includeUrgencyTreatment && fieldId === (0, $8oOr4.DUE_DATE) && (0, $epTsa.expVal)('color_due_date_all_views', 'showColoredDueDate', false)) && $5f9b76cb43e378fb$var$clampStyles
        ]
    }, includeUrgencyTreatment && fieldId === (0, $8oOr4.DUE_DATE) && (0, $epTsa.expVal)('color_due_date_all_views', 'showColoredDueDate', false) ? renderColoredDueDate() : renderedValue), !(0, $epTsa.expVal)('color_due_date_all_views', 'showColoredDueDate', false) && shouldShowRecurWorkIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f9b76cb43e378fb$var$RecurringWorkItemIcon, {
        useUrgentColour: (isDatePast || isDueToday) && !!includeUrgencyTreatment && (0, $epTsa.expVal)('due_date_colured_field', 'showUrgencyIndicator', false)
    }));
};
const $5f9b76cb43e378fb$var$dateReadViewStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $5f9b76cb43e378fb$var$clampStyles = (0, $1DXK0.xcss)({
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2
});
const $5f9b76cb43e378fb$var$singleLineStyles = (0, $1DXK0.xcss)({
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1
});

});
parcelRegister("3JU4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6dd5f636cb2f6de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c589d0cfd038548f69d781b5781337f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f6dd5f636cb2f6de$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "date_issueFieldDateReadviewFull_DateReadView",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "date"
        }
    ],
    "type": "JiraDatePickerField"
};
$f6dd5f636cb2f6de$var$node.hash = "2f4bee59147d16a06e8569a9e3b3c8a3";
var $f6dd5f636cb2f6de$export$2e2bcd8739ae039 = $f6dd5f636cb2f6de$var$node;

});

parcelRegister("bemI6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a88758e67a65d8683bdcd5e828d8b686>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82d29e52dbda888e$var$_react = $82d29e52dbda888e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $82d29e52dbda888e$var$_baseNew = $82d29e52dbda888e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $82d29e52dbda888e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82d29e52dbda888e$var$RepeatIcon = (props)=>/*#__PURE__*/ $82d29e52dbda888e$var$_react.default.createElement($82d29e52dbda888e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$82d29e52dbda888e$var$RepeatIcon.displayName = 'RepeatIcon';
var $82d29e52dbda888e$var$_default = module.exports.default = $82d29e52dbda888e$var$RepeatIcon;

});

parcelRegister("lBRZk", function(module, exports) {

$parcel$export(module.exports, "ColoredDueDate", () => $a14336caaa0d75c4$export$63c54814247cca36);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $bemI6 = parcelRequire("bemI6");

var $3GKOL = parcelRequire("3GKOL");

var $i5stJ = parcelRequire("i5stJ");

var $leOHG = parcelRequire("leOHG");

var $k71qx = parcelRequire("k71qx");

var $2cfd4 = parcelRequire("2cfd4");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $6pncb = parcelRequire("6pncb");

var $9Vf8k = parcelRequire("9Vf8k");

var $kPKM4 = parcelRequire("kPKM4");
const $a14336caaa0d75c4$var$RecurringWorkItemIcon = ({ testId: testId })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $6pncb.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $9Vf8k.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bemI6))), {
        label: "",
        testId: testId
    });
};
const $a14336caaa0d75c4$export$63c54814247cca36 = ({ dateString: dateString, pastDue: pastDue, dueToday: dueToday, warningIconTestId: warningIconTestId, clockIconTestId: clockIconTestId, calendarIconTestId: calendarIconTestId, tooltipTestId: tooltipTestId, isShortFormat: isShortFormat = false, maybeShowRecurIcon: maybeShowRecurIcon = false, recurIconTestId: recurIconTestId })=>{
    const locale = (0, $2cfd4.useLocale)();
    const localeString = locale.replace('_', '-');
    const formatter = new Intl.DateTimeFormat(localeString, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
    });
    const parts = formatter.formatToParts(new Date(dateString));
    const formatDateParts = ({ dateParts: dateParts, includeYear: includeYear = true })=>{
        let result = '';
        dateParts.forEach((part, index)=>{
            const isYearLiteralInShortFormat = part.type === 'literal' && (dateParts[index + 1]?.type === 'year' || dateParts[index - 1]?.type === 'year') && !includeYear;
            if (part.type === 'year' && includeYear || part.type !== 'year' && !isYearLiteralInShortFormat) result += part.value;
        });
        return result;
    };
    const displayDate = isShortFormat ? formatDateParts({
        dateParts: parts,
        includeYear: false
    }) : formatDateParts({
        dateParts: parts
    });
    const tooltipDate = formatDateParts({
        dateParts: parts,
        includeYear: true
    });
    const dueMessage = pastDue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $kPKM4.messages).overdue,
        values: {
            date: tooltipDate
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $kPKM4.messages).due,
        values: {
            date: tooltipDate
        }
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const iconLabel = pastDue ? formatMessage((0, $kPKM4.messages).overdue, {
        date: tooltipDate
    }) : formatMessage((0, $kPKM4.messages).due, {
        date: tooltipDate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: dueMessage,
        position: "top",
        testId: tooltipTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $a14336caaa0d75c4$var$styles.dateTag,
            $a14336caaa0d75c4$var$styles.flexContainer,
            pastDue ? $a14336caaa0d75c4$var$styles.overdue : undefined,
            dueToday ? $a14336caaa0d75c4$var$styles.dueToday : undefined,
            !pastDue && !dueToday ? $a14336caaa0d75c4$var$styles.normalDate : undefined
        ],
        testId: "coloured-due-date.ui.colored-due-date-container",
        tabIndex: 0,
        role: "button",
        "aria-label": iconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a14336caaa0d75c4$var$styles.dueDateIcon,
        testId: "coloured-due-date.ui.tooltip-container"
    }, pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($leOHG))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-danger, #AE2E24)",
        testId: warningIconTestId
    }), dueToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-warning, #A54800)",
        testId: clockIconTestId
    }), !dueToday && !pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
        label: iconLabel,
        color: "var(--ds-text, #172B4D)",
        LEGACY_size: "medium",
        testId: calendarIconTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "aria-hidden": "true"
    }, displayDate), maybeShowRecurIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a14336caaa0d75c4$var$RecurringWorkItemIcon, {
        testId: recurIconTestId
    })));
};
const $a14336caaa0d75c4$var$styles = {
    dateTag: (0, $1DXK0.xcss)({
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        borderStyle: 'solid',
        borderRadius: 'border.radius.100',
        borderWidth: 'border.width',
        color: 'color.text',
        cursor: 'pointer'
    }),
    flexContainer: (0, $1DXK0.xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    }),
    overdue: (0, $1DXK0.xcss)({
        color: 'color.text.danger',
        borderColor: 'color.border.danger'
    }),
    dueToday: (0, $1DXK0.xcss)({
        color: 'color.text.warning',
        borderColor: 'color.border.warning'
    }),
    normalDate: (0, $1DXK0.xcss)({
        color: 'color.text',
        borderColor: 'color.border'
    }),
    dueDateIcon: (0, $1DXK0.xcss)({
        display: 'flex',
        alignItems: 'center'
    })
};

});
parcelRegister("3GKOL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2af99c62070f9b2c$var$_react = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2af99c62070f9b2c$var$_calendar = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("btkTq")));

var $2af99c62070f9b2c$var$_calendar2 = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("76JV8")));
function $2af99c62070f9b2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2af99c62070f9b2c$var$CalendarIcon = (props)=>/*#__PURE__*/ $2af99c62070f9b2c$var$_react.default.createElement($2af99c62070f9b2c$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $2af99c62070f9b2c$var$_calendar2.default
    }, props));
$2af99c62070f9b2c$var$CalendarIcon.Name = 'CalendarIconMigration';
var $2af99c62070f9b2c$var$_default = module.exports.default = $2af99c62070f9b2c$var$CalendarIcon;

});
parcelRegister("btkTq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a29c08b1b7d658$var$_react = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $85a29c08b1b7d658$var$_baseNew = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $85a29c08b1b7d658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85a29c08b1b7d658$var$CalendarIcon = (props)=>/*#__PURE__*/ $85a29c08b1b7d658$var$_react.default.createElement($85a29c08b1b7d658$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$85a29c08b1b7d658$var$CalendarIcon.displayName = 'CalendarIcon';
var $85a29c08b1b7d658$var$_default = module.exports.default = $85a29c08b1b7d658$var$CalendarIcon;

});

parcelRegister("76JV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52ccb6d3a2735d8d$var$_react = $52ccb6d3a2735d8d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $52ccb6d3a2735d8d$var$_calendar = $52ccb6d3a2735d8d$var$_interopRequireDefault((parcelRequire("btkTq")));
function $52ccb6d3a2735d8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $52ccb6d3a2735d8d$var$CalendarIcon = (props)=>/*#__PURE__*/ $52ccb6d3a2735d8d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $52ccb6d3a2735d8d$var$_calendar.default
    }));
$52ccb6d3a2735d8d$var$CalendarIcon.displayName = 'CalendarIcon';
var $52ccb6d3a2735d8d$var$_default = module.exports.default = $52ccb6d3a2735d8d$var$CalendarIcon;

});


parcelRegister("leOHG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70d38d66c51578fdcb83798a1209161a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7623c787bc0988e$var$_react = $f7623c787bc0988e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f7623c787bc0988e$var$_baseNew = $f7623c787bc0988e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f7623c787bc0988e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7623c787bc0988e$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $f7623c787bc0988e$var$_react.default.createElement($f7623c787bc0988e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$f7623c787bc0988e$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $f7623c787bc0988e$var$_default = module.exports.default = $f7623c787bc0988e$var$WarningOutlineIcon;

});

parcelRegister("6pncb", function(module, exports) {

$parcel$export(module.exports, "RecurWorkItemContainer", () => $c7179b3f6e81c7a6$export$32458a51e0870d6c);
$parcel$export(module.exports, "useRecurWorkItemState", () => $c7179b3f6e81c7a6$export$5730c874dfb9803f);
$parcel$export(module.exports, "useRecurWorkItemActions", () => $c7179b3f6e81c7a6$export$eb9ad4e1e739768e);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $kEUB1 = parcelRequire("kEUB1");

var $g1NZW = parcelRequire("g1NZW");

var $bNexr = parcelRequire("bNexr");

var $3MbOI = parcelRequire("3MbOI");

var $eSnSE = parcelRequire("eSnSE");

var $5Ix22 = parcelRequire("5Ix22");

var $as8tn = parcelRequire("as8tn");
const $c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer = (0, $6E16M.createContainer)();
const $c7179b3f6e81c7a6$export$32458a51e0870d6c = ({ children: children, issueKey: issueKey })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const environment = (0, $g1NZW.useEnvironment)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    const { data: currentUser } = (0, $3MbOI.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (!projectId) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-recur-work-item.src.controllers.RecurWorkItemContainer', 'Error initialising RecurWorkItemContainer, could not retrieve projectId');
        return children;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer, {
        scope: `recur-${issueKey}`,
        issueKey: issueKey,
        environment: environment,
        cloudId: cloudId,
        currentUserAccountId: currentUser.user.accountId,
        projectId: projectId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $c7179b3f6e81c7a6$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'RecurWorkItemStore',
    initialState: (0, $as8tn.INITIAL_STATE),
    actions: $5Ix22.actions,
    containedBy: $c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch })=>{
                await dispatch((0, $5Ix22.actions).fetch());
            }
    }
});
const $c7179b3f6e81c7a6$export$6630e454597fb59c = (0, $iJq0l.createHook)($c7179b3f6e81c7a6$export$390f32400eaf98c9);
const $c7179b3f6e81c7a6$export$5730c874dfb9803f = (0, $iJq0l.createStateHook)($c7179b3f6e81c7a6$export$390f32400eaf98c9);
const $c7179b3f6e81c7a6$export$eb9ad4e1e739768e = (0, $iJq0l.createActionsHook)($c7179b3f6e81c7a6$export$390f32400eaf98c9);

});
parcelRegister("5Ix22", function(module, exports) {

$parcel$export(module.exports, "actions", () => $13cafe401ee5ee68$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1Lz15 = parcelRequire("1Lz15");

var $2ZEsM = parcelRequire("2ZEsM");

var $b7KsF = parcelRequire("b7KsF");

var $f0czN = parcelRequire("f0czN");
const $13cafe401ee5ee68$export$5153917efea4a83d = (issueProperties)=>({ setState: setState })=>{
        setState({
            issueProperties: issueProperties
        });
    };
const $13cafe401ee5ee68$export$e324594224ef24da = {
    fetch: $1Lz15.fetch,
    setIssueProperties: $13cafe401ee5ee68$export$5153917efea4a83d,
    setAsNonRecurringIssue: $2ZEsM.setAsNonRecurringIssue,
    setAsRecurringIssue: $b7KsF.setAsRecurringIssue,
    updateRule: $f0czN.updateRule
};

});
parcelRegister("1Lz15", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $92eb5cf7fd76697f$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");

var $k9ldc = parcelRequire("k9ldc");

var $g7LgB = parcelRequire("g7LgB");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");

var $9Vf8k = parcelRequire("9Vf8k");
const $92eb5cf7fd76697f$export$e7aa7bc5c1b3cfb3 = ()=>async ({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId, currentUserAccountId: currentUserAccountId })=>{
        setState({
            isFetching: true,
            errors: null
        });
        try {
            // First fetch issue-properties
            const { value: issueProperties } = await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $k9ldc.fetchIssueProperties)(issueKey), 'fetchIssueProperties');
            let ruleSummary;
            // Only fetch rule summary if a rule exists in issue-properties and not a grandfathered recur-on-complete rule
            if (issueProperties?.automationRuleUuid) {
                ruleSummary = await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $k9ldc.fetchRuleSummary)(environment, cloudId, projectId, issueProperties.automationRuleUuid), 'fetchRuleSummary');
                // If rule doesn't exist or is disabled, delete issue-properties
                if (!ruleSummary || ruleSummary?.ruleState === (0, $g7LgB.RuleState).DISABLED) {
                    await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $f3jI4.deleteIssueProperties)({
                        issueKey: issueKey
                    }), 'deleteIssueProperties');
                    setState({
                        isFetching: false,
                        hasFetched: true,
                        issueProperties: null
                    });
                    return;
                }
            }
            let isRuleOwner;
            if ((0, $9Vf8k.isRecurOnCompleteToggleRule)(issueProperties)) isRuleOwner = true;
            else if (ruleSummary) isRuleOwner = ruleSummary.authorAccountId === currentUserAccountId;
            else isRuleOwner = null;
            setState({
                isFetching: false,
                hasFetched: true,
                issueProperties: issueProperties,
                isRuleOwner: isRuleOwner,
                ...(0, $7jTnu.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && {
                    hasBootstrapError: false
                }
            });
        } catch (error) {
            setState({
                isFetching: false,
                hasFetched: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    error
                ],
                hasBootstrapError: true
            });
        }
    };

});
parcelRegister("k9ldc", function(module, exports) {

$parcel$export(module.exports, "fetchIssueProperties", () => $5469679b83f8a32d$export$efa35964e975bd30);
$parcel$export(module.exports, "fetchRuleSummary", () => $5469679b83f8a32d$export$3cada9835f092161);

var $jbPE2 = parcelRequire("jbPE2");

var $1uIew = parcelRequire("1uIew");

var $jGzN3 = parcelRequire("jGzN3");
const $5469679b83f8a32d$export$efa35964e975bd30 = async (issueKey)=>{
    const recurrenceConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    try {
        return await (0, $jGzN3.performGetRequest)(recurrenceConfigEndpoint);
    } catch (error) {
        if (error instanceof (0, $1uIew.default) && error.statusCode === 404) return Promise.resolve({
            value: null
        });
        throw error;
    }
};
const $5469679b83f8a32d$export$3cada9835f092161 = async (environment, cloudId, projectId, ruleUuid)=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const summaryEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/summary`;
    try {
        return await (0, $jGzN3.performGetRequest)(summaryEndpoint);
    } catch (error) {
        if (error instanceof (0, $1uIew.default) && error.statusCode === 404) return null;
        throw error;
    }
};

});
parcelRegister("jbPE2", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $192a6ea715d806e4$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $192a6ea715d806e4$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $192a6ea715d806e4$export$8e479e490e1e69bc);

var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");
const $192a6ea715d806e4$var$localStorage = (0, $dnU6V.createLocalStorageProvider)('automation-menu');
const $192a6ea715d806e4$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $192a6ea715d806e4$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $7jTnu.fg)('automation-platform-pre-prod-instance')) {
            const stack = await $192a6ea715d806e4$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $192a6ea715d806e4$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $192a6ea715d806e4$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $192a6ea715d806e4$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $192a6ea715d806e4$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $192a6ea715d806e4$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if ((0, $7jTnu.fg)('jcs_project_type_m3')) switch(projectType){
        case 'customer_service':
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});


parcelRegister("g7LgB", function(module, exports) {

$parcel$export(module.exports, "RuleState", () => $fc4f058c04244dcc$export$c22ef3527b5f5563);
$parcel$export(module.exports, "CONDITION", () => $fc4f058c04244dcc$export$1cfe08df32bc8f76);
$parcel$export(module.exports, "FORM_TITLE_ID", () => $fc4f058c04244dcc$export$66f4c6e4b9206abf);
$parcel$export(module.exports, "SOFTWARE_END_USER_TEMPLATE_2", () => $fc4f058c04244dcc$export$c07ca23c166d6344);
const $fc4f058c04244dcc$export$c22ef3527b5f5563 = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    MISSING_PERMS: 'MISSING_PERMS'
};
const $fc4f058c04244dcc$export$1cfe08df32bc8f76 = {
    SCHEDULE: 'SCHEDULE',
    SCHEDULE_IF_COMPLETE: 'SCHEDULE_IF_COMPLETE'
};
const $fc4f058c04244dcc$export$f7109619a5e9e0d6 = 'recurWorkItemForm';
const $fc4f058c04244dcc$export$66f4c6e4b9206abf = 'recur-work-item-form-title';
const $fc4f058c04244dcc$export$c07ca23c166d6344 = 'software_end_user_template_2';

});

parcelRegister("f3jI4", function(module, exports) {

$parcel$export(module.exports, "deleteRule", () => $e4bbd2fe0788cecd$export$988cba38e738f27d);
$parcel$export(module.exports, "deleteIssueProperties", () => $e4bbd2fe0788cecd$export$3906c12f20991cd1);
$parcel$export(module.exports, "disableRule", () => $e4bbd2fe0788cecd$export$44bd9fdb7edbb04a);

var $jbPE2 = parcelRequire("jbPE2");

var $jGzN3 = parcelRequire("jGzN3");
const $e4bbd2fe0788cecd$export$988cba38e738f27d = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const DELETE_RULE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}`;
    return (0, $jGzN3.performDeleteRequest)(DELETE_RULE_URL);
};
const $e4bbd2fe0788cecd$export$3906c12f20991cd1 = async ({ issueKey: issueKey })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $jGzN3.performDeleteRequest)(ruleConfigEndpoint);
};
const $e4bbd2fe0788cecd$export$44bd9fdb7edbb04a = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const disableRuleEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/disable`;
    return (0, $jGzN3.performPatchRequest)(disableRuleEndpoint);
};

});

parcelRegister("9riZR", function(module, exports) {

$parcel$export(module.exports, "callServiceWithAnalytics", () => $6b2665faae66cf06$export$7ad2acdaf7d8c23c);

var $1uIew = parcelRequire("1uIew");

var $gCeeo = parcelRequire("gCeeo");
const $6b2665faae66cf06$var$getErrorAttributes = (error)=>{
    if (error instanceof Error) return {
        errorMessage: error.message,
        ...error instanceof (0, $1uIew.default) && {
            statusCode: error.statusCode
        }
    };
    return {};
};
const $6b2665faae66cf06$export$7ad2acdaf7d8c23c = async (analyticsEvent, requestPromise, requestName, attributes = {})=>{
    try {
        const response = await requestPromise;
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, `${requestName} succeeded`, {
            ...attributes
        });
        return response;
    } catch (err) {
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, `${requestName} failed`, {
            ...attributes,
            ...$6b2665faae66cf06$var$getErrorAttributes(err)
        });
        throw err;
    }
};

});

parcelRegister("9Vf8k", function(module, exports) {

$parcel$export(module.exports, "mapFrequencyToRRule", () => $aefb7d8338ffa0c9$export$e01411a3db8dd3d7);
$parcel$export(module.exports, "mapFrequencyToSmartOffsetValue", () => $aefb7d8338ffa0c9$export$777fffdd861d4f20);
$parcel$export(module.exports, "getFrequencyFromRRule", () => $aefb7d8338ffa0c9$export$71b17ee07540e13b);
$parcel$export(module.exports, "getRecurMenuItemLabel", () => $aefb7d8338ffa0c9$export$c7198a7e75d4478b);
$parcel$export(module.exports, "getSuccessFlagContent", () => $aefb7d8338ffa0c9$export$8eef89c3d24cb712);
$parcel$export(module.exports, "isRecurOnCompleteToggleRule", () => $aefb7d8338ffa0c9$export$b57843f38b80b500);
$parcel$export(module.exports, "hasRuleChanged", () => $aefb7d8338ffa0c9$export$8dc77b9e863f46b);
$parcel$export(module.exports, "applyUserTimezone", () => $aefb7d8338ffa0c9$export$555109634e8a63b6);

var $cSmYj = parcelRequire("cSmYj");

var $5IPrF = parcelRequire("5IPrF");

var $8RQlO = parcelRequire("8RQlO");

var $e3Aqb = parcelRequire("e3Aqb");

var $fBF7C = parcelRequire("fBF7C");
var $h5cuQ = parcelRequire("h5cuQ");

var $9RPB3 = parcelRequire("9RPB3");

var $b5IjV = parcelRequire("b5IjV");
const $aefb7d8338ffa0c9$export$e01411a3db8dd3d7 = (timeframe, recurWeeklyConfig)=>{
    switch(timeframe){
        case 'DAILY':
            return {
                frequency: (0, $9RPB3.Frequencies).DAILY,
                interval: 1
            };
        case 'WEEKDAY':
            return {
                frequency: (0, $9RPB3.Frequencies).DAILY,
                byDay: [
                    (0, $9RPB3.Days).MO,
                    (0, $9RPB3.Days).TU,
                    (0, $9RPB3.Days).WE,
                    (0, $9RPB3.Days).TH,
                    (0, $9RPB3.Days).FR
                ],
                interval: 1
            };
        case 'WEEKLY':
            return {
                frequency: (0, $9RPB3.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 1
            };
        case 'FORTNIGHTLY':
            // There is no native FORTNIGHTLY frequency for ical, so we need to combine WEEKLY with interval 2
            return {
                frequency: (0, $9RPB3.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 2
            };
        default:
            throw new Error(`Unknown timeframe: ${timeframe}`);
    }
};
const $aefb7d8338ffa0c9$export$777fffdd861d4f20 = (timeframe)=>{
    switch(timeframe){
        case 'DAILY':
            return '{{now.plusDays(1)}}';
        case 'WEEKDAY':
            return '{{now.plusBusinessDays(1)}}';
        case 'WEEKLY':
            return '{{now.plusWeeks(1)}}';
        case 'FORTNIGHTLY':
            return '{{now.plusWeeks(2)}}';
        default:
            throw new Error(`Could not calculate due date smart offset value: ${timeframe}`);
    }
};
const $aefb7d8338ffa0c9$export$71b17ee07540e13b = (rrule)=>{
    if (rrule.frequency === (0, $9RPB3.Frequencies).DAILY) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(rrule.byDay, [
            (0, $9RPB3.Days).MO,
            (0, $9RPB3.Days).TU,
            (0, $9RPB3.Days).WE,
            (0, $9RPB3.Days).TH,
            (0, $9RPB3.Days).FR
        ])) return 'WEEKDAY';
        return 'DAILY';
    }
    if (rrule.frequency === (0, $9RPB3.Frequencies).WEEKLY) {
        if (rrule.interval === 2) return 'FORTNIGHTLY';
        return 'WEEKLY';
    }
};
const $aefb7d8338ffa0c9$export$c7198a7e75d4478b = (rrule, isRecurOnComplete = false)=>{
    if (isRecurOnComplete) return (0, $b5IjV.default).recursOnComplete;
    const frequency = $aefb7d8338ffa0c9$export$71b17ee07540e13b(rrule);
    // Every business day (Monday to Friday)
    if (frequency === 'WEEKDAY') return (0, $b5IjV.default).recursEveryWeekday;
    // Daily
    if (frequency === 'DAILY') return (0, $b5IjV.default).recursDaily;
    // Fortnightly
    if (frequency === 'FORTNIGHTLY') return (0, $b5IjV.default).recursEveryTwoWeeks;
    // Weekly
    if (frequency === 'WEEKLY') return (0, $b5IjV.default).recursWeekly;
    return (0, $b5IjV.default).setToRecur;
};
const $aefb7d8338ffa0c9$var$byDayOptions = Object.values((0, $9RPB3.Days));
const $aefb7d8338ffa0c9$var$getWeekDayNameFromByDay = (byDayValue, intl)=>{
    const dayIndex = $aefb7d8338ffa0c9$var$byDayOptions.indexOf(byDayValue);
    if (dayIndex < 0) throw new Error(`Invalid ByDay value provided: ${byDayValue}. Valid options: ${$aefb7d8338ffa0c9$var$byDayOptions}`);
    const firstDayOfWeek = (0, $5IPrF.default)(new Date(), {
        weekStartsOn: 1
    });
    const day = (0, $8RQlO.default)(firstDayOfWeek, dayIndex);
    return intl.formatDate(day, {
        weekday: 'long'
    });
};
const $aefb7d8338ffa0c9$export$5c6d45150d1588c0 = ({ byDayValues: byDayValues, intl: intl, standardizedLocale: standardizedLocale })=>new Intl.ListFormat(standardizedLocale, {
        style: 'long',
        type: 'conjunction'
    }).format(Array.from(byDayValues, (byDayValue)=>$aefb7d8338ffa0c9$var$getWeekDayNameFromByDay(byDayValue, intl)));
const $aefb7d8338ffa0c9$export$8eef89c3d24cb712 = ({ frequency: frequency, recurCondition: recurCondition, recurWeeklyConfig: recurWeeklyConfig, intl: intl, standardizedLocale: standardizedLocale, issueKey: issueKey, issueType: issueType })=>{
    const issueTypeLowercase = issueType.toLocaleLowerCase(standardizedLocale);
    switch(recurCondition){
        case 'SCHEDULE_IF_COMPLETE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteDaily, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteDaily, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteWeekday, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekday, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteWeekly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteFortnightly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteFortnightly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        case 'SCHEDULE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleDaily, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleWeekday, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleWeekly, {
                            issueKey: issueKey,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleFortnightly, {
                            issueKey: issueKey,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        default:
            throw new Error(`Unknown recur condition: ${recurCondition}`);
    }
};
const $aefb7d8338ffa0c9$export$b57843f38b80b500 = (issueProperties)=>{
    return !!issueProperties && !!issueProperties.token && (issueProperties.recurOnScheduleConfig === null || issueProperties.recurOnScheduleConfig === undefined);
};
const $aefb7d8338ffa0c9$var$areByDaysEqual = ({ byDays: byDays, anotherByDays: anotherByDays })=>{
    // assumes lists have a consistent order
    if (byDays === undefined) return anotherByDays === undefined;
    if (anotherByDays === undefined) return false;
    if (byDays.length !== anotherByDays.length) return false;
    return byDays.every((byDay, index)=>byDay === anotherByDays[index]);
};
const $aefb7d8338ffa0c9$var$areDatesEqual = (date1, date2)=>{
    if (date1 === undefined || date2 === undefined) return date1 === date2;
    // We only care about checking the date equality, not the time
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const $aefb7d8338ffa0c9$export$8dc77b9e863f46b = ({ formInput: formInput, formOutput: formOutput })=>{
    // comparing 2 recur-on-schedule rules
    if (formInput.frequency !== formOutput.frequency || formInput.condition !== formOutput.condition || !$aefb7d8338ffa0c9$var$areDatesEqual(formInput.endsOn, formOutput.endsOn)) return true;
    if (formInput.frequency === 'WEEKLY' || formInput.frequency === 'FORTNIGHTLY') return !$aefb7d8338ffa0c9$var$areByDaysEqual({
        byDays: formInput.byDay,
        anotherByDays: formOutput.byDay
    });
    return false;
};
const $aefb7d8338ffa0c9$export$555109634e8a63b6 = (date, browserTimezone, userTimezone)=>{
    const browserTimezoneOffsetMs = (0, $e3Aqb.default)(browserTimezone);
    const userTimezoneOffsetMs = (0, $e3Aqb.default)(userTimezone);
    return (0, $fBF7C.default)((0, $h5cuQ.default)(date, browserTimezoneOffsetMs), userTimezoneOffsetMs);
};

});
parcelRegister("9RPB3", function(module, exports) {

$parcel$export(module.exports, "NEWLINE_REGEX", () => $0c0ab4669e06d62e$export$665ca7211e0c33c);
$parcel$export(module.exports, "FOLD_LINES_REGEX", () => $0c0ab4669e06d62e$export$4b7f22f32fbb5949);
$parcel$export(module.exports, "LF", () => $0c0ab4669e06d62e$export$606cfc2a8896c91f);
$parcel$export(module.exports, "NewlineCharacters", () => $0c0ab4669e06d62e$export$ccae594c20078277);
$parcel$export(module.exports, "NewlineCharacterValues", () => $0c0ab4669e06d62e$export$c3edd2b21ac02f88);
$parcel$export(module.exports, "Frequencies", () => $0c0ab4669e06d62e$export$895ee510b2e84ade);
$parcel$export(module.exports, "Days", () => $0c0ab4669e06d62e$export$d3134eff2123aadb);
$parcel$export(module.exports, "BEGIN_VEVENT", () => $0c0ab4669e06d62e$export$67de00e87412dc6f);
$parcel$export(module.exports, "END_VEVENT", () => $0c0ab4669e06d62e$export$987d86d2e891c4cb);
$parcel$export(module.exports, "DTSTART", () => $0c0ab4669e06d62e$export$fd1a0e011a586e26);
$parcel$export(module.exports, "RRULE", () => $0c0ab4669e06d62e$export$d86ed937a45b0291);
$parcel$export(module.exports, "ICalSpecificationFields", () => $0c0ab4669e06d62e$export$98eba4d8ff00c139);
$parcel$export(module.exports, "ICalSupportedFields", () => $0c0ab4669e06d62e$export$38b1323f325ffd22);
$parcel$export(module.exports, "TZID", () => $0c0ab4669e06d62e$export$5b9a78912028c06d);
$parcel$export(module.exports, "DTStartProperties", () => $0c0ab4669e06d62e$export$20184b745430719e);
$parcel$export(module.exports, "FREQ", () => $0c0ab4669e06d62e$export$fb124b4fa837b262);
$parcel$export(module.exports, "UNTIL", () => $0c0ab4669e06d62e$export$4cc4f35131ed029c);
$parcel$export(module.exports, "INTERVAL", () => $0c0ab4669e06d62e$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "BYHOUR", () => $0c0ab4669e06d62e$export$a764ed9c4884f76d);
$parcel$export(module.exports, "BYMINUTE", () => $0c0ab4669e06d62e$export$7a96578de7a037b6);
$parcel$export(module.exports, "BYSECOND", () => $0c0ab4669e06d62e$export$55bcca3bd8d3041f);
$parcel$export(module.exports, "BYDAY", () => $0c0ab4669e06d62e$export$f512ea3e90612d03);
$parcel$export(module.exports, "BYMONTH", () => $0c0ab4669e06d62e$export$b3203f635d74ce88);
$parcel$export(module.exports, "BYMONTHDAY", () => $0c0ab4669e06d62e$export$15623ad945e92c4c);
$parcel$export(module.exports, "RRuleProperties", () => $0c0ab4669e06d62e$export$7898bd020dba0a27);
$parcel$export(module.exports, "MISSING", () => $0c0ab4669e06d62e$export$64c81710c321f252);
$parcel$export(module.exports, "EMPTY", () => $0c0ab4669e06d62e$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "INVALID", () => $0c0ab4669e06d62e$export$9a105a556e65c2c0);
$parcel$export(module.exports, "VALID", () => $0c0ab4669e06d62e$export$f3abe3d006c81602);
const $0c0ab4669e06d62e$export$665ca7211e0c33c = /\r?\n/;
const $0c0ab4669e06d62e$export$4b7f22f32fbb5949 = /\r?\n[ \t]/g; // match line breaks followed by a whitespace character (space or tab)
const $0c0ab4669e06d62e$export$ae9ea0d00d3d8982 = 'CRLF';
const $0c0ab4669e06d62e$export$a1f3f1ef020bdc3a = '\r\n';
const $0c0ab4669e06d62e$export$606cfc2a8896c91f = 'LF';
const $0c0ab4669e06d62e$export$477fea8aa280bb1e = '\n';
const $0c0ab4669e06d62e$export$ccae594c20078277 = {
    CRLF: $0c0ab4669e06d62e$export$ae9ea0d00d3d8982,
    LF: $0c0ab4669e06d62e$export$606cfc2a8896c91f
};
const $0c0ab4669e06d62e$export$c3edd2b21ac02f88 = {
    [$0c0ab4669e06d62e$export$ae9ea0d00d3d8982]: $0c0ab4669e06d62e$export$a1f3f1ef020bdc3a,
    [$0c0ab4669e06d62e$export$606cfc2a8896c91f]: $0c0ab4669e06d62e$export$477fea8aa280bb1e
};
const $0c0ab4669e06d62e$export$895ee510b2e84ade = {
    SECONDLY: 'SECONDLY',
    MINUTELY: 'MINUTELY',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const $0c0ab4669e06d62e$export$d3134eff2123aadb = {
    MO: 'MO',
    TU: 'TU',
    WE: 'WE',
    TH: 'TH',
    FR: 'FR',
    SA: 'SA',
    SU: 'SU'
};
const $0c0ab4669e06d62e$export$f62540a8bebc4ed3 = 'BEGIN';
const $0c0ab4669e06d62e$export$32239d68d9c6cb49 = 'END';
const $0c0ab4669e06d62e$export$67de00e87412dc6f = 'BEGIN:VEVENT';
const $0c0ab4669e06d62e$export$987d86d2e891c4cb = 'END:VEVENT';
const $0c0ab4669e06d62e$export$fd1a0e011a586e26 = 'DTSTART';
const $0c0ab4669e06d62e$export$d86ed937a45b0291 = 'RRULE';
const $0c0ab4669e06d62e$export$913055729e1380b2 = 'SUMMARY';
const $0c0ab4669e06d62e$export$87d0ca22edb7493a = 'LOCATION';
const $0c0ab4669e06d62e$export$d44826c816b5619b = 'DESCRIPTION';
const $0c0ab4669e06d62e$export$c8b4a4d253b84ce0 = 'UID';
const $0c0ab4669e06d62e$export$34694f8d8b23ee2a = 'SEQUENCE';
const $0c0ab4669e06d62e$export$e50006273435e7d4 = 'STATUS';
const $0c0ab4669e06d62e$export$36034111438e3f25 = 'TRANSP';
const $0c0ab4669e06d62e$export$bb34f3538ba26c7e = 'PRIORITY';
const $0c0ab4669e06d62e$export$30dbcad954808285 = 'DTEND';
const $0c0ab4669e06d62e$export$bacc88974c736870 = 'DURATION';
const $0c0ab4669e06d62e$export$da3a32b38cbf59ba = 'ATTACH';
const $0c0ab4669e06d62e$export$5e0bdf8bba8d5088 = 'ATTENDEE';
const $0c0ab4669e06d62e$export$a513ea61a7bee91c = 'CATEGORIES';
const $0c0ab4669e06d62e$export$a29989082612d0d9 = 'COMMENT';
const $0c0ab4669e06d62e$export$11038cc09fdccb91 = 'CONTACT';
const $0c0ab4669e06d62e$export$133ffe3c8efbf133 = 'EXDATE';
const $0c0ab4669e06d62e$export$7e27a94778a9d7d7 = 'EXRULE';
const $0c0ab4669e06d62e$export$3d166b1dacd2503a = 'RDATE';
const $0c0ab4669e06d62e$export$47a1d4cd38dddc05 = 'RELATED-TO';
const $0c0ab4669e06d62e$export$4e841128923ef26 = 'RESOURCES';
const $0c0ab4669e06d62e$export$1c0dd28c42f2741e = 'RECURRENCE-ID';
const $0c0ab4669e06d62e$export$61abde59b50deb8e = 'URL';
const $0c0ab4669e06d62e$export$ff39ebd4bb12b718 = 'CREATED';
const $0c0ab4669e06d62e$export$2ebcefe61501d5fe = 'DTSTAMP';
const $0c0ab4669e06d62e$export$90812500f628da64 = 'LAST-MODIFIED';
const $0c0ab4669e06d62e$export$5409f4c14bda7ac = 'ORGANIZER';
const $0c0ab4669e06d62e$export$9fe99b3b71be9378 = 'REQUEST-STATUS';
const $0c0ab4669e06d62e$export$98eba4d8ff00c139 = {
    BEGIN: $0c0ab4669e06d62e$export$f62540a8bebc4ed3,
    END: $0c0ab4669e06d62e$export$32239d68d9c6cb49,
    BEGIN_VEVENT: $0c0ab4669e06d62e$export$67de00e87412dc6f,
    END_VEVENT: $0c0ab4669e06d62e$export$987d86d2e891c4cb,
    SUMMARY: $0c0ab4669e06d62e$export$913055729e1380b2,
    LOCATION: $0c0ab4669e06d62e$export$87d0ca22edb7493a,
    DESCRIPTION: $0c0ab4669e06d62e$export$d44826c816b5619b,
    UID: $0c0ab4669e06d62e$export$c8b4a4d253b84ce0,
    SEQUENCE: $0c0ab4669e06d62e$export$34694f8d8b23ee2a,
    STATUS: $0c0ab4669e06d62e$export$e50006273435e7d4,
    TRANSP: $0c0ab4669e06d62e$export$36034111438e3f25,
    PRIORITY: $0c0ab4669e06d62e$export$bb34f3538ba26c7e,
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    RRULE: $0c0ab4669e06d62e$export$d86ed937a45b0291,
    DTEND: $0c0ab4669e06d62e$export$30dbcad954808285,
    DURATION: $0c0ab4669e06d62e$export$bacc88974c736870,
    ATTACH: $0c0ab4669e06d62e$export$da3a32b38cbf59ba,
    ATTENDEE: $0c0ab4669e06d62e$export$5e0bdf8bba8d5088,
    CATEGORIES: $0c0ab4669e06d62e$export$a513ea61a7bee91c,
    COMMENT: $0c0ab4669e06d62e$export$a29989082612d0d9,
    CONTACT: $0c0ab4669e06d62e$export$11038cc09fdccb91,
    EXDATE: $0c0ab4669e06d62e$export$133ffe3c8efbf133,
    EXRULE: $0c0ab4669e06d62e$export$7e27a94778a9d7d7,
    RDATE: $0c0ab4669e06d62e$export$3d166b1dacd2503a,
    RELATED_TO: $0c0ab4669e06d62e$export$47a1d4cd38dddc05,
    RESOURCES: $0c0ab4669e06d62e$export$4e841128923ef26,
    RECURRENCE_ID: $0c0ab4669e06d62e$export$1c0dd28c42f2741e,
    URL: $0c0ab4669e06d62e$export$61abde59b50deb8e,
    CREATED: $0c0ab4669e06d62e$export$ff39ebd4bb12b718,
    DTSTAMP: $0c0ab4669e06d62e$export$2ebcefe61501d5fe,
    LAST_MODIFIED: $0c0ab4669e06d62e$export$90812500f628da64,
    ORGANIZER: $0c0ab4669e06d62e$export$5409f4c14bda7ac,
    REQUEST_STATUS: $0c0ab4669e06d62e$export$9fe99b3b71be9378
};
const $0c0ab4669e06d62e$export$38b1323f325ffd22 = {
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    RRULE: $0c0ab4669e06d62e$export$d86ed937a45b0291
};
const $0c0ab4669e06d62e$export$5b9a78912028c06d = 'TZID';
const $0c0ab4669e06d62e$export$20184b745430719e = {
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    TZID: $0c0ab4669e06d62e$export$5b9a78912028c06d
};
const $0c0ab4669e06d62e$export$fb124b4fa837b262 = 'FREQ';
const $0c0ab4669e06d62e$export$4cc4f35131ed029c = 'UNTIL';
const $0c0ab4669e06d62e$export$7dea0e6e08f87a8a = 'INTERVAL';
const $0c0ab4669e06d62e$export$a764ed9c4884f76d = 'BYHOUR';
const $0c0ab4669e06d62e$export$7a96578de7a037b6 = 'BYMINUTE';
const $0c0ab4669e06d62e$export$55bcca3bd8d3041f = 'BYSECOND';
const $0c0ab4669e06d62e$export$f512ea3e90612d03 = 'BYDAY';
const $0c0ab4669e06d62e$export$b3203f635d74ce88 = 'BYMONTH';
const $0c0ab4669e06d62e$export$15623ad945e92c4c = 'BYMONTHDAY';
const $0c0ab4669e06d62e$export$7898bd020dba0a27 = {
    FREQ: $0c0ab4669e06d62e$export$fb124b4fa837b262,
    UNTIL: $0c0ab4669e06d62e$export$4cc4f35131ed029c,
    INTERVAL: $0c0ab4669e06d62e$export$7dea0e6e08f87a8a,
    BYHOUR: $0c0ab4669e06d62e$export$a764ed9c4884f76d,
    BYMINUTE: $0c0ab4669e06d62e$export$7a96578de7a037b6,
    BYSECOND: $0c0ab4669e06d62e$export$55bcca3bd8d3041f,
    BYDAY: $0c0ab4669e06d62e$export$f512ea3e90612d03,
    BYMONTH: $0c0ab4669e06d62e$export$b3203f635d74ce88,
    BYMONTHDAY: $0c0ab4669e06d62e$export$15623ad945e92c4c
};
const $0c0ab4669e06d62e$export$64c81710c321f252 = 'MISSING';
const $0c0ab4669e06d62e$export$ccb33e29d92c9a58 = 'EMPTY';
const $0c0ab4669e06d62e$export$9a105a556e65c2c0 = 'INVALID';
const $0c0ab4669e06d62e$export$f3abe3d006c81602 = 'VALID';

});

parcelRegister("b5IjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $129c4b3b6b9310c5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $129c4b3b6b9310c5$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    formTitle: {
        "id": "recur-work-item.form-title",
        "defaultMessage": "Set to recur"
    },
    saveButtonText: {
        "id": "recur-work-item.save-button-text",
        "defaultMessage": "Save"
    },
    cancelButtonText: {
        "id": "recur-work-item.cancel-button-text",
        "defaultMessage": "Cancel"
    },
    deleteButtonText: {
        "id": "recur-work-item.delete-button-text",
        "defaultMessage": "Delete"
    },
    recurFieldsLabel: {
        "id": "recur-work-item.recur-fields-label",
        "defaultMessage": "Recur"
    },
    setToRecur: {
        "id": "recur-work-item.set-to-recur",
        "defaultMessage": "Set to recur"
    },
    recursDaily: {
        "id": "recur-work-item.recurs-daily",
        "defaultMessage": "Recurs daily"
    },
    recursEveryWeekday: {
        "id": "recur-work-item.recurs-every-weekday",
        "defaultMessage": "Every weekday (Monday to Friday)"
    },
    recursWeekly: {
        "id": "recur-work-item.recurs-weekly",
        "defaultMessage": "Recurs weekly"
    },
    recursEveryTwoWeeks: {
        "id": "recur-work-item.recurs-every-two-weeks",
        "defaultMessage": "Recurs every 2 weeks"
    },
    recursOnComplete: {
        "id": "recur-work-item.recurs-on-complete",
        "defaultMessage": "Recurs when completed"
    },
    successFlagTitleRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "{issueKey} recurs every week"
    },
    successFlagTitleRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-daily",
        "defaultMessage": "This {issueType} recurs daily when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "This {issueType} recurs every weekday when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "This {issueType} recurs weekly on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "This {issueType} recurs every 2 weeks on {weekDayNames} when completed"
    },
    successFlagTitleRecurOnScheduleDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekly",
        "defaultMessage": "{issueKey} recurs every week on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks on {weekDayNames}"
    },
    goBackLabel: {
        "id": "recur-work-item.go-back-label",
        "defaultMessage": "Go back"
    },
    errorFlagReloadPageButton: {
        "id": "recur-work-item.error-flag-reload-page-button",
        "defaultMessage": "Reload page"
    },
    errorFlagDescription: {
        "id": "recur-work-item.error-flag-description",
        "defaultMessage": "If this keeps happening, share this information with your admin, who should <link>contact support</link>."
    },
    errorFlagTitle: {
        "id": "recur-work-item.error-flag-title",
        "defaultMessage": "Something went wrong on our end"
    }
});

});



parcelRegister("2ZEsM", function(module, exports) {

$parcel$export(module.exports, "setAsNonRecurringIssue", () => $215cf24c960383d9$export$7b76980c59e9a391);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gCeeo = parcelRequire("gCeeo");

var $as8tn = parcelRequire("as8tn");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");
const $215cf24c960383d9$export$7b76980c59e9a391 = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, skipDeletingIssueProperties: skipDeletingIssueProperties = false })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { issueProperties: issueProperties, errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        // this can't be !automationRuleUuid because recur-on-complete rules won't have an
        // automationRuleUuid, but they will have issueProperties
        if (!issueProperties) {
            const error = new Error('User is trying to delete a rule before the rule data has been stored.');
            setState({
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (!isSiteAdmin && !isProjectAdmin && !isRuleOwner) {
            const error = new Error('User does not have permission to set issue as non-recurring.');
            setState({
                // TODO: decide if we want to be appending to this list or overwriting it
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId, recurOnScheduleConfig: recurOnScheduleConfig } = issueProperties;
        if (skipDeletingIssueProperties && !ruleUuid) // nothing to do
        return;
        setState({
            isDeletingRule: true
        });
        const analyticsEvent = createAnalyticsEvent({});
        // delete or disable the rule if we know the rule UUID
        if (ruleUuid) try {
            if (isRuleOwner || isSiteAdmin) {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.deleteRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'deleteRule');
                (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'recurringRule deleted', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            } else {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.disableRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'disableRule');
                (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'recurringRule disabled', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            }
        } catch (error) {
            // abort if the rule cannot be deleted/disabled
            setState({
                isDeletingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (skipDeletingIssueProperties) {
            // we only get here if we've successfully deleted/disabled a recur-on-schedule rule.
            // it's not possible to re-enable disabled rules, so we can assume that the rule will
            // no longer generate future work items. this means that the issue's issue properties
            // are no longer important to store.
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE)
            });
            return;
        }
        try {
            await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.deleteIssueProperties)({
                issueKey: issueKey
            }), 'deleteIssueProperties');
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE)
            });
        } catch (error) {
            if (!ruleUuid) {
                // in this case, we haven't deleted or disabled the rule, so the rule can still generate
                // future work items. we leave the rule stored in state unchanged and rethrow the error.
                setState({
                    isDeletingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
                throw error;
            }
            // don't rethrow because from the user's perspective, the work item is no longer recurring.
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
        }
    };

});
parcelRegister("as8tn", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $924bedb187db69de$export$36d128238e6b60f5);
$parcel$export(module.exports, "NO_RULE_PARTIAL_STATE", () => $924bedb187db69de$export$a1b15f9b9ceb0f70);
const $924bedb187db69de$export$36d128238e6b60f5 = {
    hasFetched: false,
    isFetching: false,
    isCreatingRule: false,
    isDeletingRule: false,
    isUpdatingRule: false,
    errors: null,
    hasBootstrapError: false,
    isRuleOwner: null,
    issueProperties: null
};
const $924bedb187db69de$export$a1b15f9b9ceb0f70 = {
    isRuleOwner: null,
    issueProperties: null
};

});


parcelRegister("b7KsF", function(module, exports) {

$parcel$export(module.exports, "setAsRecurringIssue", () => $480578f2ddd18139$export$5d9cc8e9f9314f21);

var $aXKmr = parcelRequire("aXKmr");

var $gCeeo = parcelRequire("gCeeo");

var $bPEVb = parcelRequire("bPEVb");

var $g7LgB = parcelRequire("g7LgB");

var $9riZR = parcelRequire("9riZR");
const $480578f2ddd18139$export$5d9cc8e9f9314f21 = ({ recurOnScheduleConfig: { rRule: rRule, recurCondition: recurCondition, dueDateOffsetSmartValue: dueDateOffsetSmartValue } })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        setState({
            isCreatingRule: true
        });
        const recurrenceToken = (0, $aXKmr.v4)();
        const templateId = (0, $g7LgB.SOFTWARE_END_USER_TEMPLATE_2);
        const analyticsEvent = createAnalyticsEvent({});
        try {
            const createTemplateResponse = await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $bPEVb.createTemplate)({
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                recurrenceToken: recurrenceToken,
                recurCondition: recurCondition,
                rRule: rRule,
                dueDateOffsetSmartValue: dueDateOffsetSmartValue
            }), 'createTemplate');
            if (createTemplateResponse?.ruleUuid) {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $bPEVb.setIssueProperties)({
                    issueKey: issueKey,
                    recurrenceToken: recurrenceToken,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    recurCondition: recurCondition,
                    rRule: rRule,
                    templateId: templateId,
                    dueDateOffsetSmartValue: dueDateOffsetSmartValue
                }), 'setIssueProperties');
                (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'recurringRule created', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    templateId: templateId,
                    recurCondition: recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
                const issueProperties = {
                    automationRuleUuid: createTemplateResponse.ruleUuid,
                    token: recurrenceToken,
                    templateId: templateId,
                    recurOnScheduleConfig: {
                        rRule: rRule,
                        dueDateOffsetSmartValue: dueDateOffsetSmartValue,
                        recurCondition: recurCondition
                    }
                };
                setState({
                    isCreatingRule: false,
                    issueProperties: issueProperties,
                    isRuleOwner: true
                });
            } else throw new Error('New rule failed to be created.');
        } catch (error) {
            setState({
                isCreatingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
    };

});
parcelRegister("bPEVb", function(module, exports) {

$parcel$export(module.exports, "createTemplate", () => $688cd7c66c97ef2e$export$7b7ae612b60e1630);
$parcel$export(module.exports, "setIssueProperties", () => $688cd7c66c97ef2e$export$5153917efea4a83d);

var $3osLr = parcelRequire("3osLr");

var $jbPE2 = parcelRequire("jbPE2");

var $jGzN3 = parcelRequire("jGzN3");

var $g7LgB = parcelRequire("g7LgB");
const $688cd7c66c97ef2e$export$7b7ae612b60e1630 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const CREATE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/public/rest/v1/template/create`;
    const ruleHomeARI = (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    });
    const payload = {
        ruleHome: ruleHomeARI,
        templateId: (0, $g7LgB.SOFTWARE_END_USER_TEMPLATE_2),
        parameters: {
            recurrenceToken: {
                value: recurrenceToken,
                type: 'TEXT'
            },
            rRule: {
                value: rRule,
                type: 'TEXT'
            },
            dueDateOffsetSmartValue: {
                value: dueDateOffsetSmartValue,
                type: 'TEXT'
            },
            recurCondition: {
                value: recurCondition,
                type: 'TEXT'
            }
        }
    };
    return (0, $jGzN3.performPostRequest)(CREATE_TEMPLATE_URL, {
        body: JSON.stringify(payload)
    });
};
const $688cd7c66c97ef2e$export$5153917efea4a83d = async ({ issueKey: issueKey, ruleUuid: ruleUuid, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, templateId: templateId, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const issuePropertiesEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    const requestBody = {
        automationRuleUuid: ruleUuid,
        token: recurrenceToken,
        templateId: templateId,
        recurOnScheduleConfig: {
            rRule: rRule,
            dueDateOffsetSmartValue: dueDateOffsetSmartValue,
            recurCondition: recurCondition
        }
    };
    return (0, $jGzN3.performPutRequest)(issuePropertiesEndpoint, {
        body: JSON.stringify(requestBody)
    });
};

});


parcelRegister("f0czN", function(module, exports) {

$parcel$export(module.exports, "updateRule", () => $d769bcc7f9751998$export$b2ebf395d72c5a4c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gCeeo = parcelRequire("gCeeo");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");

var $b7KsF = parcelRequire("b7KsF");

var $2ZEsM = parcelRequire("2ZEsM");
const $d769bcc7f9751998$export$b2ebf395d72c5a4c = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, recurOnScheduleConfig: recurOnScheduleConfig })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey })=>{
        const { issueProperties: issueProperties, errors: errors } = getState();
        if (!issueProperties) {
            // if there is no existing rule, then create a new rule and update issue properties
            await dispatch((0, $b7KsF.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            return;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId } = issueProperties;
        setState({
            isUpdatingRule: true
        });
        try {
            await dispatch((0, $2ZEsM.setAsNonRecurringIssue)({
                isProjectAdmin: isProjectAdmin,
                isRuleOwner: isRuleOwner,
                isSiteAdmin: isSiteAdmin,
                // we'll update issue properties later
                skipDeletingIssueProperties: true
            }));
        } catch (error) {
            // don't need to save the error to state because setAsNonRecurringIssue should already do this
            setState({
                isUpdatingRule: false
            });
            throw error;
        }
        // create the new rule
        try {
            await dispatch((0, $b7KsF.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'recurringRule updated', {
                issueKey: // TODO: add ruleId attribute
                issueKey,
                ruleUuid: ruleUuid,
                templateId: templateId,
                recurCondition: recurOnScheduleConfig?.recurCondition,
                isUpdateForExistingRule: true
            });
            setState({
                isUpdatingRule: false
            });
        } catch (error) {
            // if we fail to create the rule and update issue properties, then we need to go back and remove the
            // original recurring rule config from issue properties
            try {
                setState({
                    isDeletingRule: true
                });
                await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $f3jI4.deleteIssueProperties)({
                    issueKey: issueKey
                }), 'deleteIssueProperties');
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    issueProperties: null,
                    isRuleOwner: null,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
            } catch (anotherError) {
                // we've made no changes to the rule config since we called `setAsNonRecurringIssue` above,
                // so we don't need to update ruleSummary or issueProperties.
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error,
                        anotherError
                    ]
                });
                throw anotherError;
            }
            // we've just successfully deleted the existing rule; we haven't actually created a new one.
            throw error;
        }
    };

});



parcelRegister("kPKM4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a82ad686544dfbb0$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a82ad686544dfbb0$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    overdue: {
        "id": "business.list.ui.list-view.date-cell.overdue",
        "defaultMessage": "Overdue since {date}"
    },
    due: {
        "id": "business.list.ui.list-view.date-cell.due",
        "defaultMessage": "Due on {date}"
    }
});

});


parcelRegister("dVT0O", function(module, exports) {

$parcel$export(module.exports, "DateWithUrgencyIndicator", () => $89428acd7cb12298$export$31bba0fc7d099434);

var $eJOHy = parcelRequire("eJOHy");

var $i5stJ = parcelRequire("i5stJ");

var $d8UFE = parcelRequire("d8UFE");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $3NHJr = parcelRequire("3NHJr");

var $g2hxj = parcelRequire("g2hxj");

var $6XJko = parcelRequire("6XJko");

var $2cNSz = parcelRequire("2cNSz");
const $89428acd7cb12298$export$31bba0fc7d099434 = ({ value: value, formattedDateString: formattedDateString })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { formatDateOnly: formatDateOnly } = (0, $3NHJr.useDateTimeFormatter)();
    const daysBetweenTodayAndValue = (0, $eJOHy.useMemo)(()=>(0, $g2hxj.getNoOfDaysSinceUTCDateString)(value), [
        value
    ]);
    const formattedDate = (0, $eJOHy.useMemo)(()=>formattedDateString || formatDateOnly(value), [
        formattedDateString,
        formatDateOnly,
        value
    ]);
    const dueMessage = daysBetweenTodayAndValue === 0 ? formatMessage((0, $2cNSz.default).dueToday) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $2cNSz.default).dueIn,
        values: {
            daysBetween: daysBetweenTodayAndValue
        }
    });
    const isDatePast = daysBetweenTodayAndValue != null && daysBetweenTodayAndValue >= 0;
    const Icon = daysBetweenTodayAndValue === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))) : (0, (/*@__PURE__*/$parcel$interopDefault($d8UFE)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        testId: "date-with-urgency-indicator.container",
        gap: "space.075"
    }, (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $89428acd7cb12298$var$baseStyles,
            isDatePast ? $89428acd7cb12298$var$redBackgroundStyle : false
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: isDatePast ? 'color.text.accent.red' : 'color.text.accent.gray.bolder'
    }, formattedDate)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $89428acd7cb12298$var$baseStyles,
            isDatePast ? $89428acd7cb12298$var$redBackgroundStyle : $89428acd7cb12298$var$greyBackgroundStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: isDatePast ? 'color.text.accent.red' : 'color.text.accent.gray.bolder'
    }, formattedDate)), isDatePast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: dueMessage,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        LEGACY_size: "medium",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: "date-with-urgency-indicator.warning-icon"
    })));
};
const $89428acd7cb12298$var$baseStyles = (0, $1DXK0.xcss)({
    padding: 'space.025',
    borderRadius: 'border.radius.100'
});
const $89428acd7cb12298$var$redBackgroundStyle = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.accent.red.subtlest',
    ':hover': {
        backgroundColor: 'color.background.accent.red.subtlest.hovered'
    },
    minWidth: '92px'
});
const $89428acd7cb12298$var$greyBackgroundStyle = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    ':hover': {
        backgroundColor: 'color.background.accent.gray.subtlest.hovered'
    },
    minWidth: '92px'
});

});
parcelRegister("3NHJr", function(module, exports) {

$parcel$export(module.exports, "useDateTimeFormatter", () => $c04f3d2981f71a59$export$163f492669f74d5b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $3MbOI = parcelRequire("3MbOI");

var $2cfd4 = parcelRequire("2cfd4");

var $gKm6m = parcelRequire("gKm6m");

var $iw2hI = parcelRequire("iw2hI");
const $c04f3d2981f71a59$export$163f492669f74d5b = (overrideTimeZone)=>{
    (0, $gRw8I.di)(Intl);
    const { data: { // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    user: { timeZone: timeZonePreference } } } = (0, $3MbOI.useCurrentUser)();
    const timeZone = overrideTimeZone ?? timeZonePreference;
    const jiraLocal = (0, $2cfd4.useLocale)();
    const standardizedLocale = (0, $iw2hI.standardizeLocale)(jiraLocal);
    const verifiedTimeZone = (0, $iw2hI.verifyTimeZone)(timeZone);
    const dateTimeFormatter = (0, $eJOHy.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $gKm6m.longDateTimeFormat),
            timeZone: verifiedTimeZone
        }), [
        standardizedLocale,
        verifiedTimeZone
    ]);
    const dateOnlyFormatter = (0, $eJOHy.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $gKm6m.longDateOnlyFormat),
            timeZone: 'UTC'
        }), [
        standardizedLocale
    ]);
    const formatDateTime = (0, $eJOHy.useCallback)((date)=>{
        const rawValue = typeof date === 'string' ? new Date(date) : date;
        return dateTimeFormatter.format(rawValue);
    }, [
        dateTimeFormatter
    ]);
    const formatDateOnly = (0, $eJOHy.useCallback)((date)=>dateOnlyFormatter.format(new Date(date)), [
        dateOnlyFormatter
    ]);
    return {
        formatDateTime: /**
		 * Returns the long form of a date value with respect to the user's locale and timezone preferences
		 *
		 * @param {string|number|date} date Value as either an [ISO8601 string](https://www.w3.org/TR/NOTE-datetime) (eg `"1997-07-16T19:20:30.45+01:00"`), epoch number (eg `1615431020`), or vanilla `Date` object
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021, 1:11 PM
		 * formatDateTime(1611281490857) // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日 午後1:11
		 * formatDateTime(1611281490857) // where user locale is "ja-JP"
		 * ```
		 */ formatDateTime,
        formatDateOnly: /**
		 * Returns the long form of a date without time value with respect to the user's locale. Timezones do not apply to these dates.
		 *
		 * @param {string} date Value as a 'YYYY-MM-DD' string (eg `"1997-07-16"`)
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021
		 * formatDateOnly('2021-01-22') // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日
		 * formatDateOnly('2021-01-22') // where user locale is "ja-JP"
		 * ```
		 */ formatDateOnly
    };
};

});
parcelRegister("gKm6m", function(module, exports) {

$parcel$export(module.exports, "longDateTimeFormat", () => $3c5abb5b9eb6dd5e$export$f2f390060309965);
$parcel$export(module.exports, "longDateOnlyFormat", () => $3c5abb5b9eb6dd5e$export$51f819d50bcd4ae1);
/**
 * If this file gets changed, please update platform/packages/proforma/proforma-common-core/src/form-system/components/questions/common/defaultDateTimeFormats.tsx or let the owners know via #jsm-request-intake.
 *
 * Proforma wants to stay consistent with Jira date and time format options.
 *
 * Later on Proforma will introduce React Context to pass config props, and this will be removed.
 */ /**
 * Long format of a date time, eg "Jun 16, 1971, 2:34 AM" with 12h/24h formatting resolved from locale
 */ const $3c5abb5b9eb6dd5e$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $3c5abb5b9eb6dd5e$export$51f819d50bcd4ae1 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
};

});

parcelRegister("iw2hI", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $07e147bc3d7cc59d$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $07e147bc3d7cc59d$export$93ff13646da25bd);

var $4qiFT = parcelRequire("4qiFT");

var $eSnSE = parcelRequire("eSnSE");
const $07e147bc3d7cc59d$export$95b7602913551865 = 'en-US';
const $07e147bc3d7cc59d$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$07e147bc3d7cc59d$export$95b7602913551865}.`);
        return $07e147bc3d7cc59d$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $4qiFT.default).includes(jiraLocale)) (0, $eSnSE.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $07e147bc3d7cc59d$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($07e147bc3d7cc59d$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});


parcelRegister("g2hxj", function(module, exports) {

$parcel$export(module.exports, "getIsUTCDatePastOrDueSoon", () => $1429be59672d5cc8$export$3d094644d6bd82b9);
$parcel$export(module.exports, "getNoOfDaysSinceUTCDateString", () => $1429be59672d5cc8$export$7f4e2d0c87567b43);

var $fSCkM = parcelRequire("fSCkM");
/**
 * Normalizes a given date by removing the time component.
 *
 * @param {Date} date - The date to be normalized.
 * @returns {Date} - The normalized date without the time component.
 */ const $1429be59672d5cc8$var$normalizeDate = (date)=>new Date(date.getFullYear(), date.getMonth(), date.getDate());
/**
 * Adds a specified number of days to a given date.
 *
 * @param date - The date to which the days should be added.
 * @param days - The number of days to add.
 * @returns The new date after adding the specified number of days.
 */ const $1429be59672d5cc8$var$datePlusXDays = (date, days)=>$1429be59672d5cc8$var$normalizeDate(new Date(date.getTime() + days * 86400000));
const $1429be59672d5cc8$export$9417a5d0968b488e = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const date = $1429be59672d5cc8$var$normalizeDate(new Date(dateString));
    if (Number.isNaN(date.getTime())) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const TODAY = $1429be59672d5cc8$var$normalizeDate(new Date());
    const TODAY_PLUS_DUE_DAYS_OFFSET = $1429be59672d5cc8$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = date.getTime() === TODAY.getTime() || date < TODAY;
    const isDueSoon = !isDueDatePast && date < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $1429be59672d5cc8$export$3d094644d6bd82b9 = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    let inputDateInISO;
    try {
        inputDateInISO = (0, $fSCkM.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return {
            isDueDatePast: false,
            isDueSoon: false
        };
    }
    const TODAY = (0, $fSCkM.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const TODAY_PLUS_DUE_DAYS_OFFSET = $1429be59672d5cc8$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = inputDateInISO.getTime() === TODAY.getTime() || inputDateInISO < TODAY;
    const isDueSoon = !isDueDatePast && inputDateInISO < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $1429be59672d5cc8$export$7f4e2d0c87567b43 = (dateString)=>{
    if (!dateString) return null;
    let inputDateInISO;
    try {
        inputDateInISO = (0, $fSCkM.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return null;
    }
    const TODAY = (0, $fSCkM.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const daysBetween = Math.floor((TODAY.getTime() - inputDateInISO.getTime()) / 86400000);
    return daysBetween;
};

});
parcelRegister("fSCkM", function(module, exports) {

$parcel$export(module.exports, "DateOnly", () => $f890d9b837113be1$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $f890d9b837113be1$export$b0961ad8aee63b8b);
const $f890d9b837113be1$export$9cda9b56d134780f = 'Invalid date or date format';
const $f890d9b837113be1$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $f890d9b837113be1$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $f890d9b837113be1$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $f890d9b837113be1$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $f890d9b837113be1$var$isLeapYear(year) ? 29 : $f890d9b837113be1$var$daysInMonth[month - 1])) return false;
    return true;
};
const $f890d9b837113be1$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $f890d9b837113be1$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $f890d9b837113be1$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $f890d9b837113be1$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $f890d9b837113be1$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($f890d9b837113be1$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $f890d9b837113be1$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $f890d9b837113be1$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $f890d9b837113be1$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$f890d9b837113be1$var$isDateValid(year, month, day)) throw new Error($f890d9b837113be1$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $f890d9b837113be1$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $f890d9b837113be1$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $f890d9b837113be1$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $f890d9b837113be1$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});


parcelRegister("2cNSz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9601b7655c62666f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9601b7655c62666f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    dueToday: {
        "id": "date-with-urgency-indicator.due-today",
        "defaultMessage": "Due today"
    },
    dueIn: {
        "id": "date-with-urgency-indicator.due-in",
        "defaultMessage": "{daysBetween} {daysBetween, plural, one {day} other {days}} overdue"
    }
});

});


parcelRegister("7y0HS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d326cc713d411d8c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d326cc713d411d8c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-date-readview-full.date.no-value-text-experiment",
        "defaultMessage": "Add date"
    },
    noValueTextExperimentDueDate: {
        "id": "issue-field-date-readview-full.date.no-value-text-experiment-due-date",
        "defaultMessage": "Add due date"
    }
});

});


parcelRegister("k745d", function(module, exports) {

$parcel$export(module.exports, "useDateValidator", () => $8853f60cb6101294$export$bb028423d75e7237);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cwGo1 = parcelRequire("cwGo1");
const $8853f60cb6101294$export$bb028423d75e7237 = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && (!value || value.trim().length === 0)) return {
            type: 'error',
            message: formatMessage((0, $cwGo1.messages).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("cwGo1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a28e04ebf5c72bb6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a28e04ebf5c72bb6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-field-date-inline-edit-full.date.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});

});




parcelRegister("jGEbG", function(module, exports) {

$parcel$export(module.exports, "DateTimeCell", () => $ec8d64f9d2693d1b$export$372b87ceae2922a4);

var $3VkcD = parcelRequire("3VkcD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $aIRHL = parcelRequire("aIRHL");

var $j8Km1 = parcelRequire("j8Km1");

var $7jTnu = parcelRequire("7jTnu");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $ec8d64f9d2693d1b$export$372b87ceae2922a4 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $3VkcD.default), fieldRef);
    const isCreatedOrUpdated = data.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).CREATED || data.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).UPDATED;
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = !isCreatedOrUpdated && isInlineEditingExtendedFieldSupportEnabled;
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    // We can also disable editability of the created/updated fields as they are never editable.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIRHL.DateTimeInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: isFirstField ? $ec8d64f9d2693d1b$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isAutoFocusFixEnabled: true,
        shouldRenderHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIRHL.DateTimeInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isAutoFocusFixEnabled: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $ec8d64f9d2693d1b$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ec8d64f9d2693d1b$var$customTargetStyles,
        ref: ref
    });
});
const $ec8d64f9d2693d1b$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("3VkcD", function(module, exports) {

$parcel$export(module.exports, "default", () => $db807f22383cf26c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f40040f20e49a676e75cea1191e3dde3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $db807f22383cf26c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "dateTime_nativeIssueTable_DateTimeCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$db807f22383cf26c$var$node.hash = "b976a3c6a5f97459d63599a3152d13cd";
var $db807f22383cf26c$export$2e2bcd8739ae039 = $db807f22383cf26c$var$node;

});

parcelRegister("aIRHL", function(module, exports) {

$parcel$export(module.exports, "DateTimeInlineEditViewWithIsEditable", () => $03d97e1e763124f7$export$40278230a655efcf);
$parcel$export(module.exports, "DateTimeInlineEditView", () => $03d97e1e763124f7$export$2044e876297ff5d7);

var $jR5RG = parcelRequire("jR5RG");

var $47Hfw = parcelRequire("47Hfw");

var $j91Br = parcelRequire("j91Br");

var $jSXSj = parcelRequire("jSXSj");

var $31TE2 = parcelRequire("31TE2");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $57raR = parcelRequire("57raR");

var $5EMLi = parcelRequire("5EMLi");

var $16sa1 = parcelRequire("16sa1");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $f5dwt = parcelRequire("f5dwt");

var $h47gY = parcelRequire("h47gY");

var $epTsa = parcelRequire("epTsa");

var $3x6NA = parcelRequire("3x6NA");

var $ejuPL = parcelRequire("ejuPL");

var $gQeix = parcelRequire("gQeix");

var $b3Emp = parcelRequire("b3Emp");

var $auNLL = parcelRequire("auNLL");

var $2cfd4 = parcelRequire("2cfd4");

var $iw2hI = parcelRequire("iw2hI");

var $7iVmZ = parcelRequire("7iVmZ");

var $daGbj = parcelRequire("daGbj");

var $8c3Yt = parcelRequire("8c3Yt");

var $6XJko = parcelRequire("6XJko");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $bJscI = parcelRequire("bJscI");

var $gYnSx = parcelRequire("gYnSx");

var $3wIGE = parcelRequire("3wIGE");

var $c6Qqm = parcelRequire("c6Qqm");
const $03d97e1e763124f7$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-date-time-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $03d97e1e763124f7$export$7525482b5931e326 = 'dateTimeFieldInlineEdit'; /**
                                                          * DateTimeInlineEditView Component will handle the switching behaviour between the 'readView' and 'editView' components
                                                          * @param props {@link DateTimeInlineEditView}
                                                          *
                                                          * we also want to finalise if we need areActionButtonsHidden here or not
                                                          * */ 
const $03d97e1e763124f7$var$DateTimeInlineEditViewOld = ({ fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, timeZone: timeZone })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $31TE2.default), fragmentRef);
    const { id: uniqueFieldId, fieldConfig: fieldConfig, dateTime: dateTime } = data;
    const [commit] = (0, $j4oe4.useMutation)((0, $jSXSj.default)); // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isEditing, setIsEditing] = (0, $8c3Yt.useOptionallyControlledEditingState)(startWithEditViewOpen, uniqueFieldId);
    const [newValue, setNewValue] = (0, $eJOHy.useState)(dateTime ?? null);
    const [newTimeValue, setNewTimeValue] = (0, $eJOHy.useState)(null);
    const [newDateValue, setNewDateValue] = (0, $eJOHy.useState)(null);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const locale = (0, $2cfd4.useLocale)();
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(fieldConfig?.isEditable || false), [
        fieldConfig?.isEditable,
        overriding
    ]); // #endregion
    // #region Handle new value
    const onEditRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        setError(null);
        setIsEditing(true);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
    }, [
        setError,
        setIsEditing
    ]);
    const handleErrors = (0, $eJOHy.useCallback)((incomingError)=>{
        setError(incomingError);
        setIsEditing(true);
        setNewValue(dateTime ?? null);
    }, [
        setError,
        setIsEditing,
        setNewValue,
        dateTime
    ]);
    const onCancelRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        if (analyticsEvent && analyticsEvent instanceof KeyboardEvent && 'stopPropagation' in analyticsEvent && (0, $epTsa.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true)) {
            analyticsEvent.stopPropagation();
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'canceled',
                actionSubject: 'dateTimeFieldInlineEdit'
            }));
        } else if ((0, $5EMLi.isUIAnalyticsEvent)(analyticsEvent)) (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        setError(null);
        setIsEditing(false);
    }, [
        setError,
        setIsEditing,
        createAnalyticsEvent
    ]);
    const handleNewValue = (0, $eJOHy.useCallback)((newDateTime)=>{
        onSubmit?.(newDateTime);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        datetime: newDateTime ?? null,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateDateTimeField) {
                    const { success: success, errors: responseErrors } = mutationData.jira?.updateDateTimeField;
                    if (success) {
                        onSubmitSucceeded?.(newDateTime);
                        return;
                    }
                    onSubmitFailed?.();
                    if (responseErrors != null && responseErrors.length > 0) handleErrors(new Error(responseErrors[0].message != null ? responseErrors[0].message : undefined));
                }
            },
            onError (incomingError) {
                handleErrors(incomingError);
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateDateTimeField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            dateTime: newDateTime
                        }
                    }
                }
            }
        });
        setIsEditing(false);
    }, [
        commit,
        handleErrors,
        onSubmit,
        onSubmitFailed,
        onSubmitSucceeded,
        setIsEditing,
        uniqueFieldId
    ]);
    const onConfirm = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        if ((0, $epTsa.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true)) {
            if (!newValue && (newDateValue || newTimeValue)) {
                const constructedValue = (0, $3wIGE.constructDateTimeFromPartialData)(newDateValue, newTimeValue);
                setNewValue(constructedValue);
                const date = new Date(constructedValue);
                setNewDateValue((0, $57raR.default)(date, 'yyyy-MM-dd'));
                setNewTimeValue((0, $57raR.default)(date, 'HH:mm'));
                handleNewValue(constructedValue);
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
            } else {
                handleNewValue(newValue);
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
            }
        } else {
            handleNewValue(newValue);
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        }
    }, [
        newValue,
        newDateValue,
        newTimeValue,
        handleNewValue
    ]);
    const onChange = (0, $eJOHy.useCallback)((value)=>{
        if ((0, $epTsa.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true)) {
            if (!value) {
                handleNewValue(value);
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'confirmed',
                    actionSubject: 'dateTimeFieldInlineEdit'
                }));
            }
        }
        setError(null);
        setNewValue(value);
    }, [
        setNewValue,
        handleNewValue,
        createAnalyticsEvent
    ]);
    const onDateChange = (newDate)=>{
        setNewDateValue(newDate);
    };
    const onTimeChange = (newTime)=>{
        setNewTimeValue(newTime);
    };
    const timePlaceholder = (0, $eJOHy.useMemo)(()=>{
        const standardizedLocale = (0, $iw2hI.standardizeLocale)(locale);
        return (0, $3wIGE.getNext30MinuteInterval)(undefined, standardizedLocale);
    }, [
        locale
    ]);
    const datePlaceholder = (0, $eJOHy.useMemo)(()=>{
        let formattedDate = '';
        try {
            formattedDate = (0, $3wIGE.getFormattedDate)(locale);
        } catch (dateFormatError) {
            (0, $gYnSx.default)({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: dateFormatError,
                meta: {
                    packageName: 'dateTimeFieldInlineEdit',
                    id: 'formatDateError'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return formattedDate;
    }, [
        locale
    ]); // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iVmZ.ReadViewContainer), {
            "data-testid": "issue-field-date-time-inline-edit-full.ui.date-time.read-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03d97e1e763124f7$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3Emp.DateTimeReadView), {
            fragmentRef: data,
            timeZone: timeZone
        }))); // #endregion
    // #region Edit view
    const renderEditView = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03d97e1e763124f7$var$EditViewContainer, {
            "data-testid": "issue-field-date-time-inline-edit-full.ui.date-time.edit-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ejuPL.DateTimeEditView), {
            ...(0, $epTsa.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? {
                autoFocus: true,
                defaultIsOpen: true,
                spacing: 'compact',
                datePlaceholder: datePlaceholder,
                timePlaceholder: timePlaceholder,
                onDateChange: onDateChange,
                onTimeChange: onTimeChange
            } : {},
            value: newValue,
            onChange: onChange,
            timeZone: timeZone
        })));
    }; // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "Field(DateTime)",
        prefixOverride: "issue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
        onEscape: onCancelRequest
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3x6NA.ErrorFlag), {
        description: (0, $c6Qqm.default).errorMessage,
        error: error,
        title: (0, $c6Qqm.default).errorTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iVmZ.InlineEditContainer), {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $daGbj.FieldInlineEditStateLess), {
        testId: "issue-field-date-time-inline-edit-full.ui.date-time.field-date-time",
        fieldId: uniqueFieldId,
        isEditing: isEditing,
        areActionButtonsHidden: true,
        actionSubject: $03d97e1e763124f7$export$7525482b5931e326,
        isEditable: isFieldEditable,
        readView: renderReadView,
        editView: renderEditView,
        onCancel: onCancelRequest,
        onConfirm: onConfirm,
        onEdit: onEditRequest,
        defaultValue: null
    }))));
};
const $03d97e1e763124f7$export$40278230a655efcf = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, timeZone: timeZone, isAutoFocusFixEnabled: isAutoFocusFixEnabled, readViewDateOnlyFormat: readViewDateOnlyFormat, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $j91Br.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, name: fieldName, type: type, dateTime: dateTime } = data;
    const [commit] = (0, $j4oe4.useMutation)((0, $47Hfw.default)); // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const locale = (0, $2cfd4.useLocale)();
    const initialValue = dateTime ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(isEditable), [
        isEditable,
        overriding
    ]); // #endregion
    // #region Handle new value
    const handleSubmit = (0, $eJOHy.useCallback)((newDateTime, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newDateTime);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        datetime: newDateTime ?? null,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateDateTimeField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateDateTimeField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            dateTime: newDateTime
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        clipboardComponentType: 'dateTime'
    }); // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03d97e1e763124f7$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3Emp.DateTimeReadView), {
            fragmentRef: data,
            timeZone: timeZone,
            isDateOnlyFormat: readViewDateOnlyFormat,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        timeZone,
        readViewDateOnlyFormat,
        shouldRenderHoverPopover
    ]); // #endregion
    // #region Edit view
    const timePlaceholder = (0, $eJOHy.useMemo)(()=>{
        const standardizedLocale = (0, $iw2hI.standardizeLocale)(locale);
        return (0, $3wIGE.getNext30MinuteInterval)(undefined, standardizedLocale);
    }, [
        locale
    ]);
    const datePlaceholder = (0, $eJOHy.useMemo)(()=>{
        let formattedDate = '';
        try {
            formattedDate = (0, $3wIGE.getFormattedDate)(locale);
        } catch (dateFormatError) {
            (0, $gYnSx.default)({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: dateFormatError,
                meta: {
                    packageName: 'dateTimeFieldInlineEdit',
                    id: 'formatDateError'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return formattedDate;
    }, [
        locale
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: isAutoFocusFixEnabled,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            timeZone: timeZone,
            ...(0, $epTsa.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? {
                autoFocus: true,
                spacing: spacing,
                datePlaceholder: datePlaceholder,
                timePlaceholder: timePlaceholder
            } : {}
        }); // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPoint: (0, $gQeix.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $03d97e1e763124f7$export$3babe8d01dc38aca = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $jR5RG.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03d97e1e763124f7$export$40278230a655efcf, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $03d97e1e763124f7$export$2044e876297ff5d7 = (0, $bJscI.componentWithFG)('jsc_inline_editing_field_refactor', $03d97e1e763124f7$export$3babe8d01dc38aca, $03d97e1e763124f7$var$DateTimeInlineEditViewOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03d97e1e763124f7$var$EditViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm",
            (0, $6XJko.isVisualRefreshEnabled)() ? "_1pby1kze" : "_1pbyowjs",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jR5RG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba321c81e4a9cee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ff168d0c48feb770d902c19b185aa605>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ba321c81e4a9cee$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewNew_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraDateTimePickerField"
};
$6ba321c81e4a9cee$var$node.hash = "eeb23ad7c37c54cf808653965b7bf769";
var $6ba321c81e4a9cee$export$2e2bcd8739ae039 = $6ba321c81e4a9cee$var$node;

});

parcelRegister("47Hfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $449421f6ccdf1783$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35b0d1b8dda4ba883b598557010413d2>>
 * @relayHash b962bde817ae9133f076383673744639
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52b99b4d5da7ae41fc7cea0050d5a473435a64cac29f4d8502862f446fbffbc0
const $449421f6ccdf1783$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "dateTime"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "52b99b4d5da7ae41fc7cea0050d5a473435a64cac29f4d8502862f446fbffbc0",
            "metadata": {},
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$449421f6ccdf1783$var$node.hash = "e0c0e1ca810b79fb98a05142a47ace9e";
var $449421f6ccdf1783$export$2e2bcd8739ae039 = $449421f6ccdf1783$var$node;

});

parcelRegister("j91Br", function(module, exports) {

$parcel$export(module.exports, "default", () => $26e6d5fe67544e2a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf046c3fc1d1cb9d3c8a8b0339c689f5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $26e6d5fe67544e2a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$26e6d5fe67544e2a$var$node.hash = "e7911508d34079b211453d8cdb4bbc3d";
var $26e6d5fe67544e2a$export$2e2bcd8739ae039 = $26e6d5fe67544e2a$var$node;

});

parcelRegister("jSXSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $840de917c3036798$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf44c1d99ad8ee8656c194a9a3f356f4>>
 * @relayHash 1b42d3ae71d08906518143d93b5393d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2c4a5297dcf7456a85d37e509ecffb6458d390684805ae3fdc6ac19dec04468f
const $840de917c3036798$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "dateTime"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dateTime_issueFieldDateTime_DateTimeFieldOld_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dateTime_issueFieldDateTime_DateTimeFieldOld_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2c4a5297dcf7456a85d37e509ecffb6458d390684805ae3fdc6ac19dec04468f",
            "metadata": {},
            "name": "dateTime_issueFieldDateTime_DateTimeFieldOld_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$840de917c3036798$var$node.hash = "7520fca6dd1c12ddc4a3f71f7cea7484";
var $840de917c3036798$export$2e2bcd8739ae039 = $840de917c3036798$var$node;

});

parcelRegister("31TE2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3d84fa1a326e7e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3c9fa4cc29432746d5c47ff473bcc9f9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f3d84fa1a326e7e0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewOld_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "dateTime"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraDateTimePickerField"
};
$f3d84fa1a326e7e0$var$node.hash = "524086c2c1d813c84e1e36bbc0676a40";
var $f3d84fa1a326e7e0$export$2e2bcd8739ae039 = $f3d84fa1a326e7e0$var$node;

});

parcelRegister("3x6NA", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $c2ff2855b752b258$export$518ba8e0e60f145f);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $1uIew = parcelRequire("1uIew");

var $29pUO = parcelRequire("29pUO");
const $c2ff2855b752b258$export$518ba8e0e60f145f = ({ error: error, title: title, description: description })=>{
    if (!error) return null;
    if (error instanceof (0, $1uIew.ValidationError)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessage = error.message || error.errors && error.errors[0] && error.errors[0].error || description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $29pUO.FlagRenderer), {
            flag: {
                messageId: 'issue-error-flag.flag.warning.issue.fields.components.error-flag.flag.warning',
                messageType: 'transactional',
                type: 'warning',
                title: title,
                description: errorMessage,
                testId: (0, $7jTnu.fg)('relay-migration-issue-fields-number') ? 'issue-error-flag.error-flag.warning' : undefined
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $29pUO.FlagRenderer), {
        flag: {
            messageId: 'issue-error-flag.flag.error.issue.fields.components.error-flag.flag.error',
            messageType: 'transactional',
            type: 'error',
            title: title,
            description: description,
            testId: (0, $7jTnu.fg)('relay-migration-issue-fields-number') ? 'issue-error-flag.error-flag.error' : undefined
        }
    });
};

});
parcelRegister("29pUO", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $e514b6f1790a69a0$export$7c38ebd1f7ca6a5a);

var $1EfkQ = parcelRequire("1EfkQ");

var $bdG9p = parcelRequire("bdG9p");
const $e514b6f1790a69a0$export$7c38ebd1f7ca6a5a = (0, $bdG9p.default)((0, $1EfkQ.default));

});
parcelRegister("1EfkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6685770d7ee2653a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $90d5q = parcelRequire("90d5q");
class $6685770d7ee2653a$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $90d5q.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});



parcelRegister("ejuPL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "DEFAULT_WEEK_START_DAY", () => $51cfd76395ea9907$export$845e1054649a85c2);
$parcel$export(module.exports, "DateTimeEditView", () => $51cfd76395ea9907$export$22b93d77c10368c8);
$parcel$export(module.exports, "default", () => $51cfd76395ea9907$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $g0bBb = parcelRequire("g0bBb");

var $kkMDK = parcelRequire("kkMDK");

var $igoRN = parcelRequire("igoRN");

var $8IU7V = parcelRequire("8IU7V");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $iw2hI = parcelRequire("iw2hI");

var $3MbOI = parcelRequire("3MbOI");

var $dO9h7 = parcelRequire("dO9h7");

var $2cfd4 = parcelRequire("2cfd4");

var $l5gZd = parcelRequire("l5gZd");
const $51cfd76395ea9907$export$845e1054649a85c2 = 0; // Sunday
const $51cfd76395ea9907$export$22b93d77c10368c8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ autoFocus: autoFocus, isDisabled: isDisabled, isInvalid: isInvalid, timeZone: timeZone, value: value, onChange: onChange, datePlaceholder: datePlaceholder, timePlaceholder: timePlaceholder, onDatePickerKeyDown: onDatePickerKeyDown, defaultIsOpen: defaultIsOpen, spacing: spacing, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onDateChange: onDateChange, onTimeChange: onTimeChange }, ref)=>{
    const locale = (0, $2cfd4.useLocale)();
    const { data: { user: user } } = (0, $3MbOI.useCurrentUser)();
    const currentUserTimeZone = 'timeZone' in user ? user.timeZone || null : null;
    const timeZoneToUse = timeZone !== undefined ? timeZone : currentUserTimeZone;
    const handleOnChange = (0, $eJOHy.useCallback)((isoDateTimeValue)=>{
        const convertedIso = (0, $8IU7V.convertISODateFormat)(isoDateTimeValue ?? '');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($g0bBb)))(Date.parse(convertedIso))) onChange?.(null);
        else onChange?.(convertedIso);
    }, [
        onChange
    ]);
    const parseValue = (0, $eJOHy.useCallback)((dateTimeValue, fallbackDate, fallbackTime, fallbackTimeZone)=>(0, $l5gZd.parseDateTimeValue)(dateTimeValue, fallbackDate, fallbackTime, timeZoneToUse ?? fallbackTimeZone), [
        timeZoneToUse
    ]);
    const baseSelectProps = (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? {
        blurInputOnSelect: false,
        menuPosition: menuPosition,
        menuPortalTarget: menuPortalTarget
    } : {};
    const handleKeyDown = (0, $eJOHy.useCallback)((e)=>{
        switch(e.code){
            case 'ArrowLeft':
            case 'ArrowRight':
            case 'ArrowUp':
            case 'ArrowDown':
                // Stop propagation of arrow keys used for keyboard navigation in the date picker control so it
                // doesn't clash with consumer shortcut keys, i.e. issue view.
                if (e.defaultPrevented) e.stopPropagation();
                break;
            default:
                break;
        }
    }, []);
    const standardizedLocale = (0, $iw2hI.standardizeLocale)(locale);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkMDK.default), {
        testId: "issue-field-date-time-editview-full.ui.date-time.date-time-picker",
        locale: standardizedLocale,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        value: value || '',
        onChange: handleOnChange,
        parseValue: timeZoneToUse != null ? parseValue : undefined,
        spacing: spacing,
        timePickerProps: {
            placeholder: timePlaceholder,
            times: (0, $igoRN.default),
            timeIsEditable: true,
            onChange: onTimeChange,
            selectProps: {
                ...baseSelectProps,
                formatCreateLabel: (val)=>val,
                // Want to show the dropdown option if the user input
                // matches the value (22:30) or the label (10:30pm)
                filterOption: (option, val)=>!val || option.value === val || option.label === val
            }
        },
        // Use of non-standardized locale is intentional, getLocale map accounts for this.
        datePickerProps: {
            placeholder: datePlaceholder || '',
            defaultIsOpen: (0, $epTsa.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? defaultIsOpen : false,
            weekStartDay: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))((0, $dO9h7.getLocale)(locale), 'options.weekStartsOn', $51cfd76395ea9907$export$845e1054649a85c2),
            selectProps: {
                ...baseSelectProps,
                ...onDatePickerKeyDown ? {
                    onKeyDown: onDatePickerKeyDown
                } : {}
            },
            onChange: onDateChange,
            ...(0, $7jTnu.fg)('kenji_enghealth_26780_calendar_fix') ? {
                shouldShowCalendarButton: true
            } : {}
        }
    });
    return (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') || (0, $epTsa.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        role: "presentation",
        ref: ref,
        onKeyDown: (0, $epTsa.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? handleKeyDown : undefined
    }, content) : content;
});
const $51cfd76395ea9907$var$DateTimeEditViewEntryPoint = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($51cfd76395ea9907$export$22b93d77c10368c8, props);
var $51cfd76395ea9907$export$2e2bcd8739ae039 = $51cfd76395ea9907$var$DateTimeEditViewEntryPoint;

});
parcelRegister("g0bBb", function(module, exports) {

var $lBtjB = parcelRequire("lBtjB");
/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $ba65a4b582214aac$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $lBtjB(value) && value != +value;
}
module.exports = $ba65a4b582214aac$var$isNaN;

});

parcelRegister("kkMDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ec97aa1f0f4c3e1$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $1BRZx = parcelRequire("1BRZx");

var $dvsWI = parcelRequire("dvsWI");

var $gW6sD = parcelRequire("gW6sD");
const $3ec97aa1f0f4c3e1$var$DateTimePicker = (0, $1BRZx.componentWithCondition)(()=>(0, $eGOwo.fg)('dst-date-time-picker-use-functional-component'), (0, $gW6sD.default), (0, $dvsWI.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3ec97aa1f0f4c3e1$export$2e2bcd8739ae039 = $3ec97aa1f0f4c3e1$var$DateTimePicker;

});
parcelRegister("1BRZx", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $48de19f2c65a8561$export$6e8ea24b15199873);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $48de19f2c65a8561$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("dvsWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $26ee02f66b42cef8$export$2e2bcd8739ae039);
/* date-time-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $5fWw9 = parcelRequire("5fWw9");
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $5pWSu = parcelRequire("5pWSu");

var $eGOwo = parcelRequire("eGOwo");

var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $6EOrx = parcelRequire("6EOrx");

var $1BRZx = parcelRequire("1BRZx");

var $5PwWU = parcelRequire("5PwWU");

var $lLHJE = parcelRequire("lLHJE");

var $k2Uo2 = parcelRequire("k2Uo2");

var $fkh8F = parcelRequire("fkh8F");
const $26ee02f66b42cef8$var$DatePicker = (0, $1BRZx.componentWithCondition)(()=>(0, $eGOwo.fg)('dst-date-picker-use-functional-component'), (0, $k2Uo2.default), (0, $lLHJE.default));
const $26ee02f66b42cef8$var$packageName = "platform-pkg";
const $26ee02f66b42cef8$var$packageVersion = "0.0.0-use.local";
const $26ee02f66b42cef8$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_19itglyw _v564vrg3 _1e0c1txw _4cvr1h6o _i0dl1kw7 _bfhk1kw7 _syaz131l _6rthe4h9 _1pfhe4h9 _12l2e4h9 _ahbqe4h9 _85i512x7 _1q5112x7 _y4tiu2gc _bozg1b66 _30l31gjq"
}; // react-select overrides (via @atlaskit/select).
const $26ee02f66b42cef8$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $26ee02f66b42cef8$var$dateTimePickerDefaultProps = {
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $26ee02f66b42cef8$export$3b559a1219cb3c27 = 'Date';
const $26ee02f66b42cef8$export$d82cc7e53d68a428 = 'Time'; // eslint-disable-next-line @repo/internal/react/no-class-components
class $26ee02f66b42cef8$export$732a1726f0a3523b extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = $26ee02f66b42cef8$var$dateTimePickerDefaultProps;
    }
    parseValue(value, dateValue, timeValue, zoneValue) {
        if (this.props.parseValue) {
            const parsedFromFn = this.props.parseValue(value, dateValue, timeValue, zoneValue); // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: dateValue,
                timeValue: timeValue,
                zoneValue: zoneValue
            };
        }
        const parsed = (0, $kQ82p.default)(value);
        return (0, $dBLX0.default)(parsed) ? {
            dateValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('HH:mm')),
            zoneValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }
    onValueChange({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue }) {
        this.setState({
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        });
        if (dateValue && timeValue) {
            const value = (0, $RoXqn.formatDateTimeZoneIntoIso)(dateValue, timeValue, zoneValue);
            const { zoneValue: parsedZone } = this.parseValue(value, dateValue, timeValue, zoneValue);
            const valueWithValidZone = (0, $RoXqn.formatDateTimeZoneIntoIso)(dateValue, timeValue, parsedZone);
            this.setState({
                value: valueWithValidZone
            });
            this.props.onChange?.(valueWithValidZone); // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (this.getValue()) {
            this.setState({
                value: ''
            });
            this.props.onChange?.('');
        }
    }
    render() {
        const { 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerProps = {}, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, locale: locale = 'en-US', name: name = '', spacing: spacing = 'default', testId: testId, timePickerProps: timePickerProps = {} } = this.props;
        const value = this.getValue();
        const { isFocused: isFocused } = this.state;
        const parsedValues = this.getParsedValues();
        const dateValue = parsedValues?.dateValue;
        const timeValue = parsedValues?.timeValue;
        const datePickerSelectProps = datePickerProps?.selectProps;
        const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
        const datePickerLabel = datePickerProps.label || $26ee02f66b42cef8$export$3b559a1219cb3c27;
        const mergedDatePickerSelectProps = {
            ...datePickerSelectProps,
            styles: (0, $e9zKl.mergeStyles)($26ee02f66b42cef8$var$styles, datePickerSelectProps?.styles)
        };
        const timePickerSelectProps = timePickerProps?.selectProps;
        const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
        const timePickerLabel = timePickerProps.label || $26ee02f66b42cef8$export$d82cc7e53d68a428;
        const mergedTimePickerSelectProps = {
            ...timePickerSelectProps,
            styles: (0, $e9zKl.mergeStyles)($26ee02f66b42cef8$var$styles, timePickerSelectProps?.styles)
        }; // Render DateTimePicker's IconContainer when a value has been filled
        // Don't use Date or TimePicker's because they can't be customised
        const isClearable = Boolean(dateValue || timeValue);
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6EOrx.DateTimePickerContainer), {
            appearance: appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: isInvalid,
            testId: testId,
            innerProps: innerProps,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $26ee02f66b42cef8$var$compiledStyles.datePickerContainerStyles
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($26ee02f66b42cef8$var$DatePicker, {
                        appearance: appearance,
                        "aria-describedby": datePickerAriaDescribedBy,
                        autoFocus: datePickerProps.autoFocus || autoFocus,
                        dateFormat: datePickerProps.dateFormat,
                        defaultIsOpen: datePickerProps.defaultIsOpen,
                        defaultValue: datePickerProps.defaultValue,
                        disabled: datePickerProps.disabled,
                        disabledDateFilter: datePickerProps.disabledDateFilter,
                        formatDisplayLabel: datePickerProps.formatDisplayLabel,
                        hideIcon: datePickerProps.hideIcon || true,
                        icon: datePickerProps.icon,
                        id: datePickerProps.id || id,
                        innerProps: datePickerProps.innerProps,
                        isDisabled: datePickerProps.isDisabled || isDisabled,
                        isInvalid: datePickerProps.isInvalid || isInvalid,
                        isRequired: datePickerProps.isRequired || isRequired,
                        isOpen: datePickerProps.isOpen,
                        label: datePickerLabel,
                        locale: datePickerProps.locale || locale,
                        maxDate: datePickerProps.maxDate,
                        minDate: datePickerProps.minDate,
                        name: datePickerProps.name,
                        nextMonthLabel: datePickerProps.nextMonthLabel,
                        onBlur: this.onDateBlur,
                        onChange: this.onDateChange,
                        onFocus: this.onDateFocus,
                        parseInputValue: datePickerProps.parseInputValue,
                        placeholder: datePickerProps.placeholder,
                        previousMonthLabel: datePickerProps.previousMonthLabel,
                        selectProps: mergedDatePickerSelectProps,
                        shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                        spacing: datePickerProps.spacing || spacing,
                        testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                        value: dateValue,
                        weekStartDay: datePickerProps.weekStartDay
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $26ee02f66b42cef8$var$compiledStyles.timePickerContainerStyles
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fkh8F.default), {
                        appearance: timePickerProps.appearance || appearance,
                        "aria-describedby": timePickerAriaDescribedBy,
                        autoFocus: timePickerProps.autoFocus,
                        defaultIsOpen: timePickerProps.defaultIsOpen,
                        defaultValue: timePickerProps.defaultValue,
                        formatDisplayLabel: timePickerProps.formatDisplayLabel,
                        hideIcon: timePickerProps.hideIcon || true,
                        id: timePickerProps.id,
                        innerProps: timePickerProps.innerProps,
                        isDisabled: timePickerProps.isDisabled || isDisabled,
                        isInvalid: timePickerProps.isInvalid || isInvalid,
                        isOpen: timePickerProps.isOpen,
                        isRequired: timePickerProps.isRequired || isRequired,
                        label: timePickerLabel,
                        locale: timePickerProps.locale || locale,
                        name: timePickerProps.name,
                        onBlur: this.onTimeBlur,
                        onChange: this.onTimeChange,
                        onFocus: this.onTimeFocus,
                        parseInputValue: timePickerProps.parseInputValue,
                        placeholder: timePickerProps.placeholder,
                        selectProps: mergedTimePickerSelectProps,
                        spacing: timePickerProps.spacing || spacing,
                        testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                        timeFormat: timePickerProps.timeFormat,
                        timeIsEditable: timePickerProps.timeIsEditable,
                        times: timePickerProps.times,
                        value: timeValue
                    })
                }),
                isClearable && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsxs)("button", {
                    onClick: this.onClear,
                    "data-testid": testId && `${testId}--icon--container`,
                    tabIndex: -1,
                    type: "button",
                    className: (0, $hcewu.default)([
                        $26ee02f66b42cef8$var$compiledStyles.iconContainerStyles
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5pWSu))), {
                            LEGACY_size: "small",
                            color: "currentColor",
                            label: clearControlLabel,
                            size: "small"
                        }),
                        ' '
                    ]
                }) : null
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            dateValue: this.props.datePickerProps?.defaultValue || '',
            isFocused: false,
            timeValue: this.props.timePickerProps?.defaultValue || '',
            value: this.props.defaultValue || '',
            zoneValue: ''
        } // All state needs to be accessed via this function so that the state is mapped from props
        , // correctly to allow controlled/uncontrolled usage.
        this.getParsedValues = ()=>this.parseValue(this.getValue(), this.state.dateValue, this.state.timeValue, this.state.zoneValue), this.getValue = ()=>this.props.value ?? this.state.value, this.onDateBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.datePickerProps?.onBlur) this.props.datePickerProps.onBlur(event);
        }, this.onTimeBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.timePickerProps?.onBlur) this.props.timePickerProps.onBlur(event);
        }, this.onDateFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.datePickerProps?.onFocus) this.props.datePickerProps.onFocus(event);
        }, this.onTimeFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.timePickerProps?.onFocus) this.props.timePickerProps.onFocus(event);
        }, this.onDateChange = (dateValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: dateValue,
                timeValue: parsedValues.timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange(dateValue);
        }, this.onTimeChange = (timeValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: parsedValues.dateValue,
                timeValue: timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange(timeValue);
        }, this.onClear = ()=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: '',
                timeValue: '',
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange('');
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange('');
        };
    }
}
const $26ee02f66b42cef8$var$DateTimePicker = (0, $dUaMU.default)({
    componentName: 'dateTimePicker',
    packageName: $26ee02f66b42cef8$var$packageName,
    packageVersion: $26ee02f66b42cef8$var$packageVersion
})((0, $4J0ad.default)({
    onChange: (0, $5fWw9.default)('atlaskit')({
        action: 'changed',
        actionSubject: 'dateTimePicker',
        attributes: {
            componentName: 'dateTimePicker',
            packageName: $26ee02f66b42cef8$var$packageName,
            packageVersion: $26ee02f66b42cef8$var$packageVersion
        }
    })
})($26ee02f66b42cef8$export$732a1726f0a3523b));
var $26ee02f66b42cef8$export$2e2bcd8739ae039 = $26ee02f66b42cef8$var$DateTimePicker;

});
parcelRegister("RoXqn", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $f314d4d8e1112a31$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $f314d4d8e1112a31$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $f314d4d8e1112a31$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $f314d4d8e1112a31$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $f314d4d8e1112a31$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $f314d4d8e1112a31$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $f314d4d8e1112a31$export$5e30e9a24d6c1203 = ()=>null;
const $f314d4d8e1112a31$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $f314d4d8e1112a31$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $f314d4d8e1112a31$export$9e6d8fcf62256b85 = 'h:mma';
const $f314d4d8e1112a31$export$75032c84f56650eb = 'YYYY/MM/DD';
function $f314d4d8e1112a31$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("6EOrx", function(module, exports) {

$parcel$export(module.exports, "DateTimePickerContainer", () => $c66482dfa6b4af59$export$83034b1f07ab0b20);
/* date-time-picker-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c66482dfa6b4af59$var$isInvalidBorderStyles = null;
const $c66482dfa6b4af59$var$isFocusedBorderStyles = null;
const $c66482dfa6b4af59$var$isFocusedStyles = null;
const $c66482dfa6b4af59$var$subtleBgStyles = null;
const $c66482dfa6b4af59$var$subtleFocusedBgStyles = null;
const $c66482dfa6b4af59$var$noBgStyles = null;
const $c66482dfa6b4af59$var$hoverStyles = null;
const $c66482dfa6b4af59$var$isInvalidHoverStyles = null;
const $c66482dfa6b4af59$var$isDisabledStyles = null;
const $c66482dfa6b4af59$var$newBorderStyles = null;
const $c66482dfa6b4af59$var$baseContainerStyles = null;
const $c66482dfa6b4af59$export$83034b1f07ab0b20 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    // we cannot use Box or Flex primitives because these do not allow ...innerProps to be passed
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            "_2rkoglpi _v564r5cv _1e0c1txw _bfhk1j9a _d0altlke",
            "_19it1k9g",
            isDisabled && "_1h6d13gt _bfhksyzs _d0al73ad",
            isFocused && "_bfhkr01l",
            appearance === 'subtle' && isFocused && "_1h6d3acm _bfhkxbh0",
            appearance === 'subtle' && !isFocused && "_1h6d3acm _bfhk18uv",
            isFocused && "_1h6d1p6i _16qsq049",
            isInvalid && "_1h6d1bqt",
            notFocusedOrIsDisabled && isInvalid && "_4cvx1bqt _irr31d5g",
            notFocusedOrIsDisabled && !isInvalid && "_4cvx1elr _irr31d5g",
            appearance === 'none' && "_1h6d3acm _bfhk18uv _4cvx3acm _irr318uv"
        ]),
        children: children
    });
});

});

parcelRegister("5PwWU", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $0e0ecc26a93a278c$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $0e0ecc26a93a278c$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $0e0ecc26a93a278c$var$v1tokens = Object.keys($0e0ecc26a93a278c$var$tokensMap).sort().reverse();
const $0e0ecc26a93a278c$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$0e0ecc26a93a278c$var$v1tokens.join('|') + '|.)', 'g');
function $0e0ecc26a93a278c$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($0e0ecc26a93a278c$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $0e0ecc26a93a278c$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});

parcelRegister("lLHJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe32780a1f5c05c$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $5fWw9 = parcelRequire("5fWw9");
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $2fe32780a1f5c05c$var$packageName = "platform-pkg";
const $2fe32780a1f5c05c$var$packageVersion = "0.0.0-use.local";
const $2fe32780a1f5c05c$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $2fe32780a1f5c05c$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $2fe32780a1f5c05c$export$df43d21f5faca9f7 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = $2fe32780a1f5c05c$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $47or1.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $47or1.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1u9xN.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $47or1.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date()),
            l10n: (0, $cK9J2.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $cK9J2.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $2fe32780a1f5c05c$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $7OE9J.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gNwsY.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $RoXqn.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $47or1.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $hcewu.default)([
                $2fe32780a1f5c05c$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $47or1.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: selectComponents,
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: (0, $6qaBj.cx)($2fe32780a1f5c05c$var$styles.iconContainerStyles, value && !hideIcon ? $2fe32780a1f5c05c$var$styles.iconSpacingWithClearButtonStyles : $2fe32780a1f5c05c$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $2fe32780a1f5c05c$var$DatePicker = (0, $dUaMU.default)({
    componentName: 'datePicker',
    packageName: $2fe32780a1f5c05c$var$packageName,
    packageVersion: $2fe32780a1f5c05c$var$packageVersion
})((0, $4J0ad.default)({
    onChange: (0, $5fWw9.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $2fe32780a1f5c05c$var$packageName,
            packageVersion: $2fe32780a1f5c05c$var$packageVersion
        }
    })
})($2fe32780a1f5c05c$export$df43d21f5faca9f7));
var $2fe32780a1f5c05c$export$2e2bcd8739ae039 = $2fe32780a1f5c05c$var$DatePicker;

});
parcelRegister("cK9J2", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $2150f4a906bcb332$export$ea56ca58f08ffa52);

var $4ZGCx = parcelRequire("4ZGCx");

var $ktSIT = parcelRequire("ktSIT");

var $92aEh = parcelRequire("92aEh");
const $2150f4a906bcb332$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $ktSIT.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("4ZGCx", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $caa7b379de4e9e4d$export$dca0327c9b9c6498);
const $caa7b379de4e9e4d$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("ktSIT", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $f0407708fddca50b$export$cfa2ef2687faeda2);

var $4ZGCx = parcelRequire("4ZGCx");

var $61I7t = parcelRequire("61I7t");
const $f0407708fddca50b$var$INVALID_DATE = new Date(NaN);
const $f0407708fddca50b$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $f0407708fddca50b$var$INVARIANT_DATE = (0, $61I7t.toDate)($f0407708fddca50b$var$INVARIANT);
const $f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $f0407708fddca50b$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $f0407708fddca50b$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $f0407708fddca50b$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $f0407708fddca50b$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($f0407708fddca50b$var$INVARIANT_DATE);
    const shortDate = $f0407708fddca50b$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $f0407708fddca50b$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $f0407708fddca50b$var$stripExtras(date).match($f0407708fddca50b$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $f0407708fddca50b$var$INVALID_DATE;
        const dateParts = $f0407708fddca50b$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $61I7t.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $61I7t.isValid)(normalizedDate)) return $f0407708fddca50b$var$INVALID_DATE;
        return (0, $61I7t.toDate)(normalizedDate);
    };
};

});
parcelRegister("61I7t", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $862914b96a01ecbb$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $862914b96a01ecbb$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $862914b96a01ecbb$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $862914b96a01ecbb$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $862914b96a01ecbb$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $862914b96a01ecbb$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $862914b96a01ecbb$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $862914b96a01ecbb$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $862914b96a01ecbb$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $862914b96a01ecbb$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $862914b96a01ecbb$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $862914b96a01ecbb$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("92aEh", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $0bfc942d7a009811$export$9b7ca29af37c192);
const $0bfc942d7a009811$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("47or1", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $0a9aca5af48d76f0$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $0a9aca5af48d76f0$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $0a9aca5af48d76f0$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $0a9aca5af48d76f0$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $57raR = parcelRequire("57raR");
var $cBFyu = parcelRequire("cBFyu");
var $kQ82p = parcelRequire("kQ82p");

var $5PwWU = parcelRequire("5PwWU");

var $RoXqn = parcelRequire("RoXqn");
const $0a9aca5af48d76f0$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $0a9aca5af48d76f0$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $cBFyu.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(parsedDate)}`;
    return newIso;
};
const $0a9aca5af48d76f0$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $RoXqn.defaultDateFormat));
    return l10n.parseDate(date);
};
const $0a9aca5af48d76f0$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $RoXqn.defaultDateFormat));
    const date = (0, $kQ82p.default)(value);
    return dateFormat ? (0, $57raR.default)(date, (0, $5PwWU.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $RoXqn.placeholderDatetime));
};

});

parcelRegister("hmV0i", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $85a1248019ae74fb$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XEne = parcelRequire("6XEne");
const $85a1248019ae74fb$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $85a1248019ae74fb$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            showClearIndicator ? $85a1248019ae74fb$var$styles.calendarButtonInclusionStyles : $85a1248019ae74fb$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gNwsY", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $41b3b0700e22b1c1$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $cSUzd = parcelRequire("cSUzd");

var $3rigy = parcelRequire("3rigy");

var $7G7nX = parcelRequire("7G7nX");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $41b3b0700e22b1c1$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $kQ82p.default)(iso);
        return (0, $dBLX0.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $41b3b0700e22b1c1$var$menuStyles = null;
const $41b3b0700e22b1c1$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $41b3b0700e22b1c1$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rigy.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7G7nX.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $hcewu.default)([
                    "_2rkoglpi _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cSUzd.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("cSUzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1db3bdfc4d701b2$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $hWhuM = parcelRequire("hWhuM");

var $jOHXZ = parcelRequire("jOHXZ");

var $1p4Fz = parcelRequire("1p4Fz");

var $h2Y6s = parcelRequire("h2Y6s");

var $7pqrO = parcelRequire("7pqrO");

var $8m7JM = parcelRequire("8m7JM");

var $5Pa93 = parcelRequire("5Pa93");

var $cM3gB = parcelRequire("cM3gB");

var $lPLOh = parcelRequire("lPLOh");

var $jtNxE = parcelRequire("jtNxE");
const $d1db3bdfc4d701b2$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $d1db3bdfc4d701b2$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $d1db3bdfc4d701b2$var$InnerCalendar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $h2Y6s.blankStringArray), defaultSelected: defaultSelected = (0, $h2Y6s.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $3Vuhz.default), onChange: onChange = (0, $3Vuhz.default), onFocus: onFocus = (0, $3Vuhz.default), onSelect: onSelect = (0, $3Vuhz.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $7pqrO.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eJOHy.useState)(false);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $cM3gB.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $lPLOh.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $8m7JM.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jtNxE.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $5Pa93.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $gl2vi.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $d1db3bdfc4d701b2$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hWhuM.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1p4Fz.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jOHXZ.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    }));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $d1db3bdfc4d701b2$var$Calendar = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d1db3bdfc4d701b2$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$d1db3bdfc4d701b2$var$Calendar.displayName = 'Calendar';
var $d1db3bdfc4d701b2$export$2e2bcd8739ae039 = $d1db3bdfc4d701b2$var$Calendar;

});
parcelRegister("hWhuM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe58087a91a587c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $gl2vi = parcelRequire("gl2vi");

var $806LH = parcelRequire("806LH");

var $ld0cd = parcelRequire("ld0cd");

var $cqfIR = parcelRequire("cqfIR");

var $8PCRQ = parcelRequire("8PCRQ");

var $cQxBL = parcelRequire("cQxBL");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
const $8fe58087a91a587c$var$Header = /*#__PURE__*/ (0, $eJOHy.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $gl2vi.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $eJOHy.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld0cd))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8PCRQ))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cqfIR))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$8fe58087a91a587c$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8fe58087a91a587c$export$2e2bcd8739ae039 = $8fe58087a91a587c$var$Header;

});
parcelRegister("ld0cd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89a5ee1ee34f6c51127fc5be19fb8c41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f70af6cd1d0cef8e$var$_react = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f70af6cd1d0cef8e$var$_baseNew = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f70af6cd1d0cef8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $f70af6cd1d0cef8e$var$_react.default.createElement($f70af6cd1d0cef8e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $f70af6cd1d0cef8e$var$_default = module.exports.default = $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon;

});

parcelRegister("cqfIR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a70faad39a1700c3cb50a44f6bcc1a4e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90b41be71667434a$var$_react = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90b41be71667434a$var$_baseNew = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90b41be71667434a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90b41be71667434a$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $90b41be71667434a$var$_react.default.createElement($90b41be71667434a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$90b41be71667434a$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $90b41be71667434a$var$_default = module.exports.default = $90b41be71667434a$var$ChevronDoubleRightIcon;

});


parcelRegister("jOHXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7776188040914bac$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");

var $17gD3 = parcelRequire("17gD3");

var $48tPc = parcelRequire("48tPc");
const $7776188040914bac$var$WeekDays = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $17gD3.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$7776188040914bac$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7776188040914bac$export$2e2bcd8739ae039 = $7776188040914bac$var$WeekDays;

});
parcelRegister("17gD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f55ebb7772d4c5d$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Vuhz = parcelRequire("3Vuhz");

var $hYvlq = parcelRequire("hYvlq");
const $7f55ebb7772d4c5d$var$dateCellSiblingStyle = null;
const $7f55ebb7772d4c5d$var$dateCellTodayStyle = null;
const $7f55ebb7772d4c5d$var$dateCellPrevSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellDisabledStyle = null;
const $7f55ebb7772d4c5d$var$dateCellStyles = null;
const $7f55ebb7772d4c5d$var$Date = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $3Vuhz.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eJOHy.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $hcewu.default)([
                "_kkk2n7od _2rko1l7b _11c82smr _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$7f55ebb7772d4c5d$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7f55ebb7772d4c5d$export$2e2bcd8739ae039 = $7f55ebb7772d4c5d$var$Date;

});
parcelRegister("hYvlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e062987a137d87a$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3e062987a137d87a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3e062987a137d87a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3e062987a137d87a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3e062987a137d87a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $3e062987a137d87a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3e062987a137d87a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $3e062987a137d87a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3e062987a137d87a$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $3e062987a137d87a$var$baseStyles.root,
            gap && $3e062987a137d87a$var$columnGapMap[gap],
            columnGap && $3e062987a137d87a$var$columnGapMap[columnGap],
            gap && $3e062987a137d87a$var$rowGapMap[gap],
            rowGap && $3e062987a137d87a$var$rowGapMap[rowGap],
            alignItems && $3e062987a137d87a$var$alignItemsMap[alignItems],
            alignContent && $3e062987a137d87a$var$alignContentMap[alignContent],
            justifyContent && $3e062987a137d87a$var$justifyContentMap[justifyContent],
            autoFlow && $3e062987a137d87a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3e062987a137d87a$var$Grid.displayName = 'Grid';
var $3e062987a137d87a$export$2e2bcd8739ae039 = $3e062987a137d87a$var$Grid;

});


parcelRegister("48tPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f5de1de4465d4ec$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hYvlq = parcelRequire("hYvlq");
const $4f5de1de4465d4ec$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $4f5de1de4465d4ec$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        testId: testId,
        xcss: $4f5de1de4465d4ec$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $4f5de1de4465d4ec$export$2e2bcd8739ae039 = $4f5de1de4465d4ec$var$WeekDayGrid;

});


parcelRegister("1p4Fz", function(module, exports) {

$parcel$export(module.exports, "default", () => $be65a37818b8364c$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $48tPc = parcelRequire("48tPc");
const $be65a37818b8364c$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $be65a37818b8364c$var$WeekHeader = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                padding: "space.100",
                xcss: $be65a37818b8364c$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$be65a37818b8364c$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be65a37818b8364c$export$2e2bcd8739ae039 = $be65a37818b8364c$var$WeekHeader;

});

parcelRegister("h2Y6s", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $be18158d85881f31$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $be18158d85881f31$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $be18158d85881f31$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $be18158d85881f31$export$8fa20d70624f8b9d);
const $be18158d85881f31$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $be18158d85881f31$export$3ae905d9742bef55 = 7;
const $be18158d85881f31$export$c9b7c010035d60c6 = 12;
const $be18158d85881f31$export$8fa20d70624f8b9d = [];

});

parcelRegister("7pqrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0ab84481a095dc$export$2e2bcd8739ae039);

var $7O2l7 = parcelRequire("7O2l7");

var $3c3v8 = parcelRequire("3c3v8");

var $ediHA = parcelRequire("ediHA");
function $dd0ab84481a095dc$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $3c3v8.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $7O2l7.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $7O2l7.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $7O2l7.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $7O2l7.default)(today, ()=>today || `${thisYear}-${(0, $ediHA.default)(thisMonth)}-${(0, $ediHA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $7O2l7.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $7O2l7.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("ediHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $50fecd0d0148fc4a$export$2e2bcd8739ae039);
function $50fecd0d0148fc4a$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("8m7JM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c971afa7669251e8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $c971afa7669251e8$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eJOHy.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("5Pa93", function(module, exports) {

$parcel$export(module.exports, "default", () => $6571678cf382b203$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $cFI4x = parcelRequire("cFI4x");
function $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eJOHy.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $h2Y6s.daysPerWeek) : 0;
            return (0, $cFI4x.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $h2Y6s.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $6571678cf382b203$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eJOHy.useMemo)(()=>(0, $cFI4x.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $kQ82p.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $kQ82p.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eJOHy.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $fdbAT.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $kQ82p.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("fdbAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $33e505eaecca4d6d$export$2e2bcd8739ae039);

var $ediHA = parcelRequire("ediHA");
function $33e505eaecca4d6d$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $ediHA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $ediHA.default)(date.day)}`;
}

});

parcelRegister("cFI4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc98c4c7dc36d65$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $h2Y6s = parcelRequire("h2Y6s");

var $d9oTA = parcelRequire("d9oTA");
function $5fc98c4c7dc36d65$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $h2Y6s.daysPerWeek) - weekStartDay + firstDay) % (0, $h2Y6s.daysPerWeek));
    const lastDate = (0, $d9oTA.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $h2Y6s.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $d9oTA.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $h2Y6s.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $h2Y6s.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $h2Y6s.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $h2Y6s.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $h2Y6s.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("d9oTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdb6610bba124d19$export$2e2bcd8739ae039);
function $bdb6610bba124d19$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("cM3gB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e11abbd67514b7e7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $d9oTA = parcelRequire("d9oTA");
const $e11abbd67514b7e7$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $h2Y6s.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $e11abbd67514b7e7$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $h2Y6s.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $e11abbd67514b7e7$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eJOHy.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $h2Y6s.daysPerWeek);
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $h2Y6s.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("lPLOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $395ce53b4353da25$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");
function $395ce53b4353da25$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eJOHy.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $h2Y6s.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jtNxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $01a6b7d4c4da291b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cK9J2 = parcelRequire("cK9J2");
function $01a6b7d4c4da291b$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eJOHy.useMemo)(()=>(0, $cK9J2.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eJOHy.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eJOHy.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eJOHy.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("7G7nX", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ce7a484b05c143$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $anoAR = parcelRequire("anoAR");

var $6G5P1 = parcelRequire("6G5P1");
var $8qmYl = parcelRequire("8qmYl");
var $azjc1 = parcelRequire("azjc1");
const $68ce7a484b05c143$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $68ce7a484b05c143$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $anoAR.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6G5P1.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $azjc1.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $3Vuhz.default);
    }
}

});
parcelRegister("anoAR", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $19bef17192bf3a9c$export$c647cb0ee6e282fe);
const $19bef17192bf3a9c$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $19bef17192bf3a9c$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $19bef17192bf3a9c$export$62ad7b0c781000e9 = {
    small: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("1u9xN", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $a3c204a1b42604a4$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $a3c204a1b42604a4$export$ff525416014fb67d);

var $57raR = parcelRequire("57raR");

var $5PwWU = parcelRequire("5PwWU");
function $a3c204a1b42604a4$export$77d5bc49fed7ef14(date) {
    return (0, $57raR.default)(date, (0, $5PwWU.convertTokens)('YYYY-MM-DD'));
}
function $a3c204a1b42604a4$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $a3c204a1b42604a4$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("7OE9J", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $8e54d9aa121b2675$export$6e30bf8cb1347b56);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");
const $8e54d9aa121b2675$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("k2Uo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $00683ba6c52d5435$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $jrFnt = parcelRequire("jrFnt");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $00683ba6c52d5435$var$packageName = "platform-pkg";
const $00683ba6c52d5435$var$packageVersion = "0.0.0-use.local";
const $00683ba6c52d5435$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $00683ba6c52d5435$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $00683ba6c52d5435$var$packageName,
    packageVersion: $00683ba6c52d5435$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $00683ba6c52d5435$var$DatePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const calendarRef = (0, $eJOHy.useRef)(null);
    const calendarButtonRef = (0, $eJOHy.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $eJOHy.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $eJOHy.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $eJOHy.useState)(propValue || defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $eJOHy.useState)((0, $cK9J2.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $eJOHy.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $eJOHy.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $eJOHy.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $eJOHy.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$00683ba6c52d5435$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $cK9J2.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $eJOHy.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $47or1.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $47or1.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $1u9xN.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $47or1.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen((isOpen)=>{
            if (isOpen) {
                (0, $eGOwo.fg)('platform_dst_menuonclose_fix') && props.selectProps?.onMenuClose?.();
                return false;
            } else {
                (0, $eGOwo.fg)('platform_dst_menuonclose_fix') && props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $eJOHy.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $00683ba6c52d5435$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $7OE9J.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gNwsY.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $RoXqn.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $47or1.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $gl2vi.useId)()}`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $hcewu.default)([
            $00683ba6c52d5435$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $47or1.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // @ts-ignore -- Type 'OptionType' is not assignable to type '{ label: string; value: string; }'
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: (0, $6qaBj.cx)($00683ba6c52d5435$var$styles.iconContainerStyles, value && !hideIcon ? $00683ba6c52d5435$var$styles.iconSpacingWithClearButtonStyles : $00683ba6c52d5435$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $00683ba6c52d5435$export$2e2bcd8739ae039 = $00683ba6c52d5435$var$DatePicker;

});

parcelRegister("fkh8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd2b423b4bc9ae0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $dBLX0 = parcelRequire("dBLX0");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $cK9J2 = parcelRequire("cK9J2");

var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $icQS1 = parcelRequire("icQS1");

var $kdGko = parcelRequire("kdGko");

var $5PwWU = parcelRequire("5PwWU");

var $7OE9J = parcelRequire("7OE9J");
const $bbd2b423b4bc9ae0$var$packageName = "platform-pkg";
const $bbd2b423b4bc9ae0$var$packageVersion = "0.0.0-use.local";
const $bbd2b423b4bc9ae0$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $bbd2b423b4bc9ae0$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $bbd2b423b4bc9ae0$var$packageName,
    packageVersion: $bbd2b423b4bc9ae0$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $bbd2b423b4bc9ae0$var$TimePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $3Vuhz.default), onChange: providedOnChange = (0, $3Vuhz.default), onFocus: providedOnFocus = (0, $3Vuhz.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $kdGko.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $RoXqn.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $eJOHy.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [value, setValue] = (0, $eJOHy.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$bbd2b423b4bc9ae0$var$analyticsAttributes
    });
    (0, $eJOHy.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $eJOHy.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $RoXqn.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $57raR.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $cK9J2.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $kVcjU.default) : (0, $c4OV1.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $RoXqn.defaultTimeFormat));
        const date = (0, $kdGko.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $dBLX0.default)(date)) return time;
        if (timeFormat) return (0, $57raR.default)(date, (0, $5PwWU.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $7OE9J.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $RoXqn.EmptyComponent),
        Menu: (0, $icQS1.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $RoXqn.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$bbd2b423b4bc9ae0$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $RoXqn.placeholderDatetime)),
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $bbd2b423b4bc9ae0$export$2e2bcd8739ae039 = $bbd2b423b4bc9ae0$var$TimePicker;

});
parcelRegister("icQS1", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $c710cd93a504ed53$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $7G7nX = parcelRequire("7G7nX");
const $c710cd93a504ed53$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7G7nX.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("kdGko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f14a3d51f762a0dc$export$2e2bcd8739ae039);
const $f14a3d51f762a0dc$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $f14a3d51f762a0dc$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $f14a3d51f762a0dc$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $f14a3d51f762a0dc$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $f14a3d51f762a0dc$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $f14a3d51f762a0dc$var$map24[hour];
    return hour;
}
function $f14a3d51f762a0dc$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $f14a3d51f762a0dc$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $f14a3d51f762a0dc$var$formatSemi24(timeArray[0].trim());
    const hour = $f14a3d51f762a0dc$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $f14a3d51f762a0dc$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $f14a3d51f762a0dc$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $f14a3d51f762a0dc$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $f14a3d51f762a0dc$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$f14a3d51f762a0dc$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $f14a3d51f762a0dc$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $f14a3d51f762a0dc$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $f14a3d51f762a0dc$var$assignToDate(time2);
}

});



parcelRegister("gW6sD", function(module, exports) {

$parcel$export(module.exports, "default", () => $16c18c467fdc0432$export$2e2bcd8739ae039);
/* date-time-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $jrFnt = parcelRequire("jrFnt");

var $Ay1uj = parcelRequire("Ay1uj");

var $5pWSu = parcelRequire("5pWSu");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $6EOrx = parcelRequire("6EOrx");

var $1BRZx = parcelRequire("1BRZx");

var $5PwWU = parcelRequire("5PwWU");

var $lLHJE = parcelRequire("lLHJE");

var $k2Uo2 = parcelRequire("k2Uo2");

var $fkh8F = parcelRequire("fkh8F");
const $16c18c467fdc0432$var$DatePicker = (0, $1BRZx.componentWithCondition)(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
()=>(0, $eGOwo.fg)('dst-date-picker-use-functional-component'), (0, $k2Uo2.default), (0, $lLHJE.default));
const $16c18c467fdc0432$var$packageName = "platform-pkg";
const $16c18c467fdc0432$var$packageVersion = "0.0.0-use.local";
const $16c18c467fdc0432$var$analyticsAttributes = {
    componentName: 'dateTimePicker',
    packageName: $16c18c467fdc0432$var$packageName,
    packageVersion: $16c18c467fdc0432$var$packageVersion
};
const $16c18c467fdc0432$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_1e0c1txw _4cvr1h6o _i0dl1kw7"
}; // react-select overrides (via @atlaskit/select).
const $16c18c467fdc0432$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $16c18c467fdc0432$export$3b559a1219cb3c27 = 'Date';
const $16c18c467fdc0432$export$d82cc7e53d68a428 = 'Time'; /**
                                                   * __Date time picker__
                                                   *
                                                   * A date time picker allows the user to select an associated date and time.
                                                   *
                                                   * - [Examples](https://atlassian.design/components/datetime-picker/examples)
                                                   * - [Code](https://atlassian.design/components/datetime-picker/code)
                                                   * - [Usage](https://atlassian.design/components/datetime-picker/usage)
                                                   */ 
const $16c18c467fdc0432$var$DateTimePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: // These disables are here for proper typing when used as defaults. They
// should *not* use the `noop` function.
/* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, /* eslint-enable @repo/internal/react/use-noop */ parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
    const [dateValue, setDateValue] = (0, $eJOHy.useState)(datePickerPropsWithSelectProps?.defaultValue || '');
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [timeValue, setTimeValue] = (0, $eJOHy.useState)(timePickerPropsWithSelectProps?.defaultValue || '');
    const [value, setValue] = (0, $eJOHy.useState)(defaultValue || '');
    const [zoneValue, setZoneValue] = (0, $eJOHy.useState)('');
    (0, $eJOHy.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    const parseValue = (0, $eJOHy.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
        if (providedParseValue) {
            const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue); // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            };
        }
        const parsed = (0, $kQ82p.default)(value);
        return (0, $dBLX0.default)(parsed) ? {
            dateValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('HH:mm')),
            zoneValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }, [
        providedParseValue,
        dateValue,
        timeValue,
        zoneValue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        setDateValue(parsedValues.dateValue);
        setTimeValue(parsedValues.timeValue);
        setZoneValue(parsedValues.zoneValue);
    }, [
        value,
        dateValue,
        timeValue,
        zoneValue,
        parseValue
    ]);
    const onDateBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (datePickerPropsWithSelectProps?.onBlur) datePickerPropsWithSelectProps.onBlur(event);
    };
    const onTimeBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (timePickerPropsWithSelectProps?.onBlur) timePickerPropsWithSelectProps.onBlur(event);
    };
    const onDateFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (datePickerPropsWithSelectProps?.onFocus) datePickerPropsWithSelectProps.onFocus(event);
    };
    const onTimeFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (timePickerPropsWithSelectProps?.onFocus) timePickerPropsWithSelectProps.onFocus(event);
    };
    const onDateChange = (dateValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: dateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange(dateValue);
    };
    const onTimeChange = (timeValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: parsedValues.dateValue,
            providedTimeValue: timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange(timeValue);
    };
    const onClear = ()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: '',
            providedTimeValue: '',
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange('');
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange('');
    };
    const onChangePropWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$16c18c467fdc0432$var$analyticsAttributes
    });
    const onValueChange = ({ providedDateValue: providedDateValue, providedTimeValue: providedTimeValue, providedZoneValue: providedZoneValue })=>{
        setDateValue(providedDateValue);
        setTimeValue(providedTimeValue);
        setZoneValue(providedZoneValue);
        if (providedDateValue && providedTimeValue) {
            const value = (0, $RoXqn.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, providedZoneValue);
            const { zoneValue: parsedZone } = parseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            const valueWithValidZone = (0, $RoXqn.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, parsedZone);
            setValue(valueWithValidZone);
            onChangePropWithAnalytics(valueWithValidZone); // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (value) {
            setValue('');
            onChangePropWithAnalytics('');
        }
    };
    const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
    const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || $16c18c467fdc0432$export$3b559a1219cb3c27;
    const mergedDatePickerSelectProps = {
        ...datePickerSelectProps,
        styles: (0, $e9zKl.mergeStyles)($16c18c467fdc0432$var$styles, datePickerSelectProps?.styles)
    };
    const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
    const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || $16c18c467fdc0432$export$d82cc7e53d68a428;
    const mergedTimePickerSelectProps = {
        ...timePickerSelectProps,
        styles: (0, $e9zKl.mergeStyles)($16c18c467fdc0432$var$styles, timePickerSelectProps?.styles)
    }; // Render DateTimePicker's IconContainer when a value has been filled
    // Don't use Date or TimePicker's because they can't be customised
    const isClearable = Boolean(dateValue || timeValue);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6EOrx.DateTimePickerContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isInvalid: isInvalid,
        testId: testId,
        innerProps: innerProps,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $16c18c467fdc0432$var$compiledStyles.datePickerContainerStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($16c18c467fdc0432$var$DatePicker, {
                    appearance: appearance,
                    "aria-describedby": datePickerAriaDescribedBy,
                    autoFocus: datePickerProps.autoFocus || autoFocus,
                    dateFormat: datePickerProps.dateFormat,
                    defaultIsOpen: datePickerProps.defaultIsOpen,
                    defaultValue: datePickerProps.defaultValue,
                    disabled: datePickerProps.disabled,
                    disabledDateFilter: datePickerProps.disabledDateFilter,
                    formatDisplayLabel: datePickerProps.formatDisplayLabel,
                    hideIcon: datePickerProps.hideIcon || true,
                    icon: datePickerProps.icon,
                    id: datePickerProps.id || id,
                    innerProps: datePickerProps.innerProps,
                    inputLabel: datePickerProps.inputLabel,
                    inputLabelId: datePickerProps.inputLabelId,
                    isDisabled: datePickerProps.isDisabled || isDisabled,
                    isInvalid: datePickerProps.isInvalid || isInvalid,
                    isOpen: datePickerProps.isOpen,
                    isRequired: datePickerProps.isRequired || isRequired,
                    label: datePickerLabel,
                    locale: datePickerProps.locale || locale,
                    maxDate: datePickerProps.maxDate,
                    minDate: datePickerProps.minDate,
                    name: datePickerProps.name,
                    nextMonthLabel: datePickerProps.nextMonthLabel,
                    onBlur: onDateBlur,
                    onChange: onDateChange,
                    onFocus: onDateFocus,
                    openCalendarLabel: datePickerProps.openCalendarLabel,
                    parseInputValue: datePickerProps.parseInputValue,
                    placeholder: datePickerProps.placeholder,
                    previousMonthLabel: datePickerProps.previousMonthLabel,
                    selectProps: mergedDatePickerSelectProps,
                    shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                    spacing: datePickerProps.spacing || spacing,
                    testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                    value: dateValue,
                    weekStartDay: datePickerProps.weekStartDay
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $16c18c467fdc0432$var$compiledStyles.timePickerContainerStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fkh8F.default), {
                    appearance: timePickerProps.appearance || appearance,
                    "aria-describedby": timePickerAriaDescribedBy,
                    autoFocus: timePickerProps.autoFocus,
                    defaultIsOpen: timePickerProps.defaultIsOpen,
                    defaultValue: timePickerProps.defaultValue,
                    formatDisplayLabel: timePickerProps.formatDisplayLabel,
                    hideIcon: timePickerProps.hideIcon || true,
                    id: timePickerProps.id,
                    innerProps: timePickerProps.innerProps,
                    isDisabled: timePickerProps.isDisabled || isDisabled,
                    isInvalid: timePickerProps.isInvalid || isInvalid,
                    isOpen: timePickerProps.isOpen,
                    isRequired: timePickerProps.isRequired || isRequired,
                    label: timePickerLabel,
                    locale: timePickerProps.locale || locale,
                    name: timePickerProps.name,
                    onBlur: onTimeBlur,
                    onChange: onTimeChange,
                    onFocus: onTimeFocus,
                    parseInputValue: timePickerProps.parseInputValue,
                    placeholder: timePickerProps.placeholder,
                    selectProps: mergedTimePickerSelectProps,
                    spacing: timePickerProps.spacing || spacing,
                    testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                    timeFormat: timePickerProps.timeFormat,
                    timeIsEditable: timePickerProps.timeIsEditable,
                    times: timePickerProps.times,
                    value: timeValue
                })
            }),
            isClearable && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                xcss: $16c18c467fdc0432$var$compiledStyles.iconContainerStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    appearance: "subtle",
                    label: clearControlLabel,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5pWSu))), {
                            ...iconProps,
                            color: "var(--ds-text-subtlest, #626F86)",
                            LEGACY_size: "small",
                            size: "small"
                        }),
                    onClick: onClear,
                    testId: testId && `${testId}--icon--container`,
                    tabIndex: -1
                })
            }) : null
        ]
    });
});
var $16c18c467fdc0432$export$2e2bcd8739ae039 = $16c18c467fdc0432$var$DateTimePicker;

});


parcelRegister("igoRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfac6f159c013af7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $cfac6f159c013af7$export$2e2bcd8739ae039 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});

parcelRegister("8IU7V", function(module, exports) {

$parcel$export(module.exports, "convertISODateFormat", () => $0025c3ded59bd26a$export$6ac2be7021dd8e44);
// Safari and Internet Explorer cannot parse dates (invalid date error) of a specific type of
// ISO formatting (RFC 822) that does no have timezone part (HHmm) separated by a colon (:)
// not working example: new Date('2018-02-06T20:00:00+1100')
// working example:     new Date('2018-02-06T20:00:00+11:00')
const $0025c3ded59bd26a$export$6ac2be7021dd8e44 = (date)=>date.replace(/([+-][0-9]{2})([0-9]{2})$/, '$1:$2');

});

parcelRegister("l5gZd", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeValue", () => $48d219ab406f7122$export$30dbc3f5fc81f24a);

var $hT96M = parcelRequire("hT96M");
var $6pRIG = parcelRequire("6pRIG");

var $dBLX0 = parcelRequire("dBLX0");
const $48d219ab406f7122$export$30dbc3f5fc81f24a = (dateTimeValue, fallbackDate, fallbackTime, timeZone)=>{
    const parsed = dateTimeValue !== null && (0, $dBLX0.default)(new Date(dateTimeValue)) ? (0, $6pRIG.default)(new Date(dateTimeValue), timeZone) : null;
    return parsed !== null && (0, $dBLX0.default)(parsed) ? {
        dateValue: (0, $hT96M.default)(parsed, 'yyyy-MM-dd', {
            timeZone: timeZone
        }),
        timeValue: (0, $hT96M.default)(parsed, 'HH:mm', {
            timeZone: timeZone
        }),
        zoneValue: (0, $hT96M.default)(parsed, 'XX', {
            timeZone: timeZone
        })
    } : {
        dateValue: fallbackDate,
        timeValue: fallbackTime,
        zoneValue: (0, $hT96M.default)(new Date(), 'XX', {
            timeZone: timeZone
        })
    };
};

});


parcelRegister("gQeix", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef2e1b73562b3d0c$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ef2e1b73562b3d0c$var$DateTimeEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("ejuPL"))), {
        moduleId: "60a5161a",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $ef2e1b73562b3d0c$export$2e2bcd8739ae039 = $ef2e1b73562b3d0c$var$DateTimeEditViewEntryPoint;

});

parcelRegister("b3Emp", function(module, exports) {

$parcel$export(module.exports, "DateTimeReadView", () => $4ca1d1549d29cfd8$export$962e920a3f993096);

var $4EKpv = parcelRequire("4EKpv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");

var $3NHJr = parcelRequire("3NHJr");

var $jd93d = parcelRequire("jd93d");

var $9Mapt = parcelRequire("9Mapt");

var $7jTnu = parcelRequire("7jTnu");

var $3OT15 = parcelRequire("3OT15");
const $4ca1d1549d29cfd8$export$962e920a3f993096 = (props)=>{
    const { fragmentRef: fragmentRef, timeZone: overrideTimeZone, isDateOnlyFormat: isDateOnlyFormat = false, shouldRenderHoverPopover: shouldRenderHoverPopover = false } = props;
    const data = (0, $j4oe4.useFragment)((0, $4EKpv.default), fragmentRef);
    const { dateTime: dateTime } = data || {};
    const { formatDateTime: formatDateTime, formatDateOnly: formatDateOnly } = (0, $3NHJr.useDateTimeFormatter)(overrideTimeZone);
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldRenderHoverPopover && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data?.id) : null;
    let hoverPopoverRef = null;
    if (!dateTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    let content;
    try {
        content = isDateOnlyFormat ? formatDateOnly(dateTime) : formatDateTime(dateTime);
    } catch (err) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    }
    if (shouldRenderHoverPopover && dateTime) {
        if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
            content: content
        });
        return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: 1,
            ref: hoverPopoverRef
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            contentRef: contentRef,
            content: content
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                maxLines: 1,
                ref: (0, $jd93d.mergeRefs)(ref, contentRef)
            }, content));
    }
    return content;
};

});
parcelRegister("4EKpv", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4c808c94044cc91$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1246877e65fc74c6fa03f72d3297c951>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a4c808c94044cc91$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$a4c808c94044cc91$var$node.hash = "0df740d2008e12f8a9d53fbd1dbcb30e";
var $a4c808c94044cc91$export$2e2bcd8739ae039 = $a4c808c94044cc91$var$node;

});


parcelRegister("7iVmZ", function(module, exports) {

$parcel$export(module.exports, "InlineEditContainer", () => $fc3c3a47b160fa6b$export$9f16bbb9a44c7bf6);
$parcel$export(module.exports, "InlineEditContainerExperiment", () => $fc3c3a47b160fa6b$export$409c96a6d46b6d0);
$parcel$export(module.exports, "ReadViewContainer", () => $fc3c3a47b160fa6b$export$ebb3489b83262b26);
$parcel$export(module.exports, "readOnlyViewContainerSelectorName", () => $fc3c3a47b160fa6b$export$dafe48f89a07868a);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cdbP5 = parcelRequire("cdbP5");

var $dPMMf = parcelRequire("dPMMf");
/*
 Using calc as this margin negates 2 things:
 - Left displacement which ensures there's more space for the input element that becomes visible on focus.
 - The focus outline offset for the badge (implemented as a 2px border) which is in PX everywhere currently.
 The REM is affected by browser font size settings while PX isn't. So, this ensures the spacing behaves in a consistent manner.
 */ const $fc3c3a47b160fa6b$var$MARGIN_LEFT = `calc(${"var(--ds-space-negative-075, -6px)"} - 2px)`;
const $fc3c3a47b160fa6b$export$9f16bbb9a44c7bf6 = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "q52d93-0"
})`margin-left:${$fc3c3a47b160fa6b$var$MARGIN_LEFT};margin-top:${"var(--ds-space-negative-100, -8px)"};padding-right:${"var(--ds-space-100, 8px)"};& div[data-read-view-fit-container-width]{width:100%;min-height:${(0, $dPMMf.gridSize) * 4}px;${({ hasValue: hasValue })=>hasValue ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $cdbP5.css)`padding:0;` : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $cdbP5.css)`padding:${"var(--ds-space-100, 8px)"} 0;`}}`;
const $fc3c3a47b160fa6b$export$409c96a6d46b6d0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasValue: hasValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0x0bf _19pkx0bf _u5f3u2gc _6vgs1osq _1rjezwfg",
            __cmplp.hasValue ? "_osjgidpf _2g9bidpf _alyvidpf _pa3xidpf" : "_osjg1v6z _2g9bidpf _alyv1v6z _pa3xidpf",
            __cmplp.className
        ])
    });
});
const $fc3c3a47b160fa6b$export$ebb3489b83262b26 = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "q52d93-1"
})({
    wordBreak: 'break-word',
    position: 'relative',
    left: "var(--ds-space-075, 6px)"
});
const $fc3c3a47b160fa6b$var$readViewContainerSelectorName = 'jira-issue-field-inline-edit-read-view-container';
const $fc3c3a47b160fa6b$export$dafe48f89a07868a = 'jira-issue-field-inline-edit-readonly-view-container';
const $fc3c3a47b160fa6b$export$5c18970ef161f5b6 = `[data-component-selector="${$fc3c3a47b160fa6b$var$readViewContainerSelectorName}"]`;
const $fc3c3a47b160fa6b$export$eab846169c2a4f66 = `[data-component-selector="${$fc3c3a47b160fa6b$export$dafe48f89a07868a}"]`;
$fc3c3a47b160fa6b$export$ebb3489b83262b26.defaultProps = {
    'data-component-selector': $fc3c3a47b160fa6b$var$readViewContainerSelectorName
};
const $fc3c3a47b160fa6b$export$646e0a1b0db8be98 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1nmz1hna _kqswh2mm _1ltv12x7",
            __cmplp.className
        ])
    });
});
const $fc3c3a47b160fa6b$export$3b079ed2709f4949 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("daGbj", function(module, exports) {

$parcel$export(module.exports, "FieldInlineEditStateLess", () => $3739b8ffa17b52c5$export$9a29c614a3f4aae1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6FuZ5 = parcelRequire("6FuZ5");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $dllpM = parcelRequire("dllpM");

var $7jTnu = parcelRequire("7jTnu");

var $hrKgE = parcelRequire("hrKgE");

var $f5dwt = parcelRequire("f5dwt");

var $d2AGn = parcelRequire("d2AGn");

var $bmoS1 = parcelRequire("bmoS1");

var $tYLUh = parcelRequire("tYLUh");

var $2rHwS = parcelRequire("2rHwS");

var $32zMs = parcelRequire("32zMs");

var $itOZI = parcelRequire("itOZI");

var $hjf2q = parcelRequire("hjf2q");
var $ftN6c = parcelRequire("ftN6c");

var $7iVmZ = parcelRequire("7iVmZ");
const $3739b8ffa17b52c5$export$5af7124b5599afd0 = (0, $hjf2q.AnalyticsEventToProps)('EnterEscapeHandler', {
    onEnter: 'entered',
    onEscape: 'escaped'
})((0, $f5dwt.default));
const $3739b8ffa17b52c5$export$41b20ce1a1b4f6f1 = (0, $hjf2q.AnalyticsEventToProps)('EscapeHandler', {
    onEscape: 'escaped'
})((0, $f5dwt.default));
const $3739b8ffa17b52c5$export$bfbc426ae4e1403d = (0, $hjf2q.AnalyticsEventToProps)('EnterHandler', {
    onEnter: 'entered'
})((0, $f5dwt.default));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3739b8ffa17b52c5$var$FieldContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_12jb1r31 _1gjeglyw _qrzw1o36",
            __cmplp.className
        ])
    });
});
const $3739b8ffa17b52c5$var$NonEditableMargin = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18s81uch",
            __cmplp.className
        ])
    });
});
const $3739b8ffa17b52c5$var$useCallbackWithAnalyticsEvent = (callback, payload)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // payload is almost always "unstable", lets support it
    const stablePayload = (0, $hrKgE.useShallowStableReference)(payload, (0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    return (0, $eJOHy.useCallback)(()=>{
        if (typeof callback === 'function') callback(createAnalyticsEvent(stablePayload));
    }, [
        callback,
        createAnalyticsEvent,
        stablePayload
    ]);
};
const $3739b8ffa17b52c5$var$useCallbackWithAnalyticsEventForEdit = (callback, payload)=>{
    const { fieldId: fieldId, fieldType: fieldTypeFromProps, isInlineEditing: isInlineEditing = false } = payload;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const pressTrace = (0, $dllpM.default)('issue.field.inline-edit');
    const fieldIdWithoutAri = (0, $itOZI.getFieldIdFromAri)(fieldId);
    const [fieldConfig] = (0, $2rHwS.useFieldConfig)(issueKey || '', fieldIdWithoutAri || '');
    const fieldType = fieldTypeFromProps || (0, $32zMs.getFieldType)(fieldConfig?.value);
    const stablePayload = (0, $hrKgE.useShallowStableReference)(payload, (0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    return (0, $eJOHy.useCallback)(()=>{
        pressTrace();
        if (fieldIdWithoutAri && fieldType) {
            const event = createAnalyticsEvent({});
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldIdWithoutAri, {
                analytics: event,
                attributes: {
                    fieldType: fieldType,
                    isInlineEditing: isInlineEditing
                }
            });
        }
        if (typeof callback === 'function') callback(createAnalyticsEvent(stablePayload));
    }, [
        callback,
        createAnalyticsEvent,
        fieldIdWithoutAri,
        fieldType,
        stablePayload,
        isInlineEditing,
        pressTrace
    ]);
};
function $3739b8ffa17b52c5$var$FieldInlineEditStateLessInner(props) {
    const { actionSubject: actionSubject = 'fieldInlineEdit', editView: editView, isEditable: isEditable = false, isEditing: isEditing = false, isLabelHidden: isLabelHidden = true, readView: readView, testId: testId, fieldId: fieldId, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onEditRequested: onEditRequested, onEnter: onEnter, onEscape: onEscape } = props;
    const [isMouseOver, setIsMouseOver] = (0, $eJOHy.useState)(false);
    const { isVisibleOnHover: isVisibleOnHover } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const handleEnter = $3739b8ffa17b52c5$var$useCallbackWithAnalyticsEvent(onEnter, {
        action: 'entered',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleEscape = $3739b8ffa17b52c5$var$useCallbackWithAnalyticsEvent(onEscape, {
        action: 'escaped',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleEdit = $3739b8ffa17b52c5$var$useCallbackWithAnalyticsEventForEdit(onEditRequested || onEdit, {
        action: 'focused',
        actionSubject: actionSubject,
        fieldId: fieldId,
        ...props.componentAnalyticsData
    });
    const handleCancel = $3739b8ffa17b52c5$var$useCallbackWithAnalyticsEvent(onCancel, {
        action: 'canceled',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleConfirm = (0, $eJOHy.useCallback)((_, event)=>{
        if (typeof onConfirm === 'function') onConfirm(event.update({
            action: 'confirmed',
            actionSubject: actionSubject,
            ...props.componentAnalyticsData
        }));
    }, [
        actionSubject,
        onConfirm,
        props.componentAnalyticsData
    ]);
    const handleOnHover = (0, $eJOHy.useCallback)(()=>setIsMouseOver(true), []);
    const handleOnLeave = (0, $eJOHy.useCallback)(()=>setIsMouseOver(false), []);
    const renderReadView = typeof readView === 'function' ? readView : ()=>readView;
    const renderEditView = (0, $eJOHy.useMemo)(()=>{
        if (typeof editView === 'function') return editView;
        return ()=>editView;
    }, [
        editView
    ]);
    const renderEditViewWithHandlers = (0, $eJOHy.useCallback)((editProps, ref)=>{
        if (editView === null) return null;
        if (onEnter && onEscape) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3739b8ffa17b52c5$export$5af7124b5599afd0, {
            onEnter: handleEnter,
            onEscape: handleEscape
        }, renderEditView(editProps, ref));
        if (onEnter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3739b8ffa17b52c5$export$bfbc426ae4e1403d, {
            onEnter: handleEnter
        }, renderEditView(editProps, ref));
        if (onEscape) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3739b8ffa17b52c5$export$41b20ce1a1b4f6f1, {
            onEscape: handleEscape
        }, renderEditView(editProps, ref));
        return renderEditView(editProps, ref);
    }, [
        editView,
        onEnter,
        onEscape,
        handleEnter,
        handleEscape,
        renderEditView
    ]);
    const inlineEditProps = {
        defaultValue: 'defaultValue' in props ? props.defaultValue : props.value,
        onConfirm: handleConfirm,
        readView: ()=>!isVisibleOnHover || props.value || props.defaultValue || isMouseOver ? renderReadView() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $3739b8ffa17b52c5$var$readViewHiddenUntilHoverStyle
            }, renderReadView()),
        editView: renderEditViewWithHandlers,
        isEditing: isEditing,
        onCancel: handleCancel,
        onEdit: handleEdit,
        isRequired: props.isRequired,
        analyticsContext: props.analyticsContext,
        cancelButtonLabel: props.cancelButtonLabel,
        confirmButtonLabel: props.confirmButtonLabel,
        editButtonLabel: props.editButtonLabel,
        hideActionButtons: 'hideActionButtons' in props ? props.hideActionButtons : props.areActionButtonsHidden,
        keepEditViewOpenOnBlur: 'keepEditViewOpenOnBlur' in props ? props.keepEditViewOpenOnBlur : props.isConfirmOnBlurDisabled,
        label: isLabelHidden === true ? undefined : props.label,
        readViewFitContainerWidth: 'readViewFitContainerWidth' in props ? props.readViewFitContainerWidth : props.isFitContainerWidthReadView,
        startWithEditViewOpen: props.startWithEditViewOpen,
        validate: props.validate
    };
    return isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3739b8ffa17b52c5$var$FieldContainer, {
        "data-testid": testId != null ? `${testId}--container` : undefined,
        onFocus: handleOnHover,
        onBlur: handleOnLeave,
        onMouseEnter: handleOnHover,
        onMouseLeave: handleOnLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6FuZ5.default), inlineEditProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3739b8ffa17b52c5$var$NonEditableMargin, {
        "data-component-selector": (0, $7iVmZ.readOnlyViewContainerSelectorName),
        "data-testid": testId != null ? `${testId}--read-only-container` : undefined
    }, renderReadView());
}
const $3739b8ffa17b52c5$var$readViewHiddenUntilHoverStyle = (0, $1DXK0.xcss)({
    visibility: 'hidden'
});
const $3739b8ffa17b52c5$export$9a29c614a3f4aae1 = /*#__PURE__*/ (0, $eJOHy.memo)($3739b8ffa17b52c5$var$FieldInlineEditStateLessInner);
var $3739b8ffa17b52c5$export$2e2bcd8739ae039 = $3739b8ffa17b52c5$export$9a29c614a3f4aae1;

});
parcelRegister("6FuZ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $62e487e87e8a09dc$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $6svxr = parcelRequire("6svxr");

var $3L3Os = parcelRequire("3L3Os");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");

var $6fs4r = parcelRequire("6fs4r");

var $JpPJd = parcelRequire("JpPJd");

var $bMFcf = parcelRequire("bMFcf");

var $bVPmc = parcelRequire("bVPmc");
const $62e487e87e8a09dc$var$fieldStyles = null;
const $62e487e87e8a09dc$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $62e487e87e8a09dc$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $eJOHy.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $eJOHy.useState)(startWithEditViewOpen);
    const timerRef = (0, $eJOHy.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $bMFcf.default)(isEditing, isEditingState);
    const onCancel = (0, $eJOHy.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $eJOHy.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$62e487e87e8a09dc$var$analyticsAttributes
    });
    const onCancelClick = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $eJOHy.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $eJOHy.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $eJOHy.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bVPmc.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3L3Os.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $gt9Am.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                // This is because due to some default focus being applied to the form element, the inline edit component
                // was being focused automatically and causing scroll issues in issue view
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $eGOwo.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $hcewu.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $JpPJd.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $62e487e87e8a09dc$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)($62e487e87e8a09dc$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $62e487e87e8a09dc$export$2e2bcd8739ae039 = $62e487e87e8a09dc$var$InlineEdit;

});
parcelRegister("JpPJd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd77e55f5b6541b9$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $entZ3 = parcelRequire("entZ3");

var $laG04 = parcelRequire("laG04");
const $bd77e55f5b6541b9$var$buttonsContainerStyles = null;
const $bd77e55f5b6541b9$var$buttonWrapperBaseStyles = null;
const $bd77e55f5b6541b9$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                tabIndex: -1,
                className: (0, $hcewu.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($entZ3))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                tabIndex: -1,
                className: (0, $hcewu.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($laG04))),
                            size: "small"
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd77e55f5b6541b9$export$2e2bcd8739ae039 = $bd77e55f5b6541b9$var$Buttons;

});

parcelRegister("bMFcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc8979cc798952aa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $cc8979cc798952aa$var$usePrevious = (value)=>{
    const ref = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $cc8979cc798952aa$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $eJOHy.useRef)(null);
    const editViewRef = (0, $eJOHy.useRef)();
    const preventFocusOnEditButtonRef = (0, $eJOHy.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $cc8979cc798952aa$var$usePrevious(shouldBeEditing);
    (0, $eJOHy.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $cc8979cc798952aa$export$2e2bcd8739ae039 = $cc8979cc798952aa$var$useButtonFocusHook;

});

parcelRegister("bVPmc", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c6797058a2257d$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $46R8N = parcelRequire("46R8N");
const $63c6797058a2257d$var$readViewContainerStyles = null;
const $63c6797058a2257d$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $63c6797058a2257d$var$readViewWrapperStyles = null;
const $63c6797058a2257d$var$readViewFitContainerWidthStyles = null;
const $63c6797058a2257d$var$DRAG_THRESHOLD = 5;
const $63c6797058a2257d$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $eJOHy.useRef)(0);
    const startY = (0, $eJOHy.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $63c6797058a2257d$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $63c6797058a2257d$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                xcss: $63c6797058a2257d$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $hcewu.default)([
                    "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$63c6797058a2257d$export$2e2bcd8739ae039 = $63c6797058a2257d$var$ReadView;

});


parcelRegister("2rHwS", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $9c87b1a177d5273e$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $9c87b1a177d5273e$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $9c87b1a177d5273e$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $9c87b1a177d5273e$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $9c87b1a177d5273e$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $9c87b1a177d5273e$export$28a22fd0dedf31b7);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $7jTnu = parcelRequire("7jTnu");

var $fAZgY = parcelRequire("fAZgY");

var $1uIew = parcelRequire("1uIew");

var $jGzN3 = parcelRequire("jGzN3");

var $XGDec = parcelRequire("XGDec");

var $3KXZZ = parcelRequire("3KXZZ");

var $3ibpe = parcelRequire("3ibpe");

var $4im1M = parcelRequire("4im1M");

var $b1smt = parcelRequire("b1smt");
const $9c87b1a177d5273e$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $3KXZZ.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $3ibpe.sendExperienceAnalytics)($9c87b1a177d5273e$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $1uIew.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $9c87b1a177d5273e$var$fetchData = async (issueKey)=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)((0, $XGDec.getGraphQlUrl)((0, $3KXZZ.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $9c87b1a177d5273e$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $1uIew.default) ? error : undefined
        });
        return null;
    }
};
const $9c87b1a177d5273e$var$requestSet = new Set();
const $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $9c87b1a177d5273e$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $4im1M.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $b1smt.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $eJOHy.useState)(()=>!skipRefresh && value === undefined && !$9c87b1a177d5273e$var$requestSet.has(issueKey));
    const getData = (0, $eJOHy.useCallback)(async ()=>{
        setLoading(true);
        $9c87b1a177d5273e$var$requestSet.add(issueKey);
        const result = await $9c87b1a177d5273e$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $9c87b1a177d5273e$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const shouldGetData = (0, $7jTnu.fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$9c87b1a177d5273e$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$9c87b1a177d5273e$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                loading: loading
            }
        ], [
        loading
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $b1smt.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $b1smt.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $eJOHy.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $b1smt.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $b1smt.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $9c87b1a177d5273e$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value
            }
        ], [
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $b1smt.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value
            }
        ], [
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $b1smt.useFieldConfigStoreActions)();
    const actions = (0, $eJOHy.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("XGDec", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $d2d607861b22c2c1$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $d2d607861b22c2c1$export$f2fec0cacdfabaaf);

var $cTI7h = parcelRequire("cTI7h");

var $bcdww = parcelRequire("bcdww");

const $d2d607861b22c2c1$export$5647e6bbf2b3526f = (operation)=>`/rest/graphql/1/${(0, $cTI7h.appendOperationQuery)(operation)}`;
const $d2d607861b22c2c1$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $bcdww.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("cTI7h", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $237ed4c9607e5b1c$export$69694c3add0f6058);
const $237ed4c9607e5b1c$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("bcdww", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ded878d9b9c772$export$2e2bcd8739ae039);
const $c8ded878d9b9c772$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $c8ded878d9b9c772$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $c8ded878d9b9c772$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $c8ded878d9b9c772$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $c8ded878d9b9c772$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $c8ded878d9b9c772$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
// Disable this eslint rule temporarily so we can query for configuration
const $c8ded878d9b9c772$var$createIssueDataQuery = (issueKey, projectKey)=>$c8ded878d9b9c772$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$c8ded878d9b9c772$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$c8ded878d9b9c772$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$c8ded878d9b9c772$var$getIsHybridAgilityProjectQuery()}
            ${$c8ded878d9b9c772$var$getAgileQuery()}
        }
        ${$c8ded878d9b9c772$var$getProjectQuery(projectKey)}
    }`;
var $c8ded878d9b9c772$export$2e2bcd8739ae039 = $c8ded878d9b9c772$var$createIssueDataQuery;

});


parcelRegister("3KXZZ", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $cc433f27aee6ba76$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $cc433f27aee6ba76$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $cc433f27aee6ba76$export$b38f30d67f730bc4);
const $cc433f27aee6ba76$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $cc433f27aee6ba76$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $cc433f27aee6ba76$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("3ibpe", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $b05a2baea0c3ab19$export$4a95ada1b8228562);

var $1O6Yz = parcelRequire("1O6Yz");

var $4iJGP = parcelRequire("4iJGP");

var $mjinE = parcelRequire("mjinE");

var $hWeHP = parcelRequire("hWeHP");
const $b05a2baea0c3ab19$var$isSynthetic = ()=>(0, $hWeHP.default)('ajs-is-synthetic') === 'true';
function $b05a2baea0c3ab19$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $hWeHP.default)('ajs-shard');
    const region = (0, $hWeHP.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $4iJGP.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    const synthetics = {
        additionalAttributes: {
            synthetic: $b05a2baea0c3ab19$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(experienceDescription, synthetics);
    (0, $mjinE.default)(experienceDescription);
}

});

parcelRegister("b1smt", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $f4887671cea7e277$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $f4887671cea7e277$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $f4887671cea7e277$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $f4887671cea7e277$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $f4887671cea7e277$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $f4887671cea7e277$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $f4887671cea7e277$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $f4887671cea7e277$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $f4887671cea7e277$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $ahm5r = parcelRequire("ahm5r");

var $1O6Yz = parcelRequire("1O6Yz");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $f4887671cea7e277$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $f4887671cea7e277$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $f4887671cea7e277$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $f4887671cea7e277$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState(), newIssues));
    };
const $f4887671cea7e277$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $f4887671cea7e277$var$actions = {
    setIssueConfig: $f4887671cea7e277$var$setIssueConfig,
    setIssuesConfig: $f4887671cea7e277$var$setIssuesConfig,
    mergeIssueConfig: $f4887671cea7e277$var$mergeIssueConfig,
    mergeIssuesConfig: $f4887671cea7e277$var$mergeIssuesConfig,
    setFieldConfigValue: $f4887671cea7e277$var$setFieldConfigValue
};
// this is a global state
const $f4887671cea7e277$var$store = (0, $GtRbT.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $f4887671cea7e277$var$actions
});
const $f4887671cea7e277$var$getIssueFieldConfig = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $f4887671cea7e277$export$52f51db4e2b3da57 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: $f4887671cea7e277$var$getIssueFieldConfig
});
const $f4887671cea7e277$var$getFieldConfig = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $f4887671cea7e277$var$getFieldConfigWithLabel = (0, $ahm5r.createSelector)($f4887671cea7e277$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $f4887671cea7e277$var$getFieldOptionsOverrides = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $f4887671cea7e277$export$f9beb98c7488fd61 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: $f4887671cea7e277$var$getFieldConfig
});
const $f4887671cea7e277$export$314199caf05d245 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: null
});
const $f4887671cea7e277$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $f4887671cea7e277$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $f4887671cea7e277$var$overridesActions = {
    setFieldConfigOverridesValue: $f4887671cea7e277$var$setOverrides,
    resetOverridesStore: $f4887671cea7e277$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $f4887671cea7e277$var$overridesStore = (0, $GtRbT.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $f4887671cea7e277$var$overridesActions
});
const $f4887671cea7e277$export$ff357cf5a96ec0c6 = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getIssueFieldConfig
});
const $f4887671cea7e277$export$6e41e9c34587d557 = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldConfig
});
const $f4887671cea7e277$export$e704d739927bd1d6 = (0, $iJq0l.createStateHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldConfigWithLabel
});
const $f4887671cea7e277$export$d94ae842140da412 = (0, $iJq0l.createActionsHook)($f4887671cea7e277$var$overridesStore);
const $f4887671cea7e277$export$bfea9bb9bad7bc8f = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldOptionsOverrides
});
const $f4887671cea7e277$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $f4887671cea7e277$export$982ff1008c2e2780 = (0, $iJq0l.createStateHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getIsFieldBusySelector
});

});


parcelRegister("32zMs", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $ebfa3e5ab70c9d21$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $ebfa3e5ab70c9d21$export$24d1b07fa0e9f9f1);


var $8oOr4 = parcelRequire("8oOr4");

var $814y1 = parcelRequire("814y1");
const $ebfa3e5ab70c9d21$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $8oOr4.specialFields)();
    return [
        ...(0, $8oOr4.customFieldsToDisplay)().filter((cf)=>!(0, $8oOr4.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $814y1.FLAGGED_CF_TYPE)
    ];
};
const $ebfa3e5ab70c9d21$export$f521834fc2bfcd81 = (custom)=>$ebfa3e5ab70c9d21$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $ebfa3e5ab70c9d21$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $ebfa3e5ab70c9d21$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $ebfa3e5ab70c9d21$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $6e3c8900fd92f5d7$export$89b8c5d86c10a68c) || $ebfa3e5ab70c9d21$export$b9089a6e41ed43aa(field) === (0, $814y1.DESCRIPTION_TYPE) : false;
};

});
const $6e3c8900fd92f5d7$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $6e3c8900fd92f5d7$export$a4a240cb4053b29f = 'jira-text-renderer';
const $6e3c8900fd92f5d7$export$840ed33fa94f7693 = 'frother-control-renderer';



parcelRegister("3wIGE", function(module, exports) {

$parcel$export(module.exports, "getNext30MinuteInterval", () => $9162a9d29e7f73f1$export$84c10da5aad3dff1);
$parcel$export(module.exports, "getFormattedDate", () => $9162a9d29e7f73f1$export$92521769c5df59ad);
$parcel$export(module.exports, "constructDateTimeFromPartialData", () => $9162a9d29e7f73f1$export$9fea7babeb5d6905);

var $57raR = parcelRequire("57raR");
var $ibLUB = parcelRequire("ibLUB");
var $cT05m = parcelRequire("cT05m");

var $igoRN = parcelRequire("igoRN");

var $dO9h7 = parcelRequire("dO9h7");
function $9162a9d29e7f73f1$var$getLocalisedTimeString(intervalTime, intervalString, userLocale) {
    if (userLocale) {
        const normalizedLocale = userLocale.replace(/_/g, '-');
        return new Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(intervalTime);
    }
    return intervalString;
}
function $9162a9d29e7f73f1$export$84c10da5aad3dff1(date, userLocale) {
    // Get the current date and time
    const now = date ?? new Date();
    // Format current time to 'HH:mm'
    const currentTime = (0, $57raR.default)(now, 'HH:mm');
    // Find the next interval
    for (const interval of (0, $igoRN.default)){
        // Parse the interval time to a Date object
        const intervalTime = (0, $cT05m.default)(interval, 'HH:mm', now);
        // Check if the interval is after the current time
        if ((0, $ibLUB.default)(intervalTime, now) || interval === currentTime) return $9162a9d29e7f73f1$var$getLocalisedTimeString(intervalTime, interval, userLocale);
    }
    const intervalTime = (0, $cT05m.default)((0, $igoRN.default)[0], 'HH:mm', now);
    // If no interval is found that is after the current time, return the first interval of the next day
    return $9162a9d29e7f73f1$var$getLocalisedTimeString(intervalTime, (0, $igoRN.default)[0], userLocale);
}
const $9162a9d29e7f73f1$export$92521769c5df59ad = (userLocale)=>{
    return (0, $dO9h7.formatWithLocale)(new Date(), 'P', userLocale);
};
const $9162a9d29e7f73f1$export$9fea7babeb5d6905 = (date, time)=>{
    if (!date && !time) return '';
    const referenceDate = new Date();
    let resultDate;
    if (date && !time) {
        resultDate = (0, $cT05m.default)(date, 'yyyy-MM-dd', referenceDate);
        const nextInterval = $9162a9d29e7f73f1$export$84c10da5aad3dff1();
        const parsedTime = (0, $cT05m.default)(nextInterval, 'HH:mm', referenceDate);
        resultDate.setHours(parsedTime.getHours(), parsedTime.getMinutes());
    } else if (time && !date) {
        resultDate = (0, $cT05m.default)(time, 'HH:mm', referenceDate);
        resultDate.setFullYear(referenceDate.getFullYear(), referenceDate.getMonth(), referenceDate.getDate());
    }
    return resultDate ? resultDate.toISOString() : '';
};

});

parcelRegister("c6Qqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b831cae045281da1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b831cae045281da1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "issue-field-date-time-inline-edit-full.date-time.error-title",
        "defaultMessage": "We couldn't set the date"
    },
    errorMessage: {
        "id": "issue-field-date-time-inline-edit-full.date-time.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});



parcelRegister("ce2G1", function(module, exports) {

$parcel$export(module.exports, "EpicLinkCell", () => $d6165bd703149427$export$6c1071448075813f);

var $edxwa = parcelRequire("edxwa");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $7jTnu = parcelRequire("7jTnu");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $8URAw = parcelRequire("8URAw");

var $1wTTU = parcelRequire("1wTTU");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $bBiKm = parcelRequire("bBiKm");
const $d6165bd703149427$var$getLozengeThemes = (0, $1wTTU.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $d6165bd703149427$var$getLozengeThemeByColor = (color = (0, $8URAw.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $d6165bd703149427$var$getLozengeThemes[color] ?? $d6165bd703149427$var$getLozengeThemes[0, $8URAw.DEFAULT_EPIC_COLOR]; // type assertion is fine as the record key is of type Color
const $d6165bd703149427$var$findColor = (color)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys((0, $8URAw.MAP_COLOR_TO_AK_COLOR)).find((key)=>(0, $8URAw.MAP_COLOR_TO_AK_COLOR)[key] === color);
const $d6165bd703149427$export$6c1071448075813f = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { epic: epic } = (0, $j4oe4.useFragment)((0, $edxwa.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)(); /**
                                                                           * As part of the initiative to remove "Epic Link" and "Parent Link" fields from Jira,
                                                                           * we're rendering a "Replaced by Parent field" deprecation message in the "Epic Link" cell.
                                                                           * At the time of writing this comment, "Epic Link" is still used in ~6% of issue tables, and
                                                                           * we hope this message will help these users migrate and use the "Parent" field from now on.
                                                                           */ 
    if ((0, $7jTnu.fg)('replace-epic-parent-link-by-depreca-message-in-nin')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "span",
        color: "color.text.subtlest",
        maxLines: isSingleLineRowHeightEnabled ? 1 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $bBiKm.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    as: "strong"
                }, chunks)
        }
    }));
    if (!epic) return null;
    if (epic.key == null || epic.summary == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "epicLink",
        reason: "Missing required fields"
    });
    const epicColor = (0, $1wTTU.asColor)(epic.color);
    const tagColor = (0, $8URAw.MAP_COLOR_TO_AK_COLOR)[epicColor];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d6165bd703149427$var$TagWrapper, {
        href: `/browse/${epic.key}`,
        "aria-label": `${formatMessage((0, $bBiKm.default).epicTitle)} ${epic.summary}`,
        style: $d6165bd703149427$var$getLozengeThemeByColor($d6165bd703149427$var$findColor(tagColor)),
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        }
    }, epic.summary);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6165bd703149427$var$TagWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _2rko1l7b _1e0c1o8l _s7n4nkob _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq _vchhusvi _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("edxwa", function(module, exports) {

$parcel$export(module.exports, "default", () => $355075266ee3b597$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cbbefe241979b3de7277fee2ab84498c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $355075266ee3b597$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "epicLink_nativeIssueTable_EpicLinkCell",
    "selections": [
        {
            "concreteType": "JiraEpic",
            "kind": "LinkedField",
            "name": "epic",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                }
            ]
        }
    ],
    "type": "JiraEpicLinkField"
};
$355075266ee3b597$var$node.hash = "0d48d484eeec312fafb57f96f453cf0f";
var $355075266ee3b597$export$2e2bcd8739ae039 = $355075266ee3b597$var$node;

});

parcelRegister("8URAw", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $f89c7f0e34657bc4$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $f89c7f0e34657bc4$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $f89c7f0e34657bc4$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $f89c7f0e34657bc4$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $f89c7f0e34657bc4$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $f89c7f0e34657bc4$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $f89c7f0e34657bc4$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $f89c7f0e34657bc4$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $f89c7f0e34657bc4$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $f89c7f0e34657bc4$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $f89c7f0e34657bc4$export$82fc3b0b98905453);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $f89c7f0e34657bc4$export$92b6aebfb522f0d9);

var $2IQEX = parcelRequire("2IQEX");


var $38IWH = parcelRequire("38IWH");
const $f89c7f0e34657bc4$export$c2357bec51c5cf5b = 'PURPLE';
const $f89c7f0e34657bc4$export$db33d74b098e3da9 = {
    [(0, $38IWH.PURPLE)]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $38IWH.BLUE)]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $38IWH.GREEN)]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $38IWH.TEAL)]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $38IWH.YELLOW)]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $38IWH.ORANGE)]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $38IWH.GREY)]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $38IWH.DARK_PURPLE)]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $38IWH.DARK_BLUE)]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $38IWH.DARK_GREEN)]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $38IWH.DARK_TEAL)]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $38IWH.DARK_YELLOW)]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $38IWH.DARK_ORANGE)]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $38IWH.DARK_GREY)]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $f89c7f0e34657bc4$export$fc5fe4213a5703f1 = {
    [(0, $7bb4c1736002a04a$exports).P200]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $7bb4c1736002a04a$exports).B200]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $7bb4c1736002a04a$exports).G200]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $7bb4c1736002a04a$exports).T200]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $7bb4c1736002a04a$exports).Y200]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $7bb4c1736002a04a$exports).R200]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $7bb4c1736002a04a$exports).N200]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $7bb4c1736002a04a$exports).P400]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $7bb4c1736002a04a$exports).B400]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $7bb4c1736002a04a$exports).G400]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $7bb4c1736002a04a$exports).T400]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $7bb4c1736002a04a$exports).Y400]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $7bb4c1736002a04a$exports).R400]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $7bb4c1736002a04a$exports).N700]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $f89c7f0e34657bc4$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$db33d74b098e3da9);
const $f89c7f0e34657bc4$export$43264b0781f10167 = {
    [(0, $38IWH.SERVER_PURPLE)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.SERVER_DARK_PURPLE)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.SERVER_BLUE)]: (0, $38IWH.BLUE),
    [(0, $38IWH.SERVER_DARK_BLUE)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.SERVER_GREEN)]: (0, $38IWH.GREEN),
    [(0, $38IWH.SERVER_DARK_GREEN)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.SERVER_TEAL)]: (0, $38IWH.TEAL),
    [(0, $38IWH.SERVER_DARK_TEAL)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.SERVER_YELLOW)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.SERVER_DARK_YELLOW)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.SERVER_ORANGE)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.SERVER_DARK_ORANGE)]: (0, $38IWH.DARK_ORANGE),
    [(0, $38IWH.SERVER_GREY)]: (0, $38IWH.GREY),
    [(0, $38IWH.SERVER_DARK_GREY)]: (0, $38IWH.DARK_GREY)
};
const $f89c7f0e34657bc4$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$43264b0781f10167);
const $f89c7f0e34657bc4$export$fb5d051fe1b2bccc = {
    [(0, $38IWH.GHX_LABEL_1)]: (0, $38IWH.DARK_GREY),
    [(0, $38IWH.GHX_LABEL_2)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.GHX_LABEL_3)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.GHX_LABEL_4)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.GHX_LABEL_5)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.GHX_LABEL_6)]: (0, $38IWH.GREEN),
    [(0, $38IWH.GHX_LABEL_7)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.GHX_LABEL_8)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.GHX_LABEL_9)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.GHX_LABEL_10)]: (0, $38IWH.BLUE),
    [(0, $38IWH.GHX_LABEL_11)]: (0, $38IWH.TEAL),
    [(0, $38IWH.GHX_LABEL_12)]: (0, $38IWH.GREY),
    [(0, $38IWH.GHX_LABEL_13)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.GHX_LABEL_14)]: (0, $38IWH.DARK_ORANGE)
};
const $f89c7f0e34657bc4$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$fb5d051fe1b2bccc);
const $f89c7f0e34657bc4$export$994d3ffa39be04fd = {
    [(0, $38IWH.AGILE_COLOR_1)]: (0, $38IWH.DARK_GREY),
    [(0, $38IWH.AGILE_COLOR_2)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.AGILE_COLOR_3)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.AGILE_COLOR_4)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.AGILE_COLOR_5)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.AGILE_COLOR_6)]: (0, $38IWH.GREEN),
    [(0, $38IWH.AGILE_COLOR_7)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.AGILE_COLOR_8)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.AGILE_COLOR_9)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.AGILE_COLOR_10)]: (0, $38IWH.BLUE),
    [(0, $38IWH.AGILE_COLOR_11)]: (0, $38IWH.TEAL),
    [(0, $38IWH.AGILE_COLOR_12)]: (0, $38IWH.GREY),
    [(0, $38IWH.AGILE_COLOR_13)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.AGILE_COLOR_14)]: (0, $38IWH.DARK_ORANGE)
};
const $f89c7f0e34657bc4$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$994d3ffa39be04fd);
const $f89c7f0e34657bc4$export$1fdd5a248b5f697c = {
    [(0, $38IWH.GHX_LABEL_1)]: (0, $38IWH.AGILE_COLOR_1),
    [(0, $38IWH.GHX_LABEL_2)]: (0, $38IWH.AGILE_COLOR_2),
    [(0, $38IWH.GHX_LABEL_3)]: (0, $38IWH.AGILE_COLOR_3),
    [(0, $38IWH.GHX_LABEL_4)]: (0, $38IWH.AGILE_COLOR_4),
    [(0, $38IWH.GHX_LABEL_5)]: (0, $38IWH.AGILE_COLOR_5),
    [(0, $38IWH.GHX_LABEL_6)]: (0, $38IWH.AGILE_COLOR_6),
    [(0, $38IWH.GHX_LABEL_7)]: (0, $38IWH.AGILE_COLOR_7),
    [(0, $38IWH.GHX_LABEL_8)]: (0, $38IWH.AGILE_COLOR_8),
    [(0, $38IWH.GHX_LABEL_9)]: (0, $38IWH.AGILE_COLOR_9),
    [(0, $38IWH.GHX_LABEL_10)]: (0, $38IWH.AGILE_COLOR_10),
    [(0, $38IWH.GHX_LABEL_11)]: (0, $38IWH.AGILE_COLOR_11),
    [(0, $38IWH.GHX_LABEL_12)]: (0, $38IWH.AGILE_COLOR_12),
    [(0, $38IWH.GHX_LABEL_13)]: (0, $38IWH.AGILE_COLOR_13),
    [(0, $38IWH.GHX_LABEL_14)]: (0, $38IWH.AGILE_COLOR_14)
};
const $f89c7f0e34657bc4$export$82fc3b0b98905453 = {
    [(0, $38IWH.DARK_GREY)]: 'grey',
    [(0, $38IWH.DARK_YELLOW)]: 'yellow',
    [(0, $38IWH.YELLOW)]: 'yellowLight',
    [(0, $38IWH.DARK_BLUE)]: 'blue',
    [(0, $38IWH.DARK_TEAL)]: 'teal',
    [(0, $38IWH.GREEN)]: 'greenLight',
    [(0, $38IWH.PURPLE)]: 'purpleLight',
    [(0, $38IWH.DARK_PURPLE)]: 'purple',
    [(0, $38IWH.ORANGE)]: 'redLight',
    [(0, $38IWH.BLUE)]: 'blueLight',
    [(0, $38IWH.TEAL)]: 'tealLight',
    [(0, $38IWH.GREY)]: 'greyLight',
    [(0, $38IWH.DARK_GREEN)]: 'green',
    [(0, $38IWH.DARK_ORANGE)]: 'red'
};
const $f89c7f0e34657bc4$export$703aca53c431bb88 = {
    [(0, $38IWH.AGILE_COLOR_1)]: 'grey',
    [(0, $38IWH.AGILE_COLOR_2)]: 'yellow',
    [(0, $38IWH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $38IWH.AGILE_COLOR_4)]: 'blue',
    [(0, $38IWH.AGILE_COLOR_5)]: 'teal',
    [(0, $38IWH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $38IWH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $38IWH.AGILE_COLOR_8)]: 'purple',
    [(0, $38IWH.AGILE_COLOR_9)]: 'redLight',
    [(0, $38IWH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $38IWH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $38IWH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $38IWH.AGILE_COLOR_13)]: 'green',
    [(0, $38IWH.AGILE_COLOR_14)]: 'red'
};
const $f89c7f0e34657bc4$export$92b6aebfb522f0d9 = {
    [(0, $38IWH.PURPLE)]: {
        primary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        secondary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        text: "var(--ds-text-accent-purple, #5E4DB2)",
        textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.BLUE)]: {
        primary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        secondary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        text: "var(--ds-text-accent-blue, #0055CC)",
        textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.GREEN)]: {
        primary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        secondary: "var(--ds-background-accent-green-bolder, #1F845A)",
        text: "var(--ds-text-accent-green, #216E4E)",
        textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.TEAL)]: {
        primary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        secondary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        text: "var(--ds-text-accent-teal, #206A83)",
        textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.YELLOW)]: {
        primary: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        secondary: "var(--ds-background-accent-yellow-bolder, #946F00)",
        text: "var(--ds-text-accent-yellow, #7F5F01)",
        textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        border: "var(--ds-border-accent-yellow, #B38600)",
        line: "var(--ds-border-accent-yellow, #B38600)",
        primaryGradient: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.ORANGE)]: {
        primary: "var(--ds-background-accent-red-subtle, #F87168)",
        secondary: "var(--ds-background-accent-red-bolder, #C9372C)",
        text: "var(--ds-text-accent-red, #AE2E24)",
        textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        border: "var(--ds-border-accent-red, #E2483D)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.GREY)]: {
        primary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        secondary: "var(--ds-background-accent-gray-bolder, #626F86)",
        text: "var(--ds-text-accent-gray, #44546F)",
        textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        border: "var(--ds-border-accent-gray, #758195)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.DARK_PURPLE)]: {
        primary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        secondary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_BLUE)]: {
        primary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        secondary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtle, #579DFF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_GREEN)]: {
        primary: "var(--ds-background-accent-green-bolder, #1F845A)",
        secondary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtle, #4BCE97)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_TEAL)]: {
        primary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        secondary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_YELLOW)]: {
        primary: "var(--ds-background-accent-orange-bolder, #C25100)",
        secondary: "var(--ds-background-accent-orange-subtle, #FEA362)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
        border: "var(--ds-background-accent-orange-subtle, #FEA362)",
        line: "var(--ds-border-accent-orange, #E56910)",
        primaryGradient: "var(--ds-background-accent-orange-subtle, #FEA362)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_ORANGE)]: {
        primary: "var(--ds-background-accent-red-bolder, #C9372C)",
        secondary: "var(--ds-background-accent-red-subtle, #F87168)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
        border: "var(--ds-background-accent-red-subtle, #F87168)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtle, #F87168)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_GREY)]: {
        primary: "var(--ds-background-accent-gray-bolder, #626F86)",
        secondary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
        border: "var(--ds-background-accent-gray-subtle, #8590A2)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtle, #8590A2)",
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("2IQEX", function(module, exports) {

var $9hKkF = parcelRequire("9hKkF");

var $h3TKx = parcelRequire("h3TKx");

var $d7YnM = parcelRequire("d7YnM");
/** Used for built-in method references. */ var $1fb889f558f23ac4$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1fb889f558f23ac4$var$nativeObjectToString = $1fb889f558f23ac4$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $1fb889f558f23ac4$var$invert = $h3TKx(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $1fb889f558f23ac4$var$nativeObjectToString.call(value);
    result[value] = key;
}, $9hKkF($d7YnM));
module.exports = $1fb889f558f23ac4$var$invert;

});
parcelRegister("h3TKx", function(module, exports) {

var $8uipj = parcelRequire("8uipj");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $c6bdf63192b21f8e$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $8uipj(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $c6bdf63192b21f8e$var$createInverter;

});
parcelRegister("8uipj", function(module, exports) {

var $75Jcs = parcelRequire("75Jcs");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $62df67589f85c449$var$baseInverter(object, setter, iteratee, accumulator) {
    $75Jcs(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $62df67589f85c449$var$baseInverter;

});



var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("38IWH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $92f22b7535e1838e$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $92f22b7535e1838e$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $92f22b7535e1838e$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $92f22b7535e1838e$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $92f22b7535e1838e$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $92f22b7535e1838e$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $92f22b7535e1838e$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $92f22b7535e1838e$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $92f22b7535e1838e$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $92f22b7535e1838e$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $92f22b7535e1838e$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $92f22b7535e1838e$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $92f22b7535e1838e$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $92f22b7535e1838e$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $92f22b7535e1838e$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $92f22b7535e1838e$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $92f22b7535e1838e$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $92f22b7535e1838e$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $92f22b7535e1838e$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $92f22b7535e1838e$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $92f22b7535e1838e$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $92f22b7535e1838e$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $92f22b7535e1838e$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $92f22b7535e1838e$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $92f22b7535e1838e$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $92f22b7535e1838e$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $92f22b7535e1838e$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $92f22b7535e1838e$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $92f22b7535e1838e$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $92f22b7535e1838e$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $92f22b7535e1838e$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $92f22b7535e1838e$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $92f22b7535e1838e$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $92f22b7535e1838e$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $92f22b7535e1838e$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $92f22b7535e1838e$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $92f22b7535e1838e$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $92f22b7535e1838e$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $92f22b7535e1838e$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $92f22b7535e1838e$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $92f22b7535e1838e$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $92f22b7535e1838e$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $92f22b7535e1838e$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $92f22b7535e1838e$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $92f22b7535e1838e$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $92f22b7535e1838e$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $92f22b7535e1838e$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $92f22b7535e1838e$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $92f22b7535e1838e$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $92f22b7535e1838e$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $92f22b7535e1838e$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $92f22b7535e1838e$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $92f22b7535e1838e$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $92f22b7535e1838e$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $92f22b7535e1838e$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $92f22b7535e1838e$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $92f22b7535e1838e$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $92f22b7535e1838e$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $92f22b7535e1838e$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $92f22b7535e1838e$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $92f22b7535e1838e$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $92f22b7535e1838e$export$7ffdeca4b2f927a2 = 'PURPLE';
const $92f22b7535e1838e$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $92f22b7535e1838e$export$738c3b9a44c87ecc = 'BLUE';
const $92f22b7535e1838e$export$1225f83626261b80 = 'DARK_BLUE';
const $92f22b7535e1838e$export$48d4b2cd5bc0e88b = 'GREEN';
const $92f22b7535e1838e$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $92f22b7535e1838e$export$d0446fe88325854e = 'TEAL';
const $92f22b7535e1838e$export$bb848c92687e69dc = 'DARK_TEAL';
const $92f22b7535e1838e$export$aab610c505c06a8f = 'YELLOW';
const $92f22b7535e1838e$export$466af87757d343a2 = 'DARK_YELLOW';
const $92f22b7535e1838e$export$3de5e29ed1757f9b = 'ORANGE';
const $92f22b7535e1838e$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $92f22b7535e1838e$export$7d278ca694634874 = 'GREY';
const $92f22b7535e1838e$export$26453300bfc61cb8 = 'DARK_GREY';
const $92f22b7535e1838e$export$56d196d2844d1ca1 = [
    $92f22b7535e1838e$export$7ffdeca4b2f927a2,
    $92f22b7535e1838e$export$c815fe495e8174a0,
    $92f22b7535e1838e$export$738c3b9a44c87ecc,
    $92f22b7535e1838e$export$1225f83626261b80,
    $92f22b7535e1838e$export$48d4b2cd5bc0e88b,
    $92f22b7535e1838e$export$c6f4cf2e5768eb78,
    $92f22b7535e1838e$export$d0446fe88325854e,
    $92f22b7535e1838e$export$bb848c92687e69dc,
    $92f22b7535e1838e$export$aab610c505c06a8f,
    $92f22b7535e1838e$export$466af87757d343a2,
    $92f22b7535e1838e$export$3de5e29ed1757f9b,
    $92f22b7535e1838e$export$da02e4820b6ab753,
    $92f22b7535e1838e$export$7d278ca694634874,
    $92f22b7535e1838e$export$26453300bfc61cb8
];
const $92f22b7535e1838e$export$792af22a0198af8d = 'purple';
const $92f22b7535e1838e$export$588af712afdcb006 = 'dark_purple';
const $92f22b7535e1838e$export$84c4918645391802 = 'blue';
const $92f22b7535e1838e$export$b8f1f5838352a33a = 'dark_blue';
const $92f22b7535e1838e$export$9384b7e350ee6542 = 'green';
const $92f22b7535e1838e$export$87d3fb8d8656d38b = 'dark_green';
const $92f22b7535e1838e$export$b0b4ce3e99e66aae = 'teal';
const $92f22b7535e1838e$export$a89b77a449bd223e = 'dark_teal';
const $92f22b7535e1838e$export$9a33b5e3cde94885 = 'yellow';
const $92f22b7535e1838e$export$33253d7862bceb8a = 'dark_yellow';
const $92f22b7535e1838e$export$6609c2b23fc42f39 = 'orange';
const $92f22b7535e1838e$export$cd994662b5911917 = 'dark_orange';
const $92f22b7535e1838e$export$1793d43e13e078c5 = 'grey';
const $92f22b7535e1838e$export$487a6e9145526564 = 'dark_grey';
const $92f22b7535e1838e$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $92f22b7535e1838e$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $92f22b7535e1838e$export$94ac87c81ed074a7 = 'ghx-label-3';
const $92f22b7535e1838e$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $92f22b7535e1838e$export$610a2c132b6fcf96 = 'ghx-label-5';
const $92f22b7535e1838e$export$8e4997dba71f1c40 = 'ghx-label-6';
const $92f22b7535e1838e$export$18a545b4e69b27b4 = 'ghx-label-7';
const $92f22b7535e1838e$export$27fff1a0d295292a = 'ghx-label-8';
const $92f22b7535e1838e$export$e57aa662a56724e1 = 'ghx-label-9';
const $92f22b7535e1838e$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $92f22b7535e1838e$export$457ecb9560f2bf83 = 'ghx-label-11';
const $92f22b7535e1838e$export$a866db37165a696c = 'ghx-label-12';
const $92f22b7535e1838e$export$9b18447c1168a1b6 = 'ghx-label-13';
const $92f22b7535e1838e$export$93b9ad4020e271b7 = 'ghx-label-14';
const $92f22b7535e1838e$export$5cd2af17b34de3e3 = 'color_1';
const $92f22b7535e1838e$export$987671fa69482a7b = 'color_2';
const $92f22b7535e1838e$export$70ba8a5b1f4c7446 = 'color_3';
const $92f22b7535e1838e$export$fcd1c42d8d3ebd36 = 'color_4';
const $92f22b7535e1838e$export$f80a5bd2fa0ba256 = 'color_5';
const $92f22b7535e1838e$export$37ad5ce8d2aeaf78 = 'color_6';
const $92f22b7535e1838e$export$9dc62d5d151cb355 = 'color_7';
const $92f22b7535e1838e$export$1ed15b30f5663f92 = 'color_8';
const $92f22b7535e1838e$export$5d23a84d55ac1644 = 'color_9';
const $92f22b7535e1838e$export$bf08c9a6ed42e349 = 'color_10';
const $92f22b7535e1838e$export$66c5d8f0b5ff279c = 'color_11';
const $92f22b7535e1838e$export$da30755a37c3a597 = 'color_12';
const $92f22b7535e1838e$export$721cf84faff6bf19 = 'color_13';
const $92f22b7535e1838e$export$4b8f8666bd7b61dd = 'color_14';
const $92f22b7535e1838e$export$c537fa0d021d010b = {
    PURPLE: $92f22b7535e1838e$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $92f22b7535e1838e$export$c815fe495e8174a0,
    BLUE: $92f22b7535e1838e$export$738c3b9a44c87ecc,
    DARK_BLUE: $92f22b7535e1838e$export$1225f83626261b80,
    GREEN: $92f22b7535e1838e$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $92f22b7535e1838e$export$c6f4cf2e5768eb78,
    TEAL: $92f22b7535e1838e$export$d0446fe88325854e,
    DARK_TEAL: $92f22b7535e1838e$export$bb848c92687e69dc,
    YELLOW: $92f22b7535e1838e$export$aab610c505c06a8f,
    DARK_YELLOW: $92f22b7535e1838e$export$466af87757d343a2,
    ORANGE: $92f22b7535e1838e$export$3de5e29ed1757f9b,
    DARK_ORANGE: $92f22b7535e1838e$export$da02e4820b6ab753,
    GREY: $92f22b7535e1838e$export$7d278ca694634874,
    DARK_GREY: $92f22b7535e1838e$export$26453300bfc61cb8
};
const $92f22b7535e1838e$export$d33d39828a18210a = {
    SERVER_PURPLE: $92f22b7535e1838e$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $92f22b7535e1838e$export$588af712afdcb006,
    SERVER_BLUE: $92f22b7535e1838e$export$84c4918645391802,
    SERVER_DARK_BLUE: $92f22b7535e1838e$export$b8f1f5838352a33a,
    SERVER_GREEN: $92f22b7535e1838e$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $92f22b7535e1838e$export$87d3fb8d8656d38b,
    SERVER_TEAL: $92f22b7535e1838e$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $92f22b7535e1838e$export$a89b77a449bd223e,
    SERVER_YELLOW: $92f22b7535e1838e$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $92f22b7535e1838e$export$33253d7862bceb8a,
    SERVER_ORANGE: $92f22b7535e1838e$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $92f22b7535e1838e$export$cd994662b5911917,
    SERVER_GREY: $92f22b7535e1838e$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $92f22b7535e1838e$export$487a6e9145526564
};
const $92f22b7535e1838e$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $92f22b7535e1838e$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $92f22b7535e1838e$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $92f22b7535e1838e$export$94ac87c81ed074a7,
    GHX_LABEL_4: $92f22b7535e1838e$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $92f22b7535e1838e$export$610a2c132b6fcf96,
    GHX_LABEL_6: $92f22b7535e1838e$export$8e4997dba71f1c40,
    GHX_LABEL_7: $92f22b7535e1838e$export$18a545b4e69b27b4,
    GHX_LABEL_8: $92f22b7535e1838e$export$27fff1a0d295292a,
    GHX_LABEL_9: $92f22b7535e1838e$export$e57aa662a56724e1,
    GHX_LABEL_10: $92f22b7535e1838e$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $92f22b7535e1838e$export$457ecb9560f2bf83,
    GHX_LABEL_12: $92f22b7535e1838e$export$a866db37165a696c,
    GHX_LABEL_13: $92f22b7535e1838e$export$9b18447c1168a1b6,
    GHX_LABEL_14: $92f22b7535e1838e$export$93b9ad4020e271b7
};
const $92f22b7535e1838e$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $92f22b7535e1838e$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $92f22b7535e1838e$export$987671fa69482a7b,
    AGILE_COLOR_3: $92f22b7535e1838e$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $92f22b7535e1838e$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $92f22b7535e1838e$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $92f22b7535e1838e$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $92f22b7535e1838e$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $92f22b7535e1838e$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $92f22b7535e1838e$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $92f22b7535e1838e$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $92f22b7535e1838e$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $92f22b7535e1838e$export$da30755a37c3a597,
    AGILE_COLOR_13: $92f22b7535e1838e$export$721cf84faff6bf19,
    AGILE_COLOR_14: $92f22b7535e1838e$export$4b8f8666bd7b61dd
};

});


parcelRegister("1wTTU", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $b36086cea9eb1a24$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $b36086cea9eb1a24$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $b36086cea9eb1a24$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $b36086cea9eb1a24$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $b36086cea9eb1a24$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $b36086cea9eb1a24$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $b36086cea9eb1a24$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $b36086cea9eb1a24$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $b36086cea9eb1a24$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $b36086cea9eb1a24$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $b36086cea9eb1a24$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $b36086cea9eb1a24$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $b36086cea9eb1a24$export$e4369cabd7e84cd9);

var $2IQEX = parcelRequire("2IQEX");

var $38IWH = parcelRequire("38IWH");

var $8URAw = parcelRequire("8URAw");

var $efpPR = parcelRequire("efpPR");
const $b36086cea9eb1a24$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $38IWH.Colors).PURPLE;
    if (color in (0, $38IWH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $38IWH.Colors).PURPLE;
};
const $b36086cea9eb1a24$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $38IWH.ServerColors).SERVER_PURPLE;
    if (color in (0, $38IWH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_AGILE_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $8URAw.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $38IWH.ServerColors).SERVER_PURPLE;
};
const $b36086cea9eb1a24$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $38IWH.Colors).PURPLE];
    if (color in (0, $38IWH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $8URAw.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_AGILE_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $8URAw.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $38IWH.Colors).PURPLE];
};
const $b36086cea9eb1a24$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $38IWH.Colors).PURPLE];
    if (color in (0, $38IWH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $8URAw.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $38IWH.Colors).PURPLE];
};
const $b36086cea9eb1a24$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $8URAw.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $38IWH.Colors)));
    return extendedColors.reduce((obj, color)=>Object.assign(obj, {
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $b36086cea9eb1a24$export$a00423580059ae28 = (color)=>(0, $8URAw.MAP_COLORS_TO_VALUE)[color] || (0, $8URAw.MAP_COLORS_TO_VALUE)[0, $38IWH.PURPLE];
const $b36086cea9eb1a24$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))((0, $8URAw.MAP_COLORS_TO_VALUE))[value] || (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $8URAw.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$47af25386a01de1 = (color)=>(0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $b36086cea9eb1a24$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$28fb68bb1de025d5 = (color)=>(0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $b36086cea9eb1a24$var$paletteColorValues = $b36086cea9eb1a24$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $b36086cea9eb1a24$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $efpPR.default).purpleLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $efpPR.default).blueLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $efpPR.default).greenLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $efpPR.default).tealLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $efpPR.default).yellowLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $efpPR.default).orangeLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $efpPR.default).greyLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).GREY]
        },
        {
            label: formatMessage((0, $efpPR.default).darkPurpleLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkBlueLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkGreenLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $efpPR.default).darkTealLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $efpPR.default).darkYellowLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $efpPR.default).darkOrangeLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkGreyLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_GREY]
        }
    ];
const $b36086cea9eb1a24$export$9b822862d986dfdf = $b36086cea9eb1a24$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $b36086cea9eb1a24$export$949dc67535a8ff2 = (color = (0, $8URAw.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $b36086cea9eb1a24$export$9b822862d986dfdf[color] ?? $b36086cea9eb1a24$export$9b822862d986dfdf[0, $8URAw.DEFAULT_EPIC_COLOR];
const $b36086cea9eb1a24$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $38IWH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("efpPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a8789e55bcd8e1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f5a8789e55bcd8e1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


parcelRegister("bBiKm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3241fb4419868a9b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3241fb4419868a9b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    epicTitle: {
        "id": "native-issue-table.common.issue-cells.epic-link.epic-title",
        "defaultMessage": "Click to visit"
    },
    replacedByParentField: {
        "id": "issue-create-commons.common.fields.epic-link-parent-link-disabled.replaced-by-parent-field",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});

});


parcelRegister("6HQQO", function(module, exports) {

$parcel$export(module.exports, "FallbackCell", () => $1de66a7562a0c870$export$de9d519be820a473);

var $kVWxC = parcelRequire("kVWxC");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $9Mapt = parcelRequire("9Mapt");

var $jd93d = parcelRequire("jd93d");

var $7jTnu = parcelRequire("7jTnu");

var $3OT15 = parcelRequire("3OT15");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $1de66a7562a0c870$var$TYPES_TO_REMOVE_TITLE = new Set([
    'lastViewed'
]); /**
                                                        * Render fallback version of the issue field cell that is generated by the backend.
                                                        * We trust the backend to do all HTML entity encoding and other sanitization.
                                                        */ 
const $1de66a7562a0c870$export$de9d519be820a473 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $kVWxC.default), fieldRef);
    const { renderedFieldHtml: renderedFieldHtml, type: type } = data;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $eJOHy.useRef)(null);
    const removeTitleAttributeRef = (0, $eJOHy.useCallback)((el)=>{
        if (!$1de66a7562a0c870$var$TYPES_TO_REMOVE_TITLE.has(type)) return;
        el?.querySelectorAll('[title]').forEach((node)=>{
            node.removeAttribute('title');
        });
    }, [
        type
    ]);
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (renderedFieldHtml == null) return /*#__PURE__*/ $eJOHy.createElement((0, $86BUM.default), {
        cellType: "fallback",
        reason: "Missing required fields"
    });
    if (!renderedFieldHtml.trim().length) return null;
    let hoverPopoverRef = null;
    switch(type){
        case 'thumbnail':
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            },
                            className: (0, $hcewu.default)([
                                "_1jpx1f51 _rtys1osq _19l31osq"
                            ])
                        }),
                        alwaysShow: true
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$AttachmentFallbackContainer, {
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                        ref: hoverPopoverRef
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        className: (0, $hcewu.default)([
                            "_1jpx1f51 _rtys1osq _19l31osq"
                        ])
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$AttachmentFallbackContainer, {
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                        ref: ref
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$AttachmentFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                },
                isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
            });
        case 'progress':
        case 'aggregateprogress':
            // No need for hover popover for progress as contents (graphic) is responsive to cell width
            return /*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$ProgressFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.progress-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        case 'com.atlassian.servicedesk:sd-request-feedback':
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            }
                        })
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$SatisfactionFallbackContainer, {
                        ref: hoverPopoverRef,
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    contentRef: contentRef,
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        }
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$SatisfactionFallbackContainer, {
                        ref: (0, $jd93d.mergeRefs)(contentRef, ref),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$SatisfactionFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        case 'com.atlassian.servicedesk:sd-sla-field':
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            }
                        })
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$SlaFallbackContainer, {
                        ref: hoverPopoverRef,
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    contentRef: contentRef,
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        }
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$SlaFallbackContainer, {
                        ref: (0, $jd93d.mergeRefs)(contentRef, ref),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$SlaFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        default:
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            }
                        })
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$FallbackContainer, {
                        ref: (0, $jd93d.mergeRefs)(hoverPopoverRef, removeTitleAttributeRef),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    contentRef: contentRef,
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        }
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$FallbackContainer, {
                        ref: (0, $jd93d.mergeRefs)(contentRef, ref, removeTitleAttributeRef),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($1de66a7562a0c870$var$FallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
    }
});
/**
 * Disabling selector eslint rules because we must provide the fallback style overrides this way due
 * to the markup and base styles coming from the monolith.
 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1de66a7562a0c870$var$FallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1rjc1b66 _18zru2gc _p12f1osq _1bto1l2s _bna71wug _rtys1osq",
            __cmplp && "_o5721q9c _wmb415vq _12ev15vq _5c4l1l2s _1e4iglyw",
            __cmplp.className
        ])
    });
});
const $1de66a7562a0c870$var$attachmentPopoverStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1de66a7562a0c870$var$AttachmentFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $1de66a7562a0c870$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bna71wug _19l3uuw1 _mezj1wug _rtys1osq",
            __cmplp && "_1rjcv77o _1e0c1txw _1bah1h6o _4cvr1h6o _19l31ul9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1de66a7562a0c870$var$ProgressFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $1de66a7562a0c870$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz4idpf _1lms18uv _xu7xt94y _19jqt94y _iv7lt94y _18m0t94y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1de66a7562a0c870$var$SatisfactionFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $1de66a7562a0c870$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_nmi71oqg _17go131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1de66a7562a0c870$var$SlaFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $1de66a7562a0c870$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1xngu2gc _1kss1txw _1v441h6o _1fecusic _1op7t9kd _i95c17hp _c4xnnbxb _1mf8wdcn _10ku8uof _m1tonbxb _g3h87r97",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kVWxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0aadb3379a980af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1dfee546ccadf3c26bb4b95fc50428f9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c0aadb3379a980af$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "fallback_nativeIssueTable_FallbackCell",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "renderedFieldHtml"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        }
    ],
    "type": "JiraFallbackField"
};
$c0aadb3379a980af$var$node.hash = "f6db480e9fa3aceb9daa6c2c472e9fac";
var $c0aadb3379a980af$export$2e2bcd8739ae039 = $c0aadb3379a980af$var$node;

});


parcelRegister("9GFuY", function(module, exports) {

$parcel$export(module.exports, "FlagCell", () => $ffc9a77a317ffc33$export$be4c47c19457cd1e);

var $2OVdm = parcelRequire("2OVdm");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $kePo9 = parcelRequire("kePo9");
const $ffc9a77a317ffc33$export$be4c47c19457cd1e = ({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $2OVdm.default), fieldRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return data.flag?.isFlagged && formatMessage((0, $kePo9.default).flagged);
};

});
parcelRegister("2OVdm", function(module, exports) {

$parcel$export(module.exports, "default", () => $57c7101aa6975243$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03ad9db22088fdd1e457a5121db18df3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $57c7101aa6975243$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "flag_nativeIssueTable_FlagCell",
    "selections": [
        {
            "concreteType": "JiraFlag",
            "kind": "LinkedField",
            "name": "flag",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFlagged"
                }
            ]
        }
    ],
    "type": "JiraFlagField"
};
$57c7101aa6975243$var$node.hash = "31300af4f47b42a3abf7e459bcad4233";
var $57c7101aa6975243$export$2e2bcd8739ae039 = $57c7101aa6975243$var$node;

});

parcelRegister("kePo9", function(module, exports) {

$parcel$export(module.exports, "default", () => $44166ff552e5c007$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $44166ff552e5c007$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    flagged: {
        "id": "native-issue-table.common.issue-cells.flag.flagged",
        "defaultMessage": "Impediment"
    }
});

});


parcelRegister("j1xvD", function(module, exports) {

$parcel$export(module.exports, "GoalsCell", () => $f622a83b6f9c6d5f$export$aea87ff07be8100d);

var $cRyce = parcelRequire("cRyce");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $dHPoe = parcelRequire("dHPoe");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");
const $f622a83b6f9c6d5f$export$aea87ff07be8100d = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $cRyce.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled && (0, $7jTnu.fg)('jsc_goals_inline_edit') ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldTruncate = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dHPoe.GoalsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: shouldTruncate
    });
};

});
parcelRegister("cRyce", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4c62e2a9fe0a376$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<138238bf08ff12610c67c9c231c87b2f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c4c62e2a9fe0a376$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "goals_nativeIssueTable_GoalsCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraGoalsField"
};
$c4c62e2a9fe0a376$var$node.hash = "c06d2cf0d8aec11ffdbf49b380c6dd10";
var $c4c62e2a9fe0a376$export$2e2bcd8739ae039 = $c4c62e2a9fe0a376$var$node;

});

parcelRegister("dHPoe", function(module, exports) {

$parcel$export(module.exports, "GoalsInlineEditViewWithIsEditable", () => $b69d8ff6824a40f6$export$16ba9f62f4ede1d3);

var $bb4YW = parcelRequire("bb4YW");

var $f47Or = parcelRequire("f47Or");

var $6z2Km = parcelRequire("6z2Km");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $kqd31 = parcelRequire("kqd31");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $jZbQD = parcelRequire("jZbQD");

var $kEUB1 = parcelRequire("kEUB1");

var $byUzi = parcelRequire("byUzi");

var $auNLL = parcelRequire("auNLL");

var $knIOf = parcelRequire("knIOf");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $b69d8ff6824a40f6$var$isEqualOption = (a, b)=>{
    if (a.length !== b.length) return false;
    const aUrlSet = new Set(a.map((option)=>option.url));
    return b.every((option)=>aUrlSet.has(option.url));
};
const $b69d8ff6824a40f6$var$JIRA_GOAL_TYPENAME = 'JiraGoal';
const $b69d8ff6824a40f6$var$JIRA_GOAL_EDGE_TYPENAME = 'JiraGoalEdge';
const $b69d8ff6824a40f6$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-goals-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $b69d8ff6824a40f6$export$16ba9f62f4ede1d3 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $6z2Km.default), fragmentRef);
    // for the mutation, only need to worry about the deletion / removal
    // don't worry about insertion as that's handled by the townsquare goal picker
    const [commit] = (0, $j4oe4.useMutation)((0, $f47Or.default));
    // #endregion Relay
    // #region State
    const constructGoalUrl = (0, $byUzi.useGoalUrlConstructor)();
    const { __id: __id, id: uniqueFieldId, name: name, type: fieldType, selectedGoals: selectedGoals, issue: issue } = data;
    const selectedGoalsConnectionId = selectedGoals?.__id;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        const nodes = selectedGoals?.edges?.map((edge)=>edge?.node)?.filter((node)=>Boolean(node?.key)) ?? [];
        return nodes.map((node)=>({
                id: node.id,
                url: constructGoalUrl(node.key)
            }));
    }, [
        constructGoalUrl,
        selectedGoals?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #region Action
    const updater = (0, $eJOHy.useCallback)((store, value)=>{
        const connection = selectedGoalsConnectionId ? store.get(selectedGoalsConnectionId) : null;
        if (!connection) return;
        const { EDGES: EDGES, NODE: NODE } = (0, $37Ewn.ConnectionInterface).get();
        const edges = connection.getLinkedRecords(EDGES) ?? [];
        const edgesByNodeId = {};
        edges.forEach((edge)=>{
            const nodeId = edge.getLinkedRecord(NODE)?.getValue('id');
            if (typeof nodeId === 'string') edgesByNodeId[nodeId] = edge;
        });
        const nextEdges = [];
        value.forEach(({ id: id, url: url })=>{
            if (id && id in edgesByNodeId) nextEdges.push(edgesByNodeId[id]);
            else {
                const nodeRelayDataId = (0, $kqd31.default)({
                    id: id
                }, $b69d8ff6824a40f6$var$JIRA_GOAL_TYPENAME);
                const key = (0, $byUzi.getGoalKeyFromUrl)(url);
                if (nodeRelayDataId) {
                    let node = store.get(nodeRelayDataId);
                    if (!node) {
                        node = store.create(nodeRelayDataId, $b69d8ff6824a40f6$var$JIRA_GOAL_TYPENAME);
                        node.setValue(nodeRelayDataId, 'id');
                    }
                    if (key) node.setValue(key, 'key');
                    const edge = (0, $j4oe4.ConnectionHandler).createEdge(store, connection, node, $b69d8ff6824a40f6$var$JIRA_GOAL_EDGE_TYPENAME);
                    nextEdges.push(edge);
                }
            }
        });
        connection.setLinkedRecords(nextEdges, EDGES);
    }, [
        selectedGoalsConnectionId
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        const initialIds = initialValue.map(({ id: id })=>id).filter(Boolean);
        const initialIdSet = new Set(initialIds);
        const updatedIds = value.map(({ id: id })=>id).filter(Boolean);
        const updatedIdSet = new Set(updatedIds);
        const deletedRelationships = initialIds.filter((id)=>!updatedIdSet.has(id)).map((id)=>({
                from: issue.id,
                to: id
            }));
        const createdRelationships = updatedIds.filter((id)=>!initialIdSet.has(id)).map((id)=>({
                from: issue.id,
                to: id
            }));
        commit({
            variables: {
                createInput: {
                    relationships: createdRelationships
                },
                deleteInput: {
                    relationships: deletedRelationships
                }
            },
            updater: (store)=>updater(store, value),
            optimisticUpdater: (store)=>updater(store, value),
            onCompleted (mutationData) {
                if (mutationData.townsquare?.createRelationships?.success && mutationData.townsquare?.deleteRelationships?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                townsquare: {
                    createRelationships: {
                        success: true,
                        relationships: createdRelationships
                    },
                    deleteRelationships: {
                        success: true,
                        relationships: deletedRelationships
                    }
                }
            }
        });
    }, [
        onSubmit,
        initialValue,
        commit,
        issue.id,
        updater
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $b69d8ff6824a40f6$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #endregion Action
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b69d8ff6824a40f6$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $knIOf.GoalsReadView), {
            fragmentRef: data,
            isTruncated: isTruncated
        }));
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            issueAri: issue.id,
            initialIsOpen: true,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing
        });
    const cloudId = (0, $kEUB1.useCloudId)();
    const editViewEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            issueAri: issue.id
        }), [
        cloudId,
        issue.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $jZbQD.default),
        editViewEntryPointParams: editViewEntryPointParams,
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
// #endregion Edit View
};
const $b69d8ff6824a40f6$export$fc2645c54795e7e6 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $bb4YW.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b69d8ff6824a40f6$export$16ba9f62f4ede1d3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("bb4YW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b263b3518298fbc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7542446408a11d8dcd6f34ea8741757a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7b263b3518298fbc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraGoalsField"
};
$7b263b3518298fbc$var$node.hash = "d698a934047d8a1aef53370ee1f7570c";
var $7b263b3518298fbc$export$2e2bcd8739ae039 = $7b263b3518298fbc$var$node;

});

parcelRegister("f47Or", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bcb9233c46e9d29$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57d11f4e2332b19d87c403e7d64ec868>>
 * @relayHash f896f939a1918da6870fd74a26e67107
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8dbb1de2807924cc75847f0e6cb98eddad0909f975f61d85473712a94f60740f
const $9bcb9233c46e9d29$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteInput"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "success"
        },
        {
            "concreteType": "TownsquareRelationship",
            "kind": "LinkedField",
            "name": "relationships",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "from"
                },
                {
                    "kind": "ScalarField",
                    "name": "to"
                }
            ]
        }
    ], v2 = [
        {
            "concreteType": "TownsquareMutationApi",
            "kind": "LinkedField",
            "name": "townsquare",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "createInput"
                        }
                    ],
                    "concreteType": "TownsquareCreateRelationshipsPayload",
                    "kind": "LinkedField",
                    "name": "createRelationships",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "deleteInput"
                        }
                    ],
                    "concreteType": "TownsquareDeleteRelationshipsPayload",
                    "kind": "LinkedField",
                    "name": "deleteRelationships",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "8dbb1de2807924cc75847f0e6cb98eddad0909f975f61d85473712a94f60740f",
            "metadata": {},
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9bcb9233c46e9d29$var$node.hash = "d5d407c381c2f478408ef64adaf27177";
var $9bcb9233c46e9d29$export$2e2bcd8739ae039 = $9bcb9233c46e9d29$var$node;

});

parcelRegister("6z2Km", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0c63300a1234272$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b806e0d4bbf68b8eb5cca1fbda58643>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0c63300a1234272$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v0 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issue"
            },
            {
                "kind": "FragmentSpread",
                "name": "goals_issueFieldGoalsReadviewFull_GoalsReadView"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    }
                                ]
                            }
                        ]
                    },
                    v1 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            v1 /*: any*/ 
        ],
        "type": "JiraGoalsField"
    };
}();
$b0c63300a1234272$var$node.hash = "46c4ce64c1ccf9c7ee8dc2090f374288";
var $b0c63300a1234272$export$2e2bcd8739ae039 = $b0c63300a1234272$var$node;

});

parcelRegister("jZbQD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b571ab63a42dd1e$export$2e2bcd8739ae039);

var $a8bi1 = parcelRequire("a8bi1");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7b571ab63a42dd1e$var$GoalsEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("i0yB0")), {
        moduleId: "8bcf8112",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueAri: issueAri })=>({
            queries: {
                mainGoalsPopupContentQuery: {
                    parameters: (0, $a8bi1.default),
                    variables: {
                        cloudId: cloudId,
                        issueAri: issueAri
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});
var $7b571ab63a42dd1e$export$2e2bcd8739ae039 = $7b571ab63a42dd1e$var$GoalsEditViewEntryPoint;

});
parcelRegister("a8bi1", function(module, exports) {

$parcel$export(module.exports, "default", () => $362b8360bbac003e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<781036c3adb06f7c77e174af35a312e4>>
 * @relayHash dd08e287770cfcb48d04f30c286fa246
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ba340bc8f8333ace2c167c4181ebb1a1b125ce0ea8cc34681f75c7ce6f76c2ef
const $362b8360bbac003e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "concreteType": "TownsquareUnshardedUserCapabilities",
        "kind": "LinkedField",
        "name": "userCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareUnshardedCapability",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "capability"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "capabilityContainer"
                    }
                ]
            }
        ]
    }, v5 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "issueAri"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        v5 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = [
        v8 /*: any*/ 
    ], v11 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v12 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v13 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v14 = [
        "id"
    ], v15 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainGoalsPopupContentQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueGoals_AtlassianGoalPicker"
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainGoalsPopupContentQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        },
                                                        v9 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareLocalizationField",
                                                                    "kind": "LinkedField",
                                                                    "name": "localizedLabel",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "messageId"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalIcon",
                                                            "kind": "LinkedField",
                                                            "name": "icon",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appearance"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareGoal"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ 
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "filters": v14 /*: any*/ ,
                            "handle": "connection",
                            "key": "LinkedGoals_jiraEpicContributesToAtlasGoal",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v15 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v10 /*: any*/ ,
                                                    "type": "TownsquareGoal"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v15 /*: any*/ ,
                            "filters": v14 /*: any*/ ,
                            "handle": "connection",
                            "key": "Goals_issueGoalPicker",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ba340bc8f8333ace2c167c4181ebb1a1b125ce0ea8cc34681f75c7ce6f76c2ef",
            "metadata": {},
            "name": "mainGoalsPopupContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$362b8360bbac003e$var$node.hash = "46961c295be31891ee43ef13cc35d017";
var $362b8360bbac003e$export$2e2bcd8739ae039 = $362b8360bbac003e$var$node;

});

parcelRegister("i0yB0", function(module, exports) {

let $d1c3101b0a85e64c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d1c3101b0a85e64c$var$load("ffQaD"),
    $d1c3101b0a85e64c$var$load("kvRbA"),
    $d1c3101b0a85e64c$var$load("76n7a"),
    $d1c3101b0a85e64c$var$load("l253H"),
    $d1c3101b0a85e64c$var$load("9ZmDf")
]).then(()=>parcelRequire('8gn0t'));

});


parcelRegister("byUzi", function(module, exports) {

$parcel$export(module.exports, "useGoalUrlConstructor", () => $3db898fb705dc57f$export$141a926c45c15603);
$parcel$export(module.exports, "getGoalKeyFromUrl", () => $3db898fb705dc57f$export$9bf22e4fb9891a0d);

var $eJOHy = parcelRequire("eJOHy");

var $g9Vr6 = parcelRequire("g9Vr6");

var $kEUB1 = parcelRequire("kEUB1");

var $g1NZW = parcelRequire("g1NZW");

const $3db898fb705dc57f$export$141a926c45c15603 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const isStagingOrDevOrLocal = (0, $g1NZW.useIsStagingOrDevOrLocal)();
    return (0, $eJOHy.useCallback)((goalKey)=>{
        const atlassianHomeUrl = isStagingOrDevOrLocal ? (0, $07a8c3e317a6072d$export$46b5a4e5fbe6e304) : (0, $07a8c3e317a6072d$export$732915c664dff395);
        return `${atlassianHomeUrl}/o/${orgId}/s/${cloudId}/goal/${goalKey}`;
    }, [
        cloudId,
        isStagingOrDevOrLocal,
        orgId
    ]);
};
const $3db898fb705dc57f$export$9bf22e4fb9891a0d = (url)=>url.split('/').pop();

});
const $07a8c3e317a6072d$export$732915c664dff395 = 'https://home.atlassian.com';
const $07a8c3e317a6072d$export$46b5a4e5fbe6e304 = 'https://home.stg.atlassian.com';


parcelRegister("knIOf", function(module, exports) {

$parcel$export(module.exports, "GoalsReadView", () => $1ca37a34ff4fe805$export$7f51e00c35102426);

var $ljlHd = parcelRequire("ljlHd");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $byUzi = parcelRequire("byUzi");

var $8lb7o = parcelRequire("8lb7o");

var $3PRLs = parcelRequire("3PRLs");

var $d9T1A = parcelRequire("d9T1A");

var $lRq8t = parcelRequire("lRq8t");

var $dLVMI = parcelRequire("dLVMI");

var $w8hPK = parcelRequire("w8hPK");
const $1ca37a34ff4fe805$export$7f51e00c35102426 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const constructGoalUrl = (0, $byUzi.useGoalUrlConstructor)();
    const { selectedGoals: selectedGoals } = (0, $j4oe4.useFragment)((0, $ljlHd.default), fragmentRef);
    const { firstGoal: firstGoal, totalGoalsCount: totalGoalsCount } = (0, $eJOHy.useMemo)(()=>{
        const nodes = selectedGoals?.edges?.map((edge)=>edge?.node)?.filter((node)=>Boolean(node?.key)) ?? [];
        const transformedNodes = nodes.map((node)=>({
                ...node,
                key: node.id,
                url: constructGoalUrl(node.key)
            }));
        return {
            firstGoal: transformedNodes[0],
            totalGoalsCount: transformedNodes.length
        };
    }, [
        constructGoalUrl,
        selectedGoals?.edges
    ]);
    if (totalGoalsCount === 0 || !selectedGoals) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lb7o.ItemWithEntryPointPopup), {
        ItemComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
            anchorTarget: "_blank",
            url: firstGoal.url
        }),
        totalItems: totalGoalsCount,
        isTruncated: isTruncated,
        entryPoint: (0, $dLVMI.goalsPopupContentEntryPoint),
        entryPointParams: {},
        entryPointRuntimeProps: {
            fragmentRef: selectedGoals
        },
        showMoreTooltip: formatMessage((0, $w8hPK.default).showMoreTooltip),
        actionSubjectIdPrefix: "goals"
    });
};

});
parcelRegister("ljlHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db57d336fee8eee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc3ad8e62c65a9e808cd72ccc0efee71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9db57d336fee8eee$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "goals_issueFieldGoalsReadviewFull_GoalsReadView",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraGoalConnection",
            "kind": "LinkedField",
            "name": "selectedGoals",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "popupContent_issueFieldGoalsReadviewFull"
                },
                {
                    "concreteType": "JiraGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraGoal",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedGoals(first:1000)"
        }
    ],
    "type": "JiraGoalsField"
};
$9db57d336fee8eee$var$node.hash = "13eae32e673f8f11067837df02577e03";
var $9db57d336fee8eee$export$2e2bcd8739ae039 = $9db57d336fee8eee$var$node;

});

parcelRegister("8lb7o", function(module, exports) {

$parcel$export(module.exports, "ItemWithEntryPointPopup", () => $14af9ae86efae763$export$15750a4e92a11aeb);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $l1Evt = parcelRequire("l1Evt");

var $l8oUV = parcelRequire("l8oUV");
const $14af9ae86efae763$export$15750a4e92a11aeb = ({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointRuntimeProps: entryPointRuntimeProps, ...props })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)(entryPoint, entryPointParams);
    const [retryKey, setRetryKey] = (0, $eJOHy.useState)(0);
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l1Evt.default), {
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        triggerRefCallback: triggerRef,
        entryPointActions: entryPointActions,
        PopupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            key: retryKey,
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "popup-content",
            packageName: "jiraItemWithPopup",
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l8oUV.ErrorFallback), {
                    onClick: ()=>setRetryKey((prev)=>prev + 1)
                }),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                padding: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            })),
            runtimeProps: entryPointRuntimeProps
        }),
        ...props
    });
};

});
parcelRegister("l1Evt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9039846db754c967$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6djmC = parcelRequire("6djmC");

var $7jTnu = parcelRequire("7jTnu");

var $ibVOD = parcelRequire("ibVOD");

var $1O6K6 = parcelRequire("1O6K6");
const $9039846db754c967$var$ItemWithPopup = ({ ItemComponent: ItemComponent, showMoreTooltip: showMoreTooltip, totalItems: totalItems, PopupComponent: PopupComponent, isOpen: isOpen, onSetIsOpen: onSetIsOpen, triggerRefCallback: triggerRefCallback, actionSubjectIdPrefix: actionSubjectIdPrefix, isTruncated: isTruncated = false, entryPointActions: entryPointActions })=>{
    if (ItemComponent === undefined) return null;
    const shouldTruncated = isTruncated && (0, $7jTnu.fg)('jsc_inline_editing_field_refactor');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !shouldTruncated
    }, ItemComponent, totalItems > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1O6K6.default), {
        showMoreTooltip: showMoreTooltip,
        totalItems: totalItems - 1,
        PopupComponent: PopupComponent,
        isOpen: isOpen,
        onSetIsOpen: onSetIsOpen,
        triggerRefCallback: triggerRefCallback,
        actionSubjectIdPrefix: actionSubjectIdPrefix,
        isTruncated: isTruncated,
        entryPointActions: entryPointActions
    })));
};
var $9039846db754c967$export$2e2bcd8739ae039 = $9039846db754c967$var$ItemWithPopup;

});
parcelRegister("1O6K6", function(module, exports) {

$parcel$export(module.exports, "default", () => $db629c491ab3411a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $2ZGUP = parcelRequire("2ZGUP");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $9Mapt = parcelRequire("9Mapt");
const $db629c491ab3411a$var$ShowMorePopup = ({ showMoreTooltip: showMoreTooltip, totalItems: totalItems, PopupComponent: PopupComponent, isOpen: isOpen, onSetIsOpen: onSetIsOpen, triggerRefCallback: triggerRefCallback, actionSubjectIdPrefix: actionSubjectIdPrefix, isTruncated: isTruncated, entryPointActions: entryPointActions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (totalItems === 0) return null;
    const onClickTrigger = ()=>{
        onSetIsOpen(!isOpen);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), `${actionSubjectIdPrefix}ItemWithPopup`);
    };
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $db629c491ab3411a$var$ContainerDialogStyles
        }, PopupComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null));
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (hoverProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: PopupComponent,
            entryPointActions: entryPointActions,
            isInteractive: true
        }, ({ ref: ref, ariaExpanded: ariaExpanded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                "aria-label": `${showMoreTooltip} +${totalItems}`,
                isSelected: isOpen,
                spacing: "none",
                "aria-expanded": ariaExpanded,
                testId: "item-with-popup.ui.item-with-popup.show-more-popup.button",
                ref: ref,
                ...hoverProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                as: "span",
                xcss: $db629c491ab3411a$var$itemsCountStyles,
                paddingInline: "space.050"
            }, "+", totalItems)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>onSetIsOpen(false),
        placement: "bottom",
        content: content,
        testId: "item-with-popup.ui.item-with-popup.show-more-popup.show-more-popup",
        messageId: "item-with-popup.ui.item-with-popup.show-more-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                key: "triggerLinksDialog",
                content: showMoreTooltip,
                tag: $db629c491ab3411a$var$TooltipContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                "aria-label": `${showMoreTooltip} +${totalItems}`,
                isSelected: isOpen,
                onClick: onClickTrigger,
                spacing: "none",
                ref: (element)=>{
                    triggerRefCallback && triggerRefCallback(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                as: "span",
                xcss: $db629c491ab3411a$var$itemsCountStyles,
                paddingInline: "space.050"
            }, "+", totalItems)))
    });
};
const $db629c491ab3411a$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ...props,
        ref: ref,
        as: "span",
        xcss: $db629c491ab3411a$var$tooltipContainerStyles
    }));
const $db629c491ab3411a$var$ContainerDialogStyles = (0, $1DXK0.xcss)({
    width: '240px',
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.100',
    border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
    borderRadius: 'border.radius'
});
const $db629c491ab3411a$var$tooltipContainerStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});
const $db629c491ab3411a$var$itemsCountStyles = (0, $1DXK0.xcss)({
    fontWeight: "var(--ds-font-weight-regular, 400)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-250, 20px)"
});
var $db629c491ab3411a$export$2e2bcd8739ae039 = $db629c491ab3411a$var$ShowMorePopup;

});


parcelRegister("l8oUV", function(module, exports) {

$parcel$export(module.exports, "ErrorFallback", () => $374ab770514ac6b8$export$8a7ad05c3ee0c78a);

var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $80DPg = parcelRequire("80DPg");

var $5CSKW = parcelRequire("5CSKW");

var $lRq8t = parcelRequire("lRq8t");

var $447R4 = parcelRequire("447R4");
const $374ab770514ac6b8$export$8a7ad05c3ee0c78a = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "strong"
    }, formatMessage((0, $447R4.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onClick: onClick,
        spacing: "compact"
    }, formatMessage((0, $447R4.default).retryMessage)));
};

});
parcelRegister("447R4", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd7cd7f56cf414b6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cd7cd7f56cf414b6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    retryMessage: {
        "id": "item-with-popup.ui.item-with-entrypoint-popup.error-fallback.retry-message",
        "defaultMessage": "Click to retry"
    },
    errorMessage: {
        "id": "item-with-popup.ui.item-with-entrypoint-popup.error-fallback.error-message",
        "defaultMessage": "Failed to load content"
    }
});

});



parcelRegister("3PRLs", function(module, exports) {

$parcel$export(module.exports, "SimpleInlineSmartLink", () => $6ee98882ad11c6d7$export$e918b96127f4d56b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $18DG7 = parcelRequire("18DG7");
var $5NtHI = parcelRequire("5NtHI");
var $fqBfo = parcelRequire("fqBfo");

var $8YHJ2 = parcelRequire("8YHJ2");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7Bn2k = parcelRequire("7Bn2k");
const $6ee98882ad11c6d7$var$uiOptions = {
    clickableContainer: true,
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    size: (0, $5NtHI.SmartLinkSize).Medium
};
const $6ee98882ad11c6d7$var$actionOptions = {
    hide: false,
    exclude: [
        (0, $18DG7.CardAction).ChangeStatusAction
    ]
};
const $6ee98882ad11c6d7$export$e918b96127f4d56b = ({ onRemove: onRemove, url: url, anchorTarget: anchorTarget, showHoverPreview: showHoverPreview = true, text: text, anchorRef: anchorRef, onError: onError })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.025",
        paddingInline: "space.050",
        xcss: $6ee98882ad11c6d7$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8YHJ2.CardSSR), {
        appearance: "inline",
        url: url,
        ui: $6ee98882ad11c6d7$var$uiOptions,
        actionOptions: $6ee98882ad11c6d7$var$actionOptions,
        showHoverPreview: showHoverPreview,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fqBfo.default), {
        hideTitleTooltip: true,
        maxLines: 1,
        metadata: [
            {
                name: (0, $5NtHI.ElementName).State
            }
        ],
        anchorTarget: anchorTarget ?? '_self',
        text: text,
        anchorRef: anchorRef,
        className: (0, $hcewu.default)([
            "_zulp1b66"
        ])
    })), onRemove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Bn2k.RemoveButton), {
        onClick: onRemove
    }));
};
const $6ee98882ad11c6d7$var$inlineStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.raised',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: 'border.radius',
    display: 'inline-flex',
    gap: 'space.050'
});
const $6ee98882ad11c6d7$var$titleBlockStyles = null;

});
parcelRegister("18DG7", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $ff948bb743384c72$export$f40b7e0b762b928b);
var $ff948bb743384c72$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("5NtHI", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $fc2e49eaf9e6df05$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $fc2e49eaf9e6df05$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $fc2e49eaf9e6df05$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $fc2e49eaf9e6df05$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $fc2e49eaf9e6df05$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $fc2e49eaf9e6df05$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $fc2e49eaf9e6df05$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $fc2e49eaf9e6df05$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $fc2e49eaf9e6df05$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $fc2e49eaf9e6df05$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $fc2e49eaf9e6df05$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $fc2e49eaf9e6df05$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $fc2e49eaf9e6df05$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $fc2e49eaf9e6df05$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $fc2e49eaf9e6df05$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $fc2e49eaf9e6df05$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $fc2e49eaf9e6df05$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $fc2e49eaf9e6df05$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804);
const $fc2e49eaf9e6df05$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $fc2e49eaf9e6df05$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $fc2e49eaf9e6df05$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $fc2e49eaf9e6df05$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $fc2e49eaf9e6df05$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $fc2e49eaf9e6df05$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $fc2e49eaf9e6df05$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $fc2e49eaf9e6df05$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $fc2e49eaf9e6df05$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $fc2e49eaf9e6df05$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $fc2e49eaf9e6df05$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $fc2e49eaf9e6df05$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $fc2e49eaf9e6df05$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $fc2e49eaf9e6df05$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $fc2e49eaf9e6df05$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $fc2e49eaf9e6df05$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $fc2e49eaf9e6df05$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $fc2e49eaf9e6df05$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("fqBfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0af5d75f753a471$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $5FRJ8 = parcelRequire("5FRJ8");

var $i6ktq = parcelRequire("i6ktq");

var $6P8F3 = parcelRequire("6P8F3");

var $gjoE0 = parcelRequire("gjoE0");

var $haRRg = parcelRequire("haRRg");

var $1Ub5D = parcelRequire("1Ub5D");
const $a0af5d75f753a471$var$actionStyles = null;
const $a0af5d75f753a471$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return 0, $1Ub5D.default;
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return 0, $haRRg.default;
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return 0, $gjoE0.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $a0af5d75f753a471$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const { status: status = (0, $5NtHI.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $eJOHy.useState)(false);
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i6ktq.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: ui?.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $a0af5d75f753a471$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? ui?.size,
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $a0af5d75f753a471$export$2e2bcd8739ae039 = $a0af5d75f753a471$var$TitleBlock;

});
parcelRegister("e3qu2", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $3d45ba8ff999246a$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $3d45ba8ff999246a$export$df67f318ded0283c);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $liquj = parcelRequire("liquj");
var $3d45ba8ff999246a$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $3d45ba8ff999246a$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $3d45ba8ff999246a$var$isNotLeftClick = (event)=>event.button !== 0;
const $3d45ba8ff999246a$export$df67f318ded0283c = (onMouseDown)=>{
    return $3d45ba8ff999246a$export$5993d3ca6c85f774(onMouseDown, $3d45ba8ff999246a$var$isNotLeftClick);
};

});
parcelRegister("liquj", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $9bb097c912a9f010$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $9bb097c912a9f010$export$263352d59c0c5966);

var $eJOHy = parcelRequire("eJOHy");

var $8GnsF = parcelRequire("8GnsF");

var $e3qu2 = parcelRequire("e3qu2");

var $b43DQ = parcelRequire("b43DQ");
const $9bb097c912a9f010$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $9bb097c912a9f010$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $9bb097c912a9f010$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $9bb097c912a9f010$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $8GnsF.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($9bb097c912a9f010$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $9bb097c912a9f010$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $9bb097c912a9f010$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $9bb097c912a9f010$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $9bb097c912a9f010$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $9bb097c912a9f010$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $9bb097c912a9f010$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $9bb097c912a9f010$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $9bb097c912a9f010$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
    };
const $9bb097c912a9f010$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $9bb097c912a9f010$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $e3qu2.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $e3qu2.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$9bb097c912a9f010$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("8GnsF", function(module, exports) {

$parcel$export(module.exports, "browser", () => $9001dc59012896ed$export$3f2684e5d7cb1006);
const $9001dc59012896ed$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $9001dc59012896ed$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $9001dc59012896ed$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $9001dc59012896ed$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $9001dc59012896ed$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $9001dc59012896ed$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $9001dc59012896ed$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $9001dc59012896ed$var$result.android = /Android \d/.test(navigator.userAgent);
    $9001dc59012896ed$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $9001dc59012896ed$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $9001dc59012896ed$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $9001dc59012896ed$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $9001dc59012896ed$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $9001dc59012896ed$export$3f2684e5d7cb1006() {
    return $9001dc59012896ed$var$result;
}

});

parcelRegister("b43DQ", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3132e66a6b380708$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3132e66a6b380708$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3132e66a6b380708$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3132e66a6b380708$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3132e66a6b380708$export$b91e0203b928470c);
const $3132e66a6b380708$export$85183a312807388d = 'media';
const $3132e66a6b380708$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3132e66a6b380708$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3132e66a6b380708$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3132e66a6b380708$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3132e66a6b380708$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3132e66a6b380708$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3132e66a6b380708$export$85183a312807388d);
};

});



parcelRegister("5FRJ8", function(module, exports) {

$parcel$export(module.exports, "FlexibleCardContext", () => $26ead80b20537add$export$13dde4423ab71d62);
$parcel$export(module.exports, "useFlexibleCardContext", () => $26ead80b20537add$export$a8c4167e4e9f26ab);
$parcel$export(module.exports, "useFlexibleUiContext", () => $26ead80b20537add$export$61d7957a243df7aa);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $26ead80b20537add$export$e6b5ad18b56e8f51);

var $eJOHy = parcelRequire("eJOHy");
const $26ead80b20537add$export$13dde4423ab71d62 = (0, $eJOHy.createContext)(undefined);
const $26ead80b20537add$export$a8c4167e4e9f26ab = ()=>(0, $eJOHy.useContext)($26ead80b20537add$export$13dde4423ab71d62);
const $26ead80b20537add$export$61d7957a243df7aa = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.data;
const $26ead80b20537add$export$e6b5ad18b56e8f51 = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.ui;

});

parcelRegister("i6ktq", function(module, exports) {

$parcel$export(module.exports, "default", () => $890c0338844dfde1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $890c0338844dfde1$var$TitleElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? context?.linkTitle : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Title
    }) : null;
};
var $890c0338844dfde1$export$2e2bcd8739ae039 = $890c0338844dfde1$var$TitleElement;

});
parcelRegister("8ygPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adbc5d7a57662063$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $fQH39 = parcelRequire("fQH39");
const $adbc5d7a57662063$var$DEFAULT_MAX_LINES = 2;
const $adbc5d7a57662063$var$MAXIMUM_MAX_LINES = 2;
const $adbc5d7a57662063$var$MINIMUM_MAX_LINES = 1;
const $adbc5d7a57662063$var$containerStyles = null;
const $adbc5d7a57662063$var$getMaxLines = (maxLines)=>{
    if (maxLines > $adbc5d7a57662063$var$MAXIMUM_MAX_LINES) return $adbc5d7a57662063$var$DEFAULT_MAX_LINES;
    if (maxLines < $adbc5d7a57662063$var$MINIMUM_MAX_LINES) return $adbc5d7a57662063$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $adbc5d7a57662063$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $adbc5d7a57662063$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $adbc5d7a57662063$var$baseAnchorStyle = null;
const $adbc5d7a57662063$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $adbc5d7a57662063$var$anchorConstantsStyles = null;
const $adbc5d7a57662063$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
/**
 * Remove on FG clean up of twg-graphyte-smart-card-link-theme-fix
 */ const $adbc5d7a57662063$var$themeStyleMapOld = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
const $adbc5d7a57662063$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _c2wa8stv _4fpr8stv _1bnx8stv _1x288stv _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8h1gjq _f8pj1gjq _30l31gjq _10531gjq",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {BaseLinkElementProps} BaseLinkElementProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $adbc5d7a57662063$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $adbc5d7a57662063$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5NtHI.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const hasSpace = (0, $eJOHy.useMemo)(()=>text ? (0, $fQH39.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $adbc5d7a57662063$var$linkStyleSizeMap[size],
            $adbc5d7a57662063$var$anchorLineClampMap[$adbc5d7a57662063$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $adbc5d7a57662063$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 1 && $adbc5d7a57662063$var$anchorLinkLineHeight1Map[size],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 2 && $adbc5d7a57662063$var$anchorLinkLineHeight2Map[size],
            (0, $eGOwo.fg)('twg-graphyte-smart-card-link-theme-fix') ? $adbc5d7a57662063$var$themeStyleMap[theme] : $adbc5d7a57662063$var$themeStyleMapOld[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $adbc5d7a57662063$var$withTooltip(anchor, text, testId)
    });
};
var $adbc5d7a57662063$export$2e2bcd8739ae039 = $adbc5d7a57662063$var$BaseLinkElement;
const $adbc5d7a57662063$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};

});
parcelRegister("fQH39", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $18f1b25c1730b97c$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $18f1b25c1730b97c$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $18f1b25c1730b97c$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidth", () => $18f1b25c1730b97c$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $18f1b25c1730b97c$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $18f1b25c1730b97c$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $18f1b25c1730b97c$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $18f1b25c1730b97c$export$619e376a425cb759);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $joSn0 = parcelRequire("joSn0");

var $5NtHI = parcelRequire("5NtHI");
const $18f1b25c1730b97c$export$9d642f65a919fb93 = {
    [(0, $5NtHI.SmartLinkSize).Small]: 'none',
    [(0, $5NtHI.SmartLinkSize).Medium]: 'compact',
    [(0, $5NtHI.SmartLinkSize).Large]: 'compact',
    [(0, $5NtHI.SmartLinkSize).XLarge]: 'default'
};
const $18f1b25c1730b97c$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        });
    }
};
const $18f1b25c1730b97c$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $18f1b25c1730b97c$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $18f1b25c1730b97c$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $18f1b25c1730b97c$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1.75;
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $18f1b25c1730b97c$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $18f1b25c1730b97c$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5NtHI.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $18f1b25c1730b97c$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("6P8F3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6bccbbfb4f78611$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $48q59 = parcelRequire("48q59");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");

var $aMdh8 = parcelRequire("aMdh8");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $brTAh = parcelRequire("brTAh");

var $a86OV = parcelRequire("a86OV");
const $a6bccbbfb4f78611$var$styles = null;
const $a6bccbbfb4f78611$var$renderActionItems = (items = [], size = (0, $5NtHI.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $a86OV.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $a6bccbbfb4f78611$var$ActionGroup = ({ items: items = [], size: size = (0, $5NtHI.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gRw8I.di)((0, $7rjYb.default));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const renderableActionItems = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $eJOHy.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $eJOHy.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fQH39.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).more_actions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $48q59.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $a6bccbbfb4f78611$export$2e2bcd8739ae039 = $a6bccbbfb4f78611$var$ActionGroup;

});
parcelRegister("19nmp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d6bf071ed8fc5324$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d6bf071ed8fc5324$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    owned_by_override: {
        id: 'fabric.linking.owned_by_override',
        defaultMessage: 'By {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    team_members_count: {
        id: 'fabric.linking.team_members_count',
        defaultMessage: '{context} members',
        description: 'Indicates the count of team member'
    },
    user_attributes: {
        id: 'fabric.linking.user_attributes',
        defaultMessage: '{context}',
        description: 'Displays user attributes like role, department, location, and pronouns'
    }
});

});

parcelRegister("brTAh", function(module, exports) {

$parcel$export(module.exports, "filterActionItems", () => $a0fe758b77d980f4$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $a0fe758b77d980f4$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $a0fe758b77d980f4$export$9678d3ca18bd7526);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $1YI3f = parcelRequire("1YI3f");

var $4RG9i = parcelRequire("4RG9i");

var $6P8F3 = parcelRequire("6P8F3");

var $k8J0S = parcelRequire("k8J0S");
const $a0fe758b77d980f4$export$f942619ce67b1a41 = {
    [(0, $5NtHI.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Location]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Preview]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).State]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Title]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).VoteCount]: [
        'inline'
    ]
};
const $a0fe758b77d980f4$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1;
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 0.5;
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $a0fe758b77d980f4$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $6P8F3.default);
const $a0fe758b77d980f4$var$isElementDisplayValid = (name, display)=>{
    return $a0fe758b77d980f4$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $a0fe758b77d980f4$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $a0fe758b77d980f4$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && ((0, $1YI3f.isFlexibleUiElement)(node) || node.type === (0, $k8J0S.default));
const $a0fe758b77d980f4$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5NtHI.ActionName).DeleteAction:
            case (0, $5NtHI.ActionName).EditAction:
            case (0, $5NtHI.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5NtHI.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $a0fe758b77d980f4$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if ($a0fe758b77d980f4$var$isElementOrElementGroup(child) || $a0fe758b77d980f4$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $a0fe758b77d980f4$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $4RG9i[name];
        const typedProps = props;
        if (Element && $a0fe758b77d980f4$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $gt9Am.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$a0fe758b77d980f4$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("1YI3f", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $ec5109f5e7b621c7$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isStyleCacheProvider", () => $ec5109f5e7b621c7$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $ec5109f5e7b621c7$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $ec5109f5e7b621c7$export$c0547b4405cae584);

var $eJOHy = parcelRequire("eJOHy");

var $34CM9 = parcelRequire("34CM9");
var $fqBfo = parcelRequire("fqBfo");
var $8Rjtc = parcelRequire("8Rjtc");
var $lAF2k = parcelRequire("lAF2k");

var $4RG9i = parcelRequire("4RG9i");
const $ec5109f5e7b621c7$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children)?.length > 0 ? true : false;
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).some((child)=>$ec5109f5e7b621c7$export$df0092b19156b140(child))) return true;
    return false;
};
const $ec5109f5e7b621c7$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($34CM9).some((type)=>type === node.type)) return true;
    return false;
};
const $ec5109f5e7b621c7$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (Object.values($4RG9i).some((type)=>type === node.type)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $fqBfo.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $8Rjtc.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $lAF2k.default);

});
parcelRegister("34CM9", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("lAF2k")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gKsxm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("8Rjtc")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("5gb8b")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("fqBfo")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("bIdM1")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("3pcXQ")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("2qnEp")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("eMgzj")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("4cjOx")).default);

var $lAF2k = parcelRequire("lAF2k");

var $gKsxm = parcelRequire("gKsxm");

var $8Rjtc = parcelRequire("8Rjtc");

var $5gb8b = parcelRequire("5gb8b");

var $fqBfo = parcelRequire("fqBfo");

var $bIdM1 = parcelRequire("bIdM1");

var $3pcXQ = parcelRequire("3pcXQ");

var $2qnEp = parcelRequire("2qnEp");

var $eMgzj = parcelRequire("eMgzj");

var $4cjOx = parcelRequire("4cjOx");

});
parcelRegister("lAF2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b59a3b7a9f7670d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3pcXQ = parcelRequire("3pcXQ");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $9b59a3b7a9f7670d$var$FooterBlock = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $9b59a3b7a9f7670d$export$2e2bcd8739ae039 = $9b59a3b7a9f7670d$var$FooterBlock;

});
parcelRegister("3pcXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $462a2917906f3b08$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $6P8F3 = parcelRequire("6P8F3");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $462a2917906f3b08$var$actionGroupStyles = null;
const $462a2917906f3b08$var$safariStyles = null;
const $462a2917906f3b08$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5NtHI.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const hasActions = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                testId: "smart-element-group-actions",
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                className: (0, $hcewu.default)([
                    size === (0, $5NtHI.SmartLinkSize).XLarge && "_c71lxy5q",
                    safari && "_4t3i1osq"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $462a2917906f3b08$export$2e2bcd8739ae039 = $462a2917906f3b08$var$FooterBlockResolvedView;

});
parcelRegister("6l7Bk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8115736e8f2ac6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $2a8115736e8f2ac6$var$ProviderElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Provider
    }) : null;
};
var $2a8115736e8f2ac6$export$2e2bcd8739ae039 = $2a8115736e8f2ac6$var$ProviderElement;

});
parcelRegister("4XCp5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83b25175c466aed$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toBadgeProps", () => $e83b25175c466aed$export$a2fb457791942ba4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $e83b25175c466aed$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $e83b25175c466aed$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $e83b25175c466aed$var$messageMapper = {
    [(0, $5NtHI.IconType).PriorityBlocker]: (0, $19nmp.messages).priority_blocker,
    [(0, $5NtHI.IconType).PriorityCritical]: (0, $19nmp.messages).priority_critical,
    [(0, $5NtHI.IconType).PriorityHigh]: (0, $19nmp.messages).priority_high,
    [(0, $5NtHI.IconType).PriorityHighest]: (0, $19nmp.messages).priority_highest,
    [(0, $5NtHI.IconType).PriorityLow]: (0, $19nmp.messages).priority_low,
    [(0, $5NtHI.IconType).PriorityLowest]: (0, $19nmp.messages).priority_lowest,
    [(0, $5NtHI.IconType).PriorityMajor]: (0, $19nmp.messages).priority_major,
    [(0, $5NtHI.IconType).PriorityMedium]: (0, $19nmp.messages).priority_medium,
    [(0, $5NtHI.IconType).PriorityMinor]: (0, $19nmp.messages).priority_minor,
    [(0, $5NtHI.IconType).PriorityTrivial]: (0, $19nmp.messages).priority_trivial,
    [(0, $5NtHI.IconType).PriorityUndefined]: (0, $19nmp.messages).priority_undefined
};
const $e83b25175c466aed$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $e83b25175c466aed$var$messageMapper[icon];
        if (descriptor) return (0, $fQH39.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $e83b25175c466aed$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $e83b25175c466aed$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BaseBadgeElementProps} BaseBadgeElementProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $e83b25175c466aed$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color }, ref)=>{
    const formattedMessageOrLabel = $e83b25175c466aed$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $e83b25175c466aed$var$renderAtlaskitIcon(icon, testId) || $e83b25175c466aed$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $hcewu.default)([
            $e83b25175c466aed$var$styles.container,
            $e83b25175c466aed$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                xcss: $e83b25175c466aed$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $e83b25175c466aed$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
var $e83b25175c466aed$export$2e2bcd8739ae039 = (0, $9jYtV.withOverrideCss)($e83b25175c466aed$var$BaseBadgeRefreshNew);
const $e83b25175c466aed$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};

});
parcelRegister("b4zhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d5d1de8f417451$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $lgMTT = parcelRequire("lgMTT");

var $4Gz8O = parcelRequire("4Gz8O");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $d6d5d1de8f417451$var$getIconImportFn = (icon, size)=>{
    const item = (0, $FoFt2.getLazyIcons)()[icon];
    if ((0, $FoFt2.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $d6d5d1de8f417451$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $d6d5d1de8f417451$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $5NtHI.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $5NtHI.IconType).Document:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).Blog:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $d6d5d1de8f417451$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $d6d5d1de8f417451$var$importIcon(importFn);
    switch(icon){
        case (0, $5NtHI.IconType).Confluence:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5NtHI.IconType).Jira:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5NtHI.IconType).Error:
        case (0, $5NtHI.IconType).Forbidden:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                size: size
            });
    }
};
var $d6d5d1de8f417451$export$2e2bcd8739ae039 = $d6d5d1de8f417451$var$AtlaskitIcon;

});
parcelRegister("4Gz8O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1589456b7a180f6b$export$2e2bcd8739ae039);

var $ihwup = parcelRequire("ihwup");

var $ff2hw = parcelRequire("ff2hw");

var $cPcks = parcelRequire("cPcks");
const $1589456b7a180f6b$var$BlogIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ihwup.default), (0, $ff2hw.default));
$1589456b7a180f6b$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $1589456b7a180f6b$export$2e2bcd8739ae039 = $1589456b7a180f6b$var$BlogIconWithColor;

});
parcelRegister("ihwup", function(module, exports) {

$parcel$export(module.exports, "default", () => $6042983cb1b7627c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a83a7f5a6c8e47f949d01b79ace277e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $amerd = parcelRequire("amerd");

var $37A7r = parcelRequire("37A7r");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $6042983cb1b7627c$var$Blog16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37A7r.default), {
            label: label,
            testId: testId
        })
    });
};
$6042983cb1b7627c$var$Blog16Icon.displayName = 'Blog16Icon';
var $6042983cb1b7627c$export$2e2bcd8739ae039 = $6042983cb1b7627c$var$Blog16Icon;

});
parcelRegister("amerd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78a7288f6e3e8955$var$_react = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78a7288f6e3e8955$var$_baseNew = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78a7288f6e3e8955$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78a7288f6e3e8955$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $78a7288f6e3e8955$var$_react.default.createElement($78a7288f6e3e8955$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$78a7288f6e3e8955$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $78a7288f6e3e8955$var$_default = module.exports.default = $78a7288f6e3e8955$var$QuotationMarkIcon;

});

parcelRegister("37A7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $def8fa9bf18a8fbf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $def8fa9bf18a8fbf$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$def8fa9bf18a8fbf$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$def8fa9bf18a8fbf$export$2e2bcd8739ae039 = $def8fa9bf18a8fbf$var$Blog16Icon;

});


parcelRegister("ff2hw", function(module, exports) {

$parcel$export(module.exports, "default", () => $674c38c84d40fa8d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d8623c613f391e6660af828ca0a00c8>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $amerd = parcelRequire("amerd");

var $4HJXf = parcelRequire("4HJXf");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $674c38c84d40fa8d$var$Blog24Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4HJXf.default), {
            label: label,
            testId: testId
        })
    });
};
$674c38c84d40fa8d$var$Blog24Icon.displayName = 'Blog24Icon';
var $674c38c84d40fa8d$export$2e2bcd8739ae039 = $674c38c84d40fa8d$var$Blog24Icon;

});
parcelRegister("4HJXf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddb48944e405ac0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $2ddb48944e405ac0$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$2ddb48944e405ac0$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2ddb48944e405ac0$export$2e2bcd8739ae039 = $2ddb48944e405ac0$var$Blog24Icon;

});


parcelRegister("cPcks", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $5c2d46cff1f07a26$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $5c2d46cff1f07a26$export$87c3646d0e299cfe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $5c2d46cff1f07a26$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $5c2d46cff1f07a26$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $FoFt2.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $gt9Am.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(IconSmall, {
            ...props
        });
    };
};
const $5c2d46cff1f07a26$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
            appearance: appearance,
            icon: Icon,
            size: $5c2d46cff1f07a26$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $gt9Am.jsx)(LegacyIcon, {
                ...props,
                size: size
            })
        });
    };
};

});
parcelRegister("FoFt2", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $4836221d615e2d0d$export$efca2c4705678489);
$parcel$export(module.exports, "isSpecialKey", () => $4836221d615e2d0d$export$d8de0cd37d316fdf);
$parcel$export(module.exports, "isSpecialClick", () => $4836221d615e2d0d$export$5b1771037ab7c451);
$parcel$export(module.exports, "getIconForFileType", () => $4836221d615e2d0d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $4836221d615e2d0d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $4836221d615e2d0d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $4836221d615e2d0d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $4836221d615e2d0d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $4836221d615e2d0d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $4836221d615e2d0d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $4836221d615e2d0d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $4836221d615e2d0d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $4836221d615e2d0d$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $4836221d615e2d0d$export$6a4545d6b336c401);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $eGOwo = parcelRequire("eGOwo");

var $4CCpn = parcelRequire("4CCpn");

var $5NtHI = parcelRequire("5NtHI");

var $dyU3L = parcelRequire("dyU3L");
const $4836221d615e2d0d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($4836221d615e2d0d$export$e6c5ffa684aac4d7() || $4836221d615e2d0d$export$d8de0cd37d316fdf(evt) || $4836221d615e2d0d$export$5b1771037ab7c451(evt));
const $4836221d615e2d0d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $4836221d615e2d0d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $eGOwo.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $4836221d615e2d0d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $4836221d615e2d0d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $4836221d615e2d0d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label] = icon;
    return label;
};


























































































const $4836221d615e2d0d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $5NtHI.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9dPtp")))
        },
        [(0, $5NtHI.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("4Gz8O")))
        },
        [(0, $5NtHI.IconType).Audio]: {
            default: ()=>(parcelRequire("jGI3w"))
        },
        [(0, $5NtHI.IconType).Code]: {
            default: ()=>(parcelRequire("2l32C"))
        },
        [(0, $5NtHI.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Folder]: {
            default: ()=>(parcelRequire("kM5eD"))
        },
        [(0, $5NtHI.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Image]: {
            default: ()=>(parcelRequire("ipZFl"))
        },
        [(0, $5NtHI.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("lQKQC")))
        },
        [(0, $5NtHI.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("4VIPx")))
        },
        [(0, $5NtHI.IconType).Video]: {
            default: ()=>(parcelRequire("gy68w"))
        },
        [(0, $5NtHI.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("lG2jM")))
        },
        [(0, $5NtHI.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("kSre2")))
        },
        [(0, $5NtHI.IconType).Forbidden]: {
            default: ()=>(parcelRequire("7lhDi"))
        },
        [(0, $5NtHI.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("av9Of")))
        },
        [(0, $5NtHI.IconType).Archive]: {
            default: ()=>(parcelRequire("PhsZo")),
            large: ()=>(parcelRequire("9bxQV"))
        },
        [(0, $5NtHI.IconType).Executable]: {
            default: ()=>(parcelRequire("3ypIZ")),
            large: ()=>Promise.resolve((parcelRequire("gAsmN")))
        },
        [(0, $5NtHI.IconType).GIF]: {
            default: ()=>(parcelRequire("2N4kX")),
            large: ()=>Promise.resolve((parcelRequire("2Pj0H")))
        },
        [(0, $5NtHI.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("54Irl")),
            large: ()=>Promise.resolve((parcelRequire("iqmbF")))
        },
        [(0, $5NtHI.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("5JIMH")),
            large: ()=>Promise.resolve((parcelRequire("hLw8T")))
        },
        [(0, $5NtHI.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("b7X9d")),
            large: ()=>Promise.resolve((parcelRequire("jpYYq")))
        },
        [(0, $5NtHI.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("2uY1f")),
            large: ()=>Promise.resolve((parcelRequire("4SXVP")))
        },
        [(0, $5NtHI.IconType).MSExcel]: {
            default: ()=>(parcelRequire("8S5KR")),
            large: ()=>Promise.resolve((parcelRequire("91IX3")))
        },
        [(0, $5NtHI.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("7lDFg")),
            large: ()=>Promise.resolve((parcelRequire("jb8ZN")))
        },
        [(0, $5NtHI.IconType).MSWord]: {
            default: ()=>(parcelRequire("9IKYh")),
            large: ()=>Promise.resolve((parcelRequire("4w1Xx")))
        },
        [(0, $5NtHI.IconType).PDF]: {
            default: ()=>(parcelRequire("hEMIE")),
            large: ()=>Promise.resolve((parcelRequire("6OBnQ")))
        },
        [(0, $5NtHI.IconType).Sketch]: {
            default: ()=>(parcelRequire("dE7I7")),
            large: ()=>Promise.resolve((parcelRequire("heBKY")))
        },
        // Bitbucket icons
        [(0, $5NtHI.IconType).Branch]: {
            default: ()=>Promise.resolve((parcelRequire("liS9g"))),
            large: ()=>(parcelRequire("7gFcl"))
        },
        [(0, $5NtHI.IconType).Commit]: {
            default: ()=>Promise.resolve((parcelRequire("6wUJL"))),
            large: ()=>(parcelRequire("ij46p"))
        },
        [(0, $5NtHI.IconType).PullRequest]: {
            default: ()=>Promise.resolve((parcelRequire("es92x"))),
            large: ()=>(parcelRequire("2aQhi"))
        },
        [(0, $5NtHI.IconType).Repo]: {
            default: ()=>Promise.resolve((parcelRequire("gSqCA"))),
            large: ()=>(parcelRequire("5fclM"))
        },
        // Jira icons
        [(0, $5NtHI.IconType).Bug]: {
            default: ()=>Promise.resolve((parcelRequire("i3nvV"))),
            large: ()=>(parcelRequire("f9TV4"))
        },
        [(0, $5NtHI.IconType).Change]: {
            default: ()=>Promise.resolve((parcelRequire("59W6U"))),
            large: ()=>(parcelRequire("iFMZJ"))
        },
        [(0, $5NtHI.IconType).Epic]: {
            default: ()=>Promise.resolve((parcelRequire("4VGMo"))),
            large: ()=>(parcelRequire("feyrR"))
        },
        [(0, $5NtHI.IconType).Incident]: {
            default: ()=>Promise.resolve((parcelRequire("h6Xfo"))),
            large: ()=>(parcelRequire("9YhWF"))
        },
        [(0, $5NtHI.IconType).Problem]: {
            default: ()=>Promise.resolve((parcelRequire("erbJ6"))),
            large: ()=>(parcelRequire("gbfzG"))
        },
        [(0, $5NtHI.IconType).ServiceRequest]: {
            default: ()=>Promise.resolve((parcelRequire("8WXuv"))),
            large: ()=>(parcelRequire("5M4VY"))
        },
        [(0, $5NtHI.IconType).Story]: {
            default: ()=>Promise.resolve((parcelRequire("iaeCZ"))),
            large: ()=>(parcelRequire("jc5UC"))
        },
        [(0, $5NtHI.IconType).SubTask]: {
            default: ()=>Promise.resolve((parcelRequire("dV8me"))),
            large: ()=>(parcelRequire("gDPso"))
        },
        [(0, $5NtHI.IconType).Task]: {
            default: ()=>Promise.resolve((parcelRequire("cOjgE"))),
            large: ()=>(parcelRequire("f65Of"))
        },
        // Confluence icons
        [(0, $5NtHI.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("ilCAi"))),
            large: ()=>Promise.resolve((parcelRequire("hB03j")))
        },
        // Provider icons
        [(0, $5NtHI.IconType).Confluence]: {
            default: ()=>(parcelRequire("9Iwo3")).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $5NtHI.IconType).Jira]: {
            default: ()=>(parcelRequire("5Ak2H")).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $5NtHI.IconType).Attachment]: {
            default: ()=>(parcelRequire("gb3jU"))
        },
        [(0, $5NtHI.IconType).CheckItem]: {
            default: ()=>(parcelRequire("cjeHX"))
        },
        [(0, $5NtHI.IconType).Component]: {
            default: ()=>(parcelRequire("6n9v8"))
        },
        [(0, $5NtHI.IconType).Comment]: {
            default: ()=>(parcelRequire("1ILHj"))
        },
        [(0, $5NtHI.IconType).View]: {
            default: ()=>(parcelRequire("6dx3m"))
        },
        [(0, $5NtHI.IconType).React]: {
            default: ()=>(parcelRequire("jticq"))
        },
        [(0, $5NtHI.IconType).Vote]: {
            default: ()=>(parcelRequire("eIsTj"))
        },
        [(0, $5NtHI.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("f1B8s"))
        },
        [(0, $5NtHI.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("cmEXk"))
        },
        [(0, $5NtHI.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("bTWmL"))
        },
        [(0, $5NtHI.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("iSMal"))
        },
        [(0, $5NtHI.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("jRdgC"))
        },
        [(0, $5NtHI.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("kRp0o"))
        },
        [(0, $5NtHI.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("KywEn"))
        },
        [(0, $5NtHI.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("fHwpk"))
        },
        [(0, $5NtHI.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("BSiun"))
        },
        [(0, $5NtHI.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("8l50I"))
        },
        [(0, $5NtHI.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("5S862"))
        },
        [(0, $5NtHI.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("cDlzR"))
        },
        [(0, $5NtHI.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("hMpZ8")))
        },
        [(0, $5NtHI.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("bMymA"))
        }
    };
};
const $4836221d615e2d0d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $dyU3L.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $4836221d615e2d0d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $4836221d615e2d0d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $4836221d615e2d0d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $4836221d615e2d0d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $4836221d615e2d0d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $4836221d615e2d0d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $4836221d615e2d0d$export$e772c8ff12451969(interval);
            return $4836221d615e2d0d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $4836221d615e2d0d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $4836221d615e2d0d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $4836221d615e2d0d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $4CCpn.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $4836221d615e2d0d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $5NtHI.SmartLinkSize).Large,
        (0, $5NtHI.SmartLinkSize).XLarge
    ].includes(size);
const $4836221d615e2d0d$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});
parcelRegister("dyU3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aa425783d81a7e4$export$2e2bcd8739ae039);

var $5NtHI = parcelRequire("5NtHI");
const $9aa425783d81a7e4$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $5NtHI.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $5NtHI.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $5NtHI.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $5NtHI.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $5NtHI.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $5NtHI.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $5NtHI.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $5NtHI.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $5NtHI.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $5NtHI.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $5NtHI.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $5NtHI.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $5NtHI.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $5NtHI.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $5NtHI.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $5NtHI.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $5NtHI.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $9aa425783d81a7e4$export$2e2bcd8739ae039 = $9aa425783d81a7e4$var$extractFileFormatIcon;

});

parcelRegister("9dPtp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a49966ca6c4774bc$export$2e2bcd8739ae039);

var $lImMk = parcelRequire("lImMk");

var $gxCW9 = parcelRequire("gxCW9");

var $DtmfJ = parcelRequire("DtmfJ");

var $cPcks = parcelRequire("cPcks");
const $a49966ca6c4774bc$var$PageIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))), 'blueBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($lImMk))), (0, (/*@__PURE__*/$parcel$interopDefault($gxCW9)))));
$a49966ca6c4774bc$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $a49966ca6c4774bc$export$2e2bcd8739ae039 = $a49966ca6c4774bc$var$PageIconWithColor;

});
parcelRegister("lImMk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fcef605c5c3325f6$var$_react = $fcef605c5c3325f6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $fcef605c5c3325f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fcef605c5c3325f6$var$Document16Icon = (props)=>/*#__PURE__*/ $fcef605c5c3325f6$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fcef605c5c3325f6$var$Document16Icon.displayName = 'Document16Icon';
var $fcef605c5c3325f6$var$_default = module.exports.default = $fcef605c5c3325f6$var$Document16Icon;

});

parcelRegister("gxCW9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c0adee7b3af1dc62$var$_react = $c0adee7b3af1dc62$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c0adee7b3af1dc62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c0adee7b3af1dc62$var$Document24Icon = (props)=>/*#__PURE__*/ $c0adee7b3af1dc62$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c0adee7b3af1dc62$var$Document24Icon.displayName = 'Document24Icon';
var $c0adee7b3af1dc62$var$_default = module.exports.default = $c0adee7b3af1dc62$var$Document24Icon;

});


parcelRegister("jGI3w", function(module, exports) {

let $e5541d223003f966$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e5541d223003f966$var$load("lBret").then(()=>parcelRequire('lT9gU'));

});

parcelRegister("2l32C", function(module, exports) {

let $1b3fe6d6c1117eb4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1b3fe6d6c1117eb4$var$load("c4Piz").then(()=>parcelRequire('b9JjP'));

});

parcelRegister("kM5eD", function(module, exports) {

let $f1fc59e4d78436bf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f1fc59e4d78436bf$var$load("fJRo2").then(()=>parcelRequire('3JiAU'));

});

parcelRegister("ipZFl", function(module, exports) {

let $d68a655378e7bfd3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d68a655378e7bfd3$var$load("68koG").then(()=>parcelRequire('htaza'));

});

parcelRegister("gy68w", function(module, exports) {

let $c0c494e4ef1a9465$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c0c494e4ef1a9465$var$load("gfpt4").then(()=>parcelRequire('idFH3'));

});

parcelRegister("7lhDi", function(module, exports) {

let $55882c19f26a9e19$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $55882c19f26a9e19$var$load("3roEx").then(()=>parcelRequire('eDFE1'));

});

parcelRegister("av9Of", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a54689236011148$var$_react = $7a54689236011148$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7a54689236011148$var$_link = $7a54689236011148$var$_interopRequireDefault((parcelRequire("cV8sz")));

var $7a54689236011148$var$_link2 = $7a54689236011148$var$_interopRequireDefault((parcelRequire("a2o1i")));
function $7a54689236011148$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a54689236011148$var$LinkIcon = (props)=>/*#__PURE__*/ $7a54689236011148$var$_react.default.createElement($7a54689236011148$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $7a54689236011148$var$_link2.default
    }, props));
$7a54689236011148$var$LinkIcon.Name = 'LinkIconMigration';
var $7a54689236011148$var$_default = module.exports.default = $7a54689236011148$var$LinkIcon;

});
parcelRegister("cV8sz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96815ed7645c21ae$var$_react = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $96815ed7645c21ae$var$_baseNew = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $96815ed7645c21ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $96815ed7645c21ae$var$LinkIcon = (props)=>/*#__PURE__*/ $96815ed7645c21ae$var$_react.default.createElement($96815ed7645c21ae$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$96815ed7645c21ae$var$LinkIcon.displayName = 'LinkIcon';
var $96815ed7645c21ae$var$_default = module.exports.default = $96815ed7645c21ae$var$LinkIcon;

});

parcelRegister("a2o1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74ecb925586ee899$var$_react = $74ecb925586ee899$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $74ecb925586ee899$var$_link = $74ecb925586ee899$var$_interopRequireDefault((parcelRequire("cV8sz")));
function $74ecb925586ee899$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $74ecb925586ee899$var$LinkIcon = (props)=>/*#__PURE__*/ $74ecb925586ee899$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $74ecb925586ee899$var$_link.default
    }));
$74ecb925586ee899$var$LinkIcon.displayName = 'LinkIcon';
var $74ecb925586ee899$var$_default = module.exports.default = $74ecb925586ee899$var$LinkIcon;

});


parcelRegister("PhsZo", function(module, exports) {

let $09a2500825b5c11a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $09a2500825b5c11a$var$load("9mQM4").then(()=>parcelRequire('8UJE5'));

});

parcelRegister("9bxQV", function(module, exports) {

let $6aff6695f59be982$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6aff6695f59be982$var$load("6TgwN").then(()=>parcelRequire('8ALRN'));

});

parcelRegister("3ypIZ", function(module, exports) {

let $29688079c4b0ee96$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $29688079c4b0ee96$var$load("43EiL").then(()=>parcelRequire('bKXd3'));

});

parcelRegister("2N4kX", function(module, exports) {

let $2083859e6f9dfb04$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2083859e6f9dfb04$var$load("i35Uh").then(()=>parcelRequire('ccKWN'));

});

parcelRegister("54Irl", function(module, exports) {

let $3b1fcc5c895af309$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3b1fcc5c895af309$var$load("9vjhq").then(()=>parcelRequire('aSnEf'));

});

parcelRegister("5JIMH", function(module, exports) {

let $42d3e4f963bcfa12$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $42d3e4f963bcfa12$var$load("j5W60").then(()=>parcelRequire('ju9Zq'));

});

parcelRegister("b7X9d", function(module, exports) {

let $819e3aa5538bdbce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $819e3aa5538bdbce$var$load("gHrjT").then(()=>parcelRequire('4BqrB'));

});

parcelRegister("2uY1f", function(module, exports) {

let $1d1cf0ab40960c11$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1d1cf0ab40960c11$var$load("hCGN9").then(()=>parcelRequire('cwxjA'));

});

parcelRegister("8S5KR", function(module, exports) {

let $6757d4ae8dcfc90d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6757d4ae8dcfc90d$var$load("igTGi").then(()=>parcelRequire('llYLq'));

});

parcelRegister("7lDFg", function(module, exports) {

let $55994325bd6a89db$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $55994325bd6a89db$var$load("8A7Un").then(()=>parcelRequire('bxHzv'));

});

parcelRegister("9IKYh", function(module, exports) {

let $713ca8a214b25950$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $713ca8a214b25950$var$load("fnRpB").then(()=>parcelRequire('FXbTY'));

});

parcelRegister("hEMIE", function(module, exports) {

let $cdabf6baf903c352$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cdabf6baf903c352$var$load("fMJrt").then(()=>parcelRequire('do41j'));

});

parcelRegister("dE7I7", function(module, exports) {

let $9ef4fdf58b078442$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ef4fdf58b078442$var$load("cxAqh").then(()=>parcelRequire('gbtcZ'));

});

parcelRegister("7gFcl", function(module, exports) {

let $54a9fc1f3aecb61f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $54a9fc1f3aecb61f$var$load("kvxvv").then(()=>parcelRequire('2j1uF'));

});

parcelRegister("ij46p", function(module, exports) {

let $d53d2eff9115be5f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d53d2eff9115be5f$var$load("5DW8N").then(()=>parcelRequire('8J7Hh'));

});

parcelRegister("2aQhi", function(module, exports) {

let $1955113bec4b7083$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1955113bec4b7083$var$load("er5Rw").then(()=>parcelRequire('ktJB5'));

});

parcelRegister("5fclM", function(module, exports) {

let $3d17eef5d89f84ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3d17eef5d89f84ca$var$load("a4ZTh").then(()=>parcelRequire('1O53N'));

});

parcelRegister("f9TV4", function(module, exports) {

let $b09312b6a3314853$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b09312b6a3314853$var$load("fVZub").then(()=>parcelRequire('jYfQG'));

});

parcelRegister("iFMZJ", function(module, exports) {

let $d9820fa67dfab31f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d9820fa67dfab31f$var$load("biRPG").then(()=>parcelRequire('gR3IA'));

});

parcelRegister("feyrR", function(module, exports) {

let $b172e28d8f60e9da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b172e28d8f60e9da$var$load("5PIwW").then(()=>parcelRequire('dmWJ4'));

});

parcelRegister("9YhWF", function(module, exports) {

let $7427a3392f22aacf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7427a3392f22aacf$var$load("1zPk8").then(()=>parcelRequire('eHIwa'));

});

parcelRegister("gbfzG", function(module, exports) {

let $bc79c1329eafb9ee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bc79c1329eafb9ee$var$load("hy7F8").then(()=>parcelRequire('lR9WO'));

});

parcelRegister("5M4VY", function(module, exports) {

let $434543426cb0a6c3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $434543426cb0a6c3$var$load("5UA41").then(()=>parcelRequire('aozTf'));

});

parcelRegister("jc5UC", function(module, exports) {

let $df93b95e4085ac34$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $df93b95e4085ac34$var$load("jQGZH").then(()=>parcelRequire('3mwl5'));

});

parcelRegister("gDPso", function(module, exports) {

let $c1d8341f0ee2b765$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c1d8341f0ee2b765$var$load("55GNU").then(()=>parcelRequire('7lmhQ'));

});

parcelRegister("f65Of", function(module, exports) {

let $afdbec3699fb9e2d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $afdbec3699fb9e2d$var$load("eiZZR").then(()=>parcelRequire('f8Y7f'));

});

parcelRegister("ilCAi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a3170ce3e9e98d41$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ca2d3ad1b30ce7f410ef0df588ae5aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $cruFS = parcelRequire("cruFS");

var $7KbsS = parcelRequire("7KbsS");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a3170ce3e9e98d41$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7KbsS.default), {
            label: label,
            testId: testId
        })
    });
};
$a3170ce3e9e98d41$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $a3170ce3e9e98d41$export$2e2bcd8739ae039 = $a3170ce3e9e98d41$var$PageLiveDoc16Icon;

});
parcelRegister("cruFS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90efccf3a3cdec59$var$_react = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90efccf3a3cdec59$var$_baseNew = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90efccf3a3cdec59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90efccf3a3cdec59$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $90efccf3a3cdec59$var$_react.default.createElement($90efccf3a3cdec59$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$90efccf3a3cdec59$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $90efccf3a3cdec59$var$_default = module.exports.default = $90efccf3a3cdec59$var$PageLiveDocIcon;

});

parcelRegister("7KbsS", function(module, exports) {

$parcel$export(module.exports, "default", () => $49cedc712f457d93$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbb561a99c36d24f949f1ade9ed1fa72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $49cedc712f457d93$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$49cedc712f457d93$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$49cedc712f457d93$export$2e2bcd8739ae039 = $49cedc712f457d93$var$PageLiveDoc16Icon;

});


parcelRegister("hB03j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0bd6bb1ec7db3603$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e04893101bb067974c1323f8e5a52186>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $cruFS = parcelRequire("cruFS");

var $kZFQQ = parcelRequire("kZFQQ");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $0bd6bb1ec7db3603$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kZFQQ.default), {
            label: label,
            testId: testId
        })
    });
};
$0bd6bb1ec7db3603$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $0bd6bb1ec7db3603$export$2e2bcd8739ae039 = $0bd6bb1ec7db3603$var$PageLiveDoc24Icon;

});
parcelRegister("kZFQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6dc3d78982b295d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5906433494daa938e0cf018edb0a9fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $b6dc3d78982b295d$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m10.555-6.832a1 1 0 0 0-1.545.973l1 7a1 1 0 0 0 1.884.306L17.118 17H20a1 1 0 0 0 .555-1.832z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$b6dc3d78982b295d$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b6dc3d78982b295d$export$2e2bcd8739ae039 = $b6dc3d78982b295d$var$PageLiveDoc24Icon;

});


parcelRegister("9Iwo3", function(module, exports) {

let $7131587aee457d5d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7131587aee457d5d$var$load("8qkPR").then(()=>parcelRequire('dci17'));

});

parcelRegister("5Ak2H", function(module, exports) {

let $410fdc8d94fecfa7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $410fdc8d94fecfa7$var$load("fbn5L").then(()=>parcelRequire('C9929'));

});

parcelRegister("gb3jU", function(module, exports) {

let $bc703fbd5be688a8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bc703fbd5be688a8$var$load("gKXx1").then(()=>parcelRequire('4KX56'));

});

parcelRegister("cjeHX", function(module, exports) {

let $8f62ab1ad0909b08$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8f62ab1ad0909b08$var$load("76xTz").then(()=>parcelRequire('3Y0kU'));

});

parcelRegister("6n9v8", function(module, exports) {

let $4a3c42c5d50247c1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4a3c42c5d50247c1$var$load("8ug3B").then(()=>parcelRequire('8BBLJ'));

});

parcelRegister("1ILHj", function(module, exports) {

let $140ee6411e9fbfef$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $140ee6411e9fbfef$var$load("erj8t").then(()=>parcelRequire('amxqt'));

});

parcelRegister("6dx3m", function(module, exports) {

let $486d98a24a52478c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $486d98a24a52478c$var$load("8zrOr").then(()=>parcelRequire('dtTJ9'));

});

parcelRegister("jticq", function(module, exports) {

let $e2ced7c344c671d5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e2ced7c344c671d5$var$load("l1bMV").then(()=>parcelRequire('6b4Xr'));

});

parcelRegister("eIsTj", function(module, exports) {

let $ab6b95f1105dbf9f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ab6b95f1105dbf9f$var$load("7eKSC").then(()=>parcelRequire('eHAfU'));

});

parcelRegister("f1B8s", function(module, exports) {

let $af03c14f83944172$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $af03c14f83944172$var$load("4Eivj").then(()=>parcelRequire('gbfWz'));

});

parcelRegister("cmEXk", function(module, exports) {

let $90074f15857f3006$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $90074f15857f3006$var$load("jYxgH").then(()=>parcelRequire('dRjRH'));

});

parcelRegister("bTWmL", function(module, exports) {

let $8aa21b1448097f6c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8aa21b1448097f6c$var$load("7Asrt").then(()=>parcelRequire('9Vj9G'));

});

parcelRegister("iSMal", function(module, exports) {

let $dbf2a1df4bf98f13$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dbf2a1df4bf98f13$var$load("lHw2B").then(()=>parcelRequire('eRvGI'));

});

parcelRegister("jRdgC", function(module, exports) {

let $e74d4222aaf1447b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e74d4222aaf1447b$var$load("kjPUS").then(()=>parcelRequire('6l95m'));

});

parcelRegister("kRp0o", function(module, exports) {

let $f2fc277294405d0e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f2fc277294405d0e$var$load("iNoMF").then(()=>parcelRequire('fuz0W'));

});

parcelRegister("KywEn", function(module, exports) {

let $08bf140fab0acedd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $08bf140fab0acedd$var$load("4oVpa").then(()=>parcelRequire('dn2cU'));

});

parcelRegister("fHwpk", function(module, exports) {

let $b6e4029ff0dd119f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b6e4029ff0dd119f$var$load("66VwL").then(()=>parcelRequire('cAlmw'));

});

parcelRegister("BSiun", function(module, exports) {

let $071d931c65cacbd8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $071d931c65cacbd8$var$load("giNlE").then(()=>parcelRequire('9HReW'));

});

parcelRegister("8l50I", function(module, exports) {

let $61242be4982e6a7b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $61242be4982e6a7b$var$load("8vZhS").then(()=>parcelRequire('8Pg2Y'));

});

parcelRegister("5S862", function(module, exports) {

let $446846ad0fad738a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $446846ad0fad738a$var$load("ffQaD"),
    $446846ad0fad738a$var$load("kvRbA"),
    $446846ad0fad738a$var$load("gLziw")
]).then(()=>parcelRequire('lrD2G'));

});

parcelRegister("cDlzR", function(module, exports) {

let $9329dd5d9131bf69$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9329dd5d9131bf69$var$load("4Z2q8").then(()=>parcelRequire('ka71P'));

});

parcelRegister("bMymA", function(module, exports) {

let $893ed53a3c7667da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $893ed53a3c7667da$var$load("kzCMD").then(()=>parcelRequire('kmi1F'));

});




parcelRegister("9020Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9e6bf288701895f$export$2e2bcd8739ae039);

var $ilCAi = parcelRequire("ilCAi");

var $hB03j = parcelRequire("hB03j");

var $cPcks = parcelRequire("cPcks");
const $d9e6bf288701895f$var$LiveDocumentIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ilCAi.default), (0, $hB03j.default));
$d9e6bf288701895f$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $d9e6bf288701895f$export$2e2bcd8739ae039 = $d9e6bf288701895f$var$LiveDocumentIconWithColor;

});


parcelRegister("67ulW", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e2ae224831a17c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2HNHt = parcelRequire("2HNHt");

var $65mpR = parcelRequire("65mpR");
const $78e2ae224831a17c$var$styles = {
    roundImg: "_2rko14q2"
};
const $78e2ae224831a17c$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If url changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton) return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: "",
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $hcewu.default)([
            appearance === 'round' && $78e2ae224831a17c$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: url,
        loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: "",
            style: {
                width: width,
                height: height
            },
            className: (0, $hcewu.default)([
                appearance === 'round' && $78e2ae224831a17c$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $78e2ae224831a17c$export$2e2bcd8739ae039 = $78e2ae224831a17c$var$ImageIcon;

});
parcelRegister("2HNHt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1f862656e4ed4164$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eJOHy = parcelRequire("eJOHy");
var $1f862656e4ed4164$var$React = $1f862656e4ed4164$var$_interopRequireWildcard($eJOHy);
function $1f862656e4ed4164$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1f862656e4ed4164$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1f862656e4ed4164$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1f862656e4ed4164$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $1f862656e4ed4164$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $1f862656e4ed4164$var$loaded() {
    return {
        isLoaded: true
    };
}
function $1f862656e4ed4164$var$errored() {
    return {
        isErrored: true
    };
}
function $1f862656e4ed4164$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $1f862656e4ed4164$var$ImageRenderer = function(_React$Component) {
    $1f862656e4ed4164$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $1f862656e4ed4164$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $1f862656e4ed4164$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $1f862656e4ed4164$var$_possibleConstructorReturn(_this, _ret);
    }
    $1f862656e4ed4164$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(this.props, nextProps)) this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($1f862656e4ed4164$var$React.Component);
module.exports.default = $1f862656e4ed4164$var$ImageRenderer;

});

parcelRegister("65mpR", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $dc3223680a49307e$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dc3223680a49307e$var$animationNameStyles = null;
const $dc3223680a49307e$var$loadingSkeletonStyle = null;
const $dc3223680a49307e$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $hcewu.default)([
            "_2rkoyh40 _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("9jYtV", function(module, exports) {

$parcel$export(module.exports, "withOverrideCss", () => $641d28b8590b444f$export$e0bdcacb944f1da6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $641d28b8590b444f$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $eJOHy.useRef)(null);
        (0, $eJOHy.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});



parcelRegister("bIdM1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b32359b6ff0e19a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $2b32359b6ff0e19a$var$baseBlockStyles = null;
const $2b32359b6ff0e19a$var$highlightRemoveStyles = null;
const $2b32359b6ff0e19a$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $2b32359b6ff0e19a$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $2b32359b6ff0e19a$var$Block = ({ children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $eJOHy.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $2b32359b6ff0e19a$var$directionStyles[direction],
            $2b32359b6ff0e19a$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId,
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $2b32359b6ff0e19a$export$2e2bcd8739ae039 = $2b32359b6ff0e19a$var$Block;

});

parcelRegister("k8J0S", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ef789dfa4e54c3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $7ef789dfa4e54c3c$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $7ef789dfa4e54c3c$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $7ef789dfa4e54c3c$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $7ef789dfa4e54c3c$var$baseStyles = null;
const $7ef789dfa4e54c3c$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $7ef789dfa4e54c3c$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $7ef789dfa4e54c3c$var$horizontalStyleBase = null;
const $7ef789dfa4e54c3c$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $7ef789dfa4e54c3c$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $7ef789dfa4e54c3c$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $7ef789dfa4e54c3c$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $7ef789dfa4e54c3c$var$ElementGroup = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5NtHI.SmartLinkWidth).FitToContent, position: position = (0, $5NtHI.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5NtHI.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7ef789dfa4e54c3c$var$baseStyleBySize[size],
            $7ef789dfa4e54c3c$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $7ef789dfa4e54c3c$var$alignmentStyleMap[align],
            "_1ul99by0",
            $7ef789dfa4e54c3c$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $7ef789dfa4e54c3c$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Left && $7ef789dfa4e54c3c$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Right && $7ef789dfa4e54c3c$var$gapStylesRight[size],
            $7ef789dfa4e54c3c$var$positionStyle[position],
            className
        ]),
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $7ef789dfa4e54c3c$export$2e2bcd8739ae039 = $7ef789dfa4e54c3c$var$ElementGroup;

});



parcelRegister("gKsxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $948e354a880fdc81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $948e354a880fdc81$var$DEFAULT_MAX_LINES = 2;
const $948e354a880fdc81$var$MAXIMUM_MAX_LINES = 2;
const $948e354a880fdc81$var$MINIMUM_MAX_LINES = 1;
const $948e354a880fdc81$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $948e354a880fdc81$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $948e354a880fdc81$var$getMaxLines = (maxLines)=>{
    if (maxLines > $948e354a880fdc81$var$MAXIMUM_MAX_LINES) return $948e354a880fdc81$var$DEFAULT_MAX_LINES;
    if (maxLines < $948e354a880fdc81$var$MINIMUM_MAX_LINES) return $948e354a880fdc81$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $948e354a880fdc81$var$ElementItemRenderer = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $5NtHI.SmartLinkSize).Medium, maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $brTAh.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
        align: align,
        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
        width: (0, $5NtHI.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $hcewu.default)([
            $948e354a880fdc81$var$truncateStyles[maxLines],
            $948e354a880fdc81$var$sizeStyles[size]
        ]),
        children: elements
    });
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $948e354a880fdc81$var$MetadataBlock = ({ maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $5NtHI.SmartLinkSize).Medium;
    const maxLinesTotal = $948e354a880fdc81$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                items: primary,
                size: size,
                maxLines: maxLinesTotal
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                items: secondary,
                size: size,
                maxLines: maxLinesTotal
            })
        ]
    });
};
var $948e354a880fdc81$export$2e2bcd8739ae039 = $948e354a880fdc81$var$MetadataBlock;

});

parcelRegister("8Rjtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $56e117ae59d9b928$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bgqs9 = parcelRequire("bgqs9");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $56e117ae59d9b928$var$PreviewBlock = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bgqs9.default), {
        ...blockProps,
        size: blockProps.size ?? ui?.size,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $56e117ae59d9b928$export$2e2bcd8739ae039 = $56e117ae59d9b928$var$PreviewBlock;

});
parcelRegister("bgqs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7730cb1921d134f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $7Byzo = parcelRequire("7Byzo");

var $bIdM1 = parcelRequire("bIdM1");
const $7730cb1921d134f4$var$previewBlockStyleCommon = null;
const $7730cb1921d134f4$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $7730cb1921d134f4$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)(style ?? {});
    const updateStyles = (0, $eJOHy.useCallback)(()=>{
        if (placement === (0, $5NtHI.MediaPlacement).Left || placement === (0, $5NtHI.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $5NtHI.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $5NtHI.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $eJOHy.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $eJOHy.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $eJOHy.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Byzo.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $7730cb1921d134f4$export$2e2bcd8739ae039 = $7730cb1921d134f4$var$PreviewBlockResolvedView;

});
parcelRegister("7Byzo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cb8c392c94261f3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4YO5T = parcelRequire("4YO5T");
const $4cb8c392c94261f3$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5NtHI.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4YO5T.default), {
        ...rest,
        ...data
    });
};
var $4cb8c392c94261f3$export$2e2bcd8739ae039 = $4cb8c392c94261f3$var$PreviewElement;

});
parcelRegister("4YO5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7eb4202b966638f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $67ulW = parcelRequire("67ulW");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $d7eb4202b966638f$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param props - The props necessary for the Media element.
 */ const $d7eb4202b966638f$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $d7eb4202b966638f$export$2e2bcd8739ae039 = $d7eb4202b966638f$var$MediaElement;

});




parcelRegister("5gb8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbe48527b965b005$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $5MmSu = parcelRequire("5MmSu");

var $f7w3l = parcelRequire("f7w3l");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
const $fbe48527b965b005$var$DEFAULT_MAX_LINES = 3;
const $fbe48527b965b005$var$MAXIMUM_MAX_LINES = 6;
const $fbe48527b965b005$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $fbe48527b965b005$var$SnippetBlock = ({ maxLines: maxLines = $fbe48527b965b005$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    const context = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5FRJ8.useFlexibleUiContext)() : undefined;
    const renderers = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5MmSu.useSmartLinkRenderers)() : undefined;
    const enableSnippetRenderer = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5FRJ8.useFlexibleUiOptionContext)()?.enableSnippetRenderer : undefined;
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fQH39.getMaxLines)(maxLines, $fbe48527b965b005$var$DEFAULT_MAX_LINES, $fbe48527b965b005$var$MAXIMUM_MAX_LINES, $fbe48527b965b005$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7w3l.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!(0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') || !enableSnippetRenderer) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: snippet
    });
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: SnippetReplacement ? /*#__PURE__*/ (0, $gt9Am.jsx)(SnippetReplacement, {
            fallbackText: (text || context?.snippet) ?? '',
            fallbackComponent: snippet,
            contentId: context?.meta?.objectId ?? '',
            contentType: context?.meta?.resourceType ?? '',
            cloudId: context?.meta?.tenantId ?? '',
            maxLines: snippetMaxLines,
            isHidden: isHidden,
            showFooter: showFooter
        }) : snippet
    });
};
var $fbe48527b965b005$export$2e2bcd8739ae039 = $fbe48527b965b005$var$SnippetBlock;

});
parcelRegister("5MmSu", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkRenderers", () => $8065e50e2bfb34aa$export$c3514c024fefef57);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $8065e50e2bfb34aa$export$c3514c024fefef57 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $eJOHy.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});

parcelRegister("f7w3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5970e5c744f439f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $b5970e5c744f439f$var$snippetBaseStyle = null;
const $b5970e5c744f439f$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $b5970e5c744f439f$export$2e2bcd8739ae039 = $b5970e5c744f439f$var$SnippetElement;

});
parcelRegister("38cBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6311575d89bb2b6b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toFormattedTextProps", () => $6311575d89bb2b6b$export$b9738bf28fb14829);
$parcel$export(module.exports, "toTextProps", () => $6311575d89bb2b6b$export$f12aecc78be3c7bb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $fQH39 = parcelRequire("fQH39");
const $6311575d89bb2b6b$var$baseStyle = null;
const $6311575d89bb2b6b$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
const $6311575d89bb2b6b$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $fQH39.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && $6311575d89bb2b6b$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $awdRS.default)(maxLines)
        },
        children: formattedContent
    });
};
var $6311575d89bb2b6b$export$2e2bcd8739ae039 = $6311575d89bb2b6b$export$79422073c7118b5b;
const $6311575d89bb2b6b$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};
const $6311575d89bb2b6b$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};

});



parcelRegister("2qnEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a63c55a864af4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $gxvmf = parcelRequire("gxvmf");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $d4a63c55a864af4f$var$AISummaryBlock = ({ testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gxvmf.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
};
var $d4a63c55a864af4f$export$2e2bcd8739ae039 = $d4a63c55a864af4f$var$AISummaryBlock;

});
parcelRegister("gxvmf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5839dd28b40ea23d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $2LycE = parcelRequire("2LycE");

var $4zxv7 = parcelRequire("4zxv7");

var $ei710 = parcelRequire("ei710");

var $bIdM1 = parcelRequire("bIdM1");

var $cQU20 = parcelRequire("cQU20");
const $5839dd28b40ea23d$var$styles = null;
const $5839dd28b40ea23d$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $4zxv7.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $2LycE.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $eJOHy.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        direction: (0, $5NtHI.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $hcewu.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cQU20.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4zxv7.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $5839dd28b40ea23d$export$2e2bcd8739ae039 = $5839dd28b40ea23d$var$AISummaryBlockResolvedView;

});
parcelRegister("2LycE", function(module, exports) {

$parcel$export(module.exports, "default", () => $442e3e8f06b649b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9R3Jd = parcelRequire("9R3Jd");
var $3seWH = parcelRequire("3seWH");

var $bmWcp = parcelRequire("bmWcp");

var $1mLfK = parcelRequire("1mLfK");

var $5TXKo = parcelRequire("5TXKo");

var $5sknP = parcelRequire("5sknP");

var $k2hJv = parcelRequire("k2hJv");
const $442e3e8f06b649b8$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $442e3e8f06b649b8$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $k2hJv.useAISummaryConfig)();
    const cardState = (0, $5TXKo.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $9R3Jd.extractAri)(data);
    const dataUrl = data && (0, $3seWH.extractLink)(data) || '';
    const onStart = (0, $eJOHy.useCallback)((id)=>{
        (0, $1mLfK.startUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $eJOHy.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1mLfK.succeedUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $eJOHy.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1mLfK.failUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $5sknP.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $442e3e8f06b649b8$export$2e2bcd8739ae039 = $442e3e8f06b649b8$var$useAISummaryAction;

});
parcelRegister("bmWcp", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $b236f5372ffdd3ba$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");


var $928jS = parcelRequire("928jS");
const $b236f5372ffdd3ba$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireEvent = (0, $eJOHy.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $928jS.default)(...params));
        event.fire((0, $6462ef276ac974ec$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $6462ef276ac974ec$export$3f072f06b90c3985 = 'media';

parcelRegister("928jS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac9e1681ec36717$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $5ac9e1681ec36717$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $5ac9e1681ec36717$export$2e2bcd8739ae039 = $5ac9e1681ec36717$var$createEventPayload;

});


parcelRegister("1mLfK", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $e01fd61e15160d33$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $e01fd61e15160d33$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $e01fd61e15160d33$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $e01fd61e15160d33$export$4084c0df4a03a6af);

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
const $e01fd61e15160d33$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
};
const $e01fd61e15160d33$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9iIu4.ConcurrentExperience)('smart-link-rendered', $e01fd61e15160d33$var$renderExperience),
    'smart-link-authenticated': new (0, $9iIu4.ConcurrentExperience)('smart-link-authenticated', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9iIu4.ConcurrentExperience)('smart-link-action-invocation', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9iIu4.ConcurrentExperience)('smart-link-ai-summary', $e01fd61e15160d33$var$aiExperience)
};
const $e01fd61e15160d33$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $e01fd61e15160d33$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("5TXKo", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $644fcc1916cdb207$export$b0444d00ba7313c6);

var $iHcr1 = parcelRequire("iHcr1");

var $9kfy2 = parcelRequire("9kfy2");
const $644fcc1916cdb207$var$PENDING_STATE = {
    status: 'pending'
};
function $644fcc1916cdb207$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const cardState = (0, $iHcr1.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $644fcc1916cdb207$var$PENDING_STATE;
}

});

parcelRegister("5sknP", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bI4It = parcelRequire("bI4It");

var $64EXn = parcelRequire("64EXn");
const $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $eJOHy.useState)((0, $64EXn.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $64EXn.AISummariesStore).get(url)) (0, $64EXn.AISummariesStore).set(url, new (0, $bI4It.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $64EXn.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $64EXn.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("bI4It", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $ee3df5d12a847ac3$export$73e4b807d5bd74b6);

var $aXKmr = parcelRequire("aXKmr");

var $a5MXk = parcelRequire("a5MXk");

var $eGOwo = parcelRequire("eGOwo");

var $4NcaA = parcelRequire("4NcaA");

var $8hWqs = parcelRequire("8hWqs");

var $9ntiN = parcelRequire("9ntiN");
const $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $ee3df5d12a847ac3$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = (0, $eGOwo.fg)('platform-linking-ai-summary-migration-to-convo-ai') ? $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT : 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $a5MXk.getBaseUrl)(envKey);
                return (0, $9ntiN.addPath)(baseUrl, path);
            }
            return (0, $9ntiN.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: (0, $eGOwo.fg)('platform-linking-ai-summary-migration-to-convo-ai') ? {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                } : undefined
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $4NcaA.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $9ntiN.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = (0, $eGOwo.fg)('platform-linking-ai-summary-migration-to-convo-ai') ? chunk.message.content : chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $8hWqs.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $8hWqs.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("4NcaA", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $3c1ef1a29697a261$export$e45226161c660403);

var $9ntiN = parcelRequire("9ntiN");
async function* $3c1ef1a29697a261$export$e45226161c660403(response) {
    const reader = (0, $9ntiN.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("9ntiN", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $75d74a4f0b187756$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $75d74a4f0b187756$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $75d74a4f0b187756$export$ff2962de2b2c930f);
const $75d74a4f0b187756$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $75d74a4f0b187756$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $75d74a4f0b187756$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $75d74a4f0b187756$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $75d74a4f0b187756$export$ff2962de2b2c930f = (product)=>{
    if ($75d74a4f0b187756$var$isJiraProduct(product)) return $75d74a4f0b187756$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("8hWqs", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $424f983e1007104e$export$fcec967a4b7ebd84);
class $424f983e1007104e$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $424f983e1007104e$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("64EXn", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $6b567d039eac44f3$export$6979339b6d41707e);

var $7xkt0 = parcelRequire("7xkt0");
const $6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE = 100;
const $6b567d039eac44f3$export$6979339b6d41707e = new (0, $7xkt0.LRUMap)($6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("k2hJv", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $3042bebadd8b2921$export$4480af2c00aa7ebe);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $3042bebadd8b2921$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("4zxv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e0b0d82c1c1601$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gzZ1I = parcelRequire("gzZ1I");

var $3JG7o = parcelRequire("3JG7o");
const $50e0b0d82c1c1601$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $50e0b0d82c1c1601$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gzZ1I.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $3JG7o.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $50e0b0d82c1c1601$export$2e2bcd8739ae039 = $50e0b0d82c1c1601$var$AISummary;

});
parcelRegister("gzZ1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $031d6845af3014cc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $031d6845af3014cc$var$t() {
    return $031d6845af3014cc$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $031d6845af3014cc$var$t.apply(this, arguments);
}
const $031d6845af3014cc$var$n = [
    "children",
    "options"
], $031d6845af3014cc$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $031d6845af3014cc$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($031d6845af3014cc$var$i || ($031d6845af3014cc$var$i = {}));
const $031d6845af3014cc$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $031d6845af3014cc$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $031d6845af3014cc$var$o = [
    "style",
    "script"
], $031d6845af3014cc$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $031d6845af3014cc$var$s = /mailto:/i, $031d6845af3014cc$var$d = /\n{2,}$/, $031d6845af3014cc$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $031d6845af3014cc$var$u = /^ *> ?/gm, $031d6845af3014cc$var$f = /^ {2,}\n/, $031d6845af3014cc$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $031d6845af3014cc$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $031d6845af3014cc$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $031d6845af3014cc$var$k = /^(?:\n *)*\n/, $031d6845af3014cc$var$x = /\r\n?/g, $031d6845af3014cc$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $031d6845af3014cc$var$v = /^\[\^([^\]]+)]/, $031d6845af3014cc$var$S = /\f/g, $031d6845af3014cc$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $031d6845af3014cc$var$C = /^\s*?\[(x|\s)\]/, $031d6845af3014cc$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $031d6845af3014cc$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $031d6845af3014cc$var$T = /^<!--[\s\S]*?(?:-->)/, $031d6845af3014cc$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $031d6845af3014cc$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $031d6845af3014cc$var$M = /^\{.*\}$/, $031d6845af3014cc$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $031d6845af3014cc$var$I = /^<([^ >]+@[^ >]+)>/, $031d6845af3014cc$var$U = /^<([^ >]+:\/[^ >]+)>/, $031d6845af3014cc$var$D = /-([a-z])?/gi, $031d6845af3014cc$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $031d6845af3014cc$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $031d6845af3014cc$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $031d6845af3014cc$var$_ = /\t/g, $031d6845af3014cc$var$G = /(^ *\||\| *$)/g, $031d6845af3014cc$var$W = /^ *:-+: *$/, $031d6845af3014cc$var$Z = /^ *:-+ *$/, $031d6845af3014cc$var$q = /^ *-+: *$/, $031d6845af3014cc$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $031d6845af3014cc$var$V = new RegExp(`^([*_])\\1${$031d6845af3014cc$var$Q}\\1\\1(?!\\1)`), $031d6845af3014cc$var$X = new RegExp(`^([*_])${$031d6845af3014cc$var$Q}\\1(?!\\1|\\w)`), $031d6845af3014cc$var$J = new RegExp(`^==${$031d6845af3014cc$var$Q}==`), $031d6845af3014cc$var$K = new RegExp(`^~~${$031d6845af3014cc$var$Q}~~`), $031d6845af3014cc$var$Y = /^\\([^0-9A-Za-z\s])/, $031d6845af3014cc$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $031d6845af3014cc$var$te = /^\n+/, $031d6845af3014cc$var$ne = /^([ \t]*)/, $031d6845af3014cc$var$re = /\\([^\\])/g, $031d6845af3014cc$var$ie = / *\n+$/, $031d6845af3014cc$var$le = /(?:^|\n)( *)$/, $031d6845af3014cc$var$ae = "(?:\\d+\\.)", $031d6845af3014cc$var$oe = "(?:[*+-])";
function $031d6845af3014cc$var$ce(e) {
    return "( *)(" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + ") +";
}
const $031d6845af3014cc$var$se = $031d6845af3014cc$var$ce(1), $031d6845af3014cc$var$de = $031d6845af3014cc$var$ce(2);
function $031d6845af3014cc$var$pe(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de));
}
const $031d6845af3014cc$var$ue = $031d6845af3014cc$var$pe(1), $031d6845af3014cc$var$fe = $031d6845af3014cc$var$pe(2);
function $031d6845af3014cc$var$he(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $031d6845af3014cc$var$me = $031d6845af3014cc$var$he(1), $031d6845af3014cc$var$ge = $031d6845af3014cc$var$he(2);
function $031d6845af3014cc$var$ye(e) {
    const t = 1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $031d6845af3014cc$var$ke = $031d6845af3014cc$var$ye(1), $031d6845af3014cc$var$xe = $031d6845af3014cc$var$ye(2);
function $031d6845af3014cc$var$be(e, t) {
    const n = 1 === t, i = n ? $031d6845af3014cc$var$ke : $031d6845af3014cc$var$xe, l = n ? $031d6845af3014cc$var$me : $031d6845af3014cc$var$ge, a = n ? $031d6845af3014cc$var$ue : $031d6845af3014cc$var$fe;
    return {
        match (e, t) {
            const n = $031d6845af3014cc$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($031d6845af3014cc$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($031d6845af3014cc$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($031d6845af3014cc$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $031d6845af3014cc$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $031d6845af3014cc$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $031d6845af3014cc$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $031d6845af3014cc$var$Ee = [
    $031d6845af3014cc$var$p,
    $031d6845af3014cc$var$m,
    $031d6845af3014cc$var$g,
    $031d6845af3014cc$var$$,
    $031d6845af3014cc$var$z,
    $031d6845af3014cc$var$w,
    $031d6845af3014cc$var$T,
    $031d6845af3014cc$var$j,
    $031d6845af3014cc$var$me,
    $031d6845af3014cc$var$ke,
    $031d6845af3014cc$var$ge,
    $031d6845af3014cc$var$xe
], $031d6845af3014cc$var$Ce = [
    ...$031d6845af3014cc$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $031d6845af3014cc$var$L,
    $031d6845af3014cc$var$B
];
function $031d6845af3014cc$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $031d6845af3014cc$var$we(e) {
    return $031d6845af3014cc$var$q.test(e) ? "right" : $031d6845af3014cc$var$W.test(e) ? "center" : $031d6845af3014cc$var$Z.test(e) ? "left" : null;
}
function $031d6845af3014cc$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $031d6845af3014cc$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $031d6845af3014cc$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($031d6845af3014cc$var$G, "").split("|").map($031d6845af3014cc$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $031d6845af3014cc$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $031d6845af3014cc$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.paragraph
    };
}
function $031d6845af3014cc$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $031d6845af3014cc$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $031d6845af3014cc$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $031d6845af3014cc$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$031d6845af3014cc$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $031d6845af3014cc$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $031d6845af3014cc$var$Ue(e) {
    return e.replace($031d6845af3014cc$var$re, "$1");
}
function $031d6845af3014cc$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $031d6845af3014cc$var$He = (e, t, n)=>({
        children: $031d6845af3014cc$var$De(t, e[1], n)
    });
function $031d6845af3014cc$var$Fe() {
    return {};
}
function $031d6845af3014cc$var$Pe() {
    return null;
}
function $031d6845af3014cc$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $031d6845af3014cc$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $031d6845af3014cc$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $031d6845af3014cc$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $031d6845af3014cc$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $031d6845af3014cc$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $031d6845af3014cc$var$t({}, n, l, {
            className: $031d6845af3014cc$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($031d6845af3014cc$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $031d6845af3014cc$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($031d6845af3014cc$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $eJOHy.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($031d6845af3014cc$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($031d6845af3014cc$var$O) && (e = e.replace($031d6845af3014cc$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $031d6845af3014cc$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($031d6845af3014cc$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($031d6845af3014cc$var$L.test(p) || $031d6845af3014cc$var$B.test(p)) && (n[d] = $eJOHy.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$031d6845af3014cc$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $031d6845af3014cc$export$3e2338ea76b578c9, i.slugify = i.slugify || $031d6845af3014cc$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $031d6845af3014cc$var$t({}, $031d6845af3014cc$var$a, i.namedCodesToUnicode) : $031d6845af3014cc$var$a, i.createElement = i.createElement || $eJOHy.createElement;
    const Z = [], q = {}, Q = {
        [$031d6845af3014cc$export$e0aa44767d8750d5.blockQuote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($031d6845af3014cc$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakLine]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$f),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakThematic]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$h),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeBlock]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $031d6845af3014cc$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeFenced]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeInline]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnoteReference]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $031d6845af3014cc$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.gfmTask]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.heading]: {
            match: $031d6845af3014cc$var$Be(i.enforceAtxHeadings ? $031d6845af3014cc$var$w : $031d6845af3014cc$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[2], n),
                    id: i.slugify(e[2], $031d6845af3014cc$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.headingSetext]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.heading
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($031d6845af3014cc$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $031d6845af3014cc$var$Ce.some((e)=>e.test(c)) ? $031d6845af3014cc$var$Ne : $031d6845af3014cc$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $031d6845af3014cc$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlComment]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$T),
            order: 1,
            parse: ()=>({}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.image]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.link]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$je(t, e[1], n),
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $031d6845af3014cc$var$Te($031d6845af3014cc$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $031d6845af3014cc$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                };
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.orderedList]: $031d6845af3014cc$var$be(d, 1),
        [$031d6845af3014cc$export$e0aa44767d8750d5.unorderedList]: $031d6845af3014cc$var$be(d, 2),
        [$031d6845af3014cc$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$k),
            order: 3,
            parse: $031d6845af3014cc$var$Fe,
            render: ()=>"\n"
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.paragraph]: {
            match: $031d6845af3014cc$var$Re,
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.ref]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refImage]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refLink]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.table]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$j),
            order: 1,
            parse: $031d6845af3014cc$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $031d6845af3014cc$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $031d6845af3014cc$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.text]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($031d6845af3014cc$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textBolded]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEmphasized]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEscaped]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textMarked]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$J),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$K),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock], delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($031d6845af3014cc$var$x, "\n").replace($031d6845af3014cc$var$S, "").replace($031d6845af3014cc$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $031d6845af3014cc$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $031d6845af3014cc$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $031d6845af3014cc$var$n);
    return $eJOHy.cloneElement($031d6845af3014cc$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("3JG7o", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f398c5c3f3cb7e7$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $8f398c5c3f3cb7e7$var$listStyles = null;
const $8f398c5c3f3cb7e7$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        ...props,
        className: (0, $hcewu.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $8f398c5c3f3cb7e7$export$2e2bcd8739ae039 = $8f398c5c3f3cb7e7$var$UList;

});


parcelRegister("ei710", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda5b98323afadf3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $fda5b98323afadf3$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $eJOHy.useState)(0);
    const ref = (0, $eJOHy.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $eJOHy.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $fda5b98323afadf3$export$2e2bcd8739ae039 = $fda5b98323afadf3$export$6118ed0013927eb2;

});

parcelRegister("cQU20", function(module, exports) {

$parcel$export(module.exports, "default", () => $f73e03b62ddf95ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $f73e03b62ddf95ac$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $f73e03b62ddf95ac$export$2e2bcd8739ae039 = $f73e03b62ddf95ac$var$AIEventSummaryViewed;

});



parcelRegister("eMgzj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a57421ef9d4f6376$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $37K19 = parcelRequire("37K19");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $a57421ef9d4f6376$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37K19.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $a57421ef9d4f6376$export$2e2bcd8739ae039 = $a57421ef9d4f6376$var$AIFooterBlock;

});
parcelRegister("37K19", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a90281cb091ec71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $bIdM1 = parcelRequire("bIdM1");

var $kopBz = parcelRequire("kopBz");
const $3a90281cb091ec71$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopBz.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $3a90281cb091ec71$export$2e2bcd8739ae039 = $3a90281cb091ec71$var$AIFooterBlockResolvedView;

});
parcelRegister("kopBz", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $bf118c10e8951921$export$175228cc2c92b3b6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $fOqNz = parcelRequire("fOqNz");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $k71qx = parcelRequire("k71qx");

var $19nmp = parcelRequire("19nmp");

var $2LycE = parcelRequire("2LycE");

var $jeUcl = parcelRequire("jeUcl");

var $bB163 = parcelRequire("bB163");
const $bf118c10e8951921$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bB163.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $jeUcl.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("fOqNz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b830502683dea4c7$var$_react = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b830502683dea4c7$var$_baseNew = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b830502683dea4c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b830502683dea4c7$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $b830502683dea4c7$var$_react.default.createElement($b830502683dea4c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$b830502683dea4c7$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $b830502683dea4c7$var$_default = module.exports.default = $b830502683dea4c7$var$AtlassianIntelligenceIcon;

});

parcelRegister("jeUcl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f62baba7cd68ce1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $9f62baba7cd68ce1$var$AiIcon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $9f62baba7cd68ce1$export$2e2bcd8739ae039 = $9f62baba7cd68ce1$var$AiIcon;

});

parcelRegister("bB163", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $ebe2ee8525f34821$export$2957fc44b3d2481);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2R0ne = parcelRequire("2R0ne");

var $klVDP = parcelRequire("klVDP");
const $ebe2ee8525f34821$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $klVDP.default),
        ...props
    });

});
parcelRegister("klVDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $95f050f94233fcee$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $95f050f94233fcee$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $95f050f94233fcee$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $95f050f94233fcee$var$InfoIconGlyph
    });
var $95f050f94233fcee$export$2e2bcd8739ae039 = $95f050f94233fcee$var$InfoIcon;

});





parcelRegister("4cjOx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a174909684ab758$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $lHA6U = parcelRequire("lHA6U");

var $1dIgp = parcelRequire("1dIgp");
const $3a174909684ab758$var$ignoreContainerPaddingStyles = null;
const $3a174909684ab758$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $3a174909684ab758$var$sort = (a, b)=>{
    let idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $3a174909684ab758$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $3a174909684ab758$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gRw8I.di)((0, $1dIgp.ActionFooter));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const onLoadingChange = (0, $eJOHy.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $3a174909684ab758$export$1af10e3728e3a644(ui?.size || (0, $5NtHI.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $eJOHy.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $eJOHy.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $eJOHy.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($3a174909684ab758$var$sort);
        return arr.map((name)=>{
            const Action = name in $lHA6U ? $lHA6U[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || ui?.size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick
    ]);
    return actions ? /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dIgp.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $3a174909684ab758$export$2e2bcd8739ae039 = $3a174909684ab758$var$ActionBlock;

});
parcelRegister("lHA6U", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("9hHCO")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("dckwx")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("c0FsA")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("dGv8r")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("lSW97")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("3MDCL")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("b1dbu")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("cLrUd")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("2fs4B")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("1EoLm")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("bKvNh")).default);
$parcel$export(module.exports, "CustomUnresolvedAction", () => (parcelRequire("fd4of")).default);

var $9hHCO = parcelRequire("9hHCO");

var $dckwx = parcelRequire("dckwx");

var $c0FsA = parcelRequire("c0FsA");

var $dGv8r = parcelRequire("dGv8r");

var $lSW97 = parcelRequire("lSW97");

var $3MDCL = parcelRequire("3MDCL");

var $b1dbu = parcelRequire("b1dbu");

var $cLrUd = parcelRequire("cLrUd");

var $2fs4B = parcelRequire("2fs4B");

var $1EoLm = parcelRequire("1EoLm");

var $bKvNh = parcelRequire("bKvNh");

var $fd4of = parcelRequire("fd4of");

});
parcelRegister("9hHCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2469864747178fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $8ABAe = parcelRequire("8ABAe");

var $fh1oH = parcelRequire("fh1oH");

var $dQnV8 = parcelRequire("dQnV8");

var $cNUXI = parcelRequire("cNUXI");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $c2469864747178fa$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cNUXI.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fh1oH.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ABAe.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $c2469864747178fa$export$2e2bcd8739ae039 = $c2469864747178fa$var$Action;

});
parcelRegister("8ABAe", function(module, exports) {

$parcel$export(module.exports, "default", () => $810b448b0b6757f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cA0Y2 = parcelRequire("cA0Y2");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");
var $5bY40 = parcelRequire("5bY40");
var $6K3F5 = parcelRequire("6K3F5");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $810b448b0b6757f9$var$IconOnlyLarge = null;
const $810b448b0b6757f9$var$SizeSmall = null;
const $810b448b0b6757f9$var$SizeSmallIconOnly = null;
const $810b448b0b6757f9$var$SizeSmallNotIconOnly = null;
const $810b448b0b6757f9$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $810b448b0b6757f9$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $810b448b0b6757f9$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $810b448b0b6757f9$var$ActionButtonRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $eJOHy.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6K3F5.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
const $810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss = (0, $9jYtV.withOverrideCss)($810b448b0b6757f9$var$ActionButtonRefresh);
const $810b448b0b6757f9$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            size === (0, $5NtHI.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5NtHI.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $5NtHI.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $5NtHI.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cA0Y2.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fQH39.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $810b448b0b6757f9$var$ActionButton = (props)=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonNew, {
        ...props
    });
};
var $810b448b0b6757f9$export$2e2bcd8739ae039 = $810b448b0b6757f9$var$ActionButton;

});

parcelRegister("fh1oH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4141238200e2a86d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $FoFt2 = parcelRequire("FoFt2");
const $4141238200e2a86d$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $FoFt2.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $4141238200e2a86d$export$2e2bcd8739ae039 = $4141238200e2a86d$var$ActionDropdownItem;

});

parcelRegister("dQnV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $182322eb34547fdc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
const $182322eb34547fdc$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$stackItemIconStylesOld = null;
const $182322eb34547fdc$var$stackItemIconStylesCompiled = null;
const $182322eb34547fdc$var$ActionIcon = ({ size: size, testId: testId, icon: icon, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap[$182322eb34547fdc$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $182322eb34547fdc$export$2e2bcd8739ae039 = $182322eb34547fdc$var$ActionIcon;

});

parcelRegister("cNUXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23b94a27dbb965d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $e5DLq = parcelRequire("e5DLq");
const $d23b94a27dbb965d$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $d23b94a27dbb965d$export$2e2bcd8739ae039 = $d23b94a27dbb965d$var$ActionStackItem;

});
parcelRegister("e5DLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d6dc8e23eec4828$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");

var $7ep4S = parcelRequire("7ep4S");

var $fQH39 = parcelRequire("fQH39");

var $dQnV8 = parcelRequire("dQnV8");
const $0d6dc8e23eec4828$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $0d6dc8e23eec4828$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fQH39.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $0d6dc8e23eec4828$export$2e2bcd8739ae039 = $0d6dc8e23eec4828$var$ActionButton;

});



parcelRegister("dckwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3290b93af8be85b3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $6J9k6 = parcelRequire("6J9k6");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $3290b93af8be85b3$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        ...props
    });
var $3290b93af8be85b3$export$2e2bcd8739ae039 = $3290b93af8be85b3$var$DeleteAction;

});

parcelRegister("c0FsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $920fde411498a771$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bp0jd = parcelRequire("bp0jd");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $920fde411498a771$var$EditAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bp0jd))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        ...props
    });
var $920fde411498a771$export$2e2bcd8739ae039 = $920fde411498a771$var$EditAction;

});
parcelRegister("bp0jd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84d244d8a31b5641$var$_react = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $84d244d8a31b5641$var$_edit = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("gTr6H")));

var $84d244d8a31b5641$var$_edit2 = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("dUYQ5")));
function $84d244d8a31b5641$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84d244d8a31b5641$var$EditIcon = (props)=>/*#__PURE__*/ $84d244d8a31b5641$var$_react.default.createElement($84d244d8a31b5641$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $84d244d8a31b5641$var$_edit2.default
    }, props));
$84d244d8a31b5641$var$EditIcon.Name = 'EditIconMigration';
var $84d244d8a31b5641$var$_default = module.exports.default = $84d244d8a31b5641$var$EditIcon;

});
parcelRegister("dUYQ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a21fb2aec03ab384$var$_react = $a21fb2aec03ab384$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $a21fb2aec03ab384$var$_edit = $a21fb2aec03ab384$var$_interopRequireDefault((parcelRequire("gTr6H")));
function $a21fb2aec03ab384$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a21fb2aec03ab384$var$EditIcon = (props)=>/*#__PURE__*/ $a21fb2aec03ab384$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $a21fb2aec03ab384$var$_edit.default
    }));
$a21fb2aec03ab384$var$EditIcon.displayName = 'EditIcon';
var $a21fb2aec03ab384$var$_default = module.exports.default = $a21fb2aec03ab384$var$EditIcon;

});



parcelRegister("dGv8r", function(module, exports) {

$parcel$export(module.exports, "default", () => $bea6a5d6049b9822$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $kHcBe = parcelRequire("kHcBe");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $bea6a5d6049b9822$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).DownloadAction];
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $19nmp.messages).download_file : (0, $19nmp.messages).download;
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).download_description : (0, $19nmp.messages).download;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHcBe))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $bea6a5d6049b9822$export$2e2bcd8739ae039 = $bea6a5d6049b9822$var$DownloadAction;

});
parcelRegister("kHcBe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f11198d3276cd080$var$_react = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f11198d3276cd080$var$_download = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("5Mb5i")));

var $f11198d3276cd080$var$_download2 = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("bRp3T")));
function $f11198d3276cd080$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f11198d3276cd080$var$DownloadIcon = (props)=>/*#__PURE__*/ $f11198d3276cd080$var$_react.default.createElement($f11198d3276cd080$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $f11198d3276cd080$var$_download2.default
    }, props));
$f11198d3276cd080$var$DownloadIcon.Name = 'DownloadIconMigration';
var $f11198d3276cd080$var$_default = module.exports.default = $f11198d3276cd080$var$DownloadIcon;

});
parcelRegister("5Mb5i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $434a088e5f2bb7a6$var$_react = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $434a088e5f2bb7a6$var$_baseNew = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $434a088e5f2bb7a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $434a088e5f2bb7a6$var$DownloadIcon = (props)=>/*#__PURE__*/ $434a088e5f2bb7a6$var$_react.default.createElement($434a088e5f2bb7a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$434a088e5f2bb7a6$var$DownloadIcon.displayName = 'DownloadIcon';
var $434a088e5f2bb7a6$var$_default = module.exports.default = $434a088e5f2bb7a6$var$DownloadIcon;

});

parcelRegister("bRp3T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a2815b0aa140afa$var$_react = $8a2815b0aa140afa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $8a2815b0aa140afa$var$_download = $8a2815b0aa140afa$var$_interopRequireDefault((parcelRequire("5Mb5i")));
function $8a2815b0aa140afa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a2815b0aa140afa$var$DownloadIcon = (props)=>/*#__PURE__*/ $8a2815b0aa140afa$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $8a2815b0aa140afa$var$_download.default
    }));
$8a2815b0aa140afa$var$DownloadIcon.displayName = 'DownloadIcon';
var $8a2815b0aa140afa$var$_default = module.exports.default = $8a2815b0aa140afa$var$DownloadIcon;

});


parcelRegister("7xssH", function(module, exports) {

$parcel$export(module.exports, "default", () => $28096ecb360b0e22$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $bmWcp = parcelRequire("bmWcp");

var $2QXr6 = parcelRequire("2QXr6");

var $1mLfK = parcelRequire("1mLfK");
const $28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $28096ecb360b0e22$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $eJOHy.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $2QXr6.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1mLfK.startUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $2QXr6.mark(markName, 'resolved');
            (0, $1mLfK.succeedUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $2QXr6.mark(markName, 'errored');
            (0, $1mLfK.failUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $28096ecb360b0e22$export$2e2bcd8739ae039 = $28096ecb360b0e22$var$useInvokeClientAction;

});
parcelRegister("2QXr6", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $a922bc214c753b7c$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $a922bc214c753b7c$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $a922bc214c753b7c$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $a922bc214c753b7c$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $a922bc214c753b7c$export$185802fd694ee1f5);
const $a922bc214c753b7c$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $a922bc214c753b7c$var$hasPerformanceAPIAvailable = $a922bc214c753b7c$var$isPerformanceAPIAvailable();
const $a922bc214c753b7c$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $a922bc214c753b7c$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $a922bc214c753b7c$export$1a717feb4df1a945 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $a922bc214c753b7c$export$de42547d395c8271 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $a922bc214c753b7c$var$getMark = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $a922bc214c753b7c$export$185802fd694ee1f5 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measure = $a922bc214c753b7c$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $a922bc214c753b7c$var$getMark(id, 'pending');
            const endMark = $a922bc214c753b7c$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("lSW97", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfe202eda411d4c1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $5UiT3 = parcelRequire("5UiT3");

var $kxXL5 = parcelRequire("kxXL5");


const $dfe202eda411d4c1$var$importIconMapper = {
    goal: ()=>(parcelRequire("59ZsC")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("b7Rzw")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $dfe202eda411d4c1$var$getIcon = (stackIconType)=>{
    const importFn = $dfe202eda411d4c1$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fQH39.importIcon)(importFn);
};
const $dfe202eda411d4c1$var$FollowAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $19nmp.messages).follow : (0, $19nmp.messages).unfollow;
    const projectMessage = value ? (0, $19nmp.messages).follow_project : (0, $19nmp.messages).unfollow_project;
    const goalMessage = value ? (0, $19nmp.messages).follow_goal : (0, $19nmp.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $19nmp.messages).follow_project_description : (0, $19nmp.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $19nmp.messages).follow_goal_description : (0, $19nmp.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $dfe202eda411d4c1$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $kxXL5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5UiT3.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $dfe202eda411d4c1$export$2e2bcd8739ae039 = $dfe202eda411d4c1$var$FollowAction;

});
parcelRegister("5UiT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce9aaae704363155$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $1rn8a = parcelRequire("1rn8a");

var $9hHCO = parcelRequire("9hHCO");
const $ce9aaae704363155$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const invoke = (0, $6O4ri.default)();
    const reload = (0, $kbv8x.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleClick = (0, $eJOHy.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $1rn8a.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $d0InI.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $ce9aaae704363155$export$2e2bcd8739ae039 = $ce9aaae704363155$var$ServerAction;

});
parcelRegister("6O4ri", function(module, exports) {

$parcel$export(module.exports, "default", () => $b69a1ac7b939ac3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $18BbB = parcelRequire("18BbB");

var $9kfy2 = parcelRequire("9kfy2");
const $b69a1ac7b939ac3b$var$useInvoke = ()=>{
    const { connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const clientExt = (0, $18BbB.useSmartLinkClientExtension)(connections.client);
    return (0, $eJOHy.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $b69a1ac7b939ac3b$export$2e2bcd8739ae039 = $b69a1ac7b939ac3b$var$useInvoke;

});
parcelRegister("18BbB", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $365002b9ec3223b9$export$303ede4eed148855);

var $eJOHy = parcelRequire("eJOHy");

var $hhFie = parcelRequire("hhFie");

var $5CgrK = parcelRequire("5CgrK");

var $jAAbh = parcelRequire("jAAbh");
const $365002b9ec3223b9$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $jAAbh.useResolverUrl)(cardClient);
    const invoke = (0, $eJOHy.useCallback)(async (data)=>{
        try {
            return await (0, $hhFie.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $5CgrK.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("5CgrK", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $1ec6011516cb04bd$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $1ec6011516cb04bd$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $1ec6011516cb04bd$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $1ec6011516cb04bd$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("jAAbh", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $248dfa90412a2e2f$export$d08617a365fbe694);

var $eJOHy = parcelRequire("eJOHy");

var $a5MXk = parcelRequire("a5MXk");
const $248dfa90412a2e2f$export$d08617a365fbe694 = (cardClient)=>(0, $eJOHy.useMemo)(()=>(0, $a5MXk.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("d0InI", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $842afed3b5601c74$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $842afed3b5601c74$export$1694272377fa07d8);

var $b43DQ = parcelRequire("b43DQ");
const $842afed3b5601c74$export$65b3f792dff0bd60 = (err)=>{
    if (!$842afed3b5601c74$export$1694272377fa07d8(err)) return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $b43DQ.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    }
};
const $842afed3b5601c74$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("kbv8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $b139b7122b26d76a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3jSKi = parcelRequire("3jSKi");

var $9kfy2 = parcelRequire("9kfy2");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $99QxN = parcelRequire("99QxN");
const $b139b7122b26d76a$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $99QxN.default)();
    return (0, $eJOHy.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $3jSKi.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1mLfK.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $b139b7122b26d76a$export$2e2bcd8739ae039 = $b139b7122b26d76a$var$useResolve;

});
parcelRegister("99QxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b217076914baa8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");
var $4pUJe = parcelRequire("4pUJe");
var $4g7cp = parcelRequire("4g7cp");

var $5NtHI = parcelRequire("5NtHI");

var $gA511 = parcelRequire("gA511");

const $69b217076914baa8$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $eJOHy.useCallback)((url, metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $eJOHy.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: url
        }, (0, $gA511.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $4g7cp.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fallback', hostname, (0, $9121cfe34e6487d9$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fatal', hostname, (0, $9121cfe34e6487d9$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('error', hostname, (0, $9121cfe34e6487d9$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $aQK2r.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $69b217076914baa8$export$2e2bcd8739ae039 = $69b217076914baa8$var$useResponse;

});
parcelRegister("gA511", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $af7c5b7c4494ebd5$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $af7c5b7c4494ebd5$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $af7c5b7c4494ebd5$export$e32193033a594efb);
const $af7c5b7c4494ebd5$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $af7c5b7c4494ebd5$export$2796a804c6e44f63 = ()=>$af7c5b7c4494ebd5$var$emptyData;
const $af7c5b7c4494ebd5$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });
const $af7c5b7c4494ebd5$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });

});

const $9121cfe34e6487d9$export$297c39c8b9bfca0 = 'resolving';
const $9121cfe34e6487d9$export$b64a888338c24e0e = 'errored';
const $9121cfe34e6487d9$export$677b6edfa0002c70 = 'fallback';
const $9121cfe34e6487d9$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $9121cfe34e6487d9$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $9121cfe34e6487d9$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("1rn8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $6426c76052ace8de$export$2e2bcd8739ae039);
const $6426c76052ace8de$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $6426c76052ace8de$export$2e2bcd8739ae039 = $6426c76052ace8de$var$createInvokeRequest;

});


parcelRegister("kxXL5", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $b87644dc5deec150$export$49248678d3914625);

var $19nmp = parcelRequire("19nmp");
const $b87644dc5deec150$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $19nmp.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $19nmp.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $19nmp.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $19nmp.messages).unfollow_goal_error;
    return (0, $19nmp.messages).generic_error_message;
};

});

parcelRegister("59ZsC", function(module, exports) {

let $3c1d77d2dd928a94$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3c1d77d2dd928a94$var$load("ffQaD"),
    $3c1d77d2dd928a94$var$load("kvRbA"),
    $3c1d77d2dd928a94$var$load("3nUhw")
]).then(()=>parcelRequire('k96Yq'));

});

parcelRegister("b7Rzw", function(module, exports) {

let $8199e76ea14b9640$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8199e76ea14b9640$var$load("ffQaD"),
    $8199e76ea14b9640$var$load("kvRbA"),
    $8199e76ea14b9640$var$load("1877j")
]).then(()=>parcelRequire('c6wmU'));

});


parcelRegister("3MDCL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7238a60227ffb9b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1hBh4 = parcelRequire("1hBh4");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $a7238a60227ffb9b$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).PreviewAction];
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).preview_description : (0, $19nmp.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1hBh4))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $a7238a60227ffb9b$export$2e2bcd8739ae039 = $a7238a60227ffb9b$var$PreviewAction;

});
parcelRegister("1hBh4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ef44ae728b7e983$var$_react = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0ef44ae728b7e983$var$_growDiagonal = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("XhTSt")));

var $0ef44ae728b7e983$var$_actualSize = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("2F5b6")));
function $0ef44ae728b7e983$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ef44ae728b7e983$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0ef44ae728b7e983$var$_react.default.createElement($0ef44ae728b7e983$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $0ef44ae728b7e983$var$_actualSize.default
    }, props));
$0ef44ae728b7e983$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $0ef44ae728b7e983$var$_default = module.exports.default = $0ef44ae728b7e983$var$GrowDiagonalIcon;

});
parcelRegister("XhTSt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fa3a459488ae98c9a4dea821f09e885>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b23656b9dea9ae5$var$_react = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0b23656b9dea9ae5$var$_baseNew = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0b23656b9dea9ae5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b23656b9dea9ae5$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0b23656b9dea9ae5$var$_react.default.createElement($0b23656b9dea9ae5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$0b23656b9dea9ae5$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $0b23656b9dea9ae5$var$_default = module.exports.default = $0b23656b9dea9ae5$var$GrowDiagonalIcon;

});

parcelRegister("2F5b6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f036d580202d537$var$_react = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1f036d580202d537$var$_growDiagonal = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("XhTSt")));
function $1f036d580202d537$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f036d580202d537$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $1f036d580202d537$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $1f036d580202d537$var$_growDiagonal.default
    }));
$1f036d580202d537$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $1f036d580202d537$var$_default = module.exports.default = $1f036d580202d537$var$MediaServicesActualSizeIcon;

});



parcelRegister("b1dbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbc64436e41aec7f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $av9Of = parcelRequire("av9Of");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $cbc64436e41aec7f$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_url_to_clipboard);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $19nmp.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $cbc64436e41aec7f$export$2e2bcd8739ae039 = $cbc64436e41aec7f$var$CopyLinkAction;

});

parcelRegister("cLrUd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c33132973d68a83$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $8c33132973d68a83$var$styles = {
    button: "_1e0c1bgi",
    padding: "_18zrutpp",
    message: "_1rjcze3t _18zrze3t"
};
const $8c33132973d68a83$var$UnresolvedAction = ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $6qaBj.cx)($8c33132973d68a83$var$styles.message, hasPadding && $8c33132973d68a83$var$styles.padding),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        })
    });
    return hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $8c33132973d68a83$var$styles.button,
        children: message
    }) : message;
};
var $8c33132973d68a83$export$2e2bcd8739ae039 = $8c33132973d68a83$var$UnresolvedAction;

});

parcelRegister("2fs4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $b30a89f78a7b1395$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3IFDE = parcelRequire("3IFDE");
const $b30a89f78a7b1395$var$AISummaryAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3IFDE.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $b30a89f78a7b1395$export$2e2bcd8739ae039 = $b30a89f78a7b1395$var$AISummaryAction;

});
parcelRegister("3IFDE", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $f1effd59dd51917b$export$8eed96bc6d982595);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $4N9mw = parcelRequire("4N9mw");

var $9ljdO = parcelRequire("9ljdO");
const $f1effd59dd51917b$export$8eed96bc6d982595 = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $2LycE.default)(url);
    (0, $eJOHy.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ljdO.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4N9mw.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("4N9mw", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $74950477f844069d$export$75a19de44af58722);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $fOqNz = parcelRequire("fOqNz");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $jeUcl = parcelRequire("jeUcl");

var $9hHCO = parcelRequire("9hHCO");

var $4XsCU = parcelRequire("4XsCU");
function $74950477f844069d$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onCompleted = (0, $eJOHy.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $4XsCU.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $jeUcl.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("4XsCU", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $97c2d7f54971c4db$export$82f46aa4e6535a45);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $7tQSx = parcelRequire("7tQSx");

var $2Q7aM = parcelRequire("2Q7aM");

var $hDtQ6 = parcelRequire("hDtQ6");
const $97c2d7f54971c4db$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $7tQSx.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Q7aM.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDtQ6.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("7tQSx", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $9b4bccd413fec8a7$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $9b4bccd413fec8a7$export$cd2e891d7f87074d);

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $9b4bccd413fec8a7$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $9b4bccd413fec8a7$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $19nmp.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5NtHI.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $19nmp.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $19nmp.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $19nmp.messages).ai_summary_error_generic,
                url: (0, $5NtHI.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("2Q7aM", function(module, exports) {

$parcel$export(module.exports, "default", () => $af835e3708ee9394$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $af835e3708ee9394$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $af835e3708ee9394$export$2e2bcd8739ae039 = $af835e3708ee9394$var$AIEventErrorViewed;

});

parcelRegister("hDtQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4df7b5a8aadcea38$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $5NtHI = parcelRequire("5NtHI");
const $4df7b5a8aadcea38$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
        href: (0, $5NtHI.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $4df7b5a8aadcea38$export$2e2bcd8739ae039 = $4df7b5a8aadcea38$var$AILearnMoreAnchor;

});



parcelRegister("9ljdO", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $d9ba8f475ac91e83$export$cfa1d3eed9a61059);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4TA31 = parcelRequire("4TA31");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
function $d9ba8f475ac91e83$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $eJOHy.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $19nmp.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4TA31))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_summary_action_description),
        ...props
    });
}

});
parcelRegister("4TA31", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $390842c9527311f0$var$_react = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $390842c9527311f0$var$_copy = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("lGr6J")));

var $390842c9527311f0$var$_copy2 = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("hZKKB")));
function $390842c9527311f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $390842c9527311f0$var$CopyIcon = (props)=>/*#__PURE__*/ $390842c9527311f0$var$_react.default.createElement($390842c9527311f0$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $390842c9527311f0$var$_copy2.default
    }, props));
$390842c9527311f0$var$CopyIcon.Name = 'CopyIconMigration';
var $390842c9527311f0$var$_default = module.exports.default = $390842c9527311f0$var$CopyIcon;

});
parcelRegister("lGr6J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc928c338a001a7a$var$_react = $fc928c338a001a7a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc928c338a001a7a$var$_baseNew = $fc928c338a001a7a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fc928c338a001a7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc928c338a001a7a$var$CopyIcon = (props)=>/*#__PURE__*/ $fc928c338a001a7a$var$_react.default.createElement($fc928c338a001a7a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$fc928c338a001a7a$var$CopyIcon.displayName = 'CopyIcon';
var $fc928c338a001a7a$var$_default = module.exports.default = $fc928c338a001a7a$var$CopyIcon;

});

parcelRegister("hZKKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d19c65e3fa3f02f9$var$_react = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $d19c65e3fa3f02f9$var$_copy = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("lGr6J")));
function $d19c65e3fa3f02f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d19c65e3fa3f02f9$var$CopyIcon = (props)=>/*#__PURE__*/ $d19c65e3fa3f02f9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $d19c65e3fa3f02f9$var$_copy.default
    }));
$d19c65e3fa3f02f9$var$CopyIcon.displayName = 'CopyIcon';
var $d19c65e3fa3f02f9$var$_default = module.exports.default = $d19c65e3fa3f02f9$var$CopyIcon;

});





parcelRegister("1EoLm", function(module, exports) {

$parcel$export(module.exports, "default", () => $807f9b07437985a7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $dtpha = parcelRequire("dtpha");

var $3cMgR = parcelRequire("3cMgR");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $4iE29 = parcelRequire("4iE29");

var $kkF5t = parcelRequire("kkF5t");

const $807f9b07437985a7$var$AutomationModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aQZ7P")));
const $807f9b07437985a7$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const modal = (0, $fezTc.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5NtHI.ActionName).AutomationAction];
    const automationActionOnClick = (0, $eJOHy.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $kkF5t.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($807f9b07437985a7$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $19nmp.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $4iE29.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $807f9b07437985a7$export$2e2bcd8739ae039 = $807f9b07437985a7$var$AutomationAction;

});
parcelRegister("dtpha", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf1970ee03bcd13$var$_react = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9cf1970ee03bcd13$var$_baseNew = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9cf1970ee03bcd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cf1970ee03bcd13$var$AutomationIcon = (props)=>/*#__PURE__*/ $9cf1970ee03bcd13$var$_react.default.createElement($9cf1970ee03bcd13$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$9cf1970ee03bcd13$var$AutomationIcon.displayName = 'AutomationIcon';
var $9cf1970ee03bcd13$var$_default = module.exports.default = $9cf1970ee03bcd13$var$AutomationIcon;

});

parcelRegister("fezTc", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $a8c10a96c4151b39$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $7JfLF = parcelRequire("7JfLF");
const $a8c10a96c4151b39$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $a8c10a96c4151b39$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($a8c10a96c4151b39$var$FALLBACK_API);
const $a8c10a96c4151b39$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $eJOHy.useState)(null);
    const api = (0, $eJOHy.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7JfLF.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $eJOHy.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $eJOHy.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8 = ()=>(0, $eJOHy.useContext)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c);

});
parcelRegister("7JfLF", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $7b6d8602f75ebf94$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");
const $7b6d8602f75ebf94$var$styles = {
    pressable: "_c71lidpf _p12fidpf _kqswstnw"
};
const $7b6d8602f75ebf94$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return (0, $eGOwo.fg)('navx-1184-fix-smart-link-a11y-interactive-states') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: $7b6d8602f75ebf94$var$styles.pressable,
        onClick: onClick,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        onClick: onClick,
        className: (0, $hcewu.default)([
            $7b6d8602f75ebf94$var$styles.pressable
        ]),
        children: children
    });
};

});


parcelRegister("4iE29", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fe410232594ccf2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $1fe410232594ccf2$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $1fe410232594ccf2$export$2e2bcd8739ae039 = $1fe410232594ccf2$var$AutomationManualTriggersGlyph;

});

parcelRegister("kkF5t", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $c38c894acd6bcefe$export$93e707b363eaf5c8);

var $19nmp = parcelRequire("19nmp");
const $c38c894acd6bcefe$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $19nmp.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $19nmp.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("aQZ7P", function(module, exports) {

let $7e6e2cee59393130$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7e6e2cee59393130$var$load("kNFvF"),
    $7e6e2cee59393130$var$load("ffQaD"),
    $7e6e2cee59393130$var$load("kvRbA"),
    $7e6e2cee59393130$var$load("kVzfx")
]).then(()=>parcelRequire('kczS3'));

});


parcelRegister("bKvNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f8cb4fc04a0fca0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $8wmgQ = parcelRequire("8wmgQ");

const $1f8cb4fc04a0fca0$var$RelatedLinksModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9EkqU")));
const $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $fezTc.useSmartLinkModal)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($1f8cb4fc04a0fca0$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).related_links_view_related_links
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wmgQ.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $1f8cb4fc04a0fca0$export$2e2bcd8739ae039 = $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction;

});
parcelRegister("8wmgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c344254860ed9d13$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i5stJ = parcelRequire("i5stJ");
const $c344254860ed9d13$var$RelatedLinksActionIcon = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    });
var $c344254860ed9d13$export$2e2bcd8739ae039 = $c344254860ed9d13$var$RelatedLinksActionIcon;

});

parcelRegister("9EkqU", function(module, exports) {

let $7067b308d3e627fa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7067b308d3e627fa$var$load("6ojIT").then(()=>parcelRequire('3cErl'));

});


parcelRegister("fd4of", function(module, exports) {

$parcel$export(module.exports, "default", () => $875ad99f72c777d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $875ad99f72c777d8$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $875ad99f72c777d8$var$validErrorStatuses = [
    (0, $5NtHI.SmartLinkStatus).Forbidden,
    (0, $5NtHI.SmartLinkStatus).Unauthorized
];
const $875ad99f72c777d8$var$validateErrorStatus = (status)=>{
    return status !== undefined && $875ad99f72c777d8$var$validErrorStatuses.includes(status);
};
const $875ad99f72c777d8$var$getMessageDescriptor = (status, accessType, props)=>{
    if (!$875ad99f72c777d8$var$validateErrorStatus(status)) return undefined;
    const message = props?.[status]?.[accessType ?? 'FALLBACK'];
    return message;
};
const $875ad99f72c777d8$var$CustomUnresolvedAction = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $875ad99f72c777d8$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $875ad99f72c777d8$var$styles.message,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...messageDescriptor,
            values: values
        })
    });
    const component = hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $875ad99f72c777d8$var$styles.button,
        children: message
    }) : message;
    return Container ? /*#__PURE__*/ (0, $gt9Am.jsx)(Container, {
        children: component
    }) : component;
};
var $875ad99f72c777d8$export$2e2bcd8739ae039 = $875ad99f72c777d8$var$CustomUnresolvedAction;

});


parcelRegister("1dIgp", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $495d2943b4977c6a$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1NG86 = parcelRequire("1NG86");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $ei710 = parcelRequire("ei710");
const $495d2943b4977c6a$var$styles = {
    containerStyles: "_kkk2n7od _2rkoglpi _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $495d2943b4977c6a$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                size: "small"
            });
        default:
            return null;
    }
};
const $495d2943b4977c6a$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $495d2943b4977c6a$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $495d2943b4977c6a$var$styles.errorContentStyles,
                children: [
                    message.icon || $495d2943b4977c6a$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        xcss: $495d2943b4977c6a$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});



parcelRegister("4RG9i", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => (parcelRequire("9Xcvc")).default);
$parcel$export(module.exports, "AssignedToGroup", () => (parcelRequire("41Mwl")).default);
$parcel$export(module.exports, "AttachmentCount", () => (parcelRequire("lVTJZ")).default);
$parcel$export(module.exports, "AuthorGroup", () => (parcelRequire("gl0Fx")).default);
$parcel$export(module.exports, "ChecklistProgress", () => (parcelRequire("iCDdz")).default);
$parcel$export(module.exports, "CollaboratorGroup", () => (parcelRequire("cSuZU")).default);
$parcel$export(module.exports, "CommentCount", () => (parcelRequire("gA3VJ")).default);
$parcel$export(module.exports, "CreatedOn", () => (parcelRequire("aiy2i")).default);
$parcel$export(module.exports, "CreatedBy", () => (parcelRequire("k4xpX")).default);
$parcel$export(module.exports, "DueOn", () => (parcelRequire("kCe9K")).default);
$parcel$export(module.exports, "LatestCommit", () => (parcelRequire("kB4Nm")).default);
$parcel$export(module.exports, "LinkIcon", () => (parcelRequire("jPfaa")).default);
$parcel$export(module.exports, "Location", () => (parcelRequire("2Bqsd")).default);
$parcel$export(module.exports, "ModifiedBy", () => (parcelRequire("1FNi6")).default);
$parcel$export(module.exports, "ModifiedOn", () => (parcelRequire("81kl8")).default);
$parcel$export(module.exports, "OwnedBy", () => (parcelRequire("946bQ")).default);
$parcel$export(module.exports, "OwnedByGroup", () => (parcelRequire("4Nd99")).default);
$parcel$export(module.exports, "Preview", () => (parcelRequire("7Byzo")).default);
$parcel$export(module.exports, "Priority", () => (parcelRequire("5kUaD")).default);
$parcel$export(module.exports, "ProgrammingLanguage", () => (parcelRequire("8MxlB")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("6l7Bk")).default);
$parcel$export(module.exports, "ReactCount", () => (parcelRequire("lwvSM")).default);
$parcel$export(module.exports, "ReadTime", () => (parcelRequire("2ITMK")).default);
$parcel$export(module.exports, "SentOn", () => (parcelRequire("iw2r2")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("f7w3l")).default);
$parcel$export(module.exports, "SourceBranch", () => (parcelRequire("6Po2h")).default);
$parcel$export(module.exports, "State", () => (parcelRequire("4U5iq")).default);
$parcel$export(module.exports, "SubscriberCount", () => (parcelRequire("jJD7c")).default);
$parcel$export(module.exports, "SubTasksProgress", () => (parcelRequire("7mGkc")).default);
$parcel$export(module.exports, "StoryPoints", () => (parcelRequire("w1OaX")).default);
$parcel$export(module.exports, "TargetBranch", () => (parcelRequire("cwvSG")).default);
$parcel$export(module.exports, "TeamMemberCount", () => (parcelRequire("2j4b1")).default);
$parcel$export(module.exports, "Title", () => (parcelRequire("i6ktq")).default);
$parcel$export(module.exports, "UserAttributes", () => (parcelRequire("iQvIm")).default);
$parcel$export(module.exports, "ViewCount", () => (parcelRequire("bApaO")).default);
$parcel$export(module.exports, "VoteCount", () => (parcelRequire("1IQ2A")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("lJDNU")).default);
$parcel$export(module.exports, "CustomByAccessTypeElement", () => (parcelRequire("i4NpI")).default);
$parcel$export(module.exports, "CustomByStatusElement", () => (parcelRequire("5d1ks")).default);

var $9Xcvc = parcelRequire("9Xcvc");

var $41Mwl = parcelRequire("41Mwl");

var $lVTJZ = parcelRequire("lVTJZ");

var $gl0Fx = parcelRequire("gl0Fx");

var $iCDdz = parcelRequire("iCDdz");

var $cSuZU = parcelRequire("cSuZU");

var $gA3VJ = parcelRequire("gA3VJ");

var $aiy2i = parcelRequire("aiy2i");

var $k4xpX = parcelRequire("k4xpX");

var $kCe9K = parcelRequire("kCe9K");

var $kB4Nm = parcelRequire("kB4Nm");

var $jPfaa = parcelRequire("jPfaa");

var $2Bqsd = parcelRequire("2Bqsd");

var $1FNi6 = parcelRequire("1FNi6");

var $81kl8 = parcelRequire("81kl8");

var $946bQ = parcelRequire("946bQ");

var $4Nd99 = parcelRequire("4Nd99");

var $7Byzo = parcelRequire("7Byzo");

var $5kUaD = parcelRequire("5kUaD");

var $8MxlB = parcelRequire("8MxlB");

var $6l7Bk = parcelRequire("6l7Bk");

var $lwvSM = parcelRequire("lwvSM");

var $2ITMK = parcelRequire("2ITMK");

var $iw2r2 = parcelRequire("iw2r2");

var $f7w3l = parcelRequire("f7w3l");

var $6Po2h = parcelRequire("6Po2h");

var $4U5iq = parcelRequire("4U5iq");

var $jJD7c = parcelRequire("jJD7c");

var $7mGkc = parcelRequire("7mGkc");

var $w1OaX = parcelRequire("w1OaX");

var $cwvSG = parcelRequire("cwvSG");

var $2j4b1 = parcelRequire("2j4b1");

var $i6ktq = parcelRequire("i6ktq");

var $iQvIm = parcelRequire("iQvIm");

var $bApaO = parcelRequire("bApaO");

var $1IQ2A = parcelRequire("1IQ2A");

var $lJDNU = parcelRequire("lJDNU");

var $i4NpI = parcelRequire("i4NpI");

var $5d1ks = parcelRequire("5d1ks");

});
parcelRegister("9Xcvc", function(module, exports) {

$parcel$export(module.exports, "default", () => $68e65e4967ed5bbb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $68e65e4967ed5bbb$var$AssignedToElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedTo
    }) : null;
};
var $68e65e4967ed5bbb$export$2e2bcd8739ae039 = $68e65e4967ed5bbb$var$AssignedToElement;

});

parcelRegister("41Mwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $54562c55fd1b3586$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $54562c55fd1b3586$var$AssignedToGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedToGroup
    }) : null;
};
var $54562c55fd1b3586$export$2e2bcd8739ae039 = $54562c55fd1b3586$var$AssignedToGroupElement;

});
parcelRegister("vUns3", function(module, exports) {

$parcel$export(module.exports, "default", () => $672b014d8429d73d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAvatarGroupProps", () => $672b014d8429d73d$export$91ba8651475968bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $gqBnP = parcelRequire("gqBnP");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $fQH39 = parcelRequire("fQH39");
const $672b014d8429d73d$var$stylesOld = null;
const $672b014d8429d73d$var$styles = null;
const $672b014d8429d73d$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxu2gc _102oidpf",
    large: "_1e0c116y _1kvxu2gc _102oidpf",
    medium: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $672b014d8429d73d$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5NtHI.ElementName).AssignedToGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).assigned_to, personName);
        case (0, $5NtHI.ElementName).OwnedByGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).owned_by, personName);
        case (0, $5NtHI.ElementName).AuthorGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {BaseAvatarGroupElementProps} BaseAvatarGroupElementProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $672b014d8429d73d$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $lRq8t.default)();
    const data = (0, $eJOHy.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5NtHI.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $672b014d8429d73d$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...(0, $eGOwo.fg)('platform-linking-enable-avatar-data-separator') ? {
            ['data-separator']: true
        } : {},
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            !(0, $eGOwo.fg)('platform-linking-fix-smart-card-avatar-overrides') && $672b014d8429d73d$var$stylesMap[size],
            (0, $eGOwo.fg)('platform-linking-fix-smart-card-avatar-overrides') ? "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf" : "_1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $672b014d8429d73d$export$2e2bcd8739ae039 = $672b014d8429d73d$var$BaseAvatarGroup;
const $672b014d8429d73d$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};

});


parcelRegister("lVTJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca273e569a0c1d25$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $ca273e569a0c1d25$var$AttachmentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AttachmentCount
    }) : null;
};
var $ca273e569a0c1d25$export$2e2bcd8739ae039 = $ca273e569a0c1d25$var$AttachmentCountElement;

});

parcelRegister("gl0Fx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5186dee07e48afde$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $5186dee07e48afde$var$AuthorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AuthorGroup
    }) : null;
};
var $5186dee07e48afde$export$2e2bcd8739ae039 = $5186dee07e48afde$var$AuthorGroupElement;

});

parcelRegister("iCDdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e60145f3c4ab217$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $0e60145f3c4ab217$var$ChecklistProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }) : null;
};
var $0e60145f3c4ab217$export$2e2bcd8739ae039 = $0e60145f3c4ab217$var$ChecklistProgressElement;

});

parcelRegister("cSuZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e78c51e7c53936$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $b3e78c51e7c53936$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CollaboratorGroup
    }) : null;
};
var $b3e78c51e7c53936$export$2e2bcd8739ae039 = $b3e78c51e7c53936$var$CollaboratorGroupElement;

});

parcelRegister("gA3VJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $55e7c0307b507f46$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $55e7c0307b507f46$var$CommentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.commentCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).CommentCount
    }) : null;
};
var $55e7c0307b507f46$export$2e2bcd8739ae039 = $55e7c0307b507f46$var$CommentCountElement;

});

parcelRegister("aiy2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $932490ed3e7f327b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $932490ed3e7f327b$var$CreatedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedOn
    }) : null;
};
var $932490ed3e7f327b$export$2e2bcd8739ae039 = $932490ed3e7f327b$var$CreatedOnElement;

});
parcelRegister("aKX5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb039ade903c50b2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateTimeProps", () => $cb039ade903c50b2$export$2d4384e6b150cbe3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6wSDf = parcelRequire("6wSDf");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $19nmp = parcelRequire("19nmp");
const $cb039ade903c50b2$var$styles = null;
const $cb039ade903c50b2$var$typeToDescriptorMap = {
    created: {
        relative: (0, $19nmp.messages).created_on_relative,
        absolute: (0, $19nmp.messages).created_on_absolute
    },
    modified: {
        relative: (0, $19nmp.messages).modified_on_relative,
        absolute: (0, $19nmp.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $19nmp.messages).sent_on_relative,
        absolute: (0, $19nmp.messages).sent_on_absolute
    }
};
const $cb039ade903c50b2$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {BaseDateTimeElementProps} BaseDateTimeElementProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $cb039ade903c50b2$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $lRq8t.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $6wSDf.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...$cb039ade903c50b2$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && $cb039ade903c50b2$var$fontOverrideStyleMap[fontSize],
            className
        ]),
        children: content
    });
};
var $cb039ade903c50b2$export$2e2bcd8739ae039 = $cb039ade903c50b2$var$BaseDateTimeElement;
const $cb039ade903c50b2$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};

});


parcelRegister("k4xpX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f3b49272a6afc71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $3f3b49272a6afc71$var$CreatedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedBy
    }) : null;
};
var $3f3b49272a6afc71$export$2e2bcd8739ae039 = $3f3b49272a6afc71$var$CreatedByElement;

});

parcelRegister("kCe9K", function(module, exports) {

$parcel$export(module.exports, "default", () => $805a1aa3004ae832$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $805a1aa3004ae832$var$DueOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $cmzNL.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).DueOn
    }) : null;
};
var $805a1aa3004ae832$export$2e2bcd8739ae039 = $805a1aa3004ae832$var$DueOnElement;

});
parcelRegister("cmzNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $351b36f187c69d22$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateLozengeProps", () => $351b36f187c69d22$export$8f9f58f7bac50fbe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7qGN1 = parcelRequire("7qGN1");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4Frd9 = parcelRequire("4Frd9");
const $351b36f187c69d22$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $351b36f187c69d22$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Frd9.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
        appearance: appearance,
        ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $351b36f187c69d22$export$2e2bcd8739ae039 = $351b36f187c69d22$var$BaseLozengeElement;
const $351b36f187c69d22$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qGN1.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};

});
parcelRegister("4Frd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9074bb98cbadc69e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $EtcI0 = parcelRequire("EtcI0");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $CpyFM = parcelRequire("CpyFM");

var $b43DQ = parcelRequire("b43DQ");

var $hxkmu = parcelRequire("hxkmu");

var $e9seM = parcelRequire("e9seM");

var $5iuU7 = parcelRequire("5iuU7");

var $4dVhH = parcelRequire("4dVhH");

var $htuxE = parcelRequire("htuxE");

var $dsXZb = parcelRequire("dsXZb");
const $9074bb98cbadc69e$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $9074bb98cbadc69e$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $eJOHy.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [items, setItems] = (0, $eJOHy.useState)();
    const [errorMessage, setErrorMessage] = (0, $eJOHy.useState)();
    const reload = (0, $kbv8x.default)();
    const invoke = (0, $6O4ri.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $eJOHy.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $EtcI0.default));
                const validItems = typeof text === 'string' ? $9074bb98cbadc69e$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? (0, $4dVhH.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $4dVhH.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dsXZb.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $eJOHy.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $CpyFM.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $d0InI.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $eJOHy.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5iuU7.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $htuxE.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $9074bb98cbadc69e$export$2e2bcd8739ae039 = (0, $hxkmu.default)($9074bb98cbadc69e$var$LozengeAction);

});
parcelRegister("EtcI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $377731e831492625$export$2e2bcd8739ae039);
const $377731e831492625$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $377731e831492625$export$2e2bcd8739ae039 = $377731e831492625$var$extractLozengeActionItems;

});

parcelRegister("CpyFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb2d7fc7fdf8041$export$2e2bcd8739ae039);
const $7cb2d7fc7fdf8041$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $7cb2d7fc7fdf8041$export$2e2bcd8739ae039 = $7cb2d7fc7fdf8041$var$createStatusUpdateRequest;

});

parcelRegister("hxkmu", function(module, exports) {

$parcel$export(module.exports, "default", () => $808be4e18c85f3f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $808be4e18c85f3f4$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: props?.appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props
            })
        });
    };
var $808be4e18c85f3f4$export$2e2bcd8739ae039 = $808be4e18c85f3f4$var$withErrorBoundary;

});

parcelRegister("e9seM", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$618660b8f2aa87e2);
const $20533813e4fe1916$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $20533813e4fe1916$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $20533813e4fe1916$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $20533813e4fe1916$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("5iuU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bafe1b037124149$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $kDaaB = parcelRequire("kDaaB");

var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $1NG86 = parcelRequire("1NG86");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $7xssH = parcelRequire("7xssH");

var $fQH39 = parcelRequire("fQH39");
const $1bafe1b037124149$var$MAX_LINE_NUMBER = 8;
const $1bafe1b037124149$var$styles = {
    contentStyles: "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt",
    linkStyles: "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o",
    textStylesBase: "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
    dropdownItemGroupStyles: "_14hp1wdt _6pup1kw7 _1eo073ad",
    openIssueInJiraStyles: "_11c82smr _bfhk18uv _1bah1e5h _1e0c1kw7 _syaz14q2 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1 _30l316c2"
};
const $1bafe1b037124149$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $1bafe1b037124149$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const invoke = (0, $7xssH.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $eJOHy.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $1bafe1b037124149$var$styles.contentStyles
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $hcewu.default)([
                                $1bafe1b037124149$var$styles.textStylesBase,
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $awdRS.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fQH39.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1bafe1b037124149$var$styles.linkStyles
                    ]),
                    children: (0, $eGOwo.fg)('navx-1184-fix-smart-link-a11y-interactive-states') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                        testId: `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        xcss: $1bafe1b037124149$var$styles.openIssueInJiraStyles,
                        children: (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jira
                        })
                    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor, jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                    /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $hcewu.default)([
            $1bafe1b037124149$var$styles.dropdownItemGroupStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $1bafe1b037124149$export$2e2bcd8739ae039 = $1bafe1b037124149$var$LozengeActionError;

});

parcelRegister("4dVhH", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $d6614d1ef8f5be72$export$4f2e371a667ad688);

var $19nmp = parcelRequire("19nmp");
const $d6614d1ef8f5be72$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $19nmp.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $19nmp.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $19nmp.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $19nmp.messages)['status_change_update_error']
    }
};

});

parcelRegister("htuxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $df529be6a716333d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aLJ1L = parcelRequire("aLJ1L");

var $aDuBe = parcelRequire("aDuBe");
const $df529be6a716333d$var$dropdownItemGroupStyles = null;
const $df529be6a716333d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $hcewu.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $eJOHy.createElement)((0, $aDuBe.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $df529be6a716333d$export$2e2bcd8739ae039 = $df529be6a716333d$var$LozengeActionItemsGroup;

});
parcelRegister("aDuBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f377c3a55bec1fd7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $f377c3a55bec1fd7$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        role: "presentation",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    });
};
var $f377c3a55bec1fd7$export$2e2bcd8739ae039 = $f377c3a55bec1fd7$var$LozengeActionItem;

});


parcelRegister("dsXZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d29b99195ec403c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $5lAAn = parcelRequire("5lAAn");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $8d29b99195ec403c$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rkoiti9 _1dqonqa1 _189ee4h9 _1h6d3acm _bfhk18uv _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1p6i"
};
const $8d29b99195ec403c$var$triggerLozengeStyles = null;
const $8d29b99195ec403c$var$triggerButtonStyles = null;
const $8d29b99195ec403c$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isHovering, setIsHovering] = (0, $eJOHy.useState)(false);
    const [isPressing, setIsPressing] = (0, $eJOHy.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $eJOHy.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $eJOHy.useState)(undefined);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>setIsHovering(true), []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>setIsHovering(false), []);
    const onMouseOrKeyDown = (0, $eJOHy.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $eJOHy.useCallback)(()=>setIsPressing(false), []);
    (0, $eJOHy.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #85B8FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else if (isOpen) {
            if (isHovering) setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CCE0FF)");
            else setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen,
        isHovering
    ]);
    const lozenge = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: (0, $k0ahr.cx)($8d29b99195ec403c$var$styles.lozengeContainer, (isOpen || isPressing) && $8d29b99195ec403c$var$styles.lozengeContainerSelected),
            as: "span",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? true : isHovering,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    backgroundColor: lozengeBackgroundColor,
                    color: lozengeForegroundColor
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
                    className: (0, $hcewu.default)([
                        "_4cvr1h6o _1e0c1txw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            children: text
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $8d29b99195ec403c$var$styles.chevronDown,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                                color: "currentColor",
                                label: "options",
                                LEGACY_size: "medium",
                                LEGACY_margin: "-4px -8px -4px -7px",
                                size: "small"
                            })
                        })
                    ]
                })
            })
        });
    }, [
        appearance,
        isHovering,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        className: (0, $hcewu.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189e1bk5 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $8d29b99195ec403c$export$2e2bcd8739ae039 = $8d29b99195ec403c$var$LozengeActionTrigger;

});




parcelRegister("kB4Nm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e36aa41e9ad3ded$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $9e36aa41e9ad3ded$var$LatestCommitElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Commit,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LatestCommit
    }) : null;
};
var $9e36aa41e9ad3ded$export$2e2bcd8739ae039 = $9e36aa41e9ad3ded$var$LatestCommitElement;

});

parcelRegister("jPfaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3002c31f53401640$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $d6nZP = parcelRequire("d6nZP");
const $3002c31f53401640$var$LinkIconElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context) return null;
    const data = (0, $d6nZP.toLinkIconProps)(context?.linkIcon, context.type);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LinkIcon
    }) : null;
};
var $3002c31f53401640$export$2e2bcd8739ae039 = $3002c31f53401640$var$LinkIconElement;

});
parcelRegister("d6nZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a220f00187bff59$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toLinkIconProps", () => $7a220f00187bff59$export$6d33abd591a3f700);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $av9Of = parcelRequire("av9Of");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $fQH39 = parcelRequire("fQH39");
const $7a220f00187bff59$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $7a220f00187bff59$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $7a220f00187bff59$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym"
};
const $7a220f00187bff59$var$renderAtlaskitIcon = (icon, testId, size = (0, $5NtHI.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        size: size
    });
};
const $7a220f00187bff59$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $7a220f00187bff59$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5NtHI.SmartLinkSize).Medium, appearance, hideLoadingSkeleton)=>{
    const width = size === (0, $5NtHI.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param props - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $7a220f00187bff59$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $5NtHI.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const element = (0, $eJOHy.useMemo)(()=>{
        const defaultIcon = $7a220f00187bff59$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $7a220f00187bff59$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton) || $7a220f00187bff59$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon
    ]);
    const width = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7a220f00187bff59$var$styles.container,
            $7a220f00187bff59$var$positionStyleMap[position],
            render && $7a220f00187bff59$var$customRenderStyleMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $7a220f00187bff59$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        })
    });
};
var $7a220f00187bff59$export$2e2bcd8739ae039 = $7a220f00187bff59$var$IconElement;
const $7a220f00187bff59$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $FoFt2.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};

});


parcelRegister("2Bqsd", function(module, exports) {

$parcel$export(module.exports, "default", () => $684e70f9d4a0e20c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $684e70f9d4a0e20c$var$LocationElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        theme: (0, $5NtHI.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Location
    }) : null;
};
var $684e70f9d4a0e20c$export$2e2bcd8739ae039 = $684e70f9d4a0e20c$var$LocationElement;

});

parcelRegister("1FNi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $59cc5cb27d2f6980$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $59cc5cb27d2f6980$var$ModifiedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ModifiedBy
    }) : null;
};
var $59cc5cb27d2f6980$export$2e2bcd8739ae039 = $59cc5cb27d2f6980$var$ModifiedByElement;

});

parcelRegister("81kl8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b4cff059a6d0796$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $5b4cff059a6d0796$var$ModifiedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ModifiedOn
    }) : null;
};
var $5b4cff059a6d0796$export$2e2bcd8739ae039 = $5b4cff059a6d0796$var$ModifiedOnElement;

});

parcelRegister("946bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $36681a63387d26b9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $36681a63387d26b9$var$OwnedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages)[textPrefix], context?.ownedBy) : null;
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedBy
    }) : null;
};
var $36681a63387d26b9$export$2e2bcd8739ae039 = $36681a63387d26b9$var$OwnedByElement;

});

parcelRegister("4Nd99", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ab17b3f9ac16f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $d0ab17b3f9ac16f4$var$OwnedByGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedByGroup
    }) : null;
};
var $d0ab17b3f9ac16f4$export$2e2bcd8739ae039 = $d0ab17b3f9ac16f4$var$OwnedByGroupElement;

});

parcelRegister("5kUaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb8efb6535893df$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $8cb8efb6535893df$var$PriorityElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Priority
    }) : null;
};
var $8cb8efb6535893df$export$2e2bcd8739ae039 = $8cb8efb6535893df$var$PriorityElement;

});

parcelRegister("8MxlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $12bbc9fa6baf6ce0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ProgrammingLanguage
    }) : null;
};
var $12bbc9fa6baf6ce0$export$2e2bcd8739ae039 = $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement;

});

parcelRegister("lwvSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c70b57958761eec$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $1c70b57958761eec$var$ReactCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.reactCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).React,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ReactCount
    }) : null;
};
var $1c70b57958761eec$export$2e2bcd8739ae039 = $1c70b57958761eec$var$ReactCountElement;

});

parcelRegister("2ITMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2d9d65227b56648$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b2d9d65227b56648$var$ReadTimeElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ReadTime
    }) : null;
};
var $b2d9d65227b56648$export$2e2bcd8739ae039 = $b2d9d65227b56648$var$ReadTimeElement;

});

parcelRegister("iw2r2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e6bf42d4a97c401$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $0e6bf42d4a97c401$var$SentOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SentOn
    }) : null;
};
var $0e6bf42d4a97c401$export$2e2bcd8739ae039 = $0e6bf42d4a97c401$var$SentOnElement;

});

parcelRegister("6Po2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7164a95a609845f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $f7164a95a609845f$var$SourceBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SourceBranch
    }) : null;
};
var $f7164a95a609845f$export$2e2bcd8739ae039 = $f7164a95a609845f$var$SourceBranchElement;

});

parcelRegister("4U5iq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd8773a8f5d6e97c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $cd8773a8f5d6e97c$var$StateElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.state ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).State
    }) : null;
};
var $cd8773a8f5d6e97c$export$2e2bcd8739ae039 = $cd8773a8f5d6e97c$var$StateElement;

});

parcelRegister("jJD7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $e661b354f8faff8b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $e661b354f8faff8b$var$SubscriberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubscriberCount
    }) : null;
};
var $e661b354f8faff8b$export$2e2bcd8739ae039 = $e661b354f8faff8b$var$SubscriberCountElement;

});

parcelRegister("7mGkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $da8be0e62ff3be52$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $da8be0e62ff3be52$var$SubTasksProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubTasksProgress
    }) : null;
};
var $da8be0e62ff3be52$export$2e2bcd8739ae039 = $da8be0e62ff3be52$var$SubTasksProgressElement;

});

parcelRegister("w1OaX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6da98c25506acfc3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hTi78 = parcelRequire("hTi78");
const $6da98c25506acfc3$var$StoryPointsElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $hTi78.toAtlaskitBadgeProps)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hTi78.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).StoryPoints
    }) : null;
};
var $6da98c25506acfc3$export$2e2bcd8739ae039 = $6da98c25506acfc3$var$StoryPointsElement;

});
parcelRegister("hTi78", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fb2764f8e50f778$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAtlaskitBadgeProps", () => $5fb2764f8e50f778$export$731812b93bd90554);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7q9BG = parcelRequire("7q9BG");
const $5fb2764f8e50f778$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $5fb2764f8e50f778$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7q9BG.default), {
            children: value
        })
    });
};
var $5fb2764f8e50f778$export$2e2bcd8739ae039 = $5fb2764f8e50f778$var$BaseAtlaskitElementBadge;
const $5fb2764f8e50f778$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};

});


parcelRegister("cwvSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $44a8674c49925bc5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $44a8674c49925bc5$var$TargetBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TargetBranch
    }) : null;
};
var $44a8674c49925bc5$export$2e2bcd8739ae039 = $44a8674c49925bc5$var$TargetBranchElement;

});

parcelRegister("2j4b1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee83b62dd045c6fd$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $ee83b62dd045c6fd$var$TeamMemberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    const count = context?.teamMemberCount && context?.teamMemberCount > $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT ? `${$ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
    const data = count ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TeamMemberCount
    }) : null;
};
var $ee83b62dd045c6fd$export$2e2bcd8739ae039 = $ee83b62dd045c6fd$var$TeamMemberCountElement;

});

parcelRegister("iQvIm", function(module, exports) {

$parcel$export(module.exports, "default", () => $13574bab0abb9b76$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $13574bab0abb9b76$var$UserAttributesElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $5NtHI.ElementName).UserAttributes
                }, key));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: elements
    }) : null;
};
var $13574bab0abb9b76$export$2e2bcd8739ae039 = $13574bab0abb9b76$var$UserAttributesElement;

});

parcelRegister("bApaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db5b76dc584a40$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $32db5b76dc584a40$var$ViewCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).View,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ViewCount
    }) : null;
};
var $32db5b76dc584a40$export$2e2bcd8739ae039 = $32db5b76dc584a40$var$ViewCountElement;

});

parcelRegister("1IQ2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $49df200106082223$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $49df200106082223$var$VoteCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Vote,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).VoteCount
    }) : null;
};
var $49df200106082223$export$2e2bcd8739ae039 = $49df200106082223$var$VoteCountElement;

});

parcelRegister("lJDNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64afcea66b05029$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $b64afcea66b05029$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $19nmp.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Component,
        label: label,
        ...props
    });
};
var $b64afcea66b05029$export$2e2bcd8739ae039 = $b64afcea66b05029$var$AppliedToComponentsCountElement;

});

parcelRegister("i4NpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e868f1df007f5c9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $7e868f1df007f5c9$var$baseStyle = null;
const $7e868f1df007f5c9$var$isMessageDescriptor = (x)=>!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(x);
const $7e868f1df007f5c9$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
const $7e868f1df007f5c9$var$maxLinesCss = null;
const $7e868f1df007f5c9$var$CustomElementByAccessType = ({ className: className, testId: testId = 'custom-by-access-type-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const accessType = context?.data?.meta?.accessType;
    const contentForAccessType = props[accessType] ?? props.fallback;
    if (!contentForAccessType) return null;
    const values = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]?.values;
    if ($7e868f1df007f5c9$var$isMessageDescriptor(contentForAccessType)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...props,
        message: {
            descriptor: contentForAccessType,
            values: values
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        testId: testId,
        hideFormat: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: props.color
        },
        "data-separator": true,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            props.fontSize !== undefined && $7e868f1df007f5c9$var$fontOverrideStyleMap[props.fontSize],
            "_1yyjkb7n _102k1j6v",
            className
        ]),
        children: contentForAccessType
    });
};
var $7e868f1df007f5c9$export$2e2bcd8739ae039 = $7e868f1df007f5c9$var$CustomElementByAccessType;

});

parcelRegister("5d1ks", function(module, exports) {

$parcel$export(module.exports, "default", () => $255ff319c604874a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");
const $255ff319c604874a$var$CustomByStatusElement = ({ className: className, testId: testId = 'custom-by-status-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const status = context?.status;
    if (!status) return null;
    const component = props[status];
    if (!component) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": "custom-element",
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        children: component
    });
};
var $255ff319c604874a$export$2e2bcd8739ae039 = $255ff319c604874a$var$CustomByStatusElement;

});




parcelRegister("a86OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $26c0c5c54b91a954$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lHA6U = parcelRequire("lHA6U");
const $26c0c5c54b91a954$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $lHA6U ? $lHA6U[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $26c0c5c54b91a954$export$2e2bcd8739ae039 = $26c0c5c54b91a954$var$ActionGroupItem;

});


parcelRegister("gjoE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9925dc77e1d9b77$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cLrUd = parcelRequire("cLrUd");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $e9925dc77e1d9b77$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position
            }),
            title,
            showRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cLrUd.default), {
                    testId: testId
                })
            }),
            actionGroup
        ]
    });
};
var $e9925dc77e1d9b77$export$2e2bcd8739ae039 = $e9925dc77e1d9b77$var$TitleBlockErroredView;

});

parcelRegister("haRRg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bf1e0846d3cab95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $3bf1e0846d3cab95$var$style = null;
const $3bf1e0846d3cab95$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $3bf1e0846d3cab95$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $brTAh.renderElementItems)(metadata);
    const subtitleElements = (0, $brTAh.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position,
                size: size,
                hideLoadingSkeleton: hideIconLoadingSkeleton
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Vertical,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $hcewu.default)([
                    "_zulp1b66"
                ]),
                children: [
                    CompetitorPrompt && url && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        xcss: $3bf1e0846d3cab95$var$styles.titleBox,
                        children: [
                            title,
                            /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
                                sourceUrl: url,
                                linkType: 'card'
                            })
                        ]
                    }) : title,
                    subtitleElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $5NtHI.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $3bf1e0846d3cab95$export$2e2bcd8739ae039 = $3bf1e0846d3cab95$var$TitleBlockResolvedView;

});

parcelRegister("1Ub5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9eea7741f2cb919$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $65mpR = parcelRequire("65mpR");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $f9eea7741f2cb919$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5NtHI.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                style: {
                    width: iconWidth,
                    height: iconWidth
                },
                "data-testid": `${testId}-icon`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                    width: iconWidth,
                    height: iconWidth,
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $f9eea7741f2cb919$export$2e2bcd8739ae039 = $f9eea7741f2cb919$var$TitleBlockResolvingView;

});


parcelRegister("8YHJ2", function(module, exports) {

$parcel$export(module.exports, "CardSSR", () => $265c0be3b7df6739$export$7b5e1b7f9a325b6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $aXKmr = parcelRequire("aXKmr");

var $e2B2h = parcelRequire("e2B2h");

var $eGOwo = parcelRequire("eGOwo");

var $b43DQ = parcelRequire("b43DQ");

var $4oATR = parcelRequire("4oATR");

var $k9P6L = parcelRequire("k9P6L");
const $265c0be3b7df6739$export$7b5e1b7f9a325b6 = (props)=>{
    const [id] = (0, $eJOHy.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
    const cardProps = {
        ...props,
        id: id
    };
    const ErrorFallbackComponent = cardProps.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorFallbackComponent, {});
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
            ...cardProps
        });
    };
    if ((0, $eGOwo.fg)('platform_editor_inline_card_selected_state_fix')) {
        const Component = cardProps.appearance === 'inline' ? 'span' : 'div';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: (0, $b43DQ.context),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                FallbackComponent: errorBoundaryFallbackComponent,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    className: "loader-wrapper",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                        ...cardProps
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: (0, $b43DQ.context),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            FallbackComponent: errorBoundaryFallbackComponent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                ...cardProps
            })
        })
    });
};

});
parcelRegister("4oATR", function(module, exports) {

$parcel$export(module.exports, "CardWithUrlContent", () => $e563c8affb3daadf$export$7598f5d7c597dd32);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $iT7eO = parcelRequire("iT7eO");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $fezTc = parcelRequire("fezTc");

var $FoFt2 = parcelRequire("FoFt2");

var $88ISi = parcelRequire("88ISi");

var $liquj = parcelRequire("liquj");

var $44bDi = parcelRequire("44bDi");

var $1YI3f = parcelRequire("1YI3f");

var $2QXr6 = parcelRequire("2QXr6");

var $3u14o = parcelRequire("3u14o");

var $9uyEx = parcelRequire("9uyEx");

var $19G04 = parcelRequire("19G04");

var $6J1DL = parcelRequire("6J1DL");
function $e563c8affb3daadf$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $iT7eO.useSmartLink)(id, url);
    const ari = (0, $03JM4.getObjectAri)(state.details);
    const name = (0, $03JM4.getObjectName)(state.details);
    const definitionId = (0, $03JM4.getDefinitionId)(state.details);
    const extensionKey = (0, $03JM4.getExtensionKey)(state.details);
    const resourceType = (0, $03JM4.getResourceType)(state.details);
    const services = (0, $03JM4.getServices)(state.details);
    let isFlexibleUi = (0, $eJOHy.useMemo)(()=>(0, $1YI3f.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    const actionOptions = (0, $88ISi.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    // Setup UI handlers.
    const handleClickWrapper = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialKey)(event) || (0, $FoFt2.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $5NtHI.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        // If preview panel is available and the user clicked on the link,
        // delegate the click to the preview panel handler
        if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
            ari: ari
        }) && !(0, $eGOwo.fg)('platform_editor_preview_panel_linking')) {
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $03JM4.getObjectIconUrl)(state.details)
            });
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
        } else if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $03JM4.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isSpecialEvent` be true.
            const target = (0, $FoFt2.isSpecialEvent)(event) ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        onClick,
        url,
        state.details,
        ari,
        name,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent
    ]);
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $eJOHy.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $eJOHy.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $eJOHy.useEffect)(()=>{
        $2QXr6.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $2QXr6.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $2QXr6.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $03JM4.isFinalState)(state.status)) {
            (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $eJOHy.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $19G04.default), {
            id: id,
            cardState: cardState,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6J1DL.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            });
        case 'block':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3u14o.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9uyEx.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                CompetitorPrompt: CompetitorPrompt
            });
    }
}
const $e563c8affb3daadf$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $1YI3f.isFlexibleUiCard)(props.children, props?.ui) ? (0, $5NtHI.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: props.url,
            id: props.id,
            display: display,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($e563c8affb3daadf$var$Component, {
                ...props
            })
        })
    });
};

});
parcelRegister("iT7eO", function(module, exports) {

$parcel$export(module.exports, "useSmartLink", () => $509c107b2b076848$export$9f4e486b1dc3e700);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $bde0S = parcelRequire("bde0S");

var $2vJUc = parcelRequire("2vJUc");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");
function $509c107b2b076848$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $5TXKo.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const actions = (0, $bde0S.useSmartCardActions)(id, url);
    const config = (0, $2vJUc.useSmartLinkConfig)();
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $eJOHy.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
}

});
parcelRegister("bde0S", function(module, exports) {

$parcel$export(module.exports, "useSmartCardActions", () => $0b92ec45d8e4fb8b$export$f7c340395f31e832);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");

var $ldBiz = parcelRequire("ldBiz");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $7xssH = parcelRequire("7xssH");

var $kbv8x = parcelRequire("kbv8x");
const $0b92ec45d8e4fb8b$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $kbv8x.default)();
    const invokeClientAction = (0, $7xssH.default)({});
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $eJOHy.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5NtHI.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $eJOHy.useCallback)((metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $eJOHy.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        if (definitionId) (0, $03JM4.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $eJOHy.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $eJOHy.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        const extensionKey = (0, $03JM4.getExtensionKey)(details);
        const services = (0, $03JM4.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $ldBiz.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $eJOHy.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("ldBiz", function(module, exports) {

$parcel$export(module.exports, "auth", () => $3affdc949abfd5e9$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("kwM7Y")).AuthError);

var $kwM7Y = parcelRequire("kwM7Y");

var $jGjox = parcelRequire("jGjox");
function $3affdc949abfd5e9$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $jGjox.isOfTypeAuthError)(errorType)) reject(new (0, $kwM7Y.AuthError)(data.message, errorType));
                    else reject(new (0, $kwM7Y.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $kwM7Y.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("kwM7Y", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $4f8710bc730ecae5$export$145273558d58e0ac);
class $4f8710bc730ecae5$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("jGjox", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $b4e26c6b0cd1efbb$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $b4e26c6b0cd1efbb$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("03JM4", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $a9130c46b8c7e440$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $a9130c46b8c7e440$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $a9130c46b8c7e440$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $a9130c46b8c7e440$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $a9130c46b8c7e440$export$81164c1570bcd038);
$parcel$export(module.exports, "getObjectName", () => $a9130c46b8c7e440$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $a9130c46b8c7e440$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $a9130c46b8c7e440$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $a9130c46b8c7e440$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $a9130c46b8c7e440$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $a9130c46b8c7e440$export$3f9446bb21b945a0);

var $70skx = parcelRequire("70skx");
const $a9130c46b8c7e440$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $a9130c46b8c7e440$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $70skx.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $a9130c46b8c7e440$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $a9130c46b8c7e440$export$218d96312e385949 = (details)=>details?.meta?.key;
const $a9130c46b8c7e440$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $a9130c46b8c7e440$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $a9130c46b8c7e440$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $a9130c46b8c7e440$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $a9130c46b8c7e440$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $a9130c46b8c7e440$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $a9130c46b8c7e440$export$ac5d414b1ebfab5a = (details)=>details && $a9130c46b8c7e440$export$cd41ae544cfc2a65(details) && $a9130c46b8c7e440$export$795910f5f15a9633(details);
const $a9130c46b8c7e440$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $a9130c46b8c7e440$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $a9130c46b8c7e440$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $a9130c46b8c7e440$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $a9130c46b8c7e440$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $a9130c46b8c7e440$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $a9130c46b8c7e440$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $a9130c46b8c7e440$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;

});
parcelRegister("70skx", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $23c7211e82610c9c$export$c81497d3681f24f4);
const $23c7211e82610c9c$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});



parcelRegister("2vJUc", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkConfig", () => $42e17606dc58a0f1$export$5d10838c1e539409);

var $9kfy2 = parcelRequire("9kfy2");
const $42e17606dc58a0f1$export$5d10838c1e539409 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});


parcelRegister("88ISi", function(module, exports) {

$parcel$export(module.exports, "combineActionOptions", () => $8dae431f81ca4538$export$2ae4cf79c720146a);
const $8dae431f81ca4538$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("44bDi", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$eaff10f7ec59c455);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $wq6W1 = parcelRequire("wq6W1");

var $9kfy2 = parcelRequire("9kfy2");

var $9NiLY = parcelRequire("9NiLY");

var $eGOwo = parcelRequire("eGOwo");

var $5TXKo = parcelRequire("5TXKo");

var $b43DQ = parcelRequire("b43DQ");
const $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $wq6W1.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $b43DQ.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $5c3f03a637d1ec7f$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const state = store ? (0, $9NiLY.getUrl)(store, url) : undefined;
    return (0, $eJOHy.useMemo)(()=>{
        return $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $5c3f03a637d1ec7f$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $5TXKo.useSmartCardState)(url);
    const data = $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("wq6W1", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $05ccd9b6e0c82253$export$7243431f5325a7b);

var $4g7cp = parcelRequire("4g7cp");

var $6jgT3 = parcelRequire("6jgT3");

var $eGOwo = parcelRequire("eGOwo");
const $05ccd9b6e0c82253$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $4g7cp.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $6jgT3.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("6jgT3", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $e94b2157750adb74$export$28ddbae335bd80b5);
const $e94b2157750adb74$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});



parcelRegister("3u14o", function(module, exports) {

$parcel$export(module.exports, "BlockCard", () => $5cab8467edf2e496$export$d18ccd25c0d2c6b0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $9gzoR = parcelRequire("9gzoR");

var $4UV7R = parcelRequire("4UV7R");

var $dDP8i = parcelRequire("dDP8i");

var $kj3Kk = parcelRequire("kj3Kk");

var $fQuyl = parcelRequire("fQuyl");

var $1uPx2 = parcelRequire("1uPx2");

var $eB1dU = parcelRequire("eB1dU");

var $8jMdw = parcelRequire("8jMdw");

var $4fOPS = parcelRequire("4fOPS");
const $5cab8467edf2e496$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-block-card"
            }),
            children
        ]
    }) : children;
};
const $5cab8467edf2e496$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $dDP8i.handleClickCommon)(event, handleFrameClick),
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($5cab8467edf2e496$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    ...blockCardProps,
                    testId: "smart-block-resolving-view"
                })
            });
        case 'resolved':
            if ((0, $eGOwo.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                    ...blockCardProps,
                    onAuthorize: handleAuthorize
                });
            }
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                ...blockCardProps
            });
        case 'unauthorized':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1uPx2.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eB1dU.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fQuyl.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("9gzoR", function(module, exports) {

$parcel$export(module.exports, "useControlDataExportConfig", () => $99508fe9399992b6$export$f93c47f1b2b3f55b);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $99508fe9399992b6$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("4UV7R", function(module, exports) {

$parcel$export(module.exports, "getIsDataExportEnabled", () => $12a2b77c03a84659$export$a019611f39785186);
const $12a2b77c03a84659$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));

});

parcelRegister("dDP8i", function(module, exports) {

$parcel$export(module.exports, "handleClickCommon", () => $b32501177a2ef5a6$export$9759a67e215c4598);
const $b32501177a2ef5a6$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("kj3Kk", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $c60e87c9a02f8e5e$export$ce508304ed2dd145);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bu0pj = parcelRequire("bu0pj");
class $c60e87c9a02f8e5e$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("bu0pj", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $a33467e63cbde9e1$export$b89a827e9254211a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e3qu2 = parcelRequire("e3qu2");

var $hFjcp = parcelRequire("hFjcp");
const $a33467e63cbde9e1$export$b89a827e9254211a = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $hFjcp.WrapperAnchor) : (0, $hFjcp.WrapperSpan);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("hFjcp", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $410d9f0a7ea732a2$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $410d9f0a7ea732a2$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $410d9f0a7ea732a2$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$var$baseWrapperStyles = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $410d9f0a7ea732a2$var$interactiveStyles = null;
const $410d9f0a7ea732a2$var$hoveredStyles = null;
const $410d9f0a7ea732a2$var$hoveredWithBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withoutBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withBackgroundStyles = null;
const $410d9f0a7ea732a2$var$truncateStyles = null;
const $410d9f0a7ea732a2$var$notSelectedStyle = null;
const $410d9f0a7ea732a2$var$selectedStyles = null;

});



parcelRegister("fQuyl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee7e07d7b1d98a1b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jkYbX = parcelRequire("jkYbX");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dX77y = parcelRequire("dX77y");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $ee7e07d7b1d98a1b$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $eJOHy.useMemo)(()=>props.onAuthorize ? [
            (0, $dX77y.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
                label: "errored-warning-icon",
                color: "var(--ds-icon-warning, #E56910)",
                LEGACY_size: "small",
                testId: `${testId}-warning-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $19nmp.messages).could_not_load_link
                }
            })
        ]
    });
};
var $ee7e07d7b1d98a1b$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($ee7e07d7b1d98a1b$var$ErroredView);

});
parcelRegister("dX77y", function(module, exports) {

$parcel$export(module.exports, "RetryAction", () => $bcb724787f99bc8f$export$c527d977b53f7537);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $bcb724787f99bc8f$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).try_again
        }),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("dXXLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae672cf08406695$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $3pcXQ = parcelRequire("3pcXQ");
var $8Rjtc = parcelRequire("8Rjtc");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");
const $2ae672cf08406695$var$customBlockStyles = null;
const $2ae672cf08406695$var$titleBlockCss = null;
const $2ae672cf08406695$var$footerBlockCss = null;
const $2ae672cf08406695$var$footerBlockSafariStyles = null;
const $2ae672cf08406695$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $g7toL.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                hideIcon: !!title,
                text: title,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc01fxt"
                ]),
                children: children
            }),
            showPreview && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
                actions: actions,
                testId: "smart-block-card-footer",
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $2ae672cf08406695$export$2e2bcd8739ae039 = $2ae672cf08406695$var$UnresolvedView;

});
parcelRegister("19G04", function(module, exports) {

$parcel$export(module.exports, "default", () => $b72b0d53d138fc6a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $k2hJv = parcelRequire("k2hJv");

var $kbv8x = parcelRequire("kbv8x");

var $dpCTw = parcelRequire("dpCTw");

var $025st = parcelRequire("025st");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $b72b0d53d138fc6a$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $k2hJv.useAISummaryConfig)();
    const resolve = (0, $kbv8x.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $eJOHy.useMemo)(()=>(0, $025st.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: status,
            url: url
        }), [
        aiSummaryConfig,
        appearance,
        fireEvent,
        details,
        id,
        onAuthorize,
        onClick,
        origin,
        renderers,
        resolve,
        actionOptions,
        status,
        url
    ]);
    const flexibleCardContext = (0, $eJOHy.useMemo)(()=>({
            data: context,
            status: status,
            ui: ui
        }), [
        context,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5FRJ8.FlexibleCardContext).Provider, {
        value: flexibleCardContext,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dpCTw.default), {
            testId: testId,
            ...ui,
            onClick: onClick,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            status: status,
            retry: retry,
            children: children
        })
    });
};
var $b72b0d53d138fc6a$export$2e2bcd8739ae039 = $b72b0d53d138fc6a$var$FlexibleCard;

});
parcelRegister("dpCTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2113f7140aee1e4f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hq0iR = parcelRequire("hq0iR");

var $1YI3f = parcelRequire("1YI3f");

var $fqBfo = parcelRequire("fqBfo");

var $hjkWh = parcelRequire("hjkWh");

var $59hpa = parcelRequire("59hpa");
const $2113f7140aee1e4f$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $hq0iR.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
            if ((0, $1YI3f.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $5NtHI.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $5NtHI.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $2113f7140aee1e4f$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) && (0, $1YI3f.isFlexibleUiBlock)(child) ? child : undefined);
};
const $2113f7140aee1e4f$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return undefined;
    if (node.type === (0, $fqBfo.default)) return node;
    if ((0, $1YI3f.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $2113f7140aee1e4f$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $2113f7140aee1e4f$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).map((child)=>$2113f7140aee1e4f$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(block)) return block.props;
};
const $2113f7140aee1e4f$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $2113f7140aee1e4f$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59hpa.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || linkTitle?.text,
        url: url
    });
};
const $2113f7140aee1e4f$var$baseStyleCommon = null;
const $2113f7140aee1e4f$var$backgroundStyles = null;
const $2113f7140aee1e4f$var$elevationStyles = null;
const $2113f7140aee1e4f$var$clickableContainerStyles = null;
const $2113f7140aee1e4f$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $2113f7140aee1e4f$var$getPadding = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $2113f7140aee1e4f$var$getGap = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $2113f7140aee1e4f$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $2113f7140aee1e4f$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $2113f7140aee1e4f$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $5NtHI.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container' })=>{
    (0, $gRw8I.di)((0, $hjkWh.default));
    const padding = hidePadding ? '0px' : $2113f7140aee1e4f$var$getPadding(size);
    const gap = $2113f7140aee1e4f$var$getGap(size);
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $2113f7140aee1e4f$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $2113f7140aee1e4f$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $2113f7140aee1e4f$var$previewOnLeftStyleMap[size],
            previewOnRight && $2113f7140aee1e4f$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itzgxb _2rkob7nn _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $awdRS.default)(padding),
            "--_73mooq": (0, $awdRS.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $awdRS.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $2113f7140aee1e4f$var$getLayeredLink(testId, context, children, onClick) : null,
            $2113f7140aee1e4f$var$filterChildren(children, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hjkWh.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $2113f7140aee1e4f$export$2e2bcd8739ae039 = $2113f7140aee1e4f$var$Container;

});
parcelRegister("hq0iR", function(module, exports) {

$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $0488d9459cc3a179$export$783c1bf8fee63f80);
const $0488d9459cc3a179$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("hjkWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $68910ca9bc088568$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $3S6ja = parcelRequire("3S6ja");
const $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $68910ca9bc088568$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $eJOHy.useState)(true);
    const mouseStopTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $eJOHy.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $5NtHI.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            role: 'presentation',
            children: children
        })
    });
};
var $68910ca9bc088568$export$2e2bcd8739ae039 = $68910ca9bc088568$var$HoverCardControl;

});
parcelRegister("3S6ja", function(module, exports) {

$parcel$export(module.exports, "HoverCard", () => $4672c7a0b9a7b840$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $4J0ad = parcelRequire("4J0ad");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $fezTc = parcelRequire("fezTc");

var $44bDi = parcelRequire("44bDi");

var $ct5r8 = parcelRequire("ct5r8");
const $4672c7a0b9a7b840$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $gRw8I.di)((0, $ct5r8.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $44bDi.useSmartLinkAnalyticsContext)({
        display: (0, $5NtHI.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $ct5r8.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $eJOHy.useCallback)((error, info)=>{
        (0, $1mLfK.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ct5r8.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext = (0, $4J0ad.default)()($4672c7a0b9a7b840$var$HoverCardWithErrorBoundary);
const $4672c7a0b9a7b840$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("ct5r8", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $bcd82f075ee4a70e$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $bcd82f075ee4a70e$export$e2173dafa6a751bb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $5NtHI = parcelRequire("5NtHI");

var $bde0S = parcelRequire("bde0S");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");

var $44bDi = parcelRequire("44bDi");

var $dNwAf = parcelRequire("dNwAf");

var $awu5s = parcelRequire("awu5s");

var $kj7DC = parcelRequire("kj7DC");
const $bcd82f075ee4a70e$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGRER_WRAPPER = 'hover-card-trigger-wrapper';
const $bcd82f075ee4a70e$var$FADE_IN_DELAY = 500;
const $bcd82f075ee4a70e$var$FADE_OUT_DELAY = 300;
const $bcd82f075ee4a70e$var$RESOLVE_DELAY = 100;
const $bcd82f075ee4a70e$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $kj7DC.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, label: label, titleId: titleId })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $bcd82f075ee4a70e$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const fadeOutTimeoutId = (0, $eJOHy.useRef)();
    const fadeInTimeoutId = (0, $eJOHy.useRef)();
    const resolveTimeOutId = (0, $eJOHy.useRef)();
    const mousePos = (0, $eJOHy.useRef)();
    const popupOffset = (0, $eJOHy.useRef)();
    const parentSpan = (0, $eJOHy.useRef)(null);
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const { loadMetadata: loadMetadata } = (0, $bde0S.useSmartCardActions)(id, url);
    const setMousePosition = (0, $eJOHy.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $kj7DC.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $kj7DC.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $eJOHy.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $bcd82f075ee4a70e$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $eJOHy.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $bcd82f075ee4a70e$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $eJOHy.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay
    ]);
    const onActionClick = (0, $eJOHy.useCallback)((actionId)=>{
        if (actionId === (0, $5NtHI.ActionName).PreviewAction || actionId === (0, $5NtHI.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eJOHy.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id,
            source: $bcd82f075ee4a70e$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $awu5s.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $eJOHy.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGRER_WRAPPER,
                ...(0, $eGOwo.fg)('platform_editor_preview_panel_linking') ? {
                    className: $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGRER_WRAPPER
                } : {},
                ...(0, $eGOwo.fg)('fix_a11y_violation_in_hover_card_trigger') ? {
                    role: 'button'
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $dNwAf.default)
    });
};

});
parcelRegister("dNwAf", function(module, exports) {

$parcel$export(module.exports, "default", () => $540bc4e78d228f2e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $540bc4e78d228f2e$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
var $540bc4e78d228f2e$export$2e2bcd8739ae039 = $540bc4e78d228f2e$var$CustomPopupContainer;

});

parcelRegister("awu5s", function(module, exports) {

$parcel$export(module.exports, "hoverCardClassName", () => $28757f6aaca5ab4f$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $28757f6aaca5ab4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $9kfy2 = parcelRequire("9kfy2");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $03JM4 = parcelRequire("03JM4");

var $5TXKo = parcelRequire("5TXKo");

var $FoFt2 = parcelRequire("FoFt2");

var $7tQSx = parcelRequire("7tQSx");

var $liquj = parcelRequire("liquj");

var $kj7DC = parcelRequire("kj7DC");

var $gpl3i = parcelRequire("gpl3i");

var $2bxQs = parcelRequire("2bxQs");

var $8Oxy9 = parcelRequire("8Oxy9");

var $hG20o = parcelRequire("hG20o");

var $1klMO = parcelRequire("1klMO");

var $jwqmr = parcelRequire("jwqmr");
const $28757f6aaca5ab4f$export$34883cbaea18402d = 'smart-links-hover-preview';
const $28757f6aaca5ab4f$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const extensionKey = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $7tQSx.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $03JM4.getServices)(linkState.details);
    const statusRef = (0, $eJOHy.useRef)(linkStatus);
    const fireEventRef = (0, $eJOHy.useRef)(fireEvent);
    const definitionIdRef = (0, $eJOHy.useRef)(definitionId);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $gpl3i.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $5NtHI.SmartLinkSize).Large,
        position: (0, $5NtHI.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const uiOptions = (0, $kj7DC.flexibleUiOptions);
    if ((0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $5NtHI.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $eJOHy.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1klMO.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jwqmr.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Oxy9.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hG20o.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bxQs.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $28757f6aaca5ab4f$export$2e2bcd8739ae039 = $28757f6aaca5ab4f$var$HoverCardContent;

});
parcelRegister("kj7DC", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $0426ea3ec103c831$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $0426ea3ec103c831$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $0426ea3ec103c831$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $0426ea3ec103c831$export$e7cae8c75d768024);

var $IW7jS = parcelRequire("IW7jS");

var $5NtHI = parcelRequire("5NtHI");
const $0426ea3ec103c831$export$8245b0eaabf3440c = (0, $IW7jS.layers).modal();
const $0426ea3ec103c831$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $5NtHI.SmartLinkSize).Medium,
    zIndex: $0426ea3ec103c831$export$8245b0eaabf3440c + 1
};
const $0426ea3ec103c831$export$a0a37c997fbcd678 = 24;
const $0426ea3ec103c831$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("gpl3i", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $76d8fd2bfb093db5$export$8548546c0aa631e6);

var $dpM2S = parcelRequire("dpM2S");

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");
const $76d8fd2bfb093db5$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $dpM2S.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $5NtHI.ElementName).AuthorGroup,
            (0, $5NtHI.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).SubscriberCount,
                    (0, $5NtHI.ElementName).State
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).SourceBranch,
                    (0, $5NtHI.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $5NtHI.ElementName).LatestCommit,
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $1UXt3.extractOwnedBy)(data) ? (0, $5NtHI.ElementName).OwnedByGroup : (0, $5NtHI.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $5NtHI.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $5NtHI.ElementName).AssignedToGroup,
                        (0, $5NtHI.ElementName).State,
                        (0, $5NtHI.ElementName).StoryPoints,
                        (0, $5NtHI.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ],
                secondary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).AttachmentCount,
                    (0, $5NtHI.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).SentOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix = [
    (0, $5NtHI.ElementName).AssignedToGroup,
    (0, $5NtHI.ElementName).OwnedByGroup,
    (0, $5NtHI.ElementName).AuthorGroup
];
const $76d8fd2bfb093db5$var$toElementItem = (name)=>{
    const showNamePrefix = $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $76d8fd2bfb093db5$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $5NtHI.ElementName)).map($76d8fd2bfb093db5$var$toElementItem);
};
const $76d8fd2bfb093db5$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $76d8fd2bfb093db5$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $76d8fd2bfb093db5$var$toElementItems(metadata.subtitle),
        primary: $76d8fd2bfb093db5$var$toElementItems(primary),
        secondary: $76d8fd2bfb093db5$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("1UXt3", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkCommentCount", () => $72576417d80bd61c$export$fb0960a89fb9c17b);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $72576417d80bd61c$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $72576417d80bd61c$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $72576417d80bd61c$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractSmartLinkReactCount", () => $72576417d80bd61c$export$bb52c21c67a309ca);
$parcel$export(module.exports, "extractVoteCount", () => $72576417d80bd61c$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $72576417d80bd61c$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $72576417d80bd61c$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $72576417d80bd61c$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $72576417d80bd61c$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $72576417d80bd61c$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $72576417d80bd61c$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractTeamMemberCount", () => $72576417d80bd61c$export$9fc8706c6cb5343a);
$parcel$export(module.exports, "extractAttachmentCount", () => $72576417d80bd61c$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $72576417d80bd61c$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $72576417d80bd61c$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $72576417d80bd61c$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $72576417d80bd61c$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractUserAttributes", () => $72576417d80bd61c$export$6052f26bb463e370);
$parcel$export(module.exports, "extractReadTime", () => $72576417d80bd61c$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSmartLinkSentOn", () => $72576417d80bd61c$export$5c05c5b7ca37e36e);
$parcel$export(module.exports, "extractStoryPoints", () => $72576417d80bd61c$export$bdcea84d1550eb9d);
$parcel$export(module.exports, "extractMetaObjectId", () => $72576417d80bd61c$export$bec1443e3e33b166);
$parcel$export(module.exports, "extractMetaResourceType", () => $72576417d80bd61c$export$11d1314ebbee594e);
$parcel$export(module.exports, "extractMetaTenantId", () => $72576417d80bd61c$export$92037aea7f27bf7f);

var $3jSKi = parcelRequire("3jSKi");
var $fGP6b = parcelRequire("fGP6b");
var $aHgka = parcelRequire("aHgka");
var $3a3fF = parcelRequire("3a3fF");
var $hdxEk = parcelRequire("hdxEk");

var $eGOwo = parcelRequire("eGOwo");
const $72576417d80bd61c$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $72576417d80bd61c$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $72576417d80bd61c$export$b68822b76d5d51d5 = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:commentCount');
const $72576417d80bd61c$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eGOwo.fg)('platform-linking-slack-entity-support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) {
            const entity = (0, $3jSKi.extractEntity)(response);
            return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
        }
    }
    return response?.data && $72576417d80bd61c$export$b68822b76d5d51d5(response?.data);
};
const $72576417d80bd61c$export$4356c594f5c138d6 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $72576417d80bd61c$export$ac56bd7a37249b48 = (data)=>$72576417d80bd61c$var$extractValue(data, 'endTime');
const $72576417d80bd61c$export$e57334ce4738e29d = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:viewCount');
const $72576417d80bd61c$export$44130aa92252501 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:reactCount');
const $72576417d80bd61c$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eGOwo.fg)('platform-linking-slack-entity-support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) {
            const entity = (0, $3jSKi.extractEntity)(response);
            const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
            return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
        }
    }
    return response?.data && $72576417d80bd61c$export$44130aa92252501(response?.data);
};
const $72576417d80bd61c$export$c8bef3d5e550a3a = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:voteCount');
const $72576417d80bd61c$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $3a3fF.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$5546969a505305 = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $72576417d80bd61c$export$69b10d653f96288b = (data)=>{
    const persons = (0, $aHgka.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $hdxEk.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$43e54589935a1ff = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:programmingLanguage');
const $72576417d80bd61c$export$949ac6a8325b3fdb = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeSource']);
const $72576417d80bd61c$export$8bd03a7beb5badf1 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:subscriberCount');
const $72576417d80bd61c$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $72576417d80bd61c$export$65362ff78a97fd8 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:attachmentCount');
const $72576417d80bd61c$export$29b0ac5d2f9890cf = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeDestination']);
const $72576417d80bd61c$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $72576417d80bd61c$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $72576417d80bd61c$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $72576417d80bd61c$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $72576417d80bd61c$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $72576417d80bd61c$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $72576417d80bd61c$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $72576417d80bd61c$export$cc4028b2878d0675 = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $72576417d80bd61c$export$b592ddecae70b61d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'dateSent');
};
const $72576417d80bd61c$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eGOwo.fg)('platform-linking-slack-entity-support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdAt;
    }
    return response?.data && $72576417d80bd61c$export$b592ddecae70b61d(response?.data);
};
const $72576417d80bd61c$export$bdcea84d1550eb9d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:storyPoints');
};
const $72576417d80bd61c$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $72576417d80bd61c$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $72576417d80bd61c$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});
parcelRegister("fGP6b", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $5046cec7bbb70f2b$export$38a0979ebf273662);

var $9JeZK = parcelRequire("9JeZK");
const $5046cec7bbb70f2b$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9JeZK.extractPersonFromJsonLd)(assignedTo);
};

});

parcelRegister("3a3fF", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $acd7880777d9e468$export$19ee667f3f7a6ec3);

var $9JeZK = parcelRequire("9JeZK");
const $acd7880777d9e468$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9JeZK.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9JeZK.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});



parcelRegister("2bxQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $cef1c4bd3f25f5fc$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $gEJiH = parcelRequire("gEJiH");

var $awu5s = parcelRequire("awu5s");
const $cef1c4bd3f25f5fc$var$NEW_CARD_WIDTH_REM = 25;
const $cef1c4bd3f25f5fc$var$HoverCardContainerStyle = null;
const $cef1c4bd3f25f5fc$var$popupContainerStyles = null;
const $cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $gEJiH.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    const [showPrism, setShowPrism] = (0, $eJOHy.useState)(status === 'loading');
    (0, $eJOHy.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rkopd34 _bfhk1bhr _16qs1e6u",
            (0, $awu5s.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gEJiH.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $cef1c4bd3f25f5fc$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)($cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $cef1c4bd3f25f5fc$export$2e2bcd8739ae039 = $cef1c4bd3f25f5fc$var$ContentContainer;

});
parcelRegister("gEJiH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ac4bb0b0e3771c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $58yRG = parcelRequire("58yRG");

var $ic0QK = parcelRequire("ic0QK");

var $aIqUw = parcelRequire("aIqUw");
const $6ac4bb0b0e3771c8$var$contentStyles = null;
const $6ac4bb0b0e3771c8$var$contentStylesPrismVisible = null;
const $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $6ac4bb0b0e3771c8$var$popupContainerStyles = null;
const $6ac4bb0b0e3771c8$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $58yRG.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ic0QK.default), {
        palette: (0, $aIqUw.AI_BORDER_PALETTE)[colorMode] ?? (0, $aIqUw.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $hcewu.default)([
            $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_2rkopd34 _bfhk1bhr _16qs1e6u",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $6ac4bb0b0e3771c8$export$2e2bcd8739ae039 = $6ac4bb0b0e3771c8$var$AIPrism;

});
parcelRegister("ic0QK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c556e491b590659$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4gixb = parcelRequire("4gixb");
const $1c556e491b590659$var$borderContainerStyles = null;
const $1c556e491b590659$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $1c556e491b590659$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_2rkoftgi _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $1c556e491b590659$export$2e2bcd8739ae039 = $1c556e491b590659$var$AIGlowingBorder;

});
parcelRegister("4gixb", function(module, exports) {

$parcel$export(module.exports, "default", () => $915978962937a033$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
let $915978962937a033$var$namespaceUUID = 0;
const $915978962937a033$var$svgStyles = null;
const $915978962937a033$var$blurredStyles = null;
const $915978962937a033$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $915978962937a033$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $915978962937a033$var$namespaceUUID;
        $915978962937a033$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $915978962937a033$export$2e2bcd8739ae039 = $915978962937a033$var$AnimatedSvgContainer;

});


parcelRegister("aIqUw", function(module, exports) {

$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $668726bbe5390a04$export$23b7b83c7063ccfe);
const $668726bbe5390a04$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $668726bbe5390a04$export$23b7b83c7063ccfe = {
    dark: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue800,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal500,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue600,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal300,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("8Oxy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ec0240a00cb7a69$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $ftN6c = parcelRequire("ftN6c");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $8Rjtc = parcelRequire("8Rjtc");
const $7ec0240a00cb7a69$var$titleBlockStyles = null;
const $7ec0240a00cb7a69$var$mainTextStyles = null;
const $7ec0240a00cb7a69$var$connectButtonStyles = null;
const $7ec0240a00cb7a69$var$basePreviewStyles = null;
const $7ec0240a00cb7a69$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
        children: (0, $4Qxcv.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $7r0tl.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    const ButtonComponent = (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? (0, $5CSKW.default) : (0, $goZPP.default);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ignoreContainerPadding: true,
                testId: testId,
                className: (0, $hcewu.default)([
                    "_13lipd34 _qrwqpd34 _otyru2gc"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(ButtonComponent, {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $7ec0240a00cb7a69$export$2e2bcd8739ae039 = $7ec0240a00cb7a69$var$HoverCardForbiddenView;

});
parcelRegister("7r0tl", function(module, exports) {

$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $acbd55282a01ac89$export$846c1540a86749e6);

var $19nmp = parcelRequire("19nmp");

var $b43DQ = parcelRequire("b43DQ");

var $5OkN2 = parcelRequire("5OkN2");

var $4Qxcv = parcelRequire("4Qxcv");
const $acbd55282a01ac89$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $4Qxcv.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $19nmp.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $19nmp.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $5OkN2.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $19nmp.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $19nmp.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("5OkN2", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $1cf8e394dba29dd6$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");
const $1cf8e394dba29dd6$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $19nmp.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("4Qxcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $37283c298b2f6d8f$export$2e2bcd8739ae039);
const $37283c298b2f6d8f$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $37283c298b2f6d8f$export$2e2bcd8739ae039 = $37283c298b2f6d8f$var$extractHostname;

});



parcelRegister("hG20o", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d163d2cd5927fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $19G04 = parcelRequire("19G04");

var $4cjOx = parcelRequire("4cjOx");
var $eMgzj = parcelRequire("eMgzj");
var $2qnEp = parcelRequire("2qnEp");
var $gKsxm = parcelRequire("gKsxm");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $gpl3i = parcelRequire("gpl3i");

var $33eto = parcelRequire("33eto");
const $f7d163d2cd5927fd$var$hiddenSnippetStyles = null;
const $f7d163d2cd5927fd$var$titleBlockStyles = null;
const $f7d163d2cd5927fd$var$snippetBlockCss = null;
const $f7d163d2cd5927fd$var$actionBlockCss = null;
const $f7d163d2cd5927fd$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $eJOHy.useMemo)(()=>{
        return (0, $gpl3i.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(0);
    const snippetBlockRef = (0, $eJOHy.useRef)(null);
    const onSnippetRender = (0, $eJOHy.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $33eto.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
        className: (0, $hcewu.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...titleBlockProps,
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $5NtHI.SmartLinkSize).Medium
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qnEp.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet
            }) : snippet,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                isHidden: true,
                className: (0, $hcewu.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cjOx.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $hcewu.default)([
                    "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eMgzj.default), {})
        ]
    });
};
var $f7d163d2cd5927fd$export$2e2bcd8739ae039 = $f7d163d2cd5927fd$var$HoverCardResolvedView;

});
parcelRegister("33eto", function(module, exports) {

$parcel$export(module.exports, "default", () => $114e5090f71be87e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $71sLJ = parcelRequire("71sLJ");

var $8Rjtc = parcelRequire("8Rjtc");
const $114e5090f71be87e$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $eJOHy.useRef)(false);
    const previewBlockRef = (0, $eJOHy.useRef)(null);
    const [showPreview, setShowPreview] = (0, $eJOHy.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $eJOHy.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
                borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
                marginBottom: "var(--ds-space-100, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $eJOHy.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $eJOHy.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $71sLJ.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $114e5090f71be87e$export$2e2bcd8739ae039 = $114e5090f71be87e$var$ImagePreview;

});
parcelRegister("71sLJ", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $5db4479b590c898b$export$a79836076066b8b6);

var $3jSKi = parcelRequire("3jSKi");
var $GcYFq = parcelRequire("GcYFq");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
const $5db4479b590c898b$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $GcYFq.extractImage)(data);
    return url ? {
        type: (0, $5NtHI.MediaType).Image,
        url: url
    } : undefined;
};
var $5db4479b590c898b$export$2e2bcd8739ae039 = $5db4479b590c898b$var$extractPreview;
const $5db4479b590c898b$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        if (!url && !(0, $eGOwo.fg)('smart_links_noun_support')) {
            const provider = (0, $3jSKi.extractEntityProvider)(response);
            url = provider?.image;
        }
        return url ? {
            type: (0, $5NtHI.MediaType).Image,
            url: url
        } : undefined;
    }
    return $5db4479b590c898b$var$extractPreview(response.data);
};

});
parcelRegister("GcYFq", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $d2101dc0ce9c996b$export$4c753a1297cb9805);

var $jo2Je = parcelRequire("jo2Je");
const $d2101dc0ce9c996b$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});




parcelRegister("1klMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $208dcc57b264b5f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $65mpR = parcelRequire("65mpR");

var $d6nZP = parcelRequire("d6nZP");

var $kj7DC = parcelRequire("kj7DC");
const $208dcc57b264b5f9$var$loadingViewContainer = null;
const $208dcc57b264b5f9$var$skeletonContainer = null;
const $208dcc57b264b5f9$var$titleStyle = null;
const $208dcc57b264b5f9$var$titleBlockStyles = null;
const $208dcc57b264b5f9$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $kj7DC.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1e9d _u5f31e9d _n3td1e9d _19bv1e9d"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $hcewu.default)([
                        "_zulpcxkx _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
                            render: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $hcewu.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                                height: `${lineHeightRem}rem`
                            })
                        }),
                        actionGroup
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                })
            ]
        })
    });
};
var $208dcc57b264b5f9$export$2e2bcd8739ae039 = $208dcc57b264b5f9$var$HoverCardLoadingView;

});

parcelRegister("jwqmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a30e9762e9a1caf4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $bde0S = parcelRequire("bde0S");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $jPfaa = parcelRequire("jPfaa");
const $a30e9762e9a1caf4$var$connectButtonStyles = null;
const $a30e9762e9a1caf4$var$titleBlockStyles = null;
const $a30e9762e9a1caf4$var$mainTextStyles = null;
const $a30e9762e9a1caf4$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $bde0S.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5NtHI.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_link_account_card_name,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-button`,
                className: (0, $hcewu.default)([
                    "_1bahesu3 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $a30e9762e9a1caf4$export$2e2bcd8739ae039 = $a30e9762e9a1caf4$var$HoverCardUnauthorisedView;

});
parcelRegister("5z6NJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b17ec2d366022be$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $lc0OY = parcelRequire("lc0OY");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $4b17ec2d366022be$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $19nmp.messages).learn_more_about_connecting_account : (0, $19nmp.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_unauthorised_account_description,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                href: isProductIntegrationSupported ? (0, $5NtHI.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5NtHI.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $4b17ec2d366022be$export$2e2bcd8739ae039 = $4b17ec2d366022be$var$UnauthorisedViewContent;

});






parcelRegister("59hpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $059fbcc0253de40e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $e3qu2 = parcelRequire("e3qu2");
const $059fbcc0253de40e$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $059fbcc0253de40e$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1,
        children: text
    });
};
var $059fbcc0253de40e$export$2e2bcd8739ae039 = $059fbcc0253de40e$var$LayeredLink;

});


parcelRegister("025st", function(module, exports) {

$parcel$export(module.exports, "getContextByStatus", () => $78d5204a1babb283$export$e68aec76e359e401);

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $4ho8r = parcelRequire("4ho8r");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $19nmp = parcelRequire("19nmp");

var $FoFt2 = parcelRequire("FoFt2");

var $gA511 = parcelRequire("gA511");
const $78d5204a1babb283$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                url: url
            };
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return (0, $4ho8r.default)(params);
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $8z78z.extractErrorIcon)(response, status),
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
                provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $5NtHI.InternalActionName).UnresolvedAction]: $78d5204a1babb283$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response?.meta?.requestAccess?.accessType
                }
            };
    }
};
const $78d5204a1babb283$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $78d5204a1babb283$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $hy9OT.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const access = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $78d5204a1babb283$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $19nmp.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $FoFt2.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $19nmp.messages).connect_link_account_card_name,
                onClick: (0, $FoFt2.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $19nmp.messages).cannot_find_link
            };
    }
};

});
parcelRegister("4ho8r", function(module, exports) {

$parcel$export(module.exports, "default", () => $4044cb6e4b021061$export$2e2bcd8739ae039);

var $3a3fF = parcelRequire("3a3fF");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $eGOwo = parcelRequire("eGOwo");

var $3SqDE = parcelRequire("3SqDE");

var $2YDTG = parcelRequire("2YDTG");

var $jIa7q = parcelRequire("jIa7q");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $2LW3F = parcelRequire("2LW3F");

var $96cCi = parcelRequire("96cCi");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $krByh = parcelRequire("krByh");

var $1UXt3 = parcelRequire("1UXt3");
const $4044cb6e4b021061$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    return {
        actions: (0, $2YDTG.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url
        }),
        appliedToComponentsCount: (0, $1UXt3.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $1UXt3.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $1UXt3.extractAttachmentCount)(data),
        authorGroup: (0, $hy9OT.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $3a3fF.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $jIa7q.extractPersonsUpdatedBy)(data),
        commentCount: (0, $1UXt3.extractSmartLinkCommentCount)(response),
        viewCount: (0, $1UXt3.extractViewCount)(data),
        reactCount: (0, $1UXt3.extractSmartLinkReactCount)(response),
        voteCount: (0, $1UXt3.extractVoteCount)(data),
        checklistProgress: (0, $1UXt3.extractChecklistProgress)(data),
        createdBy: (0, $hy9OT.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $1UXt3.extractOwnedBy)(data),
        assignedTo: (0, $1UXt3.extractAssignedTo)(data),
        createdOn: (0, $hy9OT.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $1UXt3.extractDueOn)(data),
        latestCommit: (0, $krByh.extractLatestCommit)(data),
        linkIcon: (0, $8z78z.extractSmartLinkIcon)(response),
        linkTitle: (0, $13x9L.default)(status, props.url, response, onClick),
        location: (0, $1UXt3.extractLocation)(data),
        modifiedBy: (0, $hy9OT.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $hy9OT.extractSmartLinkModifiedOn)(response),
        preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
        priority: (0, $2LW3F.default)(data),
        provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $1UXt3.extractProgrammingLanguage)(data),
        readTime: (0, $1UXt3.extractReadTime)(data),
        sentOn: (0, $1UXt3.extractSmartLinkSentOn)(response),
        snippet: (0, $3SqDE.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $1UXt3.extractSourceBranch)(data),
        state: (0, $96cCi.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve),
        subscriberCount: (0, $1UXt3.extractSubscriberCount)(data),
        subTasksProgress: (0, $1UXt3.extractSubTasksProgress)(data),
        storyPoints: (0, $1UXt3.extractStoryPoints)(data),
        targetBranch: (0, $1UXt3.extractTargetBranch)(data),
        ...(0, $eGOwo.fg)('platform-linking-user-attributes-component') && {
            userAttributes: (0, $1UXt3.extractUserAttributes)(data)
        },
        ...(0, $eGOwo.fg)('platform-linking-team-member-count-component') && {
            teamMemberCount: (0, $1UXt3.extractTeamMemberCount)(data)
        },
        url: url,
        ari: (0, $hy9OT.extractSmartLinkAri)(response),
        type: (0, $dpM2S.extractType)(data),
        ...(0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') && {
            meta: {
                objectId: (0, $1UXt3.extractMetaObjectId)(meta),
                resourceType: (0, $1UXt3.extractMetaResourceType)(meta),
                tenantId: (0, $1UXt3.extractMetaTenantId)(meta)
            }
        }
    };
};
var $4044cb6e4b021061$export$2e2bcd8739ae039 = $4044cb6e4b021061$var$extractFlexibleUiContext;

});
parcelRegister("3SqDE", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkSummary", () => $f7e45c18a3795a6b$export$8c6b9b49f358840);

var $3jSKi = parcelRequire("3jSKi");

var $eGOwo = parcelRequire("eGOwo");
const $f7e45c18a3795a6b$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $f7e45c18a3795a6b$export$8c6b9b49f358840 = (response)=>{
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.description;
    }
    return response?.data && $f7e45c18a3795a6b$export$db5a8500f6b6286e(response.data);
};

});

parcelRegister("2YDTG", function(module, exports) {

$parcel$export(module.exports, "extractFlexibleCardActions", () => $df0887593ff7101f$export$abe8d0ca1daa1755);

var $5NtHI = parcelRequire("5NtHI");

var $4DFm3 = parcelRequire("4DFm3");

var $glHkX = parcelRequire("glHkX");

var $71e7e = parcelRequire("71e7e");

var $9ZYEf = parcelRequire("9ZYEf");

var $7xgpC = parcelRequire("7xgpC");

var $l3lcT = parcelRequire("l3lcT");

var $iJBt4 = parcelRequire("iJBt4");
const $df0887593ff7101f$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url })=>{
    const action = {
        [(0, $5NtHI.ActionName).CopyLinkAction]: (0, $71e7e.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).DownloadAction]: (0, $9ZYEf.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).FollowAction]: (0, $7xgpC.default)(response, actionOptions, id),
        [(0, $5NtHI.ActionName).PreviewAction]: (0, $l3lcT.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response
        }),
        [(0, $5NtHI.ActionName).AutomationAction]: (0, $glHkX.extractAutomationAction)(response),
        [(0, $5NtHI.InternalActionName).AISummaryAction]: (0, $4DFm3.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $5NtHI.InternalActionName).ViewRelatedLinksAction]: (0, $iJBt4.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("4DFm3", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $3a123960ee44ec9b$export$e7f7a50a8b8932df);

var $2fsAU = parcelRequire("2fsAU");

var $7tQSx = parcelRequire("7tQSx");

var $18DG7 = parcelRequire("18DG7");
const $3a123960ee44ec9b$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).AISummaryAction, actionOptions) || !(0, $7tQSx.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("2fsAU", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $2264131ee11f6725$export$2487b058456cca75);
const $2264131ee11f6725$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});


parcelRegister("glHkX", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $26db5af86415f15e$export$f913cc6abf3ec084);

var $5NtHI = parcelRequire("5NtHI");
const $26db5af86415f15e$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $5NtHI.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("71e7e", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkClientAction", () => $c1fb7cacddedb674$export$31ddd5c40039ce53);

var $kGroK = parcelRequire("kGroK");
const $c1fb7cacddedb674$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $kGroK.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("kGroK", function(module, exports) {

$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $944dc4c637fc31a2$export$5ec86886067a062d);

var $3seWH = parcelRequire("3seWH");
var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");
const $944dc4c637fc31a2$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).CopyLinkAction, actionOptions)) return;
    const data = response.data;
    const url = (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkUrl)(response) : (0, $3seWH.extractLink)(data);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $5NtHI.ActionName).CopyLinkAction,
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});


parcelRegister("9ZYEf", function(module, exports) {

$parcel$export(module.exports, "extractDownloadClientAction", () => $8b4fa13cd6f1b67f$export$f6c386869a352b1f);

var $ccFJO = parcelRequire("ccFJO");
const $8b4fa13cd6f1b67f$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $ccFJO.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("ccFJO", function(module, exports) {

$parcel$export(module.exports, "extractInvokeDownloadAction", () => $0aeada01337c8e80$export$ea97cd34c2ca86de);

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");

var $37QDL = parcelRequire("37QDL");
const $0aeada01337c8e80$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkDownloadUrl)(response) : (0, $37QDL.extractDownloadUrl)(data);
        return {
            actionFn: async ()=>(0, $FoFt2.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5NtHI.ActionName).DownloadAction,
            definitionId: (0, $03JM4.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $03JM4.getExtensionKey)(response),
            id: id,
            resourceType: (0, $03JM4.getResourceType)(response)
        };
    }
};

});
parcelRegister("blyJR", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $a3fe6b36e98c43c2$export$8f031784a3a03b23);
const $a3fe6b36e98c43c2$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});

parcelRegister("37QDL", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $5db269b02f6f1ef1$export$9682e3ac9d184e95);
const $5db269b02f6f1ef1$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});



parcelRegister("7xgpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d7e2884a85971c9$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");
var $dpM2S = parcelRequire("dpM2S");

var $5CgrK = parcelRequire("5CgrK");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $bT52P = parcelRequire("bT52P");
const $2d7e2884a85971c9$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    const type = (0, $dpM2S.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $5CgrK.SmartLinkActionType).FollowEntityAction || actionName === (0, $5CgrK.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $3seWH.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $5CgrK.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $2d7e2884a85971c9$export$2e2bcd8739ae039 = $2d7e2884a85971c9$var$extractFollowAction;

});
parcelRegister("bT52P", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfb63d54723b1798$export$2e2bcd8739ae039);
const $bfb63d54723b1798$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $bfb63d54723b1798$export$2e2bcd8739ae039 = $bfb63d54723b1798$var$extractServerAction;

});


parcelRegister("l3lcT", function(module, exports) {

$parcel$export(module.exports, "extractPreviewClientAction", () => $be48c7ee2c64cc3a$export$9f0d9100b079448);

var $5O37S = parcelRequire("5O37S");
const $be48c7ee2c64cc3a$export$9f0d9100b079448 = (param)=>{
    const invokeAction = (0, $5O37S.extractInvokePreviewAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("5O37S", function(module, exports) {

$parcel$export(module.exports, "extractInvokePreviewAction", () => $5a058ee1f9e9b538$export$caf83f49e52ac0bb);

var $3seWH = parcelRequire("3seWH");
var $6OR2o = parcelRequire("6OR2o");
var $9Thyx = parcelRequire("9Thyx");
var $hy9OT = parcelRequire("hy9OT");
var $8T839 = parcelRequire("8T839");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $aNEbu = parcelRequire("aNEbu");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");

var $8z78z = parcelRequire("8z78z");

var $ccFJO = parcelRequire("ccFJO");

var $el1MG = parcelRequire("el1MG");
const $5a058ee1f9e9b538$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response } = param;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (0, $6OR2o.extractPreview)(data, 'web')?.src;
    if (src) {
        const url = (0, $3seWH.extractLink)(data);
        const extensionKey = (0, $03JM4.getExtensionKey)(response);
        return {
            actionFn: async ()=>(0, $aNEbu.openEmbedModal)({
                    fireEvent: fireEvent,
                    extensionKey: extensionKey,
                    id: id,
                    invokeDownloadAction: (0, $ccFJO.extractInvokeDownloadAction)(param),
                    invokeViewAction: (0, $el1MG.extractInvokeViewAction)(param, true),
                    isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
                    isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
                    linkIcon: (0, $8z78z.extractLinkIcon)(response),
                    providerName: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkProvider)(response)?.text : (0, $9Thyx.extractProvider)(data)?.text,
                    onClose: onClose,
                    origin: origin,
                    src: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkEmbed)(response)?.src : src,
                    title: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkTitle)(response) : (0, $8T839.extractTitle)(data),
                    url: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkUrl)(response) : url
                }),
            actionSubjectId: 'invokePreviewScreen',
            actionType: (0, $5NtHI.ActionName).PreviewAction,
            display: display,
            extensionKey: extensionKey,
            id: id
        };
    }
};

});
parcelRegister("aNEbu", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $2e72cab05fd02eba$export$7859f96cd8cff034);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");
const $2e72cab05fd02eba$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $2e72cab05fd02eba$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("4M5bk"));
    (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).render(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Modal.default, {
            ...props,
            iframeName: $2e72cab05fd02eba$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("4M5bk", function(module, exports) {

let $379faa16a2da8ae6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $379faa16a2da8ae6$var$load("ffQaD"),
    $379faa16a2da8ae6$var$load("kvRbA"),
    $379faa16a2da8ae6$var$load("16B8C")
]).then(()=>parcelRequire('lJ0K6'));

});


parcelRegister("b5GVx", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $d6879f4d400478b0$export$38d755f52cdf4acb);

var $3DgO9 = parcelRequire("3DgO9");
const $d6879f4d400478b0$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $3DgO9.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("3DgO9", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $a195a16b307c9ed2$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $a195a16b307c9ed2$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $a195a16b307c9ed2$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $a195a16b307c9ed2$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $a195a16b307c9ed2$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $a195a16b307c9ed2$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $a195a16b307c9ed2$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $a195a16b307c9ed2$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $a195a16b307c9ed2$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $a195a16b307c9ed2$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $a195a16b307c9ed2$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $a195a16b307c9ed2$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $a195a16b307c9ed2$export$fe44ce30fd8d131b);
const $a195a16b307c9ed2$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $a195a16b307c9ed2$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $a195a16b307c9ed2$export$84a73a0383f58180 = 'JiraTask';
const $a195a16b307c9ed2$export$c6c83963a9378a67 = 'JiraSubTask';
const $a195a16b307c9ed2$export$58af3c426c111a6d = 'JiraStory';
const $a195a16b307c9ed2$export$ac9898a63417219e = 'JiraBug';
const $a195a16b307c9ed2$export$54db5e3fb12e39cd = 'JiraEpic';
const $a195a16b307c9ed2$export$2f54a5a217202c85 = 'JiraIncident';
const $a195a16b307c9ed2$export$d097371052bfc411 = 'JiraServiceRequest';
const $a195a16b307c9ed2$export$efd9452ad16c6676 = 'JiraChange';
const $a195a16b307c9ed2$export$2e7e70abb5d81f67 = 'JiraProblem';
const $a195a16b307c9ed2$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $a195a16b307c9ed2$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider'
];

});


parcelRegister("1jpb6", function(module, exports) {

$parcel$export(module.exports, "extractIsTrusted", () => $ec58a694a8b15740$export$4f3ffbb500daac5a);
const $ec58a694a8b15740$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("8z78z", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $908dbe215fe49acc$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $908dbe215fe49acc$export$bdd29be9b0395931);
$parcel$export(module.exports, "extractSmartLinkIcon", () => $908dbe215fe49acc$export$35040aed9264b11c);

var $3jSKi = parcelRequire("3jSKi");

var $5NtHI = parcelRequire("5NtHI");

var $1zbM5 = parcelRequire("1zbM5");

var $lBR2D = parcelRequire("lBR2D");

var $kYbGg = parcelRequire("kYbGg");
const $908dbe215fe49acc$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $1zbM5.default)(data, renderers);
    return {
        ...(0, $lBR2D.default)(data),
        render: render
    };
};
const $908dbe215fe49acc$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $kYbGg.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5NtHI.IconType).Forbidden
            };
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5NtHI.IconType).Error
            };
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5NtHI.IconType).Default
            };
    }
};
const $908dbe215fe49acc$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityIcon)(response);
    return $908dbe215fe49acc$export$43612bed147eae48(response, renderers);
};

});
parcelRegister("1zbM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $006269c1cd396984$export$2e2bcd8739ae039);
const $006269c1cd396984$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $006269c1cd396984$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $006269c1cd396984$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $006269c1cd396984$export$2e2bcd8739ae039 = $006269c1cd396984$var$extractIconRenderer;

});

parcelRegister("lBR2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $294e9df0fd90b4dc$export$2e2bcd8739ae039);

var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");

var $l5kRv = parcelRequire("l5kRv");

var $3DgO9 = parcelRequire("3DgO9");

var $3LiRd = parcelRequire("3LiRd");

var $dyU3L = parcelRequire("dyU3L");

var $imtUu = parcelRequire("imtUu");

var $kYbGg = parcelRequire("kYbGg");

var $6LWK3 = parcelRequire("6LWK3");
const $294e9df0fd90b4dc$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $l5kRv.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $294e9df0fd90b4dc$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0] : type;
};
const $294e9df0fd90b4dc$var$isJiraProvider = (provider)=>provider === (0, $3DgO9.JIRA_GENERATOR_ID);
function $294e9df0fd90b4dc$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $dyU3L.default)(fileFormat);
    const documentTypeIcon = $294e9df0fd90b4dc$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $3LiRd.default)(type, label, providerId);
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $294e9df0fd90b4dc$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $5NtHI.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $5NtHI.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $5NtHI.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $5NtHI.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $5NtHI.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $5NtHI.IconType).Task,
                label: taskLabel
            };
            if ($294e9df0fd90b4dc$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $294e9df0fd90b4dc$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $imtUu.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $294e9df0fd90b4dc$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $8T839.extractTitle)(data);
    const type = $294e9df0fd90b4dc$var$extractType(data);
    const urlIcon = (0, $6LWK3.default)(data.icon, label);
    const providerIcon = (0, $kYbGg.default)(data);
    return $294e9df0fd90b4dc$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $294e9df0fd90b4dc$export$2e2bcd8739ae039 = $294e9df0fd90b4dc$var$extractJsonldDataIcon;

});
parcelRegister("abbo9", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $2e5b1fff8f67610f$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $2e5b1fff8f67610f$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("aDkpj", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4);
const $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("l5kRv", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $30b3c63f6ca4244d$export$ed3fd59180514d27);

var $4moW4 = parcelRequire("4moW4");
const $30b3c63f6ca4244d$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $4moW4.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("3LiRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $75b1006362800173$export$2e2bcd8739ae039);

var $9Thyx = parcelRequire("9Thyx");

var $5NtHI = parcelRequire("5NtHI");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $75b1006362800173$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $5NtHI.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $9Thyx.isConfluenceGenerator)(providerId)) return {
                icon: (0, $5NtHI.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else return {
                icon: (0, $5NtHI.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $5NtHI.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $75b1006362800173$export$2e2bcd8739ae039 = $75b1006362800173$var$extractDocumentTypeIcon;

});

parcelRegister("imtUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebe1a8cda0f126bd$export$2e2bcd8739ae039);

var $5NtHI = parcelRequire("5NtHI");
const $ebe1a8cda0f126bd$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $5NtHI.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $5NtHI.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $5NtHI.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $5NtHI.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $5NtHI.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $5NtHI.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $5NtHI.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $5NtHI.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label
            };
    }
};
var $ebe1a8cda0f126bd$export$2e2bcd8739ae039 = $ebe1a8cda0f126bd$var$extractJiraTaskIcon;

});

parcelRegister("kYbGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bccbab21d09288f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkProviderIcon", () => $1bccbab21d09288f$export$5def189f04eea025);

var $3jSKi = parcelRequire("3jSKi");
var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $3DgO9 = parcelRequire("3DgO9");

var $6LWK3 = parcelRequire("6LWK3");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $1bccbab21d09288f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $8T839.extractTitle)(data);
    if (provider === (0, $3DgO9.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $3DgO9.JIRA_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $6LWK3.default)(icon, label);
};
var $1bccbab21d09288f$export$2e2bcd8739ae039 = $1bccbab21d09288f$var$extractProviderIcon;
const $1bccbab21d09288f$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $3DgO9.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $3DgO9.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $3jSKi.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $1bccbab21d09288f$var$extractProviderIcon(response.data);
};

});
parcelRegister("6LWK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $500a210ebb43c155$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $500a210ebb43c155$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $4moW4.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $500a210ebb43c155$export$2e2bcd8739ae039 = $500a210ebb43c155$var$extractUrlIcon;

});




parcelRegister("el1MG", function(module, exports) {

$parcel$export(module.exports, "extractInvokeViewAction", () => $8933c20370529de6$export$88c5813cfbbe4e4c);

var $3seWH = parcelRequire("3seWH");

var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");
const $8933c20370529de6$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $3seWH.extractLink)(data);
    const viewActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $FoFt2.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});



parcelRegister("iJBt4", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $30a13f343fd23d01$export$debae7424a0231b9);

var $9R3Jd = parcelRequire("9R3Jd");
var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");
const $30a13f343fd23d01$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkAri)(response) : (0, $9R3Jd.extractAri)(response.data);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("jIa7q", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $afd980b8f5408674$export$216e4f6aa7c169b8);

var $8pdx9 = parcelRequire("8pdx9");
var $9JeZK = parcelRequire("9JeZK");
const $afd980b8f5408674$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $8pdx9.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $9JeZK.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("8pdx9", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $491ba0064e87a086$export$6281d080d62a0719);

var $9JeZK = parcelRequire("9JeZK");
const $491ba0064e87a086$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9JeZK.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9JeZK.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("13x9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $f77867f4004a4594$export$2e2bcd8739ae039);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
const $f77867f4004a4594$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const responseUrl = (0, $hy9OT.extractSmartLinkUrl)(response);
    const url = status === (0, $5NtHI.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $hy9OT.extractSmartLinkTitle)(response);
    const text = status === (0, $5NtHI.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $f77867f4004a4594$export$2e2bcd8739ae039 = $f77867f4004a4594$var$extractLinkTitle;

});

parcelRegister("2LW3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $46aad986c1287f3b$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");

var $5NtHI = parcelRequire("5NtHI");
const $46aad986c1287f3b$var$priorityMapper = {
    blocker: (0, $5NtHI.IconType).PriorityBlocker,
    critical: (0, $5NtHI.IconType).PriorityCritical,
    high: (0, $5NtHI.IconType).PriorityHigh,
    highest: (0, $5NtHI.IconType).PriorityHighest,
    low: (0, $5NtHI.IconType).PriorityLow,
    lowest: (0, $5NtHI.IconType).PriorityLowest,
    major: (0, $5NtHI.IconType).PriorityMajor,
    medium: (0, $5NtHI.IconType).PriorityMedium,
    minor: (0, $5NtHI.IconType).PriorityMinor,
    trivial: (0, $5NtHI.IconType).PriorityTrivial,
    undefined: (0, $5NtHI.IconType).PriorityUndefined
};
const $46aad986c1287f3b$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $46aad986c1287f3b$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $4moW4.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $46aad986c1287f3b$export$2e2bcd8739ae039 = $46aad986c1287f3b$var$extractPriority;

});

parcelRegister("96cCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $599db3951a68070c$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $5O37S = parcelRequire("5O37S");

var $bpSSH = parcelRequire("bpSSH");

var $bT52P = parcelRequire("bT52P");
const $599db3951a68070c$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $599db3951a68070c$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $3seWH.extractLink)(data);
    const invokePreviewAction = response ? (0, $5O37S.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response
    }) : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $599db3951a68070c$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $bpSSH.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $599db3951a68070c$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve);
    return {
        ...lozenge,
        action: action
    };
};
var $599db3951a68070c$export$2e2bcd8739ae039 = $599db3951a68070c$var$extractState;

});
parcelRegister("bpSSH", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $c2b51845c5984a0b$export$e5da155556a77bca);

var $dpM2S = parcelRequire("dpM2S");

var $8haf8 = parcelRequire("8haf8");

var $1Kr9e = parcelRequire("1Kr9e");

var $7ncIg = parcelRequire("7ncIg");

var $l5kRv = parcelRequire("l5kRv");
const $c2b51845c5984a0b$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $dpM2S.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $1Kr9e.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $7ncIg.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $c2b51845c5984a0b$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $8haf8.extractState)(jsonLd);
    }
};
const $c2b51845c5984a0b$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $l5kRv.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("8haf8", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $76dc1be10470e17b$export$5e4074cbce6574c7);

var $9tSQF = parcelRequire("9tSQF");
// Maps accent color short names to their corresponding background and text colors
const $76dc1be10470e17b$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $76dc1be10470e17b$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $9tSQF.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $9tSQF.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $76dc1be10470e17b$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("9tSQF", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $ae66787404c6b4b4$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $ae66787404c6b4b4$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $ae66787404c6b4b4$export$772610da74ddbc07);
const $ae66787404c6b4b4$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $ae66787404c6b4b4$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $ae66787404c6b4b4$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $ae66787404c6b4b4$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $ae66787404c6b4b4$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("1Kr9e", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $00d711d353e3bb83$export$962a8da34cf78a4f);

var $9tSQF = parcelRequire("9tSQF");
const $00d711d353e3bb83$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($00d711d353e3bb83$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $00d711d353e3bb83$var$extractTagItem(tag);
    }
};
const $00d711d353e3bb83$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $9tSQF.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("7ncIg", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $7aa28bf1d699e3b1$export$7698df1946deda72);
const $7aa28bf1d699e3b1$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("krByh", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $ce13437708ceefb0$export$f222392162cff0d8);
const $ce13437708ceefb0$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("g7toL", function(module, exports) {

$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $e227bf38409b8990$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $e227bf38409b8990$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $e227bf38409b8990$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $e227bf38409b8990$export$9671929f11bd4ad8);

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");

var $03JM4 = parcelRequire("03JM4");
const $e227bf38409b8990$var$baseTopMetadata = [
    {
        name: (0, $5NtHI.ElementName).ModifiedOn
    },
    {
        name: (0, $5NtHI.ElementName).AttachmentCount
    },
    {
        name: (0, $5NtHI.ElementName).SubscriberCount
    },
    {
        name: (0, $5NtHI.ElementName).VoteCount
    },
    {
        name: (0, $5NtHI.ElementName).DueOn
    },
    {
        name: (0, $5NtHI.ElementName).ReadTime
    }
];
const $e227bf38409b8990$var$baseBottomMetaData = [
    {
        name: (0, $5NtHI.ElementName).ReactCount
    },
    {
        name: (0, $5NtHI.ElementName).CommentCount
    },
    {
        name: (0, $5NtHI.ElementName).ViewCount
    },
    {
        name: (0, $5NtHI.ElementName).Priority
    },
    {
        name: (0, $5NtHI.ElementName).SubTasksProgress
    },
    {
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }
];
const $e227bf38409b8990$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $5NtHI.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $5NtHI.ElementName).AuthorGroup
        },
        {
            name: (0, $5NtHI.ElementName).CreatedBy
        },
        ...$e227bf38409b8990$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $e227bf38409b8990$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $5NtHI.ElementName).LatestCommit
                    },
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AppliedToComponentsCount
                    },
                    ...$e227bf38409b8990$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AuthorGroup
                },
                {
                    name: (0, $5NtHI.ElementName).CreatedBy
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AssignedToGroup
                },
                {
                    name: (0, $5NtHI.ElementName).AssignedTo
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).OwnedByGroup
                },
                {
                    name: (0, $5NtHI.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).StoryPoints
                    },
                    {
                        name: (0, $5NtHI.ElementName).Priority
                    },
                    {
                        name: (0, $5NtHI.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).ReactCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).UserAttributes
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $e227bf38409b8990$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $e227bf38409b8990$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $5NtHI.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $5NtHI.SmartLinkSize).Large
};
const $e227bf38409b8990$export$9671929f11bd4ad8 = {
    placement: (0, $5NtHI.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("lc1jH", function(module, exports) {

$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $c6261e336be0cca4$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c6261e336be0cca4$var$flexibleBlockCardStyle = null;
const $c6261e336be0cca4$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_1g96pd34 _1qo3h6cr"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(FlexibleBlockCardView, {
                ...props
            })
        });
    };

});


parcelRegister("1uPx2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e11d03c412e160$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $gA511 = parcelRequire("gA511");

var $38cBa = parcelRequire("38cBa");

var $fPNY3 = parcelRequire("fPNY3");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $c5e11d03c412e160$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $c5e11d03c412e160$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $lRq8t.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
    const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
    const providerName = provider?.text || '';
    const messageContext = (0, $eJOHy.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
            children: (0, $4Qxcv.default)(url)
        });
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $eJOHy.useMemo)(()=>{
        return (0, $7r0tl.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $eJOHy.useMemo)(()=>{
        const descriptor = (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $fPNY3.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $fPNY3.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "forbidden-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
                    values: messageContext
                },
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $c5e11d03c412e160$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($c5e11d03c412e160$var$ForbiddenView);

});
parcelRegister("9QgTI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a613e9f42e1e21$var$_react = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72a613e9f42e1e21$var$_baseNew = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72a613e9f42e1e21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72a613e9f42e1e21$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72a613e9f42e1e21$var$_react.default.createElement($72a613e9f42e1e21$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72a613e9f42e1e21$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72a613e9f42e1e21$var$_default = module.exports.default = $72a613e9f42e1e21$var$LockLockedIcon;

});

parcelRegister("jFH1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e523377710580c71$var$_react = $e523377710580c71$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $e523377710580c71$var$_lockLocked = $e523377710580c71$var$_interopRequireDefault((parcelRequire("9QgTI")));
function $e523377710580c71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e523377710580c71$var$LockIcon = (props)=>/*#__PURE__*/ $e523377710580c71$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $e523377710580c71$var$_lockLocked.default
    }));
$e523377710580c71$var$LockIcon.displayName = 'LockIcon';
var $e523377710580c71$var$_default = module.exports.default = $e523377710580c71$var$LockIcon;

});

parcelRegister("idDkX", function(module, exports) {

$parcel$export(module.exports, "toMessage", () => $d5f398015422946e$export$d14c2a6dee946f52);

var $19nmp = parcelRequire("19nmp");
const $d5f398015422946e$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $19nmp.messages)) return (0, $19nmp.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("fPNY3", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $f4b684ab7f00a73c$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $f4b684ab7f00a73c$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("eB1dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa49cd5b8f02fcca$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $aa49cd5b8f02fcca$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $aa49cd5b8f02fcca$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $lRq8t.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $eJOHy.useMemo)(()=>{
        const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $eJOHy.useMemo)(()=>intl.formatMessage((0, $19nmp.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $eJOHy.useMemo)(()=>({
            descriptor: (0, $19nmp.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "not-found-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                message: description,
                testId: `${testId}-message`,
                maxLines: 3,
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $aa49cd5b8f02fcca$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($aa49cd5b8f02fcca$var$NotFoundView);

});

parcelRegister("8jMdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d529b5b9d214a4cd$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $19G04 = parcelRequire("19G04");

var $lAF2k = parcelRequire("lAF2k");
var $gKsxm = parcelRequire("gKsxm");
var $8Rjtc = parcelRequire("8Rjtc");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");

var $lc1jH = parcelRequire("lc1jH");
const $d529b5b9d214a4cd$var$titleBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockSafariStyles = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $d529b5b9d214a4cd$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $eJOHy.useState)(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    (0, $eJOHy.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $g7toL.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const uiOptions = (0, $g7toL.FlexibleCardUiOptions);
    if ((0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                metadata: titleMetadata,
                subtitle: [
                    {
                        name: (0, $5NtHI.ElementName).Location
                    }
                ],
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                CompetitorPrompt: CompetitorPrompt,
                url: url,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: topMetadata,
                maxLines: 1
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: bottomMetadata,
                maxLines: 1
            }),
            !isPreviewBlockErrored ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions),
                onError: ()=>{
                    setIsPreviewBlockErrored(true);
                }
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lAF2k.default), {
                actions: footerActions,
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $d529b5b9d214a4cd$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($d529b5b9d214a4cd$var$ResolvedView);

});

parcelRegister("4fOPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1855e7f6748dd65c$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $6Xgel = parcelRequire("6Xgel");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $1855e7f6748dd65c$var$contentStyles = null;
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $1855e7f6748dd65c$var$UnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>onAuthorize ? [
            (0, $6Xgel.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-content`,
            className: (0, $hcewu.default)([
                "_11c8dcr7 _syaz1fxt _19pku2gc"
            ]),
            children: content
        })
    });
};
var $1855e7f6748dd65c$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($1855e7f6748dd65c$var$UnauthorisedView);

});
parcelRegister("6Xgel", function(module, exports) {

$parcel$export(module.exports, "AuthorizeAction", () => $3bad804239ca8758$export$34cef2b72294bd84);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $3bad804239ca8758$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $5NtHI.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_link_account_card
        }),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});



parcelRegister("9uyEx", function(module, exports) {

$parcel$export(module.exports, "EmbedCard", () => $05d9abb62f80e331$export$6789d7ecdc77631b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $7r0tl = parcelRequire("7r0tl");

var $7AKPz = parcelRequire("7AKPz");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $9gzoR = parcelRequire("9gzoR");

var $gA511 = parcelRequire("gA511");

var $4UV7R = parcelRequire("4UV7R");

var $8jMdw = parcelRequire("8jMdw");

var $eIvWj = parcelRequire("eIvWj");

var $hFl6W = parcelRequire("hFl6W");

var $i53U1 = parcelRequire("i53U1");

var $5RX8x = parcelRequire("5RX8x");

var $h9g6U = parcelRequire("h9g6U");

var $iUsXM = parcelRequire("iUsXM");
const $05d9abb62f80e331$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-embed-card"
            }),
            children
        ]
    }) : children;
};
const $05d9abb62f80e331$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($05d9abb62f80e331$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
                })
            });
        case 'resolved':
            const resolvedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio
            });
            if ((0, $eGOwo.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                    const unauthViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                        context: unauthViewProps.context,
                        extensionKey: extensionKey,
                        frameStyle: frameStyle,
                        isProductIntegrationSupported: isProductIntegrationSupported,
                        inheritDimensions: inheritDimensions,
                        isSelected: isSelected,
                        onAuthorize: handleAuthorize,
                        onClick: handleFrameClick,
                        testId: testId,
                        url: unauthViewProps.link
                    });
                }
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $aRZRK.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef
            });
            const forbiddenAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i53U1.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5RX8x.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hFl6W.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("7AKPz", function(module, exports) {

$parcel$export(module.exports, "extractEmbedProps", () => $bddb5ab530f782ff$export$d6cf81ca6e68bcc3);

var $6OR2o = parcelRequire("6OR2o");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $eGOwo = parcelRequire("eGOwo");

var $gA511 = parcelRequire("gA511");

var $9xgNQ = parcelRequire("9xgNQ");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");
const $bddb5ab530f782ff$var$extractEmbedPreview = (jsonLd, platform, iframeUrlType)=>{
    const preview = (0, $6OR2o.extractPreview)(jsonLd, platform, iframeUrlType);
    if (preview && preview.src) return {
        ...preview,
        src: preview.src
    };
};
const $bddb5ab530f782ff$export$d6cf81ca6e68bcc3 = (response, platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response) || '',
        title: (0, $hy9OT.extractSmartLinkTitle)(response),
        context: (0, $9xgNQ.extractSmartLinkContext)(response),
        preview: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkEmbed)(response, iframeUrlType) : $bddb5ab530f782ff$var$extractEmbedPreview(jsonLd, platform, iframeUrlType),
        isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
        isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("9xgNQ", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkContext", () => $81938710ecd918a9$export$6ec4b6b24dec9156);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $4moW4 = parcelRequire("4moW4");

var $gA511 = parcelRequire("gA511");

var $abbo9 = parcelRequire("abbo9");

var $7r0tl = parcelRequire("7r0tl");
function $81938710ecd918a9$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $9Thyx.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $81938710ecd918a9$export$6ec4b6b24dec9156(response) {
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityProvider)(response);
    return $81938710ecd918a9$export$8dcb07487061d3c1(response?.data || (0, $gA511.getEmptyJsonLd)());
}

});


parcelRegister("aRZRK", function(module, exports) {

$parcel$export(module.exports, "extractInlineProps", () => $56b7d71381ad586c$export$68e1703c529dc7e0);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $gA511 = parcelRequire("gA511");

var $k4P1T = parcelRequire("k4P1T");

var $bpSSH = parcelRequire("bpSSH");

var $7BqfG = parcelRequire("7BqfG");

var $gxXx6 = parcelRequire("gxXx6");

var $3DgO9 = parcelRequire("3DgO9");
const $56b7d71381ad586c$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $3DgO9.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $3DgO9.JIRA_GENERATOR_ID)) return (0, $k4P1T.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $k4P1T.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $56b7d71381ad586c$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (provider) return provider.icon;
    // We don't need this for design entities,
    // but we can add it back when we support more entities
    // it requires extractInlineIcon to be moved to the smart link extractor package.
    // see: https://product-fabric.atlassian.net/browse/EDM-12375
    // return extractSmartLinkIcon(response);
    }
    return $56b7d71381ad586c$var$extractInlineIcon(response?.data || (0, $gA511.getEmptyJsonLd)(), showLabel);
};
const $56b7d71381ad586c$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response),
        title: (0, $hy9OT.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: $56b7d71381ad586c$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $bpSSH.extractLozenge)(jsonLd),
        titleTextColor: (0, $7BqfG.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $gxXx6.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("k4P1T", function(module, exports) {

$parcel$export(module.exports, "extractIcon", () => $0a1959a1b48f0e49$export$64bdf1f5e49e8626);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $liS9g = parcelRequire("liS9g");

var $gSqCA = parcelRequire("gSqCA");

var $6wUJL = parcelRequire("6wUJL");

var $es92x = parcelRequire("es92x");

var $cOjgE = parcelRequire("cOjgE");

var $lG2jM = parcelRequire("lG2jM");

var $9Thyx = parcelRequire("9Thyx");
var $8T839 = parcelRequire("8T839");
var $4moW4 = parcelRequire("4moW4");

var $FoFt2 = parcelRequire("FoFt2");

var $l5kRv = parcelRequire("l5kRv");

var $ip2tE = parcelRequire("ip2tE");

var $l8s0O = parcelRequire("l8s0O");

var $1yraT = parcelRequire("1yraT");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");
const $0a1959a1b48f0e49$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $8T839.extractTitle)(jsonLd),
        provider: (0, $9Thyx.extractProvider)(jsonLd),
        fileFormat: (0, $ip2tE.extractFileFormat)(jsonLd),
        taskType: (0, $l5kRv.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        return $0a1959a1b48f0e49$var$extractIconByType(highestPriorityType, opts);
    } else return $0a1959a1b48f0e49$var$extractIconByType(type, opts);
};
function $0a1959a1b48f0e49$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6wUJL.default), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
                label: opts.title || 'project',
                LEGACY_size: "small",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $es92x.default), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $liS9g.default), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gSqCA.default), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $1yraT.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $0a1959a1b48f0e49$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $FoFt2.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $0a1959a1b48f0e49$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $l8s0O.extractIconFromDocument)(type, opts);
        default:
            return $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("liS9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fba6d3a5fd6972fb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57895ef0b52fd8c4c74cfb41dd495e36>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $awZZu = parcelRequire("awZZu");

var $cBTRt = parcelRequire("cBTRt");
/**
 * __16px `branch` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $fba6d3a5fd6972fb$var$Branch16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($awZZu))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cBTRt.default), {
            label: label,
            testId: testId
        })
    });
};
$fba6d3a5fd6972fb$var$Branch16Icon.displayName = 'Branch16Icon';
var $fba6d3a5fd6972fb$export$2e2bcd8739ae039 = $fba6d3a5fd6972fb$var$Branch16Icon;

});
parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("cBTRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3462a9699ad70391$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::371b0d35eca629b3ebb5e933140aedc3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $3462a9699ad70391$var$Branch16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 0 1 8.002 11l-.004 2A3.995 3.995 0 0 0 12 9.007v-.274a2 2 0 1 0-2 0m-4-3a2 2 0 1 0-2 0v4.536a2 2 0 1 0 2 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$3462a9699ad70391$var$Branch16Icon.displayName = 'Branch16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3462a9699ad70391$export$2e2bcd8739ae039 = $3462a9699ad70391$var$Branch16Icon;

});


parcelRegister("gSqCA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $978ab5b169d02f01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e82b283fed135d161349bed7f64fbf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $8lO5P = parcelRequire("8lO5P");

var $j8Au4 = parcelRequire("j8Au4");
/**
 * __16px `code` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $978ab5b169d02f01$var$Code16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j8Au4.default), {
            label: label,
            testId: testId
        })
    });
};
$978ab5b169d02f01$var$Code16Icon.displayName = 'Code16Icon';
var $978ab5b169d02f01$export$2e2bcd8739ae039 = $978ab5b169d02f01$var$Code16Icon;

});
parcelRegister("8lO5P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6147244ca1278d21$var$_react = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6147244ca1278d21$var$_baseNew = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6147244ca1278d21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6147244ca1278d21$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $6147244ca1278d21$var$_react.default.createElement($6147244ca1278d21$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$6147244ca1278d21$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $6147244ca1278d21$var$_default = module.exports.default = $6147244ca1278d21$var$AngleBracketsIcon;

});

parcelRegister("j8Au4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6502744a03af16$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a17b0b5d454f4262ba3195f959601cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $7a6502744a03af16$var$Code16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L4.46 8.006l1.873-1.871A1 1 0 1 0 4.92 4.72m4.792 0a1 1 0 0 0 0 1.415l1.874 1.87-1.873 1.87a1 1 0 1 0 1.414 1.416l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292 1 1 0 0 0-.708.293"/></svg>`,
        ...props,
        size: "small"
    });
$7a6502744a03af16$var$Code16Icon.displayName = 'Code16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a6502744a03af16$export$2e2bcd8739ae039 = $7a6502744a03af16$var$Code16Icon;

});


parcelRegister("6wUJL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c727218f2343b747$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f2c30ba9921a6754c4914a2815ab1ac6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $7XCnf = parcelRequire("7XCnf");

var $1OiKX = parcelRequire("1OiKX");
/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c727218f2343b747$var$Commit16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1OiKX.default), {
            label: label,
            testId: testId
        })
    });
};
$c727218f2343b747$var$Commit16Icon.displayName = 'Commit16Icon';
var $c727218f2343b747$export$2e2bcd8739ae039 = $c727218f2343b747$var$Commit16Icon;

});
parcelRegister("7XCnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06952e599791aaa8e8e82dba5053d210>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cbbcf5690c6b367$var$_react = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5cbbcf5690c6b367$var$_baseNew = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5cbbcf5690c6b367$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cbbcf5690c6b367$var$CommitIcon = (props)=>/*#__PURE__*/ $5cbbcf5690c6b367$var$_react.default.createElement($5cbbcf5690c6b367$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$5cbbcf5690c6b367$var$CommitIcon.displayName = 'CommitIcon';
var $5cbbcf5690c6b367$var$_default = module.exports.default = $5cbbcf5690c6b367$var$CommitIcon;

});

parcelRegister("1OiKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd5ceb37ab40bc73$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::50d5a3bab2c708a6de1c7dc72e3a297a>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $bd5ceb37ab40bc73$var$Commit16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.986 1.834a3.001 3.001 0 0 1 0-5.668A1 1 0 0 1 7 5V3a1 1 0 1 1 2 0v2q0 .085-.014.166a3.001 3.001 0 0 1 0 5.668Q9 10.915 9 11v2a1 1 0 0 1-2 0v-2q0-.085.014-.166"/></svg>`,
        ...props,
        size: "small"
    });
$bd5ceb37ab40bc73$var$Commit16Icon.displayName = 'Commit16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd5ceb37ab40bc73$export$2e2bcd8739ae039 = $bd5ceb37ab40bc73$var$Commit16Icon;

});


parcelRegister("es92x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $44741c921c28f10f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2fa1578bca00f96f8398b8ab3053f83>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $MUJuW = parcelRequire("MUJuW");

var $3xtgM = parcelRequire("3xtgM");
/**
 * __16px `pull-request` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $44741c921c28f10f$var$PullRequest16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3xtgM.default), {
            label: label,
            testId: testId
        })
    });
};
$44741c921c28f10f$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $44741c921c28f10f$export$2e2bcd8739ae039 = $44741c921c28f10f$var$PullRequest16Icon;

});
parcelRegister("MUJuW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a083285ccf5836110a489694f045affe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09307dc51f4f46f2$var$_react = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $09307dc51f4f46f2$var$_baseNew = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $09307dc51f4f46f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09307dc51f4f46f2$var$PullRequestIcon = (props)=>/*#__PURE__*/ $09307dc51f4f46f2$var$_react.default.createElement($09307dc51f4f46f2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$09307dc51f4f46f2$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $09307dc51f4f46f2$var$_default = module.exports.default = $09307dc51f4f46f2$var$PullRequestIcon;

});

parcelRegister("3xtgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $38a04956c9fd4802$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f46cc1f5eba58da93be626b062afbd6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $38a04956c9fd4802$var$PullRequest16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M6.417 6H9a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V7a3 3 0 0 0-3-3H6.415l.294-.295a1 1 0 1 0-1.413-1.414l-2.003 2a1 1 0 0 0 .001 1.415l2.002 2.001a1 1 0 0 0 1.414-.002 1 1 0 0 0-.001-1.413zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`,
        ...props,
        size: "small"
    });
$38a04956c9fd4802$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$38a04956c9fd4802$export$2e2bcd8739ae039 = $38a04956c9fd4802$var$PullRequest16Icon;

});


parcelRegister("cOjgE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $442ecc1a7897d80c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e3cfaee41b098df8ae4032fe4210963>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $bwM92 = parcelRequire("bwM92");

var $dSbyY = parcelRequire("dSbyY");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $442ecc1a7897d80c$var$Task16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dSbyY.default), {
            label: label,
            testId: testId
        })
    });
};
$442ecc1a7897d80c$var$Task16Icon.displayName = 'Task16Icon';
var $442ecc1a7897d80c$export$2e2bcd8739ae039 = $442ecc1a7897d80c$var$Task16Icon;

});
parcelRegister("bwM92", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8648076de2cded56$var$_react = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8648076de2cded56$var$_baseNew = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8648076de2cded56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8648076de2cded56$var$TaskIcon = (props)=>/*#__PURE__*/ $8648076de2cded56$var$_react.default.createElement($8648076de2cded56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$8648076de2cded56$var$TaskIcon.displayName = 'TaskIcon';
var $8648076de2cded56$var$_default = module.exports.default = $8648076de2cded56$var$TaskIcon;

});

parcelRegister("dSbyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7143582d1b645e3c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73d9ff981bcfc769f66de456322c40e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $7143582d1b645e3c$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$7143582d1b645e3c$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7143582d1b645e3c$export$2e2bcd8739ae039 = $7143582d1b645e3c$var$Task16Icon;

});


parcelRegister("lG2jM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4ce7dd41e05f3ded01848e6f06d1f7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc7f518425e4bcf9$var$_react = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc7f518425e4bcf9$var$_peopleGroup = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $fc7f518425e4bcf9$var$_peopleGroup2 = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hh8BY")));
function $fc7f518425e4bcf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc7f518425e4bcf9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $fc7f518425e4bcf9$var$_react.default.createElement($fc7f518425e4bcf9$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $fc7f518425e4bcf9$var$_peopleGroup2.default
    }, props));
$fc7f518425e4bcf9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $fc7f518425e4bcf9$var$_default = module.exports.default = $fc7f518425e4bcf9$var$PeopleGroupIcon;

});
parcelRegister("hh8BY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c93ab4407be6cde9$var$_react = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $c93ab4407be6cde9$var$_peopleGroup = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("hxN6p")));
function $c93ab4407be6cde9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c93ab4407be6cde9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c93ab4407be6cde9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props, {
        newIcon: $c93ab4407be6cde9$var$_peopleGroup.default
    }));
$c93ab4407be6cde9$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c93ab4407be6cde9$var$_default = module.exports.default = $c93ab4407be6cde9$var$PeopleGroupIcon;

});


parcelRegister("ip2tE", function(module, exports) {

$parcel$export(module.exports, "extractFileFormat", () => $733ec07b82674776$export$f2d65f02f6888b60);
const $733ec07b82674776$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("l8s0O", function(module, exports) {

$parcel$export(module.exports, "extractIconFromDocument", () => $f67edadeb7739c7c$export$25c24c7f577936d3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kSre2 = parcelRequire("kSre2");

var $9Thyx = parcelRequire("9Thyx");

var $4Gz8O = parcelRequire("4Gz8O");

var $lQKQC = parcelRequire("lQKQC");

var $iOphm = parcelRequire("iOphm");

var $4VIPx = parcelRequire("4VIPx");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $FoFt2 = parcelRequire("FoFt2");

var $abbo9 = parcelRequire("abbo9");
const $f67edadeb7739c7c$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $f67edadeb7739c7c$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $f67edadeb7739c7c$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f67edadeb7739c7c$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $FoFt2.getIconForFileType)(opts.fileFormat);
};
const $f67edadeb7739c7c$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: opts.showIconLabel ? opts.title || 'blog' : '',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return $f67edadeb7739c7c$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'document' : '',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lQKQC.default), {
                label: opts.showIconLabel ? opts.title || 'presentation' : '',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VIPx.default), {
                label: opts.showIconLabel ? opts.title || 'spreadsheet' : '',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kSre2))), {
                color: "currentColor",
                label: opts.showIconLabel ? opts.title || 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'undefinedLink' : '',
                testId: "document-icon"
            });
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $f67edadeb7739c7c$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $9Thyx.isConfluenceGenerator)(opts.provider.id)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
        label: "live-doc",
        testId: "live-doc-icon"
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iOphm.default), {
        label: opts.showIconLabel ? opts.title || 'file' : '',
        testId: "file-icon"
    });
};

});
parcelRegister("kSre2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c20e147606d139fd2bd9c488f6dfb0c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f32df82c412cc2b2$var$_react = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f32df82c412cc2b2$var$_file = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("jvbqF")));

var $f32df82c412cc2b2$var$_documentFilled = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("ePbAf")));
function $f32df82c412cc2b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f32df82c412cc2b2$var$FileIcon = (props)=>/*#__PURE__*/ $f32df82c412cc2b2$var$_react.default.createElement($f32df82c412cc2b2$var$_file.default, Object.assign({
        LEGACY_fallbackIcon: $f32df82c412cc2b2$var$_documentFilled.default
    }, props));
$f32df82c412cc2b2$var$FileIcon.Name = 'FileIconMigration';
var $f32df82c412cc2b2$var$_default = module.exports.default = $f32df82c412cc2b2$var$FileIcon;

});
parcelRegister("jvbqF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e329c724a11ab833$var$_react = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e329c724a11ab833$var$_baseNew = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e329c724a11ab833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e329c724a11ab833$var$FileIcon = (props)=>/*#__PURE__*/ $e329c724a11ab833$var$_react.default.createElement($e329c724a11ab833$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e329c724a11ab833$var$FileIcon.displayName = 'FileIcon';
var $e329c724a11ab833$var$_default = module.exports.default = $e329c724a11ab833$var$FileIcon;

});

parcelRegister("ePbAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acaed063c693be85$var$_react = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $acaed063c693be85$var$_file = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("jvbqF")));
function $acaed063c693be85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $acaed063c693be85$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $acaed063c693be85$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props, {
        newIcon: $acaed063c693be85$var$_file.default
    }));
$acaed063c693be85$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $acaed063c693be85$var$_default = module.exports.default = $acaed063c693be85$var$DocumentFilledIcon;

});


parcelRegister("lQKQC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $457cf0e778e4e077$export$2e2bcd8739ae039);

var $5cEyJ = parcelRequire("5cEyJ");

var $1TONM = parcelRequire("1TONM");

var $amDP4 = parcelRequire("amDP4");

var $cPcks = parcelRequire("cPcks");
const $457cf0e778e4e077$var$ChartBarIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($amDP4))), 'purpleBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($5cEyJ))), (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))));
$457cf0e778e4e077$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $457cf0e778e4e077$export$2e2bcd8739ae039 = $457cf0e778e4e077$var$ChartBarIconWithColor;

});
parcelRegister("5cEyJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3c9d88f73aaa21a0$var$_react = $3c9d88f73aaa21a0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $3c9d88f73aaa21a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c9d88f73aaa21a0$var$Presentation16Icon = (props)=>/*#__PURE__*/ $3c9d88f73aaa21a0$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$3c9d88f73aaa21a0$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $3c9d88f73aaa21a0$var$_default = module.exports.default = $3c9d88f73aaa21a0$var$Presentation16Icon;

});

parcelRegister("amDP4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f75e2054943fb775b789c9f2b57e27>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78bad9690aef89d2$var$_react = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78bad9690aef89d2$var$_baseNew = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78bad9690aef89d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78bad9690aef89d2$var$ChartBarIcon = (props)=>/*#__PURE__*/ $78bad9690aef89d2$var$_react.default.createElement($78bad9690aef89d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$78bad9690aef89d2$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $78bad9690aef89d2$var$_default = module.exports.default = $78bad9690aef89d2$var$ChartBarIcon;

});


parcelRegister("iOphm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d1a6648d509434f8$export$2e2bcd8739ae039);

var $hLSBq = parcelRequire("hLSBq");

var $btZ6J = parcelRequire("btZ6J");

var $jvbqF = parcelRequire("jvbqF");

var $cPcks = parcelRequire("cPcks");
const $d1a6648d509434f8$var$FileIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($jvbqF))), 'grayBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($hLSBq))), (0, (/*@__PURE__*/$parcel$interopDefault($btZ6J)))));
$d1a6648d509434f8$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $d1a6648d509434f8$export$2e2bcd8739ae039 = $d1a6648d509434f8$var$FileIconWithColor;

});
parcelRegister("hLSBq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cf012e6694ca1348$var$_react = $cf012e6694ca1348$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $cf012e6694ca1348$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cf012e6694ca1348$var$Generic16Icon = (props)=>/*#__PURE__*/ $cf012e6694ca1348$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$cf012e6694ca1348$var$Generic16Icon.displayName = 'Generic16Icon';
var $cf012e6694ca1348$var$_default = module.exports.default = $cf012e6694ca1348$var$Generic16Icon;

});

parcelRegister("btZ6J", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $85c1cdd5f70b300c$var$_react = $85c1cdd5f70b300c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $85c1cdd5f70b300c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85c1cdd5f70b300c$var$Generic24Icon = (props)=>/*#__PURE__*/ $85c1cdd5f70b300c$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$85c1cdd5f70b300c$var$Generic24Icon.displayName = 'Generic24Icon';
var $85c1cdd5f70b300c$var$_default = module.exports.default = $85c1cdd5f70b300c$var$Generic24Icon;

});


parcelRegister("4VIPx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $261b25b77463fadb$export$2e2bcd8739ae039);

var $avN5P = parcelRequire("avN5P");

var $i9oSq = parcelRequire("i9oSq");

var $hJIkn = parcelRequire("hJIkn");

var $cPcks = parcelRequire("cPcks");
const $261b25b77463fadb$var$ListBulletedIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), 'greenBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($avN5P))), (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))));
$261b25b77463fadb$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $261b25b77463fadb$export$2e2bcd8739ae039 = $261b25b77463fadb$var$ListBulletedIconWithColor;

});
parcelRegister("avN5P", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a72e175f7c6772a$var$_react = $7a72e175f7c6772a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $7a72e175f7c6772a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a72e175f7c6772a$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $7a72e175f7c6772a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$7a72e175f7c6772a$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $7a72e175f7c6772a$var$_default = module.exports.default = $7a72e175f7c6772a$var$Spreadsheet16Icon;

});

parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});



parcelRegister("1yraT", function(module, exports) {

$parcel$export(module.exports, "extractIconFromTask", () => $4555066ff891e98a$export$321256ed044e3100);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i3nvV = parcelRequire("i3nvV");

var $59W6U = parcelRequire("59W6U");

var $4VGMo = parcelRequire("4VGMo");

var $h6Xfo = parcelRequire("h6Xfo");

var $8WXuv = parcelRequire("8WXuv");

var $erbJ6 = parcelRequire("erbJ6");

var $iaeCZ = parcelRequire("iaeCZ");

var $dV8me = parcelRequire("dV8me");

var $cOjgE = parcelRequire("cOjgE");

var $3DgO9 = parcelRequire("3DgO9");
const $4555066ff891e98a$var$TaskIcon = (0, $cOjgE.default);
const $4555066ff891e98a$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, $gt9Am.jsx)($4555066ff891e98a$var$TaskIcon, {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $3DgO9.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $3DgO9.JIRA_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $3DgO9.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dV8me.default), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $3DgO9.JIRA_STORY:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iaeCZ.default), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $3DgO9.JIRA_BUG:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3nvV.default), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $3DgO9.JIRA_EPIC:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VGMo.default), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $3DgO9.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h6Xfo.default), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $3DgO9.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8WXuv.default), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $3DgO9.JIRA_CHANGE:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59W6U.default), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $3DgO9.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $erbJ6.default), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $3DgO9.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("i3nvV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7757e0f556678002$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b3eace3db32e909d8e4c2d548565af4>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $9UdpB = parcelRequire("9UdpB");

var $ePICl = parcelRequire("ePICl");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7757e0f556678002$var$Bug16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9UdpB))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ePICl.default), {
            label: label,
            testId: testId
        })
    });
};
$7757e0f556678002$var$Bug16Icon.displayName = 'Bug16Icon';
var $7757e0f556678002$export$2e2bcd8739ae039 = $7757e0f556678002$var$Bug16Icon;

});
parcelRegister("9UdpB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7363bf5e9aa00467$var$_react = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7363bf5e9aa00467$var$_baseNew = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7363bf5e9aa00467$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7363bf5e9aa00467$var$BugIcon = (props)=>/*#__PURE__*/ $7363bf5e9aa00467$var$_react.default.createElement($7363bf5e9aa00467$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$7363bf5e9aa00467$var$BugIcon.displayName = 'BugIcon';
var $7363bf5e9aa00467$var$_default = module.exports.default = $7363bf5e9aa00467$var$BugIcon;

});

parcelRegister("ePICl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c67568ee10eb7c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508e97af907f08dc14fc66e28b081e3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $c67568ee10eb7c6c$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$c67568ee10eb7c6c$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c67568ee10eb7c6c$export$2e2bcd8739ae039 = $c67568ee10eb7c6c$var$Bug16Icon;

});


parcelRegister("59W6U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b85119f148eef897$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::505d8909c8998f8492f66eab6e38980b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $4aDUk = parcelRequire("4aDUk");

var $bqSXM = parcelRequire("bqSXM");
/**
 * __16px `changes` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $b85119f148eef897$var$Changes16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4aDUk))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bqSXM.default), {
            label: label,
            testId: testId
        })
    });
};
$b85119f148eef897$var$Changes16Icon.displayName = 'Changes16Icon';
var $b85119f148eef897$export$2e2bcd8739ae039 = $b85119f148eef897$var$Changes16Icon;

});
parcelRegister("4aDUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30970d602f267700$var$_react = $30970d602f267700$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $30970d602f267700$var$_baseNew = $30970d602f267700$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $30970d602f267700$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30970d602f267700$var$ChangesIcon = (props)=>/*#__PURE__*/ $30970d602f267700$var$_react.default.createElement($30970d602f267700$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$30970d602f267700$var$ChangesIcon.displayName = 'ChangesIcon';
var $30970d602f267700$var$_default = module.exports.default = $30970d602f267700$var$ChangesIcon;

});

parcelRegister("bqSXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5517f3f5f4a6b147$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281636a4b7ecb1d97df53dcc5763d1a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $5517f3f5f4a6b147$var$Changes16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 1 0 4.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L5.456 9h5.134l-.877.876a1 1 0 1 0 1.414 1.415l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292.999.999 0 0 0-.707 1.707zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$5517f3f5f4a6b147$var$Changes16Icon.displayName = 'Changes16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5517f3f5f4a6b147$export$2e2bcd8739ae039 = $5517f3f5f4a6b147$var$Changes16Icon;

});


parcelRegister("4VGMo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $adbcbb4e84b923ab$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ef3c8ed5e57f17047733a8020ce784d5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $gtN4u = parcelRequire("gtN4u");

var $3zPlh = parcelRequire("3zPlh");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $adbcbb4e84b923ab$var$Epic16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtN4u))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3zPlh.default), {
            label: label,
            testId: testId
        })
    });
};
$adbcbb4e84b923ab$var$Epic16Icon.displayName = 'Epic16Icon';
var $adbcbb4e84b923ab$export$2e2bcd8739ae039 = $adbcbb4e84b923ab$var$Epic16Icon;

});
parcelRegister("gtN4u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69c5703d29cce34dd1176fbc8fceb659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bff56b51666b12d4$var$_react = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bff56b51666b12d4$var$_baseNew = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bff56b51666b12d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bff56b51666b12d4$var$EpicIcon = (props)=>/*#__PURE__*/ $bff56b51666b12d4$var$_react.default.createElement($bff56b51666b12d4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$bff56b51666b12d4$var$EpicIcon.displayName = 'EpicIcon';
var $bff56b51666b12d4$var$_default = module.exports.default = $bff56b51666b12d4$var$EpicIcon;

});

parcelRegister("3zPlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e901c858f1e000$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cb559f656356bdb13b54acac6c1eee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $07e901c858f1e000$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$07e901c858f1e000$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07e901c858f1e000$export$2e2bcd8739ae039 = $07e901c858f1e000$var$Epic16Icon;

});


parcelRegister("h6Xfo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $10b82fbbd3c25549$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ede68a79193f0a8a70fa374ba104253c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $ljmsu = parcelRequire("ljmsu");

var $ewxpd = parcelRequire("ewxpd");
/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $10b82fbbd3c25549$var$Incident16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ljmsu))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewxpd.default), {
            label: label,
            testId: testId
        })
    });
};
$10b82fbbd3c25549$var$Incident16Icon.displayName = 'Incident16Icon';
var $10b82fbbd3c25549$export$2e2bcd8739ae039 = $10b82fbbd3c25549$var$Incident16Icon;

});
parcelRegister("ljmsu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f83ccb209af59fed$var$_react = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f83ccb209af59fed$var$_baseNew = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f83ccb209af59fed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f83ccb209af59fed$var$IncidentIcon = (props)=>/*#__PURE__*/ $f83ccb209af59fed$var$_react.default.createElement($f83ccb209af59fed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$f83ccb209af59fed$var$IncidentIcon.displayName = 'IncidentIcon';
var $f83ccb209af59fed$var$_default = module.exports.default = $f83ccb209af59fed$var$IncidentIcon;

});

parcelRegister("ewxpd", function(module, exports) {

$parcel$export(module.exports, "default", () => $629cf392ad3aaa3f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dce0ac1582dc2507da5f80cdb2ca3ec0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $629cf392ad3aaa3f$var$Incident16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499zM4 11a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1zm1.856-4h4.288L8.942 3.632a1 1 0 0 0-1.884 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$629cf392ad3aaa3f$var$Incident16Icon.displayName = 'Incident16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$629cf392ad3aaa3f$export$2e2bcd8739ae039 = $629cf392ad3aaa3f$var$Incident16Icon;

});


parcelRegister("8WXuv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67922ee1ec2953f7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f51ecb48642a229c7b6d1a69d64d867>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $c59mr = parcelRequire("c59mr");

var $28xc1 = parcelRequire("28xc1");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67922ee1ec2953f7$var$Issue16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $28xc1.default), {
            label: label,
            testId: testId
        })
    });
};
$67922ee1ec2953f7$var$Issue16Icon.displayName = 'Issue16Icon';
var $67922ee1ec2953f7$export$2e2bcd8739ae039 = $67922ee1ec2953f7$var$Issue16Icon;

});
parcelRegister("c59mr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16b1a013266ea85d8875a6b5e1d2412a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cbd368cf037dfb6$var$_react = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8cbd368cf037dfb6$var$_baseNew = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8cbd368cf037dfb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cbd368cf037dfb6$var$WorkItemIcon = (props)=>/*#__PURE__*/ $8cbd368cf037dfb6$var$_react.default.createElement($8cbd368cf037dfb6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$8cbd368cf037dfb6$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $8cbd368cf037dfb6$var$_default = module.exports.default = $8cbd368cf037dfb6$var$WorkItemIcon;

});

parcelRegister("28xc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d0d6c17f6a21a0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a9a249fb572b3dfc8cacf8f2a204c85>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $26d0d6c17f6a21a0$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$26d0d6c17f6a21a0$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$26d0d6c17f6a21a0$export$2e2bcd8739ae039 = $26d0d6c17f6a21a0$var$Issue16Icon;

});


parcelRegister("erbJ6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a57d8898cb2acd54$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45711362ad054d9d0de581c03f164950>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $gNXvC = parcelRequire("gNXvC");

var $kFcVs = parcelRequire("kFcVs");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a57d8898cb2acd54$var$Problem16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNXvC))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFcVs.default), {
            label: label,
            testId: testId
        })
    });
};
$a57d8898cb2acd54$var$Problem16Icon.displayName = 'Problem16Icon';
var $a57d8898cb2acd54$export$2e2bcd8739ae039 = $a57d8898cb2acd54$var$Problem16Icon;

});
parcelRegister("gNXvC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ad59de50cbf2d9cd9f6ad629f1ce9da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf622d2894843f$var$_react = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c3bf622d2894843f$var$_baseNew = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c3bf622d2894843f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf622d2894843f$var$ProblemIcon = (props)=>/*#__PURE__*/ $c3bf622d2894843f$var$_react.default.createElement($c3bf622d2894843f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343a8 8 0 1 1 11.314 11.315A8 8 0 0 1 2.343 2.343m.561 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.693-.562a6.5 6.5 0 0 0-8.632-.499l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$c3bf622d2894843f$var$ProblemIcon.displayName = 'ProblemIcon';
var $c3bf622d2894843f$var$_default = module.exports.default = $c3bf622d2894843f$var$ProblemIcon;

});

parcelRegister("kFcVs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a016a8b27712b47b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03a2258325f093d634d77334f2165e7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $a016a8b27712b47b$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$a016a8b27712b47b$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a016a8b27712b47b$export$2e2bcd8739ae039 = $a016a8b27712b47b$var$Problem16Icon;

});


parcelRegister("iaeCZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5d125ca7430036a6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::544b9f71dc9f7001702597ba0216e61f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $hVZow = parcelRequire("hVZow");

var $ayExB = parcelRequire("ayExB");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $5d125ca7430036a6$var$Story16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hVZow))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayExB.default), {
            label: label,
            testId: testId
        })
    });
};
$5d125ca7430036a6$var$Story16Icon.displayName = 'Story16Icon';
var $5d125ca7430036a6$export$2e2bcd8739ae039 = $5d125ca7430036a6$var$Story16Icon;

});
parcelRegister("hVZow", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57b828e09f9287500323fc5bcdd6b33d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0e76235a9209c86$var$_react = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d0e76235a9209c86$var$_baseNew = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d0e76235a9209c86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0e76235a9209c86$var$StoryIcon = (props)=>/*#__PURE__*/ $d0e76235a9209c86$var$_react.default.createElement($d0e76235a9209c86$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$d0e76235a9209c86$var$StoryIcon.displayName = 'StoryIcon';
var $d0e76235a9209c86$var$_default = module.exports.default = $d0e76235a9209c86$var$StoryIcon;

});

parcelRegister("ayExB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03bb463cddb9827$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fd8d8228b7585fa76e9cb13da3baf72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $a03bb463cddb9827$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$a03bb463cddb9827$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a03bb463cddb9827$export$2e2bcd8739ae039 = $a03bb463cddb9827$var$Story16Icon;

});


parcelRegister("dV8me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $462b7112313631bd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a4f42caad88ed71da33903f9c7053102>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $d67Vm = parcelRequire("d67Vm");

var $kqL94 = parcelRequire("kqL94");
/**
 * __16px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $462b7112313631bd$var$Subtask16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d67Vm))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kqL94.default), {
            label: label,
            testId: testId
        })
    });
};
$462b7112313631bd$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $462b7112313631bd$export$2e2bcd8739ae039 = $462b7112313631bd$var$Subtask16Icon;

});
parcelRegister("d67Vm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1eed99abd44e812ae4cb98f136c93f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9891fb7b92d506c5$var$_react = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9891fb7b92d506c5$var$_baseNew = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9891fb7b92d506c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9891fb7b92d506c5$var$SubtasksIcon = (props)=>/*#__PURE__*/ $9891fb7b92d506c5$var$_react.default.createElement($9891fb7b92d506c5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$9891fb7b92d506c5$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $9891fb7b92d506c5$var$_default = module.exports.default = $9891fb7b92d506c5$var$SubtasksIcon;

});

parcelRegister("kqL94", function(module, exports) {

$parcel$export(module.exports, "default", () => $602f9b1db5d82f1d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cad22e1176a9874a0c269f62ca4a13d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $602f9b1db5d82f1d$var$Subtask16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M9 7V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM9 9h2v2H9zM5 5h2v2H5z"/></svg>`,
        ...props,
        size: "small"
    });
$602f9b1db5d82f1d$var$Subtask16Icon.displayName = 'Subtask16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$602f9b1db5d82f1d$export$2e2bcd8739ae039 = $602f9b1db5d82f1d$var$Subtask16Icon;

});




parcelRegister("7BqfG", function(module, exports) {

$parcel$export(module.exports, "extractTitleTextColor", () => $33546c004f5f4832$export$a2afc198e9dada1);


var $aDkpj = parcelRequire("aDkpj");
const $33546c004f5f4832$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $7bb4c1736002a04a$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});

parcelRegister("gxXx6", function(module, exports) {

$parcel$export(module.exports, "extractTitlePrefix", () => $c5f184c1c3b70b36$export$58d9bc37318dfb32);
const $c5f184c1c3b70b36$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $c5f184c1c3b70b36$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $c5f184c1c3b70b36$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("eIvWj", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvedView", () => $f516ef55418d7e1c$export$6d5912cb4b56390e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $3S6ja = parcelRequire("3S6ja");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
class $f516ef55418d7e1c$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
            children: lozenge.text
        });
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            truncateInline: truncateInline,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                    emoji: titlePrefix,
                    icon: icon,
                    title: title,
                    titleTextColor: titleTextColor,
                    type: type
                }),
                this.renderLozenge()
            ]
        });
        if (showHoverPreview && link) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions,
            children: inlineCardResolvedView
        });
        return inlineCardResolvedView;
    }
}

});
parcelRegister("k6uZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e6c0fa079b82f37$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");
const $7e6c0fa079b82f37$var$wrapperStyles = null;
const $7e6c0fa079b82f37$var$InlineLozenge = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
            ...props
        })
    });
var $7e6c0fa079b82f37$export$2e2bcd8739ae039 = $7e6c0fa079b82f37$var$InlineLozenge;

});

parcelRegister("3KRDe", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $5d532ff440b5b275$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $5d532ff440b5b275$export$c73a53738ef9e3f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2HNHt = parcelRequire("2HNHt");

var $av9Of = parcelRequire("av9Of");

var $8IeH1 = parcelRequire("8IeH1");

var $FoFt2 = parcelRequire("FoFt2");

var $3aPI4 = parcelRequire("3aPI4");
const $5d532ff440b5b275$var$iconWrapperStyle = null;
const $5d532ff440b5b275$var$iconImageStyle = null;
const $5d532ff440b5b275$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkogqwt",
    noLinkAppearanceStyle: "_syaz131l _18u01b66",
    roundImageStyle: "_2rko14q2"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/design-system/no-html-anchor -- Ignored via go/DSP-18766
const $5d532ff440b5b275$var$LinkAppearance = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1y58 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $5d532ff440b5b275$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type })=>{
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (emoji) return emoji;
        if (!icon || typeof icon === 'string') return null;
        return icon;
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $FoFt2.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((errored, testId)=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))));
        if (!icon || typeof icon !== 'string') return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $5d532ff440b5b275$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3aPI4.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
                // We cannot set the fix font because inline is taking the parent container font size into account.
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                style: {
                    lineHeight: `1`
                },
                xcss: $5d532ff440b5b275$var$styles.iconOuterWrapperStyle,
                testId: "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $5d532ff440b5b275$var$styles.iconEmptyStyle,
                            testId: "icon-empty-wrapper"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testId": "icon-wrapper",
                            className: (0, $hcewu.default)([
                                "_11c81o8v _2rkoyh40 _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
                            ]),
                            children: renderIcon(testId)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                style: {
                    color: titleTextColor
                },
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)($5d532ff440b5b275$export$c73a53738ef9e3f, {
            style: {
                color: titleColor
            },
            testId: testId,
            children: [
                link ? /*#__PURE__*/ (0, $gt9Am.jsx)($5d532ff440b5b275$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    className: (0, $hcewu.default)([
                        $5d532ff440b5b275$var$styles.linkStyle
                    ]),
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $5d532ff440b5b275$var$styles.noLinkAppearanceStyle,
                    children: rightSide
                }) : null
            ]
        })
    });
};
const $5d532ff440b5b275$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $5d532ff440b5b275$var$styles.iconTitleWrapperStyle,
        ...props
    });
};

});
parcelRegister("3aPI4", function(module, exports) {

$parcel$export(module.exports, "Shimmer", () => $4025455d45ae9834$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $klP06 = parcelRequire("klP06");
const $4025455d45ae9834$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoyh40 _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $4025455d45ae9834$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $klP06.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("klP06", function(module, exports) {

$parcel$export(module.exports, "SpanSkeleton", () => $e1fe181bedc556ac$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $e1fe181bedc556ac$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $e1fe181bedc556ac$var$placeholderShimmer = null;
const $e1fe181bedc556ac$var$appearanceValues = {
    darkGray: {
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $7bb4c1736002a04a$export$c2e91cbeada39b8b)})`
    },
    gray: {
        animation: `var(--ds-skeleton, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
const $e1fe181bedc556ac$var$spanSkeletonStyles = null;
const $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk1cs6",
    blue: "_bfhk1hdx",
    darkGray: "_bfhk1gk7"
};
const $e1fe181bedc556ac$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $e1fe181bedc556ac$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $e1fe181bedc556ac$export$2e2bcd8739ae039 = $e1fe181bedc556ac$export$8f31e4c4a37b8e9c;

});




parcelRegister("hFl6W", function(module, exports) {

$parcel$export(module.exports, "EmbedCardErroredView", () => $35d1688af0eea2fa$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $1NG86 = parcelRequire("1NG86");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");


var $19nmp = parcelRequire("19nmp");

var $05blM = parcelRequire("05blM");
const $35d1688af0eea2fa$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $35d1688af0eea2fa$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $05blM.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
                label: "error-icon"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $35d1688af0eea2fa$var$styles.boxStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).could_not_load_link
                    })
                })
            }),
            (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                testId: "err-view-retry",
                spacing: "compact",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).try_again
                })
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                testId: "err-view-retry",
                appearance: "link",
                spacing: "none",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).try_again
                })
            })
        ]
    });

});
parcelRegister("05blM", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $5e19ca37647e9fa5$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $5e19ca37647e9fa5$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$f862a410248f4f00, {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$7b360cd785b6c366, {
        ...props
    });
const $5e19ca37647e9fa5$var$sharedBaseFrameStyles = null;
const $5e19ca37647e9fa5$var$sharedFrameStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightTrueStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightFalseStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameStyles = null;
const $5e19ca37647e9fa5$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3k6hx _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40" : "_2rko1lya _1h6d3acm _1dqonqa1 _189eyh40",
            "_1reo15vq _18m915vq _1bah1yb4 _16qs1os1",
            className
        ]),
        "data-trello-do-not-use-override": testId,
        children: children
    });
};
const $5e19ca37647e9fa5$var$compactFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsTrueStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsFalseStyles = null;
const $5e19ca37647e9fa5$var$compactFrameAlignStyles = null;
const $5e19ca37647e9fa5$var$compactFrameStyles = null;
const $5e19ca37647e9fa5$var$compactFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3yw9d",
            isSelected && "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40",
            !isSelected && "_2rko1lya",
            "_1bah1h6o _4cvr1h6o _bfhkiw92",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("i53U1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cede8882a7ef616$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $eGOwo = parcelRequire("eGOwo");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $hVxRW = parcelRequire("hVxRW");
const $1cede8882a7ef616$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: hostname
            })
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $eJOHy.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        const ButtonComponent = (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? (0, $5CSKW.default) : (0, $goZPP.default);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ButtonComponent, {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $idDkX.toMessage)((0, $19nmp.messages).try_another_account, callToActionMessageKey),
                values: values
            })
        });
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hVxRW.ForbiddenSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $1cede8882a7ef616$export$2e2bcd8739ae039 = $1cede8882a7ef616$var$ForbiddenView;

});
parcelRegister("l22Ft", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0a8b05351117ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $av9Of = parcelRequire("av9Of");

var $2l8bu = parcelRequire("2l8bu");

var $gegRH = parcelRequire("gegRH");
const $fe0a8b05351117ab$var$containerStyles = null;
const $fe0a8b05351117ab$var$contentStyles = null;
const $fe0a8b05351117ab$var$descriptionStyles = null;
const $fe0a8b05351117ab$var$imageStyles = null;
const $fe0a8b05351117ab$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $eJOHy.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $eJOHy.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": imageTestId,
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ]),
            children: imageUrlOrElement
        });
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-unresolved-container`,
            className: (0, $hcewu.default)([
                "_1e0c11p5 _4t3i1kw7"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
                ]),
                children: [
                    image,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "large",
                        testId: `${testId}-unresolved-title`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        "data-testid": `${testId}-unresolved-description`,
                        className: (0, $hcewu.default)([
                            "_11c82smr _y3gn1h6o"
                        ]),
                        children: description
                    }),
                    button
                ]
            })
        })
    });
};
var $fe0a8b05351117ab$export$2e2bcd8739ae039 = $fe0a8b05351117ab$var$UnresolvedView;

});
parcelRegister("2l8bu", function(module, exports) {

$parcel$export(module.exports, "ExpandedFrame", () => $5f28b71e696600f5$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $k71qx = parcelRequire("k71qx");

var $e3qu2 = parcelRequire("e3qu2");

var $dDP8i = parcelRequire("dDP8i");

var $65oSX = parcelRequire("65oSX");
const $5f28b71e696600f5$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $dDP8i.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    // Note: cleanup fg based on results of prompt_whiteboard_competitor_link experiment
    const CompetitorPromptComponent = CompetitorPrompt && href && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $5f28b71e696600f5$var$styles.leftSection
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.headerIcon
                            ]),
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.tooltipWrapper
                            ]),
                            children: !isPlaceholder && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                                content: text,
                                hideTooltipOnMouseDown: true,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                                    href: href,
                                    onClick: handleClick,
                                    onMouseDown: handleMouseDown,
                                    className: (0, $hcewu.default)([
                                        $5f28b71e696600f5$var$styles.headerAnchor
                                    ]),
                                    children: text
                                })
                            })
                        })
                    ]
                }),
                CompetitorPromptComponent
            ]
        });
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.contentStyle,
                setOverflow && allowScrollBar && $5f28b71e696600f5$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $5f28b71e696600f5$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $5f28b71e696600f5$var$styles.linkWrapper,
            inheritDimensions && $5f28b71e696600f5$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $5f28b71e696600f5$var$styles.linkWrapperSelected,
            showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperInteractiveNotHidden,
            (0, $65oSX.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $5f28b71e696600f5$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mjb7nn _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk18uv _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u92p9",
    linkWrapperBorderAndBackground: "_1tqzzgxb _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgvzgxb _4tpuhp5a _x148kb7n",
    header: "_11c8140y _zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3igktf _1pbykb7n",
    leftSection: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c8140y _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik18uv _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c8140y _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19it1pvm _2rko1y44 _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1ips",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};

});
parcelRegister("65oSX", function(module, exports) {

$parcel$export(module.exports, "className", () => $11f8274f575811f3$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $11f8274f575811f3$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "Image", () => $11f8274f575811f3$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $11f8274f575811f3$export$2913c0c0b5623090 = 'media-card-frame';
const $11f8274f575811f3$export$8f5a73ba0d077b01 = 32;
const $11f8274f575811f3$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $11f8274f575811f3$export$3e431a229df88919 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $awdRS.default)($11f8274f575811f3$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $11f8274f575811f3$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $awdRS.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gegRH", function(module, exports) {

$parcel$export(module.exports, "ImageIcon", () => $28cc40acfaa5a547$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");

var $2HNHt = parcelRequire("2HNHt");

var $65oSX = parcelRequire("65oSX");
const $28cc40acfaa5a547$var$styles = {
    roundedImage: "_2rko14q2"
};
const $28cc40acfaa5a547$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square' })=>{
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    const LoadedImageComponent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65oSX.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            appearance === 'round' && $28cc40acfaa5a547$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("hVxRW", function(module, exports) {

$parcel$export(module.exports, "ForbiddenSVG", () => $d57be4b9de9beae3$export$f51768a4e7ff128);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $d57be4b9de9beae3$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "49.4199",
                x2: "122.662",
                y1: "59.7673",
                y2: "59.7673",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "0",
                        stopColor: "#0065ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".2188",
                        stopColor: "#0b6cff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".5999",
                        stopColor: "#2780ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "1",
                        stopColor: "#4c9aff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
                fill: "#ff7452"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
                fill: "#344563"
            })
        ]
    });

});


parcelRegister("5RX8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc831c55b9e606a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $KprKQ = parcelRequire("KprKQ");
const $9fc831c55b9e606a$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $KprKQ.NotFoundSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $9fc831c55b9e606a$export$2e2bcd8739ae039 = $9fc831c55b9e606a$var$NotFoundView;

});
parcelRegister("KprKQ", function(module, exports) {

$parcel$export(module.exports, "NotFoundSVG", () => $8c23d6ed0b92caba$export$80542c1714a314c8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $8c23d6ed0b92caba$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "1316.98",
                        y1: "230.66",
                        x2: "1396.36",
                        y2: "230.66",
                        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6c798f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "170.3",
                        y1: "897.49",
                        x2: "365.15",
                        y2: "897.49",
                        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("title", {
                children: "Search error"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    id: "Objects",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cfd4db",
                            d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_",
                            "data-name": "<Path>",
                            fill: "url(#linear-gradient)",
                            d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#091e42",
                            opacity: 0.1,
                            d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#344563",
                            d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Clipping_Path_",
                            "data-name": "<Clipping Path>",
                            fill: "#deebff",
                            d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_2",
                            "data-name": "<Path>",
                            fill: "#b2d4ff",
                            d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cce0ff",
                            d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "url(#linear-gradient-2)",
                            d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("polygon", {
                            id: "_Path_3",
                            "data-name": "<Path>",
                            fill: "#5e6c84",
                            points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#344563",
                            d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("h9g6U", function(module, exports) {

$parcel$export(module.exports, "EmbedCardResolvedView", () => $367ff287c16eda7a$export$30f3c6c32b384a8b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $av9Of = parcelRequire("av9Of");

var $58yRG = parcelRequire("58yRG");

var $FoFt2 = parcelRequire("FoFt2");

var $2l8bu = parcelRequire("2l8bu");

var $e3qHE = parcelRequire("e3qHE");

var $gegRH = parcelRequire("gegRH");
const $367ff287c16eda7a$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: src,
            default: linkGlyph,
            appearance: (0, $FoFt2.isProfileType)(type) ? 'round' : 'square'
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type
    ]);
    const themeState = (0, $58yRG.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $FoFt2.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e3qHE.Frame), {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            title: text
        })
    });
});

});
parcelRegister("e3qHE", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $32febd87e387ddae$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $FoFt2 = parcelRequire("FoFt2");

var $hprWR = parcelRequire("hprWR");

var $RCgNH = parcelRequire("RCgNH");
function $32febd87e387ddae$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $32febd87e387ddae$var$iframeStyles = null;
const $32febd87e387ddae$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title }, iframeRef)=>{
    (0, $gRw8I.di)((0, $hprWR.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $eJOHy.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $eJOHy.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $eJOHy.useState)(true);
    const ref = (0, $eJOHy.useRef)();
    const mergedRef = $32febd87e387ddae$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $eJOHy.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $eJOHy.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $RCgNH.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: isMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hprWR.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $FoFt2.getIframeSandboxAttribute)(isTrusted),
                title: title,
                className: (0, $hcewu.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rko1l7b _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});

});
parcelRegister("hprWR", function(module, exports) {

$parcel$export(module.exports, "IFrame", () => $0dab6c672ddaa5a8$export$b32b5f1ee4493319);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $0dab6c672ddaa5a8$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, ...props })=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};

});

parcelRegister("RCgNH", function(module, exports) {

$parcel$export(module.exports, "IframeDwellTracker", () => $069958df693c5c51$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $069958df693c5c51$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $069958df693c5c51$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $eJOHy.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $eJOHy.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $eJOHy.useEffect)(()=>{
        if (dwell.time > 0 && $069958df693c5c51$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $eJOHy.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});



parcelRegister("iUsXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5z6NJ = parcelRequire("5z6NJ");

var $l22Ft = parcelRequire("l22Ft");

var $5x724 = parcelRequire("5x724");
const $9a8ffe7d7e8e9c62$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>{
        const ButtonComponent = (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? (0, $5CSKW.default) : (0, $goZPP.default);
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, $gt9Am.jsx)(ButtonComponent, {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_unauthorised_account_action,
                        values: values
                    })
                })
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name_no_provider
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description_no_provider
            })
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5x724.UnauthorizedSVG), {}),
        testId: testId,
        text: context?.text
    });
};
var $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039 = $9a8ffe7d7e8e9c62$var$UnauthorizedView;

});
parcelRegister("5x724", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedSVG", () => $f913a8b5e191dd5f$export$6526edaac83a8c90);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $f913a8b5e191dd5f$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_1375_267)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "563.88",
                        height: "265.81",
                        transform: "translate(0.870117 0.509766)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
                        stroke: "url(#paint0_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
                        fill: "#403294"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
                        fill: "url(#paint1_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
                        fill: "url(#paint2_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
                        stroke: "url(#paint3_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.38",
                        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
                        fill: "url(#paint4_radial_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
                        fill: "url(#paint5_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
                        fill: "url(#paint6_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
                        fill: "url(#paint7_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
                        fill: "url(#paint8_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
                        fill: "url(#paint9_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
                        fill: "url(#paint10_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
                        fill: "url(#paint11_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
                        fill: "url(#paint12_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
                        fill: "#172B4D"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
                        fill: "url(#paint13_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
                        fill: "url(#paint14_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
                        fill: "url(#paint15_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
                        fill: "url(#paint16_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
                        fill: "#6554C0"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
                        fill: "url(#paint17_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
                        fill: "#5243AA"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
                        fill: "url(#paint18_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
                        fill: "#B3BAC5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_1375_267",
                        x1: "141.994",
                        y1: "181.192",
                        x2: "0.870117",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C1C7D0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_1375_267",
                        x1: "208.292",
                        y1: "264.428",
                        x2: "0.870117",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_1375_267",
                        x1: "357.327",
                        y1: "264.428",
                        x2: "564.748",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_1375_267",
                        x1: "423.624",
                        y1: "181.192",
                        x2: "564.748",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1724",
                                stopColor: "#076AFF",
                                stopOpacity: "0.8007"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4145",
                                stopColor: "#1976FF",
                                stopOpacity: "0.5208"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6966",
                                stopColor: "#378BFF",
                                stopOpacity: "0.1947"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8651",
                                stopColor: "#4C9AFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "paint4_radial_1375_267",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(285 99.0229) scale(96.5182)",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1584",
                                stopColor: "#FFE587",
                                stopOpacity: "0.8416"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3589",
                                stopColor: "#FFDA57",
                                stopOpacity: "0.6411"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5498",
                                stopColor: "#FFD031",
                                stopOpacity: "0.4502"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7256",
                                stopColor: "#FFC916",
                                stopOpacity: "0.2744"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8811",
                                stopColor: "#FFC506",
                                stopOpacity: "0.1189"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_1375_267",
                        x1: "346.074",
                        y1: "98.8386",
                        x2: "423.624",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_1375_267",
                        x1: "237.087",
                        y1: "120.044",
                        x2: "276.412",
                        y2: "120.044",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_1375_267",
                        x1: "237.087",
                        y1: "75.0106",
                        x2: "276.412",
                        y2: "75.0106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_1375_267",
                        x1: "335.969",
                        y1: "146.593",
                        x2: "335.969",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B2D4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_1375_267",
                        x1: "219.544",
                        y1: "98.8386",
                        x2: "141.994",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_1375_267",
                        x1: "229.65",
                        y1: "146.593",
                        x2: "229.65",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F4F5F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_1375_267",
                        x1: "402.858",
                        y1: "216.64",
                        x2: "421.684",
                        y2: "223.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8134",
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8713",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_1375_267",
                        x1: "376.968",
                        y1: "157.139",
                        x2: "433.936",
                        y2: "157.139",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_1375_267",
                        x1: "289.638",
                        y1: "45.0027",
                        x2: "289.638",
                        y2: "0.510323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_1375_267",
                        x1: "262.238",
                        y1: "36.2259",
                        x2: "272.592",
                        y2: "36.2259",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_1375_267",
                        x1: "259.6",
                        y1: "180.859",
                        x2: "259.6",
                        y2: "141.017",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_1375_267",
                        x1: "284.971",
                        y1: "171.613",
                        x2: "284.971",
                        y2: "149.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_1375_267",
                        x1: "157.982",
                        y1: "221.995",
                        x2: "188.627",
                        y2: "221.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3435",
                                stopColor: "#6554C0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#998DD9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_1375_267",
                        x1: "163.185",
                        y1: "155.517",
                        x2: "213.758",
                        y2: "155.517",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#5243AA"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8777D9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_1375_267",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "563.88",
                            height: "265.81",
                            fill: "white",
                            transform: "translate(0.870117 0.509766)"
                        })
                    })
                ]
            })
        ]
    });

});



parcelRegister("6J1DL", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $71d51cdd37301ec2$export$aff6291803939b05);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $gA511 = parcelRequire("gA511");

var $kj3Kk = parcelRequire("kj3Kk");

var $3sgI9 = parcelRequire("3sgI9");

var $6kw7n = parcelRequire("6kw7n");

var $eIvWj = parcelRequire("eIvWj");

var $4dnWW = parcelRequire("4dnWW");

var $kFkj1 = parcelRequire("kFkj1");
const $71d51cdd37301ec2$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-inline-card"
            }),
            children
        ]
    }) : children;
};
const $71d51cdd37301ec2$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $5NtHI.SmartLinkStatus).Resolved ? (0, $aRZRK.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($71d51cdd37301ec2$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4dnWW.InlineCardResolvingView), {
                    url: url,
                    isSelected: isSelected,
                    onClick: handleFrameClick,
                    testId: testIdWithStatus,
                    inlinePreloaderStyle: inlinePreloaderStyle,
                    resolvingPlaceholder: resolvingPlaceholder,
                    truncateInline: truncateInline
                })
            });
        case 'resolved':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                truncateInline: truncateInline
            });
        case 'unauthorized':
            const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFkj1.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $hy9OT.extractSmartLinkProvider)(details);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6kw7n.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3sgI9.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline
            });
    }
};

});
parcelRegister("3sgI9", function(module, exports) {

$parcel$export(module.exports, "InlineCardErroredView", () => $f78d8ca0def2e8b6$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1NG86 = parcelRequire("1NG86");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $f78d8ca0def2e8b6$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_size: "small",
        testId: "errored-view-default-icon"
    });
};
const $f78d8ca0def2e8b6$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleRetry,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).try_again
            })
        });
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon || $f78d8ca0def2e8b6$var$fallbackIcon(),
                link: hashAction ? url : undefined,
                title: url,
                onClick: hashAction ? onClick : undefined,
                rightSide: message
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("4Rp6r", function(module, exports) {

$parcel$export(module.exports, "ActionButton", () => $36fa193905cb5ef0$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $46R8N = parcelRequire("46R8N");
const $36fa193905cb5ef0$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    disabled: "_syaz1lh4 _80om13gf _bfhksyzs"
};
const $36fa193905cb5ef0$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $36fa193905cb5ef0$var$styles.button,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            tabIndex: isDisabled ? undefined : 0,
            className: (0, $hcewu.default)([
                $36fa193905cb5ef0$var$styles.innerContainer,
                isDisabled ? $36fa193905cb5ef0$var$styles.disabled : $36fa193905cb5ef0$var$styles.enabled
            ]),
            children: children
        })
    });
});

});


parcelRegister("6kw7n", function(module, exports) {

$parcel$export(module.exports, "InlineCardForbiddenView", () => $5783739fd5be2c19$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");


var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $5783739fd5be2c19$var$styles = {
    actionButtonLozengeStyle: "_2rkogqwt _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $5783739fd5be2c19$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small",
        testId: "forbidden-view-fallback-icon"
    });
};
const $5783739fd5be2c19$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).invalid_permissions,
            children: (formattedMessage)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: formattedMessage
                })
        });
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account",
                children: renderForbiddenAccessMessage()
            });
        }
        if (onAuthorise) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            xcss: $5783739fd5be2c19$var$styles.actionButtonLozengeStyle,
            onClick: handleRetry,
            style: {
                font: `inherit`
            },
            testId: "button-connect-other-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
                appearance: "moved",
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: renderForbiddenAccessMessage()
            })
        });
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $5783739fd5be2c19$var$fallbackForbiddenIcon(),
                link: url,
                title: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("kKPzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1c01b17c1604b90$var$_react = $f1c01b17c1604b90$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $f1c01b17c1604b90$var$_lockLocked = $f1c01b17c1604b90$var$_interopRequireDefault((parcelRequire("9QgTI")));
function $f1c01b17c1604b90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1c01b17c1604b90$var$LockFilledIcon = (props)=>/*#__PURE__*/ $f1c01b17c1604b90$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $f1c01b17c1604b90$var$_lockLocked.default
    }));
$f1c01b17c1604b90$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $f1c01b17c1604b90$var$_default = module.exports.default = $f1c01b17c1604b90$var$LockFilledIcon;

});


parcelRegister("4dnWW", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvingView", () => $7b3077a1d4f02d91$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");

var $8a4B6 = parcelRequire("8a4B6");
const $7b3077a1d4f02d91$var$styles = {
    spinnerWrapper: "_11c81o8v _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $7b3077a1d4f02d91$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            xcss: $7b3077a1d4f02d91$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: 14
            })
        }), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3KRDe.IconTitleWrapper), {
            children: [
                url,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8a4B6.RightIconPositionWrapper), {
                    children: renderSpinner()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
            icon: renderSpinner(),
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor
        })
    });
};

});
parcelRegister("8a4B6", function(module, exports) {

$parcel$export(module.exports, "RightIconPositionWrapper", () => $9116d903068768cf$export$91b164375b8037b5);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9116d903068768cf$export$91b164375b8037b5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kFkj1", function(module, exports) {

$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $38c365e1bf03afe8$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $38c365e1bf03afe8$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small"
    });
};
const $38c365e1bf03afe8$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        });
    }, [
        handleConnectAccount,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $38c365e1bf03afe8$var$fallbackUnauthorizedIcon(),
                title: url,
                link: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        id: id,
        children: inlineCardUnauthenticatedView
    });
    return inlineCardUnauthenticatedView;
};

});



parcelRegister("k9P6L", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $9acebe3c2480723a$export$1ca0544321134ad6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kj3Kk = parcelRequire("kj3Kk");

const $9acebe3c2480723a$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6ed49f57481afa45$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
const $6ed49f57481afa45$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';



parcelRegister("7Bn2k", function(module, exports) {

$parcel$export(module.exports, "RemoveButton", () => $0d8083ad70c45c39$export$4e9d5ce1e6c22a94);

var $eJOHy = parcelRequire("eJOHy");

var $6zhpo = parcelRequire("6zhpo");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $bWlv0 = parcelRequire("bWlv0");
const $0d8083ad70c45c39$export$4e9d5ce1e6c22a94 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        e.stopPropagation();
        onClick();
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $bWlv0.default).removeTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
            ...tooltipProps,
            "aria-label": formatMessage((0, $bWlv0.default).removeTooltip),
            onClick: handleClick,
            padding: "space.0",
            xcss: $0d8083ad70c45c39$var$pressableStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            color: "var(--ds-icon, #44546F)",
            spacing: "compact",
            label: "",
            size: "small"
        })));
};
const $0d8083ad70c45c39$var$pressableStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'border.radius',
    display: 'flex',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});

});
parcelRegister("bWlv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $90667d3202671c6f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $90667d3202671c6f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    removeTooltip: {
        "id": "issue-smart-links-popup-edit-view.smart-link-options-trigger.remove-button.remove-all-tooltip",
        "defaultMessage": "Remove"
    }
});

});



parcelRegister("dLVMI", function(module, exports) {

$parcel$export(module.exports, "goalsPopupContentEntryPoint", () => $7628b25b096ee0c0$export$dc38dd29dc6b8559);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7628b25b096ee0c0$export$dc38dd29dc6b8559 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jj4Qu")), {
        moduleId: "e7e5e5c1",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jj4Qu", function(module, exports) {

let $e0e38ceba9f6033c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e0e38ceba9f6033c$var$load("bihbw").then(()=>parcelRequire('aH7r4'));

});


parcelRegister("w8hPK", function(module, exports) {

$parcel$export(module.exports, "default", () => $33c1064efeb698b8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $33c1064efeb698b8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-goals-readview-full.goals.show-more-tooltip",
        "defaultMessage": "See more selected goals"
    }
});

});




parcelRegister("1OSuW", function(module, exports) {

$parcel$export(module.exports, "IssueKeyCell", () => $9cd5113694971561$export$a6c835c7dffd9abf);

var $cWdRP = parcelRequire("cWdRP");

var $5jE0z = parcelRequire("5jE0z");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $jd93d = parcelRequire("jd93d");

var $7keuM = parcelRequire("7keuM");

var $lRq8t = parcelRequire("lRq8t");

var $jCEKQ = parcelRequire("jCEKQ");

var $6XJko = parcelRequire("6XJko");

var $9Mapt = parcelRequire("9Mapt");

var $7jTnu = parcelRequire("7jTnu");

var $jiTA8 = parcelRequire("jiTA8");

var $3OT15 = parcelRequire("3OT15");

var $34oCh = parcelRequire("34oCh");

var $86BUM = parcelRequire("86BUM");

var $88mo0 = parcelRequire("88mo0");

var $84lUd = parcelRequire("84lUd");
const $9cd5113694971561$export$a6c835c7dffd9abf = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isTruncated: isTruncated, issueRef: issueRef, onIssueLinkSelected: onIssueLinkSelected })=>{
    const intl = (0, $lRq8t.default)();
    const issueKeyData = (0, $j4oe4.useFragment)((0, $5jE0z.default), fieldRef);
    const { text: issueKey } = issueKeyData;
    const fieldsByIdFragment = (0, $j4oe4.useFragment)((0, $cWdRP.default), issueRef || null);
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const tableCellLinkRef = (0, $eJOHy.useRef)(null);
    let isMergedColumnVisible = false;
    if ((0, $7jTnu.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(issueKeyData.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: issueKey
    });
    const isEmbedMode = (0, $7jTnu.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jiTA8.useIsEmbedMode)() : false;
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && issueKey && onIssueLinkSelected(issueKey);
        if (handled) e.preventDefault();
    }, [
        isEmbedMode,
        issueKey,
        onIssueLinkSelected
    ]);
    const issueKeyWithHoverPopover = (0, $eJOHy.useCallback)(({ key: key, link: link })=>{
        if ((0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) return link(hoverPopoverRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: key,
            contentRef: tableCellLinkRef
        }, ({ ref: ref })=>link(ref));
    }, [
        hoverPopoverRef,
        tableCellLinkRef
    ]);
    if (!issueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueKey",
        reason: "Missing required fields"
    });
    const issueStrikeThroughProps = {};
    const statusField = (0, $7jTnu.fg)('jiv-20953-query-by-status-field-directly') ? fieldsByIdFragment?.statusField?.status : fieldsByIdFragment?.fieldsById?.edges?.find((edge)=>edge?.node?.fieldId === 'status')?.node?.status;
    const statusCategoryId = statusField?.statusCategory?.statusCategoryId;
    const isResolved = fieldsByIdFragment?.isResolved ?? undefined;
    const isIssueResolved = (0, $jCEKQ.shouldDisplayStrikethrough)(isResolved, (0, $7keuM.statusCategoryForId)(statusCategoryId));
    issueStrikeThroughProps.shouldDisplayStrikethrough = isIssueResolved;
    issueStrikeThroughProps['aria-label'] = intl.formatMessage((0, $84lUd.default).issueKeyWithResolution, {
        issueKey: issueKey,
        isResolved: isIssueResolved
    });
    const getWrapperStyles = ()=>{
        if (isDensityFull) return (0, $6XJko.isVisualRefreshEnabled)() ? $9cd5113694971561$var$wrapperStylesFull : $9cd5113694971561$var$wrapperStylesFullOld;
        return (0, $6XJko.isVisualRefreshEnabled)() ? $9cd5113694971561$var$wrapperStylesCompact : $9cd5113694971561$var$wrapperStylesCompactOld;
    };
    if (isInlineEditingExtendedFieldSupportEnabled) {
        const issueKeyLink = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88mo0.TableCellLink), {
                ...issueStrikeThroughProps,
                href: `/browse/${issueKey}`,
                isTruncated: !isDensityFull || isSingleLineRowHeightEnabled,
                onClick: onClick,
                ref: (0, $jd93d.mergeRefs)(tableCellLinkRef, ref),
                testId: "native-issue-table.common.ui.issue-cells.issue-key.issue-key-cell"
            }, issueKey);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            paddingBlock: "space.050",
            paddingInline: isMergedColumnVisible ? 'space.050' : 'space.100',
            "data-vc": "native-issue-table-ui-issue-key-cell",
            xcss: [
                isMergedColumnVisible && isTruncated && $9cd5113694971561$var$overflowHiddenStyles
            ]
        }, isSingleLineRowHeightEnabled ? issueKeyWithHoverPopover({
            key: issueKey,
            link: issueKeyLink
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: issueKey
        }, issueKeyLink()));
    }
    const issueKeyLink = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88mo0.TableCellDiscreteLink), {
            href: `/browse/${issueKey}`,
            "data-testid": "native-issue-table.common.ui.issue-cells.issue-key.issue-key-cell",
            ...issueStrikeThroughProps,
            isSubtle: true,
            ref: (0, $jd93d.mergeRefs)(tableCellLinkRef, ref),
            onClick: onClick
        }, issueKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        paddingInline: isMergedColumnVisible ? 'space.050' : 'space.100',
        xcss: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            getWrapperStyles(),
            isSingleLineRowHeightEnabled && $9cd5113694971561$var$singleLineRowHeightStyles,
            isMergedColumnVisible && !isTruncated && $9cd5113694971561$var$overflowVisibleStyles
        ],
        "data-vc": "native-issue-table-ui-issue-key-cell"
    }, isSingleLineRowHeightEnabled ? issueKeyWithHoverPopover({
        key: issueKey,
        link: issueKeyLink
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: issueKey
    }, issueKeyLink()));
});
const $9cd5113694971561$var$singleLineRowHeightStyles = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis'
});
const $9cd5113694971561$var$wrapperStylesCompactOld = (0, $1DXK0.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $9cd5113694971561$var$wrapperStylesCompact = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $9cd5113694971561$var$wrapperStylesFullOld = (0, $1DXK0.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%'
});
const $9cd5113694971561$var$wrapperStylesFull = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%'
});
const $9cd5113694971561$var$overflowVisibleStyles = (0, $1DXK0.xcss)({
    overflow: 'visible'
});
const $9cd5113694971561$var$overflowHiddenStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});

});
parcelRegister("cWdRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $690a775bde3d7be4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<89a3681fce28bf93201023b2e03933ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $690a775bde3d7be4$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "concreteType": "JiraStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraStatusCategory",
                    "kind": "LinkedField",
                    "name": "statusCategory",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCategoryId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isResolved"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraStatusField",
                        "kind": "LinkedField",
                        "name": "statusField",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                    "status"
                                ]
                            }
                        ],
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsById",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v0 /*: any*/ ,
                                                "type": "JiraStatusField"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "fieldsById(ids:[\"status\"])"
                    }
                ]
            }
        ],
        "type": "JiraIssue"
    };
}();
$690a775bde3d7be4$var$node.hash = "7f6c5f7e3145fad95a220ddab9110efe";
var $690a775bde3d7be4$export$2e2bcd8739ae039 = $690a775bde3d7be4$var$node;

});

parcelRegister("5jE0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $723f9ad0ccdcb916$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d9e343d0cf3471606fccebe056d81ab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $723f9ad0ccdcb916$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldRef",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$723f9ad0ccdcb916$var$node.hash = "ff06de891b6af9d42c8c03e50786c395";
var $723f9ad0ccdcb916$export$2e2bcd8739ae039 = $723f9ad0ccdcb916$var$node;

});

parcelRegister("jCEKQ", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayStrikethrough", () => $71a3d2c694c5502c$export$1e1e848245d3a6f7);

var $7keuM = parcelRequire("7keuM");
const { DONE: $71a3d2c694c5502c$var$DONE } = (0, $7keuM);
const $71a3d2c694c5502c$export$1e1e848245d3a6f7 = (isResolved, statusCategory)=>{
    if (isResolved !== undefined) return isResolved;
    // In JSW, the strikethrough must now only depend on resolution. However we have to keep
    // this logic because there is a consumer of issue-line-card in JSM that displays
    // the strikethrough based on status src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx
    return statusCategory === $71a3d2c694c5502c$var$DONE;
};

});

parcelRegister("88mo0", function(module, exports) {

$parcel$export(module.exports, "TableCellDiscreteLink", () => $89c9752ede73cfdb$export$4e03936e0e9409e2);
$parcel$export(module.exports, "TableCellLink", () => $89c9752ede73cfdb$export$fce640eb3bd348ea);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $f2JN3 = parcelRequire("f2JN3");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $c9uTK = parcelRequire("c9uTK");

var $7jTnu = parcelRequire("7jTnu");

var $jiTA8 = parcelRequire("jiTA8");

var $34oCh = parcelRequire("34oCh");
const $89c9752ede73cfdb$export$4e03936e0e9409e2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((e)=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'tableIssueLink');
        onClick && onClick(e);
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const isEmbedMode = (0, $7jTnu.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jiTA8.useIsEmbedMode)() : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89c9752ede73cfdb$var$StyledLink, {
        ...rest,
        onClick: onClickWithAnalytics,
        ref: ref,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    });
});
const $89c9752ede73cfdb$export$fce640eb3bd348ea = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ 'aria-label': ariaLabel, children: children, href: href, isTruncated: isTruncated, onClick: onClick, shouldDisplayStrikethrough: shouldDisplayStrikethrough, testId: testId }, ref)=>{
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
        onClick && onClick(e);
    }, [
        onClick
    ]);
    const isEmbedMode = (0, $7jTnu.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jiTA8.useIsEmbedMode)() : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        "aria-label": ariaLabel,
        href: href,
        onClick: onClickWithAnalytics,
        ref: ref,
        testId: testId,
        xcss: [
            $89c9752ede73cfdb$var$linkDefaultStyles,
            isTruncated && $89c9752ede73cfdb$var$linkTruncatedStyles,
            shouldDisplayStrikethrough && $89c9752ede73cfdb$var$linkStrikethroughStyles
        ],
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
});
// Fix for Compiled bug where invalid props are passed on to the underlying DOM element when using inheritance.
const $89c9752ede73cfdb$var$PropFilteredLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ innerFocusOutline: innerFocusOutline, shouldDisplayStrikethrough: shouldDisplayStrikethrough, isSubtle: isSubtle, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ...rest,
        ref: ref
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89c9752ede73cfdb$var$StyledLinkOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $89c9752ede73cfdb$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1nmz1hna",
            __cmplp.innerFocusOutline && "_1ah31i6y",
            __cmplp.shouldDisplayStrikethrough && "_4bfu18uv _1hms1911 _ajmmnqa1",
            __cmplp.isSingleLineRowHeightEnabled && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $89c9752ede73cfdb$var$StyledLinkNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $89c9752ede73cfdb$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1nmz1hna",
            __cmplp.isSubtle ? "_syaz1gjq" : "_syaz1fxt",
            __cmplp.innerFocusOutline && "_1ah31i6y",
            __cmplp.shouldDisplayStrikethrough && "_4bfu18uv _1hms1911 _ajmmnqa1",
            __cmplp.isSingleLineRowHeightEnabled && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $89c9752ede73cfdb$var$linkDefaultStyles = (0, $1DXK0.xcss)({
    cursor: 'pointer',
    display: 'block',
    font: 'font.body',
    overflow: 'hidden',
    textDecoration: 'underline',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});
const $89c9752ede73cfdb$var$linkTruncatedStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap'
});
const $89c9752ede73cfdb$var$linkStrikethroughStyles = (0, $1DXK0.xcss)({
    textDecoration: 'line-through',
    ':hover': {
        textDecoration: 'line-through'
    }
});
const $89c9752ede73cfdb$var$StyledLink = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $89c9752ede73cfdb$var$StyledLinkNew, $89c9752ede73cfdb$var$StyledLinkOld);

});

parcelRegister("84lUd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f69130195f8c718$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5f69130195f8c718$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issueKeyWithResolution: {
        "id": "native-issue-table.common.issue-cells.issue-key.issue-key-with-resolution",
        "defaultMessage": "{issueKey} is {isResolved, select, \n            true {resolved}\n            false {not resolved}\n            other {}\n        }"
    }
});

});


parcelRegister("eVFZZ", function(module, exports) {

$parcel$export(module.exports, "IssueLinksCell", () => $a71b27fa3aad833e$export$75aa2ccc20dd7954);

var $ETE9W = parcelRequire("ETE9W");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $1NG86 = parcelRequire("1NG86");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $7ep4S = parcelRequire("7ep4S");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $l1Evt = parcelRequire("l1Evt");

var $8lb7o = parcelRequire("8lb7o");

var $1tX0c = parcelRequire("1tX0c");

var $kEUB1 = parcelRequire("kEUB1");

var $8jOO7 = parcelRequire("8jOO7");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $5O293 = parcelRequire("5O293");

var $kwfkD = parcelRequire("kwfkD");
const $a71b27fa3aad833e$export$f48224de87d33a65 = (initialIsOpen)=>(0, $eJOHy.useState)(initialIsOpen);
const $a71b27fa3aad833e$export$75aa2ccc20dd7954 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, issueKey: issueKey, accordionInitialIsOpen: accordionInitialIsOpen = false, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const [isOpen, setIsOpen] = $a71b27fa3aad833e$export$f48224de87d33a65(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $ETE9W.default), fieldRef);
    const cloudId = (0, $kEUB1.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        issueKey,
        cloudId
    ]);
    const issueLinks = data?.issueLinkConnection?.edges;
    const totalCount = data?.issueLinkConnection?.totalCount;
    const filteredIssueLinks = (0, $eJOHy.useMemo)(()=>issueLinks?.map((edge)=>edge?.node?.issue?.key != null ? {
                key: edge.node.issue?.key || 'missingId',
                name: edge.node.issue?.key,
                href: edge.node.issue?.webUrl || '',
                relationName: edge.node.relationName,
                shouldDisplayStrikethrough: edge.node.issue?.fieldsById?.edges?.[0]?.node?.statusCategory?.statusCategoryId === '3' || false
            } : null).filter(Boolean) ?? [], [
        issueLinks
    ]);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const runtimeProps = (0, $eJOHy.useMemo)(()=>({
                issueKey: issueKey,
                issueSearchBaseUrl: issueSearchBaseUrl,
                accordionInitialIsOpen: accordionInitialIsOpen
            }), [
            issueKey,
            issueSearchBaseUrl,
            accordionInitialIsOpen
        ]);
        if (!issueLinks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
            cellType: "issueLinks",
            reason: "Missing issue links field"
        });
        if (issueLinks.length !== filteredIssueLinks.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
            cellType: "issueLinks",
            reason: "Missing fields on issue links"
        });
        if (totalCount === undefined || totalCount === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
            cellType: "issueLinks",
            reason: "Missing total count"
        });
        if (totalCount < 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
            cellType: "issueLinks",
            reason: "Invalid total count"
        });
        if (totalCount > 0 && filteredIssueLinks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
            cellType: "issueLinks",
            reason: "Total count valid but no issue links given"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lb7o.ItemWithEntryPointPopup), {
            entryPoint: (0, $5O293.issueLinksPopUpContentEntryPoint),
            entryPointParams: entryPointParams,
            entryPointRuntimeProps: runtimeProps,
            totalItems: Math.min(totalCount, 1000),
            ItemComponent: totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tX0c.TagItem), {
                name: filteredIssueLinks[0].name,
                href: filteredIssueLinks[0].href,
                shouldDisplayStrikethrough: filteredIssueLinks[0].shouldDisplayStrikethrough,
                key: filteredIssueLinks[0].key,
                isHoverPopoverEnabled: isSingleLineRowHeightEnabled,
                isOnlyOneItem: totalCount === 1
            }) : undefined,
            showMoreTooltip: formatMessage((0, $kwfkD.default).triggerButton),
            actionSubjectIdPrefix: "issueLinks",
            isTruncated: isSingleLineRowHeightEnabled
        }));
    }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $5O293.issueLinksPopUpContentEntryPoint), entryPointParams);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [retryKey, setRetryKey] = (0, $eJOHy.useState)(0);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    if (!issueLinks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Missing issue links field"
    });
    if (issueLinks.length !== filteredIssueLinks.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Missing fields on issue links"
    });
    if (totalCount === undefined || totalCount === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Missing total count"
    });
    if (totalCount < 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Invalid total count"
    });
    if (totalCount > 0 && filteredIssueLinks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Total count valid but no issue links given"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l1Evt.default), {
        totalItems: Math.min(totalCount, 1000),
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        triggerRefCallback: triggerRef,
        ItemComponent: totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tX0c.TagItem), {
            name: filteredIssueLinks[0].name,
            href: filteredIssueLinks[0].href,
            shouldDisplayStrikethrough: filteredIssueLinks[0].shouldDisplayStrikethrough,
            key: filteredIssueLinks[0].key,
            isHoverPopoverEnabled: isSingleLineRowHeightEnabled
        }) : undefined,
        showMoreTooltip: formatMessage((0, $kwfkD.default).triggerButton),
        PopupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            key: retryKey,
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "issue-links-popup-content",
            packageName: (0, $8jOO7.PACKAGE_NAME),
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a71b27fa3aad833e$export$7981ca72a47ca202, {
                    onClick: ()=>setRetryKey((prev)=>prev + 1)
                }),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                padding: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            })),
            runtimeProps: {
                issueKey: issueKey,
                issueSearchBaseUrl: issueSearchBaseUrl,
                accordionInitialIsOpen: accordionInitialIsOpen
            }
        }),
        actionSubjectIdPrefix: "issueLinks",
        isTruncated: isSingleLineRowHeightEnabled
    }));
});
const $a71b27fa3aad833e$export$7981ca72a47ca202 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "strong"
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kwfkD.default).errorMessageIssueTermRefresh : (0, $kwfkD.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClick,
        appearance: "link",
        spacing: "compact",
        testId: "native-issue-table.common.ui.issue-cells.issue-links.button"
    }, formatMessage((0, $kwfkD.default).retryMessage)));
};

});
parcelRegister("ETE9W", function(module, exports) {

$parcel$export(module.exports, "default", () => $52652c725f1bc51f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9cb685025347abb0a5b07424eaaf6a04>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $52652c725f1bc51f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueLinks_nativeIssueTable_IssueLinksCell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "JiraIssueLinkConnection",
            "kind": "LinkedField",
            "name": "issueLinkConnection",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                {
                    "concreteType": "JiraIssueLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueLink",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "ids",
                                                    "value": [
                                                        "statusCategory"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusCategoryField"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "relationName"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "issueLinkConnection(first:1)"
        }
    ],
    "type": "JiraIssueLinkField"
};
$52652c725f1bc51f$var$node.hash = "1e9888fcf84cc8f53dcabd49810063d2";
var $52652c725f1bc51f$export$2e2bcd8739ae039 = $52652c725f1bc51f$var$node;

});

parcelRegister("5O293", function(module, exports) {

$parcel$export(module.exports, "issueLinksPopUpContentEntryPoint", () => $e0267059e9a46e26$export$94cbcdadb553c314);

var $2dBMj = parcelRequire("2dBMj");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $e0267059e9a46e26$export$94cbcdadb553c314 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jNPu4")), {
        moduleId: "95d98593",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueKey: issueKey, cloudId: cloudId })=>({
            queries: {
                links: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $2dBMj.default,
                    variables: {
                        issueKey: issueKey,
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("2dBMj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c2eb7383de16064$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1958999ab18d9f57257e6116583fd83>>
 * @relayHash 5c17b8fbf5a1e69531b46c6e762bc127
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46a6916f10ae38e187e874e829f804706892021354f2ba5bad26efc50947a5ee
const $3c2eb7383de16064$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "46a6916f10ae38e187e874e829f804706892021354f2ba5bad26efc50947a5ee",
        "metadata": {},
        "name": "ui_IssueLinksPopUpContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $3c2eb7383de16064$export$2e2bcd8739ae039 = $3c2eb7383de16064$var$node;

});

parcelRegister("jNPu4", function(module, exports) {

let $e6aa8796ba595e58$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e6aa8796ba595e58$var$load("5clF5").then(()=>parcelRequire('aQvQl'));

});


parcelRegister("kwfkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6704bed28e4bf44$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a6704bed28e4bf44$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.issue-links.trigger-button",
        "defaultMessage": "See more"
    },
    showMoreLink: {
        "id": "native-issue-table.common.issue-cells.issue-links.show-more-link",
        "defaultMessage": "Go to all linked issues"
    },
    showMoreLinkIssueTermRefresh: {
        "id": "native-issue-table.common.issue-cells.issue-links.show-more-link-issue-term-refresh",
        "defaultMessage": "Go to all linked work items"
    },
    retryMessage: {
        "id": "native-issue-table.common.issue-cells.issue-links.retry-message",
        "defaultMessage": "Click to retry"
    },
    errorMessage: {
        "id": "native-issue-table.common.issue-cells.issue-links.error-message",
        "defaultMessage": "Failed to load issue links"
    },
    errorMessageIssueTermRefresh: {
        "id": "native-issue-table.common.issue-cells.issue-links.error-message-issue-term-refresh",
        "defaultMessage": "Failed to load linked work items"
    }
});

});


parcelRegister("dBL3m", function(module, exports) {

$parcel$export(module.exports, "IssueOperations", () => $a53c21bf66ddff69$export$125bc3f55de1b4bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3NFLp = parcelRequire("3NFLp");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");
const $a53c21bf66ddff69$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-cell-issue-operations",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $a53c21bf66ddff69$export$125bc3f55de1b4bd = /*#__PURE__*/ (0, $eJOHy.memo)(({ issueKey: issueKey, issueId: issueId, workType: workType, onIssueRefetch: onIssueRefetch, onIssueDelete: onIssueDelete, isCreateSubTaskAllowed: isCreateSubTaskAllowed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a53c21bf66ddff69$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a53c21bf66ddff69$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3NFLp.default), {
        issueId: issueId,
        issueKey: issueKey,
        workType: workType,
        isCreateSubTaskAllowed: isCreateSubTaskAllowed,
        onIssueRefetch: onIssueRefetch,
        onIssueDelete: onIssueDelete
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a53c21bf66ddff69$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1y44 _bfhk1w7a _1bsb1ns9 _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3NFLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b7c54fef03c1259$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");

var $aMdh8 = parcelRequire("aMdh8");

var $7jTnu = parcelRequire("7jTnu");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $am4Zv = parcelRequire("am4Zv");

var $lJU2B = parcelRequire("lJU2B");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9b7c54fef03c1259$var$MeatballMenu = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("jtLUq")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/issue-operations/meatball-menu/src/ui/index.tsx"
});
const $9b7c54fef03c1259$var$Fallback = ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, ...props })=>{
            const iconColor = isSelected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                    label: "",
                    LEGACY_size: "medium",
                    color: iconColor,
                    LEGACY_primaryColor: iconColor,
                    spacing: "spacious"
                }),
                ref: triggerRef,
                isSelected: isSelected
            });
        },
        placement: "bottom-end",
        shouldRenderToParent: (0, $7jTnu.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $am4Zv.ErrorState), {
        onRetry: onRetry
    }));
const $9b7c54fef03c1259$var$AsyncMeatballMenu = (props)=>{
    const [resetCaughtError, setResetCaughtError] = (0, $eJOHy.useState)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorIssueOperations",
        id: "async-meatball-menu",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b7c54fef03c1259$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error)
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            id: `async-meatball-menu-button-fallback-${props.issueId}`,
            "aria-label": formatMessage((0, $lJU2B.default).disabledMenuButtonLabel, {
                issueKey: props.issueKey
            }),
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                label: "",
                LEGACY_size: "medium",
                color: "currentColor",
                spacing: "spacious"
            }),
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b7c54fef03c1259$var$MeatballMenu, props)));
};
var $9b7c54fef03c1259$export$2e2bcd8739ae039 = $9b7c54fef03c1259$var$AsyncMeatballMenu;

});
parcelRegister("am4Zv", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $ab7c8c7f7d593717$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $goZPP = parcelRequire("goZPP");

var $1NG86 = parcelRequire("1NG86");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");

var $hbIEt = parcelRequire("hbIEt");

var $1vQks = parcelRequire("1vQks");
const $ab7c8c7f7d593717$export$c1ed4f415b9e7023 = ({ onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ab7c8c7f7d593717$var$DropdownItemsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ab7c8c7f7d593717$var$StyledBox, {
        height: (0, $dPMMf.gridSize) * 9,
        iconSize: (0, $dPMMf.gridSize) * 9
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        spacing: "spacious",
        testId: "issue-navigator-issue-operations.common.ui.error-state.error-icon",
        color: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1vQks.StyledText), null, formatMessage((0, $hbIEt.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onRetry,
        appearance: "link"
    }, formatMessage((0, $hbIEt.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab7c8c7f7d593717$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1tket9kd _1ul9p3fh _p12fp3fh _c71leo28 _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $ab7c8c7f7d593717$var$StyledBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i2nrh _1bah1h6o",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hbIEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb51cbc6690af4f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $beb51cbc6690af4f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.retry-message",
        "defaultMessage": "Click to retry"
    }
});

});

parcelRegister("1vQks", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $cb87d90349dd7fec$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb87d90349dd7fec$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $cb87d90349dd7fec$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cb87d90349dd7fec$var$StyledTextComponent, props));

});


parcelRegister("lJU2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $53abab7dcd5cf0f2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $53abab7dcd5cf0f2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    menuButton: {
        "id": "issue-navigator-issue-operations.menu-button",
        "defaultMessage": "Issue operations menu"
    },
    menuButtonLabel: {
        "id": "issue-navigator-issue-operations.menu-button-label",
        "defaultMessage": "More actions for {issueKey}"
    },
    disabledMenuButtonLabel: {
        "id": "issue-navigator-issue-operations.disabled-menu-button-label",
        "defaultMessage": "Disabled more actions button for {issueKey}"
    },
    menuButtonIssueTerminologyRefreshM4: {
        "id": "issue-navigator-issue-operations.menu-button-issue-terminology-refresh-m4",
        "defaultMessage": "Work item operations menu"
    }
});

});

parcelRegister("jtLUq", function(module, exports) {

let $e2e5e38283a43e23$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e2e5e38283a43e23$var$load("gD3cg").then(()=>parcelRequire('lWS5G'));

});



parcelRegister("icPQx", function(module, exports) {

$parcel$export(module.exports, "IssueStatusCategoryCell", () => $8798890f1b6bccbb$export$663286ccb241374c);

var $gCx03 = parcelRequire("gCx03");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $hRhIm = parcelRequire("hRhIm");

var $9Mapt = parcelRequire("9Mapt");

var $7jTnu = parcelRequire("7jTnu");

var $jd93d = parcelRequire("jd93d");

var $3OT15 = parcelRequire("3OT15");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $8798890f1b6bccbb$export$663286ccb241374c = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $gCx03.default), fieldRef);
    const { statusCategory: statusCategory } = data;
    const { name: name } = statusCategory;
    const statusCategoryId = parseInt(statusCategory.statusCategoryId, 10);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: statusCategory.name
    });
    if (Number.isNaN(statusCategoryId) || statusCategoryId === -1 || !name?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "statusCategory",
        reason: "Missing required fields"
    });
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8798890f1b6bccbb$var$alignmentFixStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: {
            id: '',
            name: name,
            statusCategory: {
                id: statusCategoryId
            }
        }
    }));
    return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8798890f1b6bccbb$var$alignmentFixStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: {
            id: '',
            name: name,
            statusCategory: {
                id: statusCategoryId
            }
        },
        contentRef: hoverPopoverRef
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: statusCategory.name,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8798890f1b6bccbb$var$alignmentFixStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
            value: {
                id: '',
                name: name,
                statusCategory: {
                    id: statusCategoryId
                }
            },
            contentRef: (0, $jd93d.mergeRefs)(contentRef, ref)
        })));
});
// Status lozenges have a 2px invisible border around them to keep them in the same place if they enter an "error" state (where a border colour is added).
// Refer to: src/packages/issue/fields/status/src/common/ui/status-lozenge/main.tsx
const $8798890f1b6bccbb$var$alignmentFixStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.negative.025'
});

});
parcelRegister("gCx03", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc48d89b92611d78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<232b56ebe752f130593d5f21dbd8e977>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc48d89b92611d78$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusCategoryId"
                }
            ]
        }
    ],
    "type": "JiraStatusCategoryField"
};
$bc48d89b92611d78$var$node.hash = "5ac9d58580f304815724e86b4f84e317";
var $bc48d89b92611d78$export$2e2bcd8739ae039 = $bc48d89b92611d78$var$node;

});

parcelRegister("hRhIm", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $7b782d104096cf08$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $7b782d104096cf08$export$9f5070a985b0679b);

var $eJOHy = parcelRequire("eJOHy");

var $6UBwj = parcelRequire("6UBwj");
const $7b782d104096cf08$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        contentRef: props.contentRef
    });
};
const $7b782d104096cf08$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("6UBwj", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $517c92a4e3fff9f6$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $517c92a4e3fff9f6$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $517c92a4e3fff9f6$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $abjs4 = parcelRequire("abjs4");

var $fL0In = parcelRequire("fL0In");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $2zOdI = parcelRequire("2zOdI");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $fWpUz = parcelRequire("fWpUz");

var $jAZ6b = parcelRequire("jAZ6b");
const $517c92a4e3fff9f6$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $517c92a4e3fff9f6$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $517c92a4e3fff9f6$var$StatusLozengeNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusContentWrapper, {
        "data-testid": `${$517c92a4e3fff9f6$export$9cbc201c09a37b3f}${statusCategory.id}`,
        ref: ref
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fWpUz.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $517c92a4e3fff9f6$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fWpUz.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $517c92a4e3fff9f6$var$hoverOverlayStyles
    })));
const $517c92a4e3fff9f6$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, contentRef: contentRef, triggerProps: triggerProps = {}, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $517c92a4e3fff9f6$var$pressableStyles,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable,
        ref: contentRef
    }));
};
const $517c92a4e3fff9f6$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jAZ6b.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $517c92a4e3fff9f6$var$CustomChevronDownGlyph,
        label: ""
    })));
const $517c92a4e3fff9f6$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$517c92a4e3fff9f6$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jAZ6b.LozengeOld), null, name)));
const $517c92a4e3fff9f6$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, triggerProps: triggerProps = {}, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? "var(--ds-border-danger, #E2483D)" : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? "var(--ds-border-focused, #388BFF)" : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $517c92a4e3fff9f6$export$f72db4ad1e9b3e6d = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $517c92a4e3fff9f6$var$StatusLozengeNew, $517c92a4e3fff9f6$var$StatusLozengeOld);
const $517c92a4e3fff9f6$export$69ea4907eefa8e7b = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $517c92a4e3fff9f6$var$WrappedStatusLozengeNew, $517c92a4e3fff9f6$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StyledLozenge = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>// eslint-disable-next-line no-nested-ternary
    props.isDisabled ? (0, $2zOdI.disabledColor).text : !(0, $6XJko.isVisualRefreshEnabled)() ? (0, $2zOdI.textColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]] : (0, $2zOdI.textColorOld)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $2zOdI.disabledColor).bg : (0, $2zOdI.bgColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $2zOdI.disabledColor).text : (0, $2zOdI.textHoverColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $2zOdI.disabledColor).bg : (0, $2zOdI.bgHoverColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $cdbP5.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1bgi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StatusContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $517c92a4e3fff9f6$var$pressableStyles = (0, $1DXK0.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: 'border.radius.100',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%',
    marginLeft: 'space.025'
});
const $517c92a4e3fff9f6$var$hoverOverlayStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: 'border.radius.100',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("2zOdI", function(module, exports) {

$parcel$export(module.exports, "statusCategoryToThemeMap", () => $576836415c331af3$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $576836415c331af3$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $576836415c331af3$export$32f78bffcd82ff28);
$parcel$export(module.exports, "textColorOld", () => $576836415c331af3$export$26ac04004fa4ead4);
$parcel$export(module.exports, "bgHoverColor", () => $576836415c331af3$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $576836415c331af3$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $576836415c331af3$export$b70f10fc4a6ba453);
const $576836415c331af3$export$61137dce61763ec3 = 'default';
const $576836415c331af3$export$132676d06d92ad48 = 'success';
const $576836415c331af3$export$5c1f3b72419aa125 = 'inprogress';
const $576836415c331af3$export$d9e35f42afe1e488 = {
    '1': $576836415c331af3$export$61137dce61763ec3,
    '2': $576836415c331af3$export$61137dce61763ec3,
    '3': $576836415c331af3$export$132676d06d92ad48,
    '4': $576836415c331af3$export$5c1f3b72419aa125
};
const $576836415c331af3$export$7dcbec377a25efc6 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-background-neutral, #091E420F)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-background-success, #DCFFF1)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-background-information, #E9F2FF)"
};
const $576836415c331af3$export$32f78bffcd82ff28 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text-subtle, #44546F)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$26ac04004fa4ead4 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$69fdf3ba928b4c77 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-background-neutral-hovered, #091E4224)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-background-success-hovered, #BAF3DB)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-background-information-hovered, #CCE0FF)"
};
const $576836415c331af3$export$99ec0cf2cf1b2082 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$b70f10fc4a6ba453 = {
    bg: "var(--ds-background-neutral, #091E420F)",
    text: "var(--ds-text-disabled, #091E424F)"
};

});

parcelRegister("fWpUz", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $b5ac3d09b389e3b4$export$a31cbe1bf5463979);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $2zOdI = parcelRequire("2zOdI");

const $b5ac3d09b389e3b4$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $2zOdI.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $2zOdI.disabledColor).text,
                backgroundColor: (0, $2zOdI.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("jAZ6b", function(module, exports) {

$parcel$export(module.exports, "LozengeOld", () => $6750667a552dd8b6$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $eJOHy = parcelRequire("eJOHy");
const $6750667a552dd8b6$var$containerStyles = {
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $6750667a552dd8b6$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $6750667a552dd8b6$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $6750667a552dd8b6$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $6750667a552dd8b6$var$contentStyles
    }, children));
$6750667a552dd8b6$export$26089816624d22fc.displayName = 'Lozenge';

});




parcelRegister("3rjQa", function(module, exports) {

$parcel$export(module.exports, "IssueStatusCell", () => $f6f10ee9c0e4f3dc$export$58e0df5bb69dbb83);

var $3lvuu = parcelRequire("3lvuu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6BnaS = parcelRequire("6BnaS");

var $hRhIm = parcelRequire("hRhIm");

var $gCeeo = parcelRequire("gCeeo");

var $ljej9 = parcelRequire("ljej9");

var $9Mapt = parcelRequire("9Mapt");

var $7jTnu = parcelRequire("7jTnu");

var $3OT15 = parcelRequire("3OT15");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $7Gpga = parcelRequire("7Gpga");
const $f6f10ee9c0e4f3dc$export$58e0df5bb69dbb83 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueKey: issueKey, onUpdateCache: onUpdateCache, issueId: issueId })=>{
    const data = (0, $j4oe4.useFragment)((0, $3lvuu.default), fieldRef);
    const { status: status } = data;
    const [value, setValue] = (0, $eJOHy.useState)(status);
    const [isEditing, setIsEditing] = (0, $eJOHy.useState)(false);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const contentRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        setValue(status);
    }, [
        status
    ]);
    const onSubmit = (0, $eJOHy.useCallback)((oldValue, newValue, meta, event)=>{
        // Mirrors the updated event fired from the issue view (with the addition of `isInlineEditing: true`) to
        // be used for core action tracking as defined in https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueStatus updated', {
            oldValId: oldValue.id,
            oldStatusCategoryId: oldValue.statusCategory.id,
            newValId: newValue.id,
            newStatusCategoryId: newValue.statusCategory.id,
            hasScreen: meta.transition.hasScreen,
            isConditional: meta.transition.isConditional,
            isInlineEditing: true
        });
    }, []);
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (value?.statusCategory?.statusCategoryId === undefined || !value?.name?.length || !value?.statusId?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "status",
        reason: "Missing required fields"
    });
    const onSuccess = (newStatus)=>{
        const transformedStatus = (0, $7Gpga.toJiraStatusField)(newStatus);
        setValue(transformedStatus);
        onUpdateCache && onUpdateCache(issueKey, 'status', transformedStatus);
    };
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: (0, $7Gpga.toStatusValue)(value).name
    });
    // If the property does not exist in fragment data then we know it has been conditionally excluded because
    // inline editing is disabled. In future this should follow the same design/deferred loading strategy of
    // other inline editable fields, however this would require a larger effort to decompose the status field.
    const isEditable = data && typeof data.id === 'string';
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f6f10ee9c0e4f3dc$var$alignmentFixStyles,
        "data-vc": "native-issue-table-ui-issue-status-box"
    }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BnaS.AsyncIssueStatusField), {
        issueKey: (0, $ljej9.toIssueKey)(issueKey),
        issueId: issueId && (0, $ljej9.toIssueId)(issueId),
        appearance: "lozenge",
        value: (0, $7Gpga.toStatusValue)(value),
        onSubmit: onSubmit,
        onSuccess: onSuccess
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: (0, $7Gpga.toStatusValue)(value)
    }));
    return hoverPopoverRef && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f6f10ee9c0e4f3dc$var$alignmentFixStyles,
        "data-vc": "native-issue-table-ui-issue-status-box",
        ref: isEditing ? ()=>hoverPopoverRef(null) : hoverPopoverRef
    }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BnaS.AsyncIssueStatusField), {
        issueKey: (0, $ljej9.toIssueKey)(issueKey),
        issueId: issueId && (0, $ljej9.toIssueId)(issueId),
        appearance: "lozenge",
        value: (0, $7Gpga.toStatusValue)(value),
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onEditStart: ()=>setIsEditing(true),
        onEditCancel: ()=>setIsEditing(false),
        ...(0, $7jTnu.fg)('nin-grid-keyboard-navigation') ? {
            shouldCaptureEscape: false
        } : {}
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: (0, $7Gpga.toStatusValue)(value)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: (0, $7Gpga.toStatusValue)(value).name,
        contentRef: contentRef,
        hidePopover: isEditing
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $f6f10ee9c0e4f3dc$var$alignmentFixStyles,
            "data-vc": "native-issue-table-ui-issue-status-box",
            ref: ref
        }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BnaS.AsyncIssueStatusField), {
            issueKey: (0, $ljej9.toIssueKey)(issueKey),
            issueId: issueId && (0, $ljej9.toIssueId)(issueId),
            appearance: "lozenge",
            value: (0, $7Gpga.toStatusValue)(value),
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            statusButtonRef: contentRef,
            onEditStart: ()=>setIsEditing(true),
            onEditCancel: ()=>setIsEditing(false),
            ...(0, $7jTnu.fg)('nin-grid-keyboard-navigation') ? {
                shouldCaptureEscape: false
            } : {}
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
            value: (0, $7Gpga.toStatusValue)(value)
        })));
});
// Status lozenges have a 2px invisible border around them to keep them in the same place if they enter an "error" state (where a border colour is added).
// Refer to: src/packages/issue/fields/status/src/common/ui/status-lozenge/main.tsx
const $f6f10ee9c0e4f3dc$var$alignmentFixStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.negative.025'
});

});
parcelRegister("3lvuu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d841100fd9cc1803$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c0f79ce5044190fc6da94cb6bd50afa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d841100fd9cc1803$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "issueStatus_nativeIssueTable_IssueStatusCell",
    "selections": [
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "concreteType": "JiraStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusId"
                },
                {
                    "concreteType": "JiraStatusCategory",
                    "kind": "LinkedField",
                    "name": "statusCategory",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCategoryId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraStatusField"
};
$d841100fd9cc1803$var$node.hash = "90e3d56baf9c61aa74ebf80af89d841c";
var $d841100fd9cc1803$export$2e2bcd8739ae039 = $d841100fd9cc1803$var$node;

});

parcelRegister("6BnaS", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueStatusField", () => $d4bd70c5964975e8$export$ddd324b06f34200);
$parcel$export(module.exports, "IssueStatusFieldBoundary", () => $d4bd70c5964975e8$export$dba9e9c892560f60);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $hRhIm = parcelRequire("hRhIm");

const $d4bd70c5964975e8$export$6dbb1a485af348f = (0, $bQWwW.lazy)(()=>(parcelRequire("dzJkG")), {
    moduleId: "./src/packages/issue/fields/status/src/ui/main.tsx"
});
const $d4bd70c5964975e8$export$ddd324b06f34200 = (props)=>{
    const { initialValue: initialValue, value: value } = props;
    const errorProps = {
        initialValue: initialValue,
        value: value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-field-status",
        packageName: "jira-issue-field-status",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-status-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4bd70c5964975e8$export$6dbb1a485af348f, props)));
};
const $d4bd70c5964975e8$export$dba9e9c892560f60 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-status-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-status-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("dzJkG", function(module, exports) {

let $9e21b55d2aa2e820$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $9e21b55d2aa2e820$var$load("ltVCh")
        ]);
    }, function() {
        return Promise.all([
            $9e21b55d2aa2e820$var$load("7BIsM")
        ]);
    }),
    $9e21b55d2aa2e820$var$load("76n7a"),
    $9e21b55d2aa2e820$var$load("l253H"),
    $9e21b55d2aa2e820$var$load("ffQaD"),
    $9e21b55d2aa2e820$var$load("kvRbA"),
    $9e21b55d2aa2e820$var$load("kvhnd")
]).then(()=>parcelRequire('d8WYQ'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});



parcelRegister("7Gpga", function(module, exports) {

$parcel$export(module.exports, "toJiraStatusField", () => $0f7719130d68fc56$export$54bbdde829b87b5c);
$parcel$export(module.exports, "toStatusValue", () => $0f7719130d68fc56$export$2950d85c450ec19d);
const $0f7719130d68fc56$export$54bbdde829b87b5c = (statusValue)=>({
        statusId: statusValue.id,
        name: statusValue.name,
        statusCategory: {
            statusCategoryId: `${statusValue.statusCategory.id}`
        }
    });
const $0f7719130d68fc56$export$2950d85c450ec19d = (jiraStatusField)=>({
        id: jiraStatusField.statusId,
        name: jiraStatusField.name ?? '',
        statusCategory: {
            id: parseInt(jiraStatusField.statusCategory?.statusCategoryId ?? '', 10)
        }
    });

});


parcelRegister("cg2Iv", function(module, exports) {

$parcel$export(module.exports, "IssueSummaryCell", () => $5476c2df7ccdf262$export$4da280f2973efc5c);

var $e1KXq = parcelRequire("e1KXq");

var $4jX7W = parcelRequire("4jX7W");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $9t1Xl = parcelRequire("9t1Xl");

var $7jTnu = parcelRequire("7jTnu");

var $9Mapt = parcelRequire("9Mapt");

var $jd93d = parcelRequire("jd93d");

var $ljej9 = parcelRequire("ljej9");

var $jiTA8 = parcelRequire("jiTA8");

var $3OT15 = parcelRequire("3OT15");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $86BUM = parcelRequire("86BUM");

var $88mo0 = parcelRequire("88mo0");

var $4vHFI = parcelRequire("4vHFI");

var $8jOO7 = parcelRequire("8jOO7");

var $fQPwz = parcelRequire("fQPwz");

var $8fpTm = parcelRequire("8fpTm");

var $5TzMU = parcelRequire("5TzMU");
const $5476c2df7ccdf262$export$4da280f2973efc5c = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueRef: issueRef, children: children, isRowHoveredOrSelected: isRowHoveredOrSelected, onIssueLinkSelected: onIssueLinkSelected })=>{
    const isEmbedMode = (0, $7jTnu.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jiTA8.useIsEmbedMode)() : false;
    const data = (0, $j4oe4.useFragment)((0, $4jX7W.default), fieldRef);
    const issueData = (0, $j4oe4.useFragment)((0, $e1KXq.default), issueRef);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const updateIssueSummary = (0, $7jTnu.fg)('jsc_list_reparenting') ? (0, $fQPwz.useUpdateIssueSummary)() : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    const onSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>{
        if (issueData?.__id && (0, $7jTnu.fg)('jsc_list_reparenting')) updateIssueSummary(issueData.__id, value);
    }, [
        issueData?.__id,
        updateIssueSummary
    ]);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isDensityCompact = !(0, $34oCh.useIsDensityFull)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const contentRef = (0, $eJOHy.useRef)(null);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const onLinkClick = (0, $eJOHy.useCallback)((e)=>{
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && onIssueLinkSelected(issueData.key);
        if (handled) e.preventDefault();
    }, [
        isEmbedMode,
        issueData.key,
        onIssueLinkSelected
    ]);
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    let showOpenIssueLink = true;
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    isGridNavigationEnabled && (0, $7jTnu.fg)('jira_list_merged_column_gate') && (0, $7jTnu.fg)('jira_list_merged_column_inline_create_icon_style')) showOpenIssueLink = !!isRowHoveredOrSelected;
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    const renderCustomReadView = (0, $eJOHy.useCallback)((text)=>{
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
            cellType: "summary",
            reason: "Missing required fields"
        });
        let hoverPopoverRef = null;
        if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
            content: text,
            shouldRenderToContent: true
        });
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88mo0.TableCellDiscreteLink), {
            innerFocusOutline: true,
            href: `/browse/${issueData.key}`,
            isSubtle: false,
            onClick: onLinkClick,
            "data-testid": "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
            ...isEmbedMode && {
                target: '_blank',
                rel: 'noopener'
            }
        }, text);
        if (isInlineEditingExtendedFieldSupportEnabled && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            ref: hoverPopoverRef,
            testId: "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
            maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW)
        }, text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: text,
            contentRef: contentRef
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                ref: (0, $jd93d.mergeRefs)(contentRef, ref),
                testId: "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
                maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW)
            }, text)), (0, $7jTnu.fg)('jira_list_merged_column_inline_create_icon_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $5476c2df7ccdf262$var$actionButtonsWrapStyles
        }, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: (0, $ljej9.toIssueKey)(issueData.key),
            onClick: onLinkClick
        }), (0, $7jTnu.fg)('jira_list_merged_column_gate') && children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: (0, $ljej9.toIssueKey)(issueData.key),
            onClick: onLinkClick
        }), (0, $7jTnu.fg)('jira_list_merged_column_gate') && children));
        if (isInlineEditingExtendedFieldSupportEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            testId: "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
            maxLines: isDensityCompact ? 2 : undefined
        }, text), (0, $7jTnu.fg)('jira_list_merged_column_inline_create_icon_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $5476c2df7ccdf262$var$actionButtonsWrapStyles
        }, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: (0, $ljej9.toIssueKey)(issueData.key),
            onClick: onLinkClick
        }), (0, $7jTnu.fg)('jira_list_merged_column_gate') && children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: (0, $ljej9.toIssueKey)(issueData.key),
            onClick: onLinkClick
        }), (0, $7jTnu.fg)('jira_list_merged_column_gate') && children));
        // Span is necessary here to ensure only link text is clickable for multiline summaries, rather than the
        // entire content box.
        return isDensityCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            xcss: $5476c2df7ccdf262$var$textOverflowStyles
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, content);
    }, [
        children,
        isDensityCompact,
        isEmbedMode,
        isInlineEditingExtendedFieldSupportEnabled,
        isSingleLineRowHeightEnabled,
        issueData.key,
        onLinkClick,
        showOpenIssueLink,
        hoverPopoverRefFactory
    ]);
    const node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9t1Xl.SingleLineTextInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        editViewPopupTarget: $5476c2df7ccdf262$var$EditViewPopupTarget,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        isRequired: true,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: renderCustomReadView,
        hideEditButton: isInlineEditingExtendedFieldSupportEnabled,
        onSubmitSucceeded: (0, $7jTnu.fg)('jsc_list_reparenting') ? onSubmitSucceeded : undefined,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
    if (isInlineEditingExtendedFieldSupportEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8fpTm.ActionContainer), null, node);
    return node;
});
const $5476c2df7ccdf262$var$EditViewPopupTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5476c2df7ccdf262$var$customTargetStyles,
        ref: ref
    });
});
// We have an extra flex container around our inline edit component so we can show the open issue link button. We need
// to explicitly center align the edit view popup target to ensure consistent alignment in the table cell.
const $5476c2df7ccdf262$var$customTargetStyles = (0, $1DXK0.xcss)({
    alignSelf: 'center',
    width: '0'
});
const $5476c2df7ccdf262$var$textOverflowStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});
const $5476c2df7ccdf262$var$actionButtonsWrapStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    gap: 'space.050'
});

});
parcelRegister("e1KXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $151f7f119f493ee4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8218f47ddc91c3359aa0c4b7cefdd7c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $151f7f119f493ee4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueSummary_nativeIssueTable_IssueSummaryCell_issueRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$151f7f119f493ee4$var$node.hash = "dcb0d0c1f8d780927dbe796b45e5676f";
var $151f7f119f493ee4$export$2e2bcd8739ae039 = $151f7f119f493ee4$var$node;

});

parcelRegister("4jX7W", function(module, exports) {

$parcel$export(module.exports, "default", () => $c54bd74e5e3f1718$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c4ac5609d74626566ce1666b4ad9a7bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c54bd74e5e3f1718$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "issueSummary_nativeIssueTable_IssueSummaryCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$c54bd74e5e3f1718$var$node.hash = "beddff3ed27f18187b31aea14d38514c";
var $c54bd74e5e3f1718$export$2e2bcd8739ae039 = $c54bd74e5e3f1718$var$node;

});

parcelRegister("9t1Xl", function(module, exports) {

$parcel$export(module.exports, "SingleLineTextInlineEditViewWithIsEditable", () => $05ffceec1b992bab$export$f267c8aeb8112733);
$parcel$export(module.exports, "SingleLineTextInlineEditView", () => $05ffceec1b992bab$export$ad603a514b680587);

var $e7hE4 = parcelRequire("e7hE4");

var $ehWR9 = parcelRequire("ehWR9");

var $dxYuw = parcelRequire("dxYuw");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $77rtG = parcelRequire("77rtG");

var $beyOl = parcelRequire("beyOl");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $gBHYt = parcelRequire("gBHYt");
const $05ffceec1b992bab$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-single-line-text-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $05ffceec1b992bab$export$f267c8aeb8112733 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen, isRequired: isRequired = false, hideEditButton: hideEditButton, maxLength: maxLength, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, renderCustomReadView: renderCustomReadView, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled = false })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $dxYuw.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, type: type, text: text, name: name } = data;
    const [commit] = (0, $j4oe4.useMutation)((0, $ehWR9.default));
    // #endregion
    // #region Common state
    const initialValue = text ?? '';
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    // #endregion
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding ? overriding.overrideIsEditable(isEditable) : isEditable, [
        isEditable,
        overriding
    ]);
    const fieldName = (0, $eJOHy.useMemo)(()=>overriding ? overriding.overrideLabel(name) : name, [
        name,
        overriding
    ]);
    const validator = (0, $gBHYt.useSingleLineTextValidator)(fieldName, isRequired, maxLength);
    /**
   * This will execute the GraphQL mutation.
   */ const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        text: value,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateSingleLineTextField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateSingleLineTextField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            text: value
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        initialValue: initialValue,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'text'
    });
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        handleChange(event.target.value);
    }, [
        handleChange
    ]);
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05ffceec1b992bab$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $beyOl.SingleLineTextReadView), {
            fragmentRef: data,
            renderCustomReadView: renderCustomReadView
        })), [
        data,
        renderCustomReadView
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            value: updatedValue,
            onChange: onChange,
            isInvalid: !!invalidMessage,
            autoFocus: true,
            ariaLabel: fieldName
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "large",
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPoint: (0, $77rtG.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        hideEditButton: hideEditButton,
        invalidMessage: invalidMessage ?? undefined,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled
    });
};
const $05ffceec1b992bab$export$ad603a514b680587 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $e7hE4.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05ffceec1b992bab$export$f267c8aeb8112733, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("e7hE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9aa9957d2c29bd6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5603fda12586c734accd519f63ebd761>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b9aa9957d2c29bd6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleLineTextField"
};
$b9aa9957d2c29bd6$var$node.hash = "834bf98c01966c210bc0a4f6e9f0f4a7";
var $b9aa9957d2c29bd6$export$2e2bcd8739ae039 = $b9aa9957d2c29bd6$var$node;

});

parcelRegister("ehWR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f93877c2a5f40217$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f87bbae0df7928fcb860f8d696c8c51>>
 * @relayHash 029277561796d9f13acaef1dbb085ee8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6baebfa2f37e676d26595f29fc232725ad41353c9fcd04168be34a6b616f152
const $f93877c2a5f40217$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSingleLineTextFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateSingleLineTextField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "text"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a6baebfa2f37e676d26595f29fc232725ad41353c9fcd04168be34a6b616f152",
            "metadata": {},
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$f93877c2a5f40217$var$node.hash = "7910ed923271af0f6fe2fd325e2358de";
var $f93877c2a5f40217$export$2e2bcd8739ae039 = $f93877c2a5f40217$var$node;

});

parcelRegister("dxYuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2331200186e2823b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebc67ee0e5b1d19577ad84dec6dd3022>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2331200186e2823b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView"
        },
        {
            "kind": "ScalarField",
            "name": "text"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$2331200186e2823b$var$node.hash = "fa64e21466cd3e14f917674796ea3359";
var $2331200186e2823b$export$2e2bcd8739ae039 = $2331200186e2823b$var$node;

});

parcelRegister("77rtG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c81c30a47fc76fc$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $1c81c30a47fc76fc$var$SingleLineTextEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("2sEmv"))), {
        moduleId: "c6bbf997",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $1c81c30a47fc76fc$export$2e2bcd8739ae039 = $1c81c30a47fc76fc$var$SingleLineTextEditViewEntryPoint;

});

parcelRegister("beyOl", function(module, exports) {

$parcel$export(module.exports, "SingleLineTextReadView", () => $2f2fb34322581dfc$export$5a145b2225896aea);

var $bqbuJ = parcelRequire("bqbuJ");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $guChT = parcelRequire("guChT");

var $eNS8S = parcelRequire("eNS8S");

var $epTsa = parcelRequire("epTsa");

var $d9T1A = parcelRequire("d9T1A");

var $8UsZ0 = parcelRequire("8UsZ0");

var $7jTnu = parcelRequire("7jTnu");
const $2f2fb34322581dfc$export$5a145b2225896aea = ({ fragmentRef: fragmentRef, renderFieldContentWrapper: FieldContentWrapper, renderCustomReadView: renderCustomReadView })=>{
    const { text: text = null, fieldId: fieldId } = (0, $j4oe4.useFragment)((0, $bqbuJ.default), fragmentRef);
    const getReadView = (0, $eJOHy.useCallback)(()=>{
        if (renderCustomReadView) return renderCustomReadView(text);
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
        const testId = `issue.views.field.single-line-text.read-view.${fieldId}`;
        if ((0, $eNS8S.default)(text, true) && (0, $epTsa.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) {
            if ((0, $7jTnu.fg)('enable_redaction_support_in_jira_issue_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
                name: `redaction-marker-${fieldId}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
                "data-testid": testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8UsZ0.LazySmartLink), {
                appearance: "inline",
                url: text
            })));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
                "data-testid": testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8UsZ0.LazySmartLink), {
                appearance: "inline",
                url: text
            }));
        }
        if ((0, $7jTnu.fg)('enable_redaction_support_in_jira_issue_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
            name: `redaction-marker-${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
            "data-testid": testId
        }, text));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
            "data-testid": testId
        }, text);
    }, [
        renderCustomReadView,
        fieldId,
        text
    ]);
    if (FieldContentWrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldContentWrapper, null, getReadView());
    return getReadView();
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f2fb34322581dfc$var$ReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _vwz4gktf _1nmz1hna _kqswh2mm _1bsb1osq _1eog1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bqbuJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $14eaab89a17af546$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28cc3f1e512619502f58cc6e1fc159db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $14eaab89a17af546$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "text"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$14eaab89a17af546$var$node.hash = "5f51bd1526b02ac7cd91c57eec827a2f";
var $14eaab89a17af546$export$2e2bcd8739ae039 = $14eaab89a17af546$var$node;

});

parcelRegister("eNS8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae6a7d95440d0325$export$2e2bcd8739ae039);
/**
 * The URL standard regex for spec.: RFC 3986
 * https://tools.ietf.org/html/rfc3986#page-51
 */ const $ae6a7d95440d0325$var$URLStandardRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?');
/**
 * Full Domain name limits as per RFC is 256 characters
 * TLD limit as per RFC 1035 is 63 characters. Although, TLDs can contain numbers, since none of the existing popular TLDs are numbers, we are not allowing numbers in TLD.
 * Any characters allowed in protocol and query string. Domain name needs to be alphanumeric with hyphens allowed.
 */ const $ae6a7d95440d0325$var$stricterURLRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?[-a-zA-Z0-9@:.]{2,256}.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)');
const $ae6a7d95440d0325$var$protocolRegex = new RegExp('^(http|https|ftp)://.*|^//[^/]*?');
function $ae6a7d95440d0325$export$bef94a5618bf18bf(string, strict = false) {
    // Have to be string
    if (!string || typeof string !== 'string') return false;
    // Exit early if there is a space, no need to regex that
    if (string.indexOf(' ') >= 0 || string.length === 0) return false;
    // Localhost is bit different, doesn't need a dot but others likely should
    if (string.indexOf('localhost') === -1 && string.indexOf('.') === -1) return false;
    if (strict === true) return $ae6a7d95440d0325$var$stricterURLRegex.test(string) || $ae6a7d95440d0325$var$protocolRegex.test(string);
    return $ae6a7d95440d0325$var$URLStandardRegex.test(string);
}
var $ae6a7d95440d0325$export$2e2bcd8739ae039 = $ae6a7d95440d0325$export$bef94a5618bf18bf;

});

parcelRegister("8UsZ0", function(module, exports) {

$parcel$export(module.exports, "LazySmartLink", () => $8977add9d34e6e7b$export$fe7f8e391b2babff);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $6qmxl = parcelRequire("6qmxl");
const $8977add9d34e6e7b$var$entryPointParams = {};
const $8977add9d34e6e7b$export$fe7f8e391b2babff = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $6qmxl.SmartLinkEntryPoint), $8977add9d34e6e7b$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.issue-field.smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("6qmxl", function(module, exports) {

$parcel$export(module.exports, "SmartLinkEntryPoint", () => $caa0557c78d97e7a$export$29454edb61a1a57e);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $caa0557c78d97e7a$export$29454edb61a1a57e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8S7qX")).then((module)=>module.SmartLink), {
        moduleId: "3da73bc4",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8S7qX", function(module, exports) {

let $675922109f6fe979$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $675922109f6fe979$var$load("91SIJ").then(()=>parcelRequire('bmeQi'));

});




parcelRegister("gBHYt", function(module, exports) {

$parcel$export(module.exports, "useSingleLineTextValidator", () => $d52f5e0d730f9978$export$6955d95abfe9109c);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $g2Uiq = parcelRequire("g2Uiq");
const $d52f5e0d730f9978$export$6955d95abfe9109c = (fieldName, isRequired, maxLength)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const change = (0, $eJOHy.useCallback)((value)=>{
        if (maxLength && maxLength > 0 && value.length > maxLength) return {
            type: 'error',
            message: formatMessage((0, $g2Uiq.default).maxLengthErrorMessage, {
                maxLength: maxLength
            })
        };
        return null;
    }, [
        formatMessage,
        maxLength
    ]);
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && value.trim().length === 0) return {
            type: 'error',
            message: formatMessage((0, $g2Uiq.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        change: change,
        submit: submit
    };
};

});
parcelRegister("g2Uiq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebe796aeade62014$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ebe796aeade62014$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    maxLengthErrorMessage: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.max-length-error-message",
        "defaultMessage": "{maxLength} character limit"
    },
    requiredErrorMessage: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});

});



parcelRegister("fQPwz", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueSummary", () => $67b77c5a2df6a013$export$8664a69d14346ead);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");
const $67b77c5a2df6a013$export$8664a69d14346ead = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((issueRelayId, summary)=>{
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const issueEntry = store.get(issueRelayId);
            if (issueEntry) issueEntry.setValue(summary, 'summary');
        });
    }, [
        environment
    ]);
};

});

parcelRegister("8fpTm", function(module, exports) {

$parcel$export(module.exports, "ActionContainer", () => $9c426a359ad88357$export$37ab3bdebc286ca);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");
const $9c426a359ad88357$export$37ab3bdebc286ca = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "native-issue-table.common.ui.issue-cells.issue-summary.action-container",
        className: (0, $hcewu.default)([
            (0, $7jTnu.fg)('jira_list_merged_column_gate') ? "_1e0c1txw _16jlkb7n _1tke1osq _ic7gglyw _18wjidpf _lt0o1yb4 _17mg1txw _1se1t94y _nouyt94y _ev7t1txw _1aszt94y _12nht94y" : "_1e0c1txw _16jlkb7n _1tke1osq _155eidpf _nouyt94y _12nht94y"
        ])
    }, children);
};
const $9c426a359ad88357$var$containerStyles = null;
/**
 * @deprecated remove when jira_list_merged_column_gate is removed
 */ const $9c426a359ad88357$var$containerStylesOld = null;

});

parcelRegister("5TzMU", function(module, exports) {

$parcel$export(module.exports, "OpenIssueLink", () => $9a4c8f9eda00c36f$export$8f0bae95f8140072);

var $eJOHy = parcelRequire("eJOHy");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $ac080 = parcelRequire("ac080");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $jiTA8 = parcelRequire("jiTA8");

var $7jTnu = parcelRequire("7jTnu");

var $34oCh = parcelRequire("34oCh");

var $dD4QM = parcelRequire("dD4QM");
const $9a4c8f9eda00c36f$export$8f0bae95f8140072 = ({ issueKey: issueKey, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isEmbedMode = (0, $7jTnu.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jiTA8.useIsEmbedMode)() : false;
    const handleClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
        onClick?.(e);
    }, [
        onClick
    ]);
    let style;
    if ((0, $7jTnu.fg)('jira_list_merged_column_gate')) {
        if ((0, $7jTnu.fg)('jira_list_merged_column_inline_create_icon_style')) {
            if (!isGridNavigationEnabled) style = $9a4c8f9eda00c36f$var$openIssueLinkStyle;
        } else style = $9a4c8f9eda00c36f$var$buttonOpacityVariableStyle;
    } else style = $9a4c8f9eda00c36f$var$buttonOpacityVariableStyleOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $dD4QM.default).openTooltip)
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
            ...triggerProps,
            "aria-label": formatMessage((0, $dD4QM.default).openLabel, {
                issueKey: issueKey
            }),
            href: `/browse/${issueKey}`,
            onClick: handleClick,
            xcss: (0, $7jTnu.fg)('jira_list_merged_column_gate') ? $9a4c8f9eda00c36f$var$buttonStyles : $9a4c8f9eda00c36f$var$buttonStylesOld,
            // Cannot provide CSS variable as a compile time value due to various type constraints between
            // primitives + compiled.
            // eslint-disable-next-line jira/react/no-style-attribute,@atlaskit/ui-styling-standard/enforce-style-prop
            style: style,
            ...isEmbedMode && {
                target: '_blank',
                rel: 'noopener'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac080))), {
            label: "",
            ...(0, $7jTnu.fg)('jira_list_merged_column_inline_create_icon_style') && {
                size: 'small'
            }
        })));
};
const $9a4c8f9eda00c36f$var$buttonOpacityVariableStyle = {
    display: 'var(--open-button-display, "none")'
};
const $9a4c8f9eda00c36f$var$openIssueLinkStyle = {
    opacity: 'var(--open-button-opacity, 0)'
};
/**
 * @deprecated remove when jira_list_merged_column_gate is removed
 */ const $9a4c8f9eda00c36f$var$buttonOpacityVariableStyleOld = {
    opacity: 'var(--open-button-opacity, 0)'
};
const $9a4c8f9eda00c36f$var$buttonStyles = (0, $1DXK0.xcss)({
    alignItems: 'center',
    borderRadius: 'border.radius',
    borderStyle: 'none',
    borderColor: 'color.border',
    borderWidth: '0',
    color: 'color.text',
    display: 'inline-flex',
    height: '24px',
    justifyContent: 'center',
    marginLeft: 'auto',
    paddingTop: 'space.050',
    paddingRight: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.050',
    width: '24px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    },
    ':active': {
        color: 'color.text'
    }
});
/**
 * @deprecated remove when jira_list_merged_column_gate is removed
 */ const $9a4c8f9eda00c36f$var$buttonStylesOld = (0, $1DXK0.xcss)({
    alignItems: 'center',
    borderRadius: 'border.radius',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderWidth: 'border.width',
    color: 'color.text',
    display: 'inline-flex',
    height: '24px',
    justifyContent: 'center',
    marginLeft: 'auto',
    paddingTop: 'space.050',
    paddingRight: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.050',
    width: '24px',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    },
    ':active': {
        color: 'color.text'
    }
});

});
parcelRegister("dD4QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0b787aedc47989$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5f0b787aedc47989$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    openTooltip: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-tooltip",
        "defaultMessage": "Select work item"
    },
    openLabel: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-label",
        "defaultMessage": "Select work item {issueKey}"
    }
});

});



parcelRegister("3jrj1", function(module, exports) {

$parcel$export(module.exports, "IssueTypeCell", () => $c43defa5778dfeda$export$75b44b408924c851);

var $6ihpM = parcelRequire("6ihpM");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $8skUg = parcelRequire("8skUg");
const $c43defa5778dfeda$export$75b44b408924c851 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $6ihpM.default), fieldRef);
    const { issueType: issueType } = data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8skUg.IconCell), {
        iconUrlOld: issueType?.avatar?.small,
        nameOld: issueType?.name,
        fragmentRef: data && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? data : null,
        showErrorIconWhenEmpty: true
    });
});

});
parcelRegister("6ihpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc956a07fd6b7206$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8be3e8b3fe1d49f6c614796da8af51a0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc956a07fd6b7206$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "issueType_nativeIssueTable_IssueTypeCell",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "iconCell_nativeIssueTable"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueTypeField"
};
$bc956a07fd6b7206$var$node.hash = "425112dc3a29b577cda1592409e66174";
var $bc956a07fd6b7206$export$2e2bcd8739ae039 = $bc956a07fd6b7206$var$node;

});

parcelRegister("8skUg", function(module, exports) {

$parcel$export(module.exports, "IconCell", () => $6bf6b2b82854a6be$export$5ffd26a2d6f7e2d);

var $cTndB = parcelRequire("cTndB");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $7jTnu = parcelRequire("7jTnu");

var $9Mapt = parcelRequire("9Mapt");

var $3OT15 = parcelRequire("3OT15");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $6bf6b2b82854a6be$export$5ffd26a2d6f7e2d = /*#__PURE__*/ (0, $eJOHy.memo)(({ nameOld: nameOld, iconUrlOld: iconUrlOld, showErrorIconWhenEmpty: showErrorIconWhenEmpty, fragmentRef: fragmentRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $cTndB.default), fragmentRef);
    const iconUrl = iconUrlOld ?? data?.issueType?.avatar?.small;
    const name = nameOld ?? data?.issueType?.name;
    const isSingleLineRowHeightFeatureEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const hoverPopoverRefFactory = isSingleLineRowHeightFeatureEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data?.id) : null;
    let isMergedColumnVisible = false;
    if ((0, $7jTnu.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    const isSingleLineRowHeightEnabled = isSingleLineRowHeightFeatureEnabled && !isMergedColumnVisible;
    if (!name?.length || !iconUrl?.length) return showErrorIconWhenEmpty ? /*#__PURE__*/ $eJOHy.createElement((0, $86BUM.default), {
        cellType: "icon",
        reason: "Missing required fields"
    }) : null; // aka an empty cell
    const imgComponent = (ref = null)=>/*#__PURE__*/ $eJOHy.createElement("img", {
            height: "16",
            width: "16",
            src: iconUrl,
            alt: name,
            "data-vc": "native-issue-table-ui-icon-cell-img" // Assertion can be cleaned up with issue_table_single_line_row_height_event_delegator fg
            ,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            className: (0, $hcewu.default)([
                isSingleLineRowHeightEnabled && "_1e0c1ule"
            ])
        });
    if (isSingleLineRowHeightEnabled) {
        let hoverPopoverRef = null;
        if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) {
            hoverPopoverRef = hoverPopoverRefFactory({
                content: name,
                alwaysShow: true
            });
            return imgComponent(hoverPopoverRef);
        }
        return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: name
        }, ({ ref: ref })=>imgComponent(ref));
    }
    return(// @ts-expect-error Incompatible ref type in tooltip (AK needs "HTMLElement", Compiled provides "HTMLDivElement" somehow these are not compatible in Typescript)
    /*#__PURE__*/ $eJOHy.createElement((0, $k71qx.default), {
        content: name,
        tag: $6bf6b2b82854a6be$var$AlignmentFix
    }, imgComponent()));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6bf6b2b82854a6be$var$AlignmentFix = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6bf6b2b82854a6be$var$imgStyles = null;

});
parcelRegister("cTndB", function(module, exports) {

$parcel$export(module.exports, "default", () => $aabdbad07b440367$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8edaa860b1cc467e7d7cbac2ea0a2723>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aabdbad07b440367$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "iconCell_nativeIssueTable",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueTypeField"
};
$aabdbad07b440367$var$node.hash = "4cec1bb5514ec70b11c157839ebe132b";
var $aabdbad07b440367$export$2e2bcd8739ae039 = $aabdbad07b440367$var$node;

});



parcelRegister("kta9N", function(module, exports) {

$parcel$export(module.exports, "LabelsCell", () => $ac022bd8ece8410b$export$b1db1ca9063ebfb8);

var $hHhL8 = parcelRequire("hHhL8");

var $bcP0u = parcelRequire("bcP0u");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $6djmC = parcelRequire("6djmC");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $i45OY = parcelRequire("i45OY");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $j8Km1 = parcelRequire("j8Km1");

var $epTsa = parcelRequire("epTsa");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $P01So = parcelRequire("P01So");

var $86BUM = parcelRequire("86BUM");

var $4vHFI = parcelRequire("4vHFI");

var $8jOO7 = parcelRequire("8jOO7");

var $1m9se = parcelRequire("1m9se");
/**
 * Expected JQL Output: `${jqlTerm} = ${name}`
 */ const $ac022bd8ece8410b$var$getLinkJql = (jqlTerm, name)=>{
    const jast = (0, $f26C8.default).jast((0, $f26C8.default).query((0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $P01So.escapeBackslashes)(jqlTerm)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand((0, $P01So.escapeBackslashes)(name)))));
    return (0, $1jiqw.print)(jast, {
        operatorCase: 'upper'
    });
};
const $ac022bd8ece8410b$export$b1db1ca9063ebfb8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    /* eslint-disable @atlassian/relay/graphql-naming */ const data = (0, $j4oe4.useFragment)((0, $bcP0u.default), fieldRef);
    /* eslint-enable @atlassian/relay/graphql-naming */ const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isLabelsSystemField = data.fieldId === (0, $j8Km1.KNOWN_COLUMN_TYPES).LABELS;
    const labels = data.selectedLabelsConnection?.edges;
    const filteredLabels = (0, $eJOHy.useMemo)(()=>isLabelsSystemField ? [] : labels?.map((edge)=>edge?.node?.name != null ? {
                key: edge.node.name,
                name: edge.node.name,
                href: `${issueSearchBaseUrl}?jql=${encodeURIComponent($ac022bd8ece8410b$var$getLinkJql(jqlTerm, edge.node.name))}`,
                ...(0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) || (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
                    isColored: true
                } : {},
                ...(0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
                    color: edge.node.color?.colorKey
                } : {}
            } : null).filter((0, $P01So.isNonNullish)) ?? [], [
        isLabelsSystemField,
        labels,
        issueSearchBaseUrl,
        jqlTerm
    ]);
    if (isLabelsSystemField || (0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac022bd8ece8410b$export$194e7ceec6d29085, {
        fieldRef: data,
        issueSearchBaseUrl: issueSearchBaseUrl,
        isTruncated: !isDensityFull,
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled,
        isFirstField: isFirstField,
        hasDuplicates: hasDuplicates
    });
    if (!labels || labels.length !== filteredLabels.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "labels",
        reason: "Missing required fields"
    });
    if (isDensityFull) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: true
    }, filteredLabels.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tX0c.TagItem), {
            key: label.key,
            name: label.name,
            href: label.href,
            ...label.isColored ? {
                isColored: label.isColored
            } : {},
            ...label.color ? {
                color: label.color
            } : {}
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: filteredLabels,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $1m9se.default).triggerButton)
    });
});
const $ac022bd8ece8410b$export$194e7ceec6d29085 = ({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, isTruncated: isTruncated, menuPortalTarget: menuPortalTarget, isHoverPopoverEnabled: isHoverPopoverEnabled, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $hHhL8.default), fieldRef);
    const isLabelsSystemField = data.fieldId === (0, $j8Km1.KNOWN_COLUMN_TYPES).LABELS;
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = isLabelsSystemField || isInlineEditingExtendedFieldSupportEnabled;
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isHoverPopoverEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i45OY.LabelsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupTarget: isFirstField ? $ac022bd8ece8410b$var$CustomTarget : undefined,
        fragmentRef: data,
        isTruncated: isTruncated,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        menuPortalTarget: menuPortalTarget,
        readViewFitContainerHeight: true,
        isHoverPopoverEnabled: isFirstField && isHoverPopoverEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i45OY.LabelsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isTruncated: isTruncated,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        menuPortalTarget: menuPortalTarget,
        readViewFitContainerHeight: true,
        isHoverPopoverEnabled: isHoverPopoverEnabled
    });
};
const $ac022bd8ece8410b$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ac022bd8ece8410b$var$customTargetStyles,
        ref: ref
    });
});
const $ac022bd8ece8410b$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("hHhL8", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c635394393d1ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<62e3116c435d80a798da8c375c0bf69d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $02c635394393d1ce$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "labels_nativeIssueTable_LabelsInlineEditCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraLabelsField"
};
$02c635394393d1ce$var$node.hash = "f76e2dc26627b6d7258218de93f192ad";
var $02c635394393d1ce$export$2e2bcd8739ae039 = $02c635394393d1ce$var$node;

});

parcelRegister("bcP0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0154cacb985e6051$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eabd1381bf9dc7070d8895b2b24c07b8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0154cacb985e6051$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "labels_nativeIssueTable_LabelsCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraLabelConnection",
            "kind": "LinkedField",
            "name": "selectedLabelsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraLabelEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraLabel",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "concreteType": "JiraColor",
                                    "kind": "LinkedField",
                                    "name": "color",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorKey"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedLabelsConnection(first:1000)"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "labels_nativeIssueTable_LabelsInlineEditCell_fieldRef"
        }
    ],
    "type": "JiraLabelsField"
};
$0154cacb985e6051$var$node.hash = "9c4b4338163e3e48c60b555fdffe675c";
var $0154cacb985e6051$export$2e2bcd8739ae039 = $0154cacb985e6051$var$node;

});

parcelRegister("i45OY", function(module, exports) {

$parcel$export(module.exports, "LabelsInlineEditViewWithIsEditable", () => $08b033632138b934$export$f00c136eadca5f4b);
$parcel$export(module.exports, "LabelsInlineEditView", () => $08b033632138b934$export$f066b3edf0d7cd25);

var $jmtvE = parcelRequire("jmtvE");

var $eYjK5 = parcelRequire("eYjK5");

var $5XpUh = parcelRequire("5XpUh");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $eSnSE = parcelRequire("eSnSE");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");

var $16sa1 = parcelRequire("16sa1");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $1j4Y6 = parcelRequire("1j4Y6");

var $chD07 = parcelRequire("chD07");

var $h67Wd = parcelRequire("h67Wd");

var $1A5eX = parcelRequire("1A5eX");

var $ftN6c = parcelRequire("ftN6c");

var $cNNNb = parcelRequire("cNNNb");

var $fAZgY = parcelRequire("fAZgY");

var $5UIJ7 = parcelRequire("5UIJ7");
const $08b033632138b934$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-labels-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $08b033632138b934$var$FIELD_KEY = 'labels';
const $08b033632138b934$var$FIELD_TYPE = 'labels';
const $08b033632138b934$export$865a98c44e795d94 = 'field updated';
const $08b033632138b934$export$1b05898090f57b12 = 'issue-field.save-value';
const $08b033632138b934$export$3f27bc10068ef877 = `Failed to update field ${$08b033632138b934$var$FIELD_KEY} of type ${$08b033632138b934$var$FIELD_TYPE}`;
const $08b033632138b934$var$transformAggToAtlaskitOption = (connection)=>{
    const labelValues = connection?.edges?.map((edge)=>edge?.node ?? null).filter(Boolean).filter((label)=>label && label.name != null) || [];
    const labelOptions = labelValues.map((label)=>({
            label: label.name || '',
            value: label.name || '',
            ...label.color ? {
                color: label.color.colorKey
            } : {}
        }));
    return labelOptions;
};
const $08b033632138b934$var$transformAtlaskitOptionToAgg = (value)=>({
        totalCount: value.length,
        edges: value.map((label)=>({
                node: {
                    name: label.value,
                    ...label.color ? {
                        color: {
                            colorKey: label.color
                        }
                    } : {
                        color: null
                    }
                }
            }))
    });
const $08b033632138b934$var$transformLabelsOptionsToLabelNames = (value)=>value?.map((labelOption)=>labelOption.value) ?? [];
const $08b033632138b934$var$transformLabelsOptionsToColoredLabels = (labels)=>{
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'JiraOptionColorInput | null | undefined'.
    return labels?.map(({ value: value, color: color, __isNew__: __isNew__ })=>{
        if (color) return {
            name: value,
            color: color
        };
        return {
            name: value,
            ...__isNew__ ? {
                color: (0, $cNNNb.GREY_META).name
            } : {}
        };
    }) ?? [];
};
const $08b033632138b934$var$transformOptionsOperationsIntoAggOperationInput = (operations)=>operations.map(({ operation: operation, value: value })=>{
        if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
            const coloredLabels = $08b033632138b934$var$transformLabelsOptionsToColoredLabels(value);
            return {
                operation: operation,
                labels: coloredLabels?.map((label)=>label.name) || [],
                labelProperties: coloredLabels
            };
        }
        return {
            operation: operation,
            labels: $08b033632138b934$var$transformLabelsOptionsToLabelNames(value)
        };
    });
const $08b033632138b934$var$isEqualLabels = (a, b)=>a.length === b.length && a.every((option, index)=>option.label === b[index].label && option.value === b[index].value);
const $08b033632138b934$export$f00c136eadca5f4b = ({ attributes: attributes, spacing: spacing = 'compact', baseSearchUrl: baseSearchUrl, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, isTruncated: isTruncated, isEditable: isEditable, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldScrollIntoView: menuShouldScrollIntoView, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceededProp, onSubmitFailed: onSubmitFailedProp, fragmentRef: fragmentRef, readViewFitContainerHeight: readViewFitContainerHeight, shouldShowProjectScopedCheckbox: shouldShowProjectScopedCheckbox, shouldPrefetchSuggestions: shouldPrefetchSuggestions = false, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const [{ dirtyValue: dirtyValue, operations: operations }, { onChange: onChange, initializeDirtyValue: initializeDirtyValue }] = (0, $1A5eX.useMultiSelectFieldDirtyValueOperations)();
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const [currentProjectOnly, setCurrentProjectOnly] = (0, $eJOHy.useState)((0, $5UIJ7.getProjectScopeLabelCheckboxValueFromLocalStorage));
    (0, $eJOHy.useEffect)(()=>{
        (0, $7jTnu.fg)('labels_restricted_to_project_experiment') && (0, $5UIJ7.setProjectScopeLabelCheckboxValueFromLocalStorage)(currentProjectOnly);
    }, [
        currentProjectOnly
    ]);
    const data = (0, $j4oe4.useFragment)((0, $5XpUh.default), fragmentRef);
    const { id: uniqueFieldId, name: fieldNameNoOverrides, fieldId: fieldId, type: type } = data;
    const isFieldEditable = overriding.overrideIsEditable(isEditable);
    const fieldName = overriding.overrideLabel(fieldNameNoOverrides);
    const initialValue = (0, $eJOHy.useMemo)(()=>$08b033632138b934$var$transformAggToAtlaskitOption(data?.selectedLabelsConnection), [
        data?.selectedLabelsConnection
    ]);
    const [newValue, setNewValue] = (0, $eJOHy.useState)(initialValue);
    const [cachedLabels, { addToCache: addToCache }] = (0, $h67Wd.useLabelsCache)(fieldId);
    const [commit] = (0, $j4oe4.useMutation)((0, $eYjK5.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const validator = (0, $5UIJ7.useLabelsValidator)();
    const isValueEqual = (0, $eJOHy.useCallback)((a, b)=>!(0, $7jTnu.fg)('jsc_inline_editing_field_refactor') && operations.length === 0 || $08b033632138b934$var$isEqualLabels(a, b), [
        operations.length
    ]);
    const onUpdateValue = (0, $eJOHy.useCallback)((value, isInitRequest)=>{
        isInitRequest ? initializeDirtyValue(value) : onChange(value);
    }, [
        initializeDirtyValue,
        onChange
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        const updatedValue = $08b033632138b934$var$transformLabelsOptionsToLabelNames(value);
        const updatedColoredValue = $08b033632138b934$var$transformLabelsOptionsToColoredLabels(value);
        addToCache((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? updatedColoredValue : updatedValue);
        onSubmit?.((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? updatedColoredValue : updatedValue);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? $08b033632138b934$var$transformOptionsOperationsIntoAggOperationInput([
                        {
                            operation: 'SET',
                            value: value
                        }
                    ]) : $08b033632138b934$var$transformOptionsOperationsIntoAggOperationInput(operations)
                }
            },
            optimisticResponse: {
                jira: {
                    updateLabelsField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            type: type,
                            fieldId: fieldId,
                            // @ts-expect-error - ts2322 - Property 'id' is missing in type '{ readonly colorKey: string | null | undefined; }' but required in type '{ readonly colorKey: string | null | undefined; readonly id: string | null | undefined; }'.
                            selectedLabelsConnection: $08b033632138b934$var$transformAtlaskitOptionToAgg((0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? value : dirtyValue)
                        }
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData?.jira?.updateLabelsField?.success) onSuccess();
                else {
                    const errorMessage = mutationData?.jira?.updateLabelsField?.errors?.[0]?.message ?? undefined;
                    onFail(undefined, errorMessage);
                    (0, $eSnSE.default).safeErrorWithoutCustomerData($08b033632138b934$export$1b05898090f57b12, `Failed to update field ${fieldId} of type ${$08b033632138b934$var$FIELD_TYPE}`);
                }
            },
            onError (error) {
                onFail(error, error.message);
                (0, $eSnSE.default).safeErrorWithoutCustomerData($08b033632138b934$export$1b05898090f57b12, `Failed to update field ${fieldId} of type ${$08b033632138b934$var$FIELD_TYPE}`);
            }
        });
    }, // PLEASE CONFIRM THESE DEPENDENCIES ARE CORRECT
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        addToCache,
        onSubmit,
        commit,
        uniqueFieldId,
        operations,
        fieldName,
        type,
        fieldId,
        dirtyValue,
        createAnalyticsEvent
    ]);
    const handleSubmitSucceeded = (0, $fAZgY.useCallbackWithCondition)((value)=>{
        // onSubmitSucceededProp expects a list of strings so we must map our updated value accordingly.
        onSubmitSucceededProp?.((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? $08b033632138b934$var$transformLabelsOptionsToColoredLabels(value) : $08b033632138b934$var$transformLabelsOptionsToLabelNames(value));
    }, [
        onSubmitSucceededProp
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-issue-view-2'));
    const [config] = (0, $epTsa.UNSAFE_noExposureExp)('labels_restricted_to_project');
    const memoizedAttributes = (0, $fAZgY.useMemoWithCondition)(()=>({
            ...attributes,
            ...(0, $7jTnu.fg)('labels_restricted_to_project_experiment') ? {
                hasProjectScopedLabels: config.get('showProjectFilter', false),
                currentProjectOnly: currentProjectOnly
            } : {}
        }), [
        attributes,
        config,
        currentProjectOnly
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-issue-view-2'));
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: memoizedAttributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: isValueEqual,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: handleSubmitSucceeded,
        onSubmitFailed: onSubmitFailedProp,
        onUpdateValue: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? setNewValue : onUpdateValue,
        updatedValue: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? newValue : dirtyValue,
        validator: validator,
        clipboardComponentType: 'labels'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08b033632138b934$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $chD07.LabelsReadView), {
            baseSearchUrl: baseSearchUrl,
            fragmentRef: data,
            isTruncated: isTruncated,
            isHoverPopoverEnabled: isHoverPopoverEnabled
        })), [
        baseSearchUrl,
        data,
        isTruncated,
        isHoverPopoverEnabled
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            ariaLabel: fieldName,
            spacing: spacing,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            onChange: handleChange,
            value: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? newValue : dirtyValue,
            cachedOptions: cachedLabels,
            nodeIdFragment: data,
            isInvalid: !!invalidMessage,
            sessionId: sessionId.current,
            testId: 'issue-field-labels-inline-edit-view-full.ui.labels.edit-view',
            shouldShowProjectScopedCheckbox: shouldShowProjectScopedCheckbox,
            ...(0, $7jTnu.fg)('labels_restricted_to_project_experiment') ? {
                currentProjectOnly: currentProjectOnly,
                setCurrentProjectOnly: setCurrentProjectOnly
            } : {}
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPoint: (0, $1j4Y6.default),
        editViewEntryPointParams: shouldPrefetchSuggestions ? {
            id: uniqueFieldId
        } : {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        invalidMessage: invalidMessage,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        hasReadViewTruncateDisabled: isHoverPopoverEnabled,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        hasUnsubmittedChanges: hasServerValidationError
    });
};
const $08b033632138b934$export$f066b3edf0d7cd25 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)(/* eslint-disable @atlassian/relay/graphql-naming */ (0, $jmtvE.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08b033632138b934$export$f00c136eadca5f4b, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("jmtvE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bdc8b298b8d382c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a5d785db9d94536cfc54c642b914993>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2bdc8b298b8d382c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraLabelsField"
};
$2bdc8b298b8d382c$var$node.hash = "83c0a65ee08db15e69b7b1d990bb3c2d";
var $2bdc8b298b8d382c$export$2e2bcd8739ae039 = $2bdc8b298b8d382c$var$node;

});

parcelRegister("eYjK5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81d3c01cbd4049f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7947fae5515817c329d71de17e81921>>
 * @relayHash c63fef829683257621ca44c6de704569
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID decd3960fcb949b4372ef20ce095b3faec3c8a144d2c1b402c746b261e027e87
const $d81d3c01cbd4049f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                },
                                                {
                                                    "concreteType": "JiraLabelEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraColor",
                                                                    "kind": "LinkedField",
                                                                    "name": "color",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "colorKey"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                        },
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "decd3960fcb949b4372ef20ce095b3faec3c8a144d2c1b402c746b261e027e87",
            "metadata": {},
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d81d3c01cbd4049f$var$node.hash = "b7c0af684826341f4d5d5b319e095b51";
var $d81d3c01cbd4049f$export$2e2bcd8739ae039 = $d81d3c01cbd4049f$var$node;

});

parcelRegister("5XpUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a51f8a9fdc04e48$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f260bad90f08e590a093963f832701b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3a51f8a9fdc04e48$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "labels_issueFieldLabelsReadviewFull_LabelsReadView"
            },
            {
                "kind": "FragmentSpread",
                "name": "labels_issueFieldLabelsEditviewFull_LabelsEditView_nodeIdFragment"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1000
                        }
                    ],
                    "concreteType": "JiraLabelConnection",
                    "kind": "LinkedField",
                    "name": "selectedLabelsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "concreteType": "JiraLabelEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraLabel",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "concreteType": "JiraColor",
                                            "kind": "LinkedField",
                                            "name": "color",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "colorKey"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "selectedLabelsConnection(first:1000)"
                },
                "action": "THROW",
                "path": "selectedLabelsConnection"
            }
        ],
        "type": "JiraLabelsField"
    };
}();
$3a51f8a9fdc04e48$var$node.hash = "36e5976ba7a2feeb9ac95152dd750aef";
var $3a51f8a9fdc04e48$export$2e2bcd8739ae039 = $3a51f8a9fdc04e48$var$node;

});

parcelRegister("1j4Y6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a5de43dc26a37ed$export$2e2bcd8739ae039);

var $L8BZE = parcelRequire("L8BZE");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $3a5de43dc26a37ed$var$LabelsEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dknqf")), {
        moduleId: "f49080b6",
        priority: "interaction"
    }),
    getPreloadProps: ({ id: id })=>id ? {
            queries: {
                labelsSuggestionsData: {
                    parameters: $L8BZE.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    variables: {
                        id: id
                    }
                }
            }
        } : {}
});
var $3a5de43dc26a37ed$export$2e2bcd8739ae039 = $3a5de43dc26a37ed$var$LabelsEditViewEntryPoint;

});
parcelRegister("L8BZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c60c3724c891dcef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1812ef87b1f80def77b88faa395f28a5>>
 * @relayHash cf60cab627fd5a4526b86847467cc927
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 16a655da0b16a10ad930e84f8f7bfc022914d3262cbdef1fd962c0f5bc00523e
const $c60c3724c891dcef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        },
        {
            "kind": "Literal",
            "name": "suggested",
            "value": true
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewWithSuggestionsFragment_suggestionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraLabelConnection",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraLabelEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraLabel",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "color",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "labels(first:50,searchBy:\"\",suggested:true)"
                                },
                                {
                                    "args": v3 /*: any*/ ,
                                    "filters": [
                                        "suggested",
                                        "searchBy",
                                        "currentProjectOnly"
                                    ],
                                    "handle": "connection",
                                    "key": "labels_issueFieldLabelsEditviewFull_LabelsEditViewWithSuggestionsFragmentSearch__labels",
                                    "kind": "LinkedHandle",
                                    "name": "labels"
                                }
                            ],
                            "type": "JiraLabelsField"
                        },
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "16a655da0b16a10ad930e84f8f7bfc022914d3262cbdef1fd962c0f5bc00523e",
            "metadata": {},
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c60c3724c891dcef$var$node.hash = "f7c0efbc6f8dee59af5c37b02898ac3e";
var $c60c3724c891dcef$export$2e2bcd8739ae039 = $c60c3724c891dcef$var$node;

});

parcelRegister("dknqf", function(module, exports) {

let $9b3f4fd2ef9288ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9b3f4fd2ef9288ca$var$load("8L4O3").then(()=>parcelRequire('i1Kmk'));

});


parcelRegister("chD07", function(module, exports) {

$parcel$export(module.exports, "LabelsReadView", () => $908eb3b1fb928d18$export$79e9d2357368ec9e);

var $kwYMD = parcelRequire("kwYMD");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $ar6fB = parcelRequire("ar6fB");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $iyBBa = parcelRequire("iyBBa");

var $aCFLd = parcelRequire("aCFLd");

var $6XJko = parcelRequire("6XJko");

var $051tO = parcelRequire("051tO");

var $iiHt1 = parcelRequire("iiHt1");

var $fjnDV = parcelRequire("fjnDV");

var $gZJc1 = parcelRequire("gZJc1");
const $908eb3b1fb928d18$var$getLabelTagColor = (label)=>{
    if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        const colorName = label?.color?.colorKey;
        if (!colorName) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label?.name || '');
        const { tagColor: tagColor } = (0, $051tO.getColorMetadata)(colorName);
        return tagColor;
    }
    if ((0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label.name);
};
const $908eb3b1fb928d18$export$79e9d2357368ec9e = ({ baseSearchUrl: baseSearchUrl, fragmentRef: fragmentRef, isTruncated: isTruncated, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $gZJc1.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const data = (0, $j4oe4.useFragment)((0, $kwYMD.default), fragmentRef);
    const { selectedLabelsConnection: labels, fieldId: fieldId } = data;
    if (labels.totalCount !== 0) {
        const labelValues = labels?.edges?.filter(Boolean).map((edge)=>edge.node).filter((label)=>label != null && label.name != null) || [];
        if (labelValues.length !== 0) {
            if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fjnDV.LabelsTruncatedReadView), {
                baseSearchUrl: baseSearchUrl,
                fieldId: fieldId,
                labelValues: labelValues,
                isHoverPopoverEnabled: isHoverPopoverEnabled
            });
            if (!(0, $6XJko.isVisualRefreshEnabled)() && ((0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) || (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($908eb3b1fb928d18$var$GroupWithNegativeMarginOffset, null, labelValues.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iyBBa.ColoredTag), {
                    key: label.name,
                    labelName: label.name,
                    href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl),
                    ...(0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
                        color: (0, $fjnDV.getLabelColor)(label)
                    } : {}
                })));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($908eb3b1fb928d18$var$GroupWithNegativeMarginOffset, null, labelValues.map((label)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
                    key: label.name,
                    isRemovable: false,
                    text: label.name,
                    href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl),
                    color: $908eb3b1fb928d18$var$getLabelTagColor(label)
                });
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $908eb3b1fb928d18$var$GroupWithNegativeMarginOffset = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq _1n261g80 _1bah1y6m _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kwYMD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2001a55d2e4c9ef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7dec5d911d8d729060e7c86a5f17d210>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c2001a55d2e4c9ef$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "labels_issueFieldLabelsReadviewFull_LabelsReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedLabelsConnection"
        }
    ],
    "type": "JiraLabelsField"
};
$c2001a55d2e4c9ef$var$node.hash = "3f7bd1f7c0b3da8b1c1b35313d9735b4";
var $c2001a55d2e4c9ef$export$2e2bcd8739ae039 = $c2001a55d2e4c9ef$var$node;

});

parcelRegister("iiHt1", function(module, exports) {

$parcel$export(module.exports, "getLabelHref", () => $95a0728e309b1229$export$a1200807f331a4bd);

var $bnIBr = parcelRequire("bnIBr");
const $95a0728e309b1229$var$CUSTOM_FIELD_PREFIX = 'customfield_';
const $95a0728e309b1229$export$faff4881e53b3cb6 = (fieldId)=>{
    if (fieldId.startsWith($95a0728e309b1229$var$CUSTOM_FIELD_PREFIX)) {
        const customId = fieldId.substring($95a0728e309b1229$var$CUSTOM_FIELD_PREFIX.length, fieldId.length);
        return `cf[${customId}]`;
    }
    return fieldId;
};
const $95a0728e309b1229$export$a1200807f331a4bd = (fieldId, label, baseSearchUrl = '/issues/')=>{
    const jqlEncodedValue = encodeURIComponent(`${$95a0728e309b1229$export$faff4881e53b3cb6(fieldId)} = ${(0, $bnIBr.toQuotedString)(label)}`);
    return `${baseSearchUrl}?jql=${jqlEncodedValue}`;
};

});

parcelRegister("fjnDV", function(module, exports) {

$parcel$export(module.exports, "getLabelColor", () => $d18877e75f12e55a$export$627d17b212b38ee0);
$parcel$export(module.exports, "LabelsTruncatedReadView", () => $d18877e75f12e55a$export$95d698e57184b56c);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $aCFLd = parcelRequire("aCFLd");

var $051tO = parcelRequire("051tO");

var $iiHt1 = parcelRequire("iiHt1");

var $gZJc1 = parcelRequire("gZJc1");
const $d18877e75f12e55a$export$627d17b212b38ee0 = (label)=>{
    if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        const colorName = label?.color?.colorKey;
        const { backgroundColor: color } = (0, $051tO.getColorMetadata)(colorName || (0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(label.name));
        return color;
    }
    if ((0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) {
        const { backgroundColor: color } = (0, $051tO.getColorMetadata)((0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(label.name));
        return color;
    }
};
const $d18877e75f12e55a$export$95d698e57184b56c = ({ baseSearchUrl: baseSearchUrl, fieldId: fieldId, labelValues: labelValues, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $gZJc1.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    if (labelValues.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
    const items = labelValues.map((label)=>{
        if ((0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) || (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) return {
            name: label.name,
            key: label.name,
            href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl),
            isColored: true,
            ...(0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
                color: $d18877e75f12e55a$export$627d17b212b38ee0(label)
            } : {}
        };
        return {
            name: label.name,
            key: label.name,
            href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl)
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: $d18877e75f12e55a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: items,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $gZJc1.default).showMoreTooltip),
        isHoverPopoverEnabled: isHoverPopoverEnabled
    }));
};
const $d18877e75f12e55a$var$containerStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});

});
parcelRegister("gZJc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9950418b3a51d36e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9950418b3a51d36e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-labels-readview-full.labels.compact.show-more-tooltip",
        "defaultMessage": "See more labels"
    },
    noValueTextExperiment: {
        "id": "issue-field-labels-readview-full.labels.compact.no-value-text-experiment",
        "defaultMessage": "Add labels"
    }
});

});



parcelRegister("h67Wd", function(module, exports) {

$parcel$export(module.exports, "useLabelsCache", () => $4950fca072871133$export$18b2bd971a089d24);

var $eJOHy = parcelRequire("eJOHy");

var $d2fZT = parcelRequire("d2fZT");

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $aCTqO = parcelRequire("aCTqO");
const $4950fca072871133$var$useRerenderTrigger = ()=>{
    const [token, setSymbol] = (0, $eJOHy.useState)(Symbol('useRerenderTrigger_initial'));
    const refreshToken = (0, $eJOHy.useCallback)(()=>setSymbol(Symbol('useRerenderTrigger_rerender')), []);
    return [
        token,
        refreshToken
    ];
};
const $4950fca072871133$var$isStringArray = (labels)=>{
    return labels.length > 0 && typeof labels[0] === 'string';
};
const $4950fca072871133$var$isColoredLabelArray = (labels)=>{
    return labels.length > 0 && typeof labels[0] !== 'string';
};
const $4950fca072871133$export$18b2bd971a089d24 = (fieldId)=>{
    const labelsCache = (0, $d2fZT.getLabelsCache)(fieldId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [cachedLabels, setCachedLabels] = (0, $eJOHy.useState)([]);
    const [cacheRefreshToken, refreshCache] = $4950fca072871133$var$useRerenderTrigger();
    const addToCache = (0, $eJOHy.useCallback)((labels)=>{
        // Filter out labels with spaces upfront if feature flag is enabled
        let labelsToProcess;
        if (!(0, $7jTnu.fg)('kenji-jjj-fix-spaced-label-recommendation')) labelsToProcess = labels;
        else if (labels.length === 0) labelsToProcess = labels;
        else if ($4950fca072871133$var$isStringArray(labels)) // String array - filter out labels with spaces
        labelsToProcess = labels.filter((label)=>!label.includes(' '));
        else if ($4950fca072871133$var$isColoredLabelArray(labels)) // ColoredLabel array - filter out labels with spaces
        labelsToProcess = labels.filter((label)=>!label.name?.includes(' '));
        else labelsToProcess = labels;
        Promise.all(labelsToProcess.map(async (label)=>{
            try {
                if (typeof label !== 'string') {
                    const cachedOption = await labelsCache.get(label.name);
                    (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache set', {
                        isFromCache: Boolean(cachedOption?.label)
                    });
                    return label && labelsCache.set(`${label.name}`, {
                        label: label.name,
                        ...label.color ? {
                            color: label.color
                        } : {}
                    });
                }
                const cachedOption = await labelsCache.get(label);
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache set', {
                    isFromCache: Boolean(cachedOption?.label)
                });
                return label && labelsCache.set(`${label}`, {
                    label: label
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view.labels.cache.set', error.message);
            }
            return undefined;
        })).then(()=>{
            refreshCache(); // trigger an update of the returned cached labels value
        });
    }, [
        createAnalyticsEvent,
        labelsCache,
        refreshCache
    ]);
    const removeFromCache = (0, $eJOHy.useCallback)((labels)=>{
        Promise.all(labels.map(async (label)=>{
            try {
                const cachedOption = await labelsCache.get(label);
                if (cachedOption) {
                    (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache removed');
                    return cachedOption && labelsCache.remove(`${cachedOption.label}`);
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view.labels.cache.remove', error.message);
            }
            return undefined;
        })).then(()=>{
            refreshCache(); // trigger an update of the returned cached labels value
        });
    }, [
        createAnalyticsEvent,
        labelsCache,
        refreshCache
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const getCachedLabels = async ()=>{
            const cachedItems = await labelsCache.getAll();
            // Filter out labels with spaces before processing
            const filteredCachedItems = (0, $7jTnu.fg)('kenji-jjj-fix-spaced-label-recommendation') ? cachedItems.filter((item)=>{
                return item.label && !item.label.includes(' ');
            }) : cachedItems;
            const transformedCachedItems = (0, $aCTqO.transformCacheEntries)(filteredCachedItems);
            const labelOptions = (0, $aCTqO.mapCachedItemsToLabelOptions)(transformedCachedItems);
            setCachedLabels(labelOptions);
        };
        getCachedLabels();
    // Having cacheRefreshToken in the deps array allows us to retrigger a loading of the cached values whenever refreshCache is called
    }, [
        cacheRefreshToken,
        labelsCache
    ]);
    return [
        cachedLabels,
        {
            addToCache: addToCache,
            removeFromCache: removeFromCache
        }
    ];
};

});
parcelRegister("d2fZT", function(module, exports) {

$parcel$export(module.exports, "getLabelsCache", () => $9c2777dbc27f83a3$export$f7e90ae127ed72ef);

var $2ZrIe = parcelRequire("2ZrIe");

var $7s7dw = parcelRequire("7s7dw");
const $9c2777dbc27f83a3$var$labelsCaches = {};
const $9c2777dbc27f83a3$export$f7e90ae127ed72ef = (labelsFieldId)=>{
    const cacheKey = labelsFieldId || (0, $7s7dw.props).cacheKey;
    if (!$9c2777dbc27f83a3$var$labelsCaches[cacheKey]) $9c2777dbc27f83a3$var$labelsCaches[cacheKey] = (0, $2ZrIe.default)({
        ...(0, $7s7dw.props),
        cacheKey: cacheKey
    });
    return $9c2777dbc27f83a3$var$labelsCaches[cacheKey];
};

});
parcelRegister("2ZrIe", function(module, exports) {

$parcel$export(module.exports, "default", () => $68c90beac6bbcd15$export$2e2bcd8739ae039);

var $dQ3qN = parcelRequire("dQ3qN");
const $68c90beac6bbcd15$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$68c90beac6bbcd15$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $dQ3qN.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $68c90beac6bbcd15$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $68c90beac6bbcd15$var$pNothing,
        update: $68c90beac6bbcd15$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $68c90beac6bbcd15$var$pNothing
    };
};

});
parcelRegister("dQ3qN", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $dad4e0b94ce9085b$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $dad4e0b94ce9085b$export$2e2bcd8739ae039);

var $dnU6V = parcelRequire("dnU6V");

var $4elgJ = parcelRequire("4elgJ");

var $eSnSE = parcelRequire("eSnSE");


var $6O0zm = parcelRequire("6O0zm");
const $dad4e0b94ce9085b$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $dad4e0b94ce9085b$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $6O0zm.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $dad4e0b94ce9085b$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $8da4e41a25982619$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $dad4e0b94ce9085b$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $8da4e41a25982619$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $8da4e41a25982619$export$2670cb7d5d4f7184)) storage = (0, $dnU6V.createLocalStorageProvider)((0, $6O0zm.CACHE_PREFIX));
        else storage = (0, $4elgJ.createSessionStorageProvider)((0, $6O0zm.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $8da4e41a25982619$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $8da4e41a25982619$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $eSnSE.default).safeWarnWithoutCustomerData((0, $8da4e41a25982619$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $8da4e41a25982619$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $8da4e41a25982619$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $6O0zm.default).scopes.current !== (0, $6O0zm.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dad4e0b94ce9085b$var$cacheMap = {};
const $dad4e0b94ce9085b$var$getCache = async (props)=>{
    await (0, $6O0zm.scopeGuard)().catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $dad4e0b94ce9085b$var$cacheMap[cacheKey] = $dad4e0b94ce9085b$var$cacheMap[cacheKey] || new $dad4e0b94ce9085b$export$94affb487e701bf2(props);
    return $dad4e0b94ce9085b$var$cacheMap[cacheKey];
};
const $dad4e0b94ce9085b$export$710d301bf26d9700 = ()=>{
    Object.values($dad4e0b94ce9085b$var$cacheMap).forEach((cache)=>cache.clear());
};
var $dad4e0b94ce9085b$export$2e2bcd8739ae039 = $dad4e0b94ce9085b$var$getCache;

});
const $8da4e41a25982619$export$7271276960377470 = 'common-cache';
const $8da4e41a25982619$export$a61768fefd33fcb1 = 'capacity exceeded';
const $8da4e41a25982619$export$6c4d37c7f376a1de = 'clear';
const $8da4e41a25982619$export$e271b26eefe41db8 = 'update';
const $8da4e41a25982619$export$4bd2facc4a3e6aa1 = 'delete';
const $8da4e41a25982619$export$26d12233004a7a60 = 'delete stale entry';
const $8da4e41a25982619$export$1bb358554aac31c1 = 'get';
const $8da4e41a25982619$export$61f74127e2b53cbe = 'hydrate';
const $8da4e41a25982619$export$5e8f180ef0142226 = 'set';
const $8da4e41a25982619$export$9eb68924983e00fb = 'get entries';
const $8da4e41a25982619$export$bf340b99118a1511 = 'memory';
const $8da4e41a25982619$export$2670cb7d5d4f7184 = 'local';
const $8da4e41a25982619$export$b796061ff0c82e1a = 'session';



parcelRegister("7s7dw", function(module, exports) {

$parcel$export(module.exports, "props", () => $c90795d61c531dc8$export$8128bb6492cf3de7);

const $c90795d61c531dc8$var$MAX_RESULTS = 10;
const $c90795d61c531dc8$var$CACHE_SIZE = $c90795d61c531dc8$var$MAX_RESULTS * 2;
const $c90795d61c531dc8$var$LABELS_CACHE_KEY = 'labels';
const $c90795d61c531dc8$export$8128bb6492cf3de7 = {
    size: $c90795d61c531dc8$var$CACHE_SIZE,
    cacheKey: $c90795d61c531dc8$var$LABELS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $8da4e41a25982619$export$2670cb7d5d4f7184)
};

});


parcelRegister("aCTqO", function(module, exports) {

$parcel$export(module.exports, "mapCachedItemsToLabelOptions", () => $a0b3ef3b5b5776a6$export$9ba85e25262c8a32);
$parcel$export(module.exports, "transformCacheEntries", () => $a0b3ef3b5b5776a6$export$64c1e7aa265973f8);

const $a0b3ef3b5b5776a6$export$9ba85e25262c8a32 = (items)=>items.map((item)=>({
            label: item.label,
            value: item.label,
            ...item.color ? {
                color: item.color
            } : {}
        }));
const $a0b3ef3b5b5776a6$export$64c1e7aa265973f8 = (items)=>items.slice(-1 * (0, $c663f6eba89f5eed$export$f6b2881bc1090cea)).reverse();

});
const $c663f6eba89f5eed$export$ffb1c0893bcc2c13 = 'customfield_';
const $c663f6eba89f5eed$export$f6b2881bc1090cea = 5;



parcelRegister("1A5eX", function(module, exports) {

$parcel$export(module.exports, "useMultiSelectFieldDirtyValueOperations", () => $8b2131d96c87af82$export$484e5e1fabcb3ce2);

var $eJOHy = parcelRequire("eJOHy");
const $8b2131d96c87af82$export$484e5e1fabcb3ce2 = ()=>{
    const [dirtyValue, setDirtyValue] = (0, $eJOHy.useState)([]);
    const [operations, setOperations] = (0, $eJOHy.useState)([]);
    const initializeDirtyValue = (0, $eJOHy.useCallback)((currentValue)=>{
        setDirtyValue(currentValue);
        setOperations([]);
    }, []);
    const onChange = (0, $eJOHy.useCallback)((newValue)=>{
        // todo JIV-13917: compare the new values to previous state. convert in to a discrete combination of add, remove, and set operations.
        // Eg: User adds item A and removes item B -> results in -> [{operation: 'REMOVE', value: ['B']}, {operation: 'ADD', value: ['A']}]
        // Eg: User swaps the order of items A and B to [B,A] -> results in -> [{operation: 'REMOVE', value: ['A', 'B']}, {operation: 'ADD', value: ['B', 'A']}]
        // Eg: User clears the value of the field (using x button) then adds item A -> results in -> [{operation: 'SET', value: []}, {operation: 'ADD', value: ['A']}]
        // Rules:
        // If the user clears the field value, first operation must be SET to []
        // Any permutation of any number of single-value-add events, single-value-remove events or re-ordering events can be simplified down to a single `ADD` and `REMOVE` operation
        //
        // This will end up a fair bit more complex than it is now, but it will allow us to avoid bugs where we accidentally chop off values past the initial page
        setOperations([
            {
                operation: 'SET',
                value: newValue
            }
        ]);
        setDirtyValue(newValue);
    }, []);
    return [
        {
            dirtyValue: dirtyValue,
            operations: operations
        },
        {
            onChange: onChange,
            initializeDirtyValue: initializeDirtyValue
        }
    ];
};

});

parcelRegister("5UIJ7", function(module, exports) {

$parcel$export(module.exports, "useLabelsValidator", () => $5feb26d49619397f$export$990e7f2d0da9a96a);
$parcel$export(module.exports, "getProjectScopeLabelCheckboxValueFromLocalStorage", () => $5feb26d49619397f$export$6181698b046b748f);
$parcel$export(module.exports, "setProjectScopeLabelCheckboxValueFromLocalStorage", () => $5feb26d49619397f$export$9e31f8fbc2feb98f);

var $eJOHy = parcelRequire("eJOHy");

var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");


var $at2Tf = parcelRequire("at2Tf");
const $5feb26d49619397f$export$990e7f2d0da9a96a = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const change = (0, $eJOHy.useCallback)((newValues)=>{
        for(let i = newValues.length - 1; i >= 0; i -= 1){
            const { __isNew__: __isNew__, value: value } = newValues[i];
            if (__isNew__ === true) {
                if (value.includes(' ')) return {
                    type: 'error',
                    message: formatMessage((0, $at2Tf.default).newLabelContainsSpacesError)
                };
                if (value.length > (0, $705a9ff31bc3258c$export$e85fda072a12fed9)) return {
                    type: 'error',
                    message: formatMessage((0, $at2Tf.default).newLabelTooLongError, {
                        maxLength: (0, $705a9ff31bc3258c$export$e85fda072a12fed9)
                    })
                };
            }
        }
        if (newValues.length > (0, $705a9ff31bc3258c$export$45f4d7adca48db10)) return {
            type: 'warning',
            message: formatMessage((0, $at2Tf.default).maximumNumberOfLabelsExceededError, {
                maxNumberOfLabels: (0, $705a9ff31bc3258c$export$45f4d7adca48db10)
            })
        };
        return null;
    }, [
        formatMessage
    ]);
    return {
        change: change
    };
};
const $5feb26d49619397f$export$f04a317778b8db56 = 'restrict_labels_to_projects_checkbox_value';
const $5feb26d49619397f$export$b19885560047617b = (0, $dnU6V.createLocalStorageProvider)('project-scoped-labels');
const $5feb26d49619397f$export$6181698b046b748f = ()=>{
    if (!(0, $7jTnu.fg)('labels_restricted_to_project_experiment')) return false;
    return $5feb26d49619397f$export$b19885560047617b.get($5feb26d49619397f$export$f04a317778b8db56) || false;
};
const $5feb26d49619397f$export$9e31f8fbc2feb98f = (value)=>{
    return $5feb26d49619397f$export$b19885560047617b.set($5feb26d49619397f$export$f04a317778b8db56, value);
};

});
const $705a9ff31bc3258c$export$45f4d7adca48db10 = 55;
const $705a9ff31bc3258c$export$e85fda072a12fed9 = 255;

parcelRegister("at2Tf", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d6558214ceb0917$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0d6558214ceb0917$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "issue-field-labels-inline-edit-view-full.labels.error-title",
        "defaultMessage": "We couldn't set the labels value"
    },
    errorMessage: {
        "id": "issue-field-labels-inline-edit-view-full.labels.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    noValueText: {
        "id": "issue-field-labels-inline-edit-view-full.labels.no-value-text",
        "defaultMessage": "None"
    },
    newLabelTooLongError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.new-label-too-long-error",
        "defaultMessage": "Labels can't be more than {maxLength} characters."
    },
    newLabelContainsSpacesError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.new-label-contains-spaces-error",
        "defaultMessage": "Labels can't have spaces."
    },
    maximumNumberOfLabelsExceededError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.maximum-number-of-labels-exceeded-error",
        "defaultMessage": "Can't have more than {maxNumberOfLabels} labels."
    }
});

});



parcelRegister("1m9se", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc4fb94e153b4b8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2cc4fb94e153b4b8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.labels.trigger-button",
        "defaultMessage": "See more labels"
    }
});

});


parcelRegister("bwtnm", function(module, exports) {

$parcel$export(module.exports, "MultiSelectCell", () => $8aadece9ed0b27ab$export$4ae427e87d8482e2);

var $l5HU9 = parcelRequire("l5HU9");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cqb3z = parcelRequire("cqb3z");

var $7jTnu = parcelRequire("7jTnu");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $8aadece9ed0b27ab$export$4ae427e87d8482e2 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $l5HU9.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cqb3z.MultiSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupTarget: isFirstField ? $8aadece9ed0b27ab$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cqb3z.MultiSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $8aadece9ed0b27ab$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8aadece9ed0b27ab$var$customTargetStyles,
        ref: ref
    });
});
const $8aadece9ed0b27ab$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("l5HU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $868ac540bdcf0a0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35bf3f97067093f7601e1f59825819c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $868ac540bdcf0a0d$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "multiSelect_nativeIssueTable_MultiSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleSelectField"
};
$868ac540bdcf0a0d$var$node.hash = "b76efba9f73e137476cc5523a3ecf23a";
var $868ac540bdcf0a0d$export$2e2bcd8739ae039 = $868ac540bdcf0a0d$var$node;

});

parcelRegister("cqb3z", function(module, exports) {

$parcel$export(module.exports, "MultiSelectInlineEditViewWithIsEditable", () => $b97be3da31764f0c$export$2dcdfc567a992efd);

var $4VuI3 = parcelRequire("4VuI3");

var $ygzCA = parcelRequire("ygzCA");

var $2QpOv = parcelRequire("2QpOv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $16sa1 = parcelRequire("16sa1");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $8xlP3 = parcelRequire("8xlP3");

var $l8r9T = parcelRequire("l8r9T");

var $auNLL = parcelRequire("auNLL");

var $bJscI = parcelRequire("bJscI");
const $b97be3da31764f0c$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-multi-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $b97be3da31764f0c$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $b97be3da31764f0c$export$2dcdfc567a992efd = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $2QpOv.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $ygzCA.default));
    // #endregion Relay
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedOptions: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                id: edge?.node?.id ?? '',
                optionId: edge?.node?.optionId ?? '',
                value: edge?.node?.value ?? '',
                selectableLabel: edge?.node?.value ?? '',
                selectableGroupKey: null,
                selectableIconUrl: null
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $eJOHy.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleSelectField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOptions: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.id ?? '',
                                            value: edge.selectableLabel ?? '',
                                            optionId: edge.optionId ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $b97be3da31764f0c$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiSelect'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b97be3da31764f0c$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l8r9T.MultiSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        })), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            filterOptionsById: filterOptionsById,
            openMenuOnFocus: true,
            spacing: spacing
        });
    // #endregion Edit view
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $8xlP3.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $b97be3da31764f0c$export$9d754a44e976e46a = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $4VuI3.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b97be3da31764f0c$export$2dcdfc567a992efd, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("4VuI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d7fcdab25bd9bed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c8784dc5c6cf0181fba42792ac91445>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1d7fcdab25bd9bed$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectField"
};
$1d7fcdab25bd9bed$var$node.hash = "d32e2ded197d2b2b4bc30729f9587a62";
var $1d7fcdab25bd9bed$export$2e2bcd8739ae039 = $1d7fcdab25bd9bed$var$node;

});

parcelRegister("ygzCA", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f2cf57eb77e224$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab89800218576513b704c68f8ce1ac28>>
 * @relayHash b4af6905e862873a8846fa4a71f56a57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12ff733a258befd165b334ced2a9a4ad512afe20c3502276964dc077438a292d
const $56f2cf57eb77e224$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12ff733a258befd165b334ced2a9a4ad512afe20c3502276964dc077438a292d",
            "metadata": {},
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$56f2cf57eb77e224$var$node.hash = "cb08d7ecaba6a03f3f00edae8eb1b5a3";
var $56f2cf57eb77e224$export$2e2bcd8739ae039 = $56f2cf57eb77e224$var$node;

});

parcelRegister("2QpOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a6d495cf00d0cbd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<357beb53165a8a4df485e730345c9792>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3a6d495cf00d0cbd$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "multiSelect_issueFieldMultiSelectReadviewFull_MultiSelectReadView"
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleSelectField"
    };
}();
$3a6d495cf00d0cbd$var$node.hash = "51442265271466c01819bfe490c82976";
var $3a6d495cf00d0cbd$export$2e2bcd8739ae039 = $3a6d495cf00d0cbd$var$node;

});

parcelRegister("8xlP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6be29c11818f392$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a6be29c11818f392$var$MultiSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("i6SDn")), {
        moduleId: "f60cd571",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $a6be29c11818f392$export$2e2bcd8739ae039 = $a6be29c11818f392$var$MultiSelectEditViewEntryPoint;

});
parcelRegister("i6SDn", function(module, exports) {

let $d2f32ab7da4514c2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d2f32ab7da4514c2$var$load("5k4Zc").then(()=>parcelRequire('1CasD'));

});


parcelRegister("l8r9T", function(module, exports) {

$parcel$export(module.exports, "MultiSelectReadView", () => $3094c29efbad1630$export$ecebbf80cc7a07f1);

var $3aszq = parcelRequire("3aszq");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $kp5kj = parcelRequire("kp5kj");

var $1tX0c = parcelRequire("1tX0c");

var $2j0d2 = parcelRequire("2j0d2");

var $hIfdw = parcelRequire("hIfdw");
const $3094c29efbad1630$export$ecebbf80cc7a07f1 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $3aszq.default), fragmentRef);
    const transformedSelectedOptions = (0, $eJOHy.useMemo)(()=>{
        if (!data?.selectedOptions?.edges) return null;
        const selectedOptions = data.selectedOptions.edges.map((edge)=>edge?.node).filter((node)=>Boolean(node?.value));
        return selectedOptions.map((node)=>({
                key: node.id,
                name: node.value,
                color: null,
                isInteractive: false
            }));
    }, [
        data?.selectedOptions?.edges
    ]);
    if (!transformedSelectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        role: "group",
        xcss: isTruncatedWithHoverPopover && $3094c29efbad1630$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: transformedSelectedOptions,
        ItemComponent: isTruncatedWithHoverPopover ? (0, $1tX0c.TagItem) : (0, $kp5kj.OptionTag),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $hIfdw.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        role: "group",
        shouldWrap: true
    }, transformedSelectedOptions.map(({ key: key, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            key: key,
            ...restProps
        })));
};
const $3094c29efbad1630$var$inlineStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("3aszq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfb087594e0a6656$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<24f8ea29f5b0a9e715aebdeec184bd0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dfb087594e0a6656$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiSelect_issueFieldMultiSelectReadviewFull_MultiSelectReadView",
    "selections": [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectField"
};
$dfb087594e0a6656$var$node.hash = "30f1fb233423b8843508f947cb7c3c09";
var $dfb087594e0a6656$export$2e2bcd8739ae039 = $dfb087594e0a6656$var$node;

});

parcelRegister("kp5kj", function(module, exports) {

$parcel$export(module.exports, "OptionTag", () => $3f06606f2017e535$export$5991b62d89f5cc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $epTsa = parcelRequire("epTsa");

var $051tO = parcelRequire("051tO");
const $3f06606f2017e535$export$5991b62d89f5cc = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ name: name, color: color, isInteractive: isInteractive = true, showTooltip: showTooltip = false, isColoredLabel: isColoredLabel }, ref)=>{
    const { backgroundColor: tagColor } = (0, $051tO.getColorMetadata)(color);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $3f06606f2017e535$var$tagWrapperStyles,
            isInteractive && $3f06606f2017e535$var$interactiveStyles
        ],
        "aria-label": name,
        testId: "option-color-picker.option-tag.field-tag-wrapper",
        ref: ref
    }, isColoredLabel && (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: `option-color-picker.option-tag.${color || 'default'}`,
        xcss: $3f06606f2017e535$var$styledTagsStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: tagColor
        }
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f06606f2017e535$var$StyledTag, {
        "data-testid": `option-color-picker.option-tag.${color || 'default'}`,
        color: tagColor
    }, name));
    return showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3f06606f2017e535$var$tooltipStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: name
    }, content)) : content;
}));
const $3f06606f2017e535$var$tooltipStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});
const $3f06606f2017e535$var$tagWrapperStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    justifyContent: 'left',
    alignItems: 'center',
    transition: '0.3s',
    maxWidth: '100%',
    minWidth: '0',
    minHeight: '0',
    color: 'color.text'
});
const $3f06606f2017e535$var$interactiveStyles = (0, $1DXK0.xcss)({
    ':hover': {
        cursor: 'pointer'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f06606f2017e535$var$StyledTagBase = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _vwz4f6fq _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $3f06606f2017e535$var$StyledTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $3f06606f2017e535$var$StyledTagBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $awdRS.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko5n0m _19it11we _bfhk18uv _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $3f06606f2017e535$var$styledTagsStyles = (0, $1DXK0.xcss)({
    font: 'font.body',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderRadius: 'border.radius.100',
    backgroundColor: 'color.background.neutral.subtle',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    paddingRight: 'space.050',
    paddingLeft: 'space.050',
    maxWidth: '180px'
});

});

parcelRegister("hIfdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4db827a084446152$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4db827a084446152$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-select-readview-full.multi-select.compact.show-more-tooltip",
        "defaultMessage": "See more selected options"
    }
});

});




parcelRegister("16mrC", function(module, exports) {

$parcel$export(module.exports, "MultiUserPickerCell", () => $d1fe5055025d982b$export$900adf2a2bd19e48);

var $77o02 = parcelRequire("77o02");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $1b9aE = parcelRequire("1b9aE");

var $7jTnu = parcelRequire("7jTnu");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $d1fe5055025d982b$export$900adf2a2bd19e48 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $77o02.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1b9aE.MultiUserPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: isFirstField ? $d1fe5055025d982b$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1b9aE.MultiUserPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        menuPosition: "fixed",
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true
    });
};
const $d1fe5055025d982b$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d1fe5055025d982b$var$customTargetStyles,
        ref: ref
    });
});
const $d1fe5055025d982b$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("77o02", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ea2d558f592ea0c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4dc2f91c60665fe027d57b6a9920fbb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1ea2d558f592ea0c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "multiUserPicker_nativeIssueTable_MultiUserPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$1ea2d558f592ea0c$var$node.hash = "6a94b62d1ee5b9d8e348b0b01dee08ff";
var $1ea2d558f592ea0c$export$2e2bcd8739ae039 = $1ea2d558f592ea0c$var$node;

});

parcelRegister("1b9aE", function(module, exports) {

$parcel$export(module.exports, "MultiUserPickerInlineEditViewWithIsEditable", () => $bd008b5eaa50c36c$export$2d98458340508c60);

var $1vTZH = parcelRequire("1vTZH");

var $koE1D = parcelRequire("koE1D");

var $8bqDU = parcelRequire("8bqDU");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $22FmW = parcelRequire("22FmW");

var $flmqW = parcelRequire("flmqW");

var $8y7U1 = parcelRequire("8y7U1");

var $auNLL = parcelRequire("auNLL");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");
const $bd008b5eaa50c36c$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-multi-user-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $bd008b5eaa50c36c$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $bd008b5eaa50c36c$export$2d98458340508c60 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact' })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $8bqDU.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $koE1D.default));
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedUsersConnection: selectedUsersConnection, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedUsersConnection?.edges) return null;
        return selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
    }, [
        selectedUsersConnection?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((users, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(users);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: users?.map((user)=>user.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleSelectUserPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedUsersConnection: {
                                edges: users?.map((user)=>({
                                        node: {
                                            __typename: 'AtlassianAccountUser',
                                            ...user
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $bd008b5eaa50c36c$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiUserPicker'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd008b5eaa50c36c$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8y7U1.MultiUserPickerReadView), {
            fragmentRef: data
        })), [
        data
    ]);
    // #endregion
    // #region Edit view
    const transformedEditViewValue = (0, $eJOHy.useMemo)(()=>{
        if (!updatedValue) return null;
        return updatedValue.map((0, $22FmW.transformAggToUserOption));
    }, [
        updatedValue
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            value: transformedEditViewValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing,
            inputId: uniqueFieldId,
            ariaLabel: fieldName
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $flmqW.default),
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $bd008b5eaa50c36c$export$117723181a3f3b6b = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $1vTZH.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd008b5eaa50c36c$export$2d98458340508c60, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("1vTZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $49f2d17a28c1bbb2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c4638e38e1d56970af022bce2a6a8dc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $49f2d17a28c1bbb2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$49f2d17a28c1bbb2$var$node.hash = "cce81be96601eacce28b3398c7aff2e6";
var $49f2d17a28c1bbb2$export$2e2bcd8739ae039 = $49f2d17a28c1bbb2$var$node;

});

parcelRegister("koE1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $010de0568afd1352$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<66cd6416b55761810bcabaeaa23726f8>>
 * @relayHash c8257d74afaa8e2a4de1b61f4752e171
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71c4e49904469f656bf1a9edb542eb4f4a559d8a265dd802b3e7ae36a1a084cb
const $010de0568afd1352$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraUserConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedUsersConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraUserEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountId"
                                                                },
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountStatus"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "email"
                                                                        }
                                                                    ],
                                                                    "type": "AtlassianAccountUser"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71c4e49904469f656bf1a9edb542eb4f4a559d8a265dd802b3e7ae36a1a084cb",
            "metadata": {},
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$010de0568afd1352$var$node.hash = "66516ecfc9f74fa693150553eb2bae7f";
var $010de0568afd1352$export$2e2bcd8739ae039 = $010de0568afd1352$var$node;

});

parcelRegister("8bqDU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ead0575469c11ba7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<87c2e0fc25d3c82a0a376ce7418f273f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ead0575469c11ba7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "multiUserPicker_issueFieldMultiUserPickerReadviewFull_MultiUserPickerReadView"
            },
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountStatus"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleSelectUserPickerField"
    };
}();
$ead0575469c11ba7$var$node.hash = "b0466005c00a3d3242fa4c867100b929";
var $ead0575469c11ba7$export$2e2bcd8739ae039 = $ead0575469c11ba7$var$node;

});

parcelRegister("22FmW", function(module, exports) {

$parcel$export(module.exports, "transformAggToUserOption", () => $0a955f742f9dce61$export$e466b9791a3fee63);
const $0a955f742f9dce61$export$e466b9791a3fee63 = (user)=>({
        avatarUrl: user.picture,
        id: user.id,
        accountId: user.accountId,
        name: user.name,
        active: user.accountStatus === 'active',
        byline: user.email ?? undefined
    });

});

parcelRegister("flmqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8227025ef6ca891a$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $8227025ef6ca891a$var$MultiUserPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("KZdm6")), {
        moduleId: "d8224b35",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $8227025ef6ca891a$export$2e2bcd8739ae039 = $8227025ef6ca891a$var$MultiUserPickerEditViewEntryPoint;

});
parcelRegister("KZdm6", function(module, exports) {

let $08d3c7e65830ba5f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $08d3c7e65830ba5f$var$load("74Iit").then(()=>parcelRequire('dfmeK'));

});


parcelRegister("8y7U1", function(module, exports) {

$parcel$export(module.exports, "MultiUserPickerReadView", () => $84ea473a7b6539c0$export$183c102b43ea6c63);

var $62qvA = parcelRequire("62qvA");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gqBnP = parcelRequire("gqBnP");

var $d9T1A = parcelRequire("d9T1A");
const $84ea473a7b6539c0$export$183c102b43ea6c63 = ({ fragmentRef: fragmentRef })=>{
    const { selectedUsersConnection: selectedUsersConnection } = (0, $j4oe4.useFragment)((0, $62qvA.default), fragmentRef);
    const transformedData = (0, $eJOHy.useMemo)(()=>{
        const filteredEdges = selectedUsersConnection?.edges?.filter((edge)=>Boolean(edge?.node)) ?? [];
        return filteredEdges.map((edge)=>({
                name: edge.node.name,
                key: edge.node.accountId,
                src: edge.node.picture
            }));
    }, [
        selectedUsersConnection?.edges
    ]);
    if (transformedData.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        data: transformedData,
        size: "small"
    });
};

});
parcelRegister("62qvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd8c043d1d313584$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f931ef21191ed67113fe4de202f1f6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dd8c043d1d313584$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiUserPicker_issueFieldMultiUserPickerReadviewFull_MultiUserPickerReadView",
    "selections": [
        {
            "concreteType": "JiraUserConnection",
            "kind": "LinkedField",
            "name": "selectedUsersConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$dd8c043d1d313584$var$node.hash = "9a92e933723ed56c13d8c6b22c70828b";
var $dd8c043d1d313584$export$2e2bcd8739ae039 = $dd8c043d1d313584$var$node;

});




parcelRegister("dpp73", function(module, exports) {

$parcel$export(module.exports, "ConfluencePagesCell", () => $f81358b422e5dcee$export$486bd1bbeaa77e1b);

var $gIeV7 = parcelRequire("gIeV7");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lIUOF = parcelRequire("lIUOF");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");
const $f81358b422e5dcee$export$486bd1bbeaa77e1b = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $gIeV7.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldTruncate = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lIUOF.ConfluencePagesInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        isTruncated: shouldTruncate,
        menuPosition: "fixed",
        readViewFitContainerHeight: true
    });
};

});
parcelRegister("gIeV7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9adc9ef523e6bece$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f9be0af5fe3d8171a37c5def43a971c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9adc9ef523e6bece$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "confluencePages_nativeIssueTable_ConfluencePagesCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraConfluenceRemoteIssueLinksField"
};
$9adc9ef523e6bece$var$node.hash = "0ec3d60cde87b4245ca941ac347b32b8";
var $9adc9ef523e6bece$export$2e2bcd8739ae039 = $9adc9ef523e6bece$var$node;

});

parcelRegister("lIUOF", function(module, exports) {

$parcel$export(module.exports, "ConfluencePagesInlineEditViewWithIsEditable", () => $cdb3021b77eb3aaa$export$efa01917dd201830);

var $IEFvw = parcelRequire("IEFvw");

var $5dE3S = parcelRequire("5dE3S");

var $kxS3D = parcelRequire("kxS3D");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $42SRb = parcelRequire("42SRb");

var $gGrR8 = parcelRequire("gGrR8");
const $cdb3021b77eb3aaa$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-confluence-pages-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $cdb3021b77eb3aaa$var$isEqualOption = (a, b)=>{
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.url));
    return b.every((option)=>aIdSet.has(option.url));
};
const $cdb3021b77eb3aaa$export$efa01917dd201830 = ({ editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $kxS3D.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $5dE3S.default));
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: fieldName, type: fieldType, confluenceRemoteIssueLinks: confluenceRemoteIssueLinks } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>confluenceRemoteIssueLinks?.edges?.map((edge)=>edge?.node).filter(Boolean).map((node)=>({
                id: node.id,
                url: node.href ?? ''
            })) ?? [], [
        confluenceRemoteIssueLinks
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            // Retain the ID of existing linked pages and use the URL for new links to add.
                            links: value.map(({ id: id, url: url })=>id ? {
                                    id: id
                                } : {
                                    href: url
                                }),
                            operation: 'SET'
                        }
                    ]
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateConfluenceRemoteIssueLinksField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateConfluenceRemoteIssueLinksField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            confluenceRemoteIssueLinks: {
                                totalCount: value.length,
                                edges: value.map((option)=>({
                                        node: {
                                            id: option.id ?? (0, $aXKmr.v4)(),
                                            href: option.url
                                        }
                                    }))
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $cdb3021b77eb3aaa$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdb3021b77eb3aaa$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gGrR8.ConfluencePagesReadView), {
            isTruncated: isTruncated,
            fragmentRef: data
        }));
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            initialIsOpen: true,
            value: updatedValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            spacing: spacing
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $42SRb.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isTruncated,
        hideActionButtons: true
    });
};
const $cdb3021b77eb3aaa$export$f4b4c94c27bd1239 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $IEFvw.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdb3021b77eb3aaa$export$efa01917dd201830, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("IEFvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2f79f746b9faa3d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af30466501d29bf9367df09283f83219>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d2f79f746b9faa3d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraConfluenceRemoteIssueLinksField"
};
$d2f79f746b9faa3d$var$node.hash = "b82ba55e135c40c22b29327df36827d2";
var $d2f79f746b9faa3d$export$2e2bcd8739ae039 = $d2f79f746b9faa3d$var$node;

});

parcelRegister("5dE3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $79ee585cf2db4239$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<46f34e0dbaff7a790931598d5eb80697>>
 * @relayHash 71362fb7aaa6d0429d2aed33d89eb4ee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9675e340b6bb104d22e83d06403274891cc1b875c55fa638ac9c04906108c4f9
const $79ee585cf2db4239$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraConfluenceRemoteIssueLink",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "href"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateConfluenceRemoteIssueLinksFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateConfluenceRemoteIssueLinksField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraConfluenceRemoteIssueLinksField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView"
                                        },
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "confluenceRemoteIssueLinks",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateConfluenceRemoteIssueLinksFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateConfluenceRemoteIssueLinksField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraConfluenceRemoteIssueLinksField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "confluenceRemoteIssueLinks",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                }
                                            ],
                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9675e340b6bb104d22e83d06403274891cc1b875c55fa638ac9c04906108c4f9",
            "metadata": {},
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$79ee585cf2db4239$var$node.hash = "a9a457b54100bc9a68a78acaa2bbf10f";
var $79ee585cf2db4239$export$2e2bcd8739ae039 = $79ee585cf2db4239$var$node;

});

parcelRegister("kxS3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb40e5316ae8e3d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<16818de4fc298571f8a5370d99c1798e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $eb40e5316ae8e3d4$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "href"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            }
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    };
}();
$eb40e5316ae8e3d4$var$node.hash = "0f9e69e7f6f14ef254011afc14f3f8bc";
var $eb40e5316ae8e3d4$export$2e2bcd8739ae039 = $eb40e5316ae8e3d4$var$node;

});

parcelRegister("42SRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $10e6d0a5d209f87f$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $10e6d0a5d209f87f$var$ConfluencePagesEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("iKJuU")), {
        moduleId: "7aa734f7",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $10e6d0a5d209f87f$export$2e2bcd8739ae039 = $10e6d0a5d209f87f$var$ConfluencePagesEditViewEntryPoint;

});
parcelRegister("iKJuU", function(module, exports) {

let $da6fd0ba09b99fa9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $da6fd0ba09b99fa9$var$load("ffQaD"),
    $da6fd0ba09b99fa9$var$load("kvRbA"),
    $da6fd0ba09b99fa9$var$load("76n7a"),
    $da6fd0ba09b99fa9$var$load("l253H"),
    $da6fd0ba09b99fa9$var$load("dZaje")
]).then(()=>parcelRequire('c3eOq'));

});


parcelRegister("gGrR8", function(module, exports) {

$parcel$export(module.exports, "ConfluencePagesReadView", () => $127aee618b583128$export$10de55138ce5421b);

var $5FcwY = parcelRequire("5FcwY");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8lb7o = parcelRequire("8lb7o");

var $lRq8t = parcelRequire("lRq8t");

var $3PRLs = parcelRequire("3PRLs");

var $eQdsc = parcelRequire("eQdsc");

var $43xuA = parcelRequire("43xuA");
const $127aee618b583128$export$10de55138ce5421b = ({ fragmentRef: fragmentRef, isTruncated: isTruncated = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { confluenceRemoteIssueLinks: confluenceRemoteIssueLinks } = (0, $j4oe4.useFragment)((0, $5FcwY.default), fragmentRef);
    const totalCount = confluenceRemoteIssueLinks?.totalCount ?? 0;
    const node = confluenceRemoteIssueLinks?.edges?.[0]?.node;
    const popupContentProps = (0, $eJOHy.useMemo)(()=>confluenceRemoteIssueLinks ? {
            fragmentRef: confluenceRemoteIssueLinks
        } : null, [
        confluenceRemoteIssueLinks
    ]);
    if (!popupContentProps || !node || totalCount === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lb7o.ItemWithEntryPointPopup), {
        ItemComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
            anchorTarget: "_blank",
            url: node.href ?? ''
        }),
        totalItems: Math.min(totalCount, 1000),
        entryPoint: (0, $eQdsc.confluencePagesPopupContentEntryPoint),
        entryPointParams: {},
        entryPointRuntimeProps: popupContentProps,
        showMoreTooltip: formatMessage((0, $43xuA.default).showMore),
        actionSubjectIdPrefix: "confluencePages",
        isTruncated: isTruncated
    });
};

});
parcelRegister("5FcwY", function(module, exports) {

$parcel$export(module.exports, "default", () => $af30a5c414eac913$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c91a79ca0472abe266a7e6cd7908dc4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $af30a5c414eac913$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
            "kind": "LinkedField",
            "name": "confluenceRemoteIssueLinks",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "popupContent_issueFieldConfluencePagesReadviewFull"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                {
                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraConfluenceRemoteIssueLink",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "href"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
        }
    ],
    "type": "JiraConfluenceRemoteIssueLinksField"
};
$af30a5c414eac913$var$node.hash = "9339f5dfa3bce053620f77695601921b";
var $af30a5c414eac913$export$2e2bcd8739ae039 = $af30a5c414eac913$var$node;

});

parcelRegister("eQdsc", function(module, exports) {

$parcel$export(module.exports, "confluencePagesPopupContentEntryPoint", () => $4cc0ba0819c90cbd$export$a98f421071b5b6ae);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $4cc0ba0819c90cbd$export$a98f421071b5b6ae = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dId82")), {
        moduleId: "5019f0bb",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dId82", function(module, exports) {

let $9fb9917f23b8ab10$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9fb9917f23b8ab10$var$load("bJbeT").then(()=>parcelRequire('4sxUW'));

});


parcelRegister("43xuA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf8902fe0b4f33fd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bf8902fe0b4f33fd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showMore: {
        "id": "confluence-pages-readview-full.ui.confluence-pages.show-more",
        "defaultMessage": "Show more"
    }
});

});




parcelRegister("idXX1", function(module, exports) {

$parcel$export(module.exports, "NumberCell", () => $27352ee5b21d6d85$export$da27302eef6199ea);

var $9KcNX = parcelRequire("9KcNX");

var $fpBby = parcelRequire("fpBby");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $wZ00q = parcelRequire("wZ00q");

var $lgXDp = parcelRequire("lgXDp");

var $7jTnu = parcelRequire("7jTnu");

var $j8Km1 = parcelRequire("j8Km1");

var $DZkM2 = parcelRequire("DZkM2");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $27352ee5b21d6d85$export$da27302eef6199ea = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $fpBby.default), fieldRef);
    const isSingleRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (data.isStoryPointField || data.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $DZkM2.StoryPointEstimateCell), {
        fieldRef: data,
        shouldRenderHoverPopover: isSingleRowHeightEnabled
    });
    return (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27352ee5b21d6d85$var$NumberInlineEditCell, {
        fieldRef: data,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled,
        isFirstField: isFirstField,
        hasDuplicates: hasDuplicates
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $wZ00q.NumberReadView), {
        fragmentRef: data,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled
    }));
});
const $27352ee5b21d6d85$var$NumberInlineEditCell = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isSingleRowHeightEnabled: isSingleRowHeightEnabled, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $9KcNX.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgXDp.NumberInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: isFirstField ? $27352ee5b21d6d85$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSingleRowHeightEnabled: isFirstField && isSingleRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgXDp.NumberInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled
    });
});
const $27352ee5b21d6d85$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $27352ee5b21d6d85$var$customTargetStyles,
        ref: ref
    });
});
const $27352ee5b21d6d85$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("9KcNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea8b15b708e9a114$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebb1fbf47d4719bad13771f2800b5f8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea8b15b708e9a114$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "number_nativeIssueTable_NumberInlineEditCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraNumberField"
};
$ea8b15b708e9a114$var$node.hash = "8c280da2215ac59fe486945cc9e551a9";
var $ea8b15b708e9a114$export$2e2bcd8739ae039 = $ea8b15b708e9a114$var$node;

});

parcelRegister("fpBby", function(module, exports) {

$parcel$export(module.exports, "default", () => $b40ab404e8d7c222$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<17e7b3bb588145775d0b366cc52edffd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b40ab404e8d7c222$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "number_nativeIssueTable_NumberCell_fieldRef",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "number_issueFieldNumberReadviewFull_NumberReadView"
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": v0 /*: any*/ ,
                        "kind": "FragmentSpread",
                        "name": "number_nativeIssueTable_NumberInlineEditCell_fieldRef"
                    }
                ]
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "storyPointEstimate_nativeIssueTable_StoryPointEstimateCell"
            }
        ],
        "type": "JiraNumberField"
    };
}();
$b40ab404e8d7c222$var$node.hash = "a39feb75905be7bc84dc70d725916c5e";
var $b40ab404e8d7c222$export$2e2bcd8739ae039 = $b40ab404e8d7c222$var$node;

});

parcelRegister("wZ00q", function(module, exports) {

$parcel$export(module.exports, "NumberReadView", () => $4a1db8e5c57729b2$export$9267d0b69e52e344);

var $jLSzN = parcelRequire("jLSzN");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $jd93d = parcelRequire("jd93d");

var $lRq8t = parcelRequire("lRq8t");

var $2cfd4 = parcelRequire("2cfd4");

var $d9T1A = parcelRequire("d9T1A");

var $9Mapt = parcelRequire("9Mapt");

var $g5wv4 = parcelRequire("g5wv4");

var $tYLUh = parcelRequire("tYLUh");

var $7jTnu = parcelRequire("7jTnu");

var $3OT15 = parcelRequire("3OT15");

var $kTUE3 = parcelRequire("kTUE3");
const $4a1db8e5c57729b2$export$9267d0b69e52e344 = ({ fragmentRef: fragmentRef, isSingleRowHeightEnabled: isSingleRowHeightEnabled = false })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $kTUE3.default).noValueTextExperiment);
    const contentRef = (0, $eJOHy.useRef)(null);
    const locale = (0, $2cfd4.useLocale)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const fieldData = (0, $j4oe4.useFragment)((0, $jLSzN.default), fragmentRef);
    const hoverPopoverRefFactory = isSingleRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(fieldData.id) : null;
    let hoverPopoverRef = null;
    const { number: number, formatConfig: formatConfig } = fieldData;
    const numberContent = formatConfig && formatConfig.formatStyle && (0, $7jTnu.fg)('frontier-currency-field-d1') ? (0, $g5wv4.formatNumberField)(number ?? 0, {
        formatStyle: formatConfig.formatStyle,
        formatUnit: formatConfig.formatUnit,
        locale: locale
    }) : formatNumber(number ?? 0);
    const children = number === null || number === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    }) : numberContent;
    if (isSingleRowHeightEnabled) {
        if ((0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) {
            if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
                content: numberContent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                testId: "issue-field-number-readview-full.ui.number.text",
                ref: hoverPopoverRef,
                maxLines: 1
            }, children);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            contentRef: contentRef,
            content: numberContent
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                testId: "issue-field-number-readview-full.ui.number.text",
                ref: (0, $jd93d.mergeRefs)(contentRef, ref),
                maxLines: 1
            }, children));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": "issue-field-number-readview-full.ui.number.span"
    }, children);
};

});
parcelRegister("jLSzN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad4f0360dff8dc0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<80fc515770cbf6fc33b92252586a9a12>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ad4f0360dff8dc0a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "number_issueFieldNumberReadviewFull_NumberReadView",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraNumberFieldFormatConfig",
                    "kind": "LinkedField",
                    "name": "formatConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "formatStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "formatUnit"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$ad4f0360dff8dc0a$var$node.hash = "17ae89f526f0d36866ade85f61dcad68";
var $ad4f0360dff8dc0a$export$2e2bcd8739ae039 = $ad4f0360dff8dc0a$var$node;

});

parcelRegister("g5wv4", function(module, exports) {

$parcel$export(module.exports, "formatDecimal", () => $9f3ef12a68cb7fc4$export$845857f28dc08744);
$parcel$export(module.exports, "formatNumberField", () => $9f3ef12a68cb7fc4$export$d390e3b8d1c21e01);
$parcel$export(module.exports, "isSidebarFormatConfigEnabled", () => $9f3ef12a68cb7fc4$export$3c854a930069a447);
$parcel$export(module.exports, "formatConfigFromAggJiraNumberFieldFormatConfig", () => $9f3ef12a68cb7fc4$export$29f524126725ba4b);

var $7jTnu = parcelRequire("7jTnu");

/**
 * This is due to Jira commonly using the POSIX format (using '_' for defining locales),
 * such as in jira/src/packages/platform/utils/constants/src/supported-locales.tsx,
 * whereas the Intl Javascript API requires locales to be in the IETF BCP 47 format.
 */ const $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat = (locale)=>{
    return locale.replace('_', '-');
};
// Converts strings to lower case while also preventing string literal types from being converted
// into the more general `string` type as the String.prototype.toLowerCase() method always returns
// a `string` type, even if the string is a string literal. For example:
// const string = 'CONSTANT'; // type is `'CONSTANT'`;
// string.toLowerCase() // returned type is `string`;
// toLowerCase(string) // returned type is `'constant'`;
const $9f3ef12a68cb7fc4$var$toLowerCase = (inputString)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return inputString.toLocaleLowerCase();
};
const $9f3ef12a68cb7fc4$var$isSupportedCurrencyCode = (currencyCode)=>{
    // Check if the currency code is supported
    return Intl.supportedValuesOf($9f3ef12a68cb7fc4$var$toLowerCase((0, $7b3dcdbff4fbb09a$export$a82896da99871ba4))).includes(currencyCode);
};
const $9f3ef12a68cb7fc4$var$isSupportedUnit = (unit)=>{
    // Check if the unit is supported
    return Intl.supportedValuesOf($9f3ef12a68cb7fc4$var$toLowerCase((0, $7b3dcdbff4fbb09a$export$83551de9ca24925e))).includes(unit);
};
const $9f3ef12a68cb7fc4$export$3dc27271f5d5c629 = (amount, config = {})=>{
    const { currencyCode: currencyCode = (0, $7b3dcdbff4fbb09a$export$c852e1f5bb177898), locale: locale, currencyDisplay: currencyDisplay = (0, $7b3dcdbff4fbb09a$export$b9e50a64e0ca3437), ...rest } = config;
    // Check if the currency code is supported. fall back to decimal format if not.
    const formatOptions = $9f3ef12a68cb7fc4$var$isSupportedCurrencyCode(currencyCode) ? {
        style: (0, $7b3dcdbff4fbb09a$export$a82896da99871ba4).toLocaleLowerCase(),
        currency: currencyCode,
        currencyDisplay: currencyDisplay,
        maximumFractionDigits: Number.isInteger(amount) ? 0 : undefined,
        ...rest
    } : {
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(amount ?? 0);
};
const $9f3ef12a68cb7fc4$export$32e6b1ae352e94d6 = (amount, config = {})=>{
    const { locale: locale, ...rest } = config;
    return new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), {
        ...rest,
        style: (0, $7b3dcdbff4fbb09a$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: (0, $7b3dcdbff4fbb09a$export$97f1ae291e87b4b2)
    }).format(amount ?? 0);
};
const $9f3ef12a68cb7fc4$export$bd39b96f71da1885 = (number, config = {})=>{
    const { unit: unit, locale: locale, ...rest } = config;
    // Check if the unit code is supported. fall back to decimal format if not.
    const formatOptions = unit && $9f3ef12a68cb7fc4$var$isSupportedUnit(unit) ? {
        style: (0, $7b3dcdbff4fbb09a$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: unit,
        ...rest
    } : {
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(number ?? 0);
};
const $9f3ef12a68cb7fc4$export$845857f28dc08744 = (number, config = {})=>{
    const formatter = new Intl.NumberFormat(config.locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(config.locale), {
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...config
    });
    return formatter.format(number ?? 0);
};
const $9f3ef12a68cb7fc4$export$d390e3b8d1c21e01 = (number, config = {
    formatStyle: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea)
})=>{
    const { formatStyle: formatStyle, formatUnit: formatUnit, locale: locale } = config;
    switch(formatStyle){
        case 0, $7b3dcdbff4fbb09a$export$a82896da99871ba4:
            return formatUnit ? $9f3ef12a68cb7fc4$export$3dc27271f5d5c629(number, {
                locale: locale,
                currencyCode: formatUnit
            }) : $9f3ef12a68cb7fc4$export$845857f28dc08744(number, {
                locale: locale
            });
        case 0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9:
            return $9f3ef12a68cb7fc4$export$32e6b1ae352e94d6(number, {
                locale: locale
            });
        case 0, $7b3dcdbff4fbb09a$export$83551de9ca24925e:
            return formatUnit ? $9f3ef12a68cb7fc4$export$bd39b96f71da1885(number, {
                locale: locale,
                unit: formatUnit
            }) : $9f3ef12a68cb7fc4$export$845857f28dc08744(number, {
                locale: locale
            });
        default:
            return $9f3ef12a68cb7fc4$export$845857f28dc08744(number);
    }
};
const $9f3ef12a68cb7fc4$export$3c854a930069a447 = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $7jTnu.fg)('frontier-currency-field-d1') && (0, $7jTnu.fg)('fields-settings-currency-field-display');
const $9f3ef12a68cb7fc4$var$formatStyleMapper = (jiraFormatStyle)=>{
    switch(jiraFormatStyle){
        case 'CURRENCY':
            return 0, $7b3dcdbff4fbb09a$export$a82896da99871ba4;
        case 'PERCENT':
            return 0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9;
        case 'UNIT':
            return 0, $7b3dcdbff4fbb09a$export$83551de9ca24925e;
        default:
            return 0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea;
    }
};
const $9f3ef12a68cb7fc4$export$29f524126725ba4b = (gqlFormatConfig)=>{
    const { formatDecimals: formatDecimals, formatStyle: formatStyle, formatUnit: formatUnit } = gqlFormatConfig || {};
    return {
        formatStyle: $9f3ef12a68cb7fc4$var$formatStyleMapper(formatStyle),
        formatUnit: formatUnit || null,
        formatDecimals: formatDecimals ?? null
    };
};

});
const $7b3dcdbff4fbb09a$export$c852e1f5bb177898 = 'USD';
const $7b3dcdbff4fbb09a$export$b9e50a64e0ca3437 = 'narrowSymbol';
const $7b3dcdbff4fbb09a$export$768e3e8e60d01cea = 'DECIMAL';
const $7b3dcdbff4fbb09a$export$a82896da99871ba4 = 'CURRENCY';
const $7b3dcdbff4fbb09a$export$e50c15d5408652a9 = 'PERCENT';
const $7b3dcdbff4fbb09a$export$83551de9ca24925e = 'UNIT';
const $7b3dcdbff4fbb09a$export$e0f41b79f8d902b5 = 'liter';
const $7b3dcdbff4fbb09a$export$83a33c313ebf2c4a = 'meter';
const $7b3dcdbff4fbb09a$export$32fca264df3a7957 = 'kilogram';
const $7b3dcdbff4fbb09a$export$97f1ae291e87b4b2 = 'percent';


parcelRegister("kTUE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $43ed06390f00aff2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $43ed06390f00aff2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-number-readview-full.number.no-value-text-experiment",
        "defaultMessage": "Add number"
    }
});

});


parcelRegister("lgXDp", function(module, exports) {

$parcel$export(module.exports, "NumberInlineEditViewWithIsEditable", () => $1cd2ec746a518e4f$export$96ce9815e2ea97b5);
$parcel$export(module.exports, "NumberInlineEditView", () => $1cd2ec746a518e4f$export$47665260b410f801);

var $iv0Ul = parcelRequire("iv0Ul");

var $8pwvP = parcelRequire("8pwvP");

var $kSJZ2 = parcelRequire("kSJZ2");

var $k8EDV = parcelRequire("k8EDV");

var $kqtM5 = parcelRequire("kqtM5");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $16sa1 = parcelRequire("16sa1");

var $1uIew = parcelRequire("1uIew");

var $lRq8t = parcelRequire("lRq8t");

var $3x6NA = parcelRequire("3x6NA");

var $auNLL = parcelRequire("auNLL");

var $7iVmZ = parcelRequire("7iVmZ");

var $daGbj = parcelRequire("daGbj");

var $70nnk = parcelRequire("70nnk");

var $2Sipn = parcelRequire("2Sipn");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $bJscI = parcelRequire("bJscI");

var $wZ00q = parcelRequire("wZ00q");

var $8c3Yt = parcelRequire("8c3Yt");

var $gCeeo = parcelRequire("gCeeo");

var $46gnV = parcelRequire("46gnV");
const $1cd2ec746a518e4f$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-number-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $1cd2ec746a518e4f$export$43034831b58d2012 = ({ fragmentRef: fragmentRef, isEditing: isEditingDefault = false, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onEnter: onEnter, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed })=>{
    const data = (0, $j4oe4.useFragment)((0, $kqtM5.default), fragmentRef);
    const { id: uniqueFieldId, number: value, name: name } = data;
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const [commit] = (0, $j4oe4.useMutation)((0, $k8EDV.default));
    const [isEditing, setIsEditing] = (0, $8c3Yt.useOptionallyControlledEditingState)(isEditingDefault, uniqueFieldId);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(value);
    const isFieldEditable = overriding.overrideIsEditable(data.fieldConfig?.isEditable ?? false);
    (0, $eJOHy.useEffect)(()=>{
        if (error) setIsEditing(true);
        if (!isEditing) setUpdatedValue(value);
    }, [
        error,
        isEditing,
        value,
        setIsEditing
    ]);
    const save = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        if (updatedValue !== value) commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        number: updatedValue
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateNumberField) {
                    const { success: success, errors: responseErrors, field: field } = mutationData.jira?.updateNumberField;
                    if (success == null || success === false) {
                        if (responseErrors != null && responseErrors.length > 0) {
                            if (responseErrors[0].message && (0, $7jTnu.fg)('relay-migration-issue-fields-number')) setError(new (0, $1uIew.ValidationError)(responseErrors[0].message != null ? responseErrors[0].message : 'Relay error encountered while updating number field'));
                            else setError(new Error(responseErrors[0].message != null ? responseErrors[0].message : 'Relay error encountered while updating number field'));
                        } else setError(new Error('Relay error encountered while updating number field'));
                    } else if (success && field != null) {
                        onSubmitSucceeded && onSubmitSucceeded(field.number);
                        setIsEditing(false);
                    }
                }
            },
            onError: (incomingError)=>{
                setError(incomingError);
                onSubmitFailed?.();
            },
            optimisticResponse: {
                jira: {
                    updateNumberField: {
                        success: true,
                        errors: [],
                        field: {
                            id: uniqueFieldId,
                            number: updatedValue != null ? updatedValue : null
                        }
                    }
                }
            },
            optimisticUpdater: ()=>{
                setIsEditing(false);
            }
        });
        else setIsEditing(false);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
    }, [
        updatedValue,
        value,
        commit,
        uniqueFieldId,
        onSubmitSucceeded,
        setIsEditing,
        onSubmitFailed
    ]);
    const cancel = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        setError(null);
        setIsEditing(false);
        setUpdatedValue(value);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
    }, [
        setError,
        setIsEditing,
        value
    ]);
    const onCancelRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        onCancel,
        cancel
    ]);
    const onConfirmRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onSubmit?.(updatedValue);
    }, [
        onSubmit,
        save,
        updatedValue
    ]);
    const onEditRequested = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit,
        setIsEditing
    ]);
    const onEscapeRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const onEnterRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        onEnter && onEnter(analyticsEvent);
    }, [
        onEnter
    ]);
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        setError(null);
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        setUpdatedValue(typedValue);
    }, [
        setError,
        setUpdatedValue
    ]);
    const renderEditView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $70nnk.NumberEditView), {
            label: name,
            defaultValue: updatedValue,
            isInvalid: !!error,
            onChange: onChange
        });
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cd2ec746a518e4f$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iVmZ.ReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $wZ00q.NumberReadView), {
            fragmentRef: data
        })));
    const InlineEditWrapper = isFieldEditable ? (0, $7iVmZ.InlineEditContainer) : $1cd2ec746a518e4f$var$NumberInlineEditContainer;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3x6NA.ErrorFlag), {
        description: (0, $46gnV.default).errorMessage,
        error: error,
        title: formatMessage((0, $46gnV.default).errorTitleWithFieldName, {
            fieldName: data.name
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InlineEditWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $daGbj.FieldInlineEditStateLess), {
        actionSubject: "numberInlineEdit",
        defaultValue: updatedValue,
        editView: renderEditView,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        readView: renderReadView,
        testId: "issue-field-number-inline-edit-full.ui.number.issue-field-number",
        fieldId: uniqueFieldId,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequested,
        onEnter: onEnterRequest,
        onEscape: onEscapeRequest
    })));
};
const $1cd2ec746a518e4f$export$96ce9815e2ea97b5 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, editViewPopupWidth: editViewPopupWidth, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, isSingleRowHeightEnabled: isSingleRowHeightEnabled })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $kSJZ2.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, name: fieldName, type: type, number: initialValue, formatConfig: formatConfig } = data;
    const [commit] = (0, $j4oe4.useMutation)((0, $8pwvP.default)); // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const isFieldEditable = overriding.overrideIsEditable(isEditable ?? false); // #endregion
    // #region Handle new value
    const handleSubmit = (0, $eJOHy.useCallback)((newNumber, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newNumber);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        number: newNumber
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateNumberField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateNumberField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            number: newNumber
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const getFormatConfigAnalyticsAttributes = (0, $eJOHy.useCallback)(()=>formatConfig ? {
            formatStyle: formatConfig.formatStyle,
            formatUnit: formatConfig.formatUnit
        } : {}, [
        formatConfig
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: {
            ...attributes,
            ...getFormatConfigAnalyticsAttributes()
        },
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        clipboardComponentType: 'numberNullable',
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue
    });
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        handleChange(typedValue);
    }, [
        handleChange
    ]); // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cd2ec746a518e4f$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $wZ00q.NumberReadView), {
            fragmentRef: data,
            isSingleRowHeightEnabled: isSingleRowHeightEnabled
        })); // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            label: fieldName,
            defaultValue: updatedValue,
            onChange: onChange,
            spacing: spacing
        }); // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $2Sipn.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isSingleRowHeightEnabled
    });
};
const $1cd2ec746a518e4f$export$5a1b6dba6957de98 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $iv0Ul.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cd2ec746a518e4f$export$96ce9815e2ea97b5, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $1cd2ec746a518e4f$export$47665260b410f801 = (0, $bJscI.componentWithFG)('jsc_inline_editing_field_refactor', $1cd2ec746a518e4f$export$5a1b6dba6957de98, $1cd2ec746a518e4f$export$43034831b58d2012);
const $1cd2ec746a518e4f$var$readViewContainerSelectorName = 'jira-issue-field-inline-edit-read-view-container';
const $1cd2ec746a518e4f$var$READ_VIEW_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$1cd2ec746a518e4f$var$readViewContainerSelectorName}"]`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cd2ec746a518e4f$var$NumberInlineEditContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $7iVmZ.InlineEditContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qi2wt _u5f3idpf _n3tdi2wt _19bvidpf _1ltvidpf _1bch1skh _1yb1idpf _79pa1l7b _1rhwyh40 _1bt6idpf _f8epkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iv0Ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5771a32d8262b74$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a41ce353c1fbfcb9b34059e57d9a6b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f5771a32d8262b74$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewNew_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$f5771a32d8262b74$var$node.hash = "208597408b836a196e2e432d65098e64";
var $f5771a32d8262b74$export$2e2bcd8739ae039 = $f5771a32d8262b74$var$node;

});

parcelRegister("8pwvP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7278133da95b693$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9eac824a5d526dbdcbe1b4f030e7c4b8>>
 * @relayHash bac56b5a15fe2bdd371f393834598764
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9b5e7ad81080c3ef0caaf8a1945246c94639ab4dd9c2bfabbb0adde00cb670
const $a7278133da95b693$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraNumberFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateNumberField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraNumberField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5b9b5e7ad81080c3ef0caaf8a1945246c94639ab4dd9c2bfabbb0adde00cb670",
            "metadata": {},
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a7278133da95b693$var$node.hash = "229bc4c46fc83a0e7aaf848fb3a4b543";
var $a7278133da95b693$export$2e2bcd8739ae039 = $a7278133da95b693$var$node;

});

parcelRegister("kSJZ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9be423b8dc624296$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<551dba2675f09b90c1ded9ed27d88d82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9be423b8dc624296$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberReadviewFull_NumberReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraNumberFieldFormatConfig",
                    "kind": "LinkedField",
                    "name": "formatConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "formatStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "formatUnit"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$9be423b8dc624296$var$node.hash = "b1237a150436223d181b77d20b811582";
var $9be423b8dc624296$export$2e2bcd8739ae039 = $9be423b8dc624296$var$node;

});

parcelRegister("k8EDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f3bb18d574b40bc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef48d192981f0f268b9ad7c92dd887db>>
 * @relayHash c8e36dd3f69248a71385ba85e14baf53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11a4a1773edd0bed1ab5a91c27491612d6e74bcc2831efc2008ec42047a543f2
const $3f3bb18d574b40bc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraNumberFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateNumberField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraNumberField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "number_issueFieldNumber_NumberFieldOld_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "number_issueFieldNumber_NumberFieldOld_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "11a4a1773edd0bed1ab5a91c27491612d6e74bcc2831efc2008ec42047a543f2",
            "metadata": {},
            "name": "number_issueFieldNumber_NumberFieldOld_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3f3bb18d574b40bc$var$node.hash = "ac912bce87973eb366494b28c4298c64";
var $3f3bb18d574b40bc$export$2e2bcd8739ae039 = $3f3bb18d574b40bc$var$node;

});

parcelRegister("kqtM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $62e12a443b1028d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7b80001a3afd1cda2239b0d08823ccf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $62e12a443b1028d5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewOld_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberReadviewFull_NumberReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$62e12a443b1028d5$var$node.hash = "30654c0fb3d781e263ba3a0f270acaf3";
var $62e12a443b1028d5$export$2e2bcd8739ae039 = $62e12a443b1028d5$var$node;

});

parcelRegister("70nnk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "NumberEditView", () => $df9130d45ac633fa$export$a377d188591c514b);
$parcel$export(module.exports, "default", () => $df9130d45ac633fa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jkYbX = parcelRequire("jkYbX");

var $sY9BV = parcelRequire("sY9BV");

var $7jTnu = parcelRequire("7jTnu");

const $df9130d45ac633fa$export$a377d188591c514b = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { defaultValue: defaultValue, isInvalid: isInvalid = false, autoFocus: autoFocus = true, isDisabled: isDisabled = false, showWarningIconWhenInvalid: showWarningIconWhenInvalid = true, onWheel: onWheel, onChange: onChange, onBlur: onBlur, onFocus: onFocus, ariaLabelledBy: ariaLabelledBy, label: label, spacing: spacing } = props;
    const value = defaultValue == null || defaultValue === '' ? '' : Number(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df9130d45ac633fa$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        ref: ref,
        "aria-labelledby": ariaLabelledBy,
        "aria-label": label,
        autoFocus: autoFocus,
        isCompact: spacing === 'compact',
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onFocus: (0, $7jTnu.fg)('inline_edit_read_view_container_target') ? onFocus : undefined,
        step: "any",
        type: "number",
        value: value,
        onWheel: onWheel,
        elemAfterInput: showWarningIconWhenInvalid === true && isInvalid === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df9130d45ac633fa$var$WarningWrapper, {
            "data-testid": (0, $7870b583bf999c2a$export$ac421571f56485b8)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
            label: "",
            color: "var(--ds-icon-warning, #E56910)",
            LEGACY_size: "medium",
            spacing: "spacious"
        })) : null,
        onChange: onChange,
        onBlur: onBlur
    }));
});
const $df9130d45ac633fa$var$NumberEditViewEntryPoint = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df9130d45ac633fa$export$a377d188591c514b, props);
var $df9130d45ac633fa$export$2e2bcd8739ae039 = $df9130d45ac633fa$var$NumberEditViewEntryPoint;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $df9130d45ac633fa$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _80om1wug",
            __cmplp.className
        ])
    });
});
const $df9130d45ac633fa$var$WarningWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0r5cr _2hwx1b66",
            __cmplp.className
        ])
    });
});

});
const $7870b583bf999c2a$export$ac421571f56485b8 = 'issue-field-number.edit.warning-icon';


parcelRegister("2Sipn", function(module, exports) {

$parcel$export(module.exports, "default", () => $386d161ba121aaff$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $386d161ba121aaff$var$NumberEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("70nnk"))), {
        moduleId: "ac3a36e0",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $386d161ba121aaff$export$2e2bcd8739ae039 = $386d161ba121aaff$var$NumberEditViewEntryPoint;

});

parcelRegister("46gnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b2e2738717c235e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3b2e2738717c235e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorTitleWithFieldName: {
        "id": "issue-field-number-inline-edit-full.number.error-title-with-field-name",
        "defaultMessage": "We couldn't set the {fieldName} value"
    },
    errorMessage: {
        "id": "issue-field-number-inline-edit-full.number.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("DZkM2", function(module, exports) {

$parcel$export(module.exports, "StoryPointEstimateCell", () => $cbcdb818ec5199bd$export$78dcdef75b89353b);

var $fYVoJ = parcelRequire("fYVoJ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $fzIah = parcelRequire("fzIah");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");
const $cbcdb818ec5199bd$export$78dcdef75b89353b = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $fYVoJ.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fzIah.StoryPointEstimateInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: shouldRenderHoverPopover
    });
});

});
parcelRegister("fYVoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed9bb45f64a95e9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70e48106f05bb968bcc0404240ec4f6b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8ed9bb45f64a95e9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "storyPointEstimate_nativeIssueTable_StoryPointEstimateCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraNumberField"
};
$8ed9bb45f64a95e9$var$node.hash = "cdb9181ba214ad4249622bb22a6ba8ed";
var $8ed9bb45f64a95e9$export$2e2bcd8739ae039 = $8ed9bb45f64a95e9$var$node;

});

parcelRegister("fzIah", function(module, exports) {

$parcel$export(module.exports, "StoryPointEstimateInlineEditViewIsEditable", () => $dcc00af3f4448d4a$export$d2c15e488724d3b6);
$parcel$export(module.exports, "StoryPointEstimateInlineEditView", () => $dcc00af3f4448d4a$export$53d82fd5560565fa);

var $7mEiF = parcelRequire("7mEiF");

var $h2t9f = parcelRequire("h2t9f");

var $h17EP = parcelRequire("h17EP");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3bSs8 = parcelRequire("3bSs8");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $2Sipn = parcelRequire("2Sipn");

var $8DpUN = parcelRequire("8DpUN");

var $814y1 = parcelRequire("814y1");
const $dcc00af3f4448d4a$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-story-point-estimate-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $dcc00af3f4448d4a$export$d2c15e488724d3b6 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isFieldEditable, isEditing: startWithEditViewOpen, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $h17EP.default), fragmentRef);
    const { id: uniqueFieldId, type: type, name: fieldName, number: initialValue } = data;
    const [commit] = (0, $j4oe4.useMutation)((0, $h2t9f.default));
    // #endregion
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        number: value
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateNumberField) {
                    const { success: success, errors: responseErrors, field: field } = mutationData.jira.updateNumberField;
                    if (success && field != null) onSuccess();
                    else {
                        const errorMessage = responseErrors?.[0]?.message;
                        onFail(new Error(errorMessage || 'Relay error encountered while updating number field'), // Display server error message in flag if it exists
                        errorMessage ?? undefined);
                    }
                }
            },
            onError: (incomingError)=>{
                onFail(incomingError);
            },
            optimisticResponse: {
                jira: {
                    updateNumberField: {
                        success: true,
                        errors: [],
                        field: {
                            id: uniqueFieldId,
                            number: value != null ? value : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleChange: handleChange, handleConfirm: handleConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        clipboardComponentType: 'numberNullable',
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        analyticsFieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE]
    });
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        handleChange(typedValue);
    }, [
        handleChange
    ]);
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcc00af3f4448d4a$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8DpUN.StoryPointEstimateReadView), {
            fragmentRef: data,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            label: fieldName,
            defaultValue: updatedValue,
            isInvalid: invalidMessage != null || hasServerValidationError,
            onChange: onChange
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $2Sipn.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage ?? undefined,
        isEditable: isFieldEditable,
        isEditing: isEditing || hasServerValidationError,
        keepEditViewOpenOnBlur: hasServerValidationError,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $dcc00af3f4448d4a$export$53d82fd5560565fa = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $7mEiF.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcc00af3f4448d4a$export$d2c15e488724d3b6, {
        ...props,
        fragmentRef: data,
        isEditable: data.isEditableInIssueView ?? false
    });
};

});
parcelRegister("7mEiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0f5f7536d0c260b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5a0439ffc3e7985b2ffc49200c7c91a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e0f5f7536d0c260b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef"
        },
        {
            "kind": "ScalarField",
            "name": "isEditableInIssueView"
        }
    ],
    "type": "JiraNumberField"
};
$e0f5f7536d0c260b$var$node.hash = "e4b34a649ef5dd8533f5cabe75fe48a9";
var $e0f5f7536d0c260b$export$2e2bcd8739ae039 = $e0f5f7536d0c260b$var$node;

});

parcelRegister("h2t9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $e75f603e5fe9e296$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3848ab8ba84307c52100812d34d678eb>>
 * @relayHash d31d751b8d2df6b00dba2227445c1922
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22c405c1466d19ac86bfc1ee91264decd40c73ed8fc34c324f886cba733f9321
const $e75f603e5fe9e296$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraNumberFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateNumberField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraNumberField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "22c405c1466d19ac86bfc1ee91264decd40c73ed8fc34c324f886cba733f9321",
            "metadata": {},
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e75f603e5fe9e296$var$node.hash = "cd8233b80d650588112eb0d15d581a9c";
var $e75f603e5fe9e296$export$2e2bcd8739ae039 = $e75f603e5fe9e296$var$node;

});

parcelRegister("h17EP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9179fa879450e87d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<104e7a7c30e42c208fb29f3aec68910d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9179fa879450e87d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraNumberField"
};
$9179fa879450e87d$var$node.hash = "c258cd7d5b4392c1e7419c5721e2a6cd";
var $9179fa879450e87d$export$2e2bcd8739ae039 = $9179fa879450e87d$var$node;

});

parcelRegister("8DpUN", function(module, exports) {

$parcel$export(module.exports, "StoryPointEstimateReadView", () => $0b1dd76fc20e2df8$export$29398521b1f444c1);

var $7FWhJ = parcelRequire("7FWhJ");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $7q9BG = parcelRequire("7q9BG");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $9Mapt = parcelRequire("9Mapt");

var $jd93d = parcelRequire("jd93d");

var $tYLUh = parcelRequire("tYLUh");

var $7jTnu = parcelRequire("7jTnu");

var $3OT15 = parcelRequire("3OT15");


var $dXaoD = parcelRequire("dXaoD");
const $0b1dd76fc20e2df8$export$29398521b1f444c1 = ({ fragmentRef: fragmentRef, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $dXaoD.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const data = (0, $j4oe4.useFragment)((0, $7FWhJ.default), fragmentRef);
    const { number: number } = data;
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldRenderHoverPopover && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (number === null || number === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $9449af9a14f793a7$export$d3d47c5f37010b20)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    }));
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: formatNumber(number)
    });
    if (shouldRenderHoverPopover) return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $9449af9a14f793a7$export$d3d47c5f37010b20)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0b1dd76fc20e2df8$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        testId: (0, $9449af9a14f793a7$export$3804bd7641b5a138)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: 1,
        ref: hoverPopoverRef
    }, formatNumber(number))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: formatNumber(number),
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
            "data-testid": (0, $9449af9a14f793a7$export$d3d47c5f37010b20)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0b1dd76fc20e2df8$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
            testId: (0, $9449af9a14f793a7$export$3804bd7641b5a138)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: 1,
            ref: (0, $jd93d.mergeRefs)(ref, contentRef)
        }, formatNumber(number))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $9449af9a14f793a7$export$d3d47c5f37010b20)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0b1dd76fc20e2df8$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        testId: (0, $9449af9a14f793a7$export$3804bd7641b5a138)
    }, formatNumber(number))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $0b1dd76fc20e2df8$var$BadgeWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_189eyh40 _1dqonqa1 _1h6d3acm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7FWhJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e9098bb4a75ed1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<701ae393984c3ec62918e5301aeed75b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95e9098bb4a75ed1$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraNumberField"
};
$95e9098bb4a75ed1$var$node.hash = "55c809aed02a493612e0bac6df522d64";
var $95e9098bb4a75ed1$export$2e2bcd8739ae039 = $95e9098bb4a75ed1$var$node;

});

const $9449af9a14f793a7$export$3804bd7641b5a138 = 'issue-field-story-point-estimate-readview-full.ui.story-point-estimate.badge';
const $9449af9a14f793a7$export$d3d47c5f37010b20 = 'issue-field-story-point-estimate-readview-full.ui.story-point-estimate';

parcelRegister("dXaoD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fde5f4779b82760$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0fde5f4779b82760$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-story-point-estimate-readview-full.story-point-estimate.no-value-text-experiment",
        "defaultMessage": "Add story points"
    }
});

});





parcelRegister("8nvWc", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateCell", () => $2958768ba2e9d6a8$export$6ffde629399d0fd4);

var $1OIMl = parcelRequire("1OIMl");

var $3pHuF = parcelRequire("3pHuF");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gCxgt = parcelRequire("gCxgt");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");
const $2958768ba2e9d6a8$export$6ffde629399d0fd4 = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    // NOTE: original estimate type is used to get timeTrackingField data, which is used in underlying original estimate decomposed field.
    const data = (0, $j4oe4.useFragment)((0, $3pHuF.default), fieldRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2958768ba2e9d6a8$var$OriginalEstimateTimeTrackingFieldCell, {
        fieldRef: data.issue?.timeTrackingField ?? null,
        isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover,
        issueFieldId: data.id
    });
};
const $2958768ba2e9d6a8$var$OriginalEstimateTimeTrackingFieldCell = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover, issueFieldId: issueFieldId })=>{
    const data = (0, $j4oe4.useFragment)((0, $1OIMl.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = data && 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data?.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gCxgt.OriginalEstimateInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data ?? null,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled,
        issueFieldId: issueFieldId
    });
};

});
parcelRegister("1OIMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ea1c79ce17da2af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc43b310bfeb98fe57b6af71c560fef1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9ea1c79ce17da2af$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraTimeTrackingField"
};
$9ea1c79ce17da2af$var$node.hash = "312db87c0c11a408da53829b2a0390aa";
var $9ea1c79ce17da2af$export$2e2bcd8739ae039 = $9ea1c79ce17da2af$var$node;

});

parcelRegister("3pHuF", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa27cd20f1bd07bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ff7d47ec86d8908f28c9c506b9372575>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa27cd20f1bd07bf$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "originalEstimate_nativeIssueTable_OriginalEstimateCell_fieldRef",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraTimeTrackingField",
                    "kind": "LinkedField",
                    "name": "timeTrackingField",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isInlineEditingEnabled",
                                    "variableName": "isInlineEditingEnabled"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraOriginalTimeEstimateField"
};
$aa27cd20f1bd07bf$var$node.hash = "5fa38d0731f78cb522f192e04368006b";
var $aa27cd20f1bd07bf$export$2e2bcd8739ae039 = $aa27cd20f1bd07bf$var$node;

});

parcelRegister("gCxgt", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateInlineEditViewIsEditable", () => $24cd2fcd185c750a$export$6b7ba0cc8e5fd10);
$parcel$export(module.exports, "OriginalEstimateInlineEditView", () => $24cd2fcd185c750a$export$63b1ca4384eabbd8);

var $e0J42 = parcelRequire("e0J42");

var $jtEOx = parcelRequire("jtEOx");

var $7m2ek = parcelRequire("7m2ek");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $auNLL = parcelRequire("auNLL");

var $flcqE = parcelRequire("flcqE");

var $iz9K8 = parcelRequire("iz9K8");

var $bWfD9 = parcelRequire("bWfD9");

var $8T4lL = parcelRequire("8T4lL");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $tYLUh = parcelRequire("tYLUh");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $gc7nM = parcelRequire("gc7nM");
const $24cd2fcd185c750a$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-original-estimate-lite-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $24cd2fcd185c750a$export$6b7ba0cc8e5fd10 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, spacing: spacing = 'compact', readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, isEditing: startWithEditViewOpen, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, shouldRenderHoverPopover: shouldRenderHoverPopover, issueFieldId: issueFieldId })=>{
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $7m2ek.default), fragmentRef);
    const { id: uniqueFieldId = '', name: name = '', fieldId: fieldId = '', type: fieldType = '', originalEstimate: originalEstimate, timeTrackingSettings: timeTrackingSettings } = data || {};
    const { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit } = timeTrackingSettings ?? {};
    const [commit] = (0, $j4oe4.useMutation)((0, $jtEOx.default));
    // #endregion
    // #region Common state
    const settingsInput = {
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek,
        defaultFormat: defaultFormat,
        defaultUnit: defaultUnit
    };
    const formatInputValue = (0, $bWfD9.useFormatInputValue)(settingsInput);
    const initialValue = (0, $eJOHy.useMemo)(()=>originalEstimate ? formatInputValue(originalEstimate.timeInSeconds ?? 0) : '', [
        formatInputValue,
        originalEstimate
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const validator = (0, $gc7nM.useOriginalEstimateValidator)(settingsInput);
    const parseTimeString = (0, $8T4lL.useParseTimeString)(settingsInput);
    const { overriding: { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } } = (0, $auNLL.useInlineEditFieldInjections)();
    const fieldName = overrideLabel(name);
    const isFieldEditable = overrideIsEditable(isEditable);
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        const timeInSeconds = parseTimeString(value) ?? 0;
        onSubmit?.(timeInSeconds);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    originalEstimate: {
                        timeInSeconds: timeInSeconds
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateTimeTrackingField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateTimeTrackingField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            originalEstimate: {
                                timeInSeconds: timeInSeconds
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        parseTimeString,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>onSubmitSucceeded?.(parseTimeString(value) ?? 0), [
        onSubmitSucceeded,
        parseTimeString
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        updatedValue: updatedValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        validator: validator,
        clipboardComponentType: 'originalEstimate'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24cd2fcd185c750a$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $flcqE.OriginalEstimateReadView), {
            fragmentRef: data ?? null,
            enableHover: isFieldEditable,
            shouldRenderHoverPopover: shouldRenderHoverPopover,
            issueFieldId: issueFieldId
        })), [
        data,
        isFieldEditable,
        shouldRenderHoverPopover,
        issueFieldId
    ]);
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        handleChange(event.target.value);
    }, [
        handleChange
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            ...isExperimentEnabled ? {
                value: updatedValue === '0m' ? undefined : updatedValue
            } : {
                value: updatedValue
            },
            spacing: spacing,
            onChange: onChange,
            isInvalid: Boolean(invalidMessage)
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $iz9K8.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage ?? undefined,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $24cd2fcd185c750a$export$63b1ca4384eabbd8 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $e0J42.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24cd2fcd185c750a$export$6b7ba0cc8e5fd10, {
        ...props,
        fragmentRef: data ?? null,
        isEditable: data?.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("e0J42", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ab545c2b3beed9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ecf5a6bb9641458cdf434ff38434eef3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b6ab545c2b3beed9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$b6ab545c2b3beed9$var$node.hash = "5e2d79baa2633a5005ef945a7c8b3f28";
var $b6ab545c2b3beed9$export$2e2bcd8739ae039 = $b6ab545c2b3beed9$var$node;

});

parcelRegister("jtEOx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfb2fe493b4c7340$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<81707b0a4ee0455bcaae6e531f239a91>>
 * @relayHash 3520cb3405bf5df677e699e027e38f90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d5f6fe91ca3eeb49cf1444c59cbc5edd8accf64f7e09b2f84426f70b4a476e13
const $bfb2fe493b4c7340$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraTimeTrackingFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateTimeTrackingField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraTimeTrackingField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "JiraEstimate",
                                    "kind": "LinkedField",
                                    "name": "originalEstimate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "timeInSeconds"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "d5f6fe91ca3eeb49cf1444c59cbc5edd8accf64f7e09b2f84426f70b4a476e13",
            "metadata": {},
            "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$bfb2fe493b4c7340$var$node.hash = "11dd5c5c4df23d2a67f16300cb79844d";
var $bfb2fe493b4c7340$export$2e2bcd8739ae039 = $bfb2fe493b4c7340$var$node;

});

parcelRegister("7m2ek", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf3e34bdf5ad7d0f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<552dc3a05ed5f6d783af14a0f4b74a40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cf3e34bdf5ad7d0f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "originalEstimate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$cf3e34bdf5ad7d0f$var$node.hash = "92ecace176224672cc8283c177c6cb95";
var $cf3e34bdf5ad7d0f$export$2e2bcd8739ae039 = $cf3e34bdf5ad7d0f$var$node;

});

parcelRegister("flcqE", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateReadView", () => $a23c3d9b42eb819c$export$9fbd5776dc81fee9);

var $dv0ed = parcelRequire("dv0ed");

var $dpKdw = parcelRequire("dpKdw");

var $c4LIf = parcelRequire("c4LIf");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $7q9BG = parcelRequire("7q9BG");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $tYLUh = parcelRequire("tYLUh");

var $d9T1A = parcelRequire("d9T1A");

var $7iVmZ = parcelRequire("7iVmZ");

var $kjvkS = parcelRequire("kjvkS");

var $7jTnu = parcelRequire("7jTnu");

var $9Mapt = parcelRequire("9Mapt");

var $jd93d = parcelRequire("jd93d");

var $3OT15 = parcelRequire("3OT15");

var $bWfD9 = parcelRequire("bWfD9");

var $9QjVb = parcelRequire("9QjVb");
const $a23c3d9b42eb819c$export$3ebe0d7f11c619e2 = ({ fragmentRef: fragmentRef, enableHover: enableHover = false })=>{
    const testId = 'issue-field-original-estimate-read-view';
    const data = (0, $j4oe4.useFragment)((0, $c4LIf.default), fragmentRef);
    const intl = (0, $lRq8t.default)();
    const value = data?.originalEstimate?.timeInSeconds;
    const noValueTextExperiment = intl.formatMessage((0, $9QjVb.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const readTimeString = (0, $eJOHy.useMemo)(()=>(0, $kjvkS.timeTrackingFormatterWithDefaults)(value || 0, {
            workingHoursPerDay: data?.timeTrackingSettings?.workingHoursPerDay,
            workingDaysPerWeek: data?.timeTrackingSettings?.workingDaysPerWeek,
            timeFormat: (0, $kjvkS.transformAGGToJiraTimeFormat)(data?.timeTrackingSettings?.defaultFormat),
            defaultUnit: (0, $kjvkS.transformAGGToJiraTimeUnit)(data?.timeTrackingSettings?.defaultUnit)
        }, intl), [
        intl,
        data?.timeTrackingSettings?.defaultFormat,
        data?.timeTrackingSettings?.defaultUnit,
        data?.timeTrackingSettings?.workingDaysPerWeek,
        data?.timeTrackingSettings?.workingHoursPerDay,
        value
    ]);
    const getRenderView = ()=>{
        const badge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
            testId: `${testId}.badge`
        }, readTimeString);
        if (enableHover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a23c3d9b42eb819c$var$HoverContainer, null, badge);
        return badge;
    };
    if (!value && isExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: noValueTextExperiment
    });
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a23c3d9b42eb819c$var$ReadViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a23c3d9b42eb819c$var$BadgeWrapper, {
        "data-testid": "issue-field-original-estimate-readview-full.ui.original-estimate.test-id"
    }, getRenderView()));
};
const $a23c3d9b42eb819c$export$99c86d7be9f97fdf = ({ fragmentRef: fragmentRef, shouldRenderHoverPopover: shouldRenderHoverPopover, issueFieldId: issueFieldId })=>{
    const data = (0, $j4oe4.useFragment)((0, $dpKdw.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $9QjVb.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const settingsInput = {
        workingHoursPerDay: data?.timeTrackingSettings?.workingHoursPerDay,
        workingDaysPerWeek: data?.timeTrackingSettings?.workingDaysPerWeek,
        defaultFormat: data?.timeTrackingSettings?.defaultFormat,
        defaultUnit: data?.timeTrackingSettings?.defaultUnit
    };
    const formatInputValue = (0, $bWfD9.useFormatInputValue)(settingsInput);
    const timeString = (0, $eJOHy.useMemo)(()=>data ? formatInputValue(data.originalEstimate?.timeInSeconds ?? 0) : null, [
        data,
        formatInputValue
    ]);
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverContentRefFactory = shouldRenderHoverPopover && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(issueFieldId) : null;
    let hoverPopoverContentRef = null;
    if (hoverPopoverContentRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverContentRef = hoverPopoverContentRefFactory({
        content: timeString
    });
    if (!data?.originalEstimate?.timeInSeconds && isExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: noValueTextExperiment
    });
    if (timeString === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (shouldRenderHoverPopover) return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // Empty div to allow ellipsis
    // eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: 1,
        ref: hoverPopoverContentRef
    }, timeString))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        contentRef: contentRef,
        content: timeString
    }, ({ ref: ref })=>// Empty div to allow ellipsis
        // eslint-disable-next-line jira/react/no-empty-divs
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: 1,
            ref: (0, $jd93d.mergeRefs)(ref, contentRef)
        }, timeString))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), null, timeString);
};
const $a23c3d9b42eb819c$export$9fbd5776dc81fee9 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)(/* eslint-disable @atlassian/relay/graphql-naming */ (0, $dv0ed.default), fragmentRef);
    if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a23c3d9b42eb819c$export$99c86d7be9f97fdf, {
        fragmentRef: data ?? null,
        ...props
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a23c3d9b42eb819c$export$3ebe0d7f11c619e2, {
        fragmentRef: data ?? null,
        ...props
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a23c3d9b42eb819c$var$ReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $7iVmZ.ReadViewContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_u5f3v77o _2hwx1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a23c3d9b42eb819c$var$HoverContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_80omtlke _vwz4gktf _ll8p16l4 _1lgi1hek",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a23c3d9b42eb819c$var$BadgeWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _kqswh2mm _19pk196n _otyr196n _2hwx1i6y _18u0v77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dv0ed", function(module, exports) {

$parcel$export(module.exports, "default", () => $e08bb88ce6cc7969$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<71daf17df2b5557176e7ee592688e383>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e08bb88ce6cc7969$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadView",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadViewNew_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadViewOld_fragmentRef"
        }
    ],
    "type": "JiraTimeTrackingField"
};
$e08bb88ce6cc7969$var$node.hash = "2a15c08b9114d781806c532c837870f5";
var $e08bb88ce6cc7969$export$2e2bcd8739ae039 = $e08bb88ce6cc7969$var$node;

});

parcelRegister("dpKdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $58e35dc67a340d65$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4af30c9e76ced09dc57a6f90a33ebb20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $58e35dc67a340d65$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadViewNew_fragmentRef",
    "selections": [
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "originalEstimate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$58e35dc67a340d65$var$node.hash = "a3476e4eb2e47d4faef4bffed9ccd3fe";
var $58e35dc67a340d65$export$2e2bcd8739ae039 = $58e35dc67a340d65$var$node;

});

parcelRegister("c4LIf", function(module, exports) {

$parcel$export(module.exports, "default", () => $816823b826ca927b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<df001974101b6e0f2a769d7013b44d6b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $816823b826ca927b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadViewOld_fragmentRef",
    "selections": [
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "originalEstimate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$816823b826ca927b$var$node.hash = "b4aba6775c0f3cf0df39e10598fc1144";
var $816823b826ca927b$export$2e2bcd8739ae039 = $816823b826ca927b$var$node;

});

parcelRegister("kjvkS", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $9d0512273747699d$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterWithDefaults", () => $9d0512273747699d$export$71be3aa954f6065b);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $9d0512273747699d$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $9d0512273747699d$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $9d0512273747699d$export$8516173ab945b52f);

var $iYiee = parcelRequire("iYiee");

var $b7Ydn = parcelRequire("b7Ydn");

var $hjbuK = parcelRequire("hjbuK");
const $9d0512273747699d$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $9d0512273747699d$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $9d0512273747699d$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $9d0512273747699d$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $9d0512273747699d$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $iYiee.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $hjbuK.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $b7Ydn.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $b7Ydn.default).timeUnitDay,
            transform: $9d0512273747699d$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $b7Ydn.default).timeUnitHour,
            transform: $9d0512273747699d$var$validate(isTimeValid),
            seconds: (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $b7Ydn.default).timeUnitMinute,
            seconds: (0, $iYiee.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $iYiee.TimeFormats).DAYS:
            return $9d0512273747699d$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $iYiee.TimeFormats).HOURS:
            return $9d0512273747699d$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $iYiee.TimeFormats).PRETTY:
        default:
            return $9d0512273747699d$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $9d0512273747699d$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $iYiee.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $iYiee.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $iYiee.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $iYiee.defaultTimeTrackingOptions).defaultUnit
    };
    return $9d0512273747699d$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $9d0512273747699d$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $iYiee.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $hjbuK.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $b7Ydn.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $b7Ydn.default).timeUnitLongDay,
            transform: $9d0512273747699d$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $b7Ydn.default).timeUnitLongHour,
            transform: $9d0512273747699d$var$validate(isTimeValid),
            seconds: (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $b7Ydn.default).timeUnitLongMinute,
            seconds: (0, $iYiee.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $iYiee.TimeFormats).DAYS:
            return $9d0512273747699d$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $iYiee.TimeFormats).HOURS:
            return $9d0512273747699d$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $iYiee.TimeFormats).PRETTY:
        default:
            return $9d0512273747699d$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $9d0512273747699d$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $iYiee.TimeFormats).DAYS:
            return (0, $iYiee.TimeFormats).DAYS;
        case (0, $iYiee.TimeFormats).HOURS:
            return (0, $iYiee.TimeFormats).HOURS;
        case (0, $iYiee.TimeFormats).PRETTY:
            return (0, $iYiee.TimeFormats).PRETTY;
        default:
            return (0, $iYiee.TimeFormats).DAYS;
    }
};
const $9d0512273747699d$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $iYiee.TimeUnits).DAY:
            return (0, $iYiee.TimeUnits).DAY;
        case (0, $iYiee.TimeUnits).HOUR:
            return (0, $iYiee.TimeUnits).HOUR;
        case (0, $iYiee.TimeUnits).MINUTE:
            return (0, $iYiee.TimeUnits).MINUTE;
        case (0, $iYiee.TimeUnits).WEEK:
            return (0, $iYiee.TimeUnits).WEEK;
        default:
            return (0, $iYiee.TimeUnits).DAY;
    }
};

});
parcelRegister("iYiee", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $8c530bce5cc29340$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $8c530bce5cc29340$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $8c530bce5cc29340$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $8c530bce5cc29340$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $8c530bce5cc29340$export$f8d48c1fed813e90);
const $8c530bce5cc29340$export$544c576050746347 = 60;
const $8c530bce5cc29340$var$MINUTES_PER_HOUR = 60;
const $8c530bce5cc29340$export$3cc7ae4b390f50a = $8c530bce5cc29340$var$MINUTES_PER_HOUR * $8c530bce5cc29340$export$544c576050746347;
const $8c530bce5cc29340$var$TIME_FORMAT_PRETTY = 'pretty';
const $8c530bce5cc29340$var$TIME_FORMAT_DAYS = 'days';
const $8c530bce5cc29340$var$TIME_FORMAT_HOURS = 'hours';
const $8c530bce5cc29340$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $8c530bce5cc29340$var$TIME_FORMAT_PRETTY,
    DAYS: $8c530bce5cc29340$var$TIME_FORMAT_DAYS,
    HOURS: $8c530bce5cc29340$var$TIME_FORMAT_HOURS
});
const $8c530bce5cc29340$var$TIME_UNIT_WEEK = 'week';
const $8c530bce5cc29340$var$TIME_UNIT_DAY = 'day';
const $8c530bce5cc29340$var$TIME_UNIT_HOUR = 'hour';
const $8c530bce5cc29340$var$TIME_UNIT_MINUTE = 'minute';
const $8c530bce5cc29340$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $8c530bce5cc29340$var$TIME_UNIT_WEEK,
    DAY: $8c530bce5cc29340$var$TIME_UNIT_DAY,
    HOUR: $8c530bce5cc29340$var$TIME_UNIT_HOUR,
    MINUTE: $8c530bce5cc29340$var$TIME_UNIT_MINUTE
});
const $8c530bce5cc29340$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $8c530bce5cc29340$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $8c530bce5cc29340$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("b7Ydn", function(module, exports) {

$parcel$export(module.exports, "default", () => $01af1416d2d590d9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $01af1416d2d590d9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("hjbuK", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $df66d7a8dfc617f8$export$aab44654646f3ccc);
const $df66d7a8dfc617f8$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});


parcelRegister("bWfD9", function(module, exports) {

$parcel$export(module.exports, "useFormatInputValue", () => $0d58d74844c77d4a$export$249a26bf47be0b0b);

var $eJOHy = parcelRequire("eJOHy");

var $kjvkS = parcelRequire("kjvkS");

var $lRq8t = parcelRequire("lRq8t");


var $5GvTs = parcelRequire("5GvTs");
const $0d58d74844c77d4a$var$toTimeFormat = (format)=>{
    return format ? (0, $5GvTs.toLowercaseTimeUnion)(format) : (0, $e1e7fb6a6c70503b$export$c4d2eaadfa3c28df);
};
const $0d58d74844c77d4a$var$toTimeUnit = (unit)=>{
    return unit ? (0, $5GvTs.toLowercaseTimeUnion)(unit) : (0, $e1e7fb6a6c70503b$export$2ee07242bbb09b61);
};
const $0d58d74844c77d4a$export$249a26bf47be0b0b = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit })=>{
    const intl = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)((value)=>{
        return (0, $kjvkS.timeTrackingFormatter)(value, {
            workingHoursPerDay: workingHoursPerDay || (0, $e1e7fb6a6c70503b$export$8c7070611f332ef9),
            workingDaysPerWeek: workingDaysPerWeek || (0, $e1e7fb6a6c70503b$export$21ed1f454652d913),
            timeFormat: $0d58d74844c77d4a$var$toTimeFormat(defaultFormat),
            defaultUnit: $0d58d74844c77d4a$var$toTimeUnit(defaultUnit)
        }, intl);
    }, [
        workingHoursPerDay,
        workingDaysPerWeek,
        defaultFormat,
        defaultUnit,
        intl
    ]);
};

});
const $e1e7fb6a6c70503b$export$8c7070611f332ef9 = 8;
const $e1e7fb6a6c70503b$export$21ed1f454652d913 = 5;
const $e1e7fb6a6c70503b$export$c4d2eaadfa3c28df = 'pretty';
const $e1e7fb6a6c70503b$export$2ee07242bbb09b61 = 'minute';

parcelRegister("5GvTs", function(module, exports) {

$parcel$export(module.exports, "toLowercaseTimeUnion", () => $2643f7fbf3114189$export$72046bdd228710d3);
// Exclude union value automatically added by Relay
// eslint-disable-next-line @atlassian/relay/no-future-added-value
const $2643f7fbf3114189$export$72046bdd228710d3 = (union)=>union.toLowerCase();

});


parcelRegister("9QjVb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a5a4811371f334c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0a5a4811371f334c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-original-estimate-readview-full.original-estimate.no-value-text-experiment",
        "defaultMessage": "Add estimate"
    }
});

});


parcelRegister("iz9K8", function(module, exports) {

$parcel$export(module.exports, "default", () => $309767fda67bd6c2$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $309767fda67bd6c2$var$OriginalEstimateEditViewWithFormattedValueEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hhiem")), {
        moduleId: "78b5a554",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $309767fda67bd6c2$export$2e2bcd8739ae039 = $309767fda67bd6c2$var$OriginalEstimateEditViewWithFormattedValueEntryPoint;

});
parcelRegister("hhiem", function(module, exports) {

let $c9422a6e33bec03d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c9422a6e33bec03d$var$load("74Sbn").then(()=>parcelRequire('fCAPY'));

});


parcelRegister("8T4lL", function(module, exports) {

$parcel$export(module.exports, "useValidateTimeString", () => $ffea187516977204$export$27badca43bbaa0e);
$parcel$export(module.exports, "useParseTimeString", () => $ffea187516977204$export$a1109322d92e0ba8);

var $eJOHy = parcelRequire("eJOHy");

var $169bb = parcelRequire("169bb");


var $5GvTs = parcelRequire("5GvTs");
const $ffea187516977204$var$toTimeFormat = (format)=>{
    return format ? (0, $5GvTs.toLowercaseTimeUnion)(format) : (0, $e1e7fb6a6c70503b$export$c4d2eaadfa3c28df);
};
const $ffea187516977204$var$toTimeUnit = (unit)=>{
    return unit ? (0, $5GvTs.toLowercaseTimeUnion)(unit) : (0, $e1e7fb6a6c70503b$export$2ee07242bbb09b61);
};
const $ffea187516977204$var$useTimeTrackingParsingConfig = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit })=>{
    return (0, $eJOHy.useMemo)(()=>({
            hoursPerDay: workingHoursPerDay || (0, $e1e7fb6a6c70503b$export$8c7070611f332ef9),
            daysPerWeek: workingDaysPerWeek || (0, $e1e7fb6a6c70503b$export$21ed1f454652d913),
            format: $ffea187516977204$var$toTimeFormat(defaultFormat),
            defaultUnit: $ffea187516977204$var$toTimeUnit(defaultUnit),
            isTimeTrackingEnabled: true
        }), [
        defaultFormat,
        defaultUnit,
        workingDaysPerWeek,
        workingHoursPerDay
    ]);
};
const $ffea187516977204$export$27badca43bbaa0e = (input)=>{
    const config = $ffea187516977204$var$useTimeTrackingParsingConfig(input);
    return (0, $eJOHy.useMemo)(()=>(0, $169bb.isValidTimeString)(config), [
        config
    ]);
};
const $ffea187516977204$export$a1109322d92e0ba8 = (input)=>{
    const config = $ffea187516977204$var$useTimeTrackingParsingConfig(input);
    return (0, $eJOHy.useMemo)(()=>(0, $169bb.parseTimeString)(config), [
        config
    ]);
};

});
parcelRegister("169bb", function(module, exports) {

$parcel$export(module.exports, "formatTimeString", () => $711aadf76714c8f0$export$2de90790c3ad23b1);
$parcel$export(module.exports, "isValidTimeString", () => $711aadf76714c8f0$export$669626963db3b187);
$parcel$export(module.exports, "parseTimeString", () => $711aadf76714c8f0$export$53148bfa4e677363);

var $9J40B = parcelRequire("9J40B");

var $eebhl = parcelRequire("eebhl");

var $j7N7F = parcelRequire("j7N7F");

var $3YPJ0 = parcelRequire("3YPJ0");

var $5iJeL = parcelRequire("5iJeL");

const $711aadf76714c8f0$export$2de90790c3ad23b1 = (config)=>(timeValue)=>(0, $eebhl.default)(config.daysPerWeek, config.hoursPerDay)(timeValue || 0);
const $711aadf76714c8f0$export$5eb9d332712102eb = (config)=>(value)=>{
        let trimmedValue = value.trim();
        // If user doesn't type the valid format (m, h, d, or w), use default unit format set in the configuration.
        const isValidNumber = (0, $3YPJ0.isNumeric)(trimmedValue.replaceAll(',', '.'));
        if (isValidNumber) {
            const { defaultUnit: defaultUnit } = config;
            trimmedValue = `${trimmedValue}${(0, $5iJeL.getDefaultTimeTrackingUnit)(defaultUnit)}`;
        }
        return trimmedValue;
    };
const $711aadf76714c8f0$export$669626963db3b187 = (config)=>(value)=>{
        const timeString = $711aadf76714c8f0$export$5eb9d332712102eb(config)(value);
        return timeString === '' || (0, $9J40B.default)(timeString);
    };
const $711aadf76714c8f0$export$53148bfa4e677363 = (config)=>(value)=>{
        const timeString = $711aadf76714c8f0$export$5eb9d332712102eb(config)(value);
        if (!$711aadf76714c8f0$export$669626963db3b187(config)(timeString)) return 0;
        return (0, $j7N7F.default)(config.daysPerWeek, config.hoursPerDay)(timeString);
    };

});
parcelRegister("9J40B", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1e063e4d6ff7ef7$export$2e2bcd8739ae039);

var $eRPqr = parcelRequire("eRPqr");

var $j7N7F = parcelRequire("j7N7F");
const $e1e063e4d6ff7ef7$var$isTimeStringValid = (timeString)=>{
    // We don't care about daysPerWeek or hoursPerDay - we only need to test that the value can be parsed.
    const result = (0, $j7N7F.default)(1, 1)(timeString);
    return result !== null && (0, (/*@__PURE__*/$parcel$interopDefault($eRPqr)))(result);
};
var $e1e063e4d6ff7ef7$export$2e2bcd8739ae039 = $e1e063e4d6ff7ef7$var$isTimeStringValid;

});
parcelRegister("eRPqr", function(module, exports) {

var $NROo8 = parcelRequire("NROo8");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ad2de7eeaba7a4ae$var$nativeIsFinite = $NROo8.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function $ad2de7eeaba7a4ae$var$isFinite(value) {
    return typeof value == 'number' && $ad2de7eeaba7a4ae$var$nativeIsFinite(value);
}
module.exports = $ad2de7eeaba7a4ae$var$isFinite;

});

parcelRegister("j7N7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $90469f1cb6ff73a8$export$2e2bcd8739ae039);
const $90469f1cb6ff73a8$var$MINUTES_PER_HOUR = 60;
const $90469f1cb6ff73a8$var$SECONDS_PER_MINUTE = 60;
// Supports both '.' and ',' as decimal separators
const $90469f1cb6ff73a8$var$UNIT_STRING_PATTERN = /^(\d+(?:[.,]\d+)?)([wdhm])$/;
const $90469f1cb6ff73a8$var$convertToUnitQuantity = (rawString)=>{
    const matches = $90469f1cb6ff73a8$var$UNIT_STRING_PATTERN.exec(rawString);
    if (!matches) return null;
    // Replace comma with a period for evaluating arithmetic decimal
    const normalizedQuantity = matches[1].replaceAll(',', '.');
    return {
        quantity: parseFloat(normalizedQuantity),
        unit: matches[2]
    };
};
const $90469f1cb6ff73a8$var$timeStringToSeconds = (daysPerWeek, hoursPerDay)=>{
    const unitDefinitions = [
        {
            unit: 'w',
            seconds: daysPerWeek * hoursPerDay * $90469f1cb6ff73a8$var$MINUTES_PER_HOUR * $90469f1cb6ff73a8$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'd',
            seconds: hoursPerDay * $90469f1cb6ff73a8$var$MINUTES_PER_HOUR * $90469f1cb6ff73a8$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'h',
            seconds: $90469f1cb6ff73a8$var$MINUTES_PER_HOUR * $90469f1cb6ff73a8$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'm',
            seconds: $90469f1cb6ff73a8$var$SECONDS_PER_MINUTE
        }
    ];
    return (timeString)=>{
        // Split up the time string, and parse it into an array of UnitQuantities.
        const unitQuantities = timeString.split(' ').map($90469f1cb6ff73a8$var$convertToUnitQuantity);
        let quantitiesConsumed = 0;
        let seconds = 0;
        for(let i = 0; i < unitDefinitions.length; i += 1){
            // If we have consumed all the quantity-unit pairs in the string
            // we are done.
            if (quantitiesConsumed === unitQuantities.length) break;
            const unitDefinition = unitDefinitions[i];
            const unitQuantity = unitQuantities[quantitiesConsumed];
            if (!unitQuantity) return null;
            // If the quantity-unit pair matches the unit definition we are up to, consume it.
            if (unitQuantity.unit === unitDefinition.unit) {
                seconds += unitQuantity.quantity * unitDefinition.seconds;
                quantitiesConsumed += 1;
            }
        }
        // We have made it through all the unit definitions, but there is still some left-over input
        if (quantitiesConsumed < unitQuantities.length) return null;
        return Math.floor(seconds);
    };
};
var $90469f1cb6ff73a8$export$2e2bcd8739ae039 = $90469f1cb6ff73a8$var$timeStringToSeconds;

});


parcelRegister("eebhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $853dcd26ce405ee8$export$2e2bcd8739ae039);
const $853dcd26ce405ee8$var$MINUTES_PER_HOUR = 60;
const $853dcd26ce405ee8$var$SECONDS_PER_MINUTE = 60;
const $853dcd26ce405ee8$var$secondsToTimeString = (daysPerWeek, hoursPerDay)=>{
    const units = [
        {
            suffix: 'w',
            seconds: daysPerWeek * hoursPerDay * $853dcd26ce405ee8$var$MINUTES_PER_HOUR * $853dcd26ce405ee8$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'd',
            seconds: hoursPerDay * $853dcd26ce405ee8$var$MINUTES_PER_HOUR * $853dcd26ce405ee8$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'h',
            seconds: $853dcd26ce405ee8$var$MINUTES_PER_HOUR * $853dcd26ce405ee8$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'm',
            seconds: $853dcd26ce405ee8$var$SECONDS_PER_MINUTE
        }
    ];
    return (seconds)=>{
        const initial = {
            secondsRemaining: seconds,
            timeString: ''
        };
        const result = units.reduce((acc, unit)=>{
            // Skip this unit if it doesn't have a valid number of seconds
            if (unit.seconds <= 0) return acc;
            const numUnits = Math.floor(acc.secondsRemaining / unit.seconds);
            const updatedSecondsRemaining = numUnits >= 1 ? acc.secondsRemaining % unit.seconds : acc.secondsRemaining;
            const updatedTimeString = numUnits >= 1 ? `${acc.timeString} ${numUnits}${unit.suffix}` : acc.timeString;
            return {
                secondsRemaining: updatedSecondsRemaining,
                timeString: updatedTimeString
            };
        }, initial);
        return result.timeString.trim() || '0m';
    };
};
var $853dcd26ce405ee8$export$2e2bcd8739ae039 = $853dcd26ce405ee8$var$secondsToTimeString;

});

parcelRegister("3YPJ0", function(module, exports) {

$parcel$export(module.exports, "isNumeric", () => $ef06441bdd270ccf$export$e90fb89750dba83f);
const $ef06441bdd270ccf$export$e90fb89750dba83f = (num)=>num.length > 0 && !Number.isNaN(Number(num));

});

parcelRegister("5iJeL", function(module, exports) {

$parcel$export(module.exports, "getDefaultTimeTrackingUnit", () => $4a595c55416867fe$export$2b38dfc7401492ba);
// This is required to map the default time-tracking unit coming from the server (gira endpoint BENTO: 3334) to client
const $4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT = {
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w'
};
const $4a595c55416867fe$export$2b38dfc7401492ba = (serverDefaultUnit)=>$4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT[serverDefaultUnit] || $4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT.minute;

});



parcelRegister("gc7nM", function(module, exports) {

$parcel$export(module.exports, "useOriginalEstimateValidator", () => $dff13978bd5b469e$export$339bd53893728f75);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $8T4lL = parcelRequire("8T4lL");

var $9EIWa = parcelRequire("9EIWa");
const $dff13978bd5b469e$export$339bd53893728f75 = (settingsInput)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const validate = (0, $8T4lL.useValidateTimeString)(settingsInput);
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (!validate(value)) return {
            type: 'error',
            message: formatMessage((0, $9EIWa.default).invalidInput)
        };
        return null;
    }, [
        formatMessage,
        validate
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("9EIWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f021f33e8707aa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f8f021f33e8707aa$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    invalidInput: {
        "id": "issue-field-original-estimate-inline-edit-full.original-estimate.invalid-input",
        "defaultMessage": "Your estimate must be in the format 2w 4d 6h 45m"
    }
});

});




parcelRegister("6AOez", function(module, exports) {

$parcel$export(module.exports, "ParentCell", () => $d3fa5ce4fe097cda$export$d5a4cc78f8c5a2cd);

var $9vdI2 = parcelRequire("9vdI2");

var $5ua1B = parcelRequire("5ua1B");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $7jTnu = parcelRequire("7jTnu");

var $dSKax = parcelRequire("dSKax");

var $11Y63 = parcelRequire("11Y63");

var $kDaaB = parcelRequire("kDaaB");

var $34oCh = parcelRequire("34oCh");

var $86BUM = parcelRequire("86BUM");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $e0p2q = parcelRequire("e0p2q");
const $d3fa5ce4fe097cda$export$d5a4cc78f8c5a2cd = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, fieldType: fieldType = '', isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $5ua1B.default), fieldRef);
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    /**
   * As part of the initiative to remove "Epic Link" and "Parent Link" fields from Jira,
   * we're rendering a "Replaced by Parent field" deprecation message in the "Parent Link" cell.
   * At the time of writing this comment, "Parent Link" is still used in ~1% of issue tables, and
   * we hope this message will help these users migrate and use the "Parent" field from now on.
   */ if (fieldType === 'com.atlassian.jpo:jpo-custom-field-parent' && (0, $7jTnu.fg)('replace-epic-parent-link-by-depreca-message-in-nin')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "span",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $e0p2q.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    as: "strong"
                }, chunks)
        }
    }));
    if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const inlineEditData = (0, $j4oe4.useFragment)((0, $9vdI2.default), data);
        // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
        // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
        const isEditable = 'lazyIsEditableInIssueView' in inlineEditData && isInlineEditingExtendedFieldSupportEnabled ? inlineEditData.lazyIsEditableInIssueView : false;
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eqbO4.useLazyLoadEditability)(inlineEditData.id, isEditable);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $11Y63.ParentInlineEditViewIsEditable), {
            attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
            spacing: "default",
            editViewPopup: true,
            editViewPopupAlignBlock: "center",
            fragmentRef: inlineEditData,
            isTruncated: !isDensityFull || isSingleLineRowHeightEnabled,
            isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
            menuPosition: "fixed",
            readViewFitContainerHeight: true,
            // Render an empty string when there is no parent and experiment is off to mimic FG off state
            emptyText: isInlineEditingExtendedFieldSupportEnabled ? undefined : '',
            isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
        });
    }
    const { parentIssue: parentIssue } = data;
    if (!parentIssue) return null;
    if (parentIssue.key == null || parentIssue.summaryField?.text == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "parent",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dSKax.ParentReadView), {
        fragmentRef: data,
        isTruncated: !isDensityFull || isSingleLineRowHeightEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
    });
});

});
parcelRegister("9vdI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7247c7fda430ccfc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b486690fc24de66310921e30e199c6eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7247c7fda430ccfc$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "parent_nativeIssueTable_ParentCell_data",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraParentIssueField"
};
$7247c7fda430ccfc$var$node.hash = "5bd5d278efda13fd8ec2a79f00dfd945";
var $7247c7fda430ccfc$export$2e2bcd8739ae039 = $7247c7fda430ccfc$var$node;

});

parcelRegister("5ua1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f39d0556a582be6b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5cea65a179854d7e08a64f57841499df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f39d0556a582be6b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "parent_nativeIssueTable_ParentCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "parentIssue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraSingleLineTextField",
                    "kind": "LinkedField",
                    "name": "summaryField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "text"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "parent_issueFieldParentReadviewFull_ParentReadView"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "parent_nativeIssueTable_ParentCell_data"
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$f39d0556a582be6b$var$node.hash = "2a93235cfca7356f6c6155a5a26e263c";
var $f39d0556a582be6b$export$2e2bcd8739ae039 = $f39d0556a582be6b$var$node;

});

parcelRegister("dSKax", function(module, exports) {

$parcel$export(module.exports, "ParentReadView", () => $257192e729b39853$export$72990b9b43fe6c69);

var $fnhET = parcelRequire("fnhET");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $9Mapt = parcelRequire("9Mapt");

var $coXKe = parcelRequire("coXKe");

var $3OT15 = parcelRequire("3OT15");

var $ajyMI = parcelRequire("ajyMI");

var $5Cerh = parcelRequire("5Cerh");
const $257192e729b39853$export$72990b9b43fe6c69 = ({ fragmentRef: fragmentRef, disableClickAction: disableClickAction, emptyText: emptyText, onClick: onClick, isTruncated: isTruncated = true, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $fnhET.default), fragmentRef);
    const { parentIssue: parentIssue } = data;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const noValueTextExperiment = formatMessage((0, $ajyMI.default).noValueTextExperiment);
    const contentRef = (0, $eJOHy.useRef)(null);
    const issueType = parentIssue?.issueTypeField?.issueType;
    const label = `${parentIssue?.key} ${parentIssue?.summaryField?.text ?? ''}`;
    const iconUrl = issueType?.avatar?.xsmall;
    const isWideViewLayout = userPreferredLayout === 'WIDE';
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: label
    });
    if (!parentIssue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : emptyText
    });
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: label,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: [
            isTruncated && $257192e729b39853$var$containerStyles,
            isWideViewLayout && $257192e729b39853$var$wideLayoutMaxWidth
        ]
    }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($257192e729b39853$var$Icon, {
        src: iconUrl,
        alt: formatMessage((0, $ajyMI.default).icon, {
            issueType: issueType?.name ?? ''
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Cerh.Summary), {
        disableClickAction: disableClickAction,
        issueKey: parentIssue.key,
        label: label,
        colorKey: parentIssue.issueColorField?.color?.colorKey,
        onClick: onClick,
        isTruncated: isTruncated
    })));
    return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: $257192e729b39853$var$containerStyles
    }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($257192e729b39853$var$Icon, {
        src: iconUrl,
        alt: formatMessage((0, $ajyMI.default).icon, {
            issueType: issueType?.name ?? ''
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Cerh.Summary), {
        disableClickAction: disableClickAction,
        issueKey: parentIssue?.key || '',
        label: label,
        colorKey: parentIssue?.issueColorField?.color?.colorKey,
        onClick: onClick,
        isTruncated: isTruncated,
        contentRef: hoverPopoverRef
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        contentRef: contentRef,
        content: label
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            alignBlock: "center",
            space: "space.100",
            xcss: $257192e729b39853$var$containerStyles,
            ref: ref
        }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($257192e729b39853$var$Icon, {
            src: iconUrl,
            alt: formatMessage((0, $ajyMI.default).icon, {
                issueType: issueType?.name ?? ''
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Cerh.Summary), {
            disableClickAction: disableClickAction,
            issueKey: parentIssue?.key || '',
            label: label,
            colorKey: parentIssue?.issueColorField?.color?.colorKey,
            onClick: onClick,
            isTruncated: isTruncated,
            contentRef: contentRef
        })));
};
const $257192e729b39853$var$containerStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $257192e729b39853$var$wideLayoutMaxWidth = (0, $1DXK0.xcss)({
    maxWidth: '240px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $257192e729b39853$var$Icon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fnhET", function(module, exports) {

$parcel$export(module.exports, "default", () => $17cca88dc2caac89$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3bcbebe74c091ba622da6d6bc6690cee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $17cca88dc2caac89$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "parent_issueFieldParentReadviewFull_ParentReadView",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "parentIssue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraColorField",
                    "kind": "LinkedField",
                    "name": "issueColorField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "color",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "colorKey"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "xsmall"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraSingleLineTextField",
                    "kind": "LinkedField",
                    "name": "summaryField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "text"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$17cca88dc2caac89$var$node.hash = "6ecef1f6a096d5fe262348916d52bc29";
var $17cca88dc2caac89$export$2e2bcd8739ae039 = $17cca88dc2caac89$var$node;

});

parcelRegister("coXKe", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainers", () => $3b984a26137eed7b$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $3b984a26137eed7b$export$5f49a43487b268);
$parcel$export(module.exports, "useLayoutContainerByTypeMemoised", () => $3b984a26137eed7b$export$ef5966e43b13b4a9);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $3b984a26137eed7b$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $3b984a26137eed7b$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $3b984a26137eed7b$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $3b984a26137eed7b$export$1e5e9fc877a47cd9);

var $eJOHy = parcelRequire("eJOHy");

var $fAZgY = parcelRequire("fAZgY");

var $pz0Wh = parcelRequire("pz0Wh");

var $kfvK2 = parcelRequire("kfvK2");

var $epTsa = parcelRequire("epTsa");

var $cs58I = parcelRequire("cs58I");

var $hbF3h = parcelRequire("hbF3h");

var $bmoS1 = parcelRequire("bmoS1");

var $2cfd4 = parcelRequire("2cfd4");


var $bNexr = parcelRequire("bNexr");

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $16PQW = parcelRequire("16PQW");

var $eSnSE = parcelRequire("eSnSE");

var $l7Alo = parcelRequire("l7Alo");

var $lpEwy = parcelRequire("lpEwy");

var $co62F = parcelRequire("co62F");
const $3b984a26137eed7b$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $3b984a26137eed7b$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
        ], [
        container?.items.nodes,
        fieldsHiddenByUim
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $3b984a26137eed7b$export$ef5966e43b13b4a9 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    const filteredItems = (0, $eJOHy.useMemo)(()=>{
        return (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim);
    }, [
        container,
        fieldsHiddenByUim
    ]);
    return [
        filteredItems
    ];
};
const $3b984a26137eed7b$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $lpEwy.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $3b984a26137eed7b$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $lpEwy.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $a85d9f0dd63c9b50$export$39aaf586c7ee5202));
    const isMobile = (0, $l7Alo.default)();
    const locale = (0, $2cfd4.useLocale)();
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate') && !(0, $7jTnu.fg)('issue_view_tab_layout_feature_gate')) {
            if ((0, $7jTnu.fg)('thor_layouts_splunk_logs_enable')) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `useUserPreferredWorkItemLayout: Kill switch is off with flag values: ${JSON.stringify({
                isMobile: isMobile,
                isFullIssueView: isFullIssueView,
                projectType: projectType,
                isIssueKeyNull: issueKey === null,
                isProjectKeyNull: projectKey === null,
                isProjectTypeNull: projectType === null,
                locale: locale,
                userPreferredLayout: userPreferredLayout,
                isWideLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
                isDiscussionLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
            })}`);
            return {
                isInDiscussionLayoutExperiment: false,
                isInWideLayoutExperiment: false,
                isInLayoutExperiment: false,
                isActivityInVerticalSidePanel: false,
                userPreferredLayout: null
            };
        }
        const isSoftwareOrBusiness = projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $7jTnu.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $epTsa.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        if (userLayoutType === null && ((0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false) || (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false)) && (0, $7jTnu.fg)('thor_layouts_splunk_logs_enable')) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `useUserPreferredWorkItemLayout: User layout type parsing: ${JSON.stringify({
            userPreferredLayout: userPreferredLayout,
            userLayoutType: userLayoutType,
            isMobile: isMobile,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            locale: locale,
            isSoftwareOrBusiness: isSoftwareOrBusiness,
            isFullIssueView: isFullIssueView,
            isWideLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isDiscussionLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        let userSelectedLayout = userLayoutType;
        if (!(0, $7jTnu.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        if (userSelectedLayout === null && ((0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false) || (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false)) && (0, $7jTnu.fg)('thor_layouts_splunk_logs_enable')) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `useUserPreferredWorkItemLayout: User selected layout parsing: ${JSON.stringify({
            userSelectedLayout: userSelectedLayout,
            isInLayoutExperiment: isInLayoutExperiment,
            userPreferredLayout: userPreferredLayout,
            isMobile: isMobile,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            locale: locale,
            isSoftwareOrBusiness: isSoftwareOrBusiness,
            isFullIssueView: isFullIssueView,
            isWideLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isDiscussionLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${JSON.stringify({
            error: error,
            isMobile: isMobile,
            isFullIssueView: isFullIssueView,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            userPreferredLayout: userPreferredLayout,
            locale: locale,
            isInWideLayoutExperiment: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isInDiscussionLayoutExperiment: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff = ()=>{
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate') && !(0, $7jTnu.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        // eslint-disable-next-line react-hooks/react-compiler
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $bmoS1.useIssueKey)();
        const projectKey = (0, $bNexr.useProjectKey)(issueKey);
        const projectType = (0, $bNexr.useProjectType)(projectKey);
        const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
        const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $a85d9f0dd63c9b50$export$39aaf586c7ee5202));
        const isMobile = (0, $l7Alo.default)();
        const isSoftwareOrBusiness = projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $7jTnu.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $epTsa.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ let userSelectedLayout = userLayoutType;
        if (!(0, $7jTnu.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$export$9889eea62fdfa091 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('issue_layout_rule_of_hook_fix'), $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn, $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff);
const $3b984a26137eed7b$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $lpEwy.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $eJOHy.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $eJOHy.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $eJOHy.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};
/**
 * useRouteToGetQueryParams hook
 * This hook retrieves the current query parameters from the router state.
 * It is used to access the active tab and other query parameters in the issue view layout.
 */ const $3b984a26137eed7b$var$useRouteToGetQueryParams = (0, $kfvK2.createRouterSelector)((state)=>{
    return state.query;
});
const $3b984a26137eed7b$export$b027791af8c9b114 = ()=>{
    const { activeTab: activeTab = (0, $16PQW.defaultActiveTab), ...otherQueryParams } = $3b984a26137eed7b$var$useRouteToGetQueryParams();
    const { updateQueryParam: updateQueryParam } = (0, $kfvK2.useRouterStoreActions)();
    const setActiveTab = (0, $eJOHy.useCallback)((tab)=>{
        if (activeTab !== tab) updateQueryParam({
            ...otherQueryParams,
            activeTab: tab
        }, 'replace');
    }, [
        activeTab,
        otherQueryParams,
        updateQueryParam
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            setDescriptionAsActive: ()=>setActiveTab((0, $16PQW.Tabs).Description),
            setWorkItemsAsActive: ()=>setActiveTab((0, $16PQW.Tabs).WorkItems),
            setIntegrationsAsActive: ()=>setActiveTab((0, $16PQW.Tabs).Integrations),
            setResourcesAsActive: ()=>setActiveTab((0, $16PQW.Tabs).Resources),
            currentActiveTab: activeTab
        }), [
        activeTab,
        setActiveTab
    ]);
};

});
parcelRegister("pz0Wh", function(module, exports) {

$parcel$export(module.exports, "useEnabledHiddenFields", () => $437c493a8e065bc6$export$bb6c2b9159c3f32b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $i7n3g = parcelRequire("i7n3g");

var $4Swsy = parcelRequire("4Swsy");
const $437c493a8e065bc6$export$bb6c2b9159c3f32b = ()=>{
    (0, $gRw8I.di)((0, $i7n3g.useAdjustmentsEnabled), (0, $4Swsy.useHiddenFields));
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const hiddenFields = (0, $4Swsy.useHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("i7n3g", function(module, exports) {

$parcel$export(module.exports, "store", () => $35b1fa370eb6f514$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $35b1fa370eb6f514$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $35b1fa370eb6f514$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $35b1fa370eb6f514$export$5eb9c167b683d125);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $35b1fa370eb6f514$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $35b1fa370eb6f514$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($35b1fa370eb6f514$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $35b1fa370eb6f514$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-adjustments-context',
    initialState: $35b1fa370eb6f514$var$initialState,
    actions: $35b1fa370eb6f514$export$e324594224ef24da
});
const $35b1fa370eb6f514$export$a12f82a132dee079 = (0, $iJq0l.createHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$358ad850b2f6d6fe = (0, $iJq0l.createStateHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $35b1fa370eb6f514$export$4f2729981f4b81d2 = (0, $iJq0l.createActionsHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$5eb9c167b683d125 = (0, $6E16M.createContainer)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("4Swsy", function(module, exports) {

$parcel$export(module.exports, "useHiddenFields", () => $8e2f20b0b0e23b91$export$de6fdc67c945e596);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $8e2f20b0b0e23b91$var$selectHiddenFields = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8e2f20b0b0e23b91$export$de6fdc67c945e596 = (0, $iJq0l.createStateHook)((0, $ixrOr.store), {
    selector: $8e2f20b0b0e23b91$var$selectHiddenFields
});

});
parcelRegister("ixrOr", function(module, exports) {

$parcel$export(module.exports, "store", () => $3142574379bc5921$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $3142574379bc5921$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $3142574379bc5921$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $3142574379bc5921$export$677b3e34bd14c681);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4XahM = parcelRequire("4XahM");

var $4CM51 = parcelRequire("4CM51");

var $aub9z = parcelRequire("aub9z");

var $cJU1r = parcelRequire("cJU1r");

var $2A1rz = parcelRequire("2A1rz");

var $jfSsT = parcelRequire("jfSsT");

var $hUz0e = parcelRequire("hUz0e");

var $8ZmJu = parcelRequire("8ZmJu");

var $cXMA2 = parcelRequire("cXMA2");

var $5qpxn = parcelRequire("5qpxn");

var $9w3dh = parcelRequire("9w3dh");

var $fkUIk = parcelRequire("fkUIk");

var $bfBqP = parcelRequire("bfBqP");

var $fY47y = parcelRequire("fY47y");

var $dmz3j = parcelRequire("dmz3j");
const $3142574379bc5921$var$name = 'issue-adjustments';
const $3142574379bc5921$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $3142574379bc5921$var$triggerFieldInitializationKey, viewType: $3142574379bc5921$var$scopedViewType, numberOfSupportedFields: $3142574379bc5921$var$numberOfSupportedFields, ...$3142574379bc5921$var$stateForResetAllFields } = $3142574379bc5921$export$d4c72bab9d6cc13a;
const $3142574379bc5921$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5qpxn.processChange,
    setFieldValue: $fkUIk.setFieldValue,
    initializeField: $jfSsT.initializeField,
    initializeFields: $jfSsT.initializeFields,
    startFieldsInitialisationTimeout: $2A1rz.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $2A1rz.successFieldsInitalisation,
    registerFields: $9w3dh.registerFields,
    unregisterFields: $9w3dh.unregisterFields,
    updateFields: $fY47y.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($3142574379bc5921$var$stateForResetAllFields);
        },
    setError: $cJU1r.setError,
    resetError: $cJU1r.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $4XahM.setAppErrors,
    resetAppErrors: $4XahM.resetAppErrors,
    addAppsErrors: $4XahM.addAppsErrors,
    initializeNoScreenTab: $hUz0e.initializeNoScreenTab,
    initializeScreenTabs: $8ZmJu.initializeScreenTabs,
    updateScreenTabs: $dmz3j.updateScreenTabs,
    updateActiveScreenTab: $bfBqP.updateActiveScreenTab,
    detectAppliedChangesConflicts: $4CM51.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $aub9z.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $aub9z.collectFieldsAppliedChangesHistory,
    setNotification: $cXMA2.setNotification,
    resetNotification: $cXMA2.resetNotification
};
const $3142574379bc5921$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: $3142574379bc5921$var$name,
    initialState: $3142574379bc5921$export$d4c72bab9d6cc13a,
    actions: $3142574379bc5921$export$e324594224ef24da
});
const $3142574379bc5921$export$37792a602e748c08 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$var$stableEmptyFieldFromIframe = {};
const $3142574379bc5921$export$c76e674a29843e21 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $3142574379bc5921$export$df4b0714e8177e0e = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $3142574379bc5921$var$stableEmptyFieldFromIframe
});
const $3142574379bc5921$export$cb9a014ec14556d8 = (0, $iJq0l.createActionsHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$export$677b3e34bd14c681 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("4XahM", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $5579267a84760bc0$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $5579267a84760bc0$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $5579267a84760bc0$export$24c821207687a907);
const $5579267a84760bc0$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $5579267a84760bc0$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $5579267a84760bc0$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4CM51", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $8731ff5311f46f9c$export$90d94f20d157e756);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $4XahM = parcelRequire("4XahM");

var $cXMA2 = parcelRequire("cXMA2");

var $7Agw7 = parcelRequire("7Agw7");
const $8731ff5311f46f9c$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $8731ff5311f46f9c$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $8731ff5311f46f9c$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $e65702a72ab5ec3d$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $7Agw7.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $4XahM.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $cXMA2.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("jgvEH", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $cbc5413d6b6dbcfa$export$a1fb57756f0de62b);

var $5fWw9 = parcelRequire("5fWw9");


const $cbc5413d6b6dbcfa$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $5fWw9.default)((0, $0390845c0b61b1a1$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $e9db81972dce4ebc$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $0390845c0b61b1a1$export$8280e5c6104c5b40 = 'ui-modifications';


const $e65702a72ab5ec3d$export$415cc1afa6445f90 = 'onInitChangeId';
const $e65702a72ab5ec3d$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("cXMA2", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $c89e780a89ca3c37$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $c89e780a89ca3c37$export$caafa3945f199bc7);
const $c89e780a89ca3c37$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $c89e780a89ca3c37$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("7Agw7", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $6ecf22ae7e9f4956$export$a06103ec99e4e394);

var $jFHCE = parcelRequire("jFHCE");


var $5sAot = parcelRequire("5sAot");

const $6ecf22ae7e9f4956$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $6ecf22ae7e9f4956$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $702a64456849b1c0$export$f674b7a3bbd94b5)) return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $5sAot.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $6ecf22ae7e9f4956$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $6ecf22ae7e9f4956$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $585e8f7167f61808$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $585e8f7167f61808$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $585e8f7167f61808$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $585e8f7167f61808$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $585e8f7167f61808$export$e4ac32edd5da2ee7 = 'FIELD';
const $585e8f7167f61808$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("5sAot", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $2728f69de31c50a0$export$e1cc7da28a1c4bb7);
const $2728f69de31c50a0$var$SET_NAME_METHOD = 'setName';
const $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $2728f69de31c50a0$var$SET_VISIBLE_METHOD = 'setVisible';
const $2728f69de31c50a0$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $2728f69de31c50a0$var$SET_VALUE_METHOD = 'setValue';
const $2728f69de31c50a0$var$SET_REQUIRED_METHOD = 'setRequired';
const $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $2728f69de31c50a0$export$8325709d137b2606 = {
    fieldName: $2728f69de31c50a0$var$SET_NAME_METHOD,
    description: $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD,
    isVisible: $2728f69de31c50a0$var$SET_VISIBLE_METHOD,
    isReadOnly: $2728f69de31c50a0$var$SET_READ_ONLY_METHOD,
    value: $2728f69de31c50a0$var$SET_VALUE_METHOD,
    isRequired: $2728f69de31c50a0$var$SET_REQUIRED_METHOD,
    optionsVisibility: $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $2728f69de31c50a0$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $2728f69de31c50a0$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $702a64456849b1c0$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $702a64456849b1c0$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("aub9z", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $94bb1a042906c320$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $94bb1a042906c320$export$7d0f534e5b16dcc9);


var $gD9lZ = parcelRequire("gD9lZ");
const $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $94bb1a042906c320$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $702a64456849b1c0$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $94bb1a042906c320$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $gD9lZ.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("gD9lZ", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $b80c31bd414cd9d4$export$8a23b3e9a1749620);

const $b80c31bd414cd9d4$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $702a64456849b1c0$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $b80c31bd414cd9d4$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $b80c31bd414cd9d4$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("cJU1r", function(module, exports) {

$parcel$export(module.exports, "setError", () => $60a309f31f0bb435$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $60a309f31f0bb435$export$7e5930c6217b1d4e);
const $60a309f31f0bb435$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $60a309f31f0bb435$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("2A1rz", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $601c25cd313fe741$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $601c25cd313fe741$export$cf768a695e83eefa);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");

var $ieQ0v = parcelRequire("ieQ0v");

var $cJU1r = parcelRequire("cJU1r");
const $601c25cd313fe741$var$getTimeout = ()=>50000;
const $601c25cd313fe741$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $601c25cd313fe741$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $601c25cd313fe741$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($601c25cd313fe741$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $601c25cd313fe741$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $601c25cd313fe741$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status) || (0, $ieQ0v.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $cJU1r.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $601c25cd313fe741$var$getTimeout(),
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $601c25cd313fe741$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("ieQ0v", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $d3350efc4111ec81$export$4cadeedb8c3f31f7);

var $4MchI = parcelRequire("4MchI");
const $d3350efc4111ec81$export$4cadeedb8c3f31f7 = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("jfSsT", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $a40b94674a995fd7$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $a40b94674a995fd7$export$4a6b4707110b0552);

var $37MnT = parcelRequire("37MnT");
const $a40b94674a995fd7$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $a40b94674a995fd7$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("37MnT", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $cc8ab347810a3948$export$50806045b617d116);

var $gRw8I = parcelRequire("gRw8I");

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $cc8ab347810a3948$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gRw8I.di)((0, $1qarT.fireErrorAnalytics), (0, $82wKS.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $1qarT.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("1qarT", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $7486f28a569b9ec0$export$a27c21aa3ed8f0f1);

var $7U6OJ = parcelRequire("7U6OJ");

var $cMdIN = parcelRequire("cMdIN");
const $7486f28a569b9ec0$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $7486f28a569b9ec0$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $cMdIN.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $7U6OJ.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $7486f28a569b9ec0$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("cMdIN", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $c511a0dff3897a12$export$e19f9f08a6d79fd2);

var $l58EO = parcelRequire("l58EO");
const $c511a0dff3897a12$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $c511a0dff3897a12$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $c511a0dff3897a12$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $c511a0dff3897a12$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $c511a0dff3897a12$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $c511a0dff3897a12$export$89a175d4190df42e = 'Invoke value functions failed:';
const $c511a0dff3897a12$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $c511a0dff3897a12$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $c511a0dff3897a12$var$BAD_REQUEST = 400;
const $c511a0dff3897a12$var$REQUEST_TIMEOUT = 408;
const $c511a0dff3897a12$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $c511a0dff3897a12$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $c511a0dff3897a12$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($c511a0dff3897a12$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $c511a0dff3897a12$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($c511a0dff3897a12$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($c511a0dff3897a12$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($c511a0dff3897a12$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $l58EO.isClientFetchError)(error)) return $c511a0dff3897a12$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("l58EO", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cd5265fc67dbb6eb$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cd5265fc67dbb6eb$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cd5265fc67dbb6eb$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cd5265fc67dbb6eb$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cd5265fc67dbb6eb$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cd5265fc67dbb6eb$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.cause.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("82wKS", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $0757a5b98ef450f3$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $0757a5b98ef450f3$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $0757a5b98ef450f3$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $0757a5b98ef450f3$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $0757a5b98ef450f3$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $0757a5b98ef450f3$export$ef45e4471aa21b27);

var $1qarT = parcelRequire("1qarT");

var $6beFf = parcelRequire("6beFf");
const $0757a5b98ef450f3$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $0757a5b98ef450f3$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $6beFf.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $0757a5b98ef450f3$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$0757a5b98ef450f3$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $1qarT.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $0757a5b98ef450f3$export$e4330d77fd93d1de = (viewType)=>$0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $0757a5b98ef450f3$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $0757a5b98ef450f3$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $0757a5b98ef450f3$export$20eabd2b3ada6bf3(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $0757a5b98ef450f3$export$b768d6a95f7a930(context) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $0757a5b98ef450f3$export$b0297573c90085aa(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $0757a5b98ef450f3$export$c0728caa743a409e(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $0757a5b98ef450f3$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $0757a5b98ef450f3$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("6beFf", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $9cd8cd98b7c2eeee$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
const $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS = new Map();
const $9cd8cd98b7c2eeee$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.has(viewType)) $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $9cd8cd98b7c2eeee$export$176b6e68da08ffa2 = (viewType)=>$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.get(viewType);
const $9cd8cd98b7c2eeee$export$e8091eff40c4f16e = ()=>{
    $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.clear();
};
const $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gRw8I.di)($9cd8cd98b7c2eeee$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $eJOHy.useState)(()=>{
        $9cd8cd98b7c2eeee$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("hUz0e", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $7faac090c61abadc$export$93459ad9bfd6c380);
const $7faac090c61abadc$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("8ZmJu", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $5faefcecd8cba222$export$7f7be235f64f029b);
const $5faefcecd8cba222$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("5qpxn", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $bbbbfc09b273134e$export$352dfcce04d66748);

var $9UJzd = parcelRequire("9UJzd");

var $gRw8I = parcelRequire("gRw8I");

var $82wKS = parcelRequire("82wKS");

var $5ldku = parcelRequire("5ldku");
const $bbbbfc09b273134e$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});

parcelRegister("5ldku", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0);

var $cSmYj = parcelRequire("cSmYj");

var $37MnT = parcelRequire("37MnT");
const $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("9w3dh", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $60e092cfdd3e6be9$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $60e092cfdd3e6be9$export$1ca69a85bb7273de);

var $jFHCE = parcelRequire("jFHCE");

var $jvwCK = parcelRequire("jvwCK");
const $60e092cfdd3e6be9$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $60e092cfdd3e6be9$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("fkUIk", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $adb039aa861139a2$export$6556d46d2662453c);

var $5ldku = parcelRequire("5ldku");
const $adb039aa861139a2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("bfBqP", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $910f8611d1056e54$export$21363496760d39cd);
const $910f8611d1056e54$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("fY47y", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $e5c83e79d4f29b58$export$cceae62fd4d1ef0a);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $81O8J = parcelRequire("81O8J");

var $cfL5m = parcelRequire("cfL5m");

var $3JMvu = parcelRequire("3JMvu");

var $82idB = parcelRequire("82idB");

var $lKslV = parcelRequire("lKslV");

var $4XahM = parcelRequire("4XahM");

var $aub9z = parcelRequire("aub9z");

var $TiFiE = parcelRequire("TiFiE");
const $e5c83e79d4f29b58$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $aub9z.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $cfL5m.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $4XahM.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $7f80bdb4337734ff$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $7f80bdb4337734ff$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $TiFiE.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lKslV.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $3JMvu.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errorsByField)) throw new (0, $81O8J.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $82idB.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $aub9z.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $7f80bdb4337734ff$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $7f80bdb4337734ff$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $7f80bdb4337734ff$export$f5d5f6bb902f1027 = '-1';
const $7f80bdb4337734ff$export$106087dcfd4fb129 = 100;

parcelRegister("81O8J", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b784ee4f71bce498$export$9e8b5e552e255163);

var $607Dw = parcelRequire("607Dw");
class $b784ee4f71bce498$export$9e8b5e552e255163 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("607Dw", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $8683b9e27ffb2718$export$6e8165c81a6a65df);
class $8683b9e27ffb2718$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("cfL5m", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $84902f345f4d9ec2$export$fbe9157c12cb4e7b);
const $84902f345f4d9ec2$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("3JMvu", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $7a07bba1139035a5$export$460820f27643954e);

var $82wKS = parcelRequire("82wKS");
const $7a07bba1139035a5$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("82idB", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $b396c3e05312c1f7$export$e1fce51bc5be90b7);
const $b396c3e05312c1f7$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("lKslV", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $fb1c6d2f11d8a679$export$aa453854f74fab);

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $fb1c6d2f11d8a679$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("TiFiE", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0fdd9846971f3713$export$d14f85c01e334a1);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $6rtzq = parcelRequire("6rtzq");

var $82wKS = parcelRequire("82wKS");


var $5sAot = parcelRequire("5sAot");

var $gOp4r = parcelRequire("gOp4r");

var $i9dWk = parcelRequire("i9dWk");
const $0fdd9846971f3713$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gRw8I.di)((0, $82wKS.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $gOp4r.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $gOp4r.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $6rtzq.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $585e8f7167f61808$export$d1996cb46a690190),
                        method: (0, $5sAot.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $i9dWk.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $i9dWk.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("6rtzq", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a);
class $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("gOp4r", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $af0c126b48130091$export$ee79e3ab53b8db79);
const $af0c126b48130091$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("i9dWk", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $d76dab7db88ac392$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $d76dab7db88ac392$export$ddd005554aecd409);
const $d76dab7db88ac392$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $d76dab7db88ac392$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("dmz3j", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $d4a266f6d4506eb1$export$131c67fd312b8a11);

var $gRw8I = parcelRequire("gRw8I");

var $9WNAv = parcelRequire("9WNAv");

var $iGhbB = parcelRequire("iGhbB");

var $aub9z = parcelRequire("aub9z");

var $2TFQ7 = parcelRequire("2TFQ7");
const $d4a266f6d4506eb1$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gRw8I.di)((0, $aub9z.collectScreenTabsAppliedChangesHistory), (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $2TFQ7.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $2TFQ7.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $aub9z.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $9WNAv.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $iGhbB.toScreenTabsValidationError))
        });
    };

});
parcelRegister("9WNAv", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $5a1018b8bae0ac45$export$faf1f1824ee0a136);

var $607Dw = parcelRequire("607Dw");
class $5a1018b8bae0ac45$export$faf1f1824ee0a136 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("iGhbB", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $609355188438e567$export$b2675440ade984fb);

const $609355188438e567$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $585e8f7167f61808$export$fd26696d109785a0)
    });

});

parcelRegister("2TFQ7", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $e157d25468b560b0$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $e157d25468b560b0$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $e157d25468b560b0$export$62d63af83dac7315);
const $e157d25468b560b0$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $e157d25468b560b0$var$isValidScreenTabId = (internalScreenTabs, id)=>$e157d25468b560b0$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $e157d25468b560b0$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, id) && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && $e157d25468b560b0$var$isValidScreenTabIsActive(isActive);
const $e157d25468b560b0$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $e157d25468b560b0$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $e157d25468b560b0$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $e157d25468b560b0$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("cs58I", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $22623340bdbf14f6$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $22623340bdbf14f6$export$eefe4b2985e8203e);

var $eJOHy = parcelRequire("eJOHy");

var $jkWf0 = parcelRequire("jkWf0");

var $etbP7 = parcelRequire("etbP7");
const $22623340bdbf14f6$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $jkWf0.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $eJOHy.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, newValue);
    }, [
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eJOHy.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
    }, [
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $eJOHy.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $22623340bdbf14f6$export$eefe4b2985e8203e = ()=>{
    const [, actions] = (0, $jkWf0.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eJOHy.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("jkWf0", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $97758271cd46a4b8$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $97758271cd46a4b8$export$4d156074562bac9a);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $i64h0 = parcelRequire("i64h0");
const $97758271cd46a4b8$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $i64h0.actions
});
const $97758271cd46a4b8$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $97758271cd46a4b8$export$46e7eeb2fc34fab8 = (0, $iJq0l.createHook)($97758271cd46a4b8$export$6f57813fe9f31bf9, {
    selector: $97758271cd46a4b8$var$getUserPreference
});
const $97758271cd46a4b8$export$4d156074562bac9a = (0, $iJq0l.createHook)($97758271cd46a4b8$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("i64h0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $343d470acbc8bd87$export$e324594224ef24da);
const $343d470acbc8bd87$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $343d470acbc8bd87$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $343d470acbc8bd87$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $343d470acbc8bd87$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $343d470acbc8bd87$export$e324594224ef24da = {
    setUserPreferenceValue: $343d470acbc8bd87$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $343d470acbc8bd87$var$deleteUserPreferenceValue,
    setUserPreferences: $343d470acbc8bd87$var$setUserPreferences,
    getUserPreferenceValue: $343d470acbc8bd87$export$df0a4f67b9888111
};

});


parcelRegister("etbP7", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $a9cf1c440643deff$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $a9cf1c440643deff$export$a60a810760d07867);

var $jGzN3 = parcelRequire("jGzN3");
const $a9cf1c440643deff$export$bebe1b9e9f4cbf16 = async (userPreferenceKey, value)=>(0, $jGzN3.performPutRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    });
const $a9cf1c440643deff$export$a60a810760d07867 = async (userPreferenceKey)=>(0, $jGzN3.performDeleteRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`);

});


const $a85d9f0dd63c9b50$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $a85d9f0dd63c9b50$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $a85d9f0dd63c9b50$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $a85d9f0dd63c9b50$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $a85d9f0dd63c9b50$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $a85d9f0dd63c9b50$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $a85d9f0dd63c9b50$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $a85d9f0dd63c9b50$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $a85d9f0dd63c9b50$export$1a08240e14f65aa = 'jira.user.issue.collapsible-sections-state';
const $a85d9f0dd63c9b50$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("16PQW", function(module, exports) {

$parcel$export(module.exports, "Tabs", () => $9af4469a8b4e550d$export$b2539bed5023c21c);
$parcel$export(module.exports, "defaultActiveTab", () => $9af4469a8b4e550d$export$7566e064a478af42);
const $9af4469a8b4e550d$export$b2539bed5023c21c = {
    Description: 'description',
    WorkItems: 'workItems',
    Resources: 'resources',
    Integrations: 'integrations'
};
const $9af4469a8b4e550d$export$7566e064a478af42 = $9af4469a8b4e550d$export$b2539bed5023c21c.Description;
const $9af4469a8b4e550d$export$d07bba395c9390f1 = 42;

});

parcelRegister("lpEwy", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $e029db5d7fe89f63$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $e029db5d7fe89f63$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $e029db5d7fe89f63$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $e029db5d7fe89f63$export$5513f3c310d101f5);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5TQFX = parcelRequire("5TQFX");
const $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY = [];
const $e029db5d7fe89f63$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY;
const $e029db5d7fe89f63$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
const $e029db5d7fe89f63$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $5TQFX
});
const $e029db5d7fe89f63$export$5c4a1f63cea7b5b3 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContainers
});
const $e029db5d7fe89f63$export$769bbe2bda9a43ce = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutGlance
});
const $e029db5d7fe89f63$export$3aa9017e11451546 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel
});
const $e029db5d7fe89f63$export$5513f3c310d101f5 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("5TQFX", function(module, exports) {

$parcel$export(module.exports, "setIssueViewContainersLayout", () => $1fee7e98aeef55ea$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $1fee7e98aeef55ea$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $1fee7e98aeef55ea$export$9a04e4b958ebc410);
const $1fee7e98aeef55ea$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $1fee7e98aeef55ea$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $1fee7e98aeef55ea$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("co62F", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $f780ca908cc08c0e$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $f780ca908cc08c0e$export$355607dae809ec65);

var $5OyZl = parcelRequire("5OyZl");
const $f780ca908cc08c0e$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $5OyZl.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $5OyZl.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $5OyZl.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $f780ca908cc08c0e$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($f780ca908cc08c0e$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $5OyZl.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $f780ca908cc08c0e$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("5OyZl", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $37dff345eecb4f05$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $37dff345eecb4f05$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $37dff345eecb4f05$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $37dff345eecb4f05$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $37dff345eecb4f05$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $37dff345eecb4f05$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $37dff345eecb4f05$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $37dff345eecb4f05$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $37dff345eecb4f05$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $37dff345eecb4f05$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $37dff345eecb4f05$export$ad3536b13febb432);
const $37dff345eecb4f05$export$99ad62164189f781 = 'ecosystemGlance';
const $37dff345eecb4f05$export$7719ef6e9283671 = 'forgeGlance';
const $37dff345eecb4f05$export$bfebea5ce2e1887a = 'ecosystemContext';
const $37dff345eecb4f05$export$be8e68fb1aed253e = 'forgeContext';
const $37dff345eecb4f05$export$7bf561e6ab380ea1 = 'context';
const $37dff345eecb4f05$export$f42c11634d75863e = 'content';
const $37dff345eecb4f05$export$b38842736b6dbc1d = 'content-request';
const $37dff345eecb4f05$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_TYPE = 'FORGE';
const $37dff345eecb4f05$export$605c43f1b33ab69 = 'SUMMARY';
const $37dff345eecb4f05$export$e655b77b9efe622f = 'CustomItem';
const $37dff345eecb4f05$export$5cf403de05e9bea = 'FieldSectionItem';
const $37dff345eecb4f05$export$30f7f9a86f182492 = 'TabLayout';
const $37dff345eecb4f05$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $37dff345eecb4f05$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $37dff345eecb4f05$export$ad3536b13febb432 = (node)=>node.type === $37dff345eecb4f05$export$5507f31126c8b283.tab;

});



parcelRegister("ajyMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7febdbb69aed227c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7febdbb69aed227c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    icon: {
        "id": "issue-field-parent-readview-full.parent.icon",
        "defaultMessage": "{issueType} icon"
    },
    noValueTextExperiment: {
        "id": "issue-field-parent.no-value-text-experiment",
        "defaultMessage": "Add parent"
    }
});

});

parcelRegister("5Cerh", function(module, exports) {

$parcel$export(module.exports, "Summary", () => $76aa50f6a6036032$export$46453a0401d6cd1a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $1wTTU = parcelRequire("1wTTU");

var $bVyuq = parcelRequire("bVyuq");
const $76aa50f6a6036032$export$46453a0401d6cd1a = ({ disableClickAction: disableClickAction, onClick: onClick, label: label, colorKey: colorKey, issueKey: issueKey, isTruncated: isTruncated, contentRef: contentRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const lozengeTheme = (0, $eJOHy.useMemo)(()=>colorKey ? (0, $1wTTU.getLozengeThemeByColor)((0, $1wTTU.asColor)(colorKey)) : undefined, [
        colorKey
    ]);
    if (disableClickAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76aa50f6a6036032$var$WrapperNoClick // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: lozengeTheme
    }, label);
    if (onClick != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76aa50f6a6036032$var$ButtonText, {
        onClick: onClick,
        style: lozengeTheme
    }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        testId: (0, $7jTnu.fg)('relay-migration-issue-header-and-parent') ? 'issue-field-parent.ui.view-link' : 'issue-field-parent-readview-full.ui.parent.summary.view-link',
        href: `/browse/${issueKey}`,
        "aria-label": formatMessage((0, $bVyuq.default).parentTitle, {
            label: label
        }),
        style: lozengeTheme,
        xcss: [
            $76aa50f6a6036032$var$linkTextStylesBase,
            isTruncated ? $76aa50f6a6036032$var$linkTextStylesTruncated : $76aa50f6a6036032$var$linkTextStylesNonTruncated
        ],
        ref: contentRef
    }, label);
};
const $76aa50f6a6036032$var$linkTextStylesBase = (0, $1DXK0.xcss)({
    borderRadius: "var(--ds-border-radius, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $76aa50f6a6036032$var$linkTextStylesNonTruncated = (0, $1DXK0.xcss)({
    overflowWrap: 'anywhere'
});
const $76aa50f6a6036032$var$linkTextStylesTruncated = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $76aa50f6a6036032$var$ButtonText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _19itglyw _11q7glyw _11c82smr _12ji1r31 _1qu21kw7 _12y31o36 _2rko1l7b _1bto1l2s _o5721q9c _syaz1kw7 _vwz47vkz _80omtlke _4t3igktf _p12f1osq _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $76aa50f6a6036032$var$WrapperNoClick = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _11c82smr _2rko1l7b _1bto1l2s _o5721q9c _1e0c1ule _vwz47vkz _4t3i7vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bVyuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $66722d678b1a697a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $66722d678b1a697a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    parentTitle: {
        "id": "issue-field-parent-readview-full.parent.summary.parent-title",
        "defaultMessage": "Click to visit {label}"
    }
});

});



parcelRegister("11Y63", function(module, exports) {

$parcel$export(module.exports, "ParentInlineEditViewIsEditable", () => $088da67924e4d7a9$export$ed7c5b45ec99cbc3);
$parcel$export(module.exports, "ParentInlineEditView", () => $088da67924e4d7a9$export$536c9a0501611e73);

var $iFZ5b = parcelRequire("iFZ5b");

var $2vLh0 = parcelRequire("2vLh0");

var $bUnL2 = parcelRequire("bUnL2");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $d2AGn = parcelRequire("d2AGn");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $8MKsY = parcelRequire("8MKsY");

var $bARvQ = parcelRequire("bARvQ");

var $dSKax = parcelRequire("dSKax");

var $7jTnu = parcelRequire("7jTnu");

var $kev0f = parcelRequire("kev0f");
const $088da67924e4d7a9$var$isEqualParent = (a, b)=>a?.value === b?.value;
const $088da67924e4d7a9$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-parent-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $088da67924e4d7a9$export$ed7c5b45ec99cbc3 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, isTruncated: isTruncated, spacing: spacing = 'compact', emptyText: emptyText, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $bUnL2.default), fragmentRef);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name } = data;
    const fieldName = overriding.overrideLabel(name);
    const isFieldEditable = overriding?.overrideIsEditable(isEditable);
    const [commit] = (0, $j4oe4.useMutation)((0, $2vLh0.default));
    // #endregion
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (data?.parentIssue) return (0, $bARvQ.transformParentNode)(data.parentIssue);
        return null;
    }, [
        data.parentIssue
    ]);
    // #region Common state
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.((0, $kev0f.transformOptionToAgg)(option));
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value?.toString() || null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateParentField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateParentField: {
                        success: true,
                        errors: [],
                        field: (0, $kev0f.transformOptionToOptimisticFieldResponse)(data, option?.aggValue)
                    }
                }
            }
        });
    }, [
        onSubmit,
        commit,
        uniqueFieldId,
        data
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((option)=>{
        onSubmitSucceeded?.((0, $kev0f.transformOptionToAgg)(option));
    }, [
        onSubmitSucceeded
    ]);
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        if (initialValue !== value) {
            const oldValId = initialValue?.issueId;
            const newValId = value?.issueId || null;
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, oldValId, newValId);
        }
    }, [
        fieldId,
        initialValue
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $088da67924e4d7a9$var$isEqualParent,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        setAnalyticsAttributes: setAnalyticsAttributes,
        clipboardComponentType: 'parent'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($088da67924e4d7a9$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dSKax.ParentReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            emptyText: emptyText,
            isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
        })), [
        data,
        isTruncated,
        emptyText,
        isSingleLineRowHeightEnabled
    ]);
    const getEditViewProps = (0, $eJOHy.useCallback)((fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            menuIsOpen: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? true : undefined,
            spacing: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? spacing : undefined
        }), [
        fieldName,
        handleChangeAndConfirm,
        menuPosition,
        menuPortalTarget,
        uniqueFieldId,
        updatedValue,
        spacing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $8MKsY.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
};
const $088da67924e4d7a9$export$536c9a0501611e73 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $iFZ5b.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($088da67924e4d7a9$export$ed7c5b45ec99cbc3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("iFZ5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $5109f35be6f33862$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d698883de3c28ee2d0fd655b48eeea5a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5109f35be6f33862$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$5109f35be6f33862$var$node.hash = "935d17179ef6e93f2b74d57828fd1128";
var $5109f35be6f33862$export$2e2bcd8739ae039 = $5109f35be6f33862$var$node;

});

parcelRegister("2vLh0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd558d5ed2d3a369$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9aaca64d86b34da4df439d3d57ad9ff0>>
 * @relayHash 35a89be773f9e0f04f82240d00d7f8b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ae2d109ad94f1ae872c99ab33debff4182b0268fd3f0d04ca934aedc0b957cc

var $dTrc4 = parcelRequire("dTrc4");
const $bd558d5ed2d3a369$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "text"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraParentIssueField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraParentIssueField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "parentIssue",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "concreteType": "JiraColorField",
                                                    "kind": "LinkedField",
                                                    "name": "issueColorField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "color",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraSingleLineTextField",
                                                    "kind": "LinkedField",
                                                    "name": "summaryField",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "issuetype",
                                                                "project",
                                                                "summary",
                                                                "status"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSingleLineTextField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "issueTypeId"
                                                                                        },
                                                                                        v6 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "hierarchy",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "level"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v4 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraStatus",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "status",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatusCategory",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "statusCategory",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "statusCategoryId"
                                                                                                },
                                                                                                v4 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v4 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusField"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                }
                                            ]
                                        },
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7ae2d109ad94f1ae872c99ab33debff4182b0268fd3f0d04ca934aedc0b957cc",
            "metadata": {},
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default)
            }
        }
    };
}();
$bd558d5ed2d3a369$var$node.hash = "8b384097fdc3b65908abb3c6f1e54624";
var $bd558d5ed2d3a369$export$2e2bcd8739ae039 = $bd558d5ed2d3a369$var$node;

});

parcelRegister("bUnL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d7502dde3003ce6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<908f6fe037baa11f41efe8e8fe7fe66d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2d7502dde3003ce6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "parent_issueFieldParentReadviewFull_ParentReadView"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v2 /*: any*/ ,
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "issueId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                    "issuetype",
                                    "project",
                                    "summary",
                                    "status"
                                ]
                            }
                        ],
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsById",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "text"
                                                    }
                                                ],
                                                "type": "JiraSingleLineTextField"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "issueType",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "issueTypeId"
                                                            },
                                                            v2 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "xsmall"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                "kind": "LinkedField",
                                                                "name": "hierarchy",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "level"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraIssueTypeField"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraStatusField"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    };
}();
$2d7502dde3003ce6$var$node.hash = "5ae5cd1e04dbf76ee936e2c851d2cd7c";
var $2d7502dde3003ce6$export$2e2bcd8739ae039 = $2d7502dde3003ce6$var$node;

});

parcelRegister("8MKsY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6254ede357cd9891$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $6254ede357cd9891$var$ParentEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3hnkM")), {
        moduleId: "c1f15ee7",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $6254ede357cd9891$export$2e2bcd8739ae039 = $6254ede357cd9891$var$ParentEditViewEntryPoint;

});
parcelRegister("3hnkM", function(module, exports) {

let $26350f48dace01f4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $26350f48dace01f4$var$load("dzONu").then(()=>parcelRequire('kTqjh'));

});


parcelRegister("bARvQ", function(module, exports) {

$parcel$export(module.exports, "transformParentNode", () => $346ef850ba3728ec$export$1b622b80a5cf731f);
$parcel$export(module.exports, "transformToSuggestions", () => $346ef850ba3728ec$export$6cffaaeb4c7c0c18);

var $7keuM = parcelRequire("7keuM");

var $8URAw = parcelRequire("8URAw");
const $346ef850ba3728ec$export$1b622b80a5cf731f = (edgeNode)=>{
    const fieldsEdges = edgeNode?.fieldsById?.edges || [];
    const summaryField = fieldsEdges.find((field)=>field?.node?.fieldId === 'summary');
    const issueTypeField = fieldsEdges.find((field)=>field?.node?.fieldId === 'issuetype');
    const statusField = fieldsEdges.find((field)=>field?.node?.fieldId === 'status');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKey = edgeNode?.issueColorField?.color?.colorKey;
    const checkParentIssueIsDone = (statusCategoryId)=>{
        const doneStatusCategoryId = (0, $7keuM).StatusCategoryIds[(0, $7keuM).StatusCategoryTypes.DONE];
        return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
    };
    const isDone = checkParentIssueIsDone(statusField?.node?.status?.statusCategory?.statusCategoryId || '');
    return {
        id: edgeNode?.id || '',
        key: edgeNode?.key || '',
        issueId: edgeNode?.issueId || undefined,
        webUrl: edgeNode?.webUrl || undefined,
        fields: {
            issuetype: {
                id: issueTypeField?.node?.issueType?.issueTypeId || '',
                name: issueTypeField?.node?.issueType?.name || '',
                iconUrl: issueTypeField?.node?.issueType?.avatar?.xsmall || ''
            },
            summary: summaryField?.node?.text || ''
        },
        color: colorKey in (0, $8URAw.MAP_FROM_SERVER_COLOR) ? (0, $8URAw.MAP_FROM_SERVER_COLOR)[colorKey] : undefined,
        value: edgeNode?.id || '',
        label: `${edgeNode?.key || ''} ${summaryField?.node?.text || ''}`,
        isDone: isDone,
        aggValue: edgeNode
    };
};
const $346ef850ba3728ec$export$6cffaaeb4c7c0c18 = (fieldOptionsData)=>(fieldOptionsData?.edges || [])?.filter((edge)=>edge?.node).map((edge)=>$346ef850ba3728ec$export$1b622b80a5cf731f(edge?.node));

});

parcelRegister("kev0f", function(module, exports) {

$parcel$export(module.exports, "transformOptionToAgg", () => $d2228ef4a598cc4e$export$4e115b8a3d13d179);
$parcel$export(module.exports, "transformOptionToOptimisticFieldResponse", () => $d2228ef4a598cc4e$export$728251e8d8f6eacb);
const $d2228ef4a598cc4e$export$4e115b8a3d13d179 = (option)=>{
    if (!option) return null;
    return {
        id: String(option?.id) || '',
        issueId: option?.issueId || '',
        webUrl: option?.webUrl || '',
        key: option?.key,
        issueColorField: {
            color: {
                colorKey: option?.color || ''
            }
        },
        issueTypeField: {
            issueType: {
                avatar: {
                    xsmall: option?.fields?.issuetype?.iconUrl || ''
                },
                name: option?.fields?.issuetype?.name || ''
            }
        },
        summaryField: {
            text: option?.fields.summary || ''
        }
    };
};
const $d2228ef4a598cc4e$export$728251e8d8f6eacb = (field, aggValue)=>{
    const summaryField = aggValue?.fieldsById?.edges?.find((edge)=>edge?.node?.__typename === 'JiraSingleLineTextField');
    const issueTypeField = aggValue?.fieldsById?.edges?.find((edge)=>edge?.node?.__typename === 'JiraIssueTypeField');
    return {
        id: field?.id,
        fieldId: field?.fieldId,
        type: field?.type,
        name: field?.name,
        parentIssue: aggValue ? {
            id: aggValue?.id,
            issueId: aggValue?.issueId,
            webUrl: aggValue?.webUrl,
            key: aggValue?.key,
            issueColorField: aggValue?.issueColorField,
            fieldsById: aggValue?.fieldsById,
            summaryField: {
                id: summaryField?.node?.id || '',
                text: summaryField?.node?.text || ''
            },
            issueTypeField: {
                id: issueTypeField?.node?.id || '',
                issueType: {
                    id: issueTypeField?.node?.issueType?.id || '',
                    avatar: {
                        xsmall: issueTypeField?.node?.issueType?.avatar?.xsmall || ''
                    },
                    name: issueTypeField?.node?.issueType?.name || ''
                }
            }
        } : null
    };
};

});


parcelRegister("e0p2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1108666f999df9c8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1108666f999df9c8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    replacedByParentField: {
        "id": "native-issue-table.common.issue-cells.parent.replaced-by-parent-field",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});

});


parcelRegister("kcYXT", function(module, exports) {

$parcel$export(module.exports, "PlainTextCell", () => $acea026246263ff8$export$4e4b42df80bf4dce);
$parcel$export(module.exports, "PlainTextCellOld", () => $acea026246263ff8$export$8361effa71bec5d8);

var $jJItF = parcelRequire("jJItF");

var $3XZRA = parcelRequire("3XZRA");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $9t1Xl = parcelRequire("9t1Xl");

var $d9T1A = parcelRequire("d9T1A");

var $9Mapt = parcelRequire("9Mapt");

var $jd93d = parcelRequire("jd93d");

var $7jTnu = parcelRequire("7jTnu");

var $3OT15 = parcelRequire("3OT15");

var $8mV8n = parcelRequire("8mV8n");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $8jOO7 = parcelRequire("8jOO7");
// Attributes for inline editing track events
const $acea026246263ff8$var$attributes = {
    // If the update was made inline (and not via the issue view)
    isInlineEditing: true
};
const $acea026246263ff8$export$4e4b42df80bf4dce = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $3XZRA.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isDensityCompact = !(0, $34oCh.useIsDensityFull)();
    const contentRef = (0, $eJOHy.useRef)(null);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    const renderCustomReadView = (0, $eJOHy.useCallback)((text)=>{
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
        if (isSingleLineRowHeightEnabled) {
            if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) {
                let hoverPopoverRef = null;
                hoverPopoverRef = hoverPopoverRefFactory({
                    content: text
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    ref: hoverPopoverRef,
                    maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW),
                    testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
                }, text);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: text,
                contentRef: contentRef
            }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    ref: (0, $jd93d.mergeRefs)(contentRef, ref),
                    maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW),
                    testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
                }, text));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: isDensityCompact ? 2 : undefined
        }, text);
    }, [
        isDensityCompact,
        isSingleLineRowHeightEnabled,
        hoverPopoverRefFactory
    ]);
    if (!isInlineEditingExtendedFieldSupportEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acea026246263ff8$export$8361effa71bec5d8, {
        fieldRef: data
    });
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9t1Xl.SingleLineTextInlineEditViewWithIsEditable), {
        attributes: $acea026246263ff8$var$attributes,
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: isFirstField ? $acea026246263ff8$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: isFirstField ? renderCustomReadView : undefined,
        hideEditButton: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled && isFirstField
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9t1Xl.SingleLineTextInlineEditViewWithIsEditable), {
        attributes: $acea026246263ff8$var$attributes,
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: renderCustomReadView,
        hideEditButton: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
});
const $acea026246263ff8$export$8361effa71bec5d8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false })=>{
    const data = (0, $j4oe4.useFragment)((0, $jJItF.default), fieldRef);
    const { text: text } = data;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(shouldOpenOnFirstRender);
    const contentRef = (0, $eJOHy.useRef)(null);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: text
    });
    if (isSingleLineRowHeightEnabled) return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        ref: hoverPopoverRef,
        maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW),
        testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
    }, text)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: text,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            paddingBlock: "space.050",
            paddingInline: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            ref: (0, $jd93d.mergeRefs)(contentRef, ref),
            maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW),
            testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
        }, text)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mV8n.TruncatedTextWithPopup), {
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, text),
        triggerText: text ?? null
    });
});
const $acea026246263ff8$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $acea026246263ff8$var$customTargetStyles,
        ref: ref
    });
});
const $acea026246263ff8$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("jJItF", function(module, exports) {

$parcel$export(module.exports, "default", () => $aff468674360a6b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a426743b8e2cd0f1a892b83a5146685e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aff468674360a6b9$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "plainText_nativeIssueTable_PlainTextCellOld_fieldRef",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$aff468674360a6b9$var$node.hash = "fac8b4989806cd588f8fc44360173e86";
var $aff468674360a6b9$export$2e2bcd8739ae039 = $aff468674360a6b9$var$node;

});

parcelRegister("3XZRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2d795d66beec621$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e42ee4fe58e0ffcde26272e806d5be3c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2d795d66beec621$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "plainText_nativeIssueTable_PlainTextCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "plainText_nativeIssueTable_PlainTextCellOld_fieldRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$a2d795d66beec621$var$node.hash = "8353edf6c7248abbd34dfd87bef397f4";
var $a2d795d66beec621$export$2e2bcd8739ae039 = $a2d795d66beec621$var$node;

});

parcelRegister("8mV8n", function(module, exports) {

$parcel$export(module.exports, "TruncatedTextWithPopup", () => $c45d5d8603d7c463$export$a81ef5b6e801751b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $2ZGUP = parcelRequire("2ZGUP");

var $cNe2t = parcelRequire("cNe2t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $iqtgH = parcelRequire("iqtgH");

var $8jOO7 = parcelRequire("8jOO7");

var $lvbmo = parcelRequire("lvbmo");
const $c45d5d8603d7c463$export$a81ef5b6e801751b = /*#__PURE__*/ (0, $eJOHy.memo)(({ triggerText: triggerText, content: content, triggerRefCallback: triggerRefCallback, onSetIsOpen: onSetIsOpen, isOpen: isOpen, maxLength: maxLength = (0, $8jOO7.MAX_LINE_WRAP_OLD) })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (!triggerText) return null;
    const onClick = ()=>{
        onSetIsOpen(!isOpen);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'truncatedTextWithPopupButton');
    };
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c45d5d8603d7c463$var$TruncatedTextContainer, {
            onClick: onClick,
            ...triggerProps,
            ref: (element)=>{
                triggerRefCallback && triggerRefCallback(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c45d5d8603d7c463$var$TruncatedText, {
            maxLength: maxLength
        }, triggerText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>onSetIsOpen(false),
        messageId: "native-issue-table.common.ui.truncated-text-cell-with-popup.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
                sourceName: "TruncatedTextPopUpContent",
                sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
            }, content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null)),
        trigger: trigger,
        placement: "bottom",
        popupComponent: (0, $lvbmo.PopupContainer)
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c45d5d8603d7c463$var$TruncatedTextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7glyw _19itglyw _11c82smr _1rjc1b66 _18zru2gc _80omtlke _1e0c1ule _vchhusvi _syaz1fxt _4t3i1osq _1bsb1osq _6sshglyw _1oex4v9p _nt751r31 _49pcglyw _1hvw1o36 _7ehi64oc _irr3166n",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c45d5d8603d7c463$var$TruncatedText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_jz2kj3": (0, $awdRS.default)(__cmplp.maxLength)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _y3gn1e5h _1e0ccj1k _1bto1l2s _sudp1e54 _1yyjpeh7 _1nmz1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lvbmo", function(module, exports) {

$parcel$export(module.exports, "PopupContainer", () => $8fff991d977513ff$export$cca08eed9de89ba9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $IW7jS = parcelRequire("IW7jS");
// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const $8fff991d977513ff$var$layerValue = (0, $IW7jS.layers).layer;
/**
 * Styling the container itself removes the need for an additional nested `<div>`,
 * containing our custom styles, in the Popup content. Having an extra `<div>`
 * introduces problems with autofocus when popup is opened.
 *
 * Unfortunately the base PopupContainer styles are not exported from atlaskit,
 * so they had to be copy + pasted and extended with our custom styles.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8fff991d977513ff$var$StyledPopupContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2rko1sit _1reo1wug _18m91wug _189eyh40 _1dqonqa1 _1h6d1p6i _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _1bsbdgin _c71l1kdj _1tke12am _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $8fff991d977513ff$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8fff991d977513ff$var$StyledPopupContainer, {
        ...props,
        ref: ref
    }));

});



parcelRegister("fvCj0", function(module, exports) {

$parcel$export(module.exports, "PriorityCell", () => $02f8ba53af0aafdd$export$b526cf238a0a0ab3);

var $1IASs = parcelRequire("1IASs");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8sJ8t = parcelRequire("8sJ8t");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");
const $02f8ba53af0aafdd$export$b526cf238a0a0ab3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $1IASs.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8sJ8t.PriorityInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
});

});
parcelRegister("1IASs", function(module, exports) {

$parcel$export(module.exports, "default", () => $da328ad02d635747$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ff13e98fbb419ea356adc53734e2cb24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $da328ad02d635747$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "priority_nativeIssueTable_PriorityCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraPriorityField"
};
$da328ad02d635747$var$node.hash = "6802a1e026f22ca790d9f99b07f6e464";
var $da328ad02d635747$export$2e2bcd8739ae039 = $da328ad02d635747$var$node;

});

parcelRegister("8sJ8t", function(module, exports) {

$parcel$export(module.exports, "PriorityInlineEditViewIsEditable", () => $1e7fc42b27c29889$export$90b66d052260aa39);
$parcel$export(module.exports, "PriorityInlineEditView", () => $1e7fc42b27c29889$export$934d144304ae7d88);

var $35cth = parcelRequire("35cth");

var $5tW5L = parcelRequire("5tW5L");

var $74Y5d = parcelRequire("74Y5d");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9Mapt = parcelRequire("9Mapt");

var $7jTnu = parcelRequire("7jTnu");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $d2AGn = parcelRequire("d2AGn");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $i0tCo = parcelRequire("i0tCo");

var $faRrL = parcelRequire("faRrL");

var $itOZI = parcelRequire("itOZI");

var $3OT15 = parcelRequire("3OT15");

var $gwLYs = parcelRequire("gwLYs");
const $1e7fc42b27c29889$var$isEqualPriority = (a, b)=>a?.value === b?.value;
const $1e7fc42b27c29889$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-priority-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $1e7fc42b27c29889$export$90b66d052260aa39 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isCompact: isCompact, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitNew: onSubmitNew, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onSubmitSucceededNew: onSubmitSucceededNew, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $74Y5d.default), fragmentRef);
    const { overriding: overriding } = (0, $7jTnu.fg)('relay-migration-issue-fields-priority') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $auNLL.useInlineEditFieldInjections)() : {
        overriding: undefined
    };
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, priority: priority } = data;
    const hoverPopoverRefFactory = shouldRenderHoverPopover && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: data.priority?.name
    });
    const fieldName = (0, $eJOHy.useMemo)(()=>overriding && (0, $7jTnu.fg)('relay-migration-issue-fields-priority') ? overriding?.overrideLabel(name) : name, [
        name,
        overriding
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding && (0, $7jTnu.fg)('relay-migration-issue-fields-priority') ? overriding?.overrideIsEditable(isEditable) : isEditable, [
        isEditable,
        overriding
    ]);
    const filterOptionsById = (0, $7jTnu.fg)('relay-migration-issue-fields-priority') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>overriding?.overrideFieldOptionsFilter(null), [
        overriding
    ]) : undefined;
    const [commit] = (0, $j4oe4.useMutation)((0, $5tW5L.default));
    // #endregion
    const initialValue = (0, $eJOHy.useMemo)(()=>priority ? {
            label: priority.name ?? '',
            value: priority.id,
            iconUrl: priority.iconUrl ?? ''
        } : null, [
        priority
    ]);
    // #region Common state
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        const aggValue = (0, $7jTnu.fg)('relay-migration-issue-fields-priority') ? (0, $gwLYs.transformOptionToAgg)(option) : undefined;
        if ((0, $7jTnu.fg)('relay-migration-issue-fields-priority')) // TODO remove eslint on relay-migration-issue-fields-priority' cleanup
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onSubmitNew?.(aggValue);
        else onSubmit?.(option);
        if (option?.value != null) commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updatePriorityField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updatePriorityField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            priority: (0, $7jTnu.fg)('relay-migration-issue-fields-priority') ? {
                                // TODO remove below eslints on relay-migration-issue-fields-priority' cleanup
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                id: aggValue.id,
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                iconUrl: aggValue.iconUrl,
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                name: aggValue.name
                            } : {
                                id: option.value,
                                iconUrl: option.iconUrl,
                                name: option.label
                            }
                        }
                    }
                }
            }
        });
    }, [
        onSubmit,
        onSubmitNew,
        commit,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $7jTnu.fg)('relay-migration-issue-fields-priority') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)((value)=>{
        onSubmitSucceededNew?.((0, $gwLYs.transformOptionToAgg)(value));
    }, [
        onSubmitSucceededNew
    ]) : undefined;
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, (0, $itOZI.getPriorityIdFromAri)(initialValue?.value), (0, $itOZI.getPriorityIdFromAri)(value?.value));
    }, [
        fieldId,
        initialValue
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $1e7fc42b27c29889$var$isEqualPriority,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: (0, $7jTnu.fg)('relay-migration-issue-fields-priority') ? handleSubmitSucceeded : onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        clipboardComponentType: 'priority',
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    const readViewContentRef = (0, $eJOHy.useRef)(null);
    const renderReadView = (0, $eJOHy.useCallback)((ref = null)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1e7fc42b27c29889$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $faRrL.PriorityReadView), {
                fragmentRef: data,
                isCompact: isCompact,
                contentRef: readViewContentRef,
                ref: ref
            })), [
        data,
        isCompact
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            openMenuOnFocus: true,
            menuPosition: menuPosition,
            filterOptionsById: filterOptionsById
        });
    const content = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
            editViewPopup: editViewPopup,
            editViewPopupAlignBlock: editViewPopupAlignBlock,
            editViewPopupMinWidth: "small",
            editViewEntryPoint: (0, $i0tCo.default),
            editViewEntryPointParams: {},
            getEditViewProps: getEditViewProps,
            fieldName: fieldName,
            hasUnsubmittedChanges: hasServerValidationError,
            invalidMessage: invalidMessage,
            isEditing: isEditing,
            isEditable: isFieldEditable,
            onCancel: handleCancel,
            onConfirm: handleConfirm,
            onEdit: handleEdit,
            onCopy: handleCopy,
            onCut: handleCut,
            onPaste: handlePaste,
            readViewFitContainerHeight: readViewFitContainerHeight,
            readView: ref ? renderReadView(ref) : renderReadView(),
            hideActionButtons: true
        });
    if (!shouldRenderHoverPopover) return content();
    if ((0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) return content(hoverPopoverRef);
    const renderWithPopover = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: data.priority?.name,
            contentRef: readViewContentRef
        }, ({ ref: ref })=>content(ref));
    return isEditing ? content() : renderWithPopover();
};
const $1e7fc42b27c29889$export$934d144304ae7d88 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $35cth.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1e7fc42b27c29889$export$90b66d052260aa39, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("35cth", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b9f8fc58164f39c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa62d4fc64bc2c74e04363ef91ec33f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8b9f8fc58164f39c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$8b9f8fc58164f39c$var$node.hash = "a5f9582db120fe1c7d1ede5d19fc0614";
var $8b9f8fc58164f39c$export$2e2bcd8739ae039 = $8b9f8fc58164f39c$var$node;

});

parcelRegister("5tW5L", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0f610aad8a2e449$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb32ad0218f1234eb10ceea6afef44da>>
 * @relayHash afc6cf650d76ec77ae6c4e967b74c46b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa
const $d0f610aad8a2e449$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPriorityFieldPayload",
                            "kind": "LinkedField",
                            "name": "updatePriorityField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraPriorityField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPriorityFieldPayload",
                            "kind": "LinkedField",
                            "name": "updatePriorityField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraPriorityField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa",
            "metadata": {},
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d0f610aad8a2e449$var$node.hash = "e0f2a7894e2dd7cf045761e8324c5c39";
var $d0f610aad8a2e449$export$2e2bcd8739ae039 = $d0f610aad8a2e449$var$node;

});

parcelRegister("74Y5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8aeb6c10c6b6e97$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a915f86f984bf0d357677c111ce3d858>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a8aeb6c10c6b6e97$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "priority_issueFieldPriorityReadviewFull_PriorityReadView"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "JiraPriorityField"
    };
}();
$a8aeb6c10c6b6e97$var$node.hash = "d2dd68625b79ae7cbb16126a5aa64c95";
var $a8aeb6c10c6b6e97$export$2e2bcd8739ae039 = $a8aeb6c10c6b6e97$var$node;

});

parcelRegister("i0tCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $09d00e9330fb89b3$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $09d00e9330fb89b3$var$PriorityEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8roj9")), {
        moduleId: "079c16d8",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $09d00e9330fb89b3$export$2e2bcd8739ae039 = $09d00e9330fb89b3$var$PriorityEditViewEntryPoint;

});
parcelRegister("8roj9", function(module, exports) {

let $6253b3694dc43a49$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6253b3694dc43a49$var$load("5lDnH").then(()=>parcelRequire('hryia'));

});


parcelRegister("faRrL", function(module, exports) {

$parcel$export(module.exports, "PriorityReadView", () => $df35b4b66c4dd438$export$9ff40693dcfb2eb3);

var $jqSCd = parcelRequire("jqSCd");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bQyn2 = parcelRequire("bQyn2");

var $d9T1A = parcelRequire("d9T1A");
const $df35b4b66c4dd438$export$9ff40693dcfb2eb3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ fragmentRef: fragmentRef, isCompact: isCompact, contentRef: contentRef }, ref)=>{
    const data = (0, $j4oe4.useFragment)((0, $jqSCd.default), fragmentRef);
    const value = data.priority;
    if (isCompact && (!value?.name || !value?.iconUrl)) return null;
    if (!value?.name || !value?.iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df35b4b66c4dd438$var$Wrapper, {
        "data-testid": "issue-field-priority-readview-full.ui.priority.wrapper",
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQyn2.default), {
        url: value.iconUrl,
        alt: isCompact ? value.name : undefined
    }), !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df35b4b66c4dd438$var$Text, {
        ref: contentRef
    }, value.name));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df35b4b66c4dd438$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _4t3igktf _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $df35b4b66c4dd438$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _18u0u2gc _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jqSCd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e96663eba06261c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac973913f9060bb519739c5dc997ac7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e96663eba06261c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_issueFieldPriorityReadviewFull_PriorityReadView",
    "selections": [
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$3e96663eba06261c$var$node.hash = "332bda8ea012bca1bc3e1ad5426cb13a";
var $3e96663eba06261c$export$2e2bcd8739ae039 = $3e96663eba06261c$var$node;

});

parcelRegister("bQyn2", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a57831c94bcd51$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dPMMf = parcelRequire("dPMMf");
const $69a57831c94bcd51$var$defaultIconSize = (0, $dPMMf.gridSize) * 2;
/* Represents an asynchronous icon loader that handles loading of icons from URLs with error handling.
 * It displays the icon fetched from the provided URL. In case of an error or if the URL is undefined,
 * a fallback UI component or placeholder is displayed.
 * This component accepts various props like URL, title, alt text, dimensions, and a fallback component
 * to customize the behavior and presentation of the loaded or placeholder icon.
 * The component also includes functionality to prevent the icon from being draggable.
 */ const $69a57831c94bcd51$var$AsyncIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, title: title, alt: alt, width: width, height: height, fallback: fallback })=>{
    const [isBroken, setIsBroken] = (0, $eJOHy.useState)(false);
    const onError = (0, $eJOHy.useCallback)(()=>{
        setIsBroken(true);
    }, []);
    const convertSize = (0, $eJOHy.useCallback)((size)=>size ? `${size}px` : '0', []);
    if (isBroken && fallback) return fallback();
    const convertedWidth = convertSize(width ?? $69a57831c94bcd51$var$defaultIconSize);
    const convertedHeight = convertSize(height ?? $69a57831c94bcd51$var$defaultIconSize);
    if (url) return /*#__PURE__*/ $eJOHy.createElement($69a57831c94bcd51$var$Image, {
        src: url,
        width: convertedWidth,
        height: convertedHeight,
        title: title ?? undefined,
        alt: alt ?? '',
        onError: onError,
        /**
     * Disabling dragging so drags happen on the parent instead of this icon.
     */ draggable: false,
        "data-vc": "common-components-async-icon"
    });
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: convertedHeight,
            width: convertedWidth
        },
        "data-testid": "common-components-async-icon.placeholder",
        className: (0, $hcewu.default)([
            "_2rko1l7b _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _bfhk1d5g"
        ])
    });
});
const $69a57831c94bcd51$var$placeholderStyles = null;
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69a57831c94bcd51$var$Image = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
$69a57831c94bcd51$var$AsyncIcon.displayName = 'AsyncIcon';
var $69a57831c94bcd51$export$2e2bcd8739ae039 = $69a57831c94bcd51$var$AsyncIcon;

});


parcelRegister("gwLYs", function(module, exports) {

$parcel$export(module.exports, "transformOptionToAgg", () => $f837a33cb89a6ac6$export$4e115b8a3d13d179);

var $itOZI = parcelRequire("itOZI");
const $f837a33cb89a6ac6$export$4e115b8a3d13d179 = (option)=>option ? {
        id: option.value,
        iconUrl: option.iconUrl,
        name: option.label,
        priorityId: (0, $itOZI.getPriorityIdFromAri)(option.value)
    } : option;

});



parcelRegister("cS9gj", function(module, exports) {

$parcel$export(module.exports, "ProjectCell", () => $ceb86fac824e4b03$export$a0acc7707bde1d3);

var $hK9EK = parcelRequire("hK9EK");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $11SWN = parcelRequire("11SWN");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $9Mapt = parcelRequire("9Mapt");

var $7jTnu = parcelRequire("7jTnu");

var $3OT15 = parcelRequire("3OT15");

var $34oCh = parcelRequire("34oCh");

var $86BUM = parcelRequire("86BUM");
const $ceb86fac824e4b03$export$a0acc7707bde1d3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isRequired: isRequired, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const data = (0, $j4oe4.useFragment)((0, $hK9EK.default), fieldRef);
    const { project: project } = data;
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!isRequired && project == null) return null;
    if (project == null || project.name == null || project.key == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "project",
        reason: "Missing required fields"
    });
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: project.name
    });
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ceb86fac824e4b03$var$AlignmentFix, {
        hasAvatar: Boolean(project.avatar?.large)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $11SWN.ProjectReadView), {
        value: {
            key: project.key,
            name: project.name,
            avatarUrls: {
                '48x48': project.avatar?.large ?? ''
            }
        },
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        },
        isTruncated: !isDensityFull
    }));
    return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ceb86fac824e4b03$var$AlignmentFix, {
        hasAvatar: Boolean(project.avatar?.large)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $11SWN.ProjectReadView), {
        value: {
            key: project.key,
            name: project.name,
            avatarUrls: {
                '48x48': project.avatar?.large ?? ''
            }
        },
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        },
        isTruncated: !isDensityFull,
        contentRef: hoverPopoverRef
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: project.name,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ceb86fac824e4b03$var$AlignmentFix, {
            hasAvatar: Boolean(project.avatar?.large),
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $11SWN.ProjectReadView), {
            value: {
                key: project.key,
                name: project.name,
                avatarUrls: {
                    '48x48': project.avatar?.large ?? ''
                }
            },
            onClick: ()=>{
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'tableIssueLink');
            },
            isTruncated: !isDensityFull,
            contentRef: contentRef
        })));
});
// The Project component has a 4px padding plus the avatar inside has a 2px invisible border that we have to account for
// Refer to: src/packages/issue/fields/project/src/ui/view/main.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ceb86fac824e4b03$var$AlignmentFix = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasAvatar: hasAvatar, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ogwtze3t _6tinze3t _1cezze3t _m3zkze3t",
            __cmplp.hasAvatar ? "_18u01i6y" : "_18u0ze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hK9EK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e6cff294f939123$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ce7d8e669aa0bfbeb602f38f079ab21>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4e6cff294f939123$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "project_nativeIssueTable_ProjectCell",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "large"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProjectField"
};
$4e6cff294f939123$var$node.hash = "21388eb803fac1056b9b023b9d4254ea";
var $4e6cff294f939123$export$2e2bcd8739ae039 = $4e6cff294f939123$var$node;

});

parcelRegister("11SWN", function(module, exports) {

$parcel$export(module.exports, "ProjectReadView", () => $cd6933b72e61d231$export$5c3359f22f4596bc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");
const $cd6933b72e61d231$export$5c3359f22f4596bc = ({ value: value, noValueText: noValueText, onClick: onClick, isTruncated: isTruncated = true, contentRef: contentRef })=>{
    const onClickLink = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        e.stopPropagation();
        onClick && onClick(e);
    }, [
        onClick
    ]);
    if (value === undefined || value === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cd6933b72e61d231$var$emptyValueContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd6933b72e61d231$var$EmptyValue, {
        "data-testid": "issue-field-project.ui.view-read-view-empty-value"
    }, noValueText || ''));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stopPropagation = (e)=>{
        e.stopPropagation();
    };
    const ReadViewContainer = (0, $7jTnu.fg)('remove_project_field_max_width') ? $cd6933b72e61d231$var$ReadViewContainerNew : $cd6933b72e61d231$var$ReadViewContainerOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ReadViewContainer, {
        "data-component-selector": "project-read-view-container"
    }, Boolean(value.avatarUrls['48x48']) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd6933b72e61d231$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        size: "xsmall",
        src: value.avatarUrls['48x48'],
        borderColor: "transparent",
        testId: "issue-field-project.ui.project-avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cd6933b72e61d231$var$labelContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        testId: "issue-field-project.ui.view-label-link",
        onClick: onClickLink,
        onKeyUp: stopPropagation,
        onKeyDown: stopPropagation,
        href: `/projects/${value.key}`,
        xcss: [
            $cd6933b72e61d231$var$labelLinkStylesBase,
            isTruncated ? $cd6933b72e61d231$var$labelLinkStylesTruncated : $cd6933b72e61d231$var$labelLinkStylesNonTruncated
        ],
        ref: contentRef
    }, value.name)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd6933b72e61d231$var$EmptyValue = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});
const $cd6933b72e61d231$var$ReadViewContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _p12fuuw1 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $cd6933b72e61d231$var$ReadViewContainerNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $cd6933b72e61d231$var$emptyValueContainerStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.075'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd6933b72e61d231$var$AvatarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $cd6933b72e61d231$var$labelContainerStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    minWidth: '0',
    marginRight: 'space.100'
});
const $cd6933b72e61d231$var$labelLinkStylesBase = (0, $1DXK0.xcss)({
    display: 'inline-block',
    maxWidth: '100%',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $cd6933b72e61d231$var$labelLinkStylesTruncated = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $cd6933b72e61d231$var$labelLinkStylesNonTruncated = (0, $1DXK0.xcss)({
    overflowWrap: 'anywhere'
});

});


parcelRegister("cC5v7", function(module, exports) {

$parcel$export(module.exports, "RadioSelectCell", () => $bf6357636c625728$export$fca29406b7991f70);

var $eJHsJ = parcelRequire("eJHsJ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cVtVW = parcelRequire("cVtVW");

var $7jTnu = parcelRequire("7jTnu");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $bf6357636c625728$export$fca29406b7991f70 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $eJHsJ.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cVtVW.RadioSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: isFirstField ? $bf6357636c625728$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        maxLines: 1,
        shouldRenderHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cVtVW.RadioSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        maxLines: 1,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $bf6357636c625728$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $bf6357636c625728$var$customTargetStyles,
        ref: ref
    });
});
const $bf6357636c625728$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("eJHsJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $710ae62002bf72d1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e866447ded66af1176c20edd32f4008a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $710ae62002bf72d1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "radioSelect_nativeIssueTable_RadioSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraRadioSelectField"
};
$710ae62002bf72d1$var$node.hash = "4ddf81d7a8f53773f53f258f07e3add7";
var $710ae62002bf72d1$export$2e2bcd8739ae039 = $710ae62002bf72d1$var$node;

});

parcelRegister("cVtVW", function(module, exports) {

$parcel$export(module.exports, "RadioSelectInlineEditViewWithIsEditable", () => $b6983db111adbe70$export$75b30b2e24d95c5b);

var $931At = parcelRequire("931At");

var $fNju7 = parcelRequire("fNju7");

var $e5obU = parcelRequire("e5obU");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $jF5pp = parcelRequire("jF5pp");

var $G3oln = parcelRequire("G3oln");

var $auNLL = parcelRequire("auNLL");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $b6983db111adbe70$var$isEqualOption = (a, b)=>a?.value === b?.value;
const $b6983db111adbe70$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-radio-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $b6983db111adbe70$export$75b30b2e24d95c5b = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, isEditable: isEditable, isEditing: startWithEditViewOpen = false, maxLines: maxLines, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $e5obU.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $fNju7.default));
    const { id: uniqueFieldId, name: name, selectedOption: selectedOption, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOption?.label) return null;
        return {
            value: selectedOption?.value ?? '',
            label: selectedOption?.label ?? ''
        };
    }, [
        selectedOption
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(option);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value ?? null
                    }
                }
            },
            onCompleted (response) {
                if (response.jira?.updateRadioSelectField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateRadioSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOption: {
                                id: option?.value ?? '',
                                label: option?.label ?? '',
                                value: option?.value ?? ''
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $b6983db111adbe70$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'radioSelect'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6983db111adbe70$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $G3oln.RadioSelectReadView), {
            fragmentRef: data,
            maxLines: maxLines,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        maxLines,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $jF5pp.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $b6983db111adbe70$export$2fe0a2918d206b4f = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $931At.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6983db111adbe70$export$75b30b2e24d95c5b, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("931At", function(module, exports) {

$parcel$export(module.exports, "default", () => $d77c6c685a91bfb9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a9b2d76f8b35cc5bb4a87c0769a312f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d77c6c685a91bfb9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$d77c6c685a91bfb9$var$node.hash = "dd081df58866af7dd0bb2712ac60b258";
var $d77c6c685a91bfb9$export$2e2bcd8739ae039 = $d77c6c685a91bfb9$var$node;

});

parcelRegister("fNju7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c790734486a3c741$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0b37515fcb043fe99058711c41a49f85>>
 * @relayHash 6a1984f2ab25de78abb9ccf7a2d36942
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a5951cc90107c30baf1e3003bb8f3971be9da2b60067cbabdc865463dde68e2b

var $dTrc4 = parcelRequire("dTrc4");
const $c790734486a3c741$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRadioSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateRadioSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraRadioSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRadioSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateRadioSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraRadioSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "selectedOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "label",
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "alias": "value",
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a5951cc90107c30baf1e3003bb8f3971be9da2b60067cbabdc865463dde68e2b",
            "metadata": {},
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default)
            }
        }
    };
}();
$c790734486a3c741$var$node.hash = "c21145b09e3422aaf4c5cef7684d37b2";
var $c790734486a3c741$export$2e2bcd8739ae039 = $c790734486a3c741$var$node;

});

parcelRegister("e5obU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b431b445dc777ef4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<59c263de72de7e78a494bb2126d6f5c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b431b445dc777ef4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "selectedOption",
            "plural": false,
            "selections": [
                {
                    "alias": "value",
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "alias": "label",
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$b431b445dc777ef4$var$node.hash = "e7794cc18631c54a9305078af2e6b52a";
var $b431b445dc777ef4$export$2e2bcd8739ae039 = $b431b445dc777ef4$var$node;

});

parcelRegister("jF5pp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f9c80b6cdc9f62d$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $5f9c80b6cdc9f62d$var$RadioSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("31GrT")), {
        moduleId: "d70243cc",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $5f9c80b6cdc9f62d$export$2e2bcd8739ae039 = $5f9c80b6cdc9f62d$var$RadioSelectEditViewEntryPoint;

});
parcelRegister("31GrT", function(module, exports) {

let $2342648d35218413$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2342648d35218413$var$load("jKXeZ").then(()=>parcelRequire('6OxSZ'));

});


parcelRegister("G3oln", function(module, exports) {

$parcel$export(module.exports, "RadioSelectReadView", () => $e7c58c6de3805c49$export$6455a2bb536ab8db);

var $ipQig = parcelRequire("ipQig");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");

var $9Mapt = parcelRequire("9Mapt");

var $jd93d = parcelRequire("jd93d");

var $7jTnu = parcelRequire("7jTnu");

var $3OT15 = parcelRequire("3OT15");
const $e7c58c6de3805c49$export$6455a2bb536ab8db = ({ fragmentRef: fragmentRef, maxLines: maxLines, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $ipQig.default), fragmentRef);
    const { selectedOption: selectedOption } = data;
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldRenderHoverPopover && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!selectedOption?.label) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: selectedOption?.label
    });
    if (shouldRenderHoverPopover) return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines,
        ref: hoverPopoverRef
    }, selectedOption?.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: selectedOption?.label,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: maxLines,
            ref: (0, $jd93d.mergeRefs)(ref, contentRef)
        }, selectedOption?.label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines,
        ref: contentRef
    }, selectedOption?.label);
};

});
parcelRegister("ipQig", function(module, exports) {

$parcel$export(module.exports, "default", () => $1793aab392779be5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b40d2dd64d21725d0e781d32a1edb4b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1793aab392779be5$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "selectedOption",
            "plural": false,
            "selections": [
                {
                    "alias": "label",
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$1793aab392779be5$var$node.hash = "7cda682c68e5f3dd6709f8005b44e0de";
var $1793aab392779be5$export$2e2bcd8739ae039 = $1793aab392779be5$var$node;

});




parcelRegister("3PbyM", function(module, exports) {

$parcel$export(module.exports, "RequestTypeCell", () => $4b9a9a7783b8b8e2$export$f5707174b12c16a9);

var $ajGVv = parcelRequire("ajGVv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $3OT15 = parcelRequire("3OT15");

var $9Mapt = parcelRequire("9Mapt");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $4b9a9a7783b8b8e2$var$REQUEST_TYPE_IMAGE_SIZE = 16;
const $4b9a9a7783b8b8e2$export$f5707174b12c16a9 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $ajGVv.default), fieldRef);
    const { requestType: requestType } = data;
    const hoverPopoverEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = hoverPopoverEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!requestType) return null;
    if (!requestType.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "requestType",
        reason: "Missing required fields"
    });
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: requestType.name
    });
    const content = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            alignBlock: "center",
            space: "space.100",
            ref: ref
        }, requestType?.avatar?.xsmall && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $4b9a9a7783b8b8e2$var$imageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
            src: requestType.avatar.xsmall,
            width: $4b9a9a7783b8b8e2$var$REQUEST_TYPE_IMAGE_SIZE,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            xcss: hoverPopoverEnabled ? $4b9a9a7783b8b8e2$var$textEllipsesStyles : $4b9a9a7783b8b8e2$var$textOverflowStyles,
            ref: contentRef
        }, requestType.name));
    if (hoverPopoverEnabled) {
        if ((0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) return content(hoverPopoverRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: requestType.name,
            contentRef: contentRef
        }, ({ ref: ref })=>content(ref));
    }
    return content();
});
const $4b9a9a7783b8b8e2$var$imageContainerStyles = (0, $1DXK0.xcss)({
    display: 'inline',
    height: `${$4b9a9a7783b8b8e2$var$REQUEST_TYPE_IMAGE_SIZE}px`
});
const $4b9a9a7783b8b8e2$var$textOverflowStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});
const $4b9a9a7783b8b8e2$var$textEllipsesStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordBreak: 'break-word'
});

});
parcelRegister("ajGVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $836bec6bd1923d4a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<855d83dab38037b4c84a9c2eecba381d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $836bec6bd1923d4a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "requestType_nativeIssueTable_RequestTypeCell",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "concreteType": "JiraServiceManagementRequestType",
            "kind": "LinkedField",
            "name": "requestType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "xsmall"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraServiceManagementRequestTypeField"
};
$836bec6bd1923d4a$var$node.hash = "426fa73f24ee625613ad6e1ed09d9b53";
var $836bec6bd1923d4a$export$2e2bcd8739ae039 = $836bec6bd1923d4a$var$node;

});


parcelRegister("bmB3W", function(module, exports) {

$parcel$export(module.exports, "ResolutionCell", () => $a44fa21abc4dacd6$export$8b67413bfec99fe);

var $3XH1U = parcelRequire("3XH1U");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $9Mapt = parcelRequire("9Mapt");

var $jd93d = parcelRequire("jd93d");

var $7jTnu = parcelRequire("7jTnu");

var $3OT15 = parcelRequire("3OT15");

var $34oCh = parcelRequire("34oCh");

var $iOUbG = parcelRequire("iOUbG");
const $a44fa21abc4dacd6$export$8b67413bfec99fe = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $3XH1U.default), fieldRef);
    const { resolution: resolution } = data;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    const text = resolution?.name ?? formatMessage((0, $iOUbG.default).unresolved);
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a44fa21abc4dacd6$var$Cell, {
        "data-vc": "native-issue-table-ui-resolution-cell"
    }, text);
    if ((0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) {
        let hoverPopoverRef = null;
        if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
            content: text
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a44fa21abc4dacd6$var$Cell, {
            "data-vc": "native-issue-table-ui-resolution-cell",
            ref: hoverPopoverRef
        }, text);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: text,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a44fa21abc4dacd6$var$Cell, {
            "data-vc": "native-issue-table-ui-resolution-cell",
            ref: (0, $jd93d.mergeRefs)(contentRef, ref)
        }, text));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a44fa21abc4dacd6$var$Cell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3XH1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbf7c263609ba022$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<17253bf892080c1defc0fa78a5f3a068>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fbf7c263609ba022$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "resolution_nativeIssueTable_ResolutionCell",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "concreteType": "JiraResolution",
            "kind": "LinkedField",
            "name": "resolution",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraResolutionField"
};
$fbf7c263609ba022$var$node.hash = "beb592d5c9992aa347f2c7b6b31262c0";
var $fbf7c263609ba022$export$2e2bcd8739ae039 = $fbf7c263609ba022$var$node;

});

parcelRegister("iOUbG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d76f5b91cdad1216$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d76f5b91cdad1216$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    unresolved: {
        "id": "native-issue-table.common.issue-cells.resolution.unresolved",
        "defaultMessage": "Unresolved"
    }
});

});


parcelRegister("cmNPo", function(module, exports) {

$parcel$export(module.exports, "RichTextCell", () => $d8d884687fa28525$export$b77590c339790c17);

var $1Kaed = parcelRequire("1Kaed");

var $de0va = parcelRequire("de0va");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7ep4S = parcelRequire("7ep4S");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $3cMgR = parcelRequire("3cMgR");

var $kEUB1 = parcelRequire("kEUB1");

var $bbdV2 = parcelRequire("bbdV2");

var $9Mapt = parcelRequire("9Mapt");

var $cBavF = parcelRequire("cBavF");

var $ibVOD = parcelRequire("ibVOD");

var $7jTnu = parcelRequire("7jTnu");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");

var $5Rrfi = parcelRequire("5Rrfi");

var $8ia30 = parcelRequire("8ia30");

var $9Ubc3 = parcelRequire("9Ubc3");

var $g2AHA = parcelRequire("g2AHA");
const $d8d884687fa28525$export$b77590c339790c17 = /*#__PURE__*/ (0, $eJOHy.memo)(({ issueKey: issueKey, fieldRef: fieldRef, issueRef: issueRef, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false, isFirstField: isFirstField })=>{
    const { richText: richText, fieldId: fieldId } = (0, $j4oe4.useFragment)((0, $de0va.default), fieldRef);
    const issueData = (0, $j4oe4.useFragment)((0, $1Kaed.default), issueRef || null);
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            fieldId: fieldId,
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        fieldId,
        cloudId,
        issueKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $9Ubc3.richTextPopUpContentEntryPoint), entryPointParams);
    if (isSingleLineRowHeightEnabled && !isDensityFull) {
        const previewText = richText?.adfValue?.convertedPlainText?.plainText;
        if (!isFirstField && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $d8d884687fa28525$var$readOnlyNoPopoverStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: 1
        }, previewText));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: previewText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                    entryPointReferenceSubject: entryPointReferenceSubject,
                    id: "rich-text-popup-content",
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g2AHA.ErrorState), null),
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                        size: "medium"
                    }),
                    runtimeProps: {}
                }),
                entryPointActions: entryPointActions,
                isInteractive: true // Applying a fixed width when the content contains media (e.g images) to prevent the popover from collapsing
                ,
                // when the popup only contains a single image or an image with a small amount of text
                isFixedWidth: (0, $7jTnu.fg)('issue_table_single_line_row_height_fast_follows') ? previewText?.includes('[media]') : true,
                analyticsAttributes: {
                    cellType: 'rich-text'
                }
            }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                    xcss: $d8d884687fa28525$var$richTextCellWrapperStyles,
                    ref: ref,
                    ...props
                }, previewText))));
    }
    if (isDensityFull) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ia30.RichTextCellFull), {
        issueKey: issueKey,
        richText: richText?.adfValue?.json || '',
        canBeExported: issueData?.canBeExported
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Rrfi.RichTextCellCompact), {
        fieldId: fieldId,
        plainText: richText?.adfValue?.convertedPlainText?.plainText || '',
        issueKey: issueKey,
        shouldOpenOnFirstRender: shouldOpenOnFirstRender
    });
});
const $d8d884687fa28525$var$richTextCellWrapperStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    display: 'block',
    backgroundColor: 'color.background.neutral.subtle',
    boxSizing: 'border-box',
    height: '100%',
    font: 'font.body',
    width: '100%',
    textAlign: 'left',
    borderWidth: 'border.width.outline',
    borderStyle: 'solid',
    borderRadius: 'border.radius',
    // @ts-expect-error Transparent is not valid but should be
    borderColor: 'transparent',
    ':focus': {
        borderColor: 'color.border.focused',
        outline: 'none'
    }
});
const $d8d884687fa28525$var$readOnlyNoPopoverStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    display: 'block',
    backgroundColor: 'color.background.neutral.subtle',
    boxSizing: 'border-box',
    height: '100%',
    font: 'font.body',
    width: '100%',
    textAlign: 'left',
    borderWidth: 'border.width.outline',
    borderStyle: 'solid',
    borderRadius: 'border.radius',
    // @ts-expect-error Transparent is not valid but should be
    borderColor: 'transparent',
    ':focus': {
        borderColor: 'color.border.focused',
        outline: 'none'
    }
});

});
parcelRegister("1Kaed", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff34dbbfcfadaafc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7015fe40c096d2611995826fe9007308>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ff34dbbfcfadaafc$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "richText_nativeIssueTable_RichTextCell_issueRef",
    "selections": [
        {
            "condition": "isDensityFull",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canBeExported"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$ff34dbbfcfadaafc$var$node.hash = "6b89e8c15c1698f5f6af6c467470897f";
var $ff34dbbfcfadaafc$export$2e2bcd8739ae039 = $ff34dbbfcfadaafc$var$node;

});

parcelRegister("de0va", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac469b5928490e9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bda41d384640311154c7f8d58b578860>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5ac469b5928490e9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "richText_nativeIssueTable_RichTextCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "richText",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraADF",
                    "kind": "LinkedField",
                    "name": "adfValue",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isDensityFull",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAdfToConvertedPlainText",
                                    "kind": "LinkedField",
                                    "name": "convertedPlainText",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "plainText"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isDensityFull",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "json"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraRichTextField"
};
$5ac469b5928490e9$var$node.hash = "9735b308958216a9c39073bc5e73008a";
var $5ac469b5928490e9$export$2e2bcd8739ae039 = $5ac469b5928490e9$var$node;

});

parcelRegister("5Rrfi", function(module, exports) {

$parcel$export(module.exports, "RichTextCellCompact", () => $d1b17c4c3bf914ca$export$367da69f6099f447);

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $kEUB1 = parcelRequire("kEUB1");

var $8jOO7 = parcelRequire("8jOO7");

var $8mV8n = parcelRequire("8mV8n");

var $g2AHA = parcelRequire("g2AHA");

var $9Ubc3 = parcelRequire("9Ubc3");
const $d1b17c4c3bf914ca$var$runtimeProps = {};
const $d1b17c4c3bf914ca$export$367da69f6099f447 = /*#__PURE__*/ (0, $eJOHy.memo)(({ issueKey: issueKey, fieldId: fieldId, plainText: plainText, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            fieldId: fieldId,
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        fieldId,
        cloudId,
        issueKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $9Ubc3.richTextPopUpContentEntryPoint), entryPointParams);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(shouldOpenOnFirstRender);
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mV8n.TruncatedTextWithPopup), {
        triggerText: plainText,
        triggerRefCallback: triggerRef,
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "rich-text-popup-content",
            packageName: (0, $8jOO7.PACKAGE_NAME),
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g2AHA.ErrorState), null),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            }),
            runtimeProps: $d1b17c4c3bf914ca$var$runtimeProps
        })
    });
});

});
parcelRegister("g2AHA", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $96069305cd4df334$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1NG86 = parcelRequire("1NG86");

var $lRq8t = parcelRequire("lRq8t");

var $91wBH = parcelRequire("91wBH");

var $BE68B = parcelRequire("BE68B");
const $96069305cd4df334$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96069305cd4df334$var$StyledBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $BE68B.StyledText), null, formatMessage((0, $91wBH.default).errorMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $96069305cd4df334$var$StyledBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1tkeqkoa _1bah1h6o _19pkutpp _2hwx1ejb _otyrpxbi _18u01ejb _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});

});
parcelRegister("91wBH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab34034d18cfc120$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ab34034d18cfc120$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "native-issue-table.common.issue-cells.rich-text.error-state.error-message",
        "defaultMessage": "Something went wrong. Close and re-open this modal to try again."
    }
});
var $ab34034d18cfc120$export$2e2bcd8739ae039 = $ab34034d18cfc120$var$messages;

});

parcelRegister("BE68B", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $363421016b666d27$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $363421016b666d27$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $363421016b666d27$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($363421016b666d27$var$StyledTextComponent, props));

});


parcelRegister("9Ubc3", function(module, exports) {

$parcel$export(module.exports, "richTextPopUpContentEntryPoint", () => $bc94eab26320dc93$export$6c4574991456a42);

var $mCxYR = parcelRequire("mCxYR");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $bc94eab26320dc93$export$6c4574991456a42 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("l3PuD")), {
        moduleId: "e30443a3",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueKey: issueKey, fieldId: fieldId, cloudId: cloudId })=>({
            queries: {
                richTextContent: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $mCxYR.default,
                    variables: {
                        issueKey: issueKey,
                        fieldId: fieldId,
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                issueKey: issueKey
            }
        })
});

});
parcelRegister("mCxYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c084dfa0aede0222$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<43f95445791158b53e4f62c754a7e121>>
 * @relayHash f3f5453a258ab6fd76ff8a41380a7ce3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2da8aad6f8f4b5efabc8cdc7b5e6df47535b423f8314048978d461b2553a816e
const $c084dfa0aede0222$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2da8aad6f8f4b5efabc8cdc7b5e6df47535b423f8314048978d461b2553a816e",
        "metadata": {},
        "name": "ui_RichTextPopUpContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c084dfa0aede0222$export$2e2bcd8739ae039 = $c084dfa0aede0222$var$node;

});

parcelRegister("l3PuD", function(module, exports) {

let $f551d238a84d5a8d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f551d238a84d5a8d$var$load("8ibok").then(()=>parcelRequire('70Y6Z'));

});



parcelRegister("8ia30", function(module, exports) {

$parcel$export(module.exports, "RichTextCellFull", () => $78462eb2a4e30a43$export$e41920e4ba1d08f2);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $jZFgr = parcelRequire("jZFgr");

var $JHcTN = parcelRequire("JHcTN");
const $78462eb2a4e30a43$export$e41920e4ba1d08f2 = /*#__PURE__*/ (0, $eJOHy.memo)(({ richText: richText, issueKey: issueKey, canBeExported: canBeExported })=>{
    const viewContext = (0, $jZFgr.useLazyMediaViewContext)(issueKey);
    const disableMediaDownload = canBeExported === false && (0, $7jTnu.fg)('block_attachment_download_on_data_export_dsp_rule');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $78462eb2a4e30a43$var$richTextCellWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $JHcTN.AsyncRichTextRenderer), {
        mediaContext: {
            viewContext: viewContext,
            uploadContext: null,
            userAuth: null
        },
        adfDocument: richText,
        disableMediaDownload: disableMediaDownload
    }));
});
const $78462eb2a4e30a43$var$richTextCellWrapperStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100'
});

});
parcelRegister("JHcTN", function(module, exports) {

$parcel$export(module.exports, "AsyncRichTextRenderer", () => $2b5fe3805c761c54$export$7e19ac09148aecfa);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

const $2b5fe3805c761c54$var$LazyRichTextRenderer = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("9Ttw2")), {
    moduleId: "./src/packages/platform/ui/issue-table/issue-table/src/common/ui/issue-cells/rich-text/rich-text-renderer/main.tsx"
});
const $2b5fe3805c761c54$export$7e19ac09148aecfa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-rich-text-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b5fe3805c761c54$var$LazyRichTextRenderer, props));

});
parcelRegister("9Ttw2", function(module, exports) {

let $7340254d30547162$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7340254d30547162$var$load("2mJlZ").then(()=>parcelRequire('1H71o'));

});




parcelRegister("273hQ", function(module, exports) {

$parcel$export(module.exports, "SingleSelectCell", () => $b8fca2cdd4342ca3$export$2574fb9bde9d7289);

var $lsrSH = parcelRequire("lsrSH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k89l2 = parcelRequire("k89l2");

var $7jTnu = parcelRequire("7jTnu");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $b8fca2cdd4342ca3$export$2574fb9bde9d7289 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $lsrSH.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k89l2.SingleSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupTarget: isFirstField ? $b8fca2cdd4342ca3$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        shouldShowPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k89l2.SingleSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        shouldShowPopover: isSingleLineRowHeightEnabled
    });
};
const $b8fca2cdd4342ca3$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b8fca2cdd4342ca3$var$customTargetStyles,
        ref: ref
    });
});
const $b8fca2cdd4342ca3$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("lsrSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef29c58cb668276$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d57f69fb6ad9a352f21f1cb6aee4989>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fef29c58cb668276$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "singleSelect_nativeIssueTable_SingleSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectField"
};
$fef29c58cb668276$var$node.hash = "aa28f66296203077a00025e9c2e0ba1b";
var $fef29c58cb668276$export$2e2bcd8739ae039 = $fef29c58cb668276$var$node;

});

parcelRegister("k89l2", function(module, exports) {

$parcel$export(module.exports, "SingleSelectInlineEditView", () => $0cdfb48f3eeb9c25$export$dd40a625fe2da362);
$parcel$export(module.exports, "SingleSelectInlineEditViewIsEditable", () => $0cdfb48f3eeb9c25$export$abac8bafb7f6b6d4);

var $1ooYc = parcelRequire("1ooYc");

var $5ZzWp = parcelRequire("5ZzWp");

var $j3aZM = parcelRequire("j3aZM");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $16sa1 = parcelRequire("16sa1");

var $3edXJ = parcelRequire("3edXJ");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $auNLL = parcelRequire("auNLL");

var $fmLhX = parcelRequire("fmLhX");

var $bJscI = parcelRequire("bJscI");
const $0cdfb48f3eeb9c25$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-single-select-lite-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $0cdfb48f3eeb9c25$export$35f807a25e63be2d = (a, b)=>a?.value === b?.value;
const $0cdfb48f3eeb9c25$export$dd40a625fe2da362 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $j3aZM.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cdfb48f3eeb9c25$export$abac8bafb7f6b6d4, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $0cdfb48f3eeb9c25$export$abac8bafb7f6b6d4 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupWidth: editViewPopupWidth, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, spacing: spacing = 'compact', menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, shouldShowPopover: shouldShowPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $5ZzWp.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $1ooYc.default));
    const { id: uniqueFieldId, name: name, fieldOption: fieldOption, fieldId: fieldId, type: fieldType } = data;
    // #endregion Relay
    // #region State
    const initialValue = (0, $eJOHy.useMemo)(()=>fieldOption ? {
            label: fieldOption.value ?? '',
            value: fieldOption.id ?? '',
            optionId: fieldOption.optionId ?? ''
        } : null, [
        fieldOption
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $eJOHy.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion State
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((newOption, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newOption);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newOption?.value ?? null
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateSingleSelectField?.success) onSuccess();
                else {
                    const errorMessage = response.jira?.updateSingleSelectField?.errors?.[0]?.message ?? undefined;
                    errorMessage ? onFail(new Error(`Relay error encountered while updating single select field - ${errorMessage}`), errorMessage) : onFail();
                }
            },
            onError: (error)=>onFail(error, error.message),
            optimisticResponse: {
                jira: {
                    updateSingleSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: name,
                            fieldId: fieldId,
                            type: fieldType,
                            fieldOptions: null,
                            fieldOption: newOption ? {
                                id: newOption.value,
                                optionId: newOption.optionId,
                                value: newOption.label,
                                color: newOption.color ? {
                                    colorKey: newOption.color.colorKey,
                                    id: null
                                } : null
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldType,
        name,
        onSubmit,
        uniqueFieldId
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        isValueEqual: $0cdfb48f3eeb9c25$export$35f807a25e63be2d,
        clipboardComponentType: 'singleSelect'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    // #endregion Action
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cdfb48f3eeb9c25$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fmLhX.SingleSelectReadView), {
            fieldType: fieldType,
            fragmentRef: data,
            shouldShowPopover: shouldShowPopover
        })), [
        data,
        fieldType,
        shouldShowPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            fieldType: fieldType,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            filterOptionsById: filterOptionsById,
            spacing: spacing,
            openMenuOnFocus: true
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $3edXJ.default),
        editViewEntryPointParams: {
            id: uniqueFieldId,
            filterById: filterOptionsById
        },
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: shouldShowPopover
    });
// #endregion View
};

});
parcelRegister("1ooYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f67695e52ea8b70$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<88acbd5b79f471fc47c28983068bbddd>>
 * @relayHash 311b99cf1b1fec46cc8b6d0e040acce5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0a742688bcd5bd90e49edcf85d259e397e82cd087c50c637945c254ea1fdb5b4

var $kZq2R = parcelRequire("kZq2R");

var $dTrc4 = parcelRequire("dTrc4");
const $3f67695e52ea8b70$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "fieldOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "concreteType": "JiraColor",
                                                    "kind": "LinkedField",
                                                    "name": "color",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "colorKey"
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "optionId"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldOptions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0a742688bcd5bd90e49edcf85d259e397e82cd087c50c637945c254ea1fdb5b4",
            "metadata": {},
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default)
            }
        }
    };
}();
$3f67695e52ea8b70$var$node.hash = "4efc8e08a4925bceb3af2c617ed6d9ee";
var $3f67695e52ea8b70$export$2e2bcd8739ae039 = $3f67695e52ea8b70$var$node;

});

parcelRegister("5ZzWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $03103f20675c4079$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf08ad1c8fb2273d225a10ddb1a04bd8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03103f20675c4079$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView"
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "optionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectField"
    };
}();
$03103f20675c4079$var$node.hash = "28f321ab534b072c7deae95a3905b5dd";
var $03103f20675c4079$export$2e2bcd8739ae039 = $03103f20675c4079$var$node;

});

parcelRegister("j3aZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce4d75d1ae344d6f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<608f4af1a5cabdbfcda4b6156bf47821>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ce4d75d1ae344d6f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectField"
};
$ce4d75d1ae344d6f$var$node.hash = "91dade2591d1180af31cf3ea5a906996";
var $ce4d75d1ae344d6f$export$2e2bcd8739ae039 = $ce4d75d1ae344d6f$var$node;

});

parcelRegister("3edXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d63ec91007e0fb8$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $7jTnu = parcelRequire("7jTnu");

var $1Yyty = parcelRequire("1Yyty");

const $7d63ec91007e0fb8$var$SingleSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7sKxi")), {
        moduleId: "2f9b0ca9",
        priority: "interaction"
    }),
    getPreloadProps: ({ id: id, filterById: filterById })=>(0, $7jTnu.fg)('jsc_single_select_preload_on_hover') ? {
            queries: {
                singleSelectEditViewData: {
                    parameters: $1Yyty.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    variables: {
                        id: id,
                        filterById: filterById
                    }
                }
            }
        } : {}
});
var $7d63ec91007e0fb8$export$2e2bcd8739ae039 = $7d63ec91007e0fb8$var$SingleSelectEditViewEntryPoint;

});
parcelRegister("1Yyty", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e17643d8e3fc807$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06b742fb19a2e6529885cdf09f5c8710>>
 * @relayHash 37af781a1179426a4b376a2a0406fd5a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2635dc65a51b8a59f0fbc9315844d072aac9ee6d4f9812cc638ef68b06c69d9b

var $an5hi = parcelRequire("an5hi");
const $3e17643d8e3fc807$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "singleSelect_issueSelectableFieldQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "singleSelect_issueSelectableFieldQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ],
                            "type": "JiraIssueField",
                            "abstractKey": "__isJiraIssueField"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "JiraFieldOperation",
                                    "kind": "LinkedField",
                                    "name": "fieldOperations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEdit"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraSingleSelectField"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableGroupKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableIconUrl"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDisabled"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "color",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "colorKey"
                                                                                },
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ],
                                                            "type": "JiraOption"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionId"
                                                                }
                                                            ],
                                                            "type": "JiraVersion"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions",
                                    "kind": "LinkedHandle",
                                    "name": "selectableValueOptions"
                                }
                            ],
                            "type": "JiraHasSelectableValueOptions",
                            "abstractKey": "__isJiraHasSelectableValueOptions"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2635dc65a51b8a59f0fbc9315844d072aac9ee6d4f9812cc638ef68b06c69d9b",
            "metadata": {},
            "name": "singleSelect_issueSelectableFieldQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $an5hi.default)
            }
        }
    };
}();
$3e17643d8e3fc807$var$node.hash = "bbde42dda5618f7ad8e7a90fbd9941ed";
var $3e17643d8e3fc807$export$2e2bcd8739ae039 = $3e17643d8e3fc807$var$node;

});
parcelRegister("an5hi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0b1137c52b8d888$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $b0b1137c52b8d888$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('thor_colourful_single_select_milestone2_gate');
    }
};

});


parcelRegister("7sKxi", function(module, exports) {

let $56ef3efd8b990ebe$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $56ef3efd8b990ebe$var$load("5uj8R").then(()=>parcelRequire('kfaV9'));

});


parcelRegister("fmLhX", function(module, exports) {

$parcel$export(module.exports, "SingleSelectReadView", () => $18bf8c7160e24e99$export$68bfa072e694358d);

var $8gAft = parcelRequire("8gAft");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8IeH1 = parcelRequire("8IeH1");

var $epTsa = parcelRequire("epTsa");

var $d9T1A = parcelRequire("d9T1A");

var $kp5kj = parcelRequire("kp5kj");

var $jbtzi = parcelRequire("jbtzi");

var $814y1 = parcelRequire("814y1");

var $9Mapt = parcelRequire("9Mapt");

var $7jTnu = parcelRequire("7jTnu");

var $jd93d = parcelRequire("jd93d");

var $3OT15 = parcelRequire("3OT15");
const $18bf8c7160e24e99$export$68bfa072e694358d = (props)=>{
    const { fragmentRef: fragmentRef, fieldType: fieldType, shouldShowPopover: shouldShowPopover } = props;
    const data = (0, $j4oe4.useFragment)((0, $8gAft.default), fragmentRef);
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldShowPopover && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: data.fieldOption?.value
    });
    if (!data.fieldOption?.value) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    const totalOptionsCount = data?.fieldOptions?.totalCount ?? 0;
    const isCategoryAndListExperimentON = props.fieldType === (0, $814y1.CATEGORY_TYPE);
    // Separate checks to assure exposure
    const isSingleSelectAndColourfulExperimentOn = fieldType === (0, $814y1.SELECT_CF_TYPE) && // removing total options count check with empanada_remove_singleselect_readview_fieldoptions
    ((0, $7jTnu.fg)('empanada_remove_singleselect_readview_fieldoptions') || totalOptionsCount <= (0, $jbtzi.FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST)) && (0, $epTsa.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false);
    if (isSingleSelectAndColourfulExperimentOn || isCategoryAndListExperimentON) {
        if (shouldShowPopover) return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            name: data.fieldOption?.value ?? '',
            color: data.fieldOption?.color?.colorKey ?? null,
            ref: hoverPopoverRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: data.fieldOption.value,
            contentRef: contentRef
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
                name: data.fieldOption?.value ?? '',
                color: data.fieldOption?.color?.colorKey ?? null,
                ref: (0, $jd93d.mergeRefs)(ref, contentRef)
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            name: data.fieldOption.value,
            color: data?.fieldOption?.color?.colorKey ?? null,
            showTooltip: (0, $epTsa.expVal)('single_select_with_tooltips', 'enabled', false) || (0, $7jTnu.fg)('add_tooltip_to_single_select_options')
        });
    }
    const contentWithPopover = ()=>(0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            ref: hoverPopoverRef
        }, data.fieldOption?.value ?? '') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: data.fieldOption?.value ?? '',
            contentRef: contentRef
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                ref: (0, $jd93d.mergeRefs)(ref, contentRef)
            }, data.fieldOption?.value ?? ''));
    return shouldShowPopover ? contentWithPopover() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data.fieldOption?.value ?? '');
};

});
parcelRegister("8gAft", function(module, exports) {

$parcel$export(module.exports, "default", () => $979e9f61b251491b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<72f0102a70ed58d52179ee130290c15e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $979e9f61b251491b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraOptionConnection",
                    "kind": "LinkedField",
                    "name": "fieldOptions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "fieldOption",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSingleSelectField"
};
$979e9f61b251491b$var$node.hash = "4719cfe591e56918754591749ccec2fd";
var $979e9f61b251491b$export$2e2bcd8739ae039 = $979e9f61b251491b$var$node;

});




parcelRegister("iour7", function(module, exports) {

$parcel$export(module.exports, "SprintCell", () => $03bf701914b6346f$export$a092d4418bd765b8);

var $l3cXw = parcelRequire("l3cXw");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $cMwFX = parcelRequire("cMwFX");

var $jJI50 = parcelRequire("jJI50");

var $eqbO4 = parcelRequire("eqbO4");

var $P01So = parcelRequire("P01So");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");
/**
 * Expected JQL Output: `${jqlTerm} = ${sprintId}`
 */ const $03bf701914b6346f$var$getSprintJql = (jqlTerm, sprintId)=>{
    const jast = (0, $f26C8.default).jast((0, $f26C8.default).query((0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $P01So.escapeBackslashes)(jqlTerm)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand(String(sprintId)))));
    return (0, $1jiqw.print)(jast, {
        operatorCase: 'upper'
    });
};
const $03bf701914b6346f$export$a092d4418bd765b8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, projectKey: projectKey, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $l3cXw.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const [restrictSprints, { onRestrictSprints: onRestrictSprints }] = (0, $jJI50.useRestrictSprints)();
    const getUrl = (0, $eJOHy.useCallback)((sprintId)=>{
        const jql = $03bf701914b6346f$var$getSprintJql(jqlTerm, sprintId);
        return `${issueSearchBaseUrl}?jql=${encodeURIComponent(jql)}`;
    }, [
        issueSearchBaseUrl,
        jqlTerm
    ]);
    const shouldTruncate = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cMwFX.SprintInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        getUrl: getUrl,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        onRestrictSprints: onRestrictSprints,
        projectKey: projectKey,
        readViewFitContainerHeight: true,
        restrictSprints: restrictSprints,
        isTruncated: shouldTruncate
    });
});

});
parcelRegister("l3cXw", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa542055fe52b0a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a62cc27130243d03242a5f5bc30151b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa542055fe52b0a1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "sprint_nativeIssueTable_SprintCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSprintField"
};
$aa542055fe52b0a1$var$node.hash = "a6a38290e680b03dbe7f0c69af281f9c";
var $aa542055fe52b0a1$export$2e2bcd8739ae039 = $aa542055fe52b0a1$var$node;

});

parcelRegister("cMwFX", function(module, exports) {

$parcel$export(module.exports, "SprintInlineEditViewIsEditable", () => $fa6beaf7f70924f1$export$e7a88b03161da897);
$parcel$export(module.exports, "SprintInlineEditView", () => $fa6beaf7f70924f1$export$c035f6dfde6d5d50);

var $37A4u = parcelRequire("37A4u");

var $6p71y = parcelRequire("6p71y");

var $6zBPl = parcelRequire("6zBPl");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $d2AGn = parcelRequire("d2AGn");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $4DuQo = parcelRequire("4DuQo");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $iy7qP = parcelRequire("iy7qP");

var $9G6SK = parcelRequire("9G6SK");

var $ibVOD = parcelRequire("ibVOD");

var $fk01k = parcelRequire("fk01k");
const $fa6beaf7f70924f1$var$isEqualSprint = (a, b)=>a?.value === b?.value;
const $fa6beaf7f70924f1$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-sprint-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $fa6beaf7f70924f1$export$e7a88b03161da897 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, getUrl: getUrl, isEditable: isFieldEditable, isEditing: startWithEditViewOpen, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onRestrictSprints: onRestrictSprints, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, projectKey: projectKey, readViewFitContainerHeight: readViewFitContainerHeight, restrictSprints: restrictSprints, isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $6zBPl.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: fieldName, selectedSprintsConnection: selectedSprintsConnection } = data;
    const [commit] = (0, $j4oe4.useMutation)((0, $6p71y.default));
    const sprintEdges = (0, $eJOHy.useMemo)(()=>selectedSprintsConnection?.edges?.filter(Boolean) ?? [], [
        selectedSprintsConnection?.edges
    ]);
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        const sprintNodes = sprintEdges.map(({ node: node })=>node).filter(Boolean);
        const currentSprint = (0, $iy7qP.findActiveOrFutureSprint)(sprintNodes);
        return currentSprint && (0, $iy7qP.isObjectWithSprintState)(currentSprint) ? {
            value: currentSprint.id,
            label: currentSprint.name ?? '',
            state: currentSprint.state,
            sprintId: currentSprint.sprintId
        } : null;
    }, [
        sprintEdges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.((0, $fk01k.transformOptionToAgg)(selectedSprintsConnection?.edges ?? [], option));
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSprintField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: (0, $fk01k.toOptimisticResponse)(uniqueFieldId, option, sprintEdges)
        });
    }, [
        commit,
        onSubmit,
        selectedSprintsConnection?.edges,
        sprintEdges,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>{
        onSubmitSucceeded?.((0, $fk01k.transformOptionToAgg)(selectedSprintsConnection?.edges ?? [], value));
    }, [
        onSubmitSucceeded,
        selectedSprintsConnection?.edges
    ]);
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, initialValue?.sprintId, value?.sprintId || null);
    }, [
        fieldId,
        initialValue
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $fa6beaf7f70924f1$var$isEqualSprint,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'sprint',
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa6beaf7f70924f1$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9G6SK.SprintReadView), {
            fragmentRef: data,
            getUrl: getUrl,
            isTruncated: isTruncated
        }))), [
        data,
        getUrl,
        isTruncated
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            projectKey: projectKey,
            onRestrictSprints: onRestrictSprints,
            restrictSprints: restrictSprints,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $4DuQo.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isTruncated,
        hideActionButtons: true
    });
};
const $fa6beaf7f70924f1$export$c035f6dfde6d5d50 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $37A4u.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa6beaf7f70924f1$export$e7a88b03161da897, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("37A4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $501657d6da7e919b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37eab354ffef704063d36bf755f8ce5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $501657d6da7e919b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$501657d6da7e919b$var$node.hash = "aba26260bac1c5d276c6291d7046e952";
var $501657d6da7e919b$export$2e2bcd8739ae039 = $501657d6da7e919b$var$node;

});

parcelRegister("6p71y", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5263f31c70ddd02$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d38c11cbcc28d051d2caaff8b2100e27>>
 * @relayHash fe046116013b2c3336c51bcbbb0fadff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41bae81fc0a3022641c80d39ea76c8cb98023eb98fecc3699abf8ef4138c4e7
const $a5263f31c70ddd02$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSprintFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSprintField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSprintField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "sprint_issueFieldSprintReadviewFull_SprintReadView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSprintFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSprintField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSprintField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraSprintConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedSprintsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSprintEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprint",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "sprintId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "endDate"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e41bae81fc0a3022641c80d39ea76c8cb98023eb98fecc3699abf8ef4138c4e7",
            "metadata": {},
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a5263f31c70ddd02$var$node.hash = "10015ae363c37285aaa230e388ba466f";
var $a5263f31c70ddd02$export$2e2bcd8739ae039 = $a5263f31c70ddd02$var$node;

});

parcelRegister("6zBPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $706729d2dadf5cd6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac88ab127ac9ae040b14fea73c66a12b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $706729d2dadf5cd6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "sprint_issueFieldSprintReadviewFull_SprintReadView"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSprintField"
    };
}();
$706729d2dadf5cd6$var$node.hash = "52958eeea1ec618ec650c65098329a2d";
var $706729d2dadf5cd6$export$2e2bcd8739ae039 = $706729d2dadf5cd6$var$node;

});

parcelRegister("4DuQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b10e4eaf75093e1$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7b10e4eaf75093e1$var$SprintEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("ibvj6")), {
        moduleId: "8d561192",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $7b10e4eaf75093e1$export$2e2bcd8739ae039 = $7b10e4eaf75093e1$var$SprintEditViewEntryPoint;

});
parcelRegister("ibvj6", function(module, exports) {

let $036a9b00236e4f47$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $036a9b00236e4f47$var$load("iMnjN").then(()=>parcelRequire('jqyo2'));

});


parcelRegister("iy7qP", function(module, exports) {

$parcel$export(module.exports, "getRapidViewUrl", () => $e14a9757607507d9$export$e6c9132cef5ee76f);
$parcel$export(module.exports, "findActiveOrFutureSprint", () => $e14a9757607507d9$export$d53a51166e1544ba);
$parcel$export(module.exports, "isClosedSprint", () => $e14a9757607507d9$export$7494fd835c1a1b3);
$parcel$export(module.exports, "filterClosedSprints", () => $e14a9757607507d9$export$af48278faaf4e92d);
$parcel$export(module.exports, "isObjectWithSprintState", () => $e14a9757607507d9$export$9ba6a679066a1e8c);

var $3V5Jq = parcelRequire("3V5Jq");
const $e14a9757607507d9$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $e14a9757607507d9$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state != null && sprint.state.toUpperCase() === state.toUpperCase();
const $e14a9757607507d9$export$fb6b70a9c996212b = (sprints, state)=>sprints.find($e14a9757607507d9$export$d2fec4e2fc5f065a(state));
const $e14a9757607507d9$export$d53a51166e1544ba = (value)=>{
    const activeSprint = $e14a9757607507d9$export$fb6b70a9c996212b(value, (0, $3V5Jq.ACTIVE_SPRINT_STATE));
    if (activeSprint) return activeSprint;
    const futureSprint = $e14a9757607507d9$export$fb6b70a9c996212b(value, (0, $3V5Jq.FUTURE_SPRINT_STATE));
    if (futureSprint) return futureSprint;
    return null;
};
const $e14a9757607507d9$export$7494fd835c1a1b3 = $e14a9757607507d9$export$d2fec4e2fc5f065a((0, $3V5Jq.CLOSED_SPRINT_STATE));
const $e14a9757607507d9$export$af48278faaf4e92d = (value)=>value.filter($e14a9757607507d9$export$7494fd835c1a1b3);
const $e14a9757607507d9$export$9ba6a679066a1e8c = (val)=>val.state ? val.state in (0, $3V5Jq.SPRINT_STATES) : false;

});
parcelRegister("3V5Jq", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $7e490155e8b1a9ed$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $7e490155e8b1a9ed$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $7e490155e8b1a9ed$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $7e490155e8b1a9ed$export$73a0206a4dc59760);
const $7e490155e8b1a9ed$export$3ebc9911a79d714f = 'ACTIVE';
const $7e490155e8b1a9ed$export$863e42082c6bde5 = 'FUTURE';
const $7e490155e8b1a9ed$export$86cdef09a89e8c4b = 'CLOSED';
const $7e490155e8b1a9ed$export$73a0206a4dc59760 = {
    ACTIVE: $7e490155e8b1a9ed$export$3ebc9911a79d714f,
    CLOSED: $7e490155e8b1a9ed$export$86cdef09a89e8c4b,
    FUTURE: $7e490155e8b1a9ed$export$863e42082c6bde5
};

});


parcelRegister("9G6SK", function(module, exports) {

$parcel$export(module.exports, "SprintReadView", () => $e0780739f49c9cfa$export$ea735e24cb7dd13);

var $6SUEP = parcelRequire("6SUEP");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jFHCE = parcelRequire("jFHCE");

var $j4oe4 = parcelRequire("j4oe4");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $3Lkm9 = parcelRequire("3Lkm9");

var $9Mapt = parcelRequire("9Mapt");

var $ibVOD = parcelRequire("ibVOD");

var $jd93d = parcelRequire("jd93d");

var $iy7qP = parcelRequire("iy7qP");

var $jON6X = parcelRequire("jON6X");

var $fLyz2 = parcelRequire("fLyz2");
const $e0780739f49c9cfa$export$ea735e24cb7dd13 = ({ fragmentRef: fragmentRef, shouldHideSprintLink: shouldHideSprintLink = false, shouldHideClosedSprintsLinks: shouldHideClosedSprintsLinks = false, placeholder: placeholder, onSprintClick: onSprintClick, getUrl: getUrl = (0, $iy7qP.getRapidViewUrl), isTruncated: isTruncated })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const placeholderMessage = placeholder || formatMessage((0, $3Lkm9.default).emptyFieldText);
    const { selectedSprintsConnection: selectedSprintsConnection } = (0, $j4oe4.useFragment)((0, $6SUEP.default), fragmentRef);
    const sprints = (0, $eJOHy.useMemo)(()=>selectedSprintsConnection?.edges?.filter(Boolean).map(({ node: node })=>node).filter(Boolean).filter((0, $iy7qP.isObjectWithSprintState)).map((node)=>({
                id: node.id,
                sprintId: parseInt(node.sprintId, 10),
                name: node.name,
                state: node.state,
                endDate: node.endDate ?? undefined
            })) ?? [], [
        selectedSprintsConnection?.edges
    ]);
    const value = (0, $eJOHy.useMemo)(()=>{
        const currentSprint = (0, $iy7qP.findActiveOrFutureSprint)(sprints);
        if (!currentSprint) return null;
        const sprintOption = {
            label: currentSprint.name,
            value: currentSprint.id,
            href: getUrl(currentSprint.sprintId),
            state: currentSprint.state
        }; // If in backlog, use onSprintClick instead of href
        return onSprintClick ? (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(sprintOption, 'href') : sprintOption;
    }, [
        getUrl,
        onSprintClick,
        sprints
    ]);
    const closedSprints = (0, $eJOHy.useMemo)(()=>(0, $iy7qP.filterClosedSprints)(sprints)?.map((closedSprint)=>({
                id: closedSprint.sprintId,
                name: closedSprint.name,
                href: getUrl(closedSprint.sprintId),
                endDate: formatDate(closedSprint.endDate, {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                })
            })), [
        formatDate,
        getUrl,
        sprints
    ]);
    const sprintContentRef = (0, $eJOHy.useRef)(null);
    const renderClosedSprints = (0, $eJOHy.useCallback)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, closedSprints.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jON6X.default), props));
    }, [
        closedSprints
    ]);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !isTruncated,
        xcss: $e0780739f49c9cfa$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: value?.label,
            contentRef: sprintContentRef,
            shouldGetParentRef: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fLyz2.default), {
                value: value,
                shouldHideSprintLink: shouldHideSprintLink,
                placeholder: placeholderMessage,
                onClick: onSprintClick,
                sprintContentRef: (0, $jd93d.mergeRefs)(ref, sprintContentRef),
                hoverAttributes: props
            }))), renderClosedSprints({
        closedSprints: closedSprints,
        shouldHideLinks: shouldHideClosedSprintsLinks,
        isTruncated: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e0780739f49c9cfa$var$ReadWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fLyz2.default), {
        value: value,
        shouldHideSprintLink: shouldHideSprintLink,
        placeholder: placeholderMessage,
        onClick: onSprintClick
    }), renderClosedSprints({
        closedSprints: closedSprints,
        shouldHideLinks: shouldHideClosedSprintsLinks
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e0780739f49c9cfa$var$ReadWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1bsb1osq _1n261g80",
            __cmplp.className
        ])
    });
});
const $e0780739f49c9cfa$var$inlineStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});

});
parcelRegister("6SUEP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6578e83530060f66$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ee21c1a385c649c86345ac0a88a0470>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6578e83530060f66$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprint_issueFieldSprintReadviewFull_SprintReadView",
    "selections": [
        {
            "concreteType": "JiraSprintConnection",
            "kind": "LinkedField",
            "name": "selectedSprintsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSprintEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "sprintId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    "action": "THROW",
                                    "path": "selectedSprintsConnection.edges.node.name"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    "action": "THROW",
                                    "path": "selectedSprintsConnection.edges.node.state"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$6578e83530060f66$var$node.hash = "94ae9fbf007cadd0e44b60b0777f74f2";
var $6578e83530060f66$export$2e2bcd8739ae039 = $6578e83530060f66$var$node;

});

parcelRegister("jON6X", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed002d22c6a98a04$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $3cMgR = parcelRequire("3cMgR");

var $6joHJ = parcelRequire("6joHJ");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $c9uTK = parcelRequire("c9uTK");

var $9Mapt = parcelRequire("9Mapt");

var $5vUQ3 = parcelRequire("5vUQ3");
const $ed002d22c6a98a04$var$ClosedSprintsView = (props)=>{
    const { shouldHideLinks: shouldHideLinks = false, closedSprints: closedSprints, isTruncated: isTruncated } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isDialogOpen, setIsDialogOpen] = (0, $eJOHy.useState)(false);
    const handleButtonClick = (0, $eJOHy.useCallback)((e)=>{
        setIsDialogOpen(!isDialogOpen);
        e.stopPropagation();
    }, [
        isDialogOpen
    ]);
    const handleDialogClose = (0, $eJOHy.useCallback)((data)=>{
        setIsDialogOpen(data.isOpen);
    }, []);
    const handleDialogClick = (0, $eJOHy.useCallback)((e)=>{
        e.stopPropagation();
    }, []);
    const handleDialogMouseDown = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
    }, []);
    const closedSprintsLabel = (0, $eJOHy.useMemo)(()=>{
        const numberOfClosedSprints = closedSprints.length;
        return numberOfClosedSprints > 0 ? formatMessage((0, $5vUQ3.default).closedSprintsLabel, {
            count: numberOfClosedSprints
        }) : null;
    }, [
        closedSprints,
        formatMessage
    ]);
    const renderInlineDialogContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": "issue-field-sprint-readview-full.ui.sprint.closed-sprints.view-closed-sprint-inline-dialog-content-container"
        }, (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            weight: "medium"
        }, closedSprintsLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$Title, null, closedSprintsLabel), closedSprints.map((sprint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$ItemContainer, {
                key: sprint.name,
                "data-testid": `issue-field-sprint-readview-full.ui.sprint.closed-sprints.closed-sprint-item-${sprint.id}`
            }, shouldHideLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$NameSpan, null, sprint.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$NameLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
                href: sprint.href
            }, sprint.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$NoWrapDate, null, sprint.endDate))));
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (hoverProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: renderInlineDialogContent(),
            isInteractive: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                spacing: "none",
                ref: ref,
                testId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.button",
                ...hoverProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$ClosedSprintsCount, null, `+${closedSprints.length}`)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$Container, {
        onClick: handleDialogClick,
        onMouseDown: handleDialogMouseDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
        content: renderInlineDialogContent(),
        isOpen: isDialogOpen,
        onClose: handleDialogClose,
        placement: "bottom",
        messageId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.inline-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: handleButtonClick,
        spacing: "none",
        isSelected: isDialogOpen,
        testId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.button",
        "aria-expanded": isDialogOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$ClosedSprintsCount, null, `+${closedSprints.length}`))));
};
var $ed002d22c6a98a04$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $ed002d22c6a98a04$var$ClosedSprintsView;
const $ed002d22c6a98a04$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed002d22c6a98a04$var$ClosedSprintsCount = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _k48pi7a9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed002d22c6a98a04$var$ItemContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc _1e0c1txw _1bah1yb4 _p12f1mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed002d22c6a98a04$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});
const $ed002d22c6a98a04$var$nameStyles = `
    margin-right: ${"var(--ds-space-300, 24px)"};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ed002d22c6a98a04$var$NameLinkContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _2hwx1ejb _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ed002d22c6a98a04$var$NameSpan = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _2hwx1ejb _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed002d22c6a98a04$var$NoWrapDate = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6joHJ", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $765bdfac52a4c302$export$7ab52478615504b3);

var $eJOHy = parcelRequire("eJOHy");

var $cwZBT = parcelRequire("cwZBT");

var $SyPNn = parcelRequire("SyPNn");

var $fYeTG = parcelRequire("fYeTG");

var $1kIuW = parcelRequire("1kIuW");
const $765bdfac52a4c302$export$7ab52478615504b3 = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kIuW.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cwZBT.default), rest);
};

});
parcelRegister("1kIuW", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $7432b934335413bd$export$44a404f218b0e66e);

var $cwZBT = parcelRequire("cwZBT");

var $gL5G0 = parcelRequire("gL5G0");
const $7432b934335413bd$export$44a404f218b0e66e = (0, $gL5G0.withChoreographedToggle)((0, $cwZBT.default), 'isOpen', 'content');

});


parcelRegister("5vUQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a3bdce371919139$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3a3bdce371919139$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    closedSprintsLabel: {
        "id": "issue-field-sprint-readview-full.sprint.closed-sprints.closed-sprints-label",
        "defaultMessage": "{count} completed {count, plural, one {sprint} other {sprints}}"
    }
});

});


parcelRegister("fLyz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd3a63dfa9d33df6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $jvd21 = parcelRequire("jvd21");

var $tYLUh = parcelRequire("tYLUh");

var $c9uTK = parcelRequire("c9uTK");

var $3qWdv = parcelRequire("3qWdv");
const $bd3a63dfa9d33df6$var$SprintContent = (props)=>{
    const { value: value, onClick: onClick, placeholder: placeholder, shouldHideSprintLink: shouldHideSprintLink = false, sprintContentRef: sprintContentRef, hoverAttributes: hoverAttributes } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $3qWdv.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const renderSprintContent = ()=>{
        if (shouldHideSprintLink) return value && value.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
            "data-testid": "issue-field-sprint-readview-full.ui.sprint.sprint-content.view-sprint-content-link",
            href: value?.href,
            onClick: onClick,
            ref: sprintContentRef,
            ...hoverAttributes
        }, value && value.label);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd3a63dfa9d33df6$var$Ellipsis, {
        "data-testid": "issue-field-sprint-readview-full.ui.sprint.sprint-content.view-sprint-content"
    }, value ? renderSprintContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvd21.default), null, isExperimentEnabled ? noValueTextExperiment : placeholder));
};
var $bd3a63dfa9d33df6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bd3a63dfa9d33df6$var$SprintContent;
const $bd3a63dfa9d33df6$var$Ellipsis = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jvd21", function(module, exports) {

$parcel$export(module.exports, "default", () => $d76fa90793402a52$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $d76fa90793402a52$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3qWdv", function(module, exports) {

$parcel$export(module.exports, "default", () => $81f1641e160db5ad$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $81f1641e160db5ad$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-sprint-readview-full.sprint.no-value-text-experiment",
        "defaultMessage": "Add sprint"
    }
});

});



parcelRegister("fk01k", function(module, exports) {

$parcel$export(module.exports, "toOptimisticResponse", () => $ab0accbcd13a5bc9$export$79353fa5e28d43d8);
$parcel$export(module.exports, "transformOptionToAgg", () => $ab0accbcd13a5bc9$export$4e115b8a3d13d179);

var $iy7qP = parcelRequire("iy7qP");
const $ab0accbcd13a5bc9$export$79353fa5e28d43d8 = (fieldId, option, previousEdges)=>{
    // Previously closed sprints should still be displayed for the updated field
    const selectedSprints = previousEdges.filter((edge)=>edge?.node && (0, $iy7qP.isClosedSprint)(edge.node));
    if (option) selectedSprints.unshift({
        node: {
            id: option.value,
            name: option.label,
            state: option.state,
            sprintId: option.sprintId,
            endDate: null
        }
    });
    return {
        jira: {
            updateSprintField: {
                success: true,
                errors: null,
                field: {
                    id: fieldId,
                    selectedSprintsConnection: {
                        edges: selectedSprints
                    }
                }
            }
        }
    };
};
const $ab0accbcd13a5bc9$export$4e115b8a3d13d179 = (currentEdges, option)=>{
    // Previously closed sprints should still be displayed for the updated field
    const selectedSprints = currentEdges.filter((edge)=>edge?.node && (0, $iy7qP.isClosedSprint)(edge.node));
    if (option) selectedSprints.unshift({
        node: {
            id: option.value,
            name: option.label,
            state: option.state,
            sprintId: option.sprintId,
            endDate: null
        }
    });
    return {
        selectedSprintsConnection: {
            edges: selectedSprints
        }
    };
};

});


parcelRegister("jJI50", function(module, exports) {

$parcel$export(module.exports, "useRestrictSprints", () => $1d7048aa3f6edc98$export$8fafa660b00d922);

var $4JBcj = parcelRequire("4JBcj");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $1d7048aa3f6edc98$var$initialState = {
    restrictSprints: (0, $4JBcj.getSharedRestrictSprintsValueFromLocalStorage)()
};
const $1d7048aa3f6edc98$var$actions = {
    onRestrictSprints: (restrictSprints)=>({ setState: setState })=>{
            (0, $4JBcj.setSharedRestrictSprintsValueInLocalStorage)(restrictSprints);
            setState({
                restrictSprints: restrictSprints
            });
        }
};
const $1d7048aa3f6edc98$var$RestrictSprintsStore = (0, $GtRbT.createStore)({
    initialState: $1d7048aa3f6edc98$var$initialState,
    actions: $1d7048aa3f6edc98$var$actions
});
const $1d7048aa3f6edc98$export$8fafa660b00d922 = (0, $iJq0l.createHook)($1d7048aa3f6edc98$var$RestrictSprintsStore, {
    selector: (state)=>state.restrictSprints
});

});
parcelRegister("4JBcj", function(module, exports) {

$parcel$export(module.exports, "getSharedRestrictSprintsValueFromLocalStorage", () => $f5002babcd0c3294$export$7186d1e916f1211c);
$parcel$export(module.exports, "setSharedRestrictSprintsValueInLocalStorage", () => $f5002babcd0c3294$export$4e2f56cec9369837);

var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");
// Helper functions to get the checkbox value in sprint edit component from local storage
const $f5002babcd0c3294$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY = 'edit_sprint_cache_value';
const $f5002babcd0c3294$var$storageProvider = (0, $dnU6V.createLocalStorageProvider)('', false);
const $f5002babcd0c3294$var$getRestrictSprintsValueFromLocalStorage = (key)=>{
    // SSR should not try to retrieve local storage values, so return default value
    if (false) return true;
    let value;
    try {
        if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) value = $f5002babcd0c3294$var$storageProvider.get(key);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        value = window.localStorage?.getItem(key);
        return value ? JSON.parse(value) : true;
    } catch  {
        return true;
    }
};
const $f5002babcd0c3294$var$setRestrictSprintsValueInLocalStorage = (key, value)=>{
    try {
        const valueToStore = String(value);
        if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) $f5002babcd0c3294$var$storageProvider.set(key, valueToStore);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.localStorage.setItem(key, valueToStore);
    } catch  {
    // do nothing
    }
};
const $f5002babcd0c3294$export$7186d1e916f1211c = ()=>$f5002babcd0c3294$var$getRestrictSprintsValueFromLocalStorage($f5002babcd0c3294$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY);
const $f5002babcd0c3294$export$4e2f56cec9369837 = (value)=>$f5002babcd0c3294$var$setRestrictSprintsValueInLocalStorage($f5002babcd0c3294$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY, value);

});



parcelRegister("7B1xx", function(module, exports) {

$parcel$export(module.exports, "TeamCell", () => $06b493236257cf7b$export$2ea8e60ef5e5f6ad);

var $8cTvr = parcelRequire("8cTvr");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $2dtFa = parcelRequire("2dtFa");

var $7jTnu = parcelRequire("7jTnu");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $06b493236257cf7b$export$2ea8e60ef5e5f6ad = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const data = (0, $j4oe4.useFragment)((0, $8cTvr.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dtFa.TeamInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: isFirstField ? $06b493236257cf7b$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        sessionId: sessionId.current,
        maxLines: isSingleLineRowHeightEnabled ? 1 : 2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dtFa.TeamInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        sessionId: sessionId.current,
        maxLines: isSingleLineRowHeightEnabled ? 1 : 2
    });
};
const $06b493236257cf7b$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $06b493236257cf7b$var$customTargetStyles,
        ref: ref
    });
});
const $06b493236257cf7b$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("8cTvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $246f220aade20370$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec77bf3f2635403a4d9a43c9c4b52a43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $246f220aade20370$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "team_nativeIssueTable_TeamCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraTeamViewField"
};
$246f220aade20370$var$node.hash = "0c8231e21e67e20de3d4bc8ca26ff0ec";
var $246f220aade20370$export$2e2bcd8739ae039 = $246f220aade20370$var$node;

});

parcelRegister("2dtFa", function(module, exports) {

$parcel$export(module.exports, "TeamInlineEditViewWithIsEditable", () => $f82f0d90cc8d59f5$export$810a8205b15f6ef5);

var $gtPRb = parcelRequire("gtPRb");

var $25NwS = parcelRequire("25NwS");

var $65yaB = parcelRequire("65yaB");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $luwvO = parcelRequire("luwvO");

var $gbhyT = parcelRequire("gbhyT");

var $8BFAJ = parcelRequire("8BFAJ");

var $auNLL = parcelRequire("auNLL");

var $b1dAu = parcelRequire("b1dAu");
const $f82f0d90cc8d59f5$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-team-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $f82f0d90cc8d59f5$var$isEqualOption = (a, b)=>a?.id === b?.id;
const $f82f0d90cc8d59f5$export$810a8205b15f6ef5 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', sessionId: sessionId, maxLines: maxLines })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $65yaB.default), fragmentRef);
    // Team will not always be available in Jira when is recently created,
    // at least not right away, due to eventual consistency. We are retrying
    // to give time to Jira to receive the newly team and accepts the given
    // team ARI as a valid team
    const retryCommit = (0, $b1dAu.useMutationWithRetriesCommit)((0, $eJOHy.useMemo)(()=>({
            retries: 3,
            isValidOnCompleted: (response)=>Boolean(response.jira?.updateTeamField?.success)
        }), []));
    const [commit] = (0, $j4oe4.useMutation)((0, $25NwS.default), retryCommit);
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedTeam: selectedTeam, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedTeam) return null;
        return {
            id: selectedTeam.jiraSuppliedId,
            name: selectedTeam.jiraSuppliedName ?? ''
        };
    }, [
        selectedTeam
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onFail: onFail, onSuccess: onSuccess })=>{
        onSubmit?.(value);
        const id = (0, $luwvO.isRecentlyCreatedTeam)(value) ? value.teamAri : value?.id ?? null;
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: id
                    }
                }
            },
            onCompleted (response) {
                if (response.jira?.updateTeamField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateTeamField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedTeam: value && {
                                jiraSuppliedId: id ?? '',
                                jiraSuppliedName: value?.name ?? ''
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $f82f0d90cc8d59f5$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'team'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f82f0d90cc8d59f5$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8BFAJ.TeamReadView), {
            fragmentRef: data,
            maxLines: maxLines,
            triggerLinkType: isFieldEditable ? 'none' : 'link'
        })), [
        data,
        maxLines,
        isFieldEditable
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            spacing: spacing,
            sessionId: sessionId
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $gbhyT.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $f82f0d90cc8d59f5$export$d6fa94a3a6e2c653 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $gtPRb.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f82f0d90cc8d59f5$export$810a8205b15f6ef5, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("gtPRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $102994d922aa2430$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65a0c0d2951c8f6f84c344c3564c0df1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $102994d922aa2430$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$102994d922aa2430$var$node.hash = "10546ea9458e9373d43b23a6a4446d16";
var $102994d922aa2430$export$2e2bcd8739ae039 = $102994d922aa2430$var$node;

});

parcelRegister("25NwS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fa234e0048e4ba1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f20c59dab77492604598897b506d3fd>>
 * @relayHash ead4aeaad9bf490eb7d3435ec219e3a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c49ad7e0999f23413665b12454770bad160b1b9af9354368998b9abe8369bcc
const $2fa234e0048e4ba1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraTeamFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraTeamViewField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraTeamFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraTeamViewField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraTeamView",
                                            "kind": "LinkedField",
                                            "name": "selectedTeam",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedName"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c49ad7e0999f23413665b12454770bad160b1b9af9354368998b9abe8369bcc",
            "metadata": {},
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2fa234e0048e4ba1$var$node.hash = "f3f61da99e07b74cee3d1344c1a154d1";
var $2fa234e0048e4ba1$export$2e2bcd8739ae039 = $2fa234e0048e4ba1$var$node;

});

parcelRegister("65yaB", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ec8e9b1b339220$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7807a89c68ac9a44db6c3316858f4987>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $72ec8e9b1b339220$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamReadviewFull_TeamReadView"
        },
        {
            "concreteType": "JiraTeamView",
            "kind": "LinkedField",
            "name": "selectedTeam",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedId"
                },
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedName"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$72ec8e9b1b339220$var$node.hash = "b9fb955ce9530b3f35116dcc41a56241";
var $72ec8e9b1b339220$export$2e2bcd8739ae039 = $72ec8e9b1b339220$var$node;

});

parcelRegister("luwvO", function(module, exports) {

$parcel$export(module.exports, "isRecentlyCreatedTeam", () => $bfc9862a1d9200d8$export$695c72729cb9130e);
const $bfc9862a1d9200d8$export$695c72729cb9130e = (team)=>{
    return team != null && Object.hasOwn(team, 'isRecentlyCreated');
};

});

parcelRegister("gbhyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0815c43a3970e724$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $0815c43a3970e724$var$MultiUserPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("f0kh7")), {
        moduleId: "47e554b4",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $0815c43a3970e724$export$2e2bcd8739ae039 = $0815c43a3970e724$var$MultiUserPickerEditViewEntryPoint;

});
parcelRegister("f0kh7", function(module, exports) {

let $aec6954d3a8606d8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $aec6954d3a8606d8$var$load("6RcIS").then(()=>parcelRequire('33Ayl'));

});


parcelRegister("8BFAJ", function(module, exports) {

$parcel$export(module.exports, "TeamReadView", () => $ede7f5ac143c4eec$export$87458045213a5f61);

var $gSMCv = parcelRequire("gSMCv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");

var $KQDhS = parcelRequire("KQDhS");

var $7jTnu = parcelRequire("7jTnu");

var $aVor1 = parcelRequire("aVor1");
const $ede7f5ac143c4eec$export$87458045213a5f61 = ({ fragmentRef: fragmentRef, maxLines: maxLines, triggerLinkType: triggerLinkType })=>{
    const { selectedTeam: selectedTeam } = (0, $j4oe4.useFragment)((0, $gSMCv.default), fragmentRef);
    if (!selectedTeam?.jiraSuppliedName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if ((0, $7jTnu.fg)('gpp_for_issue_cells_team_field')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVor1.TeamReadViewWithGpp), {
        teamName: selectedTeam?.jiraSuppliedName,
        ariId: selectedTeam?.jiraSuppliedId,
        maxLines: maxLines,
        showTeamPreview: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $KQDhS.default), {
        teamId: selectedTeam.jiraSuppliedId,
        trigger: "hover-click",
        position: "left-start",
        triggerLinkType: triggerLinkType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines
    }, selectedTeam.jiraSuppliedName));
};

});
parcelRegister("gSMCv", function(module, exports) {

$parcel$export(module.exports, "default", () => $be46d963dd0a06cb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2eecf37369c6c8c0d95dae02e8db59b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $be46d963dd0a06cb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamReadviewFull_TeamReadView",
    "selections": [
        {
            "concreteType": "JiraTeamView",
            "kind": "LinkedField",
            "name": "selectedTeam",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedId"
                },
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedName"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$be46d963dd0a06cb$var$node.hash = "69af0ce99580e256b8a8c95839ad6bd2";
var $be46d963dd0a06cb$export$2e2bcd8739ae039 = $be46d963dd0a06cb$var$node;

});

parcelRegister("KQDhS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $033a892b23467e2f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8q7lT = parcelRequire("8q7lT");

var $cECwI = parcelRequire("cECwI");

var $83DiZ = parcelRequire("83DiZ");

var $bJscI = parcelRequire("bJscI");

var $1KdDN = parcelRequire("1KdDN");

var $lFp9s = parcelRequire("lFp9s");


var $2FOaD = parcelRequire("2FOaD");
const $033a892b23467e2f$var$ConditionalErrorBoundary = (0, $bJscI.componentWithFG)('empanada_profilecard_sync_trigger_import_final', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "team-profilecard",
        packageName: (0, $6d22448f78a7f25a$export$9345d7360ffe0722),
        fallback: "flag"
    }, children), (0, $eJOHy.Fragment));
const $033a892b23467e2f$var$TeamProfileCardNext = (props)=>{
    const { children: children, teamId: teamId } = props;
    const userId = (0, $8q7lT.useAccountId)();
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    if (!teamId || isAnonymous || !userId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($033a892b23467e2f$var$ConditionalErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lFp9s.ProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2FOaD.TeamProfileCardInner), {
        ...props,
        userId: userId,
        onRedirect: push
    })));
};
var $033a892b23467e2f$export$2e2bcd8739ae039 = $033a892b23467e2f$var$TeamProfileCardNext;

});
parcelRegister("lFp9s", function(module, exports) {

$parcel$export(module.exports, "ProfileCardWrapper", () => $298aff9366b0951f$export$59abd6feb7dc8540);

var $eJOHy = parcelRequire("eJOHy");

var $kEUB1 = parcelRequire("kEUB1");

var $8q7lT = parcelRequire("8q7lT");

var $9hopi = parcelRequire("9hopi");

var $9yGgq = parcelRequire("9yGgq");

var $16TBK = parcelRequire("16TBK");
const $298aff9366b0951f$export$59abd6feb7dc8540 = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const accountId = (0, $8q7lT.useAccountId)();
    const fabricPfDirUrl = (0, $9yGgq.useFabricProfileDirectoryUrl)();
    const orgId = (0, $9hopi.useOrgId)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16TBK.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: !externalProfileClient,
        orgId: orgId
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};

});
parcelRegister("9hopi", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $854fde3141521561$export$52a03a3207af3687);

var $lvKO5 = parcelRequire("lvKO5");
const $854fde3141521561$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

parcelRegister("9yGgq", function(module, exports) {

$parcel$export(module.exports, "useFabricProfileDirectoryUrl", () => $3671ddc1abbfe28d$export$cb9379d435214a54);

var $lvKO5 = parcelRequire("lvKO5");
const $3671ddc1abbfe28d$export$cb9379d435214a54 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.fabricPfDirUrl || '';
};

});

parcelRegister("16TBK", function(module, exports) {

$parcel$export(module.exports, "createUserProfileCardClient", () => $ca869b060f836c8a$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientContainer", () => $ca869b060f836c8a$export$d816ba2709570028);
$parcel$export(module.exports, "useProfileClient", () => $ca869b060f836c8a$export$d43dc22a8337ee9f);

var $d5fwz = parcelRequire("d5fwz");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $aBTmI = parcelRequire("aBTmI");
const $ca869b060f836c8a$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $ca869b060f836c8a$export$c4393c51e6d104c3 = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, orgId)=>{
    const userClient = new (0, $aBTmI.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $d5fwz.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId,
        orgId: orgId
    }, {
        userClient: userClient
    });
};
const $ca869b060f836c8a$export$e324594224ef24da = {
    bootstrap: ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, profileClient: profileClient, onLoadError: onLoadError, cloudId: cloudId, orgId: orgId })=>{
            const finalProfileClient = profileClient || $ca869b060f836c8a$export$c4393c51e6d104c3(fabricPfDirUrl ?? '', onLoadError, $ca869b060f836c8a$var$GATEWAY_GRAPHQL_URL, cloudId, orgId);
            setState({
                profileClient: finalProfileClient
            });
        }
};
const $ca869b060f836c8a$export$d816ba2709570028 = (0, $6E16M.createContainer)({
    displayName: 'ProfileClientContainer'
});
const $ca869b060f836c8a$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $ca869b060f836c8a$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'ProfileClientStore',
    initialState: $ca869b060f836c8a$export$d4c72bab9d6cc13a,
    actions: $ca869b060f836c8a$export$e324594224ef24da,
    containedBy: $ca869b060f836c8a$export$d816ba2709570028,
    handlers: {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($ca869b060f836c8a$export$e324594224ef24da.bootstrap())
    }
});
const $ca869b060f836c8a$export$d43dc22a8337ee9f = (0, $iJq0l.createStateHook)($ca869b060f836c8a$export$6f57813fe9f31bf9);

});
parcelRegister("d5fwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f71266daf2e15d5$export$2e2bcd8739ae039);


var $9PyvN = parcelRequire("9PyvN");


var $9uvjI = parcelRequire("9uvjI");
var $5f71266daf2e15d5$export$2e2bcd8739ae039 = (0, $9PyvN.default);

});
parcelRegister("9PyvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $495edb629a854866$export$2e2bcd8739ae039);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $bRjww = parcelRequire("bRjww");

var $49UfM = parcelRequire("49UfM");

var $52RFj = parcelRequire("52RFj");

var $9uvjI = parcelRequire("9uvjI");
const $495edb629a854866$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $495edb629a854866$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$495edb629a854866$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $495edb629a854866$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $9uvjI.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $52RFj.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $bRjww.default)(withDefaultConfig);
        this.tcClient = $495edb629a854866$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $8RHPx.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $8RHPx.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $495edb629a854866$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $lopBx.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $49UfM.default)({
        ...config
    }) : undefined;
}
var $495edb629a854866$export$2e2bcd8739ae039 = $495edb629a854866$var$ProfileCardClient;

});
parcelRegister("bRjww", function(module, exports) {

$parcel$export(module.exports, "default", () => $05e8b6328c708954$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");
const $05e8b6328c708954$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $05e8b6328c708954$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    basePath() {
        return (0, $eGOwo.fg)('pt-deprecate-assistance-service') ? '/gateway/api/assist/rovo/v1/agents' : '/gateway/api/assist/agents/v1';
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("2EPX4", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $7d8a130fd15a8bb5$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $7d8a130fd15a8bb5$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $7d8a130fd15a8bb5$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $7d8a130fd15a8bb5$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $7d8a130fd15a8bb5$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $7d8a130fd15a8bb5$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $7d8a130fd15a8bb5$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $7d8a130fd15a8bb5$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $7d8a130fd15a8bb5$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $7d8a130fd15a8bb5$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $7d8a130fd15a8bb5$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $7d8a130fd15a8bb5$export$a9f8c9f412cf5664);

var $kNQN4 = parcelRequire("kNQN4");
/** Below lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $7d8a130fd15a8bb5$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $7d8a130fd15a8bb5$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $7d8a130fd15a8bb5$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$TEAM_SUBJECT = 'teamProfileCard';
const $7d8a130fd15a8bb5$var$USER_SUBJECT = 'profilecard';
const $7d8a130fd15a8bb5$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $7d8a130fd15a8bb5$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $kNQN4.getPageTime)())
        }
    });
const $7d8a130fd15a8bb5$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $7d8a130fd15a8bb5$var$USER_SUBJECT;
        case 'team':
            return $7d8a130fd15a8bb5$var$TEAM_SUBJECT;
        case 'agent':
            return $7d8a130fd15a8bb5$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $7d8a130fd15a8bb5$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $7d8a130fd15a8bb5$var$createEvent('ui', 'triggered', $7d8a130fd15a8bb5$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $7d8a130fd15a8bb5$export$c9b0e37b229a297b = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$12dae48763368ac9 = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$USER_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$41816a317479160b = (type, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'rendered', $7d8a130fd15a8bb5$var$getActionSubject(type), actionSubjectId, attributes);
const $7d8a130fd15a8bb5$export$fdcd134fbeb1f921 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'action', attributes);
const $7d8a130fd15a8bb5$export$93260987012593be = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$USER_SUBJECT, 'reportingLines', attributes);
const $7d8a130fd15a8bb5$export$79befd155063a6a7 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'moreActions', attributes);
const $7d8a130fd15a8bb5$export$2703289b35687fde = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'avatar', attributes);
const $7d8a130fd15a8bb5$export$b4411a7661cf2d3f = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $7d8a130fd15a8bb5$export$c86679da702d560e = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $7d8a130fd15a8bb5$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("kNQN4", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $64b9704217d393a1$export$e9faea7c41053334);
const $64b9704217d393a1$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $64b9704217d393a1$var$performanceAvailable = $64b9704217d393a1$var$isPerformanceAvailable();
const $64b9704217d393a1$var$initialPageTime = Date.now();
const $64b9704217d393a1$export$e9faea7c41053334 = ()=>{
    if ($64b9704217d393a1$var$performanceAvailable) return performance.now();
    return Date.now() - $64b9704217d393a1$var$initialPageTime;
};

});


parcelRegister("fqVaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc90275f52a03ea7$export$2e2bcd8739ae039);

var $7xkt0 = parcelRequire("7xkt0");
class $cc90275f52a03ea7$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $7xkt0.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});

parcelRegister("2stUb", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $3d31a5950b175c26$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $3d31a5950b175c26$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $3d31a5950b175c26$export$d9ad65d422ee3f8c);

var $as7HK = parcelRequire("as7HK");
const $3d31a5950b175c26$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $3d31a5950b175c26$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $3d31a5950b175c26$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $3d31a5950b175c26$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $as7HK.DirectoryGraphQLError)) return !!error && $3d31a5950b175c26$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $as7HK.AGGError)) return !!error.errorType && $3d31a5950b175c26$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $3d31a5950b175c26$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $3d31a5950b175c26$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $as7HK.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $as7HK.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $as7HK.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $as7HK.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $as7HK.DirectoryGraphQLErrors) || causeError instanceof (0, $as7HK.AGGErrors)) return $3d31a5950b175c26$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $3d31a5950b175c26$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $as7HK.DirectoryGraphQLErrors)(errors, traceId);
};
const $3d31a5950b175c26$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $as7HK.AGGErrors)(errors, traceId);
};

});
parcelRegister("as7HK", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $e980080011a8d765$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $e980080011a8d765$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $e980080011a8d765$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $e980080011a8d765$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $e980080011a8d765$export$60d8267243755b9c);
class $e980080011a8d765$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $e980080011a8d765$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $e980080011a8d765$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $e980080011a8d765$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $e980080011a8d765$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $e980080011a8d765$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $e980080011a8d765$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("49UfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b519ebe8bdd19c29$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $fqVaP = parcelRequire("fqVaP");

var $jjeHq = parcelRequire("jjeHq");

var $4qbZy = parcelRequire("4qbZy");
const $b519ebe8bdd19c29$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $b519ebe8bdd19c29$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $b519ebe8bdd19c29$var$orgIdPromiseCache = new Map();
const $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache = new Map();
class $b519ebe8bdd19c29$var$TeamCentralCardClient extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $b519ebe8bdd19c29$export$1862ef0c3880ca8d(userId);
        const response = await (0, $4qbZy.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $eGOwo.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $eGOwo.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $b519ebe8bdd19c29$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $b519ebe8bdd19c29$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $jjeHq.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $b519ebe8bdd19c29$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $b519ebe8bdd19c29$export$2e2bcd8739ae039 = $b519ebe8bdd19c29$var$TeamCentralCardClient;

});
parcelRegister("jjeHq", function(module, exports) {

$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $a1fbf8b2b4930fa8$export$d38a536fd806c68f);

var $4qbZy = parcelRequire("4qbZy");
const $a1fbf8b2b4930fa8$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $a1fbf8b2b4930fa8$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $a1fbf8b2b4930fa8$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $a1fbf8b2b4930fa8$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $4qbZy.AGGQuery)(url, query, $a1fbf8b2b4930fa8$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});
parcelRegister("4qbZy", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $79a99a18e51eddf3$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $79a99a18e51eddf3$export$a14afb5f82fe705);

var $as7HK = parcelRequire("as7HK");

var $2stUb = parcelRequire("2stUb");
const $79a99a18e51eddf3$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $79a99a18e51eddf3$var$id = (headers)=>headers;
async function $79a99a18e51eddf3$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id) {
    return $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $2stUb.handleDirectoryGraphQLErrors));
}
async function $79a99a18e51eddf3$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id) {
    return $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $2stUb.handleAGGErrors));
}
async function $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id, handleErrors) {
    const headers = processHeaders($79a99a18e51eddf3$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $as7HK.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});



parcelRegister("52RFj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8330ec0bc030b200$export$2e2bcd8739ae039);

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");

var $7jwft = parcelRequire("7jwft");
class $8330ec0bc030b200$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $7jwft.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('succeeded', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('failed', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("7jwft", function(module, exports) {

$parcel$export(module.exports, "extractIdFromAri", () => $34e7bc800a4991e6$export$5816a09dbb711691);
$parcel$export(module.exports, "getTeamFromAGG", () => $34e7bc800a4991e6$export$26a8aad0c7182dd6);

var $4qbZy = parcelRequire("4qbZy");
const $34e7bc800a4991e6$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $34e7bc800a4991e6$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $34e7bc800a4991e6$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $34e7bc800a4991e6$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($34e7bc800a4991e6$var$ARI_PREFIX) ? teamIdOrTeamAri : $34e7bc800a4991e6$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $34e7bc800a4991e6$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $34e7bc800a4991e6$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $34e7bc800a4991e6$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $34e7bc800a4991e6$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$34e7bc800a4991e6$var$TEAM_FRAGMENT}
    }
  }
}`;
const $34e7bc800a4991e6$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $34e7bc800a4991e6$export$4968f4e0119a5d9c,
        variables: {
            teamId: $34e7bc800a4991e6$export$7878e28c136af76(teamId),
            siteId: siteId || 'None'
        }
    });
const $34e7bc800a4991e6$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $34e7bc800a4991e6$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $34e7bc800a4991e6$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $4qbZy.AGGQuery)(url, query, $34e7bc800a4991e6$export$1229c72526c01df2);
    return $34e7bc800a4991e6$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("9uvjI", function(module, exports) {

$parcel$export(module.exports, "default", () => $467a485168b1cd0d$export$2e2bcd8739ae039);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");

var $eGOwo = parcelRequire("eGOwo");

var $2EPX4 = parcelRequire("2EPX4");

var $hX5cm = parcelRequire("hX5cm");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");

var $4qbZy = parcelRequire("4qbZy");
const $467a485168b1cd0d$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $467a485168b1cd0d$var$aggUserQuery = (0, $kuAvn.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $467a485168b1cd0d$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $467a485168b1cd0d$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $eGOwo.fg)('platform_agg_user_query_doc_change') ? (0, $6NFTG.print)($467a485168b1cd0d$var$aggUserQuery) : $467a485168b1cd0d$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $467a485168b1cd0d$var$queryAGGUser = async (url, userId)=>{
    const query = $467a485168b1cd0d$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $4qbZy.AGGQuery)(url, query);
    return user;
};
class $467a485168b1cd0d$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $467a485168b1cd0d$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        const timeFormat = (0, $eGOwo.fg)('platform_profilecard-update-time-format') ? 'h:mmaaa' : 'h:mmbbb';
        if (user.zoneinfo) {
            if ((0, $hX5cm.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $hX5cm.localTime)(user.zoneinfo, timeFormat) || undefined;
            else timestring = (0, $hX5cm.localTime)(user.zoneinfo, `eee ${timeFormat}`) || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            isServiceAccount: user.__typename === 'AppUser' && user.appType === 'service',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('succeeded', {
                    duration: (0, $kNQN4.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('failed', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("hX5cm", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $98ebf9c8b6385a65$export$f0dfd716e7b023cd);
parcelRequire("7XJii");
var $iLEEy = parcelRequire("iLEEy");
const $98ebf9c8b6385a65$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $iLEEy.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("7XJii", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("iLEEy")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $iLEEy = parcelRequire("iLEEy");





});
parcelRegister("iLEEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $da9c26a946bf047b$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $a4wuW = parcelRequire("a4wuW");

var $iEVvn = parcelRequire("iEVvn");
function $da9c26a946bf047b$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $a4wuW.default)((0, $iEVvn.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("a4wuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $75537c87aa32bbea$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $jn1Yb = parcelRequire("jn1Yb");

var $bWiNt = parcelRequire("bWiNt");
var $75537c87aa32bbea$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $75537c87aa32bbea$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($75537c87aa32bbea$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $bWiNt.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $jn1Yb.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("jn1Yb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a1b16befdfb889$export$2e2bcd8739ae039);

var $emmbH = parcelRequire("emmbH");

var $a2zuC = parcelRequire("a2zuC");
var $e1a1b16befdfb889$var$MILLISECONDS_IN_MINUTE = 60000;
var $e1a1b16befdfb889$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $e1a1b16befdfb889$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $emmbH.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $emmbH.default)('long', date, options);
        }
    }
};
function $e1a1b16befdfb889$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $a2zuC.default)(timeZone, originalDate, true) / $e1a1b16befdfb889$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $e1a1b16befdfb889$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $e1a1b16befdfb889$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $e1a1b16befdfb889$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $e1a1b16befdfb889$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $e1a1b16befdfb889$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $e1a1b16befdfb889$var$formatTimezone(offset, dirtyDelimeter);
}
function $e1a1b16befdfb889$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $e1a1b16befdfb889$var$addLeadingZeros(minutes, 2);
}
var $e1a1b16befdfb889$export$2e2bcd8739ae039 = $e1a1b16befdfb889$var$formatters;

});
parcelRegister("emmbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a74454c810e10efc$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $a74454c810e10efc$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $a74454c810e10efc$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $a74454c810e10efc$var$partsTimeZone(dtf, date) : $a74454c810e10efc$var$hackyTimeZone(dtf, date);
}
function $a74454c810e10efc$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $a74454c810e10efc$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $a74454c810e10efc$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("a2zuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f59f73042f5ea2$export$2e2bcd8739ae039);

var $iKmlv = parcelRequire("iKmlv");

var $eMjjs = parcelRequire("eMjjs");
var $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR = 3600000;
var $74f59f73042f5ea2$var$MILLISECONDS_IN_MINUTE = 60000;
var $74f59f73042f5ea2$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $74f59f73042f5ea2$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $74f59f73042f5ea2$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $74f59f73042f5ea2$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$74f59f73042f5ea2$var$validateTimezone(hours)) return NaN;
        return -(hours * $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $74f59f73042f5ea2$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$74f59f73042f5ea2$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR + minutes * $74f59f73042f5ea2$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($74f59f73042f5ea2$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $74f59f73042f5ea2$var$toUtcDate(date);
        var offset = $74f59f73042f5ea2$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $74f59f73042f5ea2$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $74f59f73042f5ea2$var$toUtcDate(date) {
    return (0, $eMjjs.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $74f59f73042f5ea2$var$calcOffset(date, timezoneString) {
    var tokens = (0, $iKmlv.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $eMjjs.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $74f59f73042f5ea2$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $74f59f73042f5ea2$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $74f59f73042f5ea2$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $74f59f73042f5ea2$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $74f59f73042f5ea2$var$validIANATimezoneCache = {};
function $74f59f73042f5ea2$var$isValidTimezoneIANAString(timeZoneString) {
    if ($74f59f73042f5ea2$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $74f59f73042f5ea2$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("iKmlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $da5ddb5213ce8f83$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $da5ddb5213ce8f83$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $da5ddb5213ce8f83$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $da5ddb5213ce8f83$var$partsOffset(dtf, date) : $da5ddb5213ce8f83$var$hackyOffset(dtf, date);
}
var $da5ddb5213ce8f83$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $da5ddb5213ce8f83$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $da5ddb5213ce8f83$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $da5ddb5213ce8f83$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $da5ddb5213ce8f83$var$dtfCache = {};
function $da5ddb5213ce8f83$var$getDateTimeFormat(timeZone) {
    if (!$da5ddb5213ce8f83$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $da5ddb5213ce8f83$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $da5ddb5213ce8f83$var$dtfCache[timeZone];
}

});

parcelRegister("eMjjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac2487857a682a48$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $ac2487857a682a48$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("bWiNt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b13b1308e9ec166$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $a2zuC = parcelRequire("a2zuC");

var $cIjNZ = parcelRequire("cIjNZ");
var $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR = 3600000;
var $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE = 60000;
var $8b13b1308e9ec166$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $8b13b1308e9ec166$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $cIjNZ.default)
};
function $8b13b1308e9ec166$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $8b13b1308e9ec166$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $8b13b1308e9ec166$var$splitDateString(argument);
    var parseYearResult = $8b13b1308e9ec166$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $8b13b1308e9ec166$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $8b13b1308e9ec166$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $a2zuC.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $8b13b1308e9ec166$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $8b13b1308e9ec166$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $8b13b1308e9ec166$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $8b13b1308e9ec166$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $8b13b1308e9ec166$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $8b13b1308e9ec166$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $8b13b1308e9ec166$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $8b13b1308e9ec166$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $8b13b1308e9ec166$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $8b13b1308e9ec166$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $8b13b1308e9ec166$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $8b13b1308e9ec166$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$8b13b1308e9ec166$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $8b13b1308e9ec166$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$8b13b1308e9ec166$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $8b13b1308e9ec166$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateWeekDate(year, week)) return new Date(NaN);
        return $8b13b1308e9ec166$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $8b13b1308e9ec166$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $8b13b1308e9ec166$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $8b13b1308e9ec166$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $8b13b1308e9ec166$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $8b13b1308e9ec166$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR + minutes * $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $8b13b1308e9ec166$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR + minutes * $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $8b13b1308e9ec166$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $8b13b1308e9ec166$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8b13b1308e9ec166$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $8b13b1308e9ec166$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $8b13b1308e9ec166$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $8b13b1308e9ec166$var$isLeapYearIndex(year);
        if (isLeapYear && date > $8b13b1308e9ec166$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $8b13b1308e9ec166$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $8b13b1308e9ec166$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $8b13b1308e9ec166$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $8b13b1308e9ec166$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $8b13b1308e9ec166$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("cIjNZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9418f4fd702d1312$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $9418f4fd702d1312$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $9418f4fd702d1312$export$2e2bcd8739ae039 = $9418f4fd702d1312$var$tzPattern;

});



parcelRegister("iEVvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d95891bc4ee0ba6d$export$2e2bcd8739ae039);

var $a2zuC = parcelRequire("a2zuC");

var $bWiNt = parcelRequire("bWiNt");
function $d95891bc4ee0ba6d$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $bWiNt.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $a2zuC.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("aBTmI", function(module, exports) {

$parcel$export(module.exports, "CustomUserProfileClient", () => $21d1f3a214a5c794$export$4b2a86afb64f42f1);

var $9uvjI = parcelRequire("9uvjI");

var $1Ozm9 = parcelRequire("1Ozm9");

var $38H79 = parcelRequire("38H79");
class $21d1f3a214a5c794$export$4b2a86afb64f42f1 extends (0, $9uvjI.default) {
    constructor(fabricPfDirUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        }), this.makeRequest = async (cloudId, userId)=>{
            // call old profile rest endpoint
            try {
                if ((0, $38H79.isCustomerAccount)(userId)) {
                    const response = await (0, $1Ozm9.default)(`/rest/api/3/user?accountId=${userId}`);
                    return (0, $38H79.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});
parcelRegister("38H79", function(module, exports) {

$parcel$export(module.exports, "generateUserLink", () => $b826be912fd09914$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $b826be912fd09914$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $b826be912fd09914$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $b826be912fd09914$export$ffbbcf55d672ec61);
$parcel$export(module.exports, "restResponseToUserData", () => $b826be912fd09914$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $b826be912fd09914$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $b826be912fd09914$export$518f47d656cb4e1a);
$parcel$export(module.exports, "getSpaActionsWithRouterPush", () => $b826be912fd09914$export$96e0a21dc8f6c225);

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");

var $a62R3 = parcelRequire("a62R3");

var $9LvIj = parcelRequire("9LvIj");

const $b826be912fd09914$export$f4673d7e11341514 = (userId)=>{
    const userProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        }
    });
    return (0, $a62R3.isTeamsAppEnabled)() ? userProfile.href : `/jira/people/${userId}`;
};
const $b826be912fd09914$export$b163ce931504dcff = (teamId)=>{
    const teamProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        }
    });
    return (0, $a62R3.isTeamsAppEnabled)() ? teamProfile.href : `/jira/people/team/${teamId}`;
};
const $b826be912fd09914$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(profileUrl);
        }
    });
const $b826be912fd09914$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $b826be912fd09914$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($b826be912fd09914$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $gCeeo.fireScreenAnalytics)(analyticsEvent);
    }
};
const $b826be912fd09914$export$66691b1affeb3bc5 = (userData)=>({
        avatarUrl: userData.avatarUrls?.['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $b826be912fd09914$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $b826be912fd09914$export$f38de51a346a7b1 = (intl, accountId)=>{
    const userProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: accountId
        }
    });
    return {
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewProfile),
        id: 'view-profile',
        link: (0, $a62R3.isTeamsAppEnabled)() ? userProfile.href : `/jira/people/${accountId}`,
        callback: (0, $a62R3.isTeamsAppEnabled)() ? userProfile.onNavigate : undefined,
        shouldRender: (data)=>/*
     * Those without @atlassian.com accounts do not have viewable profiles
     */ data?.accountType !== 'customer'
    };
};
const $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush = (intl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $b826be912fd09914$var$getAssignedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $9LvIj.profileCardMessages).assignedIssuesIssueTerminologyRefreshM4 : (0, $9LvIj.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$var$getReportedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $9LvIj.profileCardMessages).reportedIssuesIssueTerminologyRefreshM4 : (0, $9LvIj.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$export$518f47d656cb4e1a = (accountId, intl, actions)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $6d22448f78a7f25a$export$23cedd3261bd8015:
                return $b826be912fd09914$export$f38de51a346a7b1(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6bef782d14a92db8:
                return $b826be912fd09914$var$getAssignedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6b36f20db7a18a86:
                return $b826be912fd09914$var$getReportedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$56da0dd0b0aa67b9:
                return $b826be912fd09914$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $b826be912fd09914$export$f38de51a346a7b1(intl, accountId)
    ];
};
const $b826be912fd09914$export$96e0a21dc8f6c225 = (accountId, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $6d22448f78a7f25a$export$23cedd3261bd8015:
                return $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup);
            case 0, $6d22448f78a7f25a$export$6bef782d14a92db8:
                return $b826be912fd09914$var$getAssignedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6b36f20db7a18a86:
                return $b826be912fd09914$var$getReportedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$56da0dd0b0aa67b9:
                return $b826be912fd09914$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("a62R3", function(module, exports) {

$parcel$export(module.exports, "useNavigateToTeamsApp", () => $4bdb55387d231b38$export$520a42ab062954ec);
$parcel$export(module.exports, "getNavigateToTeamsApp", () => $4bdb55387d231b38$export$cfadab73fb247145);
$parcel$export(module.exports, "useTransformToTeamsAppUrl", () => $4bdb55387d231b38$export$dc7e633fb6368a43);
$parcel$export(module.exports, "toTeamsAppURL", () => $4bdb55387d231b38$export$196b2cec97b1c87c);
$parcel$export(module.exports, "isTeamsAppEnabled", () => $4bdb55387d231b38$export$5921b2a93a401547);

var $fvpPO = parcelRequire("fvpPO");

var $j19W0 = parcelRequire("j19W0");

var $g9Vr6 = parcelRequire("g9Vr6");

var $kEUB1 = parcelRequire("kEUB1");

var $83DiZ = parcelRequire("83DiZ");

var $6zXPf = parcelRequire("6zXPf");

var $hWeHP = parcelRequire("hWeHP");
const $4bdb55387d231b38$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    if (!orgId && !cloudId) throw new Error('Org ID or Cloud ID is required to navigate to Teams App');
    return (0, $j19W0.navigateToTeamsApp)({
        push: push,
        hostProduct: 'jira',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$cfadab73fb247145 = (navActionPayload, shouldOpenInSameTab)=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $j19W0.navigateToTeamsApp)({
        hostProduct: 'jira',
        orgId: orgId || '',
        cloudId: cloudId || undefined,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$dc7e633fb6368a43 = (path, search = '')=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    return (0, $j19W0.toTeamsAppURL)(path, search, {
        orgId: orgId,
        cloudId: cloudId
    });
};
const $4bdb55387d231b38$export$196b2cec97b1c87c = (path, search = '')=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $j19W0.toTeamsAppURL)(path, search, {
        orgId: orgId ?? '',
        cloudId: cloudId ?? ''
    });
};
const $4bdb55387d231b38$export$5921b2a93a401547 = ()=>{
    return (0, $fvpPO.isTeamsAppEnabled)({
        hostProduct: 'jira',
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)()
    });
};

});
parcelRegister("fvpPO", function(module, exports) {

$parcel$export(module.exports, "isTeamsAppEnabled", () => $e45f3caa2e661ed2$export$5921b2a93a401547);

var $lopBx = parcelRequire("lopBx");

var $59rsN = parcelRequire("59rsN");

var $eGOwo = parcelRequire("eGOwo");
function $e45f3caa2e661ed2$export$5921b2a93a401547(config) {
    // Due to experiment exposures, we need to first check if Nav4 is enabled to see if the user is in the cohort
    // In FedRamp, we are ignoring the Nav4 dependency
    if (!(0, $lopBx.isFedRamp)() && config.userHasNav4Enabled !== undefined && !config.userHasNav4Enabled) return false;
    if ((0, $59rsN.default).initializeCompleted()) {
        // Next we check the experiment value based on the host product
        if (config.hostProduct === 'jira' && (0, $59rsN.default).getExperimentValue('migrate-jira-people-directory-to-teams-app', 'isEnabled', false)) return true;
        if (config.hostProduct === 'confluence' && (0, $59rsN.default).getExperimentValue('migrate-confluence-people-directory-to-teams-app', 'isEnabled', false)) return true;
    }
    // Lastly we check the feature gate which we are using for dogfooding, we won't roll this flag out in production.
    return (0, $eGOwo.fg)('should-redirect-directory-to-teams-app');
}

});

parcelRegister("j19W0", function(module, exports) {

$parcel$export(module.exports, "navigateToTeamsApp", () => $bcd485df6c831087$export$cd99a4ca8e852372);
$parcel$export(module.exports, "toTeamsAppURL", () => $bcd485df6c831087$export$196b2cec97b1c87c);

var $fvpPO = parcelRequire("fvpPO");

var $0FujR = parcelRequire("0FujR");
const $bcd485df6c831087$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $fvpPO.isTeamsAppEnabled)(action) : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $0FujR.getHostProductFromPath)()
    };
    const { path: path, query: query } = (0, $0FujR.getPathAndQuery)(actionWithDefaults);
    const href = (0, $0FujR.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $0FujR.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};
const $bcd485df6c831087$export$196b2cec97b1c87c = (path, search, config)=>{
    return (0, $0FujR.generateTeamsAppPath)(path, config, new URLSearchParams(search));
};

});
parcelRegister("0FujR", function(module, exports) {

$parcel$export(module.exports, "generateTeamsAppPath", () => $a228ae66ede9224c$export$9665cb78fbba2c92);
$parcel$export(module.exports, "generatePath", () => $a228ae66ede9224c$export$82476f982757e71e);
$parcel$export(module.exports, "onNavigateBase", () => $a228ae66ede9224c$export$39f25014273b0a58);
$parcel$export(module.exports, "getPathAndQuery", () => $a228ae66ede9224c$export$b406f12e2156b3fe);
$parcel$export(module.exports, "getHostProductFromPath", () => $a228ae66ede9224c$export$a792d22ca73cc3ca);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $chYv1 = parcelRequire("chYv1");

var $fvpPO = parcelRequire("fvpPO");
function $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $lopBx.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${$a228ae66ede9224c$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    return `${(0, $8RHPx.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}
function $a228ae66ede9224c$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    if ((0, $fvpPO.isTeamsAppEnabled)(config) || config.hostProduct === 'home' || !config.hostProduct) return $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query, anchor);
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $chYv1.origin)()}/${config.hostProduct === 'confluence' ? 'wiki' : 'jira'}/people/${path}${queryString}`;
}
const $a228ae66ede9224c$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ((0, $fvpPO.isTeamsAppEnabled)(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $chYv1.redirect)(href);
                return;
            }
            (0, $chYv1.openInNewTab)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $chYv1.redirect)(href);
            return;
        } else {
            (0, $chYv1.openInNewTab)(href);
            return;
        }
    };
function $a228ae66ede9224c$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.includes('/') ? id.split('/').pop() || '' : id;
}
function $a228ae66ede9224c$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            // Safety check for undefined userId, just redirect to the landing page as the profile redirect will fail
            if (!action.payload?.userId) return {
                path: ''
            };
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            // Safety check for undefined teamId, just redirect to the landing page as the team redirect will fail
            if (!action.payload?.teamId) return {
                path: ''
            };
            return {
                path: `team/${$a228ae66ede9224c$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            // Safety check for undefined agentId, just redirect to the landing page as the agent redirect will fail
            if (!action.payload?.agentId) return {
                path: ''
            };
            return {
                path: `agent/${$a228ae66ede9224c$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            // Safety check for undefined kudosId, just redirect to the landing page as the kudos redirect will fail
            if (!action.payload?.kudosId) return {
                path: ''
            };
            return {
                path: `kudos/${$a228ae66ede9224c$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            return {
                path: `search/people`,
                query: new URLSearchParams(action.payload.query)
            };
        case 'USER_WORK':
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}/work`
            };
        case 'CURRENT_USER_PROFILE':
            return {
                path: 'me'
            };
        default:
            return {
                path: ''
            };
    }
}
function $a228ae66ede9224c$export$a9f2c34176fff494() {
    const host = (0, $chYv1.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    return false;
}
function $a228ae66ede9224c$export$a792d22ca73cc3ca() {
    const path = (0, $chYv1.pathname)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $chYv1.hostname)().startsWith('home')) return 'home';
    return undefined;
}

});
parcelRegister("chYv1", function(module, exports) {

$parcel$export(module.exports, "redirect", () => $c76ad79e98e47bfd$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $c76ad79e98e47bfd$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "hostname", () => $c76ad79e98e47bfd$export$640106f6dc7d2706);
$parcel$export(module.exports, "origin", () => $c76ad79e98e47bfd$export$f710a83a91838a36);
$parcel$export(module.exports, "pathname", () => $c76ad79e98e47bfd$export$7333db99aa99d383);
function $c76ad79e98e47bfd$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $c76ad79e98e47bfd$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $c76ad79e98e47bfd$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
const $c76ad79e98e47bfd$export$f710a83a91838a36 = ()=>globalThis.location?.origin;
const $c76ad79e98e47bfd$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;

});




parcelRegister("9LvIj", function(module, exports) {

$parcel$export(module.exports, "profileCardMessages", () => $8d56fb88e7ef3ba6$export$49f2d2ccb123fddf);

var $7qGN1 = parcelRequire("7qGN1");
const $8d56fb88e7ef3ba6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $8d56fb88e7ef3ba6$export$49f2d2ccb123fddf = (0, $7qGN1.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    },
    assignedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.assigned-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Assigned work items"
    },
    reportedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.reported-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Reported work items"
    }
});

});

const $6d22448f78a7f25a$export$9345d7360ffe0722 = 'jira-profilecard-next';
const $6d22448f78a7f25a$export$81319ffa9c0d18d7 = 'profileCardNext';
const $6d22448f78a7f25a$export$50632e21ea714398 = 'profileCardNextLegacy';
const $6d22448f78a7f25a$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $6d22448f78a7f25a$export$23cedd3261bd8015 = 'viewProfile';
const $6d22448f78a7f25a$export$6bef782d14a92db8 = 'assignedIssues';
const $6d22448f78a7f25a$export$6b36f20db7a18a86 = 'reportedIssues';
const $6d22448f78a7f25a$export$56da0dd0b0aa67b9 = 'viewFilters';





parcelRegister("2FOaD", function(module, exports) {

$parcel$export(module.exports, "TeamProfileCardInner", () => $e8a53ac93d071996$export$25379cf72e576e0e);

var $eJOHy = parcelRequire("eJOHy");

var $3VLQJ = parcelRequire("3VLQJ");

var $22c3C = parcelRequire("22c3C");
var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $g9Vr6 = parcelRequire("g9Vr6");

var $a62R3 = parcelRequire("a62R3");

var $7jTnu = parcelRequire("7jTnu");

var $38H79 = parcelRequire("38H79");

var $16TBK = parcelRequire("16TBK");
const $e8a53ac93d071996$export$25379cf72e576e0e = ({ children: children, onRedirect: onRedirect, position: position, shouldRenderToParent: shouldRenderToParent, teamId: teamId, trigger: trigger, triggerLinkType: triggerLinkType, userId: userId })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const onUserClick = (0, $eJOHy.useCallback)((accountId)=>onRedirect((0, $38H79.generateUserLink)(accountId)), [
        onRedirect
    ]);
    const { href: href, onNavigate: onNavigate } = (0, $a62R3.useNavigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        }
    });
    const teamProfileUrl = (0, $7jTnu.fg)('jira-adopt-teams-nav-config') ? href : `/jira/people/team/${teamId}`;
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { profileClient: profileClient } = (0, $16TBK.useProfileClient)();
    if (!profileClient) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VLQJ.default), {
        teamId: teamId,
        orgId: orgId,
        viewingUserId: userId,
        resourceClient: profileClient,
        trigger: trigger,
        triggerLinkType: triggerLinkType,
        viewProfileLink: teamProfileUrl,
        viewProfileOnClick: ()=>(0, $7jTnu.fg)('jira-adopt-teams-nav-config') ? onNavigate() : onRedirect(teamProfileUrl),
        generateUserLink: (0, $38H79.generateUserLink),
        onUserClick: onUserClick,
        position: position,
        shouldRenderToParent: shouldRenderToParent,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- FYI: Typed as "any" in platform component
        addFlag: (flag)=>{
            const flagId = (0, $hrodw.toFlagId)(flag.id);
            showFlag({
                id: flagId,
                render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $22c3C.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        messageId: `profilecard-next.ui.team-profilecard.ak-flag.${flagId}`,
                        messageType: "transactional",
                        ...flagProps
                    })
            });
        }
    }, children);
};

});
parcelRegister("3VLQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $211b7e44240e97e1$export$2e2bcd8739ae039);
// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.


var $zgYE5 = parcelRequire("zgYE5");
var $211b7e44240e97e1$export$2e2bcd8739ae039 = (0, $zgYE5.default);

});
parcelRegister("zgYE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecd450f82eec537e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $6YFG2 = parcelRequire("6YFG2");

var $4J0ad = parcelRequire("4J0ad");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $8nu6j = parcelRequire("8nu6j");

var $IW7jS = parcelRequire("IW7jS");

var $gh6xW = parcelRequire("gh6xW");

var $2L2e5 = parcelRequire("2L2e5");

var $2EPX4 = parcelRequire("2EPX4");

var $g5TmB = parcelRequire("g5TmB");


var $kNQN4 = parcelRequire("kNQN4");

var $74i65 = parcelRequire("74i65");

var $aci2z = parcelRequire("aci2z");

var $8ZI1l = parcelRequire("8ZI1l");
class $ecd450f82eec537e$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.defaultProps = {
            actions: [],
            trigger: 'hover',
            position: 'bottom-start',
            triggerLinkType: 'link',
            shouldRenderToParent: true
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $gh6xW.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $2L2e5.default).giveKudosButton
                }),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $74i65.ErrorBoundary), {
            onError: this.onErrorBoundary,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, $IW7jS.layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card') && this.props.shouldRenderToParent
            })
        });
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args), this._isMounted = false, this.showTimer = 0, this.hideTimer = 0, this.openedByHover = false, this.openTime = 0, this.fireAnalytics = (payload)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $2EPX4.fireEvent)(this.props.createAnalyticsEvent, payload);
        }, this.fireAnalyticsWithDuration = (generator)=>{
            const event = generator((0, $kNQN4.getPageTime)() - this.openTime);
            this.fireAnalytics(event);
        }, this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        }, this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $kNQN4.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        }, this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $g5TmB.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics((0, $2EPX4.cardTriggered)('team', 'click', this.props.teamId));
            }
        }, this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                this.fireAnalytics((0, $2EPX4.cardTriggered)('team', 'hover', this.props.teamId));
            }
            this.showProfilecard((0, $776ef75d5b01ad48$export$5b956b542f1bc1b3));
        }, this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $776ef75d5b01ad48$export$89a9f35a94d7f196));
        }, this.onKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isTriggeredByKeyboard: true
                });
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics((0, $2EPX4.cardTriggered)('team', 'click', this.props.teamId));
            }
        }, this.onClose = ()=>{
            this.hideProfilecard();
            this.setState({
                isTriggeredByKeyboard: false
            });
        }, this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $776ef75d5b01ad48$export$89a9f35a94d7f196));
            this.setState({
                kudosDrawerOpen: true
            });
        }, this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        }, this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        }, this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        }, this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false,
            isTriggeredByKeyboard: false
        }, this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const fireEvent = (event)=>{
                    this.fireAnalytics(event);
                };
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        }, this.onErrorBoundary = ()=>{
            this.fireAnalytics((0, $2EPX4.profileCardRendered)('team', 'errorBoundary', {
                duration: 0
            }));
            this.setState({
                renderError: true
            });
        }, this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ...this.cardListeners,
                children: this.state.visible && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ZI1l.default), {
                        analytics: this.fireAnalyticsWithDuration
                    }),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aci2z.TeamProfileCardLazy), {
                        ...newProps,
                        isLoading: isLoading,
                        hasError: hasError,
                        errorType: error,
                        isTriggeredByKeyboard: this.state.isTriggeredByKeyboard
                    })
                })
            });
        }, this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })
            });
        }, this.renderTrigger = (triggerProps)=>{
            const { children: children, intl: intl, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                        as: "span",
                        role: "button",
                        testId: "team-profilecard-trigger-wrapper",
                        tabIndex: 0,
                        "aria-label": intl.formatMessage((0, $2L2e5.default).teamProfileCardAriaLabel),
                        onKeyUp: this.onKeyPress,
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
            return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            color: 'initial',
                            textDecoration: 'none'
                        },
                        href: viewProfileLink,
                        ...triggerProps,
                        ref: triggerProps.ref,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
        };
    }
}
var $ecd450f82eec537e$export$2e2bcd8739ae039 = (0, $4J0ad.default)()((0, $6YFG2.default)($ecd450f82eec537e$export$f811dc569217c959));

});
parcelRegister("7m76n", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $ec00209f14041f24$export$93fe397a02fe8b76);

var $eJOHy = parcelRequire("eJOHy");

const $ec00209f14041f24$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lWqKn")));

});
parcelRegister("lWqKn", function(module, exports) {

let $ff93c327b9f5ea83$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ff93c327b9f5ea83$var$load("76n7a"),
    $ff93c327b9f5ea83$var$load("l253H"),
    $ff93c327b9f5ea83$var$load("ffQaD"),
    $ff93c327b9f5ea83$var$load("kvRbA"),
    $ff93c327b9f5ea83$var$load("2tv8I")
]).then(()=>parcelRequire('3dj1A'));

});


parcelRegister("XUWry", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $2c3b135763fda18f$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $2c3b135763fda18f$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $2c3b135763fda18f$export$7a1fc1a1b0477464);
var $2c3b135763fda18f$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $2c3b135763fda18f$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $2c3b135763fda18f$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($2c3b135763fda18f$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("gh6xW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4adbe5caf86a5ece$export$2e2bcd8739ae039);
const $4adbe5caf86a5ece$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $4adbe5caf86a5ece$export$2e2bcd8739ae039 = $4adbe5caf86a5ece$var$filterActions;

});

parcelRegister("2L2e5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0136d5b4c5e5df89$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0136d5b4c5e5df89$var$messages = (0, $7qGN1.defineMessages)({
    inactiveAccountMsg: {
        id: 'pt.profile-card.inactive.account',
        defaultMessage: 'Account deactivated',
        description: 'A text in a grey lozenge shows that this user is inactive'
    },
    generalDescMsgForDisabledUser: {
        id: 'pt.profile-card.general.msg.disabled.user',
        defaultMessage: 'You can no longer collaborate with this person.',
        description: 'A first sentence of a long text explains this user is inactive/closed'
    },
    inactiveAccountDescMsgNoDate: {
        id: 'pt.profile-card.inactive.account.no.date',
        defaultMessage: 'Their account has been deactivated.',
        description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.inactive.account.has.date.this.week',
        defaultMessage: 'Their account was deactivated this week.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.inactive.account.has.date.this.month',
        defaultMessage: 'Their account was deactivated this month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.inactive.account.has.date.last.month',
        defaultMessage: 'Their account was deactivated last month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.inactive.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deactivated for a few months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.inactive.account.has.date.several.months',
        defaultMessage: 'Their account has been deactivated for several months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deactivated for more than a year.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    closedAccountMsg: {
        id: 'pt.profile-card.closed.account',
        defaultMessage: 'Account deleted',
        description: 'A text in a grey lozenge shows that this user is closed/deleted'
    },
    closedAccountDescMsgNoDate: {
        id: 'pt.profile-card.closed.account.no.date',
        defaultMessage: 'Their account has been deleted.',
        description: 'A long text explains this user is closed when we do not know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.closed.account.has.date.this.week',
        defaultMessage: 'Their account was deleted this week.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.closed.account.has.date.this.month',
        defaultMessage: 'Their account was deleted this month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.closed.account.has.date.last.month',
        defaultMessage: 'Their account was deleted last month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.closed.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deleted for a few months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.closed.account.has.date.several.months',
        defaultMessage: 'Their account has been deleted for several months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deleted for more than a year.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    disabledAccountDefaultName: {
        id: 'pt.profile-card.disabled.account.default.name',
        defaultMessage: 'Former user',
        description: 'A default name when we cannot get name of an inactive or closed user'
    },
    teamViewProfile: {
        id: 'pt.team-profile-card.team.action.view-profile',
        defaultMessage: 'View profile',
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: 'pt.team-profile-card.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team'
    },
    memberCountIncludingYou: {
        id: 'pt.team-profile-card.team.member.count-including-you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team and highlight that the user is a member'
    },
    membersMoreThan50: {
        id: 'pt.team-profile-card.team.member.many',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the team has more than 50 members'
    },
    membersMoreThan50IncludingYou: {
        id: 'pt.team-profile-card.team.member.many-including-you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
    },
    teamErrorTitle: {
        id: 'pt.team-profile-card.error.title',
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: 'Title for an error view explaining that data for this team cannot be accessed'
    },
    teamErrorText: {
        id: 'pt.team-profile-card.error.suggestion',
        defaultMessage: 'Wait a few moments, then try again.',
        description: 'Second line suggesting how to fix the issue'
    },
    teamErrorButton: {
        id: 'pt.team-profile-card.error.refresh-button',
        defaultMessage: 'Try again',
        description: 'Text on a button that will try to get the data again when clicked'
    },
    teamForbiddenErrorStateTitle: {
        id: 'pt.team-profile-card.forbidden-error-state.title',
        defaultMessage: "We can\u2019t show you this team",
        description: 'Title for the error state that is displayed when a user lacks access to the team'
    },
    teamForbiddenErrorStateDescription: {
        id: 'pt.team-profile-card.forbidden-error-state.description',
        defaultMessage: "You don\u2019t have access to view this team.",
        description: 'Description for the error state that is displayed when a user lacks access to the team'
    },
    managerSectionHeading: {
        id: 'pt.team-profile-card.manager.heading',
        defaultMessage: 'Manager',
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: 'pt.team-profile-card.directReports.heading',
        defaultMessage: 'Direct reports',
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    teamProfileCardAriaLabel: {
        id: 'pt.team-profile-card.aria-label',
        defaultMessage: 'More information about this team',
        description: 'Aria label for the team profile card'
    },
    giveKudosButton: {
        id: 'pt.profile-card.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Title for the button on the profile card for a user to give a kudos'
    },
    profileCardMoreIconLabel: {
        id: 'pt.profile-card.more-icon-label',
        defaultMessage: 'More',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    },
    profileCardMoreReportingLinesLabel: {
        id: 'pt.user-profile-card.reporting-lines.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {profile} other {profiles}}',
        description: 'Label for the "more profiles" indicator in the reporting lines section of the user profile card'
    },
    profileCardMoreMembersLabel: {
        id: 'pt.team.profile-card.members.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {members} other {members}}',
        description: 'Label for the "more members" indicator in the members section of the team profile card'
    }
});
var $0136d5b4c5e5df89$export$2e2bcd8739ae039 = $0136d5b4c5e5df89$var$messages;

});

parcelRegister("g5TmB", function(module, exports) {

$parcel$export(module.exports, "isBasicClick", () => $d966bd6e0cdd5a4c$export$eddcd8a5b7e09991);
const $d966bd6e0cdd5a4c$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

const $776ef75d5b01ad48$export$5b956b542f1bc1b3 = 800;
const $776ef75d5b01ad48$export$89a9f35a94d7f196 = 200;

parcelRegister("74i65", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $c1e0a551e3d32906$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
class $c1e0a551e3d32906$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $c1e0a551e3d32906$export$2e2bcd8739ae039 = $c1e0a551e3d32906$export$e926676385687eaf;

});

parcelRegister("aci2z", function(module, exports) {

$parcel$export(module.exports, "TeamProfileCardLazy", () => $0341a64f783b98dd$export$82a49d896f41ca78);

var $eJOHy = parcelRequire("eJOHy");

const $0341a64f783b98dd$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("50d7b")));

});
parcelRegister("50d7b", function(module, exports) {

let $3a47202928fe5824$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3a47202928fe5824$var$load("azqRW").then(()=>parcelRequire('gVW5o'));

});


parcelRegister("8ZI1l", function(module, exports) {

$parcel$export(module.exports, "default", () => $46bb11efbe40b76f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $84DsM = parcelRequire("84DsM");

var $2EPX4 = parcelRequire("2EPX4");
var $46bb11efbe40b76f$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    (0, $eJOHy.useEffect)(()=>{
        analytics((duration)=>(0, $2EPX4.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $84DsM.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.CardContent), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
                })
            })
        ]
    });
};

});
parcelRegister("84DsM", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $a368743025da7b9f$export$6aa22a823032b784);
$parcel$export(module.exports, "CardHeader", () => $a368743025da7b9f$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardContent", () => $a368743025da7b9f$export$64ef9b8c11710c47);
$parcel$export(module.exports, "LoadingWrapper", () => $a368743025da7b9f$export$43a792a870d28db2);
/* TeamTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");

var $gVqtd = parcelRequire("gVqtd");
const $a368743025da7b9f$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rkoglpi _1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw"
};
const $a368743025da7b9f$export$a443be8291b92497 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardtriggerwrapper)
    });
const $a368743025da7b9f$export$6aa22a823032b784 = ({ testId: testId, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    });
const $a368743025da7b9f$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label })=>isLoading || !image ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardheader),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gVqtd.CoverImage), {
        alt: label || '',
        src: image
    });
const $a368743025da7b9f$export$64ef9b8c11710c47 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardcontent),
        ...props
    });
const $a368743025da7b9f$export$43a792a870d28db2 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.loadingwrapper),
        ...props
    });

});
parcelRegister("gVqtd", function(module, exports) {

$parcel$export(module.exports, "CoverImage", () => $2e76209cd6ae11d8$export$a65e282337ff0f53);
/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $2e76209cd6ae11d8$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13liglpi _qrwqglpi _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug"
};
const $2e76209cd6ae11d8$export$a65e282337ff0f53 = ({ src: src, alt: alt = '' })=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const imgRef = (0, $eJOHy.useRef)(null);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        ref: containerRef,
        xcss: $2e76209cd6ae11d8$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: $2e76209cd6ae11d8$var$styles.image
        })
    });
};

});







parcelRegister("aVor1", function(module, exports) {

$parcel$export(module.exports, "TeamReadViewWithGpp", () => $deb0ebcb9ca82ac4$export$ad83489c3f151e9e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $3cMgR = parcelRequire("3cMgR");

var $6bLlX = parcelRequire("6bLlX");

var $bmoS1 = parcelRequire("bmoS1");

var $lRq8t = parcelRequire("lRq8t");

var $48BVs = parcelRequire("48BVs");

var $KQDhS = parcelRequire("KQDhS");

var $lO5gq = parcelRequire("lO5gq");
const $deb0ebcb9ca82ac4$export$ad83489c3f151e9e = ({ teamName: teamName, teamId: teamId, ariId: ariId, maxLines: maxLines, triggerLinkType: triggerLinkType = 'link', showTeamPreview: showTeamPreview = false })=>{
    const { openPreviewPanel: openPreviewPanel, isPreviewPanelAvailable: isPreviewPanelAvailable } = (0, $6bLlX.useGlobalObjectPreviewPanels)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const resolvedTeamId = teamId || (ariId ? (0, $48BVs.getIdFromAri)(ariId) : '');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const teamUrl = `${window.location.origin}/jira/people/team/${resolvedTeamId}`;
    const openPreviewPanelWithTeamData = (0, $eJOHy.useCallback)((event)=>{
        // For keyboard events, only respond to Enter and Space
        if ('key' in event && event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopPropagation();
        openPreviewPanel({
            ari: ariId,
            url: teamUrl,
            name: 'identity-team'
        });
    }, [
        ariId,
        openPreviewPanel,
        teamUrl
    ]);
    const handleLinkClick = (0, $eJOHy.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    const ariaLabel = formatMessage((0, $lO5gq.default).teamPreviewLabel, {
        teamName: teamName
    });
    const isModal = (0, $bmoS1.useIsModal)();
    const canShowPreview = !isModal && isPreviewPanelAvailable({
        ari: ariId || ''
    });
    const gppContent = canShowPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($deb0ebcb9ca82ac4$var$TeamNameWrapper, {
        onClick: openPreviewPanelWithTeamData,
        onKeyDown: openPreviewPanelWithTeamData,
        role: "button",
        tabIndex: 0,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines
    }, teamName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        href: teamUrl,
        target: "_blank",
        onClick: handleLinkClick,
        xcss: $deb0ebcb9ca82ac4$var$teamLinkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines
    }, teamName));
    if (showTeamPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $KQDhS.default), {
        teamId: ariId,
        trigger: "hover",
        position: "left-start",
        triggerLinkType: triggerLinkType
    }, gppContent);
    return gppContent;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $deb0ebcb9ca82ac4$var$TeamNameWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _80omtlke _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $deb0ebcb9ca82ac4$var$teamLinkStyles = (0, $1DXK0.xcss)({
    cursor: 'pointer',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'color.text',
    ':hover': {
        textDecoration: 'underline',
        color: 'color.text'
    },
    ':visited': {
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    }
});

});
parcelRegister("48BVs", function(module, exports) {

$parcel$export(module.exports, "getColorForProgress", () => $de59d015c44f2268$export$58950a4b8fb8acf4);
$parcel$export(module.exports, "getScorecardHealthCountsFromScores", () => $de59d015c44f2268$export$a64a7643d5a3fae);
$parcel$export(module.exports, "getSummaryText", () => $de59d015c44f2268$export$d48af90fda49897);
$parcel$export(module.exports, "getScorecardsSortedByHealth", () => $de59d015c44f2268$export$6e2af0614a0d9b67);
$parcel$export(module.exports, "getIdFromAri", () => $de59d015c44f2268$export$79640a85913af5aa);


var $9CuM6 = parcelRequire("9CuM6");
const $de59d015c44f2268$export$aa91e30498abc411 = {
    FAILING: 0,
    NEEDS_ATTENTION: 50,
    PASSING: 100
};
const $de59d015c44f2268$var$COLOR_RANGES = [
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.FAILING,
        end: $de59d015c44f2268$export$aa91e30498abc411.NEEDS_ATTENTION - 1,
        color: (0, $7bb4c1736002a04a$exports).R300
    },
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.NEEDS_ATTENTION,
        end: $de59d015c44f2268$export$aa91e30498abc411.PASSING - 1,
        color: (0, $7bb4c1736002a04a$exports).Y300
    },
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.PASSING,
        end: $de59d015c44f2268$export$aa91e30498abc411.PASSING,
        color: (0, $7bb4c1736002a04a$exports).G300
    }
];
const $de59d015c44f2268$export$58950a4b8fb8acf4 = (progress)=>{
    for (const { start: start, end: end, color: color } of $de59d015c44f2268$var$COLOR_RANGES){
        if (progress >= start && progress <= end) return color;
    }
    // Default.
    return (0, $7bb4c1736002a04a$exports).R300;
};
const $de59d015c44f2268$export$921f23fa0f13f23e = 90;
const $de59d015c44f2268$export$69a1d9a35c04a358 = 50;
const $de59d015c44f2268$export$a64a7643d5a3fae = (scorecardScores)=>{
    let failingScorecards = 0;
    let needsAttentionScorecards = 0;
    let totalScorecards = 0;
    scorecardScores.forEach((scorecardScore)=>{
        const totalScore = scorecardScore?.totalScore ?? 0;
        totalScorecards += 1;
        if (totalScore < $de59d015c44f2268$export$69a1d9a35c04a358) failingScorecards += 1;
        else if (totalScore >= $de59d015c44f2268$export$69a1d9a35c04a358 && totalScore < $de59d015c44f2268$export$921f23fa0f13f23e) needsAttentionScorecards += 1;
    });
    return {
        total: totalScorecards,
        passing: totalScorecards - failingScorecards - needsAttentionScorecards,
        needsAttention: needsAttentionScorecards
    };
};
const $de59d015c44f2268$export$d48af90fda49897 = (scorecardHealthCount, totalScorecardsCount, formatMessage)=>{
    const { passing: passing } = scorecardHealthCount;
    const { needsAttention: needsAttention } = scorecardHealthCount;
    let numerator = 0;
    let message;
    if (passing === 0 && totalScorecardsCount === 0) message = (0, $9CuM6.default).noScorecards;
    else if (passing + needsAttention < totalScorecardsCount) {
        numerator = Math.floor(totalScorecardsCount) - Math.floor(passing) - Math.floor(needsAttention);
        message = (0, $9CuM6.default).summaryTextForFailing;
    } else if (needsAttention > 0) {
        numerator = Math.floor(needsAttention);
        message = (0, $9CuM6.default).summaryTextForNeedsAttention;
    } else {
        numerator = Math.floor(totalScorecardsCount);
        message = (0, $9CuM6.default).summaryTextForHealthy;
    }
    return formatMessage(message, {
        numerator: numerator
    });
};
const $de59d015c44f2268$export$6e2af0614a0d9b67 = (scorecards)=>[
        ...scorecards
    ].sort((a, b)=>{
        const aTotalScore = a?.scorecardScore?.totalScore ?? 0;
        const bTotalScore = b?.scorecardScore?.totalScore ?? 0;
        return aTotalScore - bTotalScore;
    });
function $de59d015c44f2268$export$79640a85913af5aa(ari) {
    const regex = /\/([\w-]+)$/; // Matches the id at the end of the string
    const match = ari.match(regex);
    return match ? match[1] : '';
}

});
parcelRegister("9CuM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3693706a70d8818b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3693706a70d8818b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noScorecards: {
        "id": "compass-common.common.no-scorecards",
        "defaultMessage": "No scorecards"
    },
    summaryTextForFailing: {
        "id": "compass-common.common.summary-text-for-failing",
        "defaultMessage": "{numerator} {numerator, plural, one {failing} other {failing}}"
    },
    summaryTextForHealthy: {
        "id": "compass-common.common.summary-text-for-healthy",
        "defaultMessage": "All passing"
    },
    summaryTextForNeedsAttention: {
        "id": "compass-common.common.summary-text-for-needs-attention",
        "defaultMessage": "{numerator} {numerator, plural, one {needs} other {need}} attention"
    }
});

});


parcelRegister("lO5gq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fadc8f0700e23504$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fadc8f0700e23504$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    teamPreviewLabel: {
        "id": "issue-field-team-readview-with-gpp.team.preview-label",
        "defaultMessage": "Click to view {teamName} team details"
    }
});

});



parcelRegister("b1dAu", function(module, exports) {

$parcel$export(module.exports, "useMutationWithRetriesCommit", () => $8dfcccfd6d6324ba$export$aaa0248df1ccb7fc);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");
const $8dfcccfd6d6324ba$export$aaa0248df1ccb7fc = ({ retries: retries, isValidOnCompleted: isValidOnCompleted })=>{
    return (0, $eJOHy.useCallback)((environment, config)=>{
        let disposable;
        let optimisticDisposable = null;
        const handleCommitWithRetries = ({ retriesLeft: retriesLeft })=>{
            disposable = (0, $j4oe4.commitMutation)(environment, {
                ...config,
                onCompleted: (response, errors)=>{
                    if (isValidOnCompleted(response, errors)) {
                        config.onCompleted?.(response, errors);
                        return;
                    }
                    if (retriesLeft > 0) {
                        optimisticDisposable = (0, $j4oe4.applyOptimisticMutation)(environment, config);
                        // Wait 100ms before retrying
                        const timeout = setTimeout(()=>{
                            optimisticDisposable?.dispose();
                            handleCommitWithRetries({
                                retriesLeft: retriesLeft - 1
                            });
                        }, 100);
                        disposable = {
                            dispose: ()=>{
                                optimisticDisposable?.dispose();
                                clearTimeout(timeout);
                            }
                        };
                        return;
                    }
                    // Last retry needs to call onComplete
                    config.onCompleted?.(response, errors);
                }
            });
        };
        handleCommitWithRetries({
            retriesLeft: retries
        });
        // Return a new disposable that cleans up the optimistic AND committed operations
        return {
            dispose: ()=>{
                disposable?.dispose();
            }
        };
    }, [
        isValidOnCompleted,
        retries
    ]);
};

});



parcelRegister("9PzxA", function(module, exports) {

$parcel$export(module.exports, "UserCell", () => $fe06e52d9df14edf$export$dc0ef711c0db7c30);

var $jTrpS = parcelRequire("jTrpS");

var $6WRAm = parcelRequire("6WRAm");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lpMrC = parcelRequire("lpMrC");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $6AqNd = parcelRequire("6AqNd");

var $krQQZ = parcelRequire("krQQZ");

var $iZVkR = parcelRequire("iZVkR");

var $7xXvm = parcelRequire("7xXvm");


var $ljej9 = parcelRequire("ljej9");

var $j8Km1 = parcelRequire("j8Km1");

var $eqbO4 = parcelRequire("eqbO4");

var $25lAa = parcelRequire("25lAa");

var $86BUM = parcelRequire("86BUM");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");

var $jpLGv = parcelRequire("jpLGv");
const $fe06e52d9df14edf$export$afb022e5bfe0b377 = (accountId)=>(children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7xXvm.default), {
            accountId: accountId ?? '',
            actions: [
                (0, $6d22448f78a7f25a$export$23cedd3261bd8015)
            ]
        }, children);
const $fe06e52d9df14edf$export$dc0ef711c0db7c30 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, projectKey: projectKey, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $6WRAm.default), fieldRef);
    if (data.fieldId === 'assignee' || data.fieldId === 'reporter' || (0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe06e52d9df14edf$export$df3d80016052952c, {
        fieldRef: data,
        projectKey: projectKey,
        menuPortalTarget: // Portal the menu outside of the scroll container, i.e., table body
        // to prevent clipping in Safari (see https://bugs.webkit.org/show_bug.cgi?id=160953#c20)
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        (0, $lpMrC.isSafari)() ? document.body : undefined,
        isFirstField: isFirstField,
        hasDuplicates: hasDuplicates
    });
    const { type: type, user: user } = data;
    const { name: name, accountId: accountId, picture: picture } = user ?? {};
    const displayText = name ?? formatMessage(type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).ASSIGNEE ? (0, $jpLGv.default).anonymous : (0, $jpLGv.default).unassigned);
    if (user != null && (name == null || accountId == null)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "user",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $25lAa.ConditionalWrapper), {
        condition: accountId !== undefined,
        renderWrapper: $fe06e52d9df14edf$export$afb022e5bfe0b377(accountId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe06e52d9df14edf$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: picture,
        size: "small",
        borderColor: "transparent",
        name: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe06e52d9df14edf$var$Text, null, displayText)));
});
const $fe06e52d9df14edf$export$df3d80016052952c = ({ fieldRef: fieldRef, projectKey: projectKey, menuPortalTarget: menuPortalTarget, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $jTrpS.default), fieldRef);
    const isAssigneeReporter = data.fieldId === 'assignee' || data.fieldId === 'reporter';
    const isCreatorField = data.fieldId === 'creator';
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = isAssigneeReporter || isInlineEditingExtendedFieldSupportEnabled; // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    // We can also disable editability of the creator field as it is never editable.
    let isEditable;
    if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported && !isCreatorField ? data.lazyIsEditableInIssueView : false;
    else isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldRenderHoverPopover = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && shouldRenderHoverPopover && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) switch(data.fieldId){
        case 'assignee':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6AqNd.AssigneeInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "start",
                editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
                editViewPopupTarget: isFirstField ? $fe06e52d9df14edf$var$CustomTarget : undefined,
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: isFirstField ? 'fixed' : 'absolute',
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                projectKey: (0, $ljej9.toProjectKey)(projectKey),
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        case 'reporter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $krQQZ.ReporterInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "start",
                editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
                editViewPopupTarget: isFirstField ? $fe06e52d9df14edf$var$CustomTarget : undefined,
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: isFirstField ? 'fixed' : 'absolute',
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        default:
            {
                const noneOptionLabel = isCreatorField ? formatMessage((0, $jpLGv.default).anonymous) : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditViewWithIsEditable), {
                    attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                    spacing: "default",
                    editViewPopup: true,
                    editViewPopupAlignBlock: "start",
                    editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
                    editViewPopupTarget: isFirstField ? $fe06e52d9df14edf$var$CustomTarget : undefined,
                    fragmentRef: data,
                    isEditable: isEditable ?? false,
                    menuPosition: isFirstField ? 'fixed' : 'absolute',
                    portalElement: menuPortalTarget,
                    readViewFitContainerHeight: true,
                    noneOptionLabel: noneOptionLabel,
                    shouldRenderHoverPopover: shouldRenderHoverPopover
                });
            }
    }
    switch(data.fieldId){
        case 'assignee':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6AqNd.AssigneeInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "center",
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: "fixed",
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                projectKey: (0, $ljej9.toProjectKey)(projectKey),
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        case 'reporter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $krQQZ.ReporterInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "center",
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: "fixed",
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        default:
            {
                const noneOptionLabel = isCreatorField ? formatMessage((0, $jpLGv.default).anonymous) : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditViewWithIsEditable), {
                    attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                    spacing: "default",
                    editViewPopup: true,
                    editViewPopupAlignBlock: "center",
                    fragmentRef: data,
                    menuPosition: "fixed",
                    isEditable: isEditable ?? false,
                    portalElement: menuPortalTarget,
                    readViewFitContainerHeight: true,
                    noneOptionLabel: noneOptionLabel,
                    shouldRenderHoverPopover: shouldRenderHoverPopover
                });
            }
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fe06e52d9df14edf$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19bvu2gc _1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fe06e52d9df14edf$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _80om73ad _18u01i6y",
            __cmplp.className
        ])
    });
});
const $fe06e52d9df14edf$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fe06e52d9df14edf$var$customTargetStyles,
        ref: ref
    });
});
const $fe06e52d9df14edf$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("jTrpS", function(module, exports) {

$parcel$export(module.exports, "default", () => $24d9da5ad3cbcf3b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<51281952c53ea8a9049c9fb9163738de>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $24d9da5ad3cbcf3b$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "user_nativeIssueTable_UserCellInternal_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$24d9da5ad3cbcf3b$var$node.hash = "70c9b5cc4f6637fc8553932c9c90dc8f";
var $24d9da5ad3cbcf3b$export$2e2bcd8739ae039 = $24d9da5ad3cbcf3b$var$node;

});

parcelRegister("6WRAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fa8bb1cc1f05787$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3281df4ab3692851ab8562e9a5d372a1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2fa8bb1cc1f05787$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "user_nativeIssueTable_UserCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "user_nativeIssueTable_UserCellInternal_fieldRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$2fa8bb1cc1f05787$var$node.hash = "a362c09fb0469678ce4210679cf0a5fa";
var $2fa8bb1cc1f05787$export$2e2bcd8739ae039 = $2fa8bb1cc1f05787$var$node;

});

parcelRegister("6AqNd", function(module, exports) {

$parcel$export(module.exports, "AssigneeInlineEditViewWithIsEditable", () => $324f37a604262e80$export$e07ee235d4f5b512);
$parcel$export(module.exports, "AssigneeInlineEditView", () => $324f37a604262e80$export$9f32fa927ad908e5);

var $8ILq5 = parcelRequire("8ILq5");

var $e6ErP = parcelRequire("e6ErP");

var $7f399 = parcelRequire("7f399");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $41wNq = parcelRequire("41wNq");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $d2AGn = parcelRequire("d2AGn");

var $ftZVn = parcelRequire("ftZVn");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $fsoQR = parcelRequire("fsoQR");


var $1uIew = parcelRequire("1uIew");

var $jHI6h = parcelRequire("jHI6h");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $9RttA = parcelRequire("9RttA");

var $RPb3k = parcelRequire("RPb3k");
const $324f37a604262e80$var$isEqualUser = (a, b)=>a?.id === b?.id;
const $324f37a604262e80$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-assignee-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $324f37a604262e80$export$e07ee235d4f5b512 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, portalElement: portalElement, onCancel: onCancel, onEdit: onEdit, isDisabledTooltipShown: isDisabledTooltipShown = false, projectKey: projectKey, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const isFieldEditable = (0, $7jTnu.fg)('relay-migration-issue-fields-assignee-fg') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(isEditable || false), [
        isEditable,
        overriding
    ]) : isEditable;
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $7f399.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, user: user, fieldConfig: fieldConfig } = data;
    const fieldName = (0, $7jTnu.fg)('relay-migration-issue-fields-assignee-fg') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>overriding.overrideLabel(name), [
        name,
        overriding
    ]) : name;
    const isFieldRequired = fieldConfig?.isRequired ?? false;
    // Node: Change the MUTATION_NAME whenever the mutation name is also being changed
    const MUTATION_NAME = 'assignee_issueFieldAssignee_AssigneeField_Mutation';
    const [commit] = (0, $j4oe4.useMutation)((0, $e6ErP.default));
    // #endregion
    const initialValue = user ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((newUser, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newUser);
        (0, $jHI6h.startCapturingTraceIds)(MUTATION_NAME);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newUser?.id ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSingleSelectUserPickerField?.success) {
                    (0, $jHI6h.stopCapturingTraceIds)(MUTATION_NAME);
                    onSuccess();
                } else {
                    const traceIds = (0, $jHI6h.getTraceIds)(MUTATION_NAME);
                    (0, $jHI6h.stopCapturingTraceIds)(MUTATION_NAME);
                    const gqlError = mutationData.jira?.updateSingleSelectUserPickerField?.errors?.[0];
                    onFail(new (0, $1uIew.default)(gqlError?.extensions?.statusCode || 0, gqlError?.message || undefined, traceIds[0]));
                }
            },
            onError (error) {
                onFail(error);
                (0, $jHI6h.stopCapturingTraceIds)(MUTATION_NAME);
            },
            optimisticResponse: {
                jira: {
                    updateSingleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            user: newUser ? {
                                id: newUser.id,
                                accountId: newUser.accountId,
                                accountStatus: newUser.accountStatus,
                                name: newUser.name,
                                picture: newUser.picture,
                                __typename: 'AtlassianAccountUser'
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        uniqueFieldId,
        onSubmit
    ]);
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, initialValue?.accountId, value?.accountId || null);
    }, [
        fieldId,
        initialValue
    ]);
    const validator = (0, $RPb3k.useAssigneeValidator)(fieldName, isFieldRequired);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $324f37a604262e80$var$isEqualUser,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        validator: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? validator : undefined,
        clipboardComponentType: 'singleUser',
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($324f37a604262e80$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fsoQR.SingleUserPickerWithProfileCardReadView), {
            fragmentRef: data,
            emptyUserLabel: formatMessage((0, $9RttA.default).unassignedOption),
            profileCardAction: (0, $6d22448f78a7f25a$export$6bef782d14a92db8),
            shouldRenderHoverPopover: shouldRenderHoverPopover,
            fieldId: fieldId
        })), [
        data,
        formatMessage,
        shouldRenderHoverPopover,
        fieldId
    ]);
    // #endregion
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            spacing: spacing,
            projectKey: projectKey,
            fetchSuggestionsOnMount: false,
            portalElement: portalElement,
            enablePeopleInvite: true,
            includeNoneOption: !isFieldRequired,
            isClearable: !isFieldRequired,
            menuPosition: menuPosition,
            label: fieldName,
            isInvalid: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? !!invalidMessage : undefined
        });
    const editButtonLabel = formatMessage((0, $41wNq.default).extendedEditButtonLabel, {
        inputFieldValue: initialValue?.name ?? formatMessage((0, $9RttA.default).unassignedOption),
        fieldName: fieldName
    });
    const inlineEditElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPoint: (0, $ftZVn.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readView: renderReadView,
        hideActionButtons: true,
        editButtonLabel: editButtonLabel,
        readViewFitContainerHeight: readViewFitContainerHeight,
        disableReadViewAppearanceOnHoverOnly: true
    });
    return isDisabledTooltipShown && !isFieldEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $41wNq.default).disabledReporterTooltip, {
            fieldName: fieldName
        }),
        position: "mouse"
    }, inlineEditElement) : inlineEditElement;
};
const $324f37a604262e80$export$9f32fa927ad908e5 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $8ILq5.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($324f37a604262e80$export$e07ee235d4f5b512, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("8ILq5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d27229231115a401$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9ea929c7ab7c075bed623095bf805b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d27229231115a401$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$d27229231115a401$var$node.hash = "93c1d9e2338da6a23190803216172e69";
var $d27229231115a401$export$2e2bcd8739ae039 = $d27229231115a401$var$node;

});

parcelRegister("e6ErP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f6fe3eeeba7024b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e918e00b96147ea6bf09ae576e90430e>>
 * @relayHash edf533ecdfe81145f0d5ed0486a7d74c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d872673080e443d67f3c30873225e21fdfd2b89e010b0cfb4f1f1c7f8da5f301
const $3f6fe3eeeba7024b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v8 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d872673080e443d67f3c30873225e21fdfd2b89e010b0cfb4f1f1c7f8da5f301",
            "metadata": {},
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3f6fe3eeeba7024b$var$node.hash = "6c6c314bdc60901e8c03415b7add3145";
var $3f6fe3eeeba7024b$export$2e2bcd8739ae039 = $3f6fe3eeeba7024b$var$node;

});

parcelRegister("7f399", function(module, exports) {

$parcel$export(module.exports, "default", () => $3547e8de8d654203$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e2149847065382e9713c221d19daf2fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3547e8de8d654203$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$3547e8de8d654203$var$node.hash = "3dea6b061e5fab4e19523a4247ac9c2d";
var $3547e8de8d654203$export$2e2bcd8739ae039 = $3547e8de8d654203$var$node;

});

parcelRegister("41wNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $68be5f461eda860e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $68be5f461eda860e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    confirmButtonLabel: {
        "id": "inline-edit.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "inline-edit.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "inline-edit.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    },
    addButtonLabel: {
        "id": "inline-edit.add-button-label",
        "defaultMessage": "Add {fieldName}"
    },
    extendedEditButtonLabel: {
        "id": "inline-edit.extended-edit-button-label",
        "defaultMessage": "{inputFieldValue}- edit {fieldName}"
    },
    disabledEditButtonLabel: {
        "id": "inline-edit.disabled-edit-button-label",
        "defaultMessage": "{fieldName} - can\u2019t be edited"
    },
    disabledReporterTooltip: {
        "id": "inline-edit.disabled-inline-edit-tooltip",
        "defaultMessage": "{fieldName} can\u2019t be edited"
    },
    columnTitleAriaLabel: {
        "id": "inline-edit.column-title-aria-label",
        "defaultMessage": "Add column name"
    }
});

});

parcelRegister("ftZVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad0c1b7ae89be577$export$2e2bcd8739ae039);

var $l4y7H = parcelRequire("l4y7H");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ad0c1b7ae89be577$var$AssigneeEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("2VtRi")), {
        moduleId: "3f5ced6e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            queries: {
                rootData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $l4y7H.default,
                    variables: {}
                }
            }
        })
});
var $ad0c1b7ae89be577$export$2e2bcd8739ae039 = $ad0c1b7ae89be577$var$AssigneeEditViewEntryPoint;

});
parcelRegister("l4y7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $57f9257373f6ce88$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c3533b181da4fe930f227b215516895>>
 * @relayHash c0a99e60ca7db3e867b3bb2039798d28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06cc27c43b93217b220d59a67c5b60e54cc82db33ba6e684ea3f67b1f62fb4a0
const $57f9257373f6ce88$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "06cc27c43b93217b220d59a67c5b60e54cc82db33ba6e684ea3f67b1f62fb4a0",
        "metadata": {},
        "name": "assigneeEditView_rootQuery",
        "operationKind": "query",
        "text": null
    }
};
var $57f9257373f6ce88$export$2e2bcd8739ae039 = $57f9257373f6ce88$var$node;

});

parcelRegister("2VtRi", function(module, exports) {

let $221810f280e5bc62$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $221810f280e5bc62$var$load("cwtwt").then(()=>parcelRequire('dWIha'));

});


parcelRegister("fsoQR", function(module, exports) {

$parcel$export(module.exports, "SingleUserPickerWithProfileCardReadView", () => $a7294ab276327711$export$2f1ab379ffebbded);

var $6GnQ8 = parcelRequire("6GnQ8");

var $cG6qg = parcelRequire("cG6qg");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $3cMgR = parcelRequire("3cMgR");

var $9Mapt = parcelRequire("9Mapt");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");


var $7xXvm = parcelRequire("7xXvm");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $3OT15 = parcelRequire("3OT15");

var $ckebs = parcelRequire("ckebs");
const $a7294ab276327711$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', (0, $eJOHy.Fragment), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-single-user-picker-read-view",
        mode: "list"
    }, children)); /**
                   * The SingleUserPickerReadView will show a read only view of SingleUserPicker field.
                   * @param props [SingleUserPickerReadViewProps](./types.tsx)
                   */ 
const $a7294ab276327711$export$65db1532781bc51 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fragmentRef: fragmentRef, emptyUserLabel: emptyUserLabel = null, shouldRenderHoverPopover: shouldRenderHoverPopover, fieldId: fieldId })=>{
    const data = (0, $j4oe4.useFragment)((0, $cG6qg.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { name: name = emptyUserLabel ?? formatMessage((0, $ckebs.default).anonymousOption), picture: picture, accountStatus: accountStatus } = data?.user || {};
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldRenderHoverPopover && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!data?.user && fieldId !== 'assignee' && fieldId !== 'reporter' && isExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: formatMessage((0, $ckebs.default).noValueTextExperiment)
    });
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: name
    });
    if (shouldRenderHoverPopover && data?.user === null) return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        as: $a7294ab276327711$var$AvatarAlignmentFix,
        src: picture,
        name: name,
        size: "small",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: 1,
        ref: hoverPopoverRef
    }, name)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: name,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$Container, {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
            as: $a7294ab276327711$var$AvatarAlignmentFix,
            src: picture,
            name: name,
            size: "small",
            borderColor: "transparent"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: 1,
            ref: contentRef
        }, name)));
    return(// We use our own container element rather than an AvatarItem as we've observed hydration bugs with SSR+Emotion
    // when this component is wrapped in an async profile card, and this approach is the path of least friction.
    // Further context here https://atlassian.slack.com/archives/C060GTVV988/p1712624943348969.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        as: $a7294ab276327711$var$AvatarAlignmentFix,
        src: picture,
        name: name,
        size: "small",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$TextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, name), data?.user && accountStatus !== 'active' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$UserStatus, null, `(${formatMessage((0, $ckebs.default).deactivated)})`))));
});
const $a7294ab276327711$export$2f1ab379ffebbded = /*#__PURE__*/ (0, $eJOHy.memo)(({ fragmentRef: fragmentRef, emptyUserLabel: emptyUserLabel, profileCardAction: profileCardAction, shouldRenderHoverPopover: shouldRenderHoverPopover, fieldId: fieldId })=>{
    const data = (0, $j4oe4.useFragment)((0, $6GnQ8.default), fragmentRef);
    const accountId = data?.user?.accountId || null;
    const actions = (0, $eJOHy.useMemo)(()=>profileCardAction ? [
            (0, $6d22448f78a7f25a$export$23cedd3261bd8015),
            profileCardAction
        ] : [
            (0, $6d22448f78a7f25a$export$23cedd3261bd8015)
        ], [
        profileCardAction
    ]);
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7xXvm.default), {
        prepopulatedData: {
            fullName: data?.user?.name
        },
        accountId: accountId,
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$export$65db1532781bc51, {
        fragmentRef: data,
        emptyUserLabel: emptyUserLabel,
        shouldRenderHoverPopover: shouldRenderHoverPopover,
        fieldId: fieldId
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$export$65db1532781bc51, {
        fragmentRef: data,
        emptyUserLabel: emptyUserLabel,
        shouldRenderHoverPopover: shouldRenderHoverPopover,
        fieldId: fieldId
    }));
}); /**
     * Component to pass for "as" prop of Avatar. It reverses the 2px margin added in the Avatar
     * component when a transparent border is used.
     *
     * Done using div + css because styled components are not compatible with Avatar's types.
     */ 
const $a7294ab276327711$var$AvatarAlignmentFix = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ...props,
        ref: ref,
        className: (0, $hcewu.default)([
            "_19pk1i6y _2hwx1i6y _otyr1i6y _18u01i6y"
        ])
    }));
const $a7294ab276327711$var$avatarAlignmentStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7294ab276327711$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7294ab276327711$var$TextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7294ab276327711$var$UserStatus = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz131l _18u0v77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6GnQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $46308aa31193a051$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<75c9f0edae87b35dae025f46e4be4e99>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $46308aa31193a051$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$46308aa31193a051$var$node.hash = "c59dbeffeee9029f50284e101470f0fa";
var $46308aa31193a051$export$2e2bcd8739ae039 = $46308aa31193a051$var$node;

});

parcelRegister("cG6qg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fb534729e4e04ed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94b075360043815f875b51a60612f659>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5fb534729e4e04ed$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "accountStatus"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$5fb534729e4e04ed$var$node.hash = "2296c8d692007cf9a8de38c241cdd0d0";
var $5fb534729e4e04ed$export$2e2bcd8739ae039 = $5fb534729e4e04ed$var$node;

});

parcelRegister("7xXvm", function(module, exports) {

$parcel$export(module.exports, "ProfileCard", () => $329dd4b85ed15d85$export$bed540ccfa8743c4);
$parcel$export(module.exports, "default", () => $329dd4b85ed15d85$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");

var $4xbv3 = parcelRequire("4xbv3");

var $lcB5K = parcelRequire("lcB5K");

var $lRq8t = parcelRequire("lRq8t");

var $8q7lT = parcelRequire("8q7lT");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");

var $1KdDN = parcelRequire("1KdDN");

var $a62R3 = parcelRequire("a62R3");


var $lFp9s = parcelRequire("lFp9s");

var $38H79 = parcelRequire("38H79");

var $28Csj = parcelRequire("28Csj");
const $329dd4b85ed15d85$var$ConditionalErrorBoundary = (0, $bJscI.componentWithFG)('empanada_profilecard_sync_trigger_import_final', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "profilecard",
        packageName: (0, $6d22448f78a7f25a$export$9345d7360ffe0722),
        fallback: "flag"
    }, children), (0, $eJOHy.Fragment));
const $329dd4b85ed15d85$export$bed540ccfa8743c4 = ({ externalProfileClient: externalProfileClient, accountId: accountId, actions: actions, analyticsData: analyticsData, children: children, position: position, testId: testId, trigger: trigger, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment = false, shouldTruncate: shouldTruncate = false })=>{
    const intl = (0, $lRq8t.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const currentUserAccountId = (0, $8q7lT.useAccountId)();
    const toTeamsAppUserProfile = (userId)=>(0, $a62R3.getNavigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: userId
            }
        }).onNavigate();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($329dd4b85ed15d85$var$ConditionalErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: (0, $6d22448f78a7f25a$export$81319ffa9c0d18d7),
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lFp9s.ProfileCardWrapper), {
        externalProfileClient: externalProfileClient
    }, currentUserAccountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $28Csj.ProfileCardView), {
            accountId: accountId,
            actions: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $7jTnu.fg)('jira_nin_smart_link') && (0, $7jTnu.fg)('jsc_nin_smart_link_fast_follows') ? (0, $38H79.getSpaActions)(accountId, intl, actions) : (0, $38H79.getSpaActionsWithRouterPush)(accountId, intl, push, actions),
            position: position,
            onProfileClick: (profileAccountId)=>(0, $a62R3.isTeamsAppEnabled)() ? toTeamsAppUserProfile(profileAccountId) : push(`/jira/people/${profileAccountId}`),
            addFlag: showFlag,
            dismissFlag: dismissFlag,
            testId: testId,
            trigger: trigger,
            prepopulatedData: prepopulatedData,
            ariaHideProfileTrigger: ariaHideProfileTrigger,
            isChildComment: isChildComment,
            shouldTruncate: shouldTruncate
        }, children)) : children)));
};
var $329dd4b85ed15d85$export$2e2bcd8739ae039 = $329dd4b85ed15d85$export$bed540ccfa8743c4;

});
parcelRegister("28Csj", function(module, exports) {

$parcel$export(module.exports, "ProfileCardView", () => $64d7fb877670625a$export$da5098f02f405a40);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $caeqU = parcelRequire("caeqU");

var $22c3C = parcelRequire("22c3C");
var $hrodw = parcelRequire("hrodw");

var $hjf2q = parcelRequire("hjf2q");

var $6XJko = parcelRequire("6XJko");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $a62R3 = parcelRequire("a62R3");

var $16TBK = parcelRequire("16TBK");

const $64d7fb877670625a$var$PEOPLE_PROFILE_PATH = '/people/';
const $64d7fb877670625a$var$ProfileCardTriggerWithAnalytics = (0, $hjf2q.AnalyticsEventToProps)((0, $b9c60665faffac50$export$a1455360a24a2234), {
    analytics: ''
})((0, $caeqU.default));
const $64d7fb877670625a$export$da5098f02f405a40 = ({ children: children, position: position = 'top-start', trigger: trigger = 'hover', accountId: accountId, actions: actions, onProfileClick: onProfileClick, addFlag: addFlag, dismissFlag: dismissFlag, testId: testId, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment, shouldTruncate: shouldTruncate })=>{
    const profileCardWrapperRef = (0, $eJOHy.useRef)(null);
    const cloudId = (0, $kEUB1.useCloudId)();
    const viewingUserId = (0, $8q7lT.useAccountId)();
    const { profileClient: profileClient } = (0, $16TBK.useProfileClient)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64d7fb877670625a$var$Wrapper, {
        ref: profileCardWrapperRef,
        onClick: (event)=>{
            if (profileCardWrapperRef?.current !== null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            !profileCardWrapperRef?.current?.contains(event.target)) event.stopPropagation();
        },
        "data-vc": `profilecard-wrapper${false ? '-ssr' : ''}`,
        isVisualRefresh: (0, $6XJko.isVisualRefreshEnabled)(),
        className: (0, $hcewu.default)([
            isChildComment && "_kqswh2mm _1hjgt94y _1pty1eak _161e1v33 _ft5qdlk8 _2wzdc71f _2kncueha _qlwiueha _aetrb3bt _631ousvi _18postnw _g0nf1yie _15l21pz7 _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            isChildComment && "_p12f1kdh _kqswh2mm _uglpt94y _161e1v33 _1pty1eak _2knc163p _qlwi163p _631ousvi _aetrb3bt _18postnw _g0nf1yie _15l24uri _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            shouldTruncate && "_1reo15vq _18m915vq _1o9zidpf _1bto1l2s _o5721q9c"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64d7fb877670625a$var$ProfileCardTriggerWithAnalytics, {
        cloudId: cloudId,
        userId: accountId,
        resourceClient: profileClient,
        position: position,
        trigger: trigger,
        testId: testId,
        actions: actions,
        reportingLinesProfileUrl: $64d7fb877670625a$var$PEOPLE_PROFILE_PATH,
        prepopulatedData: prepopulatedData,
        onReportingLinesClick: onProfileClick ? // @ts-expect-error - TS7006 - Parameter 'user' implicitly has an 'any' type.
        (user)=>{
            onProfileClick(user.accountIdentifier);
            if ((0, $a62R3.isTeamsAppEnabled)()) return false;
        } : null,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addFlag: (flag)=>{
            const flagId = (0, $hrodw.toFlagId)(flag.id);
            addFlag({
                id: flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $22c3C.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        ...props
                    })
            });
        },
        viewingUserId: viewingUserId,
        ariaHideProfileTrigger: ariaHideProfileTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "profilecard-next.ui.profilecard.profilecard-trigger",
        className: (0, $hcewu.default)([
            shouldTruncate && "_1e0c1nu9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64d7fb877670625a$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq",
            __cmplp.isVisualRefresh && "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $64d7fb877670625a$var$profileCardStyles = null;
const $64d7fb877670625a$var$replyProfileCardStyles = null;
const $64d7fb877670625a$var$truncatedProfileCardStyles = null;
const $64d7fb877670625a$var$truncatedProfileCardInnerStyles = null;
$64d7fb877670625a$var$Wrapper.displayName = 'Wrapper';

});
parcelRegister("caeqU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9b60a56512bd43f$export$2e2bcd8739ae039);


var $1GAK3 = parcelRequire("1GAK3");

var $39Fdj = parcelRequire("39Fdj");
var $f9b60a56512bd43f$export$2e2bcd8739ae039 = (0, $39Fdj.default);

});
parcelRegister("1GAK3", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $500dc3728366069c$export$403d297463f226af);

var $eJOHy = parcelRequire("eJOHy");

const $500dc3728366069c$export$403d297463f226af = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ly6c")));

});
parcelRegister("2ly6c", function(module, exports) {

let $1b57fe43f319ccc2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1b57fe43f319ccc2$var$load("ffQaD"),
    $1b57fe43f319ccc2$var$load("kvRbA"),
    $1b57fe43f319ccc2$var$load("2wjWj")
]).then(()=>parcelRequire('k60Oj'));

});


parcelRegister("39Fdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a556daa2b306b37$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $IW7jS = parcelRequire("IW7jS");

var $gh6xW = parcelRequire("gh6xW");

var $8WJ7D = parcelRequire("8WJ7D");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");


var $bQmsU = parcelRequire("bQmsU");

var $1GAK3 = parcelRequire("1GAK3");

var $5H2ec = parcelRequire("5H2ec");
function $9a556daa2b306b37$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, trigger: trigger, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQmsU.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        trigger: trigger,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1GAK3.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $9a556daa2b306b37$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible, ssrPlaceholderId: ssrPlaceholderId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isMounted = (0, $eJOHy.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $776ef75d5b01ad48$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $776ef75d5b01ad48$export$89a9f35a94d7f196);
    const showTimer = (0, $eJOHy.useRef)(0);
    const hideTimer = (0, $eJOHy.useRef)(0);
    const [visible, setVisible] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(undefined);
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eJOHy.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eJOHy.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eJOHy.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eJOHy.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eJOHy.useState)(false);
    const triggerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eJOHy.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eJOHy.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eJOHy.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eJOHy.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $eGOwo.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eJOHy.useCallback)(()=>{
        return (0, $gh6xW.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    const ssrPlaceholderProp = (0, $eGOwo.fg)('cc_mention_ssr_placeholder') ? {
        'data-ssr-placeholder-replace': ssrPlaceholderId
    } : {};
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $8WJ7D.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        ...ssrPlaceholderProp,
                        children: children
                    });
                },
                zIndex: (0, $IW7jS.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card'),
                shouldDisableFocusLock: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $9a556daa2b306b37$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5H2ec.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("8WJ7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a2772a88ae71e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $95a2772a88ae71e4$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($95a2772a88ae71e4$var$messages.label, {
        fullName: fullName
    }) : formatMessage($95a2772a88ae71e4$var$messages.fallbackLabel);
};
const $95a2772a88ae71e4$var$messages = (0, $7qGN1.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $95a2772a88ae71e4$export$2e2bcd8739ae039 = $95a2772a88ae71e4$var$getLabelMessage;

});

parcelRegister("b4A0H", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $d37aab7a36a1d923$export$6aa22a823032b784);
$parcel$export(module.exports, "SpinnerContainer", () => $d37aab7a36a1d923$export$a5e06607a5ac6158);
/* UserTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ // PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $d37aab7a36a1d923$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
const $d37aab7a36a1d923$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    });
const $d37aab7a36a1d923$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.spinnerContainer),
        children: children
    });

});

parcelRegister("bQmsU", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $2dca9d01bdb4de20$export$4b013ffffcb40af8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $j19W0 = parcelRequire("j19W0");

var $2EPX4 = parcelRequire("2EPX4");

var $46Rs7 = parcelRequire("46Rs7");

var $dWlMJ = parcelRequire("dWlMJ");

var $kKboJ = parcelRequire("kKboJ");

var $5TZsz = parcelRequire("5TZsz");
const $2dca9d01bdb4de20$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $eJOHy.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $46Rs7.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const { href: profileHref } = (0, $j19W0.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    const getCreator = (0, $eJOHy.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $eGOwo.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKboJ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWlMJ.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5TZsz.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("46Rs7", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $5342ced741c59880$export$3761e66a04602cbd);
const $5342ced741c59880$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $5342ced741c59880$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($5342ced741c59880$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("dWlMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4c4e00d9fd0e109$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $a03qM = parcelRequire("a03qM");

var $jZF1f = parcelRequire("jZF1f");

var $5qJVF = parcelRequire("5qJVF");

var $3CCXY = parcelRequire("3CCXY");

var $2EPX4 = parcelRequire("2EPX4");
const $d4c4e00d9fd0e109$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3CCXY.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $gt9Am.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jZF1f))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                onClick: reload,
                children: "Try again"
            })
        ]
    });
};
var $d4c4e00d9fd0e109$export$2e2bcd8739ae039 = $d4c4e00d9fd0e109$var$ErrorMessage;

});
parcelRegister("3CCXY", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $f4fe046f369d0d86$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $f4fe046f369d0d86$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $f4fe046f369d0d86$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $f4fe046f369d0d86$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $f4fe046f369d0d86$export$bb27b7e39840238f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorWrapper),
        ...props
    });
const $f4fe046f369d0d86$export$b065fd053267ec81 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorTitle),
        children: props.children
    });
const $f4fe046f369d0d86$export$90d92ccfb27352c6 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.teamErrorText),
        children: props.children
    });

});


parcelRegister("kKboJ", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $d15bd5f3ea87f8ed$export$2c6604b50c274e6f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $d15bd5f3ea87f8ed$var$styles = (0, $1DXK0.xcss)({
    width: '360px'
});
const $d15bd5f3ea87f8ed$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $d15bd5f3ea87f8ed$var$styles,
        children: children
    });
};

});

parcelRegister("5TZsz", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $aff86c6979038d17$export$ed0ca9c1d49ea0bf);

var $eJOHy = parcelRequire("eJOHy");

const $aff86c6979038d17$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2XXEr")));

});
parcelRegister("2XXEr", function(module, exports) {

let $228f5cf7f6ecd638$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $228f5cf7f6ecd638$var$load("76n7a"),
    $228f5cf7f6ecd638$var$load("l253H"),
    $228f5cf7f6ecd638$var$load("ffQaD"),
    $228f5cf7f6ecd638$var$load("kvRbA"),
    $228f5cf7f6ecd638$var$load("gsod0")
]).then(()=>parcelRequire('e1nCN'));

});



parcelRegister("5H2ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $75ec444a04f48b56$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");
const $75ec444a04f48b56$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });
};
var $75ec444a04f48b56$export$2e2bcd8739ae039 = $75ec444a04f48b56$var$UserLoadingState;

});



const $b9c60665faffac50$export$a1455360a24a2234 = 'profileCardNextView';



parcelRegister("ckebs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a464ef5085b9801$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3a464ef5085b9801$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    deactivated: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.deactivated",
        "defaultMessage": "Deactivated"
    },
    anonymousOption: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.anonymous-option",
        "defaultMessage": "Anonymous"
    },
    noValueTextExperiment: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.no-value-text-experiment",
        "defaultMessage": "Add user"
    }
});

});


parcelRegister("9RttA", function(module, exports) {

$parcel$export(module.exports, "default", () => $baff1950d7ccac9c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $baff1950d7ccac9c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee-inline-edit-full.assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    assignToMe: {
        "id": "issue-field-assignee-inline-edit-full.assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    requiredErrorMessage: {
        "id": "issue-field-assignee-inline-edit-full.assignee.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});

});

parcelRegister("RPb3k", function(module, exports) {

$parcel$export(module.exports, "useAssigneeValidator", () => $02dcb8981a357561$export$37df2b94c6c5d4a3);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $9RttA = parcelRequire("9RttA");
const $02dcb8981a357561$export$37df2b94c6c5d4a3 = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && value === null) return {
            type: 'error',
            message: formatMessage((0, $9RttA.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});


parcelRegister("krQQZ", function(module, exports) {

$parcel$export(module.exports, "ReporterInlineEditViewWithIsEditable", () => $fb2bd4b71c691326$export$f3ca6190158a888f);
$parcel$export(module.exports, "ReporterInlineEditView", () => $fb2bd4b71c691326$export$981d7f2f0ffb0beb);

var $fcqIi = parcelRequire("fcqIi");

var $4IsaQ = parcelRequire("4IsaQ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $iZVkR = parcelRequire("iZVkR");


var $9qZqK = parcelRequire("9qZqK");
const $fb2bd4b71c691326$export$f3ca6190158a888f = ({ fragmentRef: fragmentRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $4IsaQ.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditViewWithIsEditable), {
        ...props,
        fragmentRef: data,
        noneOptionLabel: formatMessage((0, $9qZqK.default).anonymous),
        profileCardAction: (0, $6d22448f78a7f25a$export$6b36f20db7a18a86)
    });
};
const $fb2bd4b71c691326$export$981d7f2f0ffb0beb = ({ fragmentRef: fragmentRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $fcqIi.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditView), {
        ...props,
        fragmentRef: data,
        noneOptionLabel: formatMessage((0, $9qZqK.default).anonymous),
        profileCardAction: (0, $6d22448f78a7f25a$export$6b36f20db7a18a86)
    });
};

});
parcelRegister("fcqIi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8616de44b9538b35$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e444162d4db31fe2d8cf9ce3d49c500a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8616de44b9538b35$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditView_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$8616de44b9538b35$var$node.hash = "bd02fa384b206ea57830ba99674f24b9";
var $8616de44b9538b35$export$2e2bcd8739ae039 = $8616de44b9538b35$var$node;

});

parcelRegister("4IsaQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $75f182f97b30c803$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb86f10febd7873bf5fcf89f85958c48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $75f182f97b30c803$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$75f182f97b30c803$var$node.hash = "75550b2f1743d8a0b6176f6ded3b5c91";
var $75f182f97b30c803$export$2e2bcd8739ae039 = $75f182f97b30c803$var$node;

});

parcelRegister("iZVkR", function(module, exports) {

$parcel$export(module.exports, "SingleUserPickerInlineEditViewWithIsEditable", () => $18a4c20873122153$export$c143582b21f1a708);
$parcel$export(module.exports, "SingleUserPickerInlineEditView", () => $18a4c20873122153$export$f182346570197b8);

var $7cnPn = parcelRequire("7cnPn");

var $3Xx7G = parcelRequire("3Xx7G");

var $9LSxy = parcelRequire("9LSxy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $41wNq = parcelRequire("41wNq");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $fsoQR = parcelRequire("fsoQR");

var $1LCPi = parcelRequire("1LCPi");

var $22FmW = parcelRequire("22FmW");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $3vB7G = parcelRequire("3vB7G");

var $iqAIM = parcelRequire("iqAIM");
const $18a4c20873122153$var$isEqualUser = (a, b)=>a?.id === b?.id;
const $18a4c20873122153$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-single-user-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $18a4c20873122153$export$c143582b21f1a708 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onCancel: onCancel, onEdit: onEdit, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, noneOptionLabel: noneOptionLabel, profileCardAction: profileCardAction, portalElement: portalElement, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $9LSxy.default), fragmentRef);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, user: user, fieldConfig: fieldConfig } = data;
    const isFieldRequired = (0, $eJOHy.useMemo)(()=>fieldConfig?.isRequired ?? false, [
        fieldConfig?.isRequired
    ]);
    const fieldName = (0, $eJOHy.useMemo)(()=>overriding.overrideLabel(name), [
        name,
        overriding
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(isEditable), [
        isEditable,
        overriding
    ]);
    const [commit] = (0, $j4oe4.useMutation)((0, $3Xx7G.default));
    const initialValue = user ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((newUser, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newUser);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newUser?.id ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSingleSelectUserPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateSingleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            user: newUser ? {
                                id: newUser.id,
                                accountId: newUser.accountId,
                                accountStatus: newUser.accountStatus,
                                name: newUser.name,
                                picture: newUser.picture,
                                __typename: 'AtlassianAccountUser'
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        uniqueFieldId,
        onSubmit
    ]);
    const validator = (0, $iqAIM.useSingleUserPickerValidator)(fieldName, isFieldRequired);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $18a4c20873122153$var$isEqualUser,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        validator: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? validator : undefined,
        clipboardComponentType: 'singleUser'
    });
    // #region Read view
    const finalNoneOptionLabel = noneOptionLabel ?? formatMessage((0, $3vB7G.default).noneOption);
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($18a4c20873122153$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fsoQR.SingleUserPickerWithProfileCardReadView), {
            fragmentRef: data,
            emptyUserLabel: finalNoneOptionLabel,
            profileCardAction: profileCardAction,
            shouldRenderHoverPopover: shouldRenderHoverPopover,
            fieldId: fieldId
        })), [
        data,
        finalNoneOptionLabel,
        profileCardAction,
        shouldRenderHoverPopover,
        fieldId
    ]);
    // #endregion
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            autoFocus: true,
            value: updatedValue ? (0, $22FmW.transformAggToUserOption)(updatedValue) : null,
            onChange: handleChangeAndConfirm,
            onClear: ()=>handleChangeAndConfirm(null),
            spacing: spacing,
            noneOptionLabel: finalNoneOptionLabel,
            includeNoneOption: !isFieldRequired,
            isClearable: !isFieldRequired,
            menuPosition: menuPosition,
            portalElement: portalElement,
            ariaLabel: fieldName,
            isInvalid: (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? !!invalidMessage : undefined
        });
    const editButtonLabel = formatMessage((0, $41wNq.default).extendedEditButtonLabel, {
        inputFieldValue: initialValue?.name ?? finalNoneOptionLabel,
        fieldName: fieldName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPoint: (0, $1LCPi.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readView: renderReadView,
        hideActionButtons: true,
        editButtonLabel: editButtonLabel,
        readViewFitContainerHeight: readViewFitContainerHeight,
        disableReadViewAppearanceOnHoverOnly: fieldId === 'reporter'
    });
};
const $18a4c20873122153$export$f182346570197b8 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $7cnPn.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($18a4c20873122153$export$c143582b21f1a708, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("7cnPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7157192006c857f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ece559cc75651d75622d9b47e5f4a4ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7157192006c857f6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$7157192006c857f6$var$node.hash = "d6afe351b35e0beb2951194f3010ad16";
var $7157192006c857f6$export$2e2bcd8739ae039 = $7157192006c857f6$var$node;

});

parcelRegister("3Xx7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ea5cd096fec5cac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08007f396db418a9d13cbce15739952a>>
 * @relayHash b249572b29f7cf45d6d7890c57510aed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8768a3b7a61167cb3f57c1ea183973ef7e13af793cc24d86f169fda9c41a20dd
const $9ea5cd096fec5cac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8768a3b7a61167cb3f57c1ea183973ef7e13af793cc24d86f169fda9c41a20dd",
            "metadata": {},
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9ea5cd096fec5cac$var$node.hash = "bd06a0600bf6d9530e408c77f4b2739a";
var $9ea5cd096fec5cac$export$2e2bcd8739ae039 = $9ea5cd096fec5cac$var$node;

});

parcelRegister("9LSxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a0c510e0ae74d8b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<13beec71928bfcdc44a62173d9c393a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6a0c510e0ae74d8b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$6a0c510e0ae74d8b$var$node.hash = "aebeab1812e893081e79766395b9288b";
var $6a0c510e0ae74d8b$export$2e2bcd8739ae039 = $6a0c510e0ae74d8b$var$node;

});

parcelRegister("1LCPi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a534d5cb9d0b17f$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $2a534d5cb9d0b17f$var$SingleUserPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8Sp6w")), {
        moduleId: "9f05df27",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $2a534d5cb9d0b17f$export$2e2bcd8739ae039 = $2a534d5cb9d0b17f$var$SingleUserPickerEditViewEntryPoint;

});
parcelRegister("8Sp6w", function(module, exports) {

let $6766d708ffe0a375$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6766d708ffe0a375$var$load("9PLvk").then(()=>parcelRequire('hlQGS'));

});


parcelRegister("3vB7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e730141fc6dc9ec$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3e730141fc6dc9ec$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noneOption: {
        "id": "issue-field-single-user-picker-inline-edit-full.single-user-picker.none-option",
        "defaultMessage": "None"
    },
    requiredErrorMessage: {
        "id": "issue-field-single-user-picker-inline-edit-full.single-user-picker.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});

});

parcelRegister("iqAIM", function(module, exports) {

$parcel$export(module.exports, "useSingleUserPickerValidator", () => $b59aeb64ee7301b0$export$fb9026d1d46dfabe);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $3vB7G = parcelRequire("3vB7G");
const $b59aeb64ee7301b0$export$fb9026d1d46dfabe = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && value === null) return {
            type: 'error',
            message: formatMessage((0, $3vB7G.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});


parcelRegister("9qZqK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b148334e47965f96$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b148334e47965f96$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    anonymous: {
        "id": "issue-field-reporter-inline-edit-full.reporter.anonymous",
        "defaultMessage": "Anonymous"
    }
});

});


parcelRegister("25lAa", function(module, exports) {

$parcel$export(module.exports, "ConditionalWrapper", () => $4a804811753d7d96$export$39aecc95f0365819);

var $eJOHy = parcelRequire("eJOHy");
const $4a804811753d7d96$export$39aecc95f0365819 = ({ children: children, condition: condition, renderWrapper: renderWrapper })=>condition ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);

});

parcelRegister("jpLGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cd21ab76f02e18a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5cd21ab76f02e18a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    unassigned: {
        "id": "native-issue-table.common.issue-cells.user.unassigned",
        "defaultMessage": "Unassigned"
    },
    anonymous: {
        "id": "native-issue-table.common.issue-cells.user.anonymous",
        "defaultMessage": "Anonymous"
    }
});

});


parcelRegister("iYWyN", function(module, exports) {

$parcel$export(module.exports, "VersionsCell", () => $ad776cd12687a1af$export$77526ce3d3d3b8ba);

var $3v6mS = parcelRequire("3v6mS");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $lRq8t = parcelRequire("lRq8t");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $P01So = parcelRequire("P01So");

var $86BUM = parcelRequire("86BUM");

var $816rS = parcelRequire("816rS");
/**
 * Expected JQL Output: `project = ${projectKey} AND ${jqlTerm} = ${name}`
 */ const $ad776cd12687a1af$var$getLinkJql = (projectKey, jqlTerm, name)=>{
    const jast = (0, $f26C8.default).jast((0, $f26C8.default).query((0, $f26C8.default).compoundClause((0, $f26C8.default).compoundOperator((0, $f6415dda43b7f459$export$6d6d48d210d3ca97)), [
        (0, $f26C8.default).terminalClause((0, $f26C8.default).field('project'), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand(projectKey)),
        (0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $P01So.escapeBackslashes)(jqlTerm)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand((0, $P01So.escapeBackslashes)(name)))
    ])));
    return (0, $1jiqw.print)(jast, {
        operatorCase: 'upper'
    });
};
const $ad776cd12687a1af$export$77526ce3d3d3b8ba = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, projectKey: projectKey, jqlTerm: jqlTerm })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { name: fieldName, selectedVersionsConnection: selectedVersionsConnection } = (0, $j4oe4.useFragment)((0, $3v6mS.default), fieldRef);
    const versions = selectedVersionsConnection?.edges;
    const filteredVersions = (0, $eJOHy.useMemo)(()=>versions?.map((edge)=>edge?.node?.name != null ? {
                key: edge.node.name,
                name: edge.node.name,
                href: `${issueSearchBaseUrl}?jql=${encodeURIComponent($ad776cd12687a1af$var$getLinkJql(projectKey, jqlTerm, edge.node.name))}`
            } : null).filter((0, $P01So.isNonNullish)) ?? [], [
        versions,
        issueSearchBaseUrl,
        projectKey,
        jqlTerm
    ]);
    if (!versions || versions.length !== filteredVersions.length || !projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "versions",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: filteredVersions,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $816rS.default).triggerButtonGeneric, {
            fieldName: fieldName
        })
    });
});

});
parcelRegister("3v6mS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba2488db8472b54b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6f6ee0189b5f6db6af7efd8ebc406adf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba2488db8472b54b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "versions_nativeIssueTable_VersionsCell",
        "selections": [
            v0 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    };
}();
$ba2488db8472b54b$var$node.hash = "d633c7e45438df5a321f477c661de24c";
var $ba2488db8472b54b$export$2e2bcd8739ae039 = $ba2488db8472b54b$var$node;

});

parcelRegister("816rS", function(module, exports) {

$parcel$export(module.exports, "default", () => $709bf05c4c6b6f0d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $709bf05c4c6b6f0d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    triggerButtonGeneric: {
        "id": "native-issue-table.common.issue-cells.versions.trigger-button-generic",
        "defaultMessage": "See more versions for \u2018{fieldName}\u2018"
    }
});

});


parcelRegister("6O6q1", function(module, exports) {

$parcel$export(module.exports, "CommentSummaryCell", () => $bf3ccf785294da47$export$ec9db7e6afbd918a);

var $1dOXl = parcelRequire("1dOXl");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $gDKBr = parcelRequire("gDKBr");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $jiTA8 = parcelRequire("jiTA8");

var $7jTnu = parcelRequire("7jTnu");

var $34oCh = parcelRequire("34oCh");

var $bFwiO = parcelRequire("bFwiO");
const $bf3ccf785294da47$export$ec9db7e6afbd918a = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueKey: issueKey, onIssueLinkSelected: onIssueLinkSelected })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isEmbedMode = (0, $7jTnu.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jiTA8.useIsEmbedMode)() : false;
    const data = (0, $j4oe4.useFragment)((0, $1dOXl.default), fieldRef);
    const canAddComment = data?.commentSummary?.canAddComment;
    const totalCount = data?.commentSummary?.totalCount;
    const renderedCommentCount = (0, $eJOHy.useMemo)(()=>{
        // No comments, add comment
        if (!totalCount) return formatMessage((0, $bFwiO.default).addComment);
        // Less than 100 comments, show count
        if (totalCount < 100) return formatMessage((0, $bFwiO.default).commentsCount, {
            commentCount: totalCount
        });
        // More than 99 comments, show 99+
        return formatMessage((0, $bFwiO.default).moreComments);
    }, [
        formatMessage,
        totalCount
    ]);
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey, true);
        if (handled) e.preventDefault();
    }, [
        isEmbedMode,
        issueKey,
        onIssueLinkSelected
    ]);
    const hoverPopoverEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (!totalCount && !canAddComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        href: `/browse/${issueKey}`,
        xcss: [
            $bf3ccf785294da47$var$buttonStyles,
            !totalCount && $bf3ccf785294da47$var$emptyStyles
        ],
        onClick: handleClick,
        backgroundColor: "color.background.neutral.subtle",
        paddingInline: "space.075",
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
        color: "currentColor",
        label: formatMessage((0, $bFwiO.default).comments)
    }), hoverPopoverEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        maxLines: 1
    }, renderedCommentCount) : renderedCommentCount);
});
const $bf3ccf785294da47$var$buttonStyles = (0, $1DXK0.xcss)({
    color: 'color.text',
    borderRadius: 'border.radius',
    borderWidth: 'border.width.outline',
    borderStyle: 'solid',
    // borderColor doesn't allow transparent as a value so we use inline/block which has looser typing
    borderInlineColor: 'transparent',
    borderBlockColor: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minHeight: '100%',
    maxWidth: '100%',
    textDecoration: 'none',
    ':focus': {
        borderInlineColor: 'color.border.focused',
        borderBlockColor: 'color.border.focused',
        outline: 0,
        color: 'color.text',
        textDecoration: 'none'
    },
    ':focus-visible': {
        borderInlineColor: 'color.border.focused',
        borderBlockColor: 'color.border.focused',
        outline: 0
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text',
        textDecoration: 'none'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $bf3ccf785294da47$var$emptyStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    ':focus': {
        color: 'color.text.subtlest'
    },
    ':hover': {
        color: 'color.text.subtlest'
    }
});

});
parcelRegister("1dOXl", function(module, exports) {

$parcel$export(module.exports, "default", () => $84e863ec95af7b2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9cc54fc88782605eb9ffbd21f6adfd8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $84e863ec95af7b2d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "commentSummary_nativeIssueTable_CommentSummaryCell",
    "selections": [
        {
            "concreteType": "JiraCommentSummary",
            "kind": "LinkedField",
            "name": "commentSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canAddComment"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ]
        }
    ],
    "type": "JiraCommentSummaryField"
};
$84e863ec95af7b2d$var$node.hash = "91bb4bde7c95d88894f72343be5f8adf";
var $84e863ec95af7b2d$export$2e2bcd8739ae039 = $84e863ec95af7b2d$var$node;

});

parcelRegister("gDKBr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1d470387d991694$var$_react = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c1d470387d991694$var$_baseNew = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c1d470387d991694$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1d470387d991694$var$CommentIcon = (props)=>/*#__PURE__*/ $c1d470387d991694$var$_react.default.createElement($c1d470387d991694$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$c1d470387d991694$var$CommentIcon.displayName = 'CommentIcon';
var $c1d470387d991694$var$_default = module.exports.default = $c1d470387d991694$var$CommentIcon;

});

parcelRegister("bFwiO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9772c4bb281d361c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9772c4bb281d361c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    comments: {
        "id": "business-list.list-view.comments-cell.comments",
        "defaultMessage": "Comments"
    },
    commentsCount: {
        "id": "business-list.list-view.comments-cell.comments-count",
        "defaultMessage": "{commentCount, plural, one {# comment} other {# comments}}"
    },
    moreComments: {
        "id": "business-list.list-view.comments-cell.more-comments",
        "defaultMessage": "99+ comments"
    },
    addComment: {
        "id": "business-list.list-view.comments-cell.add-comment",
        "defaultMessage": "Add comment"
    }
});

});


parcelRegister("hL4Y9", function(module, exports) {

$parcel$export(module.exports, "UrlCell", () => $522c1198f4985b6f$export$110272e30ac53e5);

var $o2fdg = parcelRequire("o2fdg");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $57mJt = parcelRequire("57mJt");

var $7jTnu = parcelRequire("7jTnu");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $522c1198f4985b6f$export$110272e30ac53e5 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $o2fdg.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $57mJt.UrlInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: isFirstField ? $522c1198f4985b6f$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSimpleInlineSmartLinkEnabled: true,
        shouldRenderHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $57mJt.UrlInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSimpleInlineSmartLinkEnabled: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $522c1198f4985b6f$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $522c1198f4985b6f$var$customTargetStyles,
        ref: ref
    });
});
const $522c1198f4985b6f$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("o2fdg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4afb994c748c741$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64289f346ee2a0194a0429d6fc081742>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a4afb994c748c741$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "url_nativeIssueTable_UrlCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraUrlField"
};
$a4afb994c748c741$var$node.hash = "290582e90638b9296d772bdb0ec42416";
var $a4afb994c748c741$export$2e2bcd8739ae039 = $a4afb994c748c741$var$node;

});

parcelRegister("57mJt", function(module, exports) {

$parcel$export(module.exports, "UrlInlineEditViewIsEditable", () => $d5b0aa8cf071a4d2$export$b805891365234836);
$parcel$export(module.exports, "UrlInlineEditView", () => $d5b0aa8cf071a4d2$export$9c96a1eab7a0bc87);

var $7LGV4 = parcelRequire("7LGV4");

var $2bvy9 = parcelRequire("2bvy9");

var $5xql6 = parcelRequire("5xql6");

var $9wwul = parcelRequire("9wwul");

var $1oXsO = parcelRequire("1oXsO");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $auNLL = parcelRequire("auNLL");

var $daGbj = parcelRequire("daGbj");

var $2sEmv = parcelRequire("2sEmv");

var $77rtG = parcelRequire("77rtG");

var $1yqND = parcelRequire("1yqND");

var $gCeeo = parcelRequire("gCeeo");

var $bJscI = parcelRequire("bJscI");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $16sa1 = parcelRequire("16sa1");

var $6GBsJ = parcelRequire("6GBsJ");

var $entKp = parcelRequire("entKp");
const $d5b0aa8cf071a4d2$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-url-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $d5b0aa8cf071a4d2$export$21e755188d829de2 = ({ fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, readViewFitContainerWidth: readViewFitContainerWidth = true, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, onUpdate: onUpdate, onUpdateFailed: onUpdateFailed })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $1oXsO.default), fragmentRef);
    const { id: uniqueFieldId, uri: uri, fieldConfig: fieldConfig, name: name, fieldId: fieldId, type: type } = data;
    const [commit] = (0, $j4oe4.useMutation)((0, $9wwul.default)); // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const editFieldRef = (0, $eJOHy.useRef)(null);
    const [isEditing, setIsEditing] = (0, $eJOHy.useState)(startWithEditViewOpen);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(uri || '');
    const [errors, setErrors] = (0, $eJOHy.useState)(null);
    const [invalidMessage, setInvalidMessage] = (0, $eJOHy.useState)(null);
    const [showValidationMessage, setShowValidationMessage] = (0, $eJOHy.useState)(false);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(fieldConfig?.isEditable || false), [
        fieldConfig,
        overriding
    ]);
    const analyticsData = (0, $eJOHy.useMemo)(()=>({
            fieldKey: fieldId,
            fieldType: type
        }), [
        fieldId,
        type
    ]); // #endregion
    // #region Handle new value
    const save = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        /**
     * This will execute the GraphQl mutation.
     */ commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        uri: updatedValue || '',
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateUrlField) {
                    const { success: success, errors: responseErrors } = mutationData.jira?.updateUrlField;
                    if (success) {
                        onUpdate?.(updatedValue || ''); // Field updated event is a core action used to track MCU as defined in https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition
                        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'field updated', analyticsData);
                        return;
                    }
                    setErrors(responseErrors);
                } else setErrors([]);
                setIsEditing(true);
            },
            onError (error) {
                setErrors([
                    {
                        message: error.message
                    }
                ]);
                onUpdateFailed?.(updatedValue || '');
                setIsEditing(true);
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateUrlField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            uri: updatedValue,
                            fieldConfig: {
                                isEditable: true
                            }
                        }
                    }
                }
            }
        });
        setIsEditing(false);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
    }, [
        commit,
        uniqueFieldId,
        updatedValue,
        onUpdate,
        onUpdateFailed,
        analyticsData,
        createAnalyticsEvent
    ]);
    // #endregion
    // #region Common callbacks
    const cancel = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        setErrors(null);
        setIsEditing(false); // @ts-expect-error - Argument of type 'string | null | undefined' is not assignable to parameter of type 'SetStateAction<string | null>'.
        setUpdatedValue(uri);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
    }, [
        setErrors,
        uri
    ]);
    const onCancelRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        setShowValidationMessage(false);
        setInvalidMessage(null);
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        onCancel,
        cancel
    ]);
    const onConfirmRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        if (invalidMessage) {
            setShowValidationMessage(true);
            editFieldRef.current?.focus();
        } else {
            save(analyticsEvent);
            onConfirm && onConfirm(analyticsEvent, updatedValue);
        }
    }, [
        onConfirm,
        save,
        invalidMessage,
        editFieldRef,
        updatedValue
    ]);
    const onEditRequested = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit
    ]);
    const onEscapeRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        setShowValidationMessage(false);
        setInvalidMessage(null);
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const onEnterRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        onEnter && onEnter(analyticsEvent);
    }, [
        onEnter
    ]);
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        setShowValidationMessage(false);
        let { validationMessage: validationMessage } = event.target;
        const typedValue = event.target.value === '' ? null : event.target.value;
        if (!(0, $entKp.isAllowed)(typedValue)) validationMessage = formatMessage((0, $6GBsJ.default).validUrl);
        setInvalidMessage(validationMessage);
        setErrors(null);
        setUpdatedValue(typedValue);
    }, [
        setErrors,
        setUpdatedValue,
        formatMessage
    ]); // #endregion
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5b0aa8cf071a4d2$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5b0aa8cf071a4d2$var$ReadViewContainer, {
            "data-testid": "issue-field-url-inline-edit-full.ui.url.read-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1yqND.UrlReadView), {
            fragmentRef: data
        }))); // #endregion
    // #region Edit view
    const renderEditView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5b0aa8cf071a4d2$var$EditViewContainer, {
            "data-testid": "issue-field-url-inline-edit-full.ui.url.edit-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sEmv.SingleLineTextEditView), {
            ariaLabel: name,
            autoFocus: true,
            type: "url",
            ref: editFieldRef,
            value: updatedValue,
            onChange: onChange,
            invalidMessage: (0, $entKp.validationForErrors)(showValidationMessage, invalidMessage, // @ts-expect-error - Argument of type 'readonly { readonly message: string | null | undefined; }[] | null | undefined' is not assignable to parameter of type 'typeOfErrors | undefined'.
            errors)
        }))); // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5b0aa8cf071a4d2$var$InlineEditContainer, {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $daGbj.FieldInlineEditStateLess), {
        editView: renderEditView,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        isLabelHidden: true,
        readView: renderReadView,
        readViewFitContainerWidth: readViewFitContainerWidth,
        testId: "issue-field-url-inline-edit-full.ui.url.field-inline-edit-state-less",
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequested,
        onEnter: onEnterRequest,
        onEscape: onEscapeRequest,
        defaultValue: updatedValue,
        fieldId: fieldId
    }));
};
const $d5b0aa8cf071a4d2$export$b805891365234836 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, spacing: spacing = 'compact', readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $5xql6.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $2bvy9.default));
    const { id: uniqueFieldId, name: name, fieldId: fieldId, type: fieldType } = data; // #endregion Relay
    // #region State
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const uri = data.uri ?? '';
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(uri);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]); // #endregion State
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        uri: value
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateUrlField?.success) onSuccess();
                else onFail();
            },
            onError: (error)=>{
                onFail(error, error.message);
            },
            optimisticResponse: {
                jira: {
                    updateUrlField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            fieldId: fieldId,
                            type: fieldType,
                            name: name,
                            uri: value
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldType,
        name,
        onSubmit,
        uniqueFieldId
    ]);
    const validator = (0, $eJOHy.useMemo)(()=>{
        const change = (value)=>{
            if (!(0, $entKp.isAllowed)(value)) return {
                type: 'error',
                message: formatMessage((0, $6GBsJ.default).validUrl)
            };
            return null;
        };
        return {
            change: change
        };
    }, [
        formatMessage
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: uri,
        updatedValue: updatedValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        validator: validator,
        clipboardComponentType: 'url'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    const onChange = (0, $eJOHy.useCallback)(({ target: target })=>{
        handleChange(target.value);
    }, [
        handleChange
    ]); // #endregion Action
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5b0aa8cf071a4d2$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1yqND.UrlReadView), {
            fragmentRef: data,
            isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        isSimpleInlineSmartLinkEnabled,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            value: updatedValue,
            spacing: spacing,
            onChange: onChange,
            type: 'url',
            isInvalid: Boolean(invalidMessage),
            ariaLabel: fieldName
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $77rtG.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $d5b0aa8cf071a4d2$export$80ddb9ab68316fce = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $7LGV4.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5b0aa8cf071a4d2$export$b805891365234836, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $d5b0aa8cf071a4d2$export$9c96a1eab7a0bc87 = (0, $bJscI.componentWithFG)('jsc_inline_editing_field_refactor', $d5b0aa8cf071a4d2$export$80ddb9ab68316fce, $d5b0aa8cf071a4d2$export$21e755188d829de2); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5b0aa8cf071a4d2$var$EditViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pbyowjs _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5b0aa8cf071a4d2$var$ReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _1nmz1hna _kqswh2mm _vwz4gktf _19bv12x7 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $d5b0aa8cf071a4d2$var$nonEditableStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5b0aa8cf071a4d2$var$InlineEditContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _1gzc1txw _auuz1h6o _6vgs1osq _1rjezwfg",
            !__cmplp.isEditable && "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _1nmz1hna _kqswh2mm _vwz4gktf _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7LGV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2569523dfe9f7620$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac98cf9c096d64b8daeafe340a7af26a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2569523dfe9f7620$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewNew_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraUrlField"
};
$2569523dfe9f7620$var$node.hash = "e70af483ddd145941defdd9bbeb62107";
var $2569523dfe9f7620$export$2e2bcd8739ae039 = $2569523dfe9f7620$var$node;

});

parcelRegister("2bvy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dcc9349bce2e9d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39d6dfc2c61bbe8cb97eaeb503e73368>>
 * @relayHash e108106da2ecb8aa09d6fc8be81174ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d1efbe817720920b786ed0017bee97537993851d55447dd1127c35704766448e

var $dTrc4 = parcelRequire("dTrc4");
const $0dcc9349bce2e9d4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uri"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d1efbe817720920b786ed0017bee97537993851d55447dd1127c35704766448e",
            "metadata": {},
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default)
            }
        }
    };
}();
$0dcc9349bce2e9d4$var$node.hash = "60222c1fb24270ee0c27b8d3bfc763a4";
var $0dcc9349bce2e9d4$export$2e2bcd8739ae039 = $0dcc9349bce2e9d4$var$node;

});

parcelRegister("5xql6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f3c02e703621646$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63b14e199759744cdf583eb0c109846a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2f3c02e703621646$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "uri"
        },
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlReadviewFull_UrlReadView"
        }
    ],
    "type": "JiraUrlField"
};
$2f3c02e703621646$var$node.hash = "f560c76a2ba024cc2bd7b741c47d14d9";
var $2f3c02e703621646$export$2e2bcd8739ae039 = $2f3c02e703621646$var$node;

});

parcelRegister("9wwul", function(module, exports) {

$parcel$export(module.exports, "default", () => $3976b9cafd4a6c57$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<73ec3cf2a23e6034af09ec91846ed549>>
 * @relayHash b4dabb14357e1f9fe05cde387943f475
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 02d2e5e95c919368918247a89d009f10568032c33c27d0f9b032e102181a6da9

var $dTrc4 = parcelRequire("dTrc4");
const $3976b9cafd4a6c57$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "url_issueFieldUrl_UrlField_OldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewOld_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "url_issueFieldUrl_UrlField_OldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uri"
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "02d2e5e95c919368918247a89d009f10568032c33c27d0f9b032e102181a6da9",
            "metadata": {},
            "name": "url_issueFieldUrl_UrlField_OldMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default)
            }
        }
    };
}();
$3976b9cafd4a6c57$var$node.hash = "b908881d73f71a207c8e4cb38dc9a8b3";
var $3976b9cafd4a6c57$export$2e2bcd8739ae039 = $3976b9cafd4a6c57$var$node;

});

parcelRegister("1oXsO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f98f1047d9e232d9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2b9b556714e043c134344fab947d26bf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f98f1047d9e232d9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewOld_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "uri"
        },
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlReadviewFull_UrlReadView"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraUrlField"
};
$f98f1047d9e232d9$var$node.hash = "29215cce3863b3be49bd2b2a229e3ca5";
var $f98f1047d9e232d9$export$2e2bcd8739ae039 = $f98f1047d9e232d9$var$node;

});

parcelRegister("2sEmv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "SingleLineTextEditView", () => $8cf09677831d805a$export$c561aa75a6a0d51b);
$parcel$export(module.exports, "default", () => $8cf09677831d805a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fKXve = parcelRequire("fKXve");

var $jkYbX = parcelRequire("jkYbX");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $kLTzW = parcelRequire("kLTzW");

var $sY9BV = parcelRequire("sY9BV");

var $jd93d = parcelRequire("jd93d");

var $7jTnu = parcelRequire("7jTnu");
const $8cf09677831d805a$var$SingleLineTextField = (props, ref)=>{
    const { spacing: spacing, type: type = 'text', value: value = '', placeholder: placeholder = '', invalidMessage: invalidMessage = null, onChange: onChange, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, inputId: inputId, 'aria-describedby': ariaDescribedby, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    const typeTracingRef = (0, $kLTzW.default)('single-line-text-field-type-tracing');
    const fieldRef = (0, $jd93d.default)(ref, typeTracingRef);
    const displayValue = value === null ? '' : value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        "aria-describedby": (0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? ariaDescribedby : undefined,
        type: type,
        value: displayValue,
        placeholder: placeholder,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        isInvalid: !!invalidMessage || isInvalid,
        autoFocus: autoFocus,
        ref: fieldRef,
        isCompact: spacing === 'compact',
        isDisabled: isDisabled,
        id: inputId,
        elemAfterInput: !!invalidMessage === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8cf09677831d805a$var$warningWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            color: "var(--ds-icon-warning, #E56910)",
            label: ""
        })) : null,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    }), invalidMessage !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, invalidMessage) : null);
};
$8cf09677831d805a$var$SingleLineTextField.displayName = 'SingleLineTextField';
const $8cf09677831d805a$export$c561aa75a6a0d51b = /*#__PURE__*/ (0, $eJOHy.forwardRef)($8cf09677831d805a$var$SingleLineTextField);
const $8cf09677831d805a$var$SingleLineTextEditViewEntryPoint = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8cf09677831d805a$export$c561aa75a6a0d51b, props);
var $8cf09677831d805a$export$2e2bcd8739ae039 = $8cf09677831d805a$var$SingleLineTextEditViewEntryPoint;
const $8cf09677831d805a$var$warningWrapperStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.050'
});

});
parcelRegister("kLTzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0f46da885f6423f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jbhXM = parcelRequire("jbhXM");

var $aXKmr = parcelRequire("aXKmr");

var $2oAAJ = parcelRequire("2oAAJ");

var $jcIvM = parcelRequire("jcIvM");

var $2QO3b = parcelRequire("2QO3b");
const $e0f46da885f6423f$var$getTypingMetadata = (times, computeStartTime, typingPerformanceTracingMethod)=>{
    let min = 0;
    let max = 0;
    let avg = 0;
    let index = 0;
    let below50count = 0;
    times.forEach((time)=>{
        if (time !== 0) {
            avg = (avg * index + time) / ++index;
            if (time > max) max = time;
            if (min === 0 || time < min) min = time;
            if (time < 50) below50count++;
        }
    });
    return {
        typing: {
            min: min,
            max: max,
            avg: avg,
            count: index,
            below50count: below50count,
            compute: performance.now() - computeStartTime,
            typeTracingMethod: typingPerformanceTracingMethod
        }
    };
};
function $e0f46da885f6423f$var$typingPerformanceTracingTimeout(element, name, rate) {
    let tsubmit;
    let times = [];
    let isInteractionInitialised = false;
    let id;
    const start = ()=>{
        id = (0, $aXKmr.v4)();
        (0, $2QO3b.addNewInteraction)(id, name, 'typing', performance.now(), rate, null, null);
        isInteractionInitialised = true;
    };
    const end = ()=>{
        isInteractionInitialised = false;
        const timesCopy = times;
        times = [];
        (0, $jbhXM.unstable_scheduleCallback)((0, $jbhXM.unstable_IdlePriority), ()=>{
            const computeStartTime = performance.now();
            const data = $e0f46da885f6423f$var$getTypingMetadata(timesCopy, computeStartTime, 'timeout');
            (0, $2QO3b.addMetadata)(id, data);
            (0, $2QO3b.tryComplete)(id);
        });
    };
    const onKeyPressHandler = (event)=>{
        if (!isInteractionInitialised) start();
        const startTime = event.timeStamp;
        setTimeout(()=>{
            const endTime = performance.now();
            const time = endTime - startTime;
            times.push(time);
            clearTimeout(tsubmit);
            tsubmit = setTimeout(end, 2000); // debounce
        }, 0);
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    element.addEventListener('keypress', onKeyPressHandler);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.removeEventListener('keypress', onKeyPressHandler);
    };
}
function $e0f46da885f6423f$var$typingPerformanceTracingTimeoutNoAlloc(element, name, rate) {
    let tsubmit;
    let isInteractionInitialised = false;
    let min = 0;
    let max = 0;
    let below50count = 0;
    let avg = 0;
    let count = 0;
    let id;
    const resetStats = ()=>{
        min = 0;
        max = 0;
        below50count = 0;
        avg = 0;
        count = 0;
    };
    const start = ()=>{
        id = (0, $aXKmr.v4)();
        (0, $2QO3b.addNewInteraction)(id, name, 'typing', performance.now(), rate, null, null);
        isInteractionInitialised = true;
    };
    const end = ()=>{
        isInteractionInitialised = false;
        const typingMetaData = {
            typing: {
                min: min,
                max: max,
                avg: avg,
                count: count,
                below50count: below50count,
                typeTracingMethod: 'timeoutNoAlloc'
            }
        };
        resetStats();
        (0, $jbhXM.unstable_scheduleCallback)((0, $jbhXM.unstable_IdlePriority), ()=>{
            (0, $2QO3b.addMetadata)(id, typingMetaData);
            (0, $2QO3b.tryComplete)(id);
        });
    };
    const onKeyPressHandler = (event)=>{
        if (!isInteractionInitialised) start();
        const startTime = event.timeStamp;
        setTimeout(()=>{
            const endTime = performance.now();
            const time = endTime - startTime;
            if (time !== 0) {
                avg = (avg * count + time) / ++count;
                if (time > max) max = time;
                if (min === 0 || time < min) min = time;
                if (time < 50) below50count++;
            }
            clearTimeout(tsubmit);
            tsubmit = setTimeout(end, 2000); // debounce
        }, 0);
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    element.addEventListener('keypress', onKeyPressHandler);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.removeEventListener('keypress', onKeyPressHandler);
    };
}
function $e0f46da885f6423f$var$typingPerformanceTracingMutationObserver(element, name, rate) {
    let eventTime = -1;
    let isInteractionInitialised = false;
    let count = 0;
    let id;
    let tsubmit;
    const keyLimit = 20;
    const times = new Float64Array(keyLimit);
    const resetTimesArray = ()=>{
        times.fill(0);
    };
    const resetEventTime = ()=>{
        eventTime = -1;
    };
    const start = ()=>{
        id = (0, $aXKmr.v4)();
        (0, $2QO3b.addNewInteraction)(id, name, 'typing', performance.now(), rate, null, null);
        isInteractionInitialised = true;
    };
    const end = ()=>{
        isInteractionInitialised = false;
        if (count === 0) return;
        const timesCopy = new Float64Array(times);
        const countCopy = count;
        resetTimesArray();
        resetEventTime();
        count = 0;
        (0, $jbhXM.unstable_scheduleCallback)((0, $jbhXM.unstable_IdlePriority), ()=>{
            const computeStartTime = performance.now();
            const timesSubarray = timesCopy.subarray(0, countCopy);
            const data = $e0f46da885f6423f$var$getTypingMetadata(timesSubarray, computeStartTime, 'mutationObserver');
            (0, $2QO3b.addMetadata)(id, data);
            (0, $2QO3b.tryComplete)(id);
        });
    };
    const onKeyPressHandler = (event)=>{
        if (!isInteractionInitialised) start();
        eventTime = event.timeStamp;
        setTimeout(()=>{
            clearTimeout(tsubmit);
            tsubmit = setTimeout(end, 2000); // debounce
        }, 0);
    };
    const mo = new MutationObserver((events)=>{
        const moTime = performance.now();
        if (eventTime === -1) return;
        if (count > keyLimit - 1) {
            end();
            return;
        }
        const startTime = eventTime;
        resetEventTime();
        events.forEach(()=>{
            requestAnimationFrame((firstFrameTime)=>{
                if (firstFrameTime < moTime) requestAnimationFrame((secondFrameTime)=>{
                    times[count] = secondFrameTime - startTime;
                    count++;
                });
                else {
                    times[count] = firstFrameTime - startTime;
                    count++;
                }
            });
        });
    });
    mo.observe(element, {
        attributeFilter: [
            'value'
        ],
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    element.addEventListener('keypress', onKeyPressHandler);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.removeEventListener('keypress', onKeyPressHandler);
        mo.disconnect();
    };
}
const $e0f46da885f6423f$var$typingPerformanceTracingMethods = {
    timeout: $e0f46da885f6423f$var$typingPerformanceTracingTimeout,
    timeoutNoAlloc: $e0f46da885f6423f$var$typingPerformanceTracingTimeoutNoAlloc,
    mutationObserver: $e0f46da885f6423f$var$typingPerformanceTracingMutationObserver
};
function $e0f46da885f6423f$export$2e2bcd8739ae039(name) {
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const rate = (0, $jcIvM.getInteractionRate)(name, 'typing');
        if ((0, $2oAAJ.default)(rate) && ref.current != null) {
            const method = (0, $jcIvM.getTypingPerformanceTracingMethod)();
            return $e0f46da885f6423f$var$typingPerformanceTracingMethods[method](ref.current, name, rate);
        }
    }, [
        name
    ]);
    return ref;
}

});


parcelRegister("1yqND", function(module, exports) {

$parcel$export(module.exports, "UrlReadView", () => $d24b7315cb4e95ba$export$7e9a6aefd9dafa88);

var $g95Vy = parcelRequire("g95Vy");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $d9T1A = parcelRequire("d9T1A");

var $8u0ho = parcelRequire("8u0ho");

var $gg9AF = parcelRequire("gg9AF");

var $7jTnu = parcelRequire("7jTnu");

var $3PRLs = parcelRequire("3PRLs");

var $9Mapt = parcelRequire("9Mapt");

var $jd93d = parcelRequire("jd93d");

var $3OT15 = parcelRequire("3OT15");

var $8fZi6 = parcelRequire("8fZi6");
// eslint-disable-next-line no-script-url
const $d24b7315cb4e95ba$var$forbiddenScheme = 'javascript:';
const $d24b7315cb4e95ba$export$7e9a6aefd9dafa88 = ({ fragmentRef: fragmentRef, isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $g95Vy.default), fragmentRef);
    const { uri: value } = data;
    const [isUrlErrorState, setIsUrlErrorState] = (0, $eJOHy.useState)(false);
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldRenderHoverPopover && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: value
    });
    const handleSmartLinkError = ()=>{
        setIsUrlErrorState(true);
    };
    const handleHoverOut = ()=>{
        setIsUrlErrorState(false);
    };
    if (value == null || value === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isSimpleInlineSmartLinkEnabled && (0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) {
        if (value.startsWith($d24b7315cb4e95ba$var$forbiddenScheme)) {
            if (shouldRenderHoverPopover) return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                maxLines: 1,
                ref: hoverPopoverRef
            }, value) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: value,
                contentRef: contentRef,
                onHoverOut: handleHoverOut
            }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                    maxLines: 1,
                    ref: (0, $jd93d.mergeRefs)(ref, contentRef)
                }, value));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $d24b7315cb4e95ba$var$truncatedStyles,
                ref: contentRef
            }, value);
        }
        let renderContent = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
                anchorTarget: "_blank",
                url: (0, $gg9AF.default)(value, '//'),
                anchorRef: ref,
                onError: shouldRenderHoverPopover ? handleSmartLinkError : undefined
            });
        if ((0, $8u0ho.default)(value)) renderContent = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
                anchorTarget: "_blank",
                url: `mailto:${value}`,
                text: value,
                anchorRef: ref,
                onError: shouldRenderHoverPopover ? handleSmartLinkError : undefined
            });
        if (shouldRenderHoverPopover && isUrlErrorState) return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator') ? renderContent(hoverPopoverRef) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: value,
            contentRef: contentRef,
            onHoverOut: handleHoverOut
        }, ({ ref: ref })=>renderContent((0, $jd93d.mergeRefs)(ref, contentRef)));
        return renderContent(undefined);
    }
    const lDisplayValue = (0, $8fZi6.formatReadValue)(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d24b7315cb4e95ba$var$Ellipsis, {
        title: value
    }, lDisplayValue);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d24b7315cb4e95ba$var$Ellipsis = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $d24b7315cb4e95ba$var$truncatedStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("g95Vy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2dc4b6c6c15dfc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<66c234f1abe6edf2bf28156d9c9c5522>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ee2dc4b6c6c15dfc$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "url_issueFieldUrlReadviewFull_UrlReadView",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "uri"
        }
    ],
    "type": "JiraUrlField"
};
$ee2dc4b6c6c15dfc$var$node.hash = "fdbb3125f2c4058bcc235ec607d8d838";
var $ee2dc4b6c6c15dfc$export$2e2bcd8739ae039 = $ee2dc4b6c6c15dfc$var$node;

});

parcelRegister("8u0ho", function(module, exports) {

$parcel$export(module.exports, "default", () => $43ed002d88857729$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
var $43ed002d88857729$export$2e2bcd8739ae039 = (string)=>{
    if (!string || typeof string !== 'string') return false;
    return /\S+@\S+/.test(string);
};

});

parcelRegister("gg9AF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa271c6a6316ebe8$export$2e2bcd8739ae039);

var $eNS8S = parcelRequire("eNS8S");
/**
 * Absolute URL regex
 */ const $fa271c6a6316ebe8$var$AbsoluteURLRegex = new RegExp(/^[a-z][a-z\d+.-]*:/);
var /**
 * Prefix url if it is url, return what we got if not
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$fa271c6a6316ebe8$export$2e2bcd8739ae039 = (string, prefix)=>{
    // The same line is in isUrl, but flow requires it here too
    if (typeof string !== 'string' || !prefix) return string;
    // Exit early
    if (!(0, $eNS8S.default)(string)) return string;
    // Double slash urls are absolute too, relative to the schema used in current window
    if (string.substring(0, 2) === '//') return string;
    // If it's an absolute URL, return it, no need to prefix
    if ($fa271c6a6316ebe8$var$AbsoluteURLRegex.test(string)) return string;
    // If it's a relative URL, prefix it with prefix
    return prefix + string;
};

});

parcelRegister("8fZi6", function(module, exports) {

$parcel$export(module.exports, "formatReadValue", () => $b989a4aaa09f3a35$export$7ff86f9bff10df25);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $7jTnu = parcelRequire("7jTnu");

var $8u0ho = parcelRequire("8u0ho");

var $gg9AF = parcelRequire("gg9AF");

var $epTsa = parcelRequire("epTsa");

var $ix81O = parcelRequire("ix81O");
// eslint-disable-next-line no-script-url
const $b989a4aaa09f3a35$var$forbiddenScheme = 'javascript:';
const $b989a4aaa09f3a35$export$7ff86f9bff10df25 = (value)=>{
    if (value.toString().startsWith($b989a4aaa09f3a35$var$forbiddenScheme)) return value;
    if ((0, $8u0ho.default)(value)) {
        if ((0, $epTsa.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix81O.LazySingleLineSmartLink), {
            anchorTarget: "_blank",
            url: `mailto:${value}`,
            text: value,
            fieldType: "url"
        });
        return (0, $7jTnu.fg)('replace-anchor-with-link__issue-view---kenji') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: `mailto:${value}`
        }, value) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
            href: `mailto:${value}`
        }, value);
    }
    if ((0, $epTsa.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix81O.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: (0, $gg9AF.default)(value, '//'),
        fieldType: "url"
    });
    return (0, $7jTnu.fg)('replace-anchor-with-link__issue-view---kenji') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: (0, $gg9AF.default)(value, '//'),
        target: "_blank"
    }, value) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        href: (0, $gg9AF.default)(value, '//'),
        target: "_blank"
    }, value);
};

});
parcelRegister("ix81O", function(module, exports) {

$parcel$export(module.exports, "LazySingleLineSmartLink", () => $77b5c4612dd0593c$export$80092fcb07ccc4b4);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $8kVp5 = parcelRequire("8kVp5");
const $77b5c4612dd0593c$var$entryPointParams = {};
const $77b5c4612dd0593c$export$80092fcb07ccc4b4 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $8kVp5.SingleLineSmartLinkEntryPoint), $77b5c4612dd0593c$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.issue-field.single-line-smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("8kVp5", function(module, exports) {

$parcel$export(module.exports, "SingleLineSmartLinkEntryPoint", () => $9db257858ff44ec9$export$e236c9b35543c8d);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $9db257858ff44ec9$export$e236c9b35543c8d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("Qf6EI")).then((module)=>module.SingleLineSmartLink), {
        moduleId: "97818dc4",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("Qf6EI", function(module, exports) {

let $09d0933ff6557453$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $09d0933ff6557453$var$load("fliVL"),
    $09d0933ff6557453$var$load("lxHfr")
]).then(()=>parcelRequire('cNXTd'));

});





parcelRegister("6GBsJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $479b929ad3b0e6bc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $479b929ad3b0e6bc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    validUrl: {
        "id": "issue-field-url-inline-edit-full.url.valid-url",
        "defaultMessage": "Please enter a valid URL."
    }
});

});

parcelRegister("entKp", function(module, exports) {

$parcel$export(module.exports, "validationForErrors", () => $ba8c953f4fc4bb00$export$cedaf0b5bc412527);
$parcel$export(module.exports, "isAllowed", () => $ba8c953f4fc4bb00$export$f023ae853add2e3e);

var $eNS8S = parcelRequire("eNS8S");
const $ba8c953f4fc4bb00$export$cedaf0b5bc412527 = (showValidationMessage, invalidMessage, errors)=>{
    if (showValidationMessage) return invalidMessage;
    if (errors && errors.length) return errors[0].message;
    return null;
};
const $ba8c953f4fc4bb00$export$5c13dfcb31dfce7a = 'javascript:';
const $ba8c953f4fc4bb00$export$f023ae853add2e3e = (value)=>{
    if (value === '' || value === null) return true;
    if ((0, $eNS8S.default)(value)) return true;
    if (!value.startsWith($ba8c953f4fc4bb00$export$5c13dfcb31dfce7a)) return true;
    return false;
};

});



parcelRegister("emEZF", function(module, exports) {

$parcel$export(module.exports, "MultiVersionPickerCell", () => $5a153a8137dfc34f$export$5ca120a08ed26914);

var $hFr8b = parcelRequire("hFr8b");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $MUcBt = parcelRequire("MUcBt");

var $7jTnu = parcelRequire("7jTnu");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $5a153a8137dfc34f$export$5ca120a08ed26914 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $hFr8b.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MUcBt.MultiVersionPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: isFirstField ? $5a153a8137dfc34f$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MUcBt.MultiVersionPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $5a153a8137dfc34f$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5a153a8137dfc34f$var$customTargetStyles,
        ref: ref
    });
});
const $5a153a8137dfc34f$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("hFr8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a67f06279a4bea7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a83f7b6a3bf3a91c61f7514ba09b83a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1a67f06279a4bea7$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "multiVersionPicker_nativeIssueTable_MultiVersionPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$1a67f06279a4bea7$var$node.hash = "bac54c5febc57f9040c4badd289dba78";
var $1a67f06279a4bea7$export$2e2bcd8739ae039 = $1a67f06279a4bea7$var$node;

});

parcelRegister("MUcBt", function(module, exports) {

$parcel$export(module.exports, "MultiVersionPickerInlineEditViewWithIsEditable", () => $1d553014db36a9f7$export$f431495591c5e674);

var $8wM8I = parcelRequire("8wM8I");

var $40YZ2 = parcelRequire("40YZ2");

var $90IpJ = parcelRequire("90IpJ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $16sa1 = parcelRequire("16sa1");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $dzwt3 = parcelRequire("dzwt3");

var $lI4O9 = parcelRequire("lI4O9");

var $auNLL = parcelRequire("auNLL");

var $bJscI = parcelRequire("bJscI");
const $1d553014db36a9f7$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-multi-version-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $1d553014db36a9f7$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $1d553014db36a9f7$export$f431495591c5e674 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $90IpJ.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $40YZ2.default));
    const { id: uniqueFieldId, name: name, selectedVersionsConnection: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                id: edge?.node?.value ?? '',
                optionId: edge?.node?.versionId ?? '',
                value: edge?.node?.label ?? '',
                selectableLabel: edge?.node?.label ?? '',
                selectableGroupKey: null,
                selectableIconUrl: null
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleVersionPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleVersionPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedVersionsConnection: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.id ?? '',
                                            name: edge.selectableLabel ?? '',
                                            label: edge.selectableLabel ?? '',
                                            value: edge.id ?? '',
                                            versionId: edge.optionId ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $1d553014db36a9f7$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiVersionSelect'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d553014db36a9f7$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lI4O9.MultiVersionPickerReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        })), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $dzwt3.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $1d553014db36a9f7$export$39b0857e7fc9fc58 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $8wM8I.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d553014db36a9f7$export$f431495591c5e674, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("8wM8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b0d5bfb68c5a165$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2bc41e79d78b8f6ab7ab8377a87047ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8b0d5bfb68c5a165$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$8b0d5bfb68c5a165$var$node.hash = "f3cd0ae179a2d6df739a19203f713cf5";
var $8b0d5bfb68c5a165$export$2e2bcd8739ae039 = $8b0d5bfb68c5a165$var$node;

});

parcelRegister("40YZ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f165013c1955f2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8342c4e836b7ec8b7c2b0ddfa6134252>>
 * @relayHash d19489d06d268f2aa2afd983864117f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 221728ae5b3c6aa07ca8d90d92a49ae0c66a238ebcf155f78b4ee1fc1d21e007
const $0f165013c1955f2d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleVersionPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleVersionPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleVersionPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleVersionPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleVersionPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleVersionPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraVersionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedVersionsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "221728ae5b3c6aa07ca8d90d92a49ae0c66a238ebcf155f78b4ee1fc1d21e007",
            "metadata": {},
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0f165013c1955f2d$var$node.hash = "c18481704920c57572e95641cfc0676b";
var $0f165013c1955f2d$export$2e2bcd8739ae039 = $0f165013c1955f2d$var$node;

});

parcelRegister("90IpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $014b7e1963761a50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64112bc4a30b3469275bdfcb6eadd44c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $014b7e1963761a50$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "selectedVersionsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraVersion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "value",
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "alias": "label",
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "versionId"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedVersionsConnection(first:1000)"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$014b7e1963761a50$var$node.hash = "f3af5be7640f993ae73c44b61cc0fcb5";
var $014b7e1963761a50$export$2e2bcd8739ae039 = $014b7e1963761a50$var$node;

});

parcelRegister("dzwt3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87a6dba00e0e973$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $d87a6dba00e0e973$var$MultiVersionPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("9O4DG")), {
        moduleId: "e516a23c",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $d87a6dba00e0e973$export$2e2bcd8739ae039 = $d87a6dba00e0e973$var$MultiVersionPickerEditViewEntryPoint;

});
parcelRegister("9O4DG", function(module, exports) {

let $723c61cc77598f41$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $723c61cc77598f41$var$load("1ppIg").then(()=>parcelRequire('83cMO'));

});


parcelRegister("lI4O9", function(module, exports) {

$parcel$export(module.exports, "MultiVersionPickerReadView", () => $d8943f78bceb81f0$export$555d899a217b3354);

var $cZu1Q = parcelRequire("cZu1Q");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $1z178 = parcelRequire("1z178");
const $d8943f78bceb81f0$export$555d899a217b3354 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $cZu1Q.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedOptions = data?.selectedVersionsConnection?.edges?.filter((edge)=>Boolean(edge?.node?.name)).map((edge)=>({
            name: edge?.node?.name || '',
            key: edge?.node?.id || ''
        })) || [];
    if (!selectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: isTruncatedWithHoverPopover && $d8943f78bceb81f0$var$containerWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: selectedOptions,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $1z178.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d8943f78bceb81f0$var$containerWithNegativeMarginOffset
    }, selectedOptions.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
            key: item.key,
            text: item.name
        })));
};
const $d8943f78bceb81f0$var$containerWithNegativeMarginOffset = (0, $1DXK0.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $d8943f78bceb81f0$var$containerWidthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("cZu1Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $22dfda99a3914cb7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c210e8b6e67913f30c2d1a9eedbd636>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $22dfda99a3914cb7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "selectedVersionsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraVersion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedVersionsConnection(first:1000)"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$22dfda99a3914cb7$var$node.hash = "7940aec048cb5cd7c9f0feb1ad306f48";
var $22dfda99a3914cb7$export$2e2bcd8739ae039 = $22dfda99a3914cb7$var$node;

});

parcelRegister("1z178", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d340ee67f462666$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0d340ee67f462666$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-version-picker-readview-full.multi-version-picker.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});

});




parcelRegister("jT7JX", function(module, exports) {

$parcel$export(module.exports, "useHideDoneItems", () => $ceb2e86724727d09$export$c2cb7b17819b92d4);

var $eJOHy = parcelRequire("eJOHy");

var $dLXgn = parcelRequire("dLXgn");

var $iN7UY = parcelRequire("iN7UY");

var $34oCh = parcelRequire("34oCh");

var $57Nys = parcelRequire("57Nys");
// For status update with hide done it will always be a single work item that is removed
const $ceb2e86724727d09$var$NET_CHANGE_ISSUE_COUNT = -1;
function $ceb2e86724727d09$export$c2cb7b17819b92d4({ groupConnectionId: groupConnectionId, itemsConnectionId: itemsConnectionId, recordId: recordId, projectKey: projectKey }) {
    const isHideDoneEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const getConnectionDetails = (0, $eJOHy.useCallback)(()=>Object.values(connections).find((connection)=>{
            return connection.connectionId === itemsConnectionId;
        }), [
        connections,
        itemsConnectionId
    ]);
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    const removeConnection = (0, $eJOHy.useCallback)(({ store: store, remainingIssueCount: remainingIssueCount })=>{
        const connectionDetails = getConnectionDetails();
        if (!connectionDetails) return;
        updateConnectionDetails({
            store: store,
            connection: connectionDetails,
            remainingIssueCount: remainingIssueCount,
            netChangeInIssueCount: $ceb2e86724727d09$var$NET_CHANGE_ISSUE_COUNT,
            groupConnectionId: groupConnectionId,
            projectKey: projectKey
        });
    }, [
        getConnectionDetails,
        groupConnectionId,
        projectKey,
        updateConnectionDetails
    ]);
    const handler = (0, $iN7UY.useHandleStatusUpdate)(itemsConnectionId, recordId, removeConnection, {
        isHideDoneEnabled: isHideDoneEnabled
    });
    return handler;
}

});
parcelRegister("iN7UY", function(module, exports) {

$parcel$export(module.exports, "useHandleStatusUpdate", () => $b0dddbd9500361a0$export$9b67a4661b4d570a);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");


var $fRHdC = parcelRequire("fRHdC");

var $3bmN3 = parcelRequire("3bmN3");
const $b0dddbd9500361a0$var$DEFAULT_OPTIONS = {
    isHideDoneEnabled: false
};
function $b0dddbd9500361a0$export$9b67a4661b4d570a(itemsConnectionId, recordId, removeConnection, options = $b0dddbd9500361a0$var$DEFAULT_OPTIONS) {
    const updater = (0, $fRHdC.useDeleteRecord)(itemsConnectionId, recordId, removeConnection);
    const handler = (0, $3bmN3.useCommitLocalUpdate)(updater, options);
    return (0, $eJOHy.useCallback)((field)=>{
        try {
            handler(field);
        } catch (error) {
            if (error instanceof Error) (0, $gYnSx.default)({
                meta: {
                    id: 'issue-table-hide-done-status-update',
                    packageName: (0, $54713f11448e89c8$export$b8b9d90f9e5bd72b),
                    teamName: (0, $54713f11448e89c8$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    }, [
        handler
    ]);
}

});
const $54713f11448e89c8$export$b8b9d90f9e5bd72b = 'jiraIssueTableHideDoneToggle';
const $54713f11448e89c8$export$d57b6b390e78d90f = 'keystone';
const $54713f11448e89c8$export$6a7d6ab86cfdfcdc = 'hideDoneToggle';
const $54713f11448e89c8$export$f7109619a5e9e0d6 = 'jira-native-issue-table';

parcelRegister("fRHdC", function(module, exports) {

$parcel$export(module.exports, "useDeleteRecord", () => $5aaaec4fac311dfb$export$4495a148dad9d147);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
function $5aaaec4fac311dfb$export$4495a148dad9d147(itemsConnectionId, recordId, removeConnection) {
    return (0, $eJOHy.useCallback)((store)=>{
        $5aaaec4fac311dfb$var$assert(itemsConnectionId, 'itemsConnectionId');
        $5aaaec4fac311dfb$var$assert(recordId, 'recordId');
        const connectionRecord = store.get(itemsConnectionId);
        if (!connectionRecord) return;
        (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, recordId);
        removeConnection({
            store: store,
            remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length ?? 0
        });
    }, [
        itemsConnectionId,
        recordId,
        removeConnection
    ]);
}
function $5aaaec4fac311dfb$var$assertString(value, paramName) {
    if (typeof value !== 'string') throw new Error(`${paramName} must be a string`);
}
function $5aaaec4fac311dfb$var$assertNotEmpty(value, paramName) {
    if (value.trim().length === 0) throw new Error(`${paramName} must not be an empty string`);
}
function $5aaaec4fac311dfb$var$assert(value, paramName) {
    $5aaaec4fac311dfb$var$assertString(value, paramName);
    $5aaaec4fac311dfb$var$assertNotEmpty(value, paramName);
}

});

parcelRegister("3bmN3", function(module, exports) {

$parcel$export(module.exports, "useCommitLocalUpdate", () => $c3e4ffd5f883a42d$export$f0d146dc82ca0c9c);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7keuM = parcelRequire("7keuM");
function $c3e4ffd5f883a42d$export$f0d146dc82ca0c9c(updater, { isHideDoneEnabled: isHideDoneEnabled }) {
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((field)=>{
        if (!isHideDoneEnabled) return;
        if ((0, $7keuM.statusCategoryForId)(field.statusCategory?.statusCategoryId) !== (0, $7keuM.DONE)) return;
        (0, $j4oe4.commitLocalUpdate)(environment, updater);
    }, [
        environment,
        isHideDoneEnabled,
        updater
    ]);
}

});



parcelRegister("3vVaS", function(module, exports) {

$parcel$export(module.exports, "MultiGroupPickerCell", () => $7b65cce317c0282d$export$73d843f1843865aa);

var $5ybDM = parcelRequire("5ybDM");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $20P47 = parcelRequire("20P47");

var $7jTnu = parcelRequire("7jTnu");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $7b65cce317c0282d$export$73d843f1843865aa = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $5ybDM.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    const fieldId = typeof data.id === 'string' ? data.id : '';
    (0, $eqbO4.useLazyLoadEditability)(fieldId, isEditable);
    // In edit mode, use the MultiGroupPickerEditView
    if (hasDuplicates && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $20P47.MultiGroupPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: isFirstField ? $7b65cce317c0282d$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $20P47.MultiGroupPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $7b65cce317c0282d$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7b65cce317c0282d$var$customTargetStyles,
        ref: ref
    });
});
const $7b65cce317c0282d$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("5ybDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f439ffa6d85a8663$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<806abff1e975947b3de40cefa8a41b7b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f439ffa6d85a8663$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "multiGroupPicker_nativeIssueTable_MultiGroupPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$f439ffa6d85a8663$var$node.hash = "7c440756aab477bb66df5feaffeda0d0";
var $f439ffa6d85a8663$export$2e2bcd8739ae039 = $f439ffa6d85a8663$var$node;

});

parcelRegister("20P47", function(module, exports) {

$parcel$export(module.exports, "MultiGroupPickerInlineEditViewWithIsEditable", () => $41255fd266381b8b$export$7acb84464848fc0e);

var $1mWD4 = parcelRequire("1mWD4");

var $5MpJH = parcelRequire("5MpJH");

var $fkKi0 = parcelRequire("fkKi0");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $auNLL = parcelRequire("auNLL");

var $g9mk1 = parcelRequire("g9mk1");

var $jW4Yt = parcelRequire("jW4Yt");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $41255fd266381b8b$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $41255fd266381b8b$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-field-multi-group-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $41255fd266381b8b$export$7acb84464848fc0e = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $fkKi0.default), fragmentRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $5MpJH.default));
    // #endregion Relay
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedGroupsConnection: selectedGroupsConnection, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedGroupsConnection?.edges) return null;
        return selectedGroupsConnection.edges.map((edge)=>({
                id: edge?.node?.id ?? '',
                groupId: edge?.node?.groupId ?? '',
                name: edge?.node?.name ?? '',
                type: 'group'
            }));
    }, [
        selectedGroupsConnection?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $eJOHy.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleGroupPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleGroupPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedGroupsConnection: {
                                edges: values?.map((selection)=>({
                                        node: {
                                            id: selection.id,
                                            groupId: selection.groupId ?? '',
                                            name: selection.name
                                        }
                                    }))
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $41255fd266381b8b$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiGroupPicker'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41255fd266381b8b$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jW4Yt.MultiGroupPickerReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        })), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            value: updatedValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            filterOptionsById: filterOptionsById,
            isMulti: true
        });
    // #endregion Edit view
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $g9mk1.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $41255fd266381b8b$export$4caaf52d4af1250c = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $1mWD4.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41255fd266381b8b$export$7acb84464848fc0e, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("1mWD4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c78f0df18697b45$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d5623bc30488e88f1d3982f57e69c5eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8c78f0df18697b45$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$8c78f0df18697b45$var$node.hash = "2b6dc2f7fb34ef75b6db441fb9ae7810";
var $8c78f0df18697b45$export$2e2bcd8739ae039 = $8c78f0df18697b45$var$node;

});

parcelRegister("5MpJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $146fd6e8d16c8b52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02595abe4be4750a238e67d255544203>>
 * @relayHash cf7363cfea249c0b2da1cf11c7c42d39
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6ffaa25a287e76c421668cfe52d8e9f94b8ae3c13144e889b27b520dc510540
const $146fd6e8d16c8b52$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleGroupPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleGroupPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleGroupPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleGroupPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleGroupPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleGroupPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraGroupConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedGroupsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "groupId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e6ffaa25a287e76c421668cfe52d8e9f94b8ae3c13144e889b27b520dc510540",
            "metadata": {},
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$146fd6e8d16c8b52$var$node.hash = "23b63517ce9fe10047fcdf0eced5f652";
var $146fd6e8d16c8b52$export$2e2bcd8739ae039 = $146fd6e8d16c8b52$var$node;

});

parcelRegister("fkKi0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e0d416752510825$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ab669355cea1b866d173b253a3cfa88>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6e0d416752510825$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView"
            },
            {
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "selectedGroupsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "groupId"
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleGroupPickerField"
    };
}();
$6e0d416752510825$var$node.hash = "8432d03e246ec4da1c38b93c6858f003";
var $6e0d416752510825$export$2e2bcd8739ae039 = $6e0d416752510825$var$node;

});

parcelRegister("g9mk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d7b6bc74037ca57$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $4d7b6bc74037ca57$var$MultiSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hdNHP")), {
        moduleId: "5031be7a",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $4d7b6bc74037ca57$export$2e2bcd8739ae039 = $4d7b6bc74037ca57$var$MultiSelectEditViewEntryPoint;

});
parcelRegister("hdNHP", function(module, exports) {

let $c89a351ae5908748$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c89a351ae5908748$var$load("rFPjj").then(()=>parcelRequire('juA5l'));

});


parcelRegister("jW4Yt", function(module, exports) {

$parcel$export(module.exports, "MultiGroupPickerReadView", () => $f48eaf993afb193e$export$247ad3b7069fda16);

var $bnjRi = parcelRequire("bnjRi");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $kp5kj = parcelRequire("kp5kj");

var $1tX0c = parcelRequire("1tX0c");

var $2j0d2 = parcelRequire("2j0d2");

var $9HfjG = parcelRequire("9HfjG");
const $f48eaf993afb193e$export$247ad3b7069fda16 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $bnjRi.default), fragmentRef);
    const transformedSelectedOptions = (0, $eJOHy.useMemo)(()=>{
        if (!data?.selectedGroupsConnection?.edges) return null;
        const selectedOptions = data.selectedGroupsConnection.edges.map((edge)=>edge?.node).filter((node)=>!!node);
        return selectedOptions.map((node)=>({
                key: node.id,
                name: node.name,
                color: null,
                isInteractive: false
            }));
    }, [
        data?.selectedGroupsConnection?.edges
    ]);
    if (!transformedSelectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        role: "group",
        xcss: isTruncatedWithHoverPopover && $f48eaf993afb193e$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: transformedSelectedOptions,
        ItemComponent: isTruncatedWithHoverPopover ? (0, $1tX0c.TagItem) : (0, $kp5kj.OptionTag),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $9HfjG.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        role: "group",
        shouldWrap: true
    }, transformedSelectedOptions.map(({ key: key, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            key: key,
            ...restProps
        })));
};
const $f48eaf993afb193e$var$inlineStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("bnjRi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aea312b73b1a9b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5e4a0b4f914cbdbb0312a353542384d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5aea312b73b1a9b9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView",
    "selections": [
        {
            "concreteType": "JiraGroupConnection",
            "kind": "LinkedField",
            "name": "selectedGroupsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$5aea312b73b1a9b9$var$node.hash = "e7a12645b4d832047ab02c9f7b91d410";
var $5aea312b73b1a9b9$export$2e2bcd8739ae039 = $5aea312b73b1a9b9$var$node;

});

parcelRegister("9HfjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b04cc2321b0b85f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0b04cc2321b0b85f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-group-picker-readview-full.multi-group-picker.compact.show-more-tooltip",
        "defaultMessage": "See more selected options"
    }
});

});




parcelRegister("e5umc", function(module, exports) {

$parcel$export(module.exports, "TimelineCellRenderer", () => $34227da35caf49e0$export$ad6d59b978eafde7);

var $aLmum = parcelRequire("aLmum");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $6sUnz = parcelRequire("6sUnz");
const $34227da35caf49e0$export$ad6d59b978eafde7 = ({ depth: depth, groupId: groupId, fieldRef: fieldRef })=>{
    let customComponents = null;
    if ((0, $7jTnu.fg)('jira_native_issue_table_extra_custom_components')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    customComponents = (0, $6sUnz.useCustomComponents)();
    const data = (0, $j4oe4.useFragment)((0, $aLmum.default), fieldRef);
    return customComponents?.timeline?.Cell && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(customComponents.timeline.Cell, {
        depth: depth,
        groupId: groupId,
        fieldRef: data
    });
};

});
parcelRegister("aLmum", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c6a19c26e8d1b7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<132a67cd6a06ea0e8adbf0d8d07f6603>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $19c6a19c26e8d1b7$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "timeline_nativeIssueTable_TimelineCellRenderer",
    "selections": [
        {
            "condition": "isTimelineEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "timelineCell_issueTableTimelineUI_fieldRef"
                }
            ]
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$19c6a19c26e8d1b7$var$node.hash = "58d6df845c25bcf17f57eb5a180fe335";
var $19c6a19c26e8d1b7$export$2e2bcd8739ae039 = $19c6a19c26e8d1b7$var$node;

});


parcelRegister("40qcF", function(module, exports) {

$parcel$export(module.exports, "WatchersCell", () => $79f82f5ffbb38e6d$export$1e71e15ea9d46d5d);

var $LinB7 = parcelRequire("LinB7");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8IeH1 = parcelRequire("8IeH1");
const $79f82f5ffbb38e6d$var$styles = {
    watchesCell: "_1reo15vq _18m915vq _1rjc1b66 _p12f1osq _1bto1l2s"
};
const $79f82f5ffbb38e6d$export$1e71e15ea9d46d5d = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $LinB7.default), fieldRef);
    const countValue = (0, $eJOHy.useMemo)(()=>{
        return data?.watch?.count;
    }, [
        data?.watch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $79f82f5ffbb38e6d$var$styles.watchesCell
    }, countValue);
});

});
parcelRegister("LinB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd1980c2fa517462$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b670cfd7835ce6be141562df87eac6e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bd1980c2fa517462$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "watches_nativeIssueTable_WatchersCell",
    "selections": [
        {
            "concreteType": "JiraWatch",
            "kind": "LinkedField",
            "name": "watch",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "isWatching"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "JiraWatchesField"
};
$bd1980c2fa517462$var$node.hash = "093300cbc4b204e418f3c45d4c9b42cb";
var $bd1980c2fa517462$export$2e2bcd8739ae039 = $bd1980c2fa517462$var$node;

});


parcelRegister("eQ4s7", function(module, exports) {

$parcel$export(module.exports, "LinkRelationshipTypeCell", () => $fc41630e2bb842e4$export$d9d4a0e66ee82c3f);

var $bbFaG = parcelRequire("bbFaG");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5WzNk = parcelRequire("5WzNk");

var $auNLL = parcelRequire("auNLL");

var $eqbO4 = parcelRequire("eqbO4");
const $fc41630e2bb842e4$export$d9d4a0e66ee82c3f = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueKey: issueKey, onIssueUnlink: onIssueUnlink, issueStoreId: issueStoreId, itemsConnectionId: itemsConnectionId })=>{
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const data = (0, $j4oe4.useFragment)((0, $bbFaG.default), fieldRef);
    const baseIsEditable = 'isEditableInIssueView' in data ? data.isEditableInIssueView : undefined;
    (0, $eqbO4.useLazyLoadEditability)(data.id, baseIsEditable);
    const isEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(Boolean(baseIsEditable)), [
        baseIsEditable,
        overriding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5WzNk.LinkRelationshipInlineEditView), {
        fieldRef: data,
        issueKey: issueKey,
        isEditable: isEditable ?? false,
        issueStoreId: issueStoreId,
        itemsConnectionId: itemsConnectionId,
        onIssueUnlink: onIssueUnlink
    }));
});

});
parcelRegister("bbFaG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4459b474a4f4c1ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c95be55b16510ba604af75e2ef1db99>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4459b474a4f4c1ff$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditableInIssueView"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView"
        }
    ],
    "type": "JiraIssueLinkRelationshipTypeField"
};
$4459b474a4f4c1ff$var$node.hash = "4bb96af15bfeeb8439c2a314f25d54c7";
var $4459b474a4f4c1ff$export$2e2bcd8739ae039 = $4459b474a4f4c1ff$var$node;

});

parcelRegister("5WzNk", function(module, exports) {

$parcel$export(module.exports, "LinkRelationshipInlineEditView", () => $ed193198e4107b6f$export$cdf1201d8417a5e2);

var $bQB8a = parcelRequire("bQB8a");

var $gCG3p = parcelRequire("gCG3p");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $iCRih = parcelRequire("iCRih");

var $hi2yk = parcelRequire("hi2yk");

var $956it = parcelRequire("956it");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $d2AGn = parcelRequire("d2AGn");

var $4SjAP = parcelRequire("4SjAP");

var $2ZGUP = parcelRequire("2ZGUP");

var $lRq8t = parcelRequire("lRq8t");

var $1uIew = parcelRequire("1uIew");

var $gYnSx = parcelRequire("gYnSx");

var $ftN6c = parcelRequire("ftN6c");

var $8gALd = parcelRequire("8gALd");

var $jYDsp = parcelRequire("jYDsp");

var $gomlP = parcelRequire("gomlP");
const $ed193198e4107b6f$var$isEqualValue = (a, b)=>a?.id === b?.id;
const $ed193198e4107b6f$export$cdf1201d8417a5e2 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueKey: issueKey, onIssueUnlink: onIssueUnlink, issueStoreId: issueStoreId, itemsConnectionId: itemsConnectionId, isEditable: isEditable })=>{
    const [showUnlinkConfirmation, setShowUnlinkConfirmation] = (0, $eJOHy.useState)(false);
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const data = (0, $j4oe4.useFragment)((0, $gCG3p.default), fieldRef);
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        const issueLinkData = {
            issueLinkTypeARI: data?.issueLink?.type?.id ?? '',
            relationName: data?.issueLink?.relationName ?? '',
            direction: data?.issueLink?.direction ?? 'INWARD'
        };
        return (0, $8gALd.createSelectedOptionFromFieldData)(issueLinkData);
    }, [
        data?.issueLink
    ]);
    const [selectedOption, setSelectedOption] = (0, $eJOHy.useState)(initialValue);
    const [commit] = (0, $j4oe4.useMutation)((0, $bQB8a.default));
    const currentIssueFieldARI = data?.id || '';
    const currentIssueLinkARI = data?.issueLink?.id || '';
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        const nextDirection = option?.direction;
        const nextRelationName = option?.label;
        const nextIssueLinkTypeARI = option?.value;
        if (!nextIssueLinkTypeARI) {
            onFail(new Error('No issue link type id provided'));
            return;
        }
        commit({
            variables: {
                input: {
                    id: currentIssueFieldARI,
                    operation: {
                        operation: 'SET',
                        update: {
                            issueLinkId: currentIssueLinkARI,
                            issueLinkTypeId: nextIssueLinkTypeARI,
                            direction: nextDirection
                        }
                    }
                }
            },
            onCompleted: (mutationData)=>{
                const mutationResponse = mutationData.jira?.updateIssueLinkRelationshipTypeField;
                if (mutationResponse?.success) onSuccess();
                else {
                    const mutationError = mutationResponse?.errors?.[0];
                    const message = mutationError?.message ?? 'Failed to update issue link relationship type field';
                    const statusCode = mutationError?.extensions?.statusCode ?? 0;
                    if (statusCode >= 400 && statusCode < 500) onFail(new (0, $1uIew.ValidationError)(message, [], statusCode));
                    else onFail(new (0, $4SjAP.MutationError)(mutationError ?? {
                        message: message
                    }));
                }
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateIssueLinkRelationshipTypeField: {
                        success: true,
                        errors: null,
                        field: {
                            id: currentIssueFieldARI,
                            issueLink: {
                                id: currentIssueLinkARI,
                                direction: nextDirection,
                                relationName: nextRelationName,
                                type: {
                                    id: nextIssueLinkTypeARI
                                }
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        currentIssueFieldARI,
        currentIssueLinkARI
    ]);
    const fieldId = data.fieldId;
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, `${initialValue?.value}_${initialValue?.direction}`, `${value?.value}_${value?.direction}`);
    }, [
        fieldId,
        initialValue
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleEdit: handleEdit, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        fieldId: data.fieldId,
        fieldName: data.name,
        fieldType: data.type,
        initialValue: initialValue,
        updatedValue: selectedOption,
        isValueEqual: $ed193198e4107b6f$var$isEqualValue,
        clipboardComponentType: undefined,
        onSubmit: handleSubmit,
        onUpdateValue: setSelectedOption,
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    const handleUnlinkSuccess = (0, $eJOHy.useCallback)(()=>{
        showFlag({
            id: (0, $hrodw.toFlagId)('unlink-success'),
            type: 'success',
            messageId: 'issue-field-link-relationship-inline-edit-full.ui.show-flag.success.issue-cells.link-relationship-type.show-flag.success.unlink-success',
            messageType: 'transactional',
            title: formatMessage((0, $jYDsp.default).unlinkSuccessTitle),
            description: formatMessage((0, $jYDsp.default).unlinkSuccessDescription, {
                issueKey: issueKey
            }),
            isAutoDismiss: true
        });
        onIssueUnlink?.(issueKey);
    }, [
        issueKey,
        showFlag,
        formatMessage,
        onIssueUnlink
    ]);
    const handleUnlinkError = (0, $eJOHy.useCallback)((error)=>{
        showFlag({
            id: (0, $hrodw.toFlagId)('unlink-error'),
            type: 'error',
            messageId: 'issue-field-link-relationship-inline-edit-full.ui.show-flag.error.issue-cells.link-relationship-type.show-flag.error.unlink-error',
            messageType: 'transactional',
            title: formatMessage((0, $jYDsp.default).unlinkErrorTitle),
            description: formatMessage((0, $jYDsp.default).unlinkErrorDescription),
            isAutoDismiss: true
        });
        (0, $gYnSx.default)({
            meta: {
                id: 'unlink-error',
                packageName: 'jiraLinkRelationshipTypeUnlinkError',
                teamName: 'Tenet'
            },
            event: createAnalyticsEvent({}),
            error: error,
            attributes: {
                fieldName: data.name,
                issueKey: issueKey
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true
        });
    }, [
        showFlag,
        formatMessage,
        createAnalyticsEvent,
        data.name,
        issueKey
    ]);
    const handleUnlinkSubmit = (0, $eJOHy.useCallback)(()=>{
        setShowUnlinkConfirmation(false);
        commit({
            variables: {
                input: {
                    id: currentIssueFieldARI,
                    operation: {
                        operation: 'SET',
                        update: {
                            issueLinkId: currentIssueLinkARI,
                            issueLinkTypeId: null
                        }
                    }
                }
            },
            optimisticUpdater: (store)=>{
                // Optimistically remove the issue row from the table using ConnectionHandler
                // This follows the same pattern as the hide done functionality
                if (itemsConnectionId && issueStoreId) {
                    const connectionRecord = store.get(itemsConnectionId);
                    if (connectionRecord) (0, $j4oe4.ConnectionHandler).deleteNode(connectionRecord, issueStoreId);
                }
            },
            updater: (store)=>{
                // Ensure the row stays removed after the server response
                // This prevents the server response from re-adding the row
                if (itemsConnectionId && issueStoreId) {
                    const connectionRecord = store.get(itemsConnectionId);
                    if (connectionRecord) {
                        // Check if the node still exists in the connection
                        const edges = connectionRecord.getLinkedRecords('edges');
                        const nodeExists = edges?.some((edge)=>{
                            const node = edge?.getLinkedRecord('node');
                            return node?.getDataID() === issueStoreId;
                        });
                        // If the node was re-added by the server response, remove it again
                        if (nodeExists) (0, $j4oe4.ConnectionHandler).deleteNode(connectionRecord, issueStoreId);
                    }
                }
            },
            onCompleted: (mutationData)=>{
                const mutationResponse = mutationData?.jira?.updateIssueLinkRelationshipTypeField;
                if (mutationResponse?.success) handleUnlinkSuccess();
                else {
                    const mutationError = mutationResponse?.errors?.[0];
                    const message = mutationError?.message ?? 'Failed to unlink work item';
                    const statusCode = mutationError?.extensions?.statusCode ?? 0;
                    let error = new Error(message);
                    if (statusCode >= 400 && statusCode < 500) error = new (0, $1uIew.ValidationError)(message, [], statusCode);
                    handleUnlinkError(error);
                }
            },
            onError: handleUnlinkError
        });
    }, [
        commit,
        currentIssueFieldARI,
        currentIssueLinkARI,
        handleUnlinkSuccess,
        handleUnlinkError,
        issueStoreId,
        itemsConnectionId
    ]);
    const handleUnlinkCancel = (0, $eJOHy.useCallback)(()=>{
        setShowUnlinkConfirmation(false);
    }, []);
    const handleUnlink = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        handleCancel(analyticsEvent);
        setShowUnlinkConfirmation(true);
    }, [
        handleCancel
    ]);
    const getEditViewProps = (0, $eJOHy.useCallback)((fieldProps)=>({
            ...fieldProps,
            selectedOption: selectedOption,
            isDisabled: !isEditable,
            onChange: (value)=>{
                handleChangeAndConfirm(value);
            },
            onUnlink: handleUnlink
        }), [
        handleChangeAndConfirm,
        handleUnlink,
        isEditable,
        selectedOption
    ]);
    const readView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hi2yk.LinkRelationshipTypeReadView), {
            fieldRef: data
        }), [
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $iCRih.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: data.name,
        isEditable: isEditable,
        readView: readView,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        hasUnsubmittedChanges: hasServerValidationError,
        onEdit: handleEdit,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        readViewFitContainerHeight: true,
        hideActionButtons: true
    }), showUnlinkConfirmation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gomlP.default), {
        issueKey: issueKey,
        onUnlinkCancel: handleUnlinkCancel,
        onUnlinkSubmit: handleUnlinkSubmit
    }))));
});

});
parcelRegister("bQB8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $710b96e5f4d57926$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<817316d3edea076de7e2a29052259f89>>
 * @relayHash 7d884945e43cd762b79a25b956abcba1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b658d4873910d5690188b027f1f6dfa9f5b1a72e5b60a83978f900e51e0a7d29
const $710b96e5f4d57926$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "JiraIssueLinkRelationshipTypeField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "concreteType": "JiraIssueLink",
                "kind": "LinkedField",
                "name": "issueLink",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "direction"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "relationName"
                    },
                    {
                        "concreteType": "JiraIssueLinkType",
                        "kind": "LinkedField",
                        "name": "type",
                        "plural": false,
                        "selections": v7 /*: any*/ 
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateIssueLinkRelationshipTypeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueLinkRelationshipTypeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateIssueLinkRelationshipTypeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueLinkRelationshipTypeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v7 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b658d4873910d5690188b027f1f6dfa9f5b1a72e5b60a83978f900e51e0a7d29",
            "metadata": {},
            "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$710b96e5f4d57926$var$node.hash = "2f0a2d2138cd528cd40ded3dce91df75";
var $710b96e5f4d57926$export$2e2bcd8739ae039 = $710b96e5f4d57926$var$node;

});

parcelRegister("gCG3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2133bb320520a46$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<684a809e96981943759baaef3566491f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f2133bb320520a46$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraIssueLink",
                "kind": "LinkedField",
                "name": "issueLink",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "direction"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "relationName"
                    },
                    {
                        "concreteType": "JiraIssueLinkType",
                        "kind": "LinkedField",
                        "name": "type",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_JiraIssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView"
            }
        ],
        "type": "JiraIssueLinkRelationshipTypeField"
    };
}();
$f2133bb320520a46$var$node.hash = "ab55fe82c13f74f06fd5d284a97d55e1";
var $f2133bb320520a46$export$2e2bcd8739ae039 = $f2133bb320520a46$var$node;

});

parcelRegister("iCRih", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b0df9380b4d471a$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $0b0df9380b4d471a$var$RelationshipTypeEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("5qI9O")), {
        moduleId: "dd9f033e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $0b0df9380b4d471a$export$2e2bcd8739ae039 = $0b0df9380b4d471a$var$RelationshipTypeEditViewEntryPoint;

});
parcelRegister("5qI9O", function(module, exports) {

let $3f41a227e84866fc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3f41a227e84866fc$var$load("5Wleb").then(()=>parcelRequire('b7081'));

});


parcelRegister("hi2yk", function(module, exports) {

$parcel$export(module.exports, "LinkRelationshipTypeReadView", () => $c60daa2bf4da7ff9$export$2a5ee9588693f44d);

var $5E98f = parcelRequire("5E98f");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");
const $c60daa2bf4da7ff9$var$capitalize = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $c60daa2bf4da7ff9$export$2a5ee9588693f44d = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $5E98f.default), fieldRef);
    const relationName = data?.issueLink?.relationName;
    if (!relationName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        testId: "issue-field-link-relationship-readview-full.ui.text"
    }, $c60daa2bf4da7ff9$var$capitalize(relationName));
});

});
parcelRegister("5E98f", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc69840be18e15f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0f4153d6b6b017e3b20e165a058385bf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2cc69840be18e15f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_JiraIssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView",
    "selections": [
        {
            "concreteType": "JiraIssueLink",
            "kind": "LinkedField",
            "name": "issueLink",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "relationName"
                }
            ]
        }
    ],
    "type": "JiraIssueLinkRelationshipTypeField"
};
$2cc69840be18e15f$var$node.hash = "361dcf400dbdcd55049456b0ff5b544a";
var $2cc69840be18e15f$export$2e2bcd8739ae039 = $2cc69840be18e15f$var$node;

});


parcelRegister("8gALd", function(module, exports) {

$parcel$export(module.exports, "createSelectedOptionFromFieldData", () => $867b869f881dd328$export$48295089bb76e387);
const $867b869f881dd328$var$capitalize = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $867b869f881dd328$export$48295089bb76e387 = (issueLinkData)=>{
    const { issueLinkTypeARI: issueLinkTypeARI, relationName: relationName, direction: direction } = issueLinkData || {};
    if (!issueLinkTypeARI || !relationName || !direction) return null;
    return {
        id: `${issueLinkTypeARI}_${direction}`,
        value: issueLinkTypeARI,
        label: $867b869f881dd328$var$capitalize(relationName),
        direction: direction
    };
};

});

parcelRegister("jYDsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a44f012b27cbb718$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a44f012b27cbb718$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    unlinkConfirmationModalTitle: {
        "id": "native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-confirmation.modal-title.non-final",
        "defaultMessage": "Unlink {issueKey} from this work item."
    },
    unlinkConfirmationCancelButton: {
        "id": "native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-confirmation.cancel-button",
        "defaultMessage": "Cancel"
    },
    unlinkConfirmationConfirmButton: {
        "id": "native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-confirmation.confirm-button",
        "defaultMessage": "Confirm"
    },
    unlinkSuccessTitle: {
        "id": "native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-success.title.non-final",
        "defaultMessage": "Issue unlinked successfully"
    },
    unlinkSuccessDescription: {
        "id": "native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-success.description.non-final",
        "defaultMessage": "{issueKey} has been unlinked from this work item."
    },
    unlinkErrorTitle: {
        "id": "native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-error.title.non-final",
        "defaultMessage": "Failed to unlink issue"
    },
    unlinkErrorDescription: {
        "id": "native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-error.description.non-final",
        "defaultMessage": "An unexpected error occurred while unlinking the issue."
    }
});

});

parcelRegister("gomlP", function(module, exports) {

$parcel$export(module.exports, "default", () => $21038cce3e13c989$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");
var $goZPP = parcelRequire("goZPP");

var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $aC4Bh = parcelRequire("aC4Bh");

var $lRq8t = parcelRequire("lRq8t");

var $jYDsp = parcelRequire("jYDsp");
const $21038cce3e13c989$var$ConfirmationDialog = ({ issueKey: issueKey, onUnlinkCancel: onUnlinkCancel, onUnlinkSubmit: onUnlinkSubmit })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        messageId: "issue-field-link-relationship-inline-edit-full.ui.confirmation-dialog.modal-dialog.unlink-confirmation.modal-dialog",
        messageType: "transactional",
        onClose: onUnlinkCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "warning"
    }, formatMessage((0, $jYDsp.default).unlinkConfirmationModalTitle, {
        issueKey: issueKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        onClick: onUnlinkCancel
    }, formatMessage((0, $jYDsp.default).unlinkConfirmationCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "warning",
        onClick: onUnlinkSubmit
    }, formatMessage((0, $jYDsp.default).unlinkConfirmationConfirmButton)))));
};
var $21038cce3e13c989$export$2e2bcd8739ae039 = $21038cce3e13c989$var$ConfirmationDialog;

});



parcelRegister("e8DGh", function(module, exports) {

$parcel$export(module.exports, "useCellsConditionalFormatting", () => $0514b1bd05b026fd$export$22d9e69227bc5741);

var $7Iyst = parcelRequire("7Iyst");

var $lRH9F = parcelRequire("lRH9F");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kQ82p = parcelRequire("kQ82p");

var $5d1YD = parcelRequire("5d1YD");

var $7jTnu = parcelRequire("7jTnu");

var $jUTKf = parcelRequire("jUTKf");

var $34oCh = parcelRequire("34oCh");
const $0514b1bd05b026fd$var$emptyObject = {};
const $0514b1bd05b026fd$export$22d9e69227bc5741 = (project, fieldSets)=>{
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7jTnu.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const fields = (0, $j4oe4.useFragment)((0, $lRH9F.default), isConditionalFormattingEnabled ? fieldSets : null);
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const rules = (0, $j4oe4.useFragment)((0, $7Iyst.default), isConditionalFormattingEnabled ? project : null);
    const valuesByFieldId = (0, $eJOHy.useMemo)(()=>{
        if (!isConditionalFormattingEnabled) return null;
        if (rules?.conditionalFormattingRules?.edges == null || rules?.conditionalFormattingRules?.edges.length === 0) return null;
        if (fields?.edges == null || fields?.edges?.length === 0) return null;
        const localMap = new Map();
        fields.edges.forEach((fieldSet)=>fieldSet?.node?.fields?.edges?.forEach((fieldEdge)=>{
                const field = fieldEdge?.node;
                switch(field?.__typename){
                    case 'JiraSingleLineTextField':
                        localMap.set(field.fieldId, field.text);
                        break;
                    case 'JiraLabelsField':
                        {
                            const names = field.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name).filter((name)=>name != null) ?? [];
                            localMap.set(field.fieldId, names);
                            break;
                        }
                    case 'JiraComponentsField':
                        {
                            const ids = field.selectedComponentsConnection?.edges?.map((edge)=>edge?.node?.componentId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectUserPickerField':
                        localMap.set(field.fieldId, field.user?.accountId ?? 'UNASSIGNED');
                        break;
                    case 'JiraDatePickerField':
                        {
                            const parsedDate = field.date ? (0, $kQ82p.default)(field.date) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraDateTimePickerField':
                        {
                            const parsedDate = field.dateTime ? (0, $kQ82p.default)(field.dateTime) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraNumberField':
                        localMap.set(field.fieldId, field.number);
                        break;
                    case 'JiraPriorityField':
                        localMap.set(field.fieldId, field.priority?.priorityId);
                        break;
                    case 'JiraProjectField':
                        localMap.set(field.fieldId, field.project?.projectId);
                        break;
                    case 'JiraSingleVersionPickerField':
                        localMap.set(field.fieldId, field.version?.versionId);
                        break;
                    case 'JiraIssueTypeField':
                        localMap.set(field.fieldId, field.issueType?.issueTypeId);
                        break;
                    case 'JiraStatusField':
                        localMap.set(field.fieldId, field.status?.statusId);
                        break;
                    case 'JiraMultipleSelectUserPickerField':
                        {
                            const ids = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node?.accountId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSprintField':
                        {
                            const ids = field.selectedSprintsConnection?.edges?.map((edge)=>edge?.node?.sprintId).filter((sprintId)=>sprintId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraMultipleVersionPickerField':
                        {
                            const ids = field.selectedVersionsConnection?.edges?.map((edge)=>edge?.node?.versionId).filter((versionId)=>versionId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectField':
                        localMap.set(field.fieldId, field.selectedValue?.id);
                        break;
                    case 'JiraMultipleSelectField':
                        {
                            const ids = field.selectedValues?.edges?.map((edge)=>edge?.node?.id).filter((selectedValueId)=>selectedValueId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraRadioSelectField':
                        localMap.set(field.fieldId, field.selectedOption?.label);
                        break;
                    // TODO: Add all supported types value mapping
                    default:
                        break;
                }
            }));
        return localMap;
    }, [
        fields,
        isConditionalFormattingEnabled,
        rules
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (!isConditionalFormattingEnabled) return $0514b1bd05b026fd$var$emptyObject;
        /*
    	Evaluate all rules.
    	Get all rules before first row rule that's active.
    	groupBy fieldId first rule that is active for that fieldId.  {[fieldId]: {value, hoverValue}}
    */ const formattingRules = rules?.conditionalFormattingRules?.edges;
        if (!formattingRules || formattingRules.length === 0 || fields?.edges == null || fields?.edges.length === 0) return $0514b1bd05b026fd$var$emptyObject;
        if (valuesByFieldId == null) return $0514b1bd05b026fd$var$emptyObject;
        let hasActiveRowRule = false;
        const fieldWithActiveRule = new Set();
        const evaluatedRules = Object.fromEntries(formattingRules.map((rule, index)=>{
            if (hasActiveRowRule) // We dont want to evaluate more rules when
            // an active Row rule exists
            return null;
            const expression = rule?.node?.expression;
            const fieldId = expression?.fieldId;
            const value = expression?.value ?? expression?.values;
            const formattingArea = rule?.node?.formattingArea;
            const operator = expression?.noValueOperator ?? expression?.singleValueOperator ?? expression?.multipleValueOperator;
            if (!fieldId || !operator || formattingArea === 'CELL' && fieldWithActiveRule.has(fieldId)) // FieldId and Operator are mandatory for evaluation
            // First rule per fieldId will be used anything else should not be evaluated
            return null;
            const fieldValue = valuesByFieldId.get(fieldId);
            const active = (0, $5d1YD.evaluateRule)(operator, fieldValue, value);
            if (!active) return null;
            if (formattingArea === 'ROW') {
                hasActiveRowRule = true;
                return null;
            }
            fieldWithActiveRule.add(fieldId);
            return [
                fieldId,
                {
                    index: index,
                    id: fieldId,
                    color: (0, $jUTKf.formattingColors)[rule?.node?.formattingColor?.colorKey ?? ''],
                    type: 'CELL'
                }
            ];
        }).filter((maybeRule)=>maybeRule != null));
        return Object.fromEntries(fields.edges.map((fieldSetEdge)=>{
            const fieldSet = fieldSetEdge?.node;
            if (fieldSet?.fieldSetId == null) return null;
            let rule;
            fieldSet.fields?.edges?.forEach((fieldEdge)=>{
                if (fieldEdge?.node == null) return;
                const maybeRule = evaluatedRules[fieldEdge.node.fieldId];
                if (maybeRule != null && maybeRule.index < (rule?.index ?? Infinity)) rule = maybeRule;
                return null;
            });
            if (rule?.color == null) return null;
            return [
                fieldSet.fieldSetId,
                {
                    ...rule.color,
                    index: rule.index
                }
            ];
        }).filter((maybeRule)=>maybeRule != null));
    }, [
        isConditionalFormattingEnabled,
        rules,
        fields,
        valuesByFieldId
    ]);
};

});
parcelRegister("7Iyst", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a5d57a59d35e067$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<23d5a23fc506ac2aaf7688f8ba94786c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0a5d57a59d35e067$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useCellsConditionalFormatting_project",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "singleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "multipleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "noValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    }
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "formattingArea"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "formattingColor",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "conditionalFormattingRules(first:20)"
            }
        ],
        "type": "JiraProject"
    };
}();
$0a5d57a59d35e067$var$node.hash = "b73f935d4f6dd3a1c7e5915c8a973243";
var $0a5d57a59d35e067$export$2e2bcd8739ae039 = $0a5d57a59d35e067$var$node;

});

parcelRegister("lRH9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $03283f9b137e7c4f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c757d90c1676fa6e73b2278cc92d47e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03283f9b137e7c4f$var$node = function() {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "versionId"
        }
    ], v4 = [
        v2 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useCellsConditionalFormatting_fieldSet",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldSetId"
                            },
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraComponentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedComponentsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraComponentEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponent",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "componentId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedComponentsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraComponentsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraLabelConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedLabelsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraLabelEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraLabel",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "name"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraLabelsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    v2 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraUserConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedUsersConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraUserEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v1 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "date"
                                                            }
                                                        ],
                                                        "type": "JiraDatePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "dateTime"
                                                            }
                                                        ],
                                                        "type": "JiraDateTimePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "number"
                                                            }
                                                        ],
                                                        "type": "JiraNumberField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraPriority",
                                                                "kind": "LinkedField",
                                                                "name": "priority",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "priorityId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraPriorityField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "projectId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraProjectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSprintConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedSprintsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprintEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSprint",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "sprintId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSprintField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "version",
                                                                "plural": false,
                                                                "selections": v3 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraVersionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedVersionsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersion",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v3 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedVersionsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraMultipleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "selectedValue",
                                                                "plural": false,
                                                                "selections": v4 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSelectableValueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedValues",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v4 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": "label",
                                                                        "kind": "ScalarField",
                                                                        "name": "value"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraRadioSelectField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$03283f9b137e7c4f$var$node.hash = "52d45e4431db50e0b1e2ec768861dced";
var $03283f9b137e7c4f$export$2e2bcd8739ae039 = $03283f9b137e7c4f$var$node;

});

parcelRegister("5d1YD", function(module, exports) {

$parcel$export(module.exports, "evaluateRule", () => $8e832ab75969f901$export$6b882d50951f579a);

var $dGJCK = parcelRequire("dGJCK");
var $cNTKl = parcelRequire("cNTKl");
var $3bI3H = parcelRequire("3bI3H");
var $ibLUB = parcelRequire("ibLUB");
var $bf0oy = parcelRequire("bf0oy");
var $lncFc = parcelRequire("lncFc");
var $37UhW = parcelRequire("37UhW");
var $bODPS = parcelRequire("bODPS");
var $i6NVB = parcelRequire("i6NVB");
var $dBLX0 = parcelRequire("dBLX0");
var $dSLL3 = parcelRequire("dSLL3");
var $kQ82p = parcelRequire("kQ82p");
var $lTtQZ = parcelRequire("lTtQZ");
var $hwbrf = parcelRequire("hwbrf");
var $dy6Fq = parcelRequire("dy6Fq");

var $9iBuw = parcelRequire("9iBuw");
const $8e832ab75969f901$var$evaluateRuleNoValue = (operator, fieldValue)=>{
    if (Array.isArray(fieldValue)) switch(operator){
        case 'IS_EMPTY':
            return fieldValue.length === 0;
        case 'IS_NOT_EMPTY':
            return fieldValue.length > 0;
        default:
            return false;
    }
    switch(operator){
        case 'IS_EMPTY':
            return fieldValue === 0 ? false : !fieldValue;
        case 'IS_NOT_EMPTY':
            return fieldValue === 0 ? true : Boolean(fieldValue);
        default:
            return false;
    }
};
const $8e832ab75969f901$var$ruleSingleValueStringOperations = {
    CONTAINS: (fieldValue, ruleValue)=>{
        if (Array.isArray(fieldValue)) return fieldValue.some((value)=>{
            if (value == null) return false;
            if ((0, $9iBuw.isNumber)(value)) return value === Number(ruleValue);
            if ((0, $9iBuw.isString)(value)) return value.includes(ruleValue);
            return false;
        });
        return fieldValue.includes(ruleValue);
    }
};
const $8e832ab75969f901$var$ruleSingleValueOperations = {
    EQUALS: (fieldValue, ruleValue)=>{
        return Boolean(fieldValue && String(fieldValue) === ruleValue);
    }
};
const $8e832ab75969f901$var$ruleSingleValueNumberOperations = {
    GREATER_THAN: (fieldValue, ruleValue)=>{
        return fieldValue > Number(ruleValue);
    }
};
const $8e832ab75969f901$var$dateRuleValueEvaluators = {
    IS: (fieldValue, ruleValue)=>{
        switch(ruleValue){
            case 'TODAY':
                return (0, $bODPS.default)(fieldValue);
            case 'TOMORROW':
                return (0, $i6NVB.default)(fieldValue);
            case 'YESTERDAY':
                return (0, $dSLL3.default)(fieldValue);
            case 'THIS_WEEK':
                return (0, $37UhW.default)(fieldValue);
            case 'LAST_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) === -1;
            case 'NEXT_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) === 1;
            case 'THIS_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) === 0;
            case 'LAST_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) === -1;
            case 'NEXT_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) === 1;
            case 'THIS_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) === 0;
            case 'LAST_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) === -1;
            case 'NEXT_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) === 1;
            default:
                {
                    const dateValue = (0, $kQ82p.default)(ruleValue);
                    if ((0, $dBLX0.default)(dateValue)) return (0, $lncFc.default)(dateValue, fieldValue);
                    return false;
                }
        }
    },
    IS_AFTER: (fieldValue, ruleValue)=>{
        switch(ruleValue){
            case 'TODAY':
                return (0, $ibLUB.default)(fieldValue, (0, $lTtQZ.default)());
            case 'TOMORROW':
                return (0, $ibLUB.default)(fieldValue, (0, $hwbrf.default)());
            case 'YESTERDAY':
                return (0, $ibLUB.default)(fieldValue, (0, $dy6Fq.default)());
            case 'THIS_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) > 0;
            case 'LAST_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) >= 0;
            case 'NEXT_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) > 1;
            case 'THIS_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) > 0;
            case 'LAST_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) >= 0;
            case 'NEXT_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) > 1;
            case 'THIS_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) > 0;
            case 'LAST_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) >= 0;
            case 'NEXT_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) > 1;
            default:
                {
                    const dateValue = (0, $kQ82p.default)(ruleValue);
                    if ((0, $dBLX0.default)(dateValue)) return (0, $ibLUB.default)(fieldValue, dateValue);
                    return false;
                }
        }
    },
    IS_BEFORE: (fieldValue, ruleValue)=>{
        switch(ruleValue){
            case 'TODAY':
                return (0, $bf0oy.default)(fieldValue, (0, $lTtQZ.default)());
            case 'TOMORROW':
                return (0, $bf0oy.default)(fieldValue, (0, $hwbrf.default)());
            case 'YESTERDAY':
                return (0, $bf0oy.default)(fieldValue, (0, $dy6Fq.default)());
            case 'THIS_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) < 0;
            case 'LAST_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) < -1;
            case 'NEXT_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) < 1;
            case 'THIS_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) < 0;
            case 'LAST_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) < -1;
            case 'NEXT_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) < 1;
            case 'THIS_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) < 0;
            case 'LAST_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) < -1;
            case 'NEXT_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) < 1;
            default:
                {
                    const dateValue = (0, $kQ82p.default)(ruleValue);
                    if ((0, $dBLX0.default)(dateValue)) return (0, $bf0oy.default)(fieldValue, dateValue);
                    return false;
                }
        }
    },
    IS_NOT: (field, value)=>!$8e832ab75969f901$var$dateRuleValueEvaluators.IS?.(field, value),
    IS_ON_OR_AFTER: (field, value)=>Boolean($8e832ab75969f901$var$dateRuleValueEvaluators.IS?.(field, value) || $8e832ab75969f901$var$dateRuleValueEvaluators.IS_AFTER?.(field, value)),
    IS_ON_OR_BEFORE: (field, value)=>Boolean($8e832ab75969f901$var$dateRuleValueEvaluators.IS?.(field, value) || $8e832ab75969f901$var$dateRuleValueEvaluators.IS_BEFORE?.(field, value))
};
const $8e832ab75969f901$var$evaluateRuleSingleValue = (operator, fieldValue, ruleValue)=>{
    if ((0, $9iBuw.isDateRuleOnlyOperator)(operator) && fieldValue instanceof Date) return $8e832ab75969f901$var$dateRuleValueEvaluators[operator](fieldValue, ruleValue) ?? false;
    // Operators that apply to all field value types
    switch(operator){
        case 'EQUALS':
            return $8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue);
        case 'DOES_NOT_EQUAL':
            return !$8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue);
        case 'IS':
            return fieldValue === ruleValue;
        case 'IS_NOT':
            return fieldValue !== ruleValue;
        default:
            break;
    }
    if (fieldValue == null) // All single value rule requires the field value to exist
    return false;
    if ((0, $9iBuw.isString)(fieldValue) || Array.isArray(fieldValue)) // Operators that does not apply to number or nullish fields
    switch(operator){
        case 'CONTAINS':
            return $8e832ab75969f901$var$ruleSingleValueStringOperations.CONTAINS(fieldValue, ruleValue);
        case 'DOES_NOT_CONTAIN':
            return !$8e832ab75969f901$var$ruleSingleValueStringOperations.CONTAINS(fieldValue, ruleValue);
        default:
            return false;
    }
    if ((0, $9iBuw.isNumber)(fieldValue)) switch(operator){
        // Only applies to number
        case 'GREATER_THAN':
            return $8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? false;
        case 'LESS_THAN':
            return !($8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? true) && !($8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue) ?? true);
        case 'GREATER_THAN_OR_EQUALS':
            return ($8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? false) || ($8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue) ?? false);
        case 'LESS_THAN_OR_EQUALS':
            return !($8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? true);
        default:
            break;
    }
    return false;
};
const $8e832ab75969f901$var$multipleValueOperatorSingleFieldValueEvaluators = {
    HAS_ANY_OF: (fieldValue, ruleValue)=>{
        if (fieldValue == null) return false;
        return ruleValue.includes(String(fieldValue));
    },
    // No valid rule single field value contains a multiple rule value
    CONTAINS: ()=>false,
    DOES_NOT_CONTAIN: ()=>false,
    // eslint-disable-next-line @atlassian/relay/no-future-added-value
    '%future added value': ()=>false
};
const $8e832ab75969f901$var$multipleValueOperatorEvaluators = {
    CONTAINS: (fieldValue, ruleValue)=>{
        return fieldValue.filter((fval)=>{
            return ruleValue.includes(String(fval));
        }).length === ruleValue.length;
    },
    DOES_NOT_CONTAIN: (...args)=>!$8e832ab75969f901$var$multipleValueOperatorEvaluators.CONTAINS(...args),
    HAS_ANY_OF: (fieldValue, ruleValue)=>{
        return fieldValue.some((fval)=>{
            return $8e832ab75969f901$var$multipleValueOperatorSingleFieldValueEvaluators.HAS_ANY_OF(fval, ruleValue);
        });
    },
    // eslint-disable-next-line @atlassian/relay/no-future-added-value
    '%future added value': ()=>false
};
const $8e832ab75969f901$var$evaluateRuleMultipleValue = (operator, fieldValue, ruleValue)=>{
    if (Array.isArray(fieldValue)) return $8e832ab75969f901$var$multipleValueOperatorEvaluators[operator](fieldValue, ruleValue);
    return $8e832ab75969f901$var$multipleValueOperatorSingleFieldValueEvaluators[operator](fieldValue, ruleValue);
};
const $8e832ab75969f901$export$6b882d50951f579a = (operator, fieldValue, ruleValue)=>{
    if (ruleValue === undefined) {
        if ((0, $9iBuw.isNoValueOperator)(operator)) return $8e832ab75969f901$var$evaluateRuleNoValue(operator, fieldValue);
        return false;
    }
    if (Array.isArray(ruleValue) && (0, $9iBuw.isMultipleValueOperator)(operator)) return $8e832ab75969f901$var$evaluateRuleMultipleValue(operator, fieldValue, ruleValue);
    if ((0, $9iBuw.isSingleValueOperator)(operator) && typeof ruleValue === 'string') return $8e832ab75969f901$var$evaluateRuleSingleValue(operator, fieldValue, ruleValue);
// We will need to handle this in the hook, and sent analytics event when missing.
// throw new Error('Unhandled format rule'); https://jbusiness.atlassian.net/browse/JSC-2764 Uncomment when error is properly handled
};

});
parcelRegister("9iBuw", function(module, exports) {

$parcel$export(module.exports, "isNoValueOperator", () => $04d6240c5de8c6c9$export$88b85e57ca1e3f4a);
$parcel$export(module.exports, "isSingleValueOperator", () => $04d6240c5de8c6c9$export$99197f1cc2c9c086);
$parcel$export(module.exports, "isDateRuleOnlyOperator", () => $04d6240c5de8c6c9$export$f0a7020d8f55379d);
$parcel$export(module.exports, "isMultipleValueOperator", () => $04d6240c5de8c6c9$export$71082e7c2ba7f454);
$parcel$export(module.exports, "isString", () => $04d6240c5de8c6c9$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $04d6240c5de8c6c9$export$7e4aa119212bc614);
const $04d6240c5de8c6c9$var$dateRuleValue = new Set([
    'EXACT_DATE',
    'LAST_QUARTER',
    'LAST_WEEK',
    'LAST_YEAR',
    'NEXT_QUARTER',
    'NEXT_WEEK',
    'NEXT_YEAR',
    'THIS_QUARTER',
    'THIS_WEEK',
    'THIS_YEAR',
    'TODAY',
    'TOMORROW',
    'YESTERDAY'
]);
const $04d6240c5de8c6c9$export$7a93007e84f4988d = (value)=>{
    return $04d6240c5de8c6c9$var$dateRuleValue.has(value);
};
const $04d6240c5de8c6c9$var$noValueOperators = new Set([
    'IS_EMPTY',
    'IS_NOT_EMPTY'
]);
const $04d6240c5de8c6c9$export$88b85e57ca1e3f4a = (operator)=>{
    return $04d6240c5de8c6c9$var$noValueOperators.has(operator);
};
const $04d6240c5de8c6c9$var$singleValueOperators = new Set([
    'CONTAINS',
    'DOES_NOT_CONTAIN',
    'DOES_NOT_EQUAL',
    'EQUALS',
    'GREATER_THAN',
    'GREATER_THAN_OR_EQUALS',
    'IS',
    'IS_AFTER',
    'IS_BEFORE',
    'IS_NOT',
    'IS_ON_OR_AFTER',
    'IS_ON_OR_BEFORE',
    'LESS_THAN',
    'LESS_THAN_OR_EQUALS'
]);
const $04d6240c5de8c6c9$export$99197f1cc2c9c086 = (operator)=>{
    return $04d6240c5de8c6c9$var$singleValueOperators.has(operator);
};
const $04d6240c5de8c6c9$var$dateRuleOnlyOperator = new Set([
    'IS',
    'IS_AFTER',
    'IS_BEFORE',
    'IS_NOT',
    'IS_ON_OR_AFTER',
    'IS_ON_OR_BEFORE'
]);
const $04d6240c5de8c6c9$export$f0a7020d8f55379d = (operator)=>{
    return $04d6240c5de8c6c9$var$dateRuleOnlyOperator.has(operator);
};
const $04d6240c5de8c6c9$var$multipleValueOperators = new Set([
    'CONTAINS',
    'DOES_NOT_CONTAIN',
    'HAS_ANY_OF',
    'IS_BETWEEN'
]);
const $04d6240c5de8c6c9$export$71082e7c2ba7f454 = (operator)=>{
    return $04d6240c5de8c6c9$var$multipleValueOperators.has(operator);
};
const $04d6240c5de8c6c9$export$844ec244b1367d54 = (maybeString)=>{
    return typeof maybeString === 'string';
};
const $04d6240c5de8c6c9$export$7e4aa119212bc614 = (maybeNumber)=>{
    return typeof maybeNumber === 'number';
};

});


parcelRegister("jUTKf", function(module, exports) {

$parcel$export(module.exports, "formattingColors", () => $c30971d2a738910c$export$2fedf4ac4eb04087);

var $LFmXM = parcelRequire("LFmXM");

var $5zzUt = parcelRequire("5zzUt");
const $c30971d2a738910c$export$2fedf4ac4eb04087 = {
    lightPurple: {
        label: (0, $5zzUt.default).lightPurple,
        value: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        hoverValue: "var(--ds-background-accent-purple-subtlest-hovered, #DFD8FD)"
    },
    lightBlue: {
        label: (0, $5zzUt.default).lightBlue,
        value: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        hoverValue: "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)"
    },
    lightGreen: {
        label: (0, $5zzUt.default).lightGreen,
        value: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        hoverValue: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)"
    },
    lightTeal: {
        label: (0, $5zzUt.default).lightTeal,
        value: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        hoverValue: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)"
    },
    lightYellow: {
        label: (0, $5zzUt.default).lightYellow,
        value: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        hoverValue: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)"
    },
    lightRed: {
        label: (0, $5zzUt.default).lightRed,
        value: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        hoverValue: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)"
    },
    lightGray: {
        label: (0, $5zzUt.default).lightGray,
        value: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        hoverValue: "var(--ds-background-accent-gray-subtlest-hovered, #DCDFE4)"
    },
    purple: {
        label: (0, $5zzUt.default).purple,
        value: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hoverValue: "var(--ds-background-accent-purple-subtler-hovered, #B8ACF6)"
    },
    blue: {
        label: (0, $5zzUt.default).blue,
        value: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hoverValue: "var(--ds-background-accent-blue-subtler-hovered, #85B8FF)"
    },
    green: {
        label: (0, $5zzUt.default).green,
        value: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hoverValue: "var(--ds-background-accent-green-subtler-hovered, #7EE2B8)"
    },
    teal: {
        label: (0, $5zzUt.default).teal,
        value: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hoverValue: "var(--ds-background-accent-teal-subtler-hovered, #9DD9EE)"
    },
    yellow: {
        label: (0, $5zzUt.default).yellow,
        value: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hoverValue: "var(--ds-background-accent-yellow-subtler-hovered, #F5CD47)"
    },
    red: {
        label: (0, $5zzUt.default).red,
        value: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hoverValue: "var(--ds-background-accent-red-subtler-hovered, #FD9891)"
    },
    gray: {
        label: (0, $5zzUt.default).gray,
        value: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hoverValue: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)"
    }
};
const $c30971d2a738910c$export$ae7e938b8bdf2df5 = (0, $LFmXM.default)((value)=>{
    const selectedColor = Object.entries($c30971d2a738910c$export$2fedf4ac4eb04087).find(([_, color])=>color.value === value);
    return selectedColor?.[0];
});

});
parcelRegister("5zzUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $37202181219e5e4d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $37202181219e5e4d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    lightPurple: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-purple",
        "defaultMessage": "Subtle purple"
    },
    lightBlue: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-blue",
        "defaultMessage": "Subtle blue"
    },
    lightGreen: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-green",
        "defaultMessage": "Subtle green"
    },
    lightTeal: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-teal",
        "defaultMessage": "Subtle teal"
    },
    lightYellow: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-yellow",
        "defaultMessage": "Subtle yellow"
    },
    lightRed: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-red",
        "defaultMessage": "Subtle red"
    },
    lightGray: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-gray",
        "defaultMessage": "Subtle gray"
    },
    purple: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.purple",
        "defaultMessage": "Bold purple"
    },
    blue: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.blue",
        "defaultMessage": "Bold blue"
    },
    green: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.green",
        "defaultMessage": "Bold green"
    },
    teal: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.teal",
        "defaultMessage": "Bold teal"
    },
    yellow: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.yellow",
        "defaultMessage": "Bold yellow"
    },
    red: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.red",
        "defaultMessage": "Bold red"
    },
    gray: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.gray",
        "defaultMessage": "Bold gray"
    }
});

});



parcelRegister("cOqgG", function(module, exports) {

$parcel$export(module.exports, "default", () => $11224fa3afbf416f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $4xbv3 = parcelRequire("4xbv3");

var $8jOO7 = parcelRequire("8jOO7");

var $86BUM = parcelRequire("86BUM");

var $bKlUQ = parcelRequire("bKlUQ");

var $dvCjO = parcelRequire("dvCjO");
const $11224fa3afbf416f$var$DefaultFallbackComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
const $11224fa3afbf416f$var$IssueRowCellErrorFallback = ({ type: type, border: border, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: border
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: type,
        reason: (0, $7jTnu.fg)('empanada_error_cell_logging') ? error : 'Unhandled error'
    }));
const $11224fa3afbf416f$var$IssueRowCell = ({ type: type, beforeElement: beforeElement, cellElement: cellElement, border: border, spacing: spacing, multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment, FallbackComponent: FallbackComponent = $11224fa3afbf416f$var$DefaultFallbackComponent, formatting: formatting, style: style, isColumnResizing: isColumnResizing, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, hasRightShadow: hasRightShadow, fieldId: fieldId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            fieldType: type
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: (0, $8jOO7.PACKAGE_NAME),
        teamName: (0, $8jOO7.TEAM_NAME),
        id: "issueRowCellUnhandled",
        sendToPrivacyUnsafeSplunk: true,
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($11224fa3afbf416f$var$IssueRowCellErrorFallback, {
                type: type,
                border: border,
                error: error
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        spacing: spacing,
        border: border,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        ...(0, $7jTnu.fg)('issue_table_frozen_columns') && {
            isColumnSticky: isColumnSticky,
            stickyOffsets: stickyOffsets,
            isColumnResizing: isColumnResizing,
            hasRightShadow: hasRightShadow
        },
        formatting: formatting,
        fieldId: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeElement, Array.isArray(cellElement) && cellElement.length > 1 && (0, $7jTnu.fg)('jsc_duplicate_field_layout_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dvCjO.MultipleCellElements), {
        cellElements: cellElement,
        type: type,
        multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment
    }) : cellElement ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FallbackComponent, null)))));
var $11224fa3afbf416f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($11224fa3afbf416f$var$IssueRowCell);

});
parcelRegister("dvCjO", function(module, exports) {

$parcel$export(module.exports, "MultipleCellElements", () => $0dfcc569f582c593$export$4b5a1f36c48df9b0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5PQOA = parcelRequire("5PQOA");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $2R0ne = parcelRequire("2R0ne");

var $Ay1uj = parcelRequire("Ay1uj");

var $lL4G9 = parcelRequire("lL4G9");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $ibVOD = parcelRequire("ibVOD");

var $9Mapt = parcelRequire("9Mapt");

var $7jTnu = parcelRequire("7jTnu");

var $34oCh = parcelRequire("34oCh");

var $9LCGj = parcelRequire("9LCGj");
const $0dfcc569f582c593$export$1d1457a281374128 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((fieldType, numberOfElements, createAnalyticsEvent)=>{
    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'tableCell multipleElementsRendered', {
        fieldType: fieldType,
        numberOfElements: numberOfElements
    });
});
const $0dfcc569f582c593$var$MoreFieldsContent = ({ elements: elements })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$moreFieldsHeaderRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $9LCGj.default).duplicateFieldsHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$moreFieldsDescriptionStyles
    }, formatMessage((0, $9LCGj.default).duplicateFieldsContent, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
                href: "/jira/settings/issues/fields",
                target: "_blank"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("hr", {
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$fieldsContainerStyles
    }, elements.map((element, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $0dfcc569f582c593$var$fieldStyles,
            key: idx
        }, element))));
};
const $0dfcc569f582c593$export$4b5a1f36c48df9b0 = ({ cellElements: cellElements, multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment = false, type: type })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    $0dfcc569f582c593$export$1d1457a281374128(type, cellElements.length, createAnalyticsEvent);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (multipleFieldLayoutAdjustment && cellElements.length > 0 && isSingleLineRowHeightEnabled && (0, $7jTnu.fg)('single_line_row_height_collapsable_fields')) {
        const firstElement = cellElements[0];
        const rest = cellElements.slice(1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $0dfcc569f582c593$var$rowStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ...props,
                className: (0, $hcewu.default)([
                    "_1reo15vq _18m915vq _1bto1l2s",
                    "_4t3i1osq",
                    "_1bsb1osq"
                ])
            }, firstElement))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0dfcc569f582c593$var$MoreFieldsContent, {
                    elements: rest
                }),
                isInteractive: true,
                isFixedWidth: true,
                analyticsAttributes: {
                    duplicateField: true
                }
            }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                    ref: ref,
                    className: (0, $hcewu.default)([
                        "_2hwx1b66"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                    label: "",
                    appearance: "subtle",
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
                            ...iconProps,
                            color: "var(--ds-icon-information, #1D7AFC)"
                        }),
                    testId: "native-issue-table.ui.row.issue-row.cell.multiple-cell-elements.issue-table",
                    ...props
                }))))));
    }
    return multipleFieldLayoutAdjustment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$containerStyles
    }, cellElements.map((cellElement, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            key: index,
            xcss: $0dfcc569f582c593$var$elementContainerStyles
        }, cellElement))) : cellElements;
};
const $0dfcc569f582c593$var$rowStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 'space.050',
    height: '100%'
});
const $0dfcc569f582c593$var$containerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 'space.050'
});
const $0dfcc569f582c593$var$elementContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '32px'
});
const $0dfcc569f582c593$var$moreFieldsHeaderRowStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    marginBottom: 'space.050'
});
const $0dfcc569f582c593$var$moreFieldsDescriptionStyles = (0, $1DXK0.xcss)({
    font: 'font.body.medium'
});
const $0dfcc569f582c593$var$fieldsContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 'space.050',
    width: '100%',
    height: '100%'
});
const $0dfcc569f582c593$var$fieldStyles = (0, $1DXK0.xcss)({
    height: '40px',
    width: '100%'
});
const $0dfcc569f582c593$var$contentStyles = null;
const $0dfcc569f582c593$var$buttonStyle = null;
const $0dfcc569f582c593$var$fillHeight = null;
const $0dfcc569f582c593$var$fillWidth = null;

});
parcelRegister("9LCGj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce16bf62d775f359$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ce16bf62d775f359$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    duplicateFieldsHeader: {
        "id": "native-issue-table.duplicate-fields-header",
        "defaultMessage": "Duplicate fields"
    },
    duplicateFieldsContent: {
        "id": "native-issue-table.duplicate-fields-content",
        "defaultMessage": "<link>Configure fields</link> to remove duplicates"
    }
});

});



parcelRegister("bgTt1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c581616587e82620$export$2e2bcd8739ae039);

var $aeEFp = parcelRequire("aeEFp");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2XtSM = parcelRequire("2XtSM");

var $16sa1 = parcelRequire("16sa1");

var $bJscI = parcelRequire("bJscI");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");
const $c581616587e82620$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "first-column-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/**
 * @deprecated should be removed when jira_list_merged_column_gate is cleaned up
 */ const $c581616587e82620$var$FirstColumnCell = ({ isRowHoveredOrSelected: isRowHoveredOrSelected, itemsConnectionId: itemsConnectionId, depth: depth, issueRef: issueRef, triggerProps: triggerProps, isFormVisible: isFormVisible })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $aeEFp.default), issueRef);
    const { hasChildren: hasChildren, canHaveChildIssues: canHaveChildIssues } = issueData;
    const { issueId: issueId } = issueData.node ?? {};
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    const isChildIssueCreateEnabled = (0, $34oCh.useIsChildIssueCreateEnabled)();
    const showCreateChildButton = isChildIssueCreateEnabled && isRowHoveredOrSelected && Boolean(canHaveChildIssues);
    return issueId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c581616587e82620$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.ExpandButtonWithCreateChildButton), {
        itemId: issueId,
        itemsConnectionId: itemsConnectionId,
        depth: depth,
        hasChildren: Boolean(hasChildren),
        showCreateChildButton: showCreateChildButton,
        isRowHoveredOrSelected: isRowHoveredOrSelected,
        isCreateChildFormVisible: isFormVisible,
        createChildTriggerProps: triggerProps,
        groupId: groupId
    }));
};
var $c581616587e82620$export$2e2bcd8739ae039 = $c581616587e82620$var$FirstColumnCell;

});
parcelRegister("aeEFp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4894fa1d8d083744$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c8908458561d572f3260215943998593>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4894fa1d8d083744$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "firstColumnCell_nativeIssueTable",
    "selections": [
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canHaveChildIssues"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$4894fa1d8d083744$var$node.hash = "2a1a86d094950853f5ed2066834bdfcd";
var $4894fa1d8d083744$export$2e2bcd8739ae039 = $4894fa1d8d083744$var$node;

});


parcelRegister("cvtnA", function(module, exports) {

$parcel$export(module.exports, "MergedCell", () => $ac6cb46263497f3f$export$91a9bd0bc931a6e5);

var $f3378 = parcelRequire("f3378");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $dcLzM = parcelRequire("dcLzM");

var $2XtSM = parcelRequire("2XtSM");

var $bJscI = parcelRequire("bJscI");

var $16sa1 = parcelRequire("16sa1");

var $7jTnu = parcelRequire("7jTnu");

var $34oCh = parcelRequire("34oCh");

var $6sUnz = parcelRequire("6sUnz");
const $ac6cb46263497f3f$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "merged-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $ac6cb46263497f3f$var$CELL_PADDING = 8;
const $ac6cb46263497f3f$var$HIERARCHY_LEVEL_PADDING = 12;
const $ac6cb46263497f3f$var$EXPAND_ICON_WIDTH = 24;
const $ac6cb46263497f3f$export$91a9bd0bc931a6e5 = ({ issueRef: issueRef, itemsConnectionId: itemsConnectionId, depth: depth, isRowHoveredOrSelected: isRowHoveredOrSelected, createChildTriggerProps: createChildTriggerProps, isCreateChildFormVisible: isCreateChildFormVisible, groupId: groupId, renderContent: renderContent, isHierarchyEnabled: isHierarchyEnabled })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $f3378.default), issueRef);
    const hasChildren = Boolean(issueData?.hasChildren);
    const canHaveChildIssues = Boolean(issueData?.canHaveChildIssues);
    const issueId = issueData?.node?.issueId;
    const isChildIssueCreateEnabled = (0, $34oCh.useIsChildIssueCreateEnabled)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    let showCreateChildButton;
    if ((0, $7jTnu.fg)('jira_list_merged_column_inline_create_icon_style')) showCreateChildButton = isGridNavigationEnabled ? isChildIssueCreateEnabled && isRowHoveredOrSelected && canHaveChildIssues : isChildIssueCreateEnabled && canHaveChildIssues;
    else showCreateChildButton = isChildIssueCreateEnabled && isRowHoveredOrSelected && canHaveChildIssues;
    const createChildButton = showCreateChildButton && issueId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.CreateChildButtonWithExpandToggle), {
        depth: depth,
        itemId: issueId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible,
        renderIcon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                ...iconProps,
                color: "var(--ds-icon)",
                size: "small"
            })
    });
    let childCreateButton;
    if ((0, $7jTnu.fg)('jira_list_merged_column_inline_create_icon_style')) childCreateButton = !isGridNavigationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.ui.row.issue-row.merged-cell.child-create-button-wrap",
        xcss: $ac6cb46263497f3f$var$actionButtonOpacityVariableStyle
    }, createChildButton) : createChildButton;
    else childCreateButton = createChildButton;
    let customComponents = null;
    let isTimelineEnabled = false;
    if ((0, $7jTnu.fg)('jira_native_issue_table_extra_custom_components')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        customComponents = (0, $6sUnz.useCustomComponents)();
    }
    const contextualItemMenu = isTimelineEnabled && customComponents?.timeline?.ContextualItemMenu && issueData?.node?.id && isRowHoveredOrSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(customComponents.timeline.ContextualItemMenu, {
        id: issueData.node.id
    }) : null;
    const actionButtons = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, childCreateButton, contextualItemMenu);
    if (hasChildren && issueId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac6cb46263497f3f$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ac6cb46263497f3f$var$cellStyles,
        tabIndex: isGridNavigationEnabled ? undefined : 0,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${$ac6cb46263497f3f$var$HIERARCHY_LEVEL_PADDING * depth + $ac6cb46263497f3f$var$CELL_PADDING}px`
        },
        "data-vc": "merged-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ac6cb46263497f3f$var$expandButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.ExpandButton), {
        itemId: issueId,
        itemsConnectionId: itemsConnectionId,
        depth: depth
    })), renderContent({
        actionButtons: actionButtons
    })));
    const cellPadding = isHierarchyEnabled ? $ac6cb46263497f3f$var$EXPAND_ICON_WIDTH + $ac6cb46263497f3f$var$HIERARCHY_LEVEL_PADDING * depth + $ac6cb46263497f3f$var$CELL_PADDING : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac6cb46263497f3f$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ac6cb46263497f3f$var$cellStyles,
        tabIndex: isGridNavigationEnabled ? undefined : 0,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${cellPadding}px`
        },
        "data-vc": "merged-cell"
    }, renderContent({
        actionButtons: actionButtons
    })));
};
const $ac6cb46263497f3f$var$cellStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: ' 100%',
    position: 'relative'
});
const $ac6cb46263497f3f$var$expandButtonStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $ac6cb46263497f3f$var$actionButtonOpacityVariableStyle = (0, $1DXK0.xcss)({
    opacity: 'var(--action-button-opacity, 0)'
});

});
parcelRegister("f3378", function(module, exports) {

$parcel$export(module.exports, "default", () => $148380c4c78238a3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f04535e9d90ac0d47f65b5691dabfa0a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $148380c4c78238a3$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isJscM2Enabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "mergedCell_nativeIssueTable",
    "selections": [
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canHaveChildIssues"
                }
            ]
        },
        {
            "condition": "isJscM2Enabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$148380c4c78238a3$var$node.hash = "1fc749da3971a0679d7d1d591013713e";
var $148380c4c78238a3$export$2e2bcd8739ae039 = $148380c4c78238a3$var$node;

});


parcelRegister("69bTC", function(module, exports) {

$parcel$export(module.exports, "getMergedFields", () => $9857920eda2307ec$export$dd9429df1dba0f03);

var $j8Km1 = parcelRequire("j8Km1");

var $7jTnu = parcelRequire("7jTnu");
const $9857920eda2307ec$export$dd9429df1dba0f03 = (fieldSetsData)=>{
    const nodes = fieldSetsData?.edges?.flatMap((edgeData)=>edgeData?.node?.fields?.edges?.map((edge)=>edge?.node) ?? []);
    let issueTypeField;
    let issueKeyField;
    let summaryField;
    let fieldId;
    nodes?.forEach((node)=>{
        if (node?.__typename === 'JiraIssueTypeField') issueTypeField = node;
        else if (node?.__typename === 'JiraSingleLineTextField' && node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) issueKeyField = node;
        else if (node?.__typename === 'JiraSingleLineTextField' && node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) {
            summaryField = node;
            if ((0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator')) fieldId = node?.id;
        }
    });
    return {
        issueTypeField: issueTypeField,
        issueKeyField: issueKeyField,
        summaryField: summaryField,
        fieldId: fieldId
    };
};

});


parcelRegister("fY66e", function(module, exports) {

$parcel$export(module.exports, "useRowColor", () => $515fdd8cfba81324$export$b08eff1e3a7a6523);

var $anvM8 = parcelRequire("anvM8");

var $5AwTt = parcelRequire("5AwTt");

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $j4oe4 = parcelRequire("j4oe4");

var $5d1YD = parcelRequire("5d1YD");

var $7jTnu = parcelRequire("7jTnu");

var $jUTKf = parcelRequire("jUTKf");

var $34oCh = parcelRequire("34oCh");
const $515fdd8cfba81324$export$b08eff1e3a7a6523 = (fieldSets, project)=>{
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7jTnu.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const fields = (0, $j4oe4.useFragment)((0, $5AwTt.default), isConditionalFormattingEnabled ? fieldSets : null);
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const rules = (0, $j4oe4.useFragment)((0, $anvM8.default), isConditionalFormattingEnabled ? project : null);
    const valuesByFieldId = (0, $eJOHy.useMemo)(()=>{
        if (!isConditionalFormattingEnabled || rules?.conditionalFormattingRules?.edges == null || rules?.conditionalFormattingRules?.edges.length === 0 || fields?.edges == null || fields?.edges?.length === 0) return null;
        const localMap = new Map();
        fields.edges.forEach((fieldSet)=>fieldSet?.node?.fields?.edges?.forEach((fieldEdge)=>{
                const field = fieldEdge?.node;
                switch(field?.__typename){
                    case 'JiraSingleLineTextField':
                        localMap.set(field.fieldId, field.text);
                        break;
                    case 'JiraLabelsField':
                        {
                            const names = field.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name).filter((name)=>name != null) ?? [];
                            localMap.set(field.fieldId, names);
                            break;
                        }
                    case 'JiraComponentsField':
                        {
                            const ids = field.selectedComponentsConnection?.edges?.map((edge)=>edge?.node?.componentId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectUserPickerField':
                        localMap.set(field.fieldId, field.user?.accountId ?? 'UNASSIGNED');
                        break;
                    case 'JiraDatePickerField':
                        {
                            const parsedDate = field.date ? (0, $kQ82p.default)(field.date) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraDateTimePickerField':
                        {
                            const parsedDate = field.dateTime ? (0, $kQ82p.default)(field.dateTime) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraNumberField':
                        localMap.set(field.fieldId, field.number);
                        break;
                    case 'JiraPriorityField':
                        localMap.set(field.fieldId, field.priority?.priorityId);
                        break;
                    case 'JiraProjectField':
                        localMap.set(field.fieldId, field.project?.projectId);
                        break;
                    case 'JiraSingleVersionPickerField':
                        localMap.set(field.fieldId, field.version?.versionId);
                        break;
                    case 'JiraIssueTypeField':
                        localMap.set(field.fieldId, field.issueType?.issueTypeId);
                        break;
                    case 'JiraStatusField':
                        localMap.set(field.fieldId, field.status?.statusId);
                        break;
                    case 'JiraMultipleSelectUserPickerField':
                        {
                            const ids = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node?.accountId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSprintField':
                        {
                            const ids = field.selectedSprintsConnection?.edges?.map((edge)=>edge?.node?.sprintId).filter((sprintId)=>sprintId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraMultipleVersionPickerField':
                        {
                            const ids = field.selectedVersionsConnection?.edges?.map((edge)=>edge?.node?.versionId).filter((versionId)=>versionId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectField':
                        localMap.set(field.fieldId, field.selectedValue?.id);
                        break;
                    case 'JiraMultipleSelectField':
                        {
                            const ids = field.selectedValues?.edges?.map((edge)=>edge?.node?.id).filter((selectedValueId)=>selectedValueId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraRadioSelectField':
                        localMap.set(field.fieldId, field.selectedOption?.label);
                        break;
                    // TODO: Add all supported types value mapping
                    default:
                        break;
                }
            }));
        return localMap;
    }, [
        fields,
        isConditionalFormattingEnabled,
        rules
    ]);
    const formatRule = (0, $eJOHy.useMemo)(()=>{
        const formattingRulesEdges = rules?.conditionalFormattingRules?.edges;
        if (formattingRulesEdges == null || formattingRulesEdges.length === 0 || !isConditionalFormattingEnabled || valuesByFieldId == null) return null;
        for (const rule of formattingRulesEdges){
            const isRowRule = rule?.node?.formattingArea === 'ROW';
            const expression = rule?.node?.expression;
            const fieldId = expression?.fieldId;
            const value = expression?.value ?? expression?.values;
            const operator = expression?.noValueOperator ?? expression?.singleValueOperator ?? expression?.multipleValueOperator;
            if (fieldId && operator && isRowRule) {
                const fieldValue = valuesByFieldId.get(fieldId);
                const ruleResult = (0, $5d1YD.evaluateRule)(operator, fieldValue, value);
                if (ruleResult) return rule;
            }
        }
        return null;
    }, [
        valuesByFieldId,
        rules,
        isConditionalFormattingEnabled
    ]);
    const key = formatRule?.node?.formattingColor?.colorKey;
    if (!key) return null;
    return (0, $jUTKf.formattingColors)[key];
};

});
parcelRegister("anvM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fa3e1d93257c35a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3eda58044271bf52b5125f5a5ec9fb8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9fa3e1d93257c35a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useRowColor_project",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "singleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "multipleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "noValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    }
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "formattingArea"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "formattingColor",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "conditionalFormattingRules(first:20)"
            }
        ],
        "type": "JiraProject"
    };
}();
$9fa3e1d93257c35a$var$node.hash = "57c915e4d7afc473bd249e773dab24dd";
var $9fa3e1d93257c35a$export$2e2bcd8739ae039 = $9fa3e1d93257c35a$var$node;

});

parcelRegister("5AwTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3eb2ac9c778f780$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7375a226cb6d60cbb61e843960b812e9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f3eb2ac9c778f780$var$node = function() {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "versionId"
        }
    ], v4 = [
        v2 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useRowColor_fieldSets",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraComponentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedComponentsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraComponentEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponent",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "componentId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedComponentsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraComponentsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraLabelConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedLabelsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraLabelEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraLabel",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "name"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraLabelsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    v2 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraUserConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedUsersConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraUserEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v1 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "date"
                                                            }
                                                        ],
                                                        "type": "JiraDatePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "dateTime"
                                                            }
                                                        ],
                                                        "type": "JiraDateTimePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "number"
                                                            }
                                                        ],
                                                        "type": "JiraNumberField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraPriority",
                                                                "kind": "LinkedField",
                                                                "name": "priority",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "priorityId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraPriorityField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "projectId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraProjectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSprintConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedSprintsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprintEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSprint",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "sprintId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSprintField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "version",
                                                                "plural": false,
                                                                "selections": v3 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraVersionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedVersionsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersion",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v3 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedVersionsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraMultipleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "selectedValue",
                                                                "plural": false,
                                                                "selections": v4 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSelectableValueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedValues",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v4 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": "label",
                                                                        "kind": "ScalarField",
                                                                        "name": "value"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraRadioSelectField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$f3eb2ac9c778f780$var$node.hash = "d880826eebef6a2d391085138284697f";
var $f3eb2ac9c778f780$export$2e2bcd8739ae039 = $f3eb2ac9c778f780$var$node;

});



parcelRegister("2UC2O", function(module, exports) {

$parcel$export(module.exports, "RowsAdditionalContentRenderer", () => $b5c9fa9d7c18b82f$export$62e57fc2b6b904bc);

var $cbXkF = parcelRequire("cbXkF");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $6sUnz = parcelRequire("6sUnz");
const $b5c9fa9d7c18b82f$export$62e57fc2b6b904bc = ({ depth: depth, groupId: groupId, issues: issues, parentItemId: parentItemId })=>{
    let customComponents = null;
    if ((0, $7jTnu.fg)('jira_native_issue_table_extra_custom_components')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    customComponents = (0, $6sUnz.useCustomComponents)();
    const issuesData = (0, $j4oe4.useFragment)((0, $cbXkF.default), issues);
    return customComponents?.RowsAdditionalContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(customComponents.RowsAdditionalContent, {
        depth: depth,
        groupId: groupId,
        issues: issuesData,
        parentItemId: parentItemId
    });
};

});
parcelRegister("cbXkF", function(module, exports) {

$parcel$export(module.exports, "default", () => $009d3f74bcf5f7f7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc76f7be13cfddaddb707ddb49a5a00c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $009d3f74bcf5f7f7$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "rowsAdditionalContentRenderer_nativeIssueTable",
    "selections": [
        {
            "condition": "isTimelineEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "timelineRowsContent_issueTableTimeline"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$009d3f74bcf5f7f7$var$node.hash = "14936a88ab68218d38d76e038e65c173";
var $009d3f74bcf5f7f7$export$2e2bcd8739ae039 = $009d3f74bcf5f7f7$var$node;

});


parcelRegister("km3XC", function(module, exports) {

$parcel$export(module.exports, "VirtualizedRows", () => $ec1352550c791a56$export$bfdb633a3745996);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("gMNDC");
var $8GBQp = parcelRequire("8GBQp");

var $Kdcei = parcelRequire("Kdcei");

var $34oCh = parcelRequire("34oCh");
const $ec1352550c791a56$export$bfdb633a3745996 = ({ hasSpacers: hasSpacers, columnsCount: columnsCount, children: children })=>{
    const virtualizer = (0, $Kdcei.useVirtualization)();
    if (virtualizer == null) return children();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec1352550c791a56$var$VirtualizedRowsInner, {
        hasSpacers: hasSpacers,
        columnsCount: columnsCount,
        virtualizer: virtualizer
    }, children);
};
const $ec1352550c791a56$var$VirtualizedRowsInner = ({ hasSpacers: hasSpacers, columnsCount: columnsCount, virtualizer: virtualizer, children: children })=>{
    const virtualItemsMap = (0, $Kdcei.useVirtualItemsMap)();
    const virtualItemsMapRef = (0, $eJOHy.useRef)(virtualItemsMap);
    virtualItemsMapRef.current = virtualItemsMap;
    const isItemVirtual = (0, $eJOHy.useCallback)((key)=>Boolean(virtualItemsMapRef.current[key]), []);
    const items = virtualizer.getVirtualItems();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    // Calculates the height (top and bottom) of the non rendered portion of table
    const [before, after] = items.length > 0 ? [
        (0, $8GBQp.notUndefined)(items[0]).start - virtualizer.options.scrollMargin,
        virtualizer.getTotalSize() - (0, $8GBQp.notUndefined)(items.at(-1)).end
    ] : [
        0,
        0
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hasSpacers && before > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", {
        ...isGridNavigationEnabled && {
            'aria-hidden': true
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", {
        colSpan: columnsCount,
        // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
        style: {
            '--local-row-top-spacer-height': `${before}px`
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1m6g"
        ])
    })), children(isItemVirtual, virtualizer.measureElement), hasSpacers && after > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", {
        ...isGridNavigationEnabled && {
            'aria-hidden': true
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", {
        colSpan: columnsCount,
        // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
        style: {
            '--local-row-bottom-spacer-height': `${after}px`
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3ibvba"
        ])
    })));
};
const $ec1352550c791a56$var$virtualRowStyles = null;
const $ec1352550c791a56$var$virtualTopSpacerStyles = null;
const $ec1352550c791a56$var$virtualBottomSpacerStyles = null;

});
parcelRegister("gMNDC", function(module, exports) {

$parcel$export(module.exports, "defaultRangeExtractor", () => $c387a2210354f599$export$7eb7cb13fd21e5e1);
$parcel$export(module.exports, "observeElementRect", () => $c387a2210354f599$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $c387a2210354f599$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $c387a2210354f599$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $c387a2210354f599$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $c387a2210354f599$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $c387a2210354f599$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $c387a2210354f599$export$89be5a243e59c4b2);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("8GBQp")).notUndefined);

var $8GBQp = parcelRequire("8GBQp");
const $c387a2210354f599$export$76974b428a49f15b = (index)=>index;
const $c387a2210354f599$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $c387a2210354f599$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $c387a2210354f599$var$addEventListenerOptions = {
    passive: true
};
const $c387a2210354f599$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $c387a2210354f599$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $c387a2210354f599$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $c387a2210354f599$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $c387a2210354f599$var$supportsScrollend ? ()=>void 0 : (0, $8GBQp.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $c387a2210354f599$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $c387a2210354f599$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $c387a2210354f599$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $c387a2210354f599$var$supportsScrollend ? ()=>void 0 : (0, $8GBQp.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $c387a2210354f599$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $c387a2210354f599$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $c387a2210354f599$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $c387a2210354f599$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $c387a2210354f599$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $c387a2210354f599$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $c387a2210354f599$export$76974b428a49f15b,
                rangeExtractor: $c387a2210354f599$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $c387a2210354f599$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $8GBQp.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $8GBQp.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $8GBQp.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $8GBQp.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset()
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $c387a2210354f599$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $8GBQp.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $8GBQp.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $8GBQp.notUndefined)(measurements[$c387a2210354f599$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $8GBQp.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (toOffset <= scrollOffset) align = "start";
                else if (toOffset >= scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $8GBQp.notUndefined)(this.getOffsetForIndex(index, align));
                    if (!(0, $8GBQp.approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $c387a2210354f599$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $c387a2210354f599$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $c387a2210354f599$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("8GBQp", function(module, exports) {

$parcel$export(module.exports, "memo", () => $652f9a140a44b154$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $652f9a140a44b154$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $652f9a140a44b154$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $652f9a140a44b154$export$61fc7d43ac8f84b0);
function $652f9a140a44b154$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $652f9a140a44b154$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $652f9a140a44b154$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $652f9a140a44b154$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};

});



parcelRegister("8lwz0", function(module, exports) {

$parcel$export(module.exports, "VirtualizedRows", () => $b077d3ad26e98fb3$export$bfdb633a3745996);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("gMNDC");
var $8GBQp = parcelRequire("8GBQp");

var $Kdcei = parcelRequire("Kdcei");

var $jNv5I = parcelRequire("jNv5I");
function $b077d3ad26e98fb3$export$bfdb633a3745996({ children: children, renderRow: renderRow }) {
    const virtualItemsMap = (0, $Kdcei.useVirtualItemsMap)();
    const virtualizer = (0, $Kdcei.useVirtualization)();
    const { columns: columns } = (0, $jNv5I.useRowContext)();
    if (virtualizer == null) return children();
    const items = virtualizer.getVirtualItems();
    // Calculates the height (top and bottom) of the non rendered portion of table
    const [before, after] = items.length > 0 ? [
        (0, $8GBQp.notUndefined)(items[0]).start - virtualizer.options.scrollMargin,
        virtualizer.getTotalSize() - (0, $8GBQp.notUndefined)(items.at(-1)).end
    ] : [
        0,
        0
    ];
    const bottomStyle = {
        height: after
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, before > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", {
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", {
        colSpan: columns.length,
        style: {
            height: before
        }
    })), items.map((virtualRow)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            key: virtualRow.key
        }, renderRow(virtualRow.index, virtualizer.measureElement, virtualItemsMap))), after > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", {
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", {
        colSpan: columns.length,
        style: bottomStyle
    })));
}
const $b077d3ad26e98fb3$var$virtualRowStyles = null;

});



parcelRegister("jJgFJ", function(module, exports) {

$parcel$export(module.exports, "Header", () => $a8a4f36fd56f5577$export$8b251419efc915eb);

var $eUmui = parcelRequire("eUmui");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $j4oe4 = parcelRequire("j4oe4");

var $exQoy = parcelRequire("exQoy");

var $3nrCN = parcelRequire("3nrCN");

var $1l4lS = parcelRequire("1l4lS");

var $bGx3v = parcelRequire("bGx3v");

var $isfFo = parcelRequire("isfFo");

var $j8Km1 = parcelRequire("j8Km1");

var $9cbmy = parcelRequire("9cbmy");

var $bJscI = parcelRequire("bJscI");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $jE8Tu = parcelRequire("jE8Tu");

var $f2JN3 = parcelRequire("f2JN3");

var $fkKZD = parcelRequire("fkKZD");

var $8jOO7 = parcelRequire("8jOO7");

var $johMb = parcelRequire("johMb");

var $6sUnz = parcelRequire("6sUnz");

var $kbYhH = parcelRequire("kbYhH");

var $34oCh = parcelRequire("34oCh");

var $7n9BS = parcelRequire("7n9BS");

var $c4xBS = parcelRequire("c4xBS");

var $6UQ01 = parcelRequire("6UQ01");

var $3utN3 = parcelRequire("3utN3");
const $a8a4f36fd56f5577$var$BORDER_WIDTH = '1px';
const $a8a4f36fd56f5577$var$RESIZE_HANDLE_Z_INDEX = 1;
const $a8a4f36fd56f5577$var$MaybeInlineFieldCreateOnboardingProvider = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jira_inline_field_config_gate'), (0, $c4xBS.InlineFieldCreateOnboardingProvider), ({ children: children })=>children);
const $a8a4f36fd56f5577$var$baseHeaderContainerCellStyles = {
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $a8a4f36fd56f5577$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $a8a4f36fd56f5577$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-border-radius-200, 8px)"
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
        borderRightWidth: 0
    }
};
const $a8a4f36fd56f5577$var$baseHeaderContainerCellKeyboardStyles = {
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $a8a4f36fd56f5577$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $a8a4f36fd56f5577$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
        '&:focus::before': {
            left: '-1px',
            width: 'calc(100% + 3px)',
            height: 'calc(100% + 4px)',
            borderTopLeftRadius: "var(--ds-border-radius-200, 8px)"
        }
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
        borderRightWidth: 0,
        '&:focus::before': {
            borderTopRightRadius: "var(--ds-border-radius-200, 8px)"
        }
    },
    '&:focus': {
        outline: 'unset',
        '&:before': {
            content: ' ',
            boxSizing: 'border-box',
            display: 'block',
            position: 'absolute',
            height: 'calc(100% + 4px)',
            width: 'calc(100% + 5px)',
            inset: '0px',
            left: '-3px',
            top: '-2px',
            border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
        }
    }
};
const $a8a4f36fd56f5577$var$HEADER_HEIGHT = 40;
const $a8a4f36fd56f5577$var$STICKY_CELL_Z_INDEX = $a8a4f36fd56f5577$var$RESIZE_HANDLE_Z_INDEX + 1; // exported for testing purposes
const $a8a4f36fd56f5577$var$triggerColumnFlash = (table, index)=>{
    const columnCellsSelector = `th:nth-of-type(${index + 1}), td:nth-of-type(${index + 1})`;
    Array.from(table.querySelectorAll(columnCellsSelector)).filter((element)=>element instanceof HTMLElement).forEach((element)=>(0, $exQoy.triggerPostMoveFlash)(element));
};
const $a8a4f36fd56f5577$export$8b251419efc915eb = /*#__PURE__*/ (0, $eJOHy.memo)(({ view: view, columnPickerProps: columnPickerProps, columns: columns, canViewColumnConfiguration: canViewColumnConfiguration, canEditColumnConfiguration: canEditColumnConfiguration, isCompactColumnEnabled: isCompactColumnEnabled = false, resizeHandleType: resizeHandleType, onColumnsChange: onColumnsChange, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, tableRef: tableRef, tableBorderRadius: tableBorderRadius, showNoColumns: showNoColumns, resizingColumnIndex: resizingColumnIndex, setResizingColumnIndex: setResizingColumnIndex })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isRenderedInOverlay = (0, $34oCh.useIsRenderedInOverlay)();
    let customComponents = null;
    if ((0, $7jTnu.fg)('jira_native_issue_table_extra_custom_components')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    customComponents = (0, $6sUnz.useCustomComponents)();
    let isStickyColumnsVisible = false;
    if ((0, $7jTnu.fg)('issue_table_frozen_columns')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    const viewData = (0, $j4oe4.useFragment)((0, $eUmui.default), view ?? null); // Unique identifier for the header of this particular issue table instance
    const [instanceId] = (0, $eJOHy.useState)(()=>Symbol('pdnd-issue-table-header'));
    const [lastReorderOperation, setLastReorderOperation] = (0, $eJOHy.useState)(null);
    const [screenReaderMessage, setScreenReaderMessage] = (0, $eJOHy.useState)('');
    const reorderColumn = (0, $eJOHy.useCallback)(({ startIndex: startIndex, indexOfTarget: indexOfTarget, closestEdgeOfTarget: closestEdgeOfTarget = null, analyticsAttributes: analyticsAttributes = {} })=>{
        const finishIndex = (0, $1l4lS.getReorderDestinationIndex)({
            axis: 'horizontal',
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            closestEdgeOfTarget: closestEdgeOfTarget
        });
        if (startIndex === finishIndex) return;
        const newColumns = (0, $isfFo.reorder)({
            list: columns,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        onColumnsChange?.(newColumns);
        setLastReorderOperation({
            finishIndex: finishIndex
        });
        setScreenReaderMessage(formatMessage((0, $3utN3.default).movedColumn, {
            column: columns[startIndex]?.title,
            previousPosition: startIndex + 1,
            position: finishIndex + 1,
            // TODO: EM-7165 update to columns.length when excluding column picker
            total: columns.length - 1
        }));
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'reordered',
            actionSubject: 'columns'
        }), 'issueTable', analyticsAttributes);
    }, [
        columns,
        createAnalyticsEvent,
        formatMessage,
        onColumnsChange
    ]);
    const stickyColumnsWidth = (0, $7jTnu.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        let totalWidth = 0;
        columns.forEach((column)=>{
            const { id: id, isColumnSticky: isColumnSticky, defaultWidth: defaultWidth, customWidth: customWidth } = column;
            if (id === (0, $j8Km1.COLUMN_ID_CHECKBOX) || id === (0, $j8Km1.COLUMN_ID_EXPAND_BUTTON) || id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) || isColumnSticky) {
                if (id === (0, $j8Km1.COLUMN_ID_EXPAND_BUTTON)) totalWidth += defaultWidth + (0, $8jOO7.EXPAND_CELL_PADDING);
                else totalWidth += customWidth ?? defaultWidth;
            }
        });
        return totalWidth;
    }, [
        columns
    ]) : 0; // We use an object for lastReorderOperation so we can trigger the column flash
    // if the finish index is the same as the previous reorder operation.
    (0, $eJOHy.useEffect)(()=>{
        const table = tableRef?.current;
        if (table && lastReorderOperation !== null) $a8a4f36fd56f5577$var$triggerColumnFlash(table, lastReorderOperation.finishIndex);
    }, [
        lastReorderOperation,
        tableRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!canEditColumnConfiguration) return;
        return (0, $bGx3v.monitorForElements)({
            canMonitor ({ source: source }) {
                // Only monitor this particular instance id
                // (i.e. prevent monitoring entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            onDrop ({ source: source, location: location }) {
                const [destination] = location.current.dropTargets;
                if (!destination) return;
                const startIndex = columns.findIndex((column)=>column.id === source.data.id);
                if (startIndex === -1) return;
                const indexOfTarget = columns.findIndex((column)=>column.id === destination.data.id);
                if (indexOfTarget === -1) return;
                const closestEdgeOfTarget = (0, $3nrCN.extractClosestEdge)(destination.data);
                reorderColumn({
                    startIndex: startIndex,
                    indexOfTarget: indexOfTarget,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    analyticsAttributes: {
                        operation: 'drop'
                    }
                });
            }
        });
    }, [
        columns,
        canEditColumnConfiguration,
        instanceId,
        reorderColumn,
        tableRef
    ]);
    const onMoveColumn = (index, position)=>{
        if (canEditColumnConfiguration && onColumnsChange !== undefined) switch(position){
            case 0, $8jOO7.MOVE_COLUMN_FIRST:
                if (index > 0) {
                    let indexOfTarget = 0;
                    if ((0, $7jTnu.fg)('jira_list_merged_column_move_first')) indexOfTarget = columns.findIndex((column)=>column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) + 1;
                    reorderColumn({
                        startIndex: index,
                        indexOfTarget: indexOfTarget,
                        closestEdgeOfTarget: 'left',
                        analyticsAttributes: {
                            operation: 'move-first'
                        }
                    });
                }
                break;
            case 0, $8jOO7.MOVE_COLUMN_LEFT:
                if (index > 0) reorderColumn({
                    startIndex: index,
                    indexOfTarget: index - 1,
                    closestEdgeOfTarget: 'left',
                    analyticsAttributes: {
                        operation: 'move-left'
                    }
                });
                break;
            case 0, $8jOO7.MOVE_COLUMN_RIGHT:
                // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                if (index < columns.length - 2) reorderColumn({
                    startIndex: index,
                    indexOfTarget: index + 1,
                    closestEdgeOfTarget: 'right',
                    analyticsAttributes: {
                        operation: 'move-right'
                    }
                });
                break;
            case 0, $8jOO7.MOVE_COLUMN_LAST:
                // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                if (index < columns.length - 2) reorderColumn({
                    startIndex: index,
                    // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                    indexOfTarget: columns.length - 2,
                    closestEdgeOfTarget: 'right',
                    analyticsAttributes: {
                        operation: 'move-last'
                    }
                });
                break;
            default:
                throw new Error(`Unexpected target column position ${position}`);
        }
    };
    const onRemoveColumn = (index)=>{
        if (canEditColumnConfiguration && onColumnsChange !== undefined) {
            const newColumns = [
                ...columns
            ];
            newColumns.splice(index, 1);
            onColumnsChange(newColumns);
        }
    };
    const tableWidth = (0, $kbYhH.useElementSizeSelector)((size)=>size.width);
    const { hasShadowBottom: hasShadowBottom, hasShadowLeft: hasShadowLeft } = (0, $7n9BS.useScrollStateSelector)((scrollState)=>{
        const { scrollTop: scrollTop, scrollLeft: scrollLeft, width: containerWidth } = scrollState;
        return {
            hasShadowBottom: scrollTop > 0,
            // Scroll measurements are fractional, while width measurements are integer, so we need to round before comparing
            hasShadowLeft: containerWidth < tableWidth && Math.round(scrollLeft) < tableWidth - containerWidth
        };
    });
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $34oCh.useIsInBetweenColumnPickerEnabled)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    let visibleDepth = 0;
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    visibleDepth = (0, $jE8Tu.useVisibleDepth)();
    let isChildIssuesTableVisualUpliftEnabled = false;
    if ((0, $7jTnu.fg)('fg_visual_uplift_for_child_issues_table')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isChildIssuesTableVisualUpliftEnabled = (0, $34oCh.useIsChildIssuesTableVisualUpliftEnabled)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const handleDropdownStateChange = (isOpen)=>{
        setIsDropdownOpen(isOpen);
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, columns.map((column, index)=>{
        const { isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets } = column;
        const isExpandColumn = column.id === (0, $j8Km1.COLUMN_ID_EXPAND_BUTTON) && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes');
        const isMergedColumn = column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && (0, $7jTnu.fg)('jira_list_merged_column_gate');
        const isMeatballMenu = column.id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU);
        const defaultColumnWidth = column.customWidth ?? column.defaultWidth;
        const columnWidth = isExpandColumn || isMergedColumn ? (0, $johMb.getExpandColumnWidth)(visibleDepth) : defaultColumnWidth;
        let hasShadow = isExpandColumn ? false : canViewColumnConfiguration && hasShadowLeft;
        if ((0, $7jTnu.fg)('jira_list_merged_column_gate')) hasShadow = isMeatballMenu && canViewColumnConfiguration && hasShadowLeft;
        let customHeader = column.customHeader;
        if (isTimelineEnabled && customComponents?.timeline?.ColumnHeader && column.id === 'timeline') customHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(customComponents.timeline.ColumnHeader, null);
        return(// TODO: EM-7165 – refactor column picker logic, separating it from regular columns
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: column.id
        }, // Empty cell to fill remaining space if configured columns are not wide enough to fill the table
        isFixedTableLayoutEnabled && column.id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a8a4f36fd56f5577$var$EmptyHeaderCell, {
            isRenderedInOverlay: (0, $7jTnu.fg)('jira_jif_jam_fixes_fy26h1') && isRenderedInOverlay,
            "aria-hidden": true
        }), customHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a8a4f36fd56f5577$export$429fd509d8532e18, {
            scope: "col",
            columnWidth: columnWidth,
            // read as the column title when a user is navigating between columns in the table content.
            "aria-label": column.title,
            isSticky: canViewColumnConfiguration,
            hasShadow: hasShadow,
            visualRefresh: (0, $6XJko.isVisualRefreshEnabled)(),
            isCompactColumnEnabled: isCompactColumnEnabled,
            tableBorderRadius: tableBorderRadius,
            ...(0, $7jTnu.fg)('nin-grid-keyboard-navigation') && {
                tabIndex: index === 0 ? 0 : -1
            },
            ...(0, $7jTnu.fg)('issue_table_frozen_columns') && {
                isColumnSticky: isColumnSticky && isStickyColumnsVisible,
                stickyOffsets: stickyOffsets
            },
            isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
            isGridNavigationEnabled: isGridNavigationEnabled,
            isTimelineEnabled: isTimelineEnabled,
            isRenderedInOverlay: (0, $7jTnu.fg)('jira_jif_jam_fixes_fy26h1') && isRenderedInOverlay
        }, customHeader) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UQ01.HeaderCell), {
            column: column,
            hasColumnConfiguration: canEditColumnConfiguration,
            instanceId: instanceId,
            isCompactColumnEnabled: isCompactColumnEnabled,
            isFirst: index === 0,
            isLast: index === columns.length - 2,
            previousColumn: index === 0 ? undefined : columns[index - 1],
            resizeHandleType: resizeHandleType,
            tableRef: tableRef,
            tableBorderRadius: tableBorderRadius,
            onMoveColumn: (position)=>onMoveColumn(index, position),
            onDropdownStateChange: handleDropdownStateChange,
            onRemoveColumn: ()=>onRemoveColumn(index),
            onResizeColumn: onResizeColumn,
            onFreezeColumn: onFreezeColumn,
            index: index,
            ...isStickyColumnsVisible && (0, $7jTnu.fg)('issue_table_frozen_columns') && {
                stickyColumnsWidth: stickyColumnsWidth,
                resizingColumnIndex: resizingColumnIndex,
                setResizingColumnIndex: setResizingColumnIndex
            },
            ...(0, $7jTnu.fg)('nin-grid-keyboard-navigation') && {
                tabIndex: index === 0 ? 0 : -1
            },
            isRenderedInOverlay: (0, $7jTnu.fg)('jira_jif_jam_fixes_fy26h1') && isRenderedInOverlay
        })));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a8a4f36fd56f5577$var$MaybeInlineFieldCreateOnboardingProvider, null, isInBetweenColumnPickerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fkKZD.InsertColumnButton), {
        columns: columns,
        columnPickerProps: columnPickerProps,
        view: viewData
    }), (isInlineFieldConfigEnabled || isInBetweenColumnPickerEnabled) && !showNoColumns && (0, $7jTnu.fg)('jira_inline_field_config_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4xBS.InlineFieldCreateOnboarding), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderCaption), {
        "aria-live": "assertive",
        "data-testid": "native-issue-table.ui.issue-table.header.screen-reader-caption"
    }, screenReaderMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("thead", {
        className: (0, $hcewu.default)([
            (0, $7jTnu.fg)('issue_table_frozen_columns') ? "_kqsw1if8 _154iidpf _1pby11wp" : "_kqsw1if8 _154iidpf _1pbycs5v",
            isDropdownOpen && "_1pbyjwwv",
            hasShadowBottom && (0, $7jTnu.fg)('reduce_size_of_scroll_container_shadow') && "_16qs9g9j",
            hasShadowBottom && !(0, $7jTnu.fg)('reduce_size_of_scroll_container_shadow') && "_16qs1fgp"
        ])
    }, content));
});
const $a8a4f36fd56f5577$var$baseStickyHeaderStylesOld = null; // When a column is frozen, the table cell has z-index: 2. The header must have a higher z-index(3) to avoid being visually covered by the cell during vertical scrolling.
const $a8a4f36fd56f5577$var$baseStickyHeaderStyles = null;
const $a8a4f36fd56f5577$var$increasedZIndexStyles = null; // remove when cleaning up reduce_size_of_scroll_container_shadow
const $a8a4f36fd56f5577$var$shadowStylesOld = null;
const $a8a4f36fd56f5577$var$shadowStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a8a4f36fd56f5577$var$HeaderCellContainerStyledCell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRenderedInOverlay: isRenderedInOverlay, tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, hasShadow: hasShadow, visualRefresh: visualRefresh, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, isTimelineEnabled: isTimelineEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $awdRS.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $awdRS.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $awdRS.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $awdRS.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_1u3z176": (0, $awdRS.default)(__cmplp.isRenderedInOverlay ? "var(--ds-background-neutral-hovered, #091E4224)" : "var(--ds-surface-hovered, #F1F2F4)"),
            "--_1vpctke": (0, $awdRS.default)(__cmplp.stickyOffsets, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1h6dmuej _1dqonqa1 _1rjcze3t _18zru2gc _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdpd34 _4x86pd34 _1nd4idpf _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isRenderedInOverlay ? "_bfhkm7j4" : "_bfhkqbzx",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3v656",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv1l64",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.isChildIssuesTableVisualUpliftEnabled && "_bfhkglyw _hr4jidpf",
            __cmplp.isTimelineEnabled && "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a8a4f36fd56f5577$var$HeaderCellContainerNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRenderedInOverlay: isRenderedInOverlay, isGridNavigationEnabled: isGridNavigationEnabled, tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, hasShadow: hasShadow, visualRefresh: visualRefresh, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, isTimelineEnabled: isTimelineEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $awdRS.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $awdRS.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $awdRS.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $awdRS.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_1u3z176": (0, $awdRS.default)(__cmplp.isRenderedInOverlay ? "var(--ds-background-neutral-hovered, #091E4224)" : "var(--ds-surface-hovered, #F1F2F4)"),
            "--_1vpctke": (0, $awdRS.default)(__cmplp.stickyOffsets, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1rjcze3t _18zru2gc _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isRenderedInOverlay ? "_bfhkm7j4" : "_bfhkqbzx",
            __cmplp.isGridNavigationEnabled ? "_1h6dmuej _1dqonqa1 _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _1rcdpd34 _1av71n1a _jrfr1p7v _1vhm1pbc _cdlnpd34 _4x86pd34 _1nd4idpf _1obqpd34 _nt751r31 _49pcn7od _1hvw1o36 _2qv9idpf _qzh6ugt7 _x7uvf705 _6i55usvi _1j5l1ule _1qtkstnw _1w0p1pbc _1814iopo _p0vij39m _1cl912gs" : "_1h6dmuej _1dqonqa1 _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _1rcdpd34 _4x86pd34 _1nd4idpf",
            __cmplp.isGridNavigationEnabled && "_nt751r31 _49pcn7od _1hvw1o36 _858upm4j _1ya5nqa1 _1mb8yh40",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3v656",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv1l64",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.isChildIssuesTableVisualUpliftEnabled && "_bfhkglyw _hr4jidpf",
            __cmplp.isTimelineEnabled && "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // Exported for testing
const $a8a4f36fd56f5577$export$429fd509d8532e18 = (0, $bJscI.componentWithFG)('nin-grid-keyboard-navigation', $a8a4f36fd56f5577$var$HeaderCellContainerNew, $a8a4f36fd56f5577$var$HeaderCellContainerStyledCell); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a8a4f36fd56f5577$var$EmptyHeaderCell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRenderedInOverlay: isRenderedInOverlay, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1h6dmuej _1dqonqa1 _uwhkidpf _1doct94y _t6vdidpf _hr4jidpf _1rcdpd34 _4x86pd34 _1nd4idpf",
            __cmplp.isRenderedInOverlay ? "_bfhkm7j4" : "_bfhkqbzx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eUmui", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f82cd8337af7e02$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<493243528ade0deddaa0f17548d2d63a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0f82cd8337af7e02$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "header_nativeIssueTable",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "insertColumnButton_nativeIssueTable_InsertColumnButtonInner"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$0f82cd8337af7e02$var$node.hash = "e49a5c95264b2ec1daf94b87c16f86ba";
var $0f82cd8337af7e02$export$2e2bcd8739ae039 = $0f82cd8337af7e02$var$node;

});

parcelRegister("fkKZD", function(module, exports) {

$parcel$export(module.exports, "InsertColumnButton", () => $ca243961982c200a$export$ce61804b1701b38c);

var $ky42C = parcelRequire("ky42C");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6G5P1 = parcelRequire("6G5P1");
var $8qmYl = parcelRequire("8qmYl");
var $azjc1 = parcelRequire("azjc1");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $PETi0 = parcelRequire("PETi0");

var $jE8Tu = parcelRequire("jE8Tu");

var $88wTt = parcelRequire("88wTt");

var $j8Km1 = parcelRequire("j8Km1");

var $c4xBS = parcelRequire("c4xBS");

var $johMb = parcelRequire("johMb");

var $6KVf0 = parcelRequire("6KVf0");


var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $7XD6x = parcelRequire("7XD6x");
// Height/width of the popup button
const $ca243961982c200a$var$DEFAULT_BUTTON_SIZE = 24;
// Height/width of the reference element the popup button is anchored to
const $ca243961982c200a$var$REFERENCE_SIZE = 1;
const $ca243961982c200a$var$constantModifiers = [
    {
        name: 'flip',
        enabled: false
    }
];
const $ca243961982c200a$export$96c0bbf49f7c219f = ({ view: view, columns: columns, columnPickerProps: columnPickerProps })=>{
    const [{ index: columnIndex }] = (0, $6KVf0.useInlineFieldCreateActiveIndex)();
    const [{ isOpen: isOpen }, { close: close }] = (0, $PETi0.useColumnPickerOpenState)();
    const { lockIndex: lockIndex, clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay, setIndex: setIndex, setIsHovered: setIsHovered, clearIsHovered: clearIsHovered } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const { showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding } = (0, $c4xBS.useInlineFieldCreateOnboardingContext)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const projectContext = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, $34oCh.useProjectContext)() : undefined;
    const viewData = (0, $j4oe4.useFragment)((0, $ky42C.default), view);
    let visibleDepth = 0;
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    visibleDepth = (0, $jE8Tu.useVisibleDepth)();
    let isMergedColumnEnabled = false;
    if ((0, $7jTnu.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    let isStickyColumnsVisible = false;
    if ((0, $7jTnu.fg)('issue_table_frozen_columns')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    const firstFieldColumnIndex = (0, $eJOHy.useMemo)(()=>{
        return columns.findIndex((column)=>!column.id.startsWith((0, $8jOO7.COLUMN_ID_INTERNAL_COLUMN))) - 1;
    }, [
        columns
    ]);
    const hasShownOnboarding = (0, $eJOHy.useRef)(false);
    const shouldShowOnboarding = showInlineFieldCreateOnboarding && !hasShownOnboarding.current;
    if (shouldShowOnboarding) {
        setIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74), firstFieldColumnIndex);
        lockIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
        hasShownOnboarding.current = true;
    }
    const columnsWidth = (0, $eJOHy.useMemo)(()=>columns.map((column)=>{
            if (column.id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON)) return (0, $johMb.getExpandColumnWidth)(visibleDepth);
            if (column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && column.mergedColumns && column.mergedColumns.length > 1 && (0, $7jTnu.fg)('jira_list_update_merged_cell_min_width')) return Math.max((0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH), column.customWidth ?? column.defaultWidth);
            return column.customWidth ?? column.defaultWidth;
        }), [
        columns,
        visibleDepth
    ]);
    const fixedColumnCount = (0, $eJOHy.useMemo)(()=>columns.filter((column)=>column.id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON) || column.id === (0, $8jOO7.COLUMN_ID_CHECKBOX) || column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) || isStickyColumnsVisible && column.isColumnSticky && (0, $7jTnu.fg)('issue_table_frozen_columns')).length, [
        columns,
        isStickyColumnsVisible
    ]);
    const mergedColumnsCount = isMergedColumnEnabled && (0, $7jTnu.fg)('jira_list_merged_column_gate') ? (columns.find((column)=>column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns ?? []).length : 0;
    const isEmptyColumnExist = columnsWidth.length - columns.length === 1;
    const insertButtonXOffset = (0, $eJOHy.useMemo)(()=>{
        if (columnIndex != null && columnsWidth.length > 0) return columnsWidth.slice(0, columnIndex + 1).reduce((acc, width)=>acc + width, -$ca243961982c200a$var$REFERENCE_SIZE);
        return 0;
    }, [
        columnIndex,
        columnsWidth
    ]);
    const finalOffset = (0, $eJOHy.useMemo)(()=>// Negatively offset the popup by the button + reference size to center the button on the secondary axis
        [
            insertButtonXOffset,
            (0, $8jOO7.INSERT_COLUMN_BUTTON_Y_OFFSET) - ($ca243961982c200a$var$DEFAULT_BUTTON_SIZE + $ca243961982c200a$var$REFERENCE_SIZE) / 2
        ], [
        insertButtonXOffset
    ]);
    const modifiers = (0, $eJOHy.useMemo)(()=>{
        // Adjust the overflow calculation for the primary axis so it is relative to the center of the button.
        const alongCenterOffset = -($ca243961982c200a$var$DEFAULT_BUTTON_SIZE / 2);
        // Retain the provided offset for the secondary axis
        const padding = {
            top: finalOffset[1],
            left: alongCenterOffset,
            right: alongCenterOffset
        };
        return [
            ...$ca243961982c200a$var$constantModifiers,
            {
                name: 'preventOverflow',
                options: {
                    mainAxis: true,
                    altAxis: true,
                    padding: padding,
                    altBoundary: true,
                    rootBoundary: 'viewport',
                    tether: false
                }
            },
            {
                name: 'eventListeners',
                options: {
                    // Only recompute position on scroll/resize events while the button is focused to reduce CPU load
                    scroll: isOpen,
                    resize: isOpen
                }
            }
        ];
    }, [
        finalOffset,
        isOpen
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        lockIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        lockIndex
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        !isOpen && clearIndexAfterDelay((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIndexAfterDelay,
        isOpen
    ]);
    const handlePickerMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsHovered((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        setIsHovered
    ]);
    const handlePickerMouseLeave = (0, $eJOHy.useCallback)(()=>{
        clearIsHovered((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIsHovered
    ]);
    const shouldNotShowInsertButton = (0, $eJOHy.useMemo)(()=>columnIndex == null || isEmptyColumnExist && columnIndex >= columnsWidth.length - 3 || // If an empty column exists, prevent inserting in the last two columns.
        columnIndex >= columnsWidth.length - 2 || // Prevent inserting on the left or right of the last column.
        columnIndex < fixedColumnCount - 1, [
        columnIndex,
        columnsWidth.length,
        fixedColumnCount,
        isEmptyColumnExist
    ]);
    if (shouldNotShowInsertButton) {
        if (!shouldShowOnboarding) {
            clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            close();
        }
    }
    if (columnPickerProps) {
        const { components: components, ...props } = columnPickerProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6G5P1.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $azjc1.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: [
                    $ca243961982c200a$var$referenceStyles,
                    $ca243961982c200a$var$visuallyHiddenStyles
                ],
                ref: ref
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qmYl.Popper), {
            placement: "bottom",
            offset: finalOffset,
            modifiers: modifiers
        }, ({ ref: ref, style: style })=>{
            const styleProps = {
                style: style
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                ref: ref,
                ...styleProps,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                xcss: [
                    $ca243961982c200a$var$buttonStyles,
                    shouldNotShowInsertButton && $ca243961982c200a$var$hideStyles
                ],
                backgroundColor: "color.background.input",
                testId: `native-issue-table.ui.issue-table.insert-column-button.popper${shouldNotShowInsertButton ? '-hidden' : ''}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88wTt.default), {
                ...props,
                view: viewData,
                components: {
                    ...components,
                    Footer: isInlineFieldConfigEnabled ? (0, $7XD6x.IFCFooter) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
                },
                columnInsertIndex: columnIndex != null ? columnIndex - fixedColumnCount + mergedColumnsCount + 1 : undefined,
                isInBetweenColumnPickerEnabled: true,
                showInlineFieldCreateOnboarding: columnIndex === firstFieldColumnIndex && showInlineFieldCreateOnboarding,
                onPickerMouseEnter: handlePickerMouseEnter,
                onPickerMouseLeave: handlePickerMouseLeave,
                isMergedColumnEnabled: isMergedColumnEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                projectContext: projectContext !== null && (0, $7jTnu.fg)('jira_inline_field_config_gate') ? projectContext : undefined
            }));
        }));
    }
    return null;
};
const $ca243961982c200a$export$ce61804b1701b38c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $PETi0.ColumnPickerContainer), {
        scope: (0, $8jOO7.COLUMN_PICKER_ADD_COLUMN_CONTAINER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ca243961982c200a$export$96c0bbf49f7c219f, props));
};
const $ca243961982c200a$var$buttonStyles = (0, $1DXK0.xcss)({
    zIndex: 'dialog'
});
const $ca243961982c200a$var$referenceStyles = (0, $1DXK0.xcss)({
    left: "var(--ds-space-0, 0px)",
    top: `${$ca243961982c200a$var$DEFAULT_BUTTON_SIZE / 2 + 2}px`
});
const $ca243961982c200a$var$hideStyles = (0, $1DXK0.xcss)({
    display: 'none'
});
const $ca243961982c200a$var$visuallyHiddenStyles = (0, $1DXK0.xcss)({
    width: '1px',
    height: '1px',
    padding: 'space.0',
    position: 'absolute',
    border: 'none',
    clipPath: 'rect(1px 1px 1px 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});

});
parcelRegister("ky42C", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bbd5f7af66344d7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c196f2a039d1b52e4b67c46dcfb0d613>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2bbd5f7af66344d7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "insertColumnButton_nativeIssueTable_InsertColumnButtonInner",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueTableColumnPicker_ColumnConfig_view"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$2bbd5f7af66344d7$var$node.hash = "3d1927e7dd84d7b6d57bfce1310de013";
var $2bbd5f7af66344d7$export$2e2bcd8739ae039 = $2bbd5f7af66344d7$var$node;

});

parcelRegister("c4xBS", function(module, exports) {

$parcel$export(module.exports, "InlineFieldCreateOnboardingProvider", () => $b87aababb5e9070a$export$de078953583b045f);
$parcel$export(module.exports, "useInlineFieldCreateOnboardingContext", () => $b87aababb5e9070a$export$9649d04db063d324);
$parcel$export(module.exports, "InlineFieldCreateOnboarding", () => $b87aababb5e9070a$export$f07afb14f98859fd);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $3cMgR = parcelRequire("3cMgR");

var $d2s5v = parcelRequire("d2s5v");

var $58yRG = parcelRequire("58yRG");

var $lRq8t = parcelRequire("lRq8t");

var $kEUB1 = parcelRequire("kEUB1");

var $9HHOs = parcelRequire("9HHOs");

var $9zZj0 = parcelRequire("9zZj0");

var $3CprG = parcelRequire("3CprG");

var $gZTP9 = parcelRequire("gZTP9");

var $2aY2d = parcelRequire("2aY2d");

var $6rftq = parcelRequire("6rftq");

var $6KVf0 = parcelRequire("6KVf0");


var $cKKo4 = parcelRequire("cKKo4");

var $i7jEw = parcelRequire("i7jEw");

var $lCPZ7 = parcelRequire("lCPZ7");

var $bgZld = parcelRequire("bgZld");

var $lXTaV = parcelRequire("lXTaV");
const $b87aababb5e9070a$export$7749a74b05b28c3e = 'issue-navigator-inline-field-create';
const $b87aababb5e9070a$var$STARGATE_URL = '/gateway/api';
const $b87aababb5e9070a$var$InlineFieldCreateOnboardingContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $b87aababb5e9070a$export$de078953583b045f = ({ children: children })=>{
    const [showInlineFieldCreateOnboarding, setShowInlineFieldCreateOnboarding] = (0, $eJOHy.useState)(false);
    const value = (0, $eJOHy.useMemo)(()=>({
            showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding,
            setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding
        }), [
        showInlineFieldCreateOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$InlineFieldCreateOnboardingContext.Provider, {
        value: value
    }, children);
};
const $b87aababb5e9070a$export$9649d04db063d324 = ()=>{
    const inlineFieldCreateOnboardingContext = (0, $eJOHy.useContext)($b87aababb5e9070a$var$InlineFieldCreateOnboardingContext);
    if (!inlineFieldCreateOnboardingContext) throw new Error('useInlineFieldCreateOnboardingContext must be used within a InlineFieldCreateOnboardingProvider');
    return inlineFieldCreateOnboardingContext;
};
const $b87aababb5e9070a$var$ConfigureFieldsOnboardingComponent = ({ setActiveSpotlight: setActiveSpotlight, isTMPAdmin: isTMPAdmin })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { clearIndex: clearIndex } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $b87aababb5e9070a$export$9649d04db063d324();
    const actions = isTMPAdmin ? [
        {
            text: formatMessage((0, $lXTaV.default).nextButtonText),
            onClick: ()=>{
                setActiveSpotlight(1);
                clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            }
        },
        {
            text: formatMessage((0, $lXTaV.default).createFieldDismiss),
            onClick: ()=>{
                setActiveSpotlight(null);
                setShowInlineFieldCreateOnboarding(false);
                clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            }
        }
    ] : [
        {
            text: formatMessage((0, $lXTaV.default).createFieldDismiss),
            onClick: ()=>{
                setActiveSpotlight(null);
                setShowInlineFieldCreateOnboarding(false);
                clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        pulse: true,
        messageId: "native-issue-table.ui.inline-field-create-onboarding.jira-spotlight.inline-field-create-onboarding-column-picker-button.in-between",
        messageType: "engagement",
        actions: actions,
        dialogWidth: 320,
        target: "inline-field-create-onboarding-column-picker-button.in-between",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($bgZld))) : (0, (/*@__PURE__*/$parcel$interopDefault($lCPZ7))),
        actionsBeforeElement: isTMPAdmin ? '1/2' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $lXTaV.default).inlineColumnCreateBody, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                weight: "bold"
            }, chunks)
    })));
};
const $b87aababb5e9070a$var$InlineFieldCreateOnboardingComponent = ({ setActiveSpotlight: setActiveSpotlight })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { clearIndex: clearIndex } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $b87aababb5e9070a$export$9649d04db063d324();
    if (!colorMode) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        pulse: true,
        messageId: "native-issue-table.ui.inline-field-create-onboarding.jira-spotlight.inline-field-create-onboarding-column-picker-button.default",
        messageType: "engagement",
        actions: [
            {
                text: formatMessage((0, $lXTaV.default).createFieldDismiss),
                onClick: ()=>{
                    setActiveSpotlight(null);
                    setShowInlineFieldCreateOnboarding(false);
                    clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
                }
            }
        ],
        dialogPlacement: "bottom right",
        dialogWidth: 320,
        target: "inline-field-create-onboarding-column-picker-button.default",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($i7jEw))) : (0, (/*@__PURE__*/$parcel$interopDefault($cKKo4))),
        actionsBeforeElement: "2/2"
    }, formatMessage((0, $lXTaV.default).createFieldBody));
};
const $b87aababb5e9070a$export$f07afb14f98859fd = ()=>{
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $b87aababb5e9070a$export$9649d04db063d324();
    const cloudId = (0, $kEUB1.useCloudId)();
    const [activeSpotlight, setActiveSpotlight] = (0, $eJOHy.useState)(null);
    const isSiteAdmin = (0, $gZTP9.useIsAdmin)();
    const isProjectAdmin = (0, $6rftq.useIsProjectAdmin)();
    const isTMP = (0, $2aY2d.useIsSimplifiedProject)();
    const isAdmin = isSiteAdmin || isProjectAdmin;
    const isTMPAdmin = isAdmin && isTMP;
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, $b87aababb5e9070a$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $7UDun.useCoordination)(coordinationClient, $b87aababb5e9070a$export$7749a74b05b28c3e);
    const hasShownOnboarding = (0, $eJOHy.useRef)(false);
    if (isEnrolled && !hasShownOnboarding.current) {
        setShowInlineFieldCreateOnboarding(true);
        stopEnrolment(false);
        setActiveSpotlight(0);
        hasShownOnboarding.current = true;
    }
    const renderActiveSpotlight = ()=>{
        const spotlights = isTMPAdmin ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$ConfigureFieldsOnboardingComponent, {
                key: "configure-fields",
                setActiveSpotlight: setActiveSpotlight,
                isTMPAdmin: true
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$InlineFieldCreateOnboardingComponent, {
                key: "inline-field-create",
                setActiveSpotlight: setActiveSpotlight
            })
        ] : [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$ConfigureFieldsOnboardingComponent, {
                key: "configure-fields",
                setActiveSpotlight: setActiveSpotlight
            })
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isEnrolled && activeSpotlight !== null && renderActiveSpotlight()));
};

});
parcelRegister("cKKo4", function(module, exports) {
module.exports = new URL("configure-fields-light.fd3f907d.png", import.meta.url).toString();

});

parcelRegister("i7jEw", function(module, exports) {
module.exports = new URL("configure-fields-dark.cda4df1f.png", import.meta.url).toString();

});

parcelRegister("lCPZ7", function(module, exports) {
module.exports = new URL("inline-column-create-light.25926891.png", import.meta.url).toString();

});

parcelRegister("bgZld", function(module, exports) {
module.exports = new URL("inline-column-create-dark.7d2ee1ec.png", import.meta.url).toString();

});

parcelRegister("lXTaV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b198919880e512f2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b198919880e512f2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createFieldBody: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.create-field-body",
        "defaultMessage": "Create and configure fields without leaving your view."
    },
    createFieldDismiss: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.create-field-dismiss",
        "defaultMessage": "Dismiss"
    },
    inlineColumnCreateBody: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.inline-column-create-body",
        "defaultMessage": "Select <b>+</b> to quickly add columns exactly where you want them."
    },
    nextButtonText: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.next-button-text",
        "defaultMessage": "Next"
    }
});

});



parcelRegister("6UQ01", function(module, exports) {

$parcel$export(module.exports, "HeaderCell", () => $16f432ebf3f5233a$export$efcbfab786023e1a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $aQK2r = parcelRequire("aQK2r");

var $6DCNy = parcelRequire("6DCNy");

var $12DRg = parcelRequire("12DRg");

var $3nrCN = parcelRequire("3nrCN");

var $igtYB = parcelRequire("igtYB");

var $dROq6 = parcelRequire("dROq6");

var $bGx3v = parcelRequire("bGx3v");

var $92EV7 = parcelRequire("92EV7");

var $aHiGM = parcelRequire("aHiGM");

var $ltpqI = parcelRequire("ltpqI");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $j8Km1 = parcelRequire("j8Km1");

var $7jTnu = parcelRequire("7jTnu");

var $6d9QY = parcelRequire("6d9QY");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $bJscI = parcelRequire("bJscI");


var $6KVf0 = parcelRequire("6KVf0");

var $8jOO7 = parcelRequire("8jOO7");

var $k1Whm = parcelRequire("k1Whm");

var $34oCh = parcelRequire("34oCh");

var $7n9BS = parcelRequire("7n9BS");

var $johMb = parcelRequire("johMb");

var $2cK5s = parcelRequire("2cK5s");

var $4G6Vc = parcelRequire("4G6Vc");

var $3R7ZX = parcelRequire("3R7ZX");
const $16f432ebf3f5233a$var$DRAG_PREVIEW_MAX_WIDTH = 260;
const $16f432ebf3f5233a$var$BORDER_WIDTH = '1px';
const $16f432ebf3f5233a$var$HEADER_HEIGHT = 40; // ensure that the resize handle displays above subsequent header cells, but that a sticky cell will display above the
// resize handle. Improper z-index may cause the resize handle to render _above_ the column picker.
const $16f432ebf3f5233a$var$RESIZE_HANDLE_Z_INDEX = 1;
const $16f432ebf3f5233a$var$STICKY_CELL_Z_INDEX = $16f432ebf3f5233a$var$RESIZE_HANDLE_Z_INDEX + 1;
const $16f432ebf3f5233a$var$BOUNDARY = 70;
const $16f432ebf3f5233a$var$MOUSE_MOVE_THROTTLE = 16;
const $16f432ebf3f5233a$export$efcbfab786023e1a = ({ column: column, hasColumnConfiguration: hasColumnConfiguration, instanceId: instanceId, isCompactColumnEnabled: isCompactColumnEnabled = false, isFirst: isFirst, isLast: isLast, previousColumn: previousColumn, resizeHandleType: resizeHandleType = (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT), tableRef: tableRef, onMoveColumn: onMoveColumnProp, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumnProp, onFreezeColumn: onFreezeColumnProp, index: index, tableBorderRadius: tableBorderRadius, onDropdownStateChange: onDropdownStateChange, stickyColumnsWidth: stickyColumnsWidth = 0, resizingColumnIndex: resizingColumnIndex, setResizingColumnIndex: setResizingColumnIndex })=>{
    const headerCellContainerRef = (0, $eJOHy.useRef)(null);
    const headerCellActionsTriggerRef = (0, $eJOHy.useRef)(null);
    const resizeHandleRef = (0, $eJOHy.useRef)(null);
    const isColumnResizingEnabled = (0, $34oCh.useIsColumnResizingEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $34oCh.useIsInBetweenColumnPickerEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    let isChildIssuesTableVisualUpliftEnabled = false;
    if ((0, $7jTnu.fg)('fg_visual_uplift_for_child_issues_table')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isChildIssuesTableVisualUpliftEnabled = (0, $34oCh.useIsChildIssuesTableVisualUpliftEnabled)();
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const handleDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        setIsDropdownOpen(isOpen);
        if (onDropdownStateChange) onDropdownStateChange(isOpen);
    }, [
        onDropdownStateChange
    ]);
    const [state, setState] = (0, $eJOHy.useState)({
        type: 'idle'
    });
    const [dropEdge, setDropEdge] = (0, $eJOHy.useState)(null);
    let clearIndex = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let setIndex = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let clearIndexAfterDelay = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let columnIndex;
    let isInlineFieldCreateHovered;
    if (isInBetweenColumnPickerEnabled) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ clearIndex: clearIndex, setIndex: setIndex, clearIndexAfterDelay: clearIndexAfterDelay } = (0, $6KVf0.useInlineCreateActiveIndexActions)());
        [{ index: columnIndex, isHovered: isInlineFieldCreateHovered }] = // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $6KVf0.useInlineFieldCreateActiveIndex)();
    }
    let isStickyColumnsVisible = false;
    if ((0, $7jTnu.fg)('issue_table_frozen_columns')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    const height = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.height);
    let scrollElement;
    let scrollLeft = 0;
    if ((0, $7jTnu.fg)('issue_table_frozen_columns')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        scrollElement = (0, $7n9BS.useScrollElement)(); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        scrollLeft = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.scrollLeft) || 0;
    }
    const scrollElementToLeft = (0, $7jTnu.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        return scrollElement?.getBoundingClientRect().left ?? 0;
    }, [
        scrollElement
    ]) : 0;
    const stickyBoundary = scrollElementToLeft + stickyColumnsWidth;
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            fieldType: column.type
        }), [
        column.type
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const throttledHandler = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((event)=>{
            if (!event.currentTarget) return;
            const rect = event.currentTarget.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const width = rect.right - rect.left;
            if (x < width / 2 && x <= $16f432ebf3f5233a$var$BOUNDARY && rect.left >= stickyBoundary) setIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74), index - 1);
            else if (x >= width / 2 && x >= width - $16f432ebf3f5233a$var$BOUNDARY) setIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74), index);
            else clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
        }, $16f432ebf3f5233a$var$MOUSE_MOVE_THROTTLE), [
        stickyBoundary,
        setIndex,
        index,
        clearIndex
    ]);
    const calculateColumnIndex = (0, $eJOHy.useCallback)(throttledHandler, [
        throttledHandler
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)((event)=>{
        if (event.target === resizeHandleRef.current) // prevent showing "hovered" state when only the resize handle is hovered
        return;
        setIsHovered(true);
    }, []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
        if (isInBetweenColumnPickerEnabled) clearIndexAfterDelay((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIndexAfterDelay,
        isInBetweenColumnPickerEnabled
    ]);
    const handleMouseMove = (0, $eJOHy.useCallback)((event)=>{
        event.persist(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (headerCellContainerRef.current?.contains(event.target)) calculateColumnIndex(event);
        else clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        calculateColumnIndex,
        clearIndex
    ]);
    const handleMouseClick = (0, $eJOHy.useCallback)((event)=>{
        if (event.target instanceof HTMLElement && headerCellContainerRef.current?.contains(event.target.closest('button'))) clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIndex
    ]); // #region Column reordering
    const onMoveColumn = (0, $eJOHy.useCallback)((position)=>{
        onMoveColumnProp(position);
        setIsHovered(false);
    }, [
        onMoveColumnProp
    ]);
    let isMergedColumnEnabled = false;
    if ((0, $7jTnu.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    const isMergedColumn = isMergedColumnEnabled && column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && (0, $7jTnu.fg)('jira_list_merged_column_gate');
    const isMultiColumnMergedCell = isMergedColumn && column.mergedColumns && column.mergedColumns.length > 1;
    (0, $eJOHy.useEffect)(()=>{
        const headerCellContainer = headerCellContainerRef.current;
        if (!hasColumnConfiguration || !headerCellContainer || isMergedColumn) return;
        return (0, $dROq6.combine)((0, $bGx3v.draggable)({
            element: headerCellContainer,
            getInitialData () {
                if (isStickyColumnsVisible) return {
                    operation: (0, $8jOO7.COLUMN_OPERATION_REORDER),
                    id: column.id,
                    instanceId: instanceId,
                    isColumnSticky: column.isColumnSticky
                };
                return {
                    operation: (0, $8jOO7.COLUMN_OPERATION_REORDER),
                    id: column.id,
                    instanceId: instanceId
                };
            },
            onDragStart () {
                setState({
                    type: 'reordering'
                });
            },
            onDrop () {
                setState({
                    type: 'idle'
                });
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                const headerCellWidth = headerCellContainer.getBoundingClientRect().width;
                (0, $aHiGM.setCustomNativeDragPreview)({
                    getOffset () {
                        return {
                            x: 20,
                            y: 20
                        };
                    },
                    render ({ container: container }) {
                        // Cause a React re-render to create portal synchronously
                        setState({
                            type: 'preview',
                            container: container,
                            previewWidth: Math.min(headerCellWidth, $16f432ebf3f5233a$var$DRAG_PREVIEW_MAX_WIDTH)
                        }); // Cause a React re-render to remove portal on cleanup
                        return ()=>setState({
                                type: 'reordering'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }), (0, $bGx3v.dropTargetForElements)({
            element: headerCellContainer,
            canDrop ({ source: source }) {
                if (isStickyColumnsVisible) // Only allow drops from the same instance id
                // (i.e. prevent dropping entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId && // Only allow columns to be dropped within their original section:
                // frozen columns into the frozen section, and unfrozen columns into the unfrozen section
                column.isColumnSticky === source.data.isColumnSticky;
                 // Only allow drops from the same instance id
                // (i.e. prevent dropping entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            getData ({ input: input, element: element }) {
                const data = {
                    id: column.id,
                    instanceId: instanceId
                };
                return (0, $3nrCN.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            onDrag ({ self: self }) {
                const closestEdge = (0, $3nrCN.extractClosestEdge)(self.data);
                if (!closestEdge) return;
                setDropEdge(closestEdge);
            },
            onDragLeave () {
                setDropEdge(null);
            },
            onDrop () {
                setDropEdge(null);
            }
        }), (0, $bGx3v.monitorForElements)({
            canMonitor ({ source: source }) {
                // Only monitor this particular instance id
                // (i.e. prevent monitoring entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            onDrag () {
                // Close the dropdown menu when a drag starts on any column
                setIsDropdownOpen(false);
            }
        }));
    }, [
        column.id,
        column.isColumnSticky,
        hasColumnConfiguration,
        instanceId,
        isMergedColumn,
        isStickyColumnsVisible
    ]);
    // #endregion
    // #region Column resizing
    const mergedCellColumnWidth = isMultiColumnMergedCell && (0, $7jTnu.fg)('jira_list_update_merged_cell_min_width') ? Math.max((0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH), column.customWidth ?? column.defaultWidth) : column.customWidth ?? column.defaultWidth;
    const columnCustomWidth = isMultiColumnMergedCell && (0, $7jTnu.fg)('jira_list_update_merged_cell_min_width') ? mergedCellColumnWidth : column.customWidth;
    const [componentColumnWidth, setComponentColumnWidth] = (0, $eJOHy.useState)(mergedCellColumnWidth);
    const prevColumnConfigCustomWidth = (0, $6d9QY.usePreviousWithInitial)(columnCustomWidth);
    const [isResizePopupOpen, setIsResizePopupOpen] = (0, $eJOHy.useState)(false);
    const ariaSortDirection = (sortOrder)=>{
        switch(sortOrder){
            case 0, $8jOO7.SORT_ASC:
                return 'ascending';
            case 0, $8jOO7.SORT_DESC:
                return 'descending';
            default:
                return 'none';
        }
    };
    const onResizeColumn = (0, $eJOHy.useCallback)((width, resizeMethod)=>{
        if (width === componentColumnWidth) // Skip state updates if column width has not changed
        return;
        setComponentColumnWidth(width);
        const resizeColumnId = column.resizeColumnId ?? column.id;
        onResizeColumnProp && onResizeColumnProp(resizeColumnId, width === column.defaultWidth ? undefined : width);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'column'
        }), 'issueTable', {
            ...analyticsAttributes,
            resizeMethod: resizeMethod,
            columnWidth: width
        });
    }, [
        componentColumnWidth,
        onResizeColumnProp,
        column.id,
        column.defaultWidth,
        column.resizeColumnId,
        createAnalyticsEvent,
        analyticsAttributes
    ]);
    const onFreezeColumn = (0, $eJOHy.useCallback)(()=>{
        onFreezeColumnProp && onFreezeColumnProp(column.id, true);
    }, [
        column.id,
        onFreezeColumnProp
    ]);
    const onUnfreezeColumn = (0, $eJOHy.useCallback)(()=>{
        onFreezeColumnProp && onFreezeColumnProp(column.id, false);
    }, [
        column.id,
        onFreezeColumnProp
    ]); // Header actions callbacks
    const onResizeColumnAction = (0, $eJOHy.useCallback)(()=>{
        setIsResizePopupOpen(true);
    }, []);
    const onResetColumnWidthAction = (0, $eJOHy.useCallback)(()=>{
        onResizeColumn(column.defaultWidth, 'reset');
    }, [
        onResizeColumn,
        column.defaultWidth
    ]); // Resize popup callbacks
    const onChangeResizePopup = (0, $eJOHy.useCallback)((width)=>{
        (0, $3R7ZX.setCssResizingWidth)(headerCellContainerRef.current, width);
    }, []);
    const isRenderedInOverlay = (0, $34oCh.useIsRenderedInOverlay)();
    const onCloseResizePopup = (0, $eJOHy.useCallback)((event, overrideKeyboardCheck)=>{
        setIsResizePopupOpen(false);
        (0, $3R7ZX.clearCssResizingWidth)(headerCellContainerRef.current); // Focus header cell actions trigger if the resize popup was closed by keyboard
        // navigation or an override was requested
        //
        // `event.detail` docs: https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
        // (click count is 0 when using keyboard to activate a button)
        if (overrideKeyboardCheck === true || event && event.detail === 0) requestAnimationFrame(()=>headerCellActionsTriggerRef.current?.focus());
    }, []);
    const onSubmitResizePopup = (0, $eJOHy.useCallback)((width)=>{
        onResizeColumn(width, 'popup'); // No event available from form submission. We will re-focus the actions
        // trigger because submit can't be triggerd by clicking outside of popup,
        // so don't have to worry about stealing focus from what the user clicked
        onCloseResizePopup(undefined, true);
    }, [
        onResizeColumn,
        onCloseResizePopup
    ]); // Resize handle callbacks
    const onMouseEnterResizeHandle = (0, $eJOHy.useCallback)((event)=>{
        // prevent showing the drag & drop/reorder hover effect when resizing
        setIsHovered(false);
        event.stopPropagation();
    }, []);
    const onMouseLeaveResizeHandle = (0, $eJOHy.useCallback)((event)=>{
        // restore header hover state if mouse exits into the header element
        if (state.type !== 'resizing' && (event.relatedTarget === headerCellContainerRef.current || event.relatedTarget instanceof Node && headerCellContainerRef.current?.contains(event.relatedTarget))) setIsHovered(true);
    }, [
        state.type
    ]); // Update column width state if a change is made in the column config
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('restore-default-width-in-issue-table')) {
            // Consider if `customWidth` doesn't exist, e.g., restore default columns is triggered
            // In this case, use the `defaultWidth` instead
            const nextColumnWidth = isMultiColumnMergedCell && (0, $7jTnu.fg)('jira_list_update_merged_cell_min_width') ? mergedCellColumnWidth : column.customWidth ?? column.defaultWidth;
            if (prevColumnConfigCustomWidth !== columnCustomWidth && componentColumnWidth !== columnCustomWidth && nextColumnWidth != null) {
                // Update merged cell width state if a change is made in the column config
                if (isMultiColumnMergedCell && (0, $7jTnu.fg)('jira_list_update_merged_cell_min_width')) setComponentColumnWidth(mergedCellColumnWidth);
                else setComponentColumnWidth(nextColumnWidth);
            }
        } else if (prevColumnConfigCustomWidth !== column.customWidth && componentColumnWidth !== column.customWidth && column.customWidth != null) setComponentColumnWidth(column.customWidth);
    }, [
        column.customWidth,
        column.defaultWidth,
        columnCustomWidth,
        componentColumnWidth,
        isMultiColumnMergedCell,
        mergedCellColumnWidth,
        prevColumnConfigCustomWidth
    ]);
    const setFocusNone = ()=>{
        /*
    	If drag ends, setFocusNone.
    	if drag never starts but mouse down then back up, setFocusNone.
    	Focus should be yielded back when dragging ends.
    */ if ((0, $7jTnu.fg)('nin-grid-keyboard-navigation')) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const focused = document.activeElement;
            if (!(focused instanceof HTMLElement)) return;
            focused.blur();
        }
    }; // Creates draggable resize handle
    (0, $eJOHy.useEffect)(()=>{
        const resizeHandle = resizeHandleRef.current;
        if (!resizeHandle || isResizePopupOpen) return;
        return (0, $bGx3v.draggable)({
            element: resizeHandle,
            getInitialData () {
                return {
                    operation: (0, $8jOO7.COLUMN_OPERATION_RESIZE),
                    id: column.id
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // we will be moving the line to indicate a drag
                // we can disable the native drag preview
                (0, $92EV7.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                }); // we don't want any native drop animation for when the user
                // does not drop on a drop target. we want the drag to finish immediately
                (0, $ltpqI.preventUnhandled).start();
            },
            onDragStart () {
                setState({
                    type: 'resizing'
                });
                if (column.isColumnSticky && (0, $7jTnu.fg)('issue_table_frozen_columns')) setResizingColumnIndex?.(index);
                 // Disable pointer events on the table while dragging in order to prevent buggy hover states in chrome
                // https://issues.chromium.org/issues/41129937#comment43
                (0, $3R7ZX.disableCssPointerEvents)(tableRef?.current);
            },
            onDrag ({ location: location }) {
                const proposedWidth = (0, $3R7ZX.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location,
                    isCompactColumnEnabled: isCompactColumnEnabled,
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                    isMultiColumnMergedCell: isMultiColumnMergedCell
                });
                if (tableRef && column.isColumnSticky && (0, $7jTnu.fg)('issue_table_frozen_columns')) {
                    const diffX = location.current.input.clientX - location.initial.input.clientX;
                    (0, $3R7ZX.setCssResizingOffset)(tableRef.current, Math.max(proposedWidth - componentColumnWidth, diffX));
                }
                (0, $3R7ZX.setCssResizingWidth)(headerCellContainerRef.current, proposedWidth);
            },
            onDrop ({ location: location }) {
                (0, $ltpqI.preventUnhandled).stop();
                setState({
                    type: 'idle'
                });
                if (tableRef && column.isColumnSticky && (0, $7jTnu.fg)('issue_table_frozen_columns')) {
                    setResizingColumnIndex?.(undefined);
                    (0, $3R7ZX.clearCssResizingOffset)(tableRef.current);
                }
                onResizeColumn((0, $3R7ZX.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location,
                    isCompactColumnEnabled: isCompactColumnEnabled,
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                    isMultiColumnMergedCell: isMultiColumnMergedCell
                }), 'drag-and-drop'); // Re-enable pointer events to restore normal behaviour
                // https://issues.chromium.org/issues/41129937#comment43
                (0, $3R7ZX.enableCssPointerEvents)(tableRef?.current);
                (0, $3R7ZX.clearCssResizingWidth)(headerCellContainerRef.current);
                setFocusNone();
            }
        });
    }, [
        isResizePopupOpen,
        column.id,
        componentColumnWidth,
        tableRef,
        onResizeColumn,
        isCompactColumnEnabled,
        column.type,
        isSingleLineRowHeightEnabled,
        index,
        column.isColumnSticky,
        setResizingColumnIndex,
        isMultiColumnMergedCell
    ]); // #endregion
    // #region Render
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$export$429fd509d8532e18, {
        ref: headerCellContainerRef,
        scope: "col",
        columnWidth: componentColumnWidth,
        minColumnWidth: !isColumnResizingEnabled ? column.customWidth : undefined,
        isDraggable: isMergedColumn ? false : hasColumnConfiguration,
        isHovered: isHovered,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        isFirst: isFirst,
        isLast: isLast,
        index: index,
        ...isInBetweenColumnPickerEnabled && !(column.isColumnSticky && (0, $7jTnu.fg)('issue_table_frozen_columns')) && {
            onMouseMove: handleMouseMove
        },
        ...(0, $7jTnu.fg)('jira_inline_field_config_gate') && {
            onClick: handleMouseClick
        },
        // read as the column title when a user is navigating between columns in the table content.
        "aria-label": column.title,
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)(),
        isCompactColumnEnabled: isCompactColumnEnabled,
        tableBorderRadius: tableBorderRadius,
        ...(0, $7jTnu.fg)('nin-grid-keyboard-navigation') && {
            tabIndex: index === 0 ? 0 : -1,
            isResizing: state.type === 'resizing'
        },
        ...(0, $7jTnu.fg)('issue_table_frozen_columns') && {
            isColumnSticky: column.isColumnSticky,
            stickyOffsets: column.stickyOffsets,
            hasRightShadow: column.isLastStickyColumn && scrollLeft > 0,
            isColumnResizing: column.isColumnSticky && (resizingColumnIndex ?? 0) < index
        },
        "aria-sort": (0, $7jTnu.fg)('nin-grid-keyboard-navigation') ? ariaSortDirection(column.currentSorting) : undefined,
        isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isRenderedInOverlay: (0, $7jTnu.fg)('jira_jif_jam_fixes_fy26h1') && isRenderedInOverlay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: state.type === 'reordering' && $16f432ebf3f5233a$var$reorderingStyles,
        testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-container-inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $16f432ebf3f5233a$var$overflowHiddenStyles
    }, column.warningText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k1Whm.default), {
        tooltip: column.warningText
    }), (0, $7jTnu.fg)('jira_list_merged_column_gate') && column.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$Title, null, column.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2cK5s.HeaderCellActions), {
        column: column,
        previousColumn: previousColumn,
        currentColumnWidth: componentColumnWidth,
        hasColumnConfiguration: isMergedColumn ? false : hasColumnConfiguration,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isCompactColumnEnabled: isCompactColumnEnabled,
        isHeaderCellHovered: isHovered,
        isFirst: isFirst,
        isLast: isLast,
        isOpen: isDropdownOpen,
        triggerRef: headerCellActionsTriggerRef,
        isMergedColumn: isMergedColumn,
        onMoveColumn: onMoveColumn,
        onOpenChange: handleDropdownOpenChange,
        onRemoveColumn: onRemoveColumn,
        onResizeColumn: onResizeColumnAction,
        onResetColumnWidth: onResetColumnWidthAction,
        onFreezeColumn: onFreezeColumn,
        onUnfreezeColumn: onUnfreezeColumn
    })), isColumnResizingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4G6Vc.ResizePopup), {
        columnTitle: column.title,
        initialWidth: componentColumnWidth,
        placement: "bottom-start",
        isOpen: isResizePopupOpen,
        isCompactColumnEnabled: isCompactColumnEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        trigger: $16f432ebf3f5233a$var$resizePopupTarget,
        onChange: onChangeResizePopup,
        onCancel: onCloseResizePopup,
        onSubmit: onSubmitResizePopup,
        ...(0, $7jTnu.fg)('jira_list_update_merged_cell_min_width') && {
            isMultiColumnMergedCell: isMultiColumnMergedCell
        }
    }), !isResizePopupOpen && (0, $7jTnu.fg)('use_native_css_to_set_column_resize_handle_height') && (()=>{
        const commonProps = {
            ref: resizeHandleRef,
            isActive: state.type === 'resizing' || columnIndex === index && isInlineFieldCreateHovered && (0, $7jTnu.fg)('jira_inline_field_config_gate'),
            onMouseEnter: onMouseEnterResizeHandle,
            onMouseLeave: onMouseLeaveResizeHandle,
            onDoubleClick: onResetColumnWidthAction,
            onMouseDown: ()=>{
                if ((0, $7jTnu.fg)('nin-grid-keyboard-navigation')) setState({
                    type: 'resizing'
                });
            },
            onMouseUp: ()=>{
                if ((0, $7jTnu.fg)('nin-grid-keyboard-navigation')) {
                    setFocusNone();
                    setState({
                        type: 'idle'
                    });
                }
            },
            'data-testid': 'native-issue-table.ui.issue-table.header.header-cell.resize-handle',
            'data-vc': 'native-issue-table-ui-resize-handle',
            ...isInBetweenColumnPickerEnabled && {
                onMouseMove: (e)=>e.stopPropagation()
            }
        };
        return resizeHandleType === (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizeHandleFullHeight, commonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizeHandleHeaderOnly, commonProps);
    })(), !isResizePopupOpen && !(0, $7jTnu.fg)('use_native_css_to_set_column_resize_handle_height') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizeHandleOld, {
        ref: resizeHandleRef,
        height: resizeHandleType === (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT) ? height : undefined,
        isActive: state.type === 'resizing' || columnIndex === index && isInlineFieldCreateHovered && (0, $7jTnu.fg)('jira_inline_field_config_gate'),
        onMouseEnter: onMouseEnterResizeHandle,
        onMouseLeave: onMouseLeaveResizeHandle,
        onMouseDown: ()=>{
            if ((0, $7jTnu.fg)('nin-grid-keyboard-navigation')) setState({
                type: 'resizing'
            });
        },
        onMouseUp: ()=>{
            if ((0, $7jTnu.fg)('nin-grid-keyboard-navigation')) {
                setFocusNone();
                setState({
                    type: 'idle'
                });
            }
        },
        onDoubleClick: onResetColumnWidthAction,
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.resize-handle",
        "data-vc": "native-issue-table-ui-resize-handle" /*
                                                                                                                                                                                    * Consumers may currently update non-visual styles dynamically based off height prop.
                                                                                                                                                                                    * Here we allow consumers to exclude the update of height styles from VC calculation.
                                                                                                                                                                                    * Learn more about why this has been introduced https://jplat.atlassian.net/browse/EM-9208
                                                                                                                                                                                    */ ,
        "data-vc-nvs": (0, $7jTnu.fg)('ignore_column_resize_handle'),
        ...isInBetweenColumnPickerEnabled && {
            onMouseMove: (e)=>e.stopPropagation()
        }
    })), dropEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$DropTarget, {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.drop-target",
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igtYB.DropIndicator), {
        edge: dropEdge,
        gap: $16f432ebf3f5233a$var$BORDER_WIDTH,
        type: "no-terminal"
    })), state.type === 'preview' && /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$DragPreview, {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.drag-preview",
        height: height,
        width: state.previewWidth
    }), state.container))); // #endregion
};
// #region Styles
/**
 * Invisible element to attach resizing popup to - the intermediate component is required to allow
 * passing the ref while blocking the other props from being passed to the underlying div.
 *
 * This is because the other props are intended for a trigger button, but we are only using this
 * for positioning pourposes.
 */ const $16f432ebf3f5233a$var$resizePopupTarget = ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizePopupTargetDiv, {
        ref: ref
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $16f432ebf3f5233a$var$ResizePopupTargetDiv = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbidpf _4t3iidpf _kqswstnw _1ltvidpf _94n517m2",
            __cmplp.className
        ])
    });
});
const $16f432ebf3f5233a$var$reorderingStyles = (0, $1DXK0.xcss)({
    opacity: 0.4
}); // Add overflow: hidden to the inline div so that the title can collapse its width if needed
// and give space to the right-hand side icons (sort/actions)
const $16f432ebf3f5233a$var$overflowHiddenStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});
const $16f432ebf3f5233a$var$baseHeaderContainerCellStyles = {
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-border-radius-200, 8px)"
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
        borderRightWidth: 0
    }
};
const $16f432ebf3f5233a$var$baseHeaderContainerCellKeyboardStyles = {
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    '&:focus': {
        outline: 'unset',
        borderRight: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
        boxShadow: `inset 0 2px 0 0 ${"var(--ds-border-focused, #388BFF)"}`,
        '&:before': {
            content: ' ',
            display: 'block',
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: '-3px',
            left: '-1px',
            right: '-1px',
            bottom: '-1px',
            border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
        }
    }
}; // TODO: some stopgaps have been introduced to facilitate landing column config which should be addressed in EM-7165
const $16f432ebf3f5233a$export$9042168979f79508 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isColumnResizing: isColumnResizing, hasRightShadow: hasRightShadow, hasShadow: hasShadow, visualRefresh: visualRefresh, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $awdRS.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $awdRS.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $awdRS.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $awdRS.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_hmx90c": (0, $awdRS.default)((0, $johMb.getColumnOffset)(__cmplp.stickyOffsets ?? 0, !!__cmplp.isColumnResizing))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1h6dmuej _1dqonqa1 _1rjcze3t _18zru2gc _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdpd34 _4x86pd34 _1nd4idpf _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3108i",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv5eq1",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.hasRightShadow && "_qc5o6vh0 _1qdg1osq _z0ai1y44 _aetrb3bt _1peq105o _3p6m1vpr _18postnw _32rx1lpd _15l2ze3t",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.isChildIssuesTableVisualUpliftEnabled && "_bfhkglyw _hr4jidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
const $16f432ebf3f5233a$export$9e6d1f7c4a75832 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRenderedInOverlay: isRenderedInOverlay, isGridNavigationEnabled: isGridNavigationEnabled, isResizing: isResizing, isFirst: isFirst, index: index, tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isColumnResizing: isColumnResizing, hasRightShadow: hasRightShadow, hasShadow: hasShadow, visualRefresh: visualRefresh, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $awdRS.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $awdRS.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $awdRS.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $awdRS.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_1u3z176": (0, $awdRS.default)(__cmplp.isRenderedInOverlay ? "var(--ds-background-neutral-hovered, #091E4224)" : "var(--ds-surface-hovered, #F1F2F4)"),
            "--_hmx90c": (0, $awdRS.default)((0, $johMb.getColumnOffset)(__cmplp.stickyOffsets ?? 0, !!__cmplp.isColumnResizing))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1rjcze3t _18zru2gc _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isRenderedInOverlay ? "_bfhkm7j4" : "_bfhkqbzx",
            __cmplp.isGridNavigationEnabled ? "_1h6dmuej _1dqonqa1 _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _nt751r31 _49pcn7od _1hvw1o36 _qzh6ugt7 _x7uvf705 _1j5l1ule _1qtkstnw _1w0p1osq _18141osq _1cl9j39m _p0vi1n1a _t0aw1n1a _eahy1n1a _7u4sugt7 _7ehi14bn" : "_1h6dmuej _1dqonqa1 _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _1rcdpd34 _4x86pd34 _1nd4idpf",
            __cmplp.isResizing && __cmplp.isGridNavigationEnabled && "_qzh6n7od _7u4sn7od _7ehin7od",
            __cmplp.isFirst && __cmplp.isGridNavigationEnabled && "_13lipd34 _qnecidpf",
            __cmplp.index === 2 && __cmplp.isGridNavigationEnabled && "_1n9didpf _12s81n1a _1hw81n1a _zzeu1n1a _1qc71hup",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3v656",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv5eq1",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.hasRightShadow && "_qc5o6vh0 _1qdg1osq _z0ai1y44 _aetrb3bt _1peq105o _3p6m1vpr _18postnw _32rx1lpd _15l2ze3t",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.isChildIssuesTableVisualUpliftEnabled && "_bfhkglyw _hr4jidpf",
            __cmplp.className
        ])
    });
});
const $16f432ebf3f5233a$export$429fd509d8532e18 = (0, $bJscI.componentWithFG)('nin-grid-keyboard-navigation', $16f432ebf3f5233a$export$9e6d1f7c4a75832, $16f432ebf3f5233a$export$9042168979f79508); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _u5f31b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$ResizeHandleFullHeight = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _4t3i1kxc _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhk1yqz" : "_bfhk18uv",
            !__cmplp.isActive && "_irr37jlr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$ResizeHandleHeaderOnly = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _4t3i1osq _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhk1yqz" : "_bfhk18uv",
            !__cmplp.isActive && "_irr37jlr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$ResizeHandleOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $awdRS.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhk1yqz" : "_bfhk18uv",
            __cmplp.height != null ? "_4t3it1jn" : "_4t3i1osq",
            !__cmplp.isActive && "_irr37jlr",
            __cmplp.className
        ])
    });
}); // Invisible box surrounding the full column for the `DropIndicator` to attach to
const $16f432ebf3f5233a$var$DropTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154ize3t _1ltvze3t _4t3i2nrh _1bsb1osq",
            __cmplp.className
        ])
    });
}); // Custom drag preview that looks like a ghost blue column
const $16f432ebf3f5233a$var$DragPreview = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`),
            "--_6f8077": (0, $awdRS.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoiti9 _1h6d1p6i _1dqonqa1 _189e1bk5 _4t3i2nrh _c71l1kxc _1bsb1hdq _bfhk7wq0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k1Whm", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d54147c849a5eab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jkYbX = parcelRequire("jkYbX");

var $k71qx = parcelRequire("k71qx");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");

var $i2rto = parcelRequire("i2rto");
const $0d54147c849a5eab$var$WarningIndicator = ({ tooltip: tooltip })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0d54147c849a5eab$var$WarningIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        label: formatMessage((0, $i2rto.default).warningLabel),
        color: "var(--ds-icon-warning, #E56910)",
        LEGACY_size: "small"
    })));
};
var $0d54147c849a5eab$export$2e2bcd8739ae039 = $0d54147c849a5eab$var$WarningIndicator;
const $0d54147c849a5eab$var$HEADER_CELL_HEIGHT = 3.5 * (0, $dPMMf.gridSize); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0d54147c849a5eab$var$WarningIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxv77o _4t3i1f4h _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i2rto", function(module, exports) {

$parcel$export(module.exports, "default", () => $072fd65944448136$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $072fd65944448136$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    warningLabel: {
        "id": "native-issue-table.common.warning-indicator.warning-label",
        "defaultMessage": "Warning"
    }
});

});


parcelRegister("2cK5s", function(module, exports) {

$parcel$export(module.exports, "HeaderCellActions", () => $5f46d7781007ccd9$export$1d48fcee1df11ffa);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $czQLf = parcelRequire("czQLf");

var $ieul7 = parcelRequire("ieul7");
const $5f46d7781007ccd9$export$1d48fcee1df11ffa = ({ column: column, previousColumn: previousColumn, currentColumnWidth: currentColumnWidth, hasColumnConfiguration: hasColumnConfiguration, isColumnResizingEnabled: isColumnResizingEnabled, isCompactColumnEnabled: isCompactColumnEnabled = false, isHeaderCellHovered: isHeaderCellHovered, isFirst: isFirst, isLast: isLast, isOpen: isOpen, triggerRef: triggerRef = null, isMergedColumn: isMergedColumn = false, onMoveColumn: onMoveColumn, onOpenChange: onOpenChange, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, onUnfreezeColumn: onUnfreezeColumn, onResetColumnWidth: onResetColumnWidth })=>{
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        setIsFocused(true);
    }, []);
    const onBlur = (0, $eJOHy.useCallback)(()=>{
        setIsFocused(false);
    }, []);
    const isSortable = column.onSortOrderChanged !== undefined && column.isSortable;
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    // Header actions width must be static when fixed table layout is disabled to prevent column
    // widths shifting as the user hovers the table header
    const isStaticWidth = !isFixedTableLayoutEnabled;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    let minimumColumnWidth;
    if (isMergedColumn && column.mergedColumns && column.mergedColumns.length > 1 && (0, $7jTnu.fg)('jira_list_update_merged_cell_min_width')) minimumColumnWidth = (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH);
    else minimumColumnWidth = isSingleLineRowHeightEnabled ? (0, $8jOO7.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $8jOO7.MINIMUM_COLUMN_WIDTH);
    if (!isSortable && !hasColumnConfiguration && !isColumnResizingEnabled) return null;
    const isMoreActionsVisible = isHeaderCellHovered || isOpen || isFocused;
    const isSorted = column.currentSorting === (0, $8jOO7.SORT_ASC) || column.currentSorting === (0, $8jOO7.SORT_DESC);
    const isSortVisible = isMoreActionsVisible || isSorted;
    const isSortOnlyAction = isSortable && !hasColumnConfiguration && !isColumnResizingEnabled;
    const sortButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $5f46d7781007ccd9$var$baseStyles,
            !isSortVisible && $5f46d7781007ccd9$var$hiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ieul7.SortButton), {
        column: column,
        onFocus: onFocus,
        onBlur: onBlur
    }));
    const moreActionsButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $5f46d7781007ccd9$var$baseStyles,
            !isMoreActionsVisible && $5f46d7781007ccd9$var$hiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $czQLf.MoreActions), {
        column: column,
        previousColumn: previousColumn,
        currentColumnWidth: currentColumnWidth,
        hasColumnConfiguration: hasColumnConfiguration,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isFirst: isFirst,
        isLast: isLast,
        isOpen: isOpen,
        triggerRef: triggerRef,
        isMergedColumn: isMergedColumn,
        onMoveColumn: onMoveColumn,
        onOpenChange: onOpenChange,
        onRemoveColumn: onRemoveColumn,
        onResizeColumn: onResizeColumn,
        onFreezeColumn: onFreezeColumn,
        onUnfreezeColumn: onUnfreezeColumn,
        onResetColumnWidth: onResetColumnWidth,
        onFocus: onFocus,
        onBlur: onBlur
    }));
    if (isSortOnlyAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $5f46d7781007ccd9$var$containerStyles,
            isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
        ]
    }, sortButton);
    if (!isSortable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $5f46d7781007ccd9$var$containerStyles,
            isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
        ]
    }, moreActionsButton);
    if (isCompactColumnEnabled && currentColumnWidth < minimumColumnWidth) {
        if (column.currentSorting !== (0, $8jOO7.SORT_NONE) && !isHeaderCellHovered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            xcss: [
                $5f46d7781007ccd9$var$containerStyles,
                isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
            ]
        }, sortButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            xcss: [
                $5f46d7781007ccd9$var$containerStyles,
                isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
            ]
        }, moreActionsButton);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: isStaticWidth ? 'end' : undefined,
        xcss: [
            $5f46d7781007ccd9$var$containerStyles,
            // Animate between single and all button width when sorted (only when in a dynamic layout)
            !isStaticWidth && isSorted && $5f46d7781007ccd9$var$singleButtonWidth,
            (isStaticWidth || isMoreActionsVisible) && $5f46d7781007ccd9$var$allButtonsWidth
        ]
    }, sortButton, moreActionsButton);
};
const $5f46d7781007ccd9$var$containerStyles = (0, $1DXK0.xcss)({
    gap: 'space.050',
    transition: 'width .25s'
});
const $5f46d7781007ccd9$var$singleButtonWidth = (0, $1DXK0.xcss)({
    width: '24px'
});
const $5f46d7781007ccd9$var$allButtonsWidth = (0, $1DXK0.xcss)({
    width: '52px'
});
const $5f46d7781007ccd9$var$baseStyles = (0, $1DXK0.xcss)({
    transition: 'opacity .25s'
});
const $5f46d7781007ccd9$var$hiddenStyles = (0, $1DXK0.xcss)({
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: 'space.negative.025',
    overflow: 'hidden',
    padding: 'space.0',
    opacity: 0,
    position: 'absolute',
    pointerEvents: 'none'
});

});
parcelRegister("czQLf", function(module, exports) {

$parcel$export(module.exports, "MoreActions", () => $356971f4066577c6$export$f2f44eb5b71ba65f);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $NByNW = parcelRequire("NByNW");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $iO13U = parcelRequire("iO13U");

var $1kTzc = parcelRequire("1kTzc");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $2ZGUP = parcelRequire("2ZGUP");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $jd93d = parcelRequire("jd93d");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $lpMrC = parcelRequire("lpMrC");

var $j8Km1 = parcelRequire("j8Km1");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $pZqvR = parcelRequire("pZqvR");

var $cEWre = parcelRequire("cEWre");

var $fn6we = parcelRequire("fn6we");

var $9sCxj = parcelRequire("9sCxj");
const $356971f4066577c6$var$NestedSortingDropdown = ({ column: column, customMessage: customMessage, onOpenChange: onOpenChange })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const sortAsc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_ASC), (0, $7jTnu.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
        onOpenChange(false);
    }, [
        column,
        onOpenChange
    ]);
    const sortDesc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_DESC), (0, $7jTnu.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
        onOpenChange(false);
    }, [
        column,
        onOpenChange
    ]);
    let title = column.title;
    if (column.currentSorting === (0, $8jOO7.SORT_ASC) && column.ascText) title = `${column.title}: ${formatMessage((0, $9sCxj.default).sortDirection, {
        sortDescription: column.ascText
    })}`;
    else if (column.currentSorting === (0, $8jOO7.SORT_DESC) && column.descText) title = `${column.title}: ${formatMessage((0, $9sCxj.default).sortDirection, {
        sortDescription: column.descText
    })}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        placement: "right-start",
        // We should also enable shouldRenderToParent only in Chrome nested dropdown menu.
        // Mismatched `shouldRenderToParent` settings between parent and nested dropdowns
        // can break the nested menu behavior.
        shouldRenderToParent: (0, $7jTnu.fg)('jira_list_merged-cell_sort_firefox_safari') ? (0, $lpMrC.isChrome)() : true,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
                ...triggerProps,
                ref: triggerRef,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kTzc))), {
                    LEGACY_size: "small",
                    size: "small",
                    spacing: "spacious",
                    label: ""
                })
            }, title)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortAsc",
        onClick: sortAsc,
        isSelected: column.currentSorting === (0, $8jOO7.SORT_ASC),
        fieldType: column.type
    }, column.ascText ?? false ? formatMessage(customMessage, {
        sortDescription: column.ascText
    }) : formatMessage((0, $9sCxj.default).sortAsc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortDesc",
        onClick: sortDesc,
        isSelected: column.currentSorting === (0, $8jOO7.SORT_DESC),
        fieldType: column.type
    }, column.descText ?? false ? formatMessage(customMessage, {
        sortDescription: column.descText
    }) : formatMessage((0, $9sCxj.default).sortDesc))));
};
const $356971f4066577c6$export$f2f44eb5b71ba65f = ({ column: column, previousColumn: previousColumn, currentColumnWidth: currentColumnWidth, hasColumnConfiguration: hasColumnConfiguration, isColumnResizingEnabled: isColumnResizingEnabled, isMergedColumn: isMergedColumn, isFirst: isFirst, isLast: isLast, isOpen: isOpen, triggerRef: triggerRef = null, onMoveColumn: onMoveColumn, onOpenChange: onOpenChange, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, onUnfreezeColumn: onUnfreezeColumn, onResetColumnWidth: onResetColumnWidth, onFocus: onFocus, onBlur: onBlur })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const { ifcConfig: ifcConfig } = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $pZqvR.useIFCConfigContext)() : {
        ifcConfig: null
    };
    const editField = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cEWre.useIFCEditField)() : undefined;
    const sortAsc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_ASC), (0, $7jTnu.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column
    ]);
    const sortDesc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_DESC), (0, $7jTnu.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column
    ]);
    const clearSorting = (0, $eJOHy.useCallback)(()=>{
        if (isMergedColumn) column.mergedColumns?.forEach((mergedColumn)=>{
            if (mergedColumn.currentSorting && mergedColumn.currentSorting !== (0, $8jOO7.SORT_NONE)) mergedColumn.onSortOrderChanged?.(mergedColumn.jqlTerm, (0, $8jOO7.SORT_NONE), (0, $7jTnu.fg)('jsc_list_reranking_ast_refactor') ? mergedColumn.aliases : undefined);
        });
        else column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_NONE), (0, $7jTnu.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column,
        isMergedColumn
    ]);
    const handleOnOpenChange = (0, $eJOHy.useCallback)(({ isOpen: newIsOpen })=>{
        if (newIsOpen) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        }), 'issueTableHeaderActions');
        onOpenChange(newIsOpen);
    }, [
        createAnalyticsEvent,
        onOpenChange
    ]);
    const mergedColumns = column.mergedColumns ?? [];
    const shouldShowNestedSorting = Boolean(isMergedColumn && mergedColumns.length > 1);
    const fieldType = Boolean(isMergedColumn) && mergedColumns.length === 1 && (0, $7jTnu.fg)('jira_list_merged_column_gate') ? mergedColumns[0]?.type : undefined;
    const isColumnSortable = (0, $eJOHy.useCallback)((col)=>Boolean(!!col.onSortOrderChanged && col.isSortable), []);
    let isSortable = isColumnSortable(column);
    if ((0, $7jTnu.fg)('jira_list_merged_column_gate')) isSortable = isColumnSortable(column) || Boolean(isMergedColumn && !shouldShowNestedSorting && column.mergedColumns?.some(isColumnSortable));
    let isMergedColumnEnabled = false;
    if ((0, $7jTnu.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    let canMoveColumnLeft = true;
    if (isMergedColumnEnabled && previousColumn) canMoveColumnLeft = previousColumn?.id !== (0, $j8Km1.COLUMN_ID_MERGED_COLUMN);
    const triggerLabel = formatMessage((0, $9sCxj.default).columnActions, {
        column: column.title
    });
    // Ensure a stable ref function is passed through to the trigger button
    const memoizedMergeRefs = (0, $eJOHy.useMemo)(()=>(0, $LFmXM.default)((0, $jd93d.mergeRefs)), []);
    const customMessage = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, $9sCxj.default).sortCustomNew : (0, $9sCxj.default).sortCustom;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        placement: "bottom-start",
        trigger: ({ triggerRef: dropdownTriggerRef, ...triggerProps })=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...triggerProps,
                ref: memoizedMergeRefs(dropdownTriggerRef, triggerRef),
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: triggerLabel,
                onFocus: onFocus,
                onBlur: onBlur,
                isTooltipDisabled: false,
                spacing: "compact",
                appearance: "subtle",
                testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-actions.more-actions.icon-button"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: triggerLabel,
                delay: 0,
                ignoreTooltipPointerEvents: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $356971f4066577c6$var$triggerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                ref: memoizedMergeRefs(dropdownTriggerRef, triggerRef),
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iO13U))), {
                    label: triggerLabel,
                    LEGACY_size: "small"
                }),
                onFocus: onFocus,
                onBlur: onBlur
            }))),
        // We should only enable shouldRenderToParent in Chrome.
        // Safari and Firefox can clip elements inside a `position: sticky` container if the container isn’t tall enough.
        // This affects dropdowns rendered inside sticky table headers.
        shouldRenderToParent: (0, $lpMrC.isChrome)()
    }, isSortable && !shouldShowNestedSorting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, column.currentSorting !== (0, $8jOO7.SORT_ASC) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortAsc",
        onClick: sortAsc,
        fieldType: fieldType
    }, column.ascText ?? false ? formatMessage(customMessage, {
        sortDescription: column.ascText
    }) : formatMessage((0, $9sCxj.default).sortAsc)), column.currentSorting !== (0, $8jOO7.SORT_DESC) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortDesc",
        onClick: sortDesc,
        fieldType: fieldType
    }, column.descText ?? false ? formatMessage(customMessage, {
        sortDescription: column.descText
    }) : formatMessage((0, $9sCxj.default).sortDesc)), column.currentSorting !== (0, $8jOO7.SORT_NONE) && (0, $7jTnu.fg)('jsc_list_reranking_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "clearSorting",
        onClick: clearSorting,
        fieldType: fieldType
    }, formatMessage((0, $9sCxj.default).clearSorting))), shouldShowNestedSorting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        title: formatMessage((0, $9sCxj.default).sortByColumns)
    }, mergedColumns.map((mergedColumn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($356971f4066577c6$var$NestedSortingDropdown, {
            key: mergedColumn.id,
            column: mergedColumn,
            customMessage: customMessage,
            onOpenChange: onOpenChange
        })), mergedColumns.some((col)=>col.currentSorting && col.currentSorting !== (0, $8jOO7.SORT_NONE)) && (0, $7jTnu.fg)('jsc_list_reranking_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "clearSorting",
        onClick: clearSorting
    }, formatMessage((0, $9sCxj.default).clearSorting))), hasColumnConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: isSortable
    }, !isFirst && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (!isMergedColumnEnabled || canMoveColumnLeft && (0, $7jTnu.fg)('jira_list_merged_column_move_first')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnFirst",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_FIRST))
    }, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveFirstNew) : formatMessage((0, $9sCxj.default).moveFirst)), canMoveColumnLeft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnLeft",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_LEFT))
    }, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveLeftNew) : formatMessage((0, $9sCxj.default).moveLeft))), !isLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnRight",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_RIGHT))
    }, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveRightNew) : formatMessage((0, $9sCxj.default).moveRight)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnLast",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_LAST))
    }, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveLastNew) : formatMessage((0, $9sCxj.default).moveLast))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "removeColumn",
        onClick: onRemoveColumn
    }, formatMessage((0, $9sCxj.default).removeColumn))), isMergedColumn && (0, $7jTnu.fg)('issue_table_frozen_columns') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: isSortable || hasColumnConfiguration || shouldShowNestedSorting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: column.isColumnSticky ? 'unfreezeColumn' : 'freezeColumn',
        onClick: column.isColumnSticky ? onUnfreezeColumn : onFreezeColumn
    }, formatMessage(column.isColumnSticky ? (0, $9sCxj.default).unfreezeColumn : (0, $9sCxj.default).freezeColumn))), isColumnResizingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: isMergedColumn && (0, $7jTnu.fg)('issue_table_frozen_columns') ? false : isSortable || hasColumnConfiguration || shouldShowNestedSorting
    }, isMergedColumn && (0, $7jTnu.fg)('issue_table_frozen_columns'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "resizeColumn",
        onClick: onResizeColumn
    }, formatMessage((0, $9sCxj.default).resizeColumn)), currentColumnWidth != null && currentColumnWidth !== column.defaultWidth && !isMergedColumn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "resetColumnWidth",
        onClick: onResetColumnWidth
    }, formatMessage((0, $9sCxj.default).resetColumnWidth))), isInlineFieldConfigEnabled && column.configureableFieldId && ifcConfig?.IFCTriggerRef && editField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ifcConfig.IFCTriggerRef, null, ({ triggerRef: ifcTriggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
            ref: ifcTriggerRef,
            actionType: "editField",
            onClick: ()=>{
                if (column.configureableFieldId) editField(column.configureableFieldId, column.id);
            }
        }, formatMessage((0, $9sCxj.default).editField)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null));
};
const $356971f4066577c6$var$triggerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    height: '24px',
    width: '24px'
});

});
parcelRegister("iO13U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7b9c6249a1eec95e276a40edfd26c3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db0db86a05776a04$var$_react = $db0db86a05776a04$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $db0db86a05776a04$var$_showMoreVertical = $db0db86a05776a04$var$_interopRequireDefault((parcelRequire("xEGV6")));

var $db0db86a05776a04$var$_moreVertical = $db0db86a05776a04$var$_interopRequireDefault((parcelRequire("4w7Cf")));
function $db0db86a05776a04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreVerticalIcon.
 * This component is ShowMoreVerticalIcon, with `UNSAFE_fallbackIcon` set to "MoreVerticalIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db0db86a05776a04$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $db0db86a05776a04$var$_react.default.createElement($db0db86a05776a04$var$_showMoreVertical.default, Object.assign({
        LEGACY_fallbackIcon: $db0db86a05776a04$var$_moreVertical.default
    }, props));
$db0db86a05776a04$var$ShowMoreVerticalIcon.Name = 'ShowMoreVerticalIconMigration';
var $db0db86a05776a04$var$_default = module.exports.default = $db0db86a05776a04$var$ShowMoreVerticalIcon;

});
parcelRegister("xEGV6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02df73cd5dddff20d82e48f58fe7ce92>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0652a59e631f32d8$var$_react = $0652a59e631f32d8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0652a59e631f32d8$var$_baseNew = $0652a59e631f32d8$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0652a59e631f32d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0652a59e631f32d8$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $0652a59e631f32d8$var$_react.default.createElement($0652a59e631f32d8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$0652a59e631f32d8$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $0652a59e631f32d8$var$_default = module.exports.default = $0652a59e631f32d8$var$ShowMoreVerticalIcon;

});

parcelRegister("4w7Cf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34a00ef2346235e7$var$_react = $34a00ef2346235e7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $34a00ef2346235e7$var$_showMoreVertical = $34a00ef2346235e7$var$_interopRequireDefault((parcelRequire("xEGV6")));
function $34a00ef2346235e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $34a00ef2346235e7$var$MoreVerticalIcon = (props)=>/*#__PURE__*/ $34a00ef2346235e7$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="12" cy="19" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/></g></svg>`
    }, props, {
        newIcon: $34a00ef2346235e7$var$_showMoreVertical.default
    }));
$34a00ef2346235e7$var$MoreVerticalIcon.displayName = 'MoreVerticalIcon';
var $34a00ef2346235e7$var$_default = module.exports.default = $34a00ef2346235e7$var$MoreVerticalIcon;

});


parcelRegister("fn6we", function(module, exports) {

$parcel$export(module.exports, "ActionItem", () => $b29831993dcd24a9$export$ac06cb4ab481cfab);

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");
const $b29831993dcd24a9$export$841c406d190a3baa = ({ actionType: actionType, fieldType: fieldType, children: children, isSelected: isSelected = false, onClick: onClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'issueTableHeaderActions', {
            actionType: actionType,
            fieldType: (0, $7jTnu.fg)('jira_list_merged_column_gate') ? fieldType : undefined
        });
        onClick();
    }, [
        actionType,
        fieldType,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: handleOnClick,
        isSelected: isSelected
    }, children);
};
const $b29831993dcd24a9$export$ec2208c4baf896f0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ actionType: actionType, fieldType: fieldType, children: children, isSelected: isSelected = false, onClick: onClick }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'issueTableHeaderActions', {
            actionType: actionType,
            fieldType: (0, $7jTnu.fg)('jira_list_merged_column_gate') ? fieldType : undefined
        });
        onClick();
    }, [
        actionType,
        fieldType,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        ref: ref,
        onClick: handleOnClick,
        isSelected: isSelected
    }, children);
});
const $b29831993dcd24a9$export$ac06cb4ab481cfab = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jira_inline_field_config_gate'), $b29831993dcd24a9$export$ec2208c4baf896f0, $b29831993dcd24a9$export$841c406d190a3baa);

});

parcelRegister("9sCxj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cda8b0f41e72a74$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6cda8b0f41e72a74$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    columnActions: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.column-actions",
        "defaultMessage": "More actions for {column}"
    },
    sortAsc: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-asc",
        "defaultMessage": "Sort in ascending order"
    },
    sortDesc: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-desc",
        "defaultMessage": "Sort in descending order"
    },
    sortCustom: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-custom",
        "defaultMessage": "Sort {sortDescription}"
    },
    sortCustomNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-custom-new",
        "defaultMessage": "Sort {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    sortDirection: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-direction",
        "defaultMessage": "{sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    clearSorting: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.clear-sorting",
        "defaultMessage": "Clear sorting"
    },
    sortByColumns: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-by-columns",
        "defaultMessage": "Sort by columns"
    },
    moveFirst: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-first",
        "defaultMessage": "Move column to the first position"
    },
    moveLeft: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-left",
        "defaultMessage": "Move column to the left"
    },
    moveRight: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-right",
        "defaultMessage": "Move column to the right"
    },
    moveLast: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-last",
        "defaultMessage": "Move column to the last position"
    },
    moveFirstNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-first-new",
        "defaultMessage": "Move column to first position"
    },
    moveLeftNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-left-new",
        "defaultMessage": "Move column to left"
    },
    moveRightNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-right-new",
        "defaultMessage": "Move column to right"
    },
    moveLastNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-last-new",
        "defaultMessage": "Move column to last position"
    },
    removeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.remove-column",
        "defaultMessage": "Remove column"
    },
    resizeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.resize-column",
        "defaultMessage": "Resize column"
    },
    resetColumnWidth: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.reset-column-width",
        "defaultMessage": "Reset column width"
    },
    editField: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.edit-field",
        "defaultMessage": "Edit field"
    },
    freezeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.freeze-column",
        "defaultMessage": "Freeze column"
    },
    unfreezeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.unfreeze-column",
        "defaultMessage": "Unfreeze column"
    }
});

});


parcelRegister("ieul7", function(module, exports) {

$parcel$export(module.exports, "SortButton", () => $dc75ba32cd925e8e$export$e464399b18ba2124);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $56U2f = parcelRequire("56U2f");

var $iK3VB = parcelRequire("iK3VB");

var $8Gywp = parcelRequire("8Gywp");

var $aDbql = parcelRequire("aDbql");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $j8Km1 = parcelRequire("j8Km1");

var $8jOO7 = parcelRequire("8jOO7");

var $dIts6 = parcelRequire("dIts6");
const $dc75ba32cd925e8e$var$ConditionalIconContainer = ({ children: children })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $dc75ba32cd925e8e$var$iconContainerStyles
    }, children, " ");
    return children;
};
const $dc75ba32cd925e8e$var$useAccessibleLabel = ({ ascText: ascText, currentSorting: currentSorting, descText: descText, title: title })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const labelSuffix = (0, $eJOHy.useMemo)(()=>{
        const sortedTooltipMessage = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, $dIts6.default).sortedTooltipNew : (0, $dIts6.default).sortedTooltip;
        const sortPromptTooltipMessage = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, $dIts6.default).sortPromptTooltipNew : (0, $dIts6.default).sortPromptTooltip;
        switch(currentSorting){
            case 0, $8jOO7.SORT_ASC:
                return ascText ?? false ? formatMessage(sortedTooltipMessage, {
                    sortDescription: ascText
                }) : formatMessage((0, $dIts6.default).sortedDefaultAscendingTooltip);
            case 0, $8jOO7.SORT_DESC:
                return descText ?? false ? formatMessage(sortedTooltipMessage, {
                    sortDescription: descText
                }) : formatMessage((0, $dIts6.default).sortedDefaultDescendingTooltip);
            default:
                return ascText ?? false ? formatMessage(sortPromptTooltipMessage, {
                    sortDescription: ascText
                }) : formatMessage((0, $dIts6.default).sortPromptDefaultTooltip);
        }
    }, [
        ascText,
        currentSorting,
        descText,
        formatMessage
    ]);
    return (0, $eJOHy.useMemo)(()=>`${title} \u{2022} ${labelSuffix}`, [
        labelSuffix,
        title
    ]);
};
const $dc75ba32cd925e8e$export$e464399b18ba2124 = ({ column: column, onFocus: onFocus, onBlur: onBlur })=>{
    const label = $dc75ba32cd925e8e$var$useAccessibleLabel(column);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        let nextDirection = (0, $8jOO7.SORT_ASC);
        if (column.currentSorting === (0, $8jOO7.SORT_ASC)) nextDirection = (0, $8jOO7.SORT_DESC);
        else if (column.currentSorting === (0, $8jOO7.SORT_DESC)) nextDirection = (0, $7jTnu.fg)('jsc_list_reranking_gate') ? (0, $8jOO7.SORT_NONE) : (0, $8jOO7.SORT_ASC);
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const fieldType = column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && (0, $7jTnu.fg)('jira_list_merged_column_gate') ? column.mergedColumns?.[0]?.type ?? column.type : column.type;
        const attributes = {
            fieldType: fieldType,
            sortOrder: nextDirection
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'sortOrderChange', attributes);
        column.onSortOrderChanged?.(column.jqlTerm, nextDirection, (0, $7jTnu.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column,
        createAnalyticsEvent
    ]);
    const Icon = column.currentSorting === (0, $8jOO7.SORT_DESC) ? (0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDbql)));
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (iconProps)=>column.currentSorting === (0, $8jOO7.SORT_DESC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDbql))), {
                ...iconProps,
                size: "small"
            }),
        label: label,
        spacing: "compact",
        appearance: "subtle",
        isTooltipDisabled: false,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-actions.sort-button.icon-button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: label,
        delay: 0,
        ignoreTooltipPointerEvents: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dc75ba32cd925e8e$var$ConditionalIconContainer, null, column.currentSorting === (0, $8jOO7.SORT_DESC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            label: label,
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($56U2f))),
            LEGACY_size: "small",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            label: label,
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iK3VB))),
            LEGACY_size: "small",
            size: "small"
        })),
        isSelected: column.currentSorting !== (0, $8jOO7.SORT_NONE),
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }));
};
const $dc75ba32cd925e8e$var$iconContainerStyles = (0, $1DXK0.xcss)({
    margin: 'space.025'
});

});
parcelRegister("56U2f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b88fabfb9049421$var$_react = $3b88fabfb9049421$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $3b88fabfb9049421$var$_arrowDown = $3b88fabfb9049421$var$_interopRequireDefault((parcelRequire("8Gywp")));
function $3b88fabfb9049421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3b88fabfb9049421$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $3b88fabfb9049421$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $3b88fabfb9049421$var$_arrowDown.default
    }));
$3b88fabfb9049421$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $3b88fabfb9049421$var$_default = module.exports.default = $3b88fabfb9049421$var$ArrowDownIcon;

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});


parcelRegister("iK3VB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da4f91e16fa5e625$var$_react = $da4f91e16fa5e625$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $da4f91e16fa5e625$var$_arrowUp = $da4f91e16fa5e625$var$_interopRequireDefault((parcelRequire("aDbql")));
function $da4f91e16fa5e625$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $da4f91e16fa5e625$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $da4f91e16fa5e625$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $da4f91e16fa5e625$var$_arrowUp.default
    }));
$da4f91e16fa5e625$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $da4f91e16fa5e625$var$_default = module.exports.default = $da4f91e16fa5e625$var$ArrowUpIcon;

});
parcelRegister("aDbql", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bd6687a611ada9e$var$_react = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7bd6687a611ada9e$var$_baseNew = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7bd6687a611ada9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bd6687a611ada9e$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7bd6687a611ada9e$var$_react.default.createElement($7bd6687a611ada9e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7bd6687a611ada9e$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7bd6687a611ada9e$var$_default = module.exports.default = $7bd6687a611ada9e$var$ArrowUpIcon;

});


parcelRegister("dIts6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b92c373f114cd793$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b92c373f114cd793$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    sortedTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-tooltip",
        "defaultMessage": "Sorted {sortDescription}"
    },
    sortedTooltipNew: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-tooltip-new",
        "defaultMessage": "Sorted {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    sortPromptTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-tooltip",
        "defaultMessage": "Sort {sortDescription}"
    },
    sortPromptTooltipNew: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-tooltip-new",
        "defaultMessage": "Sort {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    sortPromptDefaultTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-default-tooltip",
        "defaultMessage": "Sort in ascending order"
    },
    sortedDefaultAscendingTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-default-ascending-tooltip",
        "defaultMessage": "Sorted in ascending order"
    },
    sortedDefaultDescendingTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-default-descending-tooltip",
        "defaultMessage": "Sorted in descending order"
    }
});

});



parcelRegister("4G6Vc", function(module, exports) {

$parcel$export(module.exports, "ResizePopup", () => $75984c1816247788$export$8ddf8c84a74a26df);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $3L3Os = parcelRequire("3L3Os");
var $dNvCk = parcelRequire("dNvCk");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $MevUn = parcelRequire("MevUn");

var $2ZGUP = parcelRequire("2ZGUP");

var $lRq8t = parcelRequire("lRq8t");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $8jOO7 = parcelRequire("8jOO7");

var $3R7ZX = parcelRequire("3R7ZX");

var $eEBCh = parcelRequire("eEBCh");
const $75984c1816247788$var$ResizePopupContent = ({ columnTitle: columnTitle, initialWidth: initialWidth, isCompactColumnEnabled: isCompactColumnEnabled = false, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, minimumWidth: minimumWidth, onChange: onChange, onCancel: onCancel, onSubmit: onSubmit, setInitialFocusRef: setInitialFocusRef, isMultiColumnMergedCell: isMultiColumnMergedCell })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleDragOrTouchStart = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    let minimumColumnWidth;
    if (isMultiColumnMergedCell && (0, $7jTnu.fg)('jira_list_update_merged_cell_min_width')) minimumColumnWidth = (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH);
    else minimumColumnWidth = isSingleLineRowHeightEnabled ? (0, $8jOO7.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $8jOO7.MINIMUM_COLUMN_WIDTH);
    const defaultMinWidth = isCompactColumnEnabled ? (0, $8jOO7.MINIMUM_COLUMN_WIDTH_COMPACT) : minimumColumnWidth;
    const minWidth = minimumWidth || defaultMinWidth;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingInline: "space.200",
        xcss: $75984c1816247788$var$PopupContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: ({ width: width })=>onSubmit((0, $3R7ZX.ensureWidthWithinLimits)(width, isCompactColumnEnabled, isSingleLineRowHeightEnabled))
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dNvCk.default), {
            label: formatMessage((0, $eEBCh.default).columnWidthLabel, {
                columnTitle: columnTitle
            }),
            name: "width",
            defaultValue: initialWidth
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MevUn.default), {
                ...fieldProps,
                ref: setInitialFocusRef,
                min: minWidth,
                max: (0, $8jOO7.MAXIMUM_COLUMN_WIDTH),
                step: 5,
                onChange: (value)=>{
                    onChange(value);
                    fieldProps.onChange(value);
                },
                draggable: true,
                onDragStart: handleDragOrTouchStart,
                onTouchStart: handleDragOrTouchStart
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            space: "space.100",
            alignInline: "end",
            xcss: $75984c1816247788$var$FormFooterStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle",
            onClick: onCancel
        }, formatMessage((0, $eEBCh.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            type: "submit",
            appearance: "primary"
        }, formatMessage((0, $eEBCh.default).save))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null));
};
const $75984c1816247788$export$8ddf8c84a74a26df = ({ columnTitle: columnTitle, initialWidth: initialWidth, placement: placement, isOpen: isOpen, isCompactColumnEnabled: isCompactColumnEnabled = false, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, minimumWidth: minimumWidth, trigger: trigger, onChange: onChange, onCancel: onCancelProp, onSubmit: onSubmit, isMultiColumnMergedCell: isMultiColumnMergedCell })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onCancel = (0, $eJOHy.useCallback)((event, analyticsEventParam)=>{
        const analyticsEvent = analyticsEventParam ?? createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'cancelColumnResize');
        onCancelProp(event);
    }, [
        onCancelProp,
        createAnalyticsEvent
    ]);
    const PopupContent = (0, $eJOHy.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($75984c1816247788$var$ResizePopupContent, {
            columnTitle: columnTitle,
            initialWidth: initialWidth,
            isCompactColumnEnabled: isCompactColumnEnabled,
            minimumWidth: minimumWidth,
            onChange: onChange,
            onCancel: onCancel,
            onSubmit: onSubmit,
            setInitialFocusRef: setInitialFocusRef,
            isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
            isMultiColumnMergedCell: isMultiColumnMergedCell
        }), [
        columnTitle,
        initialWidth,
        isCompactColumnEnabled,
        minimumWidth,
        onChange,
        onCancel,
        onSubmit,
        isSingleLineRowHeightEnabled,
        isMultiColumnMergedCell
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        testId: "native-issue-table.ui.issue-table.header.header-cell.resize-popup.resize-popup",
        placement: placement,
        isOpen: isOpen,
        onClose: onCancel,
        trigger: trigger,
        content: PopupContent,
        shouldRenderToParent: true,
        messageId: "native-issue-table.ui.issue-table.header.header-cell.resize-popup.popup",
        messageType: "transactional",
        ...(0, $7jTnu.fg)('nin-grid-keyboard-navigation') && {
            role: 'dialog',
            label: columnTitle
        }
    });
};
const $75984c1816247788$var$PopupContentStyles = (0, $1DXK0.xcss)({
    fontWeight: "var(--ds-font-weight-regular, 400)",
    marginBlock: 'space.200',
    whiteSpace: 'normal'
});
const $75984c1816247788$var$FormFooterStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("dNvCk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bc12428617c0200$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6svxr = parcelRequire("6svxr");
/**
 * __Range field__
 *
 * A range field is where a user can submit a range input as a part of a form.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 */ const $4bc12428617c0200$var$RangeField = ({ children: children, defaultValue: defaultValue, id: id, isDisabled: isDisabled, label: label, name: name, ...strippedProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        ...strippedProps,
        defaultValue: defaultValue,
        id: id,
        isDisabled: isDisabled,
        label: label,
        name: name,
        transform: Number,
        children: ({ fieldProps: { isInvalid: isInvalid, isRequired: isRequired, ...fieldProps }, ...rest })=>// isInvalid and isRequired are specifically invalid for range inputs
            children({
                fieldProps: fieldProps,
                ...rest
            })
    });
var $4bc12428617c0200$export$2e2bcd8739ae039 = $4bc12428617c0200$var$RangeField;

});

parcelRegister("MevUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c0f57dfc7b1472c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $dbgh6 = parcelRequire("dbgh6");
const $9c0f57dfc7b1472c$var$snapToStep = (value, min, step)=>{
    // Normalise the value to allow for division properly with different min values
    const adjustedValue = value - min;
    // Find the number of steps the value covers
    const numSteps = Math.round(adjustedValue / step);
    // Convert numSteps back into original range
    return numSteps * step + min;
};
const $9c0f57dfc7b1472c$var$getRoundedPercentValue = (value, min, max, step)=>{
    let percent = '0';
    if (min < max && value > min) {
        const snappedValue = $9c0f57dfc7b1472c$var$snapToStep(value, min, step);
        percent = ((snappedValue - min) / (max - min) * 100).toFixed(2);
    }
    return percent;
};
const $9c0f57dfc7b1472c$var$noop = (0, $3Vuhz.default);
/**
 * __Range__
 *
 * A range lets users choose an approximate value on a slider.
 *
 * - [Examples](https://atlassian.design/components/range/examples)
 * - [Code](https://atlassian.design/components/range/code)
 * - [Usage](https://atlassian.design/components/range/usage)
 */ const $9c0f57dfc7b1472c$var$Range = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Range(props, ref) {
    const { isDisabled: isDisabled = false, defaultValue: defaultValue = 50, max: max = 100, min: min = 0, onChange: onChange = $9c0f57dfc7b1472c$var$noop, step: step = 1, value: propsValue, testId: testId, ...rest } = props;
    const spreadProps = {
        max: max,
        min: min,
        step: step,
        ref: ref,
        ...rest
    };
    const [value, setValue] = (0, $eJOHy.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const handleChange = (0, $eJOHy.useCallback)((e)=>{
        const newValue = Number(e.target.value);
        setValue(newValue);
        // Note use of newValue to ensure up=to-date value is used
        onChange(newValue);
    }, [
        onChange
    ]);
    const renderValue = propsValue !== undefined ? propsValue : value;
    const valuePercent = $9c0f57dfc7b1472c$var$getRoundedPercentValue(renderValue, min, max, step);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dbgh6.Input), {
        type: "range",
        disabled: isDisabled,
        onChange: handleChange,
        value: renderValue,
        valuePercent: valuePercent,
        "data-testid": testId,
        ...spreadProps
    });
});
var $9c0f57dfc7b1472c$export$2e2bcd8739ae039 = $9c0f57dfc7b1472c$var$Range;

});
parcelRegister("dbgh6", function(module, exports) {

$parcel$export(module.exports, "Input", () => $b65ac72e66820907$export$f5b8910cec6cf069);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b65ac72e66820907$var$rangeHeight = 40; // Height of the range input, used for the track and thumb
const $b65ac72e66820907$var$trackHeight = 6; // Height of the track, used for the track and thumb
const $b65ac72e66820907$var$thumbSize = "var(--ds-space-200, 16px)"; // Size of the thumb, used for the thumb styles
// Styles are split up to avoid edge-cases with TS implementations between `css` and `cssMap` with some
// of these edge-case pseudo-selectors.
// Previously, in Emotion, these selectors weren't consolidated, eg. `&::webkit-thumb, &::moz-thumb`
// would not be parsed by either browser, but this may no longer be the case in Compiled
const $b65ac72e66820907$var$webkitStyles = null;
const $b65ac72e66820907$var$firefoxStyles = null;
const $b65ac72e66820907$var$baseStyles = null;
const $b65ac72e66820907$var$themeStyles = null;
const $b65ac72e66820907$var$trackStyles = {
    root: "_1bsb1osq _4t3i1ylp _kqswh2mm _14mj1q5u _1ywu1ule _z0ai1y44 _1qdg1y44 _18postnw _1hfk1b6k _aetrb3bt _19nq1ssb _g0nfo1yi",
    disabled: "_1peq2wxo"
};
const $b65ac72e66820907$var$rangeA11yStyles = null;
const $b65ac72e66820907$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { valuePercent: valuePercent, style: style, ...strippedProps } = props;
    const input = /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
        ...strippedProps,
        style: {
            // We are creating a css variable to control the "progress" portion of the range input
            // This avoids us needing to create a new css class for each new percentage value
            '--track-fg-width': `${valuePercent}%`
        },
        ref: ref,
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1ylp _bfhk18uv _j5dh13gf _1j552wxo _nt751r31 _49pcglyw _1hvw1o36",
            "_wstuglyw _h2ksglyw _1kdl1q5u _m8f8g56u _1yz62hjt _1bdkusvi _u98zpxbi _1j70pxbi _1esf5udg _4w431ik2 _yfyntlke _1sdc196n _18k7v77o _1cdcglyw _10lridpf _g6tdyh40 _vi4t2hjt _1g2h1osq _168l1y44 _9u3f2hce _1g741hsc _1d8tmgnk _np53xlkz _18tdtlke _1p201osq _1yte13gf _5i7a13gf",
            "_1yq0glyw _108m1q5u _1rf3g56u _1yeu2hjt _g4ppusvi _r763pxbi _1mn5pxbi _12el5udg _1oqe1ik2 _10o7tlke _1kzev77o _15raidpf _e8hnidpf _37ywyh40 _1tcb2hjt _aoww1osq _1kd2i2wt _vt2s1w6o _1ssqtlke _ru37idpf _1gvoyh40 _1nx42hjt _1f5t1osq _142y1y44 _d7w62hce _b3fmtlke _1vq313gf _1fov13gf _34m613gf",
            "_14h11kge _15dp1yrq _18lxyvsn _jxar1eo5 _ydqghkel _1jhc1eo5 _1ruc16ss _164c194a",
            "_1drq1b6k _15dp1vck _18lx1b6k _g6td1l7b _168li2wt _37yw1l7b _1kd2i2wt _1sdc1lpd _ydqgmpja"
        ])
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $b65ac72e66820907$var$trackStyles.root,
            strippedProps.disabled && $b65ac72e66820907$var$trackStyles.disabled
        ]),
        children: input
    });
});
$b65ac72e66820907$export$f5b8910cec6cf069.displayName = 'InputRange';

});


parcelRegister("3R7ZX", function(module, exports) {

$parcel$export(module.exports, "setCssResizingOffset", () => $89884b47ae19eb85$export$1799580b35bc0fce);
$parcel$export(module.exports, "clearCssResizingOffset", () => $89884b47ae19eb85$export$4a29049b3e1cea2c);
$parcel$export(module.exports, "setCssResizingWidth", () => $89884b47ae19eb85$export$7bda7a969edeaaf9);
$parcel$export(module.exports, "clearCssResizingWidth", () => $89884b47ae19eb85$export$c418ab97f3e5c176);
$parcel$export(module.exports, "disableCssPointerEvents", () => $89884b47ae19eb85$export$b0074a660e898e0);
$parcel$export(module.exports, "enableCssPointerEvents", () => $89884b47ae19eb85$export$1b5de7c0486b5e41);
$parcel$export(module.exports, "ensureWidthWithinLimits", () => $89884b47ae19eb85$export$3a38b06f96ddcc2d);
$parcel$export(module.exports, "getProposedWidth", () => $89884b47ae19eb85$export$39e6ff87d188b0e6);

var $7jTnu = parcelRequire("7jTnu");

var $8jOO7 = parcelRequire("8jOO7");
const $89884b47ae19eb85$var$CSS_RESIZING_WIDTH_PROPERTY = '--local-resizing-width';
const $89884b47ae19eb85$var$CSS_RESIZING_OFFSETX_PROPERTY = '--local-resizing-offset';
const $89884b47ae19eb85$export$1799580b35bc0fce = (container, width)=>{
    container?.style.setProperty($89884b47ae19eb85$var$CSS_RESIZING_OFFSETX_PROPERTY, `${width}px`);
};
const $89884b47ae19eb85$export$4a29049b3e1cea2c = (container)=>{
    container?.style.removeProperty($89884b47ae19eb85$var$CSS_RESIZING_OFFSETX_PROPERTY);
};
const $89884b47ae19eb85$export$7bda7a969edeaaf9 = (container, width)=>{
    container?.style.setProperty($89884b47ae19eb85$var$CSS_RESIZING_WIDTH_PROPERTY, `${width}px`);
};
const $89884b47ae19eb85$export$c418ab97f3e5c176 = (container)=>{
    container?.style.removeProperty($89884b47ae19eb85$var$CSS_RESIZING_WIDTH_PROPERTY);
};
const $89884b47ae19eb85$export$b0074a660e898e0 = (container)=>{
    container?.style.setProperty('pointer-events', 'none');
};
const $89884b47ae19eb85$export$1b5de7c0486b5e41 = (container)=>{
    container?.style.removeProperty('pointer-events');
};
const $89884b47ae19eb85$export$3a38b06f96ddcc2d = (width, isCompactColumnEnabled, isSingleLineRowHeightEnabled, isMultiColumnMergedCell)=>{
    let minColumnWidth;
    if (isMultiColumnMergedCell && (0, $7jTnu.fg)('jira_list_update_merged_cell_min_width')) minColumnWidth = (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH);
    else minColumnWidth = isSingleLineRowHeightEnabled ? (0, $8jOO7.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $8jOO7.MINIMUM_COLUMN_WIDTH);
    return Math.min(Math.max(isCompactColumnEnabled ? (0, $8jOO7.MINIMUM_COLUMN_WIDTH_COMPACT) : minColumnWidth, width), (0, $8jOO7.MAXIMUM_COLUMN_WIDTH));
};
const $89884b47ae19eb85$export$39e6ff87d188b0e6 = ({ initialWidth: initialWidth, isCompactColumnEnabled: isCompactColumnEnabled, location: location, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, isMultiColumnMergedCell: isMultiColumnMergedCell })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    const proposedWidth = initialWidth + diffX;
    // ensure we don't go below the min allowed width
    return $89884b47ae19eb85$export$3a38b06f96ddcc2d(proposedWidth, isCompactColumnEnabled, isSingleLineRowHeightEnabled, isMultiColumnMergedCell);
};

});

parcelRegister("eEBCh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff6be754c5e1a549$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ff6be754c5e1a549$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    columnWidthLabel: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.column-width-label",
        "defaultMessage": "Column width - {columnTitle}"
    },
    cancel: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.cancel",
        "defaultMessage": "Cancel"
    },
    save: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.save",
        "defaultMessage": "Save"
    }
});

});



parcelRegister("3utN3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3771e5fb7245c307$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3771e5fb7245c307$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    movedColumn: {
        "id": "native-issue-table.issue-table.header.moved-column",
        "defaultMessage": "You\u2019ve moved {column} from {previousPosition} to {position} of {total}."
    }
});

});


parcelRegister("eI4dM", function(module, exports) {

$parcel$export(module.exports, "default", () => $65dc4e4263660c62$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $65dc4e4263660c62$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issuesTableLabel: {
        "id": "native-issue-table.issue-table.issues-table-label",
        "defaultMessage": "Issues"
    },
    issuesTableLabelIssueTermRefresh: {
        "id": "native-issue-table.issue-table.issues-table-label-issue-term-refresh",
        "defaultMessage": "Work"
    }
});

});

parcelRegister("l00LF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e01c1501c2df9d15$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $3xT3U = parcelRequire("3xT3U");

var $iqtgH = parcelRequire("iqtgH");

var $dK9Sm = parcelRequire("dK9Sm");

var $hnyyS = parcelRequire("hnyyS");
const $e01c1501c2df9d15$var$NoColumnsRenderer = ({ NoColumns: NoColumns = (0, $dK9Sm.NoColumns), hasColumnConfiguration: hasColumnConfiguration, isLoading: isLoading = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e01c1501c2df9d15$var$NoColumnsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NoColumns, {
        defaultNoColumnsGlyph: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $e01c1501c2df9d15$var$ImageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3xT3U.default), {
            alt: ""
        })),
        hasColumnConfiguration: hasColumnConfiguration
    }), isLoading && ((0, $7jTnu.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.Overlay), {
        interactionName: "issue-table-no-columns-renderer-overlay"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.OverlayOld), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTableNoColumns"
    }));
var $e01c1501c2df9d15$export$2e2bcd8739ae039 = $e01c1501c2df9d15$var$NoColumnsRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e01c1501c2df9d15$var$NoColumnsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _kqsw1if8 _1ltvidpf",
            __cmplp.className
        ])
    });
});
const $e01c1501c2df9d15$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("3xT3U", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1b1236d04dc76a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("e8HDz")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("aiB9q")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $c4huj = parcelRequire("c4huj");

var $aiB9q = parcelRequire("aiB9q");

var $e8HDz = parcelRequire("e8HDz");
const $3b1b1236d04dc76a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e8HDz)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aiB9q))
});
var $3b1b1236d04dc76a$export$2e2bcd8739ae039 = $3b1b1236d04dc76a$var$Illustration;
// for advanced use only
const $3b1b1236d04dc76a$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("aiB9q", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("e8HDz", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});


parcelRegister("dK9Sm", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $edb4c92fc13b3452$export$a0e9f6d02eee4aa4);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $lRq8t = parcelRequire("lRq8t");

var $PETi0 = parcelRequire("PETi0");

var $gCeeo = parcelRequire("gCeeo");

var $5F0C9 = parcelRequire("5F0C9");
const $edb4c92fc13b3452$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ isOpen: isOpen }, actions] = (0, $PETi0.useColumnPickerOpenState)();
    const onOpenColumnPicker = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton');
        if (!isOpen) actions.open();
    }, [
        isOpen,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $5F0C9.default).noColumnsHeaderText),
        description: formatMessage((0, $5F0C9.default).noColumnsDescriptionText),
        testId: "native-issue-table.common.ui.components.no-columns.no-columns",
        primaryAction: hasColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: onOpenColumnPicker
        }, formatMessage((0, $5F0C9.default).configureColumns)) : undefined,
        renderImage: ()=>defaultNoColumnsGlyph
    }));
};

});
parcelRegister("5F0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $eacbcb43f37199f6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $eacbcb43f37199f6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noColumnsHeaderText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-header-text",
        "defaultMessage": "Configure your columns"
    },
    noColumnsDescriptionText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-description-text",
        "defaultMessage": "You haven't configured any columns yet. Add fields as columns to see search results and their information."
    },
    configureColumns: {
        "id": "native-issue-table.issue-table.no-columns.configure-columns",
        "defaultMessage": "Configure columns"
    }
});

});



parcelRegister("kaSuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f0c91843002930$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $7uL8m = parcelRequire("7uL8m");

var $kKCMK = parcelRequire("kKCMK");

var $iqtgH = parcelRequire("iqtgH");

var $6XJko = parcelRequire("6XJko");

var $hnyyS = parcelRequire("hnyyS");

var $eu3ki = parcelRequire("eu3ki");
const $c8f0c91843002930$var$NoIssuesRenderer = ({ NoIssues: NoIssues = (0, $eu3ki.NoIssues), isLoading: isLoading = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8f0c91843002930$var$EmptyIssuesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NoIssues, {
        defaultNoIssuesGlyph: (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $c8f0c91843002930$var$ImageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKCMK.default), {
            alt: ""
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $c8f0c91843002930$var$ImageWrapperStylesOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7uL8m.default), {
            alt: ""
        }))
    }), isLoading && ((0, $7jTnu.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.Overlay), {
        interactionName: "issue-table-no-issues-renderer-overlay"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.OverlayOld), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTableNoResults"
    }));
var $c8f0c91843002930$export$2e2bcd8739ae039 = $c8f0c91843002930$var$NoIssuesRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8f0c91843002930$var$EmptyIssuesContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _kqsw1if8 _1ltvidpf _mezj18pt",
            __cmplp.className
        ])
    });
});
const $c8f0c91843002930$var$ImageWrapperStylesOld = (0, $1DXK0.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});
const $c8f0c91843002930$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("7uL8m", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a8498e45c2fcae9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $c4huj = parcelRequire("c4huj");

var $lGiXj = parcelRequire("lGiXj");

var $dIBgP = parcelRequire("dIBgP");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $8a8498e45c2fcae9$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dIBgP)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lGiXj))
});
var $8a8498e45c2fcae9$export$2e2bcd8739ae039 = $8a8498e45c2fcae9$var$Illustration;
// for advanced use only
const $8a8498e45c2fcae9$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("lGiXj", function(module, exports) {
module.exports = new URL("search-no-results-old-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("dIBgP", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});


parcelRegister("kKCMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaae219acd4147f1$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $c4huj = parcelRequire("c4huj");

var $js5cg = parcelRequire("js5cg");

var $hj82Y = parcelRequire("hj82Y");
const $aaae219acd4147f1$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hj82Y)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($js5cg))
});
var $aaae219acd4147f1$export$2e2bcd8739ae039 = $aaae219acd4147f1$var$Illustration;
// for advanced use only
const $aaae219acd4147f1$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    184
];

});
parcelRegister("js5cg", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.c66ae5fb.svg", import.meta.url).toString();

});

parcelRegister("hj82Y", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});


parcelRegister("eu3ki", function(module, exports) {

$parcel$export(module.exports, "NoIssues", () => $ab49ca26ec37a201$export$a7a61a727a1d891b);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $fjV4E = parcelRequire("fjV4E");
const $ab49ca26ec37a201$export$a7a61a727a1d891b = ({ defaultNoIssuesGlyph: defaultNoIssuesGlyph })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fjV4E.default).emptyIssuesIssueTermRefresh : (0, $fjV4E.default).emptyIssues),
        renderImage: ()=>defaultNoIssuesGlyph,
        testId: "native-issue-table.ui.issue-table.no-issues-renderer.no-issues.empty-state"
    }));
};

});
parcelRegister("fjV4E", function(module, exports) {

$parcel$export(module.exports, "default", () => $386c8ad01edb0ce6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $386c8ad01edb0ce6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyIssues: {
        "id": "native-issue-table.issue-table.empty-issues.empty-issues",
        "defaultMessage": "There are no issues"
    },
    emptyIssuesIssueTermRefresh: {
        "id": "native-issue-table.issue-table.no-issues-renderer.no-issues.empty-issues-issue-term-refresh",
        "defaultMessage": "There are no work items"
    }
});

});



parcelRegister("4R6nP", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ceca96987e6835$export$2e2bcd8739ae039);

var $jVV6d = parcelRequire("jVV6d");

var $d0ISs = parcelRequire("d0ISs");

var $kILz0 = parcelRequire("kILz0");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $cNwIG = parcelRequire("cNwIG");

var $eSclU = parcelRequire("eSclU");

var $3fA0C = parcelRequire("3fA0C");

var $jNv5I = parcelRequire("jNv5I");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $bKlUQ = parcelRequire("bKlUQ");

var $7n9BS = parcelRequire("7n9BS");

var $iC2St = parcelRequire("iC2St");

var $kfIml = parcelRequire("kfIml");

var $flKZd = parcelRequire("flKZd");
const $80ceca96987e6835$var$TableBody = ({ issueResults: issueResults, project: project, rankField: rankField, isGroupingSupported: isGroupingSupported, isConditionalFormattingEnabled: isConditionalFormattingEnabled, ...tableBodyProps })=>{
    const issueResultsData = (0, $j4oe4.useFragment)((0, $kILz0.default), issueResults);
    const projectData = (0, $j4oe4.useFragment)((0, $d0ISs.default), project);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $jVV6d.default), rankField);
    const rankFieldTerms = (0, $eJOHy.useMemo)(()=>({
            jqlTerm: rankFieldData?.jqlTerm ?? null,
            aliases: rankFieldData?.aliases ? Array.from(rankFieldData.aliases) : null
        }), [
        rankFieldData
    ]);
    const renderChildRowsNew = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $flKZd.RenderChildRowsComp), {
            project: projectData,
            projectKey: projectData?.key,
            columns: tableBodyProps.columns,
            isGroupingSupported: isGroupingSupported,
            rankField: rankFieldData ?? null,
            ...props
        }), [
        projectData,
        isGroupingSupported,
        rankFieldData,
        tableBodyProps.columns
    ]); // >>>START -> Cleanup renderChildRows code when cleaning 'jira_list_improve_table_body_code'
    /**
   * Passing those values down to ChildRowsLoader as props to avoid direct imports
   */ const jql = (0, $34oCh.useJql)();
    const sortField = (0, $34oCh.useSortField)();
    const sortDirection = (0, $34oCh.useSortDirection)();
    const isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const renderDraggableWrapper = (0, $eJOHy.useCallback)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfIml.DraggableRowsContainer), {
            issueConnectionId: props.issueConnectionId,
            instanceId: props.instanceId
        }, props.children);
    }, []);
    const renderChildRows = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNwIG.ChildRows), {
            ...props,
            projectKey: projectData?.key,
            isGroupingSupported: isGroupingSupported,
            childItemsExperience: (0, $8jOO7.CHILD_ITEMS_EXPERIENCE),
            childItemsLoadMoreExperience: (0, $8jOO7.CHILD_ITEMS_LOAD_MORE_EXPERIENCE),
            analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE),
            renderChildRowsLoader: (childRowsLoaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eSclU.ChildRowsLoader), {
                    ...childRowsLoaderProps,
                    jql: jql,
                    width: width,
                    sortField: sortField,
                    sortDirection: sortDirection,
                    columns: tableBodyProps.columns,
                    amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                    actionColumns: (0, $8jOO7.ACTION_COLUMNS),
                    pageSize: (0, $8jOO7.CHILD_QUERY_PAGE_SIZE),
                    isReparentingEnabled: isReparentingEnabled,
                    isTimelineEnabled: isTimelineEnabled,
                    isIssueRankDescending: isIssueRankDescending,
                    isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                    isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
                    rankFieldId: rankFieldData?.fieldId,
                    renderRows: (rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3fA0C.Rows), {
                            project: projectData,
                            ...rowProps
                        }),
                    renderDraggableWrapper: renderDraggableWrapper,
                    renderTableCell: (tableCellProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), tableCellProps),
                    renderCreateIssueController: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2St.CreateIssueController), {
                            ...args,
                            jql: jql,
                            rankFieldTerms: rankFieldTerms
                        }),
                    isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                    isInlineFieldConfigEnabled: isInlineFieldConfigEnabled
                })
        }), [
        projectData,
        isGroupingSupported,
        jql,
        width,
        sortField,
        sortDirection,
        tableBodyProps.columns,
        isReparentingEnabled,
        isTimelineEnabled,
        isIssueRankDescending,
        isHideDoneItemsEnabled,
        isConditionalFormattingEnabled,
        isFixedTableLayoutEnabled,
        rankFieldData?.fieldId,
        renderDraggableWrapper,
        isInlineFieldConfigEnabled,
        rankFieldTerms
    ]); // <<<END -> Cleanup renderChildRows code when cleaning 'jira_list_improve_table_body_code'
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($80ceca96987e6835$var$StyledTableBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNv5I.RowContextProvider), {
        ...tableBodyProps,
        renderChildRows: (0, $7jTnu.fg)('jira_list_improve_table_body_code') ? renderChildRowsNew : renderChildRows
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3fA0C.Rows), {
        issueResults: issueResultsData,
        parentItemId: "root",
        itemsConnectionId: issueResultsData.__id,
        project: projectData,
        rankFieldId: rankFieldData?.fieldId,
        ...(0, $7jTnu.fg)('jsc_list_reparenting') ? {
            projectKey: projectData?.key
        } : {}
    })));
};
var $80ceca96987e6835$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $80ceca96987e6835$var$TableBody;
const $80ceca96987e6835$var$StyledTableBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zlglyw _1reo15vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jVV6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $67d950e18e40409e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a79d3853a2e351a1c0707c70767a6598>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $67d950e18e40409e$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "tableBody_nativeIssueTable_rankField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "jqlTerm"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "aliases"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "renderChildRows_nativeIssueTable_RenderChildRowsComp_rankField"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$67d950e18e40409e$var$node.hash = "21199ffc917dc0f149e7e66a3c87fd0b";
var $67d950e18e40409e$export$2e2bcd8739ae039 = $67d950e18e40409e$var$node;

});

parcelRegister("d0ISs", function(module, exports) {

$parcel$export(module.exports, "default", () => $18463f9912df445b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9f033b34e768942ccd0a7262cf98a0a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $18463f9912df445b$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "tableBody_nativeIssueTable_project",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "rows_jiraProject"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "renderChildRows_nativeIssueTable_RenderChildRowsComp_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$18463f9912df445b$var$node.hash = "b0aff7e8cd8c9ac1989dc7e091cad5f4";
var $18463f9912df445b$export$2e2bcd8739ae039 = $18463f9912df445b$var$node;

});

parcelRegister("kILz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $107bbdbda3dd787b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b4fedc2cc7b927fb7ee8494a32a15309>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $107bbdbda3dd787b$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "tableBody_nativeIssueTable_issueResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "rows_nativeIssueTable_issueResults"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$107bbdbda3dd787b$var$node.hash = "9bea7dab49b06da7cbca58dbf3f62ca3";
var $107bbdbda3dd787b$export$2e2bcd8739ae039 = $107bbdbda3dd787b$var$node;

});

parcelRegister("flKZd", function(module, exports) {

$parcel$export(module.exports, "RenderChildRowsComp", () => $0356e89050b04b8b$export$c65f147e25ffd0e6);

var $81CmC = parcelRequire("81CmC");

var $fn3z9 = parcelRequire("fn3z9");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cNwIG = parcelRequire("cNwIG");

var $eSclU = parcelRequire("eSclU");

var $7jTnu = parcelRequire("7jTnu");

var $3fA0C = parcelRequire("3fA0C");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $bKlUQ = parcelRequire("bKlUQ");

var $7n9BS = parcelRequire("7n9BS");

var $iC2St = parcelRequire("iC2St");

var $kfIml = parcelRequire("kfIml");
const $0356e89050b04b8b$var$renderDraggableWrapper = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfIml.DraggableRowsContainer), {
        issueConnectionId: props.issueConnectionId,
        instanceId: props.instanceId
    }, props.children);
};
const $0356e89050b04b8b$export$c65f147e25ffd0e6 = ({ project: project, projectKey: projectKey, isGroupingSupported: isGroupingSupported, columns: columns, rankField: rankField, ...childRowsProps })=>{
    const renderTableCell = (tableCellProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), tableCellProps);
    const projectRef = (0, $j4oe4.useFragment)((0, $fn3z9.default), project);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $81CmC.default), rankField);
    /**
   * Passing those values down to ChildRowsLoader as props to avoid direct imports
   */ const jql = (0, $34oCh.useJql)();
    const sortField = (0, $34oCh.useSortField)();
    const sortDirection = (0, $34oCh.useSortDirection)();
    const isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7jTnu.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    const rankFieldTerms = (0, $eJOHy.useMemo)(()=>({
            jqlTerm: rankFieldData?.jqlTerm ?? null,
            aliases: rankFieldData?.aliases ? Array.from(rankFieldData.aliases) : null
        }), [
        rankFieldData
    ]);
    const renderCreateIssueController = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2St.CreateIssueController), {
            ...props,
            jql: jql,
            rankFieldTerms: rankFieldTerms
        }), [
        jql,
        rankFieldTerms
    ]);
    const renderChildRowsLoader = (0, $eJOHy.useCallback)((childRowsLoaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eSclU.ChildRowsLoader), {
            ...childRowsLoaderProps,
            jql: jql,
            width: width,
            sortField: sortField,
            sortDirection: sortDirection,
            columns: columns,
            amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
            actionColumns: (0, $8jOO7.ACTION_COLUMNS),
            pageSize: (0, $8jOO7.CHILD_QUERY_PAGE_SIZE),
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            isIssueRankDescending: isIssueRankDescending,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            rankFieldId: rankFieldData?.fieldId,
            renderRows: (rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3fA0C.Rows), {
                    project: projectRef,
                    ...rowProps
                }),
            renderDraggableWrapper: $0356e89050b04b8b$var$renderDraggableWrapper,
            renderTableCell: renderTableCell,
            renderCreateIssueController: renderCreateIssueController,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled
        }), [
        projectRef,
        columns,
        isFixedTableLayoutEnabled,
        isHideDoneItemsEnabled,
        isIssueRankDescending,
        isReparentingEnabled,
        isTimelineEnabled,
        isConditionalFormattingEnabled,
        jql,
        rankFieldData?.fieldId,
        renderCreateIssueController,
        sortDirection,
        sortField,
        width,
        isInlineFieldConfigEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNwIG.ChildRows), {
        ...childRowsProps,
        projectKey: projectKey,
        isGroupingSupported: isGroupingSupported,
        childItemsExperience: (0, $8jOO7.CHILD_ITEMS_EXPERIENCE),
        childItemsLoadMoreExperience: (0, $8jOO7.CHILD_ITEMS_LOAD_MORE_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE),
        renderChildRowsLoader: renderChildRowsLoader
    });
};

});
parcelRegister("81CmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $14ef4db2e1c5a378$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<558b2548c4155e50632f80c44bb39ccd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $14ef4db2e1c5a378$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "renderChildRows_nativeIssueTable_RenderChildRowsComp_rankField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "jqlTerm"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "aliases"
                }
            ]
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$14ef4db2e1c5a378$var$node.hash = "aee08d7fab3a0a30f9b7b7b4452f38a7";
var $14ef4db2e1c5a378$export$2e2bcd8739ae039 = $14ef4db2e1c5a378$var$node;

});

parcelRegister("fn3z9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8e8584819c4ada8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40f9df84fe0a585a9c1d9df6714a6bc7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b8e8584819c4ada8$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "renderChildRows_nativeIssueTable_RenderChildRowsComp_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "rows_jiraProject"
        }
    ],
    "type": "JiraProject"
};
$b8e8584819c4ada8$var$node.hash = "76253f9f92c0c4a3dc660bd3fb584942";
var $b8e8584819c4ada8$export$2e2bcd8739ae039 = $b8e8584819c4ada8$var$node;

});



parcelRegister("7WpdI", function(module, exports) {

$parcel$export(module.exports, "InitializeVirtualizer", () => $771cea3dfdc61397$export$de49fec4748def14);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $6d9QY = parcelRequire("6d9QY");

var $7jTnu = parcelRequire("7jTnu");

var $fsisP = parcelRequire("fsisP");

var $8jOO7 = parcelRequire("8jOO7");

var $7n9BS = parcelRequire("7n9BS");

var $4jaZO = parcelRequire("4jaZO");

var $Kdcei = parcelRequire("Kdcei");
const $771cea3dfdc61397$var$estimateSize = ()=>(0, $8jOO7.ROW_HEIGHT) + 1; // include border
const $771cea3dfdc61397$var$InitializeVirtualizerInner = ({ rows: rows = 0, getItemKey: getItemKey, totalSizeRef: totalSizeRef, options: virtualizerOptions })=>{
    const scrollElement = (0, $7n9BS.useScrollElement)();
    const { setVirtualizer: setVirtualizer, setVirtualItemsMap: setVirtualItemsMap } = (0, $Kdcei.useVirtualizationActions)();
    const options = (0, $eJOHy.useMemo)(()=>({
            count: rows,
            getScrollElement: ()=>scrollElement,
            estimateSize: $771cea3dfdc61397$var$estimateSize,
            getItemKey: getItemKey,
            overscan: 10,
            ...(0, $7jTnu.fg)('jira_spreadsheet_timeline_image_export') && virtualizerOptions
        }), [
        getItemKey,
        rows,
        scrollElement,
        virtualizerOptions
    ]);
    const virtualizer = (0, $4jaZO.useSSRSafeVirtualizer)(options);
    const totalSize = virtualizer?.getTotalSize();
    const items = virtualizer?.getVirtualItems();
    // eslint-disable-next-line no-param-reassign, react-hooks/react-compiler
    totalSizeRef.current = totalSize ?? 0;
    const prevVirtualizer = (0, $6d9QY.usePrevious)(virtualizer);
    const prevItems = (0, $6d9QY.usePrevious)(items);
    if ((0, $7jTnu.fg)('new_jira_list_shallow_equal_virtualizer')) {
        if (!(0, $fsisP.isShallowEqual)(prevVirtualizer, virtualizer)) setVirtualizer(virtualizer);
    } else if (prevVirtualizer !== virtualizer) setVirtualizer(virtualizer);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevItems, items)) {
        const virtualItemsMap = items?.reduce((acc, item)=>{
            acc[String(item.key)] = true;
            return acc;
        }, {});
        setVirtualItemsMap(virtualItemsMap);
    }
    return null;
};
const $771cea3dfdc61397$export$de49fec4748def14 = (props)=>{
    // Skip any attempts to perform virtualization in SSR
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($771cea3dfdc61397$var$InitializeVirtualizerInner, props);
};

});
parcelRegister("4jaZO", function(module, exports) {

$parcel$export(module.exports, "useSSRSafeVirtualizer", () => $02fccf8bdbf5d1dd$export$e290ffcf7d3b6e02);

var $eJOHy = parcelRequire("eJOHy");

var $bVtHf = parcelRequire("bVtHf");
const $02fccf8bdbf5d1dd$export$f4c0efb17365077d = (options)=>{
    const { count: count, estimateSize: estimateSize, getItemKey: getItemKey } = options;
    const totalSize = count * estimateSize(0);
    let start = 0;
    const items = Array.from({
        length: count
    }).map((_, i)=>{
        const end = start + estimateSize(i);
        const item = {
            index: i,
            key: getItemKey?.(i) ?? i,
            start: start,
            end: end,
            lane: 0,
            size: estimateSize(i)
        };
        start = end;
        return item;
    });
    return {
        getTotalSize () {
            return totalSize;
        },
        getVirtualItems () {
            return items;
        }
    };
};
const $02fccf8bdbf5d1dd$var$dummyVirtualizer = {
    getTotalSize () {
        return 0;
    },
    getVirtualItems () {
        return [];
    }
};
const $02fccf8bdbf5d1dd$export$e290ffcf7d3b6e02 = (options)=>{
    const { getScrollElement: getScrollElement, count: count, estimateSize: estimateSize, getItemKey: getItemKey } = options;
    const [shouldUseSSRVirtualizer, setShouldUseSSRVirtualizer] = (0, $eJOHy.useState)(true);
    const serverVirtualizer = (0, $eJOHy.useMemo)(()=>{
        if (shouldUseSSRVirtualizer) // only calculated when is going to be used
        return $02fccf8bdbf5d1dd$export$f4c0efb17365077d({
            count: count,
            estimateSize: estimateSize,
            getItemKey: getItemKey
        });
        return $02fccf8bdbf5d1dd$var$dummyVirtualizer;
    }, [
        count,
        estimateSize,
        getItemKey,
        shouldUseSSRVirtualizer
    ]);
    const originalVirtualizer = (0, $bVtHf.useVirtualizer)(options);
    /**
	 * We swap to real virtualization when we detect that the user has initiated a scroll
	 */ (0, $eJOHy.useEffect)(()=>{
        if (!shouldUseSSRVirtualizer) return;
        const element = getScrollElement();
        const onScroll = ()=>{
            if (!false) {
                setShouldUseSSRVirtualizer(false);
                element?.removeEventListener('scroll', onScroll);
            }
        };
        element?.addEventListener('scroll', onScroll);
        return ()=>{
            element?.removeEventListener('scroll', onScroll);
        };
    }, [
        shouldUseSSRVirtualizer,
        getScrollElement
    ]);
    /**
	 * We overwrite the methods to render the items and calculate size
	 * to assure that SSR renders the same as the frontend on the initial
	 * render
	 */ return (0, $eJOHy.useMemo)(()=>{
        if (shouldUseSSRVirtualizer) return {
            ...originalVirtualizer,
            ...serverVirtualizer
        };
        // Ensure we return a stable reference between renders when we stop using the SSR virtualizer
        return originalVirtualizer;
    }, [
        originalVirtualizer,
        serverVirtualizer,
        shouldUseSSRVirtualizer
    ]);
};

});
parcelRegister("bVtHf", function(module, exports) {
$parcel$export(module.exports, "defaultRangeExtractor", () => (parcelRequire("gMNDC")).defaultRangeExtractor);
$parcel$export(module.exports, "elementScroll", () => (parcelRequire("gMNDC")).elementScroll);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("8GBQp")).notUndefined);
$parcel$export(module.exports, "observeElementOffset", () => (parcelRequire("gMNDC")).observeElementOffset);
$parcel$export(module.exports, "observeElementRect", () => (parcelRequire("gMNDC")).observeElementRect);
$parcel$export(module.exports, "observeWindowOffset", () => (parcelRequire("gMNDC")).observeWindowOffset);
$parcel$export(module.exports, "observeWindowRect", () => (parcelRequire("gMNDC")).observeWindowRect);
$parcel$export(module.exports, "Virtualizer", () => (parcelRequire("gMNDC")).Virtualizer);
$parcel$export(module.exports, "windowScroll", () => (parcelRequire("gMNDC")).windowScroll);

$parcel$export(module.exports, "useVirtualizer", () => $8aec0db0c0df701a$export$dd6d526d88b5a137);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $gMNDC = parcelRequire("gMNDC");
const $8aec0db0c0df701a$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;
function $8aec0db0c0df701a$var$useVirtualizerBase(options) {
    const rerender = $eJOHy.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $aQK2r.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $eJOHy.useState(()=>new (0, $gMNDC.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $eJOHy.useEffect(()=>{
        return instance._didMount();
    }, []);
    $8aec0db0c0df701a$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $8aec0db0c0df701a$export$dd6d526d88b5a137(options) {
    return $8aec0db0c0df701a$var$useVirtualizerBase({
        observeElementRect: $gMNDC.observeElementRect,
        observeElementOffset: $gMNDC.observeElementOffset,
        scrollToFn: (0, $gMNDC.elementScroll),
        ...options
    });
}
function $8aec0db0c0df701a$export$645722dcac657cb9(options) {
    return $8aec0db0c0df701a$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $gMNDC.observeWindowRect),
        observeElementOffset: (0, $gMNDC.observeWindowOffset),
        scrollToFn: (0, $gMNDC.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});




parcelRegister("12O1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $b411531270e205ba$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3IF6p = parcelRequire("3IF6p");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $83DiZ = parcelRequire("83DiZ");

var $7jTnu = parcelRequire("7jTnu");

var $jE8Tu = parcelRequire("jE8Tu");

var $bnxIc = parcelRequire("bnxIc");

var $34oCh = parcelRequire("34oCh");
const $b411531270e205ba$var$KeyboardShortcuts = ({ issueKeys: issueKeys = [], onIssueLinkSelected: onIssueLinkSelected })=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const [selectedRowIndex, { selectNextRow: selectNextRow, selectPrevRow: selectPrevRow }] = (0, $bnxIc.useSelectedRow)();
    const [selectedIssueKey] = (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jE8Tu.useSelectedIssueKey)() : [
        null
    ];
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const keyMap = (0, $eJOHy.useMemo)(()=>{
        const navigateToIssue = (issueKey)=>{
            push(`/browse/${issueKey}`);
        };
        return {
            arrowup: {
                callback: (e)=>{
                    // Prevent native browser scrolling as we provide auto-scroll functionality via scrollIntoView
                    e?.preventDefault();
                    if (isGridNavigationEnabled) return;
                    selectPrevRow();
                }
            },
            arrowdown: {
                callback: (e)=>{
                    // Prevent native browser scrolling as we provide auto-scroll functionality via scrollIntoView
                    e?.preventDefault();
                    if (isGridNavigationEnabled) return;
                    selectNextRow();
                }
            },
            k: {
                callback: ()=>{
                    if (isGridNavigationEnabled) return;
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'rowItem pressed', 'navigateRowUp', {
                        rowIndex: selectedRowIndex,
                        keyPressed: 'k'
                    });
                    selectPrevRow();
                }
            },
            j: {
                callback: ()=>{
                    if (isGridNavigationEnabled) return;
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'rowItem pressed', 'navigateRowDown', {
                        rowIndex: selectedRowIndex,
                        keyPressed: 'j'
                    });
                    selectNextRow();
                }
            },
            o: {
                callback: ()=>{
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'tableIssueLink', {
                        fieldType: 'unknown',
                        keyPressed: 'o',
                        tableRowNumber: selectedRowIndex,
                        keyboardShortcut: true
                    });
                    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) {
                        if (typeof selectedIssueKey === 'string' && selectedIssueKey.length > 0) {
                            const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(selectedIssueKey);
                            if (!handled) navigateToIssue(selectedIssueKey);
                        }
                        return;
                    }
                    if (typeof selectedRowIndex === 'number') {
                        const issueKey = issueKeys[selectedRowIndex];
                        if (typeof issueKey === 'string' && issueKey.length > 0) {
                            const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey);
                            if (!handled) navigateToIssue(issueKey);
                        }
                    }
                }
            },
            z: {
                callback: ()=>{
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'tableIssueLink', {
                        fieldType: 'unknown',
                        keyPressed: 'z',
                        tableRowNumber: selectedRowIndex,
                        keyboardShortcut: true
                    });
                    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) {
                        if (typeof selectedIssueKey === 'string' && selectedIssueKey.length > 0) {
                            const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(selectedIssueKey);
                            if (!handled) navigateToIssue(selectedIssueKey);
                        }
                        return;
                    }
                    if (typeof selectedRowIndex === 'number') {
                        const issueKey = issueKeys[selectedRowIndex];
                        if (typeof issueKey === 'string' && issueKey.length > 0) {
                            const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey);
                            if (!handled) navigateToIssue(issueKey);
                        }
                    }
                }
            }
        };
    }, [
        push,
        selectPrevRow,
        selectNextRow,
        createAnalyticsEvent,
        selectedRowIndex,
        selectedIssueKey,
        onIssueLinkSelected,
        issueKeys,
        isGridNavigationEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), {
        keyMap: keyMap
    });
};
var $b411531270e205ba$export$2e2bcd8739ae039 = $b411531270e205ba$var$KeyboardShortcuts;

});
parcelRegister("3IF6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac4ee5f40705d91a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $hrKgE = parcelRequire("hrKgE");

var $kvNWh = parcelRequire("kvNWh");

var $676Hn = parcelRequire("676Hn");

var $b2ThO = parcelRequire("b2ThO");

var $dM9A7 = parcelRequire("dM9A7");

var $2ZGUP = parcelRequire("2ZGUP");

var $iUli2 = parcelRequire("iUli2");
let $ac4ee5f40705d91a$var$shortcutsCount = 0;
let $ac4ee5f40705d91a$var$subscription = null;
const $ac4ee5f40705d91a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eJOHy.useContext)((0, $2ZGUP.ShortcutRegistryContext)) || (0, $dM9A7.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const addKeyMap = (0, $eJOHy.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $iUli2.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $ac4ee5f40705d91a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $ac4ee5f40705d91a$var$shortcutsCount -= 1;
            if ($ac4ee5f40705d91a$var$subscription && $ac4ee5f40705d91a$var$shortcutsCount === 0) {
                $ac4ee5f40705d91a$var$subscription.unsubscribe();
                $ac4ee5f40705d91a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $ac4ee5f40705d91a$var$subscription = $ac4ee5f40705d91a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $b2ThO.default)().subscribe((0, $676Hn.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac4ee5f40705d91a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $kvNWh.useKeyboardShortcutsToggle), ...unstableProps })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps, (0, $7jTnu.fg)('jfp-magma-concurrent-keyboard-shortcuts-fix-2'));
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac4ee5f40705d91a$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("kvNWh", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $28efcafdf90afd66$export$a33a81f1fc5458ad);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $hWeHP = parcelRequire("hWeHP");

var $gCeeo = parcelRequire("gCeeo");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $28efcafdf90afd66$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $28efcafdf90afd66$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$28efcafdf90afd66$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $jGzN3.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $gYnSx.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $28efcafdf90afd66$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $hWeHP.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $28efcafdf90afd66$export$b62f67be35e65859
    }
});
const $28efcafdf90afd66$export$a33a81f1fc5458ad = (0, $iJq0l.createHook)($28efcafdf90afd66$var$Store);

});

parcelRegister("676Hn", function(module, exports) {

$parcel$export(module.exports, "default", () => $29a82f2f140805e4$export$2e2bcd8739ae039);

var $b2ThO = parcelRequire("b2ThO");

var $dM9A7 = parcelRequire("dM9A7");
const $29a82f2f140805e4$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$29a82f2f140805e4$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $dM9A7.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $b2ThO.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($29a82f2f140805e4$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $b2ThO.flush)();
    }
};

});
parcelRegister("b2ThO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb63e776564d4094$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $bb63e776564d4094$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("7SsGX");
parcelRequire("hnYRz");
parcelRequire("llumX");
parcelRequire("lVRem");
parcelRequire("1o2WJ");
parcelRequire("8rm0O");
parcelRequire("9Zsih");
parcelRequire("lf3vd");

var $aBrUN = parcelRequire("aBrUN");
const $bb63e776564d4094$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $bb63e776564d4094$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb63e776564d4094$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$bb63e776564d4094$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb63e776564d4094$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$bb63e776564d4094$var$isEditable(e.target) && !$bb63e776564d4094$var$ignoredKeys[e.key]);
const $bb63e776564d4094$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $bb63e776564d4094$var$key$;
const $bb63e776564d4094$var$flush$ = new (0, $6WhQS.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bb63e776564d4094$export$2e2bcd8739ae039 = ()=>{
    if (!$bb63e776564d4094$var$key$) {
        $bb63e776564d4094$var$key$ = false ? new (0, $6WhQS.Subject)() : (0, $7kixv.Observable).fromEvent(document, 'keydown').filter($bb63e776564d4094$var$isRelevantKeyEvent).filter($bb63e776564d4094$export$25d1b8252b4c49b7).map((0, $aBrUN.toKeyWithModifiers));
        const sequence$ = $bb63e776564d4094$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $bb63e776564d4094$var$key$ = $bb63e776564d4094$var$key$.debounceTime(1000).startWith(null).merge($bb63e776564d4094$var$flush$).switchMapTo(sequence$);
    }
    return $bb63e776564d4094$var$key$;
};
const $bb63e776564d4094$export$4909b86c8034bf73 = ()=>{
    $bb63e776564d4094$var$flush$.next();
};

});


parcelRegister("iUli2", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $0344ad6591542af9$export$77477772a9b904da);

var $eSnSE = parcelRequire("eSnSE");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");
const $0344ad6591542af9$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $7jTnu.fg)('log-hotkey-analytics')) (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $0344ad6591542af9$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $0344ad6591542af9$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});



parcelRegister("clZvH", function(module, exports) {

$parcel$export(module.exports, "default", () => $19be9f81dd7817e6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $19be9f81dd7817e6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    columnHeaderIssueType: {
        "id": "native-issue-table.column-header-issue-type",
        "defaultMessage": "Type"
    },
    columnHeaderIssueKey: {
        "id": "native-issue-table.column-header-issue-key",
        "defaultMessage": "Key"
    },
    columnHeaderIssueSummary: {
        "id": "native-issue-table.column-header-issue-summary",
        "defaultMessage": "Summary"
    },
    columnHeaderIssueAssignee: {
        "id": "native-issue-table.column-header-issue-assignee",
        "defaultMessage": "Assignee"
    },
    columnHeaderIssueReporter: {
        "id": "native-issue-table.column-header-issue-reporter",
        "defaultMessage": "Reporter"
    },
    columnHeaderIssuePriority: {
        "id": "native-issue-table.column-header-issue-priority",
        "defaultMessage": "P"
    },
    columnHeaderIssueStatus: {
        "id": "native-issue-table.column-header-issue-status",
        "defaultMessage": "Status"
    },
    columnHeaderIssueResolution: {
        "id": "native-issue-table.column-header-issue-resolution",
        "defaultMessage": "Resolution"
    },
    columnHeaderIssueCreatedDate: {
        "id": "native-issue-table.column-header-issue-created-date",
        "defaultMessage": "Created"
    },
    columnHeaderIssueUpdatedDate: {
        "id": "native-issue-table.column-header-issue-updated-date",
        "defaultMessage": "Updated"
    },
    columnHeaderIssueDueDate: {
        "id": "native-issue-table.column-header-issue-due-date",
        "defaultMessage": "Due"
    },
    columnHeaderIssueActions: {
        "id": "native-issue-table.column-header-issue-actions",
        "defaultMessage": "More actions"
    },
    aToZOrder: {
        "id": "native-issue-table.a-to-z-order",
        "defaultMessage": "A \u279E Z"
    },
    zToAOrder: {
        "id": "native-issue-table.z-to-a-order",
        "defaultMessage": "Z \u279E A"
    },
    oldestToNewestOrder: {
        "id": "native-issue-table.oldest-to-newest-order",
        "defaultMessage": "oldest \u279E newest"
    },
    newestToOldestOrder: {
        "id": "native-issue-table.newest-to-oldest-order",
        "defaultMessage": "newest \u279E oldest"
    },
    reorderColumnsErrorTitle: {
        "id": "native-issue-table.reorder-columns-error-title",
        "defaultMessage": "We couldn't reorder your columns"
    },
    reorderColumnsErrorDescription: {
        "id": "native-issue-table.reorder-columns-error-description",
        "defaultMessage": "Refresh and try again."
    },
    deprecatedParentLinkMessage: {
        "id": "native-issue-table.deprecated-parent-link-message",
        "defaultMessage": "<strong>Parent Link</strong> is replaced by <strong>Parent</strong>."
    }
});

});

parcelRegister("6IEtQ", function(module, exports) {

$parcel$export(module.exports, "RealtimeUpdater", () => $7730a02a24c2b4f3$export$baf32da5b0b92d2b);

var $1VVlY = parcelRequire("1VVlY");

var $e9UNF = parcelRequire("e9UNF");

var $kgbgh = parcelRequire("kgbgh");

var $f51ug = parcelRequire("f51ug");

var $eevS3 = parcelRequire("eevS3");

var $dN3Rl = parcelRequire("dN3Rl");

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $j4oe4 = parcelRequire("j4oe4");

var $kEUB1 = parcelRequire("kEUB1");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8oKDI = parcelRequire("8oKDI");

var $dnCkQ = parcelRequire("dnCkQ");

var $8jOO7 = parcelRequire("8jOO7");

var $lWbOe = parcelRequire("lWbOe");
const $7730a02a24c2b4f3$var$REAL_TIME_EVENT_TYPE_KEY = 'realTimeEventType';
const $7730a02a24c2b4f3$var$CREATE_ERROR_ID = 'realTimeIssueCreate';
const $7730a02a24c2b4f3$var$UPDATE_ERROR_ID = 'realTimeIssueUpdate';
const $7730a02a24c2b4f3$var$DELETE_ERROR_ID = 'realTimeIssueDelete';
const $7730a02a24c2b4f3$export$d3ea91bf4184016b = 100;
const $7730a02a24c2b4f3$export$2c7ede6e55079caa = 3000;
const $7730a02a24c2b4f3$var$throttledFireTrackAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((0, $gCeeo.fireTrackAnalytics), 1000);
const $7730a02a24c2b4f3$var$issueCreatedSubscription = (0, $dN3Rl.default);
const $7730a02a24c2b4f3$var$issueUpdatedSubscription = (0, $eevS3.default);
const $7730a02a24c2b4f3$var$issueDeletedSubscription = (0, $f51ug.default);
const $7730a02a24c2b4f3$export$baf32da5b0b92d2b = ({ project: project, issues: issues, groups: groups, isHierarchyEnabled: isHierarchyEnabled, isStatusTrackingEnabled: isStatusTrackingEnabled, onRefetch: onRefetch })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const hasExceededMaxQueueSizeRef = (0, $eJOHy.useRef)(false);
    const showRealtimeUpdateExceededMaxFlag = (0, $lWbOe.useRealtimeUpdateExceededMaxFlag)();
    const realtimeUpdatesForIssues = (0, $lWbOe.useRealtimeUpdatesForIssues)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const issueConnection = (0, $j4oe4.useFragment)((0, $kgbgh.default), issues ?? null);
    const groupConnection = (0, $j4oe4.useFragment)((0, $e9UNF.default), groups ?? null);
    const { projectId: projectId, key: projectKey } = (0, $j4oe4.useFragment)((0, $1VVlY.default), project);
    const { issueDeleteUpdater: issueDeleteUpdater } = (0, $dnCkQ.useIssueRealtimeUpdater)();
    const issueDeleteUpdaterRef = (0, $eJOHy.useRef)(issueDeleteUpdater);
    (0, $eJOHy.useEffect)(()=>{
        issueDeleteUpdaterRef.current = issueDeleteUpdater;
    }, [
        issueDeleteUpdater
    ]);
    const variables = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectId: projectId
        }), [
        cloudId,
        projectId
    ]);
    const queueRef = (0, $eJOHy.useRef)(new Map());
    const timeoutRef = (0, $eJOHy.useRef)(null);
    const processQueue = (0, $eJOHy.useCallback)(()=>{
        if (queueRef.current.size === 0 || hasExceededMaxQueueSizeRef.current) return;
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventQueueProcessing started', {
            queueSize: queueRef.current.size
        });
        if (queueRef.current.size > $7730a02a24c2b4f3$export$d3ea91bf4184016b) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventsExceededMaxFlag shown', {
                queueSize: queueRef.current.size
            });
            hasExceededMaxQueueSizeRef.current = true;
            showRealtimeUpdateExceededMaxFlag({
                onRefresh: ()=>{
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventsExceededMaxRefresh clicked');
                    hasExceededMaxQueueSizeRef.current = false;
                    queueRef.current = new Map();
                    onRefetch?.();
                }
            });
        } else realtimeUpdatesForIssues({
            issues: Array.from(queueRef.current.values()),
            isHierarchyEnabled: isHierarchyEnabled ?? false,
            jql: issueConnection?.jql || groupConnection?.jql || '',
            groupByFieldId: groupConnection?.groupByField || undefined,
            groupConnectionId: groupConnection?.__id,
            numGroupsLoaded: groupConnection?.edges?.length ?? 0,
            projectKey: projectKey,
            isStatusTrackingEnabled: isStatusTrackingEnabled ?? false
        });
        queueRef.current = new Map();
    }, [
        createAnalyticsEvent,
        showRealtimeUpdateExceededMaxFlag,
        onRefetch,
        realtimeUpdatesForIssues,
        isHierarchyEnabled,
        issueConnection?.jql,
        groupConnection?.jql,
        groupConnection?.groupByField,
        groupConnection?.__id,
        groupConnection?.edges?.length,
        projectKey,
        isStatusTrackingEnabled
    ]);
    const triggerDelayedProcessingOfQueue = (0, $eJOHy.useCallback)(()=>{
        // Existing timeout exists, so we don't need to create a new one
        if (timeoutRef.current) return;
        timeoutRef.current = setTimeout(()=>{
            processQueue();
            timeoutRef.current = null;
        }, $7730a02a24c2b4f3$export$2c7ede6e55079caa);
    }, [
        processQueue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const handleCreateOrUpdateEvent = (0, $eJOHy.useCallback)((issueAri, issueId)=>{
        queueRef.current.set(issueAri, {
            issueAri: issueAri,
            issueId: issueId
        });
        triggerDelayedProcessingOfQueue();
    }, [
        triggerDelayedProcessingOfQueue
    ]);
    const handleCreateOrUpdateEventRef = (0, $eJOHy.useRef)(handleCreateOrUpdateEvent);
    (0, $eJOHy.useEffect)(()=>{
        handleCreateOrUpdateEventRef.current = handleCreateOrUpdateEvent;
    }, [
        handleCreateOrUpdateEvent
    ]);
    const createConfig = (0, $eJOHy.useMemo)(()=>({
            variables: variables,
            subscription: $7730a02a24c2b4f3$var$issueCreatedSubscription,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueCreatedByProjectNoEnrichment?.resource;
                    if (resourceId && (0, $8oKDI.isAri)(resourceId)) handleCreateOrUpdateEventRef.current(resourceId, (0, $8oKDI.getAriConfig)(resourceId).resourceId);
                } catch (error) {
                    (0, $gYnSx.default)({
                        meta: {
                            id: $7730a02a24c2b4f3$var$CREATE_ERROR_ID,
                            packageName: (0, $8jOO7.PACKAGE_NAME),
                            teamName: (0, $8jOO7.TEAM_NAME)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $gYnSx.default)({
                    meta: {
                        id: $7730a02a24c2b4f3$var$CREATE_ERROR_ID,
                        packageName: (0, $8jOO7.PACKAGE_NAME),
                        teamName: (0, $8jOO7.TEAM_NAME)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables
    ]);
    const updateConfig = (0, $eJOHy.useMemo)(()=>({
            variables: variables,
            subscription: $7730a02a24c2b4f3$var$issueUpdatedSubscription,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueUpdatedByProjectNoEnrichment?.resource;
                    if (resourceId && (0, $8oKDI.isAri)(resourceId)) handleCreateOrUpdateEventRef.current(resourceId, (0, $8oKDI.getAriConfig)(resourceId).resourceId);
                } catch (error) {
                    (0, $gYnSx.default)({
                        meta: {
                            id: $7730a02a24c2b4f3$var$UPDATE_ERROR_ID,
                            packageName: (0, $8jOO7.PACKAGE_NAME),
                            teamName: (0, $8jOO7.TEAM_NAME)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $gYnSx.default)({
                    meta: {
                        id: $7730a02a24c2b4f3$var$UPDATE_ERROR_ID,
                        packageName: (0, $8jOO7.PACKAGE_NAME),
                        teamName: (0, $8jOO7.TEAM_NAME)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables
    ]);
    const deleteConfig = (0, $eJOHy.useMemo)(()=>{
        return {
            variables: variables,
            subscription: $7730a02a24c2b4f3$var$issueDeletedSubscription,
            updater: (store, response)=>{
                try {
                    if (response?.jira?.onIssueDeletedByProject?.resource) {
                        const wasDeleted = issueDeleteUpdaterRef.current({
                            store: store,
                            issueResourceId: response.jira.onIssueDeletedByProject.resource,
                            groupConnectionId: groupConnection?.__id,
                            projectKey: projectKey
                        });
                        wasDeleted && $7730a02a24c2b4f3$var$throttledFireTrackAnalytics(createAnalyticsEvent({}), 'issueTableRealTimeEvent processed', {
                            [$7730a02a24c2b4f3$var$REAL_TIME_EVENT_TYPE_KEY]: 'delete'
                        });
                    }
                } catch (error) {
                    (0, $gYnSx.default)({
                        meta: {
                            id: $7730a02a24c2b4f3$var$DELETE_ERROR_ID,
                            packageName: (0, $8jOO7.PACKAGE_NAME),
                            teamName: (0, $8jOO7.TEAM_NAME)
                        },
                        attributes: {
                            logLocation: 'updater'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $gYnSx.default)({
                    meta: {
                        id: $7730a02a24c2b4f3$var$DELETE_ERROR_ID,
                        packageName: (0, $8jOO7.PACKAGE_NAME),
                        teamName: (0, $8jOO7.TEAM_NAME)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
    }, [
        variables,
        groupConnection?.__id,
        projectKey,
        createAnalyticsEvent
    ]);
    (0, $j4oe4.useSubscription)(createConfig);
    (0, $j4oe4.useSubscription)(updateConfig);
    (0, $j4oe4.useSubscription)(deleteConfig);
    return null;
};

});
parcelRegister("1VVlY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c300413cc266a0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7cb36164b5bb4bdee088db8cbf6ff35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c300413cc266a0a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "realtimeUpdater_nativeIssueTable_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$3c300413cc266a0a$var$node.hash = "54f3e67da3b1a5a78dd3e50777d39b59";
var $3c300413cc266a0a$export$2e2bcd8739ae039 = $3c300413cc266a0a$var$node;

});

parcelRegister("e9UNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a028a37968ffe90$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cdf4eac0d7108a760c04d4abe4f1ad1c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4a028a37968ffe90$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "realtimeUpdater_nativeIssueTable_groups",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "groupByField"
        },
        {
            "concreteType": "JiraSpreadsheetGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$4a028a37968ffe90$var$node.hash = "ef119ccb02ba7801b3514b38181f129c";
var $4a028a37968ffe90$export$2e2bcd8739ae039 = $4a028a37968ffe90$var$node;

});

parcelRegister("kgbgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8425cfa27eb3fe8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf288cf061331c44eef6e6763c4066ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b8425cfa27eb3fe8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "realtimeUpdater_nativeIssueTable_issues",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$b8425cfa27eb3fe8$var$node.hash = "b4c334b7a561fdded3791060aeee02a7";
var $b8425cfa27eb3fe8$export$2e2bcd8739ae039 = $b8425cfa27eb3fe8$var$node;

});

parcelRegister("f51ug", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2673a9bc88dc61b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1dab65924f9c16744eaaf71efa50a300>>
 * @relayHash f117fb91c06f881fbe04e95f9257fc16
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0665bec0712e49315eb39aff9bb1080876bc59e57382be0ffd4f37a469637b1
const $c2673a9bc88dc61b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectId",
                            "variableName": "projectId"
                        }
                    ],
                    "concreteType": "JiraIssueDeletedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueDeletedByProject",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "realtimeUpdater_issueDeleted_Subscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "realtimeUpdater_issueDeleted_Subscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "e0665bec0712e49315eb39aff9bb1080876bc59e57382be0ffd4f37a469637b1",
            "metadata": {},
            "name": "realtimeUpdater_issueDeleted_Subscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$c2673a9bc88dc61b$var$node.hash = "d3d8f04ee66fc8e4f6135f2e2268776a";
var $c2673a9bc88dc61b$export$2e2bcd8739ae039 = $c2673a9bc88dc61b$var$node;

});

parcelRegister("eevS3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ae609c71536bd6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a5be52bf2a0c5890570e2234deb934f>>
 * @relayHash 70c5cbd47116df92d038a359e0a381dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 25f49fe0ada85ace5a4512fd45e0bde5c33a1a1007a90ef950b6cf4cfbc381bb
const $c8ae609c71536bd6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectId",
                            "variableName": "projectId"
                        }
                    ],
                    "concreteType": "JiraIssueUpdatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueUpdatedByProjectNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "realtimeUpdater_issueUpdated_Subscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "realtimeUpdater_issueUpdated_Subscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "25f49fe0ada85ace5a4512fd45e0bde5c33a1a1007a90ef950b6cf4cfbc381bb",
            "metadata": {},
            "name": "realtimeUpdater_issueUpdated_Subscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$c8ae609c71536bd6$var$node.hash = "04520c3372a5e618b1581cb15407d4b5";
var $c8ae609c71536bd6$export$2e2bcd8739ae039 = $c8ae609c71536bd6$var$node;

});

parcelRegister("dN3Rl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f03cb4277ec3366f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f33348b088e2140f90d8c07f40fc6460>>
 * @relayHash 8216059cbb21289b715613ce0d8b2e51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3706e99a71c70f741da285a6437c04100694acb85ba97ba586fb317fc01be2ad
const $f03cb4277ec3366f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectId",
                            "variableName": "projectId"
                        }
                    ],
                    "concreteType": "JiraIssueCreatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueCreatedByProjectNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "realtimeUpdater_issueCreated_Subscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "realtimeUpdater_issueCreated_Subscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "3706e99a71c70f741da285a6437c04100694acb85ba97ba586fb317fc01be2ad",
            "metadata": {},
            "name": "realtimeUpdater_issueCreated_Subscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$f03cb4277ec3366f$var$node.hash = "17e162496dfc818aef8a5e9ba2bb211d";
var $f03cb4277ec3366f$export$2e2bcd8739ae039 = $f03cb4277ec3366f$var$node;

});

parcelRegister("dnCkQ", function(module, exports) {

$parcel$export(module.exports, "useIssueRealtimeUpdater", () => $9930494e7ca458a9$export$bf267694965fe0e3);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $kqd31 = parcelRequire("kqd31");

var $dLXgn = parcelRequire("dLXgn");

var $57Nys = parcelRequire("57Nys");
const $9930494e7ca458a9$var$JIRA_ISSUE_TYPENAME = 'JiraIssue';
const $9930494e7ca458a9$export$6d61b264f874da2c = ({ store: store, connectionRecord: connectionRecord, fieldSetsRecordId: fieldSetsRecordId, issueRecordId: issueRecordId, position: position, projectKey: projectKey })=>{
    const issueRecord = store.get(issueRecordId);
    const fieldSetsRecord = fieldSetsRecordId ? store.get(fieldSetsRecordId) : undefined;
    if (!issueRecord || !fieldSetsRecord) return;
    const edge = (0, $37Ewn.ConnectionHandler).createEdge(store, connectionRecord, issueRecord, 'JiraIssueEdge');
    const fieldSets = edge.getOrCreateLinkedRecord('fieldSets', 'JiraIssueFieldSetEdge', {
        first: 500
    });
    fieldSets.copyFieldsFrom(fieldSetsRecord);
    const updateArgs = projectKey ? {
        projectKey: projectKey
    } : undefined;
    const canHaveChildIssues = issueRecord.getValue('canHaveChildIssues', updateArgs);
    if (canHaveChildIssues) edge.setValue(true, 'canHaveChildIssues', updateArgs);
    // no before or after implies an empty connection, verify then create the edges list
    const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES);
    if (!edges || position === -1 || position == null) return;
    const nextEdges = edges.slice(0, position).concat(edge).concat(edges.slice(position));
    connectionRecord.setLinkedRecords(nextEdges, EDGES);
};
const $9930494e7ca458a9$export$bf267694965fe0e3 = ()=>{
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    const updateIssuesOnConnection = (0, $eJOHy.useCallback)(({ store: store, connection: connection, searchViewContexts: searchViewContexts, updatedIssues: updatedIssues, groupConnectionId: groupConnectionId, projectKey: projectKey })=>{
        const issuesProcessedAnalytics = {
            issuesUnmoved: new Set(),
            issuesMoved: new Set(),
            issuesRemoved: new Set(),
            issuesUnrelated: new Set()
        };
        const connectionRecord = store.get(connection.connectionId);
        if (!connectionRecord) return issuesProcessedAnalytics;
        const issuesWithContext = new Set(searchViewContexts?.flatMap((context)=>context?.sourceIssueId).filter(Boolean));
        const startingIssuesInConnection = new Set(connectionRecord.getLinkedRecords('edges')?.map((edge)=>edge?.getLinkedRecord('node')?.getDataID()));
        let changeInIssueCount = 0;
        updatedIssues.forEach((issue)=>{
            if (!issuesWithContext.has(issue.issueId)) {
                if (startingIssuesInConnection.has(issue.issueRecordId)) {
                    (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, issue.issueRecordId);
                    changeInIssueCount -= 1;
                    issuesProcessedAnalytics.issuesRemoved.add(issue.issueId);
                } else issuesProcessedAnalytics.issuesUnrelated.add(issue.issueId);
            }
        });
        searchViewContexts?.forEach((context)=>{
            const currentIssues = connectionRecord.getLinkedRecords('edges');
            const issueForContext = updatedIssues.get(context.sourceIssueId);
            if (!currentIssues || !issueForContext) return;
            const positionForIssue = (0, $57Nys.getIssueIndexInConnection)({
                issues: currentIssues,
                issuesWithContext: issuesWithContext,
                context: context
            });
            const issueAtPosition = currentIssues[positionForIssue];
            if (issueAtPosition && issueAtPosition.getLinkedRecord('node')?.getDataID() !== issueForContext.issueRecordId || context.position === currentIssues.length // the item would be the next loaded issue, insert in case the last page is loaded to ensure it appears in all cases
            ) {
                if (startingIssuesInConnection.has(issueForContext.issueRecordId)) (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, issueForContext.issueRecordId);
                else changeInIssueCount += 1;
                $9930494e7ca458a9$export$6d61b264f874da2c({
                    store: store,
                    connectionRecord: connectionRecord,
                    fieldSetsRecordId: issueForContext.fieldSetsRecordId,
                    issueRecordId: issueForContext.issueRecordId,
                    position: positionForIssue,
                    projectKey: projectKey
                });
                issuesProcessedAnalytics.issuesMoved.add(issueForContext.issueId);
            } else if (issueAtPosition != null) issuesProcessedAnalytics.issuesUnmoved.add(issueForContext.issueId);
            else if (positionForIssue > currentIssues.length && startingIssuesInConnection.has(issueForContext.issueRecordId)) {
                (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, issueForContext.issueRecordId);
                issuesProcessedAnalytics.issuesMoved.add(issueForContext.issueId);
                changeInIssueCount -= 1;
            } else issuesProcessedAnalytics.issuesUnrelated.add(issueForContext.issueId);
            // the issue has been handled, pop it so we can know its place in the list is trustworthy and will not be moved for relative positioning purposes
            issuesWithContext.delete(context.sourceIssueId);
        });
        updateConnectionDetails({
            store: store,
            connection: connection,
            netChangeInIssueCount: changeInIssueCount,
            remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length,
            groupConnectionId: groupConnectionId,
            projectKey: projectKey
        });
        return issuesProcessedAnalytics;
    }, [
        updateConnectionDetails
    ]);
    const updateNewParentsOnConnection = (0, $eJOHy.useCallback)(({ store: store, connection: connection, updatedParents: updatedParents, projectKey: projectKey })=>{
        const connectionRecord = store.get(connection.connectionId);
        const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
        const edges = connectionRecord?.getLinkedRecords(EDGES);
        edges?.forEach((edge)=>{
            const parentIssueRecordId = edge?.getLinkedRecord('node')?.getDataID();
            if (parentIssueRecordId && updatedParents.has(parentIssueRecordId)) (0, $57Nys.updateParentHasChildren)({
                store: store,
                parentIssueEdgeRecordId: edge?.getDataID(),
                // this refers the the children connection of the parent, where this update is designed to work on parents where no connection can exist now
                connectionId: undefined,
                hasChildren: true,
                projectKey: projectKey
            });
        });
    }, []);
    const issueDeleteUpdater = (0, $eJOHy.useCallback)(({ store: store, issueResourceId: issueResourceId, groupConnectionId: groupConnectionId, projectKey: projectKey })=>{
        const id = (0, $kqd31.default)({
            id: issueResourceId
        }, $9930494e7ca458a9$var$JIRA_ISSUE_TYPENAME);
        let wasDeleted = false;
        if (!id) return wasDeleted;
        Object.values(connections).forEach((connection)=>{
            const connectionRecord = store.get(connection.connectionId);
            if (!connectionRecord) return;
            // check if the issue is in the connection
            if (connectionRecord.getLinkedRecords('edges')?.some((edge)=>edge?.getLinkedRecord('node')?.getDataID() === id)) {
                (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, id);
                updateConnectionDetails({
                    store: store,
                    connection: connection,
                    netChangeInIssueCount: -1,
                    remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length,
                    groupConnectionId: groupConnectionId,
                    projectKey: projectKey
                });
                wasDeleted = true;
            }
        });
        return wasDeleted;
    }, [
        connections,
        updateConnectionDetails
    ]);
    const groupsForIssueUpdater = (0, $eJOHy.useCallback)(({ store: store, groupConnectionId: groupConnectionId, groupsForIssue: groupsForIssue })=>{
        let wasUpdated = false;
        if (!groupConnectionId) return wasUpdated;
        const groupsConnection = store.get(groupConnectionId);
        if (!groupsConnection) return wasUpdated;
        let groupEdges = groupsConnection.getLinkedRecords('edges') || [];
        const existingGroupIds = new Set(groupEdges?.map((edge)=>edge?.getLinkedRecord('node')?.getValue('id')));
        groupsForIssue.forEach((group)=>{
            const newGroup = store.get(group.__id);
            if (!existingGroupIds.has(group.id) && newGroup) {
                groupEdges = (0, $57Nys.insertNewGroupInGroupsConnection)({
                    store: store,
                    groupsConnection: groupsConnection,
                    newGroup: newGroup,
                    groupEdges: groupEdges,
                    afterGroupId: group.afterGroupId
                });
                wasUpdated = true;
            }
        });
        groupsConnection.setLinkedRecords(groupEdges, 'edges');
        return wasUpdated;
    }, []);
    return {
        issueDeleteUpdater: issueDeleteUpdater,
        groupsForIssueUpdater: groupsForIssueUpdater,
        updateIssuesOnConnection: updateIssuesOnConnection,
        updateNewParentsOnConnection: updateNewParentsOnConnection
    };
};

});

parcelRegister("lWbOe", function(module, exports) {

$parcel$export(module.exports, "useRealtimeUpdatesForIssues", () => $05a38ba5fed39443$export$9688da58398f9e26);
$parcel$export(module.exports, "useRealtimeUpdateExceededMaxFlag", () => $05a38ba5fed39443$export$b8dd0666e1c54372);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $i4Iw4 = parcelRequire("i4Iw4");

var $7zZ4w = parcelRequire("7zZ4w");

var $kEUB1 = parcelRequire("kEUB1");

var $dLXgn = parcelRequire("dLXgn");

var $bILK0 = parcelRequire("bILK0");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $34oCh = parcelRequire("34oCh");

var $5NEjg = parcelRequire("5NEjg");

var $dnCkQ = parcelRequire("dnCkQ");

var $gYIL3 = parcelRequire("gYIL3");

var $fXRJZ = parcelRequire("fXRJZ");

var $651sM = parcelRequire("651sM");
const $05a38ba5fed39443$export$cb618b52025e9ed0 = ({ connections: connections, isGroupingEnabled: isGroupingEnabled, groupedByFieldId: groupedByFieldId })=>{
    const expandedParents = [];
    const groups = [];
    let topLevelItemsLoaded = 0;
    Object.values(connections).forEach((connection)=>{
        if (connection.type === 'PARENT_CHILDREN') expandedParents.push({
            parentIssueId: connection.parentId,
            first: connection.first
        });
        else if (connection.type === 'GROUP_CHILDREN') groups.push({
            jql: connection.jql,
            fieldValue: connection.fieldValue,
            first: connection.first
        });
        else if (connection.type === 'ROOT_ISSUES') topLevelItemsLoaded = connection.first;
    });
    if (isGroupingEnabled && groupedByFieldId) return {
        expandedGroups: {
            groupedByFieldId: groupedByFieldId,
            groups: groups
        }
    };
    return {
        expandedParents: expandedParents,
        topLevelItemsLoaded: topLevelItemsLoaded
    };
};
const $05a38ba5fed39443$export$9688da58398f9e26 = ()=>{
    const environment = (0, $7zZ4w.default)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { fieldSetIds: fieldSetIds } = (0, $5NEjg.useIssueFetchQueryVariables)();
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const getGroupsForIssues = (0, $fXRJZ.useGetGroupsForIssues)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getRealtimeIssueDetails = (0, $gYIL3.useGetRealtimeIssueDetails)();
    const { updateIssuesOnConnection: updateIssuesOnConnection, groupsForIssueUpdater: groupsForIssueUpdater, updateNewParentsOnConnection: updateNewParentsOnConnection } = (0, $dnCkQ.useIssueRealtimeUpdater)();
    const isConditionalFormattingEnabled = (0, $7jTnu.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $34oCh.useIsConditionalFormattingEnabled)();
    return (0, $eJOHy.useCallback)(async ({ issues: issues, jql: jql, groupByFieldId: groupByFieldId, numGroupsLoaded: numGroupsLoaded, groupConnectionId: groupConnectionId, isHierarchyEnabled: isHierarchyEnabled, projectKey: projectKey, isStatusTrackingEnabled: isStatusTrackingEnabled })=>{
        const isGroupingEnabled = !!groupByFieldId;
        const searchViewContextInput = $05a38ba5fed39443$export$cb618b52025e9ed0({
            connections: connections,
            isGroupingEnabled: isGroupingEnabled,
            groupedByFieldId: groupByFieldId
        });
        const { issues: updatedIssues, searchViewContexts: searchViewContexts } = await getRealtimeIssueDetails({
            issues: issues,
            cloudId: cloudId,
            fieldSetIds: fieldSetIds,
            isInlineEditingEnabled: isInlineEditingEnabled,
            isDensityFull: isDensityFull,
            isHierarchyEnabled: isHierarchyEnabled,
            isGroupingEnabled: isGroupingEnabled,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            issueSearchInput: {
                jql: jql
            },
            searchViewContextInput: searchViewContextInput,
            projectKey: projectKey,
            isStatusTrackingEnabled: isStatusTrackingEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            isTimelineEnabled: isTimelineEnabled
        });
        let groupsToInsert;
        if (isGroupingEnabled && groupByFieldId) {
            const issueKeysWithContext = new Set(searchViewContexts?.flatMap((connection)=>{
                return connection.contexts?.map((context)=>context?.sourceIssueId);
            }).filter(Boolean));
            const issueChangesWithoutContext = updatedIssues?.reduce((acc, issue)=>{
                if (issue && !issueKeysWithContext.has(issue.issueId ?? '')) acc.push({
                    issueId: issue.issueId
                });
                return acc;
            }, []);
            groupsToInsert = await getGroupsForIssues({
                issueChanges: issueChangesWithoutContext,
                fieldId: groupByFieldId,
                numGroupsLoaded: numGroupsLoaded,
                issueSearchInput: {
                    jql: jql
                },
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: isGroupingEnabled,
                    isHideDoneEnabled: isHideDoneItemsEnabled
                }
            });
        }
        const eventDetails = {
            issuesUnmoved: new Set(),
            issuesUnrelated: new Set(),
            issuesUpdated: new Set()
        };
        const updatedIssuesMap = new Map(updatedIssues?.map(({ issueId: issueId, issueRecordId: issueRecordId, fieldSetsRecordId: fieldSetsRecordId })=>[
                issueId,
                {
                    issueId: issueId,
                    issueRecordId: issueRecordId,
                    fieldSetsRecordId: fieldSetsRecordId
                }
            ]));
        const updatedParents = new Set(updatedIssues.map((issue)=>issue.parentIssueRecordId).filter(Boolean));
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            Object.values(connections).forEach((connection)=>{
                updateNewParentsOnConnection({
                    store: store,
                    connection: connection,
                    updatedParents: updatedParents,
                    projectKey: projectKey
                });
                const matchingContext = searchViewContexts?.find((context)=>{
                    if (connection.type === 'PARENT_CHILDREN') return context?.parentIssueId === connection.parentId;
                    if (connection.type === 'GROUP_CHILDREN') return context?.jql === connection.jql;
                    return context?.jql == null && context?.parentIssueId == null;
                });
                const updatedDetails = updateIssuesOnConnection({
                    store: store,
                    connection: connection,
                    searchViewContexts: matchingContext?.contexts ?? [],
                    updatedIssues: updatedIssuesMap,
                    groupConnectionId: groupConnectionId,
                    projectKey: projectKey
                });
                updatedDetails.issuesMoved.forEach(eventDetails.issuesUpdated.add, eventDetails.issuesUpdated);
                updatedDetails.issuesUnmoved.forEach(eventDetails.issuesUnmoved.add, eventDetails.issuesUnmoved);
                updatedDetails.issuesUnrelated.forEach(eventDetails.issuesUnrelated.add, eventDetails.issuesUnrelated);
                updatedDetails.issuesRemoved.forEach(eventDetails.issuesUpdated.add, eventDetails.issuesUpdated);
            });
            if (groupsToInsert && groupsToInsert.length > 0) groupsForIssueUpdater({
                store: store,
                groupConnectionId: groupConnectionId,
                groupsForIssue: groupsToInsert
            });
        });
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventsIssueDetails Processed', {
            issuesInSamePosition: eventDetails.issuesUnmoved.size,
            issuesInNewPosition: eventDetails.issuesUpdated.size,
            issuesNotImpactingList: Array.from(eventDetails.issuesUnrelated).reduce((acc, issueId)=>eventDetails.issuesUpdated.has(issueId) || eventDetails.issuesUnmoved.has(issueId) ? acc : acc + 1, 0)
        });
    }, [
        connections,
        getRealtimeIssueDetails,
        cloudId,
        fieldSetIds,
        isInlineEditingEnabled,
        isDensityFull,
        isHideDoneItemsEnabled,
        environment,
        createAnalyticsEvent,
        getGroupsForIssues,
        updateNewParentsOnConnection,
        updateIssuesOnConnection,
        groupsForIssueUpdater,
        isConditionalFormattingEnabled,
        isTimelineEnabled
    ]);
};
const $05a38ba5fed39443$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID = 'native-issue-table.ui.realtime-updater.flag.info.native-issue-table.ui.realtime-update-exceeded-max-flag';
const $05a38ba5fed39443$export$b8dd0666e1c54372 = ()=>{
    const { showFlag: showFlag, hasFlag: hasFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const environment = (0, $7zZ4w.default)();
    return (0, $eJOHy.useCallback)(({ onRefresh: onRefresh })=>{
        if (!hasFlag?.($05a38ba5fed39443$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID)) showFlag({
            type: 'info',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-information, #1D7AFC)"
            }),
            title: (0, $651sM.default).realtimeUpdateExceededMaxHeader,
            description: (0, $651sM.default).realtimeUpdateExceededMaxDescription,
            messageId: $05a38ba5fed39443$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
            id: $05a38ba5fed39443$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
            messageType: 'transactional',
            isAutoDismiss: true,
            actions: [
                {
                    content: (0, $651sM.default).realtimeUpdateExceededMaxRefreshButton,
                    onClick: ()=>{
                        // This will reload all expanded parents/groups
                        environment.commitUpdate((store)=>{
                            Object.values(connections).forEach((connection)=>{
                                const connectionToInvalidate = store.get(connection.connectionId);
                                if (connectionToInvalidate) connectionToInvalidate.invalidateRecord();
                            });
                        });
                        dismissFlag($05a38ba5fed39443$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID);
                        onRefresh();
                    }
                }
            ]
        });
    }, [
        connections,
        dismissFlag,
        environment,
        hasFlag,
        showFlag
    ]);
};

});
parcelRegister("gYIL3", function(module, exports) {

$parcel$export(module.exports, "useGetRealtimeIssueDetails", () => $59b272b185056213$export$d36444b54640c2df);

var $9AR4c = parcelRequire("9AR4c");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $7zZ4w = parcelRequire("7zZ4w");

var $8jOO7 = parcelRequire("8jOO7");
const $59b272b185056213$export$d36444b54640c2df = ()=>{
    return (0, $eJOHy.useCallback)(async ({ issues: issues, cloudId: cloudId, fieldSetIds: fieldSetIds, isInlineEditingEnabled: isInlineEditingEnabled, isDensityFull: isDensityFull, isHierarchyEnabled: isHierarchyEnabled, isGroupingEnabled: isGroupingEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, issueSearchInput: issueSearchInput, searchViewContextInput: searchViewContextInput, projectKey: projectKey, isTimelineEnabled: isTimelineEnabled })=>{
        const environment = (0, $7zZ4w.default)();
        try {
            // if the issue is in a loaded context, the issue is visible so we need to fetch the fields for display
            const result = await (0, $j4oe4.fetchQuery)(environment, (0, $9AR4c.default), {
                issueAris: issues.map((issue)=>issue.issueAri),
                cloudId: cloudId,
                fieldSetIds: fieldSetIds,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isDensityFull: isDensityFull,
                issueSearchInput: issueSearchInput,
                searchViewContextInput: searchViewContextInput,
                isHierarchyEnabled: isHierarchyEnabled ?? false,
                projectKey: projectKey,
                issueChanges: issues.map((issue)=>({
                        issueId: issue.issueId
                    })),
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: isGroupingEnabled,
                    isHideDoneEnabled: isHideDoneItemsEnabled
                },
                isTimelineEnabled: isTimelineEnabled
            }, {
                fetchPolicy: 'network-only'
            }).toPromise();
            return {
                issues: result?.jira_issuesByIds?.filter(Boolean)?.map((issue)=>({
                        issueId: issue.issueId,
                        issueRecordId: issue.__id,
                        fieldSetsRecordId: issue.fieldSetsById?.__id,
                        parentIssueRecordId: issue.parentIssueField?.parentIssue?.__id
                    })) ?? [],
                searchViewContexts: result?.jira?.searchViewContexts?.edges?.map((edge)=>{
                    if (!edge?.node) return undefined;
                    return {
                        parentIssueId: edge.node.parentIssueId ?? undefined,
                        jql: edge.node.jql ?? undefined,
                        contexts: edge?.node?.contexts?.map((context)=>({
                                position: context.position,
                                sourceIssueId: context.sourceIssueId,
                                beforeIssueId: context.beforeIssueId,
                                afterIssueId: context.afterIssueId
                            })) ?? []
                    };
                }).filter(Boolean) ?? []
            };
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'realTimeFetchIssueFieldSetConnection',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
            return Promise.resolve({
                issues: [],
                searchViewContexts: []
            });
        }
    }, []);
};

});
parcelRegister("9AR4c", function(module, exports) {

$parcel$export(module.exports, "default", () => $97b95b06ec23a472$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<52d870759c7dc945544b7a38dea6fee4>>
 * @relayHash 47f3e733c2d3841ab6285d6e7eb01cbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 575e6194f4bd5d924ec00ad1885dc29aeffcf2bf60224f511b3d506c57ac2e48

var $kZq2R = parcelRequire("kZq2R");

var $5CxJ3 = parcelRequire("5CxJ3");

var $eHMRp = parcelRequire("eHMRp");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $ePJhs = parcelRequire("ePJhs");

var $bU8Sj = parcelRequire("bU8Sj");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");
const $97b95b06ec23a472$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHierarchyEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueAris"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueChanges"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchViewContextInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v13 = [
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "issueAris"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v15 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v16 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v20 = {
        "args": [
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "canHaveChildIssues"
    }, v21 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueChanges",
            "variableName": "issueChanges"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "searchViewContextInput",
            "variableName": "searchViewContextInput"
        },
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "parentIssueId"
            }
        ],
        "type": "JiraIssueSearchBulkViewParentContexts"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jql"
            }
        ],
        "type": "JiraIssueSearchBulkViewGroupContexts"
    }, v24 = {
        "kind": "ScalarField",
        "name": "sourceIssueId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "position"
    }, v26 = {
        "kind": "ScalarField",
        "name": "beforeIssueId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "afterIssueId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "type"
    }, v29 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v30 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v31 = {
        "kind": "ScalarField",
        "name": "name"
    }, v32 = {
        "kind": "ScalarField",
        "name": "value"
    }, v33 = [
        v32 /*: any*/ ,
        v18 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v34 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v35 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v36 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v37 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v38 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v39 = {
        "kind": "ScalarField",
        "name": "text"
    }, v40 = {
        "kind": "InlineFragment",
        "selections": [
            v39 /*: any*/ ,
            v31 /*: any*/ ,
            v34 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v41 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v42 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v18 /*: any*/ 
        ]
    }, v43 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v44 = [
        v41 /*: any*/ 
    ], v45 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v46 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v47 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v48 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v49 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v50 = [
        v18 /*: any*/ 
    ], v51 = [
        v31 /*: any*/ ,
        v18 /*: any*/ 
    ], v52 = {
        "kind": "ScalarField",
        "name": "date"
    }, v53 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v54 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v55 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v54 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v56 = [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                },
                v31 /*: any*/ ,
                v18 /*: any*/ 
            ]
        }
    ], v57 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v39 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v58 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v42 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v59 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v60 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v59 /*: any*/ ,
                    v31 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            },
            v18 /*: any*/ 
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v62 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v63 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v55 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v64 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v65 = {
        "kind": "ScalarField",
        "name": "number"
    }, v66 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v67 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v63 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v68 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v69 = [
        v29 /*: any*/ ,
        v30 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v52 /*: any*/ 
            ],
            "type": "JiraDatePickerField"
        },
        v18 /*: any*/ 
    ], v70 = [
        v29 /*: any*/ ,
        v18 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "realtimeIssueDetails_Query",
            "selections": [
                {
                    "args": v13 /*: any*/ ,
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "jira_issuesByIds",
                    "plural": true,
                    "selections": [
                        v14 /*: any*/ ,
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "isConditionalFormattingEnabled",
                                            "variableName": "isConditionalFormattingEnabled"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isDensityFull",
                                            "variableName": "isDensityFull"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isInlineEditingEnabled",
                                            "variableName": "isInlineEditingEnabled"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isTimelineEnabled",
                                            "variableName": "isTimelineEnabled"
                                        }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
                                },
                                v15 /*: any*/ 
                            ]
                        },
                        v17 /*: any*/ ,
                        {
                            "condition": "isHierarchyEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "progressSummary_issueViewChildIssuesPanel_statusAndResolved"
                        },
                        v15 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v21 /*: any*/ ,
                            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
                            "kind": "LinkedField",
                            "name": "searchViewContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchBulkViewContextMapping",
                                                    "kind": "LinkedField",
                                                    "name": "contexts",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v24 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.searchViewContexts.edges.node.contexts.sourceIssueId"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v25 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.searchViewContexts.edges.node.contexts.position"
                                                        },
                                                        v26 /*: any*/ ,
                                                        v27 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v12 /*: any*/ ,
                v9 /*: any*/ ,
                v11 /*: any*/ ,
                v10 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "realtimeIssueDetails_Query",
            "selections": [
                {
                    "args": v13 /*: any*/ ,
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "jira_issuesByIds",
                    "plural": true,
                    "selections": [
                        v14 /*: any*/ ,
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldSetId"
                                                },
                                                {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v29 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraIssueField"
                                                                        },
                                                                        v18 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "serviceId"
                                                                                                        },
                                                                                                        v31 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraAffectedServicesField"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraCascadingOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "cascadingOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentOptionValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v33 /*: any*/ 
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "childOptionValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v33 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraCascadingSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "args": v35 /*: any*/ ,
                                                                                            "concreteType": "JiraComponentConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedComponentsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponent",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v36 /*: any*/ ,
                                                                                                                v37 /*: any*/ ,
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                        },
                                                                                        v34 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraComponentsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v38 /*: any*/ ,
                                                                                        v31 /*: any*/ ,
                                                                                        v34 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDateTimePickerField"
                                                                                },
                                                                                v40 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCommentSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "commentSummary",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "canAddComment"
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraCommentSummaryField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "uri"
                                                                                        },
                                                                                        v34 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraUrlField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v32 /*: any*/ ,
                                                                                                v42 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": v44 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOptionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                v32 /*: any*/ ,
                                                                                                                v43 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOptionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                v32 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraCheckboxesField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraUserConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedUsersConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v29 /*: any*/ ,
                                                                                                                v45 /*: any*/ ,
                                                                                                                v31 /*: any*/ ,
                                                                                                                v46 /*: any*/ ,
                                                                                                                v18 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "email"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraTeamView",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedTeam",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "jiraSuppliedId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "jiraSuppliedName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraTeamViewField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "timeTrackingField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraEstimate",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "originalEstimate",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "timeInSeconds"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTimeTrackingSettings",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "timeTrackingSettings",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "workingHoursPerDay"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "workingDaysPerWeek"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "defaultFormat"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "defaultUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v30 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v48 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraRadioSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "args": v35 /*: any*/ ,
                                                                                            "concreteType": "JiraVersionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedVersionsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                v31 /*: any*/ ,
                                                                                                                v36 /*: any*/ ,
                                                                                                                v37 /*: any*/ ,
                                                                                                                v49 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                        },
                                                                                        v34 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issue",
                                                                                            "plural": false,
                                                                                            "selections": v50 /*: any*/ 
                                                                                        },
                                                                                        {
                                                                                            "args": v35 /*: any*/ ,
                                                                                            "concreteType": "JiraGoalConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedGoals",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoal",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v15 /*: any*/ 
                                                                                            ],
                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        v15 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraGoalsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "args": v35 /*: any*/ ,
                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "href"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                        },
                                                                                        v34 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "objectId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "label"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "mediaClientConfig",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "clientId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "fileId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "mediaJwtToken"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "url48"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "QueryError",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "errors",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "message"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraCMDBField"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": "componentsOld",
                                                                                            "concreteType": "JiraComponentConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedComponentsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponent",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": v51 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraComponentsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v39 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v52 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v53 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraDatePickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v38 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraDateTimePickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraEpic",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "epic",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "summary"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "color"
                                                                                        },
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraEpicLinkField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "renderedFieldHtml"
                                                                                }
                                                                            ],
                                                                            "type": "JiraFallbackField"
                                                                        },
                                                                        v40 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraStatusCategory",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "statusCategory",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        v54 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraStatus",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "status",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "statusId"
                                                                                        },
                                                                                        v55 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "args": v35 /*: any*/ ,
                                                                                    "concreteType": "JiraLabelConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedLabelsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraLabelEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraLabel",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        v42 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                },
                                                                                v31 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraLabelsField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": v56 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": v56 /*: any*/ 
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "parentIssue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        v57 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "parentIssue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v17 /*: any*/ ,
                                                                                                v58 /*: any*/ ,
                                                                                                v60 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "parentIssue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v17 /*: any*/ ,
                                                                                                v58 /*: any*/ ,
                                                                                                v60 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v14 /*: any*/ ,
                                                                                                v61 /*: any*/ ,
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "ids",
                                                                                                            "value": [
                                                                                                                "issuetype",
                                                                                                                "project",
                                                                                                                "summary",
                                                                                                                "status"
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldsById",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v29 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v39 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v62 /*: any*/ ,
                                                                                                                                        v31 /*: any*/ ,
                                                                                                                                        v59 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v63 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusField"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v31 /*: any*/ ,
                                                                                        v34 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraParentIssueField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priority",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "iconUrl"
                                                                                        },
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v31 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraPriorityField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraProject",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "project",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        v17 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraAvatar",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "avatar",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "large"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraProjectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraResolution",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "resolution",
                                                                                    "plural": false,
                                                                                    "selections": v51 /*: any*/ 
                                                                                }
                                                                            ],
                                                                            "type": "JiraResolutionField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprintConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedSprintsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraSprintEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "sprintId"
                                                                                                        },
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "state"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "endDate"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v31 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSprintField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v31 /*: any*/ ,
                                                                                        v18 /*: any*/ ,
                                                                                        v47 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v31 /*: any*/ ,
                                                                                v53 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "args": v35 /*: any*/ ,
                                                                                    "concreteType": "JiraVersionConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedVersionsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraVersionEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": v51 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                }
                                                                            ],
                                                                            "type": "JiraMultipleVersionPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraRichText",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "richText",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraADF",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "adfValue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "isDensityFull",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "convertedPlainText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "plainText"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "isDensityFull",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "json"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraRichTextField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "requestType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        v59 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "first",
                                                                                            "value": 1
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueLinkConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v41 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v61 /*: any*/ ,
                                                                                                                v17 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "statusCategory"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v29 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v55 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                        },
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                },
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v64 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueLinkField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isStoryPointField"
                                                                                },
                                                                                v65 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        v65 /*: any*/ ,
                                                                                        v66 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        v65 /*: any*/ ,
                                                                                        v31 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v66 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v34 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNumberField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraGroupConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedGroupsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGroupEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroup",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "groupId"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v34 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraMultipleGroupPickerField"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraFlag",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "flag",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFlagged"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFlagField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraWatch",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "watch",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "count"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isWatching"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraWatchesField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueLink",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueLink",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "direction"
                                                                                                },
                                                                                                v64 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "type",
                                                                                                    "plural": false,
                                                                                                    "selections": v50 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isInlineEditingEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isEditableInIssueView"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "isTimelineEnabled",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v14 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypeField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": v51 /*: any*/ 
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v17 /*: any*/ ,
                                                                                                v67 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "assigneeField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v29 /*: any*/ ,
                                                                                                                v46 /*: any*/ ,
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "args": v68 /*: any*/ ,
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "startDateViewField",
                                                                                                    "plural": false,
                                                                                                    "selections": v69 /*: any*/ ,
                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                },
                                                                                                {
                                                                                                    "args": v68 /*: any*/ ,
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "endDateViewField",
                                                                                                    "plural": false,
                                                                                                    "selections": v69 /*: any*/ ,
                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraTimelineField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": v44 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isConditionalFormattingEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSet",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v35 /*: any*/ ,
                                                                                            "concreteType": "JiraComponentConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedComponentsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponent",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "componentId"
                                                                                                                },
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraComponentsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraUserConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedUsersConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v29 /*: any*/ ,
                                                                                                                v45 /*: any*/ ,
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "priorityId"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraProject",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "project",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "projectId"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraVersion",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "version",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v49 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v62 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v35 /*: any*/ ,
                                                                                            "concreteType": "JiraVersionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedVersionsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v49 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedValue",
                                                                                            "plural": false,
                                                                                            "selections": v70 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedValues",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": v70 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v48 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraRadioSelectField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        },
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        {
                            "condition": "isHierarchyEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v18 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isResolved"
                                },
                                v67 /*: any*/ 
                            ]
                        },
                        v15 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v21 /*: any*/ ,
                            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
                            "kind": "LinkedField",
                            "name": "searchViewContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v29 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchBulkViewContextMapping",
                                                    "kind": "LinkedField",
                                                    "name": "contexts",
                                                    "plural": true,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v27 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "575e6194f4bd5d924ec00ad1885dc29aeffcf2bf60224f511b3d506c57ac2e48",
            "metadata": {},
            "name": "realtimeIssueDetails_Query",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $eHMRp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider": (0, $5CxJ3.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $ePJhs.default)
            }
        }
    };
}();
$97b95b06ec23a472$var$node.hash = "e5d9775811dc99f45b3afcd84ed992ee";
var $97b95b06ec23a472$export$2e2bcd8739ae039 = $97b95b06ec23a472$var$node;

});
parcelRegister("ePJhs", function(module, exports) {

$parcel$export(module.exports, "default", () => $92292d3add361cda$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $92292d3add361cda$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});



parcelRegister("fXRJZ", function(module, exports) {

$parcel$export(module.exports, "useGetGroupsForIssues", () => $ab19d6276ce69410$export$c756ae1e1c570081);

var $5oMOO = parcelRequire("5oMOO");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $7zZ4w = parcelRequire("7zZ4w");

var $kEUB1 = parcelRequire("kEUB1");

var $8jOO7 = parcelRequire("8jOO7");
const $ab19d6276ce69410$export$c756ae1e1c570081 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    return (0, $eJOHy.useCallback)(async ({ issueChanges: issueChanges, staticViewInput: staticViewInput, fieldId: fieldId, issueSearchInput: issueSearchInput, numGroupsLoaded: numGroupsLoaded })=>{
        const environment = (0, $7zZ4w.default)();
        try {
            const data = await (0, $j4oe4.fetchQuery)(environment, (0, $5oMOO.default), {
                cloudId: cloudId,
                issueChanges: issueChanges,
                issueSearchInput: issueSearchInput,
                fieldId: fieldId,
                // Needs to be connection length + 1 to ensure a potentially new group at the end of the
                // currently loaded connection is included
                firstNGroupsToSearch: numGroupsLoaded + 1,
                staticViewInput: staticViewInput
            }, {
                fetchPolicy: 'network-only'
            }).toPromise();
            return data?.jira?.groupsForIssues?.edges?.map((edge)=>edge?.node ? {
                    __id: edge.node.__id,
                    id: edge.node.id,
                    afterGroupId: edge.node.afterGroupId
                } : undefined)?.filter(Boolean) ?? [];
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'realTimeFetchGroupsForIssue',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
            return [];
        }
    }, [
        cloudId
    ]);
};

});
parcelRegister("5oMOO", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ea05e31e66a99d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6e3ee1d9b4fc300d127907bcc3212e68>>
 * @relayHash 8b5fc912efc7daab7e850e6e2c651e77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae0a1f7d5472c778e8f799f0013ce6b460cc19806f6cafa72f47b87440517455

var $bFEtW = parcelRequire("bFEtW");
const $98ea05e31e66a99d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "firstNGroupsToSearch"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueChanges"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldId",
            "variableName": "fieldId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Variable",
            "name": "firstNGroupsToSearch",
            "variableName": "firstNGroupsToSearch"
        },
        {
            "kind": "Variable",
            "name": "issueChanges",
            "variableName": "issueChanges"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "afterGroupId"
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v7 /*: any*/ 
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "value"
    }, v15 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "groupsForIssues_realtimeUpdater_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupConnection",
                            "kind": "LinkedField",
                            "name": "groupsForIssues",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroup",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "groupRow_issueTableGrouping_groupRow"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "groupsForIssues_realtimeUpdater_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupConnection",
                            "kind": "LinkedField",
                            "name": "groupsForIssues",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroup",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldType"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldSetId"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fieldValue",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "jqlTerm"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "label",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlLabelFieldValue"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "group",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "groupId"
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlGroupFieldValue"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "version",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "versionId"
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v13 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraJqlVersionFieldValue"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "option",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlOptionFieldValue"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueTypes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "small"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "issueTypeId"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "hierarchy",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "level"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlIssueTypeFieldValue"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraResolution",
                                                                            "kind": "LinkedField",
                                                                            "name": "resolution",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlResolutionFieldValue"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "priorityId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v15 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraStatusCategory",
                                                                    "kind": "LinkedField",
                                                                    "name": "statusCategory",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "number"
                                                                }
                                                            ],
                                                            "type": "JiraJqlNumberFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "option",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "optionId"
                                                                        },
                                                                        v14 /*: any*/ ,
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlOptionFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "sprintId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "endDate"
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGoal",
                                                                    "kind": "LinkedField",
                                                                    "name": "goal",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "score"
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlGoalsFieldValue"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueCount"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ae0a1f7d5472c778e8f799f0013ce6b460cc19806f6cafa72f47b87440517455",
            "metadata": {},
            "name": "groupsForIssues_realtimeUpdater_Query",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider": (0, $bFEtW.default)
            }
        }
    };
}();
$98ea05e31e66a99d$var$node.hash = "5b12b016130b4ac371febb9a4397fc68";
var $98ea05e31e66a99d$export$2e2bcd8739ae039 = $98ea05e31e66a99d$var$node;

});


parcelRegister("651sM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4986dc48c066a26$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f4986dc48c066a26$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    realtimeUpdateExceededMaxHeader: {
        "id": "native-issue-table.ui.realtime-updater.realtime-update-exceeded-max-header",
        "defaultMessage": "Updating those work items"
    },
    realtimeUpdateExceededMaxDescription: {
        "id": "native-issue-table.ui.realtime-updater.realtime-update-exceeded-max-description",
        "defaultMessage": "Refresh the page to see the updates"
    },
    realtimeUpdateExceededMaxRefreshButton: {
        "id": "native-issue-table.ui.realtime-updater.realtime-update-exceeded-max-refresh-button",
        "defaultMessage": "Refresh"
    }
});

});



parcelRegister("9VBAD", function(module, exports) {

$parcel$export(module.exports, "ScrollContainer", () => $ba39e90ae3fa936c$export$2631a3ab3cdd158d);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $aIjmF = parcelRequire("aIjmF");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jd93d = parcelRequire("jd93d");

var $6d9QY = parcelRequire("6d9QY");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bmoS1 = parcelRequire("bmoS1");

var $7jTnu = parcelRequire("7jTnu");

var $hbF3h = parcelRequire("hbF3h");

var $aVTEC = parcelRequire("aVTEC");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $7khpH = parcelRequire("7khpH");

var $7n9BS = parcelRequire("7n9BS");

var $4NiKr = parcelRequire("4NiKr");

var $3F6xT = parcelRequire("3F6xT");

var $hGS9u = parcelRequire("hGS9u");
const $ba39e90ae3fa936c$export$afb5fd3c74e214f9 = ({ loading: loading, resetScroll: resetScroll })=>{
    const prevLoading = (0, $6d9QY.usePrevious)(loading);
    // Reseting the scroll when the connection id change will cover any variable change
    (0, $eJOHy.useEffect)(()=>{
        if (prevLoading !== loading && prevLoading === true) resetScroll();
    });
};
const $ba39e90ae3fa936c$export$2631a3ab3cdd158d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, footer: footer, loading: loading, isGrouping: isGrouping, isChildIssuesTable: isChildIssuesTable = false, onScroll: externalOnScroll, columnCount: columnCount, ...infiniteScrollProps }, ref)=>{
    const scrollContainerRef = (0, $eJOHy.useRef)(null);
    const siblingIssueCreateOnScroll = (0, $4NiKr.useSiblingIssueCreateOnScroll)();
    const isInfiniteScrollEnabled = (0, $34oCh.useIsInfiniteScrollEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isFullPageIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const previousScrollLeftRef = (0, $eJOHy.useRef)(0);
    const totalScrollableWidthRef = (0, $eJOHy.useRef)(0);
    const resetScroll = (0, $eJOHy.useCallback)(()=>{
        if (scrollContainerRef.current != null && isInfiniteScrollEnabled) scrollContainerRef.current.scrollTop = 0;
    }, [
        isInfiniteScrollEnabled
    ]);
    $ba39e90ae3fa936c$export$afb5fd3c74e214f9({
        loading: loading,
        resetScroll: resetScroll
    });
    const { onLoadingThresholdCheck: onLoadingThresholdCheck, onScroll: infiniteScrollOnScroll } = (0, $7khpH.useInfiniteScrollHandler)(infiniteScrollProps);
    let sendAnalyticsEventDebounced;
    if (isChildIssuesTable && (0, $7jTnu.fg)('ken-2879_is_child_issue_table')) {
        const ANALYTICS_EVENT_DEBOUNCE_DELAY = 1000;
        sendAnalyticsEventDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'childIssuesTable scrolled');
        }, ANALYTICS_EVENT_DEBOUNCE_DELAY);
    }
    // Horizontal scroll analytics function
    const useHorizontalScrollAnalytics = ()=>{
        const fireDebouncedAnalyticsForHorizontalScroll = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((currentScroll, totalScrollableWidth)=>{
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueView horizontalScroll', {
                    actionSubjectId: 'issueView',
                    scrollLeft: currentScroll,
                    totalScrollableWidth: totalScrollableWidth,
                    section: 'childIssueTable',
                    columnCount: columnCount
                });
            }, 400), []);
        return fireDebouncedAnalyticsForHorizontalScroll;
    };
    // Wrapped with feature gate
    const useHorizontalScrollAnalyticsWithFF = (0, $hbF3h.functionUnionWithCondition)(()=>(0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate'), useHorizontalScrollAnalytics, ()=>undefined);
    const fireDebouncedAnalyticsForHorizontalScroll = useHorizontalScrollAnalyticsWithFF();
    const useHorizontalScrollDirectionChangeAnalyticsWithFF = (0, $hbF3h.functionUnionWithCondition)(()=>(0, $7jTnu.fg)('issue_table_horizontal_scroll_direction_analytics'), (0, $aVTEC.useHorizontalScrollDirectionChangeAnalytics), ()=>undefined);
    const fireHorizontalScrollDirectionChangeAnalytics = useHorizontalScrollDirectionChangeAnalyticsWithFF();
    const onScroll = (0, $eJOHy.useCallback)((event)=>{
        if (isChildIssuesTable && typeof sendAnalyticsEventDebounced === 'function' && (0, $7jTnu.fg)('ken-2879_is_child_issue_table')) sendAnalyticsEventDebounced();
        siblingIssueCreateOnScroll?.(event);
        if (isInfiniteScrollEnabled) infiniteScrollOnScroll(event);
        if ((0, $7jTnu.fg)('jira_list_extended_scroll_container_props')) externalOnScroll?.(event);
        if (event.currentTarget instanceof HTMLElement && fireHorizontalScrollDirectionChangeAnalytics && (0, $7jTnu.fg)('issue_table_horizontal_scroll_direction_analytics')) fireHorizontalScrollDirectionChangeAnalytics(event.currentTarget);
        if (event.target instanceof HTMLElement && (0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate')) {
            const target = event.target;
            const currentScroll = Math.round(target.scrollLeft);
            if (totalScrollableWidthRef.current === 0) totalScrollableWidthRef.current = Math.round(target.scrollWidth - target.clientWidth);
            // Send horizontal scroll analytics when scrolling right for child issue table
            const isScrollingRight = currentScroll > previousScrollLeftRef.current;
            if (isScrollingRight && isChildIssuesTable && isFullPageIssueView && fireDebouncedAnalyticsForHorizontalScroll) fireDebouncedAnalyticsForHorizontalScroll(currentScroll, totalScrollableWidthRef.current);
            previousScrollLeftRef.current = currentScroll;
        }
    }, [
        siblingIssueCreateOnScroll,
        isInfiniteScrollEnabled,
        infiniteScrollOnScroll,
        sendAnalyticsEventDebounced,
        isChildIssuesTable,
        externalOnScroll,
        fireDebouncedAnalyticsForHorizontalScroll,
        isFullPageIssueView,
        fireHorizontalScrollDirectionChangeAnalytics
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Handle auto-scrolling for pragmatic dnd operations like column resizing
        const scrollableElement = scrollContainerRef.current;
        let cleanup;
        if (scrollableElement) cleanup = (0, $aIjmF.autoScrollForElements)({
            element: scrollableElement,
            canScroll: ({ source: source })=>source.data.operation !== (0, $8jOO7.COLUMN_OPERATION_RESIZE)
        });
        return ()=>{
            cleanup?.();
            fireDebouncedAnalyticsForHorizontalScroll?.cancel();
        };
    }, [
        fireDebouncedAnalyticsForHorizontalScroll
    ]);
    const intersectionObsRef = (0, $3F6xT.useIntersectionObserver)();
    // eslint-disable-next-line react-hooks/react-compiler
    /* eslint-disable react-hooks/rules-of-hooks */ const mergedRefs = (0, $7jTnu.fg)('jira_list_extended_scroll_container_props') ? (0, $jd93d.default)(ref, intersectionObsRef, scrollContainerRef) : (0, $jd93d.default)(intersectionObsRef, scrollContainerRef);
    /* eslint-enable react-hooks/rules-of-hooks */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7n9BS.ScrollStateProvider), {
        scrollRef: scrollContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ba39e90ae3fa936c$var$loadingIndicatorContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ba39e90ae3fa936c$var$scrollContainerStyles,
        ref: mergedRefs,
        onScroll: onScroll,
        testId: "native-issue-table.ui.scroll-container.scroll-container"
    }, children), isInfiniteScrollEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hGS9u.LoadingManager), {
        isLoadingPrevious: infiniteScrollProps.isLoadingPrevious,
        isLoadingNext: infiniteScrollProps.isLoadingNext,
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        isGrouping: isGrouping
    })), footer);
});
const $ba39e90ae3fa936c$var$HEADER_HEIGHT = 40;
const $ba39e90ae3fa936c$var$scrollContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    position: 'relative',
    flexFlow: 'column nowrap',
    overflow: 'auto',
    // Since header is sticky, we need to specify a scroll padding that matches its height so that auto-scrolling
    // functionality accounts for this element in its calculations, otherwise header can overlap the selected row.
    scrollPaddingTop: `${$ba39e90ae3fa936c$var$HEADER_HEIGHT}px`
});
const $ba39e90ae3fa936c$var$loadingIndicatorContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexFlow: 'column nowrap',
    position: 'relative',
    overflow: 'hidden'
});

});
parcelRegister("aVTEC", function(module, exports) {

$parcel$export(module.exports, "useHorizontalScrollDirectionChangeAnalytics", () => $066f2008dcdea2eb$export$7f82c6c9c621dfa1);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $34oCh = parcelRequire("34oCh");
const $066f2008dcdea2eb$export$7f82c6c9c621dfa1 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const lastScrollLeft = (0, $eJOHy.useRef)(0);
    const lastDirection = (0, $eJOHy.useRef)(null);
    const isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
    return (0, $eJOHy.useCallback)((target)=>{
        const currentScrollLeft = target.scrollLeft;
        let direction = null;
        if (currentScrollLeft > lastScrollLeft.current) direction = 'right';
        else if (currentScrollLeft < lastScrollLeft.current) direction = 'left';
        // Only fire event if direction changed and it's not the first scroll
        if (direction && lastDirection.current && direction !== lastDirection.current) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueView horizontalScrollChanged', {
            actionSubjectId: 'issueView',
            direction: direction,
            isStickyColumnsEnabled: isStickyColumnsEnabled
        });
        if (direction) lastDirection.current = direction;
        lastScrollLeft.current = currentScrollLeft;
    }, [
        createAnalyticsEvent,
        isStickyColumnsEnabled
    ]);
};

});

parcelRegister("7khpH", function(module, exports) {

$parcel$export(module.exports, "useInfiniteScrollHandler", () => $8f8e5c1656e840b4$export$ee8d81e7d8c9f22d);

var $eJOHy = parcelRequire("eJOHy");

var $8jOO7 = parcelRequire("8jOO7");

var $5M8i8 = parcelRequire("5M8i8");
const $8f8e5c1656e840b4$var$DEFAULT_ACTIVATION_THRESHOLD = 10 * (0, $8jOO7.ROW_HEIGHT);
const $8f8e5c1656e840b4$export$ee8d81e7d8c9f22d = ({ onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...dataProps })=>{
    // Keep props as ref so the callback is stable across rerenders.
    const dataPropsRef = (0, $eJOHy.useRef)(dataProps);
    dataPropsRef.current = dataProps;
    const onLoadNext = (0, $5M8i8.useThrottle)(onLoadNextProp);
    const onLoadPrevious = (0, $5M8i8.useThrottle)(onLoadPreviousProp);
    const onLoadingThresholdCheck = (0, $eJOHy.useCallback)(({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop })=>{
        const { isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold = $8f8e5c1656e840b4$var$DEFAULT_ACTIVATION_THRESHOLD } = dataPropsRef.current;
        const scrollBottom = scrollHeight - clientHeight - scrollTop;
        const isLoading = isLoadingNext || isLoadingPrevious;
        // Prioritising loading next over loading previous to fill results downwards first,
        // to hopefully feel more natural.
        if (hasNext && !isLoading && scrollBottom <= activationThreshold) onLoadNext?.();
        else if (hasPrevious && !isLoading && scrollTop <= activationThreshold) onLoadPrevious?.();
    }, // Ensure that the callback is not recreated when props change.
    // onLoadNext & onLoadPrevious should be throttled & stable.
    [
        onLoadNext,
        onLoadPrevious
    ]);
    const onScroll = (0, $eJOHy.useCallback)((event)=>{
        onLoadingThresholdCheck(event.currentTarget);
    }, // Ensure that the callback is not recreated when props change.
    // onLoadingThresholdCheck should be stable.
    [
        onLoadingThresholdCheck
    ]);
    return {
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        onScroll: onScroll
    };
};

});
parcelRegister("5M8i8", function(module, exports) {

$parcel$export(module.exports, "useThrottle", () => $47c0698a2db18423$export$8b7b9481d6186f21);

var $eJOHy = parcelRequire("eJOHy");
const $47c0698a2db18423$export$8b7b9481d6186f21 = (fn, wait = 100)=>{
    const fnRef = (0, $eJOHy.useRef)(fn);
    fnRef.current = fn;
    const waitRef = (0, $eJOHy.useRef)(wait);
    waitRef.current = wait;
    const timeout = (0, $eJOHy.useRef)(undefined);
    const throttled = (0, $eJOHy.useCallback)(()=>{
        if (timeout.current !== undefined) return;
        fnRef.current?.();
        timeout.current = setTimeout(()=>{
            timeout.current = undefined;
        }, waitRef.current);
    // Ensure the callback is not recreated when props change,
    // dependency array should be empty.
    }, []);
    // Cleanup the timeout on unmount.
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeout.current !== undefined) clearTimeout(timeout.current);
        };
    }, []);
    return throttled;
};

});


parcelRegister("hGS9u", function(module, exports) {

$parcel$export(module.exports, "LoadingManager", () => $96783ac5fc2dbf3b$export$99cc795e99919eed);

var $eJOHy = parcelRequire("eJOHy");

var $9cbmy = parcelRequire("9cbmy");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $epTsa = parcelRequire("epTsa");

var $kbYhH = parcelRequire("kbYhH");

var $7n9BS = parcelRequire("7n9BS");

var $2HFPH = parcelRequire("2HFPH");

var $5ik33 = parcelRequire("5ik33");
const $96783ac5fc2dbf3b$var$getLoadingA11YMessage = ({ isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasFinishedLoadingNext: hasFinishedLoadingNext, hasFinishedLoadingPrevious: hasFinishedLoadingPrevious, isGrouping: isGrouping })=>{
    if (isGrouping) {
        if (isLoadingPrevious) return (0, $5ik33.default).loadStartA11YMessageTopWithGrouping;
        if (hasFinishedLoadingPrevious) return (0, $5ik33.default).loadEndA11YMessageTopWithGrouping;
        if (isLoadingNext) return (0, $5ik33.default).loadStartA11YMessageBottomWithGrouping;
        if (hasFinishedLoadingNext) return (0, $5ik33.default).loadEndA11YMessageBottomWithGrouping;
    }
    if (isLoadingPrevious) return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadStartA11YMessageTopIssueTermRefresh : (0, $5ik33.default).loadStartA11YMessageTop;
    if (hasFinishedLoadingPrevious) return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadEndA11YMessageTopIssueTermRefresh : (0, $5ik33.default).loadEndA11YMessageTop;
    if (isLoadingNext) return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadStartA11YMessageBottomIssueTermRefresh : (0, $5ik33.default).loadStartA11YMessageBottom;
    if (hasFinishedLoadingNext) return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadEndA11YMessageBottomIssueTermRefresh : (0, $5ik33.default).loadEndA11YMessageBottom;
    return undefined;
};
const $96783ac5fc2dbf3b$export$99cc795e99919eed = ({ isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext, isGrouping: isGrouping, onLoadingThresholdCheck: onLoadingThresholdCheck })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Table has height 0 during first render due to virtualization. Some checks need to wait for the table to have a height.
    const hasTableHeight = (0, $kbYhH.useElementSizeSelector)((tableState)=>Boolean(tableState.height));
    const scrollElement = (0, $7n9BS.useScrollElement)();
    const height = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.height);
    // #region After-load Handler
    /**
   * After initial render and any subsequent loading events, make sure that we continue loading in more issues if
   * necessary because a single load may not have enough issues to fill the scroll container.
   */ (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasTableHeight && !isLoadingPrevious && !isLoadingNext && height) onLoadingThresholdCheck(scrollElement);
    }, [
        hasTableHeight,
        isLoadingPrevious,
        isLoadingNext,
        onLoadingThresholdCheck,
        scrollElement,
        height
    ]);
    // #endregion
    // #region Top Scroll Handler
    /**
   * A component that ensures that the scroll position is kept stable when loading previous issues.
   * This is necessary because sometimes the browser does scroll to keep existing rows in view when new rows are prepended.
   *
   * Without this, we may see issues like continuously loading all previous issues until there are none left.
   */ const prevIsLoadingPrevious = (0, $6d9QY.usePreviousWithInitial)(isLoadingPrevious);
    const hasStartedLoadingPrevious = !prevIsLoadingPrevious && isLoadingPrevious;
    const hasFinishedLoadingPrevious = prevIsLoadingPrevious && !isLoadingPrevious;
    // Hook's scrollHeight doesn't update the height information when the scroll height changes due to DOM mutations
    // Need to track this separately when loading starts
    const scrollHeightRef = (0, $eJOHy.useRef)(0);
    (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && hasStartedLoadingPrevious) scrollHeightRef.current = scrollElement.scrollHeight;
    }, [
        hasStartedLoadingPrevious,
        scrollElement
    ]);
    // Ensure that the scroll is kept in place after loading previous issues - browser doesn't always handle this properly
    // Using a layout effect to make sure this happens as quickly as possible to reduce visible movement
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (scrollElement && hasFinishedLoadingPrevious) {
            const newScrollHeight = scrollElement.scrollHeight;
            if (newScrollHeight > scrollHeightRef.current) {
                const heightIncrease = newScrollHeight - scrollHeightRef.current;
                scrollElement.scrollBy(0, heightIncrease);
            }
            scrollHeightRef.current = newScrollHeight;
        }
    }, [
        hasFinishedLoadingPrevious,
        scrollElement
    ]);
    // #endregion
    // #region Loading A11y
    const prevIsLoadingNext = (0, $6d9QY.usePreviousWithInitial)(isLoadingNext);
    const hasFinishedLoadingNext = prevIsLoadingNext && !isLoadingNext;
    const loadingCompleteLiveMessage = (0, $eJOHy.useRef)(undefined);
    loadingCompleteLiveMessage.current = $96783ac5fc2dbf3b$var$getLoadingA11YMessage({
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        hasFinishedLoadingNext: hasFinishedLoadingNext,
        hasFinishedLoadingPrevious: hasFinishedLoadingPrevious,
        isGrouping: isGrouping
    });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isLoadingPrevious && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2HFPH.LoadingIndicator), {
        position: "top",
        isGrouping: isGrouping
    }), isLoadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2HFPH.LoadingIndicator), {
        position: "bottom",
        isGrouping: isGrouping
    }), loadingCompleteLiveMessage.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, formatMessage(loadingCompleteLiveMessage.current)));
};

});
parcelRegister("2HFPH", function(module, exports) {

$parcel$export(module.exports, "LoadingIndicator", () => $b6040ad16371eb3a$export$7c20be4c1d342248);

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $etVWf = parcelRequire("etVWf");
const $b6040ad16371eb3a$export$7c20be4c1d342248 = ({ position: position, isGrouping: isGrouping })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getLoadingMessage = ()=>{
        if (isGrouping) return (0, $etVWf.default).loadingMessageWithGrouping;
        return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $etVWf.default).loadingMessageIssueTermRefresh : (0, $etVWf.default).loadingMessage;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: "center",
        xcss: [
            $b6040ad16371eb3a$var$containerStyles,
            position === 'top' ? $b6040ad16371eb3a$var$positionTopStyles : $b6040ad16371eb3a$var$positionBottomStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "hug",
        xcss: $b6040ad16371eb3a$var$loadingIndicatorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        appearance: "invert",
        size: "small",
        interactionName: (0, $7jTnu.fg)('add_nin_press_interactions') ? 'issue-table-infinite-scroll-loading' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text.inverse"
    }, formatMessage(getLoadingMessage()))));
};
// Account for the sticky header row height
const $b6040ad16371eb3a$var$HEADER_HEIGHT = 40;
const $b6040ad16371eb3a$var$positionTopStyles = (0, $1DXK0.xcss)({
    top: `${$b6040ad16371eb3a$var$HEADER_HEIGHT}px`
});
const $b6040ad16371eb3a$var$positionBottomStyles = (0, $1DXK0.xcss)({
    bottom: 'space.0'
});
const $b6040ad16371eb3a$var$loadingIndicatorStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text.inverse',
    marginBlock: 'space.200',
    padding: 'space.100'
});
const $b6040ad16371eb3a$var$containerStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    width: '100%'
});

});
parcelRegister("etVWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa7af19b14864c77$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fa7af19b14864c77$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadingMessage: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message",
        "defaultMessage": "Loading more issues"
    },
    loadingMessageIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message-issue-term-refresh",
        "defaultMessage": "Loading more"
    },
    loadingMessageWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message-with-grouping",
        "defaultMessage": "Loading more groups"
    }
});

});


parcelRegister("5ik33", function(module, exports) {

$parcel$export(module.exports, "default", () => $42222096832b96bf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $42222096832b96bf$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadStartA11YMessageTop: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top",
        "defaultMessage": "Loading more issues at the top of the table."
    },
    loadEndA11YMessageTop: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top",
        "defaultMessage": "Finished loading more issues at the top of the table."
    },
    loadStartA11YMessageBottom: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom",
        "defaultMessage": "Loading more issues at the bottom of the table."
    },
    loadEndA11YMessageBottom: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom",
        "defaultMessage": "Finished loading more issues at the bottom of the table."
    },
    loadStartA11YMessageTopIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Loading more work items at the top of the table."
    },
    loadEndA11YMessageTopIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the top of the table."
    },
    loadStartA11YMessageBottomIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Loading more work items at the bottom of the table."
    },
    loadEndA11YMessageBottomIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the bottom of the table."
    },
    loadStartA11YMessageTopWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top-with-grouping",
        "defaultMessage": "Loading more groups at the top of the table."
    },
    loadEndA11YMessageTopWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top-with-grouping",
        "defaultMessage": "Finished loading more groups at the top of the table."
    },
    loadStartA11YMessageBottomWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom-with-grouping",
        "defaultMessage": "Loading more groups at the bottom of the table."
    },
    loadEndA11YMessageBottomWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom-with-grouping",
        "defaultMessage": "Finished loading more groups at the bottom of the table."
    }
});

});



parcelRegister("bUOjV", function(module, exports) {

$parcel$export(module.exports, "IssueTableSelectedIssuesProvider", () => $7234e6cdb0c3bc3b$export$8560e956e1937d5);

var $eJOHy = parcelRequire("eJOHy");

var $3TtKq = parcelRequire("3TtKq");
const $7234e6cdb0c3bc3b$export$8560e956e1937d5 = (Component)=>{
    const SelectedIssuesWrapperComponent = (props)=>{
        if (props.enableMultiSelect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3TtKq.IssueTableSelectedIssuesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props));
    };
    return SelectedIssuesWrapperComponent;
};

});

parcelRegister("cyJHb", function(module, exports) {

$parcel$export(module.exports, "CopyPasteContainer", () => $3d37cc73a680e8e4$export$f22393f54af5c587);

var $eJOHy = parcelRequire("eJOHy");

var $kjtxW = parcelRequire("kjtxW");

var $bJscI = parcelRequire("bJscI");

var $34oCh = parcelRequire("34oCh");
const $3d37cc73a680e8e4$var$CopyPasteContainerInternal = ({ children: children })=>{
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    return isInlineEditingEnabled && isInlineEditingExtendedFieldSupportEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kjtxW.CopyPasteContextProvider), null, children) : children;
};
const $3d37cc73a680e8e4$export$f22393f54af5c587 = (0, $bJscI.componentWithFG)('jsc_inline_editing_field_refactor', $3d37cc73a680e8e4$var$CopyPasteContainerInternal, ({ children: children })=>children);

});

parcelRegister("1GzaA", function(module, exports) {

$parcel$export(module.exports, "ConnectionsSubscriberContainer", () => $1dfdcf001ed824dc$export$dca2df00a75a6b37);

var $eJOHy = parcelRequire("eJOHy");

var $dLXgn = parcelRequire("dLXgn");

var $57Nys = parcelRequire("57Nys");
const $1dfdcf001ed824dc$export$dca2df00a75a6b37 = ({ ConnectionsSubscriber: ConnectionsSubscriber })=>{
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConnectionsSubscriber, {
        connections: connections,
        updateConnectionDetails: updateConnectionDetails
    });
};

});

parcelRegister("b6dH0", function(module, exports) {

$parcel$export(module.exports, "RootConnectionRegister", () => $e048b9cac452bf83$export$f2eeecab3dd535b2);

var $lSfad = parcelRequire("lSfad");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dLXgn = parcelRequire("dLXgn");
const $e048b9cac452bf83$export$f2eeecab3dd535b2 = ({ issues: issues })=>{
    const issueConnection = (0, $j4oe4.useFragment)((0, $lSfad.default), issues ?? null);
    const rootConnectionDetails = (0, $eJOHy.useMemo)(()=>{
        if (issueConnection && issueConnection.__id) return {
            type: 'ROOT_ISSUES',
            connectionId: issueConnection.__id,
            first: issueConnection?.edges?.length ?? 0
        };
        return undefined;
    }, [
        issueConnection
    ]);
    (0, $dLXgn.useRegisterConnection)(rootConnectionDetails);
    return null;
};

});
parcelRegister("lSfad", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b3ea56075c8900f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3b6024a55d0f932f442c9b98e73b03a5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8b3ea56075c8900f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "rootConnectionRegister_nativeIssueTable_issues",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$8b3ea56075c8900f$var$node.hash = "5283567b68955e1a7394bdb870c16539";
var $8b3ea56075c8900f$export$2e2bcd8739ae039 = $8b3ea56075c8900f$var$node;

});


parcelRegister("cGekj", function(module, exports) {

$parcel$export(module.exports, "useKeyboardNavigation", () => $9efc22d255ba6365$export$4da28cf324280418);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $5V25X = parcelRequire("5V25X");

var $ecCxV = parcelRequire("ecCxV");

var $8jOO7 = parcelRequire("8jOO7");
const $9efc22d255ba6365$export$4da28cf324280418 = (ref)=>{
    const lastFocusedElement = (0, $eJOHy.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Post-office trigger handlers for grid navigation onboarding
    const { isActive: isMoreShortcutsClicked } = (0, $5V25X.useTrigger)((0, $8jOO7.GRID_NAVIGATION_ONBOARDING_TRIGGERS).MORE_SHORTCUTS_CLICKED);
    const { isActive: isOkClicked } = (0, $5V25X.useTrigger)((0, $8jOO7.GRID_NAVIGATION_ONBOARDING_TRIGGERS).OK_CLICKED);
    const openHelpPanelLink = (0, $ecCxV.useHelpPanelLink)();
    (0, $eJOHy.useEffect)(()=>{
        const table = ref.current;
        if (!table) return;
        const getCell = (ele)=>ele?.closest('td') ?? ele?.closest('th');
        const isCell = (ele)=>getCell(ele) === ele;
        const getFocusableElements = ()=>Array.from(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @atlaskit/platform/no-direct-document-usage
            document.querySelectorAll([
                'a[href]:not([tabindex="-1"]):not([href=""]):not([href="javascript:;"])',
                'button:not([tabindex="-1"])',
                'input:not([tabindex="-1"], [type="hidden"])',
                'select:not([tabindex="-1"])',
                'textarea:not([tabindex="-1"])',
                "[tabindex]:not([tabindex='-1'])"
            ].join(',')));
        const getCellDepth = (ele, count = 0)=>{
            if (ele instanceof HTMLTableCellElement || !ele?.parentElement) return count;
            return getCellDepth(ele?.parentElement, count + 1);
        };
        const getScrollableContainer = (node = table)=>{
            // Goes up the DOM tree until we encounter a scrollable element.
            if (!(node instanceof HTMLElement)) return null;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const styles = window.getComputedStyle(node);
            if (styles?.overflowY === 'scroll' || styles?.overflowY === 'auto') return node;
            return getScrollableContainer(node.parentElement);
        };
        const onKeyDown = (event)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @atlaskit/platform/no-direct-document-usage
            const activeElement = document.activeElement;
            const currentTr = activeElement?.closest('tr');
            if (event.key === 'Escape') {
                event.preventDefault();
                const cell = getCell(activeElement);
                const cellButton = cell?.querySelector('button[aria-hidden="false"]');
                if (cellButton instanceof HTMLElement && getCellDepth(cellButton) < 4) return cellButton.focus();
                return cell?.focus();
            }
            if (event.key === 'Tab' && event.shiftKey && activeElement instanceof Element) {
                /*
					If focus would move from our cell to another cell when pressing shift+tab;
					Prevent default and focus last element before the table.
				*/ const isCurrentCellFocused = isCell(activeElement);
                const index = activeElement.getAttribute('tabindex');
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', '0');
                const focusable = getFocusableElements();
                const currentFocusableElementsCell = getCell(activeElement);
                const nextFocusableElementsCell = getCell(focusable[focusable.indexOf(activeElement) - 1]);
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', index ?? '-1');
                if (!isCurrentCellFocused) {
                    // go back to grid navigation
                    event.preventDefault();
                    return currentFocusableElementsCell?.focus();
                }
                if (currentFocusableElementsCell === nextFocusableElementsCell || !nextFocusableElementsCell) return;
                lastFocusedElement.current = getCell(activeElement);
                // Find the last element before the table in the document
                const lastElementBeforeTable = focusable.slice(0, focusable.findIndex((ele)=>table.contains(ele))).at(-1);
                event.preventDefault();
                if (lastElementBeforeTable instanceof HTMLElement) lastElementBeforeTable.focus();
                return;
            }
            if (event.key === 'Tab' && activeElement) {
                /*
					If focus would move from our cell to another cell when pressing tab;
					Prevent default and focus first interactable thing outside the table. (probably create button but not always)
					If we're inside a dialog; don't programmatically control focus.
				*/ if (activeElement.closest('[role="dialog"]')) return;
                const isCurrentCellFocused = isCell(activeElement);
                const index = activeElement.getAttribute('tabindex');
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', '0');
                const focusable = getFocusableElements();
                const currentFocusableElementsCell = getCell(activeElement);
                const nextFocusableElementsCell = getCell(focusable[focusable.indexOf(activeElement) + 1]);
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', index ?? '-1');
                if (currentFocusableElementsCell === nextFocusableElementsCell || !nextFocusableElementsCell) return;
                const nextFocusableElementOutsideTable = focusable.slice(focusable.indexOf(activeElement)).find((ele)=>!table.contains(ele));
                if (!nextFocusableElementOutsideTable) {
                    const lastInsideTable = focusable.slice(focusable.indexOf(activeElement)).at(-1);
                    if (!(lastInsideTable instanceof HTMLElement)) return;
                    lastInsideTable.focus({
                        preventScroll: true
                    });
                    return;
                }
                event.preventDefault();
                nextFocusableElementOutsideTable?.focus();
                return;
            }
            if (!activeElement || !(activeElement instanceof HTMLElement)) return;
            if (!currentTr || !(currentTr instanceof HTMLTableRowElement)) return;
            const currentTd = getCell(activeElement);
            if (!currentTd) return;
            const currentTds = Array.from(currentTr.children).filter((n)=>{
                return n.getAttribute('aria-hidden') !== 'true';
            });
            const currentTdIndex = currentTds.indexOf(currentTd);
            const rows = Array.from(table.querySelectorAll('tr:not([aria-hidden="true"])'));
            const currentTrIndex = rows.indexOf(currentTr);
            const isKeyboardNavigableElement = activeElement instanceof HTMLTableCellElement || activeElement instanceof HTMLButtonElement && activeElement.getAttribute('aria-hidden') === 'false';
            if (!isKeyboardNavigableElement) return;
            const next = (()=>{
                switch(event.code){
                    case 'ArrowUp':
                    case 'KeyJ':
                        {
                            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateUp', {
                                keyPressed: event.key
                            });
                            // Firing track metric to measure nin_grid_navigation_experiment, clean up when cleaning up experiment
                            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'keyboardShortcut pressed', 'KeyboardShortcut', {
                                action: 'pressed',
                                key: 'arrowup'
                            });
                            if (currentTrIndex === 0) return;
                            /* same index, in next row or first index in next row [grouped] */ const children = Array.from(rows[currentTrIndex - 1]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            return children[currentTdIndex] ?? rows[currentTrIndex - 1].children[0];
                        }
                    case 'ArrowDown':
                    case 'KeyK':
                        {
                            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateDown', {
                                keyPressed: event.key
                            });
                            // Firing track metric to measure nin_grid_navigation_experiment, clean up when cleaning up experiment
                            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'keyboardShortcut pressed', 'KeyboardShortcut', {
                                action: 'pressed',
                                key: 'arrowdown'
                            });
                            if (currentTrIndex === rows.length - 1) return;
                            /* same index, in next row or first index in next row [grouped] */ const children = Array.from(rows[currentTrIndex + 1]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            return children[currentTdIndex] ?? rows[currentTrIndex + 1].children[0];
                        }
                    case 'ArrowLeft':
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateLeft', {
                            keyPressed: event.key
                        });
                        return currentTds[currentTdIndex - 1];
                    case 'ArrowRight':
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateRight', {
                            keyPressed: event.key
                        });
                        return currentTds[currentTdIndex + 1];
                    case 'End':
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateEnd', {
                            keyPressed: event.key
                        });
                        return currentTds[currentTds.length - 1];
                    case 'Home':
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateHome', {
                            keyPressed: event.key
                        });
                        return currentTds[0];
                    case 'Enter':
                    case 'Space':
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateEdit', {
                            keyPressed: event.key
                        });
                        if (activeElement instanceof HTMLTableCellElement) {
                            if (event.code === 'Space') event.preventDefault();
                            if (currentTd.children.length !== 1) return currentTd.click();
                            const interactiveElements = Array.from(currentTd.querySelectorAll('button:not([aria-hidden="true"]), a:not([aria-hidden="true"]), input:not([aria-hidden="true"]), select:not([aria-hidden="true"]), textarea:not([aria-hidden="true"]), [role="button"]:not([aria-hidden="true"])'));
                            if (interactiveElements.length === 1) {
                                const element = interactiveElements[0];
                                if (element instanceof HTMLElement) {
                                    element.click();
                                    return;
                                }
                            }
                        }
                        return currentTd.click();
                    case 'PageDown':
                        {
                            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigatePageDown', {
                                keyPressed: event.key
                            });
                            /* Get last visible index in scrollable area, then focus the cell at the same index */ const scrollable = getScrollableContainer();
                            const rowsReversed = [
                                ...rows
                            ].reverse();
                            if (!scrollable) return null;
                            const scrollableRect = scrollable.getBoundingClientRect();
                            const lastVisibleIndex = rowsReversed.findIndex((row)=>{
                                const rowRect = row.getBoundingClientRect();
                                const isVisible = rowRect.bottom > scrollableRect.top && rowRect.top < scrollableRect.bottom;
                                return isVisible;
                            }) - 1;
                            const children = Array.from(rowsReversed[Math.max(0, lastVisibleIndex)]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            if (children.length === 0) return;
                            return children[currentTdIndex] ?? rowsReversed[Math.max(0, lastVisibleIndex)].children[0];
                        }
                    case 'PageUp':
                        {
                            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigatePageUp', {
                                keyPressed: event.key
                            });
                            /* Get first visible index in scrollable area, then focus the cell at the same index */ const scrollable = getScrollableContainer();
                            const rowsExcludingHeader = rows.filter((row)=>!row.closest('thead'));
                            if (!scrollable) return null;
                            const scrollableRect = scrollable.getBoundingClientRect();
                            const firstVisibleIndex = rowsExcludingHeader.findIndex((row)=>{
                                const rowRect = row.getBoundingClientRect();
                                const isVisible = rowRect.bottom > scrollableRect.top && rowRect.top < scrollableRect.bottom;
                                return isVisible;
                            });
                            const children = Array.from(rowsExcludingHeader[Math.max(0, firstVisibleIndex)]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            if (children.length === 0) return;
                            return children[currentTdIndex] ?? rowsExcludingHeader[Math.max(0, firstVisibleIndex)].children[0];
                        }
                    default:
                        return null;
                }
            })();
            if (!(next instanceof HTMLElement)) return;
            event.stopImmediatePropagation(); // Stop meatball menu onKeyDown hijacking focus
            event.preventDefault();
            const button = next.querySelector('button[aria-hidden="false"]');
            const depth = getCellDepth(button);
            if (button && button instanceof HTMLElement && depth < 4) return button.focus();
            return next.focus();
        };
        const onFocusIn = (e)=>{
            /*
				Focus on last focused cell if we're moving focus from inside the table to outside the table
				and lastFocusedElement is defined. (tab into table), otherwise focus on the first cell in the table.
			*/ if (e.target instanceof HTMLElement && e.relatedTarget instanceof Element && lastFocusedElement.current) {
                if (table.contains(e.target) && !table.contains(e.relatedTarget)) return lastFocusedElement.current.focus();
            }
            /* Focus first element inside table, if we've referred focus from outside table (shift+tab back into table) */ const target = e.target;
            if (!(target instanceof HTMLElement) || !(e.relatedTarget instanceof Element) || table.contains(e.relatedTarget)) {
                if (target instanceof HTMLElement) lastFocusedElement.current = getCell(target);
                return;
            }
            const focusable = getFocusableElements();
            const indexOfTable = focusable.findIndex((ele)=>table.contains(ele));
            const indexOfRelatedTarget = focusable.indexOf(e.relatedTarget);
            if (indexOfRelatedTarget < indexOfTable) lastFocusedElement.current = undefined;
        };
        const onKeyDownWindow = (e)=>{
            /*
				If focus is on the first element outside the table.
				prevent the default behaviour and move focus either to the last focuse element inside the table, or the first table cell.
			*/ if (e.key === 'Tab' && e.shiftKey) {
                const focusable = getFocusableElements();
                const elementOutsideTable = focusable.slice(focusable.findIndex((ele)=>table.contains(ele))).find((ele)=>!table.contains(ele));
                if (elementOutsideTable === e.target) {
                    e.preventDefault();
                    if (lastFocusedElement.current && table.contains(lastFocusedElement.current)) return lastFocusedElement.current.focus();
                    focusable.find((ele)=>table.contains(ele))?.focus();
                }
            }
        };
        table.addEventListener('keydown', onKeyDown);
        table.addEventListener('focusin', onFocusIn);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', onKeyDownWindow);
        return ()=>{
            table.removeEventListener('keydown', onKeyDown);
            table.removeEventListener('focusin', onFocusIn);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', onKeyDownWindow);
        };
    // RefObject is a constant reference.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref.current
    ]);
    // Handle "More shortcuts" trigger - open in-product help
    (0, $eJOHy.useEffect)(()=>{
        if (isMoreShortcutsClicked && (0, $7jTnu.fg)('jira_nin_navigation_onboarding')) openHelpPanelLink((0, $8jOO7.KEYBOARD_SHORTCUTS_HELP_ARTICLE_ID));
    }, [
        isMoreShortcutsClicked,
        openHelpPanelLink
    ]);
    // Handle "OK" trigger - focus on first th cell in the table
    (0, $eJOHy.useEffect)(()=>{
        if (isOkClicked && (0, $7jTnu.fg)('jira_nin_navigation_onboarding')) {
            const table = ref.current;
            if (table) {
                const firstThCell = table.querySelector('th');
                if (firstThCell instanceof HTMLElement) firstThCell.focus();
            }
        }
    }, [
        isOkClicked,
        ref
    ]);
};

});
parcelRegister("ecCxV", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $ceecb2ae691c2ef9$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $ceecb2ae691c2ef9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $eJ9f5 = parcelRequire("eJ9f5");

var $7jTnu = parcelRequire("7jTnu");

var $hLzUY = parcelRequire("hLzUY");

var $3VPsL = parcelRequire("3VPsL");

var $dfP3D = parcelRequire("dfP3D");

var $epTsa = parcelRequire("epTsa");
const $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $hLzUY.HELP_PANEL_ID), (0, $hLzUY.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $ceecb2ae691c2ef9$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $7jTnu.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    if ((0, $7jTnu.fg)('help_panel_as_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $ceecb2ae691c2ef9$export$2e2bcd8739ae039 = $ceecb2ae691c2ef9$export$5a09250ffddd7fd1;
const $ceecb2ae691c2ef9$var$buttonWrapperStyles = null;
const $ceecb2ae691c2ef9$var$buttonWrapperSubtleStyles = null;

});


parcelRegister("iFPDm", function(module, exports) {

$parcel$export(module.exports, "desanitizeField", () => $a465a59d4ee26246$export$261830fe943e88ac);
// Removes quotes wrapping fields and sets them to lower case to match the field names in the backend.
const $a465a59d4ee26246$export$261830fe943e88ac = (field)=>{
    if (field.startsWith('"') && field.endsWith('"') || field.startsWith("'") && field.endsWith("'")) return field.slice(1, -1).toLocaleLowerCase();
    return field.toLocaleLowerCase();
};

});



//# sourceMappingURL=async-issue-navigator-native-issue-table.85e8addc.js.map
